/* eslint-disable @typescript-eslint/no-unused-vars,@typescript-eslint/no-use-before-define,@typescript-eslint/naming-convention,@typescript-eslint/no-use-before-define */
import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';

export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = {
  [_ in K]?: never;
};
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  /** Represents an alert parameter name. */
  AlertParameterName: { input: string; output: string };
  /** Represents any value. */
  Any: { input: unknown; output: unknown };
  /** Represents a Date and Time in RFC 3339 format. */
  DateTime: { input: string; output: string };
  /** Represents a duration of time. */
  Duration: { input: string; output: string };
  /** Represents an IP address, either IPv4 or IPv6. */
  IP: { input: string; output: string };
  /** Represents an IP address prefix in CIDR notation. */
  IPPrefix: { input: string; output: string };
  /** Represents an IPv4 address. */
  IPV4: { input: string; output: string };
  /** Represents an IPv6 address. */
  IPV6: { input: string; output: string };
  /** Represents a JSON string. */
  JSON: { input: string; output: string };
  /** Represents a generic JSON object. */
  JSONObject: { input: Record<string, unknown>; output: Record<string, unknown> };
  /** Represents a MAC Address. */
  MacAddress: { input: string; output: string };
  /** Represents a Universally Unique Identifier (UUID). */
  UUID: { input: string; output: string };
  /** Represents an unmasked IP address prefix in CIDR notation. */
  UnmaskedIPPrefix: { input: string; output: string };
};

/** Represents a value of AP channel utilization metrics at a specific timestamp. */
export type ApChannelUtilizationMetricsValue = MetricsValue & {
  __typename?: 'APChannelUtilizationMetricsValue';
  /** The name of the Access Point (AP) that reported this measurement. */
  apName: Scalars['String']['output'];
  /** The time at which the measurement was recorded. */
  timestamp: Scalars['DateTime']['output'];
  /** The measured value of channel utilization at the given timestamp. */
  value: Scalars['Float']['output'];
};

/** Response type containing channel utilization metrics for an AP. */
export type ApChannelUtilizationResponse = MetricsResponse & {
  __typename?: 'APChannelUtilizationResponse';
  /** Metadata about the channel utilization metrics. */
  metadata?: Maybe<MetricsMetadata>;
  /** List of channel utilization metrics values. */
  values: Array<ApChannelUtilizationMetricsValue>;
};

/** Represents a value in the timeseries of AP channel utilization metrics. */
export type ApChannelUtilizationTimeseriesValue = {
  __typename?: 'APChannelUtilizationTimeseriesValue';
  /**
   * What channel the AP's radio was on at the time of the observation.
   * For single AP queries, this will be the most-seen channel during the bucket window.
   * This will be null for network / multiple-AP queries (because network-level is
   * an aggregation of all APs, which will likely be on a long list of channels).
   */
  channel?: Maybe<Scalars['Int']['output']>;
  /**
   * The channel width of the AP's radio at the time of the observation.
   * For single AP queries, this will be the most-seen channel width during the bucket window.
   * This will be null for network / multiple-AP queries (because network-level is
   * an aggregation of all APs, which will likely be on different channel widths).
   */
  channelWidth?: Maybe<Scalars['Int']['output']>;
  /** The maximum signal strength of interference sources detected on the channel. (in dBm) */
  interferenceSignalStrengthMaxdBm: Scalars['Int']['output'];
  /** The median signal strength of interference sources detected on the channel. (in dBm). This is a median of medians of observations within a bucket window, floored to the nearest integer. */
  interferenceSignalStrengthMediandBm: Scalars['Int']['output'];
  /** The number of sources of high interference detected on the channel. (An average of data observations, floored to the nearest integer). */
  interferenceSourceCountHigh: Scalars['Int']['output'];
  /** The number of sources of low interference detected on the channel. (An average of data observations, floored to the nearest integer). */
  interferenceSourceCountLow: Scalars['Int']['output'];
  /** The number of sources of medium interference detected on the channel. (An average of data observations, floored to the nearest integer). */
  interferenceSourceCountMedium: Scalars['Int']['output'];
  /** The amount of utilization contributed by non-802.11 interference in the environment, e.g., Bluetooth devices, cameras. (from 0 to 1) */
  non80211Utilization: Scalars['Float']['output'];
  /** The amount of utilization as a result of 802.11 interference by neighboring devices. (from 0 to 1) */
  obssUtilization: Scalars['Float']['output'];
  /** The percentage of time the channel was utilized due to transmissions from clients. (from 0 to 1) */
  rxUtilization: Scalars['Float']['output'];
  /** The percentage of time the channel was utilized by the AP itself. (from 0 to 1) */
  selfUtilization: Scalars['Float']['output'];
  /** The time at which the measurement was recorded. */
  timestamp: Scalars['DateTime']['output'];
  /** The percentage of time the channel was utilized. (from 0 to 1) */
  totalUtilization: Scalars['Float']['output'];
  /** The percentage of time the channel was utilized due to transmissions from the AP. (from 0 to 1) */
  txUtilization: Scalars['Float']['output'];
};

/**
 * Deprecated. This is a config1 query.
 * Represents an uptime metric value for an AP at a specific timestamp.
 */
export type ApUptimeMetricsValue = MetricsValue & {
  __typename?: 'APUptimeMetricsValue';
  /** The name of the AP that reported this measurement. */
  apName: Scalars['String']['output'];
  /** The time at which the measurement was recorded. */
  timestamp: Scalars['DateTime']['output'];
  /** The uptime value of the AP at the given timestamp, in seconds. */
  value: Scalars['Float']['output'];
};

/**
 * Deprecated. This is a config1 query.
 * Response type containing AP uptime metrics.
 */
export type ApUptimeResponse = MetricsResponse & {
  __typename?: 'APUptimeResponse';
  /** Metadata about the AP uptime metrics. */
  metadata?: Maybe<MetricsMetadata>;
  /** List of AP uptime metrics values. */
  values: Array<ApUptimeMetricsValue>;
};

/** Enum to indicate access availability. */
export enum AccessLevel {
  /**
   * Not complete on all parts of the stack but usable on a subset of networks for testing and validation.
   * Only Meter can view and configure it.
   */
  AccessLevelAlpha = 'ACCESS_LEVEL_ALPHA',
  /**
   * Not complete on all parts of the stack but usable on a subset of networks for testing and validation.
   * Customers who have it enabled can view and configure it.
   */
  AccessLevelBeta = 'ACCESS_LEVEL_BETA',
  /** Limited internally to operators only. Never intended for public consumption. */
  AccessLevelInternal = 'ACCESS_LEVEL_INTERNAL',
  /** Complete on all parts of the stack and usable by any network. */
  AccessLevelPublic = 'ACCESS_LEVEL_PUBLIC',
}

/** Properties for access point connection events. */
export type AccessPointConnectionProperties = {
  __typename?: 'AccessPointConnectionProperties';
  /** The access point that the connection event occurred on. */
  accessPoint: AccessPointVirtualDevice;
  /** The band on which the connection event occurred. */
  band: RadioBand;
  /** The mac address of the client corresponding to the connection event. */
  clientMac: Scalars['MacAddress']['output'];
  /** If the event type is `FAILED`, explains which step of the connection process failed. */
  connectionFailedStep?: Maybe<WirelessClientConnectionFailedStep>;
  /** The type of connection event. */
  connectionType: WirelessClientConnectionEventType;
  /** The time taken for this connection event in milliseconds. */
  durationMs?: Maybe<Scalars['Int']['output']>;
  /** The previous access point that the client was connected to, if the connection event is roam. */
  previousAccessPoint?: Maybe<AccessPointVirtualDevice>;
  /** The reason code, if the connection event is disassociated or failed. */
  reasonCode?: Maybe<Scalars['Int']['output']>;
  /** The ssid on which the connection event occurred. */
  ssid: Ssid;
};

/** Properties for access point dfs reset events. */
export type AccessPointDfsChannelResetProperties = {
  __typename?: 'AccessPointDfsChannelResetProperties';
  /** New fallback channel after the dfs channel reset. */
  fbChan: Scalars['Int']['output'];
  /** New operational channel after the dfs channel reset. */
  newOpChan: Scalars['Int']['output'];
  /** Operational channel before the dfs channel reset. */
  opChan: Scalars['Int']['output'];
  /** The virtual device that the dfs reset occurred on. */
  virtualDevice?: Maybe<VirtualDevice>;
};

/** An access point hardware device represents a physical access point. */
export type AccessPointHardwareDevice = HardwareDevice & {
  __typename?: 'AccessPointHardwareDevice';
  /** The list of BSSIDs (Basic Service Set Identifiers) that represent unique identifiers for the access point's SSID and radio band combinations. */
  BSSIDs: Array<Bssid>;
  /** Shows the most recent boot history of a device (buildName, bootCount). */
  bootHistory: Array<BootInfo>;
  /** The timestamp when the hardware device was first created in the system. */
  createdAt: Scalars['DateTime']['output'];
  /** The model name of the hardware device. */
  deviceModel: DeviceModel;
  /** The type of the hardware device. */
  deviceType: DeviceType;
  /** If the device is no longer connected to the backend, this is the time at which it was last connected. */
  disconnectedFromBackendAt?: Maybe<Scalars['DateTime']['output']>;
  /** The IP address of the access point hardware device. */
  ipAddress?: Maybe<Scalars['String']['output']>;
  /**
   * True if the device has an active websocket connection to the backend. Note that this only works if the device has registered via the /v2/register endpoint (i.e., is a Config 2 device) - otherwise is always false.
   * @deprecated Refer to `isSpare` instead.
   */
  isActive: Scalars['Boolean']['output'];
  /** Indicates whether the hardware device is connected to the backend. */
  isConnectedToBackend: Scalars['Boolean']['output'];
  /** Indicates whether the hardware device's console port is enabled. */
  isConsoleEnabled: Scalars['Boolean']['output'];
  /** Indicates whether the hardware device is marked as a development (dev) device, moving it into the dev (staging) realm for testing purposes. */
  isDev: Scalars['Boolean']['output'];
  /** Indicates whether the hardware device is in factory mode. */
  isFactoryMode: Scalars['Boolean']['output'];
  /** True if the AP's MAC address exists in the most recent controller MAC table for the network. */
  isInCurrentControllerMACTable: Scalars['Boolean']['output'];
  /** Indicates whether the hardware device is an RMA (Return Merchandise Authorization) replacement device. */
  isRMA: Scalars['Boolean']['output'];
  /** Indicates whether the hardware device has been retired. */
  isRetired: Scalars['Boolean']['output'];
  /** A spare hardware device belongs to a network but not a virtual device. Used most often to keep track of spare hardware we ship to a customer but don't install immediately. */
  isSpare: Scalars['Boolean']['output'];
  /** The latest device config metadata (ie. the config without the actual JSON payload) for the device. */
  latestDeviceConfigMetadata?: Maybe<DeviceConfigMetadata>;
  /** The MAC address of the hardware device. */
  macAddress?: Maybe<Scalars['MacAddress']['output']>;
  /** The UUID of the network that the spare hardware device belongs to. Spare hardware devices that are not affiliated with a virtual device will have this field populated. */
  networkUUID?: Maybe<Scalars['UUID']['output']>;
  /** The physical interface (on a Meter Switch) that the access point is connected to, if applicable. */
  phyInterfaceConnectedTo?: Maybe<PhyInterface>;
  /**
   * If the access point is not currently connected to a physical interface on a Meter Switch (ie. `phyInterfaceConnectedTo` is null),
   * then this field will be populated with the physical interface that the access point was last connected to, if applicable and known.
   * Only returns a result if the AP was connected to a Switch in the last 30 days and the network is on a sufficient NOS version that reports LLDP stats.
   */
  phyInterfaceLastConnectedTo?: Maybe<PhyInterfaceConnectedAt>;
  /** The public key used to add the device to the jumphost's WireGuard interface. */
  publicKey?: Maybe<Scalars['String']['output']>;
  /** The unique serial number of the hardware device. */
  serialNumber: Scalars['String']['output'];
  /** The network that the spare hardware device belongs to. Spare hardware devices that are not affiliated with a virtual device will have this field populated. */
  spareDeviceNetwork?: Maybe<Network>;
  /** IPv6 address on the jumphost subnet. Used to send requests to the device. */
  tunnelIPAddress?: Maybe<Scalars['String']['output']>;
  /** The timestamp when the hardware device was last updated in the system. */
  updatedAt: Scalars['DateTime']['output'];
  /**
   * The uptime metrics from the time series database for the device.
   * @deprecated Use `VirtualDevice.uptime` instead.
   */
  uptime?: Maybe<Scalars['Duration']['output']>;
  /** The virtual device associated with this hardware device, if any. */
  virtualDevice?: Maybe<VirtualDevice>;
  /** The UUID of the virtual device this hardware device is assigned to, if any. */
  virtualDeviceUUID?: Maybe<Scalars['UUID']['output']>;
};

/** An access point hardware device represents a physical access point. */
export type AccessPointHardwareDeviceBssiDsArgs = {
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
};

/** An access point hardware device represents a physical access point. */
export type AccessPointHardwareDeviceBootHistoryArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
};

/** An individual Access Point's health scores. */
export type AccessPointHealthScores = {
  __typename?: 'AccessPointHealthScores';
  /** This represents the quality and stability of connections between the device and its clients. */
  connectionScore: Scalars['Int']['output'];
  /** The total score, which is an aggregate of the other scores. */
  overallScore: Scalars['Int']['output'];
  /** This represents the overall throughput, latency, etc. of the device." */
  performanceScore: Scalars['Int']['output'];
  /** The score of the device's wireless environment (interference, noise, etc.). */
  rfScore: Scalars['Int']['output'];
  /** The score of the system (CPU, memory, etc) of the device. */
  systemScore: Scalars['Int']['output'];
  /** The timestamp when the health scores were last updated. */
  timestamp: Scalars['DateTime']['output'];
};

/** Properties for access point radar hit detected events. */
export type AccessPointRadarHitDetectedProperties = {
  __typename?: 'AccessPointRadarHitDetectedProperties';
  /** Clients moved off the AP (probably) due to the radar hit */
  clientsMovedOff: Array<Scalars['String']['output']>;
  /** Operation channel before the radar hit. */
  dfsChannel: Scalars['Int']['output'];
  /** Operational channel after the radar hit */
  fallbackChannel: Scalars['Int']['output'];
  /** The virtual device that detected the radar hit. */
  virtualDevice?: Maybe<VirtualDevice>;
};

/** An access point virtual device is a logical representation of a physical access point. */
export type AccessPointVirtualDevice = VirtualDevice & {
  __typename?: 'AccessPointVirtualDevice';
  /** The unique identifier (UUID) of the virtual device. */
  UUID: Scalars['UUID']['output'];
  /** The wireless clients that are currently connected to the access point. */
  connectedClients: Array<WirelessClient>;
  /** The timestamp when the virtual device was first created in the system. */
  createdAt: Scalars['DateTime']['output'];
  /** An optional description for the virtual device. */
  description?: Maybe<Scalars['String']['output']>;
  /** The model name of the virtual device. */
  deviceModel: DeviceModel;
  /** The type of the virtual device. */
  deviceType: VirtualDeviceType;
  /** The hardware device associated with this virtual device, if any. */
  hardwareDevice?: Maybe<HardwareDevice>;
  /** Indicates whether the virtual device's console port is enabled. */
  isConsoleEnabled: Scalars['Boolean']['output'];
  /** Indicates whether debug logging is enabled on the virtual device. */
  isDebugLogEnabled: Scalars['Boolean']['output'];
  /** Indicates whether LED dark mode is enabled on the access point, which turns off all LED activity. */
  isLEDDarkModeEnabled: Scalars['Boolean']['output'];
  /** A human-friendly name for the device. */
  label: Scalars['String']['output'];
  /** The health scores of an Access Point aggregated from the last 5 minutes. */
  latestHealthScores?: Maybe<AccessPointHealthScores>;
  /** The network that the virtual device belongs to. */
  network: Network;
  /** The unique identifier (UUID) of the network the virtual device belongs to. */
  networkUUID: Scalars['UUID']['output'];
  /** The group that the device belongs to for firmware upgrade grouping purposes. */
  nosUpgradeGroup: NosUpgradeGroup;
  /** The current NOS firmware version that the virtual device is configured to run. */
  nosVersion?: Maybe<ConfiguredNosVersion>;
  /** The identifier of the NOS firmware version that the virtual device is configured to run. */
  nosVersionID: Scalars['Int']['output'];
  /** WifiObserverSettings currently configured to target that device */
  observerSettings?: Maybe<Array<WifiObserverSetting>>;
  /** The NOS firmware version that the virtual device is scheduled to upgrade to. */
  pendingNosVersion?: Maybe<PendingNosVersion>;
  /** The radio profile associated with this access point. */
  radioProfile?: Maybe<RadioProfile>;
  /** The UUID of the radio profile associated with this access point. */
  radioProfileUUID?: Maybe<Scalars['UUID']['output']>;
  /** The radio settings (channel, power) specific to this access point. */
  radioSettings: RadioSettings;
  /** All of the enabled SSIDs (Service Set Identifiers) that the access point is broadcasting. */
  ssids: Array<Ssid>;
  /** The virtual device tags on this access point. */
  tags?: Maybe<Array<VirtualDeviceTag>>;
  /** Data about this virtual device's position in its network's topology. */
  topologyData?: Maybe<VirtualDeviceTopologyData>;
  /** The timestamp when the virtual device was last updated in the system. */
  updatedAt: Scalars['DateTime']['output'];
  /** The uptime from our time series database for the device. */
  uptime?: Maybe<Scalars['Duration']['output']>;
};

/** An access point virtual device is a logical representation of a physical access point. */
export type AccessPointVirtualDeviceObserverSettingsArgs = {
  resultsFilter?: InputMaybe<ObserverResultsFilterInput>;
};

/** Input type for specifying options when querying active clients metrics. */
export type ActiveClientsInput = {
  /** Whether to include meter hardware in the metrics calculation. */
  includeMeterHardware?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Response type containing active clients metrics over a specified time range. */
export type ActiveClientsMetricsResponse = MetricsResponse & {
  __typename?: 'ActiveClientsMetricsResponse';
  /**
   * Aggregated metadata for active clients over the specified time range.
   * @deprecated Use `wired` and `wireless` instead.
   */
  metadata?: Maybe<MetricsMetadata>;
  /**
   * A list of active clients (both wired and wireless) metrics values.
   * @deprecated Use `wired` and `wireless` instead.
   */
  values: Array<ActiveClientsMetricsValue>;
  /** A list of wired active clients metrics values. */
  wired: Array<ActiveClientsMetricsValue>;
  /** A list of wireless active clients metrics values. */
  wireless: Array<ActiveClientsMetricsValue>;
};

/** Represents a single data point for the number of active clients at a given timestamp. */
export type ActiveClientsMetricsValue = MetricsValue & {
  __typename?: 'ActiveClientsMetricsValue';
  /** The timestamp of the metric data point. */
  timestamp: Scalars['DateTime']['output'];
  /** The number of active clients at the given timestamp. */
  value: Scalars['Float']['output'];
};

/** Input type for adding a network to an AutoVPN Group. */
export type AddNetworkToAutoVpnGroupInput = {
  /** Indicates if failover is enabled for the member's uplink. */
  isFailoverEnabled?: Scalars['Boolean']['input'];
  /** Unique identifier of the network to add as a member. */
  networkUUID: Scalars['UUID']['input'];
  /** List of permitted VLAN unique identifiers. The associated VLANs must have participatesInVPNs set to true. */
  permittedVLANUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Unique identifier of the physical interface used by the member's uplink. */
  phyInterfaceUUID: Scalars['UUID']['input'];
};

/**
 * Address represents a physical address, used with an ISP. It encompasses the Location and Sublocation.
 *
 * WARNING: These fields are currently different from the fields used in the MailingAddress type. There is a plan to
 * consolidate these types in the future.
 */
export type Address = {
  __typename?: 'Address';
  /** Unique identifier for the location. */
  UUID: Scalars['UUID']['output'];
  /** First line of the address. Typically includes street number and name. */
  address1: Scalars['String']['output'];
  /** Second line of the address. Typically includes apartment, suite, unit, building, floor, etc. */
  address2: Scalars['String']['output'];
  /** City where the address is located. */
  city: Scalars['String']['output'];
  /** Company associated with this address. */
  company?: Maybe<Company>;
  /** ISO 3166-1 alpha-2 country code for the address. */
  country: Scalars['String']['output'];
  /** Postal or ZIP code for the address. */
  postalCode: Scalars['String']['output'];
  /** State or province where the address is located. */
  state: Scalars['String']['output'];
  /** Unique identifier for the sublocation, such as a specific site or building. */
  sublocationUUID: Scalars['UUID']['output'];
};

/** Represents a network client that is affected by one or more CVEs by their MAC address and network UUID. */
export type AffectedClient = {
  __typename?: 'AffectedClient';
  /** CVE ID */
  cveID: Scalars['String']['output'];
  /** MAC address identifying the affected client. */
  macAddress: Scalars['MacAddress']['output'];
  /** Network UUID. */
  networkUUID: Scalars['UUID']['output'];
};

/**
 * A record of an alert and its details.
 *
 * It contains every starting edge cycle alert for a unique signature that is "triggered"
 * from alert_engine_run_outcomes. This does not necessarily mean that the alert was dispatched.
 * A signature is a key formed by combining the name of the alert definition and its inputs.
 *
 * An edge cycle is defined as:
 *     - Starting edge cycle – a signature meeting the threshold to be triggered
 *     - Ending edge cycle – that same signature exiting the triggered threshold
 */
export type AlertAuditLogEntry = {
  __typename?: 'AlertAuditLogEntry';
  /** The unique identifier for this alert audit log entry. */
  UUID: Scalars['UUID']['output'];
  /** The definition of the alert that was triggered. */
  alertDefinition: AlertDefinition;
  /** The UUID of the company associated with this alert. */
  companyUUID: Scalars['UUID']['output'];
  /** The reason an alert dispatch was skipped. */
  dispatchSkipReason?: Maybe<AlertDispatchSkipReason>;
  /** When an alert trigger was dispatched. */
  dispatchedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The UUID of the network associated with this alert. */
  networkUUID: Scalars['UUID']['output'];
  /**
   * When an alert was triggered, meaning an alert engine run evaluated to true,
   * not necessarily when the alert was dispatched.
   */
  triggeredAt: Scalars['DateTime']['output'];
};

export type AlertAuditLogFilter = {
  /**
   * Corresponds to the name of the alert definition.
   * Query will return an error if the alert name is invalid.
   */
  alertName?: InputMaybe<Scalars['String']['input']>;
  /** The maximum number of alert audit log entries to return (default is 100). */
  limit?: Scalars['Int']['input'];
  /** Filter alerts triggered at or before this date and time. */
  maxTriggeredAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter alerts triggered at or after this date and time. */
  minTriggeredAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** The number of alert audit log entries to skip before starting to collect the result set (default is 0). */
  offset?: Scalars['Int']['input'];
};

/** An AlertDefinition specifies parameters for different types of Alerts used to notify stakeholders of important events for a network. */
export type AlertDefinition = {
  __typename?: 'AlertDefinition';
  /** The access availability of the alert. */
  availability: AccessLevel;
  /** A description of the alert. */
  description?: Maybe<Scalars['String']['output']>;
  /** A user-friendly display name for the alert. */
  displayName: Scalars['String']['output'];
  /** Whether the alert is loadable in batches. */
  isBatch: Scalars['Boolean']['output'];
  /** Whether the alert is supported for fleetwide notification settings. */
  isFleetwideSupported: Scalars['Boolean']['output'];
  /** The unique name of the alert. */
  name: Scalars['String']['output'];
  /** The parameters associated with the alert. */
  parameters: Array<AlertParameter>;
};

/** Reasons an alert dispatch is skipped. */
export enum AlertDispatchSkipReason {
  /** error dispatching alert */
  DispatchError = 'DISPATCH_ERROR',
  /** do not dispatch is set */
  DoNotDispatch = 'DO_NOT_DISPATCH',
  /** dry run enabled */
  DryRun = 'DRY_RUN',
  /** error in evaluation */
  EvaluationError = 'EVALUATION_ERROR',
  /** alert evaluation skipped */
  EvaluationSkipped = 'EVALUATION_SKIPPED',
  /** no state transition */
  NoStateTransition = 'NO_STATE_TRANSITION',
  /** alert is snoozed */
  Snooze = 'SNOOZE',
}

/** An interface representing a parameter for an alert. */
export type AlertParameter = {
  /** Description of the parameter. */
  description?: Maybe<Scalars['String']['output']>;
  /** Name of the parameter to be displayed in the UI. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Indicates whether the parameter is fleet supported. */
  isFleetwideSupported: Scalars['Boolean']['output'];
  /** The name of the parameter. */
  name: Scalars['AlertParameterName']['output'];
  /** Indicates whether the parameter is required. */
  required: Scalars['Boolean']['output'];
  /** The data type of the parameter. */
  type: AlertParameterType;
  /**
   * Unique identifier of the alert parameter.
   * @deprecated Use name instead
   */
  uuid: Scalars['UUID']['output'];
};

/** A boolean parameter for an alert. */
export type AlertParameterBoolean = AlertParameter & {
  __typename?: 'AlertParameterBoolean';
  /** The default value of the parameter. */
  defaultValue?: Maybe<Scalars['Boolean']['output']>;
  /** Description of the parameter. */
  description?: Maybe<Scalars['String']['output']>;
  /** Name of the parameter to be displayed in the UI. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** An example value of the parameter. */
  exampleValue?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates whether the parameter is fleet supported. */
  isFleetwideSupported: Scalars['Boolean']['output'];
  /** The name of the parameter. */
  name: Scalars['AlertParameterName']['output'];
  /** Indicates whether the parameter is required. */
  required: Scalars['Boolean']['output'];
  /** The data type of the parameter. */
  type: AlertParameterType;
  /**
   * Unique identifier of the alert parameter.
   * @deprecated Use name instead
   */
  uuid: Scalars['UUID']['output'];
};

/** A date parameter (without time) for an alert. */
export type AlertParameterDate = AlertParameter & {
  __typename?: 'AlertParameterDate';
  /** The default value of the parameter. */
  defaultValue?: Maybe<Scalars['DateTime']['output']>;
  /** Description of the parameter. */
  description?: Maybe<Scalars['String']['output']>;
  /** Name of the parameter to be displayed in the UI. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** An example value of the parameter. */
  exampleValue?: Maybe<Scalars['DateTime']['output']>;
  /** Indicates whether the parameter is fleet supported. */
  isFleetwideSupported: Scalars['Boolean']['output'];
  /**
   * The name of the parameter.
   * @deprecated Use name instead
   */
  name: Scalars['AlertParameterName']['output'];
  /** Indicates whether the parameter is required. */
  required: Scalars['Boolean']['output'];
  /** The data type of the parameter. */
  type: AlertParameterType;
  /** Unique identifier of the alert parameter. */
  uuid: Scalars['UUID']['output'];
};

/** A date and time parameter for an alert. */
export type AlertParameterDateTime = AlertParameter & {
  __typename?: 'AlertParameterDateTime';
  /** The default value of the parameter. */
  defaultValue?: Maybe<Scalars['DateTime']['output']>;
  /** Description of the parameter. */
  description?: Maybe<Scalars['String']['output']>;
  /** Name of the parameter to be displayed in the UI. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** An example value of the parameter. */
  exampleValue?: Maybe<Scalars['DateTime']['output']>;
  /** Indicates whether the parameter is fleet supported. */
  isFleetwideSupported: Scalars['Boolean']['output'];
  /** The name of the parameter. */
  name: Scalars['AlertParameterName']['output'];
  /** Indicates whether the parameter is required. */
  required: Scalars['Boolean']['output'];
  /** The data type of the parameter. */
  type: AlertParameterType;
  /**
   * Unique identifier of the alert parameter.
   * @deprecated Use name instead
   */
  uuid: Scalars['UUID']['output'];
};

/** A duration parameter for an alert. */
export type AlertParameterDuration = AlertParameter & {
  __typename?: 'AlertParameterDuration';
  /** The default value of the parameter. */
  defaultValue?: Maybe<Scalars['Duration']['output']>;
  /** Description of the parameter. */
  description?: Maybe<Scalars['String']['output']>;
  /** Name of the parameter to be displayed in the UI. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** An example value of the parameter. */
  exampleValue?: Maybe<Scalars['Duration']['output']>;
  /** Indicates whether the parameter is fleet supported. */
  isFleetwideSupported: Scalars['Boolean']['output'];
  /** The name of the parameter. */
  name: Scalars['AlertParameterName']['output'];
  /** Indicates whether the parameter is required. */
  required: Scalars['Boolean']['output'];
  /** The data type of the parameter. */
  type: AlertParameterType;
  /**
   * Unique identifier of the alert parameter.
   * @deprecated Use name instead
   */
  uuid: Scalars['UUID']['output'];
};

/** A numeric parameter for an alert. */
export type AlertParameterNumber = AlertParameter & {
  __typename?: 'AlertParameterNumber';
  /** The default value of the parameter. */
  defaultValue?: Maybe<Scalars['Float']['output']>;
  /** Description of the parameter. */
  description?: Maybe<Scalars['String']['output']>;
  /** Name of the parameter to be displayed in the UI. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** An example value of the parameter. */
  exampleValue?: Maybe<Scalars['Float']['output']>;
  /** Indicates whether the parameter is fleet supported. */
  isFleetwideSupported: Scalars['Boolean']['output'];
  /**
   * The name of the parameter.
   * @deprecated Use name instead
   */
  name: Scalars['AlertParameterName']['output'];
  /** Indicates whether the parameter is required. */
  required: Scalars['Boolean']['output'];
  /** The data type of the parameter. */
  type: AlertParameterType;
  /** Unique identifier of the alert parameter. */
  uuid: Scalars['UUID']['output'];
};

/** A number array parameter for an alert. */
export type AlertParameterNumberArray = AlertParameter & {
  __typename?: 'AlertParameterNumberArray';
  /** The default value of the parameter. */
  defaultValue?: Maybe<Array<Scalars['Float']['output']>>;
  /** Description of the parameter. */
  description?: Maybe<Scalars['String']['output']>;
  /** Name of the parameter to be displayed in the UI. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** An example value of the parameter. */
  exampleValue?: Maybe<Array<Scalars['Float']['output']>>;
  /** Indicates whether the parameter is fleet supported. */
  isFleetwideSupported: Scalars['Boolean']['output'];
  /** The name of the parameter. */
  name: Scalars['AlertParameterName']['output'];
  /** Indicates whether the parameter is required. */
  required: Scalars['Boolean']['output'];
  /** The data type of the parameter. */
  type: AlertParameterType;
  /**
   * Unique identifier of the alert parameter.
   * @deprecated Use name instead
   */
  uuid: Scalars['UUID']['output'];
};

/** A string parameter for an alert. */
export type AlertParameterString = AlertParameter & {
  __typename?: 'AlertParameterString';
  /** The default value of the parameter. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** Description of the parameter. */
  description?: Maybe<Scalars['String']['output']>;
  /** Name of the parameter to be displayed in the UI. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** An example value of the parameter. */
  exampleValue?: Maybe<Scalars['String']['output']>;
  /** Indicates whether the parameter is fleet supported. */
  isFleetwideSupported: Scalars['Boolean']['output'];
  /**
   * The name of the parameter.
   * @deprecated Use name instead
   */
  name: Scalars['AlertParameterName']['output'];
  /** Indicates whether the parameter is required. */
  required: Scalars['Boolean']['output'];
  /** The data type of the parameter. */
  type: AlertParameterType;
  /** Unique identifier of the alert parameter. */
  uuid: Scalars['UUID']['output'];
};

/** A number array parameter for an alert. */
export type AlertParameterStringArray = AlertParameter & {
  __typename?: 'AlertParameterStringArray';
  /** The default value of the parameter. */
  defaultValue?: Maybe<Array<Scalars['String']['output']>>;
  /** Description of the parameter. */
  description?: Maybe<Scalars['String']['output']>;
  /** Name of the parameter to be displayed in the UI. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** An example value of the parameter. */
  exampleValue?: Maybe<Array<Scalars['String']['output']>>;
  /** Indicates whether the parameter is fleet supported. */
  isFleetwideSupported: Scalars['Boolean']['output'];
  /** The name of the parameter. */
  name: Scalars['AlertParameterName']['output'];
  /** Indicates whether the parameter is required. */
  required: Scalars['Boolean']['output'];
  /** The data type of the parameter. */
  type: AlertParameterType;
  /**
   * Unique identifier of the alert parameter.
   * @deprecated Use name instead
   */
  uuid: Scalars['UUID']['output'];
};

/** Specifies the data type of an alert parameter. */
export enum AlertParameterType {
  /** A boolean parameter. */
  Boolean = 'BOOLEAN',
  /** A date parameter (without time). */
  Date = 'DATE',
  /** A date and time parameter. */
  Datetime = 'DATETIME',
  /** A duration parameter. */
  Duration = 'DURATION',
  /** A numeric parameter. */
  Number = 'NUMBER',
  /** A number array parameter. */
  NumberArray = 'NUMBER_ARRAY',
  /** A string parameter. */
  String = 'STRING',
  /** A string array parameter. */
  StringArray = 'STRING_ARRAY',
  /** A UUID parameter. */
  Uuid = 'UUID',
  /** A UUID array parameter. */
  UuidArray = 'UUID_ARRAY',
}

/** A UUID parameter for an alert. */
export type AlertParameterUuid = AlertParameter & {
  __typename?: 'AlertParameterUUID';
  /** The default value of the parameter. */
  defaultValue?: Maybe<Scalars['UUID']['output']>;
  /** Description of the parameter. */
  description?: Maybe<Scalars['String']['output']>;
  /** Name of the parameter to be displayed in the UI. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** An example value of the parameter. */
  exampleValue?: Maybe<Scalars['UUID']['output']>;
  /** Indicates whether the parameter is fleet supported. */
  isFleetwideSupported: Scalars['Boolean']['output'];
  /** The name of the parameter. */
  name: Scalars['AlertParameterName']['output'];
  /** Indicates whether the parameter is required. */
  required: Scalars['Boolean']['output'];
  /** The data type of the parameter. */
  type: AlertParameterType;
  /**
   * Unique identifier of the alert parameter.
   * @deprecated Use name instead
   */
  uuid: Scalars['UUID']['output'];
};

/** A UUID array parameter for an alert. */
export type AlertParameterUuidArray = AlertParameter & {
  __typename?: 'AlertParameterUUIDArray';
  /** The default value of the parameter. */
  defaultValue?: Maybe<Array<Scalars['UUID']['output']>>;
  /** Description of the parameter. */
  description?: Maybe<Scalars['String']['output']>;
  /** Name of the parameter to be displayed in the UI. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** An example value of the parameter. */
  exampleValue?: Maybe<Array<Scalars['UUID']['output']>>;
  /** Indicates whether the parameter is fleet supported. */
  isFleetwideSupported: Scalars['Boolean']['output'];
  /** The name of the parameter. */
  name: Scalars['AlertParameterName']['output'];
  /** Indicates whether the parameter is required. */
  required: Scalars['Boolean']['output'];
  /** The data type of the parameter. */
  type: AlertParameterType;
  /**
   * Unique identifier of the alert parameter.
   * @deprecated Use name instead
   */
  uuid: Scalars['UUID']['output'];
};

/** An alert receiver is called when an alert is triggered. */
export type AlertReceiver = {
  __typename?: 'AlertReceiver';
  /** Unique identifier for the alert receiver. */
  UUID: Scalars['UUID']['output'];
  /** Unique identifier of the company that owns this alert receiver. */
  companyUUID: Scalars['UUID']['output'];
  /** Timestamp when the alert receiver was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Timestamp when the alert receiver was deleted (null if not deleted). */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Descriptive label for the alert receiver. */
  label: Scalars['String']['output'];
  /** List of alert targets associated with this alert receiver. */
  targets: Array<AlertTarget>;
  /** Timestamp when the alert receiver was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** An interface representing a target to which alerts can be sent. This can be implemented by different types of alert targets, such as email or webhook. */
export type AlertTarget = {
  /** The unique identifier of the alert target. */
  UUID: Scalars['UUID']['output'];
  /** The unique identifier of the company that owns the alert target. */
  companyUUID: Scalars['UUID']['output'];
  /** The timestamp when the alert target was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The timestamp when the alert target was deleted, if applicable. */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The type of the alert target. */
  type: AlertTargetType;
  /** The timestamp when the alert target was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** An email alert target that implements the AlertTarget interface. Used to send alerts to a specified email address. */
export type AlertTargetEmail = AlertTarget & {
  __typename?: 'AlertTargetEmail';
  /** The unique identifier of the email alert target. */
  UUID: Scalars['UUID']['output'];
  /** The unique identifier of the company that owns the email alert target. */
  companyUUID: Scalars['UUID']['output'];
  /** The timestamp when the email alert target was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The timestamp when the email alert target was deleted, if applicable. */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The email address to which alerts will be sent. */
  emailAddress: Scalars['String']['output'];
  /** The type of the alert target, this should always be EMAIL. */
  type: AlertTargetType;
  /** The timestamp when the email alert target was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

export type AlertTargetInput = {
  /** Type of the alert target. */
  alertTargetType: AlertTargetType;
  /** Unique identifier of the alert target. Required for all alert target types except EMAIL. */
  alertTargetUUID?: InputMaybe<Scalars['String']['input']>;
  /** Email address for creating a new email alert target. Required if creating a new email target. */
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  /** Slack channel ID for creating a new slack alert target. Required if creating a new slack target. */
  slackChannelID?: InputMaybe<Scalars['String']['input']>;
  /** Slack channel label for creating a new slack alert target. Required if creating a new slack target. */
  slackChannelLabel?: InputMaybe<Scalars['String']['input']>;
};

/** An alert target that implements the AlertTarget interface. Used to send alerts to a specified slack channel. */
export type AlertTargetSlack = AlertTarget & {
  __typename?: 'AlertTargetSlack';
  /** The unique identifier of the slack alert target. */
  UUID: Scalars['UUID']['output'];
  /** The Slack channel ID to which alerts will be sent. */
  channelID: Scalars['String']['output'];
  /** The unique identifier of the company that owns the slack alert target. */
  companyUUID: Scalars['UUID']['output'];
  /** The timestamp when the slack alert target was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The timestamp when the slack alert target was deleted, if applicable. */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The label of the slack alert target. */
  label?: Maybe<Scalars['String']['output']>;
  /** The type of the alert target, this should always be SLACK. */
  type: AlertTargetType;
  /** The timestamp when the slack alert target was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** An enumeration of possible alert target types. */
export enum AlertTargetType {
  /** Alert target type indicating an email address. */
  Email = 'EMAIL',
  /** Alert target type indicating a slack channel. */
  Slack = 'SLACK',
  /** Alert target type indicating a webhook endpoint. */
  Webhook = 'WEBHOOK',
}

/** A webhook alert target that implements the AlertTarget interface. Used to send alerts to a specified webhook URL. */
export type AlertTargetWebhook = AlertTarget & {
  __typename?: 'AlertTargetWebhook';
  /** The unique identifier of the webhook alert target. */
  UUID: Scalars['UUID']['output'];
  /** The type of authentication to use for the webhook. */
  authType?: Maybe<WebhookAuthType>;
  /** The value of the authentication header to use for the webhook. */
  authValue?: Maybe<Scalars['String']['output']>;
  /** The unique identifier of the company that owns the webhook alert target. */
  companyUUID: Scalars['UUID']['output'];
  /** The timestamp when the webhook alert target was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The timestamp when the webhook alert target was deleted, if applicable. */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** An optional label for the webhook alert target. */
  label?: Maybe<Scalars['String']['output']>;
  /** The secret used to sign webhook requests for verification. */
  signingSecret?: Maybe<Scalars['String']['output']>;
  /** The type of the alert target, indicating that it is a webhook. */
  type: AlertTargetType;
  /** The timestamp when the webhook alert target was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** The URL endpoint of the webhook where alerts will be sent. */
  url: Scalars['String']['output'];
};

/** A response type containing lists of alert targets for both emails and webhooks. */
export type AlertTargetsResponse = {
  __typename?: 'AlertTargetsResponse';
  /** A list of email alert targets. */
  emails: Array<AlertTargetEmail>;
  /** A list of slack alert targets. */
  slacks: Array<AlertTargetSlack>;
  /** A list of webhook alert targets. */
  webhooks: Array<AlertTargetWebhook>;
};

/** Input type for specifying filters when querying all client metrics timeseries data. */
export type AllClientMetricsTimeseriesFilterInput = {
  /** Specify the time range for the timeseries data. */
  timeFilter: MetricsFilterInput;
};

/** Response type containing client metrics timeseries data over a specified time range. */
export type AllClientMetricsTimeseriesResponse = {
  __typename?: 'AllClientMetricsTimeseriesResponse';
  /** Aggregated data for the total bytes received. */
  rxBytes: BaseMetricsResponse;
  /** Aggregated data for the total bytes transmitted. */
  txBytes: BaseMetricsResponse;
};

/** An enumeration of permitted folders where files can be uploaded to or downloaded from. */
export enum AllowedFolder {
  AccessPointPhotos = 'access_point_photos',
  CompanyLogos = 'company_logos',
  FloorPlanImages = 'floor_plan_images',
  InternalNotesAttachments = 'internal_notes_attachments',
  MarketingChangelogEntries = 'marketing_changelog_entries',
  NetworkTopologyPhotos = 'network_topology_photos',
  OnboardingDocumentUploads = 'onboarding_document_uploads',
  ProviderLogos = 'provider_logos',
}

export type AnomalyStatsFilterInput = {
  /** The lookback time to consider stats for, starting at `endTime`. Maximum allowed value is 7776000, 90 days. */
  durationSeconds: Scalars['Int']['input'];
  /** The latest observation time to consider stats for, inclusive. Defaults to the current time if not set. */
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** The maximum number of results to return, between 1 and 1000. Defaults to 100 if not set. */
  limit?: Scalars['Int']['input'];
  /** The number of results to skip before returning results. Defaults to 0 if not set. */
  offset?: Scalars['Int']['input'];
  /** The unique identifiers of the virtual devices to fetch stats for. */
  virtualDeviceUUIDs: Array<Scalars['UUID']['input']>;
};

/** Anomaly stats aggregate from multiple devices. */
export type AnomalyStatsGroup = {
  __typename?: 'AnomalyStatsGroup';
  /** The count of anomalies. */
  count: Scalars['Int']['output'];
  /** The error message of the anomaly. */
  message: Scalars['String']['output'];
  /** The most recent observed time of the anomaly. */
  mostRecentObservedAt: Scalars['DateTime']['output'];
  /** The raw stats for the anomaly. */
  rawStats: Array<Stat>;
  /** Describes the source of the anomaly. */
  sourceFunction: Scalars['String']['output'];
  /** The line number description of the source function. */
  sourceLine: Scalars['String']['output'];
  /** The stack trace of the anomaly. */
  stackTrace: Scalars['String']['output'];
};

/** DNS firewall rules for a DHCP rule. These are powered by Netstar. */
export type ApplicationDnsFirewallRule = {
  __typename?: 'ApplicationDNSFirewallRule';
  /** The unique identifier of the DNS firewall rule. */
  UUID: Scalars['UUID']['output'];
  /** The action to take when the rule is matched. */
  action: FirewallRuleAction;
  /** The application associated with the DNS firewall rule as specified by Netstar. */
  application?: Maybe<ApplicationDnsFirewallRuleApplication>;
  /** List of DHCP rule bindings for the application dns firewall rule. */
  boundDHCPRules?: Maybe<Array<DhcpRule>>;
  /** The category of the DNS firewall rule as specified by Netstar. */
  category?: Maybe<ApplicationDnsFirewallRuleCategory>;
  /** The timestamp when the rule was created. */
  createdAt: Scalars['DateTime']['output'];
  /**
   * The DHCP rule associated with this DNS firewall rule.
   * @deprecated Use bindings instead. This will be the first dhcpRule in bindings
   */
  dhcpRule: DhcpRule;
  /** The domain or FQDN that is matched by the rule, allowing for wildcards denoted by '*'. */
  domain?: Maybe<Scalars['String']['output']>;
  /** The group of the DNS firewall rule as specified by Netstar. */
  group?: Maybe<ApplicationDnsFirewallRuleGroup>;
  /** Indicates whether the rule is enabled. */
  isEnabled: Scalars['Boolean']['output'];
  /** The name of the DNS firewall rule. */
  name: Scalars['String']['output'];
  /** The priority of the rule, lower priority rules are applied first. */
  priority: Scalars['Int']['output'];
  /** The timestamp when the rule was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** The application associated with a DNS firewall rule as specified by Netstar. */
export type ApplicationDnsFirewallRuleApplication = {
  __typename?: 'ApplicationDNSFirewallRuleApplication';
  /** The unique identifier of the application. */
  id: Scalars['Int']['output'];
  /** Indicates whether the application is visible to the customer. */
  isVisible: Scalars['Boolean']['output'];
  /** The name of the application. */
  name: Scalars['String']['output'];
};

/** Categories of DNS firewall rules as specified by Netstar. */
export type ApplicationDnsFirewallRuleCategory = {
  __typename?: 'ApplicationDNSFirewallRuleCategory';
  /** A description of the category. */
  description: Scalars['String']['output'];
  /** The group to which this category belongs. */
  group: ApplicationDnsFirewallRuleGroup;
  /** The unique identifier of the category. */
  id: Scalars['Int']['output'];
  /** The name of the category. */
  name: Scalars['String']['output'];
};

/** Groups multiple ApplicationDNSFirewallRuleApplications together, based on Netstar's categorizations. */
export type ApplicationDnsFirewallRuleGroup = {
  __typename?: 'ApplicationDNSFirewallRuleGroup';
  /** The unique identifier of the group. */
  id: Scalars['Int']['output'];
  /** The name of the group. */
  name: Scalars['String']['output'];
};

/** A fleetwide notification setting that has been applied to a network. */
export type AppliedFleetwideNotificationSetting = {
  __typename?: 'AppliedFleetwideNotificationSetting';
  /** The alert receiver who will receive the notifications generated by this setting. */
  alertReceiver: AlertReceiver;
  /** The fleetwide notification setting that has been applied to the network. */
  fleetwideNotificationSetting: FleetwideNotificationSetting;
  /** The network that the fleetwide notification setting has been applied to. */
  network: Network;
};

/** Specifies the hardware device / virtual device pairing when assigning hardware to a virtual device. */
export type AssignHardwareDeviceToVirtualDeviceInput = {
  /** The serial number of the hardware device to assign. */
  serialNumber: Scalars['String']['input'];
  /** The UUID of the virtual device to assign the hardware device to. */
  virtualDeviceUUID: Scalars['UUID']['input'];
};

/** Input type for attaching a device to a rack elevation. */
export type AttachDeviceToRackElevationInput = {
  /** Whether the device is front-facing or rear-facing. */
  isFrontFacing?: InputMaybe<Scalars['Boolean']['input']>;
  /** A friendly name for display purposes. */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Additional context or comments about the device. */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** The number of ports on the device. Only for switches and patch panels; cannot be specified if it's a Meter device. */
  portCount?: InputMaybe<Scalars['Int']['input']>;
  /** The indexes of the rack units that the device occupies. */
  rackMountUnitIndexes: Array<Scalars['Int']['input']>;
  /** A non-null value if the device shares or will share its rack mount unit with another device. 0-indexed; lower number is to the left when viewing the rack from the front. For simplicity this must be 0 or 1 (at-most 2 devices per rack mount unit). */
  sideBySideIndex?: InputMaybe<Scalars['Int']['input']>;
  /** The type of the device. Cannot be specified if it's a Meter device. */
  type?: InputMaybe<RackElevationDeviceType>;
  /** If it's a Meter device, the virtual device's UUID. */
  virtualDeviceUUID?: InputMaybe<Scalars['UUID']['input']>;
};

/** An authentication token entity, representing a token issued to a user or device. */
export type AuthenticationToken = {
  __typename?: 'AuthenticationToken';
  /** The unique identifier of the token. */
  UUID: Scalars['UUID']['output'];
  /** The serial number of the hardware device associated with the token, if any. */
  hardwareDeviceSerial?: Maybe<Scalars['String']['output']>;
  /** The timestamp when the token was issued. */
  issuedAt: Scalars['DateTime']['output'];
  /** The timestamp when the token was revoked, if it has been revoked. */
  revokedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The ID of the user associated with the token, if any. */
  userID?: Maybe<Scalars['Int']['output']>;
};

/** Auto Channel Selection Jobs automatically select the best channel for Access Points (APs) in a network. */
export type AutoChannelSelectionJob = AutoSelectionJob &
  NetworkJob & {
    __typename?: 'AutoChannelSelectionJob';
    /** The unique identifier of the job. */
    UUID: Scalars['UUID']['output'];
    /** The date and time when the job was completed. Null if not completed yet. */
    completedAt?: Maybe<Scalars['DateTime']['output']>;
    /** The UUID of the network where the job is executed. */
    networkUUID: Scalars['UUID']['output'];
    /**
     * The results of the Auto Channel Selection job.
     * If the job is still running (completedAt is null), then no results will be returned.
     * One result will be returned for each virtual device (AP) that had its channel changed or encountered a warning.
     * If the device did not change channel and there was no warning, it will not appear in the results.
     */
    results?: Maybe<Array<AutoChannelSelectionResult>>;
    /** The date and time when the job is scheduled to start. */
    scheduledAt: Scalars['DateTime']['output'];
    /** The date and time when the job will time out if not completed. */
    timeoutAt: Scalars['DateTime']['output'];
    /** List of UUIDs of virtual devices (APs) involved in the job. */
    virtualDeviceUUIDs: Array<Scalars['UUID']['output']>;
  };

/** Input parameters for initializing an Auto Channel Selection Job. */
export type AutoChannelSelectionJobInput = {
  /**
   * The radio bands to run ACS for.
   * Currently, only the 5GHz band is supported, but this is required for future-proofing.
   */
  bands: Array<RadioBand>;
  /** Only for network-level runs: If true, only run ACS on APs that are experiencing high external interference. */
  excludeLowInterferenceAPs?: Scalars['Boolean']['input'];
  /**
   * If true, the ACS job will run during the network's next maintenance window.
   * Otherwise, it will run immediately.
   */
  scheduledAtNextMaintenanceWindow?: Scalars['Boolean']['input'];
};

/** The result of running Auto Channel Selection on a single virtual device (AP). */
export type AutoChannelSelectionResult = {
  __typename?: 'AutoChannelSelectionResult';
  /** The new 5GHz channel assigned to the AP after ACS ran. Null if no new channel was assigned. */
  new5GHzChannel?: Maybe<Scalars['Int']['output']>;
  /** The previous 5GHz channel assigned to the AP before ACS ran. Null if not applicable. */
  previous5GHzChannel?: Maybe<Scalars['Int']['output']>;
  /** The result type indicating the outcome of the Auto Channel Selection. */
  resultType: AutoChannelSelectionResultType;
  /** The date and time when the result was recorded. */
  timestamp: Scalars['DateTime']['output'];
  /** The UUID of the virtual device (AP) for which the result is reported. */
  virtualDeviceUUID: Scalars['UUID']['output'];
};

/** Enumeration of possible results for an Auto Channel Selection on an AP. */
export enum AutoChannelSelectionResultType {
  /** ACS ran and a channel was selected with the least number of BSSs, indicating minimal interference. */
  ChannelSelectedMinBss = 'CHANNEL_SELECTED_MIN_BSS',
  /** ACS ran but a random channel was selected, possibly due to insufficient data to make an informed choice. */
  ChannelSelectedRandom = 'CHANNEL_SELECTED_RANDOM',
  /** The Auto Channel Selection failed due to an unknown reason. */
  FailedUnknownReason = 'FAILED_UNKNOWN_REASON',
  /** The Auto Channel Selection was successful. */
  Success = 'SUCCESS',
}

/** An interface representing a generic Auto Selection Job with common fields. */
export type AutoSelectionJob = {
  /** The unique identifier of the job. */
  UUID: Scalars['UUID']['output'];
  /** The date and time when the job was completed. Null if not completed yet. */
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The UUID of the network where the job is executed. */
  networkUUID: Scalars['UUID']['output'];
  /** The date and time when the job is scheduled to start. */
  scheduledAt: Scalars['DateTime']['output'];
  /** The date and time when the job will time out if not completed. */
  timeoutAt: Scalars['DateTime']['output'];
  /** A list of UUIDs of virtual devices involved in the job. */
  virtualDeviceUUIDs: Array<Scalars['UUID']['output']>;
};

/** An AutoVPNGroup defines a collection of networks connected via Auto VPN through a central hub. */
export type AutoVpnGroup = {
  __typename?: 'AutoVPNGroup';
  /** Unique identifier for the AutoVPN Group. */
  UUID: Scalars['UUID']['output'];
  /** Slug of the company the AutoVPN Group belongs to. */
  companySlug: Scalars['String']['output'];
  /** Timestamp when the AutoVPN Group was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The network that acts as the hub in the AutoVPN Group. */
  hubNetwork: Network;
  /** Unique identifier of the network that acts as the hub in the AutoVPN Group. */
  hubNetworkUUID: Scalars['UUID']['output'];
  /** Configuration of the hub's uplink interface. */
  hubUplink: AutoVpnHubUplink;
  /** Indicates if the AutoVPN Group is enabled. */
  isEnabled: Scalars['Boolean']['output'];
  /** Indicates if hub failover is enabled. */
  isHubFailoverEnabled: Scalars['Boolean']['output'];
  /** List of members in the AutoVPN Group. */
  members?: Maybe<Array<AutoVpnMember>>;
  /** Name of the AutoVPN Group. */
  name: Scalars['String']['output'];
  /** List of routes configured in the AutoVPN Group. */
  routes?: Maybe<Array<AutoVpnRoute>>;
  /** Timestamp when the AutoVPN Group was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** Represents the configuration of the hub's uplink interface in an AutoVPN Group. */
export type AutoVpnHubUplink = {
  __typename?: 'AutoVPNHubUplink';
  /** Unique identifier for the hub's uplink. */
  UUID: Scalars['UUID']['output'];
  /** IP address assigned to the hub's uplink. */
  address: Scalars['IP']['output'];
  /** Prefix length of the uplink's IP address. */
  addressPrefixLength: Scalars['Int']['output'];
  /** Port number the hub listens on for VPN connections. */
  listenPort: Scalars['Int']['output'];
  /** Physical interface used by the hub's uplink. */
  phyInterface: PhyInterface;
  /** Unique identifier of the physical interface used by the hub's uplink. */
  phyInterfaceUUID: Scalars['UUID']['output'];
  /** Public key used for WireGuard VPN. */
  publicKey: Scalars['String']['output'];
};

/** Represents a member network within an AutoVPN Group. */
export type AutoVpnMember = {
  __typename?: 'AutoVPNMember';
  /** Unique identifier for the AutoVPN member. */
  UUID: Scalars['UUID']['output'];
  /** Timestamp when the AutoVPN member was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Indicates if failover is enabled for the member. */
  isFailoverEnabled: Scalars['Boolean']['output'];
  /** Network the member belongs to. */
  network: Network;
  /** Unique identifier of the network the member belongs to. */
  networkUUID: Scalars['UUID']['output'];
  /** VLANs permitted for the member. */
  permittedVLANs: Array<Vlan>;
  /** Timestamp when the AutoVPN member was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** Configuration of the member's uplink interface. */
  uplink: AutoVpnMemberUplink;
};

/** Response type containing Client VPN server timeseries data over a specified time range. */
export type AutoVpnMemberMetricsResponse = {
  __typename?: 'AutoVPNMemberMetricsResponse';
  /** Auto VPN Group. */
  autoVPNGroup: AutoVpnGroup;
  /** Client metrics for this Auto VPN Group. */
  memberMetrics: Array<AutoVpnMemberUplinkMetricsResponse>;
};

/** Represents the configuration of a member's uplink interface in an AutoVPN Group. */
export type AutoVpnMemberUplink = {
  __typename?: 'AutoVPNMemberUplink';
  /** Unique identifier for the member's uplink. */
  UUID: Scalars['UUID']['output'];
  /** IP address assigned to the member's uplink. */
  address: Scalars['IP']['output'];
  /** Prefix length of the uplink's IP address. */
  addressPrefixLength: Scalars['Int']['output'];
  /** The latest connection info an AutoVPN hub reported about a member. */
  connectionInfo?: Maybe<AutoVpnMemberUplinkConnectionInfo>;
  /** Unique identifier of the hub's uplink this member connects to. */
  hubUplinkUUID: Scalars['UUID']['output'];
  /** Port number the member listens on for VPN connections. */
  listenPort: Scalars['Int']['output'];
  /** Physical interface used by the member's uplink. */
  phyInterface: PhyInterface;
  /** Unique identifier of the physical interface used by the member's uplink. */
  phyInterfaceUUID: Scalars['UUID']['output'];
  /** Public key used for WireGuard VPN. */
  publicKey: Scalars['String']['output'];
};

/** Provides connection statistics for a member's uplink in an AutoVPN Group. */
export type AutoVpnMemberUplinkConnectionInfo = {
  __typename?: 'AutoVPNMemberUplinkConnectionInfo';
  /** The last time a handshake was received (from the hub's perspective). */
  lastHandshakeRx?: Maybe<Scalars['DateTime']['output']>;
  /** The last time a handshake was transmitted (from the hub's perspective). */
  lastHandshakeTx?: Maybe<Scalars['DateTime']['output']>;
  /** The last time a packet was received over the tunnel (from the hub's perspective). */
  lastPacketRx?: Maybe<Scalars['DateTime']['output']>;
  /** The last time a packet was transmitted over the tunnel (from the hub's perspective). */
  lastPacketTx?: Maybe<Scalars['DateTime']['output']>;
  /** Timestamp when the connection info was observed. */
  observedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Response type containing Auto VPN member uplink client timeseries data. */
export type AutoVpnMemberUplinkMetricsResponse = {
  __typename?: 'AutoVPNMemberUplinkMetricsResponse';
  /** Auto VPN member uplink for this series */
  autoVPNMemberUplink: AutoVpnMemberUplink;
  /** Aggregated throughput for the total bytes received in bps. */
  rxBytes: BaseMetricsResponse;
  /** Aggregated throughput for the total packets received per second. */
  rxPackets: BaseMetricsResponse;
  /** Aggregated throughput for the total bytes transmitted in bps. */
  txBytes: BaseMetricsResponse;
  /** Aggregated throughput for the total packets transmitted per second. */
  txPackets: BaseMetricsResponse;
};

/** An Auto VPN route defines a network route members of an Auto VPN group route through the hub. */
export type AutoVpnRoute = {
  __typename?: 'AutoVPNRoute';
  /** Unique identifier for the AutoVPN route. */
  UUID: Scalars['UUID']['output'];
  /** Timestamp when the route was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Destination gateway IP address for the route. */
  dstGateway: Scalars['IPV4']['output'];
  /** Prefix length for the destination IP of the route. */
  dstPrefixLength: Scalars['Int']['output'];
  /** Indicates if the route is enabled. */
  isEnabled: Scalars['Boolean']['output'];
  /** Name of the route. */
  name: Scalars['String']['output'];
  /** Timestamp when the route was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

export type AutoWifiObserverFiltersInput = {
  /** The UUID of the SSID to use for the observer test, along with the parameters to use for this SSID. */
  SSIDs: Array<AutoWifiObserverSsidFilter>;
  /** The radio band on which the test should be run. */
  bands: Array<RadioBand>;
  /** Optional list of virtual devices for which we want to add observer tests; if empty, use all observers */
  virtualDeviceUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

/** Filter auto WiFi Observer setting for this SSID; if set, usernames and passwords will be used for this SSID */
export type AutoWifiObserverSsidFilter = {
  /** The UUID of the SSID to use for the observer test. */
  SSIDUUID: Scalars['UUID']['input'];
  /** 802.1X password for authentication. */
  password8021X?: InputMaybe<Scalars['String']['input']>;
  /** 802.1X username for authentication. */
  username8021X?: InputMaybe<Scalars['String']['input']>;
};

/**
 * BSSID represents a unique identifier for a wireless network, in the form of a MAC address.
 * Every radio band / SSID pair for an AP has its own BSSID, derived from the hardware device's MAC address.
 */
export type Bssid = {
  __typename?: 'BSSID';
  /** The MAC address uniquely identifying this BSSID on the wireless network. */
  BSSID: Scalars['MacAddress']['output'];
  /** The SSID object associated with this BSSID. */
  SSID: Ssid;
  /** The UUID of the SSID associated with this BSSID. */
  SSIDUUID: Scalars['UUID']['output'];
  /** The hardware device representing the access point associated with this BSSID. */
  accessPointHardwareDevice: AccessPointHardwareDevice;
  /** The serial number of the access point associated with this BSSID. */
  accessPointSerialNumber: Scalars['String']['output'];
  /** A BSSID is inactive if it is associated with a disabled SSID, or the SSID is not broadcast for its AP, or the SSID is not allowed for its radio band, or the radio band is disabled on its AP's radio profile. */
  isActive: Scalars['Boolean']['output'];
  /** The radio frequency band on which this BSSID operates. */
  radioBand: RadioBand;
};

/** Base64 encoded image data. */
export type Base64Image = {
  __typename?: 'Base64Image';
  /** The base64 encoded image data. */
  data: Scalars['String']['output'];
  /** The type of the image. */
  imageType: ImageType;
};

/** Base implementation of MetricsValue that provides no more fields. */
export type BaseMetricsResponse = MetricsResponse & {
  __typename?: 'BaseMetricsResponse';
  /** Metadata providing additional information about the metrics data. */
  metadata?: Maybe<MetricsMetadata>;
  /** The list of metrics data points. */
  values: Array<BaseMetricsValue>;
};

/** Base implementation of MetricsValue that provides no more fields. */
export type BaseMetricsValue = MetricsValue & {
  __typename?: 'BaseMetricsValue';
  /** The timestamp for this metrics data point. */
  timestamp: Scalars['DateTime']['output'];
  /** The value of the metric at the given timestamp. */
  value: Scalars['Float']['output'];
};

/** A bearer session allows a token to be created for a CLI session using the credentials of the validator. */
export type BearerSession = {
  __typename?: 'BearerSession';
  /** The unique identifier for the bearer session. This UUID is used to reference and manage the session during its lifecycle. */
  UUID: Scalars['UUID']['output'];
  /** The authentication token associated with the bearer session. This token is used for authenticated CLI requests after the session has been validated. */
  token?: Maybe<Scalars['String']['output']>;
};

/** Input type for binding a firewall rule to a physical interface. */
export type BindFirewallRuleToPhyInterface = {
  /** UUID of the firewall rule to bind. */
  firewallRuleUUID: Scalars['UUID']['input'];
  /**
   * Metric to assign to the binding (must be greater than or equal to 0).
   * @deprecated Refer to `FirewallRule.priority` instead.
   */
  metric?: InputMaybe<Scalars['Int']['input']>;
  /**
   * UUID of the physical interface to bind the firewall rule to.
   * The physical interface must be an uplink.
   */
  phyInterfaceUUID: Scalars['UUID']['input'];
};

/** Input type for binding a firewall rule to a VLAN. */
export type BindFirewallRuleToVlan = {
  /** UUID of the firewall rule to bind. */
  firewallRuleUUID: Scalars['UUID']['input'];
  /**
   * Metric to assign to the binding (must be greater than or equal to 0).
   * @deprecated Refer to `FirewallRule.priority` instead.
   */
  metric?: InputMaybe<Scalars['Int']['input']>;
  /** UUID of the VLAN to bind the firewall rule to. */
  vlanUUID: Scalars['UUID']['input'];
};

export type BindPolicyRoutingRuleInput = {
  /** The binding information for the policy routing rule. */
  binding: PolicyRoutingRuleBindingInput;
  /** The metric (priority) assigned to the binding. If not provided, will be 1 greater than current greatest metric. */
  metric?: InputMaybe<Scalars['Int']['input']>;
};

export type BindPolicyRoutingRulesInput = {
  /** The binding information to be applied. */
  binding: PolicyRoutingRuleBindingInput;
};

export type BindVlanToPhyInterfaceInput = {
  /**
   * Indicates whether the VLAN should be tagged on the physical interface.
   * If true, the VLAN will be tagged; if false, it will be set as the native (untagged) VLAN.
   */
  isTagged: Scalars['Boolean']['input'];
  /** The UUID of the physical interface to which the VLAN will be bound. */
  phyInterfaceUUID: Scalars['UUID']['input'];
  /** The UUID of the VLAN to bind to the physical interface. */
  vlanUUID: Scalars['UUID']['input'];
};

/** BootInfo captures logs every time a device boots up. */
export type BootInfo = {
  __typename?: 'BootInfo';
  /** The last reported boot counter which the device increments every time it boots. */
  bootCount: Scalars['Int']['output'];
  /** The last reported build the device was running. */
  buildName: Scalars['String']['output'];
  /** The time at which the device first reported the information. */
  createdAt: Scalars['DateTime']['output'];
  /** If the device knows, this is the last reported reason that caused the device to reboot. */
  rebootReason: Scalars['String']['output'];
  /** The time at which the device reported the information. */
  updatedAt: Scalars['DateTime']['output'];
};

/** Associates a device (mac + network) with a map of severity counts */
export type BulkCveSeverityCountResult = {
  __typename?: 'BulkCVESeverityCountResult';
  /** Array of severity and count per severity */
  counts: Array<CveSeverityCount>;
  /** MAC Address */
  macAddress: Scalars['MacAddress']['output'];
  /** Network UUID */
  networkUUID: Scalars['UUID']['output'];
};

/** Represents a bulk NOS upgrade operation. */
export type BulkNosUpgrade = {
  __typename?: 'BulkNOSUpgrade';
  /** Unique identifier of the bulk NOS upgrade. */
  UUID: Scalars['UUID']['output'];
  /** Timestamp when the bulk NOS upgrade was created. */
  createdAt: Scalars['DateTime']['output'];
  /** List of networks included in the bulk NOS upgrade. */
  networks: Array<Network>;
  /** Identifier of the NOS version to upgrade to. */
  nosVersionID: Scalars['Int']['output'];
  /** Timestamp when the bulk NOS upgrade will be scheduled at the earliest. The scheduler will schedule an upgrade at the next maintenance window for each network after this time. */
  scheduledAtEarliest: Scalars['DateTime']['output'];
  /** Timestamp when the bulk NOS upgrade was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** Username or identifier of the user who last updated the bulk NOS upgrade. */
  updatedBy: Scalars['String']['output'];
};

export type BulkNosUpgradesFilterInput = {
  /** Maximum number of bulk NOS upgrades to return. */
  limit?: Scalars['Int']['input'];
  /** Filter to include bulk NOS upgrades created before or at this time. */
  maxCreatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter to include bulk NOS upgrades created at or after this time. */
  minCreatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Number of bulk NOS upgrades to skip before starting to collect the result set. */
  offset?: Scalars['Int']['input'];
};

/**
 * A Common Platform Enumeration (CPE) is a scheme for naming different systems / software versions.
 * Following CPE schema at https://csrc.nist.gov/schema/nvd/api/2.0/cpe_api_json_2.0.schema
 */
export type Cpe = {
  __typename?: 'CPE';
  /** Unique identifier for this CPE */
  UUID: Scalars['UUID']['output'];
  /** Timestamp when the CPE was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The unique identifier NIST uses for this CPE. */
  nameID: Scalars['UUID']['output'];
  /** The type of product, valid values are 'a' (application software), 'o' (operating system), and 'h' (hardware device). */
  part: Scalars['String']['output'];
  /** The product descriptor of the platform. */
  product: Scalars['String']['output'];
  /** Timestamp when the CPE was updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The URI is defined by NIST is a combination of uri, part, vendor, and version. */
  uri: Scalars['String']['output'];
  /** The vendor of the platform. */
  vendor: Scalars['String']['output'];
  /** The version of the platform. */
  version?: Maybe<Scalars['String']['output']>;
};

/** Filter the response to CPEs. Each provided filter will be used. At least 1 must be provided. */
export type CpEsFilterInput = {
  /** The maximum number of CPEs to return. */
  limit?: Scalars['Int']['input'];
  /** The number of CPEs to skip before starting to collect the result set. */
  offset?: Scalars['Int']['input'];
  /** Filter by prefix matching the part. */
  part?: InputMaybe<Scalars['String']['input']>;
  /** Filter by prefix matching the product. */
  product?: InputMaybe<Scalars['String']['input']>;
  /** Filter by prefix matching the vendor. */
  vendor?: InputMaybe<Scalars['String']['input']>;
  /** Filter by prefix matching the version. */
  version?: InputMaybe<Scalars['String']['input']>;
};

/** A Common Vulnerability and Exposure (CVE). */
export type Cve = {
  __typename?: 'CVE';
  /** The CVE identifier (e.g. 'CVE-2023-12345'). */
  ID: Scalars['String']['output'];
  /** Base severity label for the CVE. */
  baseSeverity?: Maybe<CveSeverity>;
  /** When our system first stored this CVE in the database. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Short description from the vulnerability feed. */
  description?: Maybe<Scalars['String']['output']>;
  /** When NVD last updated it. */
  externalLastModifiedAt?: Maybe<Scalars['DateTime']['output']>;
  /** When NVD published it. */
  externalPublishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Source of the CVE info (e.g. 'MITRE', 'NVD'). */
  source?: Maybe<Scalars['String']['output']>;
  /** Title of CVE */
  title?: Maybe<Scalars['String']['output']>;
  /** When our system last updated this CVE record. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Specifies the severity of a CVE. */
export enum CveSeverity {
  /** Critical severity */
  Critical = 'CRITICAL',
  /** High severity */
  High = 'HIGH',
  /** Low severity */
  Low = 'LOW',
  /** Medium severity */
  Medium = 'MEDIUM',
  /** Unknown severity */
  Unknown = 'UNKNOWN',
}

/** Number of CVEs for a specific severity. */
export type CveSeverityCount = {
  __typename?: 'CVESeverityCount';
  /** A label like 'HIGH', 'MEDIUM', etc. */
  baseSeverity: CveSeverity;
  /** Number of CVEs found for that severity. */
  count: Scalars['Int']['output'];
};

export type CvEsByNetworkMacAddressesInput = {
  /** Array of MAC addresses */
  macAddresses: Array<Scalars['MacAddress']['input']>;
  /** Network UUID. */
  networkUUID: Scalars['UUID']['input'];
};

/** A captive portal is a web page that is displayed to newly connected users before allowing them access to the network. */
export type CaptivePortal = {
  __typename?: 'CaptivePortal';
  /** The unique identifier of the captive portal. */
  UUID: Scalars['UUID']['output'];
  /** Whitelisted IPs/URLs that are allowed on the network by default. */
  allowedHosts: Array<Scalars['String']['output']>;
  /** Authentication session duration in seconds. The amount of time a user remains authorized after accepting the terms and conditions. Defaults to 1 day (86400 seconds) if not set. */
  authLifetimeSec?: Maybe<Scalars['Int']['output']>;
  /** The heading to display on the captive portal page. */
  callToAction?: Maybe<Scalars['String']['output']>;
  /** Display settings for the captive portal page, including background and font colors and whether to hide the 'Powered by Meter' text. */
  displaySettings?: Maybe<CaptivePortalDisplaySettings>;
  /** The URL to an external captive portal. If this is configured, it will override all configurations specific to internal captive portals. */
  externalPortalURL?: Maybe<Scalars['String']['output']>;
  /** HMAC secret used to sign and verify signatures. */
  hmacSecret?: Maybe<Scalars['String']['output']>;
  /** If true, the captive portal will use company-scoped configuration. Relevant only for external captive portals. */
  isCompanyScoped: Scalars['Boolean']['output'];
  /** If true, the captive portal is enabled. */
  isEnabled: Scalars['Boolean']['output'];
  /** A base64 encoded image of the logo. This is used to limit the number of domains we need to allow for the logo image. */
  logoImageBase64?: Maybe<Base64Image>;
  /** The S3 key for where the logo image is stored. This is used for configuration and should not be used to display the image. */
  logoImageS3Key?: Maybe<Scalars['String']['output']>;
  /** A URL to a logo image that will be displayed on the captive portal page. */
  logoImageURL?: Maybe<Scalars['String']['output']>;
  /** A human-friendly name for the captive portal. */
  name?: Maybe<Scalars['String']['output']>;
  /** The UUID of the network to which this captive portal belongs. */
  networkUUID: Scalars['UUID']['output'];
  /** The URL to redirect to after a successful captive portal login. */
  redirectURL?: Maybe<Scalars['String']['output']>;
  /** If true, captive portal auth requests will need to be approved by an admin. */
  requiresApproval: Scalars['Boolean']['output'];
  /** If true, the captive portal will collect email addresses from users. */
  requiresEmail: Scalars['Boolean']['output'];
  /** If true, the captive portal will collect names from users. */
  requiresName: Scalars['Boolean']['output'];
  /** The terms and conditions text that a user must agree to before accessing the network. */
  termsAndConditions?: Maybe<Scalars['String']['output']>;
  /** The VLANs that this captive portal is associated with. */
  vlans?: Maybe<Array<Vlan>>;
  /** UUID used to generate a unique URL for a webhook corresponding to this captive portal. */
  webhookKey: Scalars['UUID']['output'];
};

/** Contains information about a client that interacted with a captive portal. */
export type CaptivePortalClient = {
  __typename?: 'CaptivePortalClient';
  /** The IP address of the client device. */
  ipAddress: Scalars['IP']['output'];
  /** If true, the client has accepted the terms and conditions and has been authorized. */
  isAuthorized: Scalars['Boolean']['output'];
  /** The MAC address of the client device. */
  macAddress: Scalars['MacAddress']['output'];
  /** The raw user-agent string of the client device. */
  rawUserAgent: Scalars['String']['output'];
  /** The timestamp when the client accessed or interacted with the captive portal. */
  timestamp: Scalars['DateTime']['output'];
};

/** Display settings for the captive portal page. */
export type CaptivePortalDisplaySettings = {
  __typename?: 'CaptivePortalDisplaySettings';
  /** The background color of the captive portal page, specified as a hex color code. */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** The color used on the call to action, specified as a hex color code. */
  callToActionColor?: Maybe<Scalars['String']['output']>;
  /** The font color used on the captive portal page, specified as a hex color code. */
  fontColor?: Maybe<Scalars['String']['output']>;
  /** If true, the 'Powered by Meter' text will be hidden on the captive portal page. */
  hidePoweredByMeter?: Maybe<Scalars['Boolean']['output']>;
};

export type CaptivePortalDisplaySettingsInput = {
  /** The background color of the captive portal page, specified as a hex color code. */
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  /** The color used on the call to action, specified as a hex color code. */
  callToActionColor?: InputMaybe<Scalars['String']['input']>;
  /** The font color used on the captive portal page, specified as a hex color code. */
  fontColor?: InputMaybe<Scalars['String']['input']>;
  /** If true, the 'Powered by Meter' text will be hidden on the captive portal page. */
  hidePoweredByMeter?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Recorded entry of an auth request for a captive portal. */
export type CaptivePortalEntry = {
  __typename?: 'CaptivePortalEntry';
  /** The UUID of the captive portal entry. */
  UUID: Scalars['UUID']['output'];
  /** User that performed the latest action on the captive portal entry. */
  actionedBy?: Maybe<User>;
  /** Timestamp when the captive portal request was approved. */
  approvedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The captive portal the entry belongs to. */
  captivePortal: CaptivePortal;
  /** Timestamp when the captive portal entry was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Timestamp when the captive portal entry data was deleted. */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Timestamp when the captive portal request was denied. */
  deniedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The email address collected from the client. */
  email?: Maybe<Scalars['String']['output']>;
  /** The ip address of the client. */
  ip?: Maybe<Scalars['IP']['output']>;
  /** The mac address of the client. */
  mac?: Maybe<Scalars['MacAddress']['output']>;
  /** The name collected from the client. */
  name?: Maybe<Scalars['String']['output']>;
  /** The UUID of the network. */
  networkUUID: Scalars['UUID']['output'];
};

export enum CaptivePortalEntryAction {
  /** Approve the captive portal entry. */
  Approve = 'APPROVE',
  /** Delete the collected data of the captive portal entry */
  DeleteData = 'DELETE_DATA',
  /** Deny the captive portal entry. */
  Deny = 'DENY',
}

export type CaptivePortalEntryFilterInput = {
  /** The maximum number of captive portal entries to return. */
  limit?: Scalars['Int']['input'];
  /** Only include captive portal entries that were created before or at this date and time. */
  maxCreatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Only include captive portal entries that were created at or after this date and time. */
  minCreatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** The number of captive portal entries to skip before starting to collect the result set. */
  offset?: Scalars['Int']['input'];
};

export type CaptivePortalEntryInput = {
  /** Email address collected from client. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** IP address of client. */
  ip: Scalars['IPV4']['input'];
  /** Mac address of client. */
  mac: Scalars['MacAddress']['input'];
  /** Name collected from client. */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** A page of captive portal entries. */
export type CaptivePortalEntryPage = {
  __typename?: 'CaptivePortalEntryPage';
  /** The list of captive portal entries. */
  entries: Array<CaptivePortalEntry>;
  /** The total number of captive portal entries. */
  total: Scalars['Int']['output'];
};

export type CaptivePortalSettingsInput = {
  /** The IPs/URLs that are whitelisted by default. */
  allowedHosts?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Authentication session duration in seconds. The amount of time a user remains authorized after accepting the terms and conditions. Defaults to 1 day (86400 seconds) if not set. */
  authLifetimeSec?: InputMaybe<Scalars['Int']['input']>;
  /** The heading to display on the captive portal page. */
  callToAction?: InputMaybe<Scalars['String']['input']>;
  /** Display settings configuration for the captive portal page, including background and font colors and whether to hide the 'Powered by Meter' text. */
  displaySettings?: InputMaybe<CaptivePortalDisplaySettingsInput>;
  /** Setting externalPortalURL will configure this captive portal to redirect users to an external portal and override any settings specific to internal captive portals. */
  externalPortalURL?: InputMaybe<Scalars['String']['input']>;
  /** If true, the captive portal will use company-scoped configuration. Relevant only for external captive portals. */
  isCompanyScoped?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, the captive portal is enabled. */
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Use the `createPreSignedUploadUrl` mutation to generate an S3 key and presigned URL for the logo image, and specify it here. */
  logoImageS3Key?: InputMaybe<Scalars['String']['input']>;
  /** A human-friendly name for the captive portal. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The URL to redirect to after a successful captive portal login. */
  redirectURL?: InputMaybe<Scalars['String']['input']>;
  /** If true, captive portal auth requests will need to be approved by an admin. */
  requiresApproval?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, the captive portal will collect email addresses from users. */
  requiresEmail?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, the captive portal will collect names from users. */
  requiresName?: InputMaybe<Scalars['Boolean']['input']>;
  /** The terms and conditions text that a user must agree to before accessing the network. */
  termsAndConditions?: InputMaybe<Scalars['String']['input']>;
  /** Setting vlanUUIDs will assign this captive portal to the specified VLANs. */
  vlanUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

/** Enumeration of possible routes for a cellular failover event. */
export enum CellularFailoverEventRoute {
  /** Route the failover event through the cellular network. */
  Cellular = 'CELLULAR',
  /** Route the failover event through the Wide Area Network (WAN). */
  Wan = 'WAN',
}

/** Enumeration of possible states for the cellular modem as managed by the device manager. */
export enum CellularManagerModemState {
  /** The modem is attached to the network. */
  Attached = 'ATTACHED',
  /** The modem is detached from the network. */
  Detached = 'DETACHED',
  /** The state of the modem is unspecified or unknown. */
  Unspecified = 'UNSPECIFIED',
}

/** Represents the current cellular status of a device, including the modem state and the time this status was observed. */
export type CellularStatus = {
  __typename?: 'CellularStatus';
  /** The state of the device's cellular modem as managed by the device manager. */
  managerModemState: CellularManagerModemState;
  /** The timestamp when this status was last observed. */
  observedAt: Scalars['DateTime']['output'];
};

/** Represents the cellular data usage of a device, including uploaded and downloaded bytes. */
export type CellularUsage = {
  __typename?: 'CellularUsage';
  /** Number of bytes downloaded by the device over the cellular network. */
  downloadBytes?: Maybe<Scalars['Int']['output']>;
  /** Number of bytes uploaded by the device over the cellular network. */
  uploadBytes?: Maybe<Scalars['Int']['output']>;
};

/** Response type containing timeseries of channel utilization metrics. */
export type ChannelUtilizationResponseV2 = {
  __typename?: 'ChannelUtilizationResponseV2';
  /** The radio band (e.g., 2.4 GHz, 5 GHz) for which the data is provided. */
  band: RadioBand;
  /** List of timeseries values of channel utilization metrics. */
  values: Array<ApChannelUtilizationTimeseriesValue>;
  /** The unique identifier of the virtual device (AP) from which the data originates. */
  virtualDeviceUUID: Scalars['UUID']['output'];
};

export type ChannelUtilizationTimeseriesFilterInput = {
  /** Specify the time range for the timeseries data. */
  timeFilter: MetricsFilterInput;
};

/** An enumeration of channel widths. */
export enum ChannelWidth {
  /** Represents a 20 MHz channel width. */
  ChannelWidth_20MHz = 'CHANNEL_WIDTH_20MHz',
  /** Represents a 40 MHz channel width. */
  ChannelWidth_40MHz = 'CHANNEL_WIDTH_40MHz',
  /** Represents a 80 MHz channel width. */
  ChannelWidth_80MHz = 'CHANNEL_WIDTH_80MHz',
  /** Represents a 160 MHz channel width. */
  ChannelWidth_160MHz = 'CHANNEL_WIDTH_160MHz',
}

/** Input type for checking if the current user has a specific role in a given context. */
export type CheckRoleInput = {
  /**
   * The slug (unique identifier) of the company to check the role against.
   *
   * If the role is global or operator-level, this can be omitted.
   */
  companySlug?: InputMaybe<Scalars['String']['input']>;
  /**
   * The UUID of the network to check the role against.
   *
   * Provide this if checking for a network-specific role.
   */
  networkUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** The name of the role to check for. */
  roleName: RoleName;
};

/** ClientAssignmentProtocol defines the method used to assign IP addresses to clients. */
export enum ClientAssignmentProtocol {
  /** DHCP protocol assigns IP addresses dynamically to clients. */
  Dhcp = 'DHCP',
  /** Static protocol assigns fixed IP addresses to clients. */
  Static = 'STATIC',
}

/** Represents a single data point of channel utilization metrics for a client. */
export type ClientChannelUtilizationTimeseriesValue = {
  __typename?: 'ClientChannelUtilizationTimeseriesValue';
  /** The amount of utilization contributed by non-802.11 interference in the environment, e.g., Bluetooth, cameras (from 0 to 1). */
  non80211Utilization: Scalars['Float']['output'];
  /** The amount of utilization due to 802.11 interference by neighboring networks (from 0 to 1). */
  obssUtilization: Scalars['Float']['output'];
  /** The percentage of time the channel was utilized due to receptions from clients (from 0 to 1). */
  rxUtilization: Scalars['Float']['output'];
  /** The percentage of time the channel was utilized by the AP itself (from 0 to 1). */
  selfUtilization: Scalars['Float']['output'];
  /** The timestamp of the metric data point. */
  timestamp: Scalars['DateTime']['output'];
  /** The percentage of time the channel was utilized (from 0 to 1). */
  totalUtilization: Scalars['Float']['output'];
  /** The percentage of time the channel was utilized due to transmissions from the AP (from 0 to 1). */
  txUtilization: Scalars['Float']['output'];
};

/** Aggregated values (like min/max) over the given time range for all of the client metrics requested. */
export type ClientMetricsMetadata = {
  __typename?: 'ClientMetricsMetadata';
  /** Aggregated metadata for the association time in seconds */
  associationTimeSeconds?: Maybe<MetricsMetadata>;
  /** Aggregated metadata for the client count */
  clientCount?: Maybe<MetricsMetadata>;
  /** Aggregated metadata for the hardware mode of the client device. */
  hwMode?: Maybe<MetricsMetadata>;
  /** Aggregated metadata for the noise level in dBm. */
  noise?: Maybe<MetricsMetadata>;
  /** Aggregated metadata for the number of receive spatial streams. */
  numSpatialStreamsRx?: Maybe<MetricsMetadata>;
  /** Aggregated metadata for the number of transmit spatial streams. */
  numSpatialStreamsTx?: Maybe<MetricsMetadata>;
  /**
   * Deprecated. Prefer `rxBytes` instead.
   * @deprecated Prefer rxBytes instead
   */
  rx?: Maybe<MetricsMetadata>;
  /** Aggregated metadata for the total bytes received. */
  rxBytes?: Maybe<MetricsMetadata>;
  /** Aggregated metadata for the multicast bytes received. */
  rxMulticastBytes?: Maybe<MetricsMetadata>;
  /** Aggregated metadata for the receive rate in kilobits per second. */
  rxRate?: Maybe<MetricsMetadata>;
  /** Aggregated metadata for the unicast bytes received. */
  rxUnicastBytes?: Maybe<MetricsMetadata>;
  /** Aggregated metadata for the signal strength in dBm. */
  signal?: Maybe<MetricsMetadata>;
  /** Aggregated metadata for the signal-to-noise ratio in dB. */
  snr?: Maybe<MetricsMetadata>;
  /**
   * Deprecated. Prefer `txBytes` instead.
   * @deprecated Prefer txBytes instead
   */
  tx?: Maybe<MetricsMetadata>;
  /** Aggregated metadata for the total bytes transmitted. */
  txBytes?: Maybe<MetricsMetadata>;
  /** Aggregated metadata for the multicast bytes transmitted. */
  txMulticastBytes?: Maybe<MetricsMetadata>;
  /** Aggregated metadata for the transmit rate in kilobits per second. */
  txRate?: Maybe<MetricsMetadata>;
  /** Aggregated metadata for the unicast bytes transmitted. */
  txUnicastBytes?: Maybe<MetricsMetadata>;
};

/** Deprecated in favor of `ClientMetricsTimeseriesResponse`. */
export type ClientMetricsResponse = {
  __typename?: 'ClientMetricsResponse';
  /** Aggregated metadata for the client metrics over the specified time range. */
  metadata?: Maybe<ClientMetricsMetadata>;
  /** A list of client metric values. */
  values: Array<ClientMetricsValue>;
};

/** Input type for specifying filters when querying client metrics timeseries data. */
export type ClientMetricsTimeseriesFilterInput = {
  /** Specifying this field returns only metrics observed for the given radio band(s). */
  bands?: InputMaybe<Array<RadioBand>>;
  /** Specifying this field returns only metrics observed for the given radio channel(s). */
  channels?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** If true, exclude events from Observers. */
  excludeObservers?: InputMaybe<Scalars['Boolean']['input']>;
  /** Specifying this field returns only metrics observed for the given SSID(s), by UUID. */
  ssidUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Specify the time range for the timeseries data. */
  timeFilter: MetricsFilterInput;
};

/** Response type containing client metrics timeseries data over a specified time range. */
export type ClientMetricsTimeseriesResponse = {
  __typename?: 'ClientMetricsTimeseriesResponse';
  /** Aggregated metadata for the client metrics timeseries. */
  metadata?: Maybe<ClientMetricsMetadata>;
  /** A list of client metrics timeseries values. */
  values: Array<ClientMetricsTimeseriesValue>;
};

/**
 * Time-series data for client connectivity metrics.
 * If requested at a per-AP level, the results will be aggregated over all clients connected to the AP.
 */
export type ClientMetricsTimeseriesValue = {
  __typename?: 'ClientMetricsTimeseriesValue';
  /**
   * Number of seconds that the client has been associated with an AP for.
   * @deprecated This isn't really timeseries data and a timestamp is more useful; refer to WirelessClient.associatedAt instead.
   */
  associationTimeSeconds?: Maybe<Scalars['Float']['output']>;
  /** The count of distinct clients (by MAC address) that connected to the AP during the time period. */
  clientCount: Scalars['Int']['output'];
  /** The Wi-Fi capabilities of the client device. */
  hwMode?: Maybe<Scalars['String']['output']>;
  /** Noise level in dBm. */
  noise: Scalars['Float']['output'];
  /** The number of receive spatial streams. */
  numSpatialStreamsRx?: Maybe<Scalars['Int']['output']>;
  /** The number of transmit spatial streams. */
  numSpatialStreamsTx?: Maybe<Scalars['Int']['output']>;
  /** Total number of bytes received in the given time period. */
  rxBytes: Scalars['Float']['output'];
  /** Total number of multicast bytes received in the given time period; a subset of `rxBytes`. */
  rxMulticastBytes: Scalars['Float']['output'];
  /** The rate at which the client is receiving data in kilobits per second. */
  rxRate: Scalars['Float']['output'];
  /** The ratio of the number of times a packet was retried to the total number of successful packets. Null if no packets succeeded. */
  rxRetryRatio?: Maybe<Scalars['Float']['output']>;
  /**
   * Deprecated. It's unreliable to determine this client stat from the AP's perspective.
   * @deprecated It's unreliable to determine this client stat from the AP's perspective.
   */
  rxSuccessRatio?: Maybe<Scalars['Float']['output']>;
  /** Total number of unicast bytes received in the given time period; a subset of `rxBytes`. */
  rxUnicastBytes: Scalars['Float']['output'];
  /** Received signal strength in dBm. */
  signal: Scalars['Float']['output'];
  /** Signal-to-noise ratio in dB. A higher value is better. SNR = signal - noise. */
  snr: Scalars['Float']['output'];
  /** The timestamp of the metric data point. */
  timestamp: Scalars['DateTime']['output'];
  /** Total number of bytes transmitted in the given time period. */
  txBytes: Scalars['Float']['output'];
  /** Total number of multicast bytes transmitted in the given time period; a subset of `txBytes`. */
  txMulticastBytes: Scalars['Float']['output'];
  /** The rate at which the client is transmitting data in kilobits per second. */
  txRate: Scalars['Float']['output'];
  /** The ratio of the number of times the client retried a packet transmission to the number of packets successfully transmitted. Null if no packets were transmitted. */
  txRetryRatio?: Maybe<Scalars['Float']['output']>;
  /** The ratio of the number of times the client successfully received a packet to the number of packets transmitted. Null if no packets were transmitted. */
  txSuccessRatio?: Maybe<Scalars['Float']['output']>;
  /** Total number of unicast bytes transmitted in the given time period; a subset of `txBytes`. */
  txUnicastBytes: Scalars['Float']['output'];
};

/** Deprecated in favor of `ClientMetricsTimeseriesValue`. */
export type ClientMetricsValue = {
  __typename?: 'ClientMetricsValue';
  /** The MAC address of the client device. */
  macAddress: Scalars['MacAddress']['output'];
  /** Noise level in dBm. */
  noise: Scalars['Float']['output'];
  /** The receive rate from the client in kilobits per second. */
  rxRate: Scalars['Float']['output'];
  /** Received signal strength in dBm. */
  signal: Scalars['Float']['output'];
  /** Signal-to-noise ratio, in dB. Literally `signal - noise`. */
  signalToNoiseRatio: Scalars['Float']['output'];
  /** The timestamp of the metric data point. */
  timestamp: Scalars['DateTime']['output'];
  /** The transmit rate to the client in kilobits per second. */
  txRate: Scalars['Float']['output'];
};

/** A Client VPN client is an end user configuration for connecting to a Client VPN server. */
export type ClientVpnClient = {
  __typename?: 'ClientVPNClient';
  /** Unique identifier for the Client VPN client. */
  UUID: Scalars['UUID']['output'];
  /** The latest connection info a device reported about this client. */
  connectionInfo?: Maybe<ClientVpnClientConnectionInfo>;
  /** Timestamp when the client configuration was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Identifier of the user who created the client configuration. */
  createdBy: Scalars['String']['output'];
  /** IP address assigned to the client by the VPN server. */
  ipAddress: Scalars['IP']['output'];
  /** Whether this client is currently connected to the VPN server. Determined by if a handshake has taken place in the last 150 seconds or if sent or received packets increased during the last observation window. */
  isConnected: Scalars['Boolean']['output'];
  /** Whether the client is enabled. If false, users will not be able to connect using this client's key. */
  isEnabled: Scalars['Boolean']['output'];
  /** Name of the client device (e.g., 'paulmbp'). */
  name: Scalars['String']['output'];
  /** WireGuard public key of the client. */
  publicKey: Scalars['String']['output'];
  /** Email address of the client user. */
  userEmail: Scalars['String']['output'];
  /** Unique identifier of the user associated with the client. */
  userSID: Scalars['UUID']['output'];
  /** Unique identifier of the VPN server this client connects to. */
  vpnServerUUID: Scalars['UUID']['output'];
};

/** Connection information reported by the client VPN client. */
export type ClientVpnClientConnectionInfo = {
  __typename?: 'ClientVPNClientConnectionInfo';
  /** The last time a handshake was received (from the controller's perspective). */
  lastHandshakeRx?: Maybe<Scalars['DateTime']['output']>;
  /** The last time a handshake was transmitted (from the controller's perspective). */
  lastHandshakeTx?: Maybe<Scalars['DateTime']['output']>;
  /** The last time a packet was received over the tunnel (from the controller's perspective). */
  lastPacketRx?: Maybe<Scalars['DateTime']['output']>;
  /** The last time a packet was transmitted over the tunnel (from the controller's perspective). */
  lastPacketTx?: Maybe<Scalars['DateTime']['output']>;
  /** Timestamp when this connection info was observed. */
  observedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Response type containing Client VPN client timeseries data. */
export type ClientVpnClientMetricsResponse = {
  __typename?: 'ClientVPNClientMetricsResponse';
  /** Client VPN client for this series */
  clientVPNClient: ClientVpnClient;
  /** Aggregated throughput for the total bytes received in bps. */
  rxBytes: BaseMetricsResponse;
  /** Aggregated throughput for the total packets received per second. */
  rxPackets: BaseMetricsResponse;
  /** Aggregated throughput for the total bytes transmitted in bps. */
  txBytes: BaseMetricsResponse;
  /** Aggregated throughput for the total packets transmitted per second. */
  txPackets: BaseMetricsResponse;
};

/** A Client VPN server is a WireGuard server used on a security appliance for remote connection to the device. */
export type ClientVpnServer = {
  __typename?: 'ClientVPNServer';
  /** Unique identifier for the Client VPN server. */
  UUID: Scalars['UUID']['output'];
  /** IP address assigned to the WireGuard interface. */
  address?: Maybe<Scalars['IP']['output']>;
  /** Subnet mask length (CIDR notation) for the WireGuard interface address. */
  addressMask?: Maybe<Scalars['Int']['output']>;
  /** The VLANs that are accessible via connections through this client VPN server. */
  boundVLANs?: Maybe<Array<Vlan>>;
  /** The Client VPN Clients for this server. */
  clients: Array<ClientVpnClient>;
  /** Sets the default value used for the WireGuard option 'AllowedIPs' for generated client configs. */
  defaultClientAllowedIPs?: Maybe<Array<Scalars['IPPrefix']['output']>>;
  /** An additional listen address other than `address` this server serves DNS traffic on. It must be a private IP. */
  dnsListenAddress?: Maybe<Scalars['IPV4']['output']>;
  /** The endpoint clients should connect to. */
  endpoint: Scalars['String']['output'];
  /** Whether the client VPN server is enabled. */
  isEnabled: Scalars['Boolean']['output'];
  /** If failover between uplink phy interfaces (WANs) should be enabled. */
  isFailoverEnabled: Scalars['Boolean']['output'];
  /** The name of this VPN server. */
  name: Scalars['String']['output'];
  /** The WireGuard interface will listen on this interface. If null, the server is not active. */
  phyInterface?: Maybe<PhyInterface>;
  /** Port number on which the WireGuard server listens for incoming connections. */
  port: Scalars['Int']['output'];
  /** The WireGuard public key. */
  publicKey: Scalars['String']['output'];
};

/** Response type containing Client VPN server timeseries data over a specified time range. */
export type ClientVpnServerMetricsResponse = {
  __typename?: 'ClientVPNServerMetricsResponse';
  /** Client metrics for this VPN server. */
  clientMetrics: Array<ClientVpnClientMetricsResponse>;
  /** Client VPN server. */
  clientVPNServer: ClientVpnServer;
  /** Network UUID for this series. */
  networkUUID: Scalars['UUID']['output'];
};

/** A company is a core Meter entity used to represent customers. Networks belong to companies. */
export type Company = {
  __typename?: 'Company';
  /** The default role for users with this company. */
  defaultRoleForUsers: RoleName;
  /** The Salesforce Company ID corresponding to this company. */
  externalID?: Maybe<Scalars['String']['output']>;
  /** If true, the network holds template networks to apply to new networks. */
  holdsGlobalNetworkTemplates: Scalars['Boolean']['output'];
  /** A company representing a Meter customer as opposed to an internal (test) company. */
  isCustomer: Scalars['Boolean']['output'];
  /** A prospective company is used for sales purposes. */
  isProspective: Scalars['Boolean']['output'];
  /** A pre-signed URL to download a company logo override specified by `logoS3Key`. */
  logoDownloadURL?: Maybe<Scalars['String']['output']>;
  /**
   * The S3 key (path) of the image file representing the company logo, stored in AWS S3.
   * This is not required; it overrides the default logo that we fetch from a 3rd party service.
   */
  logoS3Key?: Maybe<Scalars['String']['output']>;
  /** The name of the company. */
  name: Scalars['String']['output'];
  /** The networks associated with this company. */
  networks: Array<Network>;
  /** Onboarding document form completed prior to network going live. Different from `onboarding`. */
  onboardingDocument?: Maybe<CompanyOnboardingDocument>;
  /** List of email domains permitted for authentication for this company. */
  permittedEmailDomains?: Maybe<Array<PermittedEmailDomain>>;
  /** A unique, URL-friendly identifier for the company, used in APIs and URLs. */
  slug: Scalars['String']['output'];
  /** Indicates whether Single Sign-On (SSO) is enabled for the company. */
  ssoEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** An integer representing the support group assigned to the company. */
  supportGroup?: Maybe<Scalars['Int']['output']>;
  /** The Customer Success team segments customers by their tier, which dictates their level of support / sensitivity. */
  supportTier?: Maybe<CompanySupportTier>;
  /** The unique UUID identifier for the company. */
  uuid: Scalars['UUID']['output'];
  /** The company's website domain if applicable. This is set by the Salesforce -> Backend data sync process. */
  websiteDomain?: Maybe<Scalars['String']['output']>;
};

/** A company is a core Meter entity used to represent customers. Networks belong to companies. */
export type CompanyNetworksArgs = {
  filter?: InputMaybe<CompanyNetworksFilterInput>;
};

/** Defines the various membership roles a user can have within a company. (not RBAC) */
export enum CompanyMembershipRole {
  /** An administrator with full permissions in the company. */
  Admin = 'ADMIN',
  /** A guest member with limited access to company resources. */
  Guest = 'GUEST',
  /** A standard member of the company. */
  Member = 'MEMBER',
}

/** Filters the list of networks for a single company */
export type CompanyNetworksFilterInput = {
  /** Filter networks using their UUIDs. */
  networkUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

/** Represents the onboarding process for a company. */
export type CompanyOnboarding = {
  __typename?: 'CompanyOnboarding';
  /** Unique identifier for the company onboarding entry. */
  UUID: Scalars['UUID']['output'];
  /** Unique identifier of the associated company. */
  companyUUID: Scalars['UUID']['output'];
  /** Timestamp when the company onboarding was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Job data associated with the company onboarding. */
  jobData?: Maybe<NetworkOnboardingJobData>;
  /** Identifier of the associated job data. */
  jobDataID: Scalars['String']['output'];
  /** Timestamp when the company onboarding was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** Document containing information required for company onboarding. */
export type CompanyOnboardingDocument = {
  __typename?: 'CompanyOnboardingDocument';
  /** Unique identifier for the company onboarding document. */
  UUID: Scalars['UUID']['output'];
  /** Unique identifier of the associated company. */
  companyUUID: Scalars['UUID']['output'];
  /** Timestamp when the document was created. */
  createdAt: Scalars['DateTime']['output'];
  /** List of fields that have been delegated to other users for completion. */
  delegations: Array<CompanyOnboardingFieldDelegation>;
  /** JSON object containing the onboarding document data. */
  document: Scalars['JSONObject']['output'];
  /** Timestamp when the document was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** Represents the delegation of a specific field of the company onboarding document to a user. */
export type CompanyOnboardingFieldDelegation = {
  __typename?: 'CompanyOnboardingFieldDelegation';
  /** Unique identifier of the field delegation. */
  UUID: Scalars['UUID']['output'];
  /** Unique identifier of the associated company. */
  companyUUID: Scalars['UUID']['output'];
  /** Description of the delegation. */
  description?: Maybe<Scalars['String']['output']>;
  /** Email of the user to whom the field is delegated. */
  email: Scalars['String']['output'];
  /** Name of the field being delegated. */
  fieldName: Scalars['String']['output'];
};

/** Defines a SIEM integration for a company. All networks in that company will send data to the associated AWS Kinesis stream. */
export type CompanySiemIntegration = {
  __typename?: 'CompanySIEMIntegration';
  /** Unique identifier. */
  UUID: Scalars['UUID']['output'];
  /** The ARN of the AWS Kinesis stream data will be sent to. */
  awsKinesisARN: Scalars['String']['output'];
  /** Creation time. */
  createdAt: Scalars['DateTime']['output'];
  /** https://docs.aws.amazon.com/IAM/latest/UserGuide/id_roles_common-scenarios_third-party.html */
  externalID: Scalars['String']['output'];
  /** The role that is granted permission to write to awsKinesisARN that a Meter AWS user will assume. */
  roleARN: Scalars['String']['output'];
  /** The last status of the integration. */
  status?: Maybe<CompanySiemIntegrationStatus>;
  /** The time the status was set. */
  statusUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** The last status of an integration. */
export enum CompanySiemIntegrationStatus {
  /** The integration is successfully running. */
  Success = 'SUCCESS',
  /** The status is unauthorized. The stream either does not exist or we don't have access to it. */
  Unauthorized = 'UNAUTHORIZED',
}

/** The support tier indicates the customer's level of support / sensitivity. */
export enum CompanySupportTier {
  /** The highest level of support; critical support for the most sensitive customers. */
  Critical = 'CRITICAL',
  /** The high level of support; elevated support for important customers. */
  High = 'HIGH',
  /** The lowest level of support; minimal support required. */
  Low = 'LOW',
  /** The medium level of support; standard support. */
  Medium = 'MEDIUM',
}

/** A company user provides access for a user to a company's networks. */
export type CompanyUser = {
  __typename?: 'CompanyUser';
  /** The unique identifier for the company user. */
  UUID: Scalars['UUID']['output'];
  /** The company the user is associated with. */
  company: Company;
  /** The role of the user within the company. */
  companyMembershipRole: CompanyMembershipRole;
  /** The date and time when the company user was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The date and time when the company user was deleted, if applicable. */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The roles assigned to the company user. */
  roles: Array<RoleAssignment>;
  /** The user who is associated with the company. */
  user: User;
};

/** Input for configuring SSO for a company. */
export type ConfigureSsoInput = {
  /** The slug (unique identifier) of the company. */
  companySlug: Scalars['String']['input'];
  /** The type of admin portal link to generate. */
  type: SsoAdminPortalType;
};

/** Result of configuring SSO for a company. */
export type ConfigureSsoResult = {
  __typename?: 'ConfigureSSOResult';
  /** The company for which SSO has been configured. */
  company: Company;
  /** The URL of the admin portal for SSO configuration. */
  portalURL: Scalars['String']['output'];
};

/** ConfiguredNOSVersion represents the NOS firmware version that a device is configured to run. */
export type ConfiguredNosVersion = {
  __typename?: 'ConfiguredNOSVersion';
  /** The build name specified in the NOS version (could be different from that reported by the device in bootinfo table). */
  buildName: Scalars['String']['output'];
  /** The unique identifier for the NOS version configuration. */
  id: Scalars['Int']['output'];
  /** The NOS firmware version string. */
  version: Scalars['String']['output'];
};

/** A console login record represents a user logging into a device via the console. */
export type ConsoleLogin = {
  __typename?: 'ConsoleLogin';
  /** Unique identifier for the console login record. */
  UUID: Scalars['UUID']['output'];
  /** Timestamp of when the console login was recorded. */
  createdAt: Scalars['DateTime']['output'];
  /** Device that the user logged into. */
  hardwareDevice: HardwareDevice;
  /** Username of the user that logged into the device. */
  username: Scalars['String']['output'];
};

/**
 * Deprecated.
 * Time-series data point for controller DHCP server uptime metrics."
 */
export type ControllerDhcpUptimeMetricsValue = MetricsValue & {
  __typename?: 'ControllerDHCPUptimeMetricsValue';
  /** Timestamp for the metrics data point. */
  timestamp: Scalars['DateTime']['output'];
  /** Uptime value in seconds. */
  value: Scalars['Float']['output'];
};

/**
 * Deprecated.
 * Response containing metadata and values for DHCP server uptime metrics for a controller.
 */
export type ControllerDhcpUptimeResponse = MetricsResponse & {
  __typename?: 'ControllerDHCPUptimeResponse';
  /** Metadata about the metrics. */
  metadata?: Maybe<MetricsMetadata>;
  /** Array of DHCP uptime metrics values. */
  values: Array<ControllerDhcpUptimeMetricsValue>;
};

/** Response containing an array of DNS request rate values. */
export type ControllerDnsRequestRatesResponse = {
  __typename?: 'ControllerDNSRequestRatesResponse';
  /** Array of DNS request rate values per timestamp and DNS server UUID. */
  values: Array<ControllerDnsRequestRatesValue>;
};

/** Metrics data point containing DNS request rates for a controller's DNS server. */
export type ControllerDnsRequestRatesValue = MetricsValue & {
  __typename?: 'ControllerDNSRequestRatesValue';
  /** Timestamp for the metrics data point. */
  timestamp: Scalars['DateTime']['output'];
  /** UUID of the DNS server. */
  uuid: Scalars['UUID']['output'];
  /** Requests per second. */
  value: Scalars['Float']['output'];
};

/** A controller hardware device represents a physical controller (aka Security Appliance). */
export type ControllerHardwareDevice = HardwareDevice & {
  __typename?: 'ControllerHardwareDevice';
  /** The backup public key used to add the device to the jumphost's WireGuard interface. */
  backupPublicKey?: Maybe<Scalars['String']['output']>;
  /** Backup IPv6 address on the jumphost subnet. Used to send requests to the device. */
  backupTunnelIPAddress?: Maybe<Scalars['String']['output']>;
  /** Shows the most recent boot history of a device (buildName, bootCount). */
  bootHistory: Array<BootInfo>;
  /** The timestamp when the hardware device was first created in the system. */
  createdAt: Scalars['DateTime']['output'];
  /** The model name of the hardware device. */
  deviceModel: DeviceModel;
  /** The type of the hardware device. */
  deviceType: DeviceType;
  /** If the device is no longer connected to the backend, this is the time at which it was last connected. */
  disconnectedFromBackendAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * True if the device has an active websocket connection to the backend. Note that this only works if the device has registered via the /v2/register endpoint (i.e., is a Config 2 device) - otherwise is always false.
   * @deprecated Refer to `isSpare` instead.
   */
  isActive: Scalars['Boolean']['output'];
  /** Indicates whether the hardware device is connected to the backend. */
  isConnectedToBackend: Scalars['Boolean']['output'];
  /** Indicates whether the hardware device's console port is enabled. */
  isConsoleEnabled: Scalars['Boolean']['output'];
  /** Indicates whether the hardware device is marked as a development (dev) device, moving it into the dev (staging) realm for testing purposes. */
  isDev: Scalars['Boolean']['output'];
  /** Indicates whether the hardware device is in factory mode. */
  isFactoryMode: Scalars['Boolean']['output'];
  /** Indicates whether the hardware device is an RMA (Return Merchandise Authorization) replacement device. */
  isRMA: Scalars['Boolean']['output'];
  /** Indicates whether the hardware device has been retired. */
  isRetired: Scalars['Boolean']['output'];
  /** A spare hardware device belongs to a network but not a virtual device. Used most often to keep track of spare hardware we ship to a customer but don't install immediately. */
  isSpare: Scalars['Boolean']['output'];
  /** The latest device config metadata (ie. the config without the actual JSON payload) for the device. */
  latestDeviceConfigMetadata?: Maybe<DeviceConfigMetadata>;
  /** The MAC address of the hardware device. */
  macAddress?: Maybe<Scalars['MacAddress']['output']>;
  /** The UUID of the network that the spare hardware device belongs to. Spare hardware devices that are not affiliated with a virtual device will have this field populated. */
  networkUUID?: Maybe<Scalars['UUID']['output']>;
  /** The public key used to add the device to the jumphost's WireGuard interface. */
  publicKey?: Maybe<Scalars['String']['output']>;
  /** The unique serial number of the hardware device. */
  serialNumber: Scalars['String']['output'];
  /** The network that the spare hardware device belongs to. Spare hardware devices that are not affiliated with a virtual device will have this field populated. */
  spareDeviceNetwork?: Maybe<Network>;
  /** IPv6 address on the jumphost subnet. Used to send requests to the device. */
  tunnelIPAddress?: Maybe<Scalars['String']['output']>;
  /** The timestamp when the hardware device was last updated in the system. */
  updatedAt: Scalars['DateTime']['output'];
  /**
   * The uptime metrics from the time series database for the device.
   * @deprecated Use `VirtualDevice.uptime` instead.
   */
  uptime?: Maybe<Scalars['Duration']['output']>;
  /** The virtual device associated with this hardware device, if any. */
  virtualDevice?: Maybe<VirtualDevice>;
  /** The UUID of the virtual device this hardware device is assigned to, if any. */
  virtualDeviceUUID?: Maybe<Scalars['UUID']['output']>;
};

/** A controller hardware device represents a physical controller (aka Security Appliance). */
export type ControllerHardwareDeviceBootHistoryArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
};

/** Response object containing an array of controller port metrics rate values. */
export type ControllerPortMetricsRateResponse = {
  __typename?: 'ControllerPortMetricsRateResponse';
  /** Array of metrics rate values per timestamp and port. */
  values: Array<ControllerPortMetricsRateValue>;
};

/** Metrics data point containing rate statistics (per second) for a controller port over a specific time interval. */
export type ControllerPortMetricsRateValue = {
  __typename?: 'ControllerPortMetricsRateValue';
  /** Total number of broadcast packets per second received during the time interval; a subset of totalRxPackets. */
  broadcastRxPacketsPerSecond: Scalars['Float']['output'];
  /** Total number of broadcast packets per second transmitted during the time interval; a subset of totalTxPackets. */
  broadcastTxPacketsPerSecond: Scalars['Float']['output'];
  /** The number of packets per second that were dropped during the time interval. */
  dropsPerSecond: Scalars['Float']['output'];
  /** Total number of multicast packets per second received during the time interval; a subset of totalRxPackets. */
  multicastRxPacketsPerSecond: Scalars['Float']['output'];
  /** Total number of multicast packets per second transmitted during the time interval; a subset of totalTxPackets. */
  multicastTxPacketsPerSecond: Scalars['Float']['output'];
  /** The physical port number on the controller. */
  portNumber: Scalars['Int']['output'];
  /** The number of packets per second that encountered errors being received in the time interval. */
  rxErrPerSecond: Scalars['Float']['output'];
  /** Timestamp for the metrics data point. */
  timestamp: Scalars['DateTime']['output'];
  /** Total number of bytes per second received during the time interval. */
  totalRxBytesPerSecond: Scalars['Float']['output'];
  /** Total number of bytes per second transmitted during the time interval. */
  totalTxBytesPerSecond: Scalars['Float']['output'];
  /** The number of packets per second that encountered errors during transmission in the time interval. */
  txErrPerSecond: Scalars['Float']['output'];
};

/**
 * Deprecated in favor of `ControllerPortMetricsRateResponse`.
 * Response object containing an array of controller port metrics values.
 */
export type ControllerPortMetricsResponse = {
  __typename?: 'ControllerPortMetricsResponse';
  /** Array of metrics values per timestamp and port. */
  values: Array<ControllerPortMetricsValue>;
};

/**
 * Deprecated in favor of `ControllerPortMetricsRateValue`.
 * Metrics data point containing counter statistics for a controller port over a specific time interval.
 */
export type ControllerPortMetricsValue = {
  __typename?: 'ControllerPortMetricsValue';
  /** Total number of broadcast packets received during the time interval; a subset of totalRxPackets. */
  broadcastRxPackets: Scalars['Float']['output'];
  /** Total number of broadcast packets transmitted during the time interval; a subset of totalTxPackets. */
  broadcastTxPackets: Scalars['Float']['output'];
  /** The number of packets that were dropped during the time interval. */
  drops: Scalars['Float']['output'];
  /** Total number of multicast packets received during the time interval; a subset of totalRxPackets. */
  multicastRxPackets: Scalars['Float']['output'];
  /** Total number of multicast packets transmitted during the time interval; a subset of totalTxPackets. */
  multicastTxPackets: Scalars['Float']['output'];
  /** The physical port number on the controller. */
  portNumber: Scalars['Int']['output'];
  /** The number of packets that encountered errors being received in the time interval. */
  rxErr: Scalars['Float']['output'];
  /** Timestamp for the metrics data point. */
  timestamp: Scalars['DateTime']['output'];
  /** Total number of bytes received during the time interval. */
  totalRxBytes: Scalars['Float']['output'];
  /** Total number of bytes transmitted during the time interval. */
  totalTxBytes: Scalars['Float']['output'];
  /** The number of packets that encountered errors during transmission in the time interval. */
  txErr: Scalars['Float']['output'];
};

/** Summed stats (unless otherwise specified) per controller port over a lookback period. */
export type ControllerPortStat = {
  __typename?: 'ControllerPortStat';
  /** Total number of broadcast bytes received in the given time period; a subset of totalRxBytes. */
  broadcastRxBytes: Scalars['Int']['output'];
  /** Total number of broadcast packets received in the given time period; a subset of totalRxPackets. */
  broadcastRxPackets: Scalars['Int']['output'];
  /** Total number of broadcast bytes transmitted in the given time period; a subset of totalTxBytes. */
  broadcastTxBytes: Scalars['Int']['output'];
  /** Total number of broadcast packets transmitted in the given time period; a subset of totalTxPackets. */
  broadcastTxPackets: Scalars['Int']['output'];
  /** The number of packets that were dropped in the time interval. */
  drops: Scalars['Int']['output'];
  /** Most recent hardware up state. Indicates that a physical connection is established, typically meaning a cable is properly connected and active. */
  hwUp: Scalars['Boolean']['output'];
  /** The number of IPv4 packets transmitted or received. */
  ipv4: Scalars['Int']['output'];
  /** The number of IPv6 packets transmitted or received. */
  ipv6: Scalars['Int']['output'];
  /** Total number of multicast bytes received in the given time period; a subset of totalRxBytes. */
  multicastRxBytes: Scalars['Int']['output'];
  /** Total number of multicast packets received in the given time period; a subset of totalRxPackets. */
  multicastRxPackets: Scalars['Int']['output'];
  /** Total number of multicast bytes transmitted in the given time period; a subset of totalTxBytes. */
  multicastTxBytes: Scalars['Int']['output'];
  /** Total number of multicast packets transmitted in the given time period; a subset of totalTxPackets. */
  multicastTxPackets: Scalars['Int']['output'];
  /** The physical port number on the controller. */
  portNumber: Scalars['Int']['output'];
  /** The number of packets punted to the CPU for processing (currently not reported by firmware). */
  punts: Scalars['Int']['output'];
  /** The number of packets that encountered errors being received. */
  rxErr: Scalars['Int']['output'];
  /** Total number of bytes received in the given time period. */
  totalRxBytes: Scalars['Int']['output'];
  /** Total number of packets received in the given time period. */
  totalRxPackets: Scalars['Int']['output'];
  /** Total number of bytes transmitted in the given time period. */
  totalTxBytes: Scalars['Int']['output'];
  /** Total number of packets transmitted in the given time period. */
  totalTxPackets: Scalars['Int']['output'];
  /** The number of packets that encountered errors during transmission. */
  txErr: Scalars['Int']['output'];
  /** Total number of unicast bytes received in the given time period; a subset of totalRxBytes. */
  unicastRxBytes: Scalars['Int']['output'];
  /** Total number of unicast packets received in the given time period; a subset of totalRxPackets. */
  unicastRxPackets: Scalars['Int']['output'];
  /** Total number of unicast bytes transmitted in the given time period; a subset of totalTxBytes. */
  unicastTxBytes: Scalars['Int']['output'];
  /** Total number of unicast packets transmitted in the given time period; a subset of totalTxPackets. */
  unicastTxPackets: Scalars['Int']['output'];
};

/** A controller virtual device is a logical representation of a physical controller. */
export type ControllerVirtualDevice = VirtualDevice & {
  __typename?: 'ControllerVirtualDevice';
  /** The unique identifier (UUID) of the virtual device. */
  UUID: Scalars['UUID']['output'];
  /** The timestamp when the virtual device was first created in the system. */
  createdAt: Scalars['DateTime']['output'];
  /** An optional description for the virtual device. */
  description?: Maybe<Scalars['String']['output']>;
  /** The model name of the virtual device. */
  deviceModel: DeviceModel;
  /** The type of the virtual device. */
  deviceType: VirtualDeviceType;
  /** The hardware device associated with this virtual device, if any. */
  hardwareDevice?: Maybe<HardwareDevice>;
  /** The high availability (HA) configuration information associated with this controller, if configured in HA mode. */
  highAvailability?: Maybe<HighAvailabilityControllerVirtualDeviceInfo>;
  /** Indicates whether the virtual device's console port is enabled. */
  isConsoleEnabled: Scalars['Boolean']['output'];
  /** Indicates whether debug logging is enabled on the virtual device. */
  isDebugLogEnabled: Scalars['Boolean']['output'];
  /** A human-friendly name for the device. */
  label: Scalars['String']['output'];
  /** The management plane connection type for the controller. */
  managementConnection: ManagementConnection;
  /** The network that the virtual device belongs to. */
  network: Network;
  /** The unique identifier (UUID) of the network the virtual device belongs to. */
  networkUUID: Scalars['UUID']['output'];
  /** The group that the device belongs to for firmware upgrade grouping purposes. */
  nosUpgradeGroup: NosUpgradeGroup;
  /** The current NOS firmware version that the virtual device is configured to run. */
  nosVersion?: Maybe<ConfiguredNosVersion>;
  /** The identifier of the NOS firmware version that the virtual device is configured to run. */
  nosVersionID: Scalars['Int']['output'];
  /**
   * The outlet interface on a Meter Power Distribution Device that this device is connected to, if applicable.
   * This connection is a manually curated label and may not actually be the outlet that the device is connected to.
   */
  outletInterfaceConnectedTo?: Maybe<OutletInterface>;
  /** The NOS firmware version that the virtual device is scheduled to upgrade to. */
  pendingNosVersion?: Maybe<PendingNosVersion>;
  /** The physical interfaces associated with the controller. */
  phyInterfaces: Array<PhyInterface>;
  /** The security appliance profile associated with the controller. */
  securityApplianceProfile: SecurityApplianceProfile;
  /** The unique identifier of the security appliance profile associated with the controller. */
  securityApplianceProfileUUID: Scalars['UUID']['output'];
  /** Data about this virtual device's position in its network's topology. */
  topologyData?: Maybe<VirtualDeviceTopologyData>;
  /** The timestamp when the virtual device was last updated in the system. */
  updatedAt: Scalars['DateTime']['output'];
  /** The uptime from our time series database for the device. */
  uptime?: Maybe<Scalars['Duration']['output']>;
};

/** Represents geographical coordinates with latitude and longitude. */
export type Coordinates = {
  __typename?: 'Coordinates';
  /** The latitude component of the coordinates. */
  latitude: Scalars['Float']['output'];
  /** The longitude component of the coordinates. */
  longitude: Scalars['Float']['output'];
};

/** Input type for creating a new address. */
export type CreateAddressInput = {
  /** First line of the address. Typically includes street number and name. */
  address1: Scalars['String']['input'];
  /** Second line of the address. Typically includes apartment, suite, unit, building, floor, etc. */
  address2?: InputMaybe<Scalars['String']['input']>;
  /** City where the address is located. */
  city: Scalars['String']['input'];
  /** ISO 3166-1 alpha-2 country code for the address. */
  country: Scalars['String']['input'];
  /** Postal or ZIP code for the address. */
  postalCode: Scalars['String']['input'];
  /** State or province where the address is located. */
  state: Scalars['String']['input'];
};

export type CreateAlertReceiverWithTargetsInput = {
  /** Label for the new alert receiver. */
  label: Scalars['String']['input'];
  /** List of alert targets to associate with the new alert receiver. */
  targets: Array<AlertTargetInput>;
};

/** Input type for creating a new slack alert target. */
export type CreateAlertTargetSlackInput = {
  /** The Slack channel ID to which alerts will be sent. */
  channelID: Scalars['String']['input'];
  /** An optional label for the slack alert target. */
  label?: InputMaybe<Scalars['String']['input']>;
};

/** Input type for creating a new webhook alert target. */
export type CreateAlertTargetWebhookInput = {
  /** The type of authentication to use for the webhook. */
  authType?: InputMaybe<WebhookAuthType>;
  /** The value of the authentication header to use for the webhook. */
  authValue?: InputMaybe<Scalars['String']['input']>;
  /** An optional label for the webhook alert target. */
  label?: InputMaybe<Scalars['String']['input']>;
  /** An optional secret used to sign webhook requests for verification. */
  signingSecret?: InputMaybe<Scalars['String']['input']>;
  /** The URL endpoint of the webhook where alerts will be sent. */
  url: Scalars['String']['input'];
};

export type CreateApplicationDnsFirewallRuleInput = {
  /** The action to take when the rule is matched. */
  action: FirewallRuleAction;
  /** The ID of the Netstar application to associate with the rule. */
  applicationID?: InputMaybe<Scalars['Int']['input']>;
  /** List of UUIDs of DHCP rules to which the application dns firewall rule is bound. */
  boundDHCPRuleUUIDs: Array<Scalars['UUID']['input']>;
  /** The ID of the Netstar category to associate with the rule. */
  categoryID?: InputMaybe<Scalars['Int']['input']>;
  /** The domain or FQDN that is matched by the rule, allowing for wildcards denoted by '*'. */
  domain?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the Netstar group to associate with the rule. */
  groupID?: InputMaybe<Scalars['Int']['input']>;
  /** Indicates whether the rule is enabled; defaults to true. */
  isEnabled?: Scalars['Boolean']['input'];
  /** The name of the DNS firewall rule. */
  name: Scalars['String']['input'];
  /** The priority of the rule; if not provided, will default to 1 greater than the highest existing priority. */
  priority?: InputMaybe<Scalars['Int']['input']>;
};

/** Input type for configuring the hub's uplink when creating an AutoVPN Group. */
export type CreateAutoVpnGroupHubUplinkInput = {
  /** IP address assigned to the hub's uplink. */
  address: Scalars['IP']['input'];
  /** Prefix length of the uplink's IP address. */
  addressPrefixLength: Scalars['Int']['input'];
  /** Indicates if failover is enabled for the hub's uplink. */
  isFailoverEnabled?: Scalars['Boolean']['input'];
  /** Unique identifier of the physical interface used by the hub's uplink. */
  phyInterfaceUUID: Scalars['UUID']['input'];
};

/** Input type for creating a new AutoVPN Group. */
export type CreateAutoVpnGroupInput = {
  /** Unique identifier of the hub network. */
  hubNetworkUUID: Scalars['UUID']['input'];
  /** Indicates if the AutoVPN Group is enabled. Defaults to true. */
  isEnabled?: Scalars['Boolean']['input'];
  /** Indicates if hub failover is enabled. Defaults to true. */
  isHubFailoverEnabled?: Scalars['Boolean']['input'];
  /** Optionally adds specified members to the group. */
  members?: InputMaybe<Array<AddNetworkToAutoVpnGroupInput>>;
  /** Name of the AutoVPN Group. */
  name: Scalars['String']['input'];
  /** Configuration of the hub's uplink. */
  uplink: CreateAutoVpnGroupHubUplinkInput;
};

/** Input type for creating a new AutoVPN route in an AutoVPN Group. */
export type CreateAutoVpnRouteInput = {
  /** Destination gateway IP address for the route. */
  dstGateway: Scalars['IPV4']['input'];
  /** Prefix length for the destination IP of the route. Must be between 1 and 32. */
  dstPrefixLength: Scalars['Int']['input'];
  /** Indicates if the route is enabled. Defaults to true. */
  isEnabled?: Scalars['Boolean']['input'];
  /** Name of the route. */
  name: Scalars['String']['input'];
};

/** Input type for automatically creating Wifi Observer Settings for a network. */
export type CreateAutoWifiObserverSettingInput = {
  /** List of commands to run during the observer test (same for all). */
  commands?: InputMaybe<Array<WosObserverCommandInput>>;
  /**
   * Observer tests are added only if this is set to true; otherwise, we simply return the list
   * that we would add.
   */
  commit: Scalars['Boolean']['input'];
  /** Duration of the test in milliseconds (same for all). */
  durationMsec: Scalars['Int']['input'];
  /** Filters (SSIDs, bands) to create auto WiFi Observer settings. */
  filters: AutoWifiObserverFiltersInput;
  /** The UUID of the network. */
  networkUUID: Scalars['UUID']['input'];
  /** Number of spatial streams to be used in the test (same for all). */
  numSpatialStreams?: InputMaybe<Scalars['Int']['input']>;
  /** Threshold to consider an AP a valid neighbor */
  snrThreshold: Scalars['Int']['input'];
};

export type CreateBulkNosUpgradeInput = {
  /** Force the NOS upgrades to be scheduled immediately. Overrides the scheduledAtEarliest value. */
  force?: Scalars['Boolean']['input'];
  /** List of UUIDs of the networks to include in the bulk NOS upgrade. */
  networkUUIDs: Array<Scalars['UUID']['input']>;
  /** Identifier of the NOS version to upgrade to. */
  nosVersionID: Scalars['Int']['input'];
  /** Timestamp when the bulk NOS upgrade will be scheduled at the earliest. The scheduler will schedule an upgrade at the next maintenance window for each network after this time. If not provided, this value will default to now. */
  scheduledAtEarliest?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Input parameters for creating a Client VPN client. */
export type CreateClientVpnClientInput = {
  /** End user's company email associated with the VPN server's controller, e.g., 'angie@meter.com'. */
  email: Scalars['String']['input'];
  /** Whether the client is enabled. If false, users will not be able to connect using this client's key. */
  isEnabled?: Scalars['Boolean']['input'];
  /** End user's device name, e.g., 'paulmbp'. */
  name: Scalars['String']['input'];
  /** A Curve25519 public key generated by the end user using WireGuard. */
  publicKey: Scalars['String']['input'];
};

/** Input parameters for creating a Client VPN server. */
export type CreateClientVpnServerInput = {
  /** IPv4 address to assign to the WireGuard interface. */
  address: Scalars['IPV4']['input'];
  /** Subnet mask length (CIDR notation) for the WireGuard interface address. */
  addressMask: Scalars['Int']['input'];
  /** The UUIDs for the VLANs that are accessible via connections through this client VPN server. */
  boundVLANUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Default list of IP prefixes that clients are allowed to access. */
  defaultClientAllowedIPs?: Array<Scalars['IPPrefix']['input']>;
  /** An additional listen address other than `address` this server serves DNS traffic on. It must be a private IP. */
  dnsListenAddress?: InputMaybe<Scalars['IPV4']['input']>;
  /** Whether the client VPN server is enabled. */
  isEnabled?: Scalars['Boolean']['input'];
  /** Set to true to enable failover between uplink physical interfaces (WANs). */
  isFailoverEnabled?: Scalars['Boolean']['input'];
  /** Port number on which the WireGuard server listens for incoming connections. */
  listenPort?: InputMaybe<Scalars['Int']['input']>;
  /** The name of this client VPN server. */
  name?: Scalars['String']['input'];
  /** UUID of the uplink physical interface that the WireGuard server will listen on. */
  phyInterfaceUUID?: InputMaybe<Scalars['UUID']['input']>;
};

export type CreateCompanyInput = {
  /** A prospective company is used for sales purposes. */
  isProspective?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * The S3 key (path) of the image file representing the company logo, stored in AWS S3.
   * This is not required; it overrides the default logo that we fetch from a 3rd party service.
   */
  logoS3Key?: InputMaybe<Scalars['String']['input']>;
  /** The name of the company. */
  name: Scalars['String']['input'];
  /** A unique, URL-friendly identifier for the company. */
  slug: Scalars['String']['input'];
};

/** Input parameters for creating company SIEM integration. */
export type CreateCompanySiemIntegrationInput = {
  /** The ARN of the AWS Kinesis stream data will be sent to. */
  awsKinesisARN: Scalars['String']['input'];
  /** https://docs.aws.amazon.com/IAM/latest/UserGuide/id_roles_common-scenarios_third-party.html */
  externalID: Scalars['String']['input'];
  /** The role that is granted permission to write to awsKinesisARN that a Meter AWS user will assume. */
  roleARN: Scalars['String']['input'];
};

/** Create a new user for the specified company, with the provided attributes. */
export type CreateCompanyUserInput = {
  /**
   * The membership role for the new user within the company. This refers to the old style of granting permissions. This will be deprecated in the future,
   * but is currently required as only those with an admin `CompanyMembershipRole` can access the dashboard.
   */
  companyMembershipRole: CompanyMembershipRole;
  /** The email address of the new user. */
  email: Scalars['String']['input'];
  /** The first name of the new user. */
  firstName: Scalars['String']['input'];
  /** The last name of the new user. */
  lastName: Scalars['String']['input'];
  /** If specified, immediately creates the user's roles. */
  roleAssignments?: InputMaybe<Array<UserRoleInput>>;
};

/** Input for creating a new DHCP option. */
export type CreateDhcpOptionInput = {
  /**
   * The DHCP option code (also called tag). Refer to the IANA DHCP options list:
   * https://www.iana.org/assignments/bootp-dhcp-parameters/bootp-dhcp-parameters.xhtml
   */
  code: Scalars['Int']['input'];
  /** The data value for the DHCP option. */
  data: Scalars['String']['input'];
  /** If this is a custom (nonstandard) DHCP option, the type of the data. */
  dataType?: InputMaybe<DhcpOptionDataType>;
  /** An optional description for the DHCP option. */
  description?: InputMaybe<Scalars['String']['input']>;
};

/** Input for creating a DHCP proxy. */
export type CreateDhcpProxyInput = {
  /** The IP address of this DHCP proxy. */
  ipAddress: Scalars['IP']['input'];
  /** The UUID of the uplink physical interface (WAN) that should be used for egress with this proxy. */
  phyInterfaceUUID?: InputMaybe<Scalars['UUID']['input']>;
};

/** Input for creating a new DHCP reserved range. */
export type CreateDhcpReservedRangeInput = {
  /** A human-readable description. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The last reserved IP address in the range. */
  endIPAddress: Scalars['IP']['input'];
  /** The first reserved IP address in the range. */
  startIPAddress: Scalars['IP']['input'];
};

/** Input for creating DHCP rule filter. */
export type CreateDhcpRuleFilterInput = {
  /** The MAC address this rule allows. */
  allowedMACAddress?: InputMaybe<Scalars['MacAddress']['input']>;
  /** The MAC address OUI this rule allows. This is in the format XX:XX:XX */
  allowedOUI?: InputMaybe<Scalars['String']['input']>;
};

/** Input for creating a new DHCP rule. */
export type CreateDhcpRuleInput = {
  /** A list of DHCP proxies to create alongside the rule. */
  dhcpProxies?: InputMaybe<Array<CreateDhcpProxyInput>>;
  /** Enables or disables DNS caching on the DHCP server. */
  dnsCacheIsEnabled?: Scalars['Boolean']['input'];
  /** Specifies the maximum Time-To-Live (TTL) in seconds for cached DNS entries. */
  dnsCacheMaxTTL?: Scalars['Int']['input'];
  /** Specifies the maximum number of DNS records to cache. */
  dnsCacheSize?: Scalars['Int']['input'];
  /** A list of DNS search domains provided to DHCP clients. */
  dnsSearchDomains?: Array<Scalars['String']['input']>;
  /** List of upstream DNS servers to use.. */
  dnsUpstreamServers?: Array<Scalars['IP']['input']>;
  /** Determines if the gateway acts as a DNS proxy for clients. */
  dnsUseGatewayProxy?: Scalars['Boolean']['input'];
  /** The last available IP address in the DHCP range, ascending and inclusive. Omitted if DHCP is not being served. */
  endIPAddress?: InputMaybe<Scalars['IP']['input']>;
  /** The gateway IP address provided to DHCP clients. */
  gatewayIPAddress: Scalars['IP']['input'];
  /** The prefix length of the gateway IP address. */
  gatewayPrefixLength: Scalars['Int']['input'];
  /** If set, the gateway IP address is allowed to be different from its VLAN's address. */
  hasGatewayOverride?: Scalars['Boolean']['input'];
  /** Indicates whether this DHCP rule is for IPv6 (`true`) or IPv4 (`false`). */
  isIPv6: Scalars['Boolean']['input'];
  /** The duration (in seconds) of the DHCP lease assigned to clients. Omitted if DHCP is not being served. */
  leaseDurationSeconds?: InputMaybe<Scalars['Int']['input']>;
  /** The first available IP address in the DHCP range, ascending and inclusive. Omitted if DHCP is not being served. */
  startIPAddress?: InputMaybe<Scalars['IP']['input']>;
};

/** Input for creating a new DHCP static mapping. */
export type CreateDhcpStaticMappingInput = {
  /** The hostname to assign to the client device. */
  hostname?: InputMaybe<Scalars['String']['input']>;
  /** The fixed IP address to assign to the client device. */
  ipAddress: Scalars['IP']['input'];
  /** The MAC address of the client device. */
  macAddress: Scalars['MacAddress']['input'];
  /** A name or label for this static mapping. */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Input for creating a new DNS host mapping. */
export type CreateDnsHostMappingInput = {
  /** The domain to which `overrideDomain` should resolve. Acts like a 'CNAME' record if specified. */
  destinationDomain?: InputMaybe<Scalars['String']['input']>;
  /** The IP address to which `overrideDomain` should resolve. Acts like an 'A' record if specified. */
  destinationIPAddress?: InputMaybe<Scalars['IP']['input']>;
  /** Indicates whether this DNS host mapping is enabled. Defaults to `true`. */
  isEnabled?: Scalars['Boolean']['input'];
  /** The domain name to override. This can be a fully qualified domain name (FQDN) or a domain name. */
  overrideDomain: Scalars['String']['input'];
};

/** Used to mark a device as 'dev', moving it into the dev (staging) realm for testing purposes. */
export type CreateDevHardwareDeviceInput = {
  /** The model of the hardware device. */
  deviceModel: DeviceModel;
  /** The type of the hardware device. */
  deviceType: DeviceType;
  /** The MAC address of the hardware device. */
  macAddress?: InputMaybe<Scalars['MacAddress']['input']>;
  /** The serial number of the hardware device to mark as 'dev'. */
  serialNumber: Scalars['String']['input'];
};

export type CreateDeviceHeartbeatInput = {
  /** The serial number of the device for which to create a heartbeat configuration. */
  serialNumber: Scalars['String']['input'];
};

/** Input type for creating a new 802.1X encryption configuration. */
export type CreateEncryption8021XInput = {
  /** The IP address of the accounting server. If provided, accountingServerPort and accountingServerSecret must also be provided. */
  accountingServerIPAddress?: InputMaybe<Scalars['IP']['input']>;
  /** The port of the accounting server. Required if accountingServerIPAddress is provided. */
  accountingServerPort?: InputMaybe<Scalars['Int']['input']>;
  /** The shared secret used to authenticate with the accounting server. Required if accountingServerIPAddress is provided. */
  accountingServerSecret?: InputMaybe<Scalars['String']['input']>;
  /** The IP address of the authentication server. */
  authServerIPAddress: Scalars['IP']['input'];
  /** The port of the authentication server. */
  authServerPort: Scalars['Int']['input'];
  /** The shared secret used to authenticate with the authentication server. */
  authServerSecret: Scalars['String']['input'];
  /** A user-friendly label for the encryption configuration. */
  label: Scalars['String']['input'];
  /** The UUID of the network where the encryption configuration will be created. */
  networkUUID: Scalars['UUID']['input'];
};

/** The fields needed to retrieve an ids event from stats. */
export type CreateFirewallRuleIdsEventInput = {
  /** When the event was observed at. */
  observedAt: Scalars['DateTime']['input'];
  /** The UUID of the virtual device that created the event. */
  virtualDeviceUUID: Scalars['UUID']['input'];
};

/** Input type for creating a new firewall rule. */
export type CreateFirewallRuleInput = {
  /** The action to take when the firewall rule matches (e.g., DENY or PERMIT). */
  action: FirewallRuleAction;
  /**
   * List of UUIDs of physical interfaces to which the firewall rule is bound.
   * The physical interfaces must be uplinks.
   */
  boundPhyInterfaceUUIDs: Array<Scalars['UUID']['input']>;
  /** List of UUIDs of VLANs to which the firewall rule is bound. */
  boundVLANUUIDs: Array<Scalars['UUID']['input']>;
  /** A description of the firewall rule. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** UUID of the destination client VPN server to match traffic to. */
  dstClientVPNServerUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** UUID of the destination IPSec tunnel to match traffic to. */
  dstIPSecTunnelUUID?: InputMaybe<Scalars['UUID']['input']>;
  /**
   * Deprecated. Use `dstPortRanges` instead. Single destination port range to match.
   * @deprecated Use `dstPortRanges` instead.
   */
  dstPortRange?: InputMaybe<PortRangeInput>;
  /** List of destination port ranges to match traffic to. */
  dstPortRanges?: InputMaybe<Array<PortRangeInput>>;
  /** Destination IP prefix to match traffic to. */
  dstPrefix?: InputMaybe<Scalars['IPPrefix']['input']>;
  /** UUID of the destination VLAN to match traffic to. */
  dstVLANUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** Creates a firewall rules based on an IDS event. If provided, ignores all fields other than name, isEnabled, and isInternal. */
  idsEvent?: InputMaybe<CreateFirewallRuleIdsEventInput>;
  /**
   * Indicates if the firewall rule should be applied bidirectionally.
   * @deprecated Bidirectional rules are now implicit, enabled if the rule is between two VLANs.
   */
  isBidirectional?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates if the firewall rule is currently enabled. */
  isEnabled: Scalars['Boolean']['input'];
  /** Indicates if the firewall rule is internal to Meter. */
  isMeterInternal: Scalars['Boolean']['input'];
  /** The name of the firewall rule. */
  name: Scalars['String']['input'];
  /**
   * Priority of the rule within the network, lower priority rules are applied first.
   * If there is an existing rule with the provided value, it and all subsequent occupied values will be incremented.
   * If omitted, next lowest priority in network will be used.
   */
  priority?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Deprecated. Use `protocols` instead. Single IP protocol to match.
   * @deprecated Use `protocols` instead.
   */
  protocol?: InputMaybe<IpProtocol>;
  /** List of IP protocols to match. */
  protocols?: InputMaybe<Array<IpProtocol>>;
  /** UUID of the source client VPN server to match traffic from. */
  srcClientVPNServerUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** UUID of the source IPSec tunnel to match traffic from. */
  srcIPSecTunnelUUID?: InputMaybe<Scalars['UUID']['input']>;
  /**
   * Deprecated. Use `srcPortRanges` instead. Single source port range to match.
   * @deprecated Use `srcPortRanges` instead.
   */
  srcPortRange?: InputMaybe<PortRangeInput>;
  /** List of source port ranges to match traffic from. */
  srcPortRanges?: InputMaybe<Array<PortRangeInput>>;
  /** Source IP prefix to match traffic from. */
  srcPrefix?: InputMaybe<Scalars['IPPrefix']['input']>;
  /**
   * UUID of the source VLAN to match traffic from.
   * @deprecated Source VLAN is now implied from `boundVLANUUIDs`.
   */
  srcVLANUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** List of tags associated with the firewall rule. */
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Input type for creating a new default notification setting. */
export type CreateFleetwideNotificationSettingInput = {
  /** The UUID of the alert receiver who will receive the notifications. */
  alertReceiverUUID: Scalars['UUID']['input'];
  /** A list of arguments providing specific parameters or context required by the notification definition. */
  arguments: Array<NotificationSettingArgumentInput>;
  /** Optional filter by company */
  companyUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** If provided, enables the notification setting for the specified company support tiers, otherwise it is enabled for all company support tiers. */
  enabledCustomerSupportTiers?: InputMaybe<Array<CompanySupportTier>>;
  /** Whether the notification setting is enabled for only inactive networks. */
  enabledForInactiveNetworks: Scalars['Boolean']['input'];
  /** Whether the notification setting is enabled for internal networks. */
  enabledForInternalNetworks: Scalars['Boolean']['input'];
  /** If provided, enables the notification setting for the specified NOS upgrade channels, otherwise it is enabled for all NOS upgrade channels. */
  enabledNOSUpgradeChannels?: InputMaybe<Array<NetworkNosUpgradeChannel>>;
  /** The label of the fleetwide notification setting. */
  label: Scalars['String']['input'];
  /** Name of the alert definition to use for this fleetwide notification setting. */
  notificationDefinitionName: Scalars['String']['input'];
};

/** Input type for creating fleetwide notification snooze. */
export type CreateFleetwideNotificationSnoozeInput = {
  /** The reason for the snooze. */
  snoozeReason?: InputMaybe<Scalars['String']['input']>;
  /** The time window for the snooze. */
  window: SnoozeNotificationSettingWindowInput;
};

export type CreateFloorPlanInput = {
  /** A description of the new floor plan. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The S3 key (path) of the image file representing the floor plan to be uploaded. */
  imageS3Key: Scalars['String']['input'];
  /** A human-readable name or label for the new floor plan. */
  label: Scalars['String']['input'];
};

/** Input type for creating a high availability security appliance pair. */
export type CreateHighAvailabilityPairInput = {
  /** Interval at which the security appliances will advertise to one another, in milliseconds. */
  advertisementIntervalMs?: Scalars['Int']['input'];
  /**
   * VLAN ID to use for the advertisement VLAN.
   * One of `advertisementVLANUUID`, `advertisementVLANInput`, or `advertisementVLANID` must be provided.
   * @deprecated Please use `advertisementVLANUUID` or `createAdvertisementVLANInput` instead.
   */
  advertisementVLANID?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Existing VLAN UUID to use for the advertisement VLAN.
   * One of `advertisementVLANUUID`, `advertisementVLANInput`, or `advertisementVLANID` must be provided.
   */
  advertisementVLANUUID?: InputMaybe<Scalars['UUID']['input']>;
  /**
   * Input parameters to use for the new advertisement VLAN.
   * One of `advertisementVLANUUID`, `advertisementVLANInput`, or `advertisementVLANID` must be provided.
   */
  createAdvertisementVLANInput?: InputMaybe<CreateVlanInput>;
  /** Enable or disable preemption for the HA security appliances in VRRP. */
  preempt: Scalars['Boolean']['input'];
};

/** Input type for creating a new host monitoring target. */
export type CreateHostMonitoringTargetInput = {
  /** A descriptive text about the host monitoring target. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Indicates whether the host monitoring target is enabled. */
  isEnabled?: Scalars['Boolean']['input'];
  /** Whether this target is used to compute whether a WAN should failover. Only available if `type` is `PING`. */
  isUsedForWANFailover?: Scalars['Boolean']['input'];
  /**
   * The target host to monitor.
   *
   * Currently, only IPv4 addresses are permitted.
   */
  targetHost: Scalars['IPV4']['input'];
  /** The type of monitoring to perform on the target host. */
  type: HostMonitoringType;
};

export type CreateIdsipsConfigInput = {
  /** VLANs to enable IDS/IPS for. */
  enabledVLANUUIDs: Array<Scalars['UUID']['input']>;
  /** Validity of ips generated rules. */
  ipsRuleDuration?: InputMaybe<Scalars['Duration']['input']>;
  /** If east-west protection is enabled. */
  isEastWestProtectionEnabled?: Scalars['Boolean']['input'];
  /** The IPS minimum severity to act on. */
  minIPSSeverity?: InputMaybe<Scalars['Int']['input']>;
  /** The IDS minimum severity to act on. */
  minSeverity?: Scalars['Int']['input'];
  /** The mode IDS/IPS should act in. */
  mode: IdsipsMode;
  /** List of subnets that should never be blocked. */
  safelist?: InputMaybe<Array<Scalars['IPPrefix']['input']>>;
};

/** A custom intrusion rule definition for IDS/IPS. These currently apply tls.sni rules. */
export type CreateIdsipsCustomRuleInput = {
  /** The action this rule applies. */
  action: FirewallRuleAction;
  /** The ID of the Netstar application to associate with the rule. */
  applicationID?: InputMaybe<Scalars['Int']['input']>;
  /** List of UUIDs of VLAN rules to which rule is bound. */
  boundVLANUUIDs: Array<Scalars['UUID']['input']>;
  /** The FQDN this rule applies to. */
  domain?: InputMaybe<Scalars['String']['input']>;
  /** If this rule is enabled. */
  isEnabled: Scalars['Boolean']['input'];
  /** A name to identify this rule. */
  name: Scalars['String']['input'];
};

/** Input for creating IP forwarding rule. */
export type CreateIpForwardingRuleInput = {
  /** If rule is enabled. */
  isEnabled?: Scalars['Boolean']['input'];
  /** Name of this rule. */
  name: Scalars['String']['input'];
  /** The uplink interface associated with the rule. */
  uplinkPhyInterfaceUUID: Scalars['UUID']['input'];
  /** The UUID of VLAN associated with this rule. */
  vlanUUID: Scalars['UUID']['input'];
};

/** Input type for creating a new IPSec tunnel. */
export type CreateIpSecTunnelInput = {
  /** The authentication algorithm to use for the IPSec connection. */
  authenticationAlgorithm?: InputMaybe<IpSecAuthenticationAlgorithm>;
  /** Sets the DPD action for the tunnel. */
  dpdAction?: InputMaybe<IpSecDpdAction>;
  /** Sets the DPD delay for the tunnel. */
  dpdDelay?: InputMaybe<Scalars['Duration']['input']>;
  /** Sets the DPD timeout for the tunnel. */
  dpdTimeout?: InputMaybe<Scalars['Duration']['input']>;
  /** The encryption algorithm to use for the IPSec connection. */
  encryptionAlgorithm?: InputMaybe<IpSecEncryptionAlgorithm>;
  /** Sets the ikelifetime for the tunnel. */
  ikeLifetime?: InputMaybe<Scalars['Duration']['input']>;
  /**
   * If true, adds Client VPN subnets to the local traffic selectors,
   * effectively allowing Client VPN clients to route traffic over the IPSec tunnel.
   */
  isClientVPNBound?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates whether the IPSec tunnel should be enabled upon creation. */
  isEnabled: Scalars['Boolean']['input'];
  /** Indicates whether this tunnel should initiate the connection to the right participant; defaults to false. */
  isInitiator?: Scalars['Boolean']['input'];
  /** The Diffie-Hellman group to use for key exchange in the IPSec connection. */
  keyExchangeDHGroup?: InputMaybe<IpSecDhGroup>;
  /** Identifier for the left participant (this side) for authentication purposes. Must be a FQDN or IPv4 address. */
  leftID: Scalars['String']['input'];
  /** The name of the IPSec tunnel. */
  name: Scalars['String']['input'];
  /** Allows for vendor specific configuration based on this peer type */
  peerType?: InputMaybe<IpSecPeerType>;
  /** UUID of the physical interface to bind the IPSec tunnel to; must be an uplink interface. */
  phyInterfaceUUID: Scalars['UUID']['input'];
  /** The pre-shared key for authentication; can be base64 encoded or plaintext. */
  presharedKey: Scalars['String']['input'];
  /** Sets the reauth for the tunnel, true = yes, false = no */
  reauth?: Scalars['Boolean']['input'];
  /** Sets the rekey for the tunnel, true = yes, false = no */
  rekey?: Scalars['Boolean']['input'];
  /** The public IP address or hostname of the right participant's gateway. */
  right?: InputMaybe<Scalars['String']['input']>;
  /** Identifier for the right participant (remote side) for authentication purposes. Must be a FQDN or IPv4 address. */
  rightID: Scalars['String']['input'];
  /** List of IP prefixes representing the private subnets behind the right participant. */
  rightPrefixes: Array<Scalars['IPPrefix']['input']>;
  /** List of VLAN UUIDs to bind the IPSec tunnel to. */
  vlanUUIDs: Array<Scalars['UUID']['input']>;
};

export type CreateInternalNoteInput = {
  /** Indicates whether the note is marked as important. */
  isImportant?: Scalars['Boolean']['input'];
  /** Content of the internal note. */
  note: Scalars['String']['input'];
  /** Use the `createPreSignedUploadUrl` mutation to generate S3 keys and presigned URLs for the photos, and specify them here. */
  photoS3Keys?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Input type for creating a new Internet Service Plan. */
export type CreateInternetServicePlanInput = {
  /** Physical address associated with the Internet Service Plan. */
  address?: InputMaybe<CreateAddressInput>;
  /** Connection details, including product and status. */
  connection: InternetServicePlanConnectionInput;
  /** IP configuration details provided by the ISP. */
  ipConfiguration: InternetServicePlanIpInput;
  /** Unique identifier of the ISP provider. */
  providerUUID: Scalars['UUID']['input'];
};

/** Input type for creating a new Internet Service Plan Provider. */
export type CreateInternetServicePlanProviderInput = {
  /** Alternative names for Internet Service Provider used in 3rd party APIs */
  aliases?: InputMaybe<Array<Scalars['String']['input']>>;
  /** AWS S3 key of the square icon image. */
  iconS3Key?: InputMaybe<Scalars['String']['input']>;
  /** AWS S3 key of the landscape logo image. */
  logoS3Key?: InputMaybe<Scalars['String']['input']>;
  /** Name of the provider. */
  name: Scalars['String']['input'];
};

/** Input type for creating a new Internet Service Plan Provider Static Rate. */
export type CreateInternetServicePlanProviderStaticRateInput = {
  /** UUID of Product type for the rate. */
  connectionTypeUUID: Scalars['UUID']['input'];
  /** Download speed Kbps. */
  downloadKbps: Scalars['Int']['input'];
  /** Enabled status of the rate. */
  enabled: Scalars['Boolean']['input'];
  /** Install cost in cents. */
  installCostCents: Scalars['Int']['input'];
  /** Describes dependency of the static rate on a location. */
  locationMode: InternetServicePlanProviderStaticRateLocationMode;
  /** Monthly recurring cost in cents. */
  monthlyCostCents: Scalars['Int']['input'];
  /** UUID of the Internet Service Plan Provider offering the product. */
  providerUUID: Scalars['UUID']['input'];
  /** Term of contract in months. */
  termMonths: Scalars['Int']['input'];
  /** Upload speed Kbps. */
  uploadKbps: Scalars['Int']['input'];
};

/** Input type for creating a mailing address. */
export type CreateMailingAddressInput = {
  /** The city of the mailing address. */
  city: Scalars['String']['input'];
  /** The two-letter ISO code of the country. */
  countryISO2: Scalars['String']['input'];
  /** The first line of the mailing address, usually the street address. */
  line1: Scalars['String']['input'];
  /** The second line of the mailing address, such as apartment or suite number. */
  line2?: InputMaybe<Scalars['String']['input']>;
  /** The postal code or ZIP code of the mailing address. */
  postalCode?: InputMaybe<Scalars['String']['input']>;
  /** The subdivision code, such as the state or province code. */
  subdivisionCode?: InputMaybe<Scalars['String']['input']>;
};

export type CreateMarketingChangelogEntryInput = {
  /** Properties to display inside a badge alongside the changelog entry. */
  badge?: InputMaybe<DisplayBadgeInput>;
  /** Descriptive copy text for the marketing changelog entry. */
  copy?: InputMaybe<Scalars['String']['input']>;
  /** Informational heading text for the marketing changelog entry. */
  heading: Scalars['String']['input'];
  /** A pair of theme-dependent images to display alongside the changelog entry. */
  imageS3Keys?: InputMaybe<ThemedImageS3KeysInput>;
  /** A destination to link to that contains more information about the changelog entry. */
  linkURL?: InputMaybe<Scalars['String']['input']>;
  /** When the entry stops being visible to customers. */
  visibleEndAt: Scalars['DateTime']['input'];
  /** When the entry starts being visible to customers. */
  visibleStartAt: Scalars['DateTime']['input'];
};

export type CreateNosUpgradeGroupInput = {
  /** A human-friendly description of the group. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** A human-friendly label for the group. */
  name: Scalars['String']['input'];
  /**
   * The priority of the NOS upgrade group; lower values are higher priority.
   * Groups of devices will be upgraded in order of priority.
   * If set, the group will be inserted at the given priority, bumping all equal or lesser groups to an inferior priority.
   * The priority must be equal to an existing group's priority or +1 of the last existing priority.
   * If not set, the group will be inserted at the most inferior priority.
   * Priority is 0-indexed.
   */
  priority?: InputMaybe<Scalars['Int']['input']>;
  /** How long to wait for all devices in the group to upgrade before timing out, in seconds. */
  timeoutDurationSeconds?: Scalars['Int']['input'];
  /** If specified, the given virtual devices will be moved from their current group to this group. */
  virtualDeviceUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

export type CreateNetworkClientCpeBindingInput = {
  /** The UUID of the CPE for the binding. */
  cpeUUID: Scalars['UUID']['input'];
  /** The MAC address to bind cpeUUID to. */
  macAddress: Scalars['MacAddress']['input'];
};

/** Input type for creating a network. */
export type CreateNetworkInput = {
  /** If false, wifi steering will be fully disabled even if supported by NOS. */
  IsWifiSteeringEnabled?: Scalars['Boolean']['input'];
  /** The slug identifier of the company that this network belongs to. */
  companySlug?: InputMaybe<Scalars['String']['input']>;
  /** Indicates whether the network is currently active. Defaults to true. */
  isActive?: Scalars['Boolean']['input'];
  /** Enables controller to upgrade config-1 APs deployed to the network. */
  isConfig1WosUpgradesEnabled?: Scalars['Boolean']['input'];
  /** Indicates whether the network is a template for creating new networks. Defaults to false; must be true if creating the network underneath a 'global network template holding company'. */
  isTemplate?: Scalars['Boolean']['input'];
  /**
   * Deprecated: Not a network property anymore.
   * @deprecated Not a network property anymore
   */
  isTest?: Scalars['Boolean']['input'];
  /** A label to quickly identify the network. */
  label: Scalars['String']['input'];
  /**
   * Deprecated: Use `mailingAddressInput` instead.
   * @deprecated Use `mailingAddressInput` instead.
   */
  mailingAddress?: InputMaybe<Scalars['String']['input']>;
  /** The mailing address details for the network. */
  mailingAddressInput?: InputMaybe<CreateMailingAddressInput>;
  /** The UUID of the mailing address associated with the network. */
  mailingAddressUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** The algorithm used for multi-WAN load balancing. */
  multiWANAlgorithm?: InputMaybe<MultiWanAlgorithm>;
  /** The URL of the patch panel diagram for the network. */
  patchPanelDiagramURL?: InputMaybe<Scalars['String']['input']>;
  /** A NOS version should be specified. If not, the default no-upgrades NOS version is assigned. */
  pinnedNOSVersionID?: InputMaybe<Scalars['Int']['input']>;
  /** A human-readable identifier for the network. */
  slug: Scalars['String']['input'];
  /**
   * Deprecated: Not a network property anymore.
   * @deprecated Not a network property anymore
   */
  squareFeet?: InputMaybe<Scalars['Int']['input']>;
  /**
   * The interval in minutes used to stagger device upgrades within the network.
   * @deprecated No longer relevant
   */
  staggeredUpgradeIntervalMin?: InputMaybe<Scalars['Int']['input']>;
  /** The S3 key for the network topology image. */
  topologyImageS3Key?: InputMaybe<Scalars['String']['input']>;
};

export type CreateNetworkThreatAllowlistEntryInput = {
  /** A bssid to allow for honeypot AP detection. */
  BSSID?: InputMaybe<Scalars['String']['input']>;
  /** An explanation of the allowlisted device or the SSID to allow. */
  reason?: InputMaybe<Scalars['String']['input']>;
  /** An SSID to allow if a threat is broadcasting it. */
  ssidUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** A mac address to allow for rogue AP detection. */
  wiredMAC?: InputMaybe<Scalars['String']['input']>;
};

export type CreateNosFeatureInput = {
  /** A detailed description of the NOS feature. */
  description: Scalars['String']['input'];
  /** If the feature is also behind a feature flag, this is the name of the feature flag. */
  featureFlag?: InputMaybe<Scalars['String']['input']>;
  /** A unique key that identifies the NOS feature. */
  key: Scalars['String']['input'];
  /** The maximum major version of NOS firmware that supports this feature. If null, there is no upper major version limit. */
  maxMajorVersion?: InputMaybe<Scalars['Int']['input']>;
  /** The maximum minor version of NOS firmware that supports this feature. If null, there is no upper minor version limit. */
  maxMinorVersion?: InputMaybe<Scalars['Int']['input']>;
  /** The maximum patch version of NOS firmware that supports this feature. If null, there is no upper patch version limit. */
  maxPatchVersion?: InputMaybe<Scalars['Int']['input']>;
  /** The minimum major version of NOS firmware required to support this feature. */
  minMajorVersion: Scalars['Int']['input'];
  /** The minimum minor version of NOS firmware required to support this feature. */
  minMinorVersion: Scalars['Int']['input'];
  /** The minimum patch version of NOS firmware required to support this feature. */
  minPatchVersion: Scalars['Int']['input'];
  /** The display name of the NOS feature. */
  name: Scalars['String']['input'];
};

/** Input type for creating a new notification setting. */
export type CreateNotificationSettingInput = {
  /** The UUID of the alert receiver who will receive the notifications. */
  alertReceiverUUID: Scalars['UUID']['input'];
  /** A list of arguments providing specific parameters or context required by the notification definition. */
  arguments: Array<NotificationSettingArgumentInput>;
  /** The ID of the user who is creating this notification setting. */
  createdBy?: InputMaybe<Scalars['Int']['input']>;
  /** Indicates whether the notification setting is enabled. Defaults to true. */
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** The name of the notification definition specifying the type of alert. */
  notificationDefinitionName: Scalars['String']['input'];
};

/** Input type for creating notification snooze. */
export type CreateNotificationSnoozeInput = {
  /** The reason for the snooze. */
  snoozeReason?: InputMaybe<Scalars['String']['input']>;
  /** The time window for the snooze. */
  window: SnoozeNotificationSettingWindowInput;
};

export type CreateOneToOneNatRuleInput = {
  /** Optional description of the 1:1 NAT rule. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** External IP address to be mapped by the NAT rule. */
  externalIPAddr: Scalars['IPV4']['input'];
  /** UUID of the physical interface associated with the external IP address. */
  externalPhyInterfaceUUID: Scalars['UUID']['input'];
  /** Internal IP address that the external IP address will be mapped to. */
  internalIPAddr: Scalars['IPV4']['input'];
  /** Indicates whether the NAT rule is enabled upon creation. */
  isEnabled: Scalars['Boolean']['input'];
  /** Name of the 1:1 NAT rule. */
  name: Scalars['String']['input'];
};

export type CreatePermittedEmailDomainInput = {
  /** The slug of the company to which the permitted email domain will be added. */
  companySlug: Scalars['String']['input'];
  /** The email domain to allow (e.g., "example.com"). */
  domain: Scalars['String']['input'];
};

export type CreatePolicyRoutingRuleInput = {
  /** The list of bindings to associate with this policy routing rule. */
  bindings: Array<PolicyRoutingRuleBindingInput>;
  /** The list of destination port ranges for the traffic matching this rule. */
  dstPortRanges: Array<PortRangeInput>;
  /** The destination IP prefix for the traffic matching this rule. */
  dstPrefix: Scalars['IPPrefix']['input'];
  /** Indicates whether the policy routing rule is enabled. */
  isEnabled: Scalars['Boolean']['input'];
  /** The name of the policy routing rule. */
  name: Scalars['String']['input'];
  /** The list of IP protocols (e.g., TCP, UDP) for the traffic matching this rule. */
  protocols: Array<IpProtocol>;
  /** The list of source port ranges for the traffic matching this rule. */
  srcPortRanges: Array<PortRangeInput>;
  /** The source IP prefix for the traffic matching this rule (optional). */
  srcPrefix?: InputMaybe<Scalars['IPPrefix']['input']>;
  /** The UUID of the source VLAN for the traffic matching this rule (optional). */
  srcVLANUUID?: InputMaybe<Scalars['UUID']['input']>;
};

export type CreatePortForwardingRuleInput = {
  /** Restricts the port forwarding rule to only allow traffic to be forwarded if it originates from any of these IP addresses. */
  allowedRemoteIPAddresses?: InputMaybe<Array<Scalars['IP']['input']>>;
  /** Description of the port forwarding rule. */
  description?: InputMaybe<Scalars['String']['input']>;
  /**
   * The external IP address to which this rule applies.
   * One of `externalPhyInterfaceUUID` or `externalIPAddress` must be provided.
   */
  externalIPAddress?: InputMaybe<Scalars['IP']['input']>;
  /**
   * UUID of the external uplink physical interface.
   * One of `externalPhyInterfaceUUID` or `externalIPAddress` must be provided.
   */
  externalPhyInterfaceUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** The external port from which incoming traffic is forwarded. */
  externalPort: Scalars['Int']['input'];
  /** Indicates whether the port forwarding rule is enabled. */
  isEnabled: Scalars['Boolean']['input'];
  /** The local IP address to which incoming traffic is forwarded. */
  localIPAddress: Scalars['IP']['input'];
  /** The local port to which the external port forwards traffic. */
  localPort: Scalars['Int']['input'];
  /** Name of the port forwarding rule. */
  name: Scalars['String']['input'];
  /** The IP protocol to apply this rule on. These are the IANA-defined protocol numbers (e.g., 6 for TCP, 17 for UDP). */
  protocol: PortIpProtocol;
};

/** Input type for creating a pre-signed URL for file upload. */
export type CreatePreSignedUploadUrlInput = {
  /** The extension of the file being uploaded (e.g., 'jpg', 'png', 'pdf'). Do not include the leading dot. */
  fileExtension: Scalars['String']['input'];
  /** The folder where the file will be uploaded. */
  folder: AllowedFolder;
};

/** Input type for creating a new rack elevation. */
export type CreateRackElevationInput = {
  /** The left-to-right position of the rack relative to others. */
  horizontalIndex?: InputMaybe<Scalars['Int']['input']>;
  /** Human-readable name for the rack elevation. */
  label: Scalars['String']['input'];
  /** Notes associated with the rack elevation. */
  notes?: InputMaybe<Array<RackElevationNoteInput>>;
  /** The number of rack units (like slots) for the rack elevation. */
  rackMountUnitCount: Scalars['Int']['input'];
};

export type CreateRadioProfileInput = {
  /**
   * Required if band2_4GAutoChannelIsEnabled is true.
   * The list of allowed channels for auto channel selection on the 2.4 GHz band.
   */
  band2_4GAllowedChannels?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Indicates whether auto channel selection is enabled for the 2.4 GHz band. */
  band2_4GAutoChannelIsEnabled: Scalars['Boolean']['input'];
  /** Indicates whether auto channel width selection is enabled for the 2.4 GHz band. */
  band2_4GAutoChannelWidthIsEnabled: Scalars['Boolean']['input'];
  /** Indicates whether automatic transmit power adjustment is enabled for the 2.4 GHz band. */
  band2_4GAutoTxPowerIsEnabled: Scalars['Boolean']['input'];
  /**
   * Required if band2_4GAutoTxPowerIsEnabled is true.
   * The maximum transmit power in dBm for the 2.4 GHz band when auto transmit power is enabled.
   */
  band2_4GAutoTxPowerMaxdBm?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Required if band2_4GAutoTxPowerIsEnabled is true.
   * The minimum transmit power in dBm for the 2.4 GHz band when auto transmit power is enabled.
   */
  band2_4GAutoTxPowerMindBm?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Required if band2_4GAutoChannelWidthIsEnabled is false.
   * The channel width in MHz for the 2.4 GHz band when auto channel width is disabled.
   */
  band2_4GChannelWidthMHz?: InputMaybe<Scalars['Int']['input']>;
  /** Indicates whether the 2.4 GHz band is enabled. */
  band2_4GIsEnabled: Scalars['Boolean']['input'];
  /**
   * Required if band5GAutoChannelIsEnabled is true.
   * The list of allowed channels for auto channel selection on the 5 GHz band.
   */
  band5GAllowedChannels?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Indicates whether auto channel selection is enabled for the 5 GHz band. */
  band5GAutoChannelIsEnabled: Scalars['Boolean']['input'];
  /** Indicates whether auto channel width selection is enabled for the 5 GHz band. */
  band5GAutoChannelWidthIsEnabled: Scalars['Boolean']['input'];
  /** Indicates whether automatic transmit power adjustment is enabled for the 5 GHz band. */
  band5GAutoTxPowerIsEnabled: Scalars['Boolean']['input'];
  /**
   * Required if band5GAutoTxPowerIsEnabled is true.
   * The maximum transmit power in dBm for the 5 GHz band when auto transmit power is enabled.
   */
  band5GAutoTxPowerMaxdBm?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Required if band5GAutoTxPowerIsEnabled is true.
   * The minimum transmit power in dBm for the 5 GHz band when auto transmit power is enabled.
   */
  band5GAutoTxPowerMindBm?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Required if band5GAutoChannelWidthIsEnabled is false.
   * The channel width in MHz for the 5 GHz band when auto channel width is disabled.
   */
  band5GChannelWidthMHz?: InputMaybe<Scalars['Int']['input']>;
  /** Indicates whether the 5 GHz band is enabled. */
  band5GIsEnabled: Scalars['Boolean']['input'];
  /**
   * Required if band6GAutoChannelIsEnabled is true.
   * The list of allowed channels for auto channel selection on the 6 GHz band.
   */
  band6GAllowedChannels?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Indicates whether auto channel selection is enabled for the 6 GHz band. */
  band6GAutoChannelIsEnabled?: Scalars['Boolean']['input'];
  /** Indicates whether auto channel width selection is enabled for the 6 GHz band. */
  band6GAutoChannelWidthIsEnabled?: Scalars['Boolean']['input'];
  /** Indicates whether automatic transmit power adjustment is enabled for the 6 GHz band. */
  band6GAutoTxPowerIsEnabled?: Scalars['Boolean']['input'];
  /**
   * Required if band6GAutoTxPowerIsEnabled is true.
   * The maximum transmit power in dBm for the 6 GHz band when auto transmit power is enabled.
   */
  band6GAutoTxPowerMaxdBm?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Required if band6GAutoTxPowerIsEnabled is true.
   * The minimum transmit power in dBm for the 6 GHz band when auto transmit power is enabled.
   */
  band6GAutoTxPowerMindBm?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Required if band6GAutoChannelWidthIsEnabled is false.
   * The channel width in MHz for the 6 GHz band when auto channel width is disabled.
   */
  band6GChannelWidthMHz?: InputMaybe<Scalars['Int']['input']>;
  /** Indicates whether the 6 GHz band is enabled. */
  band6GIsEnabled?: Scalars['Boolean']['input'];
  /** A human-readable description. */
  description?: InputMaybe<Scalars['String']['input']>;
  /**
   * Setting this to true will set all other profiles to false.
   * Indicates whether this profile should be set as the default for the network.
   */
  isDefault: Scalars['Boolean']['input'];
  /** The name of the radio profile to create. */
  name: Scalars['String']['input'];
};

/** The metadata required to create radio settings for an access point. */
export type CreateRadioSettingsInput = {
  /** The primary channel for the 2.4 GHz radio band. */
  band2_4GPrimaryChannel: Scalars['Int']['input'];
  /** The transmit power in dBm for the 2.4 GHz radio band. */
  band2_4GTransmitPowerdBm: Scalars['Int']['input'];
  /** The primary channel for the 5 GHz radio band. */
  band5GPrimaryChannel: Scalars['Int']['input'];
  /** The secondary channel for the 5 GHz radio band, if applicable. */
  band5GSecondaryChannel?: InputMaybe<Scalars['Int']['input']>;
  /** The transmit power in dBm for the 5 GHz radio band. */
  band5GTransmitPowerdBm: Scalars['Int']['input'];
  /** The primary channel for the 6 GHz radio band. */
  band6GPrimaryChannel?: InputMaybe<Scalars['Int']['input']>;
  /** The transmit power in dBm for the 6 GHz radio band. */
  band6GTransmitPowerdBm?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateRateLimitRuleInput = {
  /** A list of UUIDs of physical interfaces to which this rate limit rule is bound. */
  boundPhyInterfaceUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** A list of UUIDs of SSIDs to which this rate limit rule is bound. */
  boundSSIDUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** A list of UUIDs of VLANs to which this rate limit rule is bound. */
  boundVLANUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** A description of the rate limit rule. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Destination MAC address to match. */
  dstMac?: InputMaybe<Scalars['MacAddress']['input']>;
  /** Destination port range to match. */
  dstPortRange?: InputMaybe<PortRangeInput>;
  /** Destination IP address prefix to match. */
  dstPrefix?: InputMaybe<Scalars['IPPrefix']['input']>;
  /** Indicates whether the rate limit rule is enabled. */
  isEnabled: Scalars['Boolean']['input'];
  /** Specifies if the rate limit is applied per source IP/MAC address. */
  isPerSource?: InputMaybe<Scalars['Boolean']['input']>;
  /** The name of the rate limit rule. */
  name: Scalars['String']['input'];
  /** The order in which the rate limit rules are applied, lower priorities first. If omitted, will be appended to the end. */
  priority?: InputMaybe<Scalars['Int']['input']>;
  /** IANA protocol number to match. */
  protocol?: InputMaybe<IpProtocol>;
  /** Maximum download rate limit in kilobits per second. */
  rateLimitKbpsDownload?: InputMaybe<Scalars['Int']['input']>;
  /** Maximum upload rate limit in kilobits per second. */
  rateLimitKbpsUpload?: InputMaybe<Scalars['Int']['input']>;
  /** Source MAC address to match. */
  srcMac?: InputMaybe<Scalars['MacAddress']['input']>;
  /** Source port range to match. */
  srcPortRange?: InputMaybe<PortRangeInput>;
  /** Source IP address prefix to match. */
  srcPrefix?: InputMaybe<Scalars['IPPrefix']['input']>;
};

export type CreateSsidInput = {
  /**
   * The lowest rate at which a client can connect to the 2.4 GHz radio, in kilobits per second.
   * If not set, will be set to a default value.
   */
  band2GMinimumBasicRateKbps?: InputMaybe<Scalars['Int']['input']>;
  /**
   * The lowest rate at which a client can connect to the 5 GHz radio, in kilobits per second.
   * If not set, will be set to a default value.
   */
  band5GMinimumBasicRateKbps?: InputMaybe<Scalars['Int']['input']>;
  /**
   * The lowest rate at which a client can connect to the 6 GHz radio, in kilobits per second.
   * If not set, will be set to a default value.
   */
  band6GMinimumBasicRateKbps?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies the schedule intervals during which the SSID will be broadcasted. */
  broadcastSchedule?: InputMaybe<Array<SsidBroadcastScheduleIntervalInput>>;
  /** A list of allowed client MACs, if isClientAllowlistEnabled is true. */
  clientAllowlist?: InputMaybe<Array<Scalars['MacAddress']['input']>>;
  /** Enable or disable client steering for association. */
  clientSteeringAssociationSteeringIsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** The minimum number of clients on an SSID before client steering is attempted. */
  clientSteeringLoadBalancingClientMinThreshold?: InputMaybe<Scalars['Int']['input']>;
  /** Enable or disable post-association client steering. */
  clientSteeringPostassociationSteeringIsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** The minimum RSSI signal strength (in dBm) before pre-association client steering is attempted. */
  clientSteeringPreassociationRSSIMinThreshold?: InputMaybe<Scalars['Int']['input']>;
  /** Description of the SSID. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** List of access point virtual device UUIDs on which the SSID is disabled. */
  disabledAccessPointVirtualDeviceUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** The DTIM period for the SSID. */
  dtimPeriod?: InputMaybe<Scalars['Int']['input']>;
  /** Dynamic VLAN mode setting. */
  dynamicVLANMode?: InputMaybe<SsidDynamicVlanMode>;
  /**
   * Required if isEnabledForAllAccessPoints is false.
   * List of access point virtual device UUIDs on which the SSID is enabled.
   */
  enabledAccessPointVirtualDeviceUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** 802.11w Protected Management Frames mode. */
  encryption80211wProtectedManagementFramesMode?: InputMaybe<SsidEncryption80211wProtectedManagementFramesMode>;
  /** Encryption protocol used by the SSID. */
  encryptionProtocol?: InputMaybe<SsidEncryptionProtocol>;
  /** Enable or disable 802.11ax (Wi-Fi 6) for the SSID. */
  is80211axEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enable or disable broadcasting the SSID on the 2.4 GHz band. */
  isBand2GAllowed: Scalars['Boolean']['input'];
  /** Enable or disable broadcasting the SSID on the 5 GHz band. */
  isBand5GAllowed: Scalars['Boolean']['input'];
  /** Enable or disable broadcasting the SSID on the 6 GHz band. */
  isBand6GAllowed?: Scalars['Boolean']['input'];
  /** If true, only clients in the client allowlist will be allowed. */
  isClientAllowlistEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enable or disable the SSID. */
  isEnabled: Scalars['Boolean']['input'];
  /** Enable the SSID for all access points or only specified ones. */
  isEnabledForAllAccessPoints: Scalars['Boolean']['input'];
  /** Mark the SSID as a guest network. */
  isGuest?: Scalars['Boolean']['input'];
  /** Hide the SSID from being broadcasted. */
  isHidden: Scalars['Boolean']['input'];
  /** Enable client isolation on the SSID. */
  isIsolateClientsEnabled: Scalars['Boolean']['input'];
  /** Whether proxy ARP (AP responds to ARP requests coming from the uplink on behalf of the clients) is enabled */
  isProxyARPEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enable or disable 802.11k roaming. */
  isRoaming80211kEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enable or disable 802.11r fast roaming. */
  isRoaming80211rEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enable or disable 802.11v roaming. */
  isRoaming80211vEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** A NAS (Network Access Server) identifier that can be used for Radius or 11r; if empty, defaults to the AP's hostname. */
  nasIdentifier?: InputMaybe<Scalars['String']['input']>;
  /** Pre-shared key (PSK) for the SSID. */
  password?: InputMaybe<Scalars['String']['input']>;
  /** Cadence for automatic password rotation. */
  passwordRotationCadence?: InputMaybe<SsidPasswordRotationCadence>;
  /** The day of the month for password rotation in the network's local time zone. */
  passwordRotationDayOfMonthLocal?: InputMaybe<Scalars['Int']['input']>;
  /** The day of the week for password rotation in the network's local time zone (0 = Sunday). */
  passwordRotationDayOfWeekLocal?: InputMaybe<Scalars['Int']['input']>;
  /** The hour of the day for password rotation in the network's local time zone. */
  passwordRotationHourOfDayLocal?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Set the primary 802.1X encryption configuration.
   * Required if encryptionProtocol is WPA2_ENTERPRISE.
   */
  primaryEncryption8021XUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** Enable or disable RADIUS Change of Authorization (CoA). */
  radiusCoaEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** A port where RADIUS servers can send CoA requests. If unset, default port will be 3799 as per RFC 3576. */
  radiusCoaPort?: InputMaybe<Scalars['Int']['input']>;
  /** Value to configure RTS/CTS. */
  rtsCtsEnabledCode?: InputMaybe<Scalars['Int']['input']>;
  /** Size of the PPDU on which RTS would be sent out. */
  rtsThreshold?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Set the secondary 802.1X encryption configuration.
   * Required if encryptionProtocol is WPA2_ENTERPRISE.
   */
  secondaryEncryption8021XUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** Name of the SSID. */
  ssid: Scalars['String']['input'];
  /** UUID of the VLAN to associate with the SSID. */
  vlanUUID?: InputMaybe<Scalars['UUID']['input']>;
};

/** Result of creating a SSO dashboard for a company. */
export type CreateSsoDashboardForCompanyResult = {
  __typename?: 'CreateSSODashboardForCompanyResult';
  /** The company for which the SSO dashboard was created. */
  company: Company;
  /** The URL of the SSO dashboard. */
  dashboardURL: Scalars['String']['output'];
};

/** Result of creating an SSO redirect URI. */
export type CreateSsoRedirectUriResult = {
  __typename?: 'CreateSSORedirectURIResult';
  /** The URI to redirect to for SSO login. */
  uri: Scalars['String']['output'];
};

/** Input for verifying an SSO authentication. */
export type CreateSsoVerifyInput = {
  /** The authorization code returned by the SSO provider. */
  code: Scalars['String']['input'];
  /**
   * Deprecated. The source of the verification request.
   * @deprecated Source is no longer important.
   */
  source?: InputMaybe<SsoVerificationSource>;
  /** Optional state parameter for CSRF protection. */
  state?: InputMaybe<Scalars['String']['input']>;
};

/** Result returned after verifying an SSO authentication. */
export type CreateSsoVerifyResult = {
  __typename?: 'CreateSSOVerifyResult';
  /** The email address of the authenticated user. */
  email: Scalars['String']['output'];
  /** The first name of the authenticated user. */
  firstName: Scalars['String']['output'];
  /** If the session was created via impersonation, this field will be set. */
  impersonator?: Maybe<Impersonator>;
  /** The last name of the authenticated user. */
  lastName: Scalars['String']['output'];
  /** The path to redirect the user to after successful authentication. */
  path?: Maybe<Scalars['String']['output']>;
  /** Indicates if the user is accessing a preview environment. */
  preview?: Maybe<Scalars['Boolean']['output']>;
  /** The method used to authenticate the user. */
  via?: Maybe<Scalars['String']['output']>;
};

/** Result of creating SSO OAuth URIs for Google and Microsoft authentication. */
export type CreateSsoOAuthUriResult = {
  __typename?: 'CreateSsoOAuthURIResult';
  /** The OAuth URI for Google authentication. */
  googleUri: Scalars['String']['output'];
  /** The OAuth URI for Microsoft authentication. */
  microsoftUri: Scalars['String']['output'];
};

export type CreateStaticRouteInput = {
  /** Destination IP prefix for the static route. */
  dstPrefix: Scalars['IPPrefix']['input'];
  /**
   * UUIDs of VLANs to be excluded from the static route.
   * Only valid if this is a default route (0.0.0.0/0 destination prefix).
   * Only one of `explicitlyBoundVLANUUIDs` and `excludedVLANUUIDs` can be non-null and non-empty.
   */
  excludedVLANUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /**
   * UUIDs of VLANs to be bound to the static route.
   * Only valid if this is a default route (0.0.0.0/0 destination prefix).
   * If empty, all non-excluded VLANs will be bound to the default route.
   * Only one of `explicitlyBoundVLANUUIDs` and `excludedVLANUUIDs` can be non-null and non-empty.
   */
  explicitlyBoundVLANUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** UUID of the DHCP Static Mapping to be used as gateway. */
  gatewayDHCPStaticMappingUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** Gateway IP address for the static route. */
  gatewayIP?: InputMaybe<Scalars['IPV4']['input']>;
  /** UUID of the VLAN to be used as the gateway. */
  gatewayVLANUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** Indicates whether the static route is enabled. */
  isEnabled?: Scalars['Boolean']['input'];
  /** Name of the static route. */
  name: Scalars['String']['input'];
};

export type CreateSwitchAutoConfigMacAddressVlanBindingInput = {
  /** The OUI (Organizationally Unique Identifier) to bind to a VLAN. Either OUI, macAddress, or vendor must be provided. */
  OUI?: InputMaybe<Scalars['String']['input']>;
  /** The UUID of the VLAN to assign to the specified MAC address or OUI. */
  VLANUUID: Scalars['UUID']['input'];
  /** The MAC address to bind to a VLAN. Either macAddress, OUI, or vendor must be provided. */
  macAddress?: InputMaybe<Scalars['MacAddress']['input']>;
  /** The vendor of devices as specified by the IEEE OUI database: https://standards-oui.ieee.org/. Either vendor, macAddress, or OUI must be provided. Use the OUI resolvers to get the correct string to input here. */
  vendor?: InputMaybe<Scalars['String']['input']>;
};

/** Input type for creating a switch profile. */
export type CreateSwitchProfileInput = {
  /** For 802.1X encryption on a Switch's ports, if a client fails 802.1X authentication, clients are placed in the specified VLAN. The VLAN must be specified as `isGuest`. If set to null, then clients must authenticate before accessing the network. */
  encryption8021XGuestVLANUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** The 802.1X encryption configurations associated with this switch profile. */
  encryption8021XUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** If true, flap link intervention protocol is enabled on the port. Both this flag and isFLIPEnabled in SwitchProfile must be true for FLIP to be enabled on a port. */
  isFLIPEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enables switch to periodically send IGMP queries to detect multicast clients. */
  isIGMPSnoopingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enables switch to periodically send MLD queries to detect multicast clients. */
  isMLDSnoopingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Multicast filtering tells the switch what to do with unknown multicast packet i.e packets for which snooping doesn't have any learned ports. When enabled, unknown multicast packets are dropped. */
  isMulticastFilteringEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, voice VLAN is enabled for this port. Both this flag and isVoiceVLANEnabled in SwitchProfile must be true for voice VLAN to be enabled on a port. */
  isVoiceVLANEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Time in seconds after which a MAC entry will be aged out, default is 300 seconds (5 minutes) and 0 means no expiration. */
  macTableAgingSec?: Scalars['Int']['input'];
  /** The maximum transmission unit (MTU) size in bytes. */
  mtu?: Scalars['Int']['input'];
  /** The name of the switch profile. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The unique identifier of the network where the switch profile will be created. */
  networkUUID: Scalars['UUID']['input'];
  /**
   * The STP bridge priority for the switch.
   *
   * The lower the value, the more likely the switch is to be elected as the root bridge.
   * The default is 32768.
   * The range is 0 to 61440. Valid values are multiples of 4096.
   */
  stpBridgePriority?: Scalars['Int']['input'];
  /** The tier of the switch device(s) associated with the switch profile, denoting the purpose of the devices in the network. */
  switchingTier: SwitchProfileSwitchingTier;
};

/** Input type containing parameters required to create user access to a network. */
export type CreateUserNetworkAccessInput = {
  /** The date and time when the access should expire. */
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** The unique identifier (UUID) of the network to which access is being granted. */
  networkUUID: Scalars['UUID']['input'];
};

export type CreateVlanInput = {
  /** A list of DHCP rules to create for this VLAN. */
  createDHCPRules?: InputMaybe<Array<CreateDhcpRuleInput>>;
  /** An optional description of the VLAN. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Specifies the protocol for assigning IPv4 addresses to clients on this VLAN. */
  ipV4ClientAssignmentProtocol?: InputMaybe<ClientAssignmentProtocol>;
  /** Specifies the IPv4 gateway address for this VLAN. */
  ipV4ClientGateway?: InputMaybe<Scalars['IPV4']['input']>;
  /** Specifies the IPv4 prefix length (subnet mask) for this VLAN. */
  ipV4ClientPrefixLength?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies the protocol for assigning IPv6 addresses to clients on this VLAN. */
  ipV6ClientAssignmentProtocol?: InputMaybe<ClientAssignmentProtocol>;
  /** Specifies the IPv6 gateway address for this VLAN. */
  ipV6ClientGateway?: InputMaybe<Scalars['IPV6']['input']>;
  /** Specifies the IPv6 prefix length (subnet mask) for this VLAN. */
  ipV6ClientPrefixLength?: InputMaybe<Scalars['Int']['input']>;
  /** If true, the VLAN is enabled upon creation. */
  isEnabled?: Scalars['Boolean']['input'];
  /** If true, this VLAN is internal to the network and should not be displayed to or editable by the customer. */
  isInternal?: Scalars['Boolean']['input'];
  /** If true, the VLAN participates in multicast/mDNS reflection. */
  isMulticastReflectionEnabled?: Scalars['Boolean']['input'];
  /** If true, prevents this VLAN from sending traffic through WANs (blocks internet access). */
  isWANDenied?: Scalars['Boolean']['input'];
  /** A human-friendly name to identify the VLAN. */
  name: Scalars['String']['input'];
  /**
   * If true, allows this VLAN to participate in cross-site VPN features and its IPv4Prefix cannot overlap with any other
   * IPv4Prefix for VLANs with a true participatesInVPN in the associated company for this network.
   */
  participatesInVPNs?: Scalars['Boolean']['input'];
  /**
   * VLANs explicitly allowed to inter-communicate with this VLAN.
   * Effectively equivalent to firewall rules allowing communication between this VLAN and all of these VLANs.
   */
  permittedInterVLANCommunicationVLANUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** The VLAN ID. Must be between 1 and 4094 and is unique per network. */
  vlanID: Scalars['Int']['input'];
};

/** The metadata required to create a virtual device. */
export type CreateVirtualDeviceInput = {
  /** An optional description for the virtual device. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The model of the virtual device. */
  deviceModel: DeviceModel;
  /** The type of the virtual device to create. */
  deviceType: VirtualDeviceType;
  /**
   * Mark the virtual device as read-only. As of now this is only supported for PDUs.
   * If the device is marked as read-only, updating any other fields will result in a Bad Request error.
   */
  isReadonly?: Scalars['Boolean']['input'];
  /** A human-friendly name for the virtual device. */
  label: Scalars['String']['input'];
  /** The UUID of the NOS upgrade group to associate with the virtual devices for grouped firmware upgrades. */
  nosUpgradeGroupUUID: Scalars['UUID']['input'];
  /** [Access Points only] The radio settings to apply to the access point. */
  radioSettings?: InputMaybe<CreateRadioSettingsInput>;
  /** [Switches only] Customize the switch profile for the device. A default hardcoded switch profile is created when the device is created; if not provided, the default will be used with no modifications. */
  switchProfile?: InputMaybe<UpdateSwitchProfileInput>;
  /** [Switches only] The UUID of the switch profile to associate with the switch. */
  switchProfileUUID?: InputMaybe<Scalars['UUID']['input']>;
  /**
   * [Switches only] The switching tier for the virtual device's switch profile.
   * @deprecated Use switchProfile instead
   */
  switchingTier?: InputMaybe<SwitchProfileSwitchingTier>;
  /** Specify VirtualDeviceTags by name. If a tag with this name does not exist in the network, it will be created and attached to the device. If it already exists, it will be attached to the device. */
  tagNames?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreateVirtualDeviceTagInput = {
  /** Name of the virtual device tag to create. */
  name: Scalars['String']['input'];
  /** Unique identifier of the network to create the tag in. */
  networkUUID: Scalars['UUID']['input'];
};

/** Create many virtual devices at once, with the same type and model. */
export type CreateVirtualDevicesInput = {
  /** How many virtual devices to create, up to 100. */
  count: Scalars['Int']['input'];
  /** The model of the virtual devices to create. */
  deviceModel: DeviceModel;
  /** The type of the virtual devices to create. */
  deviceType: VirtualDeviceType;
  /**
   * Mark the virtual device as read-only. As of now this is only supported for PDUs.
   * If the device is marked as read-only, updating any other fields will result in a Bad Request error.
   */
  isReadonly?: Scalars['Boolean']['input'];
  /** The labels of the devices will all start with the prefix, followed by an increasing suffix number (e.g., "AP" -> "AP01", "AP02", "AP03", ...). */
  labelPrefix: Scalars['String']['input'];
  /** The starting number to suffix the labels with, defaults to 1. The numbers will be zero-padded at the front. */
  labelSuffixIndex?: Scalars['Int']['input'];
  /** The UUID of the NOS upgrade group to associate with the virtual devices for grouped firmware upgrades. */
  nosUpgradeGroupUUID: Scalars['UUID']['input'];
  /** [For Switches only] Customize the switch profile for the devices. A default hardcoded switch profile is created when the devices are created; if not provided, the default will be used with no modifications. */
  switchProfile?: InputMaybe<UpdateSwitchProfileInput>;
  /**
   * [For Switches only] Set the device's switch profile's switching tier.
   * @deprecated Use switchProfile instead
   */
  switchingTier?: InputMaybe<SwitchProfileSwitchingTier>;
  /** Specify VirtualDeviceTags by name. If a tag with this name does not exist in the network, it will be created and attached to the devices. If it already exists, it will be attached to the devices. */
  tagNames?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Input type for creating a new Wifi IPSK. */
export type CreateWifiIpskInput = {
  /**
   * An optional array of MAC addresses to restrict a password to some clients (if null, no
   * MAC restriction)
   */
  clientMACs?: InputMaybe<Array<Scalars['MacAddress']['input']>>;
  /** A label for this IPSK */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Password for authentication. */
  password: Scalars['String']['input'];
  /** The UUID of the SSID for which we add an IPSK */
  ssidUUID: Scalars['UUID']['input'];
  /** The VLAN UUID if dynamic VLAN is enabled. */
  vlanUUID?: InputMaybe<Scalars['UUID']['input']>;
};

/** Input type for creating a new Wifi Observer Setting. */
export type CreateWifiObserverSettingInput = {
  /** The UUID of the SSID to use for the observer test. */
  SSIDUUID: Scalars['UUID']['input'];
  /** The radio band on which the test should be run. */
  band: RadioBand;
  /** List of commands to run during the observer test. */
  commands?: InputMaybe<Array<WosObserverCommandInput>>;
  /** Duration of the test in milliseconds. */
  durationMsec: Scalars['Int']['input'];
  /** Number of spatial streams to be used in the test; if unset, uses max number of spatial streams of the Observer */
  numSpatialStreams?: InputMaybe<Scalars['Int']['input']>;
  /** 802.1X password for authentication. */
  password8021X?: InputMaybe<Scalars['String']['input']>;
  /** The UUID of the virtual device (access point) that the observer will target or get results for. */
  targetVirtualDeviceUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** TX power to use for the test; if unset or 0, uses the TX power of the targeted AP. */
  txPowerDbm?: Scalars['Int']['input'];
  /** 802.1X username for authentication. */
  username8021X?: InputMaybe<Scalars['String']['input']>;
  /** The UUID of the virtual device on which to run the observer test. */
  virtualDeviceUUID: Scalars['UUID']['input'];
};

/** Arbitrary DHCP option values to pass to Kea configuration that we do not yet have dedicated fields for. */
export type DhcpOption = {
  __typename?: 'DHCPOption';
  /** The unique identifier of the DHCP option. */
  UUID: Scalars['UUID']['output'];
  /**
   * The DHCP option code (also called tag). Refer to the IANA DHCP options list:
   * https://www.iana.org/assignments/bootp-dhcp-parameters/bootp-dhcp-parameters.xhtml
   */
  code: Scalars['Int']['output'];
  /** The timestamp when this DHCP option was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The data value for the DHCP option. */
  data: Scalars['String']['output'];
  /** If this is a custom (nonstandard) DHCP option, the type of the data. */
  dataType?: Maybe<DhcpOptionDataType>;
  /** An optional description for the DHCP option. */
  description?: Maybe<Scalars['String']['output']>;
  /** The UUID of the DHCP rule this option belongs to. */
  dhcpRuleUUID: Scalars['UUID']['output'];
  /** The timestamp when this DHCP option was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** Data type for custom (nonstandard) DHCP options. */
export enum DhcpOptionDataType {
  /** A hexadecimal-encoded binary value, without a 0x prefix. */
  Binary = 'BINARY',
  /** A plain text string. */
  String = 'STRING',
}

/** A proxied DHCP server that will be used instead of the VLAN's own internal one. */
export type DhcpProxy = {
  __typename?: 'DHCPProxy';
  /** The unique identifier of the DHCP proxy. */
  UUID: Scalars['UUID']['output'];
  /** The VLAN associated with this DHCP proxy. */
  dhcpRule: DhcpRule;
  /** The UUID of the DHCP rule associated with this DHCP proxy. */
  dhcpRuleUUID: Scalars['UUID']['output'];
  /** The IP address of this DHCP proxy. */
  ipAddress: Scalars['IP']['output'];
  /** The uplink physical interface (WAN) that should be used for egress with this proxy. */
  phyInterface?: Maybe<PhyInterface>;
  /** The UUID of the uplink physical interface (WAN) that should be used for egress with this proxy. */
  phyInterfaceUUID?: Maybe<Scalars['UUID']['output']>;
};

/** Sub-ranges within the `DHCPRule` range to reserve for static IP assignment and not issue DHCP leases within. */
export type DhcpReservedRange = {
  __typename?: 'DHCPReservedRange';
  /** The unique identifier of the DHCP reserved range. */
  UUID: Scalars['UUID']['output'];
  /** The timestamp when this DHCP reserved range was created. */
  createdAt: Scalars['DateTime']['output'];
  /** A human-readable description. */
  description?: Maybe<Scalars['String']['output']>;
  /** The UUID of the DHCP rule this reserved range belongs to. */
  dhcpRuleUUID: Scalars['UUID']['output'];
  /** The last reserved IP address in the range, ascending and inclusive. */
  endIPAddress: Scalars['IP']['output'];
  /** The first reserved IP address in the range, ascending and inclusive. */
  startIPAddress: Scalars['IP']['output'];
  /** The timestamp when this DHCP reserved range was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** Stores specific information about a DHCP server for a specific interface, equivalent to a Kea 'subnet'. */
export type DhcpRule = {
  __typename?: 'DHCPRule';
  /** The unique identifier of the DHCP rule. */
  UUID: Scalars['UUID']['output'];
  /** A list of application-level DNS firewall rules applied to this DHCP rule. */
  applicationDNSFirewallRules: Array<ApplicationDnsFirewallRule>;
  /** The timestamp when this DHCP rule was created. */
  createdAt: Scalars['DateTime']['output'];
  /** A list of DHCP proxies on this rule. Omitted if DHCP is being served. */
  dhcpProxies?: Maybe<Array<DhcpProxy>>;
  /** A list of DHCP rule filters on this DHCP rule. */
  dhcpRuleFilters: Array<DhcpRuleFilter>;
  /** Enables or disables DNS caching on the DHCP server. If `false`, DNS caching is disabled regardless of other settings. */
  dnsCacheIsEnabled: Scalars['Boolean']['output'];
  /** Specifies the maximum Time-To-Live (TTL) in seconds for cached DNS entries. */
  dnsCacheMaxTTL: Scalars['Int']['output'];
  /** Specifies the maximum number of DNS records to cache when DNS caching is enabled. */
  dnsCacheSize: Scalars['Int']['output'];
  /** A list of DNS host mappings that override regular DNS lookups for specific domains. */
  dnsHostMappings: Array<DnsHostMapping>;
  /** A list of DNS search domains provided to DHCP clients (e.g., 'local.meter'). */
  dnsSearchDomains?: Maybe<Array<Scalars['String']['output']>>;
  /** List of upstream DNS servers to use when `dnsUseGatewayProxy` is `false`, or to forward queries to when enabled. */
  dnsUpstreamServers: Array<Scalars['IP']['output']>;
  /** Determines if the gateway acts as a DNS proxy for clients. If `true`, DNS queries are sent via the gateway. */
  dnsUseGatewayProxy: Scalars['Boolean']['output'];
  /** The last available IP address in the DHCP range, ascending and inclusive. Omitted if DHCP is not being served. */
  endIPAddress?: Maybe<Scalars['IP']['output']>;
  /** The gateway IP address provided to DHCP clients (commonly known as the router option or DHCP option 3). */
  gatewayIPAddress: Scalars['IP']['output'];
  /** The prefix length of the gateway IP address (e.g., 24 for a subnet mask of 255.255.255.0 in IPv4). */
  gatewayPrefixLength: Scalars['Int']['output'];
  /** If set, the gateway IP address is allowed to be different from its VLAN's address. */
  hasGatewayOverride: Scalars['Boolean']['output'];
  /** Indicates whether this DHCP rule is for IPv6 (`true`) or IPv4 (`false`). */
  isIPv6: Scalars['Boolean']['output'];
  /** The latest observed DHCP rule stats emitted by the active controller for this DHCP rule. */
  latestStats?: Maybe<LatestDhcpRuleStats>;
  /** The duration (in seconds) of the DHCP lease assigned to clients. Omitted if DHCP is not being served. */
  leaseDurationSeconds?: Maybe<Scalars['Int']['output']>;
  /** A list of additional DHCP options to pass to the DHCP server configuration. */
  options: Array<DhcpOption>;
  /** A list of IP ranges within the DHCP range that are reserved and not assigned to clients dynamically. */
  reservedRanges: Array<DhcpReservedRange>;
  /** The first available IP address in the DHCP range, ascending and inclusive. Omitted if DHCP is not being served. */
  startIPAddress?: Maybe<Scalars['IP']['output']>;
  /** A list of static mappings linking specific MAC addresses to fixed IP addresses. */
  staticMappings: Array<DhcpStaticMapping>;
  /** The timestamp when this DHCP rule was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** The VLAN associated with this DHCP rule. */
  vlan: Vlan;
  /** The UUID of the VLAN associated with this DHCP rule. */
  vlanUUID: Scalars['UUID']['output'];
};

/** A filter that allows specific devices to DHCP to a DHCP rule. Only one of allowedMACAddress and allowedOUI will be defined. */
export type DhcpRuleFilter = {
  __typename?: 'DHCPRuleFilter';
  /** The unique identifier of the DHCP rule filter. */
  UUID: Scalars['UUID']['output'];
  /** The MAC address this rule allows. */
  allowedMACAddress?: Maybe<Scalars['MacAddress']['output']>;
  /** The MAC address OUI this rule allows. This is in the format XX:XX:XX */
  allowedOUI?: Maybe<Scalars['String']['output']>;
  /** The timestamp when this DHCP rule filter. */
  createdAt: Scalars['DateTime']['output'];
  /** The UUID of the DHCP rule this DNS rule filter. */
  dhcpRuleUUID: Scalars['UUID']['output'];
};

/** DHCP static mappings between MAC addresses and IP addresses to ensure clients receive predefined IP addresses. */
export type DhcpStaticMapping = {
  __typename?: 'DHCPStaticMapping';
  /** The unique identifier of the DHCP static mapping. */
  UUID: Scalars['UUID']['output'];
  /** The timestamp when this DHCP static mapping was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The UUID of the DHCP rule this static mapping belongs to. */
  dhcpRuleUUID: Scalars['UUID']['output'];
  /** The hostname to assign to the client device. */
  hostname?: Maybe<Scalars['String']['output']>;
  /** Assigned IP address for client device through static DHCP. Application logic will ensure this ip is within the associated `dhcp_rule.gateway_prefix`. */
  ipAddress?: Maybe<Scalars['IP']['output']>;
  /** The MAC address of the client device. */
  macAddress: Scalars['MacAddress']['output'];
  /** A name or label for this static mapping (for organizational purposes). */
  name?: Maybe<Scalars['String']['output']>;
  /** The timestamp when this DHCP static mapping was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** Predefined mappings between a domain and IP address, overriding regular DNS lookups for the given domain. */
export type DnsHostMapping = {
  __typename?: 'DNSHostMapping';
  /** The unique identifier of the DNS host mapping. */
  UUID: Scalars['UUID']['output'];
  /** The timestamp when this DNS host mapping was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The domain to which `overrideDomain` should resolve. If specified, this mapping acts like a 'CNAME' record. */
  destinationDomain?: Maybe<Scalars['String']['output']>;
  /** The IP address to which `overrideDomain` should resolve. If specified, this mapping acts like an 'A' record. */
  destinationIPAddress?: Maybe<Scalars['IP']['output']>;
  /** The UUID of the DHCP rule this DNS host mapping belongs to. */
  dhcpRuleUUID: Scalars['UUID']['output'];
  /** Indicates whether this DNS host mapping is enabled. */
  isEnabled: Scalars['Boolean']['output'];
  /** The domain name to override. This can be a fully qualified domain name (FQDN) or a domain name (e.g., 'example.com'). */
  overrideDomain: Scalars['String']['output'];
  /** The timestamp when this DNS host mapping was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** Result for CRUD ops for managing the default role for users in an organization */
export type DefaultRoleForUsersResponse = {
  __typename?: 'DefaultRoleForUsersResponse';
  /** The slug of the company where the default role is assigned */
  companySlug: Scalars['String']['output'];
  /** The name of the default role for users in the company (ie: company_admin_read_only), may be empty */
  defaultRoleForUsers: RoleName;
};

export type DeleteDeviceHeartbeatInput = {
  /** The unique identifier of the device heartbeat to delete. Either UUID or token must be provided. */
  UUID?: InputMaybe<Scalars['UUID']['input']>;
  /** The authentication token of the device heartbeat to delete. Either token or UUID must be provided. */
  token?: InputMaybe<Scalars['String']['input']>;
};

export type DeletePermittedEmailDomainInput = {
  /** The slug of the company from which the permitted email domain will be deleted. */
  companySlug: Scalars['String']['input'];
  /** The UUID of the permitted email domain to delete. */
  permittedEmailDomainSID: Scalars['UUID']['input'];
};

/** Result of deleting a permitted email domain, indicating the number of rows deleted. */
export type DeletePermittedEmailDomainResult = {
  __typename?: 'DeletePermittedEmailDomainResult';
  /** The number of permitted email domains that were deleted. */
  numRowsDeleted: Scalars['Int']['output'];
};

/** Input type for deleting an existing Wifi Observer Setting. */
export type DeleteWifiObserverSettingInput = {
  /** The UUID of the SSID used in the observer setting. */
  SSIDUUID: Scalars['UUID']['input'];
  /** The radio band of the observer setting to delete. */
  band: RadioBand;
  /** The UUID of the virtual device (access point) that was targeted by the observer. */
  targetVirtualDeviceUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** The UUID of the virtual device from which to delete the observer setting. */
  virtualDeviceUUID: Scalars['UUID']['input'];
};

/** The union of a hardware device and a virtual device. */
export type Device = {
  __typename?: 'Device';
  /** The hardware device component of the device. */
  hardwareDevice: HardwareDevice;
  /** The virtual device component of the device. */
  virtualDevice: VirtualDevice;
};

/** Properties for device boot events. */
export type DeviceBootProperties = {
  __typename?: 'DeviceBootProperties';
  /** The number of times the device has booted. */
  bootCount: Scalars['Int']['output'];
  /** The name of the build that was booted. */
  buildName: Scalars['String']['output'];
  /** The reason for the reboot. */
  rebootReason: Scalars['String']['output'];
  /** The virtual device associated with the device boot event. */
  virtualDevice?: Maybe<VirtualDevice>;
};

/** Represents a rendered configuration for a device. */
export type DeviceConfig = {
  __typename?: 'DeviceConfig';
  /**
   * The timestamp when the device acknowledged this configuration.
   * If null, the device has not acknowledged this version of config.
   */
  acknowledgedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The config data in JSON format. */
  configJSON: Scalars['JSONObject']['output'];
  /** The timestamp when this configuration was created. */
  createdAt: Scalars['DateTime']['output'];
  /** At-most one DeviceConfig for a device is 'current'. The current version is the most recent good version of the config that the device is currently using. This timestamp is the last time the device reported the config as current. */
  isCurrentAsOf?: Maybe<Scalars['DateTime']['output']>;
  /** The state of the validation process for the config version on the device. For performance reasons, we do not return data for this field if requesting data for configs over a > 90 day time window. */
  state?: Maybe<DeviceConfigState>;
  /** The version number of the configuration. */
  version: Scalars['Int']['output'];
};

/** Represents the metadata for rendered configuration for a device, omitting the rendered `configJSON` for performance reasons when fetching many at once. A subset of `DeviceConfig`. */
export type DeviceConfigMetadata = {
  __typename?: 'DeviceConfigMetadata';
  /**
   * The timestamp when the device acknowledged this configuration.
   * If null, the device has not acknowledged this version of config.
   */
  acknowledgedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The timestamp when this configuration was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The hardware device associated with the configuration */
  hardwareDevice: HardwareDevice;
  /** At-most one DeviceConfig for a device is 'current'. The current version is the most recent good version of the config that the device is currently using. This timestamp is the last time the device reported the config as current. */
  isCurrentAsOf?: Maybe<Scalars['DateTime']['output']>;
  /** The serial number of the device associated with the configuration. */
  serialNumber: Scalars['String']['output'];
  /** The state of the validation process for the config version on the device. For performance reasons, we do not return data for this field if requesting data for configs over a > 90 day time window. */
  state?: Maybe<DeviceConfigState>;
  /** The version number of the configuration. */
  version: Scalars['Int']['output'];
};

/** Represents an override configuration for a device. */
export type DeviceConfigOverride = {
  __typename?: 'DeviceConfigOverride';
  /** The overridden configuration data in JSON format. */
  configJSON: Scalars['JSONObject']['output'];
};

/** The state of the configuration for a DeviceConfig, as reported by the device. */
export type DeviceConfigState = {
  __typename?: 'DeviceConfigState';
  /** The state of the configuration for the device. */
  state: DeviceConfigStateType;
  /** The timestamp when the state was sent from the device. */
  timestamp: Scalars['DateTime']['output'];
};

export enum DeviceConfigStateType {
  /** The device has finished its connectivity evaluation and determined the configuration to be bad. The device will roll back to the most recent `GOOD` version of the config. */
  Failed = 'FAILED',
  /** The device has finished its connectivity evaluation and determined the configuration to be good. */
  Good = 'GOOD',
  /** The device has received the configuration, but has not yet finished a connectivity evaluation to know if it's good or failed. This validation process typically takes 15 minutes. If a new config version is received before the validation is complete, this version can be stuck in this state indefinitely. */
  Received = 'RECEIVED',
  /** Uncategorized state. */
  Unknown = 'UNKNOWN',
}

/** A device heartbeat is a deadmanssnitch configuration for a device. The device periodically sends heartbeats to the heartbeat URL. */
export type DeviceHeartbeat = {
  __typename?: 'DeviceHeartbeat';
  /** The unique identifier of the device heartbeat. */
  UUID: Scalars['UUID']['output'];
  /** The interval, in seconds, at which the device is expected to send heartbeats. */
  heartbeatIntervalSeconds: Scalars['Int']['output'];
  /** The URL where the device should send its heartbeat signals. */
  heartbeatURL: Scalars['String']['output'];
  /** The serial number of the device associated with the heartbeat. */
  serialNumber: Scalars['String']['output'];
  /** The authentication token required to validate the heartbeat. */
  token: Scalars['String']['output'];
};

/** DeviceModel enumerates the different model names of devices that Meter deploys. */
export enum DeviceModel {
  A1 = 'A1',
  A2 = 'A2',
  F1 = 'F1',
  F2 = 'F2',
  F3 = 'F3',
  G1 = 'G1',
  Mc01 = 'MC01',
  Mc05 = 'MC05',
  Mc06 = 'MC06',
  Mc11 = 'MC11',
  Mp01 = 'MP01',
  Ms07 = 'MS07',
  Ms10 = 'MS10',
  Ms11 = 'MS11',
  Ms12 = 'MS12',
  Mw02 = 'MW02',
  Mw03 = 'MW03',
  Mw04 = 'MW04',
  Mw05 = 'MW05',
  Mw06 = 'MW06',
  Mw07 = 'MW07',
  Mw08 = 'MW08',
  Mw09 = 'MW09',
  P1 = 'P1',
  Psgs1518Af = 'PSGS1518AF',
  Psgs1526F = 'PSGS1526F',
  Psgs1626Gf = 'PSGS1626GF',
  Psgs2326Kf = 'PSGS2326KF',
  Psgs2852Bf = 'PSGS2852BF',
  Psgs2852Xbf = 'PSGS2852XBF',
  Psgs2852Xbl = 'PSGS2852XBL',
  S1 = 'S1',
  S2 = 'S2',
  S3 = 'S3',
}

/** Properties for device offline events. */
export type DeviceOfflineProperties = {
  __typename?: 'DeviceOfflineProperties';
  /** The time the device was last seen online. */
  lastSeen: Scalars['DateTime']['output'];
  /** The virtual device associated with the device offline event. */
  virtualDevice?: Maybe<VirtualDevice>;
};

/** Properties for device online events. */
export type DeviceOnlineProperties = {
  __typename?: 'DeviceOnlineProperties';
  /** The time the device was first seen online. */
  firstSeen: Scalars['DateTime']['output'];
  /** The virtual device associated with the device online event. */
  virtualDevice?: Maybe<VirtualDevice>;
};

/** An enumeration of radios on a device. */
export enum DeviceRadio {
  /** Represents the 2.4 GHz radio. */
  Radio_2_4G = 'RADIO_2_4G',
  /** Represents the 5 GHz radio. */
  Radio_5G = 'RADIO_5G',
  /** Represents the 6 GHz radio. */
  Radio_6G = 'RADIO_6G',
  /** Represents the scanning radio. */
  RadioScanning = 'RADIO_SCANNING',
}

/** DeviceType enumerates the different types of hardware devices that Meter deploys. */
export enum DeviceType {
  /** Represents an Access Point device type. */
  AccessPoint = 'ACCESS_POINT',
  /** Represents a Controller device type. */
  Controller = 'CONTROLLER',
  /** Represents a Power Distribution Unit device type. */
  PowerDistributionUnit = 'POWER_DISTRIBUTION_UNIT',
  /** Represents a Switch device type. */
  Switch = 'SWITCH',
}

/** Filter criteria for devices in a network. */
export type DevicesForNetworkFilter = {
  /** Filter devices by virtual device type. */
  deviceType?: InputMaybe<VirtualDeviceType>;
};

/** Represents a service that has been discovered on the network, advertising via mDNS (multicast DNS), such as printers, AirPlay devices, speakers, etc. */
export type DiscoveredService = {
  __typename?: 'DiscoveredService';
  /** IP address of the discovered service. */
  ipAddress: Scalars['IP']['output'];
  /** MAC address of the device hosting the service. */
  macAddress: Scalars['MacAddress']['output'];
  /** Name assigned to the discovered service, typically provided by the device itself. */
  name: Scalars['String']['output'];
  /** Unique identifier of the network where the service was discovered. */
  networkUUID: Scalars['UUID']['output'];
  /** Type of the discovered service, indicating its functionality (e.g., AIRPLAY, PRINTER, SPEAKER). */
  serviceType: ServiceType;
  /** Timestamp indicating when the service was last detected or reported. */
  timestamp: Scalars['DateTime']['output'];
};

/** Input parameters for querying discovered services. */
export type DiscoveredServicesInput = {
  /**
   * Number of minutes to look back when querying for available services.
   * Specifies how far back in time the query should search for services that were discovered.
   * Must be between 1 and 180 minutes.
   */
  numMinutesLookback: Scalars['Int']['input'];
  /** List of service types to filter for in the query. Only services of these types will be returned. */
  serviceTypes: Array<ServiceType>;
};

/** Properties for an informative badge to display. */
export type DisplayBadge = {
  __typename?: 'DisplayBadge';
  /** A slug for the icon to display inside the badge. */
  icon?: Maybe<Scalars['String']['output']>;
  /** Text to display inside the badge. */
  text?: Maybe<Scalars['String']['output']>;
};

export type DisplayBadgeInput = {
  /** A slug for the icon to display inside the badge. */
  icon?: InputMaybe<Scalars['String']['input']>;
  /** Text to display inside the badge. */
  text?: InputMaybe<Scalars['String']['input']>;
};

/** Input type for generating a pre-signed URL for file download. */
export type DownloadUrlInput = {
  /**
   * The S3 key (path and filename) of the file to be downloaded.
   * Example: 'access_point_photos/20231010_abcd1234.jpg'
   */
  s3Key: Scalars['String']['input'];
};

/** Represents the 802.1X encryption configuration for an SSID. */
export type Encryption8021X = {
  __typename?: 'Encryption8021X';
  /** The unique identifier of this 802.1X encryption configuration. */
  UUID: Scalars['UUID']['output'];
  /** The IP address of the accounting server. */
  accountingServerIPAddress?: Maybe<Scalars['IP']['output']>;
  /** The port of the accounting server. */
  accountingServerPort?: Maybe<Scalars['Int']['output']>;
  /** The shared secret used to authenticate with the accounting server. */
  accountingServerSecret?: Maybe<Scalars['String']['output']>;
  /** The IP address of the authentication server. */
  authServerIPAddress: Scalars['IP']['output'];
  /** The port of the authentication server. */
  authServerPort: Scalars['Int']['output'];
  /** The shared secret used to authenticate with the authentication server. */
  authServerSecret: Scalars['String']['output'];
  /** A user-friendly label for the encryption configuration. */
  label: Scalars['String']['output'];
  /** The UUID of the network to which this encryption configuration belongs. */
  networkUUID: Scalars['UUID']['output'];
  /** The SSIDs associated with this 802.1X encryption configuration. */
  ssids?: Maybe<Array<Ssid>>;
};

/** An event in the event log. */
export type EventLogEvent = {
  __typename?: 'EventLogEvent';
  /** The type of event. */
  eventType: EventType;
  /** The API name representation of the event type. */
  eventTypeAPIName: Scalars['String']['output'];
  /** The timestamp when the event was generated. */
  generatedAt: Scalars['DateTime']['output'];
  /** The timestamp when the event was inserted into the database. */
  insertedAt: Scalars['DateTime']['output'];
  /** The UUID of the network where the event occurred. */
  networkUUID: Scalars['UUID']['output'];
  /** The properties associated with the event. */
  properties: EventLogProperties;
};

/** A paged response for event log queries. */
export type EventLogEventsPage = {
  __typename?: 'EventLogEventsPage';
  /** A subset of records based on the limit and offset fields */
  events: Array<EventLogEvent>;
  /** The total number of records */
  total: Scalars['Int']['output'];
};

/** Properties associated with an event log event. */
export type EventLogProperties =
  | AccessPointConnectionProperties
  | AccessPointDfsChannelResetProperties
  | AccessPointRadarHitDetectedProperties
  | DeviceBootProperties
  | DeviceOfflineProperties
  | DeviceOnlineProperties
  | FirmwareUpgradeCompletedProperties
  | FirmwareUpgradePendingProperties
  | FirmwareUpgradeScheduledProperties
  | HighAvailabilityFailoverProperties
  | HighAvailabilityMultipleActiveProperties
  | HighAvailabilityRecoveryProperties
  | IpSecTunnelStatusChangeProperties
  | PduOutletProperties
  | WanDownProperties
  | WanStatusChangeProperties
  | WanUpProperties;

/** Enumerate the known event types that exist in the event log. */
export enum EventType {
  /** Event indicating a wireless connection event on an access point. */
  AccessPointConnection = 'ACCESS_POINT_CONNECTION',
  /** Event indicating that a DFS channel reset occurred on an access point. */
  AccessPointDfsChannelReset = 'ACCESS_POINT_DFS_CHANNEL_RESET',
  /** Event indicating that a DFS radar hit was detected by an access point. */
  AccessPointRadarHitDetected = 'ACCESS_POINT_RADAR_HIT_DETECTED',
  /** Event indicating that a High Availability failover event occurred. */
  CosHaFailover = 'COS_HA_FAILOVER',
  /** Event indicating that multiple Security Appliances are active in a High Availability setup. */
  CosHaMultipleActive = 'COS_HA_MULTIPLE_ACTIVE',
  /** Event indicating that a High Availability recovery event occurred. */
  CosHaRecovery = 'COS_HA_RECOVERY',
  /** Event indicating that a device booted with a specific version of the firmware. */
  DeviceBoot = 'DEVICE_BOOT',
  /** Event indicating that a device has gone offline. */
  DeviceOffline = 'DEVICE_OFFLINE',
  /** Event indicating that a device has come online. */
  DeviceOnline = 'DEVICE_ONLINE',
  /** Event indicating that a firmware upgrade is completed on a network. */
  FirmwareUpgradeCompleted = 'FIRMWARE_UPGRADE_COMPLETED',
  /**
   * Event indicating that a firmware upgrade is pending on a network.
   * An upgrade has been applied to the respective device configs and should immediately take affect, given
   * that these devices are online.
   */
  FirmwareUpgradePending = 'FIRMWARE_UPGRADE_PENDING',
  /**
   * Event indicating that a firmware upgrade is scheduled on a network.
   * An upgrade is scheduled for sometime in the future when and no device config change
   * has been made, but will at the scheduled time.
   */
  FirmwareUpgradeScheduled = 'FIRMWARE_UPGRADE_SCHEDULED',
  /** Event indicating that an IPSec tunnel had a status change. */
  IpsecTunnelStatusChange = 'IPSEC_TUNNEL_STATUS_CHANGE',
  /** Event indicating that a PDU outlet event occurred. */
  PduOutletStatusChanged = 'PDU_OUTLET_STATUS_CHANGED',
  /** The event type is unspecified. */
  Unspecified = 'UNSPECIFIED',
  /** Event indicating that the WAN connection is down. */
  WanDown = 'WAN_DOWN',
  /** Event indicating a change in WAN status. */
  WanStatusChange = 'WAN_STATUS_CHANGE',
  /** Event indicating that the WAN connection is up. */
  WanUp = 'WAN_UP',
}

/** Payload containing the pre-signed URL for file download. */
export type FileDownloadPayload = {
  __typename?: 'FileDownloadPayload';
  /** The pre-signed URL for downloading the file from S3. */
  presignedUrl: Scalars['String']['output'];
};

/** Payload containing the pre-signed URL for file upload. */
export type FileUploadPayload = {
  __typename?: 'FileUploadPayload';
  /**
   * The key (path and filename) for the file in S3.
   * Format: <folder>/<timestamp>_<uuid>.<extension>
   */
  key: Scalars['String']['output'];
  /** The pre-signed URL for uploading the file to S3. */
  presignedUrl: Scalars['String']['output'];
};

/** Represents a binding of a firewall rule to a physical interface with a metric. */
export type FirewallPhyInterfaceBinding = {
  __typename?: 'FirewallPhyInterfaceBinding';
  /**
   * The metric associated with the binding.
   * @deprecated Refer to `FirewallRule.priority` instead.
   */
  metric?: Maybe<Scalars['Int']['output']>;
  /** The physical interface to which the firewall rule is bound. */
  phyInterface: PhyInterface;
};

/** Represents a firewall rule in the network configuration. */
export type FirewallRule = {
  __typename?: 'FirewallRule';
  /** Unique identifier for the firewall rule. */
  UUID: Scalars['UUID']['output'];
  /** The action to take when the firewall rule matches (e.g., DENY or PERMIT). */
  action: FirewallRuleAction;
  /** The date and time when the firewall rule was created. */
  createdAt: Scalars['DateTime']['output'];
  /** A description of the firewall rule. */
  description?: Maybe<Scalars['String']['output']>;
  /** Destination client VPN server to match traffic to. */
  dstClientVPNServer?: Maybe<ClientVpnServer>;
  /** Destination IPSec tunnel to match traffic to. */
  dstIPSecTunnel?: Maybe<IpSecTunnel>;
  /**
   * Deprecated. Use `dstPortRanges` instead. Single destination port range to match.
   * @deprecated Use `dstPortRanges` instead.
   */
  dstPortRange: PortRange;
  /** List of destination port ranges to match traffic to. */
  dstPortRanges: Array<PortRange>;
  /** Destination IP prefix to match traffic to. */
  dstPrefix?: Maybe<Scalars['IPPrefix']['output']>;
  /** Destination VLAN to match traffic to. */
  dstVLAN?: Maybe<Vlan>;
  /** IDS event associated with this rule. */
  idsEvent?: Maybe<IdsEvent>;
  /**
   * If a firewall rule is bidirectional then the config renderer will generate an additional rule(s)
   * where the src and dst options are swapped.
   * @deprecated Bidirectional rules are now implicit, enabled if the rule is between two VLANs.
   */
  isBidirectional?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates if the firewall rule is currently enabled. */
  isEnabled: Scalars['Boolean']['output'];
  /** Indicates if the firewall rule is internal to Meter. */
  isMeterInternal: Scalars['Boolean']['output'];
  /** The name of the firewall rule. */
  name: Scalars['String']['output'];
  /** Unique identifier of the network to which the firewall rule belongs. */
  networkUUID: Scalars['UUID']['output'];
  /** List of physical interface bindings for the firewall rule. */
  phyInterfaceBindings?: Maybe<Array<FirewallPhyInterfaceBinding>>;
  /** Priority of the rule within the network, lower priority rules are applied first. */
  priority: Scalars['Int']['output'];
  /**
   * Deprecated. Use `protocols` instead. Single IP protocol to match.
   * @deprecated Use `protocols` instead.
   */
  protocol: IpProtocol;
  /** List of IP protocols to match. */
  protocols: Array<IpProtocol>;
  /** Source client VPN server to match traffic from. */
  srcClientVPNServer?: Maybe<ClientVpnServer>;
  /** Source IPSec tunnel to match traffic from. */
  srcIPSecTunnel?: Maybe<IpSecTunnel>;
  /**
   * Deprecated. Use `srcPortRanges` instead. Single source port range to match.
   * @deprecated Use `srcPortRanges` instead.
   */
  srcPortRange: PortRange;
  /** List of source port ranges to match traffic from. */
  srcPortRanges: Array<PortRange>;
  /** Source IP prefix to match traffic from. */
  srcPrefix?: Maybe<Scalars['IPPrefix']['output']>;
  /** Source VLAN to match traffic from. */
  srcVLAN?: Maybe<Vlan>;
  /** List of tags associated with the firewall rule. */
  tags?: Maybe<Array<Scalars['String']['output']>>;
  /** The date and time when the firewall rule was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** List of VLAN bindings for the firewall rule. */
  vlanBindings?: Maybe<Array<FirewallVlanBinding>>;
};

/** Possible actions for a firewall rule. */
export enum FirewallRuleAction {
  /** Deny the traffic. */
  Deny = 'DENY',
  /** Permit the traffic. */
  Permit = 'PERMIT',
}

/** Response type containing firewall rule timeseries data over a specified time range. */
export type FirewallRuleMetricsTimeseriesResponse = {
  __typename?: 'FirewallRuleMetricsTimeseriesResponse';
  /** The firewall rule for this series. */
  firewallRule: FirewallRule;
  /** Packets blocked per bucket. */
  packets: BaseMetricsResponse;
  /** The total packets blocked in the lookback. */
  totalPackets: Scalars['Int']['output'];
};

/** Represents a binding of a firewall rule to a VLAN with a metric. */
export type FirewallVlanBinding = {
  __typename?: 'FirewallVLANBinding';
  /**
   * The metric associated with the binding.
   * @deprecated Refer to `FirewallRule.priority` instead.
   */
  metric?: Maybe<Scalars['Int']['output']>;
  /** The VLAN to which the firewall rule is bound. */
  vlan: Vlan;
};

/** Properties for firmware upgrade completed events. */
export type FirmwareUpgradeCompletedProperties = {
  __typename?: 'FirmwareUpgradeCompletedProperties';
  /** The time the upgrade completed. */
  completedAt: Scalars['DateTime']['output'];
  /** The virtual devices that unsuccessfully upgraded to nosVersion. */
  failedVirtualDevices?: Maybe<Array<Maybe<VirtualDevice>>>;
  /** The NOS version pending for the upgrade. */
  nosVersion: NosVersion;
  /** The status of the upgrade. */
  status: FirmwareUpgradeCompletedStatus;
  /** The virtual devices that successfully upgraded to nosVersion. */
  successfulVirtualDevices?: Maybe<Array<Maybe<VirtualDevice>>>;
};

/** Specifies the status of a firmware upgrade completed event. */
export enum FirmwareUpgradeCompletedStatus {
  /** The upgrade failed. */
  Failure = 'FAILURE',
  /** The upgrade was successful. */
  Success = 'SUCCESS',
  /** Status is unknown. */
  Unspecified = 'UNSPECIFIED',
}

/** Properties for firmware upgrade pending events. */
export type FirmwareUpgradePendingProperties = {
  __typename?: 'FirmwareUpgradePendingProperties';
  /** If this was a force upgrade. */
  force: Scalars['Boolean']['output'];
  /** The NOS version pending for the upgrade. */
  nosVersion: NosVersion;
  /** The virtual devices that have a pending upgrade. */
  virtualDevices?: Maybe<Array<Maybe<VirtualDevice>>>;
};

/** Properties for firmware upgrade scheduled events. */
export type FirmwareUpgradeScheduledProperties = {
  __typename?: 'FirmwareUpgradeScheduledProperties';
  /** The NOS version scheduled for the upgrade. */
  nosVersion: NosVersion;
  /** The time the firmware upgrade is scheduled. */
  scheduledAt: Scalars['DateTime']['output'];
  /** The virtual devices scheduled for an upgrade. */
  virtualDevices?: Maybe<Array<Maybe<VirtualDevice>>>;
};

/** A fleetwide notification setting is a pre-defined set of notification settings that can be applied to many networks. */
export type FleetwideNotificationSetting = {
  __typename?: 'FleetwideNotificationSetting';
  /** The unique identifier of the default notification setting. */
  UUID: Scalars['UUID']['output'];
  /** The name of the alert definition that defines the type of alert. */
  alertDefinitionName: Scalars['String']['output'];
  /** The alert receiver who will receive the notifications generated by this setting. */
  alertReceiver: AlertReceiver;
  /** A list of arguments providing specific parameters or context related to the notification definition. */
  arguments: Array<NotificationSettingArgument>;
  /** The company for which this notification setting is configured to filter by. If null, the setting will apply to all networks. */
  company?: Maybe<Company>;
  /** Number of networks this setting is applied to. */
  countAppliedNetworks: Scalars['Int']['output'];
  /** The time at which the notification setting was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The ID of the user who created this notification setting. */
  createdBy?: Maybe<User>;
  /** If provided, enables the notification setting for the specified company support tiers, otherwise it is enabled for all company support tiers. */
  enabledCustomerSupportTiers?: Maybe<Array<CompanySupportTier>>;
  /** Whether the notification setting is enabled for inactive networks. */
  enabledForInactiveNetworks: Scalars['Boolean']['output'];
  /** Whether the notification setting is enabled for internal networks. */
  enabledForInternalNetworks: Scalars['Boolean']['output'];
  /** If provided, enables the notification setting for the specified NOS upgrade channels, otherwise it is enabled for all NOS upgrade channels. */
  enabledNOSUpgradeChannels?: Maybe<Array<NetworkNosUpgradeChannel>>;
  /** The label of the fleetwide notification setting. */
  label: Scalars['String']['output'];
  /** Name of the alert definition to use for this fleetwide notification setting. */
  notificationDefinitionName: Scalars['String']['output'];
  /** The time at which the notification setting was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

export type FleetwideNotificationSettingFiltersInput = {
  /** The name of the alert definition to retrieve the default notification settings for. */
  alertName?: InputMaybe<Scalars['String']['input']>;
  /** The UUID to use for limiting the scope of the notification setting. */
  companyUUID?: InputMaybe<Scalars['UUID']['input']>;
};

/** Information about a snooze on a fleetwide notification setting. */
export type FleetwideNotificationSnooze = {
  __typename?: 'FleetwideNotificationSnooze';
  /** The UUID of the snooze. */
  UUID: Scalars['UUID']['output'];
  /** The associated company. */
  company?: Maybe<Company>;
  /** The timestamp when the snooze was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The timestamp when the snooze was deleted. */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The associated fleetwide notification setting. */
  fleetwideNotificationSetting?: Maybe<FleetwideNotificationSetting>;
  /** The associated network. */
  network?: Maybe<Network>;
  /** The timestamp when the snooze ends. */
  snoozeEnd: Scalars['DateTime']['output'];
  /** The reason for the snooze. */
  snoozeReason?: Maybe<Scalars['String']['output']>;
  /** The timestamp when the snooze begins. */
  snoozeStart: Scalars['DateTime']['output'];
  /** The timestamp when the snooze was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/**
 * A floor plan is an overhead view of a physical space. A floor plan is one-to-many to floor plan locations,
 * which are x/y coordinates for Meter devices in the physical space.
 */
export type FloorPlan = {
  __typename?: 'FloorPlan';
  /** The unique identifier of the floor plan. */
  UUID: Scalars['UUID']['output'];
  /** The timestamp when the floor plan was created. */
  createdAt: Scalars['DateTime']['output'];
  /** A description of the floor plan. */
  description?: Maybe<Scalars['String']['output']>;
  /** A pre-signed URL to download the floor plan image. */
  imageDownloadURL: Scalars['String']['output'];
  /** The S3 key (path) of the image file representing the floor plan, stored in Amazon S3. */
  imageS3Key: Scalars['String']['output'];
  /** A human-readable name or label for the floor plan. */
  label: Scalars['String']['output'];
  /** The unique identifier of the network that this floor plan belongs to. */
  networkUUID: Scalars['UUID']['output'];
  /** The timestamp when the floor plan was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

export type GetCaptivePortalInput = {
  /** This field does not do anything; this is a placeholder for future use and will be deprecated once this input is actually used. */
  TODO?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Additional options that can be used to customize the results of a query for company users. */
export type GetCompanyUserInput = {
  /** If true, include company users that have been deleted. */
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Input parameters to retrieve notification preferences for a company and controller. */
export type GetNotificationPreferencesInput = {
  /** The slug (unique identifier) of the company. */
  companySlug: Scalars['String']['input'];
  /** The name of the controller. */
  controllerName: Scalars['String']['input'];
};

/** A hardware device represents a physical device. */
export type HardwareDevice = {
  /** Shows the most recent boot history of a device. */
  bootHistory: Array<BootInfo>;
  /** The timestamp when the hardware device was first created. */
  createdAt: Scalars['DateTime']['output'];
  /** The model name of the hardware device. */
  deviceModel: DeviceModel;
  /** The type of the hardware device. */
  deviceType: DeviceType;
  /** If the device is no longer connected to the backend, this is the time at which it was last connected. */
  disconnectedFromBackendAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * True if the device has an active websocket connection to the backend. Note that this only works if the device has registered via the /v2/register endpoint (i.e., is a Config 2 device) - otherwise is always false.
   * @deprecated Refer to `isSpare` instead.
   */
  isActive: Scalars['Boolean']['output'];
  /** Indicates whether the hardware device is connected to the backend. */
  isConnectedToBackend: Scalars['Boolean']['output'];
  /** Indicates whether the hardware device's console port is enabled. */
  isConsoleEnabled: Scalars['Boolean']['output'];
  /** Indicates whether the hardware device is marked as a development (dev) device, moving it into the dev (staging) realm for testing purposes. */
  isDev: Scalars['Boolean']['output'];
  /** Indicates whether the hardware device is in factory mode. */
  isFactoryMode: Scalars['Boolean']['output'];
  /** Indicates whether the hardware device is an RMA (Return Merchandise Authorization) replacement device. */
  isRMA: Scalars['Boolean']['output'];
  /** Indicates whether the hardware device has been retired. */
  isRetired: Scalars['Boolean']['output'];
  /** A spare hardware device belongs to a network but not a virtual device. Used most often to keep track of spare hardware we ship to a customer but don't install immediately. */
  isSpare: Scalars['Boolean']['output'];
  /** The latest device config metadata (ie. the config without the actual JSON payload) for the device. */
  latestDeviceConfigMetadata?: Maybe<DeviceConfigMetadata>;
  /** The MAC address of the hardware device. */
  macAddress?: Maybe<Scalars['MacAddress']['output']>;
  /** The UUID of the network that the spare hardware device belongs to. Spare hardware devices that are not affiliated with a virtual device will have this field populated. */
  networkUUID?: Maybe<Scalars['UUID']['output']>;
  /** The public key used to add the device to the jumphost's WireGuard interface. */
  publicKey?: Maybe<Scalars['String']['output']>;
  /** The unique serial number of the hardware device. */
  serialNumber: Scalars['String']['output'];
  /** The network that the spare hardware device belongs to. Spare hardware devices that are not affiliated with a virtual device will have this field populated. */
  spareDeviceNetwork?: Maybe<Network>;
  /** IPv6 address on the jumphost subnet. Used to send requests to the device. */
  tunnelIPAddress?: Maybe<Scalars['String']['output']>;
  /** The timestamp when the hardware device was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /**
   * The uptime of the hardware device, retrieved from the time series database.
   * @deprecated Use `VirtualDevice.uptime` instead.
   */
  uptime?: Maybe<Scalars['Duration']['output']>;
  /** The virtual device associated with this hardware device, if any. */
  virtualDevice?: Maybe<VirtualDevice>;
  /** The UUID of the virtual device this hardware device is assigned to, if any. */
  virtualDeviceUUID?: Maybe<Scalars['UUID']['output']>;
};

/** A hardware device represents a physical device. */
export type HardwareDeviceBootHistoryArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
};

/** Filters the response when fetching multiple hardware devices. */
export type HardwareDevicesFilter = {
  /** Filter hardware devices by device model. */
  deviceModel?: InputMaybe<DeviceModel>;
  /** Filter hardware devices by device type. */
  deviceType?: InputMaybe<DeviceType>;
  /** The maximum number of hardware devices to return. Default is 200. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** The offset from where to start returning hardware devices. */
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** Specifies the role of the high availability security appliance. */
export enum HighAvailabilityControllerRole {
  /** The security appliance is configured as backup. */
  Backup = 'BACKUP',
  /** The security appliance is configured as primary. */
  Primary = 'PRIMARY',
}

/** Information about a virtual device in a high availability security appliance setup. */
export type HighAvailabilityControllerVirtualDeviceInfo = {
  __typename?: 'HighAvailabilityControllerVirtualDeviceInfo';
  /** Configuration associated with the HA configuration of this virtual device. */
  config: HighAvailabilityControllersConfig;
  /**
   * The role this device is configured to serve as.
   * This does not indicate whether the device is currently serving traffic.
   */
  role: HighAvailabilityControllerRole;
  /** The status of the HA device, reported by the device. */
  status: HighAvailabilityStatus;
};

/** Configuration of the high availability security appliances. */
export type HighAvailabilityControllersConfig = {
  __typename?: 'HighAvailabilityControllersConfig';
  /** Unique identifier of the high availability configuration. */
  UUID: Scalars['UUID']['output'];
  /** Interval at which the security appliances advertise to one another, in milliseconds. */
  advertisementIntervalMs: Scalars['Int']['output'];
  /**
   * Port the security appliances use to communicate over.
   * This is currently _required_ to be the same port on both security appliances.
   */
  advertisementPort: Scalars['Int']['output'];
  /** VLAN whose sole purpose is for the HA security appliances to communicate with each other. */
  advertisementVLAN: Vlan;
  /** PhyInterface for the security appliance configured as backup in the HA setup. */
  backupPhyInterface: PhyInterface;
  /** The current status of the backup security appliance in the HA pair. */
  backupStatus: HighAvailabilityStatus;
  /** Virtual device UUID of the backup security appliance in the HA setup. */
  backupVirtualDeviceUUID: Scalars['UUID']['output'];
  /** Network that is configured with HA security appliances. */
  network: Network;
  /** Whether or not VRRP is configured for preemption between the security appliances in the HA pair. */
  preemption: Scalars['Boolean']['output'];
  /** PhyInterface for the security appliance configured as primary in the HA setup. */
  primaryPhyInterface: PhyInterface;
  /** The current status of the primary security appliance in the HA pair. */
  primaryStatus: HighAvailabilityStatus;
  /** Virtual device UUID of the primary security appliance in the HA setup. */
  primaryVirtualDeviceUUID: Scalars['UUID']['output'];
};

/** Properties for high availability failover events. */
export type HighAvailabilityFailoverProperties = {
  __typename?: 'HighAvailabilityFailoverProperties';
  /** The backup virtual device in the SA pair. */
  backupVirtualDevice?: Maybe<VirtualDevice>;
  /** The primary virtual device in the SA pair. */
  primaryVirtualDevice?: Maybe<VirtualDevice>;
  /**
   * The virtual device associated with the high availability failover event.
   * @deprecated Use `primaryVirtualDevice` and `backupVirtualDevice` instead.
   */
  virtualDevice?: Maybe<VirtualDevice>;
};

/** Properties for high availability multiple active events. */
export type HighAvailabilityMultipleActiveProperties = {
  __typename?: 'HighAvailabilityMultipleActiveProperties';
  /** The backup virtual device in the SA pair. */
  backupVirtualDevice?: Maybe<VirtualDevice>;
  /** The primary virtual device in the SA pair. */
  primaryVirtualDevice?: Maybe<VirtualDevice>;
};

/** Properties for high availability recovery events. */
export type HighAvailabilityRecoveryProperties = {
  __typename?: 'HighAvailabilityRecoveryProperties';
  /** The backup virtual device in the SA pair. */
  backupVirtualDevice?: Maybe<VirtualDevice>;
  /** The primary virtual device in the SA pair. */
  primaryVirtualDevice?: Maybe<VirtualDevice>;
};

/** Possible status values for high availability security appliances. */
export enum HighAvailabilityStatus {
  /** The security appliance is currently active and serving traffic. */
  Active = 'ACTIVE',
  /** The security appliance is ready but not currently serving traffic. */
  Ready = 'READY',
  /** The status is unspecified. */
  Unspecified = 'UNSPECIFIED',
}

/** A honeypot broadcaster is the actual device that is observed broadcasting the SSID. */
export type HoneypotBroadcaster = {
  __typename?: 'HoneypotBroadcaster';
  /** The BSSID of the honeypot. */
  bssid: Scalars['MacAddress']['output'];
  /** The devices that were able to observe the honeypot. */
  observers: Array<NetworkThreatObserver>;
};

/** A honeypot is an SSID that is being broadcasted which matches the name of a known SSID. */
export type HoneypotSsid = {
  __typename?: 'HoneypotSSID';
  /** The devices that are broadcasting the SSID. */
  broadcasters: Array<HoneypotBroadcaster>;
  /** The network that the honeypot was observed on. */
  networkUUID: Scalars['UUID']['output'];
  /** The SSID of the honeypot. */
  ssid: Scalars['String']['output'];
};

/** Represents the response containing metadata and host monitoring values. */
export type HostMonitoringResponse = MetricsResponse & {
  __typename?: 'HostMonitoringResponse';
  /** Metadata about the metrics, such as aggregation intervals. */
  metadata: MetricsMetadata;
  /** A list of host monitoring data points. */
  values: Array<HostMonitoringValue>;
};

/** Represents the status of host monitoring. */
export enum HostMonitoringStatus {
  /** The host monitoring failed. */
  Failed = 'FAILED',
  /** The host is reachable and responding. */
  Ok = 'OK',
  /** The host monitoring request timed out. */
  Timeout = 'TIMEOUT',
}

/** Host monitoring targets are used to specify hosts for which to monitor availability/reachability on a network. */
export type HostMonitoringTarget = {
  __typename?: 'HostMonitoringTarget';
  /** The unique identifier of the host monitoring target. */
  UUID: Scalars['UUID']['output'];
  /** The timestamp when the host monitoring target was created. */
  createdAt: Scalars['DateTime']['output'];
  /** A descriptive text about the host monitoring target. */
  description?: Maybe<Scalars['String']['output']>;
  /** Indicates whether the host monitoring target is enabled. */
  isEnabled: Scalars['Boolean']['output'];
  /** Whether this target is used to compute whether a WAN should failover. Only available if `type` is `PING`. */
  isUsedForWANFailover: Scalars['Boolean']['output'];
  /** The UUID of the network to which this host monitoring target belongs. */
  networkUUID: Scalars['UUID']['output'];
  /**
   * The target host to monitor.
   *
   * Currently, only IPv4 addresses are permitted, but FQDNs (Fully Qualified Domain Names) will be supported in the future.
   */
  targetHost: Scalars['IPV4']['output'];
  /** The type of monitoring to perform on the target host. */
  type: HostMonitoringType;
  /** The timestamp when the host monitoring target was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** Defines the types of host monitoring available. */
export enum HostMonitoringType {
  /** Perform ICMP ping monitoring. */
  Ping = 'PING',
  /** Perform traceroute monitoring. */
  Traceroute = 'TRACEROUTE',
}

/** Represents a single host monitoring data point. */
export type HostMonitoringValue = MetricsValue & {
  __typename?: 'HostMonitoringValue';
  /** Count of entries where status was FAILED. */
  countFailed: Scalars['Int']['output'];
  /** Count of entries where status was OK. */
  countOk: Scalars['Int']['output'];
  /** Count of entries where status was TIMEOUT. */
  countTimeout: Scalars['Int']['output'];
  /** The IP address of the monitored host. */
  hostIPAddr: Scalars['String']['output'];
  /**
   * The source Ethernet port number used for the monitoring.
   * @deprecated Use `srcPhyInterface` instead.
   */
  srcEthPortNum: Scalars['Int']['output'];
  /** The source physical interface port used for the monitoring. */
  srcPhyInterface: PhyInterface;
  /**
   * The status of the host monitoring.
   * @deprecated use statusValue
   */
  status: HostMonitoringStatus;
  /** Average value of quality where OK is 1.0 and everything else is 0.0. */
  statusValue: Scalars['Float']['output'];
  /** The time at which the measurement was taken. */
  timestamp: Scalars['DateTime']['output'];
  /** The average round-trip time (RTT) to the host in nanoseconds. */
  value: Scalars['Float']['output'];
  /** The virtual device where the measurement was taken. */
  virtualDevice: VirtualDevice;
  /** The UUID of the virtual device where the measurement was taken. */
  virtualDeviceUUID: Scalars['UUID']['output'];
};

/** The access network type as defined in Table 9-214 of 802.11-2016 IEEE Standard. */
export type Hs20AccessNetworkTypes = {
  __typename?: 'Hs20AccessNetworkTypes';
  /** Description of the access network type. */
  description: Scalars['String']['output'];
  /** Access network type as defined in Table 9-214 of 802.11-2016 IEEE Standard. */
  type: Scalars['Int']['output'];
};

/** The auth parameter for Hs20 */
export type Hs20AuthParam = {
  __typename?: 'Hs20AuthParam';
  /** Description of the authentication parameter. */
  description: Scalars['String']['output'];
  /** Authentication parameter. */
  param: Scalars['Int']['output'];
  /** Valid authentication values for this parameter. */
  validValues: Array<Hs20AuthValue>;
};

/** Hs20AuthValue and Hs20AuthParam are the authentication parameters and values as defined in Table 9-335 of 802.11-2020 IEEE Standard. */
export type Hs20AuthValue = {
  __typename?: 'Hs20AuthValue';
  /** Description of the authentication value. */
  description: Scalars['String']['output'];
  /** Authentication value. */
  value: Scalars['Int']['output'];
};

/** The EAP method as defined by IANA (http://www.iana.org/assignments/eap-numbers/eap-numbers.xhtml#eap-numbers-4). */
export type Hs20EapMethod = {
  __typename?: 'Hs20EapMethod';
  /** Description of the EAP method. */
  description: Scalars['String']['output'];
  /** An EAP method, as defined by IANA (http://www.iana.org/assignments/eap-numbers/eap-numbers.xhtml#eap-numbers-4) */
  method: Scalars['Int']['output'];
  /** Indicates if the method is commonly used. */
  mostUsed: Scalars['Boolean']['output'];
};

/** Response type containing valid Hotspot 2.0 venue types. */
export type Hs20ValidTypesResponse = {
  __typename?: 'Hs20ValidTypesResponse';
  /** List of valid Hotspot 2.0 access network types. */
  accessNetworkTypes: Array<Hs20AccessNetworkTypes>;
  /** List of valid authentication parameters. */
  authParams: Array<Hs20AuthParam>;
  /** List of valid EAP methods. */
  eapMethods: Array<Hs20EapMethod>;
  /** List of valid Hotspot 2.0 venue types. */
  venueTypes: Array<Hs20VenueTypes>;
};

/** Venue types as defined in Table 9-62 of 802.11-2016 IEEE Standard. */
export type Hs20VenueTypes = {
  __typename?: 'Hs20VenueTypes';
  /** Description of the venue. */
  description: Scalars['String']['output'];
  /** Venue group as defined in Table 9-62 of 802.11-2016 IEEE Standard. */
  group: Scalars['Int']['output'];
  /** Venue type as defined in Table 9-62 of 802.11-2016 IEEE Standard. */
  type: Scalars['Int']['output'];
};

/** An instance of an IDS event found by suricata. Full documentation can be found at https://docs.suricata.io/en/latest/output/eve/eve-json-format.html. */
export type IdsEvent = {
  __typename?: 'IDSEvent';
  /** Alert for the event. */
  alert?: Maybe<IdsEventAlert>;
  /** When application layer protocol event is detected. */
  appProto?: Maybe<Scalars['String']['output']>;
  /** Direction for this event. */
  direction: IdsEventDirection;
  /** The destination IP of this event. */
  dstIP?: Maybe<Scalars['IP']['output']>;
  /** The destination location of this event, derived from dstIP. */
  dstLocation?: Maybe<IdsEventLocation>;
  /** The destination MAC address of this event. */
  dstMAC?: Maybe<Scalars['MacAddress']['output']>;
  /** The destination port of this event. */
  dstPort: Scalars['Int']['output'];
  /**
   * The log type.
   * @deprecated No longer used.
   */
  eventType: Scalars['String']['output'];
  /** Will be defined if a firewall rule exists for this event. */
  firewallRule?: Maybe<FirewallRule>;
  /** Flow info for the event. */
  flow?: Maybe<IdsEventFlowInfo>;
  /** Correlates the network protocol, flow logs EVE data and any evidence that Suricata has logged to an alert event and that alert's metadata, as well as to fileinfo/file transaction and anomaly logs, if available. */
  flowID: Scalars['Int']['output'];
  /** HTTP info for the event. */
  httpInfo?: Maybe<IdsEventHttpInfo>;
  /** IPS rule, only populated if IPS is enabled. */
  ipsRule?: Maybe<IdsEventIpsRule>;
  /** When this event was observed. */
  observedAt: Scalars['DateTime']['output'];
  /** Network protocol for this event. */
  protocol: IdsEventProtocol;
  /** The source IP of this event. */
  srcIP?: Maybe<Scalars['IP']['output']>;
  /** The source location of this event, derived from srcIP. */
  srcLocation?: Maybe<IdsEventLocation>;
  /** The source MAC address of this event. */
  srcMAC?: Maybe<Scalars['MacAddress']['output']>;
  /** The source port of this event. */
  srcPort: Scalars['Int']['output'];
  /** Timestamp of this event. If not provided, value is filled by observed_at from stats. */
  timestamp: Scalars['DateTime']['output'];
  /** TLS info for the event. */
  tlsInfo?: Maybe<IdsEventTlsInfo>;
  /** The log type. */
  type: IdsEventType;
  /** Virtual device that observed this event. */
  virtualDevice: VirtualDevice;
};

/** https://docs.suricata.io/en/latest/output/eve/eve-json-format.html#event-type-alert */
export type IdsEventAlert = {
  __typename?: 'IDSEventAlert';
  /** Action for the alert. */
  action: IdsEventAlertAction;
  /** Category of the alert. */
  category: Scalars['String']['output'];
  /** Group ID of the alert. */
  gid: Scalars['Int']['output'];
  /** The rule that triggered this event. */
  idsRule?: Maybe<IdsRule>;
  /** Revision of the alert. */
  rev: Scalars['Int']['output'];
  /**
   * Rule of the alert.
   * @deprecated Use `idsRule` instead.
   */
  rule?: Maybe<Scalars['String']['output']>;
  /** The severity of the alert. */
  severity: Scalars['Int']['output'];
  /** Signature ID of the alert. */
  sid: Scalars['Int']['output'];
  /** The signature of the alert. */
  signature: Scalars['String']['output'];
};

export enum IdsEventAlertAction {
  /** Action is allowed. */
  Allowed = 'ALLOWED',
  /** Action is blocked. */
  Blocked = 'BLOCKED',
  /** Action is unknown. */
  Unspecified = 'UNSPECIFIED',
}

export enum IdsEventDirection {
  /** Direction is to client. */
  ToClient = 'TO_CLIENT',
  /** Direction is to server. */
  ToServer = 'TO_SERVER',
  /** Direction is unknown. */
  Unspecified = 'UNSPECIFIED',
}

export type IdsEventFilterInput = {
  /** Find events by signature ID. */
  SID?: InputMaybe<Scalars['Int']['input']>;
  /** Find events based on action. */
  action?: InputMaybe<IdsEventAlertAction>;
  /** Find events based on application layer protocol. */
  appProtocol?: InputMaybe<Scalars['String']['input']>;
  /** Find rules by class type shortname. */
  classType?: InputMaybe<Scalars['String']['input']>;
  /** Find events based on direction. */
  direction?: InputMaybe<IdsEventDirection>;
  /** Find events based on destination IP. */
  dstIP?: InputMaybe<Scalars['IP']['input']>;
  /** Find events based on destination MAC address. */
  dstMAC?: InputMaybe<Scalars['MacAddress']['input']>;
  /** Find events based on destination port. */
  dstPort?: InputMaybe<PortRangeInput>;
  /** Find events based on protocol. */
  protocol?: InputMaybe<IdsEventProtocol>;
  /** Input for non-exact search against rule fields. */
  search?: InputMaybe<IdsEventFilterSearchInput>;
  /** Find events based on source IP. */
  srcIP?: InputMaybe<Scalars['IP']['input']>;
  /** Find events based on source MAC address. */
  srcMAC?: InputMaybe<Scalars['MacAddress']['input']>;
  /** Find events based on source port. */
  srcPort?: InputMaybe<PortRangeInput>;
};

export type IdsEventFilterSearchInput = {
  /** An optional informational description for the suppression. */
  description?: InputMaybe<Scalars['String']['input']>;
};

/** https://docs.suricata.io/en/latest/output/eve/eve-json-format.html#event-type-flow */
export type IdsEventFlowInfo = {
  __typename?: 'IDSEventFlowInfo';
  /** Total bytes count to client. */
  bytesToClient: Scalars['Int']['output'];
  /** Total bytes count to server. */
  bytesToServer: Scalars['Int']['output'];
  /** Date of end of flow (last seen packet) */
  end?: Maybe<Scalars['DateTime']['output']>;
  /** Total number of packets to client. */
  packetsToClient: Scalars['Int']['output'];
  /** Total number of packets to server, include bypassed packets. */
  packetsToServer: Scalars['Int']['output'];
  /** Mechanism that did trigger the end of the flow (include "timeout", "forced" and "shutdown"). */
  reason?: Maybe<Scalars['String']['output']>;
  /** Date of start of the flow */
  start?: Maybe<Scalars['DateTime']['output']>;
};

/** https://docs.suricata.io/en/latest/output/eve/eve-json-format.html#event-type-http */
export type IdsEventHttpInfo = {
  __typename?: 'IDSEventHTTPInfo';
  /** The type of data returned (ex: application/x-gzip). */
  contentType: Scalars['String']['output'];
  /** The hostname this HTTP event is attributed to. */
  hostname: Scalars['String']['output'];
  /** The content size of the HTTP body. */
  length: Scalars['Int']['output'];
  /** Protocol / Version of HTTP (ex: HTTP/1.1). */
  protocol: Scalars['String']['output'];
  /** HTTP status code. */
  status: Scalars['Int']['output'];
  /** URL at the hostname that was accessed. */
  url: Scalars['String']['output'];
  /** The user-agent of the software that was used. */
  userAgent: Scalars['String']['output'];
};

/** Details a firewall rule created by IPS. */
export type IdsEventIpsRule = {
  __typename?: 'IDSEventIPSRule';
  /** Destination port range to match traffic from. */
  dstPortRange: PortRange;
  /** Destination IP prefix to match traffic from. */
  dstPrefix: Scalars['IPPrefix']['output'];
  /** Validity from timestamp; 0 = always valid */
  durationSec: Scalars['Int']['output'];
  /** Uplink phy interface bound to this rule. */
  phyInterfaceBindings?: Maybe<Array<PhyInterface>>;
  /** IP protocols to match. */
  protocol: IdsEventProtocol;
  /** Source port range to match traffic from. */
  srcPortRange: PortRange;
  /** Source IP prefix to match traffic from. */
  srcPrefix: Scalars['IPPrefix']['output'];
  /** VLANs bound to this rule. */
  vlanBindings?: Maybe<Array<Vlan>>;
};

/** Location of IDS event based on IP lookup */
export type IdsEventLocation = {
  __typename?: 'IDSEventLocation';
  /** ISO-3166 alpha-2 country code */
  countryCode: Scalars['String']['output'];
  /** Latitude of location */
  latitude: Scalars['Float']['output'];
  /** Longitude of location */
  longitude: Scalars['Float']['output'];
};

export enum IdsEventProtocol {
  /** Protocol is AH. */
  Ah = 'AH',
  /** Protocol is ANY. */
  Any = 'ANY',
  /** Protocol is ESP. */
  Esp = 'ESP',
  /** Protocol is ICMP. */
  Icmp = 'ICMP',
  /** Protocol is TCP. */
  Tcp = 'TCP',
  /** Protocol is UDP. */
  Udp = 'UDP',
  /** Protocol is unknown. */
  Unspecified = 'UNSPECIFIED',
}

/** https://docs.suricata.io/en/latest/output/eve/eve-json-format.html#event-type-tls */
export type IdsEventTlsInfo = {
  __typename?: 'IDSEventTLSInfo';
  /** The JA3 hash. */
  ja3Hash: Scalars['String']['output'];
  /** The JA3S hash. */
  ja3sHash: Scalars['String']['output'];
  /** The Server Name Indication (SNI) extension sent by the client */
  sni: Scalars['String']['output'];
};

export enum IdsEventType {
  /** Detect */
  Detect = 'DETECT',
  /** Inline IPS. */
  IbProtect = 'IB_PROTECT',
  /** Out-of-band firewall rule. */
  OobProtect = 'OOB_PROTECT',
  /** Unknown */
  Unspecified = 'UNSPECIFIED',
}

/** A paged response for IDS event queries. */
export type IdsEventsPage = {
  __typename?: 'IDSEventsPage';
  /** A subset of records based on the limit and offset fields */
  events?: Maybe<Array<IdsEvent>>;
  /** The total number of records */
  total: Scalars['Int']['output'];
};

/** A category for IDS/IPS rules. */
export type IdsipsCategory = {
  __typename?: 'IDSIPSCategory';
  /** Unique identifier for this category. */
  UUID: Scalars['UUID']['output'];
  /** When this category was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The priority of this category. */
  priority: Scalars['Int']['output'];
  /** The number of rules associated with this category. */
  ruleCount: Scalars['Int']['output'];
  /** A short description of this category. */
  shortDescription: Scalars['String']['output'];
  /** The unique shortname code for this category. */
  shortname: Scalars['String']['output'];
  /** When this category was updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** Holds the IDS IPS config for a network. */
export type IdsipsConfig = {
  __typename?: 'IDSIPSConfig';
  /** Unique identifier for this configuration. */
  UUID: Scalars['UUID']['output'];
  /** The configured categories for this config. */
  boundCategories: Array<IdsipsConfigCategoryBinding>;
  /** The explicitly configured rules for this config. */
  boundIDSRules: Array<IdsipsConfigRuleBinding>;
  /** When this configuration was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The custom rules for this config. */
  customRules?: Maybe<Array<IdsipsCustomRule>>;
  /** The VLANs this is enabled for. */
  enabledVLANs: Array<Vlan>;
  /** Validity of ips generated rules. */
  ipsRuleDuration?: Maybe<Scalars['Duration']['output']>;
  /** If east-west protection is enabled. */
  isEastWestProtectionEnabled: Scalars['Boolean']['output'];
  /** The IPS minimum severity to act on. */
  minIPSSeverity?: Maybe<Scalars['Int']['output']>;
  /** The IDS minimum severity to act on. */
  minSeverity: Scalars['Int']['output'];
  /** The mode IDS/IPS should act in. */
  mode: IdsipsMode;
  /** The UUID of the network for this configuration. */
  networkUUID: Scalars['UUID']['output'];
  /** List of subnets that should never be blocked. */
  safelist?: Maybe<Array<Scalars['IPPrefix']['output']>>;
  /** The rule list source version. */
  sourceVersion: Scalars['Int']['output'];
  /** The suppressed (allowed) categories for this config. */
  suppressedCategories: Array<IdsipsConfigCategorySuppression>;
  /** The suppressed (allowed) rules for this config. */
  suppressedRules: Array<IdsipsConfigRuleSuppression>;
};

/** A category for IDS/IPS rules. */
export type IdsipsConfigCategoryBinding = {
  __typename?: 'IDSIPSConfigCategoryBinding';
  /** The bound IDS/IPS category. */
  category: IdsipsCategory;
  /** Unique identifier for the bound IDS/IPS category. */
  categoryUUID: Scalars['UUID']['output'];
  /** The bound IDS/IPS configuration. */
  config: IdsipsConfig;
  /** Unique identifier for the bound IDS/IPS configuration. */
  configUUID: Scalars['UUID']['output'];
  /** When this category was created. Will be null if the binding is an implicit default. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** The mode of this binding, whether it applies to IDS or IPS. */
  mode: IdsipsMode;
  /** When this category was updated. Will be null if the binding is an implicit default. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type IdsipsConfigCategoryBindingInput = {
  /** Unique identifier of the IDS/IPS category. */
  categoryUUID: Scalars['UUID']['input'];
  /** The mode of this binding, whether it applies to IDS or IPS. */
  mode: IdsipsMode;
};

/** A suppressed category for an IDS/IPS config. */
export type IdsipsConfigCategorySuppression = {
  __typename?: 'IDSIPSConfigCategorySuppression';
  /** Unique identifier of the IDS/IPS config suppressed category. */
  UUID: Scalars['UUID']['output'];
  /** The IDS category. */
  category: IdsipsCategory;
  /** Unique identifier of the category. */
  categoryUUID: Scalars['UUID']['output'];
  /** Unique identifier of the IDS/IPS configuration. */
  configUUID: Scalars['UUID']['output'];
  /** An optional informational description for the suppression. */
  description?: Maybe<Scalars['String']['output']>;
  /** The traffic direction to consider when determining IP prefix application. Required if `ipPrefixes` is set. */
  direction?: Maybe<IdsipsSuppressedRuleDirection>;
  /** The IP prefixes that this suppression should apply to. If set, `direction` is required. */
  ipPrefixes?: Maybe<Array<Scalars['IPPrefix']['output']>>;
  /** The mode of this suppression, whether it applies to IDS or IPS. */
  mode: IdsipsMode;
};

export type IdsipsConfigCategorySuppressionInput = {
  /** Unique identifier of the IDS category. */
  categoryUUID: Scalars['UUID']['input'];
  /** An optional informational description for the suppression. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The traffic direction to consider when determining IP prefix application. Required if `ipPrefixes` is set. */
  direction?: InputMaybe<IdsipsSuppressedRuleDirection>;
  /** The IP prefixes that this suppression should apply to. If set, `direction` is required. */
  ipPrefixes?: InputMaybe<Array<Scalars['IPPrefix']['input']>>;
  /** The mode of this suppression, whether it applies to IDS or IPS. */
  mode: IdsipsMode;
};

/** A configured IDS rule for an IDS/IPS config. */
export type IdsipsConfigRuleBinding = {
  __typename?: 'IDSIPSConfigRuleBinding';
  /** Unique identifier of the IDS/IPS configuration. */
  configUUID: Scalars['UUID']['output'];
  /** The mode of this binding, whether it applies to IDS or IPS. */
  mode: IdsipsMode;
  /** The IDS rule. */
  rule: IdsRule;
  /** Unique signature ID of the IDS rule. */
  ruleSID: Scalars['Int']['output'];
};

export type IdsipsConfigRuleBindingInput = {
  /** The mode of this binding, whether it applies to IDS or IPS. */
  mode: IdsipsMode;
  /** Unique signature ID of the IDS rule. */
  ruleSID: Scalars['Int']['input'];
};

/** A suppressed IDS rule for an IDS/IPS config. */
export type IdsipsConfigRuleSuppression = {
  __typename?: 'IDSIPSConfigRuleSuppression';
  /** Unique identifier of the IDS/IPS config suppressed rule. */
  UUID: Scalars['UUID']['output'];
  /** Unique identifier of the IDS/IPS configuration. */
  configUUID: Scalars['UUID']['output'];
  /** An optional informational description for the suppression. */
  description?: Maybe<Scalars['String']['output']>;
  /** The traffic direction to consider when determining IP prefix application. Required if `ipPrefixes` is set. */
  direction?: Maybe<IdsipsSuppressedRuleDirection>;
  /** The IP prefixes that this suppression should apply to. If set, `direction` is required. */
  ipPrefixes?: Maybe<Array<Scalars['IPPrefix']['output']>>;
  /** The mode of this suppression, whether it applies to IDS or IPS. */
  mode: IdsipsMode;
  /** The IDS rule. */
  rule: IdsRule;
  /** Unique signature ID of the IDS rule. */
  ruleSID: Scalars['Int']['output'];
};

export type IdsipsConfigRuleSuppressionInput = {
  /** An optional informational description for the suppression. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The traffic direction to consider when determining IP prefix application. Required if `ipPrefixes` is set. */
  direction?: InputMaybe<IdsipsSuppressedRuleDirection>;
  /** The IP prefixes that this suppression should apply to. If set, `direction` is required. */
  ipPrefixes?: InputMaybe<Array<Scalars['IPPrefix']['input']>>;
  /** The mode of this suppression, whether it applies to IDS or IPS. */
  mode: IdsipsMode;
  /** Unique signature ID of the IDS rule. */
  ruleSID: Scalars['Int']['input'];
};

/** A custom intrusion rule definition for IDS/IPS. These currently apply tls.sni rules. */
export type IdsipsCustomRule = {
  __typename?: 'IDSIPSCustomRule';
  /** Unique identifier. */
  UUID: Scalars['UUID']['output'];
  /** The action this rule applies. */
  action: FirewallRuleAction;
  /** The application this rule applies to. */
  application?: Maybe<ApplicationDnsFirewallRuleApplication>;
  /** List of VLAN bindings for the rule. */
  boundVLANs?: Maybe<Array<Vlan>>;
  /** Unique identifier of the IDS/IPS configuration. */
  configUUID: Scalars['UUID']['output'];
  /** When this rule was created. */
  createdAt: Scalars['DateTime']['output'];
  /** When this rule was deleted. */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The FQDN this rule applies to. */
  domain?: Maybe<Scalars['String']['output']>;
  /** If this rule is enabled. */
  isEnabled: Scalars['Boolean']['output'];
  /** A name to identify this rule. */
  name: Scalars['String']['output'];
  /** When this rule was updated. */
  updatedAt: Scalars['DateTime']['output'];
};

export enum IdsipsMode {
  /** Intrusion Detection System mode */
  Ids = 'IDS',
  /** Intrusion Prevention System mode */
  Ips = 'IPS',
}

/** Identical to `IDSIPSMode`, separate for technical reasons. */
export enum IdsipsModeFilterInput {
  /** Intrusion Detection System mode */
  Ids = 'IDS',
  /** Intrusion Prevention System mode */
  Ips = 'IPS',
}

export enum IdsipsSuppressedRuleDirection {
  /** Destination */
  Destination = 'DESTINATION',
  /** Either */
  Either = 'EITHER',
  /** Source */
  Source = 'SOURCE',
}

/** A single available intrusion rule definition for IDS/IPS. */
export type IdsRule = {
  __typename?: 'IDSRule';
  /** The unique signature ID for this rule. */
  SID: Scalars['Int']['output'];
  /** Unique identifier for this rule. */
  UUID: Scalars['UUID']['output'];
  /** The action for this rule. */
  action: Scalars['String']['output'];
  /** The associated category for this rule, if present. */
  category?: Maybe<IdsipsCategory>;
  /** The category class type (shortname) for this rule. */
  classType: Scalars['String']['output'];
  /** When this rule was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The description for this rule. */
  description?: Maybe<Scalars['String']['output']>;
  /** The group ID for this rule. */
  groupID?: Maybe<Scalars['Int']['output']>;
  /** The header for this rule. */
  header: Scalars['String']['output'];
  /** The list of metadata entries for this rule. */
  metadata: Array<Scalars['String']['output']>;
  /** The list of references for this rule. */
  references: Array<IdsRuleReference>;
  /** The revision version for this rule. */
  revision: Scalars['Int']['output'];
  /** When this rule was updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** Filter IDS rules based on bindings on a given config. */
export type IdsRuleBindingFilterInput = {
  /** The mode of the bindings to filter for rules on. */
  modes?: InputMaybe<Array<InputMaybe<IdsipsModeFilterInput>>>;
};

export type IdsRuleFilterConfigInput = {
  /** Filter IDS rules based on bindings in the given config. */
  boundIDSRules?: InputMaybe<IdsRuleBindingFilterInput>;
  /** The IDS/IPS config's unique identifier to filter for rules on. */
  idsIPSConfigUUID: Scalars['UUID']['input'];
  /** Filter IDS rules based on suppressions in the given config. */
  suppressedRules?: InputMaybe<IdsRuleSuppressionFilterInput>;
};

export type IdsRuleFilterInput = {
  /** Find rules by signature ID. */
  SID?: InputMaybe<Scalars['Int']['input']>;
  /** Find based on action for this rule. */
  action?: InputMaybe<Scalars['String']['input']>;
  /** Find rules by class type shortname. */
  classType?: InputMaybe<Scalars['String']['input']>;
  /** Input for rules that are associated with a given configuration. */
  config?: InputMaybe<IdsRuleFilterConfigInput>;
  /** Find rules by group ID */
  groupID?: InputMaybe<Scalars['Int']['input']>;
  /** Find rules by revision. */
  revision?: InputMaybe<Scalars['Int']['input']>;
  /** Input for non-exact search against rule fields. */
  search?: InputMaybe<IdsRuleFilterSearchInput>;
};

/** Filter IDS rules based on substring search. */
export type IdsRuleFilterSearchInput = {
  /** Search based on description for this rule. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Search based on header for this rule. */
  header?: InputMaybe<Scalars['String']['input']>;
};

/** A page of IDS rule results. */
export type IdsRulePage = {
  __typename?: 'IDSRulePage';
  /** The results for this page. */
  items: Array<IdsRule>;
  /** The total number of results available based on the provided filters. */
  total: Scalars['Int']['output'];
};

/** A key/value reference entry for an IDS rule. */
export type IdsRuleReference = {
  __typename?: 'IDSRuleReference';
  /** The value of the reference. */
  ref: Scalars['String']['output'];
  /** The type of the reference. */
  type: Scalars['String']['output'];
};

/** Filter IDS rules based on suppressions on a given config. */
export type IdsRuleSuppressionFilterInput = {
  /** The mode of the suppression to filter for rules on. */
  modes?: InputMaybe<Array<InputMaybe<IdsipsModeFilterInput>>>;
};

/** An IEEEDeviceVendor represents a vendor registered with the IEEE, which includes the vendor's name and mailing address. */
export type IeeeDeviceVendor = {
  __typename?: 'IEEEDeviceVendor';
  /** The name of the vendor registered with the IEEE. */
  vendor: Scalars['String']['output'];
  /** The mailing address of the vendor registered with the IEEE. */
  vendorAddress: Scalars['String']['output'];
};

/** An IP forwarding rule forwards the given prefix through a specific WAN */
export type IpForwardingRule = {
  __typename?: 'IPForwardingRule';
  /** Unique identifier of the IP forwarding rule. */
  UUID: Scalars['UUID']['output'];
  /** Timestamp when rule was created. */
  createdAt: Scalars['DateTime']['output'];
  /** If rule is enabled. */
  isEnabled: Scalars['Boolean']['output'];
  /** Name of this rule. */
  name: Scalars['String']['output'];
  /** UUID of the network that this rule applies to. */
  networkUUID: Scalars['UUID']['output'];
  /** Timestamp when rule was Updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** The uplink interface associated with the rule. */
  uplinkPhyInterface: PhyInterface;
  /** The VLAN associated with this rule. */
  vlan: Vlan;
};

/** Supported IP protocols for firewall rules. */
export enum IpProtocol {
  /** All protocols. */
  All = 'ALL',
  /** Internet Control Message Protocol. */
  Icmp = 'ICMP',
  /** Transmission Control Protocol. */
  Tcp = 'TCP',
  /** User Datagram Protocol. */
  Udp = 'UDP',
}

/** Enumeration of possible IPSec authentication algorithms. */
export enum IpSecAuthenticationAlgorithm {
  /** AES-CMAC-96 authentication algorithm. */
  Cmac_96 = 'CMAC_96',
  /** SHA-1 HMAC with 96-bit truncation. */
  Sha1_96 = 'SHA1_96',
  /** SHA-256 HMAC with 128-bit truncation. */
  Sha2_256_128 = 'SHA2_256_128',
  /** SHA-384 HMAC with 192-bit truncation. */
  Sha2_384_192 = 'SHA2_384_192',
  /** SHA-512 HMAC with 256-bit truncation. */
  Sha2_512_256 = 'SHA2_512_256',
  /** AES-XCBC-MAC-96 authentication algorithm. */
  Xcbc_96 = 'XCBC_96',
}

/** Enumeration of possible states for the CHILD Security Association. */
export enum IpSecChildSaStatus {
  /** The CHILD Security Association is created but not yet installed. */
  Created = 'CREATED',
  /** The CHILD Security Association has been deleted. */
  Deleted = 'DELETED',
  /** The CHILD Security Association is being deleted. */
  Deleting = 'DELETING',
  /** The CHILD Security Association is being destroyed. */
  Destroying = 'DESTROYING',
  /** The CHILD Security Association is installed and operational. */
  Installed = 'INSTALLED',
  /** The CHILD Security Association is being installed. */
  Installing = 'INSTALLING',
  /** The CHILD Security Association has been rekeyed. */
  Rekeyed = 'REKEYED',
  /** The CHILD Security Association is rekeying. */
  Rekeying = 'REKEYING',
  /** The CHILD Security Association is retrying after failure. */
  Retrying = 'RETRYING',
  /** The CHILD Security Association is routed. */
  Routed = 'ROUTED',
  /** Unspecified status. */
  Unspecified = 'UNSPECIFIED',
  /** The CHILD Security Association is updating its configuration. */
  Updating = 'UPDATING',
}

/** Enumeration of possible Diffie-Hellman groups for key exchange. */
export enum IpSecDhGroup {
  /** Diffie-Hellman group 2 (MODP 1024). */
  Dh2 = 'DH2',
  /** Diffie-Hellman group 14 (MODP 2048). */
  Dh14 = 'DH14',
  /** Diffie-Hellman group 19 (ECP 256). */
  Dh19 = 'DH19',
  /** Diffie-Hellman group 20 (ECP 384). */
  Dh20 = 'DH20',
}

/**
 * Enumeration of possible DPD actions
 * https://wiki.strongswan.org/projects/strongswan/wiki/connsection
 */
export enum IpSecDpdAction {
  /** CLEAR */
  Clear = 'CLEAR',
  /** HOLD */
  Hold = 'HOLD',
  /** NONE. Disables DPD. */
  None = 'NONE',
  /** RESTART */
  Restart = 'RESTART',
}

/** Enumeration of possible IPSec encryption algorithms. */
export enum IpSecEncryptionAlgorithm {
  /** AES in CBC mode with a 128-bit key. */
  AesCbc_128 = 'AES_CBC_128',
  /** AES in CBC mode with a 192-bit key. */
  AesCbc_192 = 'AES_CBC_192',
  /** AES in CBC mode with a 256-bit key. */
  AesCbc_256 = 'AES_CBC_256',
  /** AES in CTR mode with a 128-bit key. */
  AesCtr_128 = 'AES_CTR_128',
  /** AES in CTR mode with a 192-bit key. */
  AesCtr_192 = 'AES_CTR_192',
  /** AES in CTR mode with a 256-bit key. */
  AesCtr_256 = 'AES_CTR_256',
  /** AES in Galois/Counter Mode (GCM) with a 128-bit key and 16-byte ICV. */
  AesGcm_16128 = 'AES_GCM_16128',
  /** AES in Galois/Counter Mode (GCM) with a 192-bit key and 16-byte ICV. */
  AesGcm_16192 = 'AES_GCM_16192',
  /** AES in Galois/Counter Mode (GCM) with a 256-bit key and 16-byte ICV. */
  AesGcm_16256 = 'AES_GCM_16256',
  /** Triple DES encryption with a 112-bit effective key length. */
  Algo_3Des_112 = 'ALGO_3DES_112',
  /** Triple DES encryption with a 168-bit key. */
  Algo_3Des_168 = 'ALGO_3DES_168',
}

export enum IpSecPeerType {
  /** AWS peer type */
  Aws = 'AWS',
  /** Azure peer type */
  Azure = 'AZURE',
}

/** Enumeration of possible states for the IKE Security Association. */
export enum IpSecSaStatus {
  /** The IKE Security Association is in the process of connecting. */
  Connecting = 'CONNECTING',
  /** The IKE Security Association is created but not yet connected. */
  Created = 'CREATED',
  /** The IKE Security Association is being deleted. */
  Deleting = 'DELETING',
  /** The IKE Security Association is being destroyed. */
  Destroying = 'DESTROYING',
  /** The IKE Security Association is established and operational. */
  Established = 'ESTABLISHED',
  /** The IKE Security Association is in passive mode, waiting for incoming connections. */
  Passive = 'PASSIVE',
  /** The IKE Security Association has been rekeyed. */
  Rekeyed = 'REKEYED',
  /** The IKE Security Association is rekeying. */
  Rekeying = 'REKEYING',
  /** Unspecified status. */
  Unspecified = 'UNSPECIFIED',
}

/** Represents an IPSec tunnel configuration. */
export type IpSecTunnel = {
  __typename?: 'IPSecTunnel';
  /** The unique identifier for the IPSec tunnel. */
  UUID: Scalars['UUID']['output'];
  /** The authentication algorithm used for the IPSec connection. */
  authenticationAlgorithm?: Maybe<IpSecAuthenticationAlgorithm>;
  /** The physical interface that this IPSec tunnel is bound to. */
  boundPhyInterface: PhyInterface;
  /** The VLANs that are bound to this IPSec tunnel. */
  boundVLANs: Array<Vlan>;
  /** Timestamp when the IPSec tunnel was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Sets the DPD action for the tunnel. */
  dpdAction?: Maybe<IpSecDpdAction>;
  /** Sets the DPD delay for the tunnel. */
  dpdDelay?: Maybe<Scalars['Duration']['output']>;
  /** Sets the DPD timeout for the tunnel. */
  dpdTimeout?: Maybe<Scalars['Duration']['output']>;
  /** The encryption algorithm used for the IPSec connection. */
  encryptionAlgorithm?: Maybe<IpSecEncryptionAlgorithm>;
  /** Sets the ikelifetime for the tunnel. */
  ikeLifetime?: Maybe<Scalars['Duration']['output']>;
  /**
   * If true, adds Client VPN subnets to the local traffic selectors,
   * effectively allowing Client VPN clients to route traffic over the IPSec tunnel.
   */
  isClientVPNBound: Scalars['Boolean']['output'];
  /** Indicates whether the IPSec tunnel is currently enabled. */
  isEnabled: Scalars['Boolean']['output'];
  /** Indicates whether this tunnel should initiate the connection to the right participant. */
  isInitiator: Scalars['Boolean']['output'];
  /** The Diffie-Hellman group used for key exchange in the IPSec connection. */
  keyExchangeDHGroup?: Maybe<IpSecDhGroup>;
  /** How the left participant should be identified for authentication. Can be an IP address or FQDN which will be validated in application logic. If this is not set, defaults to `%defaultroute`. */
  leftID: Scalars['String']['output'];
  /** A user-defined name for the IPSec tunnel. */
  name: Scalars['String']['output'];
  /** The unique identifier of the network to which this IPSec tunnel belongs. */
  networkUUID: Scalars['UUID']['output'];
  /** Allows for vendor specific configuration based on this peer type. */
  peerType?: Maybe<IpSecPeerType>;
  /** Sets the reauth for the tunnel, true = yes, false = no */
  reauth: Scalars['Boolean']['output'];
  /** Sets the rekey for the tunnel, true = yes, false = no */
  rekey: Scalars['Boolean']['output'];
  /** The public IP address or DNS hostname where the right participant can be reached. Can be an IP address or FQDN which will be validated in application logic. */
  right?: Maybe<Scalars['String']['output']>;
  /** Identifier for the right participant (remote side) for authentication purposes. Can be an IP address or FQDN which will be validated in application logic. */
  rightID: Scalars['String']['output'];
  /** The private subnets behind the right participant. This is usually 0.0.0.0/0 but in some cases may be different. */
  rightPrefixes: Array<Scalars['IPPrefix']['output']>;
  /** The last reported status of the IPSec tunnel. */
  status?: Maybe<IpSecTunnelStatus>;
  /** Timestamp when the IPSec tunnel was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** Response type containing IPSec tunnel timeseries data over a specified time range. */
export type IpSecTunnelMetricsTimeseriesResponse = {
  __typename?: 'IPSecTunnelMetricsTimeseriesResponse';
  /** IPSec tunnel for this series. */
  ipSecTunnel: IpSecTunnel;
  /** Aggregated latency to the remote IKE in milliseconds. */
  latencyMs: BaseMetricsResponse;
  /** Network UUID for this series. */
  networkUUID: Scalars['UUID']['output'];
  /** Aggregated throughput for the total bytes received in bps. */
  rxBytes: BaseMetricsResponse;
  /** Aggregated throughput for the total packets received per second. */
  rxPackets: BaseMetricsResponse;
  /** Aggregated throughput for the total bytes transmitted in bps. */
  txBytes: BaseMetricsResponse;
  /** Aggregated throughput for the total packets transmitted per second. */
  txPackets: BaseMetricsResponse;
};

/** Status information for an IPSec tunnel. */
export type IpSecTunnelStatus = {
  __typename?: 'IPSecTunnelStatus';
  /** Timestamp when the CHILD Security Association will expire. */
  childLifetime: Scalars['DateTime']['output'];
  /** Timestamp when the CHILD Security Association will be rekeyed. */
  childRekeyAt: Scalars['DateTime']['output'];
  /** Status of the CHILD Security Association. */
  childSAStatus: IpSecChildSaStatus;
  /** Timestamp when the IKE Security Association was established. */
  establishedAt: Scalars['DateTime']['output'];
  /** Latency to the remote IKE endpoint in milliseconds. */
  latencyMs: Scalars['Int']['output'];
  /** The timestamp when the status was observed. */
  observedAt: Scalars['DateTime']['output'];
  /** Timestamp when the IKE Security Association will be re-authenticated. */
  reauthAt: Scalars['DateTime']['output'];
  /** Timestamp when the IKE Security Association will be rekeyed. */
  rekeyAt: Scalars['DateTime']['output'];
  /** IPv4 address of the remote IKE endpoint. */
  remoteHostIP4Address: Scalars['String']['output'];
  /** Number of bytes received. */
  rxBytes: Scalars['Int']['output'];
  /** Timestamp of the last inbound packet, if any. */
  rxLast: Scalars['DateTime']['output'];
  /** Number of packets received. */
  rxPackets: Scalars['Int']['output'];
  /** The state of the IKE Security Association. */
  saStatus: IpSecSaStatus;
  /** Number of bytes transmitted. */
  txBytes: Scalars['Int']['output'];
  /** Timestamp of the last outbound packet, if any. */
  txLast: Scalars['DateTime']['output'];
  /** Unique identifier of the IKE Security Association. */
  uniqueID: Scalars['String']['output'];
};

/** Properties for an IPSec tunnel status change event. */
export type IpSecTunnelStatusChangeProperties = {
  __typename?: 'IPSecTunnelStatusChangeProperties';
  /** The new status of the CHILD Security Association if not null. */
  childSAStatus?: Maybe<IpSecChildSaStatus>;
  /** The IPSec tunnel associated with the event. */
  ipSecTunnel: IpSecTunnel;
  /** The new state of the IKE Security Association if not null */
  saStatus?: Maybe<IpSecSaStatus>;
};

/** The category of service provided by the ISP. */
export enum IspProduct {
  /** Business cable connection */
  BusinessCable = 'BUSINESS_CABLE',
  /** Cellular connection */
  Cellular = 'CELLULAR',
  /** Dedicated fiber optic connection */
  DedicatedFiber = 'DEDICATED_FIBER',
  /** DSL connection */
  Dsl = 'DSL',
  /** Point-to-point wireless connection */
  PointToPointWireless = 'POINT_TO_POINT_WIRELESS',
  /** Residential cable connection */
  ResidentialCable = 'RESIDENTIAL_CABLE',
  /** Residential fiber optic connection */
  ResidentialFiber = 'RESIDENTIAL_FIBER',
  /** Shared fiber optic connection */
  SharedFiber = 'SHARED_FIBER',
}

/** Whether the ISP is intended to function as the primary or backup connection. */
export enum IspStatus {
  /** The ISP is configured as the fallback ISP connection. */
  Backup = 'BACKUP',
  /** The ISP is configured as the preferred ISP connection. */
  Primary = 'PRIMARY',
}

/** An enumeration of supported image types. */
export enum ImageType {
  Gif = 'GIF',
  Jpeg = 'JPEG',
  Png = 'PNG',
  Svg = 'SVG',
}

/** Information about the user who performed the impersonation. */
export type Impersonator = {
  __typename?: 'Impersonator';
  /** The email address of the impersonating user. */
  email: Scalars['String']['output'];
};

/** Incidents are deprecated. */
export type Incident = {
  __typename?: 'Incident';
  /** Unique identifier for the incident. */
  UUID: Scalars['UUID']['output'];
  /** Category of the incident. */
  category?: Maybe<IncidentCategory>;
  /** End time of the incident. */
  endTime: Scalars['DateTime']['output'];
  /** Network associated with the incident. */
  network: Network;
  /** UUID of the network associated with the incident. */
  networkUUID: Scalars['UUID']['output'];
  /** Additional notes about the incident. */
  notes?: Maybe<Scalars['String']['output']>;
  /** Start time of the incident. */
  startTime: Scalars['DateTime']['output'];
};

/** An enumeration of incident categories. */
export enum IncidentCategory {
  /** An incident related to deinstallation of equipment or services. */
  Deinstallation = 'DEINSTALLATION',
  /** An incident related to the installation process. */
  Installation = 'INSTALLATION',
  /** An incident involving maintenance activities. */
  Maintenance = 'MAINTENANCE',
  /** An incident caused by or resulting in service outages. */
  Outage = 'OUTAGE',
  /** An incident related to provisioning of services. */
  Provisioning = 'PROVISIONING',
  /** An incident that is scheduled in advance. */
  Scheduled = 'SCHEDULED',
}

/** A pair of VLANs that are permitted to communicate with each other. */
export type InterVlanCommunicationPermittedPair = {
  __typename?: 'InterVLANCommunicationPermittedPair';
  /** The unique identifier of the inter-VLAN communication pair. */
  UUID: Scalars['UUID']['output'];
  /** The other VLAN in the permitted communication pair. */
  higherVLAN: Vlan;
  /** One VLAN in the permitted communication pair. */
  lowerVLAN: Vlan;
  /** The UUID of the network to which the VLANs belong. */
  networkUUID: Scalars['UUID']['output'];
};

/** An internal note is a note for Meter teams to share information about a network. */
export type InternalNote = {
  __typename?: 'InternalNote';
  /** Unique identifier for the internal note. */
  UUID: Scalars['UUID']['output'];
  /** Timestamp indicating when the note was created */
  createdAt: Scalars['DateTime']['output'];
  /** The email address of the user who created the note. */
  createdBy: Scalars['String']['output'];
  /** The user who created the note. */
  createdByUser: User;
  /** Important notes can be highlighted in the UI. */
  isImportant: Scalars['Boolean']['output'];
  /** UUID of the network to which this internal note belongs */
  networkUUID: Scalars['UUID']['output'];
  /** Content of the internal note. */
  note: Scalars['String']['output'];
  /** AWS S3 keys for photos attached to the note. */
  photoS3Keys?: Maybe<Array<Scalars['String']['output']>>;
  /** URLs for photos attached to the note. */
  photoURLs?: Maybe<Array<Scalars['String']['output']>>;
  /** Timestamp indicating when the note was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The email address of the user who updated the note most recently. */
  updatedBy?: Maybe<Scalars['String']['output']>;
  /** The user who updated the note most recently. */
  updatedByUser?: Maybe<User>;
};

/**
 * InternetServicePlan represents the configuration associated with an Internet Service Provider (ISP). This includes
 * information about the provider itself, as well as the IP address configurations for the network.
 */
export type InternetServicePlan = {
  __typename?: 'InternetServicePlan';
  /** Unique identifier for the Internet Service Plan. */
  UUID: Scalars['UUID']['output'];
  /** The physical address associated with this Internet Service Plan. */
  address?: Maybe<Address>;
  /** The category of service provided by the ISP (e.g., Dedicated Fiber, Shared Fiber). */
  connectionProduct: IspProduct;
  /** Indicates whether this ISP connection is the primary or backup connection. */
  connectionStatus: IspStatus;
  /**
   * ControllerIP is dynamically resolved from stats coming in to Clickhouse. These stats are reported
   * by the controller.
   */
  controllerIP?: Maybe<Scalars['IPV4']['output']>;
  /**
   * Name of the controller device associated with this Internet Service Plan.
   * @deprecated Use networkUUID instead.
   */
  controllerName?: Maybe<Scalars['String']['output']>;
  /** Timestamp when the Internet Service Plan was created. */
  createdAt: Scalars['DateTime']['output'];
  /** First usable IP address in the static IP range provided by the ISP. */
  firstUsableIP?: Maybe<Scalars['IPV4']['output']>;
  /** Gateway IP address provided by the ISP for routing. */
  gatewayAddr?: Maybe<Scalars['IPV4']['output']>;
  /** Indicates whether the ISP connection has a static IP address or range. */
  hasStaticIP: Scalars['Boolean']['output'];
  /** Last usable IP address in the static IP range provided by the ISP. */
  lastUsableIP?: Maybe<Scalars['IPV4']['output']>;
  /** Unique identifier of the network associated with this Internet Service Plan. */
  networkUUID?: Maybe<Scalars['UUID']['output']>;
  /** The ISP provider associated with this Internet Service Plan. */
  provider?: Maybe<InternetServicePlanProvider>;
  /** CIDR notation of the static IP address range provided by the ISP. */
  staticIPRange?: Maybe<Scalars['IPPrefix']['output']>;
  /** Timestamp when the Internet Service Plan was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** Input type for connection details of an Internet Service Plan. */
export type InternetServicePlanConnectionInput = {
  /** The category of service provided by the ISP (e.g., Dedicated Fiber, Shared Fiber). */
  product: IspProduct;
  /** Indicates whether the ISP connection is the primary or backup connection. */
  status: IspStatus;
};

/** Category of service provided by the ISP connection. */
export type InternetServicePlanConnectionType = {
  __typename?: 'InternetServicePlanConnectionType';
  /** Unique identifier for the ISP connection type. */
  UUID: Scalars['UUID']['output'];
  /** Name of the ISP connection type. Examples: "Dedicated Fiber", "Shared Fiber", "Coax", "Point to Point Wireless", etc. */
  name: Scalars['String']['output'];
};

/** Input type for IP configuration details of an Internet Service Plan. */
export type InternetServicePlanIpInput = {
  /** The IP address of the controller device. */
  controllerIP?: InputMaybe<Scalars['IPV4']['input']>;
  /** Name of the controller device. */
  controllerName?: InputMaybe<Scalars['String']['input']>;
  /** First usable IP address in the ISP-provided static IP range. */
  firstUsableIP?: InputMaybe<Scalars['IPV4']['input']>;
  /** Gateway IP address for routing provided by the ISP. */
  gatewayAddr?: InputMaybe<Scalars['IPV4']['input']>;
  /** Last usable IP address in the ISP-provided static IP range. */
  lastUsableIP?: InputMaybe<Scalars['IPV4']['input']>;
  /** CIDR notation of the static IP address range provided by the ISP. */
  staticIPRange?: InputMaybe<Scalars['IPPrefix']['input']>;
};

/** Represents an Internet Service Plan Provider. */
export type InternetServicePlanProvider = {
  __typename?: 'InternetServicePlanProvider';
  /** Unique identifier for the Internet Service Plan Provider. */
  UUID: Scalars['UUID']['output'];
  /** Alternative names for this provider, used in 3rd-party APIs */
  aliases?: Maybe<Array<InternetServicePlanProviderAlias>>;
  /** AWS S3 key of the square icon image. */
  iconS3Key?: Maybe<Scalars['String']['output']>;
  /** AWS S3 key of the landscape logo image. */
  logoS3Key?: Maybe<Scalars['String']['output']>;
  /** Legacy Logo image. */
  logoURL?: Maybe<Scalars['String']['output']>;
  /** Name of the Internet Service Plan Provider. */
  name: Scalars['String']['output'];
  /** Static rates for this providers products */
  staticRates?: Maybe<Array<InternetServicePlanProviderStaticRate>>;
};

/** Represents an Internet Service Plan Provider Alias. */
export type InternetServicePlanProviderAlias = {
  __typename?: 'InternetServicePlanProviderAlias';
  /** Unique identifier for the Internet Service Plan Provider. */
  UUID: Scalars['UUID']['output'];
  /** Alternative name for Internet Service Provider used in 3rd party APIs */
  alias: Scalars['String']['output'];
};

/** Static rates for a Provider's products. */
export type InternetServicePlanProviderStaticRate = {
  __typename?: 'InternetServicePlanProviderStaticRate';
  /** Unique identifier for the Provider Static Rate. */
  UUID: Scalars['UUID']['output'];
  /** Product type for the rate. */
  connectionType: InternetServicePlanConnectionType;
  /** Timestamp of when the Static Rate was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Download speed Kbps. */
  downloadKbps: Scalars['Int']['output'];
  /** Enabled status of the rate. */
  enabled: Scalars['Boolean']['output'];
  /** Install cost in cents. */
  installCostCents: Scalars['Int']['output'];
  /** Describes dependency of the static rate on a location. */
  locationMode: InternetServicePlanProviderStaticRateLocationMode;
  /** Monthly recurring cost in cents. */
  monthlyCostCents: Scalars['Int']['output'];
  /** Term of contract in months. */
  termMonths: Scalars['Int']['output'];
  /** Timestamp of when the Static Rate was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** Upload speed Kbps. */
  uploadKbps: Scalars['Int']['output'];
};

/** Describes dependency of the static rate on a location. */
export enum InternetServicePlanProviderStaticRateLocationMode {
  /** Static rates do not depend on a location. */
  Agnostic = 'AGNOSTIC',
  /** Static rates depend on location being found in location availabilities sourced from 3rd parties or internal histories. */
  Dynamic = 'DYNAMIC',
}

/**
 * Contains the kea statistics for a specific subnet. Further documentation for these values can be found at
 * https://kea.readthedocs.io/en/kea-2.2.0/arm/dhcp4-srv.html#dhcp4-stats.
 */
export type LatestDhcpRuleStats = {
  __typename?: 'LatestDHCPRuleStats';
  /**
   * Number of assigned addresses in a given subnet. It increases every time a new lease is allocated (as a result of
   * receiving a DHCPREQUEST message) and decreases every time a lease is released (a DHCPRELEASE message is received)
   * or expires.
   */
  assignedAddresses: Scalars['Int']['output'];
  /**
   * Number of IPv4 addresses that are currently declined in a given subnet; a count of the number of leases currently
   * unavailable. Once a lease is recovered, this statistic is decreased; ideally, this statistic should be zero.
   * If this statistic is non-zero or increasing, a network administrator should investigate whether there is a
   * misbehaving device in the network.
   */
  declinedAddresses: Scalars['Int']['output'];
  /**
   * Number of times an IPv4 lease had its CLTT increased in memory and its expiration time left unchanged in persistent
   * storage as part of the lease caching feature. This is referred to as a lease reuse.
   */
  leaseReuses: Scalars['Int']['output'];
  /** The time these stats were observed. */
  observedAt: Scalars['DateTime']['output'];
  /**
   * Number of IPv4 addresses that were declined, but have now been recovered. Unlike declined-addresses, this statistic
   * never decreases. It can be used as a long-term indicator of how many actual valid declines were processed and
   * recovered from.
   */
  reclaimedDeclinedAddresses: Scalars['Int']['output'];
  /**
   * Number of expired leases associated with a given subnet (id is the subnet-id) that have been reclaimed since server
   * startup. It is incremented each time an expired lease is reclaimed.
   */
  reclaimedLeases: Scalars['Int']['output'];
  /**
   * Number of host reservation allocation conflicts which have occurred in a specific subnet. When a client sends a
   * DHCP Discover and is matched to a host reservation which is already leased to another client, this counter is
   * increased by 1.
   */
  reservationConflicts: Scalars['Int']['output'];
  /**
   * Total number of addresses available for DHCPv4 management; in other words, this is the sum of all addresses in all
   * configured pools. This statistic changes only during configuration updates. It does not take into account any
   * addresses that may be reserved due to host reservation.
   */
  totalAddresses: Scalars['Int']['output'];
};

/** Represents the latest CPU load metrics for a device. */
export type LatestDeviceCpuLoad = {
  __typename?: 'LatestDeviceCPULoad';
  /** The timestamp when the CPU load was recorded. */
  timestamp: Scalars['DateTime']['output'];
  /**
   * The used CPU percentage represented as a decimal value between 0 and 1.
   * This value is computed by summing the latest percentages of user, system, soft_irq, and irq CPU times.
   */
  usedPercentage: Scalars['Float']['output'];
};

/** Represents the latest memory usage metrics for a device. */
export type LatestDeviceMemoryUsage = {
  __typename?: 'LatestDeviceMemoryUsage';
  /** The amount of memory currently available for use on the device, in bytes. */
  bytesAvailable: Scalars['Int']['output'];
  /** The total amount of memory on the device, in bytes. */
  bytesTotal: Scalars['Int']['output'];
  /** The amount of memory currently used on the device, in bytes. */
  bytesUsed: Scalars['Int']['output'];
  /** The timestamp when the memory usage was recorded. */
  timestamp: Scalars['DateTime']['output'];
};

/** Represents a mapping between a MAC address and its human-friendly alias within a specific company. */
export type MacAddressAlias = {
  __typename?: 'MACAddressAlias';
  /** The MAC address of the device. */
  MACAddress: Scalars['MacAddress']['output'];
  /** The human-friendly name assigned to the MAC address. */
  alias: Scalars['String']['output'];
  /** The unique slug identifier of the company that owns this MAC address alias. */
  companySlug: Scalars['String']['output'];
};

/** The Switch and PhyInterface that a client MAC address is associated with. */
export type MacAddressSwitchEntry = {
  __typename?: 'MACAddressSwitchEntry';
  /** The physical interface on the switch that the client MAC address is connected to. */
  phyInterface: PhyInterface;
  /** The switch virtual device that the client MAC address is associated with. */
  virtualDevice: VirtualDevice;
};

/** Represents a mailing address with optional coordinates and timezone. */
export type MailingAddress = {
  __typename?: 'MailingAddress';
  /** The unique identifier of the mailing address. */
  UUID: Scalars['UUID']['output'];
  /** The city of the mailing address. */
  city?: Maybe<Scalars['String']['output']>;
  /** The geographical coordinates of the mailing address. */
  coordinates?: Maybe<Coordinates>;
  /** The two-letter ISO code of the country. */
  countryISO2?: Maybe<Scalars['String']['output']>;
  /** The Salesforce Opportunity Location ID corresponding to this mailing address. */
  externalID?: Maybe<Scalars['String']['output']>;
  /** The first line of the mailing address. */
  line1?: Maybe<Scalars['String']['output']>;
  /** The second line of the mailing address. */
  line2?: Maybe<Scalars['String']['output']>;
  /** The postal code or ZIP code of the mailing address. */
  postalCode?: Maybe<Scalars['String']['output']>;
  /** The square footage of the location associated with the mailing address. */
  squareFeet?: Maybe<Scalars['Int']['output']>;
  /** The subdivision code, such as the state or province code. */
  subdivisionCode?: Maybe<Scalars['String']['output']>;
  /** The timezone associated with the mailing address. */
  timezone: Scalars['String']['output'];
};

/** Defines a periodic window of time during which customers prefer that maintenance be performed on a network. */
export type MaintenanceWindow = {
  __typename?: 'MaintenanceWindow';
  /** The unique identifier for the maintenance window. */
  UUID: Scalars['UUID']['output'];
  /** The ending day of the week for the maintenance window, in local time (0-6, where 0 is Sunday). */
  endDayOfWeekLocal?: Maybe<Scalars['Int']['output']>;
  /** The ending hour of the maintenance window, in local time (0-23). */
  endHourOfDayLocal?: Maybe<Scalars['Int']['output']>;
  /** For DAILY recurrence windows only. Specifies days of the week (0-6, where 0 is Sunday) to exclude from the maintenance window. */
  excludedDaysOfWeek?: Maybe<Array<Scalars['Int']['output']>>;
  /** Indicates whether the maintenance window is opted out (true) or not (false). If true, maintenance should not be performed during this window. */
  isOptedOut: Scalars['Boolean']['output'];
  /** The unique identifier of the network associated with this maintenance window. */
  networkUUID: Scalars['UUID']['output'];
  /** The recurrence pattern of the maintenance window (daily or weekly). */
  recurrence: MaintenanceWindowRecurrence;
  /** The starting day of the week for the maintenance window, in local time (0-6, where 0 is Sunday). */
  startDayOfWeekLocal?: Maybe<Scalars['Int']['output']>;
  /** The starting hour of the maintenance window, in local time (0-23). */
  startHourOfDayLocal?: Maybe<Scalars['Int']['output']>;
  /** The IANA timezone identifier (e.g., 'America/New_York') for the maintenance window. */
  timezone?: Maybe<Scalars['String']['output']>;
};

/** Defines the recurrence patterns for maintenance windows. */
export enum MaintenanceWindowRecurrence {
  /** Indicates a daily recurrence pattern. */
  Daily = 'DAILY',
  /** Indicates a weekly recurrence pattern. */
  Weekly = 'WEEKLY',
}

/** Represents the management connection result for a virtual device. */
export type ManagementConnection = {
  __typename?: 'ManagementConnection';
  /** The type of management connection (WAN, LTE, Disconnected, Unknown). */
  connectionType: ManagementConnectionType;
  /** The timestamp when the connection was observed. */
  observedAt: Scalars['DateTime']['output'];
};

/** Enumerates the connection types for management plane traffic to the controller */
export enum ManagementConnectionType {
  /** Indicates that the device is disconnected. */
  Disconnected = 'DISCONNECTED',
  /** Indicates that the device is connected via LTE. */
  Lte = 'LTE',
  /** Indicates that the device is connected via WAN. */
  Wan = 'WAN',
}

/** Marketing changelog entries are used to display informational alerts about product releases to customers. */
export type MarketingChangelogEntry = {
  __typename?: 'MarketingChangelogEntry';
  /** Unique identifier of the marketing changelog entry. */
  UUID: Scalars['UUID']['output'];
  /** Properties to display inside a badge alongside the changelog entry. */
  badge?: Maybe<DisplayBadge>;
  /** Descriptive copy text for the marketing changelog entry. */
  copy?: Maybe<Scalars['String']['output']>;
  /** Timestamp when the entry was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Informational heading text for the marketing changelog entry. */
  heading: Scalars['String']['output'];
  /** S3 keys for an image to display alongside the entry. */
  imageS3Keys?: Maybe<ThemedImageS3Keys>;
  /** A destination to link to that contains more information about the changelog entry. */
  linkURL?: Maybe<Scalars['String']['output']>;
  /** Timestamp when the entry was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** When the entry stops being visible to customers. */
  visibleEndAt: Scalars['DateTime']['output'];
  /** When the entry starts being visible to customers. */
  visibleStartAt: Scalars['DateTime']['output'];
};

export type MetricsFilterInput = {
  /** The total duration in seconds for which to retrieve metrics data. Maximum set to 1 year. */
  durationSeconds: Scalars['Int']['input'];
  /** If not provided, endTime defaults to now. */
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** The interval in seconds between data points in the metrics response. */
  stepSeconds: Scalars['Int']['input'];
};

/** Metadata providing the minimum and maximum values among all metrics data points. */
export type MetricsMetadata = {
  __typename?: 'MetricsMetadata';
  /** The maximum value among all metrics data points. */
  maxValue: Scalars['Float']['output'];
  /** The minimum value among all metrics data points. */
  minValue: Scalars['Float']['output'];
};

/** Represents a response containing metrics data points and associated metadata. */
export type MetricsResponse = {
  /** Metadata providing additional information about the metrics data. */
  metadata?: Maybe<MetricsMetadata>;
  /** The list of metrics data points. */
  values: Array<MetricsValue>;
};

export type MetricsSerialNumberDirectionInput = {
  /** Specify which traffic directions are queried for. */
  directions: Array<TrafficDirection>;
  /** The serial number of the device for which the metrics are requested. */
  serialNumber: Scalars['String']['input'];
};

/** Represents a single data point in a metrics time series, including its timestamp and value. */
export type MetricsValue = {
  /** The timestamp for this metrics data point. */
  timestamp: Scalars['DateTime']['output'];
  /** The value of the metric at the given timestamp. */
  value: Scalars['Float']['output'];
};

export type MintTokenInput = {
  /** The permissions that this token should contain. */
  permissions: Array<Permission>;
  /** The principal name for the token. For devices, the serial number; for machines, the machine name; for users, the user name. */
  principalName: Scalars['String']['input'];
  /** If the principal type is MACHINE, allows assigning a role to the principalName. */
  principalRole?: InputMaybe<RoleName>;
  /** The principal type for the token. */
  principalType: PrincipalType;
  /** How long from now the token is valid. If null, the token does not expire. */
  validityDuration?: InputMaybe<Scalars['Duration']['input']>;
};

/** Represents a newly minted (issued) token. */
export type MintedToken = {
  __typename?: 'MintedToken';
  /** The encoded string of the token. */
  encoded: Scalars['String']['output'];
  /** The epoch time when the token was issued. */
  epoch: Scalars['String']['output'];
  /** The list of permissions assigned to the token. */
  permissions: Array<Permission>;
  /** The principal (entity) for which the token is issued. */
  principal: TokenPrincipal;
  /** The realm associated with the token. */
  realm: Scalars['String']['output'];
  /** The unique identifier assigned to the token. */
  tokenId: Scalars['String']['output'];
  /** The type of the token. */
  tokenType: TokenType;
};

/** The algorithm used for multi-WAN load balancing. */
export enum MultiWanAlgorithm {
  /** Use the first active WAN interface. */
  FirstActive = 'FIRST_ACTIVE',
  /** Distribute traffic across WAN interfaces in a round-robin fashion. */
  RoundRobin = 'ROUND_ROBIN',
}

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type Mutation = {
  __typename?: 'Mutation';
  /** Performs an action on a captive portal entry. */
  actionCaptivePortalEntry: CaptivePortalEntry;
  /** Re-activates a previously deleted company user, allowing them to now log in and access the dashboard for that company as before. */
  activateCompanyUser: CompanyUser;
  /** Activates a Kore Cellular SIM card. */
  activateDeviceSIM?: Maybe<SuperSim>;
  /**
   * Activates a Kore Cellular SIM card.
   * @deprecated Use `activateDeviceSIM` instead.
   */
  activateDeviceTwilioCellular?: Maybe<SuperSim>;
  /** Adds a network to an Auto VPN Group. */
  addNetworkToAutoVPNGroup: AutoVpnMember;
  /** Adds networks to an Auto VPN Group. */
  addNetworksToAutoVPNGroup: Array<AutoVpnMember>;
  /**
   * Applies all of the configuration of a source network to a destination network.
   * The behavior is a Copy + Replace operation (ie. the destination network will have the same configuration as the source network).
   * Some network-specific fields are not copied, and the hardware from the source network is not assigned to the destination network.
   * This can only be performed on a non-active destination network because it will overwrite the configuration.
   * This is a dangerous operation and should be used only by Meter operators who know what they are doing, to kick-start a new network with the same configuration as an existing network.
   * For now the two networks must belong to the same company.
   */
  applyTemplateToNetwork: Network;
  /**
   * This assigns hardware to any virtual device in a network that matches the same type/model as the hardware.
   * Not to be confused with assignSpareHardwareDeviceToNetwork.
   * If the hardware was already associated to the network as a spare, then it will be removed from the spare list.
   */
  assignHardwareDeviceToNetwork: HardwareDevice;
  /**
   * This does not assign the hardware to a virtual device, but rather to the network as a spare device.
   * Need to call assignHardwareDeviceToVirtualDevice / assignHardwareDeviceToNetwork to actually put the hardware to use.
   */
  assignHardwareDeviceToNetworkAsSpare: HardwareDevice;
  /**
   * This assigns hardware to a specific virtual device.
   * Not to be confused with assignSpareHardwareDeviceToNetwork.
   * If the hardware was already associated to the network as a spare, then it will be removed from the spare list.
   */
  assignHardwareDeviceToVirtualDevice: HardwareDevice;
  /**
   * This assigns hardware to specific virtual devices, respectively.
   * If any hardware were already associated to the network as a spare, then they will be removed from the spare list.
   */
  assignHardwareDevicesToVirtualDevices: Array<HardwareDevice>;
  /** Assigns the role of operator to the user represented by this company user. */
  assignOperatorRole: CompanyUser;
  /** Assign a switch profile to a virtual device. */
  assignSwitchProfleToVirtualDevice: Scalars['Boolean']['output'];
  /** Add a device to a rack elevation. */
  attachDeviceToRackElevation: RackElevation;
  /** Attaches an AP to a radio profile so that the AP can inherit the radio settings. */
  attachVirtualDeviceToRadioProfile: VirtualDevice;
  /** Binds a firewall rule to a phy interface with a given metric. Subsequent calls act as an upsert. */
  bindFirewallRuleToPhyInterface: FirewallRule;
  /** Binds a firewall rule to a VLAN with a given metric. Subsequent calls act as an upsert. */
  bindFirewallRuleToVLAN: FirewallRule;
  /**
   * Binds firewall rules to a phy interface, assigning metrics based on the UUIDs' order in `orderedRuleUUIDs`.
   * Any existing bound rules not present in `orderedRuleUUIDs` will be unbound.
   * @deprecated Use `bindPhyInterfaceToFirewallRules` instead.
   */
  bindFirewallRulesToPhyInterface: Array<FirewallPhyInterfaceBinding>;
  /**
   * Binds firewall rules to a VLAN, assigning metrics based on the UUIDs' order in `orderedRuleUUIDs`.
   * Any existing bound rules not present in `orderedRuleUUIDs` will be unbound.
   * @deprecated Use `bindVLANToFirewallRules` instead.
   */
  bindFirewallRulesToVLAN: Array<FirewallVlanBinding>;
  /**
   * Binds firewall rules to a phy interface.
   * Any existing bound rules not present in `firewallRuleUUIDs` will be unbound.
   */
  bindPhyInterfaceToFirewallRules: Array<FirewallPhyInterfaceBinding>;
  /** Bind a policy routing rule to a physical interface. */
  bindPolicyRoutingRule: PolicyRoutingRule;
  /**
   * Binds `input` to `orderedRuleUUIDs`, assigning metrics based on the order in `orderedRuleUUIDs`.
   * Any existing bound rules to `input` not present in `orderedRuleUUIDs` will be unbound.
   */
  bindPolicyRoutingRules: Array<PolicyRoutingRuleBinding>;
  /** Attach a rate limit rule to a physical interface (port). */
  bindRateLimitRuleToPhyInterface: RateLimitRule;
  /** Attach a rate limit rule to an SSID. */
  bindRateLimitRuleToSSID: RateLimitRule;
  /** Attach a rate limit rule to a VLAN. */
  bindRateLimitRuleToVLAN: RateLimitRule;
  /** Add a virtual device tag to one or many virtual devices. For now this is only supported for APs. */
  bindTagToVirtualDevices: Array<VirtualDevice>;
  /**
   * Binds firewall rules to a VLAN.
   * Any existing bound rules not present in `firewallRuleUUIDs` will be unbound.
   */
  bindVLANToFirewallRules: Array<FirewallVlanBinding>;
  /** Bind a VLAN to a physical interface to permit traffic for the VLAN to flow through the port. */
  bindVLANtoPhyInterface: Scalars['Boolean']['output'];
  /**
   * Blocks one or more clients on the given network
   * Returns the newly created blocklist entries.
   */
  blockClientsInNetwork: Array<NetworkClientBlocklistEntry>;
  /** Cancel a scheduled Auto Channel Selection job that hasn't run yet. */
  cancelAutoChannelSelectionJob: AutoChannelSelectionJob;
  /** Cancel a scheduled Auto Switch Configuration job that hasn't run yet. */
  cancelAutoSwitchConfigurationJob: SwitchAutoConfigurationJob;
  /** Cancel a scheduled NOS upgrade. Must be SCHEDULED or IN_PROGRESS (if forceInProgressCancel is true). */
  cancelScheduledNetworkNOSUpgrade: ScheduledNetworkNosUpgrade;
  /** User-facing mutation that performs the full flow of enabling SSO for a company, creating a permitted email domain, and generating an admin portal URI for SSO configuration. */
  configureSSO: ConfigureSsoResult;
  /**
   * Creates an alert receiver and mappings between an alert receiver and one or more alert targets
   * Alert targets must be predefined unless the alert target type is EMAIL. In that case, the email address must be
   * provided and alertTargetUUID can be left empty. An email target will be created automatically.
   */
  createAlertReceiverWithTargets: AlertReceiver;
  /** Create a new slack alert target to notify users via slack of network events. */
  createAlertTargetSlack: AlertTargetSlack;
  /** Create a new webhook alert target to notify users via webhook of network events. */
  createAlertTargetWebhook: AlertTargetWebhook;
  /** Creates a new application DNS firewall rule for a DHCP rule. */
  createApplicationDNSFirewallRule: ApplicationDnsFirewallRule;
  /** Creates an Auto VPN Group. */
  createAutoVPNGroup: AutoVpnGroup;
  /** Creates an Auto VPN route on an Auto VPN Group. */
  createAutoVPNRoute: AutoVpnRoute;
  /**
   * Automatically creates WiFi Observer settings for this network, based on APs in range of Observers: for each Observer,
   * we get all the APs in range from the scan data; then, for every SSID and band in the filters, we create
   * a WifiObserverSetting with the parameters in CreateAutoWifiObserverSettingInput.
   */
  createAutoWifiObserverSettings: Array<Maybe<WifiObserverSetting>>;
  /** Creates a new bearer session. This mutation initiates a CLI bearer session that can be verified to obtain an authentication token. */
  createBearerSession: BearerSession;
  /** Create a new bulk NOS upgrade for a group of networks. */
  createBulkNOSUpgrade: BulkNosUpgrade;
  /** Creates a captive portal for a network. */
  createCaptivePortal: CaptivePortal;
  /** Create entry for auth request on a captive portal for the given network. */
  createCaptivePortalEntry: CaptivePortalEntry;
  /** Creates a Client VPN client on a Client VPN server. */
  createClientVPNClient: ClientVpnClient;
  /** Creates a Client VPN server for a network. */
  createClientVPNServer: ClientVpnServer;
  /** Create a new internal-only company. Customer companies cannot be created; they are created by the Salesforce -> Backend data sync process. */
  createCompany: Company;
  /** Creates a new company onboarding document associated with the specified company. */
  createCompanyOnboarding: CompanyOnboarding;
  /** Creates a SIEM integration for a company. */
  createCompanySIEMIntegration: CompanySiemIntegration;
  /** Creates a company user with the specified fields. If a user with the specified email already exists, this will be a no-op. */
  createCompanyUser: CompanyUser;
  /** Create a new DHCP option. */
  createDHCPOption: DhcpOption;
  /** Create a new DHCP proxy. */
  createDHCPProxy: DhcpProxy;
  /** Create a new DHCP reserved range. */
  createDHCPReservedRange: DhcpReservedRange;
  /** Create a new DHCP rule. */
  createDHCPRule: DhcpRule;
  /** Creates a new DHCP rule filter. */
  createDHCPRuleFilter: DhcpRuleFilter;
  /** Create a new DHCP static mapping. */
  createDHCPStaticMapping: DhcpStaticMapping;
  /** Create a new DNS host mapping. */
  createDNSHostMapping: DnsHostMapping;
  /** Invoke this method in dev to create a new device in the dev realm. This is done before invoking `setHardwareDeviceIsDev` above. */
  createDevHardwareDevice: HardwareDevice;
  /**
   * Creates a device heartbeat configuration for a device.
   * @deprecated Field no longer supported
   */
  createDeviceHeartbeat: DeviceHeartbeat;
  /** Creates a new 802.1X encryption configuration for a network. */
  createEncryption8021X: Encryption8021X;
  /** Create a new firewall rule. */
  createFirewallRule: FirewallRule;
  /** Create a fleetwide notification setting for an alert definition. */
  createFleetwideNotificationSetting: FleetwideNotificationSetting;
  /** Create a fleetwide notification snooze. */
  createFleetwideNotificationSnooze: FleetwideNotificationSnooze;
  /** Create a new floor plan within a specific network. */
  createFloorPlan: FloorPlan;
  /** Combine two security appliances on the same network into an HA pair using VRRP. */
  createHighAvailabilityControllersConfiguration: HighAvailabilityControllersConfig;
  /** Create a new host monitoring target. */
  createHostMonitoringTarget: HostMonitoringTarget;
  /** Creates a IDS IPS config for a network. There can be a single config for the network. No-op if one already exists. */
  createIDSIPSConfig: IdsipsConfig;
  /** Create a custom rule for an IDS configuration. */
  createIDSIPSCustomRule: IdsipsCustomRule;
  /** Create an IP forwarding rule for a network. */
  createIPForwardingRule: IpForwardingRule;
  /** Create a new IPSec tunnel. */
  createIPSecTunnel: IpSecTunnel;
  /** Create a new internal note. */
  createInternalNote: InternalNote;
  /** Creates a new InternetServicePlan for the given network. */
  createInternetServicePlan: InternetServicePlan;
  /** Creates a new InternetServicePlanProvider. */
  createInternetServicePlanProvider: InternetServicePlanProvider;
  /** Creates a new Internet Service Plan Provider Static Rate. */
  createInternetServicePlanProviderStaticRate: InternetServicePlanProviderStaticRate;
  /**
   * Creates a new Knock token for the authenticated user and company. The token is valid for 24 hours and used to authenticate
   * Knock integrations.
   */
  createKnockToken: Scalars['String']['output'];
  /**
   * This is a deprecated mutation.
   * @deprecated We no longer support direct creation of mailing addresses.
   */
  createMailingAddress: MailingAddress;
  /** Create a new marketing changelog entry. */
  createMarketingChangelogEntry: MarketingChangelogEntry;
  /** Create a new NOS upgrade group for a network. */
  createNOSUpgradeGroup: NosUpgradeGroup;
  /** Create an internal network for an internal company. Users cannot create customer networks under customer companies; they are created by the Salesforce -> Backend data sync process. */
  createNetwork: Network;
  /** Create network client CPE bindings on a network. */
  createNetworkClientCPEBindings: Array<NetworkClientCpeBinding>;
  /** Creates a new network onboarding document associated with the specified network. */
  createNetworkOnboarding: NetworkOnboarding;
  /** Create a NetworkThreatAllowlistEntry for a network. */
  createNetworkThreatAllowlistEntry: NetworkThreatAllowlistEntry;
  /** Create a new NOS feature. */
  createNosFeature: NosFeature;
  /** Creates a new NOS (Network Operating System) version, including the build strings for various device types. */
  createNosVersion: NosVersion;
  /** Create a new notification setting. */
  createNotificationSetting: NotificationSetting;
  /** Create a notification snooze. */
  createNotificationSnooze: NotificationSnooze;
  /** Create a new 1:1 NAT rule in the specified network. */
  createOneToOneNATRule: OneToOneNatRule;
  /** Create a new permitted email domain for a company. This feature is largely out-of-use in favor of SSO. */
  createPermittedEmailDomain: PermittedEmailDomain;
  /** Create a policy routing rule for a network. */
  createPolicyRoutingRule: PolicyRoutingRule;
  /** Create a port forwarding rule for a network. */
  createPortForwardingRule: PortForwardingRule;
  /** Generates a pre-signed URL for uploading a file to S3. */
  createPreSignedUploadUrl: FileUploadPayload;
  /** Create a rack elevation for a network. */
  createRackElevation: RackElevation;
  /** Create a radio profile for a network. */
  createRadioProfile: RadioProfile;
  /** Create a rate limit rule for a network. */
  createRateLimitRule: RateLimitRule;
  /** Create an SSID for a network. */
  createSSID: Ssid;
  /** Creates a WorkOS admin portal link for the specified company and purpose. */
  createSSOAdminPortalLink: ConfigureSsoResult;
  /**
   * Creates an SSO dashboard for the specified company.
   * @deprecated Field no longer supported
   */
  createSSODashboardForCompany: CreateSsoDashboardForCompanyResult;
  /**
   * Creates a redirect URI for SSO login. Prefer to use login.meter.* instead.
   * @deprecated Field no longer supported
   */
  createSSORedirectURI: CreateSsoRedirectUriResult;
  /** Verifies the token provided via the WorkOS callback. */
  createSSOVerify: CreateSsoVerifyResult;
  /** Fetch and save a Slack access token for a company. */
  createSlackAccessToken: SlackAccessToken;
  /** Creates SSO OAuth URIs for Google and Microsoft authentication. */
  createSsoOAuthURI: CreateSsoOAuthUriResult;
  /** Create a new static route. */
  createStaticRoute: StaticRoute;
  /** Bind MAC addresses or OUIs to VLANs before running Switch Auto Config. */
  createSwitchAutoConfigMACAddressVLANBindings: Array<SwitchAutoConfigMacAddressVlanBinding>;
  /** Create a new switch profile. */
  createSwitchProfile: SwitchProfile;
  /** Create a template network from another network, which can subsequently be used to create new networks with the same configuration. */
  createTemplateFromNetwork: Network;
  /** Provides an internal Operator user access to a network to provide elevated permissions like SSH access. */
  createUserNetworkAccess: Scalars['Boolean']['output'];
  /** Create a new VLAN. */
  createVLAN: Vlan;
  /** Create multiple new VLANs. */
  createVLANs: Array<Vlan>;
  /** Create a virtual device. */
  createVirtualDevice: VirtualDevice;
  /** Create a virtual device tag. */
  createVirtualDeviceTag: VirtualDeviceTag;
  /** Create many virtual devices of the same type and model. */
  createVirtualDevices: Array<VirtualDevice>;
  /** Create multiple virtual devices each with different parameters. */
  createVirtualDevicesIndependently: Array<VirtualDevice>;
  /** Create a new Wifi IPSK. */
  createWifiIPSK: WifiIpsk;
  /** Create new Wifi Observer Settings. */
  createWifiObserverSettings: Array<Maybe<WifiObserverSetting>>;
  /** Deactivates a Kore Cellular SIM card. */
  deactivateDeviceSIM?: Maybe<SuperSim>;
  /**
   * Deactivates a Kore Cellular SIM card.
   * @deprecated Use `deactivateDeviceSIM` instead.
   */
  deactivateDeviceTwilioCellular?: Maybe<SuperSim>;
  /** Deletes an alert receiver and all of its targets. */
  deleteAlertReceiverWithTargets: AlertReceiver;
  /** Deletes a slack alert target specified by its UUID. */
  deleteAlertTargetSlack: AlertTargetSlack;
  /** Deletes a webhook alert target specified by its UUID. */
  deleteAlertTargetWebhook: AlertTargetWebhook;
  /** Delete all Wifi IPSKs for this SSID. */
  deleteAllWifiIPSKsForSSID: Array<WifiIpsk>;
  /** Deletes an application DNS firewall rule. */
  deleteApplicationDNSFirewallRule: ApplicationDnsFirewallRule;
  /** Deletes an Auto VPN Group. Deleting an Auto VPN Group deletes all group members. */
  deleteAutoVPNGroup: AutoVpnGroup;
  /** Deletes an Auto VPN route on an Auto VPN Group. */
  deleteAutoVPNRoute: AutoVpnRoute;
  /** Delete a bulk NOS upgrade. Cannot delete a bulk upgrade that has non-PENDING scheduled NOS upgrades. */
  deleteBulkNOSUpgrade: BulkNosUpgrade;
  /** Deletes a captive portal. */
  deleteCaptivePortal: CaptivePortal;
  /** Deletes a Client VPN client. */
  deleteClientVPNClient: Scalars['Boolean']['output'];
  /** Deletes a Client VPN server. */
  deleteClientVPNServer: Scalars['Boolean']['output'];
  /** Deletes a company onboarding document. */
  deleteCompanyOnboardingDocument: CompanyOnboardingDocument;
  /** Deletes a field delegation. */
  deleteCompanyOnboardingFieldDelegation: CompanyOnboardingFieldDelegation;
  /** Deletes a SIEM integration. */
  deleteCompanySIEMIntegration: CompanySiemIntegration;
  /** Deletes the specified company user, preventing them from logging in and accessing the dashboard for that company. */
  deleteCompanyUser: CompanyUser;
  /** Delete a DHCP option by its UUID. */
  deleteDHCPOption: DhcpOption;
  /** Delete a DHCP proxy by its UUID. */
  deleteDHCPProxy: DhcpProxy;
  /** Delete a DHCP reserved range by its UUID. */
  deleteDHCPReservedRange: DhcpReservedRange;
  /** Delete a DHCP rule by its UUID. */
  deleteDHCPRule: DhcpRule;
  /** Deletes a DHCP rule filter by its UUID */
  deleteDHCPRuleFilter: DhcpRuleFilter;
  /** Delete a DHCP static mapping by its UUID. */
  deleteDHCPStaticMapping: DhcpStaticMapping;
  /** Delete a DNS host mapping by its UUID. */
  deleteDNSHostMapping: DnsHostMapping;
  /** Deletes a device heartbeat configuration. */
  deleteDeviceHeartbeat: Scalars['Boolean']['output'];
  /** Deletes an existing 802.1X encryption configuration. */
  deleteEncryption8021X: Encryption8021X;
  /** Delete a firewall rule. */
  deleteFirewallRule: FirewallRule;
  /** Deletes a fleetwide notification setting. */
  deleteFleetwideNotificationSetting: FleetwideNotificationSetting;
  /** Delete a notification snooze. */
  deleteFleetwideNotificationSnooze: FleetwideNotificationSnooze;
  /** Delete an existing floor plan. */
  deleteFloorPlan: FloorPlan;
  /** Delete the HA configuration for the given network. */
  deleteHighAvailabilityControllersConfiguration: HighAvailabilityControllersConfig;
  /** Delete an existing host monitoring target. */
  deleteHostMonitoringTarget: HostMonitoringTarget;
  /** Deletes the IDS IPS config for a network. */
  deleteIDSIPSConfig: IdsipsConfig;
  /** Delete a category configuration for an IDS/IPS configuration. */
  deleteIDSIPSConfigCategoryBinding: IdsipsConfigCategoryBinding;
  /** Delete a configured rule for an IDS/IPS configuration. */
  deleteIDSIPSConfigRuleBinding: IdsipsConfigRuleBinding;
  /** Delete a custom rule for an IDS configuration. */
  deleteIDSIPSCustomRule: IdsipsCustomRule;
  /** Delete an IP forwarding rule. */
  deleteIPForwardingRule: IpForwardingRule;
  /** Delete an IPSec tunnel. */
  deleteIPSecTunnel: IpSecTunnel;
  /** Delete an internal note. */
  deleteInternalNote: InternalNote;
  /** Deletes an existing InternetServicePlan. */
  deleteInternetServicePlan: Scalars['Boolean']['output'];
  /** Deletes an existing Internet Service Plan Provider Static Rate. */
  deleteInternetServicePlanProviderStaticRate: Scalars['Boolean']['output'];
  /** Delete an existing marketing changelog entry. */
  deleteMarketingChangelogEntry: MarketingChangelogEntry;
  /** Delete a NOS upgrade group if no devices are assigned to it. */
  deleteNOSUpgradeGroup: NosUpgradeGroup;
  /** Mark a network as soft-deleted. Customer networks cannot be deleted. Careful, this is a very dangerous operation! */
  deleteNetwork: Network;
  /** Delete network client CPE bindings on a network. */
  deleteNetworkClientCPEBindings: Array<NetworkClientCpeBinding>;
  /** Deletes a network onboarding document. */
  deleteNetworkOnboardingDocument: NetworkOnboardingDocument;
  /** Deletes a field delegation. */
  deleteNetworkOnboardingFieldDelegation: NetworkOnboardingFieldDelegation;
  /** Delete a NetworkThreatAllowlistEntry for a network. */
  deleteNetworkThreatAllowlistEntry: NetworkThreatAllowlistEntry;
  /** Deletes a NOS version. Only NOS versions that are not associated with any networks can be deleted. */
  deleteNosVersion: NosVersion;
  /**
   * Deletes a notification preference by UUID.
   * @deprecated No longer supported.
   */
  deleteNotificationPreference: NotificationPreferences;
  /** Delete a notification setting. */
  deleteNotificationSetting: NotificationSetting;
  /** Delete a notification snooze. */
  deleteNotificationSnooze: NotificationSnooze;
  /** Delete an existing 1:1 NAT rule by its UUID. */
  deleteOneToOneNATRule: OneToOneNatRule;
  /** Delete a permitted email domain for a company. */
  deletePermittedEmailDomain: DeletePermittedEmailDomainResult;
  /** Delete a policy routing rule. */
  deletePolicyRoutingRule: PolicyRoutingRule;
  /**
   * Delete a port forwarding rule.
   * @deprecated Use deletePortForwardingRules instead
   */
  deletePortForwardingRule: PortForwardingRule;
  /** Delete multiple port forwarding rules. */
  deletePortForwardingRules: Array<PortForwardingRule>;
  /** Delete a rack elevation. */
  deleteRackElevation: Scalars['Boolean']['output'];
  /** Delete a radio profile. */
  deleteRadioProfile: RadioProfile;
  /** Delete a rate limit rule. */
  deleteRateLimitRule: RateLimitRule;
  /** Delete an SSID. */
  deleteSSID: Ssid;
  /** Delete a Slack access token. */
  deleteSlackAccessToken: SlackAccessToken;
  /** Delete all Slack access tokens for a company. */
  deleteSlackAccessTokensForCompany: SlackAccessToken;
  /** Delete a static route. */
  deleteStaticRoute: StaticRoute;
  /** Un-bind a MAC address or OUI from a VLAN before running Switch Auto Config. */
  deleteSwitchAutoConfigMACAddressVLANBinding: SwitchAutoConfigMacAddressVlanBinding;
  /** Delete a VLAN. */
  deleteVLAN: Scalars['Boolean']['output'];
  /** Delete a virtual device and all associated entities. Be sure you know what you're doing, this is a hard deletion! Returns an error if the virtual device is assigned to hardware. */
  deleteVirtualDevice: VirtualDevice;
  /** Delete a virtual device tag. */
  deleteVirtualDeviceTag: VirtualDeviceTag;
  /** Delete multiple virtual devices and all associated entities. Be sure you know what you're doing! Returns an error if any of the virtual devices are assigned to hardware. */
  deleteVirtualDevices: Array<VirtualDevice>;
  /** Delete a Wifi IPSK. */
  deleteWifiIPSK: WifiIpsk;
  /** Delete a Wifi Observer Setting. */
  deleteWifiObserverSetting: WifiObserverSetting;
  /** Delete all Wifi Observer Settings for the network. */
  deleteWifiObserverSettingsForNetwork: Array<Maybe<WifiObserverSetting>>;
  /** Delete all Wifi Observer Settings for an Observer. */
  deleteWifiObserverSettingsForObserver: Array<Maybe<WifiObserverSetting>>;
  /** Delete all Wifi Observer Settings for the SSID. */
  deleteWifiObserverSettingsForSSID: Array<Maybe<WifiObserverSetting>>;
  /** Delete all Wifi Observer Settings for an AP target. */
  deleteWifiObserverSettingsForTarget: Array<Maybe<WifiObserverSetting>>;
  /** Remove a device from a rack elevation. */
  detachDeviceFromRackElevation: Scalars['Boolean']['output'];
  /** Detaches an AP from a radio profile. The AP will inherit its network's default radio profile settings. */
  detachVirtualDeviceFromRadioProfile: VirtualDevice;
  /** Edit the reason specified for why a mutation was made in the audit log. */
  editMutationAuditLogEntryReason: Scalars['Boolean']['output'];
  /** Edits the reason specified for why a mutation was made in the diff audit log entry. */
  editMutationDiffAuditLogEntryReason: Scalars['Boolean']['output'];
  /** Enables SSO for a company. */
  enableSSOForCompany: Company;
  /**
   * Force a sync of the Salesforce -> Backend data sync process for all existing companies.
   * Used when backfilling a new synced field that needs to be populated for all companies.
   * Returns the River Job ID.
   * This should only be invoked by engineers who know what they are doing.
   */
  forceSalesforceSyncCompanies: Scalars['Int']['output'];
  /**
   * Force a sync of the Salesforce -> Backend data sync process for all existing networks and their mailing addresses.
   * Used when backfilling a new synced field that needs to be populated for all networks.
   * Returns the River Job ID.
   * This should only be invoked by engineers who know what they are doing.
   */
  forceSalesforceSyncNetworks: Scalars['Int']['output'];
  /** Generate a power plan given a calibration job uuid and other interference inputs. */
  generatePowerPlanForNetwork: PowerPlan;
  /**
   * Initialize and start a job to run Auto Channel Selection for a single AP.
   * The process takes some time, so an AutoChannelSelectionJob is returned to track the progress.
   * @deprecated Prefer initializeAutoChannelSelectionForAccessPoints instead.
   */
  initializeAutoChannelSelectionForAccessPoint: AutoChannelSelectionJob;
  /**
   * Initialize and start a job to run Auto Channel Selection for a list of APs.
   * The process takes some time, so an AutoChannelSelectionJob is returned to track the progress.
   */
  initializeAutoChannelSelectionForAccessPoints: AutoChannelSelectionJob;
  /**
   * Initialize and start a job to run Auto Channel Selection for all APs in a network.
   * The process takes some time, so an AutoChannelSelectionJob is returned to track the progress.
   */
  initializeAutoChannelSelectionForNetwork: AutoChannelSelectionJob;
  /** Initialize and start a job to run Auto Switch Configuration for a network. */
  initializeAutoSwitchConfigurationForNetwork: SwitchAutoConfigurationJob;
  /** Add fake stats to a demo company for sales demonstration purposes. */
  insertStatsForDemo: Scalars['Boolean']['output'];
  /** Mint a new authentication token. */
  mintAuthenticationToken: MintedToken;
  /** Moves an internet service plan to a given network. The network must belong to the company currently associated with the ISP. */
  moveInternetServicePlanToNetwork: InternetServicePlan;
  /** Always returns true and does nothing. */
  noop: Scalars['Boolean']['output'];
  /** Pins the configurations for devices in a network to the versions at the given timestamp. Be very careful; use only in outage situations! */
  pinDeviceConfigsForNetwork: Network;
  /** Reactivates a Kore Cellular SIM card. */
  reactivateDeviceSIM?: Maybe<SuperSim>;
  /**
   * Reactivates a Kore Cellular SIM card.
   * @deprecated Use `reactivateDeviceSIM` instead.
   */
  reactivateDeviceTwilioCellular?: Maybe<SuperSim>;
  /**
   * Reassign a network from one company to another by applying the first network's configuration to the second network. Soft-deletes the destination network, replacing it with a new network with the same configuration as the source network.
   * The hardware from the source network is unassigned from the source network and assigned to the destination network.
   * The main use case for this is when a new customer moves into a space that was previously occupied by a different customer.
   * This is a very dangerous operation and will cause immediate disruption to both the source and destination networks. It should be used only by users who are very clear on what they are doing.
   */
  reassignNetwork: Network;
  /** Removes a network from an Auto VPN Group. */
  removeNetworkFromAutoVPNGroup: Scalars['Boolean']['output'];
  /** Removes networks from an Auto VPN Group. */
  removeNetworksFromAutoVPNGroup: Scalars['Boolean']['output'];
  /** Remove networks that were previously added to a pending NOS upgrade. */
  removeNetworksFromBulkNOSUpgrade: BulkNosUpgrade;
  /** Removes the role of operator from the user represented by this company user. */
  removeOperatorRole: CompanyUser;
  /**
   * Invoke a rendering of the latest configuration for a device.
   * Does the same thing as the device-facing `GET /v2/devices/:serial_number/config` endpoint.
   */
  renderDeviceConfig: DeviceConfig;
  /** Revoke an existing authentication token. */
  revokeAuthenticationToken: AuthenticationToken;
  /** Rotates the HMAC secret for a given captive portal. */
  rotateCaptivePortalSecret: CaptivePortal;
  /** Blink the LEDs on a device. */
  rpcBlinkLEDs: Scalars['Boolean']['output'];
  /** Instruct a device to clear its list of configs that were marked as bad. */
  rpcClearBlockedConfigs: Scalars['Boolean']['output'];
  /** Cycle an outlet on a Power Distribution Unit (PDU). */
  rpcPDUOutletCycle: Scalars['Boolean']['output'];
  /** Instruct a device to ping out to a host. */
  rpcPing: RpcPingResponse;
  /** Instruct a device to run a cable test on a port. */
  rpcPortCableTest: RpcCableTestResponse;
  /** Instruct a device to reboot.. */
  rpcRebootDevice: Scalars['Boolean']['output'];
  /** Instruct many devices to reboot in parallel. */
  rpcRebootDevices: Array<RpcRebootDeviceResponse>;
  /** Instruct a device to pull its latest config from the backend. */
  rpcRefreshConfig: Scalars['Boolean']['output'];
  /** Instruct a device to recreate a specified IPSec tunnel. */
  rpcRestartIPSecTunnel: Scalars['Boolean']['output'];
  /** Cycle a port on a switch. */
  rpcSwitchPortCycle: Scalars['Boolean']['output'];
  /**
   * Instruct a device to run a WAN speed test.
   * @deprecated Unused due to issues with implementation. Use startWANSpeedtestJob on config 2 networks.
   */
  rpcWANSpeedtest: RpcwanSpeedtestResponse;
  /** Instruct a device to start a network wide wireless calibration job. */
  rpcWirelessCalibrationStart: RpcWirelessCalibrationResponse;
  /** Disconnect a client from an AP. */
  rpcWosDisconnectClient: Scalars['Boolean']['output'];
  /** Instruct a device to run an EAPOL test to check RADIUS connectivity. */
  rpcWosEapolTestForSerial: RpcEapolTestForSerialResponse;
  /** Instruct devices to run EAPOL tests to check RADIUS connectivity. */
  rpcWosEapolTestForSerials: Array<RpcEapolTestForSerialResponse>;
  /** Instruct devices to run or get results for an Observer test. */
  rpcWosObserver: RpcWosObserverResponse;
  /** Instruct an AP to start a packet capture on specified monitor interfaces. */
  rpcWosPacketCaptureStart: RpcWosPacketCaptureResponse;
  /** Instruct an AP to stop a packet capture on specified monitor interfaces. */
  rpcWosPacketCaptureStop: RpcWosPacketCaptureResponse;
  /** Reset the radio for a specific band on a device. */
  rpcWosRadioReset: Scalars['Boolean']['output'];
  /** Reset Dynamic Frequency Selection (DFS) channels on an AP. */
  rpcWosResetDfs: Scalars['Boolean']['output'];
  /** Enqueue a single run of a River Job to run immediately by specifying the job kind and arguments. This should only be invoked by engineers who know what they are doing. Returns the River Job ID. */
  runRiverJob: Scalars['Int']['output'];
  /** Send a test event for a SIEM integration. */
  sendCompanySIEMIntegrationTestEvent: Scalars['Boolean']['output'];
  /** Invoke this method in prod to route a device to the dev realm. This clears the registration info and requires the device to re-register. */
  setHardwareDeviceIsDev: Scalars['Boolean']['output'];
  /** Set an arbitrary value, unique to the authenticated user. */
  setKeyValue?: Maybe<Scalars['JSON']['output']>;
  /** Sets the NOS version for a network, resulting in a firmware upgrade or downgrade being applied to all devices within the network. */
  setNetworkNosVersion: Scalars['Boolean']['output'];
  /**
   * Binds a policy routing rule to `input`, assigning metrics based on the order in `input`.
   * Any existing bound rules not present in `input` will be unbound.
   */
  setPolicyRoutingRuleBindings: Array<PolicyRoutingRuleBinding>;
  /** Sign a console login challenge, allowing the user to log in to the device. */
  signConsoleLoginChallenge: SignedConsoleLoginChallenge;
  /** Begin a WAN speed test job with the given input parameters. */
  startWANSpeedtestJob: WanSpeedtestJob;
  /** Begin a wireless calibration job with the given input parameters. */
  startWirelessCalibrationJob: WirelessCalibrationJob;
  /** Suppress applied IPS rules. */
  suppressIPSRules: Scalars['Boolean']['output'];
  /** Runs the test fire alert for an alert receiver which will always result in failure and then notification. */
  testFireAlert?: Maybe<TestFireAlertResult>;
  /**
   * Test triggering a webhook alert target by simulating an event.
   *
   * The API is unstable and may change or be removed at any time.
   */
  testTriggerWebhookAlertTarget: TestTriggerAlertTargetWebhookResponse;
  /** Unassign the given hardware from its virtual device, if any. */
  unassignHardwareDeviceFromVirtualDevice: HardwareDevice;
  /** Unassigns hardware from the list of virtual devices. Be sure you know what you're doing! */
  unassignHardwareFromVirtualDevices: Array<VirtualDevice>;
  /** Removes the association of an internet service plan from any network it was previously assigned to. */
  unassignInternetServicePlanFromNetwork: InternetServicePlan;
  /** Unassign the hardware from the network as a spare device. */
  unassignSpareHardwareDeviceFromNetwork: HardwareDevice;
  /** Unbinds a firewall rule from a physical interface. */
  unbindFirewallRuleFromPhyInterface: FirewallRule;
  /** Unbinds a firewall rule from a VLAN. */
  unbindFirewallRuleFromVLAN: FirewallRule;
  /** Unbind a policy routing rule from a physical interface. */
  unbindPolicyRoutingRule: PolicyRoutingRule;
  /** Detach a rate limit rule from a physical interface (port). */
  unbindRateLimitRuleFromPhyInterface: RateLimitRule;
  /** Detach a rate limit rule from a VLAN. */
  unbindRateLimitRuleFromSSID: RateLimitRule;
  /** Detach a rate limit rule from a VLAN. */
  unbindRateLimitRuleFromVLAN: RateLimitRule;
  /** Remove a virtual device tag from one or many virtual devices. For now this is only supported for APs. */
  unbindTagFromVirtualDevices: Array<VirtualDevice>;
  /**
   * Unblocks one or more clients on the given network.
   * Returns 'true' if the deletion succeeded.
   */
  unblockClientsInNetwork: Array<NetworkClientBlocklistEntry>;
  /** Un-soft-delete a network. Should only be used in special circumstances. */
  undeleteNetwork: Network;
  /** For trial networks only: undoes the expiry of a trial network. Un-deletes the trial network and un-deletes users / role assignments for the company. */
  unexpireTrialNetwork: Network;
  /** Unpins the configurations for devices in a network if they were previously pinned. Be very careful; use only in outage situations! */
  unpinDeviceConfigsForNetwork: Network;
  /** Invoke this method in prod to route a dev device back to the prod realm. This clears the registration info and requires the device to re-register. */
  unsetHardwareDeviceIsDev: Scalars['Boolean']['output'];
  /** Updates an alert receiver and its targets. */
  updateAlertReceiverWithTargets: AlertReceiver;
  /** Update an existing slack alert target. */
  updateAlertTargetSlack: AlertTargetSlack;
  /** Update an existing webhook alert target. */
  updateAlertTargetWebhook: AlertTargetWebhook;
  /** Updates an existing application DNS firewall rule. */
  updateApplicationDNSFirewallRule: ApplicationDnsFirewallRule;
  /** Updates the visibility of applications for DNS firewall rules. */
  updateApplicationDNSFirewallRuleApplicationVisibilities: Array<
    Maybe<ApplicationDnsFirewallRuleApplication>
  >;
  /** Updates a existing application DNS firewall rules. */
  updateApplicationDNSFirewallRules: Array<ApplicationDnsFirewallRule>;
  /**
   * Updates a list of rules to the specified priorities. Returns all updated rules.
   * Rules must be associated with the same network and DHCP rule.
   * If any provided priority is already taken, the request fails.
   * @deprecated Use `updateApplicationDNSFirewallRules` instead.
   */
  updateApplicationDNSFirewallRulesPriorities: Array<ApplicationDnsFirewallRule>;
  /** Updates an Auto VPN Group, only allowing updates to the hub. */
  updateAutoVPNGroup: AutoVpnGroup;
  /** Updates an Auto VPN Member. */
  updateAutoVPNMember: AutoVpnMember;
  /** Updates an Auto VPN route on an Auto VPN Group. */
  updateAutoVPNRoute: AutoVpnRoute;
  /** Updates a captive portal. */
  updateCaptivePortal: CaptivePortal;
  /** Updates a Client VPN client. */
  updateClientVPNClient: ClientVpnClient;
  /** Updates a Client VPN server. */
  updateClientVPNServer: ClientVpnServer;
  /** Update a limited set of fields on a company. Many fields are owned by Salesforce and cannot be updated via this endpoint. */
  updateCompany: Company;
  /** Updates a SIEM integration. */
  updateCompanySIEMIntegration: CompanySiemIntegration;
  /** Updates the specified company user with the provided fields. Note that the email field cannot be updated. */
  updateCompanyUser: CompanyUser;
  /** Update an existing DHCP option by its UUID. */
  updateDHCPOption: DhcpOption;
  /** Update an existing DHCP proxy by its UUID. */
  updateDHCPProxy: DhcpProxy;
  /** Update an existing DHCP reserved range by its UUID. */
  updateDHCPReservedRange: DhcpReservedRange;
  /** Update an existing DHCP rule by its UUID. */
  updateDHCPRule: DhcpRule;
  /** Update an existing DHCP static mapping by its UUID. */
  updateDHCPStaticMapping: DhcpStaticMapping;
  /** Update an existing DNS host mapping by its UUID. */
  updateDNSHostMapping: DnsHostMapping;
  /** Updates the default role for users in an organization */
  updateDefaultRoleForUsers: DefaultRoleForUsersResponse;
  /** Updates an existing 802.1X encryption configuration. */
  updateEncryption8021X: Encryption8021X;
  /** Update a firewall rule. */
  updateFirewallRule: FirewallRule;
  /** Updates multiple firewall rules at once. */
  updateFirewallRules: Array<FirewallRule>;
  /** Update a fleetwide notification setting. */
  updateFleetwideNotificationSetting: FleetwideNotificationSetting;
  /** Update a notification snooze. */
  updateFleetwideNotificationSnooze: FleetwideNotificationSnooze;
  /** Update the details of an existing floor plan. */
  updateFloorPlan: FloorPlan;
  /**
   * Consumes a cellular failover event in the stats pipeline and triggers an alert to escalate the issue to the support team.
   * @deprecated Field no longer supported
   */
  updateForCellularFailoverEvent: Scalars['Boolean']['output'];
  /**
   * Update the status for a high availability event.
   * This is intended to only be called by the stat-consumer.
   */
  updateForHighAvailabilityEvent: Scalars['Boolean']['output'];
  /** Update the metadata of a hardware device. */
  updateHardwareDevice: HardwareDevice;
  /** Update an existing high availability configuration between two security appliances. */
  updateHighAvailabilityControllersConfiguration: HighAvailabilityControllersConfig;
  /** Update an existing host monitoring target. */
  updateHostMonitoringTarget: HostMonitoringTarget;
  /** Updates the IDS IPS config for a network. */
  updateIDSIPSConfig: IdsipsConfig;
  /** Update a custom rule for an IDS configuration. */
  updateIDSIPSCustomRule: IdsipsCustomRule;
  /** Update an IP forwarding rule. */
  updateIPForwardingRule: IpForwardingRule;
  /** Update an IPSec tunnel. */
  updateIPSecTunnel: IpSecTunnel;
  /** Sets the permitted pairs for this network to these pairs, discarding others. Equivalent to PUT semantics. */
  updateInterVLANCommunicationPermittedPairs: Array<InterVlanCommunicationPermittedPair>;
  /** Update an internal note. */
  updateInternalNote: InternalNote;
  /** Updates an existing InternetServicePlan with the provided fields. */
  updateInternetServicePlan: InternetServicePlan;
  /** Updates an existing InternetServicePlanProvider with the provided fields. Replaces aliases. */
  updateInternetServicePlanProvider: InternetServicePlanProvider;
  /** Updates an existing Internet Service Plan Provider Static Rate with the provided fields. */
  updateInternetServicePlanProviderStaticRate: InternetServicePlanProviderStaticRate;
  /** Updates existing Internet Service Plan Provider Static Rates in bulk. */
  updateInternetServicePlanProviderStaticRates?: Maybe<
    Array<InternetServicePlanProviderStaticRate>
  >;
  /**
   * This is a deprecated mutation.
   * @deprecated We no longer support direct updating of mailing addresses.
   */
  updateMailingAddress: MailingAddress;
  /** Updates the maintenance window for a network. */
  updateMaintenanceWindowForNetwork: MaintenanceWindow;
  /** Update an existing marketing changelog entry. */
  updateMarketingChangelogEntry: MarketingChangelogEntry;
  /** Update the metadata of an existing NOS upgrade group (not the devices contained in the group). */
  updateNOSUpgradeGroup: NosUpgradeGroup;
  /** Update many NOS upgrade groups at once. */
  updateNOSUpgradeGroups: Array<NosUpgradeGroup>;
  /** Update a network. */
  updateNetwork: Network;
  /** Update a NetworkThreatAllowlistEntry for a network. */
  updateNetworkThreatAllowlistEntry: NetworkThreatAllowlistEntry;
  /** Update an existing NOS feature. */
  updateNosFeature: NosFeature;
  /** Updates an existing NOS version with new data. */
  updateNosVersion: NosVersion;
  /**
   * Updates a notification preference by UUID.
   * @deprecated No longer supported.
   */
  updateNotificationPreference: NotificationPreferences;
  /** Update a notification setting. */
  updateNotificationSetting: NotificationSetting;
  /** Update a notification snooze. */
  updateNotificationSnooze: NotificationSnooze;
  /** Update an existing 1:1 NAT rule by its UUID. */
  updateOneToOneNATRule: OneToOneNatRule;
  /** Update an outlet interface. */
  updateOutletInterface: OutletInterface;
  /** Update multiple outlet interfaces. */
  updateOutletInterfaces: Array<OutletInterface>;
  /** Update multiple outlet interfaces independently and atomically. */
  updateOutletInterfacesIndependently: Array<OutletInterface>;
  /** Update a physical interface. */
  updatePhyInterface: PhyInterface;
  /** This mutation is intended to be called only by the Kafka consumer. It updates the physical interface for a Multi-WAN event. */
  updatePhyInterfaceForMultiWANEvent: Scalars['Boolean']['output'];
  /** Update multiple physical interfaces to the same values. */
  updatePhyInterfaces: Array<PhyInterface>;
  /** Update multiple phy interfaces simultaneously and atomically, each with independent parameters. Only a subset of parameters are supported. */
  updatePhyInterfacesIndependently: Array<PhyInterface>;
  /** Update a policy routing rule. */
  updatePolicyRoutingRule: PolicyRoutingRule;
  /** Update a port forwarding rule. */
  updatePortForwardingRule: PortForwardingRule;
  /** Update a rack elevation. */
  updateRackElevation: RackElevation;
  /** Update a device in a rack elevation. */
  updateRackElevationDevice: RackElevation;
  /** Update a radio profile. */
  updateRadioProfile: RadioProfile;
  /** Update a rate limit rule. */
  updateRateLimitRule: RateLimitRule;
  /** Update multiple rate limit rules with independent values. */
  updateRateLimitRulesIndependently: Array<RateLimitRule>;
  /** Update an SSID. */
  updateSSID: Ssid;
  /** Updates a single security appliance profile. */
  updateSecurityApplianceProfile: SecurityApplianceProfile;
  /** Update all security appliance profiles belonging to a given network. */
  updateSecurityApplianceProfilesForNetwork: Array<SecurityApplianceProfile>;
  /** Fetch and update a Slack access token. */
  updateSlackAccessToken: SlackAccessToken;
  /** Update a static route. */
  updateStaticRoute: StaticRoute;
  /** Update an existing switch profile. */
  updateSwitchProfile: SwitchProfile;
  /** This mutation is intended to be called only by the Kafka consumer. It updates the external addresses of an uplink physical interface. */
  updateUplinkPhyInterfaceExternalAddresses: Scalars['Boolean']['output'];
  /**
   * Updates a user's roles to be only those specified by the input.
   *
   * Any existing roles not included in the input will be removed.
   */
  updateUserRoles: CompanyUser;
  /** Update an existing VLAN. */
  updateVLAN: Vlan;
  /** Sets the permitted pairs for this VLAN to these other VLANs, discarding others. Equivalent to PUT semantics. */
  updateVLANInterVLANCommunicationPermittedVLANs: Vlan;
  /** Update many VLANs at once, applying different settings to each. */
  updateVLANsIndependently: Array<Vlan>;
  /** Update the metadata of a virtual device. */
  updateVirtualDevice: VirtualDevice;
  /** Update a virtual device tag. */
  updateVirtualDeviceTag: VirtualDeviceTag;
  /** Update the metadata of multiple virtual devices at once, to the same values for all devices. */
  updateVirtualDevices: Array<VirtualDevice>;
  /** Update the metadata of multiple virtual devices at once, to different values for each device. */
  updateVirtualDevicesIndependently: Array<VirtualDevice>;
  /** Update a Wifi IPSK's client MACs */
  updateWifiIPSK: WifiIpsk;
  /**
   * Upserts notification preferences for a company.
   * @deprecated No longer supported.
   */
  upsertCompanyNotificationPreference: NotificationPreferences;
  /**
   * Creates or updates the company onboarding document using PUT semantics.
   * The document is keyed by `companyUUID` for convenience.
   */
  upsertCompanyOnboardingDocument: CompanyOnboardingDocument;
  /** Delegates specific fields of the company onboarding document to a user. */
  upsertCompanyOnboardingFieldDelegation: CompanyOnboardingFieldDelegation;
  /** Only use this in development or extreme outage situations! Overrides the rendered configuration for a device with the given JSON. */
  upsertDeviceConfigOverride: Scalars['Boolean']['output'];
  /** Configure a category for an IDS/IPS configuration. */
  upsertIDSIPSConfigCategoryBinding: IdsipsConfigCategoryBinding;
  /** Configure a rule for an IDS configuration. */
  upsertIDSIPSConfigRuleBinding: IdsipsConfigRuleBinding;
  /** Creates a new alias for a MAC address or updates an existing one within a specified company. */
  upsertMACAddressAlias: MacAddressAlias;
  /**
   * Upserts notification preferences for a network.
   * @deprecated No longer supported.
   */
  upsertNetworkNotificationPreference: NotificationPreferences;
  /**
   * Creates or updates the network onboarding document using PUT semantics.
   * The document is keyed by `networkUUID` for convenience.
   */
  upsertNetworkOnboardingDocument: NetworkOnboardingDocument;
  /** Delegates specific fields of the network onboarding document to a user. */
  upsertNetworkOnboardingFieldDelegation: NetworkOnboardingFieldDelegation;
  /** Bind MAC addresses or OUIs to VLANs before running Switch Auto Config. The mappings provided here will replace any existing mappings for the specified network, deleting any pre-existing mappings not included in the input. */
  upsertSwitchAutoConfigMACAddressVLANBindingsForNetwork: Array<SwitchAutoConfigMacAddressVlanBinding>;
  /** Validates a bearer session using its UUID. Should only be called a single time. Once validated, the bearer session can be used to authenticate. */
  validateBearerSession: BearerSession;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationActionCaptivePortalEntryArgs = {
  action: CaptivePortalEntryAction;
  entryUUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationActivateCompanyUserArgs = {
  companyUserUUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationActivateDeviceSimArgs = {
  input: SimActivationInput;
  serialNumber: Scalars['String']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationActivateDeviceTwilioCellularArgs = {
  input: TwilioCellularActivationInput;
  serialNumber: Scalars['String']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationAddNetworkToAutoVpnGroupArgs = {
  groupUUID: Scalars['UUID']['input'];
  input: AddNetworkToAutoVpnGroupInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationAddNetworksToAutoVpnGroupArgs = {
  groupUUID: Scalars['UUID']['input'];
  inputs: Array<AddNetworkToAutoVpnGroupInput>;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationApplyTemplateToNetworkArgs = {
  destinationNetworkUUID: Scalars['UUID']['input'];
  shouldKeepSSIDNames?: Scalars['Boolean']['input'];
  sourceNetworkUUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationAssignHardwareDeviceToNetworkArgs = {
  networkUUID: Scalars['UUID']['input'];
  serialNumber: Scalars['String']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationAssignHardwareDeviceToNetworkAsSpareArgs = {
  networkUUID: Scalars['UUID']['input'];
  serialNumber: Scalars['String']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationAssignHardwareDeviceToVirtualDeviceArgs = {
  serialNumber: Scalars['String']['input'];
  virtualDeviceUUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationAssignHardwareDevicesToVirtualDevicesArgs = {
  inputs: Array<AssignHardwareDeviceToVirtualDeviceInput>;
  networkUUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationAssignOperatorRoleArgs = {
  companyUserUUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationAssignSwitchProfleToVirtualDeviceArgs = {
  UUID: Scalars['UUID']['input'];
  virtualDeviceUUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationAttachDeviceToRackElevationArgs = {
  input: AttachDeviceToRackElevationInput;
  rackElevationUUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationAttachVirtualDeviceToRadioProfileArgs = {
  radioProfileUUID: Scalars['UUID']['input'];
  virtualDeviceUUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationBindFirewallRuleToPhyInterfaceArgs = {
  input: BindFirewallRuleToPhyInterface;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationBindFirewallRuleToVlanArgs = {
  input: BindFirewallRuleToVlan;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationBindFirewallRulesToPhyInterfaceArgs = {
  orderedRuleUUIDs: Array<Scalars['UUID']['input']>;
  phyInterfaceUUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationBindFirewallRulesToVlanArgs = {
  orderedRuleUUIDs: Array<Scalars['UUID']['input']>;
  vlanUUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationBindPhyInterfaceToFirewallRulesArgs = {
  firewallRuleUUIDs: Array<Scalars['UUID']['input']>;
  phyInterfaceUUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationBindPolicyRoutingRuleArgs = {
  UUID: Scalars['UUID']['input'];
  input: BindPolicyRoutingRuleInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationBindPolicyRoutingRulesArgs = {
  input: BindPolicyRoutingRulesInput;
  orderedRuleUUIDs: Array<Scalars['UUID']['input']>;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationBindRateLimitRuleToPhyInterfaceArgs = {
  input: RateLimitPhyInterfaceBindingInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationBindRateLimitRuleToSsidArgs = {
  input: RateLimitSsidBindingInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationBindRateLimitRuleToVlanArgs = {
  input: RateLimitVlanBindingInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationBindTagToVirtualDevicesArgs = {
  tagUUID: Scalars['UUID']['input'];
  virtualDeviceUUIDs: Array<Scalars['UUID']['input']>;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationBindVlanToFirewallRulesArgs = {
  firewallRuleUUIDs: Array<Scalars['UUID']['input']>;
  vlanUUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationBindVlaNtoPhyInterfaceArgs = {
  input: BindVlanToPhyInterfaceInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationBlockClientsInNetworkArgs = {
  macAddresses?: InputMaybe<Array<Scalars['MacAddress']['input']>>;
  networkUUID: Scalars['UUID']['input'];
  ouis?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCancelAutoChannelSelectionJobArgs = {
  jobUUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCancelAutoSwitchConfigurationJobArgs = {
  jobUUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCancelScheduledNetworkNosUpgradeArgs = {
  forceInProgressCancel?: Scalars['Boolean']['input'];
  scheduledNetworkNOSUpgradeUUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationConfigureSsoArgs = {
  input: ConfigureSsoInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateAlertReceiverWithTargetsArgs = {
  companyUUID: Scalars['UUID']['input'];
  input: CreateAlertReceiverWithTargetsInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateAlertTargetSlackArgs = {
  companyUUID: Scalars['UUID']['input'];
  input: CreateAlertTargetSlackInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateAlertTargetWebhookArgs = {
  companyUUID: Scalars['UUID']['input'];
  input: CreateAlertTargetWebhookInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateApplicationDnsFirewallRuleArgs = {
  dhcpRuleUUID?: InputMaybe<Scalars['UUID']['input']>;
  input: CreateApplicationDnsFirewallRuleInput;
  networkUUID?: InputMaybe<Scalars['UUID']['input']>;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateAutoVpnGroupArgs = {
  companySlug: Scalars['String']['input'];
  input: CreateAutoVpnGroupInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateAutoVpnRouteArgs = {
  groupUUID: Scalars['UUID']['input'];
  input: CreateAutoVpnRouteInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateAutoWifiObserverSettingsArgs = {
  input: CreateAutoWifiObserverSettingInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateBulkNosUpgradeArgs = {
  input: CreateBulkNosUpgradeInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateCaptivePortalArgs = {
  input: CaptivePortalSettingsInput;
  networkUUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateCaptivePortalEntryArgs = {
  captivePortalUUID: Scalars['UUID']['input'];
  input: CaptivePortalEntryInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateClientVpnClientArgs = {
  input: CreateClientVpnClientInput;
  serverUUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateClientVpnServerArgs = {
  input: CreateClientVpnServerInput;
  networkUUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateCompanyArgs = {
  input: CreateCompanyInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateCompanyOnboardingArgs = {
  companyUUID: Scalars['UUID']['input'];
  jobTrackerID: Scalars['String']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateCompanySiemIntegrationArgs = {
  companyUUID: Scalars['UUID']['input'];
  input: CreateCompanySiemIntegrationInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateCompanyUserArgs = {
  companySlug: Scalars['String']['input'];
  input: CreateCompanyUserInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateDhcpOptionArgs = {
  dhcpRuleUUID: Scalars['UUID']['input'];
  input: CreateDhcpOptionInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateDhcpProxyArgs = {
  dhcpRuleUUID: Scalars['UUID']['input'];
  input: CreateDhcpProxyInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateDhcpReservedRangeArgs = {
  dhcpRuleUUID: Scalars['UUID']['input'];
  input: CreateDhcpReservedRangeInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateDhcpRuleArgs = {
  input: CreateDhcpRuleInput;
  vlanUUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateDhcpRuleFilterArgs = {
  dhcpRuleUUID: Scalars['UUID']['input'];
  input: CreateDhcpRuleFilterInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateDhcpStaticMappingArgs = {
  dhcpRuleUUID: Scalars['UUID']['input'];
  input: CreateDhcpStaticMappingInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateDnsHostMappingArgs = {
  dhcpRuleUUID: Scalars['UUID']['input'];
  input: CreateDnsHostMappingInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateDevHardwareDeviceArgs = {
  input: CreateDevHardwareDeviceInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateDeviceHeartbeatArgs = {
  input: CreateDeviceHeartbeatInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateEncryption8021XArgs = {
  input: CreateEncryption8021XInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateFirewallRuleArgs = {
  input: CreateFirewallRuleInput;
  networkUUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateFleetwideNotificationSettingArgs = {
  input: CreateFleetwideNotificationSettingInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateFleetwideNotificationSnoozeArgs = {
  companyUUID?: InputMaybe<Scalars['UUID']['input']>;
  fleetwideNotificationSettingUUID?: InputMaybe<Scalars['UUID']['input']>;
  input: CreateNotificationSnoozeInput;
  networkUUID?: InputMaybe<Scalars['UUID']['input']>;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateFloorPlanArgs = {
  input: CreateFloorPlanInput;
  networkUUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateHighAvailabilityControllersConfigurationArgs = {
  backupPhyInterfaceUUID: Scalars['UUID']['input'];
  input: CreateHighAvailabilityPairInput;
  networkUUID: Scalars['UUID']['input'];
  primaryPhyInterfaceUUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateHostMonitoringTargetArgs = {
  input: CreateHostMonitoringTargetInput;
  networkUUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateIdsipsConfigArgs = {
  input: CreateIdsipsConfigInput;
  networkUUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateIdsipsCustomRuleArgs = {
  idsIPSConfigUUID: Scalars['UUID']['input'];
  input: CreateIdsipsCustomRuleInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateIpForwardingRuleArgs = {
  input: CreateIpForwardingRuleInput;
  networkUUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateIpSecTunnelArgs = {
  input: CreateIpSecTunnelInput;
  networkUUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateInternalNoteArgs = {
  input: CreateInternalNoteInput;
  networkUUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateInternetServicePlanArgs = {
  companySlug: Scalars['String']['input'];
  input: CreateInternetServicePlanInput;
  networkUUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateInternetServicePlanProviderArgs = {
  input: CreateInternetServicePlanProviderInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateInternetServicePlanProviderStaticRateArgs = {
  input: CreateInternetServicePlanProviderStaticRateInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateKnockTokenArgs = {
  companyUUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateMailingAddressArgs = {
  input: CreateMailingAddressInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateMarketingChangelogEntryArgs = {
  input: CreateMarketingChangelogEntryInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateNosUpgradeGroupArgs = {
  input: CreateNosUpgradeGroupInput;
  networkUUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateNetworkArgs = {
  input: CreateNetworkInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateNetworkClientCpeBindingsArgs = {
  inputs: Array<CreateNetworkClientCpeBindingInput>;
  networkUUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateNetworkOnboardingArgs = {
  jobTrackerID: Scalars['String']['input'];
  networkUUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateNetworkThreatAllowlistEntryArgs = {
  input: CreateNetworkThreatAllowlistEntryInput;
  networkUUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateNosFeatureArgs = {
  input: CreateNosFeatureInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateNosVersionArgs = {
  input: NosVersionInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateNotificationSettingArgs = {
  input: CreateNotificationSettingInput;
  networkUUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateNotificationSnoozeArgs = {
  companyUUID?: InputMaybe<Scalars['UUID']['input']>;
  input: CreateNotificationSnoozeInput;
  networkUUID?: InputMaybe<Scalars['UUID']['input']>;
  notificationSettingUUID?: InputMaybe<Scalars['UUID']['input']>;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateOneToOneNatRuleArgs = {
  input: CreateOneToOneNatRuleInput;
  networkUUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreatePermittedEmailDomainArgs = {
  input: CreatePermittedEmailDomainInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreatePolicyRoutingRuleArgs = {
  input: CreatePolicyRoutingRuleInput;
  networkUUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreatePortForwardingRuleArgs = {
  input: CreatePortForwardingRuleInput;
  networkUUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreatePreSignedUploadUrlArgs = {
  input: CreatePreSignedUploadUrlInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateRackElevationArgs = {
  input: CreateRackElevationInput;
  networkUUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateRadioProfileArgs = {
  input: CreateRadioProfileInput;
  networkUUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateRateLimitRuleArgs = {
  input: CreateRateLimitRuleInput;
  networkUUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateSsidArgs = {
  input: CreateSsidInput;
  networkUUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateSsoAdminPortalLinkArgs = {
  input?: InputMaybe<ConfigureSsoInput>;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateSsoDashboardForCompanyArgs = {
  companySlug: Scalars['String']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateSsoRedirectUriArgs = {
  targetApp: Scalars['String']['input'];
  userEmail: Scalars['String']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateSsoVerifyArgs = {
  input: CreateSsoVerifyInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateSlackAccessTokenArgs = {
  companyUUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateSsoOAuthUriArgs = {
  targetApp: Scalars['String']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateStaticRouteArgs = {
  input: CreateStaticRouteInput;
  networkUUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateSwitchAutoConfigMacAddressVlanBindingsArgs = {
  input: Array<CreateSwitchAutoConfigMacAddressVlanBindingInput>;
  networkUUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateSwitchProfileArgs = {
  input: CreateSwitchProfileInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateTemplateFromNetworkArgs = {
  destinationCompanyUUID: Scalars['UUID']['input'];
  label: Scalars['String']['input'];
  sourceNetworkUUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateUserNetworkAccessArgs = {
  input: CreateUserNetworkAccessInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateVlanArgs = {
  input: CreateVlanInput;
  networkUUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateVlaNsArgs = {
  inputs: Array<CreateVlanInput>;
  networkUUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateVirtualDeviceArgs = {
  input: CreateVirtualDeviceInput;
  networkUUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateVirtualDeviceTagArgs = {
  input: CreateVirtualDeviceTagInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateVirtualDevicesArgs = {
  input: CreateVirtualDevicesInput;
  networkUUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateVirtualDevicesIndependentlyArgs = {
  input: Array<CreateVirtualDeviceInput>;
  networkUUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateWifiIpskArgs = {
  input: CreateWifiIpskInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateWifiObserverSettingsArgs = {
  input: Array<CreateWifiObserverSettingInput>;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeactivateDeviceSimArgs = {
  serialNumber: Scalars['String']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeactivateDeviceTwilioCellularArgs = {
  serialNumber: Scalars['String']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteAlertReceiverWithTargetsArgs = {
  alertReceiverUUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteAlertTargetSlackArgs = {
  UUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteAlertTargetWebhookArgs = {
  UUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteAllWifiIpsKsForSsidArgs = {
  ssidUUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteApplicationDnsFirewallRuleArgs = {
  UUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteAutoVpnGroupArgs = {
  UUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteAutoVpnRouteArgs = {
  UUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteBulkNosUpgradeArgs = {
  UUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteCaptivePortalArgs = {
  uuid: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteClientVpnClientArgs = {
  UUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteClientVpnServerArgs = {
  UUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteCompanyOnboardingDocumentArgs = {
  UUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteCompanyOnboardingFieldDelegationArgs = {
  UUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteCompanySiemIntegrationArgs = {
  UUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteCompanyUserArgs = {
  companyUserUUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteDhcpOptionArgs = {
  UUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteDhcpProxyArgs = {
  UUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteDhcpReservedRangeArgs = {
  UUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteDhcpRuleArgs = {
  UUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteDhcpRuleFilterArgs = {
  UUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteDhcpStaticMappingArgs = {
  UUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteDnsHostMappingArgs = {
  UUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteDeviceHeartbeatArgs = {
  input: DeleteDeviceHeartbeatInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteEncryption8021XArgs = {
  UUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteFirewallRuleArgs = {
  UUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteFleetwideNotificationSettingArgs = {
  UUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteFleetwideNotificationSnoozeArgs = {
  UUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteFloorPlanArgs = {
  UUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteHighAvailabilityControllersConfigurationArgs = {
  UUID?: InputMaybe<Scalars['UUID']['input']>;
  networkUUID?: InputMaybe<Scalars['UUID']['input']>;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteHostMonitoringTargetArgs = {
  UUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteIdsipsConfigArgs = {
  UUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteIdsipsConfigCategoryBindingArgs = {
  idsIPSCategoryUUID: Scalars['UUID']['input'];
  idsIPSConfigUUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteIdsipsConfigRuleBindingArgs = {
  idsIPSConfigUUID: Scalars['UUID']['input'];
  ruleSID: Scalars['Int']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteIdsipsCustomRuleArgs = {
  UUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteIpForwardingRuleArgs = {
  UUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteIpSecTunnelArgs = {
  UUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteInternalNoteArgs = {
  UUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteInternetServicePlanArgs = {
  internetServicePlanUUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteInternetServicePlanProviderStaticRateArgs = {
  UUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteMarketingChangelogEntryArgs = {
  UUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteNosUpgradeGroupArgs = {
  nosUpgradeGroupUUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteNetworkArgs = {
  UUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteNetworkClientCpeBindingsArgs = {
  UUIDs: Array<Scalars['UUID']['input']>;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteNetworkOnboardingDocumentArgs = {
  UUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteNetworkOnboardingFieldDelegationArgs = {
  UUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteNetworkThreatAllowlistEntryArgs = {
  UUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteNosVersionArgs = {
  id: Scalars['Int']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteNotificationPreferenceArgs = {
  uuid: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteNotificationSettingArgs = {
  UUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteNotificationSnoozeArgs = {
  UUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteOneToOneNatRuleArgs = {
  UUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeletePermittedEmailDomainArgs = {
  input: DeletePermittedEmailDomainInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeletePolicyRoutingRuleArgs = {
  UUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeletePortForwardingRuleArgs = {
  UUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeletePortForwardingRulesArgs = {
  UUIDs: Array<Scalars['UUID']['input']>;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteRackElevationArgs = {
  UUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteRadioProfileArgs = {
  UUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteRateLimitRuleArgs = {
  UUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteSsidArgs = {
  uuid: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteSlackAccessTokenArgs = {
  uuid: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteSlackAccessTokensForCompanyArgs = {
  companyUUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteStaticRouteArgs = {
  UUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteSwitchAutoConfigMacAddressVlanBindingArgs = {
  UUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteVlanArgs = {
  UUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteVirtualDeviceArgs = {
  virtualDeviceUUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteVirtualDeviceTagArgs = {
  tagUUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteVirtualDevicesArgs = {
  virtualDeviceUUIDs: Array<Scalars['UUID']['input']>;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteWifiIpskArgs = {
  uuid: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteWifiObserverSettingArgs = {
  input: DeleteWifiObserverSettingInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteWifiObserverSettingsForNetworkArgs = {
  networkUUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteWifiObserverSettingsForObserverArgs = {
  virtualDeviceUUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteWifiObserverSettingsForSsidArgs = {
  ssidUUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteWifiObserverSettingsForTargetArgs = {
  virtualDeviceUUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDetachDeviceFromRackElevationArgs = {
  UUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDetachVirtualDeviceFromRadioProfileArgs = {
  radioProfileUUID: Scalars['UUID']['input'];
  virtualDeviceUUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationEditMutationAuditLogEntryReasonArgs = {
  UUID: Scalars['UUID']['input'];
  reason: Scalars['String']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationEditMutationDiffAuditLogEntryReasonArgs = {
  UUID: Scalars['UUID']['input'];
  reason: Scalars['String']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationEnableSsoForCompanyArgs = {
  companySlug: Scalars['String']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationGeneratePowerPlanForNetworkArgs = {
  calibrationJobUUID: Scalars['UUID']['input'];
  commit?: Scalars['Boolean']['input'];
  input: PowerPlanInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationInitializeAutoChannelSelectionForAccessPointArgs = {
  input: AutoChannelSelectionJobInput;
  virtualDeviceUUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationInitializeAutoChannelSelectionForAccessPointsArgs = {
  input: AutoChannelSelectionJobInput;
  virtualDeviceUUIDs: Array<Scalars['UUID']['input']>;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationInitializeAutoChannelSelectionForNetworkArgs = {
  input: AutoChannelSelectionJobInput;
  networkUUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationInitializeAutoSwitchConfigurationForNetworkArgs = {
  input: SwitchAutoConfigurationJobInput;
  networkUUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationInsertStatsForDemoArgs = {
  companySlug: Scalars['String']['input'];
  duration?: InputMaybe<StatInjectionDuration>;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationMintAuthenticationTokenArgs = {
  input?: InputMaybe<MintTokenInput>;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationMoveInternetServicePlanToNetworkArgs = {
  internetServicePlanUUID: Scalars['UUID']['input'];
  networkUUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationPinDeviceConfigsForNetworkArgs = {
  maxDeviceConfigCreatedAt: Scalars['DateTime']['input'];
  networkUUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationReactivateDeviceSimArgs = {
  serialNumber: Scalars['String']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationReactivateDeviceTwilioCellularArgs = {
  serialNumber: Scalars['String']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationReassignNetworkArgs = {
  destinationNetworkUUID: Scalars['UUID']['input'];
  sourceNetworkUUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationRemoveNetworkFromAutoVpnGroupArgs = {
  groupUUID: Scalars['UUID']['input'];
  networkUUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationRemoveNetworksFromAutoVpnGroupArgs = {
  groupUUID: Scalars['UUID']['input'];
  networkUUIDs: Array<Scalars['UUID']['input']>;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationRemoveNetworksFromBulkNosUpgradeArgs = {
  UUID: Scalars['UUID']['input'];
  networkUUIDs: Array<Scalars['UUID']['input']>;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationRemoveOperatorRoleArgs = {
  companyUserUUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationRenderDeviceConfigArgs = {
  serialNumber: Scalars['String']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationRevokeAuthenticationTokenArgs = {
  UUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationRotateCaptivePortalSecretArgs = {
  uuid: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationRpcBlinkLeDsArgs = {
  durationSec?: Scalars['Int']['input'];
  serialNumber: Scalars['String']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationRpcClearBlockedConfigsArgs = {
  serialNumber: Scalars['String']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationRpcPduOutletCycleArgs = {
  input: RpcpduOutletCycleInput;
  serialNumber: Scalars['String']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationRpcPingArgs = {
  input: RpcPingInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationRpcPortCableTestArgs = {
  portNumber: Scalars['Int']['input'];
  serialNumber: Scalars['String']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationRpcRebootDeviceArgs = {
  serialNumber: Scalars['String']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationRpcRebootDevicesArgs = {
  serialNumbers: Array<Scalars['String']['input']>;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationRpcRefreshConfigArgs = {
  serialNumber: Scalars['String']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationRpcRestartIpSecTunnelArgs = {
  ipSecTunnelUUID: Scalars['UUID']['input'];
  serialNumber: Scalars['String']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationRpcSwitchPortCycleArgs = {
  input: RpcSwitchPortCycleInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationRpcWanSpeedtestArgs = {
  input: RpcwanSpeedtestInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationRpcWirelessCalibrationStartArgs = {
  input: RpcWirelessCalibrationInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationRpcWosDisconnectClientArgs = {
  mac: Scalars['String']['input'];
  serialNumber: Scalars['String']['input'];
  ssid: Scalars['String']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationRpcWosEapolTestForSerialArgs = {
  input?: InputMaybe<RpcEapolTestForSerialInput>;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationRpcWosEapolTestForSerialsArgs = {
  input: RpcEapolTestForSerialsInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationRpcWosObserverArgs = {
  input: RpcWosObserverInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationRpcWosPacketCaptureStartArgs = {
  input: RpcWosPacketCaptureStartInput;
  serialNumber: Scalars['String']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationRpcWosPacketCaptureStopArgs = {
  input: RpcWosPacketCaptureStopInput;
  serialNumber: Scalars['String']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationRpcWosRadioResetArgs = {
  band: RadioBand;
  serialNumber: Scalars['String']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationRpcWosResetDfsArgs = {
  serialNumber: Scalars['String']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationRunRiverJobArgs = {
  jobArgs: Scalars['JSON']['input'];
  jobKind: Scalars['String']['input'];
  scheduledAt?: InputMaybe<Scalars['DateTime']['input']>;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationSendCompanySiemIntegrationTestEventArgs = {
  UUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationSetHardwareDeviceIsDevArgs = {
  serialNumber: Scalars['String']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationSetKeyValueArgs = {
  key: Scalars['String']['input'];
  value?: InputMaybe<Scalars['JSON']['input']>;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationSetNetworkNosVersionArgs = {
  input: SetNetworkNosVersionInput;
  networkUUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationSetPolicyRoutingRuleBindingsArgs = {
  UUID: Scalars['UUID']['input'];
  input: SetPolicyRoutingRuleBindingsInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationSignConsoleLoginChallengeArgs = {
  challenge: Scalars['String']['input'];
  serialNumber: Scalars['String']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationStartWanSpeedtestJobArgs = {
  input: StartWanSpeedtestJobInput;
  networkUUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationStartWirelessCalibrationJobArgs = {
  input: StartWirelessCalibrationJobInput;
  networkUUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationSuppressIpsRulesArgs = {
  UUIDs: Array<Scalars['UUID']['input']>;
  serialNumber: Scalars['String']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationTestFireAlertArgs = {
  alertReceiverUUID: Scalars['UUID']['input'];
  networkUUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationTestTriggerWebhookAlertTargetArgs = {
  UUID: Scalars['UUID']['input'];
  input: TestTriggerAlertTargetWebhookInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUnassignHardwareDeviceFromVirtualDeviceArgs = {
  assignAsSpare?: Scalars['Boolean']['input'];
  serialNumber: Scalars['String']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUnassignHardwareFromVirtualDevicesArgs = {
  virtualDeviceUUIDs: Array<Scalars['UUID']['input']>;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUnassignInternetServicePlanFromNetworkArgs = {
  internetServicePlanUUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUnassignSpareHardwareDeviceFromNetworkArgs = {
  networkUUID: Scalars['UUID']['input'];
  serialNumber: Scalars['String']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUnbindFirewallRuleFromPhyInterfaceArgs = {
  input: UnbindFirewallRuleFromPhyInterface;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUnbindFirewallRuleFromVlanArgs = {
  input: UnbindFirewallRuleFromVlan;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUnbindPolicyRoutingRuleArgs = {
  UUID: Scalars['UUID']['input'];
  input: UnbindPolicyRoutingRuleInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUnbindRateLimitRuleFromPhyInterfaceArgs = {
  input: RateLimitPhyInterfaceBindingInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUnbindRateLimitRuleFromSsidArgs = {
  input: RateLimitSsidBindingInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUnbindRateLimitRuleFromVlanArgs = {
  input: RateLimitVlanBindingInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUnbindTagFromVirtualDevicesArgs = {
  tagUUID: Scalars['UUID']['input'];
  virtualDeviceUUIDs: Array<Scalars['UUID']['input']>;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUnblockClientsInNetworkArgs = {
  macAddresses?: InputMaybe<Array<Scalars['MacAddress']['input']>>;
  networkUUID: Scalars['UUID']['input'];
  ouis?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUndeleteNetworkArgs = {
  UUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUnexpireTrialNetworkArgs = {
  networkUUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUnpinDeviceConfigsForNetworkArgs = {
  networkUUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUnsetHardwareDeviceIsDevArgs = {
  serialNumber: Scalars['String']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateAlertReceiverWithTargetsArgs = {
  alertReceiverUUID: Scalars['UUID']['input'];
  input: UpdateAlertReceiverWithTargetsInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateAlertTargetSlackArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateAlertTargetSlackInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateAlertTargetWebhookArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateAlertTargetWebhookInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateApplicationDnsFirewallRuleArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateApplicationDnsFirewallRuleInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateApplicationDnsFirewallRuleApplicationVisibilitiesArgs = {
  input: Array<UpdateApplicationDnsFirewallRuleApplicationVisibilities>;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateApplicationDnsFirewallRulesArgs = {
  inputs: Array<UpdateApplicationDnsFirewallRulesInput>;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateApplicationDnsFirewallRulesPrioritiesArgs = {
  input: Array<UpdateApplicationDnsFirewallRulesPrioritiesInput>;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateAutoVpnGroupArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateAutoVpnGroupInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateAutoVpnMemberArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateAutoVpnMemberInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateAutoVpnRouteArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateAutoVpnRouteInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateCaptivePortalArgs = {
  input: CaptivePortalSettingsInput;
  uuid: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateClientVpnClientArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateClientVpnClientInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateClientVpnServerArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateClientVpnServerInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateCompanyArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateCompanyInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateCompanySiemIntegrationArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateCompanySiemIntegrationInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateCompanyUserArgs = {
  companyUserUUID: Scalars['UUID']['input'];
  input: UpdateCompanyUserInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateDhcpOptionArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateDhcpOptionInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateDhcpProxyArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateDhcpProxyInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateDhcpReservedRangeArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateDhcpReservedRangeInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateDhcpRuleArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateDhcpRuleInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateDhcpStaticMappingArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateDhcpStaticMappingInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateDnsHostMappingArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateDnsHostMappingInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateDefaultRoleForUsersArgs = {
  companySlug: Scalars['String']['input'];
  input: UpdateDefaultRoleForUsersInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateEncryption8021XArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateEncryption8021XInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateFirewallRuleArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateFirewallRuleInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateFirewallRulesArgs = {
  inputs: Array<UpdateFirewallRulesInput>;
  networkUUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateFleetwideNotificationSettingArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateFleetwideNotificationSettingInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateFleetwideNotificationSnoozeArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateNotificationSnoozeInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateFloorPlanArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateFloorPlanInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateForCellularFailoverEventArgs = {
  input: UpdateForCellularFailoverEventInput;
  networkUUID: Scalars['UUID']['input'];
  virtualDeviceUUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateForHighAvailabilityEventArgs = {
  input: UpdateForHighAvailabilityEventInput;
  networkUUID: Scalars['UUID']['input'];
  virtualDeviceUUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateHardwareDeviceArgs = {
  input: UpdateHardwareDeviceInput;
  serialNumber: Scalars['String']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateHighAvailabilityControllersConfigurationArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateHighAvailabilityPairInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateHostMonitoringTargetArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateHostMonitoringTargetInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateIdsipsConfigArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateIdsipsConfigInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateIdsipsCustomRuleArgs = {
  input: UpdateIdsipsCustomRuleInput;
  ruleUUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateIpForwardingRuleArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateIpForwardingRuleInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateIpSecTunnelArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateIpSecTunnelInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateInterVlanCommunicationPermittedPairsArgs = {
  networkUUID: Scalars['UUID']['input'];
  vlanPairs: Array<VlanPairInput>;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateInternalNoteArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateInternalNoteInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateInternetServicePlanArgs = {
  input: UpdateInternetServicePlanInput;
  internetServicePlanUUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateInternetServicePlanProviderArgs = {
  input: UpdateInternetServicePlanProviderInput;
  uuid: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateInternetServicePlanProviderStaticRateArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateInternetServicePlanProviderStaticRateInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateInternetServicePlanProviderStaticRatesArgs = {
  UUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  enabled: Scalars['Boolean']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateMailingAddressArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateMailingAddressInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateMaintenanceWindowForNetworkArgs = {
  input: UpdateMaintenanceWindowInput;
  networkUUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateMarketingChangelogEntryArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateMarketingChangelogEntryInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateNosUpgradeGroupArgs = {
  input: UpdateNosUpgradeGroupInput;
  nosUpgradeGroupUUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateNosUpgradeGroupsArgs = {
  inputs: Array<UpdateNosUpgradeGroupsInput>;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateNetworkArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateNetworkInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateNetworkThreatAllowlistEntryArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateNetworkThreatAllowlistEntryInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateNosFeatureArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateNosFeatureInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateNosVersionArgs = {
  id: Scalars['Int']['input'];
  input: NosVersionInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateNotificationPreferenceArgs = {
  input?: InputMaybe<NotificationPreferenceInput>;
  uuid: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateNotificationSettingArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateNotificationSettingInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateNotificationSnoozeArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateNotificationSnoozeInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateOneToOneNatRuleArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateOneToOneNatRuleInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateOutletInterfaceArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateOutletInterfaceInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateOutletInterfacesArgs = {
  input: UpdateOutletInterfaceInput;
  outletInterfaceUUIDs: Array<Scalars['UUID']['input']>;
  virtualDeviceUUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateOutletInterfacesIndependentlyArgs = {
  inputs: Array<UpdateOutletInterfacesIndependentlyInput>;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdatePhyInterfaceArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdatePhyInterfaceInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdatePhyInterfaceForMultiWanEventArgs = {
  input: Array<UpdatePhyInterfaceForMultiWanEventInput>;
  networkUUID: Scalars['UUID']['input'];
  virtualDeviceUUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdatePhyInterfacesArgs = {
  input: UpdatePhyInterfaceInput;
  phyInterfaceUUIDs: Array<Scalars['UUID']['input']>;
  virtualDeviceUUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdatePhyInterfacesIndependentlyArgs = {
  inputs: Array<UpdatePhyInterfacesIndependentlyInput>;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdatePolicyRoutingRuleArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdatePolicyRoutingRuleInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdatePortForwardingRuleArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdatePortForwardingRuleInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateRackElevationArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateRackElevationInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateRackElevationDeviceArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateRackElevationDeviceInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateRadioProfileArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateRadioProfileInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateRateLimitRuleArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateRateLimitRuleInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateRateLimitRulesIndependentlyArgs = {
  inputs: Array<UpdateRateLimitRulesInput>;
  networkUUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateSsidArgs = {
  input: UpdateSsidInput;
  uuid: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateSecurityApplianceProfileArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateSecurityApplianceProfileInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateSecurityApplianceProfilesForNetworkArgs = {
  input: UpdateSecurityApplianceProfileInput;
  networkUUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateSlackAccessTokenArgs = {
  companyUUID: Scalars['UUID']['input'];
  uuid: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateStaticRouteArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateStaticRouteInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateSwitchProfileArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateSwitchProfileInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateUplinkPhyInterfaceExternalAddressesArgs = {
  input: UpdateUplinkPhyInterfaceExternalAddressesInput;
  networkUUID: Scalars['UUID']['input'];
  virtualDeviceUUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateUserRolesArgs = {
  companyUserUUID: Scalars['UUID']['input'];
  input: Array<UserRoleInput>;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateVlanArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateVlanInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateVlanInterVlanCommunicationPermittedVlaNsArgs = {
  otherVLANUUIDs: Array<Scalars['UUID']['input']>;
  vlanUUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateVlaNsIndependentlyArgs = {
  inputs: Array<UpdateVlaNsIndependentlyInput>;
  networkUUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateVirtualDeviceArgs = {
  input: UpdateVirtualDeviceInput;
  virtualDeviceUUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateVirtualDeviceTagArgs = {
  input: UpdateVirtualDeviceTagInput;
  tagUUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateVirtualDevicesArgs = {
  input: UpdateVirtualDeviceInput;
  networkUUID: Scalars['UUID']['input'];
  virtualDeviceUUIDs: Array<Scalars['UUID']['input']>;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateVirtualDevicesIndependentlyArgs = {
  inputs: Array<UpdateVirtualDeviceIndependentlyInput>;
  networkUUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateWifiIpskArgs = {
  input: UpdateWifiIpskInput;
  uuid: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpsertCompanyNotificationPreferenceArgs = {
  companySlug: Scalars['String']['input'];
  input?: InputMaybe<NotificationPreferenceInput>;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpsertCompanyOnboardingDocumentArgs = {
  companyUUID: Scalars['UUID']['input'];
  document: Scalars['JSONObject']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpsertCompanyOnboardingFieldDelegationArgs = {
  companyUUID: Scalars['UUID']['input'];
  fieldName: Scalars['String']['input'];
  input: UpsertCompanyOnboardingFieldDelegationInput;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpsertDeviceConfigOverrideArgs = {
  configJSON: Scalars['String']['input'];
  serialNumber: Scalars['String']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpsertIdsipsConfigCategoryBindingArgs = {
  idsIPSCategoryUUID: Scalars['UUID']['input'];
  idsIPSConfigUUID: Scalars['UUID']['input'];
  mode: IdsipsMode;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpsertIdsipsConfigRuleBindingArgs = {
  idsIPSConfigUUID: Scalars['UUID']['input'];
  mode: IdsipsMode;
  ruleSID: Scalars['Int']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpsertMacAddressAliasArgs = {
  alias: Scalars['String']['input'];
  companySlug: Scalars['String']['input'];
  macAddress: Scalars['MacAddress']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpsertNetworkNotificationPreferenceArgs = {
  controllerName: Scalars['String']['input'];
  input?: InputMaybe<NotificationPreferenceInput>;
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpsertNetworkOnboardingDocumentArgs = {
  document: Scalars['JSONObject']['input'];
  networkUUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpsertNetworkOnboardingFieldDelegationArgs = {
  fieldName: Scalars['String']['input'];
  input: UpsertNetworkOnboardingFieldDelegationInput;
  networkUUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpsertSwitchAutoConfigMacAddressVlanBindingsForNetworkArgs = {
  input: Array<CreateSwitchAutoConfigMacAddressVlanBindingInput>;
  networkUUID: Scalars['UUID']['input'];
};

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationValidateBearerSessionArgs = {
  UUID: Scalars['UUID']['input'];
};

/** Tracks the mutations that have been made to the network's configuration over time. */
export type MutationAuditLogEntry = {
  __typename?: 'MutationAuditLogEntry';
  /** The unique identifier for this audit log entry. */
  UUID: Scalars['UUID']['output'];
  /** The action or mutation that was performed, typically the name of the mutation function invoked. */
  action: Scalars['String']['output'];
  /** The arguments provided to the mutation, represented as a JSON object. */
  args: Scalars['JSONObject']['output'];
  /** The date and time when the mutation was performed, in ISO 8601 format */
  createdAt: Scalars['DateTime']['output'];
  /** The type of identity that performed the mutation. */
  identityType: Scalars['String']['output'];
  /** The unique identifier of the network where the mutation occurred */
  networkUUID: Scalars['UUID']['output'];
  /** An optional reason specified for why the mutation was made. */
  reason?: Maybe<Scalars['String']['output']>;
  /** The username or identifier of the entity (user or machine) that performed the mutation. */
  username: Scalars['String']['output'];
};

export type MutationAuditLogFilter = {
  /** Whether to include audit log entries where the identityType is 'MACHINE'. */
  includeMachine?: Scalars['Boolean']['input'];
  /** The maximum number of audit log entries to return. */
  limit?: Scalars['Int']['input'];
  /** Only include audit log entries that were created before or at this date and time. */
  maxCreatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Only include audit log entries that were created at or after this date and time. */
  minCreatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** The number of audit log entries to skip before starting to collect the result set. */
  offset?: Scalars['Int']['input'];
};

/** Tracks the mutations that have been made to the network's configuration and what was changed over time. */
export type MutationDiffAuditLogEntry = {
  __typename?: 'MutationDiffAuditLogEntry';
  /** The unique identifier for this audit log entry. */
  UUID: Scalars['UUID']['output'];
  /** The action or mutation that was performed, typically the name of the mutation function invoked. */
  action: Scalars['String']['output'];
  /** The JSON model after the mutation, represented as a JSON string. */
  afterJSON: Scalars['JSON']['output'];
  /** The JSON model before the mutation, represented as a JSON string. */
  beforeJSON: Scalars['JSON']['output'];
  /** The unique identifier of the company where the mutation occurred */
  companyUUID?: Maybe<Scalars['UUID']['output']>;
  /** The date and time when the mutation was performed, in ISO 8601 format */
  createdAt: Scalars['DateTime']['output'];
  /** Errors, if any, encountered during execution. */
  errors?: Maybe<Scalars['JSON']['output']>;
  /** The unique identifier of the network where the mutation occurred */
  networkUUID?: Maybe<Scalars['UUID']['output']>;
  /** An optional reason specified for why the mutation was made. */
  reason?: Maybe<Scalars['String']['output']>;
  /** The username or identifier of the entity (user or machine) that performed the mutation. */
  username: Scalars['String']['output'];
};

export type MutationDiffAuditLogFilterInput = {
  /** Filter audit log entries by method. */
  actions?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Include audit log entries marked as failed. */
  includeFailed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Include audit log entries marked as internal only. */
  includeInternal?: InputMaybe<Scalars['Boolean']['input']>;
  /** The maximum number of audit log entries to return. */
  limit?: Scalars['Int']['input'];
  /** Only include audit log entries that were created before or at this date and time. */
  maxCreatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Only include audit log entries that were created at or after this date and time. */
  minCreatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** The number of audit log entries to skip before starting to collect the result set. */
  offset?: Scalars['Int']['input'];
};

/** A page of a subset of mutation diff audit log entries. */
export type MutationDiffAuditLogPage = {
  __typename?: 'MutationDiffAuditLogPage';
  /** A subset of records based on the limit and offset fields */
  entries: Array<MutationDiffAuditLogEntry>;
  /** The total number of records */
  total: Scalars['Int']['output'];
};

/** Groups devices in a network together for the purpose of cohorting them for NOS upgrades. */
export type NosUpgradeGroup = {
  __typename?: 'NOSUpgradeGroup';
  /** Unique identifier of the NOS upgrade group. */
  UUID: Scalars['UUID']['output'];
  /** Timestamp when the NOS upgrade group was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Further distinguishes a device type by its role in the network; not all device types have subtypes. This is only applicable to default groups that are auto-created for a network. */
  defaultDeviceSubtype?: Maybe<NosUpgradeGroupDeviceSubtype>;
  /** The default device type for this group (unique per network). If set, devices of the given type will be assigned by default to this group. */
  defaultDeviceType?: Maybe<VirtualDeviceType>;
  /** A human-friendly description of the group. */
  description?: Maybe<Scalars['String']['output']>;
  /** A human-friendly label for the group. */
  name: Scalars['String']['output'];
  /** The network that the NOS upgrade group is associated with. */
  networkUUID: Scalars['UUID']['output'];
  /** The priority of the NOS upgrade group; lower values are higher priority (0-indexed). Groups of devices will be upgraded in order of priority. Unique per network. */
  priority: Scalars['Int']['output'];
  /** How long to wait for all devices in the group to upgrade before timing out, in seconds. */
  timeoutDurationSeconds: Scalars['Int']['output'];
  /** Timestamp when the NOS upgrade group was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** The virtual devices assigned to the NOS upgrade group. */
  virtualDevices: Array<VirtualDevice>;
};

/** Further distinguishes a device type by its role in the network. */
export enum NosUpgradeGroupDeviceSubtype {
  /** A controller backup device in a high-availability network. */
  ControllerBackup = 'CONTROLLER_BACKUP',
  /** A controller primary device in a high-availability network. */
  ControllerPrimary = 'CONTROLLER_PRIMARY',
  /** A switch access device. */
  SwitchAccess = 'SWITCH_ACCESS',
  /** A switch core device. */
  SwitchCore = 'SWITCH_CORE',
  /** A switch distribution device. */
  SwitchDistribution = 'SWITCH_DISTRIBUTION',
  /** An ISP switch device. */
  SwitchIsp = 'SWITCH_ISP',
}

/** A network is a grouping of devices in a single location belonging to a company. A core Meter entity. */
export type Network = {
  __typename?: 'Network';
  /** If false, wifi steering will be fully disabled even if supported by NOS. */
  IsWifiSteeringEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** The unique identifier of the network. */
  UUID: Scalars['UUID']['output'];
  /** The application DNS firewall rules associated with the network. */
  applicationDNSFirewallRules: Array<ApplicationDnsFirewallRule>;
  /** The Auto VPN groups associated with the network. */
  autoVPNGroups: Array<AutoVpnGroup>;
  /** The client VPN servers associated with the network. */
  clientVPNServers: Array<ClientVpnServer>;
  /** The company that this network belongs to. */
  company?: Maybe<Company>;
  /** The slug identifier of the company that this network belongs to. */
  companySlug?: Maybe<Scalars['String']['output']>;
  /** The date and time when the network was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The time when the network was deactivated, if applicable. Allows differentiation between pre-live and post-live networks. */
  deactivatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The date and time when the network was deleted, if applicable. */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The service types enabled for service discovery in this network. */
  enabledServiceDiscoveryTypes: Array<ServiceType>;
  /** The Salesforce Meter Network ID corresponding to this network. */
  externalID?: Maybe<Scalars['String']['output']>;
  /** The firewall rules associated with the network. */
  firewallRules: Array<FirewallRule>;
  /** The floor plans associated with the network. */
  floorPlans: Array<FloorPlan>;
  /** The date the network first started serving traffic. */
  goLiveAt?: Maybe<Scalars['DateTime']['output']>;
  /** Configuration of the HA controllers for this network. */
  highAvailabilityConfig?: Maybe<HighAvailabilityControllersConfig>;
  /** IDS IPS config associated with the network. */
  idsIPSConfig?: Maybe<IdsipsConfig>;
  /** Internet service plans associated with the network. */
  internetServicePlans: Array<InternetServicePlan>;
  /** The IPSec tunnels associated with the network. */
  ipSecTunnels: Array<IpSecTunnel>;
  /** Whether or not the network is currently serving traffic. */
  isActive: Scalars['Boolean']['output'];
  /** Indicates whether the controller can upgrade config-1 APs deployed to the network. */
  isConfig1WosUpgradesEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Whether or not the network services a customer (as opposed to being an internal / test network). */
  isCustomer: Scalars['Boolean']['output'];
  /**
   * A "template" network is one that does not represent a real physical network, but rather a template for creating new networks.
   * It is not associated with any physical devices, and is not intended to be used for any real-world operations.
   */
  isTemplate: Scalars['Boolean']['output'];
  /** Whether the network is participating in the Meter Trial Program. */
  isTrial: Scalars['Boolean']['output'];
  /**
   * Indicates whether a network is sensitive to firmware updates.
   * @deprecated Not a network property anymore
   */
  isUpgradeSensitive: Scalars['Boolean']['output'];
  /** A short code to quickly identify the network. Useful for customers with many networks and a need to quickly identify them. */
  label: Scalars['String']['output'];
  /** The last time this network was upgraded. It is the time when pending NOS was copied into pinned NOS by the NOS scheduler. */
  lastUpgradedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The mailing address associated with the network. */
  mailingAddress?: Maybe<MailingAddress>;
  /** The unique identifier of the network's mailing address. */
  mailingAddressUUID?: Maybe<Scalars['UUID']['output']>;
  /** Maintenance window associated with the network. */
  maintenanceWindow: MaintenanceWindow;
  /** The algorithm used for multi-WAN load balancing. */
  multiWANAlgorithm?: Maybe<MultiWanAlgorithm>;
  /** A NOS upgrade channel is a property to group networks by their sensitivity to cutting-edge NOS releases. */
  nosUpgradeChannel: NetworkNosUpgradeChannel;
  /** The maximum duration in minutes that a NOS upgrade can take, by summing the durations of all NOS upgrade groups containing at least one device. */
  nosUpgradeMaxDurationMinutes: Scalars['Int']['output'];
  /** Somewhat legacy onboarding information from Airtable job. Different from `onboardingDocument`. */
  onboarding?: Maybe<NetworkOnboarding>;
  /** Onboarding document form completed prior to network going live. Different from `onboarding`. */
  onboardingDocument?: Maybe<NetworkOnboardingDocument>;
  /** The one-to-one NAT rules associated with the network. */
  oneToOneNATRules: Array<OneToOneNatRule>;
  /** The URL of the patch panel diagram for the network. */
  patchPanelDiagramURL?: Maybe<Scalars['String']['output']>;
  /**
   * The last time an operator set the NOS version for the network.
   * @deprecated No longer supported
   */
  pendingNOSLastSetAt?: Maybe<Scalars['DateTime']['output']>;
  /** If there is a scheduled upcoming NOS upgrade for this network, this will be the NOS version that will be applied. */
  pendingNOSVersion?: Maybe<NosVersion>;
  /**
   * If there is a scheduled upcoming NOS upgrade for this network, this will be the NOS version that will be applied.
   * @deprecated Use `pendingNOSVersion` instead
   */
  pendingNOSVersionID?: Maybe<Scalars['Int']['output']>;
  /** A way to pin a network's devices to a known version of config by the config's max created at time. */
  pinnedDeviceConfigMaxCreatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The current NOS version for all devices in the network. */
  pinnedNOSVersion: NosVersion;
  /**
   * The current NOS version for all devices in the network.
   * @deprecated Use `pinnedNOSVersion` instead
   */
  pinnedNOSVersionID: Scalars['Int']['output'];
  /** The policy routing rules associated with the network. */
  policyRoutingRules: Array<PolicyRoutingRule>;
  /** The port forwarding rules associated with the network. */
  portForwardingRules: Array<PortForwardingRule>;
  /** The rack elevations associated with the network. */
  rackElevations: Array<RackElevation>;
  /** The radio profiles associated with the network. */
  radioProfiles: Array<RadioProfile>;
  /** The rate limit rules associated with the network. */
  rateLimitRules: Array<RateLimitRule>;
  /** A human-readable identifier for the network. Used in URLs to identify the network. */
  slug: Scalars['String']['output'];
  /**
   * Deprecated: Not a network property anymore.
   * @deprecated Not a network property anymore
   */
  spaceCategory?: Maybe<Scalars['String']['output']>;
  /** The SSIDs associated with the network. */
  ssids: Array<Ssid>;
  /**
   * The interval in minutes used to stagger device upgrades within the network.
   * @deprecated No longer relevant
   */
  staggeredUpgradeIntervalMin: Scalars['Int']['output'];
  /** The URL of the network topology image. */
  topologyImageURL?: Maybe<Scalars['String']['output']>;
  /** For trial networks, the date when the trial is set to expire. Expiry blocks customer access to the network and disables its functionality. */
  trialExpiresAt?: Maybe<Scalars['DateTime']['output']>;
  /** The upcoming NOS upgrade for this network, if one is scheduled. */
  upcomingScheduledNetworkNOSUpgrade?: Maybe<ScheduledNetworkNosUpgrade>;
  /** The date and time when the network was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** The virtual devices associated with the network, optionally filtered. */
  virtualDevices: Array<VirtualDevice>;
  /** The VLANs associated with the network. */
  vlans: Array<Vlan>;
  /** The maximum transmit power in dBm for this network's wireless devices, based on the network's mailing address. */
  wirelessMaxTxPowerdBm: Scalars['Int']['output'];
  /** The channels that are valid for this network's wireless devices, based on the network's mailing address. */
  wirelessValidChannels: Array<ValidChannelsResponse>;
};

/** A network is a grouping of devices in a single location belonging to a company. A core Meter entity. */
export type NetworkVirtualDevicesArgs = {
  filter?: InputMaybe<DevicesForNetworkFilter>;
};

/** A network client is a large container for all of the data that constitutes a client connected to a network. */
export type NetworkClient = {
  __typename?: 'NetworkClient';
  /** A user-defined MACAddressAlias for the client if one is defined for the company. */
  alias?: Maybe<Scalars['String']['output']>;
  /** The location of the access point (AP) to which the client is connected, if applicable. */
  apLocation?: Maybe<Scalars['String']['output']>;
  /** The serial number of the access point (AP) to which the client is connected, if applicable. */
  apSerialNumber?: Maybe<Scalars['String']['output']>;
  /** The AP as a virtual device to which the client is connected, if applicable. */
  apVirtualDevice?: Maybe<AccessPointVirtualDevice>;
  /** When the client associated with the AP, if applicable. */
  associatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The channel number used by the client's wireless connection. */
  channel?: Maybe<Scalars['Int']['output']>;
  /** The friendly name of the client device, if available from DHCP. */
  clientName?: Maybe<Scalars['String']['output']>;
  /** The SSID to which the client is connected, if wireless. */
  connectedSSID?: Maybe<Ssid>;
  /** The VLAN to which the client is connected. */
  connectedVLAN?: Maybe<Vlan>;
  /** The vendor of the client device (often its manufacturer), if known. Derived from the IEEE OUI database. */
  deviceVendor?: Maybe<Scalars['String']['output']>;
  /** The timestamp when the DHCP lease assigned to the client expires. */
  dhcpLeaseExpiresAt?: Maybe<Scalars['DateTime']['output']>;
  /** Hardware mode of the device a client is connected to. */
  hwMode?: Maybe<NetworkClientHwMode>;
  /** The IP address assigned to the client. */
  ip: Scalars['String']['output'];
  /** Whether this client is blocked by either MAC address or OUI. */
  isBlocked: Scalars['Boolean']['output'];
  /** If false, the client is connected via a wired connection. */
  isWireless: Scalars['Boolean']['output'];
  /** The timestamp when the client was last seen on the network. */
  lastSeen: Scalars['DateTime']['output'];
  /**
   * The latency between the controller and the client, measured in milliseconds. Deprecated in favor of 'latencyNs'.
   * @deprecated Use `latencyNs` instead.
   */
  latencyMs?: Maybe<Scalars['Int']['output']>;
  /** The latency between the controller and the client, measured in nanoseconds. */
  latencyNs?: Maybe<Scalars['Int']['output']>;
  /** The MAC address of the client. */
  macAddress: Scalars['MacAddress']['output'];
  /** The UUID of the network to which this client is connected. */
  networkUUID: Scalars['UUID']['output'];
  /** The noise level of the client's connection, measured in dBm. */
  noise?: Maybe<Scalars['Int']['output']>;
  /** The total number of spatial streams a client device can support, determined as the minimum of its transmit (TX) and receive (RX) spatial streams. */
  numSpatialStreams?: Maybe<Scalars['Int']['output']>;
  /** The Observer virtual device, if the client is an observer */
  observerVirtualDevice?: Maybe<ObserverVirtualDevice>;
  /** For wired clients, the phy interface to which the client is connected. */
  phyInterfaceConnectedTo?: Maybe<PhyInterface>;
  /** If the client is wireless, the radio band it is connected on. */
  radioBand?: Maybe<RadioBand>;
  /** The receive rate of the client connection, in bits per second. */
  rxRate?: Maybe<Scalars['Int']['output']>;
  /** List of mdns service types that this client offers (e.g. printer, airplay, etc). */
  serviceTypes?: Maybe<Array<ServiceType>>;
  /** The signal strength of the client's connection, measured in dBm. */
  signal?: Maybe<Scalars['Int']['output']>;
  /** The signal-to-noise ratio of the client's connection, measured in dB. Literally `signal - noise`. Null if either `signal` or `noise` is null. */
  signalToNoiseRatio?: Maybe<Scalars['Int']['output']>;
  /** The SSID of the wireless network to which the client is connected. */
  ssid?: Maybe<Scalars['String']['output']>;
  /** If the client's IP address is reserved, the DHCP static mapping associated with it. */
  staticMapping?: Maybe<DhcpStaticMapping>;
  /** The average network throughput of the client during the lookback period. */
  throughput?: Maybe<NetworkClientThroughput>;
  /** The total number of bytes received by the client over the requested lookback period. */
  totalRxBytes?: Maybe<Scalars['Int']['output']>;
  /** The total number of bytes transmitted by the client over the requested lookback period. */
  totalTxBytes?: Maybe<Scalars['Int']['output']>;
  /** The transmit rate of the client connection, in bits per second. */
  txRate?: Maybe<Scalars['Int']['output']>;
  /**
   * The VLAN the client is connected to.
   * @deprecated Use `connectedVLAN` instead.
   */
  vlan?: Maybe<Scalars['String']['output']>;
  /** The UUID of the VLAN to which the client is connected. Only supported for Config 2 networks. */
  vlanUUID?: Maybe<Scalars['UUID']['output']>;
  /** Wireless score computed based on the current health of the client. */
  wirelessScore?: Maybe<Scalars['Float']['output']>;
};

/** Entries representing MAC addresses blocked on a given network. */
export type NetworkClientBlocklistEntry = {
  __typename?: 'NetworkClientBlocklistEntry';
  /** Timestamp this entry was created. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** The MAC address being blocked. */
  macAddress?: Maybe<Scalars['MacAddress']['output']>;
  /** Network that the MAC address is blocked on. */
  networkUUID: Scalars['UUID']['output'];
  /** The OUI being blocked. Only one of either MAC Address or OUI is set. */
  oui?: Maybe<Scalars['String']['output']>;
  /** Primary key. */
  uuid?: Maybe<Scalars['UUID']['output']>;
};

/** A NetworkClientCPEBinding marks a certain CPE as running on a network client, keyed by its MAC address. */
export type NetworkClientCpeBinding = {
  __typename?: 'NetworkClientCPEBinding';
  /** Unique identifier for this NetworkClientCPEBinding */
  UUID: Scalars['UUID']['output'];
  /** The CPE associated with this binding. */
  cpe: Cpe;
  /** Timestamp when the NetworkClientCPEBinding was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The unique identifier of client associated with this binding. */
  macAddress: Scalars['MacAddress']['output'];
  /** The network associated with this binding. */
  network: Network;
};

/** Represents the hardware mode of a device the client is connected to. */
export enum NetworkClientHwMode {
  /** Represents no HW mode. */
  Na = 'NA',
  /** Represents WiFi 2 HW mode. */
  Wifi_2 = 'WIFI_2',
  /** Represents WiFi 3 HW mode. */
  Wifi_3 = 'WIFI_3',
  /** Represents WiFi 4 HW mode. */
  Wifi_4 = 'WIFI_4',
  /** Represents WiFi 5 HW mode. */
  Wifi_5 = 'WIFI_5',
  /** Represents WiFi 6 HW mode. */
  Wifi_6 = 'WIFI_6',
}

/** Represents the throughput of a client device. */
export type NetworkClientThroughput = {
  __typename?: 'NetworkClientThroughput';
  /** The average receive rate of the client, in bits per second. */
  rxRate?: Maybe<Scalars['Float']['output']>;
  /** The average transmit rate of the client, in bits per second. */
  txRate?: Maybe<Scalars['Float']['output']>;
};

/** Represents the throughput of a client device, grouped by day. */
export type NetworkClientTxRxPerDay = {
  __typename?: 'NetworkClientTxRxPerDay';
  /** The date to which the data is grouped by. */
  dateString: Scalars['String']['output'];
  /** The IP address of the client. */
  ip: Scalars['String']['output'];
  /** The MAC address of the client. */
  macAddress: Scalars['MacAddress']['output'];
  /** The total number of bytes received by the client on this date. */
  rxBytes: Scalars['Int']['output'];
  /** The total number of bytes transmitted by the client on this date. */
  txBytes: Scalars['Int']['output'];
};

export type NetworkClientsFilter = {
  /**
   * If provided, the latest connected clients for a network are returned
   * that were reported to be connected to the given AP serial number.
   * At most one of `macAddress`, `apSerialNumber`, `vlanID`, or `ssid` can be provided.
   */
  apSerialNumber?: InputMaybe<Scalars['String']['input']>;
  /** If true, clients identified as Meter hardware devices will be excluded from the results. */
  excludeMeterHardware?: Scalars['Boolean']['input'];
  /**
   * If provided, then the ping latency from controller to client is included
   * in the response.
   */
  includeLatency?: Scalars['Boolean']['input'];
  /**
   * If provided, the average usage for all returned clients in the last
   * 30 minutes will be included in the response. If macAddress is provided this field has no effect.
   */
  includeThroughput?: Scalars['Boolean']['input'];
  /**
   * When no macAddress and apSerialNumber are provided, filters resulting clients' lastSeen
   * to this many minutes before now.
   */
  lookbackMinutes?: Scalars['Int']['input'];
  /**
   * If a mac address is provided, this will get the history of clients with this mac address.
   * At most one of `macAddress`, `apSerialNumber`, `vlanID`, or `ssid` can be provided.
   */
  macAddress?: InputMaybe<Scalars['MacAddress']['input']>;
  /**
   * If provided, the latest connected clients for a network are returned
   * that were reported to be connected to the given SSID.
   * Only supported for config 2 COS networks.
   * At most one of `macAddress`, `apSerialNumber`, `vlanID`, or `ssid` can be provided.
   */
  ssid?: InputMaybe<Scalars['String']['input']>;
  /** If provided, then returns the results that were observed at the given timestamp. If null, defaults to now. */
  timestamp?: InputMaybe<Scalars['DateTime']['input']>;
  /**
   * If provided, the latest connected clients for a network are returned
   * that were reported to be connected to the given VLAN.
   * Only supported for config 2 COS networks.
   * At most one of `macAddress`, `apSerialNumber`, `vlanID`, or `ssid` can be provided.
   */
  vlanID?: InputMaybe<Scalars['Int']['input']>;
};

/** An enumeration of possible network event types that can trigger notifications. */
export enum NetworkEventType {
  /** The status of an access point has changed. */
  AccessPointChangeStatus = 'ACCESS_POINT_CHANGE_STATUS',
  /** The status of the controller has changed. */
  ControllerChangeStatus = 'CONTROLLER_CHANGE_STATUS',
  /** The controller is offline. */
  ControllerOffline = 'CONTROLLER_OFFLINE',
  /** The network has failed over to an LTE connection. */
  LteFailover = 'LTE_FAILOVER',
  /** An unexpected access point has registered on the network. */
  UnexpectedAccessPointRegistration = 'UNEXPECTED_ACCESS_POINT_REGISTRATION',
  /** The VPN connection failed over. */
  VpnFailover = 'VPN_FAILOVER',
  /** The status of the WAN connection has changed. */
  WanChangeStatus = 'WAN_CHANGE_STATUS',
  /** The network has failed over to a another WAN connection. */
  WanFailover = 'WAN_FAILOVER',
}

/** An interface representing a network job. */
export type NetworkJob = {
  /** The unique identifier for the job. */
  UUID: Scalars['UUID']['output'];
  /** The time at which the job was completed. */
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The unique identifier of the network associated with this job. */
  networkUUID: Scalars['UUID']['output'];
  /** The time at which the job was scheduled. */
  scheduledAt: Scalars['DateTime']['output'];
};

/** A NOS upgrade channel describes the network's minimum readiness to receive a given stage of NOS upgrade as it proceeds through the QA process. */
export enum NetworkNosUpgradeChannel {
  /** External networks that receive the first production-facing NOS version. NOS has passed QA and internal validation. */
  Beta = 'BETA',
  /** Internal networks that receive NOS versions which have completed regression testing; additional QA is in progress. */
  Dogfood = 'DOGFOOD',
  /** External networks that receive the first customer-ready NOS versions, intended for non-production customer lab environments. Cutting-edge but may have unknown issues. */
  EarlyAdoption = 'EARLY_ADOPTION',
  /** External networks that receive NOS versions which are fully validated, widely deployed, and considered stable. NOS has been running on customer networks for at least 5 weeks, with the majority now using this version. */
  GeneralAvailability = 'GENERAL_AVAILABILITY',
  /** Internal networks that are used by Meter employees in real-world environments, for example, office and warehouse networks. NOS versions are nearing full QA completion and is prepared for broader internal testing. */
  InternalProduction = 'INTERNAL_PRODUCTION',
  /** Internal networks that receive early-stage NOS versions that have passed preliminary QA; additional QA is in progress. */
  Kittyfood = 'KITTYFOOD',
  /** For critical or special-case external networks requiring delayed upgrades. This option will postpone updates (including bug fixes/features) by up to 2 months. It is also used for customers with active issues to prevent NOS upgrades during investigations or post-incident stabilization. */
  LimitedUpgrades = 'LIMITED_UPGRADES',
  /** External networks that receive a near-final NOS version that has completed all QA and validation and has been running stably on customer networks for at least 3 weeks. */
  ReleaseCandidate = 'RELEASE_CANDIDATE',
  /** Internal networks that do not receive automated upgrades. The network owner is fully responsible for managing their NOS version. */
  Sandbox = 'SANDBOX',
}

/** Represents the onboarding process for a network. */
export type NetworkOnboarding = {
  __typename?: 'NetworkOnboarding';
  /** Unique identifier for the network onboarding entry. */
  UUID: Scalars['UUID']['output'];
  /** Timestamp when the network onboarding was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Job data associated with the network onboarding. */
  jobData?: Maybe<NetworkOnboardingJobData>;
  /** Identifier of the associated job data. */
  jobDataID: Scalars['String']['output'];
  /** Unique identifier of the associated network. */
  networkUUID: Scalars['UUID']['output'];
  /** Timestamp when the network onboarding was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** Document containing information required for network onboarding. */
export type NetworkOnboardingDocument = {
  __typename?: 'NetworkOnboardingDocument';
  /** Unique identifier for the network onboarding document. */
  UUID: Scalars['UUID']['output'];
  /** Timestamp when the document was created. */
  createdAt: Scalars['DateTime']['output'];
  /** List of fields that have been delegated to other users for completion. */
  delegations: Array<NetworkOnboardingFieldDelegation>;
  /** JSON object containing the onboarding document data. */
  document: Scalars['JSONObject']['output'];
  /** Unique identifier of the associated network. */
  networkUUID: Scalars['UUID']['output'];
  /** Timestamp when the document was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** Represents the delegation of a specific field of the network onboarding document to a user. */
export type NetworkOnboardingFieldDelegation = {
  __typename?: 'NetworkOnboardingFieldDelegation';
  /** Unique identifier of the field delegation. */
  UUID: Scalars['UUID']['output'];
  /** Description of the delegation. */
  description?: Maybe<Scalars['String']['output']>;
  /** Email of the user to whom the field is delegated. */
  email: Scalars['String']['output'];
  /** Name of the field being delegated. */
  fieldName: Scalars['String']['output'];
  /** Unique identifier of the associated network. */
  networkUUID: Scalars['UUID']['output'];
};

/** Stores logistical data for tracking the installation and onboarding of a network. */
export type NetworkOnboardingJobData = {
  __typename?: 'NetworkOnboardingJobData';
  /** Full address of the network location, possibly including address lines, city, state, and ZIP code. */
  fullAddress?: Maybe<Array<Scalars['String']['output']>>;
  /** Unique identifier of the job data. */
  id: Scalars['String']['output'];
  /** End date of the installation. */
  installationEndDate?: Maybe<Scalars['DateTime']['output']>;
  /** Start date of the installation. */
  installationStartDate?: Maybe<Scalars['DateTime']['output']>;
  /** Identifier of the job. */
  jobID?: Maybe<Scalars['String']['output']>;
  /** User who owns the job. */
  jobOwnerUser?: Maybe<Scalars['String']['output']>;
  /** Current stage of the job. */
  jobStage?: Maybe<Scalars['String']['output']>;
  /** Current status of the job. */
  jobStatus?: Maybe<Scalars['String']['output']>;
  /** Names of the technicians assigned to the job. */
  jobTechnicianName?: Maybe<Array<Scalars['String']['output']>>;
  /** Phone numbers of the technicians assigned to the job. */
  jobTechnicianPhone?: Maybe<Array<Scalars['String']['output']>>;
  /** Code identifying the location. */
  locationCode?: Maybe<Scalars['String']['output']>;
  /** Information about the onsite contact person. */
  onsiteContactInformation?: Maybe<Scalars['String']['output']>;
  /** Links for scheduling a site survey. */
  scheduleSiteSurveyLink?: Maybe<Array<Scalars['String']['output']>>;
  /** Dates of the site survey.. */
  siteSurveyDate?: Maybe<Array<Scalars['String']['output']>>;
  /** Status updates of the site survey. */
  siteSurveyStatus?: Maybe<Array<Scalars['String']['output']>>;
  /** Target date for the network to go live. */
  targetGoLiveDate?: Maybe<Scalars['DateTime']['output']>;
  /** Total square footage of the network location. */
  totalSqFt?: Maybe<Array<Scalars['String']['output']>>;
};

/** A network route defines a route within the networking stack on a device. It can refer to either a physical interface, VLAN interface, or another Linux interface. */
export type NetworkRoute = {
  __typename?: 'NetworkRoute';
  /** The network attachment for the route; one of the attachment fields will be non-null. */
  attachment: NetworkRouteAttachment;
  /** The destination IP prefix of the network route. */
  destination: Scalars['IPPrefix']['output'];
  /** The gateway IP address for the network route. */
  gateway?: Maybe<Scalars['IPV4']['output']>;
};

/** One field of NetworkRouteAttachment will be non-null */
export type NetworkRouteAttachment = {
  __typename?: 'NetworkRouteAttachment';
  /** Attachment to an Auto VPN group. */
  autoVPNGroup?: Maybe<AutoVpnGroup>;
  /** Attachment to a Client VPN server. */
  clientVPNServer?: Maybe<ClientVpnServer>;
  /** Attachment to an IPSec tunnel. */
  ipSecTunnel?: Maybe<IpSecTunnel>;
  /** Attachment to a physical network interface. */
  phyInterface?: Maybe<PhyInterface>;
  /** Attachment to a static route. */
  staticRoute?: Maybe<StaticRoute>;
  /** Attachment to a VLAN interface. */
  vlan?: Maybe<Vlan>;
};

export type NetworkStatsFilter = {
  /** The lookback time to consider stats for, starting at `endTime`. Maximum allowed value is 7776000, 90 days. */
  durationSeconds: Scalars['Int']['input'];
  /** The latest observation time to consider stats for, inclusive. Defaults to the current time if not set. */
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** The maximum number of results to return, between 1 and 1000. Defaults to 100 if not set. */
  limit?: Scalars['Int']['input'];
  /** The number of results to skip before returning results. Defaults to 0 if not set. */
  offset?: Scalars['Int']['input'];
  /** The list of stat types to return. */
  types: Array<StatType>;
  /** The unique identifiers of the virtual devices to fetch stats for. If omitted, will include all virtual devices in the network. */
  virtualDeviceUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

/** Represents an allowed device for threat detection. */
export type NetworkThreatAllowlistEntry = {
  __typename?: 'NetworkThreatAllowlistEntry';
  /** A BSSID to allow for honeypot AP detection. */
  BSSID?: Maybe<Scalars['String']['output']>;
  /** The SSID object associated with this BSSID. */
  SSID?: Maybe<Ssid>;
  /** The unique identifier for the allowed device. */
  UUID: Scalars['UUID']['output'];
  /** The time at which the entry was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The unique identifier for the network. */
  networkUUID: Scalars['UUID']['output'];
  /** An explanation of the allowlisted device or the SSID to allow. */
  reason?: Maybe<Scalars['String']['output']>;
  /** An SSID to allow if a threat is broadcasting it. */
  ssidUUID?: Maybe<Scalars['UUID']['output']>;
  /** The time at which the entry was updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** A mac address to allow for rogue AP detection. */
  wiredMAC?: Maybe<Scalars['String']['output']>;
};

/** Represents an observer of a network threat. Will usually be an access point. */
export type NetworkThreatObserver = {
  __typename?: 'NetworkThreatObserver';
  /** The noise floor represents the background signal interference by the observer, which can affect the clarity and accuracy of the signal measurement from the network threat. */
  noiseFloor: Scalars['Int']['output'];
  /** The time that the observation occurred. */
  observedAt: Scalars['DateTime']['output'];
  /** The RSSI represents the signal strength measured by the observer from the network threat. */
  rssi: Scalars['Int']['output'];
  /** The SSID that this observer is seeing the threat broadcast. */
  ssid: Scalars['String']['output'];
  /** The virtual device that observed the network threat. */
  virtualDevice?: Maybe<VirtualDevice>;
  /** The UUID of the virtual device that observed the network threat. */
  virtualDeviceUUID: Scalars['UUID']['output'];
};

export type NetworkThreatsFilterInput = {
  /** Specify the time range for data. */
  timeFilter: MetricsFilterInput;
};

/** The response containing quality metrics for a network uplink. */
export type NetworkUplinkQualityResponse = MetricsResponse & {
  __typename?: 'NetworkUplinkQualityResponse';
  /** Metadata about the metrics. */
  metadata?: Maybe<MetricsMetadata>;
  /** A list of quality metric values. */
  values: Array<NetworkUplinkQualityValue>;
};

/** Represents the quality metrics value for a network uplink. */
export type NetworkUplinkQualityValue = MetricsValue & {
  __typename?: 'NetworkUplinkQualityValue';
  /**
   * The UUID of the physical interface associated with this quality metric.
   * Note: Since there are many data points, we reference the physical interface by UUID instead of embedding it.
   */
  phyInterfaceUUID: Scalars['UUID']['output'];
  /** The timestamp when the metric was recorded. */
  timestamp: Scalars['DateTime']['output'];
  /** The quality value measured at the given timestamp, typically represented as a percentage of successful pings. */
  value: Scalars['Float']['output'];
};

/** The response containing throughput metrics for a network uplink. */
export type NetworkUplinkThroughputMetricsResponse = MetricsResponse & {
  __typename?: 'NetworkUplinkThroughputMetricsResponse';
  /** Metadata about the metrics, such as time range and aggregation interval. */
  metadata?: Maybe<MetricsMetadata>;
  /** A list of throughput metric values. */
  values: Array<NetworkUplinkThroughputMetricsValue>;
};

/** Represents the throughput metrics value for a network uplink. */
export type NetworkUplinkThroughputMetricsValue = MetricsValue & {
  __typename?: 'NetworkUplinkThroughputMetricsValue';
  /** Indicates the direction of the traffic. */
  direction: TrafficDirection;
  /**
   * The UUID of the physical interface associated with this throughput metric.
   * Note: Since there are many data points, we reference the physical interface by UUID instead of embedding it.
   */
  phyInterfaceUUID: Scalars['UUID']['output'];
  /** The timestamp when the metric was recorded. */
  timestamp: Scalars['DateTime']['output'];
  /** The throughput value measured at the given timestamp, in bits per second. */
  value: Scalars['Float']['output'];
};

/** Filter for boolean fields in networks. */
export type NetworksBooleanFilter = {
  /** Equals comparison for boolean fields. */
  eq: Scalars['Boolean']['input'];
};

/** Filter networks by company support tiers. */
export type NetworksCompanySupportTierFilter = {
  /** Company support tiers to include. */
  in: Array<CompanySupportTier>;
  /** Invert the filter. */
  not?: Scalars['Boolean']['input'];
};

/** Filter networks by date-time fields. */
export type NetworksDateTimeFilter = {
  /** Greater than comparison. */
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Less than comparison. */
  lt?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Input type for filtering networks based on various criteria. */
export type NetworksFilter = {
  /** Filter networks by whether they are active. */
  active?: InputMaybe<NetworksBooleanFilter>;
  /** Filter networks by company support tier. */
  companySupportTier?: InputMaybe<NetworksCompanySupportTierFilter>;
  /** Filter networks by hardware model. */
  hardwareModel?: InputMaybe<NetworksHardwareModelFilter>;
  /** Filter networks by whether or not they are a Trial. */
  isTrial?: InputMaybe<NetworksBooleanFilter>;
  /** Filter networks by last upgrade date. */
  lastUpgradedAt?: InputMaybe<NetworksDateTimeFilter>;
  /** Filter networks by the square footage of their mailing address. */
  mailingAddressSquareFeet?: InputMaybe<NetworksIntFilter>;
  /** Filter networks by NOS upgrade channel. */
  nosUpgradeChannel?: InputMaybe<NetworksNosUpgradeChannelFilter>;
  /** Filter networks by NOS version ID. */
  nosVersionID?: InputMaybe<NetworksNosVersionIdFilter>;
  /** Filter networks by whether they have a pending upgrade. */
  pendingUpgrade?: InputMaybe<NetworksBooleanFilter>;
  /**
   * Filter networks by upgrade sensitivity.
   * @deprecated Not a network property anymore
   */
  upgradeSensitivity?: InputMaybe<NetworksBooleanFilter>;
};

/** Filter networks by hardware models. */
export type NetworksHardwareModelFilter = {
  /** Hardware models to include. */
  in: Array<DeviceModel>;
  /** Invert the filter */
  not?: Scalars['Boolean']['input'];
};

/** Filter networks by integer fields. */
export type NetworksIntFilter = {
  /** Greater than comparison. */
  gt?: InputMaybe<Scalars['Int']['input']>;
  /** Less than comparison. */
  lt?: InputMaybe<Scalars['Int']['input']>;
};

/** Filter networks by NOS upgrade channel. */
export type NetworksNosUpgradeChannelFilter = {
  /** NOS upgrade channels to include. */
  in: Array<NetworkNosUpgradeChannel>;
  /** Invert the filter. */
  not?: Scalars['Boolean']['input'];
};

/** Filter networks by NOS version IDs. */
export type NetworksNosVersionIdFilter = {
  /** NOS version IDs to include. */
  in: Array<Scalars['Int']['input']>;
  /** Invert the filter. */
  not?: Scalars['Boolean']['input'];
};

/** A NOS feature is a feature flag that tells us what minimum/maximum version of NOS firmware is needed to be installed on the network to support a given feature. */
export type NosFeature = {
  __typename?: 'NosFeature';
  /** A detailed description of the NOS feature. */
  description: Scalars['String']['output'];
  /** If the feature is also behind a feature flag, this is the name of the feature flag. */
  featureFlag?: Maybe<Scalars['String']['output']>;
  /** A unique key that identifies the NOS feature. */
  key: Scalars['String']['output'];
  /** The maximum major version of NOS firmware that supports this feature. */
  maxMajorVersion?: Maybe<Scalars['Int']['output']>;
  /** The maximum minor version of NOS firmware that supports this feature. */
  maxMinorVersion?: Maybe<Scalars['Int']['output']>;
  /** The maximum patch version of NOS firmware that supports this feature. */
  maxPatchVersion?: Maybe<Scalars['Int']['output']>;
  /** The minimum major version of NOS firmware required to support this feature. */
  minMajorVersion: Scalars['Int']['output'];
  /** The minimum minor version of NOS firmware required to support this feature. */
  minMinorVersion: Scalars['Int']['output'];
  /** The minimum patch version of NOS firmware required to support this feature. */
  minPatchVersion: Scalars['Int']['output'];
  /** The display name of the NOS feature. */
  name: Scalars['String']['output'];
  /** The NOS versions which have this feature enabled. */
  nosVersions: Array<NosVersion>;
  /** Unique identifier of the NOS feature. */
  uuid: Scalars['UUID']['output'];
};

/** Represents whether a NOS feature is enabled or disabled. */
export type NosFeatureEnabled = {
  __typename?: 'NosFeatureEnabled';
  /** Indicates whether the feature is enabled or disabled. */
  enabled: Scalars['Boolean']['output'];
  /** A unique key that identifies the NOS feature. */
  key: Scalars['String']['output'];
};

/** A NOS (Network Operating System) version is a grouping of build strings for various device types. Together they constitute a network-wide firmware release. */
export type NosVersion = {
  __typename?: 'NosVersion';
  /** Timestamp when the NOS version was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Unique identifier for the NOS version. */
  id: Scalars['Int']['output'];
  /** Indicates if this NOS version is the default version for new networks. */
  isDefault: Scalars['Boolean']['output'];
  /** Indicates whether the NOS version is deprecated and should no longer be used. */
  isDeprecated: Scalars['Boolean']['output'];
  /** Indicates whether the NOS version is Generally Available (GA) for all users. */
  isGA: Scalars['Boolean']['output'];
  /** Indicates whether the NOS version is locked and cannot be modified or deleted. */
  isLocked: Scalars['Boolean']['output'];
  /** Public NOS versions have a subset of their metadata visible to all users. */
  isPublic: Scalars['Boolean']['output'];
  /** If false, checks for `isLocked` and other validation checks that underlying networks associated with the build are non-customer networks will be disabled. */
  isValidationEnabled: Scalars['Boolean']['output'];
  /** Major version number component of the NOS version. */
  major: Scalars['Int']['output'];
  /** Build string for the 'mc01' controller device type. */
  mc01Build?: Maybe<Scalars['String']['output']>;
  /** Minor version number component of the NOS version. */
  minor: Scalars['Int']['output'];
  /** Build string for the 'mp01' power distribution unit device type. */
  mp01Build?: Maybe<Scalars['String']['output']>;
  /** Build string for the 'ms10' switch device type. */
  ms10Build?: Maybe<Scalars['String']['output']>;
  /** Build string for the 'ms11' switch device type. */
  ms11Build?: Maybe<Scalars['String']['output']>;
  /** Build string for the 'ms12' switch device type. */
  ms12Build?: Maybe<Scalars['String']['output']>;
  /** Build string for the 'mw03' wireless device type. */
  mw03Build?: Maybe<Scalars['String']['output']>;
  /** Build string for the 'mw04' wireless device type. */
  mw04Build?: Maybe<Scalars['String']['output']>;
  /** Build string for the 'mw06' wireless device type. */
  mw06Build?: Maybe<Scalars['String']['output']>;
  /** Build string for the 'mw07' wireless device type. */
  mw07Build?: Maybe<Scalars['String']['output']>;
  /** Build string for the 'mw08' wireless device type. */
  mw08Build?: Maybe<Scalars['String']['output']>;
  /** Build string for the 'mw09' wireless device type. */
  mw09Build?: Maybe<Scalars['String']['output']>;
  /** Optional name for the NOS version, used for display purposes. */
  name?: Maybe<Scalars['String']['output']>;
  /** The networks which are pinned to this NOS version. */
  networks: Array<Network>;
  /** Build string for the 'observer' device type. */
  observerBuild?: Maybe<Scalars['String']['output']>;
  /** Patch version number component of the NOS version. */
  patch: Scalars['Int']['output'];
  /** Release notes or description associated with the NOS version. */
  releaseNotes?: Maybe<Scalars['String']['output']>;
  /** Build string for the 's1' switch device type. */
  s1Build?: Maybe<Scalars['String']['output']>;
  /** Build string for the 's2' switch device type. */
  s2Build?: Maybe<Scalars['String']['output']>;
  /** Build string for the 's3' switch device type. */
  s3Build?: Maybe<Scalars['String']['output']>;
  /** Timestamp when the NOS version was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** String representing the overall version of the NOS, typically in 'major.minor.patch' format. */
  version: Scalars['String']['output'];
};

/** Input data for creating or updating a NOS version. */
export type NosVersionInput = {
  /** Indicates if this NOS version should be set as the default version for new networks. */
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates whether the NOS version is deprecated and should no longer be used. */
  isDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates whether the NOS version is Generally Available (GA) for all users. */
  isGA?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates whether the NOS version is locked and cannot be modified or deleted. */
  isLocked?: InputMaybe<Scalars['Boolean']['input']>;
  /** Public NOS versions have a subset of their metadata visible to all users. */
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  /** If false, checks for `isLocked` and other validation checks that underlying networks associated with the build are non-customer networks will be disabled. This should only be disabled in exceptional cases. */
  isValidationEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Major version number component of the NOS version. */
  major?: InputMaybe<Scalars['Int']['input']>;
  /** Build string for the 'mc01' controller device type. */
  mc01Build?: InputMaybe<Scalars['String']['input']>;
  /** Minor version number component of the NOS version. */
  minor?: InputMaybe<Scalars['Int']['input']>;
  /** Build string for the 'mp01' power distribution unit device type. */
  mp01Build?: InputMaybe<Scalars['String']['input']>;
  /** Build string for the 'ms10' switch device type. */
  ms10Build?: InputMaybe<Scalars['String']['input']>;
  /** Build string for the 'ms11' switch device type. */
  ms11Build?: InputMaybe<Scalars['String']['input']>;
  /** Build string for the 'ms12' switch device type. */
  ms12Build?: InputMaybe<Scalars['String']['input']>;
  /** Build string for the 'mw03' wireless device type. */
  mw03Build?: InputMaybe<Scalars['String']['input']>;
  /** Build string for the 'mw04' wireless device type. */
  mw04Build?: InputMaybe<Scalars['String']['input']>;
  /** Build string for the 'mw06' wireless device type. */
  mw06Build?: InputMaybe<Scalars['String']['input']>;
  /** Build string for the 'mw07' wireless device type. */
  mw07Build?: InputMaybe<Scalars['String']['input']>;
  /** Build string for the 'mw08' wireless device type. */
  mw08Build?: InputMaybe<Scalars['String']['input']>;
  /** Build string for the 'mw09' wireless device type. */
  mw09Build?: InputMaybe<Scalars['String']['input']>;
  /** Optional name for the NOS version, used for display purposes. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Build string for the 'observer' device type. */
  observerBuild?: InputMaybe<Scalars['String']['input']>;
  /** Patch version number component of the NOS version. */
  patch?: InputMaybe<Scalars['Int']['input']>;
  /** Release notes or description associated with the NOS version. */
  releaseNotes?: InputMaybe<Scalars['String']['input']>;
  /** Build string for the 's1' switch device type. */
  s1Build?: InputMaybe<Scalars['String']['input']>;
  /** Build string for the 's2' switch device type. */
  s2Build?: InputMaybe<Scalars['String']['input']>;
  /** Build string for the 's3' switch device type. */
  s3Build?: InputMaybe<Scalars['String']['input']>;
  /** String representing the overall version of the NOS, typically in 'major.minor.patch' format. */
  version: Scalars['String']['input'];
};

/** Input type for creating or updating notification preferences. */
export type NotificationPreferenceInput = {
  /** List of additional network event types to receive notifications for. */
  additionalEventTypes?: InputMaybe<Array<NetworkEventType>>;
  /** List of additional Slack channels to receive notifications. */
  additionalSlackChannels?: InputMaybe<Array<Scalars['String']['input']>>;
  /** List of email addresses to receive notifications. */
  emailAddresses?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** This feature is deprecated. Represents the notification preferences for a company or network. */
export type NotificationPreferences = {
  __typename?: 'NotificationPreferences';
  /** List of additional network event types to receive notifications for. */
  additionalEventTypes?: Maybe<Array<NetworkEventType>>;
  /** List of additional Slack channels to receive notifications. */
  additionalSlackChannels?: Maybe<Array<Scalars['String']['output']>>;
  /** Company associated with the notification preference. */
  company: Company;
  /** Unique identifier of the company associated with the notification preference. */
  companySID: Scalars['UUID']['output'];
  /** Timestamp when the notification preference was created. */
  createdAt: Scalars['DateTime']['output'];
  /** List of email addresses to receive notifications. */
  emailAddresses?: Maybe<Array<Scalars['String']['output']>>;
  /** Unique identifier of the network associated with the notification preference. May be null if the preference is for a company. */
  networkUUID?: Maybe<Scalars['UUID']['output']>;
  /** Timestamp when the notification preference was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** Unique identifier for the notification preference. */
  uuid: Scalars['UUID']['output'];
};

/** Response containing notification preferences at both the company and network levels. */
export type NotificationPreferencesResponse = {
  __typename?: 'NotificationPreferencesResponse';
  /** Notification preferences set at the company level. */
  companyPreferences?: Maybe<NotificationPreferences>;
  /** Notification preferences set at the network level. */
  networkPreferences?: Maybe<NotificationPreferences>;
};

/**
 * Notification settings contain preferences for how a user should be notified when events happen on a network.
 * They specify a receiver of the alert, the delivery mechanism, the type of alert, and alert-specific metadata to provide further context.
 */
export type NotificationSetting = {
  __typename?: 'NotificationSetting';
  /** The unique identifier of the notification setting. */
  UUID: Scalars['UUID']['output'];
  /** The UUID of the alert receiver who will receive the notifications generated by this setting. */
  alertReceiverUUID: Scalars['UUID']['output'];
  /** A list of arguments providing specific parameters or context required by the notification definition. */
  arguments: Array<NotificationSettingArgument>;
  /** The timestamp when the notification setting was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The ID of the user who created this notification setting. */
  createdBy?: Maybe<Scalars['Int']['output']>;
  /** The timestamp when the notification setting was deleted. */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Indicates whether the notification setting is enabled. */
  isEnabled: Scalars['Boolean']['output'];
  /** The UUID of the network to which this notification setting belongs. */
  networkUUID: Scalars['UUID']['output'];
  /** The AlertDefinition associated with this notification setting, providing details about the alert type and parameters. */
  notificationDefinition?: Maybe<AlertDefinition>;
  /** The unique name of the notification definition that defines the type of alert for this setting. */
  notificationDefinitionName: Scalars['String']['output'];
  /** The timestamp when the notification setting was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** The ID of the user who last updated this notification setting. */
  updatedBy?: Maybe<Scalars['Int']['output']>;
};

/** An argument for a notification setting, providing a value for a specific parameter required by the notification definition. */
export type NotificationSettingArgument = {
  __typename?: 'NotificationSettingArgument';
  /** The name of the parameter this argument corresponds to. */
  parameterName: Scalars['String']['output'];
  /** The value assigned to this parameter in the notification setting. */
  value: Scalars['Any']['output'];
};

/** Input type for specifying arguments when creating or updating a notification setting. */
export type NotificationSettingArgumentInput = {
  /** The name of the parameter for which the value is being provided. */
  parameterName: Scalars['String']['input'];
  /** Value is required. Only marked as nullable as a workaround for client zod validation. */
  value?: InputMaybe<Scalars['Any']['input']>;
};

/** Information about a snooze on a notification setting. */
export type NotificationSnooze = {
  __typename?: 'NotificationSnooze';
  /** The UUID of the snooze. */
  UUID: Scalars['UUID']['output'];
  /** The associated company. */
  company?: Maybe<Company>;
  /** The timestamp when the snooze was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The timestamp when the snooze was deleted. */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The associated network. */
  network?: Maybe<Network>;
  /** The associated notification setting. */
  notificationSetting?: Maybe<NotificationSetting>;
  /** The timestamp when the snooze ends. */
  snoozeEnd: Scalars['DateTime']['output'];
  /** The reason for the snooze. */
  snoozeReason?: Maybe<Scalars['String']['output']>;
  /** The timestamp when the snooze begins. */
  snoozeStart: Scalars['DateTime']['output'];
  /** The timestamp when the snooze was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/**
 * An OUI (Organizationally Unique Identifier) is the first 3 bytes of a MAC address.
 * Each OUI belongs to a vendor registered with the IEEE.
 * The data is populated from the IEEE OUI database: https://standards-oui.ieee.org/
 */
export type OuIsForVendorResult = {
  __typename?: 'OUIsForVendorResult';
  /** The OUIs belonging to the vendor. */
  OUIs: Array<Scalars['String']['output']>;
  /** The vendor registered with the IEEE. */
  vendor: IeeeDeviceVendor;
};

export type ObserverResultsFilterInput = {
  /** The lookback time to consider results for, starting at `endTime`. Maximum allowed value is 7776000, 90 days. */
  durationSeconds: Scalars['Int']['input'];
  /** The latest observation time to consider results for, inclusive. Defaults to the current time if not set. */
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** The frequency, if we want to return a slice of results */
  frequencySeconds?: InputMaybe<Scalars['Int']['input']>;
  /** The maximum number of results to return, between 1 and 1000. Defaults to 100 if not set. */
  limit?: Scalars['Int']['input'];
};

/** An observer virtual device is a logical representation of a physical observer. */
export type ObserverVirtualDevice = VirtualDevice & {
  __typename?: 'ObserverVirtualDevice';
  /** The unique identifier (UUID) of the virtual device. */
  UUID: Scalars['UUID']['output'];
  /** The timestamp when the virtual device was first created in the system. */
  createdAt: Scalars['DateTime']['output'];
  /** An optional description for the virtual device. */
  description?: Maybe<Scalars['String']['output']>;
  /** The model name of the virtual device. */
  deviceModel: DeviceModel;
  /** The type of the virtual device. */
  deviceType: VirtualDeviceType;
  /** The hardware device associated with this virtual device, if any. */
  hardwareDevice?: Maybe<HardwareDevice>;
  /** Indicates whether the virtual device's console port is enabled. */
  isConsoleEnabled: Scalars['Boolean']['output'];
  /** Indicates whether debug logging is enabled on the virtual device. */
  isDebugLogEnabled: Scalars['Boolean']['output'];
  /** Indicates whether LED dark mode is enabled on the observer, which turns off all LED activity. */
  isLEDDarkModeEnabled: Scalars['Boolean']['output'];
  /** A human-friendly name for the device. */
  label: Scalars['String']['output'];
  /** The network that the virtual device belongs to. */
  network: Network;
  /** The unique identifier (UUID) of the network the virtual device belongs to. */
  networkUUID: Scalars['UUID']['output'];
  /** The group that the device belongs to for firmware upgrade grouping purposes. */
  nosUpgradeGroup: NosUpgradeGroup;
  /** The current NOS firmware version that the virtual device is configured to run. */
  nosVersion?: Maybe<ConfiguredNosVersion>;
  /** The identifier of the NOS firmware version that the virtual device is configured to run. */
  nosVersionID: Scalars['Int']['output'];
  /** WifiObserverSettings currently configured to target that device */
  observerSettings?: Maybe<Array<WifiObserverSetting>>;
  /** The NOS firmware version that the virtual device is scheduled to upgrade to. */
  pendingNosVersion?: Maybe<PendingNosVersion>;
  /** Data about this virtual device's position in its network's topology. */
  topologyData?: Maybe<VirtualDeviceTopologyData>;
  /** The timestamp when the virtual device was last updated in the system. */
  updatedAt: Scalars['DateTime']['output'];
  /** The uptime from our time series database for the device. */
  uptime?: Maybe<Scalars['Duration']['output']>;
};

/** An observer virtual device is a logical representation of a physical observer. */
export type ObserverVirtualDeviceObserverSettingsArgs = {
  resultsFilter?: InputMaybe<ObserverResultsFilterInput>;
};

/** 1:1 NAT Rules are used to map a single external IP address to a single internal IP address. */
export type OneToOneNatRule = {
  __typename?: 'OneToOneNATRule';
  /** Unique identifier of the 1:1 NAT rule. */
  UUID: Scalars['UUID']['output'];
  /** Timestamp when the NAT rule was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Optional description of the 1:1 NAT rule. */
  description?: Maybe<Scalars['String']['output']>;
  /** The external IP address that is mapped by the NAT rule. */
  externalIPAddr: Scalars['IPV4']['output'];
  /** Physical interface associated with the external IP address. */
  externalPhyInterface: PhyInterface;
  /** UUID of the physical interface associated with the external IP address. */
  externalPhyInterfaceUUID: Scalars['UUID']['output'];
  /** The internal IP address that the external IP address is mapped to. */
  internalIPAddr: Scalars['IPV4']['output'];
  /** Indicates whether the NAT rule is currently enabled. */
  isEnabled: Scalars['Boolean']['output'];
  /** Name of the 1:1 NAT rule. */
  name: Scalars['String']['output'];
  /** UUID of the network that this NAT rule applies to. */
  networkUUID: Scalars['UUID']['output'];
  /** Timestamp when the NAT rule was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** Specifies settings for a power outlet on a Power Distribution Unit (PDU). */
export type OutletInterface = {
  __typename?: 'OutletInterface';
  /** Globally unique identifier for the outlet interface. */
  UUID: Scalars['UUID']['output'];
  /** The virtual device connected to the power outlet. */
  connectedVirtualDevice?: Maybe<VirtualDevice>;
  /** UUID of the virtual device connected to the power outlet. */
  connectedVirtualDeviceUUID?: Maybe<Scalars['UUID']['output']>;
  /** Timestamp when the outlet interface was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The current being drawn from the outlet in Amperes. */
  currentAmps?: Maybe<Scalars['Float']['output']>;
  /** Description of the outlet interface. */
  description?: Maybe<Scalars['String']['output']>;
  /** Whether or not the interface is enabled. */
  isEnabled: Scalars['Boolean']['output'];
  /** User-defined label for the outlet interface. */
  label?: Maybe<Scalars['String']['output']>;
  /** Number identifying the outlet on the PDU. */
  outletNumber: Scalars['Int']['output'];
  /**
   * Number of seconds to wait when performing a power cycle.
   * The outlet turns off, waits for this duration, and then turns back on.
   */
  powerCycleDelaySec: Scalars['Int']['output'];
  /** The power being drawn from the outlet in Watts. */
  powerWatts?: Maybe<Scalars['Float']['output']>;
  /** Timestamp when the outlet interface was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** The virtual device associated with this outlet interface. */
  virtualDevice?: Maybe<VirtualDevice>;
  /** UUID of the virtual device associated with this outlet interface. */
  virtualDeviceUUID: Scalars['UUID']['output'];
};

/** Response type containing PDU timeseries data over a specified time range. */
export type PduMetricsTimeseriesResponse = {
  __typename?: 'PDUMetricsTimeseriesResponse';
  /** Outlets metrics data from the PDU. */
  outlets: Array<PduOutletMetricsTimeseriesResponse>;
  /** Temperature readings from the PDU in celsius. */
  temperatureCelsius: BaseMetricsResponse;
};

/** Response type containing PDU outlet timeseries data over a specified time range. */
export type PduOutletMetricsTimeseriesResponse = {
  __typename?: 'PDUOutletMetricsTimeseriesResponse';
  /** Average current in amps. */
  currentAmps: BaseMetricsResponse;
  /** Average frequency in hertz. */
  frequencyHz: BaseMetricsResponse;
  /** The outlet interface for this series. */
  outlet: OutletInterface;
  /** Average power consumption in watts. */
  powerWatts: BaseMetricsResponse;
  /** Average voltage in volts. */
  voltageVolts: BaseMetricsResponse;
};

/** Properties for PDU outlet events. */
export type PduOutletProperties = {
  __typename?: 'PDUOutletProperties';
  /** Whether the outlet is enabled. */
  outletEnabled: Scalars['Boolean']['output'];
  /** The outlet number of the PDU outlet. */
  outletNum: Scalars['Int']['output'];
  /** The virtual device associated with the PDU outlet. */
  virtualDevice?: Maybe<VirtualDevice>;
};

/** Represents a Packet Capture job. */
export type PacketCaptureJob = {
  __typename?: 'PacketCaptureJob';
  /** The time at which the job was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The unique identifier for the job. */
  jobId: Scalars['UUID']['output'];
  /** The interface(s) to listen on (wireless radio(s), or wired). */
  listenOn: WosPacketCaptureCommandMonitor;
  /** The unique identifier of the network associated with this job. */
  networkUUID: Scalars['UUID']['output'];
  /** The maximum size limit of the packet capture file in megabytes. */
  sizeLimitMb: Scalars['Int']['output'];
  /** Whether the job was stopped prematurely or not. */
  stopped: Scalars['Boolean']['output'];
  /** The filter ID to be applied to the packet capture. Not yet implemented in firmware. */
  tcpDumpFilter: Scalars['String']['output'];
  /** The maximum duration of the packet capture in seconds. */
  timeLimitSeconds: Scalars['Int']['output'];
  /** The virtual device that the packet capture is run on. */
  virtualDeviceUUID: Scalars['UUID']['output'];
};

/** Specifies the NOS firmware version that a device is scheduled to upgrade to. */
export type PendingNosVersion = {
  __typename?: 'PendingNosVersion';
  /** The NOS firmware version that the device is scheduled to upgrade to. */
  nosVersion: NosVersion;
  /** The timestamp when the device is scheduled to upgrade to the specified NOS version. */
  scheduledAt: Scalars['DateTime']['output'];
};

/** An enumeration of v1 permissions (not RBAC) that can be assigned to tokens. */
export enum Permission {
  Admin = 'ADMIN',
  Api = 'API',
  Bastion = 'BASTION',
  Ci = 'CI',
  Cmd = 'CMD',
  Connect = 'CONNECT',
  ConnectAdmin = 'CONNECT_ADMIN',
  Controller = 'CONTROLLER',
  Dashboard = 'DASHBOARD',
  InventoryApp = 'INVENTORY_APP',
  Jumphost = 'JUMPHOST',
  Logs = 'LOGS',
  Noc = 'NOC',
  Ops = 'OPS',
  Portal = 'PORTAL',
  ProvisionController = 'PROVISION_CONTROLLER',
  Rpcbroker = 'RPCBROKER',
  Stats = 'STATS',
  StatConsumer = 'STAT_CONSUMER',
  StatUpload = 'STAT_UPLOAD',
  SupportTooling = 'SUPPORT_TOOLING',
  Worker = 'WORKER',
}

/**
 * A PermissionAssignment denotes the permissions of a user in the context of a company or company & network.
 *
 * In the case of an Operator role, the networkUUID field will be null.
 */
export type PermissionAssignment = {
  __typename?: 'PermissionAssignment';
  /**
   * The UUID of the network associated with these permissions.
   *
   * Null if the permissions are not network-specific or are company-wide.
   */
  networkUUID?: Maybe<Scalars['UUID']['output']>;
  /**
   * The list of permissions assigned to the user in this context.
   *
   * PermissionType represents the specific permissions granted.
   */
  permissions: Array<PermissionType>;
};

/** Result type indicating whether the user has the specified permission. */
export type PermissionCheckResult = {
  __typename?: 'PermissionCheckResult';
  /** True if the user has the specified permission, false otherwise. */
  hasPermission: Scalars['Boolean']['output'];
};

/**
 * Code generated by src/cmd/utils/permissions. DO NOT EDIT.
 * permissions are generated from src/auth/permissions/permissions.go
 */
export enum PermissionType {
  PermAlertAuditLogRead = 'PERM_ALERT___AUDIT___LOG_READ',
  PermAlertReceiverRead = 'PERM_ALERT___RECEIVER_READ',
  PermAlertReceiverTest = 'PERM_ALERT___RECEIVER_TEST',
  PermAlertReceiverWrite = 'PERM_ALERT___RECEIVER_WRITE',
  PermApplicationMaintenance = 'PERM_APPLICATION_MAINTENANCE',
  PermAuditLogRead = 'PERM_AUDIT___LOG_READ',
  PermAuditLogReadRestricted = 'PERM_AUDIT___LOG_READ_RESTRICTED',
  PermAuditLogWrite = 'PERM_AUDIT___LOG_WRITE',
  PermAuditLogWriteRestricted = 'PERM_AUDIT___LOG_WRITE_RESTRICTED',
  PermAuthenticationTokenRead = 'PERM_AUTHENTICATION___TOKEN_READ',
  PermAuthenticationTokenWrite = 'PERM_AUTHENTICATION___TOKEN_WRITE',
  PermAutoSelectionJobRead = 'PERM_AUTO___SELECTION___JOB_READ',
  PermAutoSelectionJobReadRestricted = 'PERM_AUTO___SELECTION___JOB_READ_RESTRICTED',
  PermAutoSelectionJobWrite = 'PERM_AUTO___SELECTION___JOB_WRITE',
  PermAutoSelectionJobWriteRestricted = 'PERM_AUTO___SELECTION___JOB_WRITE_RESTRICTED',
  PermAutoVpnRead = 'PERM_AUTO___VPN_READ',
  PermAutoVpnWrite = 'PERM_AUTO___VPN_WRITE',
  PermBearerSessionWrite = 'PERM_BEARER___SESSION_WRITE',
  PermBulkNosUpgradeRead = 'PERM_BULK___NOS___UPGRADE_READ',
  PermBulkNosUpgradeWrite = 'PERM_BULK___NOS___UPGRADE_WRITE',
  PermCaptivePortalRead = 'PERM_CAPTIVE___PORTAL_READ',
  PermCaptivePortalWrite = 'PERM_CAPTIVE___PORTAL_WRITE',
  PermCellularWrite = 'PERM_CELLULAR_WRITE',
  PermClientVpnClientRead = 'PERM_CLIENT___VPN_CLIENT_READ',
  PermClientVpnClientWrite = 'PERM_CLIENT___VPN_CLIENT_WRITE',
  PermClientVpnRead = 'PERM_CLIENT___VPN_READ',
  PermClientVpnWrite = 'PERM_CLIENT___VPN_WRITE',
  PermCompanyAdminAssign = 'PERM_COMPANY_ADMIN_ASSIGN',
  /** Company Admin Read Only gives users read-only access to all networks in a company. */
  PermCompanyAdminReadOnlyAssign = 'PERM_COMPANY_ADMIN___READ___ONLY_ASSIGN',
  PermCompanyGet = 'PERM_COMPANY_GET',
  PermCompanyGuestAssign = 'PERM_COMPANY_GUEST_ASSIGN',
  PermCompanyList = 'PERM_COMPANY_LIST',
  PermCompanyNetworkAdminAssign = 'PERM_COMPANY_NETWORK___ADMIN_ASSIGN',
  PermCompanyNetworkAdminReadOnlyAssign = 'PERM_COMPANY_NETWORK___ADMIN___READ___ONLY_ASSIGN',
  PermCompanyNetworkOnboardingAssign = 'PERM_COMPANY_NETWORK___ONBOARDING_ASSIGN',
  PermCompanyOnboardingAssign = 'PERM_COMPANY_ONBOARDING_ASSIGN',
  PermCompanyOnboardingRead = 'PERM_COMPANY_ONBOARDING_READ',
  PermCompanyOnboardingWrite = 'PERM_COMPANY_ONBOARDING_WRITE',
  PermCompanyOnboardingWriteRestricted = 'PERM_COMPANY_ONBOARDING_WRITE_RESTRICTED',
  PermCompanySiemIntegrationRead = 'PERM_COMPANY_SIEM___INTEGRATION_READ',
  PermCompanySiemIntegrationWrite = 'PERM_COMPANY_SIEM___INTEGRATION_WRITE',
  PermCompanySsoRead = 'PERM_COMPANY_SSO_READ',
  PermCompanySsoWrite = 'PERM_COMPANY_SSO_WRITE',
  PermCompanySupportTierReadRestricted = 'PERM_COMPANY_SUPPORT___TIER_READ_RESTRICTED',
  PermCompanyUpdate = 'PERM_COMPANY_UPDATE',
  PermCompanyUsersViewMeterEmployees = 'PERM_COMPANY_USERS_VIEW__METER__EMPLOYEES',
  PermCompanyUserAssign = 'PERM_COMPANY_USER_ASSIGN',
  PermCompanyWriteRestricted = 'PERM_COMPANY_WRITE_RESTRICTED',
  PermCpeRead = 'PERM_CPE_READ',
  /** Allows a user to access the dashboard. */
  PermDashboardAccess = 'PERM_DASHBOARD_ACCESS',
  PermDhcpDnsRead = 'PERM_DHCP___DNS_READ',
  PermDhcpDnsWrite = 'PERM_DHCP___DNS_WRITE',
  PermEventLogRead = 'PERM_EVENT___LOG_READ',
  PermFirewallRead = 'PERM_FIREWALL_READ',
  PermFirewallWrite = 'PERM_FIREWALL_WRITE',
  PermFirewallWriteRestricted = 'PERM_FIREWALL_WRITE_RESTRICTED',
  /** Allows a user to read the fleetwide notification settings for a given alert definition. */
  PermFleetwideNotificationSettingRead = 'PERM_FLEETWIDE___NOTIFICATION___SETTING_READ',
  /** Allows a user to create, update, or delete the fleetwide notification settings for a given alert definition. */
  PermFleetwideNotificationSettingWrite = 'PERM_FLEETWIDE___NOTIFICATION___SETTING_WRITE',
  PermFloorPlanRead = 'PERM_FLOOR___PLAN_READ',
  PermFloorPlanWrite = 'PERM_FLOOR___PLAN_WRITE',
  PermHardwareDeviceAssign = 'PERM_HARDWARE___DEVICE_ASSIGN',
  PermHardwareDeviceDevWrite = 'PERM_HARDWARE___DEVICE_DEV_WRITE',
  PermHardwareDeviceLogin = 'PERM_HARDWARE___DEVICE_LOGIN',
  PermHardwareDeviceRead = 'PERM_HARDWARE___DEVICE_READ',
  PermHardwareDeviceReadLimited = 'PERM_HARDWARE___DEVICE_READ_LIMITED',
  PermHardwareDeviceRpcBlinkLeds = 'PERM_HARDWARE___DEVICE_RPC_BLINK___LEDS',
  PermHardwareDeviceRpcCableTest = 'PERM_HARDWARE___DEVICE_RPC_CABLE___TEST',
  PermHardwareDeviceRpcEapolTest = 'PERM_HARDWARE___DEVICE_RPC_EAPOL___TEST',
  PermHardwareDeviceRpcPing = 'PERM_HARDWARE___DEVICE_RPC_PING',
  PermHardwareDeviceRpcPortCycle = 'PERM_HARDWARE___DEVICE_RPC_PORT___CYCLE',
  PermHardwareDeviceRpcReboot = 'PERM_HARDWARE___DEVICE_RPC_REBOOT',
  PermHardwareDeviceRpcRefreshConfig = 'PERM_HARDWARE___DEVICE_RPC_REFRESH___CONFIG',
  PermHardwareDeviceRpcWanSpeedtest = 'PERM_HARDWARE___DEVICE_RPC_WAN___SPEEDTEST',
  PermHardwareDeviceRpcWirelessCalibration = 'PERM_HARDWARE___DEVICE_RPC_WIRELESS___CALIBRATION',
  PermHighAvailabilityRead = 'PERM_HIGH___AVAILABILITY_READ',
  PermHighAvailabilityWrite = 'PERM_HIGH___AVAILABILITY_WRITE',
  PermHostMonitoringRead = 'PERM_HOST___MONITORING_READ',
  PermHostMonitoringWrite = 'PERM_HOST___MONITORING_WRITE',
  PermIdsIpsRead = 'PERM_IDS___IPS_READ',
  PermIdsIpsWrite = 'PERM_IDS___IPS_WRITE',
  PermInstallerAssign = 'PERM_INSTALLER_ASSIGN',
  PermIpsecTunnelRead = 'PERM_IPSEC___TUNNEL_READ',
  PermIpsecTunnelWrite = 'PERM_IPSEC___TUNNEL_WRITE',
  PermIpForwardingRead = 'PERM_IP___FORWARDING_READ',
  PermIpForwardingWrite = 'PERM_IP___FORWARDING_WRITE',
  PermIspRead = 'PERM_ISP_READ',
  PermIspWrite = 'PERM_ISP_WRITE',
  PermIspWriteRestricted = 'PERM_ISP_WRITE_RESTRICTED',
  PermIspConnectionTypeRead = 'PERM_ISP___CONNECTION___TYPE_READ',
  PermIspConnectionTypeWrite = 'PERM_ISP___CONNECTION___TYPE_WRITE',
  PermIspProviderRead = 'PERM_ISP___PROVIDER_READ',
  PermIspProviderWrite = 'PERM_ISP___PROVIDER_WRITE',
  PermIspProviderStaticRateRead = 'PERM_ISP___PROVIDER___STATIC___RATE_READ',
  PermIspProviderStaticRateWrite = 'PERM_ISP___PROVIDER___STATIC___RATE_WRITE',
  PermMacAddressAliasRead = 'PERM_MAC___ADDRESS___ALIAS_READ',
  PermMacAddressAliasWrite = 'PERM_MAC___ADDRESS___ALIAS_WRITE',
  PermMaintenanceWindowRead = 'PERM_MAINTENANCE___WINDOW_READ',
  PermMaintenanceWindowWrite = 'PERM_MAINTENANCE___WINDOW_WRITE',
  PermMarketingChangelogEntriesRead = 'PERM_MARKETING___CHANGELOG___ENTRIES_READ',
  PermMarketingChangelogEntriesReadRestricted = 'PERM_MARKETING___CHANGELOG___ENTRIES_READ_RESTRICTED',
  PermMarketingChangelogEntriesWrite = 'PERM_MARKETING___CHANGELOG___ENTRIES_WRITE',
  PermNetworkCpeRead = 'PERM_NETWORK_CPE_READ',
  PermNetworkCpeWrite = 'PERM_NETWORK_CPE_WRITE',
  PermNetworkInternalNoteRead = 'PERM_NETWORK_INTERNAL___NOTE_READ',
  PermNetworkInternalNoteWrite = 'PERM_NETWORK_INTERNAL___NOTE_WRITE',
  PermNetworkMetricsRead = 'PERM_NETWORK_METRICS_READ',
  PermNetworkNosWrite = 'PERM_NETWORK_NOS_WRITE',
  PermNetworkOnboardingRead = 'PERM_NETWORK_ONBOARDING_READ',
  PermNetworkOnboardingWrite = 'PERM_NETWORK_ONBOARDING_WRITE',
  PermNetworkOnboardingWriteRestricted = 'PERM_NETWORK_ONBOARDING_WRITE_RESTRICTED',
  PermNetworkRead = 'PERM_NETWORK_READ',
  PermNetworkReadLimited = 'PERM_NETWORK_READ_LIMITED',
  PermNetworkReadRestricted = 'PERM_NETWORK_READ_RESTRICTED',
  PermNetworkSettingsRead = 'PERM_NETWORK_SETTINGS_READ',
  PermNetworkSettingsUpdate = 'PERM_NETWORK_SETTINGS_UPDATE',
  PermNetworkSettingsWrite = 'PERM_NETWORK_SETTINGS_WRITE',
  PermNetworkSshRead = 'PERM_NETWORK_SSH_READ',
  PermNetworkSshWrite = 'PERM_NETWORK_SSH_WRITE',
  PermNetworkWriteLimited = 'PERM_NETWORK_WRITE_LIMITED',
  PermNetworkWriteRestricted = 'PERM_NETWORK_WRITE_RESTRICTED',
  PermNetworkClientsRead = 'PERM_NETWORK___CLIENTS_READ',
  PermNetworkClientsWriteDisconnect = 'PERM_NETWORK___CLIENTS_WRITE_DISCONNECT',
  PermNetworkDevicesRead = 'PERM_NETWORK___DEVICES_READ',
  PermNetworkDevicesReadPartner = 'PERM_NETWORK___DEVICES_READ_PARTNER',
  PermNetworkDevicesReadRestricted = 'PERM_NETWORK___DEVICES_READ_RESTRICTED',
  PermNetworkDevicesWrite = 'PERM_NETWORK___DEVICES_WRITE',
  PermNetworkDevicesWriteRestricted = 'PERM_NETWORK___DEVICES_WRITE_RESTRICTED',
  PermNetworkJobRead = 'PERM_NETWORK___JOB_READ',
  PermNetworkRouteRead = 'PERM_NETWORK___ROUTE_READ',
  PermNetworkRouteWrite = 'PERM_NETWORK___ROUTE_WRITE',
  PermNetworkThreatsRead = 'PERM_NETWORK___THREATS_READ',
  PermNetworkThreatAllowlistRead = 'PERM_NETWORK___THREAT___ALLOWLIST_READ',
  PermNetworkThreatAllowlistWrite = 'PERM_NETWORK___THREAT___ALLOWLIST_WRITE',
  PermNosRead = 'PERM_NOS_READ',
  PermNosReadRestricted = 'PERM_NOS_READ_RESTRICTED',
  PermNosWrite = 'PERM_NOS_WRITE',
  PermNosFeatureRead = 'PERM_NOS___FEATURE_READ',
  PermNosFeatureWrite = 'PERM_NOS___FEATURE_WRITE',
  PermNotificationPreferenceRead = 'PERM_NOTIFICATION___PREFERENCE_READ',
  PermNotificationPreferenceWrite = 'PERM_NOTIFICATION___PREFERENCE_WRITE',
  PermNotificationSettingRead = 'PERM_NOTIFICATION___SETTING_READ',
  PermNotificationSettingWrite = 'PERM_NOTIFICATION___SETTING_WRITE',
  PermNotificationSnoozeRead = 'PERM_NOTIFICATION___SNOOZE_READ',
  PermNotificationSnoozeWrite = 'PERM_NOTIFICATION___SNOOZE_WRITE',
  PermOneToOneNatRead = 'PERM_ONE___TO___ONE___NAT_READ',
  PermOneToOneNatWrite = 'PERM_ONE___TO___ONE___NAT_WRITE',
  PermOperatorAssign = 'PERM_OPERATOR_ASSIGN',
  PermOuiRead = 'PERM_OUI_READ',
  PermOutletWrite = 'PERM_OUTLET_WRITE',
  PermPacketCaptureJobRead = 'PERM_PACKET___CAPTURE___JOB_READ',
  PermPacketCaptureJobWrite = 'PERM_PACKET___CAPTURE___JOB_WRITE',
  /** Allows a user to assign the role of Partner to another user. A Partner is a special type of Meter customer who has elevated permissions to fully manage a Meter network. */
  PermPartnerAssign = 'PERM_PARTNER_ASSIGN',
  PermPermittedEmailDomainRead = 'PERM_PERMITTED___EMAIL___DOMAIN_READ',
  PermPermittedEmailDomainWrite = 'PERM_PERMITTED___EMAIL___DOMAIN_WRITE',
  PermPhyInterfaceRead = 'PERM_PHY___INTERFACE_READ',
  PermPhyInterfaceReadLimited = 'PERM_PHY___INTERFACE_READ_LIMITED',
  PermPhyInterfaceWrite = 'PERM_PHY___INTERFACE_WRITE',
  PermPhyInterfaceWriteRestricted = 'PERM_PHY___INTERFACE_WRITE_RESTRICTED',
  PermPolicyRoutingRead = 'PERM_POLICY___ROUTING_READ',
  PermPolicyRoutingWrite = 'PERM_POLICY___ROUTING_WRITE',
  PermPortForwardRead = 'PERM_PORT___FORWARD_READ',
  PermPortForwardWrite = 'PERM_PORT___FORWARD_WRITE',
  PermRackElevationRead = 'PERM_RACK___ELEVATION_READ',
  PermRackElevationWrite = 'PERM_RACK___ELEVATION_WRITE',
  PermRadioProfileRead = 'PERM_RADIO___PROFILE_READ',
  PermRadioProfileWrite = 'PERM_RADIO___PROFILE_WRITE',
  PermRateLimitRead = 'PERM_RATE___LIMIT_READ',
  PermRateLimitWrite = 'PERM_RATE___LIMIT_WRITE',
  PermSecurityApplianceProfileRead = 'PERM_SECURITY___APPLIANCE___PROFILE_READ',
  PermSecurityApplianceProfileWrite = 'PERM_SECURITY___APPLIANCE___PROFILE_WRITE',
  PermSsidsRead = 'PERM_SSIDS_READ',
  PermSsidsWrite = 'PERM_SSIDS_WRITE',
  PermStatEventWrite = 'PERM_STAT___EVENT_WRITE',
  PermSwitchProfileRead = 'PERM_SWITCH___PROFILE_READ',
  PermSwitchProfileWrite = 'PERM_SWITCH___PROFILE_WRITE',
  PermUserCreate = 'PERM_USER_CREATE',
  PermUserRead = 'PERM_USER_READ',
  PermUserUpdate = 'PERM_USER_UPDATE',
  PermVirtualDeviceCreate = 'PERM_VIRTUAL___DEVICE_CREATE',
  PermVirtualDeviceReadLimited = 'PERM_VIRTUAL___DEVICE_READ_LIMITED',
  PermVlanRead = 'PERM_VLAN_READ',
  PermVlanWrite = 'PERM_VLAN_WRITE',
  PermVlanWriteRestricted = 'PERM_VLAN_WRITE_RESTRICTED',
}

/** Input type specifying the context for fetching a user's permissions. */
export type PermissionsInput = {
  /**
   * The slug of the company to fetch permissions for.
   *
   * Required if permissions are company-specific.
   */
  companySlug?: InputMaybe<Scalars['String']['input']>;
  /**
   * The UUID of the network to fetch permissions for.
   *
   * Provide this if fetching network-specific permissions.
   */
  networkUUID?: InputMaybe<Scalars['UUID']['input']>;
};

/** Represents an email domain that is permitted for authentication for a company. */
export type PermittedEmailDomain = {
  __typename?: 'PermittedEmailDomain';
  /** The timestamp when the permitted email domain was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The email domain that is permitted (e.g., "example.com"). */
  domain: Scalars['String']['output'];
  /** The unique UUID identifier for the permitted email domain. */
  sid?: Maybe<Scalars['UUID']['output']>;
};

/** A PhyInterface is a physical interface on a device. It's a software representation of a physical port. */
export type PhyInterface = {
  __typename?: 'PhyInterface';
  /** The maximum transmission unit (MTU) - max size in bytes of frames that the port can transmit/receive. */
  MTU?: Maybe<Scalars['Int']['output']>;
  /** The unique identifier for the physical interface. */
  UUID: Scalars['UUID']['output'];
  /** The allowed (tagged) VLANs that are permitted to have traffic on this interface. */
  allowedVLANs?: Maybe<Array<Vlan>>;
  /** Devices connected to this physical interface. */
  connectedDevices?: Maybe<Array<PhyInterfaceConnectedDevice>>;
  /** The date and time when the physical interface was created. */
  createdAt: Scalars['DateTime']['output'];
  /** A description of the physical interface. */
  description?: Maybe<Scalars['String']['output']>;
  /** If 802.1X authentication is enabled for a Switch, this field contains the settings to configure 802.1X authentication. 802.1X must be enabled on the phy interface's switch's switch profile by having a RADIUS server configured in order for 802.1X to be enabled on the phy interface. */
  encryption8021XSettings?: Maybe<PhyInterface8021XSettings>;
  /** The maximum amount of data that can be transmitted through the interface, in Mbps. */
  forcedPortSpeedMbps?: Maybe<Scalars['Int']['output']>;
  /** Whether the phy interface allows setting a forced speed */
  forcedSpeedAllowed: Scalars['Boolean']['output'];
  /** An optional filter to only accept certain frame types on this port. If null, all frame types are accepted. */
  frameAcceptTypeFilter?: Maybe<PhyInterfaceFrameAcceptTypeFilter>;
  /** Static hardware port label, if present. */
  hardwareLabel?: Maybe<Scalars['String']['output']>;
  /** If this interface represents a WAN port, indicates if there is any recent activity representing a connection to an ISP. */
  hasWANActivity?: Maybe<Scalars['Boolean']['output']>;
  /** Configuration for high availability associated with this interface, if on a controller configured in HA mode for this port. */
  highAvailability?: Maybe<HighAvailabilityControllerVirtualDeviceInfo>;
  /** If this interface represents a WAN port, attempts to match the most recently reported IP for the port against the IP address information from the provider. */
  internetServicePlan?: Maybe<InternetServicePlan>;
  /** If assigning this interface as a client, this field indicates the IPv4 addresses to assign to the interface without netmasks. */
  ipv4ClientAddresses?: Maybe<Array<Scalars['IPV4']['output']>>;
  /** If assigning this interface as a client, this field indicates the protocol to use for IPv4 addresses. */
  ipv4ClientAssignmentProtocol?: Maybe<ClientAssignmentProtocol>;
  /** If assigning this interface as a client, this field indicates the gateway IPv4 address without a netmask. */
  ipv4ClientGateway?: Maybe<Scalars['IPV4']['output']>;
  /** If assigning this interface as a client, this field indicates the subnet prefix length for the IPv4 addresses. */
  ipv4ClientPrefixLength?: Maybe<Scalars['Int']['output']>;
  /** If assigning this interface as a client, this field indicates the IPv6 addresses to assign to the interface without netmasks. */
  ipv6ClientAddresses?: Maybe<Array<Scalars['IPV6']['output']>>;
  /** If assigning this interface as a client, this field indicates the protocol to use for IPv6 addresses. */
  ipv6ClientAssignmentProtocol?: Maybe<ClientAssignmentProtocol>;
  /** If assigning this interface as a client, this field indicates the gateway IPv6 address without a netmask. */
  ipv6ClientGateway?: Maybe<Scalars['IPV6']['output']>;
  /** If assigning this interface as a client, this field indicates the subnet prefix length for the IPv6 addresses. */
  ipv6ClientPrefixLength?: Maybe<Scalars['Int']['output']>;
  /** Indicates if the port has been blocked by FLIP (Flap Link Intervention Protocol) due to too many port flaps. */
  isBlockedByFLIP: Scalars['Boolean']['output'];
  /** Indicates if the port is blocked due to too many port flaps (link down/up). */
  isBlockedDueToFlaps: Scalars['Boolean']['output'];
  /** Whether or not the interface is implicitly bound to all VLANs, including any future VLANs that are created. If set to true, all VLAN bindings (excluding the native VLAN) will be tagged on this interface. */
  isBoundToAllVLANs: Scalars['Boolean']['output'];
  /** True if something is connected to the port. Determined by if the current port speed is positive. */
  isConnected: Scalars['Boolean']['output'];
  /** Whether or not the interface is enabled. Interfaces that are not enabled are still visible to the user. */
  isEnabled: Scalars['Boolean']['output'];
  /** Indicates if the port is an Ethernet port. */
  isEthernet: Scalars['Boolean']['output'];
  /** If true, flap link intervention protocol is enabled on the port. Both this flag and isFLIPEnabled in SwitchProfile must be true for FLIP to be enabled on a port. */
  isFLIPEnabled: Scalars['Boolean']['output'];
  /** If true, Fast Leave is enabled on this interface. When enabled, the port is removed from the multicast group as soon as the switch sees an IGMP/MLD leave message from the client on the port. */
  isFastLeaveEnabled: Scalars['Boolean']['output'];
  /** This represents whether flow control is enabled. This feature is enabled by default. */
  isFlowControlEnabled: Scalars['Boolean']['output'];
  /** If true, tagged frames are discarded when the VLAN ID of the frame does not match the VLAN ID of the port. */
  isIngressFilteringEnabled: Scalars['Boolean']['output'];
  /** If true, clients on isolated ports cannot communicate with other isolated ports; they can only communicate with non-isolated ports. */
  isIsolationEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates if the port is blocked due to loopback detection. */
  isLoopbackDetected?: Maybe<Scalars['Boolean']['output']>;
  /** Whether or not the interface is enabled to deliver Power over Ethernet. */
  isPOEEnabled: Scalars['Boolean']['output'];
  /** If true, this phy interface cannot be configured. */
  isReadOnly: Scalars['Boolean']['output'];
  /** Indicates if the port is an SFP port. */
  isSFP: Scalars['Boolean']['output'];
  /** If true, this interface will be configured as an edge port in STP (Spanning Tree Protocol). */
  isSTPEdgePortEnabled: Scalars['Boolean']['output'];
  /** Whether or not the interface is enabled to participate in Spanning Tree Protocol. */
  isSTPEnabled: Scalars['Boolean']['output'];
  /** Indicates if the port is forwarding (true) or blocking (false) due to STP. */
  isSTPForwarding?: Maybe<Scalars['Boolean']['output']>;
  /** This should only be used with trunk ports. If enabled, the port cannot become STP root. It helps prevent a customer or rogue switch from sending a low bridge priority and becoming root. If a switch has root guard enabled and it receives a low bpdu (that would normally make it a root port), then the switch ill disable that port */
  isSTPRootGuardEnabled: Scalars['Boolean']['output'];
  /** If true, this phy interface is configured as a sink. */
  isSink: Scalars['Boolean']['output'];
  /** Whether or not storm control is enabled on the port. */
  isStormControlEnabled: Scalars['Boolean']['output'];
  /** A trunk port is a port that is assigned to carry traffic for multiple VLANs. */
  isTrunkPort: Scalars['Boolean']['output'];
  /** An uplink interface connects the device to other networks or network devices. */
  isUplink: Scalars['Boolean']['output'];
  /** Only populated if `isUplink` is true. Indicates if this uplink physical interface is currently active. */
  isUplinkActive?: Maybe<Scalars['Boolean']['output']>;
  /** If true, voice VLAN is enabled for this port. Both this flag and isVoiceVLANEnabled in SwitchProfile must be true for voice VLAN to be enabled on a port. */
  isVoiceVLANEnabled: Scalars['Boolean']['output'];
  /** A custom label for the physical interface. */
  label?: Maybe<Scalars['String']['output']>;
  /** For switch port security, the maximum number of MAC addresses allowed on the port. */
  maxMACAddressesAllowed?: Maybe<Scalars['Int']['output']>;
  /** Maximum speed capability of the port from hardware specifications, in Mbps. */
  maxSpeedMbps?: Maybe<Scalars['Int']['output']>;
  /** The native (untagged) VLAN that is assigned to this interface. */
  nativeVLAN?: Maybe<Vlan>;
  /** The native (untagged) VLAN that is assigned to this interface. If no native VLAN is assigned, this returns the default VLAN for the network. */
  nativeVLANOrDefaultVLAN: Vlan;
  /** PoE type for this port. It can be 802.3af, 802.3at or 802.3bt. A nil value indicates that the port cannot deliver PoE. */
  poeType?: Maybe<PoEType>;
  /** The physical port number on the device where the interface is located. */
  portNumber: Scalars['Int']['output'];
  /** The link speed on the port, populated from our time series database. */
  portSpeedMbps?: Maybe<Scalars['Int']['output']>;
  /**
   * The type of port (Ethernet, SFP, or Unknown).
   * @deprecated Use `isEthernet` or `isSFP` instead
   */
  portType: PortType;
  /** The power draw on the port, populated from our time series database for PoE. */
  powerDraw?: Maybe<Scalars['Float']['output']>;
  /** Receive rate limit for the port, in Kbps. May be rounded down to a nearest supported value depending on hardware support. */
  rxRateLimitKbps?: Maybe<Scalars['Int']['output']>;
  /** SFP module information (if an SFP module is plugged into the port). */
  sfpModuleInfo?: Maybe<SfpModuleInfo>;
  /** The percent of broadcast traffic to drop if storm control is enabled. */
  stormControlBroadcastTrafficPercent: Scalars['Int']['output'];
  /** The percent of unknown multicast traffic to drop if storm control is enabled. */
  stormControlUnknownMulticastTrafficPercent: Scalars['Int']['output'];
  /** The percent of unknown unicast traffic to drop if storm control is enabled. */
  stormControlUnknownUnicastTrafficPercent: Scalars['Int']['output'];
  /** STP Path cost for the port (1-200000000). */
  stpPathCost?: Maybe<Scalars['Int']['output']>;
  /** The Spanning Tree Protocol (STP) role of the port. */
  stpPortRole?: Maybe<StpPortRole>;
  /** STP Priority for the port (0-240 in multiples of 16, default 128). */
  stpPriority: Scalars['Int']['output'];
  /** For phy interfaces belonging to a switch, aggregated statistics over a specified lookback period. */
  switchPortStats?: Maybe<Array<SwitchPortStat>>;
  /** The throughput (RX/TX) for the last 24 hours on the port, populated from our time series database. */
  throughputLastDay?: Maybe<Array<ThroughputValueWithDirection>>;
  /** Transmit rate limit for the port, in Kbps. May be rounded down to a nearest supported value depending on hardware support. */
  txRateLimitKbps?: Maybe<Scalars['Int']['output']>;
  /** The date and time when the physical interface was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** Only populated if `isUplink` is true. Holds the statically reported addresses of the physical interface. */
  uplinkExternalAddresses?: Maybe<Array<Scalars['UnmaskedIPPrefix']['output']>>;
  /** Can only be populated if `isUplink` is true. The MAC Address of the upstream device this physical interface is connected to. */
  uplinkGatewayMACAddress?: Maybe<Scalars['MacAddress']['output']>;
  /** Can only be populated if `isUplink` is true. The priority order in which the uplink should be used. */
  uplinkPriority?: Maybe<Scalars['Int']['output']>;
  /** Can only be populated if `isUplink` is true. The VLAN ID used for the uplink. */
  uplinkVLANID?: Maybe<Scalars['Int']['output']>;
  /** The virtual device associated with this physical interface. */
  virtualDevice: VirtualDevice;
  /** The UUID of the virtual device that this physical interface belongs to. */
  virtualDeviceUUID: Scalars['UUID']['output'];
};

/** A PhyInterface is a physical interface on a device. It's a software representation of a physical port. */
export type PhyInterfaceSwitchPortStatsArgs = {
  lookbackHours?: InputMaybe<Scalars['Int']['input']>;
};

/** Specifies how many hosts are allowed to authenticate on the port. */
export enum PhyInterface8021XHostMode {
  /** All clients on the port must authenticate using 802.1X. All must belong to the same VLAN. Guest VLAN cannot be used. */
  MultiAuth = 'MULTI_AUTH',
  /** Allows multiple clients access to the port. After the first client is authenticated, all subsequent clients can tailgate and do not have to authenticate. */
  MultiHost = 'MULTI_HOST',
  /** Allows only a single client to authenticate and use the port. No other clients can access the port. */
  SingleHost = 'SINGLE_HOST',
}

/** When a phy interface has this mode enabled, the switch will use the MAC address of the client to authenticate with the RADIUS server, often used for printer ports. */
export enum PhyInterface8021XmacAuthenticationBypassMode {
  /** The port will not use MAC authentication bypass; the client must authenticate with 802.1X. */
  Disabled = 'DISABLED',
  /** Allows a client to specify credentials and falls back to MAC auth if the client fails. */
  Hybrid = 'HYBRID',
  /** Forces only MAC-based auth; the client cannot specify user credentials. */
  MacAuthOnly = 'MAC_AUTH_ONLY',
}

/** Specifies the variant of 802.1X authentication to use. */
export enum PhyInterface8021XPortMode {
  /** Allows only EAPOL frames to be sent and received through the port until the client is authenticated by the RADIUS server. */
  Auto = 'AUTO',
  /** Configures the port as authenticated, essentially skipping 802.1X auth. The port receives and sends normal traffic without 802.1X-based authentication of the client. */
  ForceAuthorized = 'FORCE_AUTHORIZED',
}

/** Specifies the settings for 802.1X authentication on a port. */
export type PhyInterface8021XSettings = {
  __typename?: 'PhyInterface8021XSettings';
  /** Specifies how many hosts are allowed to authenticate on the port */
  hostMode: PhyInterface8021XHostMode;
  /** If enabled, the switch will dynamically assign VLANs to the port based on the RADIUS server response. */
  isAssignVLANsFromRADIUSEnabled: Scalars['Boolean']['output'];
  /** 'If enabled, unauthenticated clients will be assigned to the guest VLAN specified in the switch profile (`RADIUSGuestVLAN`). If disabled, unauthenticated clients are blocked. */
  isGuestVLANEnabled: Scalars['Boolean']['output'];
  /** The MAC authentication bypass mode for the port to accept MAC-based auth. The switch will use the MAC address of the client to authenticate with the RADIUS server, often used for printer ports. */
  macAuthenticationBypassMode: PhyInterface8021XmacAuthenticationBypassMode;
  /** Specifies the variant of 802.1X authentication to use. */
  portMode: PhyInterface8021XPortMode;
  /** The duration that the port will wait after a client fails authentication; after this period it will allow re-attempt. */
  quietPeriodSeconds: Scalars['Int']['output'];
  /** If set, authorized clients are forced to re-authenticate after this period. If not set, clients are not forced to re-authenticate. */
  reauthenticationPeriodSeconds?: Maybe<Scalars['Int']['output']>;
  /** When a client is connected to a port, the switch sends out an EAP auth request to the client; the request times out and retransmits according to this value. */
  supplicantPeriodSeconds: Scalars['Int']['output'];
};

/** An object to tell when a device was connected to a physical interface on a Meter Switch. */
export type PhyInterfaceConnectedAt = {
  __typename?: 'PhyInterfaceConnectedAt';
  /** The timestamp when the device was connected to the physical interface on a Meter Switch. */
  connectedAt: Scalars['DateTime']['output'];
  /** The physical interface on the Meter Switch that the device is connected to. */
  phyInterface: PhyInterface;
};

/** Represents a device connected to a physical interface. */
export type PhyInterfaceConnectedDevice = {
  __typename?: 'PhyInterfaceConnectedDevice';
  /**
   * If the macAddress belongs to a Meter device, this field will load it from the database. Deprecated: Use `hardwareDevice` instead.
   * @deprecated Use `hardwareDevice` instead.
   */
  device?: Maybe<Device>;
  /** If the macAddress belongs to a hardware device, this field will load it from the database. */
  hardwareDevice?: Maybe<HardwareDevice>;
  /** MAC Address of the device that is plugged into the port. Populated via LLDP. */
  macAddress: Scalars['MacAddress']['output'];
  /** A user-defined nickname for the device, if specified. */
  macAddressAlias?: Maybe<MacAddressAlias>;
  /** The network UUID. */
  networkUUID: Scalars['UUID']['output'];
  /** The other phy interface that is plugged into the calling phy interface, if the other device is a Meter device. */
  phyInterface?: Maybe<PhyInterface>;
  /** The port number of the other phy interface that is plugged into the calling phy interface, if the other device is a Meter device. */
  portNumber?: Maybe<Scalars['Int']['output']>;
};

/** Specifies the frame types to accept on a port. */
export enum PhyInterfaceFrameAcceptTypeFilter {
  /** Accept only tagged frames. */
  TaggedOnly = 'TAGGED_ONLY',
  /** Accept only untagged frames. */
  UntaggedOnly = 'UNTAGGED_ONLY',
}

/** Contains info about the PoE (Power over Ethernet) usage of a hardware device. */
export type PoEInfo = {
  __typename?: 'PoEInfo';
  /** The maximum PoE power supplyable by the device (in Watts). */
  max?: Maybe<Scalars['Float']['output']>;
  /**
   * Timestamp of the stat that max was extracted from.
   * @deprecated The same value as usedCreatedAt.
   */
  maxCreatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The current PoE power usage value (in Watts). */
  used?: Maybe<Scalars['Float']['output']>;
  /** The timestamp when the current PoE power usage was recorded. */
  usedCreatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Indicates max PoE power delivered by the port */
export enum PoEType {
  /** 802.3af max 15 Watts */
  PoE8023Af = 'PoE8023AF',
  /** 802.3at max 30 Watts */
  PoE8023At = 'PoE8023AT',
  /** 802.3bt max 90 Watts */
  PoE8023Bt = 'PoE8023BT',
}

/** A policy routing rule sets a policy for some source traffic to some destination traffic over a specific physical interface binding. */
export type PolicyRoutingRule = {
  __typename?: 'PolicyRoutingRule';
  /** The unique identifier for the policy routing rule. */
  UUID: Scalars['UUID']['output'];
  /** The physical interfaces and metrics this rule is bound to. A lower metric takes higher priority. */
  bindings?: Maybe<Array<PolicyRoutingRuleBinding>>;
  /** The timestamp when the policy routing rule was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The list of destination port ranges for the traffic matching this rule. */
  dstPortRanges: Array<PortRange>;
  /** The destination IP prefix for the traffic matching this rule. */
  dstPrefix: Scalars['IPPrefix']['output'];
  /** Indicates whether the policy routing rule is enabled. */
  isEnabled: Scalars['Boolean']['output'];
  /** The name of the policy routing rule. */
  name: Scalars['String']['output'];
  /** The unique identifier of the network to which this policy routing rule belongs. */
  networkUUID: Scalars['UUID']['output'];
  /** The list of IP protocols (e.g., TCP, UDP) for the traffic matching this rule. */
  protocols: Array<IpProtocol>;
  /** The list of source port ranges for the traffic matching this rule. */
  srcPortRanges: Array<PortRange>;
  /** The source IP prefix for the traffic matching this rule (optional). */
  srcPrefix?: Maybe<Scalars['IPPrefix']['output']>;
  /** The source VLAN for the traffic matching this rule (optional). */
  srcVLAN?: Maybe<Vlan>;
  /** The timestamp when the policy routing rule was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** Represents a binding between a policy routing rule and a physical interface, including the metric. */
export type PolicyRoutingRuleBinding = {
  __typename?: 'PolicyRoutingRuleBinding';
  /** The unique identifier for the policy routing rule binding. */
  UUID: Scalars['UUID']['output'];
  /** The metric (priority) assigned to the binding. Lower metrics have higher priority. */
  metric: Scalars['Int']['output'];
  /** The physical interface to which the policy routing rule is bound. */
  phyInterface: PhyInterface;
};

export type PolicyRoutingRuleBindingInput = {
  /** The UUID of the physical interface to bind the policy routing rule to. The physical interface must be an uplink. */
  phyInterfaceUUID: Scalars['UUID']['input'];
};

/** Port forwarding rules for a network define how incoming traffic is forwarded to a local destination. */
export type PortForwardingRule = {
  __typename?: 'PortForwardingRule';
  /** Unique identifier for the port forwarding rule. */
  UUID: Scalars['UUID']['output'];
  /** Restricts the port forwarding rule to only allow traffic to be forwarded if it originates from any of these IP addresses. */
  allowedRemoteIPAddresses?: Maybe<Array<Scalars['IP']['output']>>;
  /** Timestamp when the port forwarding rule was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Description of the port forwarding rule. */
  description?: Maybe<Scalars['String']['output']>;
  /** The external IP address to which this rule applies. */
  externalIPAddress?: Maybe<Scalars['IP']['output']>;
  /** The external physical interface associated with this rule. */
  externalPhyInterface?: Maybe<PhyInterface>;
  /**
   * One of `externalPhyInterfaceUUID` or `externalIPAddress` must be set.
   * If `externalPhyInterfaceUUID` is provided, the port forwarding rule only applies to this external physical interface.
   * If `externalIPAddress` is provided, the rule applies to the specified external IP address.
   * Otherwise, the rule will apply to all external interfaces on a device.
   * Application logic will ensure that this interface is an uplink interface.
   */
  externalPhyInterfaceUUID?: Maybe<Scalars['UUID']['output']>;
  /** The external port from which incoming traffic is forwarded. */
  externalPort: Scalars['Int']['output'];
  /** Indicates whether the port forwarding rule is enabled. */
  isEnabled: Scalars['Boolean']['output'];
  /** The local IP address to which incoming traffic is forwarded. This must be a single IP. */
  localIPAddress: Scalars['IP']['output'];
  /** The local port to which the external port forwards traffic. */
  localPort: Scalars['Int']['output'];
  /** Name of the port forwarding rule. */
  name: Scalars['String']['output'];
  /** Unique identifier of the network to which this port forwarding rule belongs. */
  networkUUID: Scalars['UUID']['output'];
  /** The IP protocol to apply this rule on. These are the IANA-defined protocol numbers. 6 = TCP, 17 = UDP. A value of 256 is reserved by IANA and will be used to denote all protocols. */
  protocol: PortIpProtocol;
  /** Timestamp when the port forwarding rule was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** Supported IP protocols for specifying port ranges. */
export enum PortIpProtocol {
  /** Transmission Control Protocol. */
  Tcp = 'TCP',
  /** User Datagram Protocol. */
  Udp = 'UDP',
}

/** Represents a range of ports. */
export type PortRange = {
  __typename?: 'PortRange';
  /** Lower bound of the port range. */
  lower: Scalars['Int']['output'];
  /** Upper bound of the port range. */
  upper: Scalars['Int']['output'];
};

/** Input type for specifying a port range. */
export type PortRangeInput = {
  /** Lower bound of the port range (1-65535). */
  lower: Scalars['Int']['input'];
  /** Upper bound of the port range (1-65535). */
  upper: Scalars['Int']['input'];
};

/** Indicates the type of port. */
export enum PortType {
  /** An Ethernet port. */
  Ethernet = 'ETHERNET',
  /** An SFP port. */
  Sfp = 'SFP',
  /** Unknown port type. */
  Unknown = 'UNKNOWN',
}

/** A power distribution unit hardware device represents a physical power distribution unit. */
export type PowerDistributionUnitHardwareDevice = HardwareDevice & {
  __typename?: 'PowerDistributionUnitHardwareDevice';
  /** Shows the most recent boot history of a device (buildName, bootCount). */
  bootHistory: Array<BootInfo>;
  /** The timestamp when the hardware device was first created in the system. */
  createdAt: Scalars['DateTime']['output'];
  /** The model name of the hardware device. */
  deviceModel: DeviceModel;
  /** The type of the hardware device. */
  deviceType: DeviceType;
  /** If the device is no longer connected to the backend, this is the time at which it was last connected. */
  disconnectedFromBackendAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * True if the device has an active websocket connection to the backend. Note that this only works if the device has registered via the /v2/register endpoint (i.e., is a Config 2 device) - otherwise is always false.
   * @deprecated Refer to `isSpare` instead.
   */
  isActive: Scalars['Boolean']['output'];
  /** Indicates whether the hardware device is connected to the backend. */
  isConnectedToBackend: Scalars['Boolean']['output'];
  /** Indicates whether the hardware device's console port is enabled. */
  isConsoleEnabled: Scalars['Boolean']['output'];
  /** Indicates whether the hardware device is marked as a development (dev) device, moving it into the dev (staging) realm for testing purposes. */
  isDev: Scalars['Boolean']['output'];
  /** Indicates whether the hardware device is in factory mode. */
  isFactoryMode: Scalars['Boolean']['output'];
  /** Indicates whether the hardware device is an RMA (Return Merchandise Authorization) replacement device. */
  isRMA: Scalars['Boolean']['output'];
  /** Indicates whether the hardware device has been retired. */
  isRetired: Scalars['Boolean']['output'];
  /** A spare hardware device belongs to a network but not a virtual device. Used most often to keep track of spare hardware we ship to a customer but don't install immediately. */
  isSpare: Scalars['Boolean']['output'];
  /** The latest device config metadata (ie. the config without the actual JSON payload) for the device. */
  latestDeviceConfigMetadata?: Maybe<DeviceConfigMetadata>;
  /** The MAC address of the hardware device. */
  macAddress?: Maybe<Scalars['MacAddress']['output']>;
  /** The UUID of the network that the spare hardware device belongs to. Spare hardware devices that are not affiliated with a virtual device will have this field populated. */
  networkUUID?: Maybe<Scalars['UUID']['output']>;
  /** The physical interface (on a Meter Switch) that the power distribution unit is connected to, if applicable. */
  phyInterfaceConnectedTo?: Maybe<PhyInterface>;
  /** The public key used to add the device to the jumphost's WireGuard interface. */
  publicKey?: Maybe<Scalars['String']['output']>;
  /** The unique serial number of the hardware device. */
  serialNumber: Scalars['String']['output'];
  /** The network that the spare hardware device belongs to. Spare hardware devices that are not affiliated with a virtual device will have this field populated. */
  spareDeviceNetwork?: Maybe<Network>;
  /** IPv6 address on the jumphost subnet. Used to send requests to the device. */
  tunnelIPAddress?: Maybe<Scalars['String']['output']>;
  /** The timestamp when the hardware device was last updated in the system. */
  updatedAt: Scalars['DateTime']['output'];
  /**
   * The uptime metrics from the time series database for the device.
   * @deprecated Use `VirtualDevice.uptime` instead.
   */
  uptime?: Maybe<Scalars['Duration']['output']>;
  /** The virtual device associated with this hardware device, if any. */
  virtualDevice?: Maybe<VirtualDevice>;
  /** The UUID of the virtual device this hardware device is assigned to, if any. */
  virtualDeviceUUID?: Maybe<Scalars['UUID']['output']>;
};

/** A power distribution unit hardware device represents a physical power distribution unit. */
export type PowerDistributionUnitHardwareDeviceBootHistoryArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
};

/** A power distribution unit virtual device is a logical representation of a physical power distribution unit. */
export type PowerDistributionUnitVirtualDevice = VirtualDevice & {
  __typename?: 'PowerDistributionUnitVirtualDevice';
  /** The unique identifier (UUID) of the virtual device. */
  UUID: Scalars['UUID']['output'];
  /** The timestamp when the virtual device was first created in the system. */
  createdAt: Scalars['DateTime']['output'];
  /** An optional description for the virtual device. */
  description?: Maybe<Scalars['String']['output']>;
  /** The model name of the virtual device. */
  deviceModel: DeviceModel;
  /** The device temperature of the PDU in degrees Celsius. */
  deviceTemperatureCelsius?: Maybe<Scalars['Float']['output']>;
  /** The type of the virtual device. */
  deviceType: VirtualDeviceType;
  /** The Ethernet interface speed of the PDU in Mbps. */
  ethernetSpeedMbps?: Maybe<Scalars['Int']['output']>;
  /** The hardware device associated with this virtual device, if any. */
  hardwareDevice?: Maybe<HardwareDevice>;
  /** The IPv4 address of the power distribution unit (PDU). */
  ipAddress?: Maybe<Scalars['IPV4']['output']>;
  /** Indicates whether the PDU's circuit breaker is functioning properly. */
  isCircuitBreakerGood?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates whether the virtual device's console port is enabled. */
  isConsoleEnabled: Scalars['Boolean']['output'];
  /** Indicates whether debug logging is enabled on the virtual device. */
  isDebugLogEnabled: Scalars['Boolean']['output'];
  /** Indicates whether the PDU is properly grounded. */
  isGrounded?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Read-only devices cannot be modified until this is set to false.
   * This also prevents sub-entities from being modified.
   */
  isReadonly: Scalars['Boolean']['output'];
  /** Indicates whether the PDU's surge protection is functioning properly. */
  isSurgeProtectionGood?: Maybe<Scalars['Boolean']['output']>;
  /** A human-friendly name for the device. */
  label: Scalars['String']['output'];
  /** The maximum allowed power for the PDU in watts. */
  maxPowerAllowedWatts?: Maybe<Scalars['Float']['output']>;
  /** The network that the virtual device belongs to. */
  network: Network;
  /** The unique identifier (UUID) of the network the virtual device belongs to. */
  networkUUID: Scalars['UUID']['output'];
  /** The group that the device belongs to for firmware upgrade grouping purposes. */
  nosUpgradeGroup: NosUpgradeGroup;
  /** The current NOS firmware version that the virtual device is configured to run. */
  nosVersion?: Maybe<ConfiguredNosVersion>;
  /** The identifier of the NOS firmware version that the virtual device is configured to run. */
  nosVersionID: Scalars['Int']['output'];
  /** The outlet interfaces of the PDU. */
  outletInterfaces: Array<OutletInterface>;
  /** The NOS firmware version that the virtual device is scheduled to upgrade to. */
  pendingNosVersion?: Maybe<PendingNosVersion>;
  /** Data about this virtual device's position in its network's topology. */
  topologyData?: Maybe<VirtualDeviceTopologyData>;
  /** The total power usage of the PDU in watts. */
  totalPowerUsedWatts?: Maybe<Scalars['Float']['output']>;
  /** The timestamp when the virtual device was last updated in the system. */
  updatedAt: Scalars['DateTime']['output'];
  /** The uptime from our time series database for the device. */
  uptime?: Maybe<Scalars['Duration']['output']>;
};

/** Represents a calculated power plan for a network. */
export type PowerPlan = {
  __typename?: 'PowerPlan';
  /** The unique identifier of the calibration job associated with this power plan. */
  calibrationJobUUID: Scalars['UUID']['output'];
  /** The SNR interference threshold with which the ATX algorithm was run with (dBm). */
  interferenceThreshold: Scalars['Int']['output'];
  /** The interferers that we expect each AP to have on this power plan. */
  interferers: Array<PowerPlanInterferer>;
  /** The maximum tx power (dBm) for the power plan. */
  maxTxPower: Scalars['Int']['output'];
  /** The minimum power an AP should see at least one other AP at (dBm). */
  minPowerToAnotherAP: Scalars['Int']['output'];
  /** The minimum tx power (dBm) for the power plan. */
  minTxPower: Scalars['Int']['output'];
  /** The unique identifier of the network the power plan is for. */
  networkUUID: Scalars['UUID']['output'];
  /** The number of interferers the ATX algorithm was calculated with. */
  numberOfInterferers: Scalars['Int']['output'];
  /** The associated power settings for this power plan. */
  powerSetting: Array<PowerSetting>;
};

/** The input for generating a power plan. */
export type PowerPlanInput = {
  /** The SNR interference threshold to run the ATX algorithm with (dBm). */
  interferenceThreshold: Scalars['Int']['input'];
  /** The maximum tx power (dBm) to run the ATX algorithm with. */
  maxTxPower: Scalars['Int']['input'];
  /** The minimum power an AP should see at least one other AP at (dBm). */
  minPowerToAnotherAP: Scalars['Int']['input'];
  /** The minimum tx power (dBm) to run the ATX algorithm with. */
  minTxPower: Scalars['Int']['input'];
  /** The number of interferers to run the ATX algorithm with. */
  numberOfInterferers: Scalars['Int']['input'];
};

/** Represents the interferer list for a single AP for the given power plan. */
export type PowerPlanInterferer = {
  __typename?: 'PowerPlanInterferer';
  /** The access point virtual device that has interfering APs. */
  accessPoint: AccessPointVirtualDevice;
  /** The access point virtual devices that are interferers. */
  interfererAccessPoints: Array<AccessPointVirtualDevice>;
};

/** Represents a power setting for a single AP for the given power plan. */
export type PowerSetting = {
  __typename?: 'PowerSetting';
  /** The access point virtual device for which to suggest a power setting. */
  accessPoint: AccessPointVirtualDevice;
  /** The calculated power setting (dBm) for the 5G radio of the access point. */
  txPower: Scalars['Int']['output'];
};

/** An enumeration of possible principal types for authentication tokens. */
export enum PrincipalType {
  /** A device principal, representing a hardware device. */
  Device = 'DEVICE',
  /** A machine principal, a virtual or physical machine. */
  Machine = 'MACHINE',
  /** A user principal, representing a human user. */
  User = 'USER',
}

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type Query = {
  __typename?: 'Query';
  /**
   * Retrieve the OUIs belonging to the given vendor. Accepts a substring of the vendor name and
   * returns all OUIs belonging to vendors whose names contain the substring.
   */
  OUIsForVendor: Array<OuIsForVendorResult>;
  /** Active clients are clients that currently appear both in the MAC and ARP tables of a network. */
  activeClients: ActiveClientsMetricsResponse;
  /** Given one CVE ID (e.g. 'CVE-2023-12345'), list all affected clients. */
  affectedClientsByCVE: Array<AffectedClient>;
  /** Given multiple CVE IDs, list all affected clients. */
  affectedClientsByCVEIDs: Array<AffectedClient>;
  /** See the list of alerts that have been triggered for a company. */
  alertAuditLogEntriesForCompany: Array<AlertAuditLogEntry>;
  /** Fetch all of the known types of Alerts that notify stakeholders of important events for a network. */
  alertDefinitions: Array<AlertDefinition>;
  /** Fetch all known types of Alerts for a network. */
  alertDefinitionsForNetwork: Array<AlertDefinition>;
  /** Get an alert receiver and its targets. */
  alertReceiver: AlertReceiver;
  /** Get all alert receivers and their targets for a company. */
  alertReceiversForCompany: Array<AlertReceiver>;
  /** Get a specific slack alert target by its UUID. */
  alertTargetSlack: AlertTargetSlack;
  /** Get a specific webhook alert target by its UUID. */
  alertTargetWebhook: AlertTargetWebhook;
  /** Get all alert targets for a specified company UUID. */
  alertTargets: AlertTargetsResponse;
  /** Get all slack alert targets for a company. */
  alertTargetsSlack: Array<AlertTargetSlack>;
  /** Get all webhook alert targets for a company. */
  alertTargetsWebhook: Array<AlertTargetWebhook>;
  /** Return all CVEs for every client in a network. */
  allCVEsForNetwork: Array<Cve>;
  /** Timeseries data of data usage metrics for a single client. */
  allClientMetricsByClient: AllClientMetricsTimeseriesResponse;
  /** Timeseries data of data usage metrics for clients on a VLAN. */
  allClientMetricsByVLAN: AllClientMetricsTimeseriesResponse;
  /** Get all marketing changelog entries. */
  allMarketingChangelogEntries: Array<MarketingChangelogEntry>;
  /** Fetch aggregated anomaly stats for multiple virtual devices. */
  anomalyStatsGroupsForVirtualDevices: Array<AnomalyStatsGroup>;
  /**
   * Retrieve the channel utilization metrics for the given network.
   *
   * This resolver is only for Config1 networks and is deprecated in favor of 'channelUtilizationByAP' for Config2 networks.
   * @deprecated Use channelUtilizationByAP for config 2 networks
   */
  apChannelUtilization: ApChannelUtilizationResponse;
  /** Retrieves the latest health metrics for a specified device. */
  apHealthScores: Array<AccessPointHealthScores>;
  /**
   * Deprecated. This is a config1 query.
   * Returns the uptime (how long since a device last booted) of the APs in the network.
   * @deprecated Config1 query
   */
  apUptime: ApUptimeResponse;
  /** Get an application DNS firewall rule. */
  applicationDNSFirewallRule: ApplicationDnsFirewallRule;
  /** Given a hostname, returns the application that would be applied to it. */
  applicationDNSFirewallRuleApplicationForHostname: ApplicationDnsFirewallRuleApplication;
  /**
   * Fetch all applications that DNS firewall rules can be associated with.
   * This currently returns all applications – in the future this will only return visible applications for customers.
   */
  applicationDNSFirewallRuleApplications: Array<ApplicationDnsFirewallRuleApplication>;
  /** Fetch all available Categories of DNS firewall rules. */
  applicationDNSFirewallRuleCategories: Array<ApplicationDnsFirewallRuleCategory>;
  /** Given a hostname, returns the category of DNS firewall rule that would be applied to it. */
  applicationDNSFirewallRuleCategoryForHostname: ApplicationDnsFirewallRuleCategory;
  /** Fetch all groups of DNS firewall rules. */
  applicationDNSFirewallRuleGroups: Array<ApplicationDnsFirewallRuleGroup>;
  /** Fetch all application DNS firewall rules for a network. */
  applicationDNSFirewallRulesForNetwork: Array<ApplicationDnsFirewallRule>;
  /** Get a specific fleetwide notification setting after it has been applied to networks. */
  appliedFleetwideNotificationSetting: Array<AppliedFleetwideNotificationSetting>;
  /**
   * Check if multiple NOS features are enabled for any network in a company.
   * In development environments, this always returns true for a key if it is not recognized on the backend.
   * This checks if *any* network for the specified company supports the NOS features.
   */
  areNosFeaturesEnabledForCompany: Array<NosFeatureEnabled>;
  /**
   * Check if multiple NOS features are enabled for a network.
   * In development environments, this always returns true for a key if it is not recognized on the backend.
   */
  areNosFeaturesEnabledForNetwork: Array<NosFeatureEnabled>;
  /** Fetch an authentication token by its unique identifier (UUID). */
  authenticationToken: AuthenticationToken;
  /** Get an Auto Channel Selection Job by its UUID. */
  autoChannelSelectionJob: AutoChannelSelectionJob;
  /** List all Auto Channel Selection Jobs for a network. */
  autoChannelSelectionJobsForNetwork: Array<AutoChannelSelectionJob>;
  /** Fetch a Switch Auto Configuration Job by its UUID. */
  autoSwitchConfigurationJob: SwitchAutoConfigurationJob;
  /** Fetch all Switch Auto Configuration Jobs for a network. */
  autoSwitchConfigurationJobsForNetwork: Array<SwitchAutoConfigurationJob>;
  /** Get an Auto VPN Group by its UUID. */
  autoVPNGroup: AutoVpnGroup;
  /** Lists Auto VPN Groups for a company. */
  autoVPNGroupsForCompany: Array<AutoVpnGroup>;
  /** Lists Auto VPN Groups for a network. */
  autoVPNGroupsForNetwork: Array<AutoVpnGroup>;
  /** Gets an Auto VPN Member by its UUID. */
  autoVPNMember: AutoVpnMember;
  /** Timeseries data of data usage metrics for members of an Auto VPN Group. */
  autoVPNMemberMetricsForCompany: Array<AutoVpnMemberMetricsResponse>;
  /**
   * Retrieves an existing bearer session by its UUID. A CLI session creates a one-time-use bearer session that must be
   * verified before issuing a token. Once it is verified, the session can no longer be used.
   */
  bearerSession: BearerSession;
  /** Returns all currently blocked clients for the given network. */
  blockedClientsForNetwork: Array<NetworkClientBlocklistEntry>;
  /** Return all of the BSSIDs associated with hardware devices linked to virtual devices in a given network. */
  bssidsForNetwork: Array<Bssid>;
  /** Get a Bulk NOS upgrade by UUID. */
  bulkNOSUpgrade: BulkNosUpgrade;
  /** List Bulk NOS upgrades with the given filter. */
  bulkNOSUpgrades: Array<BulkNosUpgrade>;
  /** Gets a captive portal. */
  captivePortal: CaptivePortal;
  /** Returns all clients that have seen or interacted with the captive portal in the last specified amount of hours. May contain duplicate clients. */
  captivePortalAllClients: Array<CaptivePortalClient>;
  /** Returns authorized clients to the captive portal in the last specified amount of hours. */
  captivePortalAuthorizedClients: Array<CaptivePortalClient>;
  /**
   * Returns a page of captive portal entries for a network along with total count of entries for the given filter.
   * @deprecated Use 'captivePortalEntriesForPortal' instead.
   */
  captivePortalEntriesForNetwork: CaptivePortalEntryPage;
  /** Returns a page of captive portal entries for a captive portal along with total count of entries for the given filter. */
  captivePortalEntriesForPortal: CaptivePortalEntryPage;
  /** Returns a captive portal entry. */
  captivePortalEntry: CaptivePortalEntry;
  /**
   * Gets the enabled captive portal for a network, if any.
   * @deprecated Use `captivePortalsForNetwork` instead.
   */
  captivePortalForNetwork?: Maybe<CaptivePortal>;
  /** Gets the captive portal attached to a VLAN. */
  captivePortalForVLAN?: Maybe<CaptivePortal>;
  /** Gets a captive portal by its webhook key. */
  captivePortalForWebhook?: Maybe<CaptivePortal>;
  /** Lists captive portals for a network. */
  captivePortalsForNetwork: Array<CaptivePortal>;
  /** Returns one timeseries per radio band for all of the radio bands broadcasted by the AP. */
  channelUtilizationByAP: Array<ChannelUtilizationResponseV2>;
  /** Returns a timeseries for channel utilization for the client, aggregated over the APs that the client has been connected to. */
  channelUtilizationByClient: Array<ClientChannelUtilizationTimeseriesValue>;
  /** Returns a time series for each radio band for the APs in the network. */
  channelUtilizationByNetwork: Array<ChannelUtilizationResponseV2>;
  /**
   * Deprecated. Gets client metrics for a device.
   * @deprecated Prefer wirelessClientMetricsByX queries instead.
   */
  clientMetrics: ClientMetricsResponse;
  /** Get a Client VPN client. */
  clientVPNClient: ClientVpnClient;
  /** Timeseries data of data usage metrics for Client VPN client. */
  clientVPNClientMetrics: Array<ClientVpnServerMetricsResponse>;
  /** Lists Client VPN clients for a Client VPN server. */
  clientVPNClients: Array<ClientVpnClient>;
  /** Get a Client VPN server. */
  clientVPNServer: ClientVpnServer;
  /** Lists Client VPN servers for a Network. */
  clientVPNServers: Array<ClientVpnServer>;
  /** Get all the companies that contain global network templates. */
  companiesHoldingGlobalNetworkTemplates: Array<Company>;
  /** Get a company by its UUID. */
  company: Company;
  /** Get a company by its slug. */
  companyBySlug: Company;
  /** Get all the companies that the user is a member of. */
  companyMemberships: Array<Company>;
  /** Get a company user by UUID. */
  companyUser: CompanyUser;
  /** List all company users for the specified company. */
  companyUsers: Array<CompanyUser>;
  /** Get recent console login challenges for a device. */
  consoleLogins: Array<ConsoleLogin>;
  /**
   * Deprecated.
   * Timeseries data of DHCP server uptime metrics for a single controller.
   * @deprecated Data lacks practical relevance.
   */
  controllerDHCPUptime: ControllerDhcpUptimeResponse;
  /** Timeseries data of requests/sec per DNS server for a single controller. */
  controllerDNSRequestRates: ControllerDnsRequestRatesResponse;
  /**
   * Deprecated.
   * Per port timeseries metrics data for a single controller.
   * @deprecated Use `controllerPortMetricsRate` instead.
   */
  controllerPortMetrics: ControllerPortMetricsResponse;
  /** Per port timeseries metrics data as a rate per second for a single controller. */
  controllerPortMetricsRate: ControllerPortMetricsRateResponse;
  /** Per port stats for a specified controller over a lookback period. Encompasses receive/transmission data counters and hardware operational status. */
  controllerPortStats: Array<ControllerPortStat>;
  /**
   * Count how many CVEs exist for each severity, for a given MAC + Network.
   * Used for the 'high/medium/low' columns in the client UI.
   */
  countCVEsBySeverityForMACAddressesBulk: Array<BulkCveSeverityCountResult>;
  /** Get a CPE by its unique identifier. */
  cpe: Cpe;
  /** Get CPEs according to provided filter. */
  cpes: Array<Cpe>;
  /** Fetch the 'Current' configuration for a device, which is the most recent Good configuration that the device is using. Do not confuse this with the 'latest' configuration, which is just the most recent configuration that was rendered. This will differ from the latest if there is a brand new (Received) config that is still being validated, or if the latest config has been marked as Failed, and a rollback has occurred to this Current config. */
  currentDeviceConfig: DeviceConfigMetadata;
  /** Retrieve a CVE by its ID */
  cve: Cve;
  /**
   * Return CVEs for a specific client (networkUUID + macAddress).
   * Optionally filter by severity if provided.
   */
  cvesForMACAddress: Array<Cve>;
  /**
   * Get a device by its serial number.
   * @deprecated Use `hardwareDevice` query instead, accessing `virtualDevice` within the hardware device if necessary.
   */
  device: Device;
  /** Gets the cellular status last reported by a device. */
  deviceCellularStatus?: Maybe<CellularStatus>;
  /** Fetch a specific configuration for a device by its version number. */
  deviceConfigByVersion: DeviceConfig;
  /** Fetch the configuration override for a device; should rarely be used, if ever, in production. */
  deviceConfigOverride: DeviceConfigOverride;
  /** Fetch metadata for all configurations for devices over time ordered by version. */
  deviceConfigs: Array<DeviceConfigMetadata>;
  /** Retrieves the device heartbeat configuration associated with a given device. */
  deviceHeartbeatForDevice: DeviceHeartbeat;
  /**
   * Retrieves the cellular usage of a controller aggregated over the last day.
   *
   * This is its own resolver so that it can be used for both config 1 and config 2.
   */
  deviceLastDayCellularUsage?: Maybe<CellularUsage>;
  /** Retrieves the SIM information for this device. */
  deviceSIM: SuperSim;
  /**
   * Config 1: Retrieves the uptime of a device specified by its serial number.
   * @deprecated Config 1 is deprecated.
   */
  deviceUptime: Scalars['Duration']['output'];
  /**
   * List devices for a network.
   * @deprecated Use `virtualDevicesForNetwork` instead, accessing `hardwareDevice` within the virtual devices if necessary.
   */
  devicesForNetwork: Array<Device>;
  /** Get a list of 5GHz DFS channels. */
  dfsChannels: Array<Scalars['Int']['output']>;
  /** Get a DHCP option by its UUID. */
  dhcpOption: DhcpOption;
  /** Get a DHCP proxy by its UUID. */
  dhcpProxy: DhcpProxy;
  /** Get a DHCP reserved range by its UUID. */
  dhcpReservedRange: DhcpReservedRange;
  /** Get a DHCP rule by its UUID. */
  dhcpRule: DhcpRule;
  /** Get a DHCP rule filter by its UUID. */
  dhcpRuleFilter: DhcpRuleFilter;
  /** Get all DHCP rules for a specific network. */
  dhcpRulesForNetwork: Array<DhcpRule>;
  /** Get a DHCP static mapping by its UUID. */
  dhcpStaticMapping: DhcpStaticMapping;
  /** Returns a list of services discovered on the specified network within the last given number of minutes, filtered by the provided service types. */
  discoveredServicesForNetwork: Array<DiscoveredService>;
  /** Get a DNS host mapping by its UUID. */
  dnsHostMapping: DnsHostMapping;
  /** Generates a pre-signed URL for downloading a file from S3. */
  downloadUrl: FileDownloadPayload;
  /** Lists the 802.1X encryption configurations for a specific network. */
  encryption8021XsForNetwork: Array<Encryption8021X>;
  /** Return the Switch virtual device / phy interface that the given wired client MAC address is associated with using LLDP stats. */
  findSwitchLLDPEntryForMAC?: Maybe<MacAddressSwitchEntry>;
  /** Return the Switch virtual device / phy interface that the given wired client MAC address is associated with. */
  findSwitchesForClientMAC: Array<MacAddressSwitchEntry>;
  /** Get a firewall rule by UUID. */
  firewallRule: FirewallRule;
  /** Timeseries data of data usage metrics for IPSec tunnels. */
  firewallRuleMetrics: Array<FirewallRuleMetricsTimeseriesResponse>;
  /** Get all firewall rules for a network. */
  firewallRulesForNetwork: Array<FirewallRule>;
  /** Get a specific fleetwide notification setting. */
  fleetwideNotificationSetting: FleetwideNotificationSetting;
  /** Get the fleetwide notification settings for a given alert definition. */
  fleetwideNotificationSettings: Array<FleetwideNotificationSetting>;
  /** Get a notification snooze by UUID. */
  fleetwideNotificationSnooze: FleetwideNotificationSnooze;
  /** Get a floor plan by its unique identifier. */
  floorPlan: FloorPlan;
  /** List all floor plans associated with a specific network. */
  floorPlansForNetwork: Array<FloorPlan>;
  /** Gets all fleetwide notification snoozes that end in the future. */
  futureFleetwideNotificationSnoozes?: Maybe<Array<FleetwideNotificationSnooze>>;
  /** Gets all fleetwide notification snoozes for a network that end in the future. */
  futureFleetwideNotificationSnoozesForNetwork?: Maybe<Array<FleetwideNotificationSnooze>>;
  /** Gets all notification snoozes for a network that end in the future. */
  futureNotificationSnoozesForNetwork?: Maybe<Array<NotificationSnooze>>;
  /**
   * Get a company by its slug.
   * @deprecated Use `companyBySlug` instead.
   */
  getCompany?: Maybe<Company>;
  /**
   * Get a company by its UUID.
   * @deprecated Use `company` instead.
   */
  getCompanyByUUID?: Maybe<Company>;
  /** Get an arbitrary previously stored value, unique to the authenticated user. */
  getKeyValue?: Maybe<Scalars['JSON']['output']>;
  /** Return a hardware device by its serial number. */
  hardwareDevice: HardwareDevice;
  /** Return a hardware device by its MAC address. */
  hardwareDeviceByMACAddress: HardwareDevice;
  /** Return a list of hardware devices that match the filter. */
  hardwareDevices: Array<HardwareDevice>;
  /** Get high availability security appliance configuration for a network. */
  highAvailabilityControllersConfig?: Maybe<HighAvailabilityControllersConfig>;
  /** List the honeypot SSIDs observed on a network. */
  honeypotSSIDsObservedOnNetwork?: Maybe<Array<HoneypotSsid>>;
  /** View host monitoring metrics for a network. */
  hostMonitoringForNetwork: Array<HostMonitoringResponse>;
  /** Get a host monitoring target by its UUID. */
  hostMonitoringTarget: HostMonitoringTarget;
  /** List all host monitoring targets for a specific network. */
  hostMonitoringTargetsForNetwork: Array<HostMonitoringTarget>;
  /** Get the valid types for Hotspot 2.0 (Passpoint) configuration. */
  hs20ValidTypes: Hs20ValidTypesResponse;
  /** Retrieve a single IDSEvent. */
  idsEvent: IdsEvent;
  /** A page of IDS events that includes the total number of records. */
  idsEvents: IdsEventsPage;
  /** All of the global IDS/IPS categories that can be configured. */
  idsIPSCategories: Array<IdsipsCategory>;
  /** All of the global IDS/IPS categories that can be configured. */
  idsIPSCategory: IdsipsCategory;
  /** Gets the IDS IPS config for a network. */
  idsIPSConfig?: Maybe<IdsipsConfig>;
  /** The IDS/IPS categories configured for an IDS/IPS configuration. */
  idsIPSConfigCategoryBindings: Array<IdsipsConfigCategoryBinding>;
  /** Get an IDS IPS custom rule. */
  idsIPSCustomRule: IdsipsCustomRule;
  /** A single globally available IDS rule. */
  idsRule: IdsRule;
  /** Configured rules for IDS/IPS configuration. */
  idsRulesForConfig: Array<IdsipsConfigRuleBinding>;
  /** The global list of available rules for a given source version. */
  idsRulesForSourceVersion: IdsRulePage;
  /**
   * Get an incident by its UUID.
   * @deprecated Incidents are no longer supported in Config 2.
   */
  incident: Incident;
  /** List all links between VLANs that are allowed to communicate with each other. */
  interVLANCommunicationPermittedPairs: Array<InterVlanCommunicationPermittedPair>;
  /** Get an internal note by UUID. */
  internalNote: InternalNote;
  /** List all internal notes for a network. */
  internalNotesForNetwork: Array<InternalNote>;
  /** Internet service plan for a given UUID. */
  internetServicePlan?: Maybe<InternetServicePlan>;
  /** Lists all existing ISPConnectionTypes. */
  internetServicePlanConnectionTypes: Array<InternetServicePlanConnectionType>;
  /** Gets an InternetServicePlanProvider. */
  internetServicePlanProvider: InternetServicePlanProvider;
  /** Gets an Internet Service Plan Provider Static Rate. */
  internetServicePlanProviderStaticRate: InternetServicePlanProviderStaticRate;
  /** Lists an existing Internet Service Plan Provider Static Rates. */
  internetServicePlanProviderStaticRates: Array<InternetServicePlanProviderStaticRate>;
  /** Lists an existing InternetServicePlanProviders. */
  internetServicePlanProviders: Array<InternetServicePlanProvider>;
  /** Internet service plans for a given company, and optionally scoped by a network. */
  internetServicePlans: Array<InternetServicePlan>;
  /** Get IP forwarding rule. */
  ipForwardingRule: IpForwardingRule;
  /** List all IP forwarding rules for a specific network. */
  ipForwardingRulesForNetwork: Array<IpForwardingRule>;
  /** Get an IPSec tunnel by UUID. */
  ipSecTunnel: IpSecTunnel;
  /** Timeseries data of data usage metrics for IPSec tunnels. */
  ipSecTunnelMetrics: Array<IpSecTunnelMetricsTimeseriesResponse>;
  /** List all IPSec tunnels for a network. */
  ipSecTunnelsForNetwork: Array<IpSecTunnel>;
  /** A page of IPS events that includes the total number of records. */
  ipsEvents: IdsEventsPage;
  /**
   * Check if a specific NOS feature is enabled for any network in a company.
   * In development environments, this always returns true if the key is not recognized on the backend.
   * This checks if *any* network for the specified company supports the NOS feature.
   */
  isNosFeatureEnabledForCompany: Scalars['Boolean']['output'];
  /**
   * Check if a specific NOS feature is enabled for a network.
   * In development environments, this always returns true if the key is not recognized on the backend.
   */
  isNosFeatureEnabledForNetwork: Scalars['Boolean']['output'];
  /** Lists network onboarding job trackers retrieved from Airtable. */
  jobTrackers: Array<NetworkOnboardingJobData>;
  /**
   * Fetch the latest configuration that a device has acknowledged.
   * @deprecated Prefer `currentDeviceConfig` instead because it incorporates connectivity and rollback checking.
   */
  latestAcknowledgedDeviceConfig: DeviceConfig;
  /**
   * Config 1: Retrieves the latest CPU load information for a device specified by its serial number.
   * @deprecated Config 1 is deprecated.
   */
  latestDeviceCPULoad: LatestDeviceCpuLoad;
  /**
   * Fetches the latest configuration rendered for a device. Does not re-render the configuration;
   * use the `renderDeviceConfig` mutation for that.
   */
  latestDeviceConfig: DeviceConfig;
  /**
   * Config 1: Retrieves the latest memory usage information for a device specified by its serial number.
   * @deprecated Config 1 is deprecated.
   */
  latestDeviceMemoryUsage: LatestDeviceMemoryUsage;
  /** Returns all of the companies, excluding companies that only have Connect quotes. */
  listCompanies: Array<Company>;
  /** Retrieves the maintenance window for the specified network. */
  maintenanceWindowForNetwork: MaintenanceWindow;
  /** Get a single marketing changelog entry by its UUID. */
  marketingChangelogEntry: MarketingChangelogEntry;
  /** Retrieve the list of mutations that a network has undergone. */
  mutationAuditLogEntriesForNetwork: Array<MutationAuditLogEntry>;
  /** Retrieves the list of mutations that a company has undergone, showing the JSON models before and after the mutation. */
  mutationDiffAuditLogEntriesForCompany: Array<MutationDiffAuditLogEntry>;
  /**
   * Retrieve the list of mutations that a network has undergone, showing the JSON models before and after the mutation.
   * @deprecated Use `mutationDiffAuditLogPageForNetwork` instead.
   */
  mutationDiffAuditLogEntriesForNetwork: Array<MutationDiffAuditLogEntry>;
  /** Retrieves the list of mutations that a network has undergone, showing the JSON models before and after the mutation. Includes a count of the total number of entries for pagination. */
  mutationDiffAuditLogPageForNetwork: MutationDiffAuditLogPage;
  /** Retrieves the list of mutations that a network has undergone, showing the JSON models before and after the mutation. Includes a count of the total number of entries for pagination. */
  mutationDiffAuditLogPageForNetworkFiltered: MutationDiffAuditLogPage;
  /** Get a network. */
  network: Network;
  /** Get a network by its slug. */
  networkBySlug: Network;
  /** Get a network client CPE binding by its unique identifier. */
  networkClientCPEBinding: NetworkClientCpeBinding;
  /** Get all network client CPE bindings for a network. */
  networkClientCPEBindingsForNetwork: Array<Maybe<NetworkClientCpeBinding>>;
  /**
   * Get the latest connected clients for a network.
   * The values in filter can alter this behavior.
   */
  networkClients: Array<NetworkClient>;
  /** Get a report of the total number of bytes transmitted and received by each client connected to a network, on a per day basis. */
  networkClientsTxRxPerDay: Array<NetworkClientTxRxPerDay>;
  /** Retrieves all jobs associated with a company that the calling user has permission on the associated network. */
  networkJobsForCompany: Array<NetworkJob>;
  /**
   * Returns the network routes of a virtual device for the most recently acknowledged configuration.
   * This reads from the rendered configuration so includes all implied routes from other features.
   */
  networkRoutesForVirtualDevice: Array<NetworkRoute>;
  /** List the NetworkThreatAllowlistEntries for a network. */
  networkThreatAllowlistForNetwork?: Maybe<Array<NetworkThreatAllowlistEntry>>;
  /**
   * Get metrics about a network's uplink quality (i.e., the ISP quality).
   * Quality is the percentage of successful pings to common web servers over the ISP connection.
   */
  networkUplinkQuality: NetworkUplinkQualityResponse;
  /**
   * Get metrics about a network's uplink throughput (i.e., the ISP throughput).
   * Throughput is the amount of data transferred over the ISP connection, measured in bits per second.
   */
  networkUplinkThroughput: NetworkUplinkThroughputMetricsResponse;
  /** Get all networks that match the given filter. */
  networks: Array<Network>;
  /** Get all of a company's networks. */
  networksForCompany: Array<Network>;
  /** Get uplink quality metrics for multiple networks. */
  networksUplinkQualities: Array<NetworkUplinkQualityResponse>;
  /** Always returns true and does nothing. */
  noop: Scalars['Boolean']['output'];
  /** Get a NOS feature by its UUID. */
  nosFeature: NosFeature;
  /** List all NOS features. */
  nosFeatures: Array<NosFeature>;
  /** Retrieves all NOS versions that were scheduled for a virtual device. */
  nosHistoryForVirtualDevice?: Maybe<Array<VirtualDeviceNosHistory>>;
  /** Fetch all NOS upgrade groups for a network. */
  nosUpgradeGroupsForNetwork: Array<NosUpgradeGroup>;
  /** List all NOS versions with optional filters. */
  nosVersions: Array<NosVersion>;
  /**
   * Get a notification preference by UUID.
   * @deprecated No longer supported.
   */
  notificationPreference: NotificationPreferences;
  /**
   * Get notification preferences for a company and controller.
   * @deprecated No longer supported.
   */
  notificationPreferences: NotificationPreferencesResponse;
  /** Get a notification setting by UUID. */
  notificationSetting: NotificationSetting;
  /** List all notification settings for a network. */
  notificationSettingsForNetwork: Array<NotificationSetting>;
  /** Get a notification snooze by UUID. */
  notificationSnooze: NotificationSnooze;
  /** Get a 1:1 NAT rule by its UUID. */
  oneToOneNATRule: OneToOneNatRule;
  /** List all 1:1 NAT rules for a specific network. */
  oneToOneNATRulesForNetwork: Array<OneToOneNatRule>;
  /** Get all outlet interfaces for a Power Distribution Unit (PDU) virtual device. */
  outletInterfacesForVirtualDevice: Array<OutletInterface>;
  /** Get a single Packet Capture Job. */
  packetCaptureJob: PacketCaptureJob;
  /** List all Packet Capture Jobs for a network. */
  packetCaptureJobsForNetwork: Array<PacketCaptureJob>;
  /** Timeseries data of PDU device. */
  pduMetrics: PduMetricsTimeseriesResponse;
  /** Retrieves the permissions that are assigned to the current user, in context of the provided parameters. */
  permissions: Array<PermissionAssignment>;
  /** Get the physical interfaces associated with a virtual device. */
  phyInterfacesForVirtualDevice: Array<PhyInterface>;
  /** Get a policy routing rule. */
  policyRoutingRule: PolicyRoutingRule;
  /** List policy routing rules for a network. */
  policyRoutingRulesForNetwork: Array<PolicyRoutingRule>;
  /** Get a port forwarding rule by UUID. */
  portForwardingRule: PortForwardingRule;
  /** Get all port forwarding rules for a network. */
  portForwardingRulesForNetwork: Array<PortForwardingRule>;
  /** Lists all `isPublic=true` NOS versions for a network in reverse semver order, starting with versions <= the network's NOS version. */
  publicNOSVersionsForNetwork: Array<NosVersion>;
  /** Get a rack elevation by UUID. */
  rackElevation: RackElevation;
  /** Get all rack elevations for a network. */
  rackElevations: Array<RackElevation>;
  /** Get the radio profiles for a network. */
  radioProfilesForNetwork: Array<RadioProfile>;
  /** Get a rate limit rule by UUID. */
  rateLimitRule: RateLimitRule;
  /** Get all rate limit rules for a network. */
  rateLimitRulesForNetwork: Array<RateLimitRule>;
  /**
   * Events in the event log represent notable state changes in the state of the network.
   * @deprecated Use `recentEventLogEventsPage` instead, includes total count of records for pagination.
   */
  recentEventLogEvents?: Maybe<Array<EventLogEvent>>;
  /** A page of events in the event log that includes the total number of records. */
  recentEventLogEventsPage: EventLogEventsPage;
  /** List the rogue access points observed on a network. */
  rogueAccessPointsObservedOnNetwork?: Maybe<Array<RogueAccessPoint>>;
  /** Retrieves the roles that are assigned to the current user, in context of the provided parameters. */
  roles: Array<RoleAssignment>;
  /** Return all of the scan data associated with a network. */
  scanDataForNetwork: Array<ScanData>;
  /** Fetch all scheduled NOS upgrades for a network in reverse chronological order to see the history of a network's firmware upgrades. Note that only grouped NOS upgrades are returned. */
  scheduledNetworkNOSUpgradesForNetwork: Array<ScheduledNetworkNosUpgrade>;
  /** Retrieves all SIEM integrations for a company. */
  siemIntegrationsForCompany?: Maybe<Array<CompanySiemIntegration>>;
  /** Return the hardware devices that are not associated with a virtual device; they're not in use but affiliated with the network for potential future use. */
  spareHardwareDevicesForNetwork: Array<HardwareDevice>;
  /** Get all speedtest servers for a network. */
  speedtestServersForNetwork: Array<SpeedtestServer>;
  /** Get an SSID */
  ssid: Ssid;
  /** List all SSIDs for a network. */
  ssidsForNetwork: Array<Ssid>;
  /** Retrieves the SSO options that can be configured for a company. */
  ssoOptions: SsoOptions;
  /** Get a static route by UUID. */
  staticRoute: StaticRoute;
  /** List all static routes for a network. */
  staticRoutesForNetwork: Array<StaticRoute>;
  /**
   * Fetch stats (device-generated metrics) for a virtual device.
   * @deprecated Use statsForVirtualDevices instead.
   */
  statsForVirtualDevice: Array<Stat>;
  /** Fetch stats (device-generated metrics) for multiple virtual devices. */
  statsForVirtualDevices: Array<Stat>;
  /**
   * Selecting a NOS upgrade group is mandatory for all devices in a network. Based on the device's label,
   * type, and other attributes, this query will suggest a NOS upgrade group to assign to the device.
   * We take in the parameters rather than the device itself because the device has not been created yet.
   * It's possible the parameters will not match any existing NOS upgrade groups, in which case the query will return null.
   */
  suggestedNOSUpgradeGroupForDevice?: Maybe<NosUpgradeGroup>;
  /** Fetch all MAC address or OUI to VLAN bindings for a network. */
  switchAutoConfigMACAddressVLANBindingsForNetwork: Array<SwitchAutoConfigMacAddressVlanBinding>;
  /**
   * Deprecated in favor of `switchPortMetricsRate`.
   * Retrieve the packet discard rates per port for a specified switch within a given time filter.
   * Discard rates represent the number of packets dropped.
   * @deprecated Use `switchPortMetricsRate` instead.
   */
  switchDiscardRatesPerPort: SwitchMetricsResponse;
  /**
   * Deprecated in favor of `switchPortMetricsRate`.
   * Retrieve the error rates per port for a specified switch within a given time filter.
   * @deprecated Use `switchPortMetricsRate` instead.
   */
  switchErrorRatesPerPort: SwitchMetricsResponse;
  /**
   * Retrieve the MAC address table for a specified switch.
   * The MAC table contains all MAC addresses observed on the switch's ports.
   */
  switchMACTable: Array<SwitchMacTableEntry>;
  /**
   * Deprecated in favor of `switchPortMetricsRate`.
   * Retrieve per-port timeseries metrics data for a specified switch.
   * @deprecated Use `switchPortMetricsRate` instead.
   */
  switchPortMetrics: SwitchPortMetricsResponse;
  /** Retrieve per-port timeseries metrics data expressed as rates (per second) for a specified switch. */
  switchPortMetricsRate: SwitchPortMetricsRateResponse;
  /** Retrieve aggregated per-port statistics for a specified switch over a given lookback period. */
  switchPortStats: Array<SwitchPortStat>;
  /**
   * Deprecated in favor of `switchPortMetricsRate`.
   * Retrieve the per-port throughput for a specified switch within a given time filter.
   * Throughput is measured in bytes per second.
   * @deprecated Use `switchPortMetricsRate` instead.
   */
  switchThroughputPerPort: SwitchMetricsResponse;
  /** Fetch system performance stats for a virtual device (as opposed to network-related data plan stats). */
  systemInfoStatForVirtualDevice: Array<SystemInfoStat>;
  /** A list of hardware devices that are detected as connected to virtual devices in the network without an associated virtual device of their own. */
  unassignedHardwareDevicesForNetwork: Array<UnassignedHardwareDeviceForNetworkResponse>;
  /** Returns network uplink (WAN) physical interfaces for the network (controller interfaces only). */
  uplinkPhyInterfacesForNetwork: Array<PhyInterface>;
  /** Checks if the calling user has access to a network. Responds with the expiration of the access if found. */
  userNetworkAccessExpiry?: Maybe<Scalars['DateTime']['output']>;
  /** Retrieve the vendor for the given OUI, if it exists in the IEEE database. */
  vendorForOUI?: Maybe<IeeeDeviceVendor>;
  /** Return a virtual device by its UUID. */
  virtualDevice: VirtualDevice;
  /** Get all virtual device tags for a network. */
  virtualDeviceTagsByNetwork?: Maybe<Array<VirtualDeviceTag>>;
  /** Get all virtual devices with a specific tag. */
  virtualDevicesByTag?: Maybe<Array<VirtualDevice>>;
  /** Return a list of virtual devices for a network that match the given filter. */
  virtualDevicesForNetwork: Array<VirtualDevice>;
  /** Get visible marketing changelog entries. */
  visibleMarketingChangelogEntries: Array<MarketingChangelogEntry>;
  /** Get a VLAN by UUID. */
  vlan: Vlan;
  /** Timeseries data of data usage metrics for clients on a VLAN. */
  vlanMetrics: Array<VlanMetricsTimeseriesResponse>;
  /** Get all VLANs for a network. */
  vlans: Array<Vlan>;
  /** Retrieve the results or check the status of a specific WAN speed test job. */
  wanSpeedtestJob: WanSpeedtestJob;
  /** Retrieve the results for all WAN speed test jobs on a particular network. */
  wanSpeedtestJobsForNetwork: Array<WanSpeedtestJob>;
  /** Get all Wifi IPSKs for an SSID. */
  wifiIPSKs: Array<WifiIpsk>;
  /** Get all Wifi Observer Settings for a network. */
  wifiObserverSettingsForNetwork: Array<WifiObserverSetting>;
  /** Retrieve the results or check the status of a specific wireless calibration job. */
  wirelessCalibrationJob: WirelessCalibrationJob;
  /** Retrieve the results for all wireless calibration jobs on a particular network. */
  wirelessCalibrationJobsForNetwork: Array<WirelessCalibrationJob>;
  /** A list of events that indicate when clients connected to an AP, disassociated from an AP, or failed to connect to an AP, for all clients on a network. */
  wirelessClientConnectionEvents: Array<WirelessClientConnectionEvent>;
  /** A list of events that indicate when clients connected to an AP, disassociated from an AP, or failed to connect to an AP, for all clients interacting with an AP. */
  wirelessClientConnectionEventsByAP: Array<WirelessClientConnectionEvent>;
  /** A list of events that indicate when a client connected to an AP, disassociated from an AP, or failed to connect to an AP, for a single client. */
  wirelessClientConnectionEventsByClient: Array<WirelessClientConnectionEvent>;
  /**
   * Timeseries data of wireless connectivity metrics for all clients on a network.
   * Returns an aggregated timeseries for each client.
   */
  wirelessClientMetrics: Array<WirelessClientMetricsResponse>;
  /**
   * Timeseries data of wireless connectivity metrics for all clients connected to an AP.
   * Returns a single aggregated timeseries, rather than one per client.
   */
  wirelessClientMetricsByAP: ClientMetricsTimeseriesResponse;
  /** Timeseries data of wireless connectivity metrics for a single client. */
  wirelessClientMetricsByClient: ClientMetricsTimeseriesResponse;
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryOuIsForVendorArgs = {
  vendorSubstring: Scalars['String']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryActiveClientsArgs = {
  filter: MetricsFilterInput;
  input?: InputMaybe<ActiveClientsInput>;
  networkUUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryAffectedClientsByCveArgs = {
  cveID: Scalars['String']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryAffectedClientsByCveiDsArgs = {
  cveIDs: Array<Scalars['String']['input']>;
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryAlertAuditLogEntriesForCompanyArgs = {
  companyUUID: Scalars['UUID']['input'];
  filter?: InputMaybe<AlertAuditLogFilter>;
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryAlertDefinitionsForNetworkArgs = {
  networkUUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryAlertReceiverArgs = {
  UUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryAlertReceiversForCompanyArgs = {
  companyUUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryAlertTargetSlackArgs = {
  UUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryAlertTargetWebhookArgs = {
  UUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryAlertTargetsArgs = {
  companyUUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryAlertTargetsSlackArgs = {
  companyUUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryAlertTargetsWebhookArgs = {
  companyUUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryAllCvEsForNetworkArgs = {
  networkUUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryAllClientMetricsByClientArgs = {
  filter: AllClientMetricsTimeseriesFilterInput;
  macAddress: Scalars['MacAddress']['input'];
  networkUUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryAllClientMetricsByVlanArgs = {
  filter: AllClientMetricsTimeseriesFilterInput;
  networkUUID: Scalars['UUID']['input'];
  vlanUUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryAnomalyStatsGroupsForVirtualDevicesArgs = {
  filter: AnomalyStatsFilterInput;
  networkUUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryApChannelUtilizationArgs = {
  band?: InputMaybe<RadioBand>;
  filter: MetricsFilterInput;
  networkUUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryApHealthScoresArgs = {
  filter: MetricsFilterInput;
  serialNumber: Scalars['String']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryApUptimeArgs = {
  filter: MetricsFilterInput;
  networkUUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryApplicationDnsFirewallRuleArgs = {
  UUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryApplicationDnsFirewallRuleApplicationForHostnameArgs = {
  hostname: Scalars['String']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryApplicationDnsFirewallRuleCategoryForHostnameArgs = {
  hostname: Scalars['String']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryApplicationDnsFirewallRulesForNetworkArgs = {
  networkUUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryAppliedFleetwideNotificationSettingArgs = {
  uuid: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryAreNosFeaturesEnabledForCompanyArgs = {
  companySlug: Scalars['String']['input'];
  nosFeatureKeys: Array<Scalars['String']['input']>;
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryAreNosFeaturesEnabledForNetworkArgs = {
  networkUUID: Scalars['UUID']['input'];
  nosFeatureKeys: Array<Scalars['String']['input']>;
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryAuthenticationTokenArgs = {
  UUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryAutoChannelSelectionJobArgs = {
  jobUUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryAutoChannelSelectionJobsForNetworkArgs = {
  networkUUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryAutoSwitchConfigurationJobArgs = {
  jobUUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryAutoSwitchConfigurationJobsForNetworkArgs = {
  networkUUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryAutoVpnGroupArgs = {
  UUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryAutoVpnGroupsForCompanyArgs = {
  companySlug: Scalars['String']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryAutoVpnGroupsForNetworkArgs = {
  networkUUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryAutoVpnMemberArgs = {
  UUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryAutoVpnMemberMetricsForCompanyArgs = {
  autoVPNGroupUUID?: InputMaybe<Scalars['UUID']['input']>;
  companyUUID: Scalars['UUID']['input'];
  filter: MetricsFilterInput;
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryBearerSessionArgs = {
  UUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryBlockedClientsForNetworkArgs = {
  networkUUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryBssidsForNetworkArgs = {
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
  networkUUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryBulkNosUpgradeArgs = {
  UUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryBulkNosUpgradesArgs = {
  filter: BulkNosUpgradesFilterInput;
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryCaptivePortalArgs = {
  input?: InputMaybe<GetCaptivePortalInput>;
  uuid: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryCaptivePortalAllClientsArgs = {
  networkUUID: Scalars['UUID']['input'];
  numHoursLookback: Scalars['Int']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryCaptivePortalAuthorizedClientsArgs = {
  networkUUID: Scalars['UUID']['input'];
  numHoursLookback: Scalars['Int']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryCaptivePortalEntriesForNetworkArgs = {
  filter?: InputMaybe<CaptivePortalEntryFilterInput>;
  networkUUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryCaptivePortalEntriesForPortalArgs = {
  captivePortalUUID: Scalars['UUID']['input'];
  filter?: InputMaybe<CaptivePortalEntryFilterInput>;
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryCaptivePortalEntryArgs = {
  uuid: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryCaptivePortalForNetworkArgs = {
  networkUUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryCaptivePortalForVlanArgs = {
  vlanUUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryCaptivePortalForWebhookArgs = {
  webhookKey: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryCaptivePortalsForNetworkArgs = {
  networkUUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryChannelUtilizationByApArgs = {
  apVirtualDeviceUUID: Scalars['UUID']['input'];
  band?: InputMaybe<RadioBand>;
  filter: ChannelUtilizationTimeseriesFilterInput;
  networkUUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryChannelUtilizationByClientArgs = {
  filter: ChannelUtilizationTimeseriesFilterInput;
  macAddress: Scalars['MacAddress']['input'];
  networkUUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryChannelUtilizationByNetworkArgs = {
  band?: InputMaybe<RadioBand>;
  filter: ChannelUtilizationTimeseriesFilterInput;
  networkUUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryClientMetricsArgs = {
  filter: MetricsFilterInput;
  serialNumber: Scalars['String']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryClientVpnClientArgs = {
  UUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryClientVpnClientMetricsArgs = {
  clientVPNServerUUID?: InputMaybe<Scalars['UUID']['input']>;
  filter: MetricsFilterInput;
  networkUUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryClientVpnClientsArgs = {
  serverUUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryClientVpnServerArgs = {
  UUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryClientVpnServersArgs = {
  networkUUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryCompanyArgs = {
  UUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryCompanyBySlugArgs = {
  slug: Scalars['String']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryCompanyUserArgs = {
  companyUserUUID: Scalars['UUID']['input'];
  input?: InputMaybe<GetCompanyUserInput>;
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryCompanyUsersArgs = {
  companySlug: Scalars['String']['input'];
  input?: InputMaybe<GetCompanyUserInput>;
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryConsoleLoginsArgs = {
  limit?: Scalars['Int']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  serialNumber: Scalars['String']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryControllerDhcpUptimeArgs = {
  filter: MetricsFilterInput;
  virtualDeviceUUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryControllerDnsRequestRatesArgs = {
  filter: MetricsFilterInput;
  virtualDeviceUUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryControllerPortMetricsArgs = {
  filter: MetricsFilterInput;
  virtualDeviceUUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryControllerPortMetricsRateArgs = {
  filter: MetricsFilterInput;
  portNumber?: InputMaybe<Scalars['Int']['input']>;
  virtualDeviceUUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryControllerPortStatsArgs = {
  lookbackHours?: InputMaybe<Scalars['Int']['input']>;
  portNumber?: InputMaybe<Scalars['Int']['input']>;
  virtualDeviceUUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryCountCvEsBySeverityForMacAddressesBulkArgs = {
  input: Array<CvEsByNetworkMacAddressesInput>;
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryCpeArgs = {
  UUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryCpesArgs = {
  filter: CpEsFilterInput;
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryCurrentDeviceConfigArgs = {
  serialNumber: Scalars['String']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryCveArgs = {
  cveID: Scalars['String']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryCvesForMacAddressArgs = {
  macAddress: Scalars['MacAddress']['input'];
  networkUUID: Scalars['UUID']['input'];
  severity?: InputMaybe<CveSeverity>;
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryDeviceArgs = {
  serialNumber: Scalars['String']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryDeviceCellularStatusArgs = {
  serialNumber: Scalars['String']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryDeviceConfigByVersionArgs = {
  serialNumber: Scalars['String']['input'];
  version: Scalars['Int']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryDeviceConfigOverrideArgs = {
  serialNumber: Scalars['String']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryDeviceConfigsArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  serialNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryDeviceHeartbeatForDeviceArgs = {
  serialNumber: Scalars['String']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryDeviceLastDayCellularUsageArgs = {
  serialNumber: Scalars['String']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryDeviceSimArgs = {
  ICCID?: InputMaybe<Scalars['String']['input']>;
  SID?: InputMaybe<Scalars['String']['input']>;
  serialNumber?: InputMaybe<Scalars['String']['input']>;
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryDeviceUptimeArgs = {
  serialNumber: Scalars['String']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryDevicesForNetworkArgs = {
  filter?: InputMaybe<DevicesForNetworkFilter>;
  networkUUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryDhcpOptionArgs = {
  UUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryDhcpProxyArgs = {
  UUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryDhcpReservedRangeArgs = {
  UUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryDhcpRuleArgs = {
  UUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryDhcpRuleFilterArgs = {
  UUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryDhcpRulesForNetworkArgs = {
  networkUUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryDhcpStaticMappingArgs = {
  UUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryDiscoveredServicesForNetworkArgs = {
  input: DiscoveredServicesInput;
  networkUUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryDnsHostMappingArgs = {
  UUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryDownloadUrlArgs = {
  input: DownloadUrlInput;
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryEncryption8021XsForNetworkArgs = {
  networkUUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryFindSwitchLldpEntryForMacArgs = {
  macAddress: Scalars['MacAddress']['input'];
  networkUUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryFindSwitchesForClientMacArgs = {
  macAddress: Scalars['MacAddress']['input'];
  networkUUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryFirewallRuleArgs = {
  UUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryFirewallRuleMetricsArgs = {
  filter: MetricsFilterInput;
  networkUUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryFirewallRulesForNetworkArgs = {
  networkUUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryFleetwideNotificationSettingArgs = {
  uuid: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryFleetwideNotificationSettingsArgs = {
  filters?: InputMaybe<FleetwideNotificationSettingFiltersInput>;
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryFleetwideNotificationSnoozeArgs = {
  UUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryFloorPlanArgs = {
  UUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryFloorPlansForNetworkArgs = {
  networkUUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryFutureFleetwideNotificationSnoozesForNetworkArgs = {
  networkUUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryFutureNotificationSnoozesForNetworkArgs = {
  networkUUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryGetCompanyArgs = {
  slug: Scalars['String']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryGetCompanyByUuidArgs = {
  uuid: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryGetKeyValueArgs = {
  key: Scalars['String']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryHardwareDeviceArgs = {
  serialNumber: Scalars['String']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryHardwareDeviceByMacAddressArgs = {
  macAddress: Scalars['MacAddress']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryHardwareDevicesArgs = {
  filter?: InputMaybe<HardwareDevicesFilter>;
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryHighAvailabilityControllersConfigArgs = {
  networkUUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryHoneypotSsiDsObservedOnNetworkArgs = {
  filter: NetworkThreatsFilterInput;
  limit?: Scalars['Int']['input'];
  networkUUID: Scalars['UUID']['input'];
  offset?: Scalars['Int']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryHostMonitoringForNetworkArgs = {
  filter: MetricsFilterInput;
  hostIPs?: InputMaybe<Array<Scalars['String']['input']>>;
  networkUUID: Scalars['UUID']['input'];
  virtualDeviceUUID?: InputMaybe<Scalars['UUID']['input']>;
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryHostMonitoringTargetArgs = {
  UUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryHostMonitoringTargetsForNetworkArgs = {
  networkUUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryIdsEventArgs = {
  observedAt: Scalars['DateTime']['input'];
  virtualDeviceUUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryIdsEventsArgs = {
  durationSeconds?: InputMaybe<Scalars['Int']['input']>;
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  filter?: InputMaybe<IdsEventFilterInput>;
  limit?: Scalars['Int']['input'];
  networkUUID: Scalars['UUID']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryIdsIpsCategoryArgs = {
  UUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryIdsIpsConfigArgs = {
  UUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryIdsIpsConfigCategoryBindingsArgs = {
  idsIPSConfigUUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryIdsIpsCustomRuleArgs = {
  UUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryIdsRuleArgs = {
  ruleSID: Scalars['Int']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryIdsRulesForConfigArgs = {
  idsIPSConfigUUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryIdsRulesForSourceVersionArgs = {
  filter?: InputMaybe<IdsRuleFilterInput>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  sourceVersion: Scalars['Int']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryIncidentArgs = {
  UUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryInterVlanCommunicationPermittedPairsArgs = {
  networkUUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryInternalNoteArgs = {
  UUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryInternalNotesForNetworkArgs = {
  networkUUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryInternetServicePlanArgs = {
  uuid: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryInternetServicePlanProviderArgs = {
  uuid: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryInternetServicePlanProviderStaticRateArgs = {
  UUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryInternetServicePlanProviderStaticRatesArgs = {
  providerUUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryInternetServicePlanProvidersArgs = {
  companySlug?: InputMaybe<Scalars['String']['input']>;
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryInternetServicePlansArgs = {
  companySlug: Scalars['String']['input'];
  networkUUID?: InputMaybe<Scalars['UUID']['input']>;
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryIpForwardingRuleArgs = {
  UUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryIpForwardingRulesForNetworkArgs = {
  networkUUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryIpSecTunnelArgs = {
  UUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryIpSecTunnelMetricsArgs = {
  filter: MetricsFilterInput;
  ipSecTunnelUUID?: InputMaybe<Scalars['UUID']['input']>;
  networkUUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryIpSecTunnelsForNetworkArgs = {
  networkUUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryIpsEventsArgs = {
  durationSeconds?: InputMaybe<Scalars['Int']['input']>;
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  idsFilter?: InputMaybe<IdsEventFilterInput>;
  limit?: Scalars['Int']['input'];
  networkUUID: Scalars['UUID']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryIsNosFeatureEnabledForCompanyArgs = {
  companySlug: Scalars['String']['input'];
  nosFeatureKey: Scalars['String']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryIsNosFeatureEnabledForNetworkArgs = {
  networkUUID: Scalars['UUID']['input'];
  nosFeatureKey: Scalars['String']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryLatestAcknowledgedDeviceConfigArgs = {
  serialNumber: Scalars['String']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryLatestDeviceCpuLoadArgs = {
  serialNumber: Scalars['String']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryLatestDeviceConfigArgs = {
  serialNumber: Scalars['String']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryLatestDeviceMemoryUsageArgs = {
  serialNumber: Scalars['String']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryListCompaniesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryMaintenanceWindowForNetworkArgs = {
  networkUUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryMarketingChangelogEntryArgs = {
  UUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryMutationAuditLogEntriesForNetworkArgs = {
  filter?: InputMaybe<MutationAuditLogFilter>;
  networkUUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryMutationDiffAuditLogEntriesForCompanyArgs = {
  companyUUID: Scalars['UUID']['input'];
  filter?: InputMaybe<MutationDiffAuditLogFilterInput>;
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryMutationDiffAuditLogEntriesForNetworkArgs = {
  filter?: InputMaybe<MutationDiffAuditLogFilterInput>;
  networkUUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryMutationDiffAuditLogPageForNetworkArgs = {
  filter?: InputMaybe<MutationDiffAuditLogFilterInput>;
  networkUUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryMutationDiffAuditLogPageForNetworkFilteredArgs = {
  filter?: InputMaybe<MutationDiffAuditLogFilterInput>;
  networkUUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryNetworkArgs = {
  UUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryNetworkBySlugArgs = {
  companySlug: Scalars['String']['input'];
  networkSlug: Scalars['String']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryNetworkClientCpeBindingArgs = {
  UUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryNetworkClientCpeBindingsForNetworkArgs = {
  macAddress?: InputMaybe<Scalars['MacAddress']['input']>;
  networkUUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryNetworkClientsArgs = {
  filter?: InputMaybe<NetworkClientsFilter>;
  networkUUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryNetworkClientsTxRxPerDayArgs = {
  networkUUID: Scalars['UUID']['input'];
  numDaysLookback: Scalars['Int']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryNetworkJobsForCompanyArgs = {
  companyUUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryNetworkRoutesForVirtualDeviceArgs = {
  virtualDeviceUUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryNetworkThreatAllowlistForNetworkArgs = {
  networkUUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryNetworkUplinkQualityArgs = {
  filter: MetricsFilterInput;
  networkUUID: Scalars['UUID']['input'];
  phyInterfaceUUID?: InputMaybe<Scalars['UUID']['input']>;
  virtualDeviceUUID?: InputMaybe<Scalars['UUID']['input']>;
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryNetworkUplinkThroughputArgs = {
  filter: MetricsFilterInput;
  networkUUID: Scalars['UUID']['input'];
  phyInterfaceUUID?: InputMaybe<Scalars['UUID']['input']>;
  virtualDeviceUUID?: InputMaybe<Scalars['UUID']['input']>;
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryNetworksArgs = {
  filter: NetworksFilter;
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryNetworksForCompanyArgs = {
  companySlug: Scalars['String']['input'];
  filter?: InputMaybe<CompanyNetworksFilterInput>;
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryNetworksUplinkQualitiesArgs = {
  filter: MetricsFilterInput;
  networkUUIDs: Array<Scalars['UUID']['input']>;
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryNosFeatureArgs = {
  UUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryNosHistoryForVirtualDeviceArgs = {
  virtualDeviceUUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryNosUpgradeGroupsForNetworkArgs = {
  networkUUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryNosVersionsArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  isGA?: InputMaybe<Scalars['Boolean']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryNotificationPreferenceArgs = {
  uuid: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryNotificationPreferencesArgs = {
  input: GetNotificationPreferencesInput;
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryNotificationSettingArgs = {
  UUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryNotificationSettingsForNetworkArgs = {
  networkUUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryNotificationSnoozeArgs = {
  UUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryOneToOneNatRuleArgs = {
  UUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryOneToOneNatRulesForNetworkArgs = {
  networkUUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryOutletInterfacesForVirtualDeviceArgs = {
  virtualDeviceUUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryPacketCaptureJobArgs = {
  jobId: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryPacketCaptureJobsForNetworkArgs = {
  limit?: Scalars['Int']['input'];
  networkUUID: Scalars['UUID']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryPduMetricsArgs = {
  filter: MetricsFilterInput;
  virtualDeviceUUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryPermissionsArgs = {
  input: PermissionsInput;
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryPhyInterfacesForVirtualDeviceArgs = {
  virtualDeviceUUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryPolicyRoutingRuleArgs = {
  UUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryPolicyRoutingRulesForNetworkArgs = {
  networkUUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryPortForwardingRuleArgs = {
  UUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryPortForwardingRulesForNetworkArgs = {
  networkUUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryPublicNosVersionsForNetworkArgs = {
  networkUUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryRackElevationArgs = {
  UUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryRackElevationsArgs = {
  networkUUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryRadioProfilesForNetworkArgs = {
  networkUUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryRateLimitRuleArgs = {
  UUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryRateLimitRulesForNetworkArgs = {
  networkUUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryRecentEventLogEventsArgs = {
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: Scalars['Int']['input'];
  networkUUID: Scalars['UUID']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryRecentEventLogEventsPageArgs = {
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: Scalars['Int']['input'];
  networkUUID: Scalars['UUID']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
  typeFilter?: InputMaybe<Array<EventType>>;
  virtualDeviceUUIDFilter?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryRogueAccessPointsObservedOnNetworkArgs = {
  filter: NetworkThreatsFilterInput;
  limit?: Scalars['Int']['input'];
  networkUUID: Scalars['UUID']['input'];
  offset?: Scalars['Int']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryRolesArgs = {
  input?: InputMaybe<RolesInput>;
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryScanDataForNetworkArgs = {
  filter: TimeFilter;
  networkUUID: Scalars['UUID']['input'];
  virtualDeviceUUID?: InputMaybe<Scalars['UUID']['input']>;
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryScheduledNetworkNosUpgradesForNetworkArgs = {
  networkUUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QuerySiemIntegrationsForCompanyArgs = {
  companyUUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QuerySpareHardwareDevicesForNetworkArgs = {
  filter?: InputMaybe<HardwareDevicesFilter>;
  networkUUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QuerySpeedtestServersForNetworkArgs = {
  UUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QuerySsidArgs = {
  UUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QuerySsidsForNetworkArgs = {
  networkUUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QuerySsoOptionsArgs = {
  input: SsoOptionsInput;
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryStaticRouteArgs = {
  UUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryStaticRoutesForNetworkArgs = {
  networkUUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryStatsForVirtualDeviceArgs = {
  filter: StatsFilter;
  virtualDeviceUUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryStatsForVirtualDevicesArgs = {
  filter: NetworkStatsFilter;
  networkUUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QuerySuggestedNosUpgradeGroupForDeviceArgs = {
  controllerRole?: InputMaybe<HighAvailabilityControllerRole>;
  deviceLabel: Scalars['String']['input'];
  deviceType: VirtualDeviceType;
  networkUUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QuerySwitchAutoConfigMacAddressVlanBindingsForNetworkArgs = {
  networkUUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QuerySwitchDiscardRatesPerPortArgs = {
  filter: MetricsFilterInput;
  input: MetricsSerialNumberDirectionInput;
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QuerySwitchErrorRatesPerPortArgs = {
  filter: MetricsFilterInput;
  input: MetricsSerialNumberDirectionInput;
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QuerySwitchMacTableArgs = {
  virtualDeviceUUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QuerySwitchPortMetricsArgs = {
  filter: MetricsFilterInput;
  virtualDeviceUUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QuerySwitchPortMetricsRateArgs = {
  filter: MetricsFilterInput;
  portNumber?: InputMaybe<Scalars['Int']['input']>;
  virtualDeviceUUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QuerySwitchPortStatsArgs = {
  lookbackHours?: InputMaybe<Scalars['Int']['input']>;
  portNumber?: InputMaybe<Scalars['Int']['input']>;
  virtualDeviceUUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QuerySwitchThroughputPerPortArgs = {
  filter: MetricsFilterInput;
  input: MetricsSerialNumberDirectionInput;
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QuerySystemInfoStatForVirtualDeviceArgs = {
  filter: SystemInfoStatsFilter;
  virtualDeviceUUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryUnassignedHardwareDevicesForNetworkArgs = {
  networkUUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryUplinkPhyInterfacesForNetworkArgs = {
  networkUUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryUserNetworkAccessExpiryArgs = {
  networkUUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryVendorForOuiArgs = {
  OUI: Scalars['String']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryVirtualDeviceArgs = {
  UUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryVirtualDeviceTagsByNetworkArgs = {
  networkUUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryVirtualDevicesByTagArgs = {
  tagUUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryVirtualDevicesForNetworkArgs = {
  filter?: InputMaybe<DevicesForNetworkFilter>;
  networkUUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryVlanArgs = {
  UUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryVlanMetricsArgs = {
  filter: MetricsFilterInput;
  networkUUID: Scalars['UUID']['input'];
  virtualDeviceUUID: Scalars['UUID']['input'];
  vlanUUID?: InputMaybe<Scalars['UUID']['input']>;
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryVlansArgs = {
  networkUUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryWanSpeedtestJobArgs = {
  UUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryWanSpeedtestJobsForNetworkArgs = {
  networkUUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryWifiIpsKsArgs = {
  ssidUUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryWifiObserverSettingsForNetworkArgs = {
  networkUUID: Scalars['UUID']['input'];
  resultsFilter?: InputMaybe<ObserverResultsFilterInput>;
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryWirelessCalibrationJobArgs = {
  UUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryWirelessCalibrationJobsForNetworkArgs = {
  networkUUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryWirelessClientConnectionEventsArgs = {
  filter: ClientMetricsTimeseriesFilterInput;
  limit?: Scalars['Int']['input'];
  networkUUID: Scalars['UUID']['input'];
  offset?: Scalars['Int']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryWirelessClientConnectionEventsByApArgs = {
  apVirtualDeviceUUID: Scalars['UUID']['input'];
  filter: ClientMetricsTimeseriesFilterInput;
  limit?: Scalars['Int']['input'];
  networkUUID: Scalars['UUID']['input'];
  offset?: Scalars['Int']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryWirelessClientConnectionEventsByClientArgs = {
  filter: ClientMetricsTimeseriesFilterInput;
  limit?: Scalars['Int']['input'];
  macAddress: Scalars['MacAddress']['input'];
  networkUUID: Scalars['UUID']['input'];
  offset?: Scalars['Int']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryWirelessClientMetricsArgs = {
  filter: ClientMetricsTimeseriesFilterInput;
  networkUUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryWirelessClientMetricsByApArgs = {
  apVirtualDeviceUUID: Scalars['UUID']['input'];
  filter: ClientMetricsTimeseriesFilterInput;
  networkUUID: Scalars['UUID']['input'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryWirelessClientMetricsByClientArgs = {
  filter: ClientMetricsTimeseriesFilterInput;
  macAddress: Scalars['MacAddress']['input'];
  networkUUID: Scalars['UUID']['input'];
};

/** A response containing the results of a cable test. */
export type RpcCableTestResponse = {
  __typename?: 'RPCCableTestResponse';
  /** The result for twisted pair A. */
  pairA: RpcCableTestTwistedPairResult;
  /** The result for twisted pair B. */
  pairB: RpcCableTestTwistedPairResult;
  /** The result for twisted pair C. */
  pairC: RpcCableTestTwistedPairResult;
  /** The result for twisted pair D. */
  pairD: RpcCableTestTwistedPairResult;
};

/** Result of the cable test for a single twisted pair. */
export type RpcCableTestTwistedPairResult = {
  __typename?: 'RPCCableTestTwistedPairResult';
  /** The estimated length of the twisted pair in meters. */
  estimatedLengthInMeters: Scalars['Int']['output'];
  /** The status of the twisted pair in the cable test. */
  status: RpcCableTestTwistedPairStatus;
};

/**
 * Cable test checks each pair of wires (Ethernet cables have 4 pairs) to find if they are crimped correctly.
 * The wires can be good, open (not connected), short, or have crosstalk (bad cabling).
 * Emplus's implementation can also estimate the length of the Ethernet cable (in meters).
 * Cable test can only be run on RJ45 Ethernet ports and not on SFP ports.
 */
export enum RpcCableTestTwistedPairStatus {
  /** The twisted pair has crosstalk (bad cabling causing interference between pairs). */
  Crosstalk = 'CROSSTALK',
  /** The twisted pair is functioning correctly. */
  Good = 'GOOD',
  /** The twisted pair is open (not connected at one end). */
  Open = 'OPEN',
  /** The twisted pair has both an open and a short circuit. */
  OpenShort = 'OPEN_SHORT',
  /** The twisted pair has a short circuit. */
  Short = 'SHORT',
  /** The status of the twisted pair is unknown. */
  Unknown = 'UNKNOWN',
}

/** A request to run an EAPOL test on a WOS access point. */
export type RpcEapolTestForSerialInput = {
  /** The UUID of the RADIUS server profile (either primary or secondary encryption 802.1X) to use for the EAPOL test. */
  Encryption8021XUUID: Scalars['UUID']['input'];
  /** The password to use for the EAPOL test. */
  password: Scalars['String']['input'];
  /** The serial number of the device to run the EAPOL test on. */
  serialNumber: Scalars['String']['input'];
  /** The UUID of the SSID to use for the EAPOL test. An EAPOL test without `ssidUuid` will omit sending this field to the authentication server. */
  ssidUuid?: InputMaybe<Scalars['UUID']['input']>;
  /** The username to use for the EAPOL test. */
  user: Scalars['String']['input'];
};

/** A response containing the results of an EAPOL test. */
export type RpcEapolTestForSerialResponse = {
  __typename?: 'RPCEapolTestForSerialResponse';
  /** A human-readable error message if the EAPOL test failed with an unknown error. */
  error_reason?: Maybe<Scalars['String']['output']>;
  /** The serial number of the device this test was run on. */
  serialNumber: Scalars['String']['output'];
  /** The status of the EAPOL server response. */
  status: RpcEapolTestForSerialStatus;
};

/**
 * EAPOL (Extensible Authentication Protocol over LAN) is a network authentication protocol used in IEEE 802.1X to
 * authenticate users and computers in a network through a RADIUS server. It is used in wireless networks (WPA-Enterprise)
 * to secure access. The EAPOL test RPC runs directly on a WOS access point and simulates a client connecting wirelessly to
 * an AP performing RADIUS authentication. A successful EAPOL test means that the AP can authenticate a client with the
 * RADIUS server using the provided credentials and validates that a client can connect to the network.
 */
export enum RpcEapolTestForSerialStatus {
  /** The EAPOL test failed due to bad user/password credentials. */
  FailureBadCredentials = 'FAILURE_BAD_CREDENTIALS',
  /** The EAPOL test failed due to an incorrect RADIUS secret. */
  FailureIncorrectRadiusSecret = 'FAILURE_INCORRECT_RADIUS_SECRET',
  /** The EAPOL test failed due to the server not responding in time. */
  FailureRadiusServerTimeout = 'FAILURE_RADIUS_SERVER_TIMEOUT',
  /** The EAPOL test failed due to an unknown error. See `error_reason` for more details. */
  FailureUnknown = 'FAILURE_UNKNOWN',
  /** The EAPOL test was successful. */
  Success = 'SUCCESS',
}

/** A request to run EAPOL tests on multiple WOS access points. */
export type RpcEapolTestForSerialsInput = {
  /** The UUID of the RADIUS server profile (either primary or secondary encryption 802.1X) to use for the EAPOL tests. */
  Encryption8021XUUID: Scalars['UUID']['input'];
  /** The password to use for the EAPOL tests. */
  password: Scalars['String']['input'];
  /** The serial numbers of the devices to run the EAPOL tests on. */
  serialNumbers: Array<Scalars['String']['input']>;
  /** The UUID of the SSID to use for the EAPOL tests. An EAPOL test without `ssidUuid` will omit sending this field to the authentication server. */
  ssidUuid?: InputMaybe<Scalars['UUID']['input']>;
  /** The username to use for the EAPOL tests. */
  user: Scalars['String']['input'];
};

/** A request to power-cycle an outlet on a Power Distribution Unit (PDU). */
export type RpcpduOutletCycleInput = {
  /** A list of UUIDs identifying the outlets to cycle. */
  outletUUIDs: Array<Scalars['UUID']['input']>;
};

/** A request to ping from a device to a specified host. */
export type RpcPingInput = {
  /** The number of ping packets the device sends at once. Defaults to 5. */
  burstSize?: Scalars['Int']['input'];
  /** The host IP address or domain name to ping. */
  host: Scalars['String']['input'];
  /** The interval between bursts of pings, in seconds. Defaults to 1 second. */
  intervalSeconds?: Scalars['Int']['input'];
  /** The number of bursts to send. Defaults to 1. */
  numberOfBursts?: Scalars['Int']['input'];
  /** The UUID of the physical interface if the user selects to ping out of a specific WAN port. */
  phyInterfaceUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** The serial number of the device issuing the ping. */
  serialNumber: Scalars['String']['input'];
  /** Maximum number of seconds before the ping command exits, regardless of how many packets have been sent or received. Defaults to 5 seconds. */
  timeoutSeconds?: Scalars['Int']['input'];
  /** The UUID of the VLAN if the user selects to ping out of a VLAN interface (for both client ping and WAN ping). */
  vlanUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** The WAN interface to use for the ping (`wan0` or `wan1`). Defaults to `wan0`. Config-1 only. */
  wanInterface?: InputMaybe<Scalars['String']['input']>;
};

/** A response containing the results of a ping operation. */
export type RpcPingResponse = {
  __typename?: 'RPCPingResponse';
  /** The mean round-trip time in milliseconds, if any pings were successful. */
  roundTripTimeMs?: Maybe<Scalars['Int']['output']>;
  /** The number of successful pings divided by the total number of pings, expressed as a float between 0 and 1. */
  successRate: Scalars['Float']['output'];
};

/** A response containing the status of a reboot request. */
export type RpcRebootDeviceResponse = {
  __typename?: 'RPCRebootDeviceResponse';
  /** The error message from the reboot, if any. */
  error?: Maybe<Scalars['String']['output']>;
  /** The serial number of the device that was attempted to be rebooted. */
  serialNumber: Scalars['String']['output'];
  /** Whether the reboot was successful. */
  success: Scalars['Boolean']['output'];
};

/** A request to power-cycle a port on a Meter switch. */
export type RpcSwitchPortCycleInput = {
  /** The number of seconds between disabling and re-enabling the port (range 1-30 seconds). Defaults to 3 seconds. */
  cycleDownSec?: InputMaybe<Scalars['Int']['input']>;
  /** If true, cycle the Power over Ethernet (PoE) on the port by disabling and re-enabling it. */
  poeCycle?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, cycle the port by disabling and re-enabling it. */
  portCycle?: InputMaybe<Scalars['Boolean']['input']>;
  /** The port number to cycle. */
  portNumber: Scalars['Int']['input'];
  /** The serial number of the switch whose port needs cycling. */
  serialNumber: Scalars['String']['input'];
};

/** A request to run a WAN speed test on a Meter device. */
export type RpcwanSpeedtestInput = {
  /** Config 2 only. The UUID of the physical interface. If omitted, will select the currently active WAN. */
  phyInterfaceUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** The serial number of the device to run the speed test on. */
  serialNumber: Scalars['String']['input'];
  /** Config 2 only. The server ID retrieved with a call to `speedtestServersForNetwork`. If omitted, the controller will auto-select a server. */
  serverID?: InputMaybe<Scalars['String']['input']>;
  /** The WAN interface to run the speed test on (e.g., `WAN1`, `WAN2`). */
  wan?: InputMaybe<Wan>;
};

/** A response containing the results of a WAN speed test. */
export type RpcwanSpeedtestResponse = {
  __typename?: 'RPCWANSpeedtestResponse';
  /** Config 2 only. The distance to the target server, in kilometers. */
  distance?: Maybe<Scalars['Float']['output']>;
  /** The measured download speed in megabits per second. */
  downloadSpeedMbps: Scalars['Float']['output'];
  /** Config 2 only. The measured jitter in nanoseconds. */
  jitterNs?: Maybe<Scalars['Int']['output']>;
  /** Config 2 only. The measured latency in nanoseconds. */
  latencyNs?: Maybe<Scalars['Int']['output']>;
  /** Config 2 only. The host of the target server the test was run against. */
  targetHost?: Maybe<Scalars['String']['output']>;
  /** Config 2 only. The name of the target server the test was run against. */
  targetName?: Maybe<Scalars['String']['output']>;
  /** The measured upload speed in megabits per second. */
  uploadSpeedMbps: Scalars['Float']['output'];
};

/** A request to run a wireless calibration job on all devices on a meter network with a given AP. */
export type RpcWirelessCalibrationInput = {
  /** The channel to set the APs to. */
  channel?: InputMaybe<Scalars['Int']['input']>;
  /** Unique identifier of the calibration job. */
  jobUUID: Scalars['UUID']['input'];
  /** The power to set the APs to. */
  power?: InputMaybe<Scalars['Int']['input']>;
  /** The serial number of the device to start the wireless calirbation on. */
  serialNumber: Scalars['String']['input'];
};

/** A response containing the status of the wireless calibration job including some extra information. */
export type RpcWirelessCalibrationResponse = {
  __typename?: 'RPCWirelessCalibrationResponse';
  /** Errors from running the wireless calibration job, if any. */
  error?: Maybe<Scalars['String']['output']>;
  /** Unique identifier of the calibration job */
  jobUUID: Scalars['UUID']['output'];
  /** The serial number of the device that was the leader AP of the calibration job. */
  serialNumber: Scalars['String']['output'];
  /** Status of the wireless calibration job. */
  status: Scalars['Boolean']['output'];
};

/** Results of a command executed during the Observer test. */
export type RpcWosObserverCommandResults = {
  __typename?: 'RPCWosObserverCommandResults';
  /** Average duration of the command execution in msec. */
  avgDurationMsec: Scalars['Int']['output'];
  /** Average number of bytes transferred per command execution. */
  avgNumBytes: Scalars['Int']['output'];
  /** Index of the test command, matching the request. */
  index: Scalars['Int']['output'];
  /** Jitter (variability) in the command execution duration in msec. */
  jitterMsec: Scalars['Int']['output'];
  /** Maximum duration of the command execution in msec. */
  maxDurationMsec: Scalars['Int']['output'];
  /** Minimum duration of the command execution in msec. */
  minDurationMsec: Scalars['Int']['output'];
  /** Number of attempts made to run the command. */
  numAttempts: Scalars['Int']['output'];
  /** Ratio of successful attempts to total attempts, expressed as a float between 0 and 1. */
  successRatio: Scalars['Float']['output'];
};

/** A request to run Observer tests on a Meter Observer device. */
export type RpcWosObserverInput = {
  /** The UUID of the SSID to use for the Observer test. If empty with `triggerTest` set to true, will simply cancel the previous test. */
  SSIDUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** The Wi-Fi band on which the test should be run (e.g., 2G, 5G, 6G). */
  band?: InputMaybe<RadioBand>;
  /** A list of commands to run during the Observer test. */
  commands?: InputMaybe<Array<WosObserverCommandInput>>;
  /** Indicates whether to run the Observer test in debug mode. */
  debugMode?: InputMaybe<Scalars['Boolean']['input']>;
  /** The duration of the test in msec. */
  durationMsec?: InputMaybe<Scalars['Int']['input']>;
  /** If true, retrieves the results from a previously triggered Observer test. */
  getTestResults?: InputMaybe<Scalars['Boolean']['input']>;
  /** Hostname to use with DHCP; if unset, the firmware generates it. */
  hostname?: InputMaybe<Scalars['String']['input']>;
  /** If set, limits the number of spatial streams for the test. */
  numSpatialStreams?: InputMaybe<Scalars['Int']['input']>;
  /** The 802.1X password to use for authentication in the Observer test. */
  password8021X?: InputMaybe<Scalars['String']['input']>;
  /** The serial number of the Observer device to run the test on. */
  serialNumber: Scalars['String']['input'];
  /** The serial number of the target device the Observer will focus on or get results for. */
  targetSerialNumber?: InputMaybe<Scalars['String']['input']>;
  /** The timeout for the connection attempt in msec. */
  timeoutMsec?: InputMaybe<Scalars['Int']['input']>;
  /** When WPA3 transition is enabled, specifies whether to use WPA2 (true) or WPA3 (false). */
  transitionUseWpa2?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, triggers the Observer test on the device. */
  triggerTest?: InputMaybe<Scalars['Boolean']['input']>;
  /** TX power to use for the test; if unset or 0, uses the TX power of the targeted AP. */
  txPowerDbm?: Scalars['Int']['input'];
  /** Indicates whether to use Protected Management Frames (802.11w). With WPA3, 802.11w is used anyway. */
  use11w?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates whether to use the scanning radio for this test. */
  useScanningRadio?: InputMaybe<Scalars['Boolean']['input']>;
  /** The 802.1X username to use for authentication in the Observer test. */
  username8021X?: InputMaybe<Scalars['String']['input']>;
};

/** A response containing the status and results of an Observer test. */
export type RpcWosObserverResponse = {
  __typename?: 'RPCWosObserverResponse';
  /** A reason for a failure, if any. */
  failureReason?: Maybe<Scalars['String']['output']>;
  /** The results of the Observer tests. */
  testResults?: Maybe<Array<RpcWosObserverTestResults>>;
  /** The status of a trigger request for the Observer test. */
  triggerStatus: RpcWosObserverResponseStatus;
};

/** Status of the Observer test trigger response. */
export enum RpcWosObserverResponseStatus {
  /** The Observer test failed to trigger. */
  TriggerFail = 'TRIGGER_FAIL',
  /** The Observer test was successfully triggered. */
  TriggerOk = 'TRIGGER_OK',
  /** Unspecified status. */
  Unspecified = 'UNSPECIFIED',
}

/** Results of an Observer test. */
export type RpcWosObserverTestResults = {
  __typename?: 'RPCWosObserverTestResults';
  /** Duration of the DHCP phase in milliseconds. */
  DHCPDurationMsec: Scalars['Int']['output'];
  /** Duration of the association phase in milliseconds. */
  assocDurationMsec: Scalars['Int']['output'];
  /** Duration of the authentication phase in milliseconds. */
  authDurationMsec: Scalars['Int']['output'];
  /** The Wi-Fi band on which the test was run. */
  band: RadioBand;
  /** Results of all commands executed during the test. */
  commandResults?: Maybe<Array<RpcWosObserverCommandResults>>;
  /** Duration of the scan phase in milliseconds. */
  scanDurationMsec: Scalars['Int']['output'];
  /** The UUID of the SSID used for the Observer test. */
  ssidUuid?: Maybe<Scalars['UUID']['output']>;
  /** Start time of the test. */
  startedAt: Scalars['DateTime']['output'];
  /** The serial number of the target device for which the Observer test was run. */
  targetSerialNumber: Scalars['String']['output'];
};

/** To start a packet capture on a specific channel (for Observers) */
export type RpcWosPacketCaptureRadioParametersInput = {
  /** The band */
  band: RadioBand;
  /** The channel to capture on for this band */
  channel: Scalars['Int']['input'];
  /** The channel width to capture on */
  channelWidth: ChannelWidth;
};

/** A response containing the status of a packet capture request. */
export type RpcWosPacketCaptureResponse = {
  __typename?: 'RPCWosPacketCaptureResponse';
  /** The job ID of the packet capture. */
  jobId: Scalars['String']['output'];
  /** Status of the packet capture request. */
  status: RpcWosPacketCaptureResponseStatus;
};

/** Status of the packet capture response. */
export enum RpcWosPacketCaptureResponseStatus {
  /** The packet capture request failed. */
  Fail = 'FAIL',
  /** The tcpdump filter provided is not valid and did not compile correctly. */
  FailFilterCompilation = 'FAIL_FILTER_COMPILATION',
  /** The requested interface is not yet implemented for packet captures. */
  FailInterfaceNotImplemented = 'FAIL_INTERFACE_NOT_IMPLEMENTED',
  /** Packet capture failed due to blank job ID. */
  FailNoJobId = 'FAIL_NO_JOB_ID',
  /** Packet capture failed due to blank size limit. */
  FailNoSizeLimit = 'FAIL_NO_SIZE_LIMIT',
  /** Packet capture failed due to blank time limit. */
  FailNoTimeLimit = 'FAIL_NO_TIME_LIMIT',
  /** The packet capture request was successful. */
  Ok = 'OK',
  /** Unspecified status. */
  Unspecified = 'UNSPECIFIED',
}

/** Run a packet capture on a device. */
export type RpcWosPacketCaptureStartInput = {
  /** Channels to listen on (for Observers) */
  channels?: InputMaybe<Array<RpcWosPacketCaptureRadioParametersInput>>;
  /** The interface(s) to listen on (wireless radio(s), or wired). */
  listenOn: WosPacketCaptureCommandMonitor;
  /** Whether or not the packet capture should be stored in /tmp on the device. */
  onDevice?: InputMaybe<Scalars['Boolean']['input']>;
  /** Maximum size of a packet in the capture (truncate if larger); if unset, no maximum. */
  packetSizeLimitBytes?: InputMaybe<Scalars['Int']['input']>;
  /** The maximum size limit of the packet capture file in megabytes. */
  sizeLimitMb: Scalars['Int']['input'];
  /** The filter ID to be applied to the packet capture. Not yet implemented in firmware. */
  tcpdumpFilter?: InputMaybe<Scalars['String']['input']>;
  /** The maximum duration of the packet capture in seconds. */
  timeLimitSec: Scalars['Int']['input'];
};

/** Stop a packet capture on a device. */
export type RpcWosPacketCaptureStopInput = {
  /** The job ID of the packet capture to stop. */
  jobId: Scalars['String']['input'];
};

/** A rack elevation is a 2D representation of racks of hardware in a datacenter or supply closet. */
export type RackElevation = {
  __typename?: 'RackElevation';
  /** The unique identifier for the rack elevation. */
  UUID: Scalars['UUID']['output'];
  /** The list of devices that are attached to this rack elevation. */
  devices: Array<RackElevationDevice>;
  /** The left-to-right position of the rack relative to others. */
  horizontalIndex?: Maybe<Scalars['Int']['output']>;
  /** Human-readable name for the rack elevation. */
  label: Scalars['String']['output'];
  /** The unique identifier of the network to which this rack elevation belongs. */
  networkUUID: Scalars['UUID']['output'];
  /** Notes associated with this rack elevation. */
  notes?: Maybe<Array<RackElevationNote>>;
  /** The number of rack units (like slots) for the rack elevation. */
  rackMountUnitCount: Scalars['Int']['output'];
};

/** A device attached to a rack elevation. */
export type RackElevationDevice = {
  __typename?: 'RackElevationDevice';
  /** The unique identifier for the rack elevation device. */
  UUID: Scalars['UUID']['output'];
  /** Whether the device is front-facing or rear-facing. */
  isFrontFacing: Scalars['Boolean']['output'];
  /** If the device is a switch, whether it supports PoE. */
  isPoESupported?: Maybe<Scalars['Boolean']['output']>;
  /** A friendly name for display purposes. */
  label?: Maybe<Scalars['String']['output']>;
  /** The hardware device's model. */
  model?: Maybe<Scalars['String']['output']>;
  /** Additional context or comments about the device. */
  notes?: Maybe<Scalars['String']['output']>;
  /** The number of ports on the device. */
  portCount?: Maybe<Scalars['Int']['output']>;
  /** The unique identifier of the rack elevation to which this device is attached. */
  rackElevationUUID: Scalars['UUID']['output'];
  /** The indexes of the rack units that the device occupies. */
  rackMountUnitIndexes: Array<Scalars['Int']['output']>;
  /** A non-null value if the device shares or will share its rack mount unit with another device. 0-indexed; lower number is to the left when viewing the rack from the front. For simplicity this is currently limited to 0 or 1 (at-most 2 devices per rack mount unit). */
  sideBySideIndex?: Maybe<Scalars['Int']['output']>;
  /** The type of the device (e.g., switch, patch panel, etc.). */
  type: RackElevationDeviceType;
  /** The virtual device associated with this rack elevation device. */
  virtualDevice?: Maybe<VirtualDevice>;
  /** If the device is associated with a virtual device, this is the UUID of that virtual device. */
  virtualDeviceUUID?: Maybe<Scalars['UUID']['output']>;
};

/** An enumeration of possible device types that can be attached to a rack elevation. */
export enum RackElevationDeviceType {
  /** A cable management device. */
  CableManagement = 'CABLE_MANAGEMENT',
  /** A fiber optic device. */
  Fiber = 'FIBER',
  /** An Internet Service Provider (ISP) device. */
  Isp = 'ISP',
  /** A Meter access point device. */
  MeterAccessPoint = 'METER_ACCESS_POINT',
  /** A Meter controller device. */
  MeterController = 'METER_CONTROLLER',
  /** A Meter PDU device. */
  MeterPdu = 'METER_PDU',
  /** A Meter switch device. */
  MeterSwitch = 'METER_SWITCH',
  /** A non-Meter switch device. */
  NonMeterSwitch = 'NON_METER_SWITCH',
  /** Other type of device. */
  Other = 'OTHER',
  /** A patch panel. */
  PatchPanel = 'PATCH_PANEL',
  /** A universal power supply (UPS) device. */
  UniversalPowerSupply = 'UNIVERSAL_POWER_SUPPLY',
}

/** A note associated with a rack elevation, applicable to a range of rack units. */
export type RackElevationNote = {
  __typename?: 'RackElevationNote';
  /** The content of the note. */
  note: Scalars['String']['output'];
  /** The ending rack mount unit index where the note applies. */
  rackMountUnitIndexEnd: Scalars['Int']['output'];
  /** The starting rack mount unit index where the note applies. */
  rackMountUnitIndexStart: Scalars['Int']['output'];
};

/** Input type for creating or updating a rack elevation note. */
export type RackElevationNoteInput = {
  /** The content of the note. */
  note: Scalars['String']['input'];
  /** The ending rack mount unit index for the note. */
  rackMountUnitIndexEnd: Scalars['Int']['input'];
  /** The starting rack mount unit index for the note. */
  rackMountUnitIndexStart: Scalars['Int']['input'];
};

/** An enumeration of radio bands. */
export enum RadioBand {
  /** Represents the 2.4 GHz radio band. */
  Band_2_4G = 'BAND_2_4G',
  /** Represents the 5 GHz radio band. */
  Band_5G = 'BAND_5G',
  /** Represents the 6 GHz radio band. */
  Band_6G = 'BAND_6G',
}

/** Contains configuration for wireless radios. A profile is a way to apply the same configuration to multiple APs. */
export type RadioProfile = {
  __typename?: 'RadioProfile';
  /** The unique identifier for the radio profile. */
  UUID: Scalars['UUID']['output'];
  /**
   * Only set if band2_4GAutoChannelIsEnabled is true.
   * This is the list of channels that are permitted for ACS (auto channel selection) to
   * select from and is user-configurable.
   */
  band2_4GAllowedChannels?: Maybe<Array<Scalars['Int']['output']>>;
  /** Indicates whether auto channel selection is enabled for the 2.4 GHz band. */
  band2_4GAutoChannelIsEnabled: Scalars['Boolean']['output'];
  /** Indicates whether auto channel width selection is enabled for the 2.4 GHz band. */
  band2_4GAutoChannelWidthIsEnabled: Scalars['Boolean']['output'];
  /** Indicates whether automatic transmit power adjustment is enabled for the 2.4 GHz band. */
  band2_4GAutoTxPowerIsEnabled: Scalars['Boolean']['output'];
  /**
   * Only set if band2_4GAutoTxPowerIsEnabled is true.
   * The maximum transmit power in dBm for the 2.4 GHz band when auto transmit power is enabled.
   */
  band2_4GAutoTxPowerMaxdBm?: Maybe<Scalars['Int']['output']>;
  /**
   * Only set if band2_4GAutoTxPowerIsEnabled is true.
   * The minimum transmit power in dBm for the 2.4 GHz band when auto transmit power is enabled.
   */
  band2_4GAutoTxPowerMindBm?: Maybe<Scalars['Int']['output']>;
  /**
   * Only set if band2_4GAutoChannelWidthIsEnabled is false.
   * The channel width in MHz for the 2.4 GHz band when auto channel width is disabled.
   */
  band2_4GChannelWidthMHz?: Maybe<Scalars['Int']['output']>;
  /** Indicates whether the 2.4 GHz band is enabled. */
  band2_4GIsEnabled: Scalars['Boolean']['output'];
  /**
   * Only set if band5GAutoChannelIsEnabled is true.
   * This is the list of channels that are permitted for ACS (auto channel selection) to
   * select from and is user-configurable.
   */
  band5GAllowedChannels?: Maybe<Array<Scalars['Int']['output']>>;
  /** Indicates whether auto channel selection is enabled for the 5 GHz band. */
  band5GAutoChannelIsEnabled: Scalars['Boolean']['output'];
  /** Indicates whether auto channel width selection is enabled for the 5 GHz band. */
  band5GAutoChannelWidthIsEnabled: Scalars['Boolean']['output'];
  /** Indicates whether automatic transmit power adjustment is enabled for the 5 GHz band. */
  band5GAutoTxPowerIsEnabled: Scalars['Boolean']['output'];
  /**
   * Only set if band5GAutoTxPowerIsEnabled is true.
   * The maximum transmit power in dBm for the 5 GHz band when auto transmit power is enabled.
   */
  band5GAutoTxPowerMaxdBm?: Maybe<Scalars['Int']['output']>;
  /**
   * Only set if band5GAutoTxPowerIsEnabled is true.
   * The minimum transmit power in dBm for the 5 GHz band when auto transmit power is enabled.
   */
  band5GAutoTxPowerMindBm?: Maybe<Scalars['Int']['output']>;
  /**
   * Only set if band5GAutoChannelWidthIsEnabled is false.
   * The channel width in MHz for the 5 GHz band when auto channel width is disabled.
   */
  band5GChannelWidthMHz?: Maybe<Scalars['Int']['output']>;
  /** Indicates whether the 5 GHz band is enabled. */
  band5GIsEnabled: Scalars['Boolean']['output'];
  /**
   * Only set if band6GAutoChannelIsEnabled is true.
   * This is the list of channels that are permitted for ACS (auto channel selection) to
   * select from and is user-configurable.
   */
  band6GAllowedChannels?: Maybe<Array<Scalars['Int']['output']>>;
  /** Indicates whether auto channel selection is enabled for the 6 GHz band. */
  band6GAutoChannelIsEnabled: Scalars['Boolean']['output'];
  /** Indicates whether auto channel width selection is enabled for the 6 GHz band. */
  band6GAutoChannelWidthIsEnabled: Scalars['Boolean']['output'];
  /** Indicates whether automatic transmit power adjustment is enabled for the 6 GHz band. */
  band6GAutoTxPowerIsEnabled: Scalars['Boolean']['output'];
  /**
   * Only set if band6GAutoTxPowerIsEnabled is true.
   * The maximum transmit power in dBm for the 6 GHz band when auto transmit power is enabled.
   */
  band6GAutoTxPowerMaxdBm?: Maybe<Scalars['Int']['output']>;
  /**
   * Only set if band6GAutoTxPowerIsEnabled is true.
   * The minimum transmit power in dBm for the 6 GHz band when auto transmit power is enabled.
   */
  band6GAutoTxPowerMindBm?: Maybe<Scalars['Int']['output']>;
  /**
   * Only set if band6GAutoChannelWidthIsEnabled is false.
   * The channel width in MHz for the 6 GHz band when auto channel width is disabled.
   */
  band6GChannelWidthMHz?: Maybe<Scalars['Int']['output']>;
  /** Indicates whether the 6 GHz band is enabled. */
  band6GIsEnabled: Scalars['Boolean']['output'];
  /** The timestamp when the radio profile was created. */
  createdAt: Scalars['DateTime']['output'];
  /** A human-readable description. */
  description?: Maybe<Scalars['String']['output']>;
  /** Indicates whether this profile is the default profile for the network. */
  isDefault: Scalars['Boolean']['output'];
  /** The name of the radio profile. */
  name: Scalars['String']['output'];
  /** The unique identifier of the network to which this radio profile belongs. */
  networkUUID: Scalars['UUID']['output'];
  /** The ISO2 country code where the device is located. */
  regulatoryDomain: Scalars['String']['output'];
  /** The timestamp when the radio profile was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** The list of virtual devices (access points) attached to this radio profile. */
  virtualDevices: Array<VirtualDevice>;
};

/** An individual Access Point's radio settings (channel, power). Other radio settings are configured in the radio profile and shared across multiple APs. */
export type RadioSettings = {
  __typename?: 'RadioSettings';
  /** The active channel for the 2.4 GHz radio band. It can be used to determine if the AP is broadcasting on the primary, secondary, or other (DFS, etc). It comes from stats, and is not configurable. */
  band2_4GActiveChannel?: Maybe<Scalars['Int']['output']>;
  /** The primary channel for the 2.4 GHz radio band. */
  band2_4GPrimaryChannel: Scalars['Int']['output'];
  /** The transmit power in dBm for the 2.4 GHz radio band. */
  band2_4GTransmitPowerdBm: Scalars['Int']['output'];
  /** The active channel for the 5 GHz radio band. It can be used to determine if the AP is broadcasting on the primary, secondary, or other (DFS, etc). It comes from stats, and is not configurable. */
  band5GActiveChannel?: Maybe<Scalars['Int']['output']>;
  /** The primary channel for the 5 GHz radio band. */
  band5GPrimaryChannel: Scalars['Int']['output'];
  /** The secondary channel for the 5 GHz radio band, if applicable. */
  band5GSecondaryChannel?: Maybe<Scalars['Int']['output']>;
  /** The transmit power in dBm for the 5 GHz radio band. */
  band5GTransmitPowerdBm: Scalars['Int']['output'];
  /** The active channel for the 6 GHz radio band. It can be used to determine if the AP is broadcasting on the primary, secondary, or other (DFS, etc). It comes from stats, and is not configurable. */
  band6GActiveChannel?: Maybe<Scalars['Int']['output']>;
  /** The primary channel for the 6 GHz radio band. */
  band6GPrimaryChannel: Scalars['Int']['output'];
  /** The transmit power in dBm for the 6 GHz radio band. */
  band6GTransmitPowerdBm: Scalars['Int']['output'];
  /** The UUID of the virtual device. */
  virtualDeviceUUID: Scalars['UUID']['output'];
};

export type RateLimitPhyInterfaceBindingInput = {
  /** The UUID of the physical interface to bind or unbind the rate limit rule to/from. */
  phyInterfaceUUID: Scalars['UUID']['input'];
  /** The UUID of the rate limit rule. */
  rateLimitRuleUUID: Scalars['UUID']['input'];
};

/** Defines L2 and L3 rate limit rules for a network. A rate limit rule can be applied to multiple interfaces. */
export type RateLimitRule = {
  __typename?: 'RateLimitRule';
  /** Unique identifier for the rate limit rule. */
  UUID: Scalars['UUID']['output'];
  /** The timestamp when the rate limit rule was created. */
  createdAt: Scalars['DateTime']['output'];
  /** A description of the rate limit rule. */
  description?: Maybe<Scalars['String']['output']>;
  /** Destination MAC address to match for the rate limit rule. */
  dstMac?: Maybe<Scalars['MacAddress']['output']>;
  /** Destination port range to match for the rate limit rule. */
  dstPortRange?: Maybe<PortRange>;
  /** Destination IP address prefix to match for the rate limit rule. */
  dstPrefix?: Maybe<Scalars['IPPrefix']['output']>;
  /** Indicates whether the rate limit rule is currently enabled. */
  isEnabled: Scalars['Boolean']['output'];
  /** Specifies if the rate limit is applied per source IP/MAC address. */
  isPerSource: Scalars['Boolean']['output'];
  /** The name of the rate limit rule. */
  name: Scalars['String']['output'];
  /** The UUID of the network this rate limit rule belongs to. */
  networkUUID: Scalars['UUID']['output'];
  /** The physical interfaces that this rate limit rule is applied on. The same rate limit rule can be applied to multiple physical interfaces. */
  phyInterfaceBindings?: Maybe<Array<PhyInterface>>;
  /** The order in which the rate limit rules are applied, lower priorities first. */
  priority: Scalars['Int']['output'];
  /** The IANA IP protocol to apply this rule on. */
  protocol?: Maybe<IpProtocol>;
  /** The maximum download rate limit in kilobits per second. */
  rateLimitKbpsDownload?: Maybe<Scalars['Int']['output']>;
  /** The maximum upload rate limit in kilobits per second. */
  rateLimitKbpsUpload?: Maybe<Scalars['Int']['output']>;
  /** Source MAC address to match for the rate limit rule. */
  srcMac?: Maybe<Scalars['MacAddress']['output']>;
  /** Source port range to match for the rate limit rule. */
  srcPortRange?: Maybe<PortRange>;
  /** Source IP address prefix to match for the rate limit rule. */
  srcPrefix?: Maybe<Scalars['IPPrefix']['output']>;
  /** The SSIDs that this rate limit rule is applied on. The same rate limit rule can be applied to multiple SSIDs. */
  ssidBindings?: Maybe<Array<Ssid>>;
  /** The timestamp when the rate limit rule was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** The VLAN interfaces that this rate limit rule is applied on. The same rate limit rule can be applied to multiple VLANs. */
  vlanBindings?: Maybe<Array<Vlan>>;
};

export type RateLimitSsidBindingInput = {
  /** The UUID of the rate limit rule. */
  rateLimitRuleUUID: Scalars['UUID']['input'];
  /** The UUID of the SSID to bind or unbind the rate limit rule to/from. */
  ssidUUID: Scalars['UUID']['input'];
};

export type RateLimitVlanBindingInput = {
  /** The UUID of the rate limit rule. */
  rateLimitRuleUUID: Scalars['UUID']['input'];
  /** The UUID of the VLAN to bind or unbind the rate limit rule to/from. */
  vlanUUID: Scalars['UUID']['input'];
};

/** A rogue access point is when an unrecognized access point is plugged into one of Meter's switches. */
export type RogueAccessPoint = {
  __typename?: 'RogueAccessPoint';
  /** The mac address of the rogue AP. */
  macAddress: Scalars['MacAddress']['output'];
  /** The network that the rogue AP was observed on. */
  networkUUID: Scalars['UUID']['output'];
  /** The devices that were able to observe the rogue AP. */
  observers: Array<NetworkThreatObserver>;
  /** The physical interface that the rogue access point is plugged into. */
  phyInterface: PhyInterface;
  /** The vendor that made the rogue AP. */
  vendor?: Maybe<Scalars['String']['output']>;
};

/** Enumeration of user roles. */
export enum Role {
  /** Operator role with elevated permissions. */
  Operator = 'OPERATOR',
}

/**
 * A RoleAssignment denotes the role of a user in the context of a company or company & network.
 *
 * In the case of an Operator role, the companySlug and networkUUID fields will be null.
 */
export type RoleAssignment = {
  __typename?: 'RoleAssignment';
  /**
   * The slug of the company associated with the role assignment.
   *
   * Omitted if the role is global or operator-level.
   */
  companySlug?: Maybe<Scalars['String']['output']>;
  /** The name of the role assigned to the user. */
  name: RoleName;
  /**
   * The UUID of the network associated with the role assignment.
   *
   * Omitted if the role is not network-specific.
   */
  networkUUID?: Maybe<Scalars['UUID']['output']>;
};

/** Result type indicating whether the user has the specified role. */
export type RoleCheckResult = {
  __typename?: 'RoleCheckResult';
  /** True if the user has the specified role, false otherwise. */
  hasRole: Scalars['Boolean']['output'];
};

/** RoleName represents the various roles that can be assigned to users within the system. */
export enum RoleName {
  /** Placeholder role so user can use Client VPN, limited access. */
  ClientVpnUser = 'CLIENT_VPN_USER',
  /** Company Global Admin role, grants administrative privileges across the entire company. */
  CompanyGlobalAdmin = 'COMPANY_GLOBAL_ADMIN',
  /** Company Admin Read Only role, grants read only administrative privileges across the entire company. */
  CompanyGlobalAdminReadOnly = 'COMPANY_GLOBAL_ADMIN_READ_ONLY',
  /** Company Guest role, limited access. */
  CompanyGuest = 'COMPANY_GUEST',
  /** Company Network Admin role, grants administrative privileges within a specific network. */
  CompanyNetworkAdmin = 'COMPANY_NETWORK_ADMIN',
  /** Company Network Admin Read Only role, grants read only administrative privileges within a specific network. */
  CompanyNetworkAdminReadOnly = 'COMPANY_NETWORK_ADMIN_READ_ONLY',
  /** Company Network Onboarding role, grants administrative privileges for onboarding a network. */
  CompanyNetworkOnboarding = 'COMPANY_NETWORK_ONBOARDING',
  /** Company Onboarding role, allows editing the company onboarding pages and gives read only access to the rest of the dashboard. */
  CompanyOnboardingOnly = 'COMPANY_ONBOARDING_ONLY',
  /** Company Standard User role, typical user role with standard access rights. */
  CompanyStandardUser = 'COMPANY_STANDARD_USER',
  /** Installer role, has access to information that is straightforward to understand and necessary to monitor installs. */
  Installer = 'INSTALLER',
  /** Operator role, has every permission. */
  Operator = 'OPERATOR',
  /** Partner admin role, grants elevated permissions for network configuration. */
  Partner = 'PARTNER',
}

/** Input type specifying the context for which to fetch the roles for a given user. */
export type RolesInput = {
  /**
   * The slug of the company to fetch roles for.
   *
   * If omitted, roles without a company context are retrieved.
   */
  companySlug?: InputMaybe<Scalars['String']['input']>;
};

/** Information about an SFP module plugged into a port. */
export type SfpModuleInfo = {
  __typename?: 'SFPModuleInfo';
  /** The speed capability of the SFP module. */
  moduleSpeed: Scalars['String']['output'];
  /** The speed capability of the SFP module, in Kbps, if determinable. */
  moduleSpeedKbps?: Maybe<Scalars['Float']['output']>;
  /** The type of the SFP module. */
  moduleType: Scalars['String']['output'];
  /** The part name of the SFP module. */
  partName: Scalars['String']['output'];
  /** The serial number of the SFP module. */
  serialNumber: Scalars['String']['output'];
  /** The vendor of the SFP module. */
  vendor: Scalars['String']['output'];
};

/** Input type for activating a Kore cellular SIM card. */
export type SimActivationInput = {
  /** The country where the SIM card will be used. */
  country: SimCountry;
  /** The ICCID (Integrated Circuit Card Identifier) of the SIM card to activate. */
  iccid: Scalars['String']['input'];
};

/**
 * Enumeration of possible activation statuses for a SIM card.
 * Actually for Kore, not Twilio.
 */
export enum SimActivationStatus {
  /** The SIM is active and can be used for cellular connectivity. */
  Active = 'ACTIVE',
  /** The SIM is inactive. */
  Inactive = 'INACTIVE',
  /** The SIM is newly created and not yet ready for use. */
  New = 'NEW',
  /** The SIM is ready for activation. */
  Ready = 'READY',
  /** The SIM activation has been scheduled. */
  Scheduled = 'SCHEDULED',
}

/** Enumeration of supported countries for activating Kore cellular SIM cards. */
export enum SimCountry {
  /** Canada */
  Ca = 'CA',
  /** Used for all other countries. */
  Other = 'OTHER',
  /** United States of America */
  Us = 'US',
}

/** Information about a Kore SuperSIM fleet. */
export type SimFleet = {
  __typename?: 'SIMFleet';
  /** The unique name of the fleet. */
  name?: Maybe<Scalars['String']['output']>;
  /** The URL for the fleet. */
  url?: Maybe<Scalars['String']['output']>;
};

/** Service set identifiers (SSIDs) for a network. */
export type Ssid = {
  __typename?: 'SSID';
  /** BSSIDs are MAC addresses that identify a radio band / SSID pair for an access point. */
  BSSIDs: Array<Bssid>;
  /** Unique identifier for the SSID. */
  UUID: Scalars['UUID']['output'];
  /** The lowest rate at which a client can connect to the 2.4 GHz radio, in kilobits per second. */
  band2GMinimumBasicRateKbps?: Maybe<Scalars['Int']['output']>;
  /** The lowest rate at which a client can connect to the 5 GHz radio, in kilobits per second. */
  band5GMinimumBasicRateKbps?: Maybe<Scalars['Int']['output']>;
  /** The lowest rate at which a client can connect to the 6 GHz radio, in kilobits per second. */
  band6GMinimumBasicRateKbps?: Maybe<Scalars['Int']['output']>;
  /** If an SSID is scheduled (only enabled during certain timeframes), this is the schedule that we follow. */
  broadcastSchedule?: Maybe<Array<SsidBroadcastScheduleInterval>>;
  /** A list of allowed client MACs, if isClientAllowlistEnabled is true. */
  clientAllowlist?: Maybe<Array<Scalars['MacAddress']['output']>>;
  /** Client steering allows devices to select an optimal access point for better connectivity and performance. */
  clientSteeringAssociationSteeringIsEnabled: Scalars['Boolean']['output'];
  /** The minimum number of clients on an SSID before client steering is attempted. */
  clientSteeringLoadBalancingClientMinThreshold?: Maybe<Scalars['Int']['output']>;
  /** Post association steering allows devices to move to a better access point after they have already connected. */
  clientSteeringPostassociationSteeringIsEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** The minimum RSSI signal strength a client must have before pre-association client steering is attempted. */
  clientSteeringPreassociationRSSIMinThreshold?: Maybe<Scalars['Int']['output']>;
  /** Timestamp when the SSID was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Description of the SSID. */
  description?: Maybe<Scalars['String']['output']>;
  /** The access points that will not broadcast this SSID, if isEnabledForAllAccessPoints is true. */
  disabledAccessPointVirtualDevices?: Maybe<Array<AccessPointVirtualDevice>>;
  /** The DTIM (Delivery Traffic Indication Message) period is a value in beacon frames that indicates how often clients should wake up to receive multicast and broadcast traffic. */
  dtimPeriod?: Maybe<Scalars['Int']['output']>;
  /** Dynamic VLAN is a setting to use the VLAN specified by an external RADIUS server's response after authentication. If null, then the VLAN specified by `vlan` is used. */
  dynamicVLANMode?: Maybe<SsidDynamicVlanMode>;
  /** The access points that will broadcast this SSID, if isEnabledForAllAccessPoints is false. */
  enabledAccessPointVirtualDevices?: Maybe<Array<AccessPointVirtualDevice>>;
  /**
   * 802.11w is a security standard that protects management frames from being forged by an attacker.
   * For WPA3 PSK, this field is required and must be REQUIRED.
   * For WPA3 Transition, this field is required but can be REQUIRED or OPTIONAL.
   * For WPA2, this field is optional.
   * For open networks, this field is not supported.
   */
  encryption80211wProtectedManagementFramesMode?: Maybe<SsidEncryption80211wProtectedManagementFramesMode>;
  /** Encryption protocol used by the SSID. If null, this is an open network. */
  encryptionProtocol?: Maybe<SsidEncryptionProtocol>;
  /** An optional value for the Hotspot 2.0 Access network type, as defined in Table 9-214 of 802.11-2016. */
  hs20AccessNetworkType?: Maybe<Scalars['Int']['output']>;
  /** A list of Hotspot 2.0 domain names. */
  hs20DomainNames?: Maybe<Array<Scalars['String']['output']>>;
  /** An option to enable/disable Hotspot 2.0, aka Passpoint. */
  hs20Enabled: Scalars['Boolean']['output'];
  /** A boolean to represent whether a Hotspot 2.0 profile is attached to the SSID (has any fields set). */
  hs20HasProfile: Scalars['Boolean']['output'];
  /** A list of MCC/MNC (Mobile Country Codes and Mobile Network Codes) pairs, formatted as "MCC,MNC". */
  hs20MccMncPairs?: Maybe<Array<Scalars['String']['output']>>;
  /** A list of Hotspot 2.0 NAI (Network Access Identifier) realms; format follows hostapd format for nai_realm option (see hostapd documentation). */
  hs20NaiRealms?: Maybe<Array<Scalars['String']['output']>>;
  /** A list of Operator names for Hotspot 2.0 (one per language). */
  hs20OperatorNames?: Maybe<Array<Scalars['String']['output']>>;
  /** A list of Hotspot 2.0 Consortium OIs (Organization Identifiers). */
  hs20RoamingConsortiumOIs?: Maybe<Array<Scalars['String']['output']>>;
  /** An optional value for the Hotspot 2.0 Venue group, as defined in Table 9-62 of 802.11-2016. */
  hs20VenueGroup?: Maybe<Scalars['Int']['output']>;
  /**
   * A list of Venue names for Hotspot 2.0 (one per language); must be formatted with a two or three character language code separated by a colon from the venue name.
   * If at least one is set, hs20VenueGroup and hs20VenueType must be set.
   */
  hs20VenueNames?: Maybe<Array<Scalars['String']['output']>>;
  /** An optional value for the Hotspot 2.0 Venue type, as defined in Table 9-62 of 802.11-2016. */
  hs20VenueType?: Maybe<Scalars['Int']['output']>;
  /** Whether or not the SSID is enabled for 802.11ax (Wi-Fi 6) clients. */
  is80211axEnabled: Scalars['Boolean']['output'];
  /** Whether or not AP debug logging is enabled for APs broadcasting the SSID. */
  isAPDebugLogEnabled: Scalars['Boolean']['output'];
  /** Whether or not the SSID is allowed to be broadcasted on the 2.4 GHz radio. */
  isBand2GAllowed: Scalars['Boolean']['output'];
  /** Whether or not the SSID is allowed to be broadcasted on the 5 GHz radio. */
  isBand5GAllowed: Scalars['Boolean']['output'];
  /** Whether or not the SSID is allowed to be broadcasted on the 6 GHz radio. */
  isBand6GAllowed: Scalars['Boolean']['output'];
  /** If true, only clients in the client allowlist will be allowed. */
  isClientAllowlistEnabled: Scalars['Boolean']['output'];
  /** Indicates whether the SSID is enabled. */
  isEnabled: Scalars['Boolean']['output'];
  /** If true, the SSID is enabled for all access points in the network, except for any access points specified in the disabledAccessPointsVirtualDevices field. If false, the SSID is enabled for only the access points specified in the enabledAccessPointVirtualDevices field. */
  isEnabledForAllAccessPoints: Scalars['Boolean']['output'];
  /** If true, the SSID is considered as guest and can be displayed on site for guest access, for example on a kiosk. */
  isGuest: Scalars['Boolean']['output'];
  /** Whether or not the broadcasted SSID is visible to clients; clients have to manually input the SSID to join the network. */
  isHidden: Scalars['Boolean']['output'];
  /** If true, clients on the same SSID cannot communicate with each other. */
  isIsolateClientsEnabled: Scalars['Boolean']['output'];
  /** True if multicast to unicast translation is enabled on the SSID. */
  isMulticastToUnicastEnabled: Scalars['Boolean']['output'];
  /** Whether proxy ARP (AP responds to ARP requests coming from the uplink on behalf of the clients) is enabled */
  isProxyARPEnabled: Scalars['Boolean']['output'];
  /** Threshold (number of clients in the multicast group) above which multicast to unicast is disabled (multicast frame is sent). If 0, no limit. */
  multicastToUnicastClientThreshold?: Maybe<Scalars['Int']['output']>;
  /** A NAS (Network Access Server) identifier that can be used for Radius or 11r; if empty, defaults to the AP's hostname. */
  nasIdentifier?: Maybe<Scalars['String']['output']>;
  /** The network the SSID belongs to. */
  network: Network;
  /** UUID of the network this SSID belongs to. */
  networkUUID: Scalars['UUID']['output'];
  /** The PSK for the SSID. If null, it is an open passwordless network or the encryption protocol does not use a PSK. */
  password?: Maybe<Scalars['String']['output']>;
  /** The last time the password was rotated, if password rotation is enabled. */
  passwordLastRotatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The next time the password will be rotated, if password rotation is enabled. */
  passwordNextRotationAt?: Maybe<Scalars['DateTime']['output']>;
  /** The period upon which the password is automatically rotated; a non-null value indicates that password rotation is enabled. */
  passwordRotationCadence?: Maybe<SsidPasswordRotationCadence>;
  /** The day of the month, in the network's local time zone, at which the password is automatically rotated. */
  passwordRotationDayOfMonthLocal?: Maybe<Scalars['Int']['output']>;
  /** The day of the week, in the network's local time zone, at which the password is automatically rotated (0 = Sunday, 1 = Monday, etc.) */
  passwordRotationDayOfWeekLocal?: Maybe<Scalars['Int']['output']>;
  /** The hour of the day, in the network's local time zone, at which the password is automatically rotated. */
  passwordRotationHourOfDayLocal?: Maybe<Scalars['Int']['output']>;
  /** Primary 802.1X encryption configuration for Enterprise authentication. */
  primaryEncryption8021X?: Maybe<Encryption8021X>;
  /** True if SSID supports RADIUS Change of Authorization (CoA). */
  radiusCoaEnabled: Scalars['Boolean']['output'];
  /** A port where RADIUS servers can send CoA requests. */
  radiusCoaPort?: Maybe<Scalars['Int']['output']>;
  /** The rate limit rules, if they exist, that are applied to this SSID. */
  rateLimitRules: Array<RateLimitRule>;
  /** 802.11k is a standard that helps wireless devices quickly find and switch to the best available access point. */
  roaming80211kIsEnabled: Scalars['Boolean']['output'];
  /** 802.11r is a standard that allows clients to roam more effectively between access points. */
  roaming80211rIsEnabled: Scalars['Boolean']['output'];
  /**
   * Used to indicate a group of APs sharing the same SSID between which a client can use 802.11r to roam. A 2 byte hex string.
   * Currently we do not allow callers to set this field.
   */
  roaming80211rMobilityDomain?: Maybe<Scalars['String']['output']>;
  /**
   * A 32 byte hex string key used for encryption in 802.11r for r0 and r1 key holders.
   * Currently we do not allow callers to set this field.
   */
  roaming80211rR0khR1khKey?: Maybe<Scalars['String']['output']>;
  /** 802.11v is a standard that allows devices to communicate with the network for better connection performance, such as optimizing roaming and power efficiency. */
  roaming80211vIsEnabled: Scalars['Boolean']['output'];
  /** A value to configure RTS/CTS (see QCA doc "Wireless LAN Access Point Command Reference" for more details). */
  rtsCtsEnabledCode?: Maybe<Scalars['Int']['output']>;
  /** Size of the PPDU on which RTS would be sent out. */
  rtsThreshold?: Maybe<Scalars['Int']['output']>;
  /** Secondary 802.1X encryption configuration for Enterprise authentication. */
  secondaryEncryption8021X?: Maybe<Encryption8021X>;
  /** Name of the SSID (network name). */
  ssid: Scalars['String']['output'];
  /** A number to uniquely identify the SSID within the network. Starts from zero. */
  ssidIndex: Scalars['Int']['output'];
  /** Timestamp when the SSID was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** VLAN associated with the SSID. This field must be non-null if the SSID is enabled. */
  vlan?: Maybe<Vlan>;
};

/** Service set identifiers (SSIDs) for a network. */
export type SsidBssiDsArgs = {
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
};

/** An interval represents a time segment that will be used to determine when to broadcast an SSID. */
export type SsidBroadcastScheduleInterval = {
  __typename?: 'SSIDBroadcastScheduleInterval';
  /** The day of the week (0=sunday, 1=monday, etc) for the end of the interval. */
  endDayOfWeek: Scalars['Int']['output'];
  /** The hour of the day (0-23) for the end of the interval. */
  endHour: Scalars['Int']['output'];
  /** The minute of the hour (0, 15, 30, 45) for the end of the interval. */
  endMinute: Scalars['Int']['output'];
  /** The day of the week (0=sunday, 1=monday, etc) for the beginning of the interval. */
  startDayOfWeek: Scalars['Int']['output'];
  /** The hour of the day (0-23) for the start of the interval. */
  startHour: Scalars['Int']['output'];
  /** The minute of the hour (0, 15, 30, 45) for the start of the interval. */
  startMinute: Scalars['Int']['output'];
};

export type SsidBroadcastScheduleIntervalInput = {
  /** The day of the week for the end of the interval (0 = Sunday, 1 = Monday, etc.). */
  endDayOfWeek: Scalars['Int']['input'];
  /** The hour of the day for the end of the interval (0-23). */
  endHour: Scalars['Int']['input'];
  /** The minute of the hour for the end of the interval (0-59). */
  endMinute: Scalars['Int']['input'];
  /** The day of the week for the start of the interval (0 = Sunday, 1 = Monday, etc.). */
  startDayOfWeek: Scalars['Int']['input'];
  /** The hour of the day for the start of the interval (0-23). */
  startHour: Scalars['Int']['input'];
  /** The minute of the hour for the start of the interval (0-59). */
  startMinute: Scalars['Int']['input'];
};

export enum SsidDynamicVlanMode {
  /**
   * The VLAN specified by an external RADIUS server's response after authentication is used.
   * The VLAN specified by `vlan` is used as a fallback if the RADIUS server does not specify a VLAN.
   */
  Enabled = 'ENABLED',
  /**
   * The VLAN specified by an external RADIUS server's response after authentication is used.
   * The VLAN specified by `vlan` is ignored.
   */
  Required = 'REQUIRED',
}

export enum SsidEncryption80211wProtectedManagementFramesMode {
  /** Can only be set as optional for WPA2 / WPA2 Enterprise / WPA3 Transition. */
  Optional = 'OPTIONAL',
  /** Must be set to this for WPA3; for other encryption protocols, it is also permitted. */
  Required = 'REQUIRED',
}

export enum SsidEncryptionProtocol {
  /** Open network with MAC address authentication via RADIUS. */
  OpenMacAuthRadius = 'OPEN_MAC_AUTH_RADIUS',
  /** Wi-Fi Protected Access II (WPA2) Personal. */
  Wpa2 = 'WPA2',
  /** WPA2 Enterprise with 802.1X authentication. */
  Wpa2Enterprise = 'WPA2_ENTERPRISE',
  /** SSID with multiple WPA2 passwords (iPSKs) */
  Wpa2Ipsk = 'WPA2_IPSK',
  /** SSID with MPSK (Radius-based iPSK solution in partnership with RoamingIQ) */
  Wpa2Mpsk = 'WPA2_MPSK',
  /** WPA3 Personal. */
  Wpa3 = 'WPA3',
  /** WPA3 Enterprise with 802.1X authentication. */
  Wpa3Enterprise = 'WPA3_ENTERPRISE',
  /** WPA3 OWE (Open). */
  Wpa3Owe = 'WPA3_OWE',
  /** Supports clients that use WPA2 or WPA3. */
  Wpa3Transition = 'WPA3_TRANSITION',
}

export enum SsidPasswordRotationCadence {
  /** Rotate the password daily. */
  Daily = 'DAILY',
  /** Rotate the password monthly. */
  Monthly = 'MONTHLY',
  /** Rotate the password weekly. */
  Weekly = 'WEEKLY',
}

/** Specifies the type of admin portal link to generate for SSO configuration. */
export enum SsoAdminPortalType {
  /** WorkOS admin dashboard for viewing WorkOS Audit Logs. */
  AuditLogs = 'AUDIT_LOGS',
  /** WorkOS admin dashboard for configuring Directory Sync. */
  Dsync = 'DSYNC',
  /** WorkOS admin dashboard for configuring Log Streams. */
  LogStreams = 'LOG_STREAMS',
  /** WorkOS admin dashboard for configuring an SSO Provider. */
  SsoProvider = 'SSO_PROVIDER',
}

/** Represents a directory that is connected to the company via WorkOS. */
export type SsoConnectedDirectory = {
  __typename?: 'SSOConnectedDirectory';
  /** The date and time when the directory was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The state of the connected directory. */
  state: SsoState;
  /** The type of the connected directory. */
  type: SsoDirectoryTypes;
};

/** Represents an SSO connection for a company. */
export type SsoConnection = {
  __typename?: 'SSOConnection';
  /** The date and time when the SSO connection was created. */
  connectedAt: Scalars['DateTime']['output'];
  /** The current state of the SSO connection. */
  state: SsoConnectionState;
  /** The type of the SSO connection. */
  type: SsoConnectionType;
};

/** Represents the state of an SSO connection. */
export enum SsoConnectionState {
  /** The SSO connection is active. */
  Active = 'Active',
  /** The SSO connection is in draft state and not yet active. */
  Draft = 'Draft',
  /** The SSO connection is inactive. */
  Inactive = 'Inactive',
  /** No SSO connection exists. */
  None = 'None',
  /** The SSO connection is validating credentials or configuration. */
  Validating = 'Validating',
}

/** Represents the type of an SSO connection. */
export enum SsoConnectionType {
  Adfssaml = 'ADFSSAML',
  AdpOidc = 'AdpOidc',
  Auth0Saml = 'Auth0SAML',
  AzureSaml = 'AzureSAML',
  CasSaml = 'CasSAML',
  ClassLinkSaml = 'ClassLinkSAML',
  CloudflareSaml = 'CloudflareSAML',
  CyberArkSaml = 'CyberArkSAML',
  DuoSaml = 'DuoSAML',
  GenericOidc = 'GenericOIDC',
  GenericSaml = 'GenericSAML',
  GoogleOAuth = 'GoogleOAuth',
  GoogleSaml = 'GoogleSAML',
  JumpCloudSaml = 'JumpCloudSAML',
  KeycloakSaml = 'KeycloakSAML',
  LastPassSaml = 'LastPassSAML',
  LoginGovOidc = 'LoginGovOidc',
  MagicLink = 'MagicLink',
  MicrosoftOAuth = 'MicrosoftOAuth',
  MiniOrangeSaml = 'MiniOrangeSAML',
  NetIqSaml = 'NetIqSAML',
  None = 'None',
  OktaSaml = 'OktaSAML',
  OneLoginSaml = 'OneLoginSAML',
  OracleSaml = 'OracleSAML',
  PingFederateSaml = 'PingFederateSAML',
  PingOneSaml = 'PingOneSAML',
  RipplingSaml = 'RipplingSAML',
  SalesforceSaml = 'SalesforceSAML',
  ShibbolethGenericSaml = 'ShibbolethGenericSAML',
  ShibbolethSaml = 'ShibbolethSAML',
  SimpleSamlPhpSaml = 'SimpleSamlPhpSAML',
  VMwareSaml = 'VMwareSAML',
}

/** Represents a directory available via WorkOS for SSO. */
export type SsoDirectory = {
  __typename?: 'SSODirectory';
  /** The domain associated with the directory. */
  domain: Scalars['String']['output'];
  /** The name of the directory. */
  name: Scalars['String']['output'];
  /** The state of the directory connection. */
  state: SsoState;
  /** The type of the directory. */
  type: SsoDirectoryTypes;
};

/** The type of directory that is available via WorkOS. 'None' doesn't exist in WorkOS, but is used internally to represent no connection. */
export enum SsoDirectoryTypes {
  AzureScimv2_0 = 'AzureSCIMV2_0',
  BambooHr = 'BambooHr',
  BreatheHr = 'BreatheHr',
  CezanneHr = 'CezanneHr',
  CyberArk = 'CyberArk',
  FourthHr = 'FourthHr',
  GSuiteDirectory = 'GSuiteDirectory',
  GenericScimv2_0 = 'GenericSCIMV2_0',
  Hibob = 'Hibob',
  JumpCloud = 'JumpCloud',
  None = 'None',
  OktaScimv2_0 = 'OktaSCIMV2_0',
  OneLogin = 'OneLogin',
  PeopleHr = 'PeopleHr',
  Personio = 'Personio',
  PingFederate = 'PingFederate',
  Rippling = 'Rippling',
  Sftp = 'SFTP',
  SftpWorkday = 'SFTPWorkday',
  Workday = 'Workday',
}

/** Represents the SSO options that can be configured for a company. */
export type SsoOptions = {
  __typename?: 'SSOOptions';
  /** The directory currently connected to the company. */
  connectedDirectory?: Maybe<SsoConnectedDirectory>;
  /** A list of SSO connections for the company. */
  connections: Array<SsoConnection>;
  /** A list of directories available via WorkOS. */
  directories: Array<SsoDirectory>;
};

/** Input for retrieving SSO options for a company. */
export type SsoOptionsInput = {
  /** The slug (unique identifier) of the company. */
  companySlug: Scalars['String']['input'];
};

/** Represents the state of the directory connection for SSO. */
export enum SsoState {
  /** The directory is connected, but the credentials are invalid. */
  InvalidCredentials = 'InvalidCredentials',
  /** The directory is connected and ready to use. */
  Linked = 'Linked',
  /** The directory is not connected and cannot be used. */
  Unlinked = 'Unlinked',
}

/** The source from which the SSO verification request originated. */
export enum SsoVerificationSource {
  /** The verification request originated from Auth Kit. */
  AuthKit = 'AUTH_KIT',
  /** The verification request originated from an SSO provider. */
  Sso = 'SSO',
}

/** STP (Spanning Tree Protocol) configuration information for switches to ensure loop-free topologies. */
export type StpInfo = {
  __typename?: 'STPInfo';
  /** The root bridge is the switch in a network from which all paths are derived to prevent loops. */
  isRootBridge: Scalars['Boolean']['output'];
  /** The MAC address of the root bridge. */
  rootBridgeMACAddress: Scalars['MacAddress']['output'];
  /** The port number on which the root bridge is connected. */
  rootBridgePortNumber: Scalars['Int']['output'];
};

/** Possible roles of a port in Spanning Tree Protocol (STP). */
export enum StpPortRole {
  /** An alternate port provides an alternate path to the root bridge in case the designated port fails. */
  Alternate = 'ALTERNATE',
  /** A backup port provides a backup path to a segment where another port already connects. */
  Backup = 'BACKUP',
  /** A designated port is a port that is designated for forwarding on a LAN segment. */
  Designated = 'DESIGNATED',
  /** A disabled port is not participating in STP. */
  Disabled = 'DISABLED',
  /** A root port is the port with the lowest cost path to the root bridge. */
  Root = 'ROOT',
}

/**
 * ScanData represents the data collected from our access points about the
 * wireless networks they observe.
 */
export type ScanData = {
  __typename?: 'ScanData';
  /** The BSSID of the SSID that was observed. */
  BSSID: Scalars['MacAddress']['output'];
  /** The RSSI of the SSID that was observed, in dBm. */
  RSSI: Scalars['Int']['output'];
  /** The SSID that was observed. */
  SSID: Scalars['String']['output'];
  /** The Band that the SSID was observed broadcasting on. */
  band: RadioBand;
  /** The channel on which the SSID was observed. */
  channel: Scalars['Int']['output'];
  /** The channel width of the SSID that was observed. */
  channelWidth: Scalars['Int']['output'];
  /** When the SSID was observed. */
  observedAt: Scalars['DateTime']['output'];
  /** The radio that observed the SSID. */
  radio: DeviceRadio;
  /** The virtual device that observed the SSID. */
  virtualDevice: VirtualDevice;
  /** The UUID of the virtual device that observed the SSID. */
  virtualDeviceUUID: Scalars['UUID']['output'];
};

/** Tracks the progress of a scheduled NOS upgrade at a device-level. */
export type ScheduledDeviceNosUpgrade = {
  __typename?: 'ScheduledDeviceNOSUpgrade';
  /** The UUID of the device NOS upgrade. */
  UUID: Scalars['UUID']['output'];
  /** The timestamp when the device NOS upgrade was applied successfully, if applicable. */
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The NOS version that the device was upgraded to. */
  nosVersion: NosVersion;
  /** The timestamp when the device NOS upgrade is scheduled to begin. */
  scheduledAt: Scalars['DateTime']['output'];
  /** The status of the device NOS upgrade. */
  status: ScheduledNosUpgradeStatus;
  /** The virtual device that the device NOS upgrade is associated with. */
  virtualDevice: VirtualDevice;
};

/** Tracks the progress of a scheduled NOS upgrade at a group-level. */
export type ScheduledGroupNosUpgrade = {
  __typename?: 'ScheduledGroupNOSUpgrade';
  /** The UUID of the group NOS upgrade. */
  UUID: Scalars['UUID']['output'];
  /** The timestamp when all of the devices in the group have successfully upgraded, if applicable. */
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The timestamp when the group NOS upgrade was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The underlying device upgrades that the group NOS upgrade is associated with. */
  deviceUpgrades: Array<ScheduledDeviceNosUpgrade>;
  /** The NOS upgrade group that the group NOS upgrade is associated with. */
  nosUpgradeGroup: NosUpgradeGroup;
  /** The timestamp when the group NOS upgrade is scheduled to begin. */
  scheduledAt: Scalars['DateTime']['output'];
  /** The status of the scheduled NOS upgrade. */
  status: ScheduledNosUpgradeStatus;
  /** The timestamp when the group NOS upgrade was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** The status of a scheduled NOS upgrade, indicating the progress of the upgrade. */
export enum ScheduledNosUpgradeStatus {
  /** The scheduled NOS upgrade was scheduled and then cancelled. */
  Cancelled = 'CANCELLED',
  /** The scheduled NOS upgrade was successfully completed. */
  Completed = 'COMPLETED',
  /** The scheduled NOS upgrade was not successful. */
  Failed = 'FAILED',
  /** The scheduled NOS upgrade is underway. */
  InProgress = 'IN_PROGRESS',
  /** The scheduled NOS upgrade has been scheduled but not yet started. */
  Scheduled = 'SCHEDULED',
}

/** Tracks the progress of a scheduled NOS upgrade at a network-level. */
export type ScheduledNetworkNosUpgrade = {
  __typename?: 'ScheduledNetworkNOSUpgrade';
  /** The UUID of the scheduled NOS upgrade. */
  UUID: Scalars['UUID']['output'];
  /** The timestamp when the scheduled NOS upgrade was completed successfully, if applicable. */
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The timestamp when the scheduled NOS upgrade was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The underlying NOS upgrade groups that the scheduled NOS upgrade is associated with, ordered by priority. */
  groupUpgrades: Array<ScheduledGroupNosUpgrade>;
  /** The network that the scheduled NOS upgrade is associated with. */
  networkUUID: Scalars['UUID']['output'];
  /** The NOS version to be applied to the network. */
  nosVersion: NosVersion;
  /** Any NOS upgrade groups that are associated with the network but not yet included in the `groupUpgrades` because they haven't been scheduled yet. */
  pendingNOSUpgradeGroups?: Maybe<Array<NosUpgradeGroup>>;
  /** The timestamp when the scheduled NOS upgrade is/was scheduled to begin. */
  scheduledAt: Scalars['DateTime']['output'];
  /** The status of the scheduled NOS upgrade. */
  status: ScheduledNosUpgradeStatus;
  /** The timestamp when the scheduled NOS upgrade was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

export enum ScopeKind {
  AlertReceiverUuid = 'ALERT_RECEIVER_UUID',
  AlertTargetSlackUuid = 'ALERT_TARGET_SLACK_UUID',
  AlertTargetWebhookUuid = 'ALERT_TARGET_WEBHOOK_UUID',
  ApplicationDnsFirewallRuleUuid = 'APPLICATION_DNS_FIREWALL_RULE_UUID',
  AutoSelectionJobUuid = 'AUTO_SELECTION_JOB_UUID',
  AutoVpnGroupUuid = 'AUTO_VPN_GROUP_UUID',
  AutoVpnMemberUuid = 'AUTO_VPN_MEMBER_UUID',
  AutoVpnRouteUuid = 'AUTO_VPN_ROUTE_UUID',
  CaptivePortalEntryUuid = 'CAPTIVE_PORTAL_ENTRY_UUID',
  CaptivePortalUuid = 'CAPTIVE_PORTAL_UUID',
  CaptivePortalWebhookUuid = 'CAPTIVE_PORTAL_WEBHOOK_UUID',
  ClientVpnClientUuid = 'CLIENT_VPN_CLIENT_UUID',
  ClientVpnServerUuid = 'CLIENT_VPN_SERVER_UUID',
  CompanyOnboardingDocumentUuid = 'COMPANY_ONBOARDING_DOCUMENT_UUID',
  CompanyOnboardingFieldDelegationUuid = 'COMPANY_ONBOARDING_FIELD_DELEGATION_UUID',
  CompanySiemIntegrationUuid = 'COMPANY_SIEM_INTEGRATION_UUID',
  CompanySlug = 'COMPANY_SLUG',
  CompanyUserUuid = 'COMPANY_USER_UUID',
  CompanyUuid = 'COMPANY_UUID',
  DhcpOptionUuid = 'DHCP_OPTION_UUID',
  DhcpProxyUuid = 'DHCP_PROXY_UUID',
  DhcpReservedRangeUuid = 'DHCP_RESERVED_RANGE_UUID',
  DhcpRuleFilterUuid = 'DHCP_RULE_FILTER_UUID',
  DhcpRuleUuid = 'DHCP_RULE_UUID',
  DhcpStaticMappingUuid = 'DHCP_STATIC_MAPPING_UUID',
  DnsHostMappingsUuid = 'DNS_HOST_MAPPINGS_UUID',
  Encryption_8021XUuid = 'ENCRYPTION_8021X_UUID',
  FirewallRuleUuid = 'FIREWALL_RULE_UUID',
  FleetwideNotificationSettingUuid = 'FLEETWIDE_NOTIFICATION_SETTING_UUID',
  FleetwideNotificationSnoozeUuid = 'FLEETWIDE_NOTIFICATION_SNOOZE_UUID',
  FloorPlanUuid = 'FLOOR_PLAN_UUID',
  HighAvailabilityConfigUuid = 'HIGH_AVAILABILITY_CONFIG_UUID',
  HostMonitoringTargetUuid = 'HOST_MONITORING_TARGET_UUID',
  IdsIpsConfigUuid = 'IDS_IPS_CONFIG_UUID',
  IdsIpsCustomRuleUuid = 'IDS_IPS_CUSTOM_RULE_UUID',
  InternalNoteUuid = 'INTERNAL_NOTE_UUID',
  InternetServicePlanUuid = 'INTERNET_SERVICE_PLAN_UUID',
  IpsecTunnelUuid = 'IPSEC_TUNNEL_UUID',
  IpForwardingRuleUuid = 'IP_FORWARDING_RULE_UUID',
  NetworkClientCpeBindingUuid = 'NETWORK_CLIENT_CPE_BINDING_UUID',
  NetworkJobUuid = 'NETWORK_JOB_UUID',
  NetworkOnboardingDocumentUuid = 'NETWORK_ONBOARDING_DOCUMENT_UUID',
  NetworkOnboardingFieldDelegationUuid = 'NETWORK_ONBOARDING_FIELD_DELEGATION_UUID',
  NetworkThreatAllowlistUuid = 'NETWORK_THREAT_ALLOWLIST_UUID',
  NetworkUuid = 'NETWORK_UUID',
  NosUpgradeGroupUuid = 'NOS_UPGRADE_GROUP_UUID',
  NotificationSettingUuid = 'NOTIFICATION_SETTING_UUID',
  NotificationSnoozeUuid = 'NOTIFICATION_SNOOZE_UUID',
  NotNetworkScoped = 'NOT_NETWORK_SCOPED',
  OneToOneNatRuleUuid = 'ONE_TO_ONE_NAT_RULE_UUID',
  OutletInterfaceUuid = 'OUTLET_INTERFACE_UUID',
  PacketCaptureJobId = 'PACKET_CAPTURE_JOB_ID',
  PhyInterfaceUuid = 'PHY_INTERFACE_UUID',
  PolicyRoutingRuleUuid = 'POLICY_ROUTING_RULE_UUID',
  PortForwardingRuleUuid = 'PORT_FORWARDING_RULE_UUID',
  RackElevationDeviceUuid = 'RACK_ELEVATION_DEVICE_UUID',
  RackElevationUuid = 'RACK_ELEVATION_UUID',
  RadioProfileUuid = 'RADIO_PROFILE_UUID',
  RateLimitRuleUuid = 'RATE_LIMIT_RULE_UUID',
  ScheduledNetworkNosUpgradeUuid = 'SCHEDULED_NETWORK_NOS_UPGRADE_UUID',
  SecurityApplianceProfileUuid = 'SECURITY_APPLIANCE_PROFILE_UUID',
  SerialNumber = 'SERIAL_NUMBER',
  SlackAccessTokenUuid = 'SLACK_ACCESS_TOKEN_UUID',
  SsidUuid = 'SSID_UUID',
  StaticRouteUuid = 'STATIC_ROUTE_UUID',
  SwitchAutoConfigMacAddressVlanBindingUuid = 'SWITCH_AUTO_CONFIG_MAC_ADDRESS_VLAN_BINDING_UUID',
  SwitchProfileUuid = 'SWITCH_PROFILE_UUID',
  Unknown = 'UNKNOWN',
  VirtualDeviceTagUuid = 'VIRTUAL_DEVICE_TAG_UUID',
  VirtualDeviceUuid = 'VIRTUAL_DEVICE_UUID',
  VlanUuid = 'VLAN_UUID',
  WifiIpskUuid = 'WIFI_IPSK_UUID',
}

/** A security appliance profile is a bundle of settings that applies to a security appliance device. */
export type SecurityApplianceProfile = {
  __typename?: 'SecurityApplianceProfile';
  /** Unique identifier of the security appliance profile. */
  UUID: Scalars['UUID']['output'];
  /** Timestamp when the profile was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The number of seconds between host monitoring pings. */
  hostMonitoringIntervalSec: Scalars['Int']['output'];
  /** The number of seconds to wait before timing out a host monitoring ping. */
  hostMonitoringTimeoutSec: Scalars['Int']['output'];
  /** The algorithm used to manage multiple WAN connections, such as load balancing or failover strategies. */
  multiWANAlgorithm: MultiWanAlgorithm;
  /** The number of seconds to wait before another failover can occur after a recent one. */
  multiWANUpdateCooldownSec?: Maybe<Scalars['Int']['output']>;
  /** Number of previous ping results to consider for the failover calculation. */
  multiWANUpdateLookback: Scalars['Int']['output'];
  /**
   * The minimum success ratio to consider a WAN link as good.
   * If it drops below the threshold, a failover occurs.
   * Stored as an integer representing the percentage.
   * For example, a value of 65 represents 65%, or a success ratio of 0.65.
   */
  multiWANUpdateThreshold: Scalars['Int']['output'];
  /** Timestamp when the profile was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** Enumeration of service types that can be discovered on the network. */
export enum ServiceType {
  /** AirPlay service (e.g., Apple devices that support media streaming). */
  Airplay = 'AIRPLAY',
  /** Printer service that is discoverable on the network. */
  Printer = 'PRINTER',
  /** Speaker service (e.g., network-connected audio devices). */
  Speaker = 'SPEAKER',
  /** Service type is unknown or not specified. */
  Unknown = 'UNKNOWN',
}

/** Input for setting the NOS version for a network, which will apply the specified NOS version to all devices in the network. */
export type SetNetworkNosVersionInput = {
  /** If true, forces the NOS version change even if there are potential conflicts or constraints. */
  force?: Scalars['Boolean']['input'];
  /** The unique identifier of the NOS version to apply to the network. */
  nosId: Scalars['Int']['input'];
  /**
   * The interval in minutes to stagger the upgrades across devices within the network to prevent simultaneous upgrades.
   * @deprecated No longer used
   */
  staggeredUpgradeIntervalMin?: Scalars['Int']['input'];
};

export type SetPolicyRoutingRuleBindingsInput = {
  /** The list of bindings to associate with the policy routing rule. */
  bindings: Array<PolicyRoutingRuleBindingInput>;
};

/** A signed response to a console login challenge, including the signature, algorithm, and key ID used for verification. */
export type SignedConsoleLoginChallenge = {
  __typename?: 'SignedConsoleLoginChallenge';
  /** Algorithm used to encode the payload. */
  algorithm: Scalars['String']['output'];
  /**
   * Key ID of the KMS key used to sign the challenge. This can be used to ensure
   * that the challenge was signed by the correct key.
   */
  keyID: Scalars['String']['output'];
  /**
   * The signature over the plain text response.
   * This is a base64 encoded string with the following JSON Object:
   * - a PSS SHA 256 signed JSON payload.
   * - A JSON encoded string with the following keys:
   *     - challenge: the original challenge
   *     - serialNumber: the serial number of the device to sign the challenge for
   *     - user: the user that signed the challenge
   * - To decode and verify the signature, use the following algorithms:
   *     - Base64 decode the response
   *     - Decode the JSON payload
   *     - Verify the PSS SHA 256 signature over the decoded JSON payload
   */
  response: Scalars['String']['output'];
};

/** Slack access tokens for sending alerts to Slack. We do NOT expose the actual access token, only the metadata. */
export type SlackAccessToken = {
  __typename?: 'SlackAccessToken';
  /** The UUID of the company that owns the Slack access token. */
  companyUUID: Scalars['UUID']['output'];
  /** The timestamp when the Slack access token was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The timestamp when the Slack access token was updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** The UUID of the Slack access token. */
  uuid: Scalars['UUID']['output'];
};

/** Input type snooze time window. */
export type SnoozeNotificationSettingWindowInput = {
  /** When the snooze expires. */
  end: Scalars['DateTime']['input'];
  /** When the snooze becomes active. */
  start: Scalars['DateTime']['input'];
};

/** Represents a speedtest server. */
export type SpeedtestServer = {
  __typename?: 'SpeedtestServer';
  /** The distance to the server from the client. */
  distance: Scalars['Int']['output'];
  /** The hostname of the server. */
  host: Scalars['String']['output'];
  /** The identifier of the server. */
  id: Scalars['String']['output'];
  /** The latitude of the server location. */
  lat: Scalars['String']['output'];
  /** The longitude of the server location. */
  lon: Scalars['String']['output'];
  /** The name of the server. */
  name: Scalars['String']['output'];
};

/** Input parameters for starting a WAN speed test job. */
export type StartWanSpeedtestJobInput = {
  /** The base URL used for downloading/uploading during the speed test. Defaults to 'https://speed.cloudflare.com'. */
  baseURL?: Scalars['String']['input'];
  /** The maximum number of bytes to transfer during the speed test. Must be greater than or equal to 100,000. */
  maxTransferBytes?: InputMaybe<Scalars['Int']['input']>;
  /** The UUID of the physical interface on which to perform the speed test. */
  phyInterfaceUUID: Scalars['UUID']['input'];
};

/** Input parameters for starting a wireless calibration job. */
export type StartWirelessCalibrationJobInput = {
  /** The channel information to set all the APs on for a calibration job. */
  channel: Scalars['Int']['input'];
  /** The power level to set all the APs at for a calibration job. */
  power: Scalars['Int']['input'];
};

/** Represents a statistical measurement of a device. */
export type Stat = {
  __typename?: 'Stat';
  /** The timestamp when the stat was inserted into the database. */
  insertedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The unique identifier of the network the device belongs to. */
  networkUUID: Scalars['UUID']['output'];
  /** The timestamp when the stat was observed by the device. */
  observedAt: Scalars['DateTime']['output'];
  /** The raw JSON data of the stat, contents depend on the type. */
  rawData: Scalars['JSONObject']['output'];
  /** The type of the stat, indicating what data is contained in rawData. */
  type: StatType;
  /** The virtual device that reported the stat. */
  virtualDevice?: Maybe<VirtualDevice>;
  /** The unique identifier of the virtual device that reported the stat. */
  virtualDeviceUUID: Scalars['UUID']['output'];
};

export type StatInjectionDuration = {
  /** The end time for fake stats injection. */
  endTime: Scalars['DateTime']['input'];
  /** The start time for fake stats injection. */
  startTime: Scalars['DateTime']['input'];
};

export enum StatType {
  Anomaly = 'ANOMALY',
  ArpTable = 'ARP_TABLE',
  CellularBootInfo = 'CELLULAR_BOOT_INFO',
  CellularStatus = 'CELLULAR_STATUS',
  ClientLatency = 'CLIENT_LATENCY',
  ConfigVersionInfo = 'CONFIG_VERSION_INFO',
  CoredumpEvent = 'COREDUMP_EVENT',
  CosCapoAuthEvent = 'COS_CAPO_AUTH_EVENT',
  CosCapoRedirectEvent = 'COS_CAPO_REDIRECT_EVENT',
  CosClients = 'COS_CLIENTS',
  CosDataplaneBuffers = 'COS_DATAPLANE_BUFFERS',
  CosDhcpServerInfo = 'COS_DHCP_SERVER_INFO',
  CosDnsInfo = 'COS_DNS_INFO',
  CosFirewallCounters = 'COS_FIREWALL_COUNTERS',
  CosHaEvent = 'COS_HA_EVENT',
  CosIpsecTunnels = 'COS_IPSEC_TUNNELS',
  CosIpsActiveAcls = 'COS_IPS_ACTIVE_ACLS',
  CosIpsControlStatus = 'COS_IPS_CONTROL_STATUS',
  CosIpsEvent = 'COS_IPS_EVENT',
  CosLteFailoverEvent = 'COS_LTE_FAILOVER_EVENT',
  CosMacTableEvent = 'COS_MAC_TABLE_EVENT',
  CosMultiwanEvent = 'COS_MULTIWAN_EVENT',
  CosNetworks = 'COS_NETWORKS',
  CosUsbPortEvent = 'COS_USB_PORT_EVENT',
  CosWanSpeedTestResult = 'COS_WAN_SPEED_TEST_RESULT',
  DhcpPacket = 'DHCP_PACKET',
  Heartbeat = 'HEARTBEAT',
  HostPing = 'HOST_PING',
  HostResults = 'HOST_RESULTS',
  HostTraceroute = 'HOST_TRACEROUTE',
  LldpTable = 'LLDP_TABLE',
  LogshipperInfo = 'LOGSHIPPER_INFO',
  MacTable = 'MAC_TABLE',
  MacTableFlushEvent = 'MAC_TABLE_FLUSH_EVENT',
  MdnsServiceDiscoveryEvent = 'MDNS_SERVICE_DISCOVERY_EVENT',
  PacketCapture = 'PACKET_CAPTURE',
  PduOutletAutoCycleEvent = 'PDU_OUTLET_AUTO_CYCLE_EVENT',
  PduOutletEvent = 'PDU_OUTLET_EVENT',
  PduStatusInfo = 'PDU_STATUS_INFO',
  PortEvent = 'PORT_EVENT',
  PortInfo = 'PORT_INFO',
  SecureAddressingAndMessagingSystemInfo = 'SECURE_ADDRESSING_AND_MESSAGING_SYSTEM_INFO',
  SfpPortsInfo = 'SFP_PORTS_INFO',
  SfpPortLoopbackInfo = 'SFP_PORT_LOOPBACK_INFO',
  Sos_8021XAuthenticatedHosts = 'SOS_8021X_AUTHENTICATED_HOSTS',
  Sos_8021XPortStatus = 'SOS_8021X_PORT_STATUS',
  SosFlapLinkStatus = 'SOS_FLAP_LINK_STATUS',
  SosIgmpSnoopingStatus = 'SOS_IGMP_SNOOPING_STATUS',
  /** @deprecated Use `MAC_TABLE` instead. */
  SosMacTable = 'SOS_MAC_TABLE',
  SosMldSnoopingStatus = 'SOS_MLD_SNOOPING_STATUS',
  SosPoeInfo = 'SOS_POE_INFO',
  SosPortCounters = 'SOS_PORT_COUNTERS',
  SosPortEvent = 'SOS_PORT_EVENT',
  SosPortLoopbackInfo = 'SOS_PORT_LOOPBACK_INFO',
  SosStpInfo = 'SOS_STP_INFO',
  StpPortEvent = 'STP_PORT_EVENT',
  SystemInfo = 'SYSTEM_INFO',
  Unspecified = 'UNSPECIFIED',
  UpgradeStatus = 'UPGRADE_STATUS',
  UplinkInfo = 'UPLINK_INFO',
  WireguardPeerEvent = 'WIREGUARD_PEER_EVENT',
  WireguardTunnelInfo = 'WIREGUARD_TUNNEL_INFO',
  WosAcsResult = 'WOS_ACS_RESULT',
  WosAutoTransmitPowerSelectionJobChannelResetFailureInfo = 'WOS_AUTO_TRANSMIT_POWER_SELECTION_JOB_CHANNEL_RESET_FAILURE_INFO',
  WosAutoTransmitPowerSelectJobResults = 'WOS_AUTO_TRANSMIT_POWER_SELECT_JOB_RESULTS',
  WosClientMoved = 'WOS_CLIENT_MOVED',
  WosClientTable = 'WOS_CLIENT_TABLE',
  WosConnectionEvent = 'WOS_CONNECTION_EVENT',
  WosEthStats = 'WOS_ETH_STATS',
  WosEvent = 'WOS_EVENT',
  WosObserverResult = 'WOS_OBSERVER_RESULT',
  WosObssStats = 'WOS_OBSS_STATS',
  WosPingTable = 'WOS_PING_TABLE',
  WosProbeMonitor = 'WOS_PROBE_MONITOR',
  WosRfStats = 'WOS_RF_STATS',
  WosScanRadioUtilInfo = 'WOS_SCAN_RADIO_UTIL_INFO',
  WosScanTable = 'WOS_SCAN_TABLE',
}

/** Go model path for the StaticRoute entity. */
export type StaticRoute = {
  __typename?: 'StaticRoute';
  /** Unique identifier of the static route. */
  UUID: Scalars['UUID']['output'];
  /**
   * VLANs bound (implicitly or explicitly) to this static route.
   * Currently only populated if this is a default route (0.0.0.0/0 destination prefix).
   */
  boundVLANs?: Maybe<Array<Vlan>>;
  /** Timestamp when the static route was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Destination IP prefix for the static route. */
  dstPrefix: Scalars['IPPrefix']['output'];
  /**
   * VLANs excluded from this static route.
   * Currently only populated if this is a default route (0.0.0.0/0 destination prefix).
   * Only one of `explicitlyBoundVLANs` and `excludedVLANs` can be non-null and non-empty.
   */
  excludedVLANs?: Maybe<Array<Vlan>>;
  /**
   * VLANs explicitly bound to this static route.
   * Currently only populated if this is a default route (0.0.0.0/0 destination prefix).
   * Only one of `explicitlyBoundVLANs` and `excludedVLANs` can be non-null and non-empty.
   */
  explicitlyBoundVLANs?: Maybe<Array<Vlan>>;
  /** DHCP Static Mapping used as gateway for the static route. */
  gatewayDHCPStaticMapping?: Maybe<DhcpStaticMapping>;
  /** Gateway IP address for the static route. */
  gatewayIP?: Maybe<Scalars['IPV4']['output']>;
  /** VLAN used as gateway for the static route. */
  gatewayVLAN?: Maybe<Vlan>;
  /** Indicates whether the static route is enabled. */
  isEnabled: Scalars['Boolean']['output'];
  /** Name of the static route. */
  name: Scalars['String']['output'];
  /** UUID of the network to which the static route belongs. */
  networkUUID: Scalars['UUID']['output'];
  /** Timestamp when the static route was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

export type StatsFilter = {
  /** The lookback time to consider stats for, starting at `endTime`. Maximum allowed value is 86400, one day. */
  durationSeconds: Scalars['Int']['input'];
  /** The latest observation time to consider stats for, inclusive. Defaults to the current time if not set. */
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** The maximum number of results to return, between 1 and 1000. Defaults to 100 if not set. */
  limit?: Scalars['Int']['input'];
  /** The number of results to skip before returning results. Defaults to 0 if not set. */
  offset?: Scalars['Int']['input'];
  /** The list of stat types to return. */
  types: Array<StatType>;
};

/** Represents the status of a SIM from Kore. */
export type SuperSim = {
  __typename?: 'SuperSIM';
  /** The account SID associated with the Super SIM. */
  accountSID?: Maybe<Scalars['String']['output']>;
  /** The date and time when the SIM was created. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Information about the fleet resource. */
  fleet?: Maybe<SimFleet>;
  /**
   * The name of the fleet to which the SIM belongs.
   * @deprecated Use `fleet.name` instead, this will always be null.
   */
  fleetName?: Maybe<Scalars['String']['output']>;
  /**
   * The URL of the fleet resource in Kore.
   * @deprecated Use `fleet.url` instead, this will always be null.
   */
  fleetURL?: Maybe<Scalars['String']['output']>;
  /** The Integrated Circuit Card Identifier (ICCID) of the SIM. */
  iccid?: Maybe<Scalars['String']['output']>;
  /** The unique SID (identifier) for the Super SIM resource. */
  sid?: Maybe<Scalars['String']['output']>;
  /** The current activation status of the SIM. */
  status?: Maybe<SimActivationStatus>;
  /** A unique name assigned to the Super SIM. */
  uniqueName?: Maybe<Scalars['String']['output']>;
  /** The date and time when the SIM was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The URL of the SIM resource in Kore. */
  url?: Maybe<Scalars['String']['output']>;
};

/** Allows users to specify which native VLAN to assign to the physical interface where a given MAC address or OUI is detected during a Switch Auto Config job. */
export type SwitchAutoConfigMacAddressVlanBinding = {
  __typename?: 'SwitchAutoConfigMACAddressVLANBinding';
  /** The Organizationally Unique Identifier (OUI) to bind to a VLAN. Optional if macAddress or vendor is specified. */
  OUI?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for this MAC address to VLAN binding. */
  UUID: Scalars['UUID']['output'];
  /** The VLAN assigned to the specified MAC address or OUI. */
  VLAN: Vlan;
  /** The specific MAC address to bind to a VLAN. Optional if OUI or vendor is specified. */
  macAddress?: Maybe<Scalars['MacAddress']['output']>;
  /** Unique identifier of the network where this binding applies. */
  networkUUID: Scalars['UUID']['output'];
  /** A vendor of devices as specified by the IEEE OUI database: https://standards-oui.ieee.org/. Optional if macAddress or OUI is specified. If specified, all OUIs for the vendor will be bound to the specified VLAN. */
  vendor?: Maybe<OuIsForVendorResult>;
};

/** Switch Auto Configuration Jobs automatically configure switch ports based on the connected clients and Meter devices. */
export type SwitchAutoConfigurationJob = AutoSelectionJob &
  NetworkJob & {
    __typename?: 'SwitchAutoConfigurationJob';
    /** The unique identifier of the job. */
    UUID: Scalars['UUID']['output'];
    /** The date and time when the job was completed. Null if not completed yet. */
    completedAt?: Maybe<Scalars['DateTime']['output']>;
    /** Whether or not the job is a dry run. If true, no configuration changes are made. */
    isDryRun: Scalars['Boolean']['output'];
    /** The UUID of the network where the job is executed. */
    networkUUID: Scalars['UUID']['output'];
    /**
     * The results of the Switch Auto Configuration job.
     * Only ports that had their configuration changed or encountered warnings will appear in the results.
     */
    results?: Maybe<Array<SwitchAutoConfigurationResult>>;
    /** The date and time when the job is scheduled to start. */
    scheduledAt: Scalars['DateTime']['output'];
    /** The date and time when the job will time out if not completed. */
    timeoutAt: Scalars['DateTime']['output'];
    /** List of UUIDs of virtual devices (switches) involved in the job. */
    virtualDeviceUUIDs: Array<Scalars['UUID']['output']>;
  };

/** Input parameters for initializing a Switch Auto Configuration Job. */
export type SwitchAutoConfigurationJobInput = {
  /**
   * If true, the job will not make any configuration changes.
   * It will only return the changes it would have made (dry run).
   */
  isDryRun?: Scalars['Boolean']['input'];
  /**
   * If true, the job will run immediately.
   * The default is false; to guarantee correctness, we need to wait several minutes for stats to be reported by the switches before configuring things.
   * However, if we know that there have been no physical cable changes in the last, say, 10 minutes, then we can run the job immediately.
   * This should be used with caution; the caller is responsible for assessing if any patching changes have been made recently.
   */
  runNow?: Scalars['Boolean']['input'];
  /**
   * The list of Switch virtual device UUIDs to run Auto Configuration on.
   * If null, all switches in the network will be auto-configured.
   */
  switchVirtualDeviceUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** The Native VLAN UUID to assign to the switch port if the clients on the port are not classified in the client MAC to VLAN mappings for the network. */
  uncategorizedClientNativeVLANUUID: Scalars['UUID']['input'];
};

/** The result of auto-configuring a single switch port. */
export type SwitchAutoConfigurationResult = {
  __typename?: 'SwitchAutoConfigurationResult';
  /** The new Native VLAN assigned to the port. Null if the VLAN has since been deleted. */
  newNativeVLAN?: Maybe<Vlan>;
  /** The physical interface (port) that was configured. */
  phyInterface: PhyInterface;
  /** The previous Native VLAN assigned to the port. Null if the VLAN has since been deleted. */
  previousNativeVLAN?: Maybe<Vlan>;
  /** The direction of the toggle between access and trunk modes (or no change). */
  toggleDirection: SwitchAutoConfigurationResultToggleDirection;
  /** The switch virtual device that was configured. */
  virtualDevice: SwitchVirtualDevice;
  /** Any warnings that occurred during the port configuration. */
  warnings?: Maybe<Array<SwitchAutoConfigurationResultWarning>>;
};

/** Enumeration of possible toggles between trunk and access modes for switch ports during auto configuration. */
export enum SwitchAutoConfigurationResultToggleDirection {
  /** The port's mode was changed from access to trunk. */
  AccessToTrunk = 'ACCESS_TO_TRUNK',
  /** No change was made to the port's mode. */
  NoChange = 'NO_CHANGE',
  /** The port's mode was changed from trunk to access. */
  TrunkToAccess = 'TRUNK_TO_ACCESS',
}

/** Enumeration of possible warnings encountered during Switch Auto Configuration. */
export enum SwitchAutoConfigurationResultWarning {
  /**
   * Clients on the port had multiple mapped native VLANs based on their MAC addresses or OUIs.
   * The `uncategorizedClientNativeVLANUUID` was selected as the native VLAN.
   */
  MultipleClientMacVlanMappings = 'MULTIPLE_CLIENT_MAC_VLAN_MAPPINGS',
  /** The switch did not report any statistics, so no configuration could take place. */
  NoStatsReported = 'NO_STATS_REPORTED',
}

/** A switch hardware device represents a physical switch. */
export type SwitchHardwareDevice = HardwareDevice & {
  __typename?: 'SwitchHardwareDevice';
  /** Shows the most recent boot history of a device (buildName, bootCount). */
  bootHistory: Array<BootInfo>;
  /** The timestamp when the hardware device was first created in the system. */
  createdAt: Scalars['DateTime']['output'];
  /** The model name of the hardware device. */
  deviceModel: DeviceModel;
  /** The type of the hardware device. */
  deviceType: DeviceType;
  /** If the device is no longer connected to the backend, this is the time at which it was last connected. */
  disconnectedFromBackendAt?: Maybe<Scalars['DateTime']['output']>;
  /** The IP address of the switch hardware device. */
  ipAddress?: Maybe<Scalars['String']['output']>;
  /**
   * True if the device has an active websocket connection to the backend. Note that this only works if the device has registered via the /v2/register endpoint (i.e., is a Config 2 device) - otherwise is always false.
   * @deprecated Refer to `isSpare` instead.
   */
  isActive: Scalars['Boolean']['output'];
  /** Indicates whether the hardware device is connected to the backend. */
  isConnectedToBackend: Scalars['Boolean']['output'];
  /** Indicates whether the hardware device's console port is enabled. */
  isConsoleEnabled: Scalars['Boolean']['output'];
  /** Indicates whether the hardware device is marked as a development (dev) device, moving it into the dev (staging) realm for testing purposes. */
  isDev: Scalars['Boolean']['output'];
  /** Indicates whether the hardware device is in factory mode. */
  isFactoryMode: Scalars['Boolean']['output'];
  /** True if the Switch's MAC address exists in the most recent controller MAC table for the network. */
  isInCurrentControllerMACTable: Scalars['Boolean']['output'];
  /** Indicates whether the hardware device is an RMA (Return Merchandise Authorization) replacement device. */
  isRMA: Scalars['Boolean']['output'];
  /** Indicates whether the hardware device has been retired. */
  isRetired: Scalars['Boolean']['output'];
  /** A spare hardware device belongs to a network but not a virtual device. Used most often to keep track of spare hardware we ship to a customer but don't install immediately. */
  isSpare: Scalars['Boolean']['output'];
  /** The latest device config metadata (ie. the config without the actual JSON payload) for the device. */
  latestDeviceConfigMetadata?: Maybe<DeviceConfigMetadata>;
  /** The MAC address of the hardware device. */
  macAddress?: Maybe<Scalars['MacAddress']['output']>;
  /** The UUID of the network that the spare hardware device belongs to. Spare hardware devices that are not affiliated with a virtual device will have this field populated. */
  networkUUID?: Maybe<Scalars['UUID']['output']>;
  /** Information about the switch's Power over Ethernet (PoE) usage. */
  poeInfo?: Maybe<PoEInfo>;
  /** The public key used to add the device to the jumphost's WireGuard interface. */
  publicKey?: Maybe<Scalars['String']['output']>;
  /** The unique serial number of the hardware device. */
  serialNumber: Scalars['String']['output'];
  /** The network that the spare hardware device belongs to. Spare hardware devices that are not affiliated with a virtual device will have this field populated. */
  spareDeviceNetwork?: Maybe<Network>;
  /** The Spanning Tree Protocol (STP) information for the switch, providing data to ensure a loop-free topology. */
  stpInfo?: Maybe<StpInfo>;
  /** IPv6 address on the jumphost subnet. Used to send requests to the device. */
  tunnelIPAddress?: Maybe<Scalars['String']['output']>;
  /** The timestamp when the hardware device was last updated in the system. */
  updatedAt: Scalars['DateTime']['output'];
  /**
   * The uptime from our time series database for the device.
   * @deprecated Use `VirtualDevice.uptime` instead.
   */
  uptime?: Maybe<Scalars['Duration']['output']>;
  /** The virtual device associated with this hardware device, if any. */
  virtualDevice?: Maybe<VirtualDevice>;
  /** The UUID of the virtual device this hardware device is assigned to, if any. */
  virtualDeviceUUID?: Maybe<Scalars['UUID']['output']>;
};

/** A switch hardware device represents a physical switch. */
export type SwitchHardwareDeviceBootHistoryArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
};

/** Represents an entry in the switch's MAC address table, mapping MAC addresses to ports and VLANs. */
export type SwitchMacTableEntry = {
  __typename?: 'SwitchMACTableEntry';
  /** The MAC address observed on the switch. */
  macAddress: Scalars['MacAddress']['output'];
  /** A user-defined nickname for the MAC address, if specified. */
  macAddressAlias?: Maybe<MacAddressAlias>;
  /** The physical interface where the MAC address was observed. */
  phyInterface: PhyInterface;
  /**
   * The port number where the MAC address was observed.
   * @deprecated Can get this info from `phyInterface`.
   */
  port: Scalars['Int']['output'];
  /** The timestamp when the entry was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** The UUID of the switch virtual device. */
  virtualDeviceUUID: Scalars['UUID']['output'];
  /** The VLAN associated with the VLAN ID. */
  vlan?: Maybe<Vlan>;
  /** The VLAN ID associated with the MAC address. */
  vlanID: Scalars['Int']['output'];
};

/**
 * Deprecated in favor of `SwitchPortMetricsRateResponse`.
 * Response type containing metadata and an array of switch port metric values.
 */
export type SwitchMetricsResponse = MetricsResponse & {
  __typename?: 'SwitchMetricsResponse';
  /** Metadata about the metrics, such as units and aggregation methods. */
  metadata?: Maybe<MetricsMetadata>;
  /** An array of switch port metric values. */
  values: Array<SwitchPortMetricsValue>;
};

/** Response type containing an array of per-port rate metrics at specific timestamps. */
export type SwitchPortMetricsRateResponse = {
  __typename?: 'SwitchPortMetricsRateResponse';
  /** An array of per-port metrics expressed as rates at specific timestamps. */
  values: Array<SwitchPortMetricsRateValue>;
};

/** Per-port metrics data expressed as rates (per second) at specific timestamps. */
export type SwitchPortMetricsRateValue = {
  __typename?: 'SwitchPortMetricsRateValue';
  /** Total number of broadcast packets per second received in the given time period; a subset of totalRxPackets. */
  broadcastRxPacketsPerSecond: Scalars['Float']['output'];
  /** Total number of broadcast packets per second received in the given time period; a subset of totalRxPackets. */
  broadcastTxPacketsPerSecond: Scalars['Float']['output'];
  /** The rate of packets per second that were dropped during transmission or reception on this port. */
  dropsPerSecond: Scalars['Float']['output'];
  /** Total number of multicast packets per second received in the given time period; a subset of totalRxPackets. */
  multicastRxPacketsPerSecond: Scalars['Float']['output'];
  /** Total number of multicast packets per second transmitted in the given time period; a subset of totalTxPackets. */
  multicastTxPacketsPerSecond: Scalars['Float']['output'];
  /** The physical port number on the switch. */
  portNumber: Scalars['Int']['output'];
  /** The rate of reception errors per second on this port. */
  rxErrPerSecond: Scalars['Float']['output'];
  /** The timestamp for when the rate values were calculated. */
  timestamp: Scalars['DateTime']['output'];
  /** The rate of bytes per second received on this port. */
  totalRxBytesPerSecond: Scalars['Float']['output'];
  /** The rate of bytes per second transmitted from this port. */
  totalTxBytesPerSecond: Scalars['Float']['output'];
  /** The rate of transmission errors per second on this port. */
  txErrPerSecond: Scalars['Float']['output'];
};

/**
 * Deprecated in favor of `SwitchPortMetricsRateResponse`.
 * Response type containing an array of per-port counter statistics captured at specific timestamps.
 */
export type SwitchPortMetricsResponse = {
  __typename?: 'SwitchPortMetricsResponse';
  /** An array of per-port counter statistics values. */
  values: Array<SwitchPortMetricsStatValue>;
};

/**
 * Deprecated in favor of `SwitchPortMetricsRateValue`.
 * Counter stats per switch port over a lookback period.
 */
export type SwitchPortMetricsStatValue = {
  __typename?: 'SwitchPortMetricsStatValue';
  /** Total number of broadcast packets received in the given time period; a subset of totalRxPackets. */
  broadcastRxPackets: Scalars['Float']['output'];
  /** Total number of broadcast packets transmitted in the given time period; a subset of totalTxPackets. */
  broadcastTxPackets: Scalars['Float']['output'];
  /** Total number of multicast packets received in the given time period; a subset of totalRxPackets. */
  multicastRxPackets: Scalars['Float']['output'];
  /** Total number of multicast packets transmitted in the given time period; a subset of totalTxPackets. */
  multicastTxPackets: Scalars['Float']['output'];
  /** The physical port number on the switch. */
  portNumber: Scalars['Int']['output'];
  /** The total cumulative number of packets discarded during reception on this port up to this timestamp. */
  rxDiscards: Scalars['Float']['output'];
  /** The total cumulative number of reception errors on this port up to this timestamp. */
  rxErr: Scalars['Float']['output'];
  /** The timestamp when the counters were recorded. */
  timestamp: Scalars['DateTime']['output'];
  /** The total cumulative number of bytes received on this port up to this timestamp. */
  totalRxBytes: Scalars['Float']['output'];
  /** The total cumulative number of bytes transmitted from this port up to this timestamp. */
  totalTxBytes: Scalars['Float']['output'];
  /** The total cumulative number of packets discarded during transmission on this port up to this timestamp. */
  txDiscards: Scalars['Float']['output'];
  /** The total cumulative number of transmission errors on this port up to this timestamp. */
  txErr: Scalars['Float']['output'];
};

/** Represents the value of switch port metrics at a specific timestamp. */
export type SwitchPortMetricsValue = MetricsValue & {
  __typename?: 'SwitchPortMetricsValue';
  /** The direction of traffic (e.g., inbound or outbound). */
  direction: TrafficDirection;
  /** The port identifier. */
  port: Scalars['String']['output'];
  /** The timestamp for the metric value. */
  timestamp: Scalars['DateTime']['output'];
  /** The metric value. */
  value: Scalars['Float']['output'];
};

/** Aggregated statistics per switch port over a specified lookback period. */
export type SwitchPortStat = {
  __typename?: 'SwitchPortStat';
  /** Total number of broadcast packets received on this port during the lookback period; a subset of totalRxPackets. */
  broadcastRxPackets: Scalars['Int']['output'];
  /** Total number of broadcast packets transmitted from this port during the lookback period; a subset of totalTxPackets. */
  broadcastTxPackets: Scalars['Int']['output'];
  /** Total number of packets received on this port but discarded due to errors or resource limitations during the lookback period; a subset of totalRxPackets. */
  discardRxPackets: Scalars['Int']['output'];
  /** Total number of packets attempted to be transmitted from this port but discarded due to errors or resource limitations during the lookback period; a subset of totalTxPackets. */
  discardTxPackets: Scalars['Int']['output'];
  /** Total number of packets received on this port that contained errors (e.g., CRC errors) during the lookback period; a subset of totalRxPackets. */
  errorRxPackets: Scalars['Int']['output'];
  /** Total number of packets transmitted from this port that encountered errors during the lookback period; a subset of totalTxPackets. */
  errorTxPackets: Scalars['Int']['output'];
  /** Total number of multicast packets received on this port during the lookback period; a subset of totalRxPackets. */
  multicastRxPackets: Scalars['Int']['output'];
  /** Total number of multicast packets transmitted from this port during the lookback period; a subset of totalTxPackets. */
  multicastTxPackets: Scalars['Int']['output'];
  /** Total number of non-unicast (i.e., multicast and broadcast) packets received on this port during the lookback period; a subset of totalRxPackets. */
  nonUnicastRxPackets: Scalars['Int']['output'];
  /** Total number of non-unicast (i.e., multicast and broadcast) packets transmitted from this port during the lookback period; a subset of totalTxPackets. */
  nonUnicastTxPackets: Scalars['Int']['output'];
  /** The physical number of the port on the switch. */
  portNumber: Scalars['Int']['output'];
  /** Total number of bytes received on this port during the lookback period. */
  totalRxBytes: Scalars['Int']['output'];
  /** Total number of packets received on this port during the lookback period. */
  totalRxPackets: Scalars['Int']['output'];
  /** Total number of bytes transmitted from this port during the lookback period. */
  totalTxBytes: Scalars['Int']['output'];
  /** Total number of packets transmitted from this port during the lookback period. */
  totalTxPackets: Scalars['Int']['output'];
  /** Total number of unicast packets received on this port during the lookback period; a subset of totalRxPackets. */
  unicastRxPackets: Scalars['Int']['output'];
  /** Total number of unicast packets transmitted from this port during the lookback period; a subset of totalTxPackets. */
  unicastTxPackets: Scalars['Int']['output'];
};

/** A switch profile is a bundle of settings that applies to a switch device. */
export type SwitchProfile = {
  __typename?: 'SwitchProfile';
  /** The unique identifier of the switch profile. */
  UUID: Scalars['UUID']['output'];
  /** Time in minutes after the last voice device leaves and the port is removed from voice VLAN. */
  VoiceVLANAgingTimeMin?: Maybe<Scalars['Int']['output']>;
  /** OUIs that should be detected as IP phones. */
  VoiceVLANOUIs?: Maybe<Array<Scalars['String']['output']>>;
  /** The date and time when the switch profile was created. */
  createdAt: Scalars['DateTime']['output'];
  /** For 802.1X encryption on a Switch's ports, if a client fails 802.1X authentication, clients are placed in the specified VLAN. The VLAN must be specified as `isGuest`. If set to null, then clients must authenticate before accessing the network. */
  encryption8021XGuestVLAN?: Maybe<Vlan>;
  /** The 802.1X encryption configurations associated with this switch profile. Setting this field enables 802.1X encryption on the switch's ports, which can individually be enabled/disabled and configured on a per-port basis. The order matters; the first index is the primary and subsequent ones are backup(s). */
  encryption8021Xs?: Maybe<Array<Encryption8021X>>;
  /** The time in seconds after which all flap state for a port is cleared. */
  flipClearFlapStateAfterSec?: Maybe<Scalars['Int']['output']>;
  /** The maximum number of times to toggle the port before requiring manual toggle of port in dashboard. */
  flipMaxRetryCount?: Maybe<Scalars['Int']['output']>;
  /** The number of seconds to wait before re-enabling the port. */
  flipRetryPeriodSec?: Maybe<Scalars['Int']['output']>;
  /** Time window in seconds to count the number of flaps. */
  flipWindowSec?: Maybe<Scalars['Int']['output']>;
  /** The number of flaps per time window that will result in a port being shut down. */
  flipWindowThreshold?: Maybe<Scalars['Int']['output']>;
  /** If true, flap link intervention protocol is enabled for this switch profile. Both this flag and isFLIPEnabled in PhyInterface must be true for FLIP to be enabled on a port. */
  isFLIPEnabled: Scalars['Boolean']['output'];
  /** Enables switch to periodically send IGMP queries to detect multicast clients. Both this flag and isIgmpSnoopingEnabled in VLAN must be true for IGMP snooping to be enabled on this switch. */
  isIGMPSnoopingEnabled: Scalars['Boolean']['output'];
  /** Enables switch to periodically send MLD queries to detect multicast clients. Both this flag and isMldSnoopingEnabled in VLAN must be true for MLD snooping to be enabled on this switch. */
  isMLDSnoopingEnabled: Scalars['Boolean']['output'];
  /** Multicast filtering tells the switch what to do with unknown multicast packet i.e packets for which snooping doesn't have any learned ports. When enabled, unknown multicast packets are dropped. */
  isMulticastFilteringEnabled: Scalars['Boolean']['output'];
  /** If true, voice VLAN is enabled for this switch profile. Both this flag and isVoiceVLANEnabled in PhyInterface must be true for voice VLAN to be enabled on a port. */
  isVoiceVLANEnabled: Scalars['Boolean']['output'];
  /** Time in seconds after which a MAC entry will be aged out, default is 300 seconds (5 minutes) and 0 means no expiration. */
  macTableAgingSec: Scalars['Int']['output'];
  /** The maximum transmission unit (MTU) size in bytes. The default is 1522. */
  mtu: Scalars['Int']['output'];
  /** The name of the switch profile. */
  name: Scalars['String']['output'];
  /** The unique identifier of the network the switch profile belongs to. */
  networkUUID: Scalars['UUID']['output'];
  /**
   * The STP (Spanning Tree Protocol) bridge priority for the switch.
   *
   * The lower the value, the more likely the switch is to be elected as the root bridge.
   * The range is 0 to 61440. Valid values are multiples of 4096.
   */
  stpBridgePriority: Scalars['Int']['output'];
  /**
   * STP forwarding delay in seconds.
   *
   * The time that the switch will wait before transitioning a port from the listening to the learning state, and from the learning to the forwarding state.
   * Valid values are between 4 and 30 seconds.
   */
  stpForwardingDelaySeconds: Scalars['Int']['output'];
  /**
   * STP Hello interval in seconds.
   *
   * The time between configuration messages sent by the root bridge to maintain the spanning tree topology.
   * Valid values are between 1 and 10 seconds.
   */
  stpHelloIntervalSeconds: Scalars['Int']['output'];
  /**
   * STP Max BPDU (Bridge Protocol Data Unit) age in seconds.
   *
   * The maximum age of received BPDU information before it is discarded.
   * Valid values are between 6 and 40 seconds.
   */
  stpMaxAgeSeconds: Scalars['Int']['output'];
  /**
   * STP BPDU transmit hold count per second.
   *
   * The maximum number of BPDUs that can be sent per second.
   * Valid values are between 1 and 10.
   */
  stpTransmitHoldCount: Scalars['Int']['output'];
  /** The tier of the switch device(s) associated with the switch profile, denoting the purpose of the devices in the network. */
  switchingTier: SwitchProfileSwitchingTier;
  /** The date and time when the switch profile was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** Voice VLAN CoS (Class Of Service) that operates on Layer-2 level. Valid values are 0-7. */
  voiceCosValue?: Maybe<Scalars['Int']['output']>;
  /** Voice VLAN DSCP (Differentiated Services Code Point) that operates on Layer-4 level. Valid values are 0-63. */
  voiceDscpValue?: Maybe<Scalars['Int']['output']>;
  /** The UUID of the VLAN designated for voice traffic. */
  voiceVLANUUID?: Maybe<Scalars['UUID']['output']>;
};

/** A categorization for the switch device(s) associated with a SwitchProfile, denoting the purpose of the devices in the network. */
export enum SwitchProfileSwitchingTier {
  /** Switches that directly connect end devices, usually with a mix of Ethernet and SFP uplinks to distribution switches. */
  Access = 'ACCESS',
  /** MDF-based aggregation layer, typically SFP-only, serving as the central switching hub for the network. These switches connect to downstream distribution/access switches and uplinks to security appliances. */
  Core = 'CORE',
  /** MDF/IDF-based switches that aggregate multiple access switches and uplink to core switches. Can be SFP-only or a mix of Ethernet and SFP uplinks. */
  Distribution = 'DISTRIBUTION',
  /** The switches distribute an ISP connection between High Availability (HA) security appliances. */
  Isp = 'ISP',
}

/** A switch virtual device is a logical representation of a physical switch. */
export type SwitchVirtualDevice = VirtualDevice & {
  __typename?: 'SwitchVirtualDevice';
  /** The unique identifier (UUID) of the virtual device. */
  UUID: Scalars['UUID']['output'];
  /** The timestamp when the virtual device was first created in the system. */
  createdAt: Scalars['DateTime']['output'];
  /** An optional description for the virtual device. */
  description?: Maybe<Scalars['String']['output']>;
  /** The model name of the virtual device. */
  deviceModel: DeviceModel;
  /** The type of the virtual device. */
  deviceType: VirtualDeviceType;
  /** The hardware device associated with this virtual device, if any. */
  hardwareDevice?: Maybe<HardwareDevice>;
  /** Indicates whether the virtual device's console port is enabled. */
  isConsoleEnabled: Scalars['Boolean']['output'];
  /** Indicates whether debug logging is enabled on the virtual device. */
  isDebugLogEnabled: Scalars['Boolean']['output'];
  /** A human-friendly name for the device. */
  label: Scalars['String']['output'];
  /** The MAC table of the switch (ie. the ports and the MAC addresses of the devices connected to them). */
  macTable?: Maybe<Array<SwitchMacTableEntry>>;
  /** The network that the virtual device belongs to. */
  network: Network;
  /** The unique identifier (UUID) of the network the virtual device belongs to. */
  networkUUID: Scalars['UUID']['output'];
  /** The group that the device belongs to for firmware upgrade grouping purposes. */
  nosUpgradeGroup: NosUpgradeGroup;
  /** The current NOS firmware version that the virtual device is configured to run. */
  nosVersion?: Maybe<ConfiguredNosVersion>;
  /** The identifier of the NOS firmware version that the virtual device is configured to run. */
  nosVersionID: Scalars['Int']['output'];
  /**
   * The outlet interface on a Meter Power Distribution Device that this device is connected to, if applicable.
   * This connection is a manually curated label and may not actually be the outlet that the device is connected to.
   */
  outletInterfaceConnectedTo?: Maybe<OutletInterface>;
  /** The NOS firmware version that the virtual device is scheduled to upgrade to. */
  pendingNosVersion?: Maybe<PendingNosVersion>;
  /** The physical interfaces associated with the switch. */
  phyInterfaces: Array<PhyInterface>;
  /** Information about the switch's Power over Ethernet (PoE) usage. */
  poeInfo?: Maybe<PoEInfo>;
  /** The switch profile associated with this switch that defines port configurations and other settings. */
  switchProfile: SwitchProfile;
  /** The UUID of the switch profile associated with this switch. */
  switchProfileUUID: Scalars['UUID']['output'];
  /** Data about this virtual device's position in its network's topology. */
  topologyData?: Maybe<VirtualDeviceTopologyData>;
  /** The timestamp when the virtual device was last updated in the system. */
  updatedAt: Scalars['DateTime']['output'];
  /** The uptime from our time series database for the device. */
  uptime?: Maybe<Scalars['Duration']['output']>;
};

/** System information about a device. */
export type SystemInfoStat = {
  __typename?: 'SystemInfoStat';
  /** The used CPU percentage represented as a value [0, 1]. */
  cpuUsedPercentage: Scalars['Float']['output'];
  /** Amount of available memory in bytes. */
  memoryBytesAvailable: Scalars['Int']['output'];
  /** Total memory in bytes. */
  memoryBytesTotal: Scalars['Int']['output'];
  /** Amount of used memory in bytes. */
  memoryBytesUsed: Scalars['Int']['output'];
  /** The uptime of the device since last reboot, in seconds. */
  uptime: Scalars['Duration']['output'];
};

export type SystemInfoStatsFilter = {
  /** The lookback time to consider stats for, starting at `endTime`. Maximum allowed value is 86400, one day. */
  durationSeconds: Scalars['Int']['input'];
  /** The latest observation time to consider stats for, inclusive. Defaults to the current time if not set. */
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** The maximum number of results to return, between 1 and 1000. Defaults to 100 if not set. */
  limit?: Scalars['Int']['input'];
};

/** Represents the result of a test fire alert. */
export type TestFireAlertResult = {
  __typename?: 'TestFireAlertResult';
  /** Unique identifier of the alert receiver that was tested. */
  alertReceiverUUID: Scalars['UUID']['output'];
  /** Outcome of the test fire alert. */
  ok: Scalars['Boolean']['output'];
};

/** Input type for testing a webhook alert target by triggering a simulated event. */
export type TestTriggerAlertTargetWebhookInput = {
  /** The name of the event to simulate triggering. */
  eventName: Scalars['String']['input'];
  /** The payload data to send with the simulated event. */
  payload: Scalars['String']['input'];
};

/** Response type for testing a webhook alert target. */
export type TestTriggerAlertTargetWebhookResponse = {
  __typename?: 'TestTriggerAlertTargetWebhookResponse';
  /** The UUID of the webhook alert target that was tested. */
  UUID: Scalars['UUID']['output'];
  /** Whether or not the webhook alert target was successfully tested. */
  ok: Scalars['Boolean']['output'];
};

/** A pair of S3 keys for a theme-dependent image. */
export type ThemedImageS3Keys = {
  __typename?: 'ThemedImageS3Keys';
  /** S3 key for an image intended to display on a dark theme. */
  darkS3Key: Scalars['String']['output'];
  /** S3 key for an image intended to display on a light theme. */
  lightS3Key: Scalars['String']['output'];
};

export type ThemedImageS3KeysInput = {
  /** S3 key for an image intended to display on a dark theme. */
  darkS3Key: Scalars['String']['input'];
  /** S3 key for an image intended to display on a light theme. */
  lightS3Key: Scalars['String']['input'];
};

/** Represents a throughput data point with its value and traffic direction. */
export type ThroughputValueWithDirection = {
  __typename?: 'ThroughputValueWithDirection';
  /** The direction of traffic for the throughput value. */
  direction: TrafficDirection;
  /** The throughput value in bits per second. */
  value: Scalars['Int']['output'];
};

export type TimeFilter = {
  /** The lookback time to consider, starting at `endTime`. Maximum allowed value is 86400, one day. */
  durationSeconds: Scalars['Int']['input'];
  /** The latest observation time to consider, inclusive. Defaults to the current time if not set. */
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Represents the principal (entity) associated with a token. */
export type TokenPrincipal = {
  __typename?: 'TokenPrincipal';
  /** The name of the principal. For devices, the serial number; for machines, the machine name; for users, the user name. */
  name: Scalars['String']['output'];
  /** The type of the principal (e.g., DEVICE, MACHINE, USER). */
  type: PrincipalType;
};

/** An enumeration of possible token types. */
export enum TokenType {
  /** A bearer token used for authentication. */
  Bearer = 'BEARER',
}

/** Represents the direction of network traffic. */
export enum TrafficDirection {
  /** Incoming traffic direction (Received traffic). */
  Rx = 'RX',
  /** Outgoing traffic direction (Transmitted traffic). */
  Tx = 'TX',
}

/** Input type for activating a Twilio cellular SIM card. Deprecated. */
export type TwilioCellularActivationInput = {
  /** The country where the SIM card will be used. */
  country: TwilioCellularCountry;
  /** The ICCID (Integrated Circuit Card Identifier) of the SIM card to activate. */
  iccid: Scalars['String']['input'];
};

/** Enumeration of supported countries for activating Twilio cellular SIM cards. Deprecated. */
export enum TwilioCellularCountry {
  /** Canada */
  Ca = 'CA',
  /** Used for all other countries. */
  Other = 'OTHER',
  /** United States of America */
  Us = 'US',
}

/** A pair of hardware devices that are not associated with any virtual device in a network. */
export type UnassignedHardwareAndConnectedPhyInterface = {
  __typename?: 'UnassignedHardwareAndConnectedPhyInterface';
  /** The physical interface of the switch that the unassigned hardware device is connected to. */
  phyInterface: PhyInterface;
  /** The physically connected hardware device that is not associated with any virtual device in this network. */
  unassignedHardwareDevice: AccessPointHardwareDevice;
};

/** Represents a response containing unassigned hardware devices for a network. */
export type UnassignedHardwareDeviceForNetworkResponse = {
  __typename?: 'UnassignedHardwareDeviceForNetworkResponse';
  /** Tuples of unassigned hardware devices and the physical interfaces they are connected to. */
  unassignedHardwareConnections: Array<UnassignedHardwareAndConnectedPhyInterface>;
  /** The switch virtual device that the unassigned hardware device is connected to. */
  virtualDevice: SwitchVirtualDevice;
};

/** Specifies the referer types allowed for unauthenticated access. */
export enum UnauthenticatedReferer {
  /** Access from any referer. */
  Any = 'ANY',
  /** Access from a captive portal. */
  Captive = 'CAPTIVE',
  /** Access during installation. */
  Install = 'INSTALL',
}

/** Input type for unbinding a firewall rule from a physical interface. */
export type UnbindFirewallRuleFromPhyInterface = {
  /** UUID of the firewall rule to unbind. */
  firewallRuleUUID: Scalars['UUID']['input'];
  /** UUID of the physical interface to unbind the firewall rule from. */
  phyInterfaceUUID: Scalars['UUID']['input'];
};

/** Input type for unbinding a firewall rule from a VLAN. */
export type UnbindFirewallRuleFromVlan = {
  /** UUID of the firewall rule to unbind. */
  firewallRuleUUID: Scalars['UUID']['input'];
  /** UUID of the VLAN to unbind the firewall rule from. */
  vlanUUID: Scalars['UUID']['input'];
};

export type UnbindPolicyRoutingRuleInput = {
  /** The binding information to unbind from the policy routing rule. */
  binding: PolicyRoutingRuleBindingInput;
};

/** The provided list of targets replaces the existing targets entirely. Any targets not included in this list will be removed. */
export type UpdateAlertReceiverWithTargetsInput = {
  /** Updated label for the alert receiver. */
  label?: InputMaybe<Scalars['String']['input']>;
  /** List of alert targets to associate with the alert receiver. This list will replace any existing targets. */
  targets?: InputMaybe<Array<AlertTargetInput>>;
};

/** Input type for updating an existing slack alert target. */
export type UpdateAlertTargetSlackInput = {
  /** An updated Slack channel ID to which alerts will be sent. */
  channelID?: InputMaybe<Scalars['String']['input']>;
  /** An updated label for the slack alert target. */
  label?: InputMaybe<Scalars['String']['input']>;
};

/** Input type for updating an existing webhook alert target. */
export type UpdateAlertTargetWebhookInput = {
  /** An updated type of authentication to use for the webhook. */
  authType?: InputMaybe<WebhookAuthType>;
  /** An updated value of the authentication header to use for the webhook. */
  authValue?: InputMaybe<Scalars['String']['input']>;
  /** An updated label for the webhook alert target. */
  label?: InputMaybe<Scalars['String']['input']>;
  /** An updated secret used to sign webhook requests for verification. */
  signingSecret?: InputMaybe<Scalars['String']['input']>;
  /** An updated URL endpoint for the webhook. */
  url?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateApplicationDnsFirewallRuleApplicationVisibilities = {
  /** The ID of the application to update visibility for. */
  id: Scalars['Int']['input'];
  /** Indicates whether the application is visible to the customer. */
  isVisible: Scalars['Boolean']['input'];
};

export type UpdateApplicationDnsFirewallRuleInput = {
  /** The action to take when the rule is matched. */
  action?: InputMaybe<FirewallRuleAction>;
  /** The ID of the Netstar application to associate with the rule. */
  applicationID?: InputMaybe<Scalars['Int']['input']>;
  /** List of UUIDs of DHCP rules to which the application dns firewall rule is bound. */
  boundDHCPRuleUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** The ID of the Netstar category to associate with the rule. */
  categoryID?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Updates the DHCP rule the DNS firewall rule is associated with. If priority is not specified, will default to 1 greater than the highest existing priority.
   * @deprecated Use boundDHCPRuleUUIDs instead.
   */
  dhcpRuleUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** The domain or FQDN that is matched by the rule, allowing for wildcards denoted by '*'. */
  domain?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the Netstar group to associate with the rule. */
  groupID?: InputMaybe<Scalars['Int']['input']>;
  /** Indicates whether the rule is enabled. */
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** The name of the DNS firewall rule. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The priority of the rule; if not specified, will default to 1 greater than the highest existing priority. */
  priority?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateApplicationDnsFirewallRulesInput = {
  /** The UUID of the DNS firewall rule to update. */
  applicationDNSFirewallRuleUUID: Scalars['UUID']['input'];
  /** The input data for updating the DNS firewall rule. */
  input: UpdateApplicationDnsFirewallRuleInput;
};

export type UpdateApplicationDnsFirewallRulesPrioritiesInput = {
  /** The UUID of the DNS firewall rule to update. */
  applicationDNSFirewallRuleUUID: Scalars['UUID']['input'];
  /** The new priority to assign to the rule. */
  priority: Scalars['Int']['input'];
};

/** Input type for updating an existing AutoVPN Group. */
export type UpdateAutoVpnGroupInput = {
  /** Indicates if the AutoVPN Group is enabled. */
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates if hub failover is enabled. */
  isHubFailoverEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** New name for the AutoVPN Group. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Updated configuration of the hub's uplink. */
  uplink?: InputMaybe<CreateAutoVpnGroupHubUplinkInput>;
};

/** Acts as a PUT */
export type UpdateAutoVpnMemberInput = {
  /** Indicates if failover is enabled for the member's uplink. */
  isFailoverEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** List of permitted VLAN unique identifiers. The associated VLANs must have participatesInVPNs set to true. */
  permittedVLANUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Unique identifier of the physical interface used by the member's uplink. */
  phyInterfaceUUID?: InputMaybe<Scalars['UUID']['input']>;
};

/** Input type for updating an existing AutoVPN route in an AutoVPN Group. */
export type UpdateAutoVpnRouteInput = {
  /** Destination gateway IP address for the route. */
  dstGateway?: InputMaybe<Scalars['IPV4']['input']>;
  /** Prefix length for the destination IP of the route. */
  dstPrefixLength?: InputMaybe<Scalars['Int']['input']>;
  /** Indicates if the route is enabled. */
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** New name for the route. */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Input parameters for updating a Client VPN client. */
export type UpdateClientVpnClientInput = {
  /** Whether the client is enabled. If false, users will not be able to connect using this client's key. */
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Input parameters for updating a Client VPN server. */
export type UpdateClientVpnServerInput = {
  /** IPv4 address to assign to the WireGuard interface. */
  address?: InputMaybe<Scalars['IPV4']['input']>;
  /** Subnet mask length (CIDR notation) for the WireGuard interface address. */
  addressMask?: InputMaybe<Scalars['Int']['input']>;
  /** The UUIDs for the VLANs that are accessible via connections through this client VPN server. */
  boundVLANUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Default list of IP prefixes that clients are allowed to access. */
  defaultClientAllowedIPs?: InputMaybe<Array<Scalars['IPPrefix']['input']>>;
  /** An additional listen address other than `address` this server serves DNS traffic on. It must be a private IP. */
  dnsListenAddress?: InputMaybe<Scalars['IPV4']['input']>;
  /** Whether the client VPN server is enabled. */
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Set to true to enable failover between uplink physical interfaces (WANs). */
  isFailoverEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Port number on which the WireGuard server listens for incoming connections. */
  listenPort?: InputMaybe<Scalars['Int']['input']>;
  /** The name of this client VPN server. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** UUID of the uplink physical interface that the WireGuard server will listen on. */
  phyInterfaceUUID?: InputMaybe<Scalars['UUID']['input']>;
};

export type UpdateCompanyInput = {
  /** Indicates if the company is prospective (used for sales purposes). */
  isProspective?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * The S3 key (path) of the image file representing the company logo, stored in AWS S3.
   * This is not required; it overrides the default logo that we fetch from a 3rd party service.
   */
  logoS3Key?: InputMaybe<Scalars['String']['input']>;
  /** New name for the company. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** New slug for the company. */
  slug?: InputMaybe<Scalars['String']['input']>;
};

/** Input parameters for updating company SIEM integration. */
export type UpdateCompanySiemIntegrationInput = {
  /** Status of the integration. */
  status: CompanySiemIntegrationStatus;
};

/** Fields that can be updated for a company user. */
export type UpdateCompanyUserInput = {
  /** The new membership role for the company user within the company. */
  companyMembershipRole?: InputMaybe<CompanyMembershipRole>;
  /** The new first name for the company user. */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** The new last name for the company user. */
  lastName?: InputMaybe<Scalars['String']['input']>;
};

/** Input for updating an existing DHCP option. */
export type UpdateDhcpOptionInput = {
  /** The data value for the DHCP option. */
  data?: InputMaybe<Scalars['String']['input']>;
  /** If this is a custom (nonstandard) DHCP option, the type of the data. */
  dataType?: InputMaybe<DhcpOptionDataType>;
  /** An optional description for the DHCP option. */
  description?: InputMaybe<Scalars['String']['input']>;
};

/** Input for updating a DHCP proxy. */
export type UpdateDhcpProxyInput = {
  /** The IP address of this DHCP proxy. */
  ipAddress?: InputMaybe<Scalars['IP']['input']>;
  /** The UUID of the uplink physical interface (WAN) that should be used for egress with this proxy. */
  phyInterfaceUUID?: InputMaybe<Scalars['UUID']['input']>;
};

/** Input for updating an existing DHCP reserved range. */
export type UpdateDhcpReservedRangeInput = {
  /** A human-readable description. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The last reserved IP address in the range. */
  endIPAddress?: InputMaybe<Scalars['IP']['input']>;
  /** The first reserved IP address in the range. */
  startIPAddress?: InputMaybe<Scalars['IP']['input']>;
};

/** Input for updating a specific DHCP reserved range identified by UUID. */
export type UpdateDhcpReservedRangeUuidInput = {
  /** The unique identifier of the DHCP reserved range to update. */
  UUID: Scalars['UUID']['input'];
  /** The input data for updating the DHCP reserved range. */
  input: UpdateDhcpReservedRangeInput;
};

/** Input for updating an existing DHCP rule. */
export type UpdateDhcpRuleInput = {
  /** List of DHCP proxies to create or update. */
  dhcpProxies?: InputMaybe<Array<UpsertDhcpProxyInput>>;
  /** Enables or disables DNS caching on the DHCP server. */
  dnsCacheIsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Specifies the maximum Time-To-Live (TTL) in seconds for cached DNS entries. */
  dnsCacheMaxTTL?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies the maximum number of DNS records to cache. */
  dnsCacheSize?: InputMaybe<Scalars['Int']['input']>;
  /** A list of DNS search domains provided to DHCP clients. */
  dnsSearchDomains?: InputMaybe<Array<Scalars['String']['input']>>;
  /** List of upstream DNS servers to use. */
  dnsUpstreamServers?: InputMaybe<Array<Scalars['IP']['input']>>;
  /** Determines if the gateway acts as a DNS proxy for clients. */
  dnsUseGatewayProxy?: InputMaybe<Scalars['Boolean']['input']>;
  /** The last available IP address in the DHCP range, ascending and inclusive. */
  endIPAddress?: InputMaybe<Scalars['IP']['input']>;
  /** The gateway IP address provided to DHCP clients. */
  gatewayIPAddress?: InputMaybe<Scalars['IP']['input']>;
  /** The prefix length of the gateway IP address. */
  gatewayPrefixLength?: InputMaybe<Scalars['Int']['input']>;
  /** If set, the gateway IP address is allowed to be different from its VLAN's address. */
  hasGatewayOverride?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates whether this DHCP rule is for IPv6 (`true`) or IPv4 (`false`). */
  isIPv6?: InputMaybe<Scalars['Boolean']['input']>;
  /** The duration (in seconds) of the DHCP lease assigned to clients. */
  leaseDurationSeconds?: InputMaybe<Scalars['Int']['input']>;
  /** List of reserved IP ranges within the DHCP range to update. */
  reservedRanges?: InputMaybe<Array<UpdateDhcpReservedRangeUuidInput>>;
  /** The first available IP address in the DHCP range, ascending and inclusive. */
  startIPAddress?: InputMaybe<Scalars['IP']['input']>;
  /** List of static mappings between MAC addresses and IP addresses to update. */
  staticMappings?: InputMaybe<Array<UpdateDhcpStaticMappingUuidInput>>;
};

/** Input for updating an existing DHCP static mapping. */
export type UpdateDhcpStaticMappingInput = {
  /** The hostname to assign to the client device. */
  hostname?: InputMaybe<Scalars['String']['input']>;
  /** The fixed IP address to assign to the client device. */
  ipAddress?: InputMaybe<Scalars['IP']['input']>;
  /** The MAC address of the client device. */
  macAddress?: InputMaybe<Scalars['MacAddress']['input']>;
  /** A name or label for this static mapping. */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Input for updating a specific DHCP static mapping identified by UUID. */
export type UpdateDhcpStaticMappingUuidInput = {
  /** The unique identifier of the DHCP static mapping to update. */
  UUID: Scalars['UUID']['input'];
  /** The input data for updating the DHCP static mapping. */
  input: UpdateDhcpStaticMappingInput;
};

/** Input for updating an existing DNS host mapping. */
export type UpdateDnsHostMappingInput = {
  /** The domain to which `overrideDomain` should resolve. */
  destinationDomain?: InputMaybe<Scalars['String']['input']>;
  /** The IP address to which `overrideDomain` should resolve. */
  destinationIPAddress?: InputMaybe<Scalars['IP']['input']>;
  /** Indicates whether this DNS host mapping is enabled. */
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** The domain name to override. This can be a fully qualified domain name (FQDN) or a domain name. */
  overrideDomain?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDefaultRoleForUsersInput = {
  /** The name of the default role for users in the company (ie: company_admin_read_only) */
  defaultRoleForUsers: RoleName;
};

/** Input type for updating an existing 802.1X encryption configuration. All fields are optional; only provided fields will be updated. */
export type UpdateEncryption8021XInput = {
  /** The new IP address of the accounting server. If provided, accountingServerPort and accountingServerSecret must also be provided. */
  accountingServerIPAddress?: InputMaybe<Scalars['IP']['input']>;
  /** The new port of the accounting server (1-65535). */
  accountingServerPort?: InputMaybe<Scalars['Int']['input']>;
  /** The new shared secret used to authenticate with the accounting server. */
  accountingServerSecret?: InputMaybe<Scalars['String']['input']>;
  /** The new IP address of the authentication server.. */
  authServerIPAddress?: InputMaybe<Scalars['IP']['input']>;
  /** The new port of the authentication server. */
  authServerPort?: InputMaybe<Scalars['Int']['input']>;
  /** The new shared secret used to authenticate with the authentication server. */
  authServerSecret?: InputMaybe<Scalars['String']['input']>;
  /** A new label for the encryption configuration. */
  label?: InputMaybe<Scalars['String']['input']>;
};

/** Input type for updating an existing firewall rule. */
export type UpdateFirewallRuleInput = {
  /** The action to take when the firewall rule matches (e.g., DENY or PERMIT). */
  action?: InputMaybe<FirewallRuleAction>;
  /**
   * List of UUIDs of physical interfaces to which the firewall rule is bound.
   * The physical interfaces must be uplinks.
   */
  boundPhyInterfaceUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** List of UUIDs of VLANs to which the firewall rule is bound. */
  boundVLANUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** A description of the firewall rule. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** UUID of the destination client VPN server to match traffic to. */
  dstClientVPNServerUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** UUID of the destination IPSec tunnel to match traffic to. */
  dstIPSecTunnelUUID?: InputMaybe<Scalars['UUID']['input']>;
  /**
   * Deprecated. Use `dstPortRanges` instead. Single destination port range to match.
   * @deprecated Use `dstPortRanges` instead.
   */
  dstPortRange?: InputMaybe<PortRangeInput>;
  /** List of destination port ranges to match traffic to. */
  dstPortRanges?: InputMaybe<Array<PortRangeInput>>;
  /** Destination IP prefix to match traffic to. */
  dstPrefix?: InputMaybe<Scalars['IPPrefix']['input']>;
  /** UUID of the destination VLAN to match traffic to. */
  dstVLANUUID?: InputMaybe<Scalars['UUID']['input']>;
  /**
   * Indicates if the firewall rule should be applied bidirectionally.
   * @deprecated Bidirectional rules are now implicit, enabled if the rule is between two VLANs.
   */
  isBidirectional?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates if the firewall rule is currently enabled. */
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates if the firewall rule is internal to Meter. */
  isMeterInternal?: InputMaybe<Scalars['Boolean']['input']>;
  /** The name of the firewall rule. */
  name?: InputMaybe<Scalars['String']['input']>;
  /**
   * Priority of the rule within the network, lower priority rules are applied first.
   * If there is an existing rule with the provided value, it and all subsequent occupied values will be incremented.
   */
  priority?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Deprecated. Use `protocols` instead. Single IP protocol to match.
   * @deprecated Use `protocols` instead.
   */
  protocol?: InputMaybe<IpProtocol>;
  /** List of IP protocols to match. */
  protocols?: InputMaybe<Array<IpProtocol>>;
  /** UUID of the source client VPN server to match traffic from. */
  srcClientVPNServerUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** UUID of the source IPSec tunnel to match traffic from. */
  srcIPSecTunnelUUID?: InputMaybe<Scalars['UUID']['input']>;
  /**
   * Deprecated. Use `srcPortRanges` instead. Single source port range to match.
   * @deprecated Use `srcPortRanges` instead.
   */
  srcPortRange?: InputMaybe<PortRangeInput>;
  /** List of source port ranges to match traffic from. */
  srcPortRanges?: InputMaybe<Array<PortRangeInput>>;
  /** Source IP prefix to match traffic from. */
  srcPrefix?: InputMaybe<Scalars['IPPrefix']['input']>;
  /**
   * UUID of the source VLAN to match traffic from.
   * @deprecated Source VLAN is now implied from `boundVLANUUIDs`.
   */
  srcVLANUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** List of tags associated with the firewall rule. */
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Input type for updating multiple existing firewall rules. */
export type UpdateFirewallRulesInput = {
  /** UUID of an existing firewall rule. */
  firewallRuleUUID: Scalars['UUID']['input'];
  /** Input data to apply to the firewall rule referred to by `firewallRuleUUID`. */
  input: UpdateFirewallRuleInput;
};

/** Input type for updating an existing default notification setting. */
export type UpdateFleetwideNotificationSettingInput = {
  /** The UUID of the alert receiver who will receive the notifications. */
  alertReceiverUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** A list of arguments providing specific parameters or context required by the notification definition. */
  arguments?: InputMaybe<Array<NotificationSettingArgumentInput>>;
  /** Optional filter by company */
  companyUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** If provided, enables the notification setting for the specified company support tiers, otherwise it is enabled for all company support tiers. */
  enabledCustomerSupportTiers?: InputMaybe<Array<CompanySupportTier>>;
  /** Whether the notification setting is enabled for only inactive networks. */
  enabledForInactiveNetworks?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the notification setting is enabled for internal networks. */
  enabledForInternalNetworks?: InputMaybe<Scalars['Boolean']['input']>;
  /** If provided, enables the notification setting for the specified NOS upgrade channels, otherwise it is enabled for all NOS upgrade channels. */
  enabledNOSUpgradeChannels?: InputMaybe<Array<NetworkNosUpgradeChannel>>;
  /** The label of the fleetwide notification setting. */
  label?: InputMaybe<Scalars['String']['input']>;
};

/** Input type for updating fleetwide notification snooze. */
export type UpdateFleetwideNotificationSnoozeInput = {
  /** The reason for the snooze. */
  snoozeReason?: InputMaybe<Scalars['String']['input']>;
  /** The time window for the snooze. */
  window?: InputMaybe<SnoozeNotificationSettingWindowInput>;
};

export type UpdateFloorPlanInput = {
  /** An updated description of the floor plan. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** An updated S3 key (path) of the image file representing the floor plan. */
  imageS3Key?: InputMaybe<Scalars['String']['input']>;
  /** An updated human-readable name or label for the floor plan. */
  label?: InputMaybe<Scalars['String']['input']>;
};

/** Input type containing details for updating the cellular failover event. */
export type UpdateForCellularFailoverEventInput = {
  /** Specifies the route that the cellular failover event should follow. It can be either CELLULAR or WAN. */
  route: CellularFailoverEventRoute;
};

/** Input type for updating high availability event status. */
export type UpdateForHighAvailabilityEventInput = {
  /** The new status of the high availability event. */
  status: HighAvailabilityStatus;
};

/** Specifies the metadata that can be updated for a hardware device. */
export type UpdateHardwareDeviceInput = {
  /** [Deprecated] Use 'isSpare' instead. Indicates whether the hardware device is active. */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enable or disable the hardware device's console port. */
  consoleEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Set the hardware device's factory mode status. */
  factoryMode?: InputMaybe<Scalars['Boolean']['input']>;
  /** Mark the hardware device as retired. */
  retired?: InputMaybe<Scalars['Boolean']['input']>;
  /** Mark the hardware device as an RMA (Return Merchandise Authorization) replacement device. */
  rma?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Input type for updating a high availability security appliance pair. */
export type UpdateHighAvailabilityPairInput = {
  /** Interval at which the security appliances will advertise to one another, in milliseconds. */
  advertisementIntervalMs?: InputMaybe<Scalars['Int']['input']>;
  /** Existing VLAN UUID to use for the advertisement VLAN. */
  advertisementVLANUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** UUID of the PhyInterface for the security appliance to be configured as backup in the HA setup. */
  backupPhyInterfaceUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** Enable or disable preemption for the HA security appliances in VRRP. */
  preempt?: InputMaybe<Scalars['Boolean']['input']>;
  /** UUID of the PhyInterface for the security appliance to be configured as primary in the HA setup. */
  primaryPhyInterfaceUUID?: InputMaybe<Scalars['UUID']['input']>;
};

/** Input type for updating an existing host monitoring target. */
export type UpdateHostMonitoringTargetInput = {
  /** A new description for the host monitoring target. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Indicates whether the host monitoring target is enabled. */
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether this target is used to compute whether a WAN should failover. Only available if `type` is `PING`. */
  isUsedForWANFailover?: InputMaybe<Scalars['Boolean']['input']>;
  /** The type of monitoring to perform on the target host. */
  type?: InputMaybe<HostMonitoringType>;
};

export type UpdateIdsipsConfigInput = {
  /** If set, replaces the list of bound categories. */
  boundCategories?: InputMaybe<Array<IdsipsConfigCategoryBindingInput>>;
  /** If set, replaces the list of bound rules. */
  boundRules?: InputMaybe<Array<IdsipsConfigRuleBindingInput>>;
  /** VLANs to enable IDS/IPS for. The enabled VLANs will be set to this value if provided. */
  enabledVLANUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Validity of ips generated rules. */
  ipsRuleDuration?: InputMaybe<Scalars['Duration']['input']>;
  /** If east-west protection is enabled. */
  isEastWestProtectionEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** The IPS minimum severity to act on. */
  minIPSSeverity?: InputMaybe<Scalars['Int']['input']>;
  /** The minimum severity to act on. */
  minSeverity?: InputMaybe<Scalars['Int']['input']>;
  /** The mode IDS IPS should act in. */
  mode?: InputMaybe<IdsipsMode>;
  /** List of subnets that should never be blocked. */
  safelist?: InputMaybe<Array<Scalars['IPPrefix']['input']>>;
  /** If set, replaces the list of category suppressions. */
  suppressedCategories?: InputMaybe<Array<IdsipsConfigCategorySuppressionInput>>;
  /** If set, replaces the list of rule suppressions. */
  suppressedRules?: InputMaybe<Array<IdsipsConfigRuleSuppressionInput>>;
};

/** A custom intrusion rule definition for IDS/IPS. These currently apply tls.sni rules. */
export type UpdateIdsipsCustomRuleInput = {
  /** The action this rule applies. */
  action?: InputMaybe<FirewallRuleAction>;
  /** The ID of the Netstar application to associate with the rule. */
  applicationID?: InputMaybe<Scalars['Int']['input']>;
  /** List of UUIDs of VLAN rules to which rule is bound. */
  boundVLANUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** The FQDN this rule applies to. */
  domain?: InputMaybe<Scalars['String']['input']>;
  /** If this rule is enabled. */
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** A name to identify this rule. */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Input for updating IP forwarding rule. */
export type UpdateIpForwardingRuleInput = {
  /** If rule is enabled. */
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Name of this rule. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The uplink interface associated with the rule. */
  uplinkPhyInterfaceUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** The UUID of VLAN associated with this rule. */
  vlanUUID?: InputMaybe<Scalars['UUID']['input']>;
};

/** Input type for updating an existing IPSec tunnel. */
export type UpdateIpSecTunnelInput = {
  /** The authentication algorithm to use for the IPSec connection. */
  authenticationAlgorithm?: InputMaybe<IpSecAuthenticationAlgorithm>;
  /** Sets the DPD action for the tunnel. */
  dpdAction?: InputMaybe<IpSecDpdAction>;
  /** Sets the DPD delay for the tunnel. */
  dpdDelay?: InputMaybe<Scalars['Duration']['input']>;
  /** Sets the DPD timeout for the tunnel. */
  dpdTimeout?: InputMaybe<Scalars['Duration']['input']>;
  /** The encryption algorithm to use for the IPSec connection. */
  encryptionAlgorithm?: InputMaybe<IpSecEncryptionAlgorithm>;
  /** Sets the ikelifetime for the tunnel. */
  ikeLifetime?: InputMaybe<Scalars['Duration']['input']>;
  /**
   * If true, adds Client VPN subnets to the local traffic selectors,
   * effectively allowing Client VPN clients to route traffic over the IPSec tunnel.
   */
  isClientVPNBound?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates whether the IPSec tunnel should be enabled. */
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates whether this tunnel should initiate the connection to the right participant. */
  isInitiator?: InputMaybe<Scalars['Boolean']['input']>;
  /** The Diffie-Hellman group to use for key exchange in the IPSec connection. */
  keyExchangeDHGroup?: InputMaybe<IpSecDhGroup>;
  /** Identifier for the left participant (this side) for authentication purposes. Must be a FQDN or IPv4 address. */
  leftID?: InputMaybe<Scalars['String']['input']>;
  /** The name of the IPSec tunnel. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Allows for vendor specific configuration based on this peer type */
  peerType?: InputMaybe<IpSecPeerType>;
  /** UUID of the physical interface to bind the IPSec tunnel to; must be an uplink interface. */
  phyInterfaceUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** The pre-shared key for authentication; can be base64 encoded or plaintext. */
  presharedKey?: InputMaybe<Scalars['String']['input']>;
  /** Sets the reauth for the tunnel, true = yes, false = no */
  reauth?: InputMaybe<Scalars['Boolean']['input']>;
  /** Sets the rekey for the tunnel, true = yes, false = no */
  rekey?: InputMaybe<Scalars['Boolean']['input']>;
  /** The public IP address or hostname of the right participant's gateway. */
  right?: InputMaybe<Scalars['String']['input']>;
  /** Identifier for the right participant (remote side) for authentication purposes. Must be a FQDN or IPv4 address. */
  rightID?: InputMaybe<Scalars['String']['input']>;
  /** List of IP prefixes representing the private subnets behind the right participant. */
  rightPrefixes?: InputMaybe<Array<Scalars['IPPrefix']['input']>>;
  /** List of VLAN UUIDs to bind the IPSec tunnel to. */
  vlanUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

export type UpdateInternalNoteInput = {
  /** Indicates whether the note is marked as important. */
  isImportant?: InputMaybe<Scalars['Boolean']['input']>;
  /** Updated content of the internal note. */
  note?: InputMaybe<Scalars['String']['input']>;
  /** Use the `createPreSignedUploadUrl` mutation to generate S3 keys and presigned URLs for the photos, and specify them here. */
  photoS3Keys?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Input type for updating an existing Internet Service Plan. */
export type UpdateInternetServicePlanInput = {
  /** Connection details to update, including product and status. */
  connection?: InputMaybe<InternetServicePlanConnectionInput>;
  /** IP configuration details to update. */
  ipConfiguration?: InputMaybe<InternetServicePlanIpInput>;
  /** Unique identifier of the ISP provider to update. */
  providerUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** Unique identifier of the sublocation to associate with the Internet Service Plan. */
  sublocationUUID?: InputMaybe<Scalars['UUID']['input']>;
};

/** Input type for updating an existing Internet Service Plan Provider. */
export type UpdateInternetServicePlanProviderInput = {
  /** Alternative names for Internet Service Provider used in 3rd party APIs.  Replaces all existing. */
  aliases?: InputMaybe<Array<Scalars['String']['input']>>;
  /** AWS S3 key of the square icon image. */
  iconS3Key?: InputMaybe<Scalars['String']['input']>;
  /** AWS S3 key of the landscape logo image. */
  logoS3Key?: InputMaybe<Scalars['String']['input']>;
  /** Name of the provider. */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Input type for updating a Internet Service Plan Provider Static Rate. */
export type UpdateInternetServicePlanProviderStaticRateInput = {
  /** UUID of Product type for the rate. */
  connectionTypeUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** Download speed Kbps. */
  downloadKbps?: InputMaybe<Scalars['Int']['input']>;
  /** Enabled status of the rate. */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Install cost in cents. */
  installCostCents?: InputMaybe<Scalars['Int']['input']>;
  /** Describes dependency of the static rate on a location. */
  locationMode?: InputMaybe<InternetServicePlanProviderStaticRateLocationMode>;
  /** Monthly recurring cost in cents. */
  monthlyCostCents?: InputMaybe<Scalars['Int']['input']>;
  /** Term of contract in months. */
  termMonths?: InputMaybe<Scalars['Int']['input']>;
  /** Upload speed Kbps. */
  uploadKbps?: InputMaybe<Scalars['Int']['input']>;
};

/** Input type for updating a mailing address. */
export type UpdateMailingAddressInput = {
  /** The city of the mailing address. */
  city?: InputMaybe<Scalars['String']['input']>;
  /** The two-letter ISO code of the country. */
  countryISO2?: InputMaybe<Scalars['String']['input']>;
  /** The first line of the mailing address. */
  line1?: InputMaybe<Scalars['String']['input']>;
  /** The second line of the mailing address. */
  line2?: InputMaybe<Scalars['String']['input']>;
  /** The postal code or ZIP code of the mailing address. */
  postalCode?: InputMaybe<Scalars['String']['input']>;
  /** The subdivision code, such as the state or province code. */
  subdivisionCode?: InputMaybe<Scalars['String']['input']>;
};

/** Input object for updating a maintenance window. */
export type UpdateMaintenanceWindowInput = {
  /** The ending day of the week for the maintenance window, in local time (0-6, where 0 is Sunday). */
  endDayOfWeekLocal?: InputMaybe<Scalars['Int']['input']>;
  /** The ending hour of the maintenance window, in local time (0-23). */
  endHourOfDayLocal?: InputMaybe<Scalars['Int']['input']>;
  /** For DAILY recurrence windows only. Specifies days of the week (0-6, where 0 is Sunday) to exclude from the maintenance window. */
  excludedDaysOfWeek?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Indicates whether the maintenance window is opted out (true) or not (false). */
  isOptedOut?: InputMaybe<Scalars['Boolean']['input']>;
  /** The recurrence pattern of the maintenance window (daily or weekly). */
  recurrence?: InputMaybe<MaintenanceWindowRecurrence>;
  /** The starting day of the week for the maintenance window, in local time (0-6, where 0 is Sunday). */
  startDayOfWeekLocal?: InputMaybe<Scalars['Int']['input']>;
  /** The starting hour of the maintenance window, in local time (0-23). */
  startHourOfDayLocal?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateMarketingChangelogEntryInput = {
  /** Properties to display inside a badge alongside the changelog entry. */
  badge?: InputMaybe<DisplayBadgeInput>;
  /** Descriptive copy text for the marketing changelog entry. */
  copy?: InputMaybe<Scalars['String']['input']>;
  /** Informational heading text for the marketing changelog entry. */
  heading?: InputMaybe<Scalars['String']['input']>;
  /** A pair of theme-dependent images to display alongside the changelog entry. */
  imageS3Keys?: InputMaybe<ThemedImageS3KeysInput>;
  /** A destination to link to that contains more information about the changelog entry. */
  linkURL?: InputMaybe<Scalars['String']['input']>;
  /** When the entry stops being visible to customers. */
  visibleEndAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** When the entry starts being visible to customers. */
  visibleStartAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateNosUpgradeGroupInput = {
  /** A human-friendly description of the group. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** A human-friendly label for the group. */
  name?: InputMaybe<Scalars['String']['input']>;
  /**
   * The priority of the NOS upgrade group; lower values are higher priority. Groups of devices will be upgraded in order of priority.
   *
   * If set, for an update of a single NOS upgrade group, the group will be inserted at the given priority, bumping all equal or lesser groups to an inferior priority. Different from the create input - if not set, no changes will be made to the priority.
   *
   * When specifying this value for a bulk-update of many groups, the auto-ordering logic above is not applied. If the priority provided collides with another group's priority (or to-be-updated priority), then an error is returned.
   */
  priority?: InputMaybe<Scalars['Int']['input']>;
  /** How long to wait for all devices in the group to upgrade before timing out, in seconds. */
  timeoutDurationSeconds?: InputMaybe<Scalars['Int']['input']>;
  /** If specified, the given virtual devices will be moved to this group. If a device already exists in this group and is not specified in this list, it will remain in the group. */
  virtualDeviceUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

export type UpdateNosUpgradeGroupsInput = {
  /** The input parameters for updating the NOS upgrade group. */
  input: UpdateNosUpgradeGroupInput;
  /** The UUID of the NOS upgrade group to update. */
  nosUpgradeGroupUUID: Scalars['UUID']['input'];
};

/** Input type for updating a network. */
export type UpdateNetworkInput = {
  /** If false, wifi steering will be fully disabled even if supported by NOS. */
  IsWifiSteeringEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** A list of service types to enable for service discovery. */
  enabledServiceDiscoveryTypes?: InputMaybe<Array<ServiceType>>;
  /** Indicates whether the network is currently active. */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enables controller to upgrade config-1 APs deployed to the network. */
  isConfig1WosUpgradesEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Indicates whether the network is a template for creating new networks.
   * @deprecated We no longer support changes to a network's template status.
   */
  isTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Deprecated: Not a network property anymore.
   * @deprecated Not a network property anymore
   */
  isTest?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Indicates whether the network is sensitive to firmware updates.
   * @deprecated Not a network property anymore
   */
  isUpgradeSensitive?: InputMaybe<Scalars['Boolean']['input']>;
  /** A label to quickly identify the network. */
  label?: InputMaybe<Scalars['String']['input']>;
  /** The mailing address details to update. */
  mailingAddressInput?: InputMaybe<CreateMailingAddressInput>;
  /** The UUID of the mailing address associated with the network. */
  mailingAddressUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** If provided, will update the maintenance window associated with the network accordingly. */
  maintenanceWindow?: InputMaybe<UpdateMaintenanceWindowInput>;
  /**
   * The algorithm used for multi-WAN load balancing.
   * @deprecated `SecurityApplianceProfile.multiWANAlgorithm` is now used instead.
   */
  multiWANAlgorithm?: InputMaybe<MultiWanAlgorithm>;
  /** The NOS upgrade channel for the network. */
  nosUpgradeChannel?: InputMaybe<NetworkNosUpgradeChannel>;
  /** The URL of the patch panel diagram for the network. */
  patchPanelDiagramURL?: InputMaybe<Scalars['String']['input']>;
  /** A human-readable identifier for the network. */
  slug?: InputMaybe<Scalars['String']['input']>;
  /**
   * Deprecated: Not a network property anymore.
   * @deprecated Not a network property anymore.
   */
  squareFeet?: InputMaybe<Scalars['Int']['input']>;
  /** The S3 key for the network topology image. */
  topologyImageS3Key?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateNetworkThreatAllowlistEntryInput = {
  /** A bssid to allow for honeypot AP detection. */
  BSSID?: InputMaybe<Scalars['String']['input']>;
  /** An explanation of the allowlisted device or the SSID to allow. */
  reason?: InputMaybe<Scalars['String']['input']>;
  /** An SSID to allow if a threat is broadcasting it. */
  ssidUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** A mac address to allow for rogue AP detection. */
  wiredMAC?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateNosFeatureInput = {
  /** A detailed description of the NOS feature. */
  description: Scalars['String']['input'];
  /** If the feature is also behind a feature flag, this is the name of the feature flag. */
  featureFlag?: InputMaybe<Scalars['String']['input']>;
  /** The maximum major version of NOS firmware that supports this feature. If null, there is no upper major version limit. */
  maxMajorVersion?: InputMaybe<Scalars['Int']['input']>;
  /** The maximum minor version of NOS firmware that supports this feature. If null, there is no upper minor version limit. */
  maxMinorVersion?: InputMaybe<Scalars['Int']['input']>;
  /** The maximum patch version of NOS firmware that supports this feature. If null, there is no upper patch version limit. */
  maxPatchVersion?: InputMaybe<Scalars['Int']['input']>;
  /** The minimum major version of NOS firmware required to support this feature. */
  minMajorVersion: Scalars['Int']['input'];
  /** The minimum minor version of NOS firmware required to support this feature. */
  minMinorVersion: Scalars['Int']['input'];
  /** The minimum patch version of NOS firmware required to support this feature. */
  minPatchVersion: Scalars['Int']['input'];
  /** The display name of the NOS feature. */
  name: Scalars['String']['input'];
};

/** Input type for updating an existing notification setting. */
export type UpdateNotificationSettingInput = {
  /** The UUID of the alert receiver who will receive the notifications. */
  alertReceiverUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** A list of arguments providing specific parameters or context required by the notification definition. */
  arguments?: InputMaybe<Array<NotificationSettingArgumentInput>>;
  /** Indicates whether the notification setting is enabled. */
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** ID of the user who updated the notification setting. */
  updatedBy?: InputMaybe<Scalars['Int']['input']>;
};

/** Input type for creating notification snooze. */
export type UpdateNotificationSnoozeInput = {
  /** The reason for the snooze. */
  snoozeReason?: InputMaybe<Scalars['String']['input']>;
  /** The time window for the snooze. */
  window?: InputMaybe<SnoozeNotificationSettingWindowInput>;
};

export type UpdateOneToOneNatRuleInput = {
  /** New description for the 1:1 NAT rule. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** New external IP address for the NAT rule. */
  externalIPAddr?: InputMaybe<Scalars['IPV4']['input']>;
  /** UUID of the new physical interface associated with the external IP address. */
  externalPhyInterfaceUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** New internal IP address for the NAT rule. */
  internalIPAddr?: InputMaybe<Scalars['IPV4']['input']>;
  /** Toggle to enable or disable the NAT rule. */
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** New name for the 1:1 NAT rule. */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Input type for updating an outlet interface. */
export type UpdateOutletInterfaceInput = {
  /** UUID of the virtual device to connect to the power outlet. */
  connectedVirtualDeviceUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** Description of the outlet interface. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Whether or not the outlet interface is enabled. */
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** User-defined label for the outlet interface. */
  label?: InputMaybe<Scalars['String']['input']>;
  /**
   * Number of seconds to wait when performing a power cycle.
   * The outlet turns off, waits for this duration, and then turns back on.
   */
  powerCycleDelaySec?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateOutletInterfacesIndependentlyInput = {
  /** UUID of the outlet interface to update. */
  UUID: Scalars['UUID']['input'];
  /** Fields to update on the outlet interface. */
  input: UpdateOutletInterfaceInput;
};

export type UpdatePhyInterface8021XSettingsInput = {
  /** Specifies how many clients can authenticate on the port. */
  hostMode?: InputMaybe<PhyInterface8021XHostMode>;
  /** If enabled, the switch will dynamiclaly assign VLANs to the port based on the RADIUS server response. */
  isAssignVLANsFromRADIUSEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** If enabled, unauthenticated clients will be assigned to the guest VLAN specified in the switch profile (`RADIUSGuestVLAN`). If disabled, unauthenticated clients are blocked. */
  isGuestVLANEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** The MAC authentication bypass mode for the port to accept MAC-based auth. The switch will use the MAC address of the client to authenticate with the RADIUS server, often used for printer ports. */
  macAuthenticationBypassMode?: InputMaybe<PhyInterface8021XmacAuthenticationBypassMode>;
  /** Specifies the variant of 802.1X authentication to use. */
  portMode?: InputMaybe<PhyInterface8021XPortMode>;
  /** The duration that the port will wait after a client fails authentication; after this period it will allow re-attempt. */
  quietPeriodSeconds?: InputMaybe<Scalars['Int']['input']>;
  /** If set, authorized clients are forced to re-authenticate after this period. If not set, clients are not forced to re-authenticate. */
  reauthenticationPeriodSeconds?: InputMaybe<Scalars['Int']['input']>;
  /** When a client is connected to a port, the switch sends out an EAP auth request to the client; the request times out and retransmits according to this value. */
  supplicantPeriodSeconds?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdatePhyInterfaceForMultiWanEventInput = {
  /** The port number of the active uplink interface following a Multi-WAN event. */
  activePortNumber: Scalars['Int']['input'];
  /** The timestamp when the active port number was updated due to the Multi-WAN event. */
  activePortNumberUpdatedAt: Scalars['DateTime']['input'];
  /** The external IP addresses assigned to the uplink interface after the Multi-WAN event. */
  uplinkExternalAddresses: Array<Scalars['UnmaskedIPPrefix']['input']>;
};

export type UpdatePhyInterfaceInput = {
  /** The maximum transmission unit (MTU) - max size in bytes for frames on the port. */
  MTU?: InputMaybe<Scalars['Int']['input']>;
  /** The UUIDs of the allowed (tagged) VLANs permitted on this interface. */
  allowedVLANUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** A description of the physical interface. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** If 802.1X authentication is enabled, this field contains the settings to configure 802.1X authentication. */
  encryption8021XSettings?: InputMaybe<UpdatePhyInterface8021XSettingsInput>;
  /** The maximum amount of data that can be transmitted through the interface, in Mbps. */
  forcedPortSpeedMbps?: InputMaybe<Scalars['Int']['input']>;
  /** An optional filter to only accept certain frame types on this port. */
  frameAcceptTypeFilter?: InputMaybe<PhyInterfaceFrameAcceptTypeFilter>;
  /** IPv4 addresses to assign to the interface without netmasks when assigning as a client. */
  ipv4ClientAddresses?: InputMaybe<Array<Scalars['IPV4']['input']>>;
  /** Protocol to use for IPv4 addresses when assigning this interface as a client. */
  ipv4ClientAssignmentProtocol?: InputMaybe<ClientAssignmentProtocol>;
  /** Gateway IPv4 address without netmask when assigning as a client. */
  ipv4ClientGateway?: InputMaybe<Scalars['IPV4']['input']>;
  /** Subnet prefix length for the IPv4 addresses when assigning as a client. */
  ipv4ClientPrefixLength?: InputMaybe<Scalars['Int']['input']>;
  /** IPv6 addresses to assign to the interface without netmasks when assigning as a client. */
  ipv6ClientAddresses?: InputMaybe<Array<Scalars['IPV6']['input']>>;
  /** Protocol to use for IPv6 addresses when assigning this interface as a client. */
  ipv6ClientAssignmentProtocol?: InputMaybe<ClientAssignmentProtocol>;
  /** Gateway IPv6 address without netmask when assigning as a client. */
  ipv6ClientGateway?: InputMaybe<Scalars['IPV6']['input']>;
  /** Subnet prefix length for the IPv6 addresses when assigning as a client. */
  ipv6ClientPrefixLength?: InputMaybe<Scalars['Int']['input']>;
  /** Whether or not the interface is implicitly bound to all VLANs. */
  isBoundToAllVLANs?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether or not the interface is enabled. */
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, flap link intervention protocol is enabled on the port. Both this flag and isFLIPEnabled in SwitchProfile must be true for FLIP to be enabled on a port. */
  isFLIPEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, Fast Leave is enabled on this interface. When enabled, the port is removed from the multicast group as soon as the switch sees an IGMP/MLD leave message from the client on the port. */
  isFastLeaveEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** This represents whether flow control is enabled. This feature is enabled by default. */
  isFlowControlEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, tagged frames are discarded when the VLAN ID does not match. */
  isIngressFilteringEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, other ports are prevented from communicating with this port. */
  isIsolationEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether or not the interface is enabled to deliver Power over Ethernet. */
  isPOEEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, configures the interface as an STP edge port. */
  isSTPEdgePortEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether or not the interface is enabled to participate in Spanning Tree Protocol. */
  isSTPEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** This should only be used with trunk ports. If enabled, the port cannot become STP root. It helps prevent a customer or rogue switch from sending a low bridge priority and becoming root. If a switch has root guard enabled and it receives a low bpdu (that would normally make it a root port), then the switch ill disable that port */
  isSTPRootGuardEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, this phy interface is configured as a sink. */
  isSink?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether or not storm control is enabled on the port. */
  isStormControlEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the port is a trunk port that carries multiple VLANs. */
  isTrunkPort?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates if the interface is an uplink to other networks or devices. */
  isUplink?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, voice VLAN is enabled for this port. Both this flag and isVoiceVLANEnabled in SwitchProfile must be true for voice VLAN to be enabled on a port. */
  isVoiceVLANEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** A custom label for the physical interface. */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Maximum number of MAC addresses allowed on the port for security. */
  maxMACAddressesAllowed?: InputMaybe<Scalars['Int']['input']>;
  /** The UUID of the native (untagged) VLAN assigned to this interface. */
  nativeVLANUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** Receive rate limit for the port, in Kbps. */
  rxRateLimitKbps?: InputMaybe<Scalars['Int']['input']>;
  /** Percent of broadcast traffic to drop if storm control is enabled. */
  stormControlBroadcastTrafficPercent?: InputMaybe<Scalars['Int']['input']>;
  /** Percent of unknown multicast traffic to drop if storm control is enabled. */
  stormControlUnknownMulticastTrafficPercent?: InputMaybe<Scalars['Int']['input']>;
  /** Percent of unknown unicast traffic to drop if storm control is enabled. */
  stormControlUnknownUnicastTrafficPercent?: InputMaybe<Scalars['Int']['input']>;
  /** STP Path cost for the port (1-200000000). */
  stpPathCost?: InputMaybe<Scalars['Int']['input']>;
  /** STP Priority for the port (0-240 in multiples of 16, default 128). */
  stpPriority?: InputMaybe<Scalars['Int']['input']>;
  /** Transmit rate limit for the port, in Kbps. */
  txRateLimitKbps?: InputMaybe<Scalars['Int']['input']>;
  /** Priority order for using the uplink; lower values take precedence (if `isUplink` is true). */
  uplinkPriority?: InputMaybe<Scalars['Int']['input']>;
  /** VLAN ID used for the uplink (if `isUplink` is true). */
  uplinkVLANID?: InputMaybe<Scalars['Int']['input']>;
};

/** Update multiple phy interfaces simultaneously and atomically, each with independent parameters. Only a subset of parameters are supported. */
export type UpdatePhyInterfacesIndependentlyInput = {
  /** The UUID of the physical interface to update. */
  UUID: Scalars['UUID']['input'];
  /** The description of the physical interface. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The label of the physical interface. */
  label?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePolicyRoutingRuleInput = {
  /** The list of bindings to update for this policy routing rule (optional). */
  bindings?: InputMaybe<Array<PolicyRoutingRuleBindingInput>>;
  /** A description for the policy routing rule (optional). */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The list of destination port ranges to update for the traffic matching this rule (optional). */
  dstPortRanges?: InputMaybe<Array<PortRangeInput>>;
  /** The destination IP prefix to update for the traffic matching this rule (optional). */
  dstPrefix?: InputMaybe<Scalars['IPPrefix']['input']>;
  /** Indicates whether the policy routing rule is enabled (optional). */
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** The new name of the policy routing rule (optional). */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The list of IP protocols to update for the traffic matching this rule (optional). */
  protocols?: InputMaybe<Array<IpProtocol>>;
  /** The list of source port ranges to update for the traffic matching this rule (optional). */
  srcPortRanges?: InputMaybe<Array<PortRangeInput>>;
  /** The source IP prefix to update for the traffic matching this rule (optional). */
  srcPrefix?: InputMaybe<Scalars['IPPrefix']['input']>;
  /** The UUID of the source VLAN to update for the traffic matching this rule (optional). */
  srcVLANUUID?: InputMaybe<Scalars['UUID']['input']>;
};

export type UpdatePortForwardingRuleInput = {
  /** Restricts the port forwarding rule to only allow traffic to be forwarded if it originates from any of these IP addresses. */
  allowedRemoteIPAddresses?: InputMaybe<Array<Scalars['IP']['input']>>;
  /** Description of the port forwarding rule. */
  description?: InputMaybe<Scalars['String']['input']>;
  /**
   * The external IP address to which this rule applies.
   * One of `externalPhyInterfaceUUID` or `externalIPAddress` must be provided.
   */
  externalIPAddress?: InputMaybe<Scalars['IP']['input']>;
  /**
   * UUID of the external uplink physical interface.
   * One of `externalPhyInterfaceUUID` or `externalIPAddress` must be provided.
   */
  externalPhyInterfaceUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** The external port from which incoming traffic is forwarded. */
  externalPort?: InputMaybe<Scalars['Int']['input']>;
  /** Indicates whether the port forwarding rule is enabled. */
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** The local IP address to which incoming traffic is forwarded. */
  localIPAddress?: InputMaybe<Scalars['IP']['input']>;
  /** The local port to which the external port forwards traffic. */
  localPort?: InputMaybe<Scalars['Int']['input']>;
  /** Name of the port forwarding rule. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The IP protocol to apply this rule on. */
  protocol?: InputMaybe<PortIpProtocol>;
};

/** Input type for updating a device in a rack elevation. */
export type UpdateRackElevationDeviceInput = {
  /** Whether the device is front-facing or rear-facing. */
  isFrontFacing?: InputMaybe<Scalars['Boolean']['input']>;
  /** A friendly name for display purposes. */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Additional context or comments about the device. */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** The number of ports on the device. Only for switches and patch panels; cannot be specified if it's a Meter device. */
  portCount?: InputMaybe<Scalars['Int']['input']>;
  /** The indexes of the rack units that the device occupies. */
  rackMountUnitIndexes?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** The index of the rack mount unit that the device is side by side with. 0-indexed; lower number is to the left when viewing the rack from the front. For simplicity this must be 0 or 1 (at-most 2 devices per rack mount unit). */
  sideBySideIndex?: InputMaybe<Scalars['Int']['input']>;
  /** The type of the device. Cannot be specified if it's a Meter device. */
  type?: InputMaybe<RackElevationDeviceType>;
  /** If it's a Meter device, the virtual device's UUID. */
  virtualDeviceUUID?: InputMaybe<Scalars['UUID']['input']>;
};

/** Input type for updating an existing rack elevation. */
export type UpdateRackElevationInput = {
  /** The left-to-right position of the rack relative to others. */
  horizontalIndex?: InputMaybe<Scalars['Int']['input']>;
  /** Human-readable name for the rack elevation. */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Notes associated with the rack elevation. */
  notes?: InputMaybe<Array<RackElevationNoteInput>>;
  /** The number of rack units (like slots) for the rack elevation. */
  rackMountUnitCount?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateRadioProfileInput = {
  /**
   * Required if band2_4GAutoChannelIsEnabled is true.
   * The list of allowed channels for auto channel selection on the 2.4 GHz band.
   */
  band2_4GAllowedChannels?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Indicates whether auto channel selection is enabled for the 2.4 GHz band. */
  band2_4GAutoChannelIsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates whether auto channel width selection is enabled for the 2.4 GHz band. */
  band2_4GAutoChannelWidthIsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates whether automatic transmit power adjustment is enabled for the 2.4 GHz band. */
  band2_4GAutoTxPowerIsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Required if band2_4GAutoTxPowerIsEnabled is true.
   * The maximum transmit power in dBm for the 2.4 GHz band when auto transmit power is enabled.
   */
  band2_4GAutoTxPowerMaxdBm?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Required if band2_4GAutoTxPowerIsEnabled is true.
   * The minimum transmit power in dBm for the 2.4 GHz band when auto transmit power is enabled.
   */
  band2_4GAutoTxPowerMindBm?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Required if band2_4GAutoChannelWidthIsEnabled is false.
   * The channel width in MHz for the 2.4 GHz band when auto channel width is disabled.
   */
  band2_4GChannelWidthMHz?: InputMaybe<Scalars['Int']['input']>;
  /** Indicates whether the 2.4 GHz band is enabled. */
  band2_4GIsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Required if band5GAutoChannelIsEnabled is true.
   * The list of allowed channels for auto channel selection on the 5 GHz band.
   */
  band5GAllowedChannels?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Indicates whether auto channel selection is enabled for the 5 GHz band. */
  band5GAutoChannelIsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates whether auto channel width selection is enabled for the 5 GHz band. */
  band5GAutoChannelWidthIsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates whether automatic transmit power adjustment is enabled for the 5 GHz band. */
  band5GAutoTxPowerIsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Required if band5GAutoTxPowerIsEnabled is true.
   * The maximum transmit power in dBm for the 5 GHz band when auto transmit power is enabled.
   */
  band5GAutoTxPowerMaxdBm?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Required if band5GAutoTxPowerIsEnabled is true.
   * The minimum transmit power in dBm for the 5 GHz band when auto transmit power is enabled.
   */
  band5GAutoTxPowerMindBm?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Required if band5GAutoChannelWidthIsEnabled is false.
   * The channel width in MHz for the 5 GHz band when auto channel width is disabled.
   */
  band5GChannelWidthMHz?: InputMaybe<Scalars['Int']['input']>;
  /** Indicates whether the 5 GHz band is enabled. */
  band5GIsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Required if band6GAutoChannelIsEnabled is true.
   * The list of allowed channels for auto channel selection on the 6 GHz band.
   */
  band6GAllowedChannels?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Indicates whether auto channel selection is enabled for the 6 GHz band. */
  band6GAutoChannelIsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates whether auto channel width selection is enabled for the 6 GHz band. */
  band6GAutoChannelWidthIsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates whether automatic transmit power adjustment is enabled for the 6 GHz band. */
  band6GAutoTxPowerIsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Required if band6GAutoTxPowerIsEnabled is true.
   * The maximum transmit power in dBm for the 6 GHz band when auto transmit power is enabled.
   */
  band6GAutoTxPowerMaxdBm?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Required if band6GAutoTxPowerIsEnabled is true.
   * The minimum transmit power in dBm for the 6 GHz band when auto transmit power is enabled.
   */
  band6GAutoTxPowerMindBm?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Required if band6GAutoChannelWidthIsEnabled is false.
   * The channel width in MHz for the 6 GHz band when auto channel width is disabled.
   */
  band6GChannelWidthMHz?: InputMaybe<Scalars['Int']['input']>;
  /** Indicates whether the 6 GHz band is enabled. */
  band6GIsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** A human-readable description. */
  description?: InputMaybe<Scalars['String']['input']>;
  /**
   * Setting this to true will set all other profiles to false.
   * Indicates whether this profile should be set as the default for the network.
   */
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  /** The new name for the radio profile. */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Specifies the metadata that can be updated for radio settings for an Access Point. */
export type UpdateRadioSettingsInput = {
  /** The primary channel for the 2.4 GHz radio band. */
  band2_4GPrimaryChannel?: InputMaybe<Scalars['Int']['input']>;
  /** The transmit power in dBm for the 2.4 GHz radio band. */
  band2_4GTransmitPowerdBm?: InputMaybe<Scalars['Int']['input']>;
  /** The primary channel for the 5 GHz radio band. */
  band5GPrimaryChannel?: InputMaybe<Scalars['Int']['input']>;
  /** The secondary channel for the 5 GHz radio band, if applicable. */
  band5GSecondaryChannel?: InputMaybe<Scalars['Int']['input']>;
  /** The transmit power in dBm for the 5 GHz radio band. */
  band5GTransmitPowerdBm?: InputMaybe<Scalars['Int']['input']>;
  /** The primary channel for the 6 GHz radio band. */
  band6GPrimaryChannel?: InputMaybe<Scalars['Int']['input']>;
  /** The transmit power in dBm for the 6 GHz radio band. */
  band6GTransmitPowerdBm?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateRateLimitRuleInput = {
  /** A list of UUIDs of physical interfaces to which this rate limit rule is bound. */
  boundPhyInterfaceUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** A list of UUIDs of SSIDs to which this rate limit rule is bound. */
  boundSSIDUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** A list of UUIDs of VLANs to which this rate limit rule is bound. */
  boundVLANUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** A description of the rate limit rule. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Destination MAC address to match. */
  dstMac?: InputMaybe<Scalars['MacAddress']['input']>;
  /** Destination port range to match. */
  dstPortRange?: InputMaybe<PortRangeInput>;
  /** Destination IP address prefix to match. */
  dstPrefix?: InputMaybe<Scalars['IPPrefix']['input']>;
  /** Indicates whether the rate limit rule is enabled. */
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Specifies if the rate limit is applied per source IP/MAC address. */
  isPerSource?: InputMaybe<Scalars['Boolean']['input']>;
  /** The name of the rate limit rule. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The order in which the rate limit rules are applied, lower priorities first. */
  priority?: InputMaybe<Scalars['Int']['input']>;
  /** IANA protocol number to match (e.g., 1 = ICMP, 6 = TCP, 17 = UDP). A value of 256 denotes all protocols. */
  protocol?: InputMaybe<IpProtocol>;
  /** Maximum download rate limit in kilobits per second. */
  rateLimitKbpsDownload?: InputMaybe<Scalars['Int']['input']>;
  /** Maximum upload rate limit in kilobits per second. */
  rateLimitKbpsUpload?: InputMaybe<Scalars['Int']['input']>;
  /** Source MAC address to match. */
  srcMac?: InputMaybe<Scalars['MacAddress']['input']>;
  /** Source port range to match. */
  srcPortRange?: InputMaybe<PortRangeInput>;
  /** Source IP address prefix to match. */
  srcPrefix?: InputMaybe<Scalars['IPPrefix']['input']>;
};

export type UpdateRateLimitRulesInput = {
  /** The UUID of the rate limit rule to update. */
  UUID: Scalars['UUID']['input'];
  /** The updates to apply to the rate limit rule. */
  input: UpdateRateLimitRuleInput;
};

export type UpdateSsidInput = {
  /** The lowest rate at which a client can connect to the 2.4 GHz radio, in kilobits per second. */
  band2GMinimumBasicRateKbps?: InputMaybe<Scalars['Int']['input']>;
  /** The lowest rate at which a client can connect to the 5 GHz radio, in kilobits per second. */
  band5GMinimumBasicRateKbps?: InputMaybe<Scalars['Int']['input']>;
  /** The lowest rate at which a client can connect to the 6 GHz radio, in kilobits per second. */
  band6GMinimumBasicRateKbps?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies the schedule intervals during which the SSID will be broadcasted. */
  broadcastSchedule?: InputMaybe<Array<SsidBroadcastScheduleIntervalInput>>;
  /** A list of allowed client MACs, if isClientAllowlistEnabled is true. */
  clientAllowlist?: InputMaybe<Array<Scalars['MacAddress']['input']>>;
  /** Enable or disable client steering for association. */
  clientSteeringAssociationSteeringIsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** The minimum number of clients on an SSID before client steering is attempted. */
  clientSteeringLoadBalancingClientMinThreshold?: InputMaybe<Scalars['Int']['input']>;
  /** Enable or disable post-association client steering. */
  clientSteeringPostassociationSteeringIsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** The minimum RSSI signal strength (in dBm) before pre-association client steering is attempted. */
  clientSteeringPreassociationRSSIMinThreshold?: InputMaybe<Scalars['Int']['input']>;
  /** Description of the SSID. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** List of access point virtual device UUIDs on which the SSID is disabled. */
  disabledAccessPointVirtualDeviceUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** The DTIM period for the SSID. */
  dtimPeriod?: InputMaybe<Scalars['Int']['input']>;
  /** Dynamic VLAN mode setting. */
  dynamicVLANMode?: InputMaybe<SsidDynamicVlanMode>;
  /**
   * Required if isEnabledForAllAccessPoints is false.
   * List of access point virtual device UUIDs on which the SSID is enabled.
   */
  enabledAccessPointVirtualDeviceUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** 802.11w Protected Management Frames mode. */
  encryption80211wProtectedManagementFramesMode?: InputMaybe<SsidEncryption80211wProtectedManagementFramesMode>;
  /** Encryption protocol used by the SSID. */
  encryptionProtocol?: InputMaybe<SsidEncryptionProtocol>;
  /** An optional value for the Hotspot 2.0 Access network type. */
  hs20AccessNetworkType?: InputMaybe<Scalars['Int']['input']>;
  /** When set to true, clears all Hotspot 2.0 data. */
  hs20ClearAll?: InputMaybe<Scalars['Boolean']['input']>;
  /** A list of Hotspot 2.0 domain names. */
  hs20DomainNames?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Enable or disable Hotspot 2.0 (Passpoint). */
  hs20Enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** A list of MCC/MNC pairs, formatted as "MCC,MNC". */
  hs20MccMncPairs?: InputMaybe<Array<Scalars['String']['input']>>;
  /** A list of Hotspot 2.0 NAI realms. */
  hs20NaiRealms?: InputMaybe<Array<Scalars['String']['input']>>;
  /** A list of Operator names for Hotspot 2.0 (one per language). */
  hs20OperatorNames?: InputMaybe<Array<Scalars['String']['input']>>;
  /** A list of Hotspot 2.0 Consortium OIs (Organization Identifiers). */
  hs20RoamingConsortiumOIs?: InputMaybe<Array<Scalars['String']['input']>>;
  /** An optional value for the Hotspot 2.0 Venue group. */
  hs20VenueGroup?: InputMaybe<Scalars['Int']['input']>;
  /**
   * A list of Venue names for Hotspot 2.0 (one per language); must be formatted with a two or three character language code separated by a colon from the venue name.
   * If at least one is set, hs20VenueGroup and hs20VenueType must be set.
   */
  hs20VenueNames?: InputMaybe<Array<Scalars['String']['input']>>;
  /** An optional value for the Hotspot 2.0 Venue type. */
  hs20VenueType?: InputMaybe<Scalars['Int']['input']>;
  /** Enable or disable 802.11ax (Wi-Fi 6) for the SSID. */
  is80211axEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enable or disable AP debug logging for APs broadcasting the SSID. */
  isAPDebugLogEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enable or disable broadcasting the SSID on the 2.4 GHz band. */
  isBand2GAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enable or disable broadcasting the SSID on the 5 GHz band. */
  isBand5GAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enable or disable broadcasting the SSID on the 6 GHz band. */
  isBand6GAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, only clients in the client allowlist will be allowed. */
  isClientAllowlistEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enable or disable the SSID. */
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enable the SSID for all access points or only specified ones. */
  isEnabledForAllAccessPoints?: InputMaybe<Scalars['Boolean']['input']>;
  /** Mark the SSID as a guest network. */
  isGuest?: InputMaybe<Scalars['Boolean']['input']>;
  /** Hide the SSID from being broadcasted. */
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enable client isolation on the SSID. */
  isIsolateClientsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enable or disable multicast to unicast translation on the SSID. */
  isMulticastToUnicastEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether proxy ARP (AP responds to ARP requests coming from the uplink on behalf of the clients) is enabled */
  isProxyARPEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enable or disable 802.11k roaming. */
  isRoaming80211kEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enable or disable 802.11r fast roaming. */
  isRoaming80211rEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enable or disable 802.11v roaming. */
  isRoaming80211vEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Threshold above which multicast to unicast is disabled. If 0, no limit. */
  multicastToUnicastClientThreshold?: InputMaybe<Scalars['Int']['input']>;
  /** A NAS (Network Access Server) identifier that can be used for Radius or 11r; if empty, defaults to the AP's hostname. */
  nasIdentifier?: InputMaybe<Scalars['String']['input']>;
  /** Pre-shared key (PSK) for the SSID. */
  password?: InputMaybe<Scalars['String']['input']>;
  /** Cadence for automatic password rotation. */
  passwordRotationCadence?: InputMaybe<SsidPasswordRotationCadence>;
  /** The day of the month for password rotation in the network's local time zone. */
  passwordRotationDayOfMonthLocal?: InputMaybe<Scalars['Int']['input']>;
  /** The day of the week for password rotation in the network's local time zone (0 = Sunday). */
  passwordRotationDayOfWeekLocal?: InputMaybe<Scalars['Int']['input']>;
  /** The hour of the day for password rotation in the network's local time zone. */
  passwordRotationHourOfDayLocal?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Set the primary 802.1X encryption configuration.
   * Required if encryptionProtocol is WPA2_ENTERPRISE.
   */
  primaryEncryption8021XUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** Enable or disable RADIUS Change of Authorization (CoA). */
  radiusCoaEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** A port where RADIUS servers can send CoA requests. */
  radiusCoaPort?: InputMaybe<Scalars['Int']['input']>;
  /** Value to configure RTS/CTS. */
  rtsCtsEnabledCode?: InputMaybe<Scalars['Int']['input']>;
  /** Size of the PPDU on which RTS would be sent out. */
  rtsThreshold?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Set the secondary 802.1X encryption configuration.
   * Required if encryptionProtocol is WPA2_ENTERPRISE.
   */
  secondaryEncryption8021XUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** Name of the SSID. */
  ssid?: InputMaybe<Scalars['String']['input']>;
  /** UUID of the VLAN to associate with the SSID. */
  vlanUUID?: InputMaybe<Scalars['UUID']['input']>;
};

/** Input type for updating a security appliance profile. */
export type UpdateSecurityApplianceProfileInput = {
  /** The number of seconds between host monitoring pings. */
  hostMonitoringIntervalSec?: InputMaybe<Scalars['Int']['input']>;
  /** The number of seconds to wait before timing out a host monitoring ping. */
  hostMonitoringTimeoutSec?: InputMaybe<Scalars['Int']['input']>;
  /** The algorithm used to manage multiple WAN connections, such as load balancing or failover strategies. */
  multiWANAlgorithm?: InputMaybe<MultiWanAlgorithm>;
  /** The number of seconds to wait before another failover can occur after a recent one */
  multiWANUpdateCooldownSec?: InputMaybe<Scalars['Int']['input']>;
  /** Number of previous ping results to consider for the failover calculation. */
  multiWANUpdateLookback?: InputMaybe<Scalars['Int']['input']>;
  /**
   * The minimum success ratio to consider a WAN link as good.
   * If it drops below the threshold, a failover occurs.
   * Stored as an integer representing the percentage.
   * For example, a value of 65 represents 65%, or a success ratio of 0.65.
   */
  multiWANUpdateThreshold?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateStaticRouteInput = {
  /**
   * UUIDs of VLANs to be excluded from the static route.
   * Only valid if this is a default route (0.0.0.0/0 destination prefix).
   * Only one of `explicitlyBoundVLANUUIDs` and `excludedVLANUUIDs` can be non-null and non-empty.
   */
  excludedVLANUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /**
   * UUIDs of VLANs to be bound to the static route.
   * Only valid if this is a default route (0.0.0.0/0 destination prefix).
   * If empty, all non-excluded VLANs will be bound to the default route.
   * Only one of `explicitlyBoundVLANUUIDs` and `excludedVLANUUIDs` can be non-null and non-empty.
   */
  explicitlyBoundVLANUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** New enabled state for the static route. */
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** New name for the static route. */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Input type for updating a switch profile. */
export type UpdateSwitchProfileInput = {
  /** For 802.1X encryption on a Switch's ports, if a client fails 802.1X authentication, clients are placed in the specified VLAN. The VLAN must be specified as `isGuest`. If set to null, then clients must authenticate before accessing the network. */
  encryption8021XGuestVLANUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** The 802.1X encryption configurations associated with this switch profile. Setting this field will replace the existing list of 802.1X encryption configurations. */
  encryption8021XUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** The time in seconds after which all flap state for a port is cleared. */
  flipClearFlapStateAfterSec?: InputMaybe<Scalars['Int']['input']>;
  /** The maximum number of times to toggle the port before requiring manual toggle of port in dashboard. */
  flipMaxRetryCount?: InputMaybe<Scalars['Int']['input']>;
  /** The number of seconds to wait before re-enabling the port. */
  flipRetryPeriodSec?: InputMaybe<Scalars['Int']['input']>;
  /** Time window in seconds to count the number of flaps. */
  flipWindowSec?: InputMaybe<Scalars['Int']['input']>;
  /** The number of flaps per time window that will result in a port being shut down. */
  flipWindowThreshold?: InputMaybe<Scalars['Int']['input']>;
  /** Flap link intervention protocol (FLIP) is a protocol that detects link failures and automatically disables the port. */
  isFLIPEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enables switch to periodically send IGMP queries to detect multicast clients. Both this flag and isIgmpSnoopingEnabled in VLAN must be true for IGMP snooping to be enabled on this switch. */
  isIGMPSnoopingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enables switch to periodically send MLD queries to detect multicast clients. Both this flag and isMldSnoopingEnabled in VLAN must be true for MLD snooping to be enabled on this switch. */
  isMLDSnoopingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Multicast filtering tells the switch what to do with unknown multicast packet i.e packets for which snooping doesn't have any learned ports. When enabled, unknown multicast packets are dropped. */
  isMulticastFilteringEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enables dedicated voice VLAN for voice traffic. */
  isVoiceVLANEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Time in seconds after which a MAC entry will be aged out. 0 means no expiration. */
  macTableAgingSec?: InputMaybe<Scalars['Int']['input']>;
  /** The maximum transmission unit (MTU) size in bytes. */
  mtu?: InputMaybe<Scalars['Int']['input']>;
  /** The new name of the switch profile. */
  name?: InputMaybe<Scalars['String']['input']>;
  /**
   * The STP bridge priority for the switch.
   *
   * The lower the value, the more likely the switch is to be elected as the root bridge.
   * The range is 0 to 61440. Valid values are multiples of 4096.
   */
  stpBridgePriority?: InputMaybe<Scalars['Int']['input']>;
  /**
   * STP forwarding delay in seconds (4-30).
   *
   * The delay between port state changes in the spanning tree.
   */
  stpForwardingDelaySeconds?: InputMaybe<Scalars['Int']['input']>;
  /**
   * STP Hello interval in seconds (1-10).
   *
   * The time between configuration messages sent by the root bridge.
   */
  stpHelloIntervalSeconds?: InputMaybe<Scalars['Int']['input']>;
  /**
   * STP Max BPDU age in seconds (6-40).
   *
   * The maximum age of received BPDU information before discarding.
   */
  stpMaxAgeSeconds?: InputMaybe<Scalars['Int']['input']>;
  /**
   * STP BPDU transmit hold count per second (1-10).
   *
   * The maximum number of BPDUs that can be sent per second.
   */
  stpTransmitHoldCount?: InputMaybe<Scalars['Int']['input']>;
  /** The tier of the switch device(s) associated with the switch profile, denoting the purpose of the devices in the network. */
  switchingTier?: InputMaybe<SwitchProfileSwitchingTier>;
  /** Voice VLAN CoS (Class Of Service) that operates on Layer-2 level. Valid values are 0-7. */
  voiceCosValue?: InputMaybe<Scalars['Int']['input']>;
  /** Voice VLAN DSCP (Differentiated Services Code Point) that operates on Layer-4 level. Valid values are 0-63. */
  voiceDscpValue?: InputMaybe<Scalars['Int']['input']>;
  /** The UUID of the VLAN designated for voice traffic. */
  voiceVLANUUID?: InputMaybe<Scalars['UUID']['input']>;
};

export type UpdateUplinkPhyInterfaceExternalAddressesInput = {
  /** Physical port number of the uplink interface whose external addresses are being updated. */
  portNumber: Scalars['Int']['input'];
  /** The external IP addresses assigned to the uplink interface. */
  uplinkExternalAddresses: Array<Scalars['UnmaskedIPPrefix']['input']>;
  /** The timestamp when the uplink external addresses were updated. */
  uplinkExternalAddressesUpdatedAt: Scalars['DateTime']['input'];
};

export type UpdateVlandhcpRuleInput = {
  /** The UUID of the DHCP rule to update. */
  dhcpRuleUUID: Scalars['UUID']['input'];
  /** The input containing updated values for the DHCP rule. */
  input: UpdateDhcpRuleInput;
};

export type UpdateVlanInput = {
  /** A list of DHCP rules to create for this VLAN. */
  createDHCPRules?: InputMaybe<Array<CreateDhcpRuleInput>>;
  /** A list of UUIDs of DHCP rules to delete from this VLAN. */
  deleteDHCPRules?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** A new description for the VLAN. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Number of IGMP queries to send when the switch first starts up using the startup query interval. */
  igmpQueryCount?: InputMaybe<Scalars['Int']['input']>;
  /** Interval in seconds between IGMP queries. Must be between 60 and 500. */
  igmpQueryIntervalSec?: InputMaybe<Scalars['Int']['input']>;
  /** Interval in seconds to wait for responses to IGMP queries. */
  igmpResponseIntervalSec?: InputMaybe<Scalars['Int']['input']>;
  /** Interval in seconds between IGMP queries when the switch first starts up.. */
  igmpStartupQueryIntervalSec?: InputMaybe<Scalars['Int']['input']>;
  /** IGMP version to use. Must be 1, 2, or 3. */
  igmpVersion?: InputMaybe<Scalars['Int']['input']>;
  /** Updates the protocol for assigning IPv4 addresses to clients on this VLAN. */
  ipV4ClientAssignmentProtocol?: InputMaybe<ClientAssignmentProtocol>;
  /** Updates the IPv4 gateway address for this VLAN. */
  ipV4ClientGateway?: InputMaybe<Scalars['IPV4']['input']>;
  /** Updates the IPv4 prefix length (subnet mask) for this VLAN. */
  ipV4ClientPrefixLength?: InputMaybe<Scalars['Int']['input']>;
  /** Updates the protocol for assigning IPv6 addresses to clients on this VLAN. */
  ipV6ClientAssignmentProtocol?: InputMaybe<ClientAssignmentProtocol>;
  /** Updates the IPv6 gateway address for this VLAN. */
  ipV6ClientGateway?: InputMaybe<Scalars['IPV6']['input']>;
  /** Updates the IPv6 prefix length (subnet mask) for this VLAN. */
  ipV6ClientPrefixLength?: InputMaybe<Scalars['Int']['input']>;
  /** Enable or disable the VLAN. */
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enables periodically sending IGMP queries to detect multicast clients. Both this flag and isIgmpSnoopingEnabled in SwitchProfile must be true for IGMP snooping to be enabled on this VLAN. */
  isIGMPSnoopingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, marks the VLAN as internal to the network. */
  isInternal?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, MLD snooping is enabled for this VLAN. Both this flag and isMLDSnoopingEnabled in SwitchProfile must be true for MLD snooping to be enabled on this VLAN. */
  isMLDSnoopingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, enables or disables multicast/mDNS reflection for the VLAN. */
  isMulticastReflectionEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, prevents this VLAN from sending traffic through WANs (blocks internet access). */
  isWANDenied?: InputMaybe<Scalars['Boolean']['input']>;
  /** Interval in seconds between MLD queries. Must be between 60 and 500. */
  mldQueryIntervalSec?: InputMaybe<Scalars['Int']['input']>;
  /** MLD version to use. Must be 1 or 2. */
  mldVersion?: InputMaybe<Scalars['Int']['input']>;
  /** A new name for the VLAN. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** If true, allows this VLAN to participate in VPN features. */
  participatesInVPNs?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * VLANs explicitly allowed to inter-communicate with this VLAN.
   * Effectively equivalent to firewall rules allowing communication between this VLAN and all of these VLANs.
   * Equivalent to PUT semantics, VLANs previously paired with this VLAN that are not present in this list will be no longer permitted.
   */
  permittedInterVLANCommunicationVLANUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** A list of DHCP rules to update for this VLAN. */
  updateDHCPRules?: InputMaybe<Array<UpdateVlandhcpRuleInput>>;
  /** The new VLAN ID. Must be between 1 and 4094 and unique per network. */
  vlanID?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateVlaNsIndependentlyInput = {
  /** The UUID of the VLAN to update. */
  UUID: Scalars['UUID']['input'];
  /** The input containing the settings to update for the VLAN. */
  input: UpdateVlaNsInput;
};

/** Settings to update for multiple VLANs. */
export type UpdateVlaNsInput = {
  /** If true, enables multicast/mDNS reflection on the VLANs. */
  isMulticastReflectionEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Specifies the metadata that can be updated for a virtual device, used to update many virtual devices at once with different values. */
export type UpdateVirtualDeviceIndependentlyInput = {
  /** The update input containing the fields to update for the virtual device. */
  input: UpdateVirtualDeviceInput;
  /** The UUID of the virtual device to update. */
  virtualDeviceUUID: Scalars['UUID']['input'];
};

/** Specifies the metadata that can be updated for a virtual device. */
export type UpdateVirtualDeviceInput = {
  /** An optional description for the virtual device. */
  description?: InputMaybe<Scalars['String']['input']>;
  /**
   * For some devices, we will allow the user to set the device model.
   * This will be useful for hardware swaps where we want to retain the same configuration for the virtual device.
   * There will be application validation, since sometimes changing the model is not valid (e.g., if the number of ports on the device differs,
   * or if the new model doesn't support features that the old model did).
   */
  deviceModel?: InputMaybe<DeviceModel>;
  /** Enable or disable the console port on the virtual device. */
  enableConsolePort?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enable or disable LED dark mode on the access point. */
  enableLEDDarkMode?: InputMaybe<Scalars['Boolean']['input']>;
  /** Currently we only support enabling debug logs on APs. */
  isDebugLogEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Mark the virtual device as read-only. As of now this is only supported for PDUs.
   * If the device is marked as read-only, updating any other fields will result in a Bad Request error.
   */
  isReadonly?: InputMaybe<Scalars['Boolean']['input']>;
  /** A human-friendly name for the virtual device. */
  label?: InputMaybe<Scalars['String']['input']>;
  /** The UUID of the NOS upgrade group to associate with the virtual device for grouped firmware upgrades. */
  nosUpgradeGroupUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** [Access Points only] The UUID of the radio profile to associate with the access point. */
  radioProfileUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** [Access Points only] The radio settings to update on the access point. */
  radioSettings?: InputMaybe<UpdateRadioSettingsInput>;
  /** [Switches only] Customize the switch profile for the device. */
  switchProfile?: InputMaybe<UpdateSwitchProfileInput>;
  /** [Switches only] The UUID of the switch profile to associate with the switch. */
  switchProfileUUID?: InputMaybe<Scalars['UUID']['input']>;
  /**
   * [Switches only] The switching tier for the virtual device's switch profile.
   * @deprecated Use switchProfile instead
   */
  switchingTier?: InputMaybe<SwitchProfileSwitchingTier>;
  /** Overwrite the VirtualDeviceTags for this device by name. If a tag with this name does not exist in the network, it will be created and attached to the device. If it already exists, it will be attached to the device. This will delete any existing tags not specified in the list. */
  tagNames?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateVirtualDeviceTagInput = {
  /** New name for the virtual device tag. */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Input type for updating an existing Wifi IPSK. */
export type UpdateWifiIpskInput = {
  /**
   * An optional array of MAC addresses to restrict a password to some clients (if null, no
   * MAC restriction)
   */
  clientMACs?: InputMaybe<Array<Scalars['MacAddress']['input']>>;
  /** A label for this IPSK */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Password for authentication. */
  password?: InputMaybe<Scalars['String']['input']>;
  /** The VLAN UUID if dynamic VLAN is enabled. */
  vlanUUID?: InputMaybe<Scalars['UUID']['input']>;
};

/** Input type for creating or updating a company onboarding field delegation. */
export type UpsertCompanyOnboardingFieldDelegationInput = {
  /** Description of the delegation. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Email of the user to whom the field is delegated. */
  email: Scalars['String']['input'];
};

/** Input for upserting a DHCP proxy. */
export type UpsertDhcpProxyInput = {
  /** The UUID of an existing DHCP proxy to update. If unset, will create a new DHCP proxy. */
  UUID?: InputMaybe<Scalars['UUID']['input']>;
  /** Input for upserting the DHCP proxy. */
  input: CreateDhcpProxyInput;
};

/** Input type for creating or updating a network onboarding field delegation. */
export type UpsertNetworkOnboardingFieldDelegationInput = {
  /** Description of the delegation. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Email of the user to whom the field is delegated. */
  email: Scalars['String']['input'];
};

/** A user is a person or machine that has access to Meter. */
export type User = {
  __typename?: 'User';
  /** The email address of the user. */
  email: Scalars['String']['output'];
  /** The first name of the user. */
  firstName?: Maybe<Scalars['String']['output']>;
  /** The unique identifier for the user. */
  id: Scalars['ID']['output'];
  /** The last name of the user. */
  lastName?: Maybe<Scalars['String']['output']>;
};

/**
 * Input type for specifying a user's role assignment.
 *
 * Allows for adding or replacing a role assignment for a user.
 */
export type UserRoleInput = {
  /**
   * The UUID of the network for network-specific roles.
   *
   * Omit for company-wide or global roles.
   */
  networkUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** The name of the role to assign or remove. */
  roleName: RoleName;
};

/** A VLAN (virtual LAN) is a logical network segment that allows network devices to communicate as if they were physically connected to the same network. */
export type Vlan = {
  __typename?: 'VLAN';
  /** The unique identifier for the VLAN. */
  UUID: Scalars['UUID']['output'];
  /** The captive portal associated with this VLAN. */
  captivePortal?: Maybe<CaptivePortal>;
  /** The timestamp indicating when the VLAN was created. */
  createdAt: Scalars['DateTime']['output'];
  /** An optional description of the VLAN. */
  description?: Maybe<Scalars['String']['output']>;
  /** The DHCP rule associated with this VLAN. */
  dhcpRule?: Maybe<DhcpRule>;
  /** Number of IGMP queries to send when the switch first starts up using the startup query interval. */
  igmpQueryCount: Scalars['Int']['output'];
  /** Interval in seconds between IGMP queries. Must be between 60 and 500. */
  igmpQueryIntervalSec: Scalars['Int']['output'];
  /** Interval in seconds to wait for responses to IGMP queries. */
  igmpResponseIntervalSec: Scalars['Int']['output'];
  /** Interval in seconds between IGMP queries when the switch first starts up.. */
  igmpStartupQueryIntervalSec: Scalars['Int']['output'];
  /** IGMP version to use. Must be 1, 2, or 3. */
  igmpVersion: Scalars['Int']['output'];
  /** Specifies the protocol for assigning IPv4 addresses to clients on this VLAN. */
  ipV4ClientAssignmentProtocol?: Maybe<ClientAssignmentProtocol>;
  /** Specifies the IPv4 gateway address for this VLAN. This value should not include a netmask. */
  ipV4ClientGateway?: Maybe<Scalars['IPV4']['output']>;
  /** Specifies the IPv4 prefix length (subnet mask) for this VLAN. */
  ipV4ClientPrefixLength?: Maybe<Scalars['Int']['output']>;
  /** Specifies the protocol for assigning IPv6 addresses to clients on this VLAN. */
  ipV6ClientAssignmentProtocol?: Maybe<ClientAssignmentProtocol>;
  /** Specifies the IPv6 gateway address for this VLAN. This value should not include a netmask. */
  ipV6ClientGateway?: Maybe<Scalars['IPV6']['output']>;
  /** Specifies the IPv6 prefix length (subnet mask) for this VLAN. */
  ipV6ClientPrefixLength?: Maybe<Scalars['Int']['output']>;
  /** Only one VLAN per network can be the default VLAN. Untagged packets that don't belong to any configured VLANs are assigned to the default one. */
  isDefault: Scalars['Boolean']['output'];
  /** If true, the VLAN is enabled and can be used in the network. */
  isEnabled: Scalars['Boolean']['output'];
  /** Enables periodically sending IGMP queries to detect multicast clients. Both this flag and isIgmpSnoopingEnabled in SwitchProfile must be true for IGMP snooping to be enabled on this VLAN. */
  isIGMPSnoopingEnabled: Scalars['Boolean']['output'];
  /** If true, this VLAN is internal to the network and should not be displayed to or editable by the customer. */
  isInternal?: Maybe<Scalars['Boolean']['output']>;
  /** If true, MLD snooping is enabled for this VLAN. Both this flag and isMLDSnoopingEnabled in SwitchProfile must be true for MLD snooping to be enabled on this VLAN. */
  isMLDSnoopingEnabled: Scalars['Boolean']['output'];
  /** If true, this VLAN participates in multicast/mDNS reflection. */
  isMulticastReflectionEnabled: Scalars['Boolean']['output'];
  /** If true, prevents this VLAN from sending traffic through WANs (blocks internet access). */
  isWANDenied: Scalars['Boolean']['output'];
  /** Interval in seconds between MLD queries. Must be between 60 and 500. */
  mldQueryIntervalSec: Scalars['Int']['output'];
  /** MLD version to use. Must be 1 or 2. */
  mldVersion: Scalars['Int']['output'];
  /** A human-friendly name to identify the VLAN, like "guest". Unique per network. */
  name: Scalars['String']['output'];
  /** The UUID of the network to which the VLAN belongs. */
  networkUUID: Scalars['UUID']['output'];
  /**
   * If true, allows this VLAN to participate in cross-site VPN features and its IPv4Prefix cannot overlap with any other
   * IPv4Prefix for VLANs with a true participatesInVPN in the associated company for this network.
   */
  participatesInVPNs: Scalars['Boolean']['output'];
  /** VLANs explicitly allowed to inter-communicate with this VLAN. Effectively equivalent to firewall rules allowing communication between this VLAN and all of these VLANs. */
  permittedInterVLANCommunicationVLANs: Array<Vlan>;
  /** The timestamp indicating the last time the VLAN was updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** The VLAN ID. Must be between 1 and 4094 and is unique per network. */
  vlanID: Scalars['Int']['output'];
};

/** Response type containing client metrics timeseries data over a specified time range. */
export type VlanMetricsTimeseriesResponse = {
  __typename?: 'VLANMetricsTimeseriesResponse';
  /** Aggregated throughput for the total drops per second. */
  drops: BaseMetricsResponse;
  /** Network UUID for this series. */
  networkUUID: Scalars['UUID']['output'];
  /** Aggregated throughput for the punts in packets per second. */
  punts: BaseMetricsResponse;
  /** Aggregated throughput for the total bytes received in bps. */
  rxBytes: BaseMetricsResponse;
  /** Aggregated throughput for the rx errors in packets per second. */
  rxError: BaseMetricsResponse;
  /** Aggregated throughput for the total packets received per second. */
  rxPackets: BaseMetricsResponse;
  /** Aggregated throughput for the total bytes transmitted in bps. */
  txBytes: BaseMetricsResponse;
  /** Aggregated throughput for the tx errors in packets per second. */
  txError: BaseMetricsResponse;
  /** Aggregated throughput for the total packets transmitted per second. */
  txPackets: BaseMetricsResponse;
  /** VLAN for this series. */
  vlan: Vlan;
  /** VLAN ID for this series. */
  vlanID: Scalars['Int']['output'];
};

/** Input to specify a pair of VLANs for permitted inter-VLAN communication. */
export type VlanPairInput = {
  /** The UUID of the first VLAN in the pair. */
  vlan1UUID: Scalars['UUID']['input'];
  /** The UUID of the second VLAN in the pair. */
  vlan2UUID: Scalars['UUID']['input'];
};

/** Response type containing valid channels for a radio band. */
export type ValidChannelsResponse = {
  __typename?: 'ValidChannelsResponse';
  /** The radio band for which the valid channels are provided. */
  band: RadioBand;
  /** A list of valid channels for the specified radio band. */
  channels: Array<Scalars['Int']['output']>;
};

/** A virtual device is a logical representation of a physical device; configuration is associated with the virtual device. */
export type VirtualDevice = {
  /** The unique identifier (UUID) of the virtual device. */
  UUID: Scalars['UUID']['output'];
  /** The timestamp when the virtual device was first created in the system. */
  createdAt: Scalars['DateTime']['output'];
  /** An optional description for the virtual device. */
  description?: Maybe<Scalars['String']['output']>;
  /** The model name of the virtual device. */
  deviceModel: DeviceModel;
  /** The type of the virtual device. */
  deviceType: VirtualDeviceType;
  /** The hardware device associated with this virtual device, if any. */
  hardwareDevice?: Maybe<HardwareDevice>;
  /** Indicates whether the virtual device's console port is enabled. */
  isConsoleEnabled: Scalars['Boolean']['output'];
  /** Indicates whether debug logging is enabled on the virtual device. */
  isDebugLogEnabled: Scalars['Boolean']['output'];
  /** A human-friendly name for the device. */
  label: Scalars['String']['output'];
  /** The network that the virtual device belongs to. */
  network: Network;
  /** The unique identifier (UUID) of the network the virtual device belongs to. */
  networkUUID: Scalars['UUID']['output'];
  /**
   * The group that the device belongs to for firmware upgrade grouping purposes.
   * Note: This is nullable in the schema but all devices now have a NOS upgrade group.
   */
  nosUpgradeGroup: NosUpgradeGroup;
  /** The current NOS firmware version that the virtual device is configured to run. */
  nosVersion?: Maybe<ConfiguredNosVersion>;
  /** The identifier of the NOS firmware version that the virtual device is configured to run. */
  nosVersionID: Scalars['Int']['output'];
  /** The NOS firmware version that the virtual device is scheduled to upgrade to. */
  pendingNosVersion?: Maybe<PendingNosVersion>;
  /** Data about this virtual device's position in its network's topology. */
  topologyData?: Maybe<VirtualDeviceTopologyData>;
  /** The timestamp when the virtual device was last updated in the system. */
  updatedAt: Scalars['DateTime']['output'];
  /** The uptime from our time series database for the device. */
  uptime?: Maybe<Scalars['Duration']['output']>;
};

/** Represents the history of NOS versions scheduled and applied to a virtual device. */
export type VirtualDeviceNosHistory = {
  __typename?: 'VirtualDeviceNosHistory';
  /** Timestamp when the NOS version was actually applied to the virtual device. */
  appliedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The NOS version scheduled or applied to the virtual device. */
  nosVersion: NosVersion;
  /** Timestamp when the NOS version was scheduled to be applied to the virtual device. */
  scheduledAt: Scalars['DateTime']['output'];
  /** Current status of the NOS version application on the virtual device (e.g., 'scheduled', 'in progress', 'completed', 'failed'). */
  status: Scalars['String']['output'];
};

/** A virtual device tag is an attribute that can be applied to many virtual devices to group them together for bulk-actions and UI filtering. */
export type VirtualDeviceTag = {
  __typename?: 'VirtualDeviceTag';
  /** Unique identifier of the virtual device tag. */
  UUID: Scalars['UUID']['output'];
  /** Name of the virtual device tag. */
  name: Scalars['String']['output'];
  /** Unique identifier of the network this tag belongs to. */
  networkUUID: Scalars['UUID']['output'];
};

/** Data about a virtual device's position in its network's topology. */
export type VirtualDeviceTopologyData = {
  __typename?: 'VirtualDeviceTopologyData';
  /** The phy interface on this device that is connected to another uplink virtual device / phy interface. */
  thisPhyInterface?: Maybe<PhyInterface>;
  /** The height of this virtual device in the topology; 0 is the root device. */
  topologyHeight: Scalars['Int']['output'];
  /** The phy interface on the uplink virtual device that is connected to this virtual device. */
  uplinkPhyInterface?: Maybe<PhyInterface>;
  /** The virtual device that is an uplink to this virtual device. */
  uplinkVirtualDevice?: Maybe<VirtualDevice>;
};

/** VirtualDeviceType enumerates the different types of virtual devices that Meter deploys. */
export enum VirtualDeviceType {
  /** Represents an Access Point virtual device type. */
  AccessPoint = 'ACCESS_POINT',
  /** Represents a Controller virtual device type. */
  Controller = 'CONTROLLER',
  /** Represents an Observer virtual device type. */
  Observer = 'OBSERVER',
  /** Represents a Power Distribution Unit virtual device type. */
  PowerDistributionUnit = 'POWER_DISTRIBUTION_UNIT',
  /** Represents a Switch virtual device type. */
  Switch = 'SWITCH',
}

/** Enumeration of Wide Area Network (WAN) interfaces. */
export enum Wan {
  /** WAN interface 0. */
  Wan0 = 'wan0',
  /** WAN interface 1. */
  Wan1 = 'wan1',
}

/** Details about a WAN connection. */
export type WanConnection = {
  __typename?: 'WANConnection';
  /** The list of external IP addresses associated with this WAN connection. */
  externalAddresses: Array<Scalars['String']['output']>;
  /** The internet service plan provider for this WAN connection. */
  internetServicePlanProvider?: Maybe<InternetServicePlanProvider>;
  /** The port number of the WAN connection. */
  port: Scalars['Int']['output'];
};

/** Properties for WAN down events. */
export type WanDownProperties = {
  __typename?: 'WANDownProperties';
  /** The virtual device associated with the WAN down event. */
  virtualDevice?: Maybe<VirtualDevice>;
};

/** Represents the direction of the WAN speed test. */
export enum WanSpeedtestDirection {
  /** Download direction. */
  Down = 'DOWN',
  /** For simplicity in schema, latency is unintuitively considered a direction. */
  Latency = 'LATENCY',
  /** Unspecified direction. */
  Unspecified = 'UNSPECIFIED',
  /** Upload direction. */
  Up = 'UP',
}

/** Represents a WAN (Wide Area Network) speed test job. */
export type WanSpeedtestJob = NetworkJob & {
  __typename?: 'WANSpeedtestJob';
  /** The unique identifier for the job. */
  UUID: Scalars['UUID']['output'];
  /** The base URL used for the speed test. */
  baseURL: Scalars['String']['output'];
  /** The time at which the job was completed. */
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The maximum number of bytes to transfer during the speed test. */
  maxTransferBytes?: Maybe<Scalars['Int']['output']>;
  /** The unique identifier of the network associated with this job. */
  networkUUID: Scalars['UUID']['output'];
  /** The physical interface on which the speed test is run. */
  phyInterface: PhyInterface;
  /** The results of the speed test job. */
  results?: Maybe<Array<WanSpeedtestJobResult>>;
  /** The time at which the job was scheduled. */
  scheduledAt: Scalars['DateTime']['output'];
  /** The current status of the speed test. */
  status?: Maybe<WanSpeedtestStatus>;
};

/** Represents the result of a single WAN speed test measurement. */
export type WanSpeedtestJobResult = {
  __typename?: 'WANSpeedtestJobResult';
  /** The speed test direction (e.g., UP, DOWN, LATENCY). */
  direction: WanSpeedtestDirection;
  /** The duration in nanoseconds that this result took. Null for LATENCY results. */
  durationNs?: Maybe<Scalars['Int']['output']>;
  /** Indicates whether the test failed. */
  failed: Scalars['Boolean']['output'];
  /** The round-trip times (RTTs) in nanoseconds for each HTTP request in this result. */
  httpRTTsNs: Array<Scalars['Int']['output']>;
  /** The measured speed in megabits per second (Mbps). Null for LATENCY results. */
  mbps?: Maybe<Scalars['Float']['output']>;
  /** The number of bytes transferred in this result. Null for LATENCY results. */
  transferBytes?: Maybe<Scalars['Int']['output']>;
};

/** Represents the status of a WAN speed test. */
export enum WanSpeedtestStatus {
  /** Indicates the test is not running. */
  Ok = 'OK',
  /** Indicates the test is currently running. */
  Running = 'RUNNING',
  /** Status is unknown. */
  Unknown = 'UNKNOWN',
}

/** Properties for WAN status change events. */
export type WanStatusChangeProperties = {
  __typename?: 'WANStatusChangeProperties';
  /** The list of active WAN connections. */
  activeWANConnections: Array<Maybe<WanConnection>>;
  /** The virtual device associated with the WAN status change. */
  virtualDevice?: Maybe<VirtualDevice>;
};

/** Properties for WAN up events. */
export type WanUpProperties = {
  __typename?: 'WANUpProperties';
  /** The virtual device associated with the WAN up event. */
  virtualDevice?: Maybe<VirtualDevice>;
};

/** An enumeration of possible authentication types for a webhook alert target. */
export enum WebhookAuthType {
  /** Basic authentication is used. */
  Basic = 'BASIC',
  /** Bearer authentication is used. */
  Bearer = 'BEARER',
  /** No authentication is used. */
  None = 'NONE',
}

/** Wifi IPSK: password for an IPSK SSID */
export type WifiIpsk = {
  __typename?: 'WifiIPSK';
  /** Unique identifier for the Wifi iPSK. */
  UUID: Scalars['UUID']['output'];
  /**
   * An optional array of MAC addresses to restrict a password to some clients (if null, no
   * MAC restriction)
   */
  clientMACs?: Maybe<Array<Scalars['MacAddress']['output']>>;
  /** A label for this IPSK */
  label?: Maybe<Scalars['String']['output']>;
  /** The UUID of the network with an IPSK SSID. */
  networkUUID: Scalars['UUID']['output'];
  /** One IPSK password for authentication. */
  password: Scalars['String']['output'];
  /** The UUID of the SSID with IPSK. */
  ssidUUID: Scalars['UUID']['output'];
  /**
   * The VLAN ID for this password; used when dynamic VLAN is set.
   * If dynamic VLAN is disabled or the VLAN is null, default VLAN is used.
   * If dynamic VLAN mode is required, it needs to be set.
   */
  vlanUUID?: Maybe<Scalars['UUID']['output']>;
};

/** Results for Observer connection attempts */
export type WifiObserverResults = {
  __typename?: 'WifiObserverResults';
  /** The lookback time for this slice of results */
  durationSeconds: Scalars['Int']['output'];
  /** The latest observation time for this slice of results */
  endTime: Scalars['DateTime']['output'];
  /** Number of association successes (802.11 assoc + authentication) */
  numAssocSuccess: Scalars['Int']['output'];
  /** Number of connection attempts */
  numConnectionAttempts: Scalars['Int']['output'];
  /** Number of consecutive recent failures (failures during the latest tests) */
  numConsecutiveRecentFailures: Scalars['Int']['output'];
  /** Number of DHCP successes (included association) */
  numDhcpSuccess: Scalars['Int']['output'];
  /** Results of the tests */
  testResults?: Maybe<Array<WifiObserverTestResults>>;
};

/** Observer settings contain configuration for running wireless observer tests. */
export type WifiObserverSetting = {
  __typename?: 'WifiObserverSetting';
  /** The SSID for this Observer test. */
  SSID: Ssid;
  /** The UUID of the SSID for this Observer test. */
  SSIDUUID: Scalars['UUID']['output'];
  /** The radio band on which the test should be run (e.g., 2.4GHz, 5GHz). */
  band: RadioBand;
  /** List of commands to run during the observer test. */
  commands?: Maybe<Array<WosObserverCommand>>;
  /** Duration of the test in milliseconds. */
  durationMsec: Scalars['Int']['output'];
  /** The UUID of the network to which this Wifi Observer Setting belongs. */
  networkUUID: Scalars['UUID']['output'];
  /** Number of spatial streams to be used in the test; if 0, uses max number of spatial streams of the Observer */
  numSpatialStreams: Scalars['Int']['output'];
  /** 802.1X password for authentication. */
  password8021X?: Maybe<Scalars['String']['output']>;
  /** List of test results */
  results?: Maybe<Array<WifiObserverResults>>;
  /** The virtual device (access point) that the observer will target or get results for. */
  targetVirtualDevice?: Maybe<AccessPointVirtualDevice>;
  /** The UUID of the virtual device (access point) that the observer will target or get results for. */
  targetVirtualDeviceUUID?: Maybe<Scalars['UUID']['output']>;
  /** TX power to use for the test; if 0, uses the TX power of the targeted AP. */
  txPowerDbm: Scalars['Int']['output'];
  /** 802.1X username for authentication. */
  username8021X?: Maybe<Scalars['String']['output']>;
  /** The virtual device on which to run the observer test. */
  virtualDevice: ObserverVirtualDevice;
  /** The UUID of the virtual device on which to run the observer test. */
  virtualDeviceUUID: Scalars['UUID']['output'];
};

/** Results for Observer tests (ping, DNS, etc.) */
export type WifiObserverTestResults = {
  __typename?: 'WifiObserverTestResults';
  /** The type of target (IPv4, IPv6, or hostname). */
  commandTargetType: WosObserverCommandTargetType;
  /** The type of command run (e.g., PING, DOWNLOAD). */
  commandType: WosObserverCommandType;
  /** Number of attempts for the test */
  numAttempts: Scalars['Int']['output'];
  /** Number of successes for the test */
  numSuccess: Scalars['Int']['output'];
  /** The target of the command, such as an IP address or hostname. */
  target: Scalars['String']['output'];
  /** Index of the test (matches WosObserverCommand index) */
  testIndex: Scalars['Int']['output'];
  /** Total latency in milliseconds (average latency will be totalLatency / numSuccess) */
  totalLatencyMs: Scalars['Float']['output'];
};

/** Represents a wireless calibration job. */
export type WirelessCalibrationJob = NetworkJob & {
  __typename?: 'WirelessCalibrationJob';
  /** The unique identifier for the job. */
  UUID: Scalars['UUID']['output'];
  /** The channel to set all the APs to for wireless calibration. */
  channel: Scalars['Int']['output'];
  /** The time at which the job was completed. */
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The unique identifier for the leader AP for this calibration job. */
  leaderAccessPoint: AccessPointVirtualDevice;
  /** The unique identifier of the network associated with this job. */
  networkUUID: Scalars['UUID']['output'];
  /** The power to set all the APs to for wireless calibration. */
  power: Scalars['Int']['output'];
  /** The results of the speed test job. */
  results?: Maybe<Array<Maybe<WirelessCalibrationResult>>>;
  /** The time at which the job was scheduled. */
  scheduledAt: Scalars['DateTime']['output'];
  /** The current status of the wireless calibration. */
  status?: Maybe<WirelessCalibrationStatus>;
};

/** Represents the result of a wireless calibration job. */
export type WirelessCalibrationResult = {
  __typename?: 'WirelessCalibrationResult';
  /** Error message, if any. */
  reason?: Maybe<Scalars['String']['output']>;
  /** Indicates whether the test failed. */
  status: Scalars['Boolean']['output'];
};

/** Represents the status of a wireless calibration job. */
export enum WirelessCalibrationStatus {
  /** Indicates the calibration is not running. */
  Ok = 'OK',
  /** Indicates the calibration is currently running. */
  Running = 'RUNNING',
  /** Status is unknown. */
  Unknown = 'UNKNOWN',
}

/**
 * A single snapshot of client connectivity metrics for a single client.
 * Not an average over a time period or across multiple clients.
 */
export type WirelessClient = {
  __typename?: 'WirelessClient';
  /** When the client associated with the AP. */
  associatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The radio band the client is connected to. */
  band: RadioBand;
  /** The channel number the client is using. */
  channel: Scalars['Int']['output'];
  /** The MAC address of the client device. */
  macAddress: Scalars['MacAddress']['output'];
  /** The latest connectivity metrics of the client. */
  metrics: ClientMetricsTimeseriesValue;
  /** The UUID of the network the client is connected to. */
  networkUUID: Scalars['UUID']['output'];
  /** The Observer virtual device, if the client is an observer */
  observerVirtualDevice?: Maybe<ObserverVirtualDevice>;
  /** List of mDNS service types that this client offers (e.g., printer, AirPlay, etc.). */
  serviceTypes?: Maybe<Array<ServiceType>>;
  /** The SSID that the client interacted with. */
  ssid: Ssid;
  /** The name of the SSID that the client interacted with. */
  ssidName: Scalars['String']['output'];
  /** The AP virtual device that the client interacted with. */
  virtualDevice: AccessPointVirtualDevice;
  /** The UUID of the AP virtual device the client is connected to. */
  virtualDeviceUUID: Scalars['UUID']['output'];
};

/** A statistic that indicates when a client connected to an AP, disassociated from an AP, or failed to connect to an AP. */
export type WirelessClientConnectionEvent = {
  __typename?: 'WirelessClientConnectionEvent';
  /** The radio band that the client interacted with. */
  band: RadioBand;
  /** The type of connection event. */
  eventType: WirelessClientConnectionEventType;
  /** If the event type is `FAILED`, explains which step of the connection process failed. */
  failedStep?: Maybe<WirelessClientConnectionFailedStep>;
  /** The instigator, either client or access point, of the disassociation. */
  instigator?: Maybe<WirelessClientConnectionEventInstigator>;
  /** Whether the connection event was part of a fast transition (802.11r) roam. */
  is80211rRoam: Scalars['Boolean']['output'];
  /** If true, came from an Observer. */
  isObserver: Scalars['Boolean']['output'];
  /** If this is a rejection event, whether it was caused by client steering. */
  isSteeringRejection: Scalars['Boolean']['output'];
  /** The MAC address of the client. */
  macAddress: Scalars['MacAddress']['output'];
  /** If the event type is `CONNECTED`, the AP virtual device that the client was previously connected to. */
  previousVirtualDeviceConnectedTo?: Maybe<AccessPointVirtualDevice>;
  /** If the event type is `CONNECTED`, the UUID of the AP virtual device the client was previously connected to. */
  previousVirtualDeviceUUIDConnectedTo?: Maybe<Scalars['UUID']['output']>;
  /** If the event type is `DISASSOCIATED` or `FAILED`, the 802.11 reason code for the event. */
  reasonCode?: Maybe<Scalars['Int']['output']>;
  /** The rssi is the signal strength (in dBm) between the client and the virtual device. */
  rssi: Scalars['Int']['output'];
  /** If the event type is `DISASSOCIATED`, how long the client was associated with the AP before disassociating. */
  sessionDuration?: Maybe<Scalars['Duration']['output']>;
  /** The SSID that the client interacted with. */
  ssid?: Maybe<Ssid>;
  /** The UUID of the SSID that the client interacted with. */
  ssidUUID?: Maybe<Scalars['UUID']['output']>;
  /** If the event type is `CONNECTED`, how long it took for the client to connect to the AP. */
  timeToConnect?: Maybe<Scalars['Duration']['output']>;
  /** The timestamp of the event. */
  timestamp: Scalars['DateTime']['output'];
  /** The AP virtual device that the client interacted with. */
  virtualDevice?: Maybe<AccessPointVirtualDevice>;
  /** The UUID of the AP virtual device that the client interacted with. */
  virtualDeviceUUID: Scalars['UUID']['output'];
};

export enum WirelessClientConnectionEventInstigator {
  /** The access point initiated the disassociation. */
  InstigatorAp = 'INSTIGATOR_AP',
  /** The client initiated the disassociation. */
  InstigatorClient = 'INSTIGATOR_CLIENT',
  /** Unknown what initiated the disassociation. */
  InstigatorUnspecified = 'INSTIGATOR_UNSPECIFIED',
}

export enum WirelessClientConnectionEventType {
  /** The client failed to connect to the AP due to an ARP failure. */
  ArpFailed = 'ARP_FAILED',
  /** The client failed to connect to the AP due to ARP taking too long. */
  ArpLate = 'ARP_LATE',
  /** The client successfully connected to the AP. */
  Connected = 'CONNECTED',
  /** The client failed to receive an IP address from the DHCP server. */
  DhcpFailed = 'DHCP_FAILED',
  /** The client successfully received an IP address from the DHCP server. */
  DhcpOk = 'DHCP_OK',
  /** The client disassociated from the AP. */
  Disassociated = 'DISASSOCIATED',
  /** The client attempted to connect to the AP but failed. */
  Failed = 'FAILED',
}

export enum WirelessClientConnectionFailedStep {
  /** The association packet exchange in the 802.11 handshake protocol failed. */
  Failed_80211Association = 'FAILED_80211_ASSOCIATION',
  /** The authentication packet exchange in the 802.11 handshake protocol failed. */
  Failed_80211Authentication = 'FAILED_80211_AUTHENTICATION',
  /** The 4-way EAPOL handshake failed. */
  FailedAuthentication = 'FAILED_AUTHENTICATION',
  /** The client declined the IP address from the DHCP server. */
  FailedDhcpDecline = 'FAILED_DHCP_DECLINE',
  /** The DHCP server denied the client's request for an IP address. */
  FailedDhcpNak = 'FAILED_DHCP_NAK',
  /** The DHCP server did not respond to the client's request for an IP address. */
  FailedDhcpTimeout = 'FAILED_DHCP_TIMEOUT',
  /** The connection failed due to other reasons. */
  FailedOther = 'FAILED_OTHER',
}

/** Response type that contains ClientMetricsTimeseriesResponse for a single MAC address. */
export type WirelessClientMetricsResponse = {
  __typename?: 'WirelessClientMetricsResponse';
  /** The MAC address for this response. */
  macAddress: Scalars['MacAddress']['output'];
  /** The metrics for this MAC Address. */
  response: ClientMetricsTimeseriesResponse;
};

/** A command to be executed by the Wifi Observer during the test. */
export type WosObserverCommand = {
  __typename?: 'WosObserverCommand';
  /** The type of target (IPv4, IPv6, or hostname). */
  commandTargetType: WosObserverCommandTargetType;
  /** The type of command to run (e.g., PING, DOWNLOAD). */
  commandType: WosObserverCommandType;
  /** An index to match with the test results. */
  index: Scalars['Int']['output'];
  /** Interval between command executions in milliseconds. */
  intervalMsec: Scalars['Int']['output'];
  /** An index indicating the order of execution; commands with the same index run in parallel. */
  orderIndex: Scalars['Int']['output'];
  /** The target of the command, such as an IP address or hostname. */
  target: Scalars['String']['output'];
  /** Timeout for the command execution in milliseconds. */
  timeoutMsec: Scalars['Int']['output'];
};

/** Input type for defining a Wifi Observer Command. */
export type WosObserverCommandInput = {
  /** The type of target for the command. */
  commandTargetType: WosObserverCommandTargetType;
  /** The type of command to run. */
  commandType: WosObserverCommandType;
  /** An index to match with the test results. */
  index: Scalars['Int']['input'];
  /** Interval between command executions in milliseconds. */
  intervalMsec: Scalars['Int']['input'];
  /** An index indicating the order of execution; commands with the same index run in parallel. */
  orderIndex: Scalars['Int']['input'];
  /** The target of the command. */
  target: Scalars['String']['input'];
  /** Timeout for the command execution in milliseconds. */
  timeoutMsec: Scalars['Int']['input'];
};

/** Enumeration of possible target types for the Wifi Observer command. */
export enum WosObserverCommandTargetType {
  /** Hostname target type. */
  Hostname = 'HOSTNAME',
  /** IPv4 address target type. */
  Ipv4 = 'IPV4',
  /** IPv6 address target type. */
  Ipv6 = 'IPV6',
}

/** Enumeration of possible command types for the Wifi Observer. */
export enum WosObserverCommandType {
  /** DNS command type. */
  Dns = 'DNS',
  /** Download command type. */
  Download = 'DOWNLOAD',
  /** Iperf command type. */
  Iperf = 'IPERF',
  /** Ping command type. */
  Ping = 'PING',
  /** Speedtest command type. */
  Speedtest = 'SPEEDTEST',
  /** Traceroute command type. */
  Traceroute = 'TRACEROUTE',
}

/** Radio interfaces available for packet capture. */
export enum WosPacketCaptureCommandMonitor {
  /** 2.4 GHz radio interface. */
  Radio_2G = 'RADIO_2G',
  /** 5 GHz radio interface. */
  Radio_5G = 'RADIO_5G',
  /** 6 GHz radio interface. */
  Radio_6G = 'RADIO_6G',
  /** Scanning radio interface. */
  RadioScan = 'RADIO_SCAN',
  /** Unspecified radio interface. */
  RadioUnspecified = 'RADIO_UNSPECIFIED',
  /** Wired interface (either eth0 or eth1) */
  Wired = 'WIRED',
}

export type AlertAuditLogQueryQueryVariables = Exact<{
  companyUUID: Scalars['UUID']['input'];
  filter?: InputMaybe<AlertAuditLogFilter>;
}>;

export type AlertAuditLogQueryQuery = {
  __typename?: 'Query';
  alertAuditLogEntriesForCompany: Array<{
    __typename?: 'AlertAuditLogEntry';
    UUID: string;
    triggeredAt: string;
    networkUUID: string;
    companyUUID: string;
    alertDefinition: {
      __typename?: 'AlertDefinition';
      name: string;
      displayName: string;
      description?: string | null;
    };
  }>;
};

export type AutoSwitchConfigurationJobsForNetworkQueryVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
}>;

export type AutoSwitchConfigurationJobsForNetworkQuery = {
  __typename?: 'Query';
  autoSwitchConfigurationJobsForNetwork: Array<{
    __typename: 'SwitchAutoConfigurationJob';
    UUID: string;
    networkUUID: string;
    virtualDeviceUUIDs: Array<string>;
    scheduledAt: string;
    completedAt?: string | null;
    isDryRun: boolean;
  }>;
};

export type AutoSwitchConfigurationJobQueryVariables = Exact<{
  jobUUID: Scalars['UUID']['input'];
}>;

export type AutoSwitchConfigurationJobQuery = {
  __typename?: 'Query';
  autoSwitchConfigurationJob: {
    __typename?: 'SwitchAutoConfigurationJob';
    UUID: string;
    scheduledAt: string;
    completedAt?: string | null;
    isDryRun: boolean;
    results?: Array<{
      __typename?: 'SwitchAutoConfigurationResult';
      toggleDirection: SwitchAutoConfigurationResultToggleDirection;
      warnings?: Array<SwitchAutoConfigurationResultWarning> | null;
      virtualDevice: { __typename?: 'SwitchVirtualDevice'; UUID: string; label: string };
      phyInterface: { __typename?: 'PhyInterface'; portNumber: number };
      previousNativeVLAN?: { __typename?: 'VLAN'; vlanID: number; name: string } | null;
      newNativeVLAN?: { __typename?: 'VLAN'; vlanID: number; name: string } | null;
    }> | null;
  };
};

export type WanSpeedtestJobsForNetworkQueryVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
}>;

export type WanSpeedtestJobsForNetworkQuery = {
  __typename?: 'Query';
  wanSpeedtestJobsForNetwork: Array<{
    __typename: 'WANSpeedtestJob';
    UUID: string;
    completedAt?: string | null;
    status?: WanSpeedtestStatus | null;
    results?: Array<{
      __typename?: 'WANSpeedtestJobResult';
      direction: WanSpeedtestDirection;
      transferBytes?: number | null;
      durationNs?: number | null;
      mbps?: number | null;
      httpRTTsNs: Array<number>;
      failed: boolean;
    }> | null;
  }>;
};

export type JobsForNetworkQueryVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
  includeWANSpeedtestJobs: Scalars['Boolean']['input'];
  includeAutoSwitchConfigurationJobs: Scalars['Boolean']['input'];
  includePacketCaptureJobs: Scalars['Boolean']['input'];
}>;

export type JobsForNetworkQuery = {
  __typename?: 'Query';
  wanSpeedtestJobsForNetwork?: Array<{
    __typename: 'WANSpeedtestJob';
    UUID: string;
    completedAt?: string | null;
    scheduledAt: string;
    status?: WanSpeedtestStatus | null;
    results?: Array<{
      __typename?: 'WANSpeedtestJobResult';
      direction: WanSpeedtestDirection;
    }> | null;
  }>;
  autoSwitchConfigurationJobsForNetwork?: Array<{
    __typename: 'SwitchAutoConfigurationJob';
    UUID: string;
    networkUUID: string;
    virtualDeviceUUIDs: Array<string>;
    scheduledAt: string;
    completedAt?: string | null;
    isDryRun: boolean;
  }>;
  packetCaptureJobsForNetwork?: Array<{
    __typename: 'PacketCaptureJob';
    jobId: string;
    stopped: boolean;
    createdAt: string;
    timeLimitSeconds: number;
    listenOn: WosPacketCaptureCommandMonitor;
    tcpDumpFilter: string;
    virtualDeviceUUID: string;
  }>;
};

export type CompanyMembershipsQueryVariables = Exact<{ [key: string]: never }>;

export type CompanyMembershipsQuery = {
  __typename?: 'Query';
  companyMemberships: Array<{
    __typename?: 'Company';
    uuid: string;
    name: string;
    slug: string;
    isCustomer: boolean;
    supportGroup?: number | null;
    websiteDomain?: string | null;
    logoS3Key?: string | null;
    logoDownloadURL?: string | null;
  }>;
};

export type VisibleMarketingChangelogsQueryVariables = Exact<{ [key: string]: never }>;

export type VisibleMarketingChangelogsQuery = {
  __typename?: 'Query';
  visibleMarketingChangelogEntries: Array<{
    __typename?: 'MarketingChangelogEntry';
    UUID: string;
    heading: string;
    copy?: string | null;
    linkURL?: string | null;
    imageS3Keys?: {
      __typename?: 'ThemedImageS3Keys';
      lightS3Key: string;
      darkS3Key: string;
    } | null;
    badge?: { __typename?: 'DisplayBadge'; icon?: string | null; text?: string | null } | null;
  }>;
};

export type ClientVpnServerFieldsFragment = {
  __typename?: 'ClientVPNServer';
  UUID: string;
  isEnabled: boolean;
  name: string;
  endpoint: string;
  publicKey: string;
  port: number;
  defaultClientAllowedIPs?: Array<string> | null;
  address?: string | null;
  addressMask?: number | null;
  dnsListenAddress?: string | null;
  isFailoverEnabled: boolean;
  phyInterface?: {
    __typename: 'PhyInterface';
    UUID: string;
    portNumber: number;
    label?: string | null;
    hardwareLabel?: string | null;
    virtualDevice:
      | {
          __typename?: 'AccessPointVirtualDevice';
          UUID: string;
          label: string;
          deviceModel: DeviceModel;
        }
      | {
          __typename?: 'ControllerVirtualDevice';
          UUID: string;
          label: string;
          deviceModel: DeviceModel;
        }
      | {
          __typename?: 'ObserverVirtualDevice';
          UUID: string;
          label: string;
          deviceModel: DeviceModel;
        }
      | {
          __typename?: 'PowerDistributionUnitVirtualDevice';
          UUID: string;
          label: string;
          deviceModel: DeviceModel;
        }
      | {
          __typename?: 'SwitchVirtualDevice';
          UUID: string;
          label: string;
          deviceModel: DeviceModel;
        };
    internetServicePlan?: {
      __typename?: 'InternetServicePlan';
      UUID: string;
      provider?: { __typename?: 'InternetServicePlanProvider'; name: string } | null;
    } | null;
  } | null;
  clients: Array<{
    __typename?: 'ClientVPNClient';
    UUID: string;
    isEnabled: boolean;
    createdAt: string;
    createdBy: string;
    ipAddress: string;
    name: string;
    publicKey: string;
    userEmail: string;
    userSID: string;
    vpnServerUUID: string;
    isConnected: boolean;
    connectionInfo?: {
      __typename?: 'ClientVPNClientConnectionInfo';
      observedAt?: string | null;
      lastHandshakeTx?: string | null;
      lastHandshakeRx?: string | null;
      lastPacketTx?: string | null;
      lastPacketRx?: string | null;
    } | null;
  }>;
  boundVLANs?: Array<{
    __typename?: 'VLAN';
    UUID: string;
    name: string;
    vlanID: number;
    ipV4ClientAssignmentProtocol?: ClientAssignmentProtocol | null;
    ipV4ClientGateway?: string | null;
    ipV4ClientPrefixLength?: number | null;
  }> | null;
};

export type ClientVpnServerQueryVariables = Exact<{
  UUID: Scalars['UUID']['input'];
}>;

export type ClientVpnServerQuery = {
  __typename?: 'Query';
  clientVPNServer: {
    __typename?: 'ClientVPNServer';
    UUID: string;
    isEnabled: boolean;
    name: string;
    endpoint: string;
    publicKey: string;
    port: number;
    defaultClientAllowedIPs?: Array<string> | null;
    address?: string | null;
    addressMask?: number | null;
    dnsListenAddress?: string | null;
    isFailoverEnabled: boolean;
    phyInterface?: {
      __typename: 'PhyInterface';
      UUID: string;
      portNumber: number;
      label?: string | null;
      hardwareLabel?: string | null;
      virtualDevice:
        | {
            __typename?: 'AccessPointVirtualDevice';
            UUID: string;
            label: string;
            deviceModel: DeviceModel;
          }
        | {
            __typename?: 'ControllerVirtualDevice';
            UUID: string;
            label: string;
            deviceModel: DeviceModel;
          }
        | {
            __typename?: 'ObserverVirtualDevice';
            UUID: string;
            label: string;
            deviceModel: DeviceModel;
          }
        | {
            __typename?: 'PowerDistributionUnitVirtualDevice';
            UUID: string;
            label: string;
            deviceModel: DeviceModel;
          }
        | {
            __typename?: 'SwitchVirtualDevice';
            UUID: string;
            label: string;
            deviceModel: DeviceModel;
          };
      internetServicePlan?: {
        __typename?: 'InternetServicePlan';
        UUID: string;
        provider?: { __typename?: 'InternetServicePlanProvider'; name: string } | null;
      } | null;
    } | null;
    clients: Array<{
      __typename?: 'ClientVPNClient';
      UUID: string;
      isEnabled: boolean;
      createdAt: string;
      createdBy: string;
      ipAddress: string;
      name: string;
      publicKey: string;
      userEmail: string;
      userSID: string;
      vpnServerUUID: string;
      isConnected: boolean;
      connectionInfo?: {
        __typename?: 'ClientVPNClientConnectionInfo';
        observedAt?: string | null;
        lastHandshakeTx?: string | null;
        lastHandshakeRx?: string | null;
        lastPacketTx?: string | null;
        lastPacketRx?: string | null;
      } | null;
    }>;
    boundVLANs?: Array<{
      __typename?: 'VLAN';
      UUID: string;
      name: string;
      vlanID: number;
      ipV4ClientAssignmentProtocol?: ClientAssignmentProtocol | null;
      ipV4ClientGateway?: string | null;
      ipV4ClientPrefixLength?: number | null;
    }> | null;
  };
};

export type ClientVpnServersQueryVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
}>;

export type ClientVpnServersQuery = {
  __typename?: 'Query';
  clientVPNServers: Array<{
    __typename?: 'ClientVPNServer';
    UUID: string;
    isEnabled: boolean;
    name: string;
    endpoint: string;
    publicKey: string;
    port: number;
    defaultClientAllowedIPs?: Array<string> | null;
    address?: string | null;
    addressMask?: number | null;
    dnsListenAddress?: string | null;
    isFailoverEnabled: boolean;
    phyInterface?: {
      __typename: 'PhyInterface';
      UUID: string;
      portNumber: number;
      label?: string | null;
      hardwareLabel?: string | null;
      virtualDevice:
        | {
            __typename?: 'AccessPointVirtualDevice';
            UUID: string;
            label: string;
            deviceModel: DeviceModel;
          }
        | {
            __typename?: 'ControllerVirtualDevice';
            UUID: string;
            label: string;
            deviceModel: DeviceModel;
          }
        | {
            __typename?: 'ObserverVirtualDevice';
            UUID: string;
            label: string;
            deviceModel: DeviceModel;
          }
        | {
            __typename?: 'PowerDistributionUnitVirtualDevice';
            UUID: string;
            label: string;
            deviceModel: DeviceModel;
          }
        | {
            __typename?: 'SwitchVirtualDevice';
            UUID: string;
            label: string;
            deviceModel: DeviceModel;
          };
      internetServicePlan?: {
        __typename?: 'InternetServicePlan';
        UUID: string;
        provider?: { __typename?: 'InternetServicePlanProvider'; name: string } | null;
      } | null;
    } | null;
    clients: Array<{
      __typename?: 'ClientVPNClient';
      UUID: string;
      isEnabled: boolean;
      createdAt: string;
      createdBy: string;
      ipAddress: string;
      name: string;
      publicKey: string;
      userEmail: string;
      userSID: string;
      vpnServerUUID: string;
      isConnected: boolean;
      connectionInfo?: {
        __typename?: 'ClientVPNClientConnectionInfo';
        observedAt?: string | null;
        lastHandshakeTx?: string | null;
        lastHandshakeRx?: string | null;
        lastPacketTx?: string | null;
        lastPacketRx?: string | null;
      } | null;
    }>;
    boundVLANs?: Array<{
      __typename?: 'VLAN';
      UUID: string;
      name: string;
      vlanID: number;
      ipV4ClientAssignmentProtocol?: ClientAssignmentProtocol | null;
      ipV4ClientGateway?: string | null;
      ipV4ClientPrefixLength?: number | null;
    }> | null;
  }>;
};

export type CreateClientVpnServerMutationVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
  input: CreateClientVpnServerInput;
}>;

export type CreateClientVpnServerMutation = {
  __typename?: 'Mutation';
  createClientVPNServer: { __typename?: 'ClientVPNServer'; UUID: string };
};

export type UpdateClientVpnServerMutationVariables = Exact<{
  uuid: Scalars['UUID']['input'];
  input: UpdateClientVpnServerInput;
}>;

export type UpdateClientVpnServerMutation = {
  __typename?: 'Mutation';
  updateClientVPNServer: { __typename?: 'ClientVPNServer'; UUID: string };
};

export type DeleteClientVpnServerMutationVariables = Exact<{
  uuid: Scalars['UUID']['input'];
}>;

export type DeleteClientVpnServerMutation = {
  __typename?: 'Mutation';
  deleteClientVPNServer: boolean;
};

export type ClientVpnClientFieldsFragment = {
  __typename?: 'ClientVPNClient';
  UUID: string;
  isEnabled: boolean;
  createdAt: string;
  createdBy: string;
  ipAddress: string;
  name: string;
  publicKey: string;
  userEmail: string;
  userSID: string;
  vpnServerUUID: string;
  isConnected: boolean;
  connectionInfo?: {
    __typename?: 'ClientVPNClientConnectionInfo';
    observedAt?: string | null;
    lastHandshakeTx?: string | null;
    lastHandshakeRx?: string | null;
    lastPacketTx?: string | null;
    lastPacketRx?: string | null;
  } | null;
};

export type ClientVpnClientsQueryVariables = Exact<{
  serverUUID: Scalars['UUID']['input'];
}>;

export type ClientVpnClientsQuery = {
  __typename?: 'Query';
  clientVPNClients: Array<{
    __typename?: 'ClientVPNClient';
    UUID: string;
    isEnabled: boolean;
    createdAt: string;
    createdBy: string;
    ipAddress: string;
    name: string;
    publicKey: string;
    userEmail: string;
    userSID: string;
    vpnServerUUID: string;
    isConnected: boolean;
    connectionInfo?: {
      __typename?: 'ClientVPNClientConnectionInfo';
      observedAt?: string | null;
      lastHandshakeTx?: string | null;
      lastHandshakeRx?: string | null;
      lastPacketTx?: string | null;
      lastPacketRx?: string | null;
    } | null;
  }>;
};

export type ClientVpnClientQueryVariables = Exact<{
  UUID: Scalars['UUID']['input'];
}>;

export type ClientVpnClientQuery = {
  __typename?: 'Query';
  clientVPNClient: {
    __typename?: 'ClientVPNClient';
    UUID: string;
    isEnabled: boolean;
    createdAt: string;
    createdBy: string;
    ipAddress: string;
    name: string;
    publicKey: string;
    userEmail: string;
    userSID: string;
    vpnServerUUID: string;
    isConnected: boolean;
    connectionInfo?: {
      __typename?: 'ClientVPNClientConnectionInfo';
      observedAt?: string | null;
      lastHandshakeTx?: string | null;
      lastHandshakeRx?: string | null;
      lastPacketTx?: string | null;
      lastPacketRx?: string | null;
    } | null;
  };
};

export type CreateClientVpnClientMutationVariables = Exact<{
  serverUUID: Scalars['UUID']['input'];
  input: CreateClientVpnClientInput;
}>;

export type CreateClientVpnClientMutation = {
  __typename?: 'Mutation';
  createClientVPNClient: {
    __typename?: 'ClientVPNClient';
    UUID: string;
    createdAt: string;
    createdBy: string;
    ipAddress: string;
    name: string;
    publicKey: string;
    userEmail: string;
    userSID: string;
  };
};

export type UpdateClientVpnClientMutationVariables = Exact<{
  uuid: Scalars['UUID']['input'];
  input: UpdateClientVpnClientInput;
}>;

export type UpdateClientVpnClientMutation = {
  __typename?: 'Mutation';
  updateClientVPNClient: { __typename?: 'ClientVPNClient'; UUID: string };
};

export type DeleteClientVpnClientMutationVariables = Exact<{
  uuid: Scalars['UUID']['input'];
}>;

export type DeleteClientVpnClientMutation = {
  __typename?: 'Mutation';
  deleteClientVPNClient: boolean;
};

export type CreateRackElevationMutationVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
  label: Scalars['String']['input'];
  rackMountUnitCount: Scalars['Int']['input'];
}>;

export type CreateRackElevationMutation = {
  __typename?: 'Mutation';
  createRackElevation: {
    __typename?: 'RackElevation';
    UUID: string;
    networkUUID: string;
    rackMountUnitCount: number;
    label: string;
  };
};

export type AttachDeviceToRackElevationMutationVariables = Exact<{
  rackElevationUUID: Scalars['UUID']['input'];
  rackMountUnitIndexes: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
  virtualDeviceUUID?: InputMaybe<Scalars['UUID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<RackElevationDeviceType>;
}>;

export type AttachDeviceToRackElevationMutation = {
  __typename?: 'Mutation';
  attachDeviceToRackElevation: {
    __typename?: 'RackElevation';
    UUID: string;
    label: string;
    rackMountUnitCount: number;
    devices: Array<{
      __typename?: 'RackElevationDevice';
      UUID: string;
      label?: string | null;
      rackMountUnitIndexes: Array<number>;
      type: RackElevationDeviceType;
      virtualDeviceUUID?: string | null;
    }>;
  };
};

export type DetachRackElevationDeviceMutationVariables = Exact<{
  UUID: Scalars['UUID']['input'];
}>;

export type DetachRackElevationDeviceMutation = {
  __typename?: 'Mutation';
  detachDeviceFromRackElevation: boolean;
};

export type RackElevationFieldsFragment = {
  __typename?: 'RackElevation';
  UUID: string;
  label: string;
  rackMountUnitCount: number;
  networkUUID: string;
  devices: Array<{
    __typename?: 'RackElevationDevice';
    UUID: string;
    label?: string | null;
    rackMountUnitIndexes: Array<number>;
    type: RackElevationDeviceType;
    virtualDeviceUUID?: string | null;
    virtualDevice?:
      | {
          __typename?: 'AccessPointVirtualDevice';
          UUID: string;
          label: string;
          deviceType: VirtualDeviceType;
          deviceModel: DeviceModel;
          description?: string | null;
          hardwareDevice?:
            | {
                __typename?: 'AccessPointHardwareDevice';
                serialNumber: string;
                deviceType: DeviceType;
                deviceModel: DeviceModel;
              }
            | {
                __typename?: 'ControllerHardwareDevice';
                serialNumber: string;
                deviceType: DeviceType;
                deviceModel: DeviceModel;
              }
            | {
                __typename?: 'PowerDistributionUnitHardwareDevice';
                serialNumber: string;
                deviceType: DeviceType;
                deviceModel: DeviceModel;
              }
            | {
                __typename?: 'SwitchHardwareDevice';
                serialNumber: string;
                deviceType: DeviceType;
                deviceModel: DeviceModel;
              }
            | null;
        }
      | {
          __typename?: 'ControllerVirtualDevice';
          UUID: string;
          label: string;
          deviceType: VirtualDeviceType;
          deviceModel: DeviceModel;
          description?: string | null;
          hardwareDevice?:
            | {
                __typename?: 'AccessPointHardwareDevice';
                serialNumber: string;
                deviceType: DeviceType;
                deviceModel: DeviceModel;
              }
            | {
                __typename?: 'ControllerHardwareDevice';
                serialNumber: string;
                deviceType: DeviceType;
                deviceModel: DeviceModel;
              }
            | {
                __typename?: 'PowerDistributionUnitHardwareDevice';
                serialNumber: string;
                deviceType: DeviceType;
                deviceModel: DeviceModel;
              }
            | {
                __typename?: 'SwitchHardwareDevice';
                serialNumber: string;
                deviceType: DeviceType;
                deviceModel: DeviceModel;
              }
            | null;
        }
      | {
          __typename?: 'ObserverVirtualDevice';
          UUID: string;
          label: string;
          deviceType: VirtualDeviceType;
          deviceModel: DeviceModel;
          description?: string | null;
          hardwareDevice?:
            | {
                __typename?: 'AccessPointHardwareDevice';
                serialNumber: string;
                deviceType: DeviceType;
                deviceModel: DeviceModel;
              }
            | {
                __typename?: 'ControllerHardwareDevice';
                serialNumber: string;
                deviceType: DeviceType;
                deviceModel: DeviceModel;
              }
            | {
                __typename?: 'PowerDistributionUnitHardwareDevice';
                serialNumber: string;
                deviceType: DeviceType;
                deviceModel: DeviceModel;
              }
            | {
                __typename?: 'SwitchHardwareDevice';
                serialNumber: string;
                deviceType: DeviceType;
                deviceModel: DeviceModel;
              }
            | null;
        }
      | {
          __typename?: 'PowerDistributionUnitVirtualDevice';
          UUID: string;
          label: string;
          deviceType: VirtualDeviceType;
          deviceModel: DeviceModel;
          description?: string | null;
          hardwareDevice?:
            | {
                __typename?: 'AccessPointHardwareDevice';
                serialNumber: string;
                deviceType: DeviceType;
                deviceModel: DeviceModel;
              }
            | {
                __typename?: 'ControllerHardwareDevice';
                serialNumber: string;
                deviceType: DeviceType;
                deviceModel: DeviceModel;
              }
            | {
                __typename?: 'PowerDistributionUnitHardwareDevice';
                serialNumber: string;
                deviceType: DeviceType;
                deviceModel: DeviceModel;
              }
            | {
                __typename?: 'SwitchHardwareDevice';
                serialNumber: string;
                deviceType: DeviceType;
                deviceModel: DeviceModel;
              }
            | null;
        }
      | {
          __typename?: 'SwitchVirtualDevice';
          UUID: string;
          label: string;
          deviceType: VirtualDeviceType;
          deviceModel: DeviceModel;
          description?: string | null;
          phyInterfaces: Array<{
            __typename?: 'PhyInterface';
            isConnected: boolean;
            portNumber: number;
            isEthernet: boolean;
            isSFP: boolean;
          }>;
          hardwareDevice?:
            | {
                __typename?: 'AccessPointHardwareDevice';
                serialNumber: string;
                deviceType: DeviceType;
                deviceModel: DeviceModel;
              }
            | {
                __typename?: 'ControllerHardwareDevice';
                serialNumber: string;
                deviceType: DeviceType;
                deviceModel: DeviceModel;
              }
            | {
                __typename?: 'PowerDistributionUnitHardwareDevice';
                serialNumber: string;
                deviceType: DeviceType;
                deviceModel: DeviceModel;
              }
            | {
                __typename?: 'SwitchHardwareDevice';
                serialNumber: string;
                deviceType: DeviceType;
                deviceModel: DeviceModel;
              }
            | null;
        }
      | null;
  }>;
  notes?: Array<{
    __typename?: 'RackElevationNote';
    rackMountUnitIndexStart: number;
    rackMountUnitIndexEnd: number;
    note: string;
  }> | null;
};

export type RackElevationQueryVariables = Exact<{
  UUID: Scalars['UUID']['input'];
}>;

export type RackElevationQuery = {
  __typename?: 'Query';
  rackElevation: {
    __typename?: 'RackElevation';
    UUID: string;
    label: string;
    rackMountUnitCount: number;
    networkUUID: string;
    devices: Array<{
      __typename?: 'RackElevationDevice';
      UUID: string;
      label?: string | null;
      rackMountUnitIndexes: Array<number>;
      type: RackElevationDeviceType;
      virtualDeviceUUID?: string | null;
      virtualDevice?:
        | {
            __typename?: 'AccessPointVirtualDevice';
            UUID: string;
            label: string;
            deviceType: VirtualDeviceType;
            deviceModel: DeviceModel;
            description?: string | null;
            hardwareDevice?:
              | {
                  __typename?: 'AccessPointHardwareDevice';
                  serialNumber: string;
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                }
              | {
                  __typename?: 'ControllerHardwareDevice';
                  serialNumber: string;
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                }
              | {
                  __typename?: 'PowerDistributionUnitHardwareDevice';
                  serialNumber: string;
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                }
              | {
                  __typename?: 'SwitchHardwareDevice';
                  serialNumber: string;
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                }
              | null;
          }
        | {
            __typename?: 'ControllerVirtualDevice';
            UUID: string;
            label: string;
            deviceType: VirtualDeviceType;
            deviceModel: DeviceModel;
            description?: string | null;
            hardwareDevice?:
              | {
                  __typename?: 'AccessPointHardwareDevice';
                  serialNumber: string;
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                }
              | {
                  __typename?: 'ControllerHardwareDevice';
                  serialNumber: string;
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                }
              | {
                  __typename?: 'PowerDistributionUnitHardwareDevice';
                  serialNumber: string;
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                }
              | {
                  __typename?: 'SwitchHardwareDevice';
                  serialNumber: string;
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                }
              | null;
          }
        | {
            __typename?: 'ObserverVirtualDevice';
            UUID: string;
            label: string;
            deviceType: VirtualDeviceType;
            deviceModel: DeviceModel;
            description?: string | null;
            hardwareDevice?:
              | {
                  __typename?: 'AccessPointHardwareDevice';
                  serialNumber: string;
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                }
              | {
                  __typename?: 'ControllerHardwareDevice';
                  serialNumber: string;
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                }
              | {
                  __typename?: 'PowerDistributionUnitHardwareDevice';
                  serialNumber: string;
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                }
              | {
                  __typename?: 'SwitchHardwareDevice';
                  serialNumber: string;
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                }
              | null;
          }
        | {
            __typename?: 'PowerDistributionUnitVirtualDevice';
            UUID: string;
            label: string;
            deviceType: VirtualDeviceType;
            deviceModel: DeviceModel;
            description?: string | null;
            hardwareDevice?:
              | {
                  __typename?: 'AccessPointHardwareDevice';
                  serialNumber: string;
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                }
              | {
                  __typename?: 'ControllerHardwareDevice';
                  serialNumber: string;
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                }
              | {
                  __typename?: 'PowerDistributionUnitHardwareDevice';
                  serialNumber: string;
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                }
              | {
                  __typename?: 'SwitchHardwareDevice';
                  serialNumber: string;
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                }
              | null;
          }
        | {
            __typename?: 'SwitchVirtualDevice';
            UUID: string;
            label: string;
            deviceType: VirtualDeviceType;
            deviceModel: DeviceModel;
            description?: string | null;
            phyInterfaces: Array<{
              __typename?: 'PhyInterface';
              isConnected: boolean;
              portNumber: number;
              isEthernet: boolean;
              isSFP: boolean;
            }>;
            hardwareDevice?:
              | {
                  __typename?: 'AccessPointHardwareDevice';
                  serialNumber: string;
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                }
              | {
                  __typename?: 'ControllerHardwareDevice';
                  serialNumber: string;
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                }
              | {
                  __typename?: 'PowerDistributionUnitHardwareDevice';
                  serialNumber: string;
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                }
              | {
                  __typename?: 'SwitchHardwareDevice';
                  serialNumber: string;
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                }
              | null;
          }
        | null;
    }>;
    notes?: Array<{
      __typename?: 'RackElevationNote';
      rackMountUnitIndexStart: number;
      rackMountUnitIndexEnd: number;
      note: string;
    }> | null;
  };
};

export type RackElevationsQueryVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
}>;

export type RackElevationsQuery = {
  __typename?: 'Query';
  rackElevations: Array<{
    __typename?: 'RackElevation';
    UUID: string;
    label: string;
    rackMountUnitCount: number;
    networkUUID: string;
    devices: Array<{
      __typename?: 'RackElevationDevice';
      UUID: string;
      label?: string | null;
      rackMountUnitIndexes: Array<number>;
      type: RackElevationDeviceType;
      virtualDeviceUUID?: string | null;
      virtualDevice?:
        | {
            __typename?: 'AccessPointVirtualDevice';
            UUID: string;
            label: string;
            deviceType: VirtualDeviceType;
            deviceModel: DeviceModel;
            description?: string | null;
            hardwareDevice?:
              | {
                  __typename?: 'AccessPointHardwareDevice';
                  serialNumber: string;
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                }
              | {
                  __typename?: 'ControllerHardwareDevice';
                  serialNumber: string;
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                }
              | {
                  __typename?: 'PowerDistributionUnitHardwareDevice';
                  serialNumber: string;
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                }
              | {
                  __typename?: 'SwitchHardwareDevice';
                  serialNumber: string;
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                }
              | null;
          }
        | {
            __typename?: 'ControllerVirtualDevice';
            UUID: string;
            label: string;
            deviceType: VirtualDeviceType;
            deviceModel: DeviceModel;
            description?: string | null;
            hardwareDevice?:
              | {
                  __typename?: 'AccessPointHardwareDevice';
                  serialNumber: string;
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                }
              | {
                  __typename?: 'ControllerHardwareDevice';
                  serialNumber: string;
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                }
              | {
                  __typename?: 'PowerDistributionUnitHardwareDevice';
                  serialNumber: string;
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                }
              | {
                  __typename?: 'SwitchHardwareDevice';
                  serialNumber: string;
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                }
              | null;
          }
        | {
            __typename?: 'ObserverVirtualDevice';
            UUID: string;
            label: string;
            deviceType: VirtualDeviceType;
            deviceModel: DeviceModel;
            description?: string | null;
            hardwareDevice?:
              | {
                  __typename?: 'AccessPointHardwareDevice';
                  serialNumber: string;
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                }
              | {
                  __typename?: 'ControllerHardwareDevice';
                  serialNumber: string;
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                }
              | {
                  __typename?: 'PowerDistributionUnitHardwareDevice';
                  serialNumber: string;
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                }
              | {
                  __typename?: 'SwitchHardwareDevice';
                  serialNumber: string;
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                }
              | null;
          }
        | {
            __typename?: 'PowerDistributionUnitVirtualDevice';
            UUID: string;
            label: string;
            deviceType: VirtualDeviceType;
            deviceModel: DeviceModel;
            description?: string | null;
            hardwareDevice?:
              | {
                  __typename?: 'AccessPointHardwareDevice';
                  serialNumber: string;
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                }
              | {
                  __typename?: 'ControllerHardwareDevice';
                  serialNumber: string;
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                }
              | {
                  __typename?: 'PowerDistributionUnitHardwareDevice';
                  serialNumber: string;
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                }
              | {
                  __typename?: 'SwitchHardwareDevice';
                  serialNumber: string;
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                }
              | null;
          }
        | {
            __typename?: 'SwitchVirtualDevice';
            UUID: string;
            label: string;
            deviceType: VirtualDeviceType;
            deviceModel: DeviceModel;
            description?: string | null;
            phyInterfaces: Array<{
              __typename?: 'PhyInterface';
              isConnected: boolean;
              portNumber: number;
              isEthernet: boolean;
              isSFP: boolean;
            }>;
            hardwareDevice?:
              | {
                  __typename?: 'AccessPointHardwareDevice';
                  serialNumber: string;
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                }
              | {
                  __typename?: 'ControllerHardwareDevice';
                  serialNumber: string;
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                }
              | {
                  __typename?: 'PowerDistributionUnitHardwareDevice';
                  serialNumber: string;
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                }
              | {
                  __typename?: 'SwitchHardwareDevice';
                  serialNumber: string;
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                }
              | null;
          }
        | null;
    }>;
    notes?: Array<{
      __typename?: 'RackElevationNote';
      rackMountUnitIndexStart: number;
      rackMountUnitIndexEnd: number;
      note: string;
    }> | null;
  }>;
};

export type UpdateRackNotesMutationVariables = Exact<{
  rackElevationUUID: Scalars['UUID']['input'];
  notes?: InputMaybe<Array<RackElevationNoteInput> | RackElevationNoteInput>;
}>;

export type UpdateRackNotesMutation = {
  __typename?: 'Mutation';
  updateRackElevation: {
    __typename?: 'RackElevation';
    UUID: string;
    label: string;
    rackMountUnitCount: number;
    devices: Array<{
      __typename?: 'RackElevationDevice';
      UUID: string;
      label?: string | null;
      rackMountUnitIndexes: Array<number>;
      type: RackElevationDeviceType;
      virtualDeviceUUID?: string | null;
    }>;
  };
};

export type VirtualDevicesForNetworkQueryVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
  filter?: InputMaybe<DevicesForNetworkFilter>;
}>;

export type VirtualDevicesForNetworkQuery = {
  __typename?: 'Query';
  virtualDevicesForNetwork: Array<
    | {
        __typename?: 'AccessPointVirtualDevice';
        UUID: string;
        networkUUID: string;
        description?: string | null;
        label: string;
        deviceType: VirtualDeviceType;
        deviceModel: DeviceModel;
        hardwareDevice?:
          | {
              __typename?: 'AccessPointHardwareDevice';
              serialNumber: string;
              deviceType: DeviceType;
              deviceModel: DeviceModel;
              isActive: boolean;
            }
          | {
              __typename?: 'ControllerHardwareDevice';
              serialNumber: string;
              deviceType: DeviceType;
              deviceModel: DeviceModel;
              isActive: boolean;
            }
          | {
              __typename?: 'PowerDistributionUnitHardwareDevice';
              serialNumber: string;
              deviceType: DeviceType;
              deviceModel: DeviceModel;
              isActive: boolean;
            }
          | {
              __typename?: 'SwitchHardwareDevice';
              serialNumber: string;
              deviceType: DeviceType;
              deviceModel: DeviceModel;
              isActive: boolean;
            }
          | null;
      }
    | {
        __typename?: 'ControllerVirtualDevice';
        UUID: string;
        networkUUID: string;
        description?: string | null;
        label: string;
        deviceType: VirtualDeviceType;
        deviceModel: DeviceModel;
        hardwareDevice?:
          | {
              __typename?: 'AccessPointHardwareDevice';
              serialNumber: string;
              deviceType: DeviceType;
              deviceModel: DeviceModel;
              isActive: boolean;
            }
          | {
              __typename?: 'ControllerHardwareDevice';
              serialNumber: string;
              deviceType: DeviceType;
              deviceModel: DeviceModel;
              isActive: boolean;
            }
          | {
              __typename?: 'PowerDistributionUnitHardwareDevice';
              serialNumber: string;
              deviceType: DeviceType;
              deviceModel: DeviceModel;
              isActive: boolean;
            }
          | {
              __typename?: 'SwitchHardwareDevice';
              serialNumber: string;
              deviceType: DeviceType;
              deviceModel: DeviceModel;
              isActive: boolean;
            }
          | null;
      }
    | {
        __typename?: 'ObserverVirtualDevice';
        UUID: string;
        networkUUID: string;
        description?: string | null;
        label: string;
        deviceType: VirtualDeviceType;
        deviceModel: DeviceModel;
        hardwareDevice?:
          | {
              __typename?: 'AccessPointHardwareDevice';
              serialNumber: string;
              deviceType: DeviceType;
              deviceModel: DeviceModel;
              isActive: boolean;
            }
          | {
              __typename?: 'ControllerHardwareDevice';
              serialNumber: string;
              deviceType: DeviceType;
              deviceModel: DeviceModel;
              isActive: boolean;
            }
          | {
              __typename?: 'PowerDistributionUnitHardwareDevice';
              serialNumber: string;
              deviceType: DeviceType;
              deviceModel: DeviceModel;
              isActive: boolean;
            }
          | {
              __typename?: 'SwitchHardwareDevice';
              serialNumber: string;
              deviceType: DeviceType;
              deviceModel: DeviceModel;
              isActive: boolean;
            }
          | null;
      }
    | {
        __typename?: 'PowerDistributionUnitVirtualDevice';
        UUID: string;
        networkUUID: string;
        description?: string | null;
        label: string;
        deviceType: VirtualDeviceType;
        deviceModel: DeviceModel;
        hardwareDevice?:
          | {
              __typename?: 'AccessPointHardwareDevice';
              serialNumber: string;
              deviceType: DeviceType;
              deviceModel: DeviceModel;
              isActive: boolean;
            }
          | {
              __typename?: 'ControllerHardwareDevice';
              serialNumber: string;
              deviceType: DeviceType;
              deviceModel: DeviceModel;
              isActive: boolean;
            }
          | {
              __typename?: 'PowerDistributionUnitHardwareDevice';
              serialNumber: string;
              deviceType: DeviceType;
              deviceModel: DeviceModel;
              isActive: boolean;
            }
          | {
              __typename?: 'SwitchHardwareDevice';
              serialNumber: string;
              deviceType: DeviceType;
              deviceModel: DeviceModel;
              isActive: boolean;
            }
          | null;
      }
    | {
        __typename?: 'SwitchVirtualDevice';
        UUID: string;
        networkUUID: string;
        description?: string | null;
        label: string;
        deviceType: VirtualDeviceType;
        deviceModel: DeviceModel;
        hardwareDevice?:
          | {
              __typename?: 'AccessPointHardwareDevice';
              serialNumber: string;
              deviceType: DeviceType;
              deviceModel: DeviceModel;
              isActive: boolean;
            }
          | {
              __typename?: 'ControllerHardwareDevice';
              serialNumber: string;
              deviceType: DeviceType;
              deviceModel: DeviceModel;
              isActive: boolean;
            }
          | {
              __typename?: 'PowerDistributionUnitHardwareDevice';
              serialNumber: string;
              deviceType: DeviceType;
              deviceModel: DeviceModel;
              isActive: boolean;
            }
          | {
              __typename?: 'SwitchHardwareDevice';
              serialNumber: string;
              deviceType: DeviceType;
              deviceModel: DeviceModel;
              isActive: boolean;
            }
          | null;
      }
  >;
};

export type UpdateRackElevationDeviceMutationVariables = Exact<{
  UUID: Scalars['UUID']['input'];
  input: UpdateRackElevationDeviceInput;
}>;

export type UpdateRackElevationDeviceMutation = {
  __typename?: 'Mutation';
  updateRackElevationDevice: {
    __typename?: 'RackElevation';
    UUID: string;
    label: string;
    rackMountUnitCount: number;
    devices: Array<{
      __typename?: 'RackElevationDevice';
      UUID: string;
      label?: string | null;
      rackMountUnitIndexes: Array<number>;
      type: RackElevationDeviceType;
      virtualDeviceUUID?: string | null;
    }>;
  };
};

export type UpdateRackElevationMutationVariables = Exact<{
  UUID: Scalars['UUID']['input'];
  input: UpdateRackElevationInput;
}>;

export type UpdateRackElevationMutation = {
  __typename?: 'Mutation';
  updateRackElevation: {
    __typename?: 'RackElevation';
    UUID: string;
    label: string;
    rackMountUnitCount: number;
  };
};

export type DeleteRackElevationMutationMutationVariables = Exact<{
  UUID: Scalars['UUID']['input'];
}>;

export type DeleteRackElevationMutationMutation = {
  __typename?: 'Mutation';
  deleteRackElevation: boolean;
};

export type DeviceConfigMetadataFieldsFragment = {
  __typename?: 'DeviceConfigMetadata';
  version: number;
  acknowledgedAt?: string | null;
  createdAt: string;
  isCurrentAsOf?: string | null;
  hardwareDevice:
    | {
        __typename?: 'AccessPointHardwareDevice';
        serialNumber: string;
        deviceType: DeviceType;
        virtualDevice?:
          | { __typename: 'AccessPointVirtualDevice'; UUID: string; label: string }
          | { __typename: 'ControllerVirtualDevice'; UUID: string; label: string }
          | { __typename: 'ObserverVirtualDevice'; UUID: string; label: string }
          | { __typename: 'PowerDistributionUnitVirtualDevice'; UUID: string; label: string }
          | { __typename: 'SwitchVirtualDevice'; UUID: string; label: string }
          | null;
      }
    | {
        __typename?: 'ControllerHardwareDevice';
        serialNumber: string;
        deviceType: DeviceType;
        virtualDevice?:
          | { __typename: 'AccessPointVirtualDevice'; UUID: string; label: string }
          | { __typename: 'ControllerVirtualDevice'; UUID: string; label: string }
          | { __typename: 'ObserverVirtualDevice'; UUID: string; label: string }
          | { __typename: 'PowerDistributionUnitVirtualDevice'; UUID: string; label: string }
          | { __typename: 'SwitchVirtualDevice'; UUID: string; label: string }
          | null;
      }
    | {
        __typename?: 'PowerDistributionUnitHardwareDevice';
        serialNumber: string;
        deviceType: DeviceType;
        virtualDevice?:
          | { __typename: 'AccessPointVirtualDevice'; UUID: string; label: string }
          | { __typename: 'ControllerVirtualDevice'; UUID: string; label: string }
          | { __typename: 'ObserverVirtualDevice'; UUID: string; label: string }
          | { __typename: 'PowerDistributionUnitVirtualDevice'; UUID: string; label: string }
          | { __typename: 'SwitchVirtualDevice'; UUID: string; label: string }
          | null;
      }
    | {
        __typename?: 'SwitchHardwareDevice';
        serialNumber: string;
        deviceType: DeviceType;
        virtualDevice?:
          | { __typename: 'AccessPointVirtualDevice'; UUID: string; label: string }
          | { __typename: 'ControllerVirtualDevice'; UUID: string; label: string }
          | { __typename: 'ObserverVirtualDevice'; UUID: string; label: string }
          | { __typename: 'PowerDistributionUnitVirtualDevice'; UUID: string; label: string }
          | { __typename: 'SwitchVirtualDevice'; UUID: string; label: string }
          | null;
      };
  state?: {
    __typename?: 'DeviceConfigState';
    state: DeviceConfigStateType;
    timestamp: string;
  } | null;
};

export type DevicesConfigsQueryQueryVariables = Exact<{
  serialNumbers: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;

export type DevicesConfigsQueryQuery = {
  __typename?: 'Query';
  deviceConfigs: Array<{
    __typename?: 'DeviceConfigMetadata';
    version: number;
    acknowledgedAt?: string | null;
    createdAt: string;
    isCurrentAsOf?: string | null;
    hardwareDevice:
      | {
          __typename?: 'AccessPointHardwareDevice';
          serialNumber: string;
          deviceType: DeviceType;
          virtualDevice?:
            | { __typename: 'AccessPointVirtualDevice'; UUID: string; label: string }
            | { __typename: 'ControllerVirtualDevice'; UUID: string; label: string }
            | { __typename: 'ObserverVirtualDevice'; UUID: string; label: string }
            | { __typename: 'PowerDistributionUnitVirtualDevice'; UUID: string; label: string }
            | { __typename: 'SwitchVirtualDevice'; UUID: string; label: string }
            | null;
        }
      | {
          __typename?: 'ControllerHardwareDevice';
          serialNumber: string;
          deviceType: DeviceType;
          virtualDevice?:
            | { __typename: 'AccessPointVirtualDevice'; UUID: string; label: string }
            | { __typename: 'ControllerVirtualDevice'; UUID: string; label: string }
            | { __typename: 'ObserverVirtualDevice'; UUID: string; label: string }
            | { __typename: 'PowerDistributionUnitVirtualDevice'; UUID: string; label: string }
            | { __typename: 'SwitchVirtualDevice'; UUID: string; label: string }
            | null;
        }
      | {
          __typename?: 'PowerDistributionUnitHardwareDevice';
          serialNumber: string;
          deviceType: DeviceType;
          virtualDevice?:
            | { __typename: 'AccessPointVirtualDevice'; UUID: string; label: string }
            | { __typename: 'ControllerVirtualDevice'; UUID: string; label: string }
            | { __typename: 'ObserverVirtualDevice'; UUID: string; label: string }
            | { __typename: 'PowerDistributionUnitVirtualDevice'; UUID: string; label: string }
            | { __typename: 'SwitchVirtualDevice'; UUID: string; label: string }
            | null;
        }
      | {
          __typename?: 'SwitchHardwareDevice';
          serialNumber: string;
          deviceType: DeviceType;
          virtualDevice?:
            | { __typename: 'AccessPointVirtualDevice'; UUID: string; label: string }
            | { __typename: 'ControllerVirtualDevice'; UUID: string; label: string }
            | { __typename: 'ObserverVirtualDevice'; UUID: string; label: string }
            | { __typename: 'PowerDistributionUnitVirtualDevice'; UUID: string; label: string }
            | { __typename: 'SwitchVirtualDevice'; UUID: string; label: string }
            | null;
        };
    state?: {
      __typename?: 'DeviceConfigState';
      state: DeviceConfigStateType;
      timestamp: string;
    } | null;
  }>;
};

export type DeviceConfigsQueryQueryVariables = Exact<{
  serialNumber: Scalars['String']['input'];
}>;

export type DeviceConfigsQueryQuery = {
  __typename?: 'Query';
  deviceConfigs: Array<{
    __typename?: 'DeviceConfigMetadata';
    version: number;
    acknowledgedAt?: string | null;
    createdAt: string;
    isCurrentAsOf?: string | null;
    hardwareDevice:
      | {
          __typename?: 'AccessPointHardwareDevice';
          serialNumber: string;
          deviceType: DeviceType;
          virtualDevice?:
            | { __typename: 'AccessPointVirtualDevice'; UUID: string; label: string }
            | { __typename: 'ControllerVirtualDevice'; UUID: string; label: string }
            | { __typename: 'ObserverVirtualDevice'; UUID: string; label: string }
            | { __typename: 'PowerDistributionUnitVirtualDevice'; UUID: string; label: string }
            | { __typename: 'SwitchVirtualDevice'; UUID: string; label: string }
            | null;
        }
      | {
          __typename?: 'ControllerHardwareDevice';
          serialNumber: string;
          deviceType: DeviceType;
          virtualDevice?:
            | { __typename: 'AccessPointVirtualDevice'; UUID: string; label: string }
            | { __typename: 'ControllerVirtualDevice'; UUID: string; label: string }
            | { __typename: 'ObserverVirtualDevice'; UUID: string; label: string }
            | { __typename: 'PowerDistributionUnitVirtualDevice'; UUID: string; label: string }
            | { __typename: 'SwitchVirtualDevice'; UUID: string; label: string }
            | null;
        }
      | {
          __typename?: 'PowerDistributionUnitHardwareDevice';
          serialNumber: string;
          deviceType: DeviceType;
          virtualDevice?:
            | { __typename: 'AccessPointVirtualDevice'; UUID: string; label: string }
            | { __typename: 'ControllerVirtualDevice'; UUID: string; label: string }
            | { __typename: 'ObserverVirtualDevice'; UUID: string; label: string }
            | { __typename: 'PowerDistributionUnitVirtualDevice'; UUID: string; label: string }
            | { __typename: 'SwitchVirtualDevice'; UUID: string; label: string }
            | null;
        }
      | {
          __typename?: 'SwitchHardwareDevice';
          serialNumber: string;
          deviceType: DeviceType;
          virtualDevice?:
            | { __typename: 'AccessPointVirtualDevice'; UUID: string; label: string }
            | { __typename: 'ControllerVirtualDevice'; UUID: string; label: string }
            | { __typename: 'ObserverVirtualDevice'; UUID: string; label: string }
            | { __typename: 'PowerDistributionUnitVirtualDevice'; UUID: string; label: string }
            | { __typename: 'SwitchVirtualDevice'; UUID: string; label: string }
            | null;
        };
    state?: {
      __typename?: 'DeviceConfigState';
      state: DeviceConfigStateType;
      timestamp: string;
    } | null;
  }>;
};

export type DeviceConfigByVersionQueryVariables = Exact<{
  serialNumber: Scalars['String']['input'];
  version: Scalars['Int']['input'];
}>;

export type DeviceConfigByVersionQuery = {
  __typename?: 'Query';
  deviceConfigByVersion: {
    __typename?: 'DeviceConfig';
    version: number;
    acknowledgedAt?: string | null;
    configJSON: Record<string, unknown>;
  };
};

export type LatestAcknowledgedDeviceConfigQueryVariables = Exact<{
  serialNumber: Scalars['String']['input'];
}>;

export type LatestAcknowledgedDeviceConfigQuery = {
  __typename?: 'Query';
  latestAcknowledgedDeviceConfig: {
    __typename?: 'DeviceConfig';
    version: number;
    acknowledgedAt?: string | null;
  };
};

export type RenderDeviceConfigMutationVariables = Exact<{
  serialNumber: Scalars['String']['input'];
}>;

export type RenderDeviceConfigMutation = {
  __typename?: 'Mutation';
  renderDeviceConfig: {
    __typename?: 'DeviceConfig';
    version: number;
    acknowledgedAt?: string | null;
    configJSON: Record<string, unknown>;
  };
};

export type SignConsoleChallengeMutationMutationVariables = Exact<{
  serial: Scalars['String']['input'];
  challenge: Scalars['String']['input'];
}>;

export type SignConsoleChallengeMutationMutation = {
  __typename?: 'Mutation';
  signConsoleLoginChallenge: { __typename?: 'SignedConsoleLoginChallenge'; response: string };
};

export type DeviceConfigMetadataFieldsForDeviceListBadgeFragment = {
  __typename?: 'DeviceConfigMetadata';
  version: number;
  acknowledgedAt?: string | null;
  createdAt: string;
  isCurrentAsOf?: string | null;
  state?: {
    __typename?: 'DeviceConfigState';
    state: DeviceConfigStateType;
    timestamp: string;
  } | null;
};

export type CreateVirtualDeviceMutationVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
  input: CreateVirtualDeviceInput;
}>;

export type CreateVirtualDeviceMutation = {
  __typename?: 'Mutation';
  createVirtualDevice:
    | { __typename?: 'AccessPointVirtualDevice'; UUID: string }
    | { __typename?: 'ControllerVirtualDevice'; UUID: string }
    | { __typename?: 'ObserverVirtualDevice'; UUID: string }
    | { __typename?: 'PowerDistributionUnitVirtualDevice'; UUID: string }
    | { __typename?: 'SwitchVirtualDevice'; UUID: string };
};

export type UpdateVirtualDeviceMutationVariables = Exact<{
  uuid: Scalars['UUID']['input'];
  input: UpdateVirtualDeviceInput;
}>;

export type UpdateVirtualDeviceMutation = {
  __typename?: 'Mutation';
  updateVirtualDevice:
    | { __typename?: 'AccessPointVirtualDevice'; UUID: string }
    | { __typename?: 'ControllerVirtualDevice'; UUID: string }
    | { __typename?: 'ObserverVirtualDevice'; UUID: string }
    | { __typename?: 'PowerDistributionUnitVirtualDevice'; UUID: string }
    | { __typename?: 'SwitchVirtualDevice'; UUID: string };
};

export type DeleteVirtualDeviceMutationVariables = Exact<{
  uuid: Scalars['UUID']['input'];
}>;

export type DeleteVirtualDeviceMutation = {
  __typename?: 'Mutation';
  deleteVirtualDevice:
    | { __typename?: 'AccessPointVirtualDevice'; UUID: string }
    | { __typename?: 'ControllerVirtualDevice'; UUID: string }
    | { __typename?: 'ObserverVirtualDevice'; UUID: string }
    | { __typename?: 'PowerDistributionUnitVirtualDevice'; UUID: string }
    | { __typename?: 'SwitchVirtualDevice'; UUID: string };
};

export type CreateVirtualDevicesMutationVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
  input: CreateVirtualDevicesInput;
}>;

export type CreateVirtualDevicesMutation = {
  __typename?: 'Mutation';
  createVirtualDevices: Array<
    | { __typename?: 'AccessPointVirtualDevice'; UUID: string }
    | { __typename?: 'ControllerVirtualDevice'; UUID: string }
    | { __typename?: 'ObserverVirtualDevice'; UUID: string }
    | { __typename?: 'PowerDistributionUnitVirtualDevice'; UUID: string }
    | { __typename?: 'SwitchVirtualDevice'; UUID: string }
  >;
};

export type CreateVirtualDevicesIndependentlyMutationVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
  inputs: Array<CreateVirtualDeviceInput> | CreateVirtualDeviceInput;
}>;

export type CreateVirtualDevicesIndependentlyMutation = {
  __typename?: 'Mutation';
  createVirtualDevicesIndependently: Array<
    | { __typename?: 'AccessPointVirtualDevice'; UUID: string }
    | { __typename?: 'ControllerVirtualDevice'; UUID: string }
    | { __typename?: 'ObserverVirtualDevice'; UUID: string }
    | { __typename?: 'PowerDistributionUnitVirtualDevice'; UUID: string }
    | { __typename?: 'SwitchVirtualDevice'; UUID: string }
  >;
};

export type UpdateVirtualDevicesIndependentlyMutationVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
  inputs: Array<UpdateVirtualDeviceIndependentlyInput> | UpdateVirtualDeviceIndependentlyInput;
}>;

export type UpdateVirtualDevicesIndependentlyMutation = {
  __typename?: 'Mutation';
  updateVirtualDevicesIndependently: Array<
    | { __typename?: 'AccessPointVirtualDevice'; UUID: string }
    | { __typename?: 'ControllerVirtualDevice'; UUID: string }
    | { __typename?: 'ObserverVirtualDevice'; UUID: string }
    | { __typename?: 'PowerDistributionUnitVirtualDevice'; UUID: string }
    | { __typename?: 'SwitchVirtualDevice'; UUID: string }
  >;
};

export type AssignHardwareDeviceToVirtualDeviceMutationVariables = Exact<{
  serialNumber: Scalars['String']['input'];
  virtualDeviceUUID: Scalars['UUID']['input'];
}>;

export type AssignHardwareDeviceToVirtualDeviceMutation = {
  __typename?: 'Mutation';
  assignHardwareDeviceToVirtualDevice:
    | {
        __typename?: 'AccessPointHardwareDevice';
        virtualDevice?:
          | { __typename?: 'AccessPointVirtualDevice'; UUID: string; label: string }
          | { __typename?: 'ControllerVirtualDevice'; UUID: string; label: string }
          | { __typename?: 'ObserverVirtualDevice'; UUID: string; label: string }
          | { __typename?: 'PowerDistributionUnitVirtualDevice'; UUID: string; label: string }
          | { __typename?: 'SwitchVirtualDevice'; UUID: string; label: string }
          | null;
      }
    | {
        __typename?: 'ControllerHardwareDevice';
        virtualDevice?:
          | { __typename?: 'AccessPointVirtualDevice'; UUID: string; label: string }
          | { __typename?: 'ControllerVirtualDevice'; UUID: string; label: string }
          | { __typename?: 'ObserverVirtualDevice'; UUID: string; label: string }
          | { __typename?: 'PowerDistributionUnitVirtualDevice'; UUID: string; label: string }
          | { __typename?: 'SwitchVirtualDevice'; UUID: string; label: string }
          | null;
      }
    | {
        __typename?: 'PowerDistributionUnitHardwareDevice';
        virtualDevice?:
          | { __typename?: 'AccessPointVirtualDevice'; UUID: string; label: string }
          | { __typename?: 'ControllerVirtualDevice'; UUID: string; label: string }
          | { __typename?: 'ObserverVirtualDevice'; UUID: string; label: string }
          | { __typename?: 'PowerDistributionUnitVirtualDevice'; UUID: string; label: string }
          | { __typename?: 'SwitchVirtualDevice'; UUID: string; label: string }
          | null;
      }
    | {
        __typename?: 'SwitchHardwareDevice';
        virtualDevice?:
          | { __typename?: 'AccessPointVirtualDevice'; UUID: string; label: string }
          | { __typename?: 'ControllerVirtualDevice'; UUID: string; label: string }
          | { __typename?: 'ObserverVirtualDevice'; UUID: string; label: string }
          | { __typename?: 'PowerDistributionUnitVirtualDevice'; UUID: string; label: string }
          | { __typename?: 'SwitchVirtualDevice'; UUID: string; label: string }
          | null;
      };
};

export type CreateDevHardwareDeviceMutationVariables = Exact<{
  input: CreateDevHardwareDeviceInput;
}>;

export type CreateDevHardwareDeviceMutation = {
  __typename?: 'Mutation';
  createDevHardwareDevice:
    | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
    | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
    | { __typename?: 'PowerDistributionUnitHardwareDevice'; serialNumber: string }
    | { __typename?: 'SwitchHardwareDevice'; serialNumber: string };
};

export type AssignHardwareDeviceToNetworkMutationVariables = Exact<{
  serialNumber: Scalars['String']['input'];
  networkUUID: Scalars['UUID']['input'];
}>;

export type AssignHardwareDeviceToNetworkMutation = {
  __typename?: 'Mutation';
  assignHardwareDeviceToNetwork:
    | {
        __typename?: 'AccessPointHardwareDevice';
        virtualDevice?:
          | { __typename?: 'AccessPointVirtualDevice'; UUID: string; label: string }
          | { __typename?: 'ControllerVirtualDevice'; UUID: string; label: string }
          | { __typename?: 'ObserverVirtualDevice'; UUID: string; label: string }
          | { __typename?: 'PowerDistributionUnitVirtualDevice'; UUID: string; label: string }
          | { __typename?: 'SwitchVirtualDevice'; UUID: string; label: string }
          | null;
      }
    | {
        __typename?: 'ControllerHardwareDevice';
        virtualDevice?:
          | { __typename?: 'AccessPointVirtualDevice'; UUID: string; label: string }
          | { __typename?: 'ControllerVirtualDevice'; UUID: string; label: string }
          | { __typename?: 'ObserverVirtualDevice'; UUID: string; label: string }
          | { __typename?: 'PowerDistributionUnitVirtualDevice'; UUID: string; label: string }
          | { __typename?: 'SwitchVirtualDevice'; UUID: string; label: string }
          | null;
      }
    | {
        __typename?: 'PowerDistributionUnitHardwareDevice';
        virtualDevice?:
          | { __typename?: 'AccessPointVirtualDevice'; UUID: string; label: string }
          | { __typename?: 'ControllerVirtualDevice'; UUID: string; label: string }
          | { __typename?: 'ObserverVirtualDevice'; UUID: string; label: string }
          | { __typename?: 'PowerDistributionUnitVirtualDevice'; UUID: string; label: string }
          | { __typename?: 'SwitchVirtualDevice'; UUID: string; label: string }
          | null;
      }
    | {
        __typename?: 'SwitchHardwareDevice';
        virtualDevice?:
          | { __typename?: 'AccessPointVirtualDevice'; UUID: string; label: string }
          | { __typename?: 'ControllerVirtualDevice'; UUID: string; label: string }
          | { __typename?: 'ObserverVirtualDevice'; UUID: string; label: string }
          | { __typename?: 'PowerDistributionUnitVirtualDevice'; UUID: string; label: string }
          | { __typename?: 'SwitchVirtualDevice'; UUID: string; label: string }
          | null;
      };
};

export type UnassignHardwareDeviceFromVirtualDeviceMutationVariables = Exact<{
  serialNumber: Scalars['String']['input'];
  assignAsSpare?: Scalars['Boolean']['input'];
}>;

export type UnassignHardwareDeviceFromVirtualDeviceMutation = {
  __typename?: 'Mutation';
  unassignHardwareDeviceFromVirtualDevice:
    | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
    | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
    | { __typename?: 'PowerDistributionUnitHardwareDevice'; serialNumber: string }
    | { __typename?: 'SwitchHardwareDevice'; serialNumber: string };
};

export type AssignHardwareToVirtualDevicesMutationVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
  inputs:
    | Array<AssignHardwareDeviceToVirtualDeviceInput>
    | AssignHardwareDeviceToVirtualDeviceInput;
}>;

export type AssignHardwareToVirtualDevicesMutation = {
  __typename?: 'Mutation';
  assignHardwareDevicesToVirtualDevices: Array<
    | {
        __typename?: 'AccessPointHardwareDevice';
        serialNumber: string;
        virtualDevice?:
          | { __typename?: 'AccessPointVirtualDevice'; UUID: string; label: string }
          | { __typename?: 'ControllerVirtualDevice'; UUID: string; label: string }
          | { __typename?: 'ObserverVirtualDevice'; UUID: string; label: string }
          | { __typename?: 'PowerDistributionUnitVirtualDevice'; UUID: string; label: string }
          | { __typename?: 'SwitchVirtualDevice'; UUID: string; label: string }
          | null;
      }
    | {
        __typename?: 'ControllerHardwareDevice';
        serialNumber: string;
        virtualDevice?:
          | { __typename?: 'AccessPointVirtualDevice'; UUID: string; label: string }
          | { __typename?: 'ControllerVirtualDevice'; UUID: string; label: string }
          | { __typename?: 'ObserverVirtualDevice'; UUID: string; label: string }
          | { __typename?: 'PowerDistributionUnitVirtualDevice'; UUID: string; label: string }
          | { __typename?: 'SwitchVirtualDevice'; UUID: string; label: string }
          | null;
      }
    | {
        __typename?: 'PowerDistributionUnitHardwareDevice';
        serialNumber: string;
        virtualDevice?:
          | { __typename?: 'AccessPointVirtualDevice'; UUID: string; label: string }
          | { __typename?: 'ControllerVirtualDevice'; UUID: string; label: string }
          | { __typename?: 'ObserverVirtualDevice'; UUID: string; label: string }
          | { __typename?: 'PowerDistributionUnitVirtualDevice'; UUID: string; label: string }
          | { __typename?: 'SwitchVirtualDevice'; UUID: string; label: string }
          | null;
      }
    | {
        __typename?: 'SwitchHardwareDevice';
        serialNumber: string;
        virtualDevice?:
          | { __typename?: 'AccessPointVirtualDevice'; UUID: string; label: string }
          | { __typename?: 'ControllerVirtualDevice'; UUID: string; label: string }
          | { __typename?: 'ObserverVirtualDevice'; UUID: string; label: string }
          | { __typename?: 'PowerDistributionUnitVirtualDevice'; UUID: string; label: string }
          | { __typename?: 'SwitchVirtualDevice'; UUID: string; label: string }
          | null;
      }
  >;
};

export type HardwareDeviceQueryVariables = Exact<{
  serialNumber: Scalars['String']['input'];
}>;

export type HardwareDeviceQuery = {
  __typename?: 'Query';
  hardwareDevice:
    | {
        __typename?: 'AccessPointHardwareDevice';
        serialNumber: string;
        deviceType: DeviceType;
        deviceModel: DeviceModel;
        virtualDevice?:
          | {
              __typename?: 'AccessPointVirtualDevice';
              UUID: string;
              label: string;
              description?: string | null;
            }
          | {
              __typename?: 'ControllerVirtualDevice';
              UUID: string;
              label: string;
              description?: string | null;
            }
          | {
              __typename?: 'ObserverVirtualDevice';
              UUID: string;
              label: string;
              description?: string | null;
            }
          | {
              __typename?: 'PowerDistributionUnitVirtualDevice';
              UUID: string;
              label: string;
              description?: string | null;
            }
          | {
              __typename?: 'SwitchVirtualDevice';
              UUID: string;
              label: string;
              description?: string | null;
            }
          | null;
      }
    | {
        __typename?: 'ControllerHardwareDevice';
        serialNumber: string;
        deviceType: DeviceType;
        deviceModel: DeviceModel;
        virtualDevice?:
          | {
              __typename?: 'AccessPointVirtualDevice';
              UUID: string;
              label: string;
              description?: string | null;
            }
          | {
              __typename?: 'ControllerVirtualDevice';
              UUID: string;
              label: string;
              description?: string | null;
            }
          | {
              __typename?: 'ObserverVirtualDevice';
              UUID: string;
              label: string;
              description?: string | null;
            }
          | {
              __typename?: 'PowerDistributionUnitVirtualDevice';
              UUID: string;
              label: string;
              description?: string | null;
            }
          | {
              __typename?: 'SwitchVirtualDevice';
              UUID: string;
              label: string;
              description?: string | null;
            }
          | null;
      }
    | {
        __typename?: 'PowerDistributionUnitHardwareDevice';
        serialNumber: string;
        deviceType: DeviceType;
        deviceModel: DeviceModel;
        virtualDevice?:
          | {
              __typename?: 'AccessPointVirtualDevice';
              UUID: string;
              label: string;
              description?: string | null;
            }
          | {
              __typename?: 'ControllerVirtualDevice';
              UUID: string;
              label: string;
              description?: string | null;
            }
          | {
              __typename?: 'ObserverVirtualDevice';
              UUID: string;
              label: string;
              description?: string | null;
            }
          | {
              __typename?: 'PowerDistributionUnitVirtualDevice';
              UUID: string;
              label: string;
              description?: string | null;
            }
          | {
              __typename?: 'SwitchVirtualDevice';
              UUID: string;
              label: string;
              description?: string | null;
            }
          | null;
      }
    | {
        __typename?: 'SwitchHardwareDevice';
        serialNumber: string;
        deviceType: DeviceType;
        deviceModel: DeviceModel;
        virtualDevice?:
          | {
              __typename?: 'AccessPointVirtualDevice';
              UUID: string;
              label: string;
              description?: string | null;
            }
          | {
              __typename?: 'ControllerVirtualDevice';
              UUID: string;
              label: string;
              description?: string | null;
            }
          | {
              __typename?: 'ObserverVirtualDevice';
              UUID: string;
              label: string;
              description?: string | null;
            }
          | {
              __typename?: 'PowerDistributionUnitVirtualDevice';
              UUID: string;
              label: string;
              description?: string | null;
            }
          | {
              __typename?: 'SwitchVirtualDevice';
              UUID: string;
              label: string;
              description?: string | null;
            }
          | null;
      };
};

export type UpdateHardwareDeviceMutationVariables = Exact<{
  serialNumber: Scalars['String']['input'];
  input: UpdateHardwareDeviceInput;
}>;

export type UpdateHardwareDeviceMutation = {
  __typename?: 'Mutation';
  updateHardwareDevice:
    | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
    | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
    | { __typename?: 'PowerDistributionUnitHardwareDevice'; serialNumber: string }
    | { __typename?: 'SwitchHardwareDevice'; serialNumber: string };
};

export type BlinkLeDsMutationMutationVariables = Exact<{
  serialNumber: Scalars['String']['input'];
}>;

export type BlinkLeDsMutationMutation = { __typename?: 'Mutation'; rpcBlinkLEDs: boolean };

export type RefreshConfigMutationMutationVariables = Exact<{
  serialNumber: Scalars['String']['input'];
}>;

export type RefreshConfigMutationMutation = { __typename?: 'Mutation'; rpcRefreshConfig: boolean };

export type ClearBlockedConfigsMutationMutationVariables = Exact<{
  serialNumber: Scalars['String']['input'];
}>;

export type ClearBlockedConfigsMutationMutation = {
  __typename?: 'Mutation';
  rpcClearBlockedConfigs: boolean;
};

export type RpcPduOutletCycleMutationMutationVariables = Exact<{
  serialNumber: Scalars['String']['input'];
  input: RpcpduOutletCycleInput;
}>;

export type RpcPduOutletCycleMutationMutation = {
  __typename?: 'Mutation';
  rpcPDUOutletCycle: boolean;
};

export type LatestDeviceMemoryUsageQueryVariables = Exact<{
  serialNumber: Scalars['String']['input'];
}>;

export type LatestDeviceMemoryUsageQuery = {
  __typename?: 'Query';
  latestDeviceMemoryUsage: {
    __typename?: 'LatestDeviceMemoryUsage';
    bytesUsed: number;
    bytesAvailable: number;
  };
};

export type DeviceUptimeQueryVariables = Exact<{
  serialNumber: Scalars['String']['input'];
}>;

export type DeviceUptimeQuery = { __typename?: 'Query'; deviceUptime: string };

export type LatestDeviceCpuLoadQueryVariables = Exact<{
  serialNumber: Scalars['String']['input'];
}>;

export type LatestDeviceCpuLoadQuery = {
  __typename?: 'Query';
  latestDeviceCPULoad: { __typename?: 'LatestDeviceCPULoad'; usedPercentage: number };
};

export type SwitchPoEInfoQueryVariables = Exact<{
  serialNumber: Scalars['String']['input'];
}>;

export type SwitchPoEInfoQuery = {
  __typename?: 'Query';
  hardwareDevice:
    | { __typename: 'AccessPointHardwareDevice' }
    | { __typename: 'ControllerHardwareDevice' }
    | { __typename: 'PowerDistributionUnitHardwareDevice' }
    | {
        __typename: 'SwitchHardwareDevice';
        poeInfo?: { __typename?: 'PoEInfo'; max?: number | null; used?: number | null } | null;
      };
};

export type SwitchVirtualDevicePoEInfoQueryVariables = Exact<{
  uuid: Scalars['UUID']['input'];
}>;

export type SwitchVirtualDevicePoEInfoQuery = {
  __typename?: 'Query';
  virtualDevice:
    | { __typename: 'AccessPointVirtualDevice' }
    | { __typename: 'ControllerVirtualDevice' }
    | { __typename: 'ObserverVirtualDevice' }
    | { __typename: 'PowerDistributionUnitVirtualDevice' }
    | {
        __typename: 'SwitchVirtualDevice';
        poeInfo?: { __typename?: 'PoEInfo'; max?: number | null; used?: number | null } | null;
      };
};

export type SystemInfoStatQueryQueryVariables = Exact<{
  uuid: Scalars['UUID']['input'];
}>;

export type SystemInfoStatQueryQuery = {
  __typename?: 'Query';
  systemInfoStatForVirtualDevice: Array<{
    __typename?: 'SystemInfoStat';
    uptime: string;
    memoryBytesAvailable: number;
    memoryBytesTotal: number;
    cpuUsedPercentage: number;
  }>;
};

export type UpdatePhyInterfaceMutationVariables = Exact<{
  uuid: Scalars['UUID']['input'];
  input: UpdatePhyInterfaceInput;
}>;

export type UpdatePhyInterfaceMutation = {
  __typename?: 'Mutation';
  updatePhyInterface: { __typename?: 'PhyInterface'; UUID: string };
};

export type UpdatePhyInterfacesMutationVariables = Exact<{
  phyInterfaceUUIDs: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
  virtualDeviceUUID: Scalars['UUID']['input'];
  input: UpdatePhyInterfaceInput;
}>;

export type UpdatePhyInterfacesMutation = {
  __typename?: 'Mutation';
  updatePhyInterfaces: Array<{ __typename?: 'PhyInterface'; UUID: string }>;
};

export type UpdatePhyInterfacesIndependentlyMutationVariables = Exact<{
  inputs: Array<UpdatePhyInterfacesIndependentlyInput> | UpdatePhyInterfacesIndependentlyInput;
}>;

export type UpdatePhyInterfacesIndependentlyMutation = {
  __typename?: 'Mutation';
  updatePhyInterfacesIndependently: Array<{ __typename?: 'PhyInterface'; UUID: string }>;
};

export type SpareHardwareDevicesForNetworkQueryVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
  filter?: InputMaybe<HardwareDevicesFilter>;
}>;

export type SpareHardwareDevicesForNetworkQuery = {
  __typename?: 'Query';
  spareHardwareDevicesForNetwork: Array<
    | {
        __typename?: 'AccessPointHardwareDevice';
        serialNumber: string;
        deviceModel: DeviceModel;
        deviceType: DeviceType;
      }
    | {
        __typename?: 'ControllerHardwareDevice';
        serialNumber: string;
        deviceModel: DeviceModel;
        deviceType: DeviceType;
      }
    | {
        __typename?: 'PowerDistributionUnitHardwareDevice';
        serialNumber: string;
        deviceModel: DeviceModel;
        deviceType: DeviceType;
      }
    | {
        __typename?: 'SwitchHardwareDevice';
        serialNumber: string;
        deviceModel: DeviceModel;
        deviceType: DeviceType;
      }
  >;
};

export type AssignHardwareDeviceAsSpareMutationVariables = Exact<{
  serialNumber: Scalars['String']['input'];
  networkUUID: Scalars['UUID']['input'];
}>;

export type AssignHardwareDeviceAsSpareMutation = {
  __typename?: 'Mutation';
  assignHardwareDeviceToNetworkAsSpare:
    | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
    | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
    | { __typename?: 'PowerDistributionUnitHardwareDevice'; serialNumber: string }
    | { __typename?: 'SwitchHardwareDevice'; serialNumber: string };
};

export type UnassignSpareHardwareDeviceMutationVariables = Exact<{
  serialNumber: Scalars['String']['input'];
  networkUUID: Scalars['UUID']['input'];
}>;

export type UnassignSpareHardwareDeviceMutation = {
  __typename?: 'Mutation';
  unassignSpareHardwareDeviceFromNetwork:
    | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
    | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
    | { __typename?: 'PowerDistributionUnitHardwareDevice'; serialNumber: string }
    | { __typename?: 'SwitchHardwareDevice'; serialNumber: string };
};

export type FloorPlansForNetworkQueryVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
}>;

export type FloorPlansForNetworkQuery = {
  __typename?: 'Query';
  floorPlansForNetwork: Array<{
    __typename?: 'FloorPlan';
    UUID: string;
    label: string;
    description?: string | null;
    imageS3Key: string;
    imageDownloadURL: string;
  }>;
};

export type FloorPlanQueryVariables = Exact<{
  UUID: Scalars['UUID']['input'];
}>;

export type FloorPlanQuery = {
  __typename?: 'Query';
  floorPlan: {
    __typename?: 'FloorPlan';
    UUID: string;
    label: string;
    description?: string | null;
    imageS3Key: string;
  };
};

export type CreateFloorPlanMutationVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
  input: CreateFloorPlanInput;
}>;

export type CreateFloorPlanMutation = {
  __typename?: 'Mutation';
  createFloorPlan: { __typename?: 'FloorPlan'; UUID: string };
};

export type UpdateFloorPlanMutationVariables = Exact<{
  UUID: Scalars['UUID']['input'];
  input: UpdateFloorPlanInput;
}>;

export type UpdateFloorPlanMutation = {
  __typename?: 'Mutation';
  updateFloorPlan: { __typename?: 'FloorPlan'; UUID: string };
};

export type DeleteFloorPlanMutationVariables = Exact<{
  UUID: Scalars['UUID']['input'];
}>;

export type DeleteFloorPlanMutation = {
  __typename?: 'Mutation';
  deleteFloorPlan: { __typename?: 'FloorPlan'; UUID: string };
};

export type ApbssiDsQueryQueryVariables = Exact<{
  virtualDeviceUUID: Scalars['UUID']['input'];
}>;

export type ApbssiDsQueryQuery = {
  __typename?: 'Query';
  virtualDevice:
    | {
        __typename?: 'AccessPointVirtualDevice';
        hardwareDevice?:
          | {
              __typename: 'AccessPointHardwareDevice';
              BSSIDs: Array<{
                __typename?: 'BSSID';
                BSSID: string;
                isActive: boolean;
                radioBand: RadioBand;
                SSID: { __typename?: 'SSID'; ssid: string; isHidden: boolean };
              }>;
            }
          | { __typename: 'ControllerHardwareDevice' }
          | { __typename: 'PowerDistributionUnitHardwareDevice' }
          | { __typename: 'SwitchHardwareDevice' }
          | null;
      }
    | {
        __typename?: 'ControllerVirtualDevice';
        hardwareDevice?:
          | {
              __typename: 'AccessPointHardwareDevice';
              BSSIDs: Array<{
                __typename?: 'BSSID';
                BSSID: string;
                isActive: boolean;
                radioBand: RadioBand;
                SSID: { __typename?: 'SSID'; ssid: string; isHidden: boolean };
              }>;
            }
          | { __typename: 'ControllerHardwareDevice' }
          | { __typename: 'PowerDistributionUnitHardwareDevice' }
          | { __typename: 'SwitchHardwareDevice' }
          | null;
      }
    | {
        __typename?: 'ObserverVirtualDevice';
        hardwareDevice?:
          | {
              __typename: 'AccessPointHardwareDevice';
              BSSIDs: Array<{
                __typename?: 'BSSID';
                BSSID: string;
                isActive: boolean;
                radioBand: RadioBand;
                SSID: { __typename?: 'SSID'; ssid: string; isHidden: boolean };
              }>;
            }
          | { __typename: 'ControllerHardwareDevice' }
          | { __typename: 'PowerDistributionUnitHardwareDevice' }
          | { __typename: 'SwitchHardwareDevice' }
          | null;
      }
    | {
        __typename?: 'PowerDistributionUnitVirtualDevice';
        hardwareDevice?:
          | {
              __typename: 'AccessPointHardwareDevice';
              BSSIDs: Array<{
                __typename?: 'BSSID';
                BSSID: string;
                isActive: boolean;
                radioBand: RadioBand;
                SSID: { __typename?: 'SSID'; ssid: string; isHidden: boolean };
              }>;
            }
          | { __typename: 'ControllerHardwareDevice' }
          | { __typename: 'PowerDistributionUnitHardwareDevice' }
          | { __typename: 'SwitchHardwareDevice' }
          | null;
      }
    | {
        __typename?: 'SwitchVirtualDevice';
        hardwareDevice?:
          | {
              __typename: 'AccessPointHardwareDevice';
              BSSIDs: Array<{
                __typename?: 'BSSID';
                BSSID: string;
                isActive: boolean;
                radioBand: RadioBand;
                SSID: { __typename?: 'SSID'; ssid: string; isHidden: boolean };
              }>;
            }
          | { __typename: 'ControllerHardwareDevice' }
          | { __typename: 'PowerDistributionUnitHardwareDevice' }
          | { __typename: 'SwitchHardwareDevice' }
          | null;
      };
};

export type ApBootHistoryQueryQueryVariables = Exact<{
  serialNumber: Scalars['String']['input'];
  count?: InputMaybe<Scalars['Int']['input']>;
}>;

export type ApBootHistoryQueryQuery = {
  __typename?: 'Query';
  hardwareDevice:
    | {
        __typename?: 'AccessPointHardwareDevice';
        bootHistory: Array<{
          __typename?: 'BootInfo';
          bootCount: number;
          buildName: string;
          rebootReason: string;
          createdAt: string;
        }>;
      }
    | {
        __typename?: 'ControllerHardwareDevice';
        bootHistory: Array<{
          __typename?: 'BootInfo';
          bootCount: number;
          buildName: string;
          rebootReason: string;
          createdAt: string;
        }>;
      }
    | {
        __typename?: 'PowerDistributionUnitHardwareDevice';
        bootHistory: Array<{
          __typename?: 'BootInfo';
          bootCount: number;
          buildName: string;
          rebootReason: string;
          createdAt: string;
        }>;
      }
    | {
        __typename?: 'SwitchHardwareDevice';
        bootHistory: Array<{
          __typename?: 'BootInfo';
          bootCount: number;
          buildName: string;
          rebootReason: string;
          createdAt: string;
        }>;
      };
};

export type RebootAccessPointMutationVariables = Exact<{
  serialNumber: Scalars['String']['input'];
}>;

export type RebootAccessPointMutation = { __typename?: 'Mutation'; rpcRebootDevice: boolean };

export type RebootAccessPointsMutationVariables = Exact<{
  serialNumbers: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;

export type RebootAccessPointsMutation = {
  __typename?: 'Mutation';
  rpcRebootDevices: Array<{
    __typename?: 'RPCRebootDeviceResponse';
    error?: string | null;
    success: boolean;
    serialNumber: string;
  }>;
};

export type RunAcsForAccessPointsMutationMutationVariables = Exact<{
  virtualDeviceUUIDs: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
  input: AutoChannelSelectionJobInput;
}>;

export type RunAcsForAccessPointsMutationMutation = {
  __typename?: 'Mutation';
  initializeAutoChannelSelectionForAccessPoints: {
    __typename?: 'AutoChannelSelectionJob';
    UUID: string;
    scheduledAt: string;
    timeoutAt: string;
  };
};

export type RunAcsForNetworkMutationMutationVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
  input: AutoChannelSelectionJobInput;
}>;

export type RunAcsForNetworkMutationMutation = {
  __typename?: 'Mutation';
  initializeAutoChannelSelectionForNetwork: {
    __typename?: 'AutoChannelSelectionJob';
    UUID: string;
    scheduledAt: string;
    timeoutAt: string;
  };
};

export type AcsJobsForNetworkQueryQueryVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
}>;

export type AcsJobsForNetworkQueryQuery = {
  __typename?: 'Query';
  autoChannelSelectionJobsForNetwork: Array<{
    __typename?: 'AutoChannelSelectionJob';
    UUID: string;
    networkUUID: string;
    scheduledAt: string;
    timeoutAt: string;
    completedAt?: string | null;
    virtualDeviceUUIDs: Array<string>;
    results?: Array<{
      __typename?: 'AutoChannelSelectionResult';
      timestamp: string;
      virtualDeviceUUID: string;
      resultType: AutoChannelSelectionResultType;
      previous5GHzChannel?: number | null;
      new5GHzChannel?: number | null;
    }> | null;
  }>;
};

export type CancelAcsJobMutationMutationVariables = Exact<{
  jobUUID: Scalars['UUID']['input'];
}>;

export type CancelAcsJobMutationMutation = {
  __typename?: 'Mutation';
  cancelAutoChannelSelectionJob: { __typename?: 'AutoChannelSelectionJob'; UUID: string };
};

export type ScanDataForNetworkQueryVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
  durationSeconds: Scalars['Int']['input'];
  virtualDeviceUUID?: InputMaybe<Scalars['UUID']['input']>;
}>;

export type ScanDataForNetworkQuery = {
  __typename?: 'Query';
  scanDataForNetwork: Array<{
    __typename?: 'ScanData';
    observedAt: string;
    BSSID: string;
    SSID: string;
    band: RadioBand;
    radio: DeviceRadio;
    channel: number;
    channelWidth: number;
    RSSI: number;
    virtualDevice:
      | {
          __typename?: 'AccessPointVirtualDevice';
          UUID: string;
          label: string;
          deviceModel: DeviceModel;
        }
      | {
          __typename?: 'ControllerVirtualDevice';
          UUID: string;
          label: string;
          deviceModel: DeviceModel;
        }
      | {
          __typename?: 'ObserverVirtualDevice';
          UUID: string;
          label: string;
          deviceModel: DeviceModel;
        }
      | {
          __typename?: 'PowerDistributionUnitVirtualDevice';
          UUID: string;
          label: string;
          deviceModel: DeviceModel;
        }
      | {
          __typename?: 'SwitchVirtualDevice';
          UUID: string;
          label: string;
          deviceModel: DeviceModel;
        };
  }>;
};

export type InstallStatusQueryQueryVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
  includeIsDev?: InputMaybe<Scalars['Boolean']['input']>;
  includeConfigMetadata?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type InstallStatusQueryQuery = {
  __typename?: 'Query';
  virtualDevicesForNetwork: Array<
    | {
        __typename: 'AccessPointVirtualDevice';
        UUID: string;
        uptime?: string | null;
        label: string;
        description?: string | null;
        deviceType: VirtualDeviceType;
        network: { __typename?: 'Network'; UUID: string; slug: string; label: string };
        nosVersion?: {
          __typename?: 'ConfiguredNOSVersion';
          id: number;
          version: string;
          buildName: string;
        } | null;
        pendingNosVersion?: {
          __typename?: 'PendingNosVersion';
          scheduledAt: string;
          nosVersion: { __typename?: 'NosVersion'; version: string };
        } | null;
        hardwareDevice?:
          | {
              __typename: 'AccessPointHardwareDevice';
              ipAddress?: string | null;
              isInCurrentControllerMACTable: boolean;
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              isDev?: boolean;
              phyInterfaceConnectedTo?: {
                __typename?: 'PhyInterface';
                UUID: string;
                isEthernet: boolean;
                isSFP: boolean;
                isUplink: boolean;
                isUplinkActive?: boolean | null;
                isConnected: boolean;
                portSpeedMbps?: number | null;
                maxSpeedMbps?: number | null;
                isFLIPEnabled: boolean;
                isVoiceVLANEnabled: boolean;
                powerDraw?: number | null;
                poeType?: PoEType | null;
                hasWANActivity?: boolean | null;
                portNumber: number;
                isTrunkPort: boolean;
                isBoundToAllVLANs: boolean;
                sfpModuleInfo?: {
                  __typename?: 'SFPModuleInfo';
                  moduleSpeedKbps?: number | null;
                } | null;
                virtualDevice:
                  | {
                      __typename?: 'AccessPointVirtualDevice';
                      UUID: string;
                      label: string;
                      deviceType: VirtualDeviceType;
                    }
                  | {
                      __typename?: 'ControllerVirtualDevice';
                      UUID: string;
                      label: string;
                      deviceType: VirtualDeviceType;
                    }
                  | {
                      __typename?: 'ObserverVirtualDevice';
                      UUID: string;
                      label: string;
                      deviceType: VirtualDeviceType;
                    }
                  | {
                      __typename?: 'PowerDistributionUnitVirtualDevice';
                      UUID: string;
                      label: string;
                      deviceType: VirtualDeviceType;
                    }
                  | {
                      __typename?: 'SwitchVirtualDevice';
                      UUID: string;
                      label: string;
                      deviceType: VirtualDeviceType;
                    };
                connectedDevices?: Array<{
                  __typename?: 'PhyInterfaceConnectedDevice';
                  macAddress: string;
                  hardwareDevice?:
                    | {
                        __typename?: 'AccessPointHardwareDevice';
                        virtualDevice?:
                          | {
                              __typename?: 'AccessPointVirtualDevice';
                              UUID: string;
                              label: string;
                              deviceType: VirtualDeviceType;
                            }
                          | {
                              __typename?: 'ControllerVirtualDevice';
                              UUID: string;
                              label: string;
                              deviceType: VirtualDeviceType;
                            }
                          | {
                              __typename?: 'ObserverVirtualDevice';
                              UUID: string;
                              label: string;
                              deviceType: VirtualDeviceType;
                            }
                          | {
                              __typename?: 'PowerDistributionUnitVirtualDevice';
                              UUID: string;
                              label: string;
                              deviceType: VirtualDeviceType;
                            }
                          | {
                              __typename?: 'SwitchVirtualDevice';
                              UUID: string;
                              label: string;
                              deviceType: VirtualDeviceType;
                            }
                          | null;
                      }
                    | {
                        __typename?: 'ControllerHardwareDevice';
                        virtualDevice?:
                          | {
                              __typename?: 'AccessPointVirtualDevice';
                              UUID: string;
                              label: string;
                              deviceType: VirtualDeviceType;
                            }
                          | {
                              __typename?: 'ControllerVirtualDevice';
                              UUID: string;
                              label: string;
                              deviceType: VirtualDeviceType;
                            }
                          | {
                              __typename?: 'ObserverVirtualDevice';
                              UUID: string;
                              label: string;
                              deviceType: VirtualDeviceType;
                            }
                          | {
                              __typename?: 'PowerDistributionUnitVirtualDevice';
                              UUID: string;
                              label: string;
                              deviceType: VirtualDeviceType;
                            }
                          | {
                              __typename?: 'SwitchVirtualDevice';
                              UUID: string;
                              label: string;
                              deviceType: VirtualDeviceType;
                            }
                          | null;
                      }
                    | {
                        __typename?: 'PowerDistributionUnitHardwareDevice';
                        virtualDevice?:
                          | {
                              __typename?: 'AccessPointVirtualDevice';
                              UUID: string;
                              label: string;
                              deviceType: VirtualDeviceType;
                            }
                          | {
                              __typename?: 'ControllerVirtualDevice';
                              UUID: string;
                              label: string;
                              deviceType: VirtualDeviceType;
                            }
                          | {
                              __typename?: 'ObserverVirtualDevice';
                              UUID: string;
                              label: string;
                              deviceType: VirtualDeviceType;
                            }
                          | {
                              __typename?: 'PowerDistributionUnitVirtualDevice';
                              UUID: string;
                              label: string;
                              deviceType: VirtualDeviceType;
                            }
                          | {
                              __typename?: 'SwitchVirtualDevice';
                              UUID: string;
                              label: string;
                              deviceType: VirtualDeviceType;
                            }
                          | null;
                      }
                    | {
                        __typename?: 'SwitchHardwareDevice';
                        virtualDevice?:
                          | {
                              __typename?: 'AccessPointVirtualDevice';
                              UUID: string;
                              label: string;
                              deviceType: VirtualDeviceType;
                            }
                          | {
                              __typename?: 'ControllerVirtualDevice';
                              UUID: string;
                              label: string;
                              deviceType: VirtualDeviceType;
                            }
                          | {
                              __typename?: 'ObserverVirtualDevice';
                              UUID: string;
                              label: string;
                              deviceType: VirtualDeviceType;
                            }
                          | {
                              __typename?: 'PowerDistributionUnitVirtualDevice';
                              UUID: string;
                              label: string;
                              deviceType: VirtualDeviceType;
                            }
                          | {
                              __typename?: 'SwitchVirtualDevice';
                              UUID: string;
                              label: string;
                              deviceType: VirtualDeviceType;
                            }
                          | null;
                      }
                    | null;
                }> | null;
              } | null;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string; createdAt: string }>;
              latestDeviceConfigMetadata?: {
                __typename?: 'DeviceConfigMetadata';
                version: number;
                acknowledgedAt?: string | null;
                createdAt: string;
                isCurrentAsOf?: string | null;
                state?: {
                  __typename?: 'DeviceConfigState';
                  state: DeviceConfigStateType;
                  timestamp: string;
                } | null;
              } | null;
            }
          | {
              __typename: 'ControllerHardwareDevice';
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              isDev?: boolean;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string; createdAt: string }>;
              latestDeviceConfigMetadata?: {
                __typename?: 'DeviceConfigMetadata';
                version: number;
                acknowledgedAt?: string | null;
                createdAt: string;
                isCurrentAsOf?: string | null;
                state?: {
                  __typename?: 'DeviceConfigState';
                  state: DeviceConfigStateType;
                  timestamp: string;
                } | null;
              } | null;
            }
          | {
              __typename: 'PowerDistributionUnitHardwareDevice';
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              isDev?: boolean;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string; createdAt: string }>;
              latestDeviceConfigMetadata?: {
                __typename?: 'DeviceConfigMetadata';
                version: number;
                acknowledgedAt?: string | null;
                createdAt: string;
                isCurrentAsOf?: string | null;
                state?: {
                  __typename?: 'DeviceConfigState';
                  state: DeviceConfigStateType;
                  timestamp: string;
                } | null;
              } | null;
            }
          | {
              __typename: 'SwitchHardwareDevice';
              ipAddress?: string | null;
              isInCurrentControllerMACTable: boolean;
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              isDev?: boolean;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string; createdAt: string }>;
              latestDeviceConfigMetadata?: {
                __typename?: 'DeviceConfigMetadata';
                version: number;
                acknowledgedAt?: string | null;
                createdAt: string;
                isCurrentAsOf?: string | null;
                state?: {
                  __typename?: 'DeviceConfigState';
                  state: DeviceConfigStateType;
                  timestamp: string;
                } | null;
              } | null;
            }
          | null;
      }
    | {
        __typename: 'ControllerVirtualDevice';
        UUID: string;
        uptime?: string | null;
        label: string;
        description?: string | null;
        deviceType: VirtualDeviceType;
        phyInterfaces: Array<{
          __typename?: 'PhyInterface';
          UUID: string;
          isEthernet: boolean;
          isSFP: boolean;
          isUplink: boolean;
          isUplinkActive?: boolean | null;
          isConnected: boolean;
          portSpeedMbps?: number | null;
          maxSpeedMbps?: number | null;
          isFLIPEnabled: boolean;
          isVoiceVLANEnabled: boolean;
          powerDraw?: number | null;
          poeType?: PoEType | null;
          hasWANActivity?: boolean | null;
          portNumber: number;
          isTrunkPort: boolean;
          isBoundToAllVLANs: boolean;
          sfpModuleInfo?: { __typename?: 'SFPModuleInfo'; moduleSpeedKbps?: number | null } | null;
          virtualDevice:
            | {
                __typename?: 'AccessPointVirtualDevice';
                UUID: string;
                label: string;
                deviceType: VirtualDeviceType;
              }
            | {
                __typename?: 'ControllerVirtualDevice';
                UUID: string;
                label: string;
                deviceType: VirtualDeviceType;
              }
            | {
                __typename?: 'ObserverVirtualDevice';
                UUID: string;
                label: string;
                deviceType: VirtualDeviceType;
              }
            | {
                __typename?: 'PowerDistributionUnitVirtualDevice';
                UUID: string;
                label: string;
                deviceType: VirtualDeviceType;
              }
            | {
                __typename?: 'SwitchVirtualDevice';
                UUID: string;
                label: string;
                deviceType: VirtualDeviceType;
              };
          connectedDevices?: Array<{
            __typename?: 'PhyInterfaceConnectedDevice';
            macAddress: string;
            hardwareDevice?:
              | {
                  __typename?: 'AccessPointHardwareDevice';
                  virtualDevice?:
                    | {
                        __typename?: 'AccessPointVirtualDevice';
                        UUID: string;
                        label: string;
                        deviceType: VirtualDeviceType;
                      }
                    | {
                        __typename?: 'ControllerVirtualDevice';
                        UUID: string;
                        label: string;
                        deviceType: VirtualDeviceType;
                      }
                    | {
                        __typename?: 'ObserverVirtualDevice';
                        UUID: string;
                        label: string;
                        deviceType: VirtualDeviceType;
                      }
                    | {
                        __typename?: 'PowerDistributionUnitVirtualDevice';
                        UUID: string;
                        label: string;
                        deviceType: VirtualDeviceType;
                      }
                    | {
                        __typename?: 'SwitchVirtualDevice';
                        UUID: string;
                        label: string;
                        deviceType: VirtualDeviceType;
                      }
                    | null;
                }
              | {
                  __typename?: 'ControllerHardwareDevice';
                  virtualDevice?:
                    | {
                        __typename?: 'AccessPointVirtualDevice';
                        UUID: string;
                        label: string;
                        deviceType: VirtualDeviceType;
                      }
                    | {
                        __typename?: 'ControllerVirtualDevice';
                        UUID: string;
                        label: string;
                        deviceType: VirtualDeviceType;
                      }
                    | {
                        __typename?: 'ObserverVirtualDevice';
                        UUID: string;
                        label: string;
                        deviceType: VirtualDeviceType;
                      }
                    | {
                        __typename?: 'PowerDistributionUnitVirtualDevice';
                        UUID: string;
                        label: string;
                        deviceType: VirtualDeviceType;
                      }
                    | {
                        __typename?: 'SwitchVirtualDevice';
                        UUID: string;
                        label: string;
                        deviceType: VirtualDeviceType;
                      }
                    | null;
                }
              | {
                  __typename?: 'PowerDistributionUnitHardwareDevice';
                  virtualDevice?:
                    | {
                        __typename?: 'AccessPointVirtualDevice';
                        UUID: string;
                        label: string;
                        deviceType: VirtualDeviceType;
                      }
                    | {
                        __typename?: 'ControllerVirtualDevice';
                        UUID: string;
                        label: string;
                        deviceType: VirtualDeviceType;
                      }
                    | {
                        __typename?: 'ObserverVirtualDevice';
                        UUID: string;
                        label: string;
                        deviceType: VirtualDeviceType;
                      }
                    | {
                        __typename?: 'PowerDistributionUnitVirtualDevice';
                        UUID: string;
                        label: string;
                        deviceType: VirtualDeviceType;
                      }
                    | {
                        __typename?: 'SwitchVirtualDevice';
                        UUID: string;
                        label: string;
                        deviceType: VirtualDeviceType;
                      }
                    | null;
                }
              | {
                  __typename?: 'SwitchHardwareDevice';
                  virtualDevice?:
                    | {
                        __typename?: 'AccessPointVirtualDevice';
                        UUID: string;
                        label: string;
                        deviceType: VirtualDeviceType;
                      }
                    | {
                        __typename?: 'ControllerVirtualDevice';
                        UUID: string;
                        label: string;
                        deviceType: VirtualDeviceType;
                      }
                    | {
                        __typename?: 'ObserverVirtualDevice';
                        UUID: string;
                        label: string;
                        deviceType: VirtualDeviceType;
                      }
                    | {
                        __typename?: 'PowerDistributionUnitVirtualDevice';
                        UUID: string;
                        label: string;
                        deviceType: VirtualDeviceType;
                      }
                    | {
                        __typename?: 'SwitchVirtualDevice';
                        UUID: string;
                        label: string;
                        deviceType: VirtualDeviceType;
                      }
                    | null;
                }
              | null;
          }> | null;
        }>;
        highAvailability?: {
          __typename?: 'HighAvailabilityControllerVirtualDeviceInfo';
          role: HighAvailabilityControllerRole;
          status: HighAvailabilityStatus;
        } | null;
        network: { __typename?: 'Network'; UUID: string; slug: string; label: string };
        nosVersion?: {
          __typename?: 'ConfiguredNOSVersion';
          id: number;
          version: string;
          buildName: string;
        } | null;
        pendingNosVersion?: {
          __typename?: 'PendingNosVersion';
          scheduledAt: string;
          nosVersion: { __typename?: 'NosVersion'; version: string };
        } | null;
        hardwareDevice?:
          | {
              __typename: 'AccessPointHardwareDevice';
              ipAddress?: string | null;
              isInCurrentControllerMACTable: boolean;
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              isDev?: boolean;
              phyInterfaceConnectedTo?: {
                __typename?: 'PhyInterface';
                UUID: string;
                isEthernet: boolean;
                isSFP: boolean;
                isUplink: boolean;
                isUplinkActive?: boolean | null;
                isConnected: boolean;
                portSpeedMbps?: number | null;
                maxSpeedMbps?: number | null;
                isFLIPEnabled: boolean;
                isVoiceVLANEnabled: boolean;
                powerDraw?: number | null;
                poeType?: PoEType | null;
                hasWANActivity?: boolean | null;
                portNumber: number;
                isTrunkPort: boolean;
                isBoundToAllVLANs: boolean;
                sfpModuleInfo?: {
                  __typename?: 'SFPModuleInfo';
                  moduleSpeedKbps?: number | null;
                } | null;
                virtualDevice:
                  | {
                      __typename?: 'AccessPointVirtualDevice';
                      UUID: string;
                      label: string;
                      deviceType: VirtualDeviceType;
                    }
                  | {
                      __typename?: 'ControllerVirtualDevice';
                      UUID: string;
                      label: string;
                      deviceType: VirtualDeviceType;
                    }
                  | {
                      __typename?: 'ObserverVirtualDevice';
                      UUID: string;
                      label: string;
                      deviceType: VirtualDeviceType;
                    }
                  | {
                      __typename?: 'PowerDistributionUnitVirtualDevice';
                      UUID: string;
                      label: string;
                      deviceType: VirtualDeviceType;
                    }
                  | {
                      __typename?: 'SwitchVirtualDevice';
                      UUID: string;
                      label: string;
                      deviceType: VirtualDeviceType;
                    };
                connectedDevices?: Array<{
                  __typename?: 'PhyInterfaceConnectedDevice';
                  macAddress: string;
                  hardwareDevice?:
                    | {
                        __typename?: 'AccessPointHardwareDevice';
                        virtualDevice?:
                          | {
                              __typename?: 'AccessPointVirtualDevice';
                              UUID: string;
                              label: string;
                              deviceType: VirtualDeviceType;
                            }
                          | {
                              __typename?: 'ControllerVirtualDevice';
                              UUID: string;
                              label: string;
                              deviceType: VirtualDeviceType;
                            }
                          | {
                              __typename?: 'ObserverVirtualDevice';
                              UUID: string;
                              label: string;
                              deviceType: VirtualDeviceType;
                            }
                          | {
                              __typename?: 'PowerDistributionUnitVirtualDevice';
                              UUID: string;
                              label: string;
                              deviceType: VirtualDeviceType;
                            }
                          | {
                              __typename?: 'SwitchVirtualDevice';
                              UUID: string;
                              label: string;
                              deviceType: VirtualDeviceType;
                            }
                          | null;
                      }
                    | {
                        __typename?: 'ControllerHardwareDevice';
                        virtualDevice?:
                          | {
                              __typename?: 'AccessPointVirtualDevice';
                              UUID: string;
                              label: string;
                              deviceType: VirtualDeviceType;
                            }
                          | {
                              __typename?: 'ControllerVirtualDevice';
                              UUID: string;
                              label: string;
                              deviceType: VirtualDeviceType;
                            }
                          | {
                              __typename?: 'ObserverVirtualDevice';
                              UUID: string;
                              label: string;
                              deviceType: VirtualDeviceType;
                            }
                          | {
                              __typename?: 'PowerDistributionUnitVirtualDevice';
                              UUID: string;
                              label: string;
                              deviceType: VirtualDeviceType;
                            }
                          | {
                              __typename?: 'SwitchVirtualDevice';
                              UUID: string;
                              label: string;
                              deviceType: VirtualDeviceType;
                            }
                          | null;
                      }
                    | {
                        __typename?: 'PowerDistributionUnitHardwareDevice';
                        virtualDevice?:
                          | {
                              __typename?: 'AccessPointVirtualDevice';
                              UUID: string;
                              label: string;
                              deviceType: VirtualDeviceType;
                            }
                          | {
                              __typename?: 'ControllerVirtualDevice';
                              UUID: string;
                              label: string;
                              deviceType: VirtualDeviceType;
                            }
                          | {
                              __typename?: 'ObserverVirtualDevice';
                              UUID: string;
                              label: string;
                              deviceType: VirtualDeviceType;
                            }
                          | {
                              __typename?: 'PowerDistributionUnitVirtualDevice';
                              UUID: string;
                              label: string;
                              deviceType: VirtualDeviceType;
                            }
                          | {
                              __typename?: 'SwitchVirtualDevice';
                              UUID: string;
                              label: string;
                              deviceType: VirtualDeviceType;
                            }
                          | null;
                      }
                    | {
                        __typename?: 'SwitchHardwareDevice';
                        virtualDevice?:
                          | {
                              __typename?: 'AccessPointVirtualDevice';
                              UUID: string;
                              label: string;
                              deviceType: VirtualDeviceType;
                            }
                          | {
                              __typename?: 'ControllerVirtualDevice';
                              UUID: string;
                              label: string;
                              deviceType: VirtualDeviceType;
                            }
                          | {
                              __typename?: 'ObserverVirtualDevice';
                              UUID: string;
                              label: string;
                              deviceType: VirtualDeviceType;
                            }
                          | {
                              __typename?: 'PowerDistributionUnitVirtualDevice';
                              UUID: string;
                              label: string;
                              deviceType: VirtualDeviceType;
                            }
                          | {
                              __typename?: 'SwitchVirtualDevice';
                              UUID: string;
                              label: string;
                              deviceType: VirtualDeviceType;
                            }
                          | null;
                      }
                    | null;
                }> | null;
              } | null;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string; createdAt: string }>;
              latestDeviceConfigMetadata?: {
                __typename?: 'DeviceConfigMetadata';
                version: number;
                acknowledgedAt?: string | null;
                createdAt: string;
                isCurrentAsOf?: string | null;
                state?: {
                  __typename?: 'DeviceConfigState';
                  state: DeviceConfigStateType;
                  timestamp: string;
                } | null;
              } | null;
            }
          | {
              __typename: 'ControllerHardwareDevice';
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              isDev?: boolean;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string; createdAt: string }>;
              latestDeviceConfigMetadata?: {
                __typename?: 'DeviceConfigMetadata';
                version: number;
                acknowledgedAt?: string | null;
                createdAt: string;
                isCurrentAsOf?: string | null;
                state?: {
                  __typename?: 'DeviceConfigState';
                  state: DeviceConfigStateType;
                  timestamp: string;
                } | null;
              } | null;
            }
          | {
              __typename: 'PowerDistributionUnitHardwareDevice';
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              isDev?: boolean;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string; createdAt: string }>;
              latestDeviceConfigMetadata?: {
                __typename?: 'DeviceConfigMetadata';
                version: number;
                acknowledgedAt?: string | null;
                createdAt: string;
                isCurrentAsOf?: string | null;
                state?: {
                  __typename?: 'DeviceConfigState';
                  state: DeviceConfigStateType;
                  timestamp: string;
                } | null;
              } | null;
            }
          | {
              __typename: 'SwitchHardwareDevice';
              ipAddress?: string | null;
              isInCurrentControllerMACTable: boolean;
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              isDev?: boolean;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string; createdAt: string }>;
              latestDeviceConfigMetadata?: {
                __typename?: 'DeviceConfigMetadata';
                version: number;
                acknowledgedAt?: string | null;
                createdAt: string;
                isCurrentAsOf?: string | null;
                state?: {
                  __typename?: 'DeviceConfigState';
                  state: DeviceConfigStateType;
                  timestamp: string;
                } | null;
              } | null;
            }
          | null;
      }
    | {
        __typename: 'ObserverVirtualDevice';
        UUID: string;
        uptime?: string | null;
        label: string;
        description?: string | null;
        deviceType: VirtualDeviceType;
        network: { __typename?: 'Network'; UUID: string; slug: string; label: string };
        nosVersion?: {
          __typename?: 'ConfiguredNOSVersion';
          id: number;
          version: string;
          buildName: string;
        } | null;
        pendingNosVersion?: {
          __typename?: 'PendingNosVersion';
          scheduledAt: string;
          nosVersion: { __typename?: 'NosVersion'; version: string };
        } | null;
        hardwareDevice?:
          | {
              __typename: 'AccessPointHardwareDevice';
              ipAddress?: string | null;
              isInCurrentControllerMACTable: boolean;
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              isDev?: boolean;
              phyInterfaceConnectedTo?: {
                __typename?: 'PhyInterface';
                UUID: string;
                isEthernet: boolean;
                isSFP: boolean;
                isUplink: boolean;
                isUplinkActive?: boolean | null;
                isConnected: boolean;
                portSpeedMbps?: number | null;
                maxSpeedMbps?: number | null;
                isFLIPEnabled: boolean;
                isVoiceVLANEnabled: boolean;
                powerDraw?: number | null;
                poeType?: PoEType | null;
                hasWANActivity?: boolean | null;
                portNumber: number;
                isTrunkPort: boolean;
                isBoundToAllVLANs: boolean;
                sfpModuleInfo?: {
                  __typename?: 'SFPModuleInfo';
                  moduleSpeedKbps?: number | null;
                } | null;
                virtualDevice:
                  | {
                      __typename?: 'AccessPointVirtualDevice';
                      UUID: string;
                      label: string;
                      deviceType: VirtualDeviceType;
                    }
                  | {
                      __typename?: 'ControllerVirtualDevice';
                      UUID: string;
                      label: string;
                      deviceType: VirtualDeviceType;
                    }
                  | {
                      __typename?: 'ObserverVirtualDevice';
                      UUID: string;
                      label: string;
                      deviceType: VirtualDeviceType;
                    }
                  | {
                      __typename?: 'PowerDistributionUnitVirtualDevice';
                      UUID: string;
                      label: string;
                      deviceType: VirtualDeviceType;
                    }
                  | {
                      __typename?: 'SwitchVirtualDevice';
                      UUID: string;
                      label: string;
                      deviceType: VirtualDeviceType;
                    };
                connectedDevices?: Array<{
                  __typename?: 'PhyInterfaceConnectedDevice';
                  macAddress: string;
                  hardwareDevice?:
                    | {
                        __typename?: 'AccessPointHardwareDevice';
                        virtualDevice?:
                          | {
                              __typename?: 'AccessPointVirtualDevice';
                              UUID: string;
                              label: string;
                              deviceType: VirtualDeviceType;
                            }
                          | {
                              __typename?: 'ControllerVirtualDevice';
                              UUID: string;
                              label: string;
                              deviceType: VirtualDeviceType;
                            }
                          | {
                              __typename?: 'ObserverVirtualDevice';
                              UUID: string;
                              label: string;
                              deviceType: VirtualDeviceType;
                            }
                          | {
                              __typename?: 'PowerDistributionUnitVirtualDevice';
                              UUID: string;
                              label: string;
                              deviceType: VirtualDeviceType;
                            }
                          | {
                              __typename?: 'SwitchVirtualDevice';
                              UUID: string;
                              label: string;
                              deviceType: VirtualDeviceType;
                            }
                          | null;
                      }
                    | {
                        __typename?: 'ControllerHardwareDevice';
                        virtualDevice?:
                          | {
                              __typename?: 'AccessPointVirtualDevice';
                              UUID: string;
                              label: string;
                              deviceType: VirtualDeviceType;
                            }
                          | {
                              __typename?: 'ControllerVirtualDevice';
                              UUID: string;
                              label: string;
                              deviceType: VirtualDeviceType;
                            }
                          | {
                              __typename?: 'ObserverVirtualDevice';
                              UUID: string;
                              label: string;
                              deviceType: VirtualDeviceType;
                            }
                          | {
                              __typename?: 'PowerDistributionUnitVirtualDevice';
                              UUID: string;
                              label: string;
                              deviceType: VirtualDeviceType;
                            }
                          | {
                              __typename?: 'SwitchVirtualDevice';
                              UUID: string;
                              label: string;
                              deviceType: VirtualDeviceType;
                            }
                          | null;
                      }
                    | {
                        __typename?: 'PowerDistributionUnitHardwareDevice';
                        virtualDevice?:
                          | {
                              __typename?: 'AccessPointVirtualDevice';
                              UUID: string;
                              label: string;
                              deviceType: VirtualDeviceType;
                            }
                          | {
                              __typename?: 'ControllerVirtualDevice';
                              UUID: string;
                              label: string;
                              deviceType: VirtualDeviceType;
                            }
                          | {
                              __typename?: 'ObserverVirtualDevice';
                              UUID: string;
                              label: string;
                              deviceType: VirtualDeviceType;
                            }
                          | {
                              __typename?: 'PowerDistributionUnitVirtualDevice';
                              UUID: string;
                              label: string;
                              deviceType: VirtualDeviceType;
                            }
                          | {
                              __typename?: 'SwitchVirtualDevice';
                              UUID: string;
                              label: string;
                              deviceType: VirtualDeviceType;
                            }
                          | null;
                      }
                    | {
                        __typename?: 'SwitchHardwareDevice';
                        virtualDevice?:
                          | {
                              __typename?: 'AccessPointVirtualDevice';
                              UUID: string;
                              label: string;
                              deviceType: VirtualDeviceType;
                            }
                          | {
                              __typename?: 'ControllerVirtualDevice';
                              UUID: string;
                              label: string;
                              deviceType: VirtualDeviceType;
                            }
                          | {
                              __typename?: 'ObserverVirtualDevice';
                              UUID: string;
                              label: string;
                              deviceType: VirtualDeviceType;
                            }
                          | {
                              __typename?: 'PowerDistributionUnitVirtualDevice';
                              UUID: string;
                              label: string;
                              deviceType: VirtualDeviceType;
                            }
                          | {
                              __typename?: 'SwitchVirtualDevice';
                              UUID: string;
                              label: string;
                              deviceType: VirtualDeviceType;
                            }
                          | null;
                      }
                    | null;
                }> | null;
              } | null;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string; createdAt: string }>;
              latestDeviceConfigMetadata?: {
                __typename?: 'DeviceConfigMetadata';
                version: number;
                acknowledgedAt?: string | null;
                createdAt: string;
                isCurrentAsOf?: string | null;
                state?: {
                  __typename?: 'DeviceConfigState';
                  state: DeviceConfigStateType;
                  timestamp: string;
                } | null;
              } | null;
            }
          | {
              __typename: 'ControllerHardwareDevice';
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              isDev?: boolean;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string; createdAt: string }>;
              latestDeviceConfigMetadata?: {
                __typename?: 'DeviceConfigMetadata';
                version: number;
                acknowledgedAt?: string | null;
                createdAt: string;
                isCurrentAsOf?: string | null;
                state?: {
                  __typename?: 'DeviceConfigState';
                  state: DeviceConfigStateType;
                  timestamp: string;
                } | null;
              } | null;
            }
          | {
              __typename: 'PowerDistributionUnitHardwareDevice';
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              isDev?: boolean;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string; createdAt: string }>;
              latestDeviceConfigMetadata?: {
                __typename?: 'DeviceConfigMetadata';
                version: number;
                acknowledgedAt?: string | null;
                createdAt: string;
                isCurrentAsOf?: string | null;
                state?: {
                  __typename?: 'DeviceConfigState';
                  state: DeviceConfigStateType;
                  timestamp: string;
                } | null;
              } | null;
            }
          | {
              __typename: 'SwitchHardwareDevice';
              ipAddress?: string | null;
              isInCurrentControllerMACTable: boolean;
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              isDev?: boolean;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string; createdAt: string }>;
              latestDeviceConfigMetadata?: {
                __typename?: 'DeviceConfigMetadata';
                version: number;
                acknowledgedAt?: string | null;
                createdAt: string;
                isCurrentAsOf?: string | null;
                state?: {
                  __typename?: 'DeviceConfigState';
                  state: DeviceConfigStateType;
                  timestamp: string;
                } | null;
              } | null;
            }
          | null;
      }
    | {
        __typename: 'PowerDistributionUnitVirtualDevice';
        ipAddress?: string | null;
        UUID: string;
        uptime?: string | null;
        label: string;
        description?: string | null;
        deviceType: VirtualDeviceType;
        network: { __typename?: 'Network'; UUID: string; slug: string; label: string };
        nosVersion?: {
          __typename?: 'ConfiguredNOSVersion';
          id: number;
          version: string;
          buildName: string;
        } | null;
        pendingNosVersion?: {
          __typename?: 'PendingNosVersion';
          scheduledAt: string;
          nosVersion: { __typename?: 'NosVersion'; version: string };
        } | null;
        hardwareDevice?:
          | {
              __typename: 'AccessPointHardwareDevice';
              ipAddress?: string | null;
              isInCurrentControllerMACTable: boolean;
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              isDev?: boolean;
              phyInterfaceConnectedTo?: {
                __typename?: 'PhyInterface';
                UUID: string;
                isEthernet: boolean;
                isSFP: boolean;
                isUplink: boolean;
                isUplinkActive?: boolean | null;
                isConnected: boolean;
                portSpeedMbps?: number | null;
                maxSpeedMbps?: number | null;
                isFLIPEnabled: boolean;
                isVoiceVLANEnabled: boolean;
                powerDraw?: number | null;
                poeType?: PoEType | null;
                hasWANActivity?: boolean | null;
                portNumber: number;
                isTrunkPort: boolean;
                isBoundToAllVLANs: boolean;
                sfpModuleInfo?: {
                  __typename?: 'SFPModuleInfo';
                  moduleSpeedKbps?: number | null;
                } | null;
                virtualDevice:
                  | {
                      __typename?: 'AccessPointVirtualDevice';
                      UUID: string;
                      label: string;
                      deviceType: VirtualDeviceType;
                    }
                  | {
                      __typename?: 'ControllerVirtualDevice';
                      UUID: string;
                      label: string;
                      deviceType: VirtualDeviceType;
                    }
                  | {
                      __typename?: 'ObserverVirtualDevice';
                      UUID: string;
                      label: string;
                      deviceType: VirtualDeviceType;
                    }
                  | {
                      __typename?: 'PowerDistributionUnitVirtualDevice';
                      UUID: string;
                      label: string;
                      deviceType: VirtualDeviceType;
                    }
                  | {
                      __typename?: 'SwitchVirtualDevice';
                      UUID: string;
                      label: string;
                      deviceType: VirtualDeviceType;
                    };
                connectedDevices?: Array<{
                  __typename?: 'PhyInterfaceConnectedDevice';
                  macAddress: string;
                  hardwareDevice?:
                    | {
                        __typename?: 'AccessPointHardwareDevice';
                        virtualDevice?:
                          | {
                              __typename?: 'AccessPointVirtualDevice';
                              UUID: string;
                              label: string;
                              deviceType: VirtualDeviceType;
                            }
                          | {
                              __typename?: 'ControllerVirtualDevice';
                              UUID: string;
                              label: string;
                              deviceType: VirtualDeviceType;
                            }
                          | {
                              __typename?: 'ObserverVirtualDevice';
                              UUID: string;
                              label: string;
                              deviceType: VirtualDeviceType;
                            }
                          | {
                              __typename?: 'PowerDistributionUnitVirtualDevice';
                              UUID: string;
                              label: string;
                              deviceType: VirtualDeviceType;
                            }
                          | {
                              __typename?: 'SwitchVirtualDevice';
                              UUID: string;
                              label: string;
                              deviceType: VirtualDeviceType;
                            }
                          | null;
                      }
                    | {
                        __typename?: 'ControllerHardwareDevice';
                        virtualDevice?:
                          | {
                              __typename?: 'AccessPointVirtualDevice';
                              UUID: string;
                              label: string;
                              deviceType: VirtualDeviceType;
                            }
                          | {
                              __typename?: 'ControllerVirtualDevice';
                              UUID: string;
                              label: string;
                              deviceType: VirtualDeviceType;
                            }
                          | {
                              __typename?: 'ObserverVirtualDevice';
                              UUID: string;
                              label: string;
                              deviceType: VirtualDeviceType;
                            }
                          | {
                              __typename?: 'PowerDistributionUnitVirtualDevice';
                              UUID: string;
                              label: string;
                              deviceType: VirtualDeviceType;
                            }
                          | {
                              __typename?: 'SwitchVirtualDevice';
                              UUID: string;
                              label: string;
                              deviceType: VirtualDeviceType;
                            }
                          | null;
                      }
                    | {
                        __typename?: 'PowerDistributionUnitHardwareDevice';
                        virtualDevice?:
                          | {
                              __typename?: 'AccessPointVirtualDevice';
                              UUID: string;
                              label: string;
                              deviceType: VirtualDeviceType;
                            }
                          | {
                              __typename?: 'ControllerVirtualDevice';
                              UUID: string;
                              label: string;
                              deviceType: VirtualDeviceType;
                            }
                          | {
                              __typename?: 'ObserverVirtualDevice';
                              UUID: string;
                              label: string;
                              deviceType: VirtualDeviceType;
                            }
                          | {
                              __typename?: 'PowerDistributionUnitVirtualDevice';
                              UUID: string;
                              label: string;
                              deviceType: VirtualDeviceType;
                            }
                          | {
                              __typename?: 'SwitchVirtualDevice';
                              UUID: string;
                              label: string;
                              deviceType: VirtualDeviceType;
                            }
                          | null;
                      }
                    | {
                        __typename?: 'SwitchHardwareDevice';
                        virtualDevice?:
                          | {
                              __typename?: 'AccessPointVirtualDevice';
                              UUID: string;
                              label: string;
                              deviceType: VirtualDeviceType;
                            }
                          | {
                              __typename?: 'ControllerVirtualDevice';
                              UUID: string;
                              label: string;
                              deviceType: VirtualDeviceType;
                            }
                          | {
                              __typename?: 'ObserverVirtualDevice';
                              UUID: string;
                              label: string;
                              deviceType: VirtualDeviceType;
                            }
                          | {
                              __typename?: 'PowerDistributionUnitVirtualDevice';
                              UUID: string;
                              label: string;
                              deviceType: VirtualDeviceType;
                            }
                          | {
                              __typename?: 'SwitchVirtualDevice';
                              UUID: string;
                              label: string;
                              deviceType: VirtualDeviceType;
                            }
                          | null;
                      }
                    | null;
                }> | null;
              } | null;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string; createdAt: string }>;
              latestDeviceConfigMetadata?: {
                __typename?: 'DeviceConfigMetadata';
                version: number;
                acknowledgedAt?: string | null;
                createdAt: string;
                isCurrentAsOf?: string | null;
                state?: {
                  __typename?: 'DeviceConfigState';
                  state: DeviceConfigStateType;
                  timestamp: string;
                } | null;
              } | null;
            }
          | {
              __typename: 'ControllerHardwareDevice';
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              isDev?: boolean;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string; createdAt: string }>;
              latestDeviceConfigMetadata?: {
                __typename?: 'DeviceConfigMetadata';
                version: number;
                acknowledgedAt?: string | null;
                createdAt: string;
                isCurrentAsOf?: string | null;
                state?: {
                  __typename?: 'DeviceConfigState';
                  state: DeviceConfigStateType;
                  timestamp: string;
                } | null;
              } | null;
            }
          | {
              __typename: 'PowerDistributionUnitHardwareDevice';
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              isDev?: boolean;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string; createdAt: string }>;
              latestDeviceConfigMetadata?: {
                __typename?: 'DeviceConfigMetadata';
                version: number;
                acknowledgedAt?: string | null;
                createdAt: string;
                isCurrentAsOf?: string | null;
                state?: {
                  __typename?: 'DeviceConfigState';
                  state: DeviceConfigStateType;
                  timestamp: string;
                } | null;
              } | null;
            }
          | {
              __typename: 'SwitchHardwareDevice';
              ipAddress?: string | null;
              isInCurrentControllerMACTable: boolean;
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              isDev?: boolean;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string; createdAt: string }>;
              latestDeviceConfigMetadata?: {
                __typename?: 'DeviceConfigMetadata';
                version: number;
                acknowledgedAt?: string | null;
                createdAt: string;
                isCurrentAsOf?: string | null;
                state?: {
                  __typename?: 'DeviceConfigState';
                  state: DeviceConfigStateType;
                  timestamp: string;
                } | null;
              } | null;
            }
          | null;
      }
    | {
        __typename: 'SwitchVirtualDevice';
        UUID: string;
        uptime?: string | null;
        label: string;
        description?: string | null;
        deviceType: VirtualDeviceType;
        phyInterfaces: Array<{
          __typename?: 'PhyInterface';
          UUID: string;
          isEthernet: boolean;
          isSFP: boolean;
          isUplink: boolean;
          isUplinkActive?: boolean | null;
          isConnected: boolean;
          portSpeedMbps?: number | null;
          maxSpeedMbps?: number | null;
          isFLIPEnabled: boolean;
          isVoiceVLANEnabled: boolean;
          powerDraw?: number | null;
          poeType?: PoEType | null;
          hasWANActivity?: boolean | null;
          portNumber: number;
          isTrunkPort: boolean;
          isBoundToAllVLANs: boolean;
          sfpModuleInfo?: { __typename?: 'SFPModuleInfo'; moduleSpeedKbps?: number | null } | null;
          virtualDevice:
            | {
                __typename?: 'AccessPointVirtualDevice';
                UUID: string;
                label: string;
                deviceType: VirtualDeviceType;
              }
            | {
                __typename?: 'ControllerVirtualDevice';
                UUID: string;
                label: string;
                deviceType: VirtualDeviceType;
              }
            | {
                __typename?: 'ObserverVirtualDevice';
                UUID: string;
                label: string;
                deviceType: VirtualDeviceType;
              }
            | {
                __typename?: 'PowerDistributionUnitVirtualDevice';
                UUID: string;
                label: string;
                deviceType: VirtualDeviceType;
              }
            | {
                __typename?: 'SwitchVirtualDevice';
                UUID: string;
                label: string;
                deviceType: VirtualDeviceType;
              };
          connectedDevices?: Array<{
            __typename?: 'PhyInterfaceConnectedDevice';
            macAddress: string;
            hardwareDevice?:
              | {
                  __typename?: 'AccessPointHardwareDevice';
                  virtualDevice?:
                    | {
                        __typename?: 'AccessPointVirtualDevice';
                        UUID: string;
                        label: string;
                        deviceType: VirtualDeviceType;
                      }
                    | {
                        __typename?: 'ControllerVirtualDevice';
                        UUID: string;
                        label: string;
                        deviceType: VirtualDeviceType;
                      }
                    | {
                        __typename?: 'ObserverVirtualDevice';
                        UUID: string;
                        label: string;
                        deviceType: VirtualDeviceType;
                      }
                    | {
                        __typename?: 'PowerDistributionUnitVirtualDevice';
                        UUID: string;
                        label: string;
                        deviceType: VirtualDeviceType;
                      }
                    | {
                        __typename?: 'SwitchVirtualDevice';
                        UUID: string;
                        label: string;
                        deviceType: VirtualDeviceType;
                      }
                    | null;
                }
              | {
                  __typename?: 'ControllerHardwareDevice';
                  virtualDevice?:
                    | {
                        __typename?: 'AccessPointVirtualDevice';
                        UUID: string;
                        label: string;
                        deviceType: VirtualDeviceType;
                      }
                    | {
                        __typename?: 'ControllerVirtualDevice';
                        UUID: string;
                        label: string;
                        deviceType: VirtualDeviceType;
                      }
                    | {
                        __typename?: 'ObserverVirtualDevice';
                        UUID: string;
                        label: string;
                        deviceType: VirtualDeviceType;
                      }
                    | {
                        __typename?: 'PowerDistributionUnitVirtualDevice';
                        UUID: string;
                        label: string;
                        deviceType: VirtualDeviceType;
                      }
                    | {
                        __typename?: 'SwitchVirtualDevice';
                        UUID: string;
                        label: string;
                        deviceType: VirtualDeviceType;
                      }
                    | null;
                }
              | {
                  __typename?: 'PowerDistributionUnitHardwareDevice';
                  virtualDevice?:
                    | {
                        __typename?: 'AccessPointVirtualDevice';
                        UUID: string;
                        label: string;
                        deviceType: VirtualDeviceType;
                      }
                    | {
                        __typename?: 'ControllerVirtualDevice';
                        UUID: string;
                        label: string;
                        deviceType: VirtualDeviceType;
                      }
                    | {
                        __typename?: 'ObserverVirtualDevice';
                        UUID: string;
                        label: string;
                        deviceType: VirtualDeviceType;
                      }
                    | {
                        __typename?: 'PowerDistributionUnitVirtualDevice';
                        UUID: string;
                        label: string;
                        deviceType: VirtualDeviceType;
                      }
                    | {
                        __typename?: 'SwitchVirtualDevice';
                        UUID: string;
                        label: string;
                        deviceType: VirtualDeviceType;
                      }
                    | null;
                }
              | {
                  __typename?: 'SwitchHardwareDevice';
                  virtualDevice?:
                    | {
                        __typename?: 'AccessPointVirtualDevice';
                        UUID: string;
                        label: string;
                        deviceType: VirtualDeviceType;
                      }
                    | {
                        __typename?: 'ControllerVirtualDevice';
                        UUID: string;
                        label: string;
                        deviceType: VirtualDeviceType;
                      }
                    | {
                        __typename?: 'ObserverVirtualDevice';
                        UUID: string;
                        label: string;
                        deviceType: VirtualDeviceType;
                      }
                    | {
                        __typename?: 'PowerDistributionUnitVirtualDevice';
                        UUID: string;
                        label: string;
                        deviceType: VirtualDeviceType;
                      }
                    | {
                        __typename?: 'SwitchVirtualDevice';
                        UUID: string;
                        label: string;
                        deviceType: VirtualDeviceType;
                      }
                    | null;
                }
              | null;
          }> | null;
        }>;
        switchProfile: {
          __typename?: 'SwitchProfile';
          stpBridgePriority: number;
          switchingTier: SwitchProfileSwitchingTier;
        };
        network: { __typename?: 'Network'; UUID: string; slug: string; label: string };
        nosVersion?: {
          __typename?: 'ConfiguredNOSVersion';
          id: number;
          version: string;
          buildName: string;
        } | null;
        pendingNosVersion?: {
          __typename?: 'PendingNosVersion';
          scheduledAt: string;
          nosVersion: { __typename?: 'NosVersion'; version: string };
        } | null;
        hardwareDevice?:
          | {
              __typename: 'AccessPointHardwareDevice';
              ipAddress?: string | null;
              isInCurrentControllerMACTable: boolean;
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              isDev?: boolean;
              phyInterfaceConnectedTo?: {
                __typename?: 'PhyInterface';
                UUID: string;
                isEthernet: boolean;
                isSFP: boolean;
                isUplink: boolean;
                isUplinkActive?: boolean | null;
                isConnected: boolean;
                portSpeedMbps?: number | null;
                maxSpeedMbps?: number | null;
                isFLIPEnabled: boolean;
                isVoiceVLANEnabled: boolean;
                powerDraw?: number | null;
                poeType?: PoEType | null;
                hasWANActivity?: boolean | null;
                portNumber: number;
                isTrunkPort: boolean;
                isBoundToAllVLANs: boolean;
                sfpModuleInfo?: {
                  __typename?: 'SFPModuleInfo';
                  moduleSpeedKbps?: number | null;
                } | null;
                virtualDevice:
                  | {
                      __typename?: 'AccessPointVirtualDevice';
                      UUID: string;
                      label: string;
                      deviceType: VirtualDeviceType;
                    }
                  | {
                      __typename?: 'ControllerVirtualDevice';
                      UUID: string;
                      label: string;
                      deviceType: VirtualDeviceType;
                    }
                  | {
                      __typename?: 'ObserverVirtualDevice';
                      UUID: string;
                      label: string;
                      deviceType: VirtualDeviceType;
                    }
                  | {
                      __typename?: 'PowerDistributionUnitVirtualDevice';
                      UUID: string;
                      label: string;
                      deviceType: VirtualDeviceType;
                    }
                  | {
                      __typename?: 'SwitchVirtualDevice';
                      UUID: string;
                      label: string;
                      deviceType: VirtualDeviceType;
                    };
                connectedDevices?: Array<{
                  __typename?: 'PhyInterfaceConnectedDevice';
                  macAddress: string;
                  hardwareDevice?:
                    | {
                        __typename?: 'AccessPointHardwareDevice';
                        virtualDevice?:
                          | {
                              __typename?: 'AccessPointVirtualDevice';
                              UUID: string;
                              label: string;
                              deviceType: VirtualDeviceType;
                            }
                          | {
                              __typename?: 'ControllerVirtualDevice';
                              UUID: string;
                              label: string;
                              deviceType: VirtualDeviceType;
                            }
                          | {
                              __typename?: 'ObserverVirtualDevice';
                              UUID: string;
                              label: string;
                              deviceType: VirtualDeviceType;
                            }
                          | {
                              __typename?: 'PowerDistributionUnitVirtualDevice';
                              UUID: string;
                              label: string;
                              deviceType: VirtualDeviceType;
                            }
                          | {
                              __typename?: 'SwitchVirtualDevice';
                              UUID: string;
                              label: string;
                              deviceType: VirtualDeviceType;
                            }
                          | null;
                      }
                    | {
                        __typename?: 'ControllerHardwareDevice';
                        virtualDevice?:
                          | {
                              __typename?: 'AccessPointVirtualDevice';
                              UUID: string;
                              label: string;
                              deviceType: VirtualDeviceType;
                            }
                          | {
                              __typename?: 'ControllerVirtualDevice';
                              UUID: string;
                              label: string;
                              deviceType: VirtualDeviceType;
                            }
                          | {
                              __typename?: 'ObserverVirtualDevice';
                              UUID: string;
                              label: string;
                              deviceType: VirtualDeviceType;
                            }
                          | {
                              __typename?: 'PowerDistributionUnitVirtualDevice';
                              UUID: string;
                              label: string;
                              deviceType: VirtualDeviceType;
                            }
                          | {
                              __typename?: 'SwitchVirtualDevice';
                              UUID: string;
                              label: string;
                              deviceType: VirtualDeviceType;
                            }
                          | null;
                      }
                    | {
                        __typename?: 'PowerDistributionUnitHardwareDevice';
                        virtualDevice?:
                          | {
                              __typename?: 'AccessPointVirtualDevice';
                              UUID: string;
                              label: string;
                              deviceType: VirtualDeviceType;
                            }
                          | {
                              __typename?: 'ControllerVirtualDevice';
                              UUID: string;
                              label: string;
                              deviceType: VirtualDeviceType;
                            }
                          | {
                              __typename?: 'ObserverVirtualDevice';
                              UUID: string;
                              label: string;
                              deviceType: VirtualDeviceType;
                            }
                          | {
                              __typename?: 'PowerDistributionUnitVirtualDevice';
                              UUID: string;
                              label: string;
                              deviceType: VirtualDeviceType;
                            }
                          | {
                              __typename?: 'SwitchVirtualDevice';
                              UUID: string;
                              label: string;
                              deviceType: VirtualDeviceType;
                            }
                          | null;
                      }
                    | {
                        __typename?: 'SwitchHardwareDevice';
                        virtualDevice?:
                          | {
                              __typename?: 'AccessPointVirtualDevice';
                              UUID: string;
                              label: string;
                              deviceType: VirtualDeviceType;
                            }
                          | {
                              __typename?: 'ControllerVirtualDevice';
                              UUID: string;
                              label: string;
                              deviceType: VirtualDeviceType;
                            }
                          | {
                              __typename?: 'ObserverVirtualDevice';
                              UUID: string;
                              label: string;
                              deviceType: VirtualDeviceType;
                            }
                          | {
                              __typename?: 'PowerDistributionUnitVirtualDevice';
                              UUID: string;
                              label: string;
                              deviceType: VirtualDeviceType;
                            }
                          | {
                              __typename?: 'SwitchVirtualDevice';
                              UUID: string;
                              label: string;
                              deviceType: VirtualDeviceType;
                            }
                          | null;
                      }
                    | null;
                }> | null;
              } | null;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string; createdAt: string }>;
              latestDeviceConfigMetadata?: {
                __typename?: 'DeviceConfigMetadata';
                version: number;
                acknowledgedAt?: string | null;
                createdAt: string;
                isCurrentAsOf?: string | null;
                state?: {
                  __typename?: 'DeviceConfigState';
                  state: DeviceConfigStateType;
                  timestamp: string;
                } | null;
              } | null;
            }
          | {
              __typename: 'ControllerHardwareDevice';
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              isDev?: boolean;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string; createdAt: string }>;
              latestDeviceConfigMetadata?: {
                __typename?: 'DeviceConfigMetadata';
                version: number;
                acknowledgedAt?: string | null;
                createdAt: string;
                isCurrentAsOf?: string | null;
                state?: {
                  __typename?: 'DeviceConfigState';
                  state: DeviceConfigStateType;
                  timestamp: string;
                } | null;
              } | null;
            }
          | {
              __typename: 'PowerDistributionUnitHardwareDevice';
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              isDev?: boolean;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string; createdAt: string }>;
              latestDeviceConfigMetadata?: {
                __typename?: 'DeviceConfigMetadata';
                version: number;
                acknowledgedAt?: string | null;
                createdAt: string;
                isCurrentAsOf?: string | null;
                state?: {
                  __typename?: 'DeviceConfigState';
                  state: DeviceConfigStateType;
                  timestamp: string;
                } | null;
              } | null;
            }
          | {
              __typename: 'SwitchHardwareDevice';
              ipAddress?: string | null;
              isInCurrentControllerMACTable: boolean;
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              isDev?: boolean;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string; createdAt: string }>;
              latestDeviceConfigMetadata?: {
                __typename?: 'DeviceConfigMetadata';
                version: number;
                acknowledgedAt?: string | null;
                createdAt: string;
                isCurrentAsOf?: string | null;
                state?: {
                  __typename?: 'DeviceConfigState';
                  state: DeviceConfigStateType;
                  timestamp: string;
                } | null;
              } | null;
            }
          | null;
      }
  >;
};

export type PhyInterfaceFieldsForInstallStatusFragment = {
  __typename?: 'PhyInterface';
  UUID: string;
  isEthernet: boolean;
  isSFP: boolean;
  isUplink: boolean;
  isUplinkActive?: boolean | null;
  isConnected: boolean;
  portSpeedMbps?: number | null;
  maxSpeedMbps?: number | null;
  isFLIPEnabled: boolean;
  isVoiceVLANEnabled: boolean;
  powerDraw?: number | null;
  poeType?: PoEType | null;
  hasWANActivity?: boolean | null;
  portNumber: number;
  isTrunkPort: boolean;
  isBoundToAllVLANs: boolean;
  sfpModuleInfo?: { __typename?: 'SFPModuleInfo'; moduleSpeedKbps?: number | null } | null;
  virtualDevice:
    | {
        __typename?: 'AccessPointVirtualDevice';
        UUID: string;
        label: string;
        deviceType: VirtualDeviceType;
      }
    | {
        __typename?: 'ControllerVirtualDevice';
        UUID: string;
        label: string;
        deviceType: VirtualDeviceType;
      }
    | {
        __typename?: 'ObserverVirtualDevice';
        UUID: string;
        label: string;
        deviceType: VirtualDeviceType;
      }
    | {
        __typename?: 'PowerDistributionUnitVirtualDevice';
        UUID: string;
        label: string;
        deviceType: VirtualDeviceType;
      }
    | {
        __typename?: 'SwitchVirtualDevice';
        UUID: string;
        label: string;
        deviceType: VirtualDeviceType;
      };
  connectedDevices?: Array<{
    __typename?: 'PhyInterfaceConnectedDevice';
    macAddress: string;
    hardwareDevice?:
      | {
          __typename?: 'AccessPointHardwareDevice';
          virtualDevice?:
            | {
                __typename?: 'AccessPointVirtualDevice';
                UUID: string;
                label: string;
                deviceType: VirtualDeviceType;
              }
            | {
                __typename?: 'ControllerVirtualDevice';
                UUID: string;
                label: string;
                deviceType: VirtualDeviceType;
              }
            | {
                __typename?: 'ObserverVirtualDevice';
                UUID: string;
                label: string;
                deviceType: VirtualDeviceType;
              }
            | {
                __typename?: 'PowerDistributionUnitVirtualDevice';
                UUID: string;
                label: string;
                deviceType: VirtualDeviceType;
              }
            | {
                __typename?: 'SwitchVirtualDevice';
                UUID: string;
                label: string;
                deviceType: VirtualDeviceType;
              }
            | null;
        }
      | {
          __typename?: 'ControllerHardwareDevice';
          virtualDevice?:
            | {
                __typename?: 'AccessPointVirtualDevice';
                UUID: string;
                label: string;
                deviceType: VirtualDeviceType;
              }
            | {
                __typename?: 'ControllerVirtualDevice';
                UUID: string;
                label: string;
                deviceType: VirtualDeviceType;
              }
            | {
                __typename?: 'ObserverVirtualDevice';
                UUID: string;
                label: string;
                deviceType: VirtualDeviceType;
              }
            | {
                __typename?: 'PowerDistributionUnitVirtualDevice';
                UUID: string;
                label: string;
                deviceType: VirtualDeviceType;
              }
            | {
                __typename?: 'SwitchVirtualDevice';
                UUID: string;
                label: string;
                deviceType: VirtualDeviceType;
              }
            | null;
        }
      | {
          __typename?: 'PowerDistributionUnitHardwareDevice';
          virtualDevice?:
            | {
                __typename?: 'AccessPointVirtualDevice';
                UUID: string;
                label: string;
                deviceType: VirtualDeviceType;
              }
            | {
                __typename?: 'ControllerVirtualDevice';
                UUID: string;
                label: string;
                deviceType: VirtualDeviceType;
              }
            | {
                __typename?: 'ObserverVirtualDevice';
                UUID: string;
                label: string;
                deviceType: VirtualDeviceType;
              }
            | {
                __typename?: 'PowerDistributionUnitVirtualDevice';
                UUID: string;
                label: string;
                deviceType: VirtualDeviceType;
              }
            | {
                __typename?: 'SwitchVirtualDevice';
                UUID: string;
                label: string;
                deviceType: VirtualDeviceType;
              }
            | null;
        }
      | {
          __typename?: 'SwitchHardwareDevice';
          virtualDevice?:
            | {
                __typename?: 'AccessPointVirtualDevice';
                UUID: string;
                label: string;
                deviceType: VirtualDeviceType;
              }
            | {
                __typename?: 'ControllerVirtualDevice';
                UUID: string;
                label: string;
                deviceType: VirtualDeviceType;
              }
            | {
                __typename?: 'ObserverVirtualDevice';
                UUID: string;
                label: string;
                deviceType: VirtualDeviceType;
              }
            | {
                __typename?: 'PowerDistributionUnitVirtualDevice';
                UUID: string;
                label: string;
                deviceType: VirtualDeviceType;
              }
            | {
                __typename?: 'SwitchVirtualDevice';
                UUID: string;
                label: string;
                deviceType: VirtualDeviceType;
              }
            | null;
        }
      | null;
  }> | null;
};

type HardwareDeviceFieldsForInstallStatus_AccessPointHardwareDevice_Fragment = {
  __typename: 'AccessPointHardwareDevice';
  ipAddress?: string | null;
  isInCurrentControllerMACTable: boolean;
  deviceType: DeviceType;
  serialNumber: string;
  macAddress?: string | null;
  isActive: boolean;
  isConnectedToBackend: boolean;
  disconnectedFromBackendAt?: string | null;
  isDev?: boolean;
  phyInterfaceConnectedTo?: {
    __typename?: 'PhyInterface';
    UUID: string;
    isEthernet: boolean;
    isSFP: boolean;
    isUplink: boolean;
    isUplinkActive?: boolean | null;
    isConnected: boolean;
    portSpeedMbps?: number | null;
    maxSpeedMbps?: number | null;
    isFLIPEnabled: boolean;
    isVoiceVLANEnabled: boolean;
    powerDraw?: number | null;
    poeType?: PoEType | null;
    hasWANActivity?: boolean | null;
    portNumber: number;
    isTrunkPort: boolean;
    isBoundToAllVLANs: boolean;
    sfpModuleInfo?: { __typename?: 'SFPModuleInfo'; moduleSpeedKbps?: number | null } | null;
    virtualDevice:
      | {
          __typename?: 'AccessPointVirtualDevice';
          UUID: string;
          label: string;
          deviceType: VirtualDeviceType;
        }
      | {
          __typename?: 'ControllerVirtualDevice';
          UUID: string;
          label: string;
          deviceType: VirtualDeviceType;
        }
      | {
          __typename?: 'ObserverVirtualDevice';
          UUID: string;
          label: string;
          deviceType: VirtualDeviceType;
        }
      | {
          __typename?: 'PowerDistributionUnitVirtualDevice';
          UUID: string;
          label: string;
          deviceType: VirtualDeviceType;
        }
      | {
          __typename?: 'SwitchVirtualDevice';
          UUID: string;
          label: string;
          deviceType: VirtualDeviceType;
        };
    connectedDevices?: Array<{
      __typename?: 'PhyInterfaceConnectedDevice';
      macAddress: string;
      hardwareDevice?:
        | {
            __typename?: 'AccessPointHardwareDevice';
            virtualDevice?:
              | {
                  __typename?: 'AccessPointVirtualDevice';
                  UUID: string;
                  label: string;
                  deviceType: VirtualDeviceType;
                }
              | {
                  __typename?: 'ControllerVirtualDevice';
                  UUID: string;
                  label: string;
                  deviceType: VirtualDeviceType;
                }
              | {
                  __typename?: 'ObserverVirtualDevice';
                  UUID: string;
                  label: string;
                  deviceType: VirtualDeviceType;
                }
              | {
                  __typename?: 'PowerDistributionUnitVirtualDevice';
                  UUID: string;
                  label: string;
                  deviceType: VirtualDeviceType;
                }
              | {
                  __typename?: 'SwitchVirtualDevice';
                  UUID: string;
                  label: string;
                  deviceType: VirtualDeviceType;
                }
              | null;
          }
        | {
            __typename?: 'ControllerHardwareDevice';
            virtualDevice?:
              | {
                  __typename?: 'AccessPointVirtualDevice';
                  UUID: string;
                  label: string;
                  deviceType: VirtualDeviceType;
                }
              | {
                  __typename?: 'ControllerVirtualDevice';
                  UUID: string;
                  label: string;
                  deviceType: VirtualDeviceType;
                }
              | {
                  __typename?: 'ObserverVirtualDevice';
                  UUID: string;
                  label: string;
                  deviceType: VirtualDeviceType;
                }
              | {
                  __typename?: 'PowerDistributionUnitVirtualDevice';
                  UUID: string;
                  label: string;
                  deviceType: VirtualDeviceType;
                }
              | {
                  __typename?: 'SwitchVirtualDevice';
                  UUID: string;
                  label: string;
                  deviceType: VirtualDeviceType;
                }
              | null;
          }
        | {
            __typename?: 'PowerDistributionUnitHardwareDevice';
            virtualDevice?:
              | {
                  __typename?: 'AccessPointVirtualDevice';
                  UUID: string;
                  label: string;
                  deviceType: VirtualDeviceType;
                }
              | {
                  __typename?: 'ControllerVirtualDevice';
                  UUID: string;
                  label: string;
                  deviceType: VirtualDeviceType;
                }
              | {
                  __typename?: 'ObserverVirtualDevice';
                  UUID: string;
                  label: string;
                  deviceType: VirtualDeviceType;
                }
              | {
                  __typename?: 'PowerDistributionUnitVirtualDevice';
                  UUID: string;
                  label: string;
                  deviceType: VirtualDeviceType;
                }
              | {
                  __typename?: 'SwitchVirtualDevice';
                  UUID: string;
                  label: string;
                  deviceType: VirtualDeviceType;
                }
              | null;
          }
        | {
            __typename?: 'SwitchHardwareDevice';
            virtualDevice?:
              | {
                  __typename?: 'AccessPointVirtualDevice';
                  UUID: string;
                  label: string;
                  deviceType: VirtualDeviceType;
                }
              | {
                  __typename?: 'ControllerVirtualDevice';
                  UUID: string;
                  label: string;
                  deviceType: VirtualDeviceType;
                }
              | {
                  __typename?: 'ObserverVirtualDevice';
                  UUID: string;
                  label: string;
                  deviceType: VirtualDeviceType;
                }
              | {
                  __typename?: 'PowerDistributionUnitVirtualDevice';
                  UUID: string;
                  label: string;
                  deviceType: VirtualDeviceType;
                }
              | {
                  __typename?: 'SwitchVirtualDevice';
                  UUID: string;
                  label: string;
                  deviceType: VirtualDeviceType;
                }
              | null;
          }
        | null;
    }> | null;
  } | null;
  bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string; createdAt: string }>;
  latestDeviceConfigMetadata?: {
    __typename?: 'DeviceConfigMetadata';
    version: number;
    acknowledgedAt?: string | null;
    createdAt: string;
    isCurrentAsOf?: string | null;
    state?: {
      __typename?: 'DeviceConfigState';
      state: DeviceConfigStateType;
      timestamp: string;
    } | null;
  } | null;
};

type HardwareDeviceFieldsForInstallStatus_ControllerHardwareDevice_Fragment = {
  __typename: 'ControllerHardwareDevice';
  deviceType: DeviceType;
  serialNumber: string;
  macAddress?: string | null;
  isActive: boolean;
  isConnectedToBackend: boolean;
  disconnectedFromBackendAt?: string | null;
  isDev?: boolean;
  bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string; createdAt: string }>;
  latestDeviceConfigMetadata?: {
    __typename?: 'DeviceConfigMetadata';
    version: number;
    acknowledgedAt?: string | null;
    createdAt: string;
    isCurrentAsOf?: string | null;
    state?: {
      __typename?: 'DeviceConfigState';
      state: DeviceConfigStateType;
      timestamp: string;
    } | null;
  } | null;
};

type HardwareDeviceFieldsForInstallStatus_PowerDistributionUnitHardwareDevice_Fragment = {
  __typename: 'PowerDistributionUnitHardwareDevice';
  deviceType: DeviceType;
  serialNumber: string;
  macAddress?: string | null;
  isActive: boolean;
  isConnectedToBackend: boolean;
  disconnectedFromBackendAt?: string | null;
  isDev?: boolean;
  bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string; createdAt: string }>;
  latestDeviceConfigMetadata?: {
    __typename?: 'DeviceConfigMetadata';
    version: number;
    acknowledgedAt?: string | null;
    createdAt: string;
    isCurrentAsOf?: string | null;
    state?: {
      __typename?: 'DeviceConfigState';
      state: DeviceConfigStateType;
      timestamp: string;
    } | null;
  } | null;
};

type HardwareDeviceFieldsForInstallStatus_SwitchHardwareDevice_Fragment = {
  __typename: 'SwitchHardwareDevice';
  ipAddress?: string | null;
  isInCurrentControllerMACTable: boolean;
  deviceType: DeviceType;
  serialNumber: string;
  macAddress?: string | null;
  isActive: boolean;
  isConnectedToBackend: boolean;
  disconnectedFromBackendAt?: string | null;
  isDev?: boolean;
  bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string; createdAt: string }>;
  latestDeviceConfigMetadata?: {
    __typename?: 'DeviceConfigMetadata';
    version: number;
    acknowledgedAt?: string | null;
    createdAt: string;
    isCurrentAsOf?: string | null;
    state?: {
      __typename?: 'DeviceConfigState';
      state: DeviceConfigStateType;
      timestamp: string;
    } | null;
  } | null;
};

export type HardwareDeviceFieldsForInstallStatusFragment =
  | HardwareDeviceFieldsForInstallStatus_AccessPointHardwareDevice_Fragment
  | HardwareDeviceFieldsForInstallStatus_ControllerHardwareDevice_Fragment
  | HardwareDeviceFieldsForInstallStatus_PowerDistributionUnitHardwareDevice_Fragment
  | HardwareDeviceFieldsForInstallStatus_SwitchHardwareDevice_Fragment;

export type StatusPageVlaNsQueryQueryVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
}>;

export type StatusPageVlaNsQueryQuery = {
  __typename?: 'Query';
  vlans: Array<{
    __typename: 'VLAN';
    UUID: string;
    name: string;
    isDefault: boolean;
    ipV4ClientGateway?: string | null;
    ipV4ClientPrefixLength?: number | null;
  }>;
};

export type RebootObserverMutationVariables = Exact<{
  serialNumber: Scalars['String']['input'];
}>;

export type RebootObserverMutation = { __typename?: 'Mutation'; rpcRebootDevice: boolean };

export type OutletTopologyLayoutPowerDistributionUnitsQueryVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
}>;

export type OutletTopologyLayoutPowerDistributionUnitsQuery = {
  __typename?: 'Query';
  network: {
    __typename?: 'Network';
    label: string;
    company?: { __typename?: 'Company'; name: string } | null;
    virtualDevices: Array<
      | { __typename: 'AccessPointVirtualDevice'; UUID: string }
      | { __typename: 'ControllerVirtualDevice'; UUID: string }
      | { __typename: 'ObserverVirtualDevice'; UUID: string }
      | {
          __typename: 'PowerDistributionUnitVirtualDevice';
          label: string;
          UUID: string;
          outletInterfaces: Array<{
            __typename?: 'OutletInterface';
            UUID: string;
            outletNumber: number;
            label?: string | null;
            description?: string | null;
            connectedVirtualDevice?:
              | { __typename?: 'AccessPointVirtualDevice'; label: string }
              | { __typename?: 'ControllerVirtualDevice'; label: string }
              | { __typename?: 'ObserverVirtualDevice'; label: string }
              | { __typename?: 'PowerDistributionUnitVirtualDevice'; label: string }
              | { __typename?: 'SwitchVirtualDevice'; label: string }
              | null;
          }>;
        }
      | { __typename: 'SwitchVirtualDevice'; UUID: string }
    >;
  };
};

export type PduMetricsQueryQueryVariables = Exact<{
  virtualDeviceUUID: Scalars['UUID']['input'];
  filter: MetricsFilterInput;
}>;

export type PduMetricsQueryQuery = {
  __typename?: 'Query';
  pduMetrics: {
    __typename?: 'PDUMetricsTimeseriesResponse';
    temperatureCelsius: {
      __typename?: 'BaseMetricsResponse';
      metadata?: { __typename?: 'MetricsMetadata'; minValue: number; maxValue: number } | null;
      values: Array<{ __typename?: 'BaseMetricsValue'; timestamp: string; value: number }>;
    };
    outlets: Array<{
      __typename?: 'PDUOutletMetricsTimeseriesResponse';
      outlet: { __typename?: 'OutletInterface'; label?: string | null; outletNumber: number };
      powerWatts: {
        __typename?: 'BaseMetricsResponse';
        metadata?: { __typename?: 'MetricsMetadata'; minValue: number; maxValue: number } | null;
        values: Array<{ __typename?: 'BaseMetricsValue'; timestamp: string; value: number }>;
      };
      voltageVolts: {
        __typename?: 'BaseMetricsResponse';
        metadata?: { __typename?: 'MetricsMetadata'; minValue: number; maxValue: number } | null;
        values: Array<{ __typename?: 'BaseMetricsValue'; timestamp: string; value: number }>;
      };
      currentAmps: {
        __typename?: 'BaseMetricsResponse';
        metadata?: { __typename?: 'MetricsMetadata'; minValue: number; maxValue: number } | null;
        values: Array<{ __typename?: 'BaseMetricsValue'; timestamp: string; value: number }>;
      };
      frequencyHz: {
        __typename?: 'BaseMetricsResponse';
        metadata?: { __typename?: 'MetricsMetadata'; minValue: number; maxValue: number } | null;
        values: Array<{ __typename?: 'BaseMetricsValue'; timestamp: string; value: number }>;
      };
    }>;
  };
};

export type RebootPowerDistributionUnitMutationVariables = Exact<{
  serialNumber: Scalars['String']['input'];
}>;

export type RebootPowerDistributionUnitMutation = {
  __typename?: 'Mutation';
  rpcRebootDevice: boolean;
};

export type FallbackPowerDistributionUnitHardwareQueryQueryVariables = Exact<{
  serialNumber: Scalars['String']['input'];
}>;

export type FallbackPowerDistributionUnitHardwareQueryQuery = {
  __typename?: 'Query';
  hardwareDevice:
    | {
        __typename?: 'AccessPointHardwareDevice';
        serialNumber: string;
        virtualDeviceUUID?: string | null;
      }
    | {
        __typename?: 'ControllerHardwareDevice';
        serialNumber: string;
        virtualDeviceUUID?: string | null;
      }
    | {
        __typename?: 'PowerDistributionUnitHardwareDevice';
        serialNumber: string;
        virtualDeviceUUID?: string | null;
      }
    | {
        __typename?: 'SwitchHardwareDevice';
        serialNumber: string;
        virtualDeviceUUID?: string | null;
      };
};

export type OutletInterfaceFieldsFragment = {
  __typename?: 'OutletInterface';
  UUID: string;
  label?: string | null;
  outletNumber: number;
  virtualDeviceUUID: string;
  isEnabled: boolean;
  powerCycleDelaySec: number;
  description?: string | null;
  currentAmps?: number | null;
  powerWatts?: number | null;
  connectedVirtualDevice?:
    | {
        __typename?: 'AccessPointVirtualDevice';
        UUID: string;
        label: string;
        deviceType: VirtualDeviceType;
      }
    | {
        __typename?: 'ControllerVirtualDevice';
        UUID: string;
        label: string;
        deviceType: VirtualDeviceType;
      }
    | {
        __typename?: 'ObserverVirtualDevice';
        UUID: string;
        label: string;
        deviceType: VirtualDeviceType;
      }
    | {
        __typename?: 'PowerDistributionUnitVirtualDevice';
        UUID: string;
        label: string;
        deviceType: VirtualDeviceType;
      }
    | {
        __typename?: 'SwitchVirtualDevice';
        UUID: string;
        label: string;
        deviceType: VirtualDeviceType;
      }
    | null;
};

export type PowerDistributionUnitQueryQueryVariables = Exact<{
  uuid: Scalars['UUID']['input'];
  includeNOS?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type PowerDistributionUnitQueryQuery = {
  __typename?: 'Query';
  virtualDevice:
    | {
        __typename: 'AccessPointVirtualDevice';
        UUID: string;
        label: string;
        description?: string | null;
        networkUUID: string;
        isConsoleEnabled: boolean;
        deviceType: VirtualDeviceType;
        deviceModel: DeviceModel;
        uptime?: string | null;
        network: { __typename?: 'Network'; UUID: string; slug: string; label: string };
        nosUpgradeGroup?: { __typename?: 'NOSUpgradeGroup'; UUID: string };
        nosVersion?: {
          __typename?: 'ConfiguredNOSVersion';
          id: number;
          buildName: string;
          version: string;
        } | null;
        pendingNosVersion?: {
          __typename?: 'PendingNosVersion';
          scheduledAt: string;
          nosVersion: { __typename?: 'NosVersion'; version: string };
        } | null;
        hardwareDevice?:
          | {
              __typename: 'AccessPointHardwareDevice';
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              macAddress?: string | null;
              deviceModel: DeviceModel;
              serialNumber: string;
              deviceType: DeviceType;
              bootHistory: Array<{
                __typename?: 'BootInfo';
                bootCount: number;
                buildName: string;
                rebootReason: string;
                createdAt: string;
              }>;
            }
          | {
              __typename: 'ControllerHardwareDevice';
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              macAddress?: string | null;
              deviceModel: DeviceModel;
              serialNumber: string;
              deviceType: DeviceType;
              bootHistory: Array<{
                __typename?: 'BootInfo';
                bootCount: number;
                buildName: string;
                rebootReason: string;
                createdAt: string;
              }>;
            }
          | {
              __typename: 'PowerDistributionUnitHardwareDevice';
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              macAddress?: string | null;
              deviceModel: DeviceModel;
              serialNumber: string;
              deviceType: DeviceType;
              phyInterfaceConnectedTo?: {
                __typename?: 'PhyInterface';
                UUID: string;
                portNumber: number;
                virtualDevice:
                  | { __typename?: 'AccessPointVirtualDevice'; UUID: string; label: string }
                  | { __typename?: 'ControllerVirtualDevice'; UUID: string; label: string }
                  | { __typename?: 'ObserverVirtualDevice'; UUID: string; label: string }
                  | {
                      __typename?: 'PowerDistributionUnitVirtualDevice';
                      UUID: string;
                      label: string;
                    }
                  | { __typename?: 'SwitchVirtualDevice'; UUID: string; label: string };
              } | null;
              bootHistory: Array<{
                __typename?: 'BootInfo';
                bootCount: number;
                buildName: string;
                rebootReason: string;
                createdAt: string;
              }>;
            }
          | {
              __typename: 'SwitchHardwareDevice';
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              macAddress?: string | null;
              deviceModel: DeviceModel;
              serialNumber: string;
              deviceType: DeviceType;
              bootHistory: Array<{
                __typename?: 'BootInfo';
                bootCount: number;
                buildName: string;
                rebootReason: string;
                createdAt: string;
              }>;
            }
          | null;
      }
    | {
        __typename: 'ControllerVirtualDevice';
        UUID: string;
        label: string;
        description?: string | null;
        networkUUID: string;
        isConsoleEnabled: boolean;
        deviceType: VirtualDeviceType;
        deviceModel: DeviceModel;
        uptime?: string | null;
        network: { __typename?: 'Network'; UUID: string; slug: string; label: string };
        nosUpgradeGroup?: { __typename?: 'NOSUpgradeGroup'; UUID: string };
        nosVersion?: {
          __typename?: 'ConfiguredNOSVersion';
          id: number;
          buildName: string;
          version: string;
        } | null;
        pendingNosVersion?: {
          __typename?: 'PendingNosVersion';
          scheduledAt: string;
          nosVersion: { __typename?: 'NosVersion'; version: string };
        } | null;
        hardwareDevice?:
          | {
              __typename: 'AccessPointHardwareDevice';
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              macAddress?: string | null;
              deviceModel: DeviceModel;
              serialNumber: string;
              deviceType: DeviceType;
              bootHistory: Array<{
                __typename?: 'BootInfo';
                bootCount: number;
                buildName: string;
                rebootReason: string;
                createdAt: string;
              }>;
            }
          | {
              __typename: 'ControllerHardwareDevice';
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              macAddress?: string | null;
              deviceModel: DeviceModel;
              serialNumber: string;
              deviceType: DeviceType;
              bootHistory: Array<{
                __typename?: 'BootInfo';
                bootCount: number;
                buildName: string;
                rebootReason: string;
                createdAt: string;
              }>;
            }
          | {
              __typename: 'PowerDistributionUnitHardwareDevice';
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              macAddress?: string | null;
              deviceModel: DeviceModel;
              serialNumber: string;
              deviceType: DeviceType;
              phyInterfaceConnectedTo?: {
                __typename?: 'PhyInterface';
                UUID: string;
                portNumber: number;
                virtualDevice:
                  | { __typename?: 'AccessPointVirtualDevice'; UUID: string; label: string }
                  | { __typename?: 'ControllerVirtualDevice'; UUID: string; label: string }
                  | { __typename?: 'ObserverVirtualDevice'; UUID: string; label: string }
                  | {
                      __typename?: 'PowerDistributionUnitVirtualDevice';
                      UUID: string;
                      label: string;
                    }
                  | { __typename?: 'SwitchVirtualDevice'; UUID: string; label: string };
              } | null;
              bootHistory: Array<{
                __typename?: 'BootInfo';
                bootCount: number;
                buildName: string;
                rebootReason: string;
                createdAt: string;
              }>;
            }
          | {
              __typename: 'SwitchHardwareDevice';
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              macAddress?: string | null;
              deviceModel: DeviceModel;
              serialNumber: string;
              deviceType: DeviceType;
              bootHistory: Array<{
                __typename?: 'BootInfo';
                bootCount: number;
                buildName: string;
                rebootReason: string;
                createdAt: string;
              }>;
            }
          | null;
      }
    | {
        __typename: 'ObserverVirtualDevice';
        UUID: string;
        label: string;
        description?: string | null;
        networkUUID: string;
        isConsoleEnabled: boolean;
        deviceType: VirtualDeviceType;
        deviceModel: DeviceModel;
        uptime?: string | null;
        network: { __typename?: 'Network'; UUID: string; slug: string; label: string };
        nosUpgradeGroup?: { __typename?: 'NOSUpgradeGroup'; UUID: string };
        nosVersion?: {
          __typename?: 'ConfiguredNOSVersion';
          id: number;
          buildName: string;
          version: string;
        } | null;
        pendingNosVersion?: {
          __typename?: 'PendingNosVersion';
          scheduledAt: string;
          nosVersion: { __typename?: 'NosVersion'; version: string };
        } | null;
        hardwareDevice?:
          | {
              __typename: 'AccessPointHardwareDevice';
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              macAddress?: string | null;
              deviceModel: DeviceModel;
              serialNumber: string;
              deviceType: DeviceType;
              bootHistory: Array<{
                __typename?: 'BootInfo';
                bootCount: number;
                buildName: string;
                rebootReason: string;
                createdAt: string;
              }>;
            }
          | {
              __typename: 'ControllerHardwareDevice';
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              macAddress?: string | null;
              deviceModel: DeviceModel;
              serialNumber: string;
              deviceType: DeviceType;
              bootHistory: Array<{
                __typename?: 'BootInfo';
                bootCount: number;
                buildName: string;
                rebootReason: string;
                createdAt: string;
              }>;
            }
          | {
              __typename: 'PowerDistributionUnitHardwareDevice';
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              macAddress?: string | null;
              deviceModel: DeviceModel;
              serialNumber: string;
              deviceType: DeviceType;
              phyInterfaceConnectedTo?: {
                __typename?: 'PhyInterface';
                UUID: string;
                portNumber: number;
                virtualDevice:
                  | { __typename?: 'AccessPointVirtualDevice'; UUID: string; label: string }
                  | { __typename?: 'ControllerVirtualDevice'; UUID: string; label: string }
                  | { __typename?: 'ObserverVirtualDevice'; UUID: string; label: string }
                  | {
                      __typename?: 'PowerDistributionUnitVirtualDevice';
                      UUID: string;
                      label: string;
                    }
                  | { __typename?: 'SwitchVirtualDevice'; UUID: string; label: string };
              } | null;
              bootHistory: Array<{
                __typename?: 'BootInfo';
                bootCount: number;
                buildName: string;
                rebootReason: string;
                createdAt: string;
              }>;
            }
          | {
              __typename: 'SwitchHardwareDevice';
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              macAddress?: string | null;
              deviceModel: DeviceModel;
              serialNumber: string;
              deviceType: DeviceType;
              bootHistory: Array<{
                __typename?: 'BootInfo';
                bootCount: number;
                buildName: string;
                rebootReason: string;
                createdAt: string;
              }>;
            }
          | null;
      }
    | {
        __typename: 'PowerDistributionUnitVirtualDevice';
        ipAddress?: string | null;
        ethernetSpeedMbps?: number | null;
        isCircuitBreakerGood?: boolean | null;
        isGrounded?: boolean | null;
        isReadonly: boolean;
        isSurgeProtectionGood?: boolean | null;
        UUID: string;
        label: string;
        description?: string | null;
        networkUUID: string;
        isConsoleEnabled: boolean;
        deviceType: VirtualDeviceType;
        deviceModel: DeviceModel;
        uptime?: string | null;
        outletInterfaces: Array<{
          __typename?: 'OutletInterface';
          UUID: string;
          label?: string | null;
          outletNumber: number;
          virtualDeviceUUID: string;
          isEnabled: boolean;
          powerCycleDelaySec: number;
          description?: string | null;
          currentAmps?: number | null;
          powerWatts?: number | null;
          connectedVirtualDevice?:
            | {
                __typename?: 'AccessPointVirtualDevice';
                UUID: string;
                label: string;
                deviceType: VirtualDeviceType;
              }
            | {
                __typename?: 'ControllerVirtualDevice';
                UUID: string;
                label: string;
                deviceType: VirtualDeviceType;
              }
            | {
                __typename?: 'ObserverVirtualDevice';
                UUID: string;
                label: string;
                deviceType: VirtualDeviceType;
              }
            | {
                __typename?: 'PowerDistributionUnitVirtualDevice';
                UUID: string;
                label: string;
                deviceType: VirtualDeviceType;
              }
            | {
                __typename?: 'SwitchVirtualDevice';
                UUID: string;
                label: string;
                deviceType: VirtualDeviceType;
              }
            | null;
        }>;
        network: { __typename?: 'Network'; UUID: string; slug: string; label: string };
        nosUpgradeGroup?: { __typename?: 'NOSUpgradeGroup'; UUID: string };
        nosVersion?: {
          __typename?: 'ConfiguredNOSVersion';
          id: number;
          buildName: string;
          version: string;
        } | null;
        pendingNosVersion?: {
          __typename?: 'PendingNosVersion';
          scheduledAt: string;
          nosVersion: { __typename?: 'NosVersion'; version: string };
        } | null;
        hardwareDevice?:
          | {
              __typename: 'AccessPointHardwareDevice';
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              macAddress?: string | null;
              deviceModel: DeviceModel;
              serialNumber: string;
              deviceType: DeviceType;
              bootHistory: Array<{
                __typename?: 'BootInfo';
                bootCount: number;
                buildName: string;
                rebootReason: string;
                createdAt: string;
              }>;
            }
          | {
              __typename: 'ControllerHardwareDevice';
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              macAddress?: string | null;
              deviceModel: DeviceModel;
              serialNumber: string;
              deviceType: DeviceType;
              bootHistory: Array<{
                __typename?: 'BootInfo';
                bootCount: number;
                buildName: string;
                rebootReason: string;
                createdAt: string;
              }>;
            }
          | {
              __typename: 'PowerDistributionUnitHardwareDevice';
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              macAddress?: string | null;
              deviceModel: DeviceModel;
              serialNumber: string;
              deviceType: DeviceType;
              phyInterfaceConnectedTo?: {
                __typename?: 'PhyInterface';
                UUID: string;
                portNumber: number;
                virtualDevice:
                  | { __typename?: 'AccessPointVirtualDevice'; UUID: string; label: string }
                  | { __typename?: 'ControllerVirtualDevice'; UUID: string; label: string }
                  | { __typename?: 'ObserverVirtualDevice'; UUID: string; label: string }
                  | {
                      __typename?: 'PowerDistributionUnitVirtualDevice';
                      UUID: string;
                      label: string;
                    }
                  | { __typename?: 'SwitchVirtualDevice'; UUID: string; label: string };
              } | null;
              bootHistory: Array<{
                __typename?: 'BootInfo';
                bootCount: number;
                buildName: string;
                rebootReason: string;
                createdAt: string;
              }>;
            }
          | {
              __typename: 'SwitchHardwareDevice';
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              macAddress?: string | null;
              deviceModel: DeviceModel;
              serialNumber: string;
              deviceType: DeviceType;
              bootHistory: Array<{
                __typename?: 'BootInfo';
                bootCount: number;
                buildName: string;
                rebootReason: string;
                createdAt: string;
              }>;
            }
          | null;
      }
    | {
        __typename: 'SwitchVirtualDevice';
        UUID: string;
        label: string;
        description?: string | null;
        networkUUID: string;
        isConsoleEnabled: boolean;
        deviceType: VirtualDeviceType;
        deviceModel: DeviceModel;
        uptime?: string | null;
        network: { __typename?: 'Network'; UUID: string; slug: string; label: string };
        nosUpgradeGroup?: { __typename?: 'NOSUpgradeGroup'; UUID: string };
        nosVersion?: {
          __typename?: 'ConfiguredNOSVersion';
          id: number;
          buildName: string;
          version: string;
        } | null;
        pendingNosVersion?: {
          __typename?: 'PendingNosVersion';
          scheduledAt: string;
          nosVersion: { __typename?: 'NosVersion'; version: string };
        } | null;
        hardwareDevice?:
          | {
              __typename: 'AccessPointHardwareDevice';
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              macAddress?: string | null;
              deviceModel: DeviceModel;
              serialNumber: string;
              deviceType: DeviceType;
              bootHistory: Array<{
                __typename?: 'BootInfo';
                bootCount: number;
                buildName: string;
                rebootReason: string;
                createdAt: string;
              }>;
            }
          | {
              __typename: 'ControllerHardwareDevice';
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              macAddress?: string | null;
              deviceModel: DeviceModel;
              serialNumber: string;
              deviceType: DeviceType;
              bootHistory: Array<{
                __typename?: 'BootInfo';
                bootCount: number;
                buildName: string;
                rebootReason: string;
                createdAt: string;
              }>;
            }
          | {
              __typename: 'PowerDistributionUnitHardwareDevice';
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              macAddress?: string | null;
              deviceModel: DeviceModel;
              serialNumber: string;
              deviceType: DeviceType;
              phyInterfaceConnectedTo?: {
                __typename?: 'PhyInterface';
                UUID: string;
                portNumber: number;
                virtualDevice:
                  | { __typename?: 'AccessPointVirtualDevice'; UUID: string; label: string }
                  | { __typename?: 'ControllerVirtualDevice'; UUID: string; label: string }
                  | { __typename?: 'ObserverVirtualDevice'; UUID: string; label: string }
                  | {
                      __typename?: 'PowerDistributionUnitVirtualDevice';
                      UUID: string;
                      label: string;
                    }
                  | { __typename?: 'SwitchVirtualDevice'; UUID: string; label: string };
              } | null;
              bootHistory: Array<{
                __typename?: 'BootInfo';
                bootCount: number;
                buildName: string;
                rebootReason: string;
                createdAt: string;
              }>;
            }
          | {
              __typename: 'SwitchHardwareDevice';
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              macAddress?: string | null;
              deviceModel: DeviceModel;
              serialNumber: string;
              deviceType: DeviceType;
              bootHistory: Array<{
                __typename?: 'BootInfo';
                bootCount: number;
                buildName: string;
                rebootReason: string;
                createdAt: string;
              }>;
            }
          | null;
      };
};

export type PowerDistributionUnitsQueryQueryVariables = Exact<{
  companySlug: Scalars['String']['input'];
  networkUUIDs?: InputMaybe<Array<Scalars['UUID']['input']> | Scalars['UUID']['input']>;
  includeIsDev?: InputMaybe<Scalars['Boolean']['input']>;
  includeNOS?: InputMaybe<Scalars['Boolean']['input']>;
  includeConfigMetadata?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type PowerDistributionUnitsQueryQuery = {
  __typename?: 'Query';
  companyBySlug: {
    __typename?: 'Company';
    networks: Array<{
      __typename?: 'Network';
      UUID: string;
      label: string;
      virtualDevices: Array<
        | {
            __typename: 'AccessPointVirtualDevice';
            UUID: string;
            label: string;
            description?: string | null;
            deviceType: VirtualDeviceType;
            deviceModel: DeviceModel;
            uptime?: string | null;
            network: { __typename?: 'Network'; UUID: string; slug: string; label: string };
            nosUpgradeGroup?: { __typename?: 'NOSUpgradeGroup'; UUID: string };
            nosVersion?: {
              __typename?: 'ConfiguredNOSVersion';
              id: number;
              version: string;
              buildName: string;
            } | null;
            pendingNosVersion?: {
              __typename?: 'PendingNosVersion';
              scheduledAt: string;
              nosVersion: { __typename?: 'NosVersion'; version: string };
            } | null;
            hardwareDevice?:
              | {
                  __typename: 'AccessPointHardwareDevice';
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                  serialNumber: string;
                  macAddress?: string | null;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  isDev?: boolean;
                  bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
                  latestDeviceConfigMetadata?: {
                    __typename?: 'DeviceConfigMetadata';
                    version: number;
                    acknowledgedAt?: string | null;
                    createdAt: string;
                    isCurrentAsOf?: string | null;
                    state?: {
                      __typename?: 'DeviceConfigState';
                      state: DeviceConfigStateType;
                      timestamp: string;
                    } | null;
                  } | null;
                }
              | {
                  __typename: 'ControllerHardwareDevice';
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                  serialNumber: string;
                  macAddress?: string | null;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  isDev?: boolean;
                  bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
                  latestDeviceConfigMetadata?: {
                    __typename?: 'DeviceConfigMetadata';
                    version: number;
                    acknowledgedAt?: string | null;
                    createdAt: string;
                    isCurrentAsOf?: string | null;
                    state?: {
                      __typename?: 'DeviceConfigState';
                      state: DeviceConfigStateType;
                      timestamp: string;
                    } | null;
                  } | null;
                }
              | {
                  __typename: 'PowerDistributionUnitHardwareDevice';
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                  serialNumber: string;
                  macAddress?: string | null;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  isDev?: boolean;
                  bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
                  latestDeviceConfigMetadata?: {
                    __typename?: 'DeviceConfigMetadata';
                    version: number;
                    acknowledgedAt?: string | null;
                    createdAt: string;
                    isCurrentAsOf?: string | null;
                    state?: {
                      __typename?: 'DeviceConfigState';
                      state: DeviceConfigStateType;
                      timestamp: string;
                    } | null;
                  } | null;
                }
              | {
                  __typename: 'SwitchHardwareDevice';
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                  serialNumber: string;
                  macAddress?: string | null;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  isDev?: boolean;
                  bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
                  latestDeviceConfigMetadata?: {
                    __typename?: 'DeviceConfigMetadata';
                    version: number;
                    acknowledgedAt?: string | null;
                    createdAt: string;
                    isCurrentAsOf?: string | null;
                    state?: {
                      __typename?: 'DeviceConfigState';
                      state: DeviceConfigStateType;
                      timestamp: string;
                    } | null;
                  } | null;
                }
              | null;
          }
        | {
            __typename: 'ControllerVirtualDevice';
            UUID: string;
            label: string;
            description?: string | null;
            deviceType: VirtualDeviceType;
            deviceModel: DeviceModel;
            uptime?: string | null;
            network: { __typename?: 'Network'; UUID: string; slug: string; label: string };
            nosUpgradeGroup?: { __typename?: 'NOSUpgradeGroup'; UUID: string };
            nosVersion?: {
              __typename?: 'ConfiguredNOSVersion';
              id: number;
              version: string;
              buildName: string;
            } | null;
            pendingNosVersion?: {
              __typename?: 'PendingNosVersion';
              scheduledAt: string;
              nosVersion: { __typename?: 'NosVersion'; version: string };
            } | null;
            hardwareDevice?:
              | {
                  __typename: 'AccessPointHardwareDevice';
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                  serialNumber: string;
                  macAddress?: string | null;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  isDev?: boolean;
                  bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
                  latestDeviceConfigMetadata?: {
                    __typename?: 'DeviceConfigMetadata';
                    version: number;
                    acknowledgedAt?: string | null;
                    createdAt: string;
                    isCurrentAsOf?: string | null;
                    state?: {
                      __typename?: 'DeviceConfigState';
                      state: DeviceConfigStateType;
                      timestamp: string;
                    } | null;
                  } | null;
                }
              | {
                  __typename: 'ControllerHardwareDevice';
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                  serialNumber: string;
                  macAddress?: string | null;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  isDev?: boolean;
                  bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
                  latestDeviceConfigMetadata?: {
                    __typename?: 'DeviceConfigMetadata';
                    version: number;
                    acknowledgedAt?: string | null;
                    createdAt: string;
                    isCurrentAsOf?: string | null;
                    state?: {
                      __typename?: 'DeviceConfigState';
                      state: DeviceConfigStateType;
                      timestamp: string;
                    } | null;
                  } | null;
                }
              | {
                  __typename: 'PowerDistributionUnitHardwareDevice';
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                  serialNumber: string;
                  macAddress?: string | null;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  isDev?: boolean;
                  bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
                  latestDeviceConfigMetadata?: {
                    __typename?: 'DeviceConfigMetadata';
                    version: number;
                    acknowledgedAt?: string | null;
                    createdAt: string;
                    isCurrentAsOf?: string | null;
                    state?: {
                      __typename?: 'DeviceConfigState';
                      state: DeviceConfigStateType;
                      timestamp: string;
                    } | null;
                  } | null;
                }
              | {
                  __typename: 'SwitchHardwareDevice';
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                  serialNumber: string;
                  macAddress?: string | null;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  isDev?: boolean;
                  bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
                  latestDeviceConfigMetadata?: {
                    __typename?: 'DeviceConfigMetadata';
                    version: number;
                    acknowledgedAt?: string | null;
                    createdAt: string;
                    isCurrentAsOf?: string | null;
                    state?: {
                      __typename?: 'DeviceConfigState';
                      state: DeviceConfigStateType;
                      timestamp: string;
                    } | null;
                  } | null;
                }
              | null;
          }
        | {
            __typename: 'ObserverVirtualDevice';
            UUID: string;
            label: string;
            description?: string | null;
            deviceType: VirtualDeviceType;
            deviceModel: DeviceModel;
            uptime?: string | null;
            network: { __typename?: 'Network'; UUID: string; slug: string; label: string };
            nosUpgradeGroup?: { __typename?: 'NOSUpgradeGroup'; UUID: string };
            nosVersion?: {
              __typename?: 'ConfiguredNOSVersion';
              id: number;
              version: string;
              buildName: string;
            } | null;
            pendingNosVersion?: {
              __typename?: 'PendingNosVersion';
              scheduledAt: string;
              nosVersion: { __typename?: 'NosVersion'; version: string };
            } | null;
            hardwareDevice?:
              | {
                  __typename: 'AccessPointHardwareDevice';
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                  serialNumber: string;
                  macAddress?: string | null;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  isDev?: boolean;
                  bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
                  latestDeviceConfigMetadata?: {
                    __typename?: 'DeviceConfigMetadata';
                    version: number;
                    acknowledgedAt?: string | null;
                    createdAt: string;
                    isCurrentAsOf?: string | null;
                    state?: {
                      __typename?: 'DeviceConfigState';
                      state: DeviceConfigStateType;
                      timestamp: string;
                    } | null;
                  } | null;
                }
              | {
                  __typename: 'ControllerHardwareDevice';
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                  serialNumber: string;
                  macAddress?: string | null;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  isDev?: boolean;
                  bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
                  latestDeviceConfigMetadata?: {
                    __typename?: 'DeviceConfigMetadata';
                    version: number;
                    acknowledgedAt?: string | null;
                    createdAt: string;
                    isCurrentAsOf?: string | null;
                    state?: {
                      __typename?: 'DeviceConfigState';
                      state: DeviceConfigStateType;
                      timestamp: string;
                    } | null;
                  } | null;
                }
              | {
                  __typename: 'PowerDistributionUnitHardwareDevice';
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                  serialNumber: string;
                  macAddress?: string | null;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  isDev?: boolean;
                  bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
                  latestDeviceConfigMetadata?: {
                    __typename?: 'DeviceConfigMetadata';
                    version: number;
                    acknowledgedAt?: string | null;
                    createdAt: string;
                    isCurrentAsOf?: string | null;
                    state?: {
                      __typename?: 'DeviceConfigState';
                      state: DeviceConfigStateType;
                      timestamp: string;
                    } | null;
                  } | null;
                }
              | {
                  __typename: 'SwitchHardwareDevice';
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                  serialNumber: string;
                  macAddress?: string | null;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  isDev?: boolean;
                  bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
                  latestDeviceConfigMetadata?: {
                    __typename?: 'DeviceConfigMetadata';
                    version: number;
                    acknowledgedAt?: string | null;
                    createdAt: string;
                    isCurrentAsOf?: string | null;
                    state?: {
                      __typename?: 'DeviceConfigState';
                      state: DeviceConfigStateType;
                      timestamp: string;
                    } | null;
                  } | null;
                }
              | null;
          }
        | {
            __typename: 'PowerDistributionUnitVirtualDevice';
            ipAddress?: string | null;
            ethernetSpeedMbps?: number | null;
            isCircuitBreakerGood?: boolean | null;
            isGrounded?: boolean | null;
            isReadonly: boolean;
            isSurgeProtectionGood?: boolean | null;
            UUID: string;
            label: string;
            description?: string | null;
            deviceType: VirtualDeviceType;
            deviceModel: DeviceModel;
            uptime?: string | null;
            outletInterfaces: Array<{
              __typename?: 'OutletInterface';
              UUID: string;
              label?: string | null;
              outletNumber: number;
              virtualDeviceUUID: string;
              isEnabled: boolean;
              powerCycleDelaySec: number;
              description?: string | null;
              currentAmps?: number | null;
              powerWatts?: number | null;
              connectedVirtualDevice?:
                | {
                    __typename?: 'AccessPointVirtualDevice';
                    UUID: string;
                    label: string;
                    deviceType: VirtualDeviceType;
                  }
                | {
                    __typename?: 'ControllerVirtualDevice';
                    UUID: string;
                    label: string;
                    deviceType: VirtualDeviceType;
                  }
                | {
                    __typename?: 'ObserverVirtualDevice';
                    UUID: string;
                    label: string;
                    deviceType: VirtualDeviceType;
                  }
                | {
                    __typename?: 'PowerDistributionUnitVirtualDevice';
                    UUID: string;
                    label: string;
                    deviceType: VirtualDeviceType;
                  }
                | {
                    __typename?: 'SwitchVirtualDevice';
                    UUID: string;
                    label: string;
                    deviceType: VirtualDeviceType;
                  }
                | null;
            }>;
            network: { __typename?: 'Network'; UUID: string; slug: string; label: string };
            nosUpgradeGroup?: { __typename?: 'NOSUpgradeGroup'; UUID: string };
            nosVersion?: {
              __typename?: 'ConfiguredNOSVersion';
              id: number;
              version: string;
              buildName: string;
            } | null;
            pendingNosVersion?: {
              __typename?: 'PendingNosVersion';
              scheduledAt: string;
              nosVersion: { __typename?: 'NosVersion'; version: string };
            } | null;
            hardwareDevice?:
              | {
                  __typename: 'AccessPointHardwareDevice';
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                  serialNumber: string;
                  macAddress?: string | null;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  isDev?: boolean;
                  bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
                  latestDeviceConfigMetadata?: {
                    __typename?: 'DeviceConfigMetadata';
                    version: number;
                    acknowledgedAt?: string | null;
                    createdAt: string;
                    isCurrentAsOf?: string | null;
                    state?: {
                      __typename?: 'DeviceConfigState';
                      state: DeviceConfigStateType;
                      timestamp: string;
                    } | null;
                  } | null;
                }
              | {
                  __typename: 'ControllerHardwareDevice';
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                  serialNumber: string;
                  macAddress?: string | null;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  isDev?: boolean;
                  bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
                  latestDeviceConfigMetadata?: {
                    __typename?: 'DeviceConfigMetadata';
                    version: number;
                    acknowledgedAt?: string | null;
                    createdAt: string;
                    isCurrentAsOf?: string | null;
                    state?: {
                      __typename?: 'DeviceConfigState';
                      state: DeviceConfigStateType;
                      timestamp: string;
                    } | null;
                  } | null;
                }
              | {
                  __typename: 'PowerDistributionUnitHardwareDevice';
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                  serialNumber: string;
                  macAddress?: string | null;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  isDev?: boolean;
                  bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
                  latestDeviceConfigMetadata?: {
                    __typename?: 'DeviceConfigMetadata';
                    version: number;
                    acknowledgedAt?: string | null;
                    createdAt: string;
                    isCurrentAsOf?: string | null;
                    state?: {
                      __typename?: 'DeviceConfigState';
                      state: DeviceConfigStateType;
                      timestamp: string;
                    } | null;
                  } | null;
                }
              | {
                  __typename: 'SwitchHardwareDevice';
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                  serialNumber: string;
                  macAddress?: string | null;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  isDev?: boolean;
                  bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
                  latestDeviceConfigMetadata?: {
                    __typename?: 'DeviceConfigMetadata';
                    version: number;
                    acknowledgedAt?: string | null;
                    createdAt: string;
                    isCurrentAsOf?: string | null;
                    state?: {
                      __typename?: 'DeviceConfigState';
                      state: DeviceConfigStateType;
                      timestamp: string;
                    } | null;
                  } | null;
                }
              | null;
          }
        | {
            __typename: 'SwitchVirtualDevice';
            UUID: string;
            label: string;
            description?: string | null;
            deviceType: VirtualDeviceType;
            deviceModel: DeviceModel;
            uptime?: string | null;
            network: { __typename?: 'Network'; UUID: string; slug: string; label: string };
            nosUpgradeGroup?: { __typename?: 'NOSUpgradeGroup'; UUID: string };
            nosVersion?: {
              __typename?: 'ConfiguredNOSVersion';
              id: number;
              version: string;
              buildName: string;
            } | null;
            pendingNosVersion?: {
              __typename?: 'PendingNosVersion';
              scheduledAt: string;
              nosVersion: { __typename?: 'NosVersion'; version: string };
            } | null;
            hardwareDevice?:
              | {
                  __typename: 'AccessPointHardwareDevice';
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                  serialNumber: string;
                  macAddress?: string | null;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  isDev?: boolean;
                  bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
                  latestDeviceConfigMetadata?: {
                    __typename?: 'DeviceConfigMetadata';
                    version: number;
                    acknowledgedAt?: string | null;
                    createdAt: string;
                    isCurrentAsOf?: string | null;
                    state?: {
                      __typename?: 'DeviceConfigState';
                      state: DeviceConfigStateType;
                      timestamp: string;
                    } | null;
                  } | null;
                }
              | {
                  __typename: 'ControllerHardwareDevice';
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                  serialNumber: string;
                  macAddress?: string | null;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  isDev?: boolean;
                  bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
                  latestDeviceConfigMetadata?: {
                    __typename?: 'DeviceConfigMetadata';
                    version: number;
                    acknowledgedAt?: string | null;
                    createdAt: string;
                    isCurrentAsOf?: string | null;
                    state?: {
                      __typename?: 'DeviceConfigState';
                      state: DeviceConfigStateType;
                      timestamp: string;
                    } | null;
                  } | null;
                }
              | {
                  __typename: 'PowerDistributionUnitHardwareDevice';
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                  serialNumber: string;
                  macAddress?: string | null;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  isDev?: boolean;
                  bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
                  latestDeviceConfigMetadata?: {
                    __typename?: 'DeviceConfigMetadata';
                    version: number;
                    acknowledgedAt?: string | null;
                    createdAt: string;
                    isCurrentAsOf?: string | null;
                    state?: {
                      __typename?: 'DeviceConfigState';
                      state: DeviceConfigStateType;
                      timestamp: string;
                    } | null;
                  } | null;
                }
              | {
                  __typename: 'SwitchHardwareDevice';
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                  serialNumber: string;
                  macAddress?: string | null;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  isDev?: boolean;
                  bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
                  latestDeviceConfigMetadata?: {
                    __typename?: 'DeviceConfigMetadata';
                    version: number;
                    acknowledgedAt?: string | null;
                    createdAt: string;
                    isCurrentAsOf?: string | null;
                    state?: {
                      __typename?: 'DeviceConfigState';
                      state: DeviceConfigStateType;
                      timestamp: string;
                    } | null;
                  } | null;
                }
              | null;
          }
      >;
    }>;
  };
};

export type DeviceHeartbeatForDeviceQueryQueryVariables = Exact<{
  serialNumber: Scalars['String']['input'];
}>;

export type DeviceHeartbeatForDeviceQueryQuery = {
  __typename?: 'Query';
  deviceHeartbeatForDevice: { __typename?: 'DeviceHeartbeat'; token: string };
};

export type UpdateOutletInterfaceMutationMutationVariables = Exact<{
  uuid: Scalars['UUID']['input'];
  input: UpdateOutletInterfaceInput;
}>;

export type UpdateOutletInterfaceMutationMutation = {
  __typename?: 'Mutation';
  updateOutletInterface: { __typename?: 'OutletInterface'; UUID: string };
};

export type UpdateOutletInterfacesIndependentlyMutationVariables = Exact<{
  inputs:
    | Array<UpdateOutletInterfacesIndependentlyInput>
    | UpdateOutletInterfacesIndependentlyInput;
}>;

export type UpdateOutletInterfacesIndependentlyMutation = {
  __typename?: 'Mutation';
  updateOutletInterfacesIndependently: Array<{ __typename?: 'OutletInterface'; UUID: string }>;
};

export type UpdateSecurityApplianceProfilesMutationMutationVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
  input: UpdateSecurityApplianceProfileInput;
}>;

export type UpdateSecurityApplianceProfilesMutationMutation = {
  __typename?: 'Mutation';
  updateSecurityApplianceProfilesForNetwork: Array<{
    __typename?: 'SecurityApplianceProfile';
    UUID: string;
  }>;
};

export type UpdateSecurityApplianceProfileMutationMutationVariables = Exact<{
  UUID: Scalars['UUID']['input'];
  input: UpdateSecurityApplianceProfileInput;
}>;

export type UpdateSecurityApplianceProfileMutationMutation = {
  __typename?: 'Mutation';
  updateSecurityApplianceProfile: { __typename?: 'SecurityApplianceProfile'; UUID: string };
};

export type RebootSecurityApplianceMutationVariables = Exact<{
  serialNumber: Scalars['String']['input'];
}>;

export type RebootSecurityApplianceMutation = { __typename?: 'Mutation'; rpcRebootDevice: boolean };

type ControllerFragment_AccessPointVirtualDevice_Fragment = {
  __typename: 'AccessPointVirtualDevice';
  UUID: string;
  label: string;
  description?: string | null;
  deviceType: VirtualDeviceType;
  deviceModel: DeviceModel;
  isConsoleEnabled: boolean;
  networkUUID: string;
  uptime?: string | null;
  nosUpgradeGroup?: { __typename?: 'NOSUpgradeGroup'; UUID: string };
  nosVersion?: {
    __typename?: 'ConfiguredNOSVersion';
    id: number;
    version: string;
    buildName: string;
  } | null;
  pendingNosVersion?: {
    __typename?: 'PendingNosVersion';
    scheduledAt: string;
    nosVersion: { __typename?: 'NosVersion'; version: string };
  } | null;
  hardwareDevice?:
    | {
        __typename: 'AccessPointHardwareDevice';
        deviceType: DeviceType;
        serialNumber: string;
        macAddress?: string | null;
        deviceModel: DeviceModel;
        isActive: boolean;
        isConnectedToBackend: boolean;
        disconnectedFromBackendAt?: string | null;
        isDev?: boolean;
        bootHistory: Array<{
          __typename?: 'BootInfo';
          bootCount: number;
          buildName: string;
          rebootReason: string;
          createdAt: string;
        }>;
        latestDeviceConfigMetadata?: {
          __typename?: 'DeviceConfigMetadata';
          version: number;
          acknowledgedAt?: string | null;
          createdAt: string;
          isCurrentAsOf?: string | null;
          state?: {
            __typename?: 'DeviceConfigState';
            state: DeviceConfigStateType;
            timestamp: string;
          } | null;
        } | null;
      }
    | {
        __typename: 'ControllerHardwareDevice';
        deviceType: DeviceType;
        serialNumber: string;
        macAddress?: string | null;
        deviceModel: DeviceModel;
        isActive: boolean;
        isConnectedToBackend: boolean;
        disconnectedFromBackendAt?: string | null;
        isDev?: boolean;
        bootHistory: Array<{
          __typename?: 'BootInfo';
          bootCount: number;
          buildName: string;
          rebootReason: string;
          createdAt: string;
        }>;
        latestDeviceConfigMetadata?: {
          __typename?: 'DeviceConfigMetadata';
          version: number;
          acknowledgedAt?: string | null;
          createdAt: string;
          isCurrentAsOf?: string | null;
          state?: {
            __typename?: 'DeviceConfigState';
            state: DeviceConfigStateType;
            timestamp: string;
          } | null;
        } | null;
      }
    | {
        __typename: 'PowerDistributionUnitHardwareDevice';
        deviceType: DeviceType;
        serialNumber: string;
        macAddress?: string | null;
        deviceModel: DeviceModel;
        isActive: boolean;
        isConnectedToBackend: boolean;
        disconnectedFromBackendAt?: string | null;
        isDev?: boolean;
        bootHistory: Array<{
          __typename?: 'BootInfo';
          bootCount: number;
          buildName: string;
          rebootReason: string;
          createdAt: string;
        }>;
        latestDeviceConfigMetadata?: {
          __typename?: 'DeviceConfigMetadata';
          version: number;
          acknowledgedAt?: string | null;
          createdAt: string;
          isCurrentAsOf?: string | null;
          state?: {
            __typename?: 'DeviceConfigState';
            state: DeviceConfigStateType;
            timestamp: string;
          } | null;
        } | null;
      }
    | {
        __typename: 'SwitchHardwareDevice';
        deviceType: DeviceType;
        serialNumber: string;
        macAddress?: string | null;
        deviceModel: DeviceModel;
        isActive: boolean;
        isConnectedToBackend: boolean;
        disconnectedFromBackendAt?: string | null;
        isDev?: boolean;
        bootHistory: Array<{
          __typename?: 'BootInfo';
          bootCount: number;
          buildName: string;
          rebootReason: string;
          createdAt: string;
        }>;
        latestDeviceConfigMetadata?: {
          __typename?: 'DeviceConfigMetadata';
          version: number;
          acknowledgedAt?: string | null;
          createdAt: string;
          isCurrentAsOf?: string | null;
          state?: {
            __typename?: 'DeviceConfigState';
            state: DeviceConfigStateType;
            timestamp: string;
          } | null;
        } | null;
      }
    | null;
};

type ControllerFragment_ControllerVirtualDevice_Fragment = {
  __typename: 'ControllerVirtualDevice';
  UUID: string;
  label: string;
  description?: string | null;
  deviceType: VirtualDeviceType;
  deviceModel: DeviceModel;
  isConsoleEnabled: boolean;
  networkUUID: string;
  uptime?: string | null;
  highAvailability?: {
    __typename?: 'HighAvailabilityControllerVirtualDeviceInfo';
    role: HighAvailabilityControllerRole;
    status: HighAvailabilityStatus;
  } | null;
  securityApplianceProfile?: {
    __typename?: 'SecurityApplianceProfile';
    UUID: string;
    multiWANAlgorithm: MultiWanAlgorithm;
    multiWANUpdateLookback: number;
    multiWANUpdateThreshold: number;
    multiWANUpdateCooldownSec?: number | null;
    hostMonitoringTimeoutSec: number;
    hostMonitoringIntervalSec: number;
  };
  managementConnection?: {
    __typename?: 'ManagementConnection';
    connectionType: ManagementConnectionType;
  };
  nosUpgradeGroup?: { __typename?: 'NOSUpgradeGroup'; UUID: string };
  nosVersion?: {
    __typename?: 'ConfiguredNOSVersion';
    id: number;
    version: string;
    buildName: string;
  } | null;
  pendingNosVersion?: {
    __typename?: 'PendingNosVersion';
    scheduledAt: string;
    nosVersion: { __typename?: 'NosVersion'; version: string };
  } | null;
  hardwareDevice?:
    | {
        __typename: 'AccessPointHardwareDevice';
        deviceType: DeviceType;
        serialNumber: string;
        macAddress?: string | null;
        deviceModel: DeviceModel;
        isActive: boolean;
        isConnectedToBackend: boolean;
        disconnectedFromBackendAt?: string | null;
        isDev?: boolean;
        bootHistory: Array<{
          __typename?: 'BootInfo';
          bootCount: number;
          buildName: string;
          rebootReason: string;
          createdAt: string;
        }>;
        latestDeviceConfigMetadata?: {
          __typename?: 'DeviceConfigMetadata';
          version: number;
          acknowledgedAt?: string | null;
          createdAt: string;
          isCurrentAsOf?: string | null;
          state?: {
            __typename?: 'DeviceConfigState';
            state: DeviceConfigStateType;
            timestamp: string;
          } | null;
        } | null;
      }
    | {
        __typename: 'ControllerHardwareDevice';
        deviceType: DeviceType;
        serialNumber: string;
        macAddress?: string | null;
        deviceModel: DeviceModel;
        isActive: boolean;
        isConnectedToBackend: boolean;
        disconnectedFromBackendAt?: string | null;
        isDev?: boolean;
        bootHistory: Array<{
          __typename?: 'BootInfo';
          bootCount: number;
          buildName: string;
          rebootReason: string;
          createdAt: string;
        }>;
        latestDeviceConfigMetadata?: {
          __typename?: 'DeviceConfigMetadata';
          version: number;
          acknowledgedAt?: string | null;
          createdAt: string;
          isCurrentAsOf?: string | null;
          state?: {
            __typename?: 'DeviceConfigState';
            state: DeviceConfigStateType;
            timestamp: string;
          } | null;
        } | null;
      }
    | {
        __typename: 'PowerDistributionUnitHardwareDevice';
        deviceType: DeviceType;
        serialNumber: string;
        macAddress?: string | null;
        deviceModel: DeviceModel;
        isActive: boolean;
        isConnectedToBackend: boolean;
        disconnectedFromBackendAt?: string | null;
        isDev?: boolean;
        bootHistory: Array<{
          __typename?: 'BootInfo';
          bootCount: number;
          buildName: string;
          rebootReason: string;
          createdAt: string;
        }>;
        latestDeviceConfigMetadata?: {
          __typename?: 'DeviceConfigMetadata';
          version: number;
          acknowledgedAt?: string | null;
          createdAt: string;
          isCurrentAsOf?: string | null;
          state?: {
            __typename?: 'DeviceConfigState';
            state: DeviceConfigStateType;
            timestamp: string;
          } | null;
        } | null;
      }
    | {
        __typename: 'SwitchHardwareDevice';
        deviceType: DeviceType;
        serialNumber: string;
        macAddress?: string | null;
        deviceModel: DeviceModel;
        isActive: boolean;
        isConnectedToBackend: boolean;
        disconnectedFromBackendAt?: string | null;
        isDev?: boolean;
        bootHistory: Array<{
          __typename?: 'BootInfo';
          bootCount: number;
          buildName: string;
          rebootReason: string;
          createdAt: string;
        }>;
        latestDeviceConfigMetadata?: {
          __typename?: 'DeviceConfigMetadata';
          version: number;
          acknowledgedAt?: string | null;
          createdAt: string;
          isCurrentAsOf?: string | null;
          state?: {
            __typename?: 'DeviceConfigState';
            state: DeviceConfigStateType;
            timestamp: string;
          } | null;
        } | null;
      }
    | null;
};

type ControllerFragment_ObserverVirtualDevice_Fragment = {
  __typename: 'ObserverVirtualDevice';
  UUID: string;
  label: string;
  description?: string | null;
  deviceType: VirtualDeviceType;
  deviceModel: DeviceModel;
  isConsoleEnabled: boolean;
  networkUUID: string;
  uptime?: string | null;
  nosUpgradeGroup?: { __typename?: 'NOSUpgradeGroup'; UUID: string };
  nosVersion?: {
    __typename?: 'ConfiguredNOSVersion';
    id: number;
    version: string;
    buildName: string;
  } | null;
  pendingNosVersion?: {
    __typename?: 'PendingNosVersion';
    scheduledAt: string;
    nosVersion: { __typename?: 'NosVersion'; version: string };
  } | null;
  hardwareDevice?:
    | {
        __typename: 'AccessPointHardwareDevice';
        deviceType: DeviceType;
        serialNumber: string;
        macAddress?: string | null;
        deviceModel: DeviceModel;
        isActive: boolean;
        isConnectedToBackend: boolean;
        disconnectedFromBackendAt?: string | null;
        isDev?: boolean;
        bootHistory: Array<{
          __typename?: 'BootInfo';
          bootCount: number;
          buildName: string;
          rebootReason: string;
          createdAt: string;
        }>;
        latestDeviceConfigMetadata?: {
          __typename?: 'DeviceConfigMetadata';
          version: number;
          acknowledgedAt?: string | null;
          createdAt: string;
          isCurrentAsOf?: string | null;
          state?: {
            __typename?: 'DeviceConfigState';
            state: DeviceConfigStateType;
            timestamp: string;
          } | null;
        } | null;
      }
    | {
        __typename: 'ControllerHardwareDevice';
        deviceType: DeviceType;
        serialNumber: string;
        macAddress?: string | null;
        deviceModel: DeviceModel;
        isActive: boolean;
        isConnectedToBackend: boolean;
        disconnectedFromBackendAt?: string | null;
        isDev?: boolean;
        bootHistory: Array<{
          __typename?: 'BootInfo';
          bootCount: number;
          buildName: string;
          rebootReason: string;
          createdAt: string;
        }>;
        latestDeviceConfigMetadata?: {
          __typename?: 'DeviceConfigMetadata';
          version: number;
          acknowledgedAt?: string | null;
          createdAt: string;
          isCurrentAsOf?: string | null;
          state?: {
            __typename?: 'DeviceConfigState';
            state: DeviceConfigStateType;
            timestamp: string;
          } | null;
        } | null;
      }
    | {
        __typename: 'PowerDistributionUnitHardwareDevice';
        deviceType: DeviceType;
        serialNumber: string;
        macAddress?: string | null;
        deviceModel: DeviceModel;
        isActive: boolean;
        isConnectedToBackend: boolean;
        disconnectedFromBackendAt?: string | null;
        isDev?: boolean;
        bootHistory: Array<{
          __typename?: 'BootInfo';
          bootCount: number;
          buildName: string;
          rebootReason: string;
          createdAt: string;
        }>;
        latestDeviceConfigMetadata?: {
          __typename?: 'DeviceConfigMetadata';
          version: number;
          acknowledgedAt?: string | null;
          createdAt: string;
          isCurrentAsOf?: string | null;
          state?: {
            __typename?: 'DeviceConfigState';
            state: DeviceConfigStateType;
            timestamp: string;
          } | null;
        } | null;
      }
    | {
        __typename: 'SwitchHardwareDevice';
        deviceType: DeviceType;
        serialNumber: string;
        macAddress?: string | null;
        deviceModel: DeviceModel;
        isActive: boolean;
        isConnectedToBackend: boolean;
        disconnectedFromBackendAt?: string | null;
        isDev?: boolean;
        bootHistory: Array<{
          __typename?: 'BootInfo';
          bootCount: number;
          buildName: string;
          rebootReason: string;
          createdAt: string;
        }>;
        latestDeviceConfigMetadata?: {
          __typename?: 'DeviceConfigMetadata';
          version: number;
          acknowledgedAt?: string | null;
          createdAt: string;
          isCurrentAsOf?: string | null;
          state?: {
            __typename?: 'DeviceConfigState';
            state: DeviceConfigStateType;
            timestamp: string;
          } | null;
        } | null;
      }
    | null;
};

type ControllerFragment_PowerDistributionUnitVirtualDevice_Fragment = {
  __typename: 'PowerDistributionUnitVirtualDevice';
  UUID: string;
  label: string;
  description?: string | null;
  deviceType: VirtualDeviceType;
  deviceModel: DeviceModel;
  isConsoleEnabled: boolean;
  networkUUID: string;
  uptime?: string | null;
  nosUpgradeGroup?: { __typename?: 'NOSUpgradeGroup'; UUID: string };
  nosVersion?: {
    __typename?: 'ConfiguredNOSVersion';
    id: number;
    version: string;
    buildName: string;
  } | null;
  pendingNosVersion?: {
    __typename?: 'PendingNosVersion';
    scheduledAt: string;
    nosVersion: { __typename?: 'NosVersion'; version: string };
  } | null;
  hardwareDevice?:
    | {
        __typename: 'AccessPointHardwareDevice';
        deviceType: DeviceType;
        serialNumber: string;
        macAddress?: string | null;
        deviceModel: DeviceModel;
        isActive: boolean;
        isConnectedToBackend: boolean;
        disconnectedFromBackendAt?: string | null;
        isDev?: boolean;
        bootHistory: Array<{
          __typename?: 'BootInfo';
          bootCount: number;
          buildName: string;
          rebootReason: string;
          createdAt: string;
        }>;
        latestDeviceConfigMetadata?: {
          __typename?: 'DeviceConfigMetadata';
          version: number;
          acknowledgedAt?: string | null;
          createdAt: string;
          isCurrentAsOf?: string | null;
          state?: {
            __typename?: 'DeviceConfigState';
            state: DeviceConfigStateType;
            timestamp: string;
          } | null;
        } | null;
      }
    | {
        __typename: 'ControllerHardwareDevice';
        deviceType: DeviceType;
        serialNumber: string;
        macAddress?: string | null;
        deviceModel: DeviceModel;
        isActive: boolean;
        isConnectedToBackend: boolean;
        disconnectedFromBackendAt?: string | null;
        isDev?: boolean;
        bootHistory: Array<{
          __typename?: 'BootInfo';
          bootCount: number;
          buildName: string;
          rebootReason: string;
          createdAt: string;
        }>;
        latestDeviceConfigMetadata?: {
          __typename?: 'DeviceConfigMetadata';
          version: number;
          acknowledgedAt?: string | null;
          createdAt: string;
          isCurrentAsOf?: string | null;
          state?: {
            __typename?: 'DeviceConfigState';
            state: DeviceConfigStateType;
            timestamp: string;
          } | null;
        } | null;
      }
    | {
        __typename: 'PowerDistributionUnitHardwareDevice';
        deviceType: DeviceType;
        serialNumber: string;
        macAddress?: string | null;
        deviceModel: DeviceModel;
        isActive: boolean;
        isConnectedToBackend: boolean;
        disconnectedFromBackendAt?: string | null;
        isDev?: boolean;
        bootHistory: Array<{
          __typename?: 'BootInfo';
          bootCount: number;
          buildName: string;
          rebootReason: string;
          createdAt: string;
        }>;
        latestDeviceConfigMetadata?: {
          __typename?: 'DeviceConfigMetadata';
          version: number;
          acknowledgedAt?: string | null;
          createdAt: string;
          isCurrentAsOf?: string | null;
          state?: {
            __typename?: 'DeviceConfigState';
            state: DeviceConfigStateType;
            timestamp: string;
          } | null;
        } | null;
      }
    | {
        __typename: 'SwitchHardwareDevice';
        deviceType: DeviceType;
        serialNumber: string;
        macAddress?: string | null;
        deviceModel: DeviceModel;
        isActive: boolean;
        isConnectedToBackend: boolean;
        disconnectedFromBackendAt?: string | null;
        isDev?: boolean;
        bootHistory: Array<{
          __typename?: 'BootInfo';
          bootCount: number;
          buildName: string;
          rebootReason: string;
          createdAt: string;
        }>;
        latestDeviceConfigMetadata?: {
          __typename?: 'DeviceConfigMetadata';
          version: number;
          acknowledgedAt?: string | null;
          createdAt: string;
          isCurrentAsOf?: string | null;
          state?: {
            __typename?: 'DeviceConfigState';
            state: DeviceConfigStateType;
            timestamp: string;
          } | null;
        } | null;
      }
    | null;
};

type ControllerFragment_SwitchVirtualDevice_Fragment = {
  __typename: 'SwitchVirtualDevice';
  UUID: string;
  label: string;
  description?: string | null;
  deviceType: VirtualDeviceType;
  deviceModel: DeviceModel;
  isConsoleEnabled: boolean;
  networkUUID: string;
  uptime?: string | null;
  nosUpgradeGroup?: { __typename?: 'NOSUpgradeGroup'; UUID: string };
  nosVersion?: {
    __typename?: 'ConfiguredNOSVersion';
    id: number;
    version: string;
    buildName: string;
  } | null;
  pendingNosVersion?: {
    __typename?: 'PendingNosVersion';
    scheduledAt: string;
    nosVersion: { __typename?: 'NosVersion'; version: string };
  } | null;
  hardwareDevice?:
    | {
        __typename: 'AccessPointHardwareDevice';
        deviceType: DeviceType;
        serialNumber: string;
        macAddress?: string | null;
        deviceModel: DeviceModel;
        isActive: boolean;
        isConnectedToBackend: boolean;
        disconnectedFromBackendAt?: string | null;
        isDev?: boolean;
        bootHistory: Array<{
          __typename?: 'BootInfo';
          bootCount: number;
          buildName: string;
          rebootReason: string;
          createdAt: string;
        }>;
        latestDeviceConfigMetadata?: {
          __typename?: 'DeviceConfigMetadata';
          version: number;
          acknowledgedAt?: string | null;
          createdAt: string;
          isCurrentAsOf?: string | null;
          state?: {
            __typename?: 'DeviceConfigState';
            state: DeviceConfigStateType;
            timestamp: string;
          } | null;
        } | null;
      }
    | {
        __typename: 'ControllerHardwareDevice';
        deviceType: DeviceType;
        serialNumber: string;
        macAddress?: string | null;
        deviceModel: DeviceModel;
        isActive: boolean;
        isConnectedToBackend: boolean;
        disconnectedFromBackendAt?: string | null;
        isDev?: boolean;
        bootHistory: Array<{
          __typename?: 'BootInfo';
          bootCount: number;
          buildName: string;
          rebootReason: string;
          createdAt: string;
        }>;
        latestDeviceConfigMetadata?: {
          __typename?: 'DeviceConfigMetadata';
          version: number;
          acknowledgedAt?: string | null;
          createdAt: string;
          isCurrentAsOf?: string | null;
          state?: {
            __typename?: 'DeviceConfigState';
            state: DeviceConfigStateType;
            timestamp: string;
          } | null;
        } | null;
      }
    | {
        __typename: 'PowerDistributionUnitHardwareDevice';
        deviceType: DeviceType;
        serialNumber: string;
        macAddress?: string | null;
        deviceModel: DeviceModel;
        isActive: boolean;
        isConnectedToBackend: boolean;
        disconnectedFromBackendAt?: string | null;
        isDev?: boolean;
        bootHistory: Array<{
          __typename?: 'BootInfo';
          bootCount: number;
          buildName: string;
          rebootReason: string;
          createdAt: string;
        }>;
        latestDeviceConfigMetadata?: {
          __typename?: 'DeviceConfigMetadata';
          version: number;
          acknowledgedAt?: string | null;
          createdAt: string;
          isCurrentAsOf?: string | null;
          state?: {
            __typename?: 'DeviceConfigState';
            state: DeviceConfigStateType;
            timestamp: string;
          } | null;
        } | null;
      }
    | {
        __typename: 'SwitchHardwareDevice';
        deviceType: DeviceType;
        serialNumber: string;
        macAddress?: string | null;
        deviceModel: DeviceModel;
        isActive: boolean;
        isConnectedToBackend: boolean;
        disconnectedFromBackendAt?: string | null;
        isDev?: boolean;
        bootHistory: Array<{
          __typename?: 'BootInfo';
          bootCount: number;
          buildName: string;
          rebootReason: string;
          createdAt: string;
        }>;
        latestDeviceConfigMetadata?: {
          __typename?: 'DeviceConfigMetadata';
          version: number;
          acknowledgedAt?: string | null;
          createdAt: string;
          isCurrentAsOf?: string | null;
          state?: {
            __typename?: 'DeviceConfigState';
            state: DeviceConfigStateType;
            timestamp: string;
          } | null;
        } | null;
      }
    | null;
};

export type ControllerFragmentFragment =
  | ControllerFragment_AccessPointVirtualDevice_Fragment
  | ControllerFragment_ControllerVirtualDevice_Fragment
  | ControllerFragment_ObserverVirtualDevice_Fragment
  | ControllerFragment_PowerDistributionUnitVirtualDevice_Fragment
  | ControllerFragment_SwitchVirtualDevice_Fragment;

export type ControllersQueryQueryVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
  includeNOS: Scalars['Boolean']['input'];
}>;

export type ControllersQueryQuery = {
  __typename?: 'Query';
  virtualDevicesForNetwork: Array<
    | {
        __typename: 'AccessPointVirtualDevice';
        UUID: string;
        label: string;
        description?: string | null;
        deviceType: VirtualDeviceType;
        deviceModel: DeviceModel;
        uptime?: string | null;
        nosVersion?: {
          __typename?: 'ConfiguredNOSVersion';
          id: number;
          version: string;
          buildName: string;
        } | null;
        hardwareDevice?:
          | {
              __typename: 'AccessPointHardwareDevice';
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
            }
          | {
              __typename: 'ControllerHardwareDevice';
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
            }
          | {
              __typename: 'PowerDistributionUnitHardwareDevice';
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
            }
          | {
              __typename: 'SwitchHardwareDevice';
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
            }
          | null;
      }
    | {
        __typename: 'ControllerVirtualDevice';
        UUID: string;
        label: string;
        description?: string | null;
        deviceType: VirtualDeviceType;
        deviceModel: DeviceModel;
        uptime?: string | null;
        nosVersion?: {
          __typename?: 'ConfiguredNOSVersion';
          id: number;
          version: string;
          buildName: string;
        } | null;
        hardwareDevice?:
          | {
              __typename: 'AccessPointHardwareDevice';
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
            }
          | {
              __typename: 'ControllerHardwareDevice';
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
            }
          | {
              __typename: 'PowerDistributionUnitHardwareDevice';
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
            }
          | {
              __typename: 'SwitchHardwareDevice';
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
            }
          | null;
      }
    | {
        __typename: 'ObserverVirtualDevice';
        UUID: string;
        label: string;
        description?: string | null;
        deviceType: VirtualDeviceType;
        deviceModel: DeviceModel;
        uptime?: string | null;
        nosVersion?: {
          __typename?: 'ConfiguredNOSVersion';
          id: number;
          version: string;
          buildName: string;
        } | null;
        hardwareDevice?:
          | {
              __typename: 'AccessPointHardwareDevice';
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
            }
          | {
              __typename: 'ControllerHardwareDevice';
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
            }
          | {
              __typename: 'PowerDistributionUnitHardwareDevice';
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
            }
          | {
              __typename: 'SwitchHardwareDevice';
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
            }
          | null;
      }
    | {
        __typename: 'PowerDistributionUnitVirtualDevice';
        UUID: string;
        label: string;
        description?: string | null;
        deviceType: VirtualDeviceType;
        deviceModel: DeviceModel;
        uptime?: string | null;
        nosVersion?: {
          __typename?: 'ConfiguredNOSVersion';
          id: number;
          version: string;
          buildName: string;
        } | null;
        hardwareDevice?:
          | {
              __typename: 'AccessPointHardwareDevice';
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
            }
          | {
              __typename: 'ControllerHardwareDevice';
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
            }
          | {
              __typename: 'PowerDistributionUnitHardwareDevice';
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
            }
          | {
              __typename: 'SwitchHardwareDevice';
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
            }
          | null;
      }
    | {
        __typename: 'SwitchVirtualDevice';
        UUID: string;
        label: string;
        description?: string | null;
        deviceType: VirtualDeviceType;
        deviceModel: DeviceModel;
        uptime?: string | null;
        nosVersion?: {
          __typename?: 'ConfiguredNOSVersion';
          id: number;
          version: string;
          buildName: string;
        } | null;
        hardwareDevice?:
          | {
              __typename: 'AccessPointHardwareDevice';
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
            }
          | {
              __typename: 'ControllerHardwareDevice';
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
            }
          | {
              __typename: 'PowerDistributionUnitHardwareDevice';
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
            }
          | {
              __typename: 'SwitchHardwareDevice';
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
            }
          | null;
      }
  >;
};

export type HaConfigForNetworkQueryQueryVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
}>;

export type HaConfigForNetworkQueryQuery = {
  __typename?: 'Query';
  network: {
    __typename?: 'Network';
    UUID: string;
    highAvailabilityConfig?: {
      __typename?: 'HighAvailabilityControllersConfig';
      UUID: string;
      preemption: boolean;
      advertisementIntervalMs: number;
      primaryPhyInterface: {
        __typename?: 'PhyInterface';
        UUID: string;
        portNumber: number;
        label?: string | null;
        virtualDevice:
          | {
              __typename?: 'AccessPointVirtualDevice';
              UUID: string;
              label: string;
              deviceType: VirtualDeviceType;
              hardwareDevice?:
                | { __typename?: 'AccessPointHardwareDevice'; isConnectedToBackend: boolean }
                | { __typename?: 'ControllerHardwareDevice'; isConnectedToBackend: boolean }
                | {
                    __typename?: 'PowerDistributionUnitHardwareDevice';
                    isConnectedToBackend: boolean;
                  }
                | { __typename?: 'SwitchHardwareDevice'; isConnectedToBackend: boolean }
                | null;
            }
          | {
              __typename?: 'ControllerVirtualDevice';
              UUID: string;
              label: string;
              deviceType: VirtualDeviceType;
              hardwareDevice?:
                | { __typename?: 'AccessPointHardwareDevice'; isConnectedToBackend: boolean }
                | { __typename?: 'ControllerHardwareDevice'; isConnectedToBackend: boolean }
                | {
                    __typename?: 'PowerDistributionUnitHardwareDevice';
                    isConnectedToBackend: boolean;
                  }
                | { __typename?: 'SwitchHardwareDevice'; isConnectedToBackend: boolean }
                | null;
            }
          | {
              __typename?: 'ObserverVirtualDevice';
              UUID: string;
              label: string;
              deviceType: VirtualDeviceType;
              hardwareDevice?:
                | { __typename?: 'AccessPointHardwareDevice'; isConnectedToBackend: boolean }
                | { __typename?: 'ControllerHardwareDevice'; isConnectedToBackend: boolean }
                | {
                    __typename?: 'PowerDistributionUnitHardwareDevice';
                    isConnectedToBackend: boolean;
                  }
                | { __typename?: 'SwitchHardwareDevice'; isConnectedToBackend: boolean }
                | null;
            }
          | {
              __typename?: 'PowerDistributionUnitVirtualDevice';
              UUID: string;
              label: string;
              deviceType: VirtualDeviceType;
              hardwareDevice?:
                | { __typename?: 'AccessPointHardwareDevice'; isConnectedToBackend: boolean }
                | { __typename?: 'ControllerHardwareDevice'; isConnectedToBackend: boolean }
                | {
                    __typename?: 'PowerDistributionUnitHardwareDevice';
                    isConnectedToBackend: boolean;
                  }
                | { __typename?: 'SwitchHardwareDevice'; isConnectedToBackend: boolean }
                | null;
            }
          | {
              __typename?: 'SwitchVirtualDevice';
              UUID: string;
              label: string;
              deviceType: VirtualDeviceType;
              hardwareDevice?:
                | { __typename?: 'AccessPointHardwareDevice'; isConnectedToBackend: boolean }
                | { __typename?: 'ControllerHardwareDevice'; isConnectedToBackend: boolean }
                | {
                    __typename?: 'PowerDistributionUnitHardwareDevice';
                    isConnectedToBackend: boolean;
                  }
                | { __typename?: 'SwitchHardwareDevice'; isConnectedToBackend: boolean }
                | null;
            };
      };
      backupPhyInterface: {
        __typename?: 'PhyInterface';
        UUID: string;
        portNumber: number;
        label?: string | null;
        virtualDevice:
          | {
              __typename?: 'AccessPointVirtualDevice';
              UUID: string;
              label: string;
              deviceType: VirtualDeviceType;
              hardwareDevice?:
                | { __typename?: 'AccessPointHardwareDevice'; isConnectedToBackend: boolean }
                | { __typename?: 'ControllerHardwareDevice'; isConnectedToBackend: boolean }
                | {
                    __typename?: 'PowerDistributionUnitHardwareDevice';
                    isConnectedToBackend: boolean;
                  }
                | { __typename?: 'SwitchHardwareDevice'; isConnectedToBackend: boolean }
                | null;
            }
          | {
              __typename?: 'ControllerVirtualDevice';
              UUID: string;
              label: string;
              deviceType: VirtualDeviceType;
              hardwareDevice?:
                | { __typename?: 'AccessPointHardwareDevice'; isConnectedToBackend: boolean }
                | { __typename?: 'ControllerHardwareDevice'; isConnectedToBackend: boolean }
                | {
                    __typename?: 'PowerDistributionUnitHardwareDevice';
                    isConnectedToBackend: boolean;
                  }
                | { __typename?: 'SwitchHardwareDevice'; isConnectedToBackend: boolean }
                | null;
            }
          | {
              __typename?: 'ObserverVirtualDevice';
              UUID: string;
              label: string;
              deviceType: VirtualDeviceType;
              hardwareDevice?:
                | { __typename?: 'AccessPointHardwareDevice'; isConnectedToBackend: boolean }
                | { __typename?: 'ControllerHardwareDevice'; isConnectedToBackend: boolean }
                | {
                    __typename?: 'PowerDistributionUnitHardwareDevice';
                    isConnectedToBackend: boolean;
                  }
                | { __typename?: 'SwitchHardwareDevice'; isConnectedToBackend: boolean }
                | null;
            }
          | {
              __typename?: 'PowerDistributionUnitVirtualDevice';
              UUID: string;
              label: string;
              deviceType: VirtualDeviceType;
              hardwareDevice?:
                | { __typename?: 'AccessPointHardwareDevice'; isConnectedToBackend: boolean }
                | { __typename?: 'ControllerHardwareDevice'; isConnectedToBackend: boolean }
                | {
                    __typename?: 'PowerDistributionUnitHardwareDevice';
                    isConnectedToBackend: boolean;
                  }
                | { __typename?: 'SwitchHardwareDevice'; isConnectedToBackend: boolean }
                | null;
            }
          | {
              __typename?: 'SwitchVirtualDevice';
              UUID: string;
              label: string;
              deviceType: VirtualDeviceType;
              hardwareDevice?:
                | { __typename?: 'AccessPointHardwareDevice'; isConnectedToBackend: boolean }
                | { __typename?: 'ControllerHardwareDevice'; isConnectedToBackend: boolean }
                | {
                    __typename?: 'PowerDistributionUnitHardwareDevice';
                    isConnectedToBackend: boolean;
                  }
                | { __typename?: 'SwitchHardwareDevice'; isConnectedToBackend: boolean }
                | null;
            };
      };
      advertisementVLAN: { __typename?: 'VLAN'; UUID: string; vlanID: number; name: string };
    } | null;
  };
};

export type ControllerVirtualDeviceFragmentFragment = {
  __typename?: 'ControllerVirtualDevice';
  highAvailability?: {
    __typename?: 'HighAvailabilityControllerVirtualDeviceInfo';
    role: HighAvailabilityControllerRole;
    status: HighAvailabilityStatus;
  } | null;
  outletInterfaceConnectedTo?: {
    __typename?: 'OutletInterface';
    UUID: string;
    label?: string | null;
    outletNumber: number;
    virtualDevice?:
      | { __typename?: 'AccessPointVirtualDevice'; UUID: string; label: string }
      | { __typename?: 'ControllerVirtualDevice'; UUID: string; label: string }
      | { __typename?: 'ObserverVirtualDevice'; UUID: string; label: string }
      | { __typename?: 'PowerDistributionUnitVirtualDevice'; UUID: string; label: string }
      | { __typename?: 'SwitchVirtualDevice'; UUID: string; label: string }
      | null;
  } | null;
  phyInterfaces: Array<{
    __typename?: 'PhyInterface';
    UUID: string;
    isConnected: boolean;
    isEnabled: boolean;
    isSFP: boolean;
    isTrunkPort: boolean;
    isUplink: boolean;
    label?: string | null;
    portNumber: number;
    portSpeedMbps?: number | null;
    hasWANActivity?: boolean | null;
    connectedDevices?: Array<{
      __typename?: 'PhyInterfaceConnectedDevice';
      hardwareDevice?:
        | {
            __typename?: 'AccessPointHardwareDevice';
            deviceModel: DeviceModel;
            deviceType: DeviceType;
            virtualDevice?:
              | {
                  __typename?: 'AccessPointVirtualDevice';
                  UUID: string;
                  label: string;
                  deviceType: VirtualDeviceType;
                }
              | {
                  __typename?: 'ControllerVirtualDevice';
                  UUID: string;
                  label: string;
                  deviceType: VirtualDeviceType;
                }
              | {
                  __typename?: 'ObserverVirtualDevice';
                  UUID: string;
                  label: string;
                  deviceType: VirtualDeviceType;
                }
              | {
                  __typename?: 'PowerDistributionUnitVirtualDevice';
                  UUID: string;
                  label: string;
                  deviceType: VirtualDeviceType;
                }
              | {
                  __typename?: 'SwitchVirtualDevice';
                  UUID: string;
                  label: string;
                  deviceType: VirtualDeviceType;
                }
              | null;
          }
        | {
            __typename?: 'ControllerHardwareDevice';
            deviceModel: DeviceModel;
            deviceType: DeviceType;
            virtualDevice?:
              | {
                  __typename?: 'AccessPointVirtualDevice';
                  UUID: string;
                  label: string;
                  deviceType: VirtualDeviceType;
                }
              | {
                  __typename?: 'ControllerVirtualDevice';
                  UUID: string;
                  label: string;
                  deviceType: VirtualDeviceType;
                }
              | {
                  __typename?: 'ObserverVirtualDevice';
                  UUID: string;
                  label: string;
                  deviceType: VirtualDeviceType;
                }
              | {
                  __typename?: 'PowerDistributionUnitVirtualDevice';
                  UUID: string;
                  label: string;
                  deviceType: VirtualDeviceType;
                }
              | {
                  __typename?: 'SwitchVirtualDevice';
                  UUID: string;
                  label: string;
                  deviceType: VirtualDeviceType;
                }
              | null;
          }
        | {
            __typename?: 'PowerDistributionUnitHardwareDevice';
            deviceModel: DeviceModel;
            deviceType: DeviceType;
            virtualDevice?:
              | {
                  __typename?: 'AccessPointVirtualDevice';
                  UUID: string;
                  label: string;
                  deviceType: VirtualDeviceType;
                }
              | {
                  __typename?: 'ControllerVirtualDevice';
                  UUID: string;
                  label: string;
                  deviceType: VirtualDeviceType;
                }
              | {
                  __typename?: 'ObserverVirtualDevice';
                  UUID: string;
                  label: string;
                  deviceType: VirtualDeviceType;
                }
              | {
                  __typename?: 'PowerDistributionUnitVirtualDevice';
                  UUID: string;
                  label: string;
                  deviceType: VirtualDeviceType;
                }
              | {
                  __typename?: 'SwitchVirtualDevice';
                  UUID: string;
                  label: string;
                  deviceType: VirtualDeviceType;
                }
              | null;
          }
        | {
            __typename?: 'SwitchHardwareDevice';
            deviceModel: DeviceModel;
            deviceType: DeviceType;
            virtualDevice?:
              | {
                  __typename?: 'AccessPointVirtualDevice';
                  UUID: string;
                  label: string;
                  deviceType: VirtualDeviceType;
                }
              | {
                  __typename?: 'ControllerVirtualDevice';
                  UUID: string;
                  label: string;
                  deviceType: VirtualDeviceType;
                }
              | {
                  __typename?: 'ObserverVirtualDevice';
                  UUID: string;
                  label: string;
                  deviceType: VirtualDeviceType;
                }
              | {
                  __typename?: 'PowerDistributionUnitVirtualDevice';
                  UUID: string;
                  label: string;
                  deviceType: VirtualDeviceType;
                }
              | {
                  __typename?: 'SwitchVirtualDevice';
                  UUID: string;
                  label: string;
                  deviceType: VirtualDeviceType;
                }
              | null;
          }
        | null;
      phyInterface?: { __typename?: 'PhyInterface'; UUID: string; portNumber: number } | null;
    }> | null;
    internetServicePlan?: {
      __typename?: 'InternetServicePlan';
      controllerIP?: string | null;
      provider?: {
        __typename?: 'InternetServicePlanProvider';
        name: string;
        logoURL?: string | null;
      } | null;
    } | null;
  }>;
};

export type ControllerForSecurityApplianceQueryQueryVariables = Exact<{
  uuid: Scalars['UUID']['input'];
  includeIsDev?: InputMaybe<Scalars['Boolean']['input']>;
  includeSecurityApplianceProfile?: InputMaybe<Scalars['Boolean']['input']>;
  includeManagementConnection?: InputMaybe<Scalars['Boolean']['input']>;
  includeNOS?: InputMaybe<Scalars['Boolean']['input']>;
  includeConfigMetadata?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type ControllerForSecurityApplianceQueryQuery = {
  __typename?: 'Query';
  virtualDevice:
    | {
        __typename: 'AccessPointVirtualDevice';
        UUID: string;
        label: string;
        description?: string | null;
        deviceType: VirtualDeviceType;
        deviceModel: DeviceModel;
        isConsoleEnabled: boolean;
        networkUUID: string;
        uptime?: string | null;
        network: { __typename?: 'Network'; UUID: string; slug: string; label: string };
        nosUpgradeGroup?: { __typename?: 'NOSUpgradeGroup'; UUID: string };
        nosVersion?: {
          __typename?: 'ConfiguredNOSVersion';
          id: number;
          version: string;
          buildName: string;
        } | null;
        pendingNosVersion?: {
          __typename?: 'PendingNosVersion';
          scheduledAt: string;
          nosVersion: { __typename?: 'NosVersion'; version: string };
        } | null;
        hardwareDevice?:
          | {
              __typename: 'AccessPointHardwareDevice';
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              deviceModel: DeviceModel;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              isDev?: boolean;
              bootHistory: Array<{
                __typename?: 'BootInfo';
                bootCount: number;
                buildName: string;
                rebootReason: string;
                createdAt: string;
              }>;
              latestDeviceConfigMetadata?: {
                __typename?: 'DeviceConfigMetadata';
                version: number;
                acknowledgedAt?: string | null;
                createdAt: string;
                isCurrentAsOf?: string | null;
                state?: {
                  __typename?: 'DeviceConfigState';
                  state: DeviceConfigStateType;
                  timestamp: string;
                } | null;
              } | null;
            }
          | {
              __typename: 'ControllerHardwareDevice';
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              deviceModel: DeviceModel;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              isDev?: boolean;
              bootHistory: Array<{
                __typename?: 'BootInfo';
                bootCount: number;
                buildName: string;
                rebootReason: string;
                createdAt: string;
              }>;
              latestDeviceConfigMetadata?: {
                __typename?: 'DeviceConfigMetadata';
                version: number;
                acknowledgedAt?: string | null;
                createdAt: string;
                isCurrentAsOf?: string | null;
                state?: {
                  __typename?: 'DeviceConfigState';
                  state: DeviceConfigStateType;
                  timestamp: string;
                } | null;
              } | null;
            }
          | {
              __typename: 'PowerDistributionUnitHardwareDevice';
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              deviceModel: DeviceModel;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              isDev?: boolean;
              bootHistory: Array<{
                __typename?: 'BootInfo';
                bootCount: number;
                buildName: string;
                rebootReason: string;
                createdAt: string;
              }>;
              latestDeviceConfigMetadata?: {
                __typename?: 'DeviceConfigMetadata';
                version: number;
                acknowledgedAt?: string | null;
                createdAt: string;
                isCurrentAsOf?: string | null;
                state?: {
                  __typename?: 'DeviceConfigState';
                  state: DeviceConfigStateType;
                  timestamp: string;
                } | null;
              } | null;
            }
          | {
              __typename: 'SwitchHardwareDevice';
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              deviceModel: DeviceModel;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              isDev?: boolean;
              bootHistory: Array<{
                __typename?: 'BootInfo';
                bootCount: number;
                buildName: string;
                rebootReason: string;
                createdAt: string;
              }>;
              latestDeviceConfigMetadata?: {
                __typename?: 'DeviceConfigMetadata';
                version: number;
                acknowledgedAt?: string | null;
                createdAt: string;
                isCurrentAsOf?: string | null;
                state?: {
                  __typename?: 'DeviceConfigState';
                  state: DeviceConfigStateType;
                  timestamp: string;
                } | null;
              } | null;
            }
          | null;
      }
    | {
        __typename: 'ControllerVirtualDevice';
        UUID: string;
        label: string;
        description?: string | null;
        deviceType: VirtualDeviceType;
        deviceModel: DeviceModel;
        isConsoleEnabled: boolean;
        networkUUID: string;
        uptime?: string | null;
        phyInterfaces: Array<{
          __typename?: 'PhyInterface';
          UUID: string;
          isConnected: boolean;
          isEnabled: boolean;
          isSFP: boolean;
          isTrunkPort: boolean;
          isUplink: boolean;
          label?: string | null;
          portNumber: number;
          portSpeedMbps?: number | null;
          hasWANActivity?: boolean | null;
          virtualDeviceUUID: string;
          description?: string | null;
          hardwareLabel?: string | null;
          forcedSpeedAllowed: boolean;
          isEthernet: boolean;
          forcedPortSpeedMbps?: number | null;
          maxSpeedMbps?: number | null;
          ipv4ClientAssignmentProtocol?: ClientAssignmentProtocol | null;
          ipv4ClientGateway?: string | null;
          ipv4ClientPrefixLength?: number | null;
          ipv4ClientAddresses?: Array<string> | null;
          uplinkPriority?: number | null;
          uplinkExternalAddresses?: Array<string> | null;
          isUplinkActive?: boolean | null;
          uplinkVLANID?: number | null;
          uplinkGatewayMACAddress?: string | null;
          connectedDevices?: Array<{
            __typename?: 'PhyInterfaceConnectedDevice';
            macAddress: string;
            hardwareDevice?:
              | {
                  __typename?: 'AccessPointHardwareDevice';
                  deviceModel: DeviceModel;
                  deviceType: DeviceType;
                  serialNumber: string;
                  isConnectedToBackend: boolean;
                  isActive: boolean;
                  virtualDevice?:
                    | {
                        __typename: 'AccessPointVirtualDevice';
                        UUID: string;
                        label: string;
                        deviceType: VirtualDeviceType;
                      }
                    | {
                        __typename: 'ControllerVirtualDevice';
                        UUID: string;
                        label: string;
                        deviceType: VirtualDeviceType;
                      }
                    | {
                        __typename: 'ObserverVirtualDevice';
                        UUID: string;
                        label: string;
                        deviceType: VirtualDeviceType;
                      }
                    | {
                        __typename: 'PowerDistributionUnitVirtualDevice';
                        UUID: string;
                        label: string;
                        deviceType: VirtualDeviceType;
                      }
                    | {
                        __typename: 'SwitchVirtualDevice';
                        UUID: string;
                        label: string;
                        deviceType: VirtualDeviceType;
                      }
                    | null;
                }
              | {
                  __typename?: 'ControllerHardwareDevice';
                  deviceModel: DeviceModel;
                  deviceType: DeviceType;
                  serialNumber: string;
                  isConnectedToBackend: boolean;
                  isActive: boolean;
                  virtualDevice?:
                    | {
                        __typename: 'AccessPointVirtualDevice';
                        UUID: string;
                        label: string;
                        deviceType: VirtualDeviceType;
                      }
                    | {
                        __typename: 'ControllerVirtualDevice';
                        UUID: string;
                        label: string;
                        deviceType: VirtualDeviceType;
                      }
                    | {
                        __typename: 'ObserverVirtualDevice';
                        UUID: string;
                        label: string;
                        deviceType: VirtualDeviceType;
                      }
                    | {
                        __typename: 'PowerDistributionUnitVirtualDevice';
                        UUID: string;
                        label: string;
                        deviceType: VirtualDeviceType;
                      }
                    | {
                        __typename: 'SwitchVirtualDevice';
                        UUID: string;
                        label: string;
                        deviceType: VirtualDeviceType;
                      }
                    | null;
                }
              | {
                  __typename?: 'PowerDistributionUnitHardwareDevice';
                  deviceModel: DeviceModel;
                  deviceType: DeviceType;
                  serialNumber: string;
                  isConnectedToBackend: boolean;
                  isActive: boolean;
                  virtualDevice?:
                    | {
                        __typename: 'AccessPointVirtualDevice';
                        UUID: string;
                        label: string;
                        deviceType: VirtualDeviceType;
                      }
                    | {
                        __typename: 'ControllerVirtualDevice';
                        UUID: string;
                        label: string;
                        deviceType: VirtualDeviceType;
                      }
                    | {
                        __typename: 'ObserverVirtualDevice';
                        UUID: string;
                        label: string;
                        deviceType: VirtualDeviceType;
                      }
                    | {
                        __typename: 'PowerDistributionUnitVirtualDevice';
                        UUID: string;
                        label: string;
                        deviceType: VirtualDeviceType;
                      }
                    | {
                        __typename: 'SwitchVirtualDevice';
                        UUID: string;
                        label: string;
                        deviceType: VirtualDeviceType;
                      }
                    | null;
                }
              | {
                  __typename?: 'SwitchHardwareDevice';
                  deviceModel: DeviceModel;
                  deviceType: DeviceType;
                  serialNumber: string;
                  isConnectedToBackend: boolean;
                  isActive: boolean;
                  virtualDevice?:
                    | {
                        __typename: 'AccessPointVirtualDevice';
                        UUID: string;
                        label: string;
                        deviceType: VirtualDeviceType;
                      }
                    | {
                        __typename: 'ControllerVirtualDevice';
                        UUID: string;
                        label: string;
                        deviceType: VirtualDeviceType;
                      }
                    | {
                        __typename: 'ObserverVirtualDevice';
                        UUID: string;
                        label: string;
                        deviceType: VirtualDeviceType;
                      }
                    | {
                        __typename: 'PowerDistributionUnitVirtualDevice';
                        UUID: string;
                        label: string;
                        deviceType: VirtualDeviceType;
                      }
                    | {
                        __typename: 'SwitchVirtualDevice';
                        UUID: string;
                        label: string;
                        deviceType: VirtualDeviceType;
                      }
                    | null;
                }
              | null;
            phyInterface?: { __typename?: 'PhyInterface'; UUID: string; portNumber: number } | null;
          }> | null;
          internetServicePlan?: {
            __typename?: 'InternetServicePlan';
            controllerIP?: string | null;
            UUID: string;
            provider?: {
              __typename?: 'InternetServicePlanProvider';
              name: string;
              logoURL?: string | null;
              UUID: string;
            } | null;
          } | null;
          virtualDevice:
            | {
                __typename?: 'AccessPointVirtualDevice';
                UUID: string;
                label: string;
                deviceModel: DeviceModel;
              }
            | {
                __typename?: 'ControllerVirtualDevice';
                UUID: string;
                label: string;
                deviceModel: DeviceModel;
              }
            | {
                __typename?: 'ObserverVirtualDevice';
                UUID: string;
                label: string;
                deviceModel: DeviceModel;
              }
            | {
                __typename?: 'PowerDistributionUnitVirtualDevice';
                UUID: string;
                label: string;
                deviceModel: DeviceModel;
              }
            | {
                __typename?: 'SwitchVirtualDevice';
                UUID: string;
                label: string;
                deviceModel: DeviceModel;
              };
          nativeVLAN?: { __typename?: 'VLAN'; UUID: string; vlanID: number; name: string } | null;
          sfpModuleInfo?: { __typename?: 'SFPModuleInfo'; moduleSpeedKbps?: number | null } | null;
        }>;
        network: { __typename?: 'Network'; UUID: string; slug: string; label: string };
        highAvailability?: {
          __typename?: 'HighAvailabilityControllerVirtualDeviceInfo';
          role: HighAvailabilityControllerRole;
          status: HighAvailabilityStatus;
        } | null;
        outletInterfaceConnectedTo?: {
          __typename?: 'OutletInterface';
          UUID: string;
          label?: string | null;
          outletNumber: number;
          virtualDevice?:
            | { __typename?: 'AccessPointVirtualDevice'; UUID: string; label: string }
            | { __typename?: 'ControllerVirtualDevice'; UUID: string; label: string }
            | { __typename?: 'ObserverVirtualDevice'; UUID: string; label: string }
            | { __typename?: 'PowerDistributionUnitVirtualDevice'; UUID: string; label: string }
            | { __typename?: 'SwitchVirtualDevice'; UUID: string; label: string }
            | null;
        } | null;
        securityApplianceProfile?: {
          __typename?: 'SecurityApplianceProfile';
          UUID: string;
          multiWANAlgorithm: MultiWanAlgorithm;
          multiWANUpdateLookback: number;
          multiWANUpdateThreshold: number;
          multiWANUpdateCooldownSec?: number | null;
          hostMonitoringTimeoutSec: number;
          hostMonitoringIntervalSec: number;
        };
        managementConnection?: {
          __typename?: 'ManagementConnection';
          connectionType: ManagementConnectionType;
        };
        nosUpgradeGroup?: { __typename?: 'NOSUpgradeGroup'; UUID: string };
        nosVersion?: {
          __typename?: 'ConfiguredNOSVersion';
          id: number;
          version: string;
          buildName: string;
        } | null;
        pendingNosVersion?: {
          __typename?: 'PendingNosVersion';
          scheduledAt: string;
          nosVersion: { __typename?: 'NosVersion'; version: string };
        } | null;
        hardwareDevice?:
          | {
              __typename: 'AccessPointHardwareDevice';
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              deviceModel: DeviceModel;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              isDev?: boolean;
              bootHistory: Array<{
                __typename?: 'BootInfo';
                bootCount: number;
                buildName: string;
                rebootReason: string;
                createdAt: string;
              }>;
              latestDeviceConfigMetadata?: {
                __typename?: 'DeviceConfigMetadata';
                version: number;
                acknowledgedAt?: string | null;
                createdAt: string;
                isCurrentAsOf?: string | null;
                state?: {
                  __typename?: 'DeviceConfigState';
                  state: DeviceConfigStateType;
                  timestamp: string;
                } | null;
              } | null;
            }
          | {
              __typename: 'ControllerHardwareDevice';
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              deviceModel: DeviceModel;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              isDev?: boolean;
              bootHistory: Array<{
                __typename?: 'BootInfo';
                bootCount: number;
                buildName: string;
                rebootReason: string;
                createdAt: string;
              }>;
              latestDeviceConfigMetadata?: {
                __typename?: 'DeviceConfigMetadata';
                version: number;
                acknowledgedAt?: string | null;
                createdAt: string;
                isCurrentAsOf?: string | null;
                state?: {
                  __typename?: 'DeviceConfigState';
                  state: DeviceConfigStateType;
                  timestamp: string;
                } | null;
              } | null;
            }
          | {
              __typename: 'PowerDistributionUnitHardwareDevice';
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              deviceModel: DeviceModel;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              isDev?: boolean;
              bootHistory: Array<{
                __typename?: 'BootInfo';
                bootCount: number;
                buildName: string;
                rebootReason: string;
                createdAt: string;
              }>;
              latestDeviceConfigMetadata?: {
                __typename?: 'DeviceConfigMetadata';
                version: number;
                acknowledgedAt?: string | null;
                createdAt: string;
                isCurrentAsOf?: string | null;
                state?: {
                  __typename?: 'DeviceConfigState';
                  state: DeviceConfigStateType;
                  timestamp: string;
                } | null;
              } | null;
            }
          | {
              __typename: 'SwitchHardwareDevice';
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              deviceModel: DeviceModel;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              isDev?: boolean;
              bootHistory: Array<{
                __typename?: 'BootInfo';
                bootCount: number;
                buildName: string;
                rebootReason: string;
                createdAt: string;
              }>;
              latestDeviceConfigMetadata?: {
                __typename?: 'DeviceConfigMetadata';
                version: number;
                acknowledgedAt?: string | null;
                createdAt: string;
                isCurrentAsOf?: string | null;
                state?: {
                  __typename?: 'DeviceConfigState';
                  state: DeviceConfigStateType;
                  timestamp: string;
                } | null;
              } | null;
            }
          | null;
      }
    | {
        __typename: 'ObserverVirtualDevice';
        UUID: string;
        label: string;
        description?: string | null;
        deviceType: VirtualDeviceType;
        deviceModel: DeviceModel;
        isConsoleEnabled: boolean;
        networkUUID: string;
        uptime?: string | null;
        network: { __typename?: 'Network'; UUID: string; slug: string; label: string };
        nosUpgradeGroup?: { __typename?: 'NOSUpgradeGroup'; UUID: string };
        nosVersion?: {
          __typename?: 'ConfiguredNOSVersion';
          id: number;
          version: string;
          buildName: string;
        } | null;
        pendingNosVersion?: {
          __typename?: 'PendingNosVersion';
          scheduledAt: string;
          nosVersion: { __typename?: 'NosVersion'; version: string };
        } | null;
        hardwareDevice?:
          | {
              __typename: 'AccessPointHardwareDevice';
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              deviceModel: DeviceModel;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              isDev?: boolean;
              bootHistory: Array<{
                __typename?: 'BootInfo';
                bootCount: number;
                buildName: string;
                rebootReason: string;
                createdAt: string;
              }>;
              latestDeviceConfigMetadata?: {
                __typename?: 'DeviceConfigMetadata';
                version: number;
                acknowledgedAt?: string | null;
                createdAt: string;
                isCurrentAsOf?: string | null;
                state?: {
                  __typename?: 'DeviceConfigState';
                  state: DeviceConfigStateType;
                  timestamp: string;
                } | null;
              } | null;
            }
          | {
              __typename: 'ControllerHardwareDevice';
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              deviceModel: DeviceModel;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              isDev?: boolean;
              bootHistory: Array<{
                __typename?: 'BootInfo';
                bootCount: number;
                buildName: string;
                rebootReason: string;
                createdAt: string;
              }>;
              latestDeviceConfigMetadata?: {
                __typename?: 'DeviceConfigMetadata';
                version: number;
                acknowledgedAt?: string | null;
                createdAt: string;
                isCurrentAsOf?: string | null;
                state?: {
                  __typename?: 'DeviceConfigState';
                  state: DeviceConfigStateType;
                  timestamp: string;
                } | null;
              } | null;
            }
          | {
              __typename: 'PowerDistributionUnitHardwareDevice';
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              deviceModel: DeviceModel;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              isDev?: boolean;
              bootHistory: Array<{
                __typename?: 'BootInfo';
                bootCount: number;
                buildName: string;
                rebootReason: string;
                createdAt: string;
              }>;
              latestDeviceConfigMetadata?: {
                __typename?: 'DeviceConfigMetadata';
                version: number;
                acknowledgedAt?: string | null;
                createdAt: string;
                isCurrentAsOf?: string | null;
                state?: {
                  __typename?: 'DeviceConfigState';
                  state: DeviceConfigStateType;
                  timestamp: string;
                } | null;
              } | null;
            }
          | {
              __typename: 'SwitchHardwareDevice';
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              deviceModel: DeviceModel;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              isDev?: boolean;
              bootHistory: Array<{
                __typename?: 'BootInfo';
                bootCount: number;
                buildName: string;
                rebootReason: string;
                createdAt: string;
              }>;
              latestDeviceConfigMetadata?: {
                __typename?: 'DeviceConfigMetadata';
                version: number;
                acknowledgedAt?: string | null;
                createdAt: string;
                isCurrentAsOf?: string | null;
                state?: {
                  __typename?: 'DeviceConfigState';
                  state: DeviceConfigStateType;
                  timestamp: string;
                } | null;
              } | null;
            }
          | null;
      }
    | {
        __typename: 'PowerDistributionUnitVirtualDevice';
        UUID: string;
        label: string;
        description?: string | null;
        deviceType: VirtualDeviceType;
        deviceModel: DeviceModel;
        isConsoleEnabled: boolean;
        networkUUID: string;
        uptime?: string | null;
        network: { __typename?: 'Network'; UUID: string; slug: string; label: string };
        nosUpgradeGroup?: { __typename?: 'NOSUpgradeGroup'; UUID: string };
        nosVersion?: {
          __typename?: 'ConfiguredNOSVersion';
          id: number;
          version: string;
          buildName: string;
        } | null;
        pendingNosVersion?: {
          __typename?: 'PendingNosVersion';
          scheduledAt: string;
          nosVersion: { __typename?: 'NosVersion'; version: string };
        } | null;
        hardwareDevice?:
          | {
              __typename: 'AccessPointHardwareDevice';
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              deviceModel: DeviceModel;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              isDev?: boolean;
              bootHistory: Array<{
                __typename?: 'BootInfo';
                bootCount: number;
                buildName: string;
                rebootReason: string;
                createdAt: string;
              }>;
              latestDeviceConfigMetadata?: {
                __typename?: 'DeviceConfigMetadata';
                version: number;
                acknowledgedAt?: string | null;
                createdAt: string;
                isCurrentAsOf?: string | null;
                state?: {
                  __typename?: 'DeviceConfigState';
                  state: DeviceConfigStateType;
                  timestamp: string;
                } | null;
              } | null;
            }
          | {
              __typename: 'ControllerHardwareDevice';
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              deviceModel: DeviceModel;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              isDev?: boolean;
              bootHistory: Array<{
                __typename?: 'BootInfo';
                bootCount: number;
                buildName: string;
                rebootReason: string;
                createdAt: string;
              }>;
              latestDeviceConfigMetadata?: {
                __typename?: 'DeviceConfigMetadata';
                version: number;
                acknowledgedAt?: string | null;
                createdAt: string;
                isCurrentAsOf?: string | null;
                state?: {
                  __typename?: 'DeviceConfigState';
                  state: DeviceConfigStateType;
                  timestamp: string;
                } | null;
              } | null;
            }
          | {
              __typename: 'PowerDistributionUnitHardwareDevice';
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              deviceModel: DeviceModel;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              isDev?: boolean;
              bootHistory: Array<{
                __typename?: 'BootInfo';
                bootCount: number;
                buildName: string;
                rebootReason: string;
                createdAt: string;
              }>;
              latestDeviceConfigMetadata?: {
                __typename?: 'DeviceConfigMetadata';
                version: number;
                acknowledgedAt?: string | null;
                createdAt: string;
                isCurrentAsOf?: string | null;
                state?: {
                  __typename?: 'DeviceConfigState';
                  state: DeviceConfigStateType;
                  timestamp: string;
                } | null;
              } | null;
            }
          | {
              __typename: 'SwitchHardwareDevice';
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              deviceModel: DeviceModel;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              isDev?: boolean;
              bootHistory: Array<{
                __typename?: 'BootInfo';
                bootCount: number;
                buildName: string;
                rebootReason: string;
                createdAt: string;
              }>;
              latestDeviceConfigMetadata?: {
                __typename?: 'DeviceConfigMetadata';
                version: number;
                acknowledgedAt?: string | null;
                createdAt: string;
                isCurrentAsOf?: string | null;
                state?: {
                  __typename?: 'DeviceConfigState';
                  state: DeviceConfigStateType;
                  timestamp: string;
                } | null;
              } | null;
            }
          | null;
      }
    | {
        __typename: 'SwitchVirtualDevice';
        UUID: string;
        label: string;
        description?: string | null;
        deviceType: VirtualDeviceType;
        deviceModel: DeviceModel;
        isConsoleEnabled: boolean;
        networkUUID: string;
        uptime?: string | null;
        network: { __typename?: 'Network'; UUID: string; slug: string; label: string };
        nosUpgradeGroup?: { __typename?: 'NOSUpgradeGroup'; UUID: string };
        nosVersion?: {
          __typename?: 'ConfiguredNOSVersion';
          id: number;
          version: string;
          buildName: string;
        } | null;
        pendingNosVersion?: {
          __typename?: 'PendingNosVersion';
          scheduledAt: string;
          nosVersion: { __typename?: 'NosVersion'; version: string };
        } | null;
        hardwareDevice?:
          | {
              __typename: 'AccessPointHardwareDevice';
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              deviceModel: DeviceModel;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              isDev?: boolean;
              bootHistory: Array<{
                __typename?: 'BootInfo';
                bootCount: number;
                buildName: string;
                rebootReason: string;
                createdAt: string;
              }>;
              latestDeviceConfigMetadata?: {
                __typename?: 'DeviceConfigMetadata';
                version: number;
                acknowledgedAt?: string | null;
                createdAt: string;
                isCurrentAsOf?: string | null;
                state?: {
                  __typename?: 'DeviceConfigState';
                  state: DeviceConfigStateType;
                  timestamp: string;
                } | null;
              } | null;
            }
          | {
              __typename: 'ControllerHardwareDevice';
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              deviceModel: DeviceModel;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              isDev?: boolean;
              bootHistory: Array<{
                __typename?: 'BootInfo';
                bootCount: number;
                buildName: string;
                rebootReason: string;
                createdAt: string;
              }>;
              latestDeviceConfigMetadata?: {
                __typename?: 'DeviceConfigMetadata';
                version: number;
                acknowledgedAt?: string | null;
                createdAt: string;
                isCurrentAsOf?: string | null;
                state?: {
                  __typename?: 'DeviceConfigState';
                  state: DeviceConfigStateType;
                  timestamp: string;
                } | null;
              } | null;
            }
          | {
              __typename: 'PowerDistributionUnitHardwareDevice';
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              deviceModel: DeviceModel;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              isDev?: boolean;
              bootHistory: Array<{
                __typename?: 'BootInfo';
                bootCount: number;
                buildName: string;
                rebootReason: string;
                createdAt: string;
              }>;
              latestDeviceConfigMetadata?: {
                __typename?: 'DeviceConfigMetadata';
                version: number;
                acknowledgedAt?: string | null;
                createdAt: string;
                isCurrentAsOf?: string | null;
                state?: {
                  __typename?: 'DeviceConfigState';
                  state: DeviceConfigStateType;
                  timestamp: string;
                } | null;
              } | null;
            }
          | {
              __typename: 'SwitchHardwareDevice';
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              deviceModel: DeviceModel;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              isDev?: boolean;
              bootHistory: Array<{
                __typename?: 'BootInfo';
                bootCount: number;
                buildName: string;
                rebootReason: string;
                createdAt: string;
              }>;
              latestDeviceConfigMetadata?: {
                __typename?: 'DeviceConfigMetadata';
                version: number;
                acknowledgedAt?: string | null;
                createdAt: string;
                isCurrentAsOf?: string | null;
                state?: {
                  __typename?: 'DeviceConfigState';
                  state: DeviceConfigStateType;
                  timestamp: string;
                } | null;
              } | null;
            }
          | null;
      };
};

export type ControllersForSecurityApplianceQueryQueryVariables = Exact<{
  companySlug: Scalars['String']['input'];
  networkUUIDs?: InputMaybe<Array<Scalars['UUID']['input']> | Scalars['UUID']['input']>;
  includeIsDev?: InputMaybe<Scalars['Boolean']['input']>;
  includeSecurityApplianceProfile?: InputMaybe<Scalars['Boolean']['input']>;
  includeManagementConnection?: InputMaybe<Scalars['Boolean']['input']>;
  includeNOS?: InputMaybe<Scalars['Boolean']['input']>;
  includeConfigMetadata?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type ControllersForSecurityApplianceQueryQuery = {
  __typename?: 'Query';
  companyBySlug: {
    __typename?: 'Company';
    networks: Array<{
      __typename?: 'Network';
      virtualDevices: Array<
        | {
            __typename: 'AccessPointVirtualDevice';
            UUID: string;
            label: string;
            description?: string | null;
            deviceType: VirtualDeviceType;
            deviceModel: DeviceModel;
            isConsoleEnabled: boolean;
            networkUUID: string;
            uptime?: string | null;
            network: { __typename?: 'Network'; UUID: string; slug: string; label: string };
            nosUpgradeGroup?: { __typename?: 'NOSUpgradeGroup'; UUID: string };
            nosVersion?: {
              __typename?: 'ConfiguredNOSVersion';
              id: number;
              version: string;
              buildName: string;
            } | null;
            pendingNosVersion?: {
              __typename?: 'PendingNosVersion';
              scheduledAt: string;
              nosVersion: { __typename?: 'NosVersion'; version: string };
            } | null;
            hardwareDevice?:
              | {
                  __typename: 'AccessPointHardwareDevice';
                  deviceType: DeviceType;
                  serialNumber: string;
                  macAddress?: string | null;
                  deviceModel: DeviceModel;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  isDev?: boolean;
                  bootHistory: Array<{
                    __typename?: 'BootInfo';
                    bootCount: number;
                    buildName: string;
                    rebootReason: string;
                    createdAt: string;
                  }>;
                  latestDeviceConfigMetadata?: {
                    __typename?: 'DeviceConfigMetadata';
                    version: number;
                    acknowledgedAt?: string | null;
                    createdAt: string;
                    isCurrentAsOf?: string | null;
                    state?: {
                      __typename?: 'DeviceConfigState';
                      state: DeviceConfigStateType;
                      timestamp: string;
                    } | null;
                  } | null;
                }
              | {
                  __typename: 'ControllerHardwareDevice';
                  deviceType: DeviceType;
                  serialNumber: string;
                  macAddress?: string | null;
                  deviceModel: DeviceModel;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  isDev?: boolean;
                  bootHistory: Array<{
                    __typename?: 'BootInfo';
                    bootCount: number;
                    buildName: string;
                    rebootReason: string;
                    createdAt: string;
                  }>;
                  latestDeviceConfigMetadata?: {
                    __typename?: 'DeviceConfigMetadata';
                    version: number;
                    acknowledgedAt?: string | null;
                    createdAt: string;
                    isCurrentAsOf?: string | null;
                    state?: {
                      __typename?: 'DeviceConfigState';
                      state: DeviceConfigStateType;
                      timestamp: string;
                    } | null;
                  } | null;
                }
              | {
                  __typename: 'PowerDistributionUnitHardwareDevice';
                  deviceType: DeviceType;
                  serialNumber: string;
                  macAddress?: string | null;
                  deviceModel: DeviceModel;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  isDev?: boolean;
                  bootHistory: Array<{
                    __typename?: 'BootInfo';
                    bootCount: number;
                    buildName: string;
                    rebootReason: string;
                    createdAt: string;
                  }>;
                  latestDeviceConfigMetadata?: {
                    __typename?: 'DeviceConfigMetadata';
                    version: number;
                    acknowledgedAt?: string | null;
                    createdAt: string;
                    isCurrentAsOf?: string | null;
                    state?: {
                      __typename?: 'DeviceConfigState';
                      state: DeviceConfigStateType;
                      timestamp: string;
                    } | null;
                  } | null;
                }
              | {
                  __typename: 'SwitchHardwareDevice';
                  deviceType: DeviceType;
                  serialNumber: string;
                  macAddress?: string | null;
                  deviceModel: DeviceModel;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  isDev?: boolean;
                  bootHistory: Array<{
                    __typename?: 'BootInfo';
                    bootCount: number;
                    buildName: string;
                    rebootReason: string;
                    createdAt: string;
                  }>;
                  latestDeviceConfigMetadata?: {
                    __typename?: 'DeviceConfigMetadata';
                    version: number;
                    acknowledgedAt?: string | null;
                    createdAt: string;
                    isCurrentAsOf?: string | null;
                    state?: {
                      __typename?: 'DeviceConfigState';
                      state: DeviceConfigStateType;
                      timestamp: string;
                    } | null;
                  } | null;
                }
              | null;
          }
        | {
            __typename: 'ControllerVirtualDevice';
            UUID: string;
            label: string;
            description?: string | null;
            deviceType: VirtualDeviceType;
            deviceModel: DeviceModel;
            isConsoleEnabled: boolean;
            networkUUID: string;
            uptime?: string | null;
            phyInterfaces: Array<{
              __typename?: 'PhyInterface';
              UUID: string;
              isConnected: boolean;
              isEnabled: boolean;
              isSFP: boolean;
              isTrunkPort: boolean;
              isUplink: boolean;
              label?: string | null;
              portNumber: number;
              portSpeedMbps?: number | null;
              hasWANActivity?: boolean | null;
              virtualDeviceUUID: string;
              description?: string | null;
              hardwareLabel?: string | null;
              forcedSpeedAllowed: boolean;
              isEthernet: boolean;
              forcedPortSpeedMbps?: number | null;
              maxSpeedMbps?: number | null;
              ipv4ClientAssignmentProtocol?: ClientAssignmentProtocol | null;
              ipv4ClientGateway?: string | null;
              ipv4ClientPrefixLength?: number | null;
              ipv4ClientAddresses?: Array<string> | null;
              uplinkPriority?: number | null;
              uplinkExternalAddresses?: Array<string> | null;
              isUplinkActive?: boolean | null;
              uplinkVLANID?: number | null;
              uplinkGatewayMACAddress?: string | null;
              connectedDevices?: Array<{
                __typename?: 'PhyInterfaceConnectedDevice';
                macAddress: string;
                hardwareDevice?:
                  | {
                      __typename?: 'AccessPointHardwareDevice';
                      deviceModel: DeviceModel;
                      deviceType: DeviceType;
                      serialNumber: string;
                      isConnectedToBackend: boolean;
                      isActive: boolean;
                      virtualDevice?:
                        | {
                            __typename: 'AccessPointVirtualDevice';
                            UUID: string;
                            label: string;
                            deviceType: VirtualDeviceType;
                          }
                        | {
                            __typename: 'ControllerVirtualDevice';
                            UUID: string;
                            label: string;
                            deviceType: VirtualDeviceType;
                          }
                        | {
                            __typename: 'ObserverVirtualDevice';
                            UUID: string;
                            label: string;
                            deviceType: VirtualDeviceType;
                          }
                        | {
                            __typename: 'PowerDistributionUnitVirtualDevice';
                            UUID: string;
                            label: string;
                            deviceType: VirtualDeviceType;
                          }
                        | {
                            __typename: 'SwitchVirtualDevice';
                            UUID: string;
                            label: string;
                            deviceType: VirtualDeviceType;
                          }
                        | null;
                    }
                  | {
                      __typename?: 'ControllerHardwareDevice';
                      deviceModel: DeviceModel;
                      deviceType: DeviceType;
                      serialNumber: string;
                      isConnectedToBackend: boolean;
                      isActive: boolean;
                      virtualDevice?:
                        | {
                            __typename: 'AccessPointVirtualDevice';
                            UUID: string;
                            label: string;
                            deviceType: VirtualDeviceType;
                          }
                        | {
                            __typename: 'ControllerVirtualDevice';
                            UUID: string;
                            label: string;
                            deviceType: VirtualDeviceType;
                          }
                        | {
                            __typename: 'ObserverVirtualDevice';
                            UUID: string;
                            label: string;
                            deviceType: VirtualDeviceType;
                          }
                        | {
                            __typename: 'PowerDistributionUnitVirtualDevice';
                            UUID: string;
                            label: string;
                            deviceType: VirtualDeviceType;
                          }
                        | {
                            __typename: 'SwitchVirtualDevice';
                            UUID: string;
                            label: string;
                            deviceType: VirtualDeviceType;
                          }
                        | null;
                    }
                  | {
                      __typename?: 'PowerDistributionUnitHardwareDevice';
                      deviceModel: DeviceModel;
                      deviceType: DeviceType;
                      serialNumber: string;
                      isConnectedToBackend: boolean;
                      isActive: boolean;
                      virtualDevice?:
                        | {
                            __typename: 'AccessPointVirtualDevice';
                            UUID: string;
                            label: string;
                            deviceType: VirtualDeviceType;
                          }
                        | {
                            __typename: 'ControllerVirtualDevice';
                            UUID: string;
                            label: string;
                            deviceType: VirtualDeviceType;
                          }
                        | {
                            __typename: 'ObserverVirtualDevice';
                            UUID: string;
                            label: string;
                            deviceType: VirtualDeviceType;
                          }
                        | {
                            __typename: 'PowerDistributionUnitVirtualDevice';
                            UUID: string;
                            label: string;
                            deviceType: VirtualDeviceType;
                          }
                        | {
                            __typename: 'SwitchVirtualDevice';
                            UUID: string;
                            label: string;
                            deviceType: VirtualDeviceType;
                          }
                        | null;
                    }
                  | {
                      __typename?: 'SwitchHardwareDevice';
                      deviceModel: DeviceModel;
                      deviceType: DeviceType;
                      serialNumber: string;
                      isConnectedToBackend: boolean;
                      isActive: boolean;
                      virtualDevice?:
                        | {
                            __typename: 'AccessPointVirtualDevice';
                            UUID: string;
                            label: string;
                            deviceType: VirtualDeviceType;
                          }
                        | {
                            __typename: 'ControllerVirtualDevice';
                            UUID: string;
                            label: string;
                            deviceType: VirtualDeviceType;
                          }
                        | {
                            __typename: 'ObserverVirtualDevice';
                            UUID: string;
                            label: string;
                            deviceType: VirtualDeviceType;
                          }
                        | {
                            __typename: 'PowerDistributionUnitVirtualDevice';
                            UUID: string;
                            label: string;
                            deviceType: VirtualDeviceType;
                          }
                        | {
                            __typename: 'SwitchVirtualDevice';
                            UUID: string;
                            label: string;
                            deviceType: VirtualDeviceType;
                          }
                        | null;
                    }
                  | null;
                phyInterface?: {
                  __typename?: 'PhyInterface';
                  UUID: string;
                  portNumber: number;
                } | null;
              }> | null;
              internetServicePlan?: {
                __typename?: 'InternetServicePlan';
                controllerIP?: string | null;
                UUID: string;
                provider?: {
                  __typename?: 'InternetServicePlanProvider';
                  name: string;
                  logoURL?: string | null;
                  UUID: string;
                } | null;
              } | null;
              virtualDevice:
                | {
                    __typename?: 'AccessPointVirtualDevice';
                    UUID: string;
                    label: string;
                    deviceModel: DeviceModel;
                  }
                | {
                    __typename?: 'ControllerVirtualDevice';
                    UUID: string;
                    label: string;
                    deviceModel: DeviceModel;
                  }
                | {
                    __typename?: 'ObserverVirtualDevice';
                    UUID: string;
                    label: string;
                    deviceModel: DeviceModel;
                  }
                | {
                    __typename?: 'PowerDistributionUnitVirtualDevice';
                    UUID: string;
                    label: string;
                    deviceModel: DeviceModel;
                  }
                | {
                    __typename?: 'SwitchVirtualDevice';
                    UUID: string;
                    label: string;
                    deviceModel: DeviceModel;
                  };
              nativeVLAN?: {
                __typename?: 'VLAN';
                UUID: string;
                vlanID: number;
                name: string;
              } | null;
              sfpModuleInfo?: {
                __typename?: 'SFPModuleInfo';
                moduleSpeedKbps?: number | null;
              } | null;
            }>;
            network: { __typename?: 'Network'; UUID: string; slug: string; label: string };
            highAvailability?: {
              __typename?: 'HighAvailabilityControllerVirtualDeviceInfo';
              role: HighAvailabilityControllerRole;
              status: HighAvailabilityStatus;
            } | null;
            outletInterfaceConnectedTo?: {
              __typename?: 'OutletInterface';
              UUID: string;
              label?: string | null;
              outletNumber: number;
              virtualDevice?:
                | { __typename?: 'AccessPointVirtualDevice'; UUID: string; label: string }
                | { __typename?: 'ControllerVirtualDevice'; UUID: string; label: string }
                | { __typename?: 'ObserverVirtualDevice'; UUID: string; label: string }
                | { __typename?: 'PowerDistributionUnitVirtualDevice'; UUID: string; label: string }
                | { __typename?: 'SwitchVirtualDevice'; UUID: string; label: string }
                | null;
            } | null;
            securityApplianceProfile?: {
              __typename?: 'SecurityApplianceProfile';
              UUID: string;
              multiWANAlgorithm: MultiWanAlgorithm;
              multiWANUpdateLookback: number;
              multiWANUpdateThreshold: number;
              multiWANUpdateCooldownSec?: number | null;
              hostMonitoringTimeoutSec: number;
              hostMonitoringIntervalSec: number;
            };
            managementConnection?: {
              __typename?: 'ManagementConnection';
              connectionType: ManagementConnectionType;
            };
            nosUpgradeGroup?: { __typename?: 'NOSUpgradeGroup'; UUID: string };
            nosVersion?: {
              __typename?: 'ConfiguredNOSVersion';
              id: number;
              version: string;
              buildName: string;
            } | null;
            pendingNosVersion?: {
              __typename?: 'PendingNosVersion';
              scheduledAt: string;
              nosVersion: { __typename?: 'NosVersion'; version: string };
            } | null;
            hardwareDevice?:
              | {
                  __typename: 'AccessPointHardwareDevice';
                  deviceType: DeviceType;
                  serialNumber: string;
                  macAddress?: string | null;
                  deviceModel: DeviceModel;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  isDev?: boolean;
                  bootHistory: Array<{
                    __typename?: 'BootInfo';
                    bootCount: number;
                    buildName: string;
                    rebootReason: string;
                    createdAt: string;
                  }>;
                  latestDeviceConfigMetadata?: {
                    __typename?: 'DeviceConfigMetadata';
                    version: number;
                    acknowledgedAt?: string | null;
                    createdAt: string;
                    isCurrentAsOf?: string | null;
                    state?: {
                      __typename?: 'DeviceConfigState';
                      state: DeviceConfigStateType;
                      timestamp: string;
                    } | null;
                  } | null;
                }
              | {
                  __typename: 'ControllerHardwareDevice';
                  deviceType: DeviceType;
                  serialNumber: string;
                  macAddress?: string | null;
                  deviceModel: DeviceModel;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  isDev?: boolean;
                  bootHistory: Array<{
                    __typename?: 'BootInfo';
                    bootCount: number;
                    buildName: string;
                    rebootReason: string;
                    createdAt: string;
                  }>;
                  latestDeviceConfigMetadata?: {
                    __typename?: 'DeviceConfigMetadata';
                    version: number;
                    acknowledgedAt?: string | null;
                    createdAt: string;
                    isCurrentAsOf?: string | null;
                    state?: {
                      __typename?: 'DeviceConfigState';
                      state: DeviceConfigStateType;
                      timestamp: string;
                    } | null;
                  } | null;
                }
              | {
                  __typename: 'PowerDistributionUnitHardwareDevice';
                  deviceType: DeviceType;
                  serialNumber: string;
                  macAddress?: string | null;
                  deviceModel: DeviceModel;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  isDev?: boolean;
                  bootHistory: Array<{
                    __typename?: 'BootInfo';
                    bootCount: number;
                    buildName: string;
                    rebootReason: string;
                    createdAt: string;
                  }>;
                  latestDeviceConfigMetadata?: {
                    __typename?: 'DeviceConfigMetadata';
                    version: number;
                    acknowledgedAt?: string | null;
                    createdAt: string;
                    isCurrentAsOf?: string | null;
                    state?: {
                      __typename?: 'DeviceConfigState';
                      state: DeviceConfigStateType;
                      timestamp: string;
                    } | null;
                  } | null;
                }
              | {
                  __typename: 'SwitchHardwareDevice';
                  deviceType: DeviceType;
                  serialNumber: string;
                  macAddress?: string | null;
                  deviceModel: DeviceModel;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  isDev?: boolean;
                  bootHistory: Array<{
                    __typename?: 'BootInfo';
                    bootCount: number;
                    buildName: string;
                    rebootReason: string;
                    createdAt: string;
                  }>;
                  latestDeviceConfigMetadata?: {
                    __typename?: 'DeviceConfigMetadata';
                    version: number;
                    acknowledgedAt?: string | null;
                    createdAt: string;
                    isCurrentAsOf?: string | null;
                    state?: {
                      __typename?: 'DeviceConfigState';
                      state: DeviceConfigStateType;
                      timestamp: string;
                    } | null;
                  } | null;
                }
              | null;
          }
        | {
            __typename: 'ObserverVirtualDevice';
            UUID: string;
            label: string;
            description?: string | null;
            deviceType: VirtualDeviceType;
            deviceModel: DeviceModel;
            isConsoleEnabled: boolean;
            networkUUID: string;
            uptime?: string | null;
            network: { __typename?: 'Network'; UUID: string; slug: string; label: string };
            nosUpgradeGroup?: { __typename?: 'NOSUpgradeGroup'; UUID: string };
            nosVersion?: {
              __typename?: 'ConfiguredNOSVersion';
              id: number;
              version: string;
              buildName: string;
            } | null;
            pendingNosVersion?: {
              __typename?: 'PendingNosVersion';
              scheduledAt: string;
              nosVersion: { __typename?: 'NosVersion'; version: string };
            } | null;
            hardwareDevice?:
              | {
                  __typename: 'AccessPointHardwareDevice';
                  deviceType: DeviceType;
                  serialNumber: string;
                  macAddress?: string | null;
                  deviceModel: DeviceModel;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  isDev?: boolean;
                  bootHistory: Array<{
                    __typename?: 'BootInfo';
                    bootCount: number;
                    buildName: string;
                    rebootReason: string;
                    createdAt: string;
                  }>;
                  latestDeviceConfigMetadata?: {
                    __typename?: 'DeviceConfigMetadata';
                    version: number;
                    acknowledgedAt?: string | null;
                    createdAt: string;
                    isCurrentAsOf?: string | null;
                    state?: {
                      __typename?: 'DeviceConfigState';
                      state: DeviceConfigStateType;
                      timestamp: string;
                    } | null;
                  } | null;
                }
              | {
                  __typename: 'ControllerHardwareDevice';
                  deviceType: DeviceType;
                  serialNumber: string;
                  macAddress?: string | null;
                  deviceModel: DeviceModel;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  isDev?: boolean;
                  bootHistory: Array<{
                    __typename?: 'BootInfo';
                    bootCount: number;
                    buildName: string;
                    rebootReason: string;
                    createdAt: string;
                  }>;
                  latestDeviceConfigMetadata?: {
                    __typename?: 'DeviceConfigMetadata';
                    version: number;
                    acknowledgedAt?: string | null;
                    createdAt: string;
                    isCurrentAsOf?: string | null;
                    state?: {
                      __typename?: 'DeviceConfigState';
                      state: DeviceConfigStateType;
                      timestamp: string;
                    } | null;
                  } | null;
                }
              | {
                  __typename: 'PowerDistributionUnitHardwareDevice';
                  deviceType: DeviceType;
                  serialNumber: string;
                  macAddress?: string | null;
                  deviceModel: DeviceModel;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  isDev?: boolean;
                  bootHistory: Array<{
                    __typename?: 'BootInfo';
                    bootCount: number;
                    buildName: string;
                    rebootReason: string;
                    createdAt: string;
                  }>;
                  latestDeviceConfigMetadata?: {
                    __typename?: 'DeviceConfigMetadata';
                    version: number;
                    acknowledgedAt?: string | null;
                    createdAt: string;
                    isCurrentAsOf?: string | null;
                    state?: {
                      __typename?: 'DeviceConfigState';
                      state: DeviceConfigStateType;
                      timestamp: string;
                    } | null;
                  } | null;
                }
              | {
                  __typename: 'SwitchHardwareDevice';
                  deviceType: DeviceType;
                  serialNumber: string;
                  macAddress?: string | null;
                  deviceModel: DeviceModel;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  isDev?: boolean;
                  bootHistory: Array<{
                    __typename?: 'BootInfo';
                    bootCount: number;
                    buildName: string;
                    rebootReason: string;
                    createdAt: string;
                  }>;
                  latestDeviceConfigMetadata?: {
                    __typename?: 'DeviceConfigMetadata';
                    version: number;
                    acknowledgedAt?: string | null;
                    createdAt: string;
                    isCurrentAsOf?: string | null;
                    state?: {
                      __typename?: 'DeviceConfigState';
                      state: DeviceConfigStateType;
                      timestamp: string;
                    } | null;
                  } | null;
                }
              | null;
          }
        | {
            __typename: 'PowerDistributionUnitVirtualDevice';
            UUID: string;
            label: string;
            description?: string | null;
            deviceType: VirtualDeviceType;
            deviceModel: DeviceModel;
            isConsoleEnabled: boolean;
            networkUUID: string;
            uptime?: string | null;
            network: { __typename?: 'Network'; UUID: string; slug: string; label: string };
            nosUpgradeGroup?: { __typename?: 'NOSUpgradeGroup'; UUID: string };
            nosVersion?: {
              __typename?: 'ConfiguredNOSVersion';
              id: number;
              version: string;
              buildName: string;
            } | null;
            pendingNosVersion?: {
              __typename?: 'PendingNosVersion';
              scheduledAt: string;
              nosVersion: { __typename?: 'NosVersion'; version: string };
            } | null;
            hardwareDevice?:
              | {
                  __typename: 'AccessPointHardwareDevice';
                  deviceType: DeviceType;
                  serialNumber: string;
                  macAddress?: string | null;
                  deviceModel: DeviceModel;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  isDev?: boolean;
                  bootHistory: Array<{
                    __typename?: 'BootInfo';
                    bootCount: number;
                    buildName: string;
                    rebootReason: string;
                    createdAt: string;
                  }>;
                  latestDeviceConfigMetadata?: {
                    __typename?: 'DeviceConfigMetadata';
                    version: number;
                    acknowledgedAt?: string | null;
                    createdAt: string;
                    isCurrentAsOf?: string | null;
                    state?: {
                      __typename?: 'DeviceConfigState';
                      state: DeviceConfigStateType;
                      timestamp: string;
                    } | null;
                  } | null;
                }
              | {
                  __typename: 'ControllerHardwareDevice';
                  deviceType: DeviceType;
                  serialNumber: string;
                  macAddress?: string | null;
                  deviceModel: DeviceModel;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  isDev?: boolean;
                  bootHistory: Array<{
                    __typename?: 'BootInfo';
                    bootCount: number;
                    buildName: string;
                    rebootReason: string;
                    createdAt: string;
                  }>;
                  latestDeviceConfigMetadata?: {
                    __typename?: 'DeviceConfigMetadata';
                    version: number;
                    acknowledgedAt?: string | null;
                    createdAt: string;
                    isCurrentAsOf?: string | null;
                    state?: {
                      __typename?: 'DeviceConfigState';
                      state: DeviceConfigStateType;
                      timestamp: string;
                    } | null;
                  } | null;
                }
              | {
                  __typename: 'PowerDistributionUnitHardwareDevice';
                  deviceType: DeviceType;
                  serialNumber: string;
                  macAddress?: string | null;
                  deviceModel: DeviceModel;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  isDev?: boolean;
                  bootHistory: Array<{
                    __typename?: 'BootInfo';
                    bootCount: number;
                    buildName: string;
                    rebootReason: string;
                    createdAt: string;
                  }>;
                  latestDeviceConfigMetadata?: {
                    __typename?: 'DeviceConfigMetadata';
                    version: number;
                    acknowledgedAt?: string | null;
                    createdAt: string;
                    isCurrentAsOf?: string | null;
                    state?: {
                      __typename?: 'DeviceConfigState';
                      state: DeviceConfigStateType;
                      timestamp: string;
                    } | null;
                  } | null;
                }
              | {
                  __typename: 'SwitchHardwareDevice';
                  deviceType: DeviceType;
                  serialNumber: string;
                  macAddress?: string | null;
                  deviceModel: DeviceModel;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  isDev?: boolean;
                  bootHistory: Array<{
                    __typename?: 'BootInfo';
                    bootCount: number;
                    buildName: string;
                    rebootReason: string;
                    createdAt: string;
                  }>;
                  latestDeviceConfigMetadata?: {
                    __typename?: 'DeviceConfigMetadata';
                    version: number;
                    acknowledgedAt?: string | null;
                    createdAt: string;
                    isCurrentAsOf?: string | null;
                    state?: {
                      __typename?: 'DeviceConfigState';
                      state: DeviceConfigStateType;
                      timestamp: string;
                    } | null;
                  } | null;
                }
              | null;
          }
        | {
            __typename: 'SwitchVirtualDevice';
            UUID: string;
            label: string;
            description?: string | null;
            deviceType: VirtualDeviceType;
            deviceModel: DeviceModel;
            isConsoleEnabled: boolean;
            networkUUID: string;
            uptime?: string | null;
            network: { __typename?: 'Network'; UUID: string; slug: string; label: string };
            nosUpgradeGroup?: { __typename?: 'NOSUpgradeGroup'; UUID: string };
            nosVersion?: {
              __typename?: 'ConfiguredNOSVersion';
              id: number;
              version: string;
              buildName: string;
            } | null;
            pendingNosVersion?: {
              __typename?: 'PendingNosVersion';
              scheduledAt: string;
              nosVersion: { __typename?: 'NosVersion'; version: string };
            } | null;
            hardwareDevice?:
              | {
                  __typename: 'AccessPointHardwareDevice';
                  deviceType: DeviceType;
                  serialNumber: string;
                  macAddress?: string | null;
                  deviceModel: DeviceModel;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  isDev?: boolean;
                  bootHistory: Array<{
                    __typename?: 'BootInfo';
                    bootCount: number;
                    buildName: string;
                    rebootReason: string;
                    createdAt: string;
                  }>;
                  latestDeviceConfigMetadata?: {
                    __typename?: 'DeviceConfigMetadata';
                    version: number;
                    acknowledgedAt?: string | null;
                    createdAt: string;
                    isCurrentAsOf?: string | null;
                    state?: {
                      __typename?: 'DeviceConfigState';
                      state: DeviceConfigStateType;
                      timestamp: string;
                    } | null;
                  } | null;
                }
              | {
                  __typename: 'ControllerHardwareDevice';
                  deviceType: DeviceType;
                  serialNumber: string;
                  macAddress?: string | null;
                  deviceModel: DeviceModel;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  isDev?: boolean;
                  bootHistory: Array<{
                    __typename?: 'BootInfo';
                    bootCount: number;
                    buildName: string;
                    rebootReason: string;
                    createdAt: string;
                  }>;
                  latestDeviceConfigMetadata?: {
                    __typename?: 'DeviceConfigMetadata';
                    version: number;
                    acknowledgedAt?: string | null;
                    createdAt: string;
                    isCurrentAsOf?: string | null;
                    state?: {
                      __typename?: 'DeviceConfigState';
                      state: DeviceConfigStateType;
                      timestamp: string;
                    } | null;
                  } | null;
                }
              | {
                  __typename: 'PowerDistributionUnitHardwareDevice';
                  deviceType: DeviceType;
                  serialNumber: string;
                  macAddress?: string | null;
                  deviceModel: DeviceModel;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  isDev?: boolean;
                  bootHistory: Array<{
                    __typename?: 'BootInfo';
                    bootCount: number;
                    buildName: string;
                    rebootReason: string;
                    createdAt: string;
                  }>;
                  latestDeviceConfigMetadata?: {
                    __typename?: 'DeviceConfigMetadata';
                    version: number;
                    acknowledgedAt?: string | null;
                    createdAt: string;
                    isCurrentAsOf?: string | null;
                    state?: {
                      __typename?: 'DeviceConfigState';
                      state: DeviceConfigStateType;
                      timestamp: string;
                    } | null;
                  } | null;
                }
              | {
                  __typename: 'SwitchHardwareDevice';
                  deviceType: DeviceType;
                  serialNumber: string;
                  macAddress?: string | null;
                  deviceModel: DeviceModel;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  isDev?: boolean;
                  bootHistory: Array<{
                    __typename?: 'BootInfo';
                    bootCount: number;
                    buildName: string;
                    rebootReason: string;
                    createdAt: string;
                  }>;
                  latestDeviceConfigMetadata?: {
                    __typename?: 'DeviceConfigMetadata';
                    version: number;
                    acknowledgedAt?: string | null;
                    createdAt: string;
                    isCurrentAsOf?: string | null;
                    state?: {
                      __typename?: 'DeviceConfigState';
                      state: DeviceConfigStateType;
                      timestamp: string;
                    } | null;
                  } | null;
                }
              | null;
          }
      >;
    }>;
  };
};

export type DeviceConfigVersionQueryVariables = Exact<{
  serialNumber: Scalars['String']['input'];
}>;

export type DeviceConfigVersionQuery = {
  __typename?: 'Query';
  latestDeviceConfig: { __typename?: 'DeviceConfig'; version: number };
  latestAcknowledgedDeviceConfig: {
    __typename?: 'DeviceConfig';
    version: number;
    acknowledgedAt?: string | null;
  };
};

export type FallbackSwitchHardwareQueryQueryVariables = Exact<{
  serialNumber: Scalars['String']['input'];
}>;

export type FallbackSwitchHardwareQueryQuery = {
  __typename?: 'Query';
  hardwareDevice:
    | {
        __typename?: 'AccessPointHardwareDevice';
        serialNumber: string;
        virtualDeviceUUID?: string | null;
      }
    | {
        __typename?: 'ControllerHardwareDevice';
        serialNumber: string;
        virtualDeviceUUID?: string | null;
      }
    | {
        __typename?: 'PowerDistributionUnitHardwareDevice';
        serialNumber: string;
        virtualDeviceUUID?: string | null;
      }
    | {
        __typename?: 'SwitchHardwareDevice';
        serialNumber: string;
        virtualDeviceUUID?: string | null;
      };
};

export type CreateHighAvailabilityConfigMutationVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
  primaryPhyInterfaceUUID: Scalars['UUID']['input'];
  backupPhyInterfaceUUID: Scalars['UUID']['input'];
  input: CreateHighAvailabilityPairInput;
}>;

export type CreateHighAvailabilityConfigMutation = {
  __typename?: 'Mutation';
  createHighAvailabilityControllersConfiguration: {
    __typename?: 'HighAvailabilityControllersConfig';
    UUID: string;
    advertisementVLAN: { __typename?: 'VLAN'; networkUUID: string };
  };
};

export type UpdateHighAvailabilityConfigMutationVariables = Exact<{
  uuid: Scalars['UUID']['input'];
  input: UpdateHighAvailabilityPairInput;
}>;

export type UpdateHighAvailabilityConfigMutation = {
  __typename?: 'Mutation';
  updateHighAvailabilityControllersConfiguration: {
    __typename?: 'HighAvailabilityControllersConfig';
    UUID: string;
  };
};

export type DeleteHighAvailabilityConfigMutationVariables = Exact<{
  uuid: Scalars['UUID']['input'];
}>;

export type DeleteHighAvailabilityConfigMutation = {
  __typename?: 'Mutation';
  deleteHighAvailabilityControllersConfiguration: {
    __typename?: 'HighAvailabilityControllersConfig';
    UUID: string;
  };
};

export type DeviceLastDayCellularUsageQueryVariables = Exact<{
  serialNumber: Scalars['String']['input'];
}>;

export type DeviceLastDayCellularUsageQuery = {
  __typename?: 'Query';
  deviceLastDayCellularUsage?: {
    __typename?: 'CellularUsage';
    uploadBytes?: number | null;
    downloadBytes?: number | null;
  } | null;
};

export type DeviceCellularStatusQueryVariables = Exact<{
  serialNumber: Scalars['String']['input'];
}>;

export type DeviceCellularStatusQuery = {
  __typename?: 'Query';
  deviceCellularStatus?: {
    __typename?: 'CellularStatus';
    managerModemState: CellularManagerModemState;
    observedAt: string;
  } | null;
};

export type DhcpRulesForNetworkQueryQueryVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
}>;

export type DhcpRulesForNetworkQueryQuery = {
  __typename?: 'Query';
  dhcpRulesForNetwork: Array<{
    __typename?: 'DHCPRule';
    UUID: string;
    vlan: { __typename?: 'VLAN'; UUID: string; name: string; vlanID: number };
  }>;
};

export type ControllerMetricsQueryQueryVariables = Exact<{
  virtualDeviceUUID: Scalars['UUID']['input'];
  filter: MetricsFilterInput;
}>;

export type ControllerMetricsQueryQuery = {
  __typename?: 'Query';
  controllerPortMetricsRate: {
    __typename?: 'ControllerPortMetricsRateResponse';
    values: Array<{
      __typename?: 'ControllerPortMetricsRateValue';
      timestamp: string;
      portNumber: number;
      dropsPerSecond: number;
      txErrPerSecond: number;
      rxErrPerSecond: number;
      totalRxBytesPerSecond: number;
      totalTxBytesPerSecond: number;
      multicastRxPacketsPerSecond: number;
      multicastTxPacketsPerSecond: number;
      broadcastRxPacketsPerSecond: number;
      broadcastTxPacketsPerSecond: number;
    }>;
  };
  controllerDNSRequestRates: {
    __typename?: 'ControllerDNSRequestRatesResponse';
    values: Array<{
      __typename?: 'ControllerDNSRequestRatesValue';
      timestamp: string;
      value: number;
      uuid: string;
    }>;
  };
};

export type ControllerPhyInterfaceFieldsFragment = {
  __typename?: 'PhyInterface';
  UUID: string;
  virtualDeviceUUID: string;
  portNumber: number;
  label?: string | null;
  description?: string | null;
  hardwareLabel?: string | null;
  forcedSpeedAllowed: boolean;
  isEnabled: boolean;
  isTrunkPort: boolean;
  isUplink: boolean;
  isEthernet: boolean;
  isSFP: boolean;
  isConnected: boolean;
  hasWANActivity?: boolean | null;
  forcedPortSpeedMbps?: number | null;
  portSpeedMbps?: number | null;
  maxSpeedMbps?: number | null;
  ipv4ClientAssignmentProtocol?: ClientAssignmentProtocol | null;
  ipv4ClientGateway?: string | null;
  ipv4ClientPrefixLength?: number | null;
  ipv4ClientAddresses?: Array<string> | null;
  uplinkPriority?: number | null;
  uplinkExternalAddresses?: Array<string> | null;
  isUplinkActive?: boolean | null;
  uplinkVLANID?: number | null;
  uplinkGatewayMACAddress?: string | null;
  virtualDevice:
    | {
        __typename?: 'AccessPointVirtualDevice';
        UUID: string;
        label: string;
        deviceModel: DeviceModel;
      }
    | {
        __typename?: 'ControllerVirtualDevice';
        UUID: string;
        label: string;
        deviceModel: DeviceModel;
      }
    | {
        __typename?: 'ObserverVirtualDevice';
        UUID: string;
        label: string;
        deviceModel: DeviceModel;
      }
    | {
        __typename?: 'PowerDistributionUnitVirtualDevice';
        UUID: string;
        label: string;
        deviceModel: DeviceModel;
      }
    | { __typename?: 'SwitchVirtualDevice'; UUID: string; label: string; deviceModel: DeviceModel };
  nativeVLAN?: { __typename?: 'VLAN'; UUID: string; vlanID: number; name: string } | null;
  connectedDevices?: Array<{
    __typename?: 'PhyInterfaceConnectedDevice';
    macAddress: string;
    hardwareDevice?:
      | {
          __typename?: 'AccessPointHardwareDevice';
          serialNumber: string;
          isConnectedToBackend: boolean;
          isActive: boolean;
          deviceType: DeviceType;
          deviceModel: DeviceModel;
          virtualDevice?:
            | {
                __typename: 'AccessPointVirtualDevice';
                deviceType: VirtualDeviceType;
                UUID: string;
                label: string;
              }
            | {
                __typename: 'ControllerVirtualDevice';
                deviceType: VirtualDeviceType;
                UUID: string;
                label: string;
              }
            | {
                __typename: 'ObserverVirtualDevice';
                deviceType: VirtualDeviceType;
                UUID: string;
                label: string;
              }
            | {
                __typename: 'PowerDistributionUnitVirtualDevice';
                deviceType: VirtualDeviceType;
                UUID: string;
                label: string;
              }
            | {
                __typename: 'SwitchVirtualDevice';
                deviceType: VirtualDeviceType;
                UUID: string;
                label: string;
              }
            | null;
        }
      | {
          __typename?: 'ControllerHardwareDevice';
          serialNumber: string;
          isConnectedToBackend: boolean;
          isActive: boolean;
          deviceType: DeviceType;
          deviceModel: DeviceModel;
          virtualDevice?:
            | {
                __typename: 'AccessPointVirtualDevice';
                deviceType: VirtualDeviceType;
                UUID: string;
                label: string;
              }
            | {
                __typename: 'ControllerVirtualDevice';
                deviceType: VirtualDeviceType;
                UUID: string;
                label: string;
              }
            | {
                __typename: 'ObserverVirtualDevice';
                deviceType: VirtualDeviceType;
                UUID: string;
                label: string;
              }
            | {
                __typename: 'PowerDistributionUnitVirtualDevice';
                deviceType: VirtualDeviceType;
                UUID: string;
                label: string;
              }
            | {
                __typename: 'SwitchVirtualDevice';
                deviceType: VirtualDeviceType;
                UUID: string;
                label: string;
              }
            | null;
        }
      | {
          __typename?: 'PowerDistributionUnitHardwareDevice';
          serialNumber: string;
          isConnectedToBackend: boolean;
          isActive: boolean;
          deviceType: DeviceType;
          deviceModel: DeviceModel;
          virtualDevice?:
            | {
                __typename: 'AccessPointVirtualDevice';
                deviceType: VirtualDeviceType;
                UUID: string;
                label: string;
              }
            | {
                __typename: 'ControllerVirtualDevice';
                deviceType: VirtualDeviceType;
                UUID: string;
                label: string;
              }
            | {
                __typename: 'ObserverVirtualDevice';
                deviceType: VirtualDeviceType;
                UUID: string;
                label: string;
              }
            | {
                __typename: 'PowerDistributionUnitVirtualDevice';
                deviceType: VirtualDeviceType;
                UUID: string;
                label: string;
              }
            | {
                __typename: 'SwitchVirtualDevice';
                deviceType: VirtualDeviceType;
                UUID: string;
                label: string;
              }
            | null;
        }
      | {
          __typename?: 'SwitchHardwareDevice';
          serialNumber: string;
          isConnectedToBackend: boolean;
          isActive: boolean;
          deviceType: DeviceType;
          deviceModel: DeviceModel;
          virtualDevice?:
            | {
                __typename: 'AccessPointVirtualDevice';
                deviceType: VirtualDeviceType;
                UUID: string;
                label: string;
              }
            | {
                __typename: 'ControllerVirtualDevice';
                deviceType: VirtualDeviceType;
                UUID: string;
                label: string;
              }
            | {
                __typename: 'ObserverVirtualDevice';
                deviceType: VirtualDeviceType;
                UUID: string;
                label: string;
              }
            | {
                __typename: 'PowerDistributionUnitVirtualDevice';
                deviceType: VirtualDeviceType;
                UUID: string;
                label: string;
              }
            | {
                __typename: 'SwitchVirtualDevice';
                deviceType: VirtualDeviceType;
                UUID: string;
                label: string;
              }
            | null;
        }
      | null;
    phyInterface?: { __typename?: 'PhyInterface'; UUID: string; portNumber: number } | null;
  }> | null;
  internetServicePlan?: {
    __typename?: 'InternetServicePlan';
    UUID: string;
    controllerIP?: string | null;
    provider?: {
      __typename?: 'InternetServicePlanProvider';
      UUID: string;
      name: string;
      logoURL?: string | null;
    } | null;
  } | null;
  sfpModuleInfo?: { __typename?: 'SFPModuleInfo'; moduleSpeedKbps?: number | null } | null;
};

export type SecurityAppliancePortStatsQueryQueryVariables = Exact<{
  virtualDeviceUUID: Scalars['UUID']['input'];
}>;

export type SecurityAppliancePortStatsQueryQuery = {
  __typename?: 'Query';
  controllerPortStats: Array<{
    __typename?: 'ControllerPortStat';
    portNumber: number;
    drops: number;
    txErr: number;
    rxErr: number;
    ipv4: number;
    ipv6: number;
    punts: number;
    totalRxBytes: number;
    totalTxBytes: number;
    totalRxPackets: number;
    totalTxPackets: number;
    hwUp: boolean;
  }>;
};

export type UptimeStatsForNetworkQueryVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
  filter: MetricsFilterInput;
}>;

export type UptimeStatsForNetworkQuery = {
  __typename?: 'Query';
  networkUplinkQuality: {
    __typename?: 'NetworkUplinkQualityResponse';
    values: Array<{
      __typename?: 'NetworkUplinkQualityValue';
      phyInterfaceUUID: string;
      timestamp: string;
      value: number;
    }>;
  };
};

export type PortCableTestMutationMutationVariables = Exact<{
  serialNumber: Scalars['String']['input'];
  portNumber: Scalars['Int']['input'];
}>;

export type PortCableTestMutationMutation = {
  __typename?: 'Mutation';
  rpcPortCableTest: {
    __typename?: 'RPCCableTestResponse';
    pairA: { __typename?: 'RPCCableTestTwistedPairResult'; status: RpcCableTestTwistedPairStatus };
    pairB: { __typename?: 'RPCCableTestTwistedPairResult'; status: RpcCableTestTwistedPairStatus };
    pairC: { __typename?: 'RPCCableTestTwistedPairResult'; status: RpcCableTestTwistedPairStatus };
    pairD: { __typename?: 'RPCCableTestTwistedPairResult'; status: RpcCableTestTwistedPairStatus };
  };
};

export type PatchPanelLayoutSwitchesQueryVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
}>;

export type PatchPanelLayoutSwitchesQuery = {
  __typename?: 'Query';
  network: {
    __typename?: 'Network';
    label: string;
    company?: { __typename?: 'Company'; name: string } | null;
    virtualDevices: Array<
      | { __typename: 'AccessPointVirtualDevice'; UUID: string }
      | { __typename: 'ControllerVirtualDevice'; UUID: string }
      | { __typename: 'ObserverVirtualDevice'; UUID: string }
      | { __typename: 'PowerDistributionUnitVirtualDevice'; UUID: string }
      | {
          __typename: 'SwitchVirtualDevice';
          label: string;
          UUID: string;
          phyInterfaces: Array<{
            __typename?: 'PhyInterface';
            UUID: string;
            portNumber: number;
            label?: string | null;
            description?: string | null;
            isTrunkPort: boolean;
            allowedVLANs?: Array<{ __typename?: 'VLAN'; name: string; vlanID: number }> | null;
            nativeVLAN?: { __typename?: 'VLAN'; name: string; vlanID: number } | null;
          }>;
        }
    >;
  };
};

export type OuIsForVendorQueryVariables = Exact<{
  vendorSubstring: Scalars['String']['input'];
}>;

export type OuIsForVendorQuery = {
  __typename?: 'Query';
  OUIsForVendor: Array<{
    __typename?: 'OUIsForVendorResult';
    OUIs: Array<string>;
    vendor: { __typename?: 'IEEEDeviceVendor'; vendorAddress: string; vendor: string };
  }>;
};

export type CancelAutoSwitchConfigurationJobMutationVariables = Exact<{
  jobUUID: Scalars['UUID']['input'];
}>;

export type CancelAutoSwitchConfigurationJobMutation = {
  __typename?: 'Mutation';
  cancelAutoSwitchConfigurationJob: { __typename?: 'SwitchAutoConfigurationJob'; UUID: string };
};

export type CreateSwitchAutoConfigMacAddressVlanBindingsMutationVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
  input:
    | Array<CreateSwitchAutoConfigMacAddressVlanBindingInput>
    | CreateSwitchAutoConfigMacAddressVlanBindingInput;
}>;

export type CreateSwitchAutoConfigMacAddressVlanBindingsMutation = {
  __typename?: 'Mutation';
  createSwitchAutoConfigMACAddressVLANBindings: Array<{
    __typename?: 'SwitchAutoConfigMACAddressVLANBinding';
    UUID: string;
  }>;
};

export type UpsertSwitchAutoConfigMacAddressVlanBindingsMutationMutationVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
  input:
    | Array<CreateSwitchAutoConfigMacAddressVlanBindingInput>
    | CreateSwitchAutoConfigMacAddressVlanBindingInput;
}>;

export type UpsertSwitchAutoConfigMacAddressVlanBindingsMutationMutation = {
  __typename?: 'Mutation';
  upsertSwitchAutoConfigMACAddressVLANBindingsForNetwork: Array<{
    __typename?: 'SwitchAutoConfigMACAddressVLANBinding';
    UUID: string;
  }>;
};

export type SwitchAutoConfigMacAddressVlanBindingsForNetworkQueryVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
}>;

export type SwitchAutoConfigMacAddressVlanBindingsForNetworkQuery = {
  __typename?: 'Query';
  switchAutoConfigMACAddressVLANBindingsForNetwork: Array<{
    __typename?: 'SwitchAutoConfigMACAddressVLANBinding';
    UUID: string;
    networkUUID: string;
    macAddress?: string | null;
    OUI?: string | null;
    vendor?: {
      __typename?: 'OUIsForVendorResult';
      vendor: { __typename?: 'IEEEDeviceVendor'; vendor: string; vendorAddress: string };
    } | null;
    VLAN: { __typename?: 'VLAN'; UUID: string };
  }>;
};

export type InitializeAutoSwitchConfigurationForNetworkMutationVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
  input: SwitchAutoConfigurationJobInput;
}>;

export type InitializeAutoSwitchConfigurationForNetworkMutation = {
  __typename?: 'Mutation';
  initializeAutoSwitchConfigurationForNetwork: {
    __typename?: 'SwitchAutoConfigurationJob';
    UUID: string;
  };
};

export type SwitchBootHistoryQueryQueryVariables = Exact<{
  serialNumber: Scalars['String']['input'];
  count?: InputMaybe<Scalars['Int']['input']>;
}>;

export type SwitchBootHistoryQueryQuery = {
  __typename?: 'Query';
  hardwareDevice:
    | {
        __typename?: 'AccessPointHardwareDevice';
        bootHistory: Array<{
          __typename?: 'BootInfo';
          bootCount: number;
          buildName: string;
          rebootReason: string;
          createdAt: string;
        }>;
      }
    | {
        __typename?: 'ControllerHardwareDevice';
        bootHistory: Array<{
          __typename?: 'BootInfo';
          bootCount: number;
          buildName: string;
          rebootReason: string;
          createdAt: string;
        }>;
      }
    | {
        __typename?: 'PowerDistributionUnitHardwareDevice';
        bootHistory: Array<{
          __typename?: 'BootInfo';
          bootCount: number;
          buildName: string;
          rebootReason: string;
          createdAt: string;
        }>;
      }
    | {
        __typename?: 'SwitchHardwareDevice';
        bootHistory: Array<{
          __typename?: 'BootInfo';
          bootCount: number;
          buildName: string;
          rebootReason: string;
          createdAt: string;
        }>;
      };
};

export type InsightsQueryQueryVariables = Exact<{
  serialNumber: Scalars['String']['input'];
  count?: InputMaybe<Scalars['Int']['input']>;
}>;

export type InsightsQueryQuery = {
  __typename?: 'Query';
  hardwareDevice:
    | {
        __typename: 'AccessPointHardwareDevice';
        serialNumber: string;
        macAddress?: string | null;
        deviceType: DeviceType;
        deviceModel: DeviceModel;
        isConnectedToBackend: boolean;
        disconnectedFromBackendAt?: string | null;
        bootHistory: Array<{
          __typename?: 'BootInfo';
          bootCount: number;
          buildName: string;
          rebootReason: string;
          createdAt: string;
        }>;
        virtualDevice?:
          | {
              __typename: 'AccessPointVirtualDevice';
              UUID: string;
              label: string;
              deviceType: VirtualDeviceType;
              deviceModel: DeviceModel;
              description?: string | null;
              networkUUID: string;
            }
          | {
              __typename: 'ControllerVirtualDevice';
              UUID: string;
              label: string;
              deviceType: VirtualDeviceType;
              deviceModel: DeviceModel;
              description?: string | null;
              networkUUID: string;
            }
          | {
              __typename: 'ObserverVirtualDevice';
              UUID: string;
              label: string;
              deviceType: VirtualDeviceType;
              deviceModel: DeviceModel;
              description?: string | null;
              networkUUID: string;
            }
          | {
              __typename: 'PowerDistributionUnitVirtualDevice';
              UUID: string;
              label: string;
              deviceType: VirtualDeviceType;
              deviceModel: DeviceModel;
              description?: string | null;
              networkUUID: string;
            }
          | {
              __typename: 'SwitchVirtualDevice';
              UUID: string;
              label: string;
              deviceType: VirtualDeviceType;
              deviceModel: DeviceModel;
              description?: string | null;
              networkUUID: string;
              switchProfile: {
                __typename?: 'SwitchProfile';
                stpBridgePriority: number;
                mtu: number;
                isFLIPEnabled: boolean;
                isVoiceVLANEnabled: boolean;
                voiceVLANUUID?: string | null;
              };
              outletInterfaceConnectedTo?: {
                __typename?: 'OutletInterface';
                outletNumber: number;
                virtualDevice?:
                  | { __typename?: 'AccessPointVirtualDevice'; UUID: string; label: string }
                  | { __typename?: 'ControllerVirtualDevice'; UUID: string; label: string }
                  | { __typename?: 'ObserverVirtualDevice'; UUID: string; label: string }
                  | {
                      __typename?: 'PowerDistributionUnitVirtualDevice';
                      UUID: string;
                      label: string;
                    }
                  | { __typename?: 'SwitchVirtualDevice'; UUID: string; label: string }
                  | null;
              } | null;
            }
          | null;
      }
    | {
        __typename: 'ControllerHardwareDevice';
        serialNumber: string;
        macAddress?: string | null;
        deviceType: DeviceType;
        deviceModel: DeviceModel;
        isConnectedToBackend: boolean;
        disconnectedFromBackendAt?: string | null;
        bootHistory: Array<{
          __typename?: 'BootInfo';
          bootCount: number;
          buildName: string;
          rebootReason: string;
          createdAt: string;
        }>;
        virtualDevice?:
          | {
              __typename: 'AccessPointVirtualDevice';
              UUID: string;
              label: string;
              deviceType: VirtualDeviceType;
              deviceModel: DeviceModel;
              description?: string | null;
              networkUUID: string;
            }
          | {
              __typename: 'ControllerVirtualDevice';
              UUID: string;
              label: string;
              deviceType: VirtualDeviceType;
              deviceModel: DeviceModel;
              description?: string | null;
              networkUUID: string;
            }
          | {
              __typename: 'ObserverVirtualDevice';
              UUID: string;
              label: string;
              deviceType: VirtualDeviceType;
              deviceModel: DeviceModel;
              description?: string | null;
              networkUUID: string;
            }
          | {
              __typename: 'PowerDistributionUnitVirtualDevice';
              UUID: string;
              label: string;
              deviceType: VirtualDeviceType;
              deviceModel: DeviceModel;
              description?: string | null;
              networkUUID: string;
            }
          | {
              __typename: 'SwitchVirtualDevice';
              UUID: string;
              label: string;
              deviceType: VirtualDeviceType;
              deviceModel: DeviceModel;
              description?: string | null;
              networkUUID: string;
              switchProfile: {
                __typename?: 'SwitchProfile';
                stpBridgePriority: number;
                mtu: number;
                isFLIPEnabled: boolean;
                isVoiceVLANEnabled: boolean;
                voiceVLANUUID?: string | null;
              };
              outletInterfaceConnectedTo?: {
                __typename?: 'OutletInterface';
                outletNumber: number;
                virtualDevice?:
                  | { __typename?: 'AccessPointVirtualDevice'; UUID: string; label: string }
                  | { __typename?: 'ControllerVirtualDevice'; UUID: string; label: string }
                  | { __typename?: 'ObserverVirtualDevice'; UUID: string; label: string }
                  | {
                      __typename?: 'PowerDistributionUnitVirtualDevice';
                      UUID: string;
                      label: string;
                    }
                  | { __typename?: 'SwitchVirtualDevice'; UUID: string; label: string }
                  | null;
              } | null;
            }
          | null;
      }
    | {
        __typename: 'PowerDistributionUnitHardwareDevice';
        serialNumber: string;
        macAddress?: string | null;
        deviceType: DeviceType;
        deviceModel: DeviceModel;
        isConnectedToBackend: boolean;
        disconnectedFromBackendAt?: string | null;
        bootHistory: Array<{
          __typename?: 'BootInfo';
          bootCount: number;
          buildName: string;
          rebootReason: string;
          createdAt: string;
        }>;
        virtualDevice?:
          | {
              __typename: 'AccessPointVirtualDevice';
              UUID: string;
              label: string;
              deviceType: VirtualDeviceType;
              deviceModel: DeviceModel;
              description?: string | null;
              networkUUID: string;
            }
          | {
              __typename: 'ControllerVirtualDevice';
              UUID: string;
              label: string;
              deviceType: VirtualDeviceType;
              deviceModel: DeviceModel;
              description?: string | null;
              networkUUID: string;
            }
          | {
              __typename: 'ObserverVirtualDevice';
              UUID: string;
              label: string;
              deviceType: VirtualDeviceType;
              deviceModel: DeviceModel;
              description?: string | null;
              networkUUID: string;
            }
          | {
              __typename: 'PowerDistributionUnitVirtualDevice';
              UUID: string;
              label: string;
              deviceType: VirtualDeviceType;
              deviceModel: DeviceModel;
              description?: string | null;
              networkUUID: string;
            }
          | {
              __typename: 'SwitchVirtualDevice';
              UUID: string;
              label: string;
              deviceType: VirtualDeviceType;
              deviceModel: DeviceModel;
              description?: string | null;
              networkUUID: string;
              switchProfile: {
                __typename?: 'SwitchProfile';
                stpBridgePriority: number;
                mtu: number;
                isFLIPEnabled: boolean;
                isVoiceVLANEnabled: boolean;
                voiceVLANUUID?: string | null;
              };
              outletInterfaceConnectedTo?: {
                __typename?: 'OutletInterface';
                outletNumber: number;
                virtualDevice?:
                  | { __typename?: 'AccessPointVirtualDevice'; UUID: string; label: string }
                  | { __typename?: 'ControllerVirtualDevice'; UUID: string; label: string }
                  | { __typename?: 'ObserverVirtualDevice'; UUID: string; label: string }
                  | {
                      __typename?: 'PowerDistributionUnitVirtualDevice';
                      UUID: string;
                      label: string;
                    }
                  | { __typename?: 'SwitchVirtualDevice'; UUID: string; label: string }
                  | null;
              } | null;
            }
          | null;
      }
    | {
        __typename: 'SwitchHardwareDevice';
        ipAddress?: string | null;
        serialNumber: string;
        macAddress?: string | null;
        deviceType: DeviceType;
        deviceModel: DeviceModel;
        isConnectedToBackend: boolean;
        disconnectedFromBackendAt?: string | null;
        stpInfo?: {
          __typename?: 'STPInfo';
          isRootBridge: boolean;
          rootBridgeMACAddress: string;
        } | null;
        bootHistory: Array<{
          __typename?: 'BootInfo';
          bootCount: number;
          buildName: string;
          rebootReason: string;
          createdAt: string;
        }>;
        virtualDevice?:
          | {
              __typename: 'AccessPointVirtualDevice';
              UUID: string;
              label: string;
              deviceType: VirtualDeviceType;
              deviceModel: DeviceModel;
              description?: string | null;
              networkUUID: string;
            }
          | {
              __typename: 'ControllerVirtualDevice';
              UUID: string;
              label: string;
              deviceType: VirtualDeviceType;
              deviceModel: DeviceModel;
              description?: string | null;
              networkUUID: string;
            }
          | {
              __typename: 'ObserverVirtualDevice';
              UUID: string;
              label: string;
              deviceType: VirtualDeviceType;
              deviceModel: DeviceModel;
              description?: string | null;
              networkUUID: string;
            }
          | {
              __typename: 'PowerDistributionUnitVirtualDevice';
              UUID: string;
              label: string;
              deviceType: VirtualDeviceType;
              deviceModel: DeviceModel;
              description?: string | null;
              networkUUID: string;
            }
          | {
              __typename: 'SwitchVirtualDevice';
              UUID: string;
              label: string;
              deviceType: VirtualDeviceType;
              deviceModel: DeviceModel;
              description?: string | null;
              networkUUID: string;
              switchProfile: {
                __typename?: 'SwitchProfile';
                stpBridgePriority: number;
                mtu: number;
                isFLIPEnabled: boolean;
                isVoiceVLANEnabled: boolean;
                voiceVLANUUID?: string | null;
              };
              outletInterfaceConnectedTo?: {
                __typename?: 'OutletInterface';
                outletNumber: number;
                virtualDevice?:
                  | { __typename?: 'AccessPointVirtualDevice'; UUID: string; label: string }
                  | { __typename?: 'ControllerVirtualDevice'; UUID: string; label: string }
                  | { __typename?: 'ObserverVirtualDevice'; UUID: string; label: string }
                  | {
                      __typename?: 'PowerDistributionUnitVirtualDevice';
                      UUID: string;
                      label: string;
                    }
                  | { __typename?: 'SwitchVirtualDevice'; UUID: string; label: string }
                  | null;
              } | null;
            }
          | null;
      };
};

export type SwitchesRootQueryQueryVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
}>;

export type SwitchesRootQueryQuery = {
  __typename?: 'Query';
  virtualDevicesForNetwork: Array<
    | {
        __typename?: 'AccessPointVirtualDevice';
        UUID: string;
        hardwareDevice?:
          | { __typename: 'AccessPointHardwareDevice'; serialNumber: string }
          | { __typename: 'ControllerHardwareDevice'; serialNumber: string }
          | { __typename: 'PowerDistributionUnitHardwareDevice'; serialNumber: string }
          | {
              __typename: 'SwitchHardwareDevice';
              serialNumber: string;
              stpInfo?: { __typename?: 'STPInfo'; isRootBridge: boolean } | null;
            }
          | null;
      }
    | {
        __typename?: 'ControllerVirtualDevice';
        UUID: string;
        hardwareDevice?:
          | { __typename: 'AccessPointHardwareDevice'; serialNumber: string }
          | { __typename: 'ControllerHardwareDevice'; serialNumber: string }
          | { __typename: 'PowerDistributionUnitHardwareDevice'; serialNumber: string }
          | {
              __typename: 'SwitchHardwareDevice';
              serialNumber: string;
              stpInfo?: { __typename?: 'STPInfo'; isRootBridge: boolean } | null;
            }
          | null;
      }
    | {
        __typename?: 'ObserverVirtualDevice';
        UUID: string;
        hardwareDevice?:
          | { __typename: 'AccessPointHardwareDevice'; serialNumber: string }
          | { __typename: 'ControllerHardwareDevice'; serialNumber: string }
          | { __typename: 'PowerDistributionUnitHardwareDevice'; serialNumber: string }
          | {
              __typename: 'SwitchHardwareDevice';
              serialNumber: string;
              stpInfo?: { __typename?: 'STPInfo'; isRootBridge: boolean } | null;
            }
          | null;
      }
    | {
        __typename?: 'PowerDistributionUnitVirtualDevice';
        UUID: string;
        hardwareDevice?:
          | { __typename: 'AccessPointHardwareDevice'; serialNumber: string }
          | { __typename: 'ControllerHardwareDevice'; serialNumber: string }
          | { __typename: 'PowerDistributionUnitHardwareDevice'; serialNumber: string }
          | {
              __typename: 'SwitchHardwareDevice';
              serialNumber: string;
              stpInfo?: { __typename?: 'STPInfo'; isRootBridge: boolean } | null;
            }
          | null;
      }
    | {
        __typename?: 'SwitchVirtualDevice';
        UUID: string;
        hardwareDevice?:
          | { __typename: 'AccessPointHardwareDevice'; serialNumber: string }
          | { __typename: 'ControllerHardwareDevice'; serialNumber: string }
          | { __typename: 'PowerDistributionUnitHardwareDevice'; serialNumber: string }
          | {
              __typename: 'SwitchHardwareDevice';
              serialNumber: string;
              stpInfo?: { __typename?: 'STPInfo'; isRootBridge: boolean } | null;
            }
          | null;
      }
  >;
};

export type SwitchMetricsQueryQueryVariables = Exact<{
  input: MetricsSerialNumberDirectionInput;
  filter: MetricsFilterInput;
}>;

export type SwitchMetricsQueryQuery = {
  __typename?: 'Query';
  switchThroughputPerPort: {
    __typename?: 'SwitchMetricsResponse';
    metadata?: { __typename?: 'MetricsMetadata'; minValue: number; maxValue: number } | null;
    values: Array<{
      __typename?: 'SwitchPortMetricsValue';
      port: string;
      direction: TrafficDirection;
      timestamp: string;
      value: number;
    }>;
  };
  switchDiscardRatesPerPort: {
    __typename?: 'SwitchMetricsResponse';
    metadata?: { __typename?: 'MetricsMetadata'; minValue: number; maxValue: number } | null;
    values: Array<{
      __typename?: 'SwitchPortMetricsValue';
      port: string;
      direction: TrafficDirection;
      timestamp: string;
      value: number;
    }>;
  };
  switchErrorRatesPerPort: {
    __typename?: 'SwitchMetricsResponse';
    metadata?: { __typename?: 'MetricsMetadata'; minValue: number; maxValue: number } | null;
    values: Array<{
      __typename?: 'SwitchPortMetricsValue';
      port: string;
      direction: TrafficDirection;
      timestamp: string;
      value: number;
    }>;
  };
};

export type RebootSwitchMutationVariables = Exact<{
  serialNumber: Scalars['String']['input'];
}>;

export type RebootSwitchMutation = { __typename?: 'Mutation'; rpcRebootDevice: boolean };

export type UnassignedHardwareForNetworkQueryVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
}>;

export type UnassignedHardwareForNetworkQuery = {
  __typename?: 'Query';
  unassignedHardwareDevicesForNetwork: Array<{
    __typename?: 'UnassignedHardwareDeviceForNetworkResponse';
    virtualDevice: { __typename?: 'SwitchVirtualDevice'; UUID: string; label: string };
    unassignedHardwareConnections: Array<{
      __typename?: 'UnassignedHardwareAndConnectedPhyInterface';
      phyInterface: { __typename?: 'PhyInterface'; UUID: string; portNumber: number };
      unassignedHardwareDevice: {
        __typename?: 'AccessPointHardwareDevice';
        serialNumber: string;
        deviceType: DeviceType;
        deviceModel: DeviceModel;
        macAddress?: string | null;
      };
    }>;
  }>;
};

export type SwitchQueryQueryVariables = Exact<{
  uuid: Scalars['UUID']['input'];
  includeNOS?: InputMaybe<Scalars['Boolean']['input']>;
  includeMACTable?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type SwitchQueryQuery = {
  __typename?: 'Query';
  virtualDevice:
    | {
        __typename: 'AccessPointVirtualDevice';
        UUID: string;
        label: string;
        description?: string | null;
        networkUUID: string;
        isConsoleEnabled: boolean;
        deviceType: VirtualDeviceType;
        deviceModel: DeviceModel;
        network: { __typename?: 'Network'; UUID: string; slug: string; label: string };
        nosUpgradeGroup?: { __typename?: 'NOSUpgradeGroup'; UUID: string };
        nosVersion?: {
          __typename?: 'ConfiguredNOSVersion';
          id: number;
          buildName: string;
          version: string;
        } | null;
        pendingNosVersion?: {
          __typename?: 'PendingNosVersion';
          scheduledAt: string;
          nosVersion: { __typename?: 'NosVersion'; version: string };
        } | null;
        hardwareDevice?:
          | {
              __typename: 'AccessPointHardwareDevice';
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              macAddress?: string | null;
              deviceModel: DeviceModel;
              serialNumber: string;
              deviceType: DeviceType;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
            }
          | {
              __typename: 'ControllerHardwareDevice';
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              macAddress?: string | null;
              deviceModel: DeviceModel;
              serialNumber: string;
              deviceType: DeviceType;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
            }
          | {
              __typename: 'PowerDistributionUnitHardwareDevice';
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              macAddress?: string | null;
              deviceModel: DeviceModel;
              serialNumber: string;
              deviceType: DeviceType;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
            }
          | {
              __typename: 'SwitchHardwareDevice';
              ipAddress?: string | null;
              isInCurrentControllerMACTable: boolean;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              macAddress?: string | null;
              deviceModel: DeviceModel;
              serialNumber: string;
              deviceType: DeviceType;
              stpInfo?: {
                __typename?: 'STPInfo';
                isRootBridge: boolean;
                rootBridgePortNumber: number;
              } | null;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
            }
          | null;
      }
    | {
        __typename: 'ControllerVirtualDevice';
        UUID: string;
        label: string;
        description?: string | null;
        networkUUID: string;
        isConsoleEnabled: boolean;
        deviceType: VirtualDeviceType;
        deviceModel: DeviceModel;
        network: { __typename?: 'Network'; UUID: string; slug: string; label: string };
        nosUpgradeGroup?: { __typename?: 'NOSUpgradeGroup'; UUID: string };
        nosVersion?: {
          __typename?: 'ConfiguredNOSVersion';
          id: number;
          buildName: string;
          version: string;
        } | null;
        pendingNosVersion?: {
          __typename?: 'PendingNosVersion';
          scheduledAt: string;
          nosVersion: { __typename?: 'NosVersion'; version: string };
        } | null;
        hardwareDevice?:
          | {
              __typename: 'AccessPointHardwareDevice';
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              macAddress?: string | null;
              deviceModel: DeviceModel;
              serialNumber: string;
              deviceType: DeviceType;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
            }
          | {
              __typename: 'ControllerHardwareDevice';
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              macAddress?: string | null;
              deviceModel: DeviceModel;
              serialNumber: string;
              deviceType: DeviceType;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
            }
          | {
              __typename: 'PowerDistributionUnitHardwareDevice';
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              macAddress?: string | null;
              deviceModel: DeviceModel;
              serialNumber: string;
              deviceType: DeviceType;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
            }
          | {
              __typename: 'SwitchHardwareDevice';
              ipAddress?: string | null;
              isInCurrentControllerMACTable: boolean;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              macAddress?: string | null;
              deviceModel: DeviceModel;
              serialNumber: string;
              deviceType: DeviceType;
              stpInfo?: {
                __typename?: 'STPInfo';
                isRootBridge: boolean;
                rootBridgePortNumber: number;
              } | null;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
            }
          | null;
      }
    | {
        __typename: 'ObserverVirtualDevice';
        UUID: string;
        label: string;
        description?: string | null;
        networkUUID: string;
        isConsoleEnabled: boolean;
        deviceType: VirtualDeviceType;
        deviceModel: DeviceModel;
        network: { __typename?: 'Network'; UUID: string; slug: string; label: string };
        nosUpgradeGroup?: { __typename?: 'NOSUpgradeGroup'; UUID: string };
        nosVersion?: {
          __typename?: 'ConfiguredNOSVersion';
          id: number;
          buildName: string;
          version: string;
        } | null;
        pendingNosVersion?: {
          __typename?: 'PendingNosVersion';
          scheduledAt: string;
          nosVersion: { __typename?: 'NosVersion'; version: string };
        } | null;
        hardwareDevice?:
          | {
              __typename: 'AccessPointHardwareDevice';
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              macAddress?: string | null;
              deviceModel: DeviceModel;
              serialNumber: string;
              deviceType: DeviceType;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
            }
          | {
              __typename: 'ControllerHardwareDevice';
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              macAddress?: string | null;
              deviceModel: DeviceModel;
              serialNumber: string;
              deviceType: DeviceType;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
            }
          | {
              __typename: 'PowerDistributionUnitHardwareDevice';
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              macAddress?: string | null;
              deviceModel: DeviceModel;
              serialNumber: string;
              deviceType: DeviceType;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
            }
          | {
              __typename: 'SwitchHardwareDevice';
              ipAddress?: string | null;
              isInCurrentControllerMACTable: boolean;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              macAddress?: string | null;
              deviceModel: DeviceModel;
              serialNumber: string;
              deviceType: DeviceType;
              stpInfo?: {
                __typename?: 'STPInfo';
                isRootBridge: boolean;
                rootBridgePortNumber: number;
              } | null;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
            }
          | null;
      }
    | {
        __typename: 'PowerDistributionUnitVirtualDevice';
        UUID: string;
        label: string;
        description?: string | null;
        networkUUID: string;
        isConsoleEnabled: boolean;
        deviceType: VirtualDeviceType;
        deviceModel: DeviceModel;
        network: { __typename?: 'Network'; UUID: string; slug: string; label: string };
        nosUpgradeGroup?: { __typename?: 'NOSUpgradeGroup'; UUID: string };
        nosVersion?: {
          __typename?: 'ConfiguredNOSVersion';
          id: number;
          buildName: string;
          version: string;
        } | null;
        pendingNosVersion?: {
          __typename?: 'PendingNosVersion';
          scheduledAt: string;
          nosVersion: { __typename?: 'NosVersion'; version: string };
        } | null;
        hardwareDevice?:
          | {
              __typename: 'AccessPointHardwareDevice';
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              macAddress?: string | null;
              deviceModel: DeviceModel;
              serialNumber: string;
              deviceType: DeviceType;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
            }
          | {
              __typename: 'ControllerHardwareDevice';
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              macAddress?: string | null;
              deviceModel: DeviceModel;
              serialNumber: string;
              deviceType: DeviceType;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
            }
          | {
              __typename: 'PowerDistributionUnitHardwareDevice';
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              macAddress?: string | null;
              deviceModel: DeviceModel;
              serialNumber: string;
              deviceType: DeviceType;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
            }
          | {
              __typename: 'SwitchHardwareDevice';
              ipAddress?: string | null;
              isInCurrentControllerMACTable: boolean;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              macAddress?: string | null;
              deviceModel: DeviceModel;
              serialNumber: string;
              deviceType: DeviceType;
              stpInfo?: {
                __typename?: 'STPInfo';
                isRootBridge: boolean;
                rootBridgePortNumber: number;
              } | null;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
            }
          | null;
      }
    | {
        __typename: 'SwitchVirtualDevice';
        UUID: string;
        label: string;
        description?: string | null;
        networkUUID: string;
        isConsoleEnabled: boolean;
        deviceType: VirtualDeviceType;
        deviceModel: DeviceModel;
        switchProfile: {
          __typename?: 'SwitchProfile';
          UUID: string;
          stpBridgePriority: number;
          mtu: number;
          isFLIPEnabled: boolean;
          isVoiceVLANEnabled: boolean;
          voiceVLANUUID?: string | null;
          switchingTier: SwitchProfileSwitchingTier;
          encryption8021Xs?: Array<{ __typename?: 'Encryption8021X'; UUID: string }> | null;
          encryption8021XGuestVLAN?: { __typename?: 'VLAN'; UUID: string } | null;
        };
        outletInterfaceConnectedTo?: {
          __typename?: 'OutletInterface';
          outletNumber: number;
          virtualDevice?:
            | { __typename?: 'AccessPointVirtualDevice'; UUID: string; label: string }
            | { __typename?: 'ControllerVirtualDevice'; UUID: string; label: string }
            | { __typename?: 'ObserverVirtualDevice'; UUID: string; label: string }
            | { __typename?: 'PowerDistributionUnitVirtualDevice'; UUID: string; label: string }
            | { __typename?: 'SwitchVirtualDevice'; UUID: string; label: string }
            | null;
        } | null;
        phyInterfaces: Array<{
          __typename?: 'PhyInterface';
          UUID: string;
          portNumber: number;
          isFLIPEnabled: boolean;
          isVoiceVLANEnabled: boolean;
          isEthernet: boolean;
          isSFP: boolean;
          isUplink: boolean;
          isConnected: boolean;
          portSpeedMbps?: number | null;
          maxSpeedMbps?: number | null;
          poeType?: PoEType | null;
          sfpModuleInfo?: { __typename?: 'SFPModuleInfo'; moduleSpeedKbps?: number | null } | null;
        }>;
        macTable?: Array<{
          __typename?: 'SwitchMACTableEntry';
          macAddress: string;
          updatedAt: string;
          macAddressAlias?: { __typename?: 'MACAddressAlias'; alias: string } | null;
          phyInterface: { __typename?: 'PhyInterface'; isUplink: boolean; portNumber: number };
          vlan?: { __typename?: 'VLAN'; UUID: string; name: string; vlanID: number } | null;
        }> | null;
        poeInfo?: { __typename?: 'PoEInfo'; used?: number | null; max?: number | null } | null;
        network: { __typename?: 'Network'; UUID: string; slug: string; label: string };
        nosUpgradeGroup?: { __typename?: 'NOSUpgradeGroup'; UUID: string };
        nosVersion?: {
          __typename?: 'ConfiguredNOSVersion';
          id: number;
          buildName: string;
          version: string;
        } | null;
        pendingNosVersion?: {
          __typename?: 'PendingNosVersion';
          scheduledAt: string;
          nosVersion: { __typename?: 'NosVersion'; version: string };
        } | null;
        hardwareDevice?:
          | {
              __typename: 'AccessPointHardwareDevice';
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              macAddress?: string | null;
              deviceModel: DeviceModel;
              serialNumber: string;
              deviceType: DeviceType;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
            }
          | {
              __typename: 'ControllerHardwareDevice';
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              macAddress?: string | null;
              deviceModel: DeviceModel;
              serialNumber: string;
              deviceType: DeviceType;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
            }
          | {
              __typename: 'PowerDistributionUnitHardwareDevice';
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              macAddress?: string | null;
              deviceModel: DeviceModel;
              serialNumber: string;
              deviceType: DeviceType;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
            }
          | {
              __typename: 'SwitchHardwareDevice';
              ipAddress?: string | null;
              isInCurrentControllerMACTable: boolean;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              macAddress?: string | null;
              deviceModel: DeviceModel;
              serialNumber: string;
              deviceType: DeviceType;
              stpInfo?: {
                __typename?: 'STPInfo';
                isRootBridge: boolean;
                rootBridgePortNumber: number;
              } | null;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
            }
          | null;
      };
};

export type SwitchesQueryQueryVariables = Exact<{
  companySlug: Scalars['String']['input'];
  networkUUIDs?: InputMaybe<Array<Scalars['UUID']['input']> | Scalars['UUID']['input']>;
  includeIsDev?: InputMaybe<Scalars['Boolean']['input']>;
  includeConfigMetadata?: InputMaybe<Scalars['Boolean']['input']>;
  includeNOS?: InputMaybe<Scalars['Boolean']['input']>;
  includeMACTable?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type SwitchesQueryQuery = {
  __typename?: 'Query';
  companyBySlug: {
    __typename?: 'Company';
    networks: Array<{
      __typename?: 'Network';
      virtualDevices: Array<
        | {
            __typename: 'AccessPointVirtualDevice';
            UUID: string;
            uptime?: string | null;
            label: string;
            description?: string | null;
            deviceType: VirtualDeviceType;
            deviceModel: DeviceModel;
            network: { __typename?: 'Network'; UUID: string; slug: string; label: string };
            nosVersion?: {
              __typename?: 'ConfiguredNOSVersion';
              id: number;
              version: string;
              buildName: string;
            } | null;
            pendingNosVersion?: {
              __typename?: 'PendingNosVersion';
              scheduledAt: string;
              nosVersion: { __typename?: 'NosVersion'; version: string };
            } | null;
            hardwareDevice?:
              | {
                  __typename: 'AccessPointHardwareDevice';
                  deviceType: DeviceType;
                  serialNumber: string;
                  macAddress?: string | null;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  isDev?: boolean;
                  bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
                  latestDeviceConfigMetadata?: {
                    __typename?: 'DeviceConfigMetadata';
                    version: number;
                    acknowledgedAt?: string | null;
                    createdAt: string;
                    isCurrentAsOf?: string | null;
                    state?: {
                      __typename?: 'DeviceConfigState';
                      state: DeviceConfigStateType;
                      timestamp: string;
                    } | null;
                  } | null;
                }
              | {
                  __typename: 'ControllerHardwareDevice';
                  deviceType: DeviceType;
                  serialNumber: string;
                  macAddress?: string | null;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  isDev?: boolean;
                  bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
                  latestDeviceConfigMetadata?: {
                    __typename?: 'DeviceConfigMetadata';
                    version: number;
                    acknowledgedAt?: string | null;
                    createdAt: string;
                    isCurrentAsOf?: string | null;
                    state?: {
                      __typename?: 'DeviceConfigState';
                      state: DeviceConfigStateType;
                      timestamp: string;
                    } | null;
                  } | null;
                }
              | {
                  __typename: 'PowerDistributionUnitHardwareDevice';
                  deviceType: DeviceType;
                  serialNumber: string;
                  macAddress?: string | null;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  isDev?: boolean;
                  bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
                  latestDeviceConfigMetadata?: {
                    __typename?: 'DeviceConfigMetadata';
                    version: number;
                    acknowledgedAt?: string | null;
                    createdAt: string;
                    isCurrentAsOf?: string | null;
                    state?: {
                      __typename?: 'DeviceConfigState';
                      state: DeviceConfigStateType;
                      timestamp: string;
                    } | null;
                  } | null;
                }
              | {
                  __typename: 'SwitchHardwareDevice';
                  ipAddress?: string | null;
                  isInCurrentControllerMACTable: boolean;
                  deviceType: DeviceType;
                  serialNumber: string;
                  macAddress?: string | null;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  isDev?: boolean;
                  stpInfo?: {
                    __typename?: 'STPInfo';
                    isRootBridge: boolean;
                    rootBridgePortNumber: number;
                  } | null;
                  bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
                  latestDeviceConfigMetadata?: {
                    __typename?: 'DeviceConfigMetadata';
                    version: number;
                    acknowledgedAt?: string | null;
                    createdAt: string;
                    isCurrentAsOf?: string | null;
                    state?: {
                      __typename?: 'DeviceConfigState';
                      state: DeviceConfigStateType;
                      timestamp: string;
                    } | null;
                  } | null;
                }
              | null;
          }
        | {
            __typename: 'ControllerVirtualDevice';
            UUID: string;
            uptime?: string | null;
            label: string;
            description?: string | null;
            deviceType: VirtualDeviceType;
            deviceModel: DeviceModel;
            network: { __typename?: 'Network'; UUID: string; slug: string; label: string };
            nosVersion?: {
              __typename?: 'ConfiguredNOSVersion';
              id: number;
              version: string;
              buildName: string;
            } | null;
            pendingNosVersion?: {
              __typename?: 'PendingNosVersion';
              scheduledAt: string;
              nosVersion: { __typename?: 'NosVersion'; version: string };
            } | null;
            hardwareDevice?:
              | {
                  __typename: 'AccessPointHardwareDevice';
                  deviceType: DeviceType;
                  serialNumber: string;
                  macAddress?: string | null;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  isDev?: boolean;
                  bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
                  latestDeviceConfigMetadata?: {
                    __typename?: 'DeviceConfigMetadata';
                    version: number;
                    acknowledgedAt?: string | null;
                    createdAt: string;
                    isCurrentAsOf?: string | null;
                    state?: {
                      __typename?: 'DeviceConfigState';
                      state: DeviceConfigStateType;
                      timestamp: string;
                    } | null;
                  } | null;
                }
              | {
                  __typename: 'ControllerHardwareDevice';
                  deviceType: DeviceType;
                  serialNumber: string;
                  macAddress?: string | null;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  isDev?: boolean;
                  bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
                  latestDeviceConfigMetadata?: {
                    __typename?: 'DeviceConfigMetadata';
                    version: number;
                    acknowledgedAt?: string | null;
                    createdAt: string;
                    isCurrentAsOf?: string | null;
                    state?: {
                      __typename?: 'DeviceConfigState';
                      state: DeviceConfigStateType;
                      timestamp: string;
                    } | null;
                  } | null;
                }
              | {
                  __typename: 'PowerDistributionUnitHardwareDevice';
                  deviceType: DeviceType;
                  serialNumber: string;
                  macAddress?: string | null;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  isDev?: boolean;
                  bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
                  latestDeviceConfigMetadata?: {
                    __typename?: 'DeviceConfigMetadata';
                    version: number;
                    acknowledgedAt?: string | null;
                    createdAt: string;
                    isCurrentAsOf?: string | null;
                    state?: {
                      __typename?: 'DeviceConfigState';
                      state: DeviceConfigStateType;
                      timestamp: string;
                    } | null;
                  } | null;
                }
              | {
                  __typename: 'SwitchHardwareDevice';
                  ipAddress?: string | null;
                  isInCurrentControllerMACTable: boolean;
                  deviceType: DeviceType;
                  serialNumber: string;
                  macAddress?: string | null;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  isDev?: boolean;
                  stpInfo?: {
                    __typename?: 'STPInfo';
                    isRootBridge: boolean;
                    rootBridgePortNumber: number;
                  } | null;
                  bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
                  latestDeviceConfigMetadata?: {
                    __typename?: 'DeviceConfigMetadata';
                    version: number;
                    acknowledgedAt?: string | null;
                    createdAt: string;
                    isCurrentAsOf?: string | null;
                    state?: {
                      __typename?: 'DeviceConfigState';
                      state: DeviceConfigStateType;
                      timestamp: string;
                    } | null;
                  } | null;
                }
              | null;
          }
        | {
            __typename: 'ObserverVirtualDevice';
            UUID: string;
            uptime?: string | null;
            label: string;
            description?: string | null;
            deviceType: VirtualDeviceType;
            deviceModel: DeviceModel;
            network: { __typename?: 'Network'; UUID: string; slug: string; label: string };
            nosVersion?: {
              __typename?: 'ConfiguredNOSVersion';
              id: number;
              version: string;
              buildName: string;
            } | null;
            pendingNosVersion?: {
              __typename?: 'PendingNosVersion';
              scheduledAt: string;
              nosVersion: { __typename?: 'NosVersion'; version: string };
            } | null;
            hardwareDevice?:
              | {
                  __typename: 'AccessPointHardwareDevice';
                  deviceType: DeviceType;
                  serialNumber: string;
                  macAddress?: string | null;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  isDev?: boolean;
                  bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
                  latestDeviceConfigMetadata?: {
                    __typename?: 'DeviceConfigMetadata';
                    version: number;
                    acknowledgedAt?: string | null;
                    createdAt: string;
                    isCurrentAsOf?: string | null;
                    state?: {
                      __typename?: 'DeviceConfigState';
                      state: DeviceConfigStateType;
                      timestamp: string;
                    } | null;
                  } | null;
                }
              | {
                  __typename: 'ControllerHardwareDevice';
                  deviceType: DeviceType;
                  serialNumber: string;
                  macAddress?: string | null;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  isDev?: boolean;
                  bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
                  latestDeviceConfigMetadata?: {
                    __typename?: 'DeviceConfigMetadata';
                    version: number;
                    acknowledgedAt?: string | null;
                    createdAt: string;
                    isCurrentAsOf?: string | null;
                    state?: {
                      __typename?: 'DeviceConfigState';
                      state: DeviceConfigStateType;
                      timestamp: string;
                    } | null;
                  } | null;
                }
              | {
                  __typename: 'PowerDistributionUnitHardwareDevice';
                  deviceType: DeviceType;
                  serialNumber: string;
                  macAddress?: string | null;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  isDev?: boolean;
                  bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
                  latestDeviceConfigMetadata?: {
                    __typename?: 'DeviceConfigMetadata';
                    version: number;
                    acknowledgedAt?: string | null;
                    createdAt: string;
                    isCurrentAsOf?: string | null;
                    state?: {
                      __typename?: 'DeviceConfigState';
                      state: DeviceConfigStateType;
                      timestamp: string;
                    } | null;
                  } | null;
                }
              | {
                  __typename: 'SwitchHardwareDevice';
                  ipAddress?: string | null;
                  isInCurrentControllerMACTable: boolean;
                  deviceType: DeviceType;
                  serialNumber: string;
                  macAddress?: string | null;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  isDev?: boolean;
                  stpInfo?: {
                    __typename?: 'STPInfo';
                    isRootBridge: boolean;
                    rootBridgePortNumber: number;
                  } | null;
                  bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
                  latestDeviceConfigMetadata?: {
                    __typename?: 'DeviceConfigMetadata';
                    version: number;
                    acknowledgedAt?: string | null;
                    createdAt: string;
                    isCurrentAsOf?: string | null;
                    state?: {
                      __typename?: 'DeviceConfigState';
                      state: DeviceConfigStateType;
                      timestamp: string;
                    } | null;
                  } | null;
                }
              | null;
          }
        | {
            __typename: 'PowerDistributionUnitVirtualDevice';
            UUID: string;
            uptime?: string | null;
            label: string;
            description?: string | null;
            deviceType: VirtualDeviceType;
            deviceModel: DeviceModel;
            network: { __typename?: 'Network'; UUID: string; slug: string; label: string };
            nosVersion?: {
              __typename?: 'ConfiguredNOSVersion';
              id: number;
              version: string;
              buildName: string;
            } | null;
            pendingNosVersion?: {
              __typename?: 'PendingNosVersion';
              scheduledAt: string;
              nosVersion: { __typename?: 'NosVersion'; version: string };
            } | null;
            hardwareDevice?:
              | {
                  __typename: 'AccessPointHardwareDevice';
                  deviceType: DeviceType;
                  serialNumber: string;
                  macAddress?: string | null;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  isDev?: boolean;
                  bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
                  latestDeviceConfigMetadata?: {
                    __typename?: 'DeviceConfigMetadata';
                    version: number;
                    acknowledgedAt?: string | null;
                    createdAt: string;
                    isCurrentAsOf?: string | null;
                    state?: {
                      __typename?: 'DeviceConfigState';
                      state: DeviceConfigStateType;
                      timestamp: string;
                    } | null;
                  } | null;
                }
              | {
                  __typename: 'ControllerHardwareDevice';
                  deviceType: DeviceType;
                  serialNumber: string;
                  macAddress?: string | null;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  isDev?: boolean;
                  bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
                  latestDeviceConfigMetadata?: {
                    __typename?: 'DeviceConfigMetadata';
                    version: number;
                    acknowledgedAt?: string | null;
                    createdAt: string;
                    isCurrentAsOf?: string | null;
                    state?: {
                      __typename?: 'DeviceConfigState';
                      state: DeviceConfigStateType;
                      timestamp: string;
                    } | null;
                  } | null;
                }
              | {
                  __typename: 'PowerDistributionUnitHardwareDevice';
                  deviceType: DeviceType;
                  serialNumber: string;
                  macAddress?: string | null;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  isDev?: boolean;
                  bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
                  latestDeviceConfigMetadata?: {
                    __typename?: 'DeviceConfigMetadata';
                    version: number;
                    acknowledgedAt?: string | null;
                    createdAt: string;
                    isCurrentAsOf?: string | null;
                    state?: {
                      __typename?: 'DeviceConfigState';
                      state: DeviceConfigStateType;
                      timestamp: string;
                    } | null;
                  } | null;
                }
              | {
                  __typename: 'SwitchHardwareDevice';
                  ipAddress?: string | null;
                  isInCurrentControllerMACTable: boolean;
                  deviceType: DeviceType;
                  serialNumber: string;
                  macAddress?: string | null;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  isDev?: boolean;
                  stpInfo?: {
                    __typename?: 'STPInfo';
                    isRootBridge: boolean;
                    rootBridgePortNumber: number;
                  } | null;
                  bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
                  latestDeviceConfigMetadata?: {
                    __typename?: 'DeviceConfigMetadata';
                    version: number;
                    acknowledgedAt?: string | null;
                    createdAt: string;
                    isCurrentAsOf?: string | null;
                    state?: {
                      __typename?: 'DeviceConfigState';
                      state: DeviceConfigStateType;
                      timestamp: string;
                    } | null;
                  } | null;
                }
              | null;
          }
        | {
            __typename: 'SwitchVirtualDevice';
            UUID: string;
            uptime?: string | null;
            label: string;
            description?: string | null;
            deviceType: VirtualDeviceType;
            deviceModel: DeviceModel;
            switchProfile: {
              __typename?: 'SwitchProfile';
              stpBridgePriority: number;
              mtu: number;
              isVoiceVLANEnabled: boolean;
              isFLIPEnabled: boolean;
              voiceVLANUUID?: string | null;
              switchingTier: SwitchProfileSwitchingTier;
            };
            phyInterfaces: Array<{
              __typename?: 'PhyInterface';
              UUID: string;
              portNumber: number;
              isEthernet: boolean;
              isSFP: boolean;
              isUplink: boolean;
              isConnected: boolean;
              portSpeedMbps?: number | null;
              maxSpeedMbps?: number | null;
              isFLIPEnabled: boolean;
              isVoiceVLANEnabled: boolean;
              sfpModuleInfo?: {
                __typename?: 'SFPModuleInfo';
                moduleSpeedKbps?: number | null;
              } | null;
            }>;
            macTable?: Array<{
              __typename?: 'SwitchMACTableEntry';
              macAddress: string;
              updatedAt: string;
              macAddressAlias?: { __typename?: 'MACAddressAlias'; alias: string } | null;
              phyInterface: { __typename?: 'PhyInterface'; isUplink: boolean; portNumber: number };
              vlan?: { __typename?: 'VLAN'; UUID: string; name: string; vlanID: number } | null;
            }> | null;
            poeInfo?: { __typename?: 'PoEInfo'; used?: number | null; max?: number | null } | null;
            network: { __typename?: 'Network'; UUID: string; slug: string; label: string };
            nosVersion?: {
              __typename?: 'ConfiguredNOSVersion';
              id: number;
              version: string;
              buildName: string;
            } | null;
            pendingNosVersion?: {
              __typename?: 'PendingNosVersion';
              scheduledAt: string;
              nosVersion: { __typename?: 'NosVersion'; version: string };
            } | null;
            hardwareDevice?:
              | {
                  __typename: 'AccessPointHardwareDevice';
                  deviceType: DeviceType;
                  serialNumber: string;
                  macAddress?: string | null;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  isDev?: boolean;
                  bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
                  latestDeviceConfigMetadata?: {
                    __typename?: 'DeviceConfigMetadata';
                    version: number;
                    acknowledgedAt?: string | null;
                    createdAt: string;
                    isCurrentAsOf?: string | null;
                    state?: {
                      __typename?: 'DeviceConfigState';
                      state: DeviceConfigStateType;
                      timestamp: string;
                    } | null;
                  } | null;
                }
              | {
                  __typename: 'ControllerHardwareDevice';
                  deviceType: DeviceType;
                  serialNumber: string;
                  macAddress?: string | null;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  isDev?: boolean;
                  bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
                  latestDeviceConfigMetadata?: {
                    __typename?: 'DeviceConfigMetadata';
                    version: number;
                    acknowledgedAt?: string | null;
                    createdAt: string;
                    isCurrentAsOf?: string | null;
                    state?: {
                      __typename?: 'DeviceConfigState';
                      state: DeviceConfigStateType;
                      timestamp: string;
                    } | null;
                  } | null;
                }
              | {
                  __typename: 'PowerDistributionUnitHardwareDevice';
                  deviceType: DeviceType;
                  serialNumber: string;
                  macAddress?: string | null;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  isDev?: boolean;
                  bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
                  latestDeviceConfigMetadata?: {
                    __typename?: 'DeviceConfigMetadata';
                    version: number;
                    acknowledgedAt?: string | null;
                    createdAt: string;
                    isCurrentAsOf?: string | null;
                    state?: {
                      __typename?: 'DeviceConfigState';
                      state: DeviceConfigStateType;
                      timestamp: string;
                    } | null;
                  } | null;
                }
              | {
                  __typename: 'SwitchHardwareDevice';
                  ipAddress?: string | null;
                  isInCurrentControllerMACTable: boolean;
                  deviceType: DeviceType;
                  serialNumber: string;
                  macAddress?: string | null;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  isDev?: boolean;
                  stpInfo?: {
                    __typename?: 'STPInfo';
                    isRootBridge: boolean;
                    rootBridgePortNumber: number;
                  } | null;
                  bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
                  latestDeviceConfigMetadata?: {
                    __typename?: 'DeviceConfigMetadata';
                    version: number;
                    acknowledgedAt?: string | null;
                    createdAt: string;
                    isCurrentAsOf?: string | null;
                    state?: {
                      __typename?: 'DeviceConfigState';
                      state: DeviceConfigStateType;
                      timestamp: string;
                    } | null;
                  } | null;
                }
              | null;
          }
      >;
    }>;
  };
};

export type PortsQueryQueryVariables = Exact<{
  virtualDeviceUUID: Scalars['UUID']['input'];
}>;

export type PortsQueryQuery = {
  __typename?: 'Query';
  phyInterfacesForVirtualDevice: Array<{
    __typename?: 'PhyInterface';
    UUID: string;
    virtualDeviceUUID: string;
    description?: string | null;
    forcedPortSpeedMbps?: number | null;
    isBoundToAllVLANs: boolean;
    isBlockedByFLIP: boolean;
    isEnabled: boolean;
    isPOEEnabled: boolean;
    isSTPEdgePortEnabled: boolean;
    isSTPEnabled: boolean;
    isTrunkPort: boolean;
    isUplink: boolean;
    isConnected: boolean;
    isLoopbackDetected?: boolean | null;
    isBlockedDueToFlaps: boolean;
    isSTPForwarding?: boolean | null;
    isIngressFilteringEnabled: boolean;
    frameAcceptTypeFilter?: PhyInterfaceFrameAcceptTypeFilter | null;
    label?: string | null;
    portNumber: number;
    isEthernet: boolean;
    isSFP: boolean;
    powerDraw?: number | null;
    portSpeedMbps?: number | null;
    maxSpeedMbps?: number | null;
    stpPortRole?: StpPortRole | null;
    stpPathCost?: number | null;
    stpPriority: number;
    isStormControlEnabled: boolean;
    stormControlBroadcastTrafficPercent: number;
    stormControlUnknownMulticastTrafficPercent: number;
    stormControlUnknownUnicastTrafficPercent: number;
    txRateLimitKbps?: number | null;
    rxRateLimitKbps?: number | null;
    isIsolationEnabled?: boolean | null;
    maxMACAddressesAllowed?: number | null;
    isSTPRootGuardEnabled: boolean;
    isFLIPEnabled: boolean;
    isVoiceVLANEnabled: boolean;
    poeType?: PoEType | null;
    encryption8021XSettings?: {
      __typename?: 'PhyInterface8021XSettings';
      isAssignVLANsFromRADIUSEnabled: boolean;
      isGuestVLANEnabled: boolean;
      macAuthenticationBypassMode: PhyInterface8021XmacAuthenticationBypassMode;
      portMode: PhyInterface8021XPortMode;
      quietPeriodSeconds: number;
      supplicantPeriodSeconds: number;
    } | null;
    allowedVLANs?: Array<{
      __typename?: 'VLAN';
      UUID: string;
      name: string;
      vlanID: number;
    }> | null;
    nativeVLAN?: { __typename?: 'VLAN'; UUID: string; name: string; vlanID: number } | null;
    nativeVLANOrDefaultVLAN: { __typename?: 'VLAN'; UUID: string; name: string; vlanID: number };
    throughputLastDay?: Array<{
      __typename?: 'ThroughputValueWithDirection';
      direction: TrafficDirection;
      value: number;
    }> | null;
    connectedDevices?: Array<{
      __typename?: 'PhyInterfaceConnectedDevice';
      macAddress: string;
      hardwareDevice?:
        | {
            __typename?: 'AccessPointHardwareDevice';
            serialNumber: string;
            isConnectedToBackend: boolean;
            isActive: boolean;
            deviceType: DeviceType;
            virtualDevice?:
              | {
                  __typename: 'AccessPointVirtualDevice';
                  deviceType: VirtualDeviceType;
                  UUID: string;
                  label: string;
                }
              | {
                  __typename: 'ControllerVirtualDevice';
                  deviceType: VirtualDeviceType;
                  UUID: string;
                  label: string;
                }
              | {
                  __typename: 'ObserverVirtualDevice';
                  deviceType: VirtualDeviceType;
                  UUID: string;
                  label: string;
                }
              | {
                  __typename: 'PowerDistributionUnitVirtualDevice';
                  deviceType: VirtualDeviceType;
                  UUID: string;
                  label: string;
                }
              | {
                  __typename: 'SwitchVirtualDevice';
                  deviceType: VirtualDeviceType;
                  UUID: string;
                  label: string;
                }
              | null;
          }
        | {
            __typename?: 'ControllerHardwareDevice';
            serialNumber: string;
            isConnectedToBackend: boolean;
            isActive: boolean;
            deviceType: DeviceType;
            virtualDevice?:
              | {
                  __typename: 'AccessPointVirtualDevice';
                  deviceType: VirtualDeviceType;
                  UUID: string;
                  label: string;
                }
              | {
                  __typename: 'ControllerVirtualDevice';
                  deviceType: VirtualDeviceType;
                  UUID: string;
                  label: string;
                }
              | {
                  __typename: 'ObserverVirtualDevice';
                  deviceType: VirtualDeviceType;
                  UUID: string;
                  label: string;
                }
              | {
                  __typename: 'PowerDistributionUnitVirtualDevice';
                  deviceType: VirtualDeviceType;
                  UUID: string;
                  label: string;
                }
              | {
                  __typename: 'SwitchVirtualDevice';
                  deviceType: VirtualDeviceType;
                  UUID: string;
                  label: string;
                }
              | null;
          }
        | {
            __typename?: 'PowerDistributionUnitHardwareDevice';
            serialNumber: string;
            isConnectedToBackend: boolean;
            isActive: boolean;
            deviceType: DeviceType;
            virtualDevice?:
              | {
                  __typename: 'AccessPointVirtualDevice';
                  deviceType: VirtualDeviceType;
                  UUID: string;
                  label: string;
                }
              | {
                  __typename: 'ControllerVirtualDevice';
                  deviceType: VirtualDeviceType;
                  UUID: string;
                  label: string;
                }
              | {
                  __typename: 'ObserverVirtualDevice';
                  deviceType: VirtualDeviceType;
                  UUID: string;
                  label: string;
                }
              | {
                  __typename: 'PowerDistributionUnitVirtualDevice';
                  deviceType: VirtualDeviceType;
                  UUID: string;
                  label: string;
                }
              | {
                  __typename: 'SwitchVirtualDevice';
                  deviceType: VirtualDeviceType;
                  UUID: string;
                  label: string;
                }
              | null;
          }
        | {
            __typename?: 'SwitchHardwareDevice';
            serialNumber: string;
            isConnectedToBackend: boolean;
            isActive: boolean;
            deviceType: DeviceType;
            virtualDevice?:
              | {
                  __typename: 'AccessPointVirtualDevice';
                  deviceType: VirtualDeviceType;
                  UUID: string;
                  label: string;
                }
              | {
                  __typename: 'ControllerVirtualDevice';
                  deviceType: VirtualDeviceType;
                  UUID: string;
                  label: string;
                }
              | {
                  __typename: 'ObserverVirtualDevice';
                  deviceType: VirtualDeviceType;
                  UUID: string;
                  label: string;
                }
              | {
                  __typename: 'PowerDistributionUnitVirtualDevice';
                  deviceType: VirtualDeviceType;
                  UUID: string;
                  label: string;
                }
              | {
                  __typename: 'SwitchVirtualDevice';
                  deviceType: VirtualDeviceType;
                  UUID: string;
                  label: string;
                }
              | null;
          }
        | null;
      phyInterface?: { __typename?: 'PhyInterface'; UUID: string; portNumber: number } | null;
    }> | null;
    sfpModuleInfo?: {
      __typename?: 'SFPModuleInfo';
      vendor: string;
      serialNumber: string;
      partName: string;
      moduleSpeed: string;
      moduleType: string;
      moduleSpeedKbps?: number | null;
    } | null;
  }>;
};

export type MacTableQueryQueryVariables = Exact<{
  virtualDeviceUUID: Scalars['UUID']['input'];
}>;

export type MacTableQueryQuery = {
  __typename?: 'Query';
  switchMACTable: Array<{
    __typename: 'SwitchMACTableEntry';
    updatedAt: string;
    macAddress: string;
    port: number;
    macAddressAlias?: { __typename?: 'MACAddressAlias'; alias: string } | null;
    vlan?: { __typename?: 'VLAN'; UUID: string; name: string; vlanID: number } | null;
  }>;
};

export type UpdateSwitchProfileMutationVariables = Exact<{
  uuid: Scalars['UUID']['input'];
  input: UpdateSwitchProfileInput;
}>;

export type UpdateSwitchProfileMutation = {
  __typename?: 'Mutation';
  updateSwitchProfile: { __typename?: 'SwitchProfile'; UUID: string };
};

export type FindMacOnSwitchQueryQueryVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
  mac: Scalars['MacAddress']['input'];
}>;

export type FindMacOnSwitchQueryQuery = {
  __typename?: 'Query';
  findSwitchesForClientMAC: Array<{
    __typename?: 'MACAddressSwitchEntry';
    virtualDevice:
      | {
          __typename?: 'AccessPointVirtualDevice';
          UUID: string;
          label: string;
          hardwareDevice?:
            | { __typename?: 'AccessPointHardwareDevice'; isConnectedToBackend: boolean }
            | { __typename?: 'ControllerHardwareDevice'; isConnectedToBackend: boolean }
            | { __typename?: 'PowerDistributionUnitHardwareDevice'; isConnectedToBackend: boolean }
            | { __typename?: 'SwitchHardwareDevice'; isConnectedToBackend: boolean }
            | null;
        }
      | {
          __typename?: 'ControllerVirtualDevice';
          UUID: string;
          label: string;
          hardwareDevice?:
            | { __typename?: 'AccessPointHardwareDevice'; isConnectedToBackend: boolean }
            | { __typename?: 'ControllerHardwareDevice'; isConnectedToBackend: boolean }
            | { __typename?: 'PowerDistributionUnitHardwareDevice'; isConnectedToBackend: boolean }
            | { __typename?: 'SwitchHardwareDevice'; isConnectedToBackend: boolean }
            | null;
        }
      | {
          __typename?: 'ObserverVirtualDevice';
          UUID: string;
          label: string;
          hardwareDevice?:
            | { __typename?: 'AccessPointHardwareDevice'; isConnectedToBackend: boolean }
            | { __typename?: 'ControllerHardwareDevice'; isConnectedToBackend: boolean }
            | { __typename?: 'PowerDistributionUnitHardwareDevice'; isConnectedToBackend: boolean }
            | { __typename?: 'SwitchHardwareDevice'; isConnectedToBackend: boolean }
            | null;
        }
      | {
          __typename?: 'PowerDistributionUnitVirtualDevice';
          UUID: string;
          label: string;
          hardwareDevice?:
            | { __typename?: 'AccessPointHardwareDevice'; isConnectedToBackend: boolean }
            | { __typename?: 'ControllerHardwareDevice'; isConnectedToBackend: boolean }
            | { __typename?: 'PowerDistributionUnitHardwareDevice'; isConnectedToBackend: boolean }
            | { __typename?: 'SwitchHardwareDevice'; isConnectedToBackend: boolean }
            | null;
        }
      | {
          __typename?: 'SwitchVirtualDevice';
          UUID: string;
          label: string;
          hardwareDevice?:
            | { __typename?: 'AccessPointHardwareDevice'; isConnectedToBackend: boolean }
            | { __typename?: 'ControllerHardwareDevice'; isConnectedToBackend: boolean }
            | { __typename?: 'PowerDistributionUnitHardwareDevice'; isConnectedToBackend: boolean }
            | { __typename?: 'SwitchHardwareDevice'; isConnectedToBackend: boolean }
            | null;
        };
    phyInterface: { __typename?: 'PhyInterface'; UUID: string; portNumber: number };
  }>;
};

export type FindLldpEntryOnSwitchQueryQueryVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
  mac: Scalars['MacAddress']['input'];
}>;

export type FindLldpEntryOnSwitchQueryQuery = {
  __typename?: 'Query';
  findSwitchLLDPEntryForMAC?: {
    __typename?: 'MACAddressSwitchEntry';
    virtualDevice:
      | {
          __typename?: 'AccessPointVirtualDevice';
          UUID: string;
          label: string;
          hardwareDevice?:
            | { __typename?: 'AccessPointHardwareDevice'; isConnectedToBackend: boolean }
            | { __typename?: 'ControllerHardwareDevice'; isConnectedToBackend: boolean }
            | { __typename?: 'PowerDistributionUnitHardwareDevice'; isConnectedToBackend: boolean }
            | { __typename?: 'SwitchHardwareDevice'; isConnectedToBackend: boolean }
            | null;
        }
      | {
          __typename?: 'ControllerVirtualDevice';
          UUID: string;
          label: string;
          hardwareDevice?:
            | { __typename?: 'AccessPointHardwareDevice'; isConnectedToBackend: boolean }
            | { __typename?: 'ControllerHardwareDevice'; isConnectedToBackend: boolean }
            | { __typename?: 'PowerDistributionUnitHardwareDevice'; isConnectedToBackend: boolean }
            | { __typename?: 'SwitchHardwareDevice'; isConnectedToBackend: boolean }
            | null;
        }
      | {
          __typename?: 'ObserverVirtualDevice';
          UUID: string;
          label: string;
          hardwareDevice?:
            | { __typename?: 'AccessPointHardwareDevice'; isConnectedToBackend: boolean }
            | { __typename?: 'ControllerHardwareDevice'; isConnectedToBackend: boolean }
            | { __typename?: 'PowerDistributionUnitHardwareDevice'; isConnectedToBackend: boolean }
            | { __typename?: 'SwitchHardwareDevice'; isConnectedToBackend: boolean }
            | null;
        }
      | {
          __typename?: 'PowerDistributionUnitVirtualDevice';
          UUID: string;
          label: string;
          hardwareDevice?:
            | { __typename?: 'AccessPointHardwareDevice'; isConnectedToBackend: boolean }
            | { __typename?: 'ControllerHardwareDevice'; isConnectedToBackend: boolean }
            | { __typename?: 'PowerDistributionUnitHardwareDevice'; isConnectedToBackend: boolean }
            | { __typename?: 'SwitchHardwareDevice'; isConnectedToBackend: boolean }
            | null;
        }
      | {
          __typename?: 'SwitchVirtualDevice';
          UUID: string;
          label: string;
          hardwareDevice?:
            | { __typename?: 'AccessPointHardwareDevice'; isConnectedToBackend: boolean }
            | { __typename?: 'ControllerHardwareDevice'; isConnectedToBackend: boolean }
            | { __typename?: 'PowerDistributionUnitHardwareDevice'; isConnectedToBackend: boolean }
            | { __typename?: 'SwitchHardwareDevice'; isConnectedToBackend: boolean }
            | null;
        };
    phyInterface: { __typename?: 'PhyInterface'; UUID: string; portNumber: number };
  } | null;
};

export type PortCycleMutationMutationVariables = Exact<{
  portNumber: Scalars['Int']['input'];
  serialNumber: Scalars['String']['input'];
  poeCycle: Scalars['Boolean']['input'];
  portCycle: Scalars['Boolean']['input'];
}>;

export type PortCycleMutationMutation = { __typename?: 'Mutation'; rpcSwitchPortCycle: boolean };

export type SwitchPortMetricsQueryQueryVariables = Exact<{
  virtualDeviceUUID: Scalars['UUID']['input'];
  filter: MetricsFilterInput;
}>;

export type SwitchPortMetricsQueryQuery = {
  __typename?: 'Query';
  switchPortMetricsRate: {
    __typename?: 'SwitchPortMetricsRateResponse';
    values: Array<{
      __typename?: 'SwitchPortMetricsRateValue';
      timestamp: string;
      portNumber: number;
      dropsPerSecond: number;
      txErrPerSecond: number;
      rxErrPerSecond: number;
      totalRxBytesPerSecond: number;
      totalTxBytesPerSecond: number;
      multicastRxPacketsPerSecond: number;
      multicastTxPacketsPerSecond: number;
      broadcastRxPacketsPerSecond: number;
      broadcastTxPacketsPerSecond: number;
    }>;
  };
};

export type SwitchPortStatsQueryQueryVariables = Exact<{
  virtualDeviceUUID: Scalars['UUID']['input'];
}>;

export type SwitchPortStatsQueryQuery = {
  __typename?: 'Query';
  switchPortStats: Array<{
    __typename?: 'SwitchPortStat';
    portNumber: number;
    totalRxBytes: number;
    totalTxBytes: number;
  }>;
};

export type SwitchPortNumbersQueryVariables = Exact<{
  virtualDeviceUUID: Scalars['UUID']['input'];
}>;

export type SwitchPortNumbersQuery = {
  __typename?: 'Query';
  phyInterfacesForVirtualDevice: Array<{ __typename?: 'PhyInterface'; portNumber: number }>;
};

export type HardwareListQueryQueryVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
  includeIsDev?: InputMaybe<Scalars['Boolean']['input']>;
  includeConfigMetadata?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type HardwareListQueryQuery = {
  __typename?: 'Query';
  virtualDevicesForNetwork: Array<
    | {
        __typename: 'AccessPointVirtualDevice';
        UUID: string;
        uptime?: string | null;
        label: string;
        description?: string | null;
        deviceType: VirtualDeviceType;
        network: { __typename?: 'Network'; UUID: string; slug: string; label: string };
        nosVersion?: {
          __typename?: 'ConfiguredNOSVersion';
          id: number;
          version: string;
          buildName: string;
        } | null;
        pendingNosVersion?: {
          __typename?: 'PendingNosVersion';
          scheduledAt: string;
          nosVersion: { __typename?: 'NosVersion'; version: string };
        } | null;
        hardwareDevice?:
          | {
              __typename: 'AccessPointHardwareDevice';
              ipAddress?: string | null;
              isInCurrentControllerMACTable: boolean;
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              isDev?: boolean;
              phyInterfaceConnectedTo?: {
                __typename?: 'PhyInterface';
                UUID: string;
                portNumber: number;
                isEthernet: boolean;
                isSFP: boolean;
                isUplink: boolean;
                isUplinkActive?: boolean | null;
                isConnected: boolean;
                portSpeedMbps?: number | null;
                maxSpeedMbps?: number | null;
                isFLIPEnabled: boolean;
                isVoiceVLANEnabled: boolean;
                sfpModuleInfo?: {
                  __typename?: 'SFPModuleInfo';
                  moduleSpeedKbps?: number | null;
                } | null;
              } | null;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
              latestDeviceConfigMetadata?: {
                __typename?: 'DeviceConfigMetadata';
                version: number;
                acknowledgedAt?: string | null;
                createdAt: string;
                isCurrentAsOf?: string | null;
                state?: {
                  __typename?: 'DeviceConfigState';
                  state: DeviceConfigStateType;
                  timestamp: string;
                } | null;
              } | null;
            }
          | {
              __typename: 'ControllerHardwareDevice';
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              isDev?: boolean;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
              latestDeviceConfigMetadata?: {
                __typename?: 'DeviceConfigMetadata';
                version: number;
                acknowledgedAt?: string | null;
                createdAt: string;
                isCurrentAsOf?: string | null;
                state?: {
                  __typename?: 'DeviceConfigState';
                  state: DeviceConfigStateType;
                  timestamp: string;
                } | null;
              } | null;
            }
          | {
              __typename: 'PowerDistributionUnitHardwareDevice';
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              isDev?: boolean;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
              latestDeviceConfigMetadata?: {
                __typename?: 'DeviceConfigMetadata';
                version: number;
                acknowledgedAt?: string | null;
                createdAt: string;
                isCurrentAsOf?: string | null;
                state?: {
                  __typename?: 'DeviceConfigState';
                  state: DeviceConfigStateType;
                  timestamp: string;
                } | null;
              } | null;
            }
          | {
              __typename: 'SwitchHardwareDevice';
              ipAddress?: string | null;
              isInCurrentControllerMACTable: boolean;
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              isDev?: boolean;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
              latestDeviceConfigMetadata?: {
                __typename?: 'DeviceConfigMetadata';
                version: number;
                acknowledgedAt?: string | null;
                createdAt: string;
                isCurrentAsOf?: string | null;
                state?: {
                  __typename?: 'DeviceConfigState';
                  state: DeviceConfigStateType;
                  timestamp: string;
                } | null;
              } | null;
            }
          | null;
      }
    | {
        __typename: 'ControllerVirtualDevice';
        UUID: string;
        uptime?: string | null;
        label: string;
        description?: string | null;
        deviceType: VirtualDeviceType;
        phyInterfaces: Array<{
          __typename?: 'PhyInterface';
          UUID: string;
          portNumber: number;
          isEthernet: boolean;
          isSFP: boolean;
          isUplink: boolean;
          isUplinkActive?: boolean | null;
          isConnected: boolean;
          portSpeedMbps?: number | null;
          maxSpeedMbps?: number | null;
          isFLIPEnabled: boolean;
          isVoiceVLANEnabled: boolean;
          sfpModuleInfo?: { __typename?: 'SFPModuleInfo'; moduleSpeedKbps?: number | null } | null;
        }>;
        network: { __typename?: 'Network'; UUID: string; slug: string; label: string };
        nosVersion?: {
          __typename?: 'ConfiguredNOSVersion';
          id: number;
          version: string;
          buildName: string;
        } | null;
        pendingNosVersion?: {
          __typename?: 'PendingNosVersion';
          scheduledAt: string;
          nosVersion: { __typename?: 'NosVersion'; version: string };
        } | null;
        hardwareDevice?:
          | {
              __typename: 'AccessPointHardwareDevice';
              ipAddress?: string | null;
              isInCurrentControllerMACTable: boolean;
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              isDev?: boolean;
              phyInterfaceConnectedTo?: {
                __typename?: 'PhyInterface';
                UUID: string;
                portNumber: number;
                isEthernet: boolean;
                isSFP: boolean;
                isUplink: boolean;
                isUplinkActive?: boolean | null;
                isConnected: boolean;
                portSpeedMbps?: number | null;
                maxSpeedMbps?: number | null;
                isFLIPEnabled: boolean;
                isVoiceVLANEnabled: boolean;
                sfpModuleInfo?: {
                  __typename?: 'SFPModuleInfo';
                  moduleSpeedKbps?: number | null;
                } | null;
              } | null;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
              latestDeviceConfigMetadata?: {
                __typename?: 'DeviceConfigMetadata';
                version: number;
                acknowledgedAt?: string | null;
                createdAt: string;
                isCurrentAsOf?: string | null;
                state?: {
                  __typename?: 'DeviceConfigState';
                  state: DeviceConfigStateType;
                  timestamp: string;
                } | null;
              } | null;
            }
          | {
              __typename: 'ControllerHardwareDevice';
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              isDev?: boolean;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
              latestDeviceConfigMetadata?: {
                __typename?: 'DeviceConfigMetadata';
                version: number;
                acknowledgedAt?: string | null;
                createdAt: string;
                isCurrentAsOf?: string | null;
                state?: {
                  __typename?: 'DeviceConfigState';
                  state: DeviceConfigStateType;
                  timestamp: string;
                } | null;
              } | null;
            }
          | {
              __typename: 'PowerDistributionUnitHardwareDevice';
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              isDev?: boolean;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
              latestDeviceConfigMetadata?: {
                __typename?: 'DeviceConfigMetadata';
                version: number;
                acknowledgedAt?: string | null;
                createdAt: string;
                isCurrentAsOf?: string | null;
                state?: {
                  __typename?: 'DeviceConfigState';
                  state: DeviceConfigStateType;
                  timestamp: string;
                } | null;
              } | null;
            }
          | {
              __typename: 'SwitchHardwareDevice';
              ipAddress?: string | null;
              isInCurrentControllerMACTable: boolean;
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              isDev?: boolean;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
              latestDeviceConfigMetadata?: {
                __typename?: 'DeviceConfigMetadata';
                version: number;
                acknowledgedAt?: string | null;
                createdAt: string;
                isCurrentAsOf?: string | null;
                state?: {
                  __typename?: 'DeviceConfigState';
                  state: DeviceConfigStateType;
                  timestamp: string;
                } | null;
              } | null;
            }
          | null;
      }
    | {
        __typename: 'ObserverVirtualDevice';
        UUID: string;
        uptime?: string | null;
        label: string;
        description?: string | null;
        deviceType: VirtualDeviceType;
        network: { __typename?: 'Network'; UUID: string; slug: string; label: string };
        nosVersion?: {
          __typename?: 'ConfiguredNOSVersion';
          id: number;
          version: string;
          buildName: string;
        } | null;
        pendingNosVersion?: {
          __typename?: 'PendingNosVersion';
          scheduledAt: string;
          nosVersion: { __typename?: 'NosVersion'; version: string };
        } | null;
        hardwareDevice?:
          | {
              __typename: 'AccessPointHardwareDevice';
              ipAddress?: string | null;
              isInCurrentControllerMACTable: boolean;
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              isDev?: boolean;
              phyInterfaceConnectedTo?: {
                __typename?: 'PhyInterface';
                UUID: string;
                portNumber: number;
                isEthernet: boolean;
                isSFP: boolean;
                isUplink: boolean;
                isUplinkActive?: boolean | null;
                isConnected: boolean;
                portSpeedMbps?: number | null;
                maxSpeedMbps?: number | null;
                isFLIPEnabled: boolean;
                isVoiceVLANEnabled: boolean;
                sfpModuleInfo?: {
                  __typename?: 'SFPModuleInfo';
                  moduleSpeedKbps?: number | null;
                } | null;
              } | null;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
              latestDeviceConfigMetadata?: {
                __typename?: 'DeviceConfigMetadata';
                version: number;
                acknowledgedAt?: string | null;
                createdAt: string;
                isCurrentAsOf?: string | null;
                state?: {
                  __typename?: 'DeviceConfigState';
                  state: DeviceConfigStateType;
                  timestamp: string;
                } | null;
              } | null;
            }
          | {
              __typename: 'ControllerHardwareDevice';
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              isDev?: boolean;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
              latestDeviceConfigMetadata?: {
                __typename?: 'DeviceConfigMetadata';
                version: number;
                acknowledgedAt?: string | null;
                createdAt: string;
                isCurrentAsOf?: string | null;
                state?: {
                  __typename?: 'DeviceConfigState';
                  state: DeviceConfigStateType;
                  timestamp: string;
                } | null;
              } | null;
            }
          | {
              __typename: 'PowerDistributionUnitHardwareDevice';
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              isDev?: boolean;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
              latestDeviceConfigMetadata?: {
                __typename?: 'DeviceConfigMetadata';
                version: number;
                acknowledgedAt?: string | null;
                createdAt: string;
                isCurrentAsOf?: string | null;
                state?: {
                  __typename?: 'DeviceConfigState';
                  state: DeviceConfigStateType;
                  timestamp: string;
                } | null;
              } | null;
            }
          | {
              __typename: 'SwitchHardwareDevice';
              ipAddress?: string | null;
              isInCurrentControllerMACTable: boolean;
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              isDev?: boolean;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
              latestDeviceConfigMetadata?: {
                __typename?: 'DeviceConfigMetadata';
                version: number;
                acknowledgedAt?: string | null;
                createdAt: string;
                isCurrentAsOf?: string | null;
                state?: {
                  __typename?: 'DeviceConfigState';
                  state: DeviceConfigStateType;
                  timestamp: string;
                } | null;
              } | null;
            }
          | null;
      }
    | {
        __typename: 'PowerDistributionUnitVirtualDevice';
        ipAddress?: string | null;
        UUID: string;
        uptime?: string | null;
        label: string;
        description?: string | null;
        deviceType: VirtualDeviceType;
        network: { __typename?: 'Network'; UUID: string; slug: string; label: string };
        nosVersion?: {
          __typename?: 'ConfiguredNOSVersion';
          id: number;
          version: string;
          buildName: string;
        } | null;
        pendingNosVersion?: {
          __typename?: 'PendingNosVersion';
          scheduledAt: string;
          nosVersion: { __typename?: 'NosVersion'; version: string };
        } | null;
        hardwareDevice?:
          | {
              __typename: 'AccessPointHardwareDevice';
              ipAddress?: string | null;
              isInCurrentControllerMACTable: boolean;
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              isDev?: boolean;
              phyInterfaceConnectedTo?: {
                __typename?: 'PhyInterface';
                UUID: string;
                portNumber: number;
                isEthernet: boolean;
                isSFP: boolean;
                isUplink: boolean;
                isUplinkActive?: boolean | null;
                isConnected: boolean;
                portSpeedMbps?: number | null;
                maxSpeedMbps?: number | null;
                isFLIPEnabled: boolean;
                isVoiceVLANEnabled: boolean;
                sfpModuleInfo?: {
                  __typename?: 'SFPModuleInfo';
                  moduleSpeedKbps?: number | null;
                } | null;
              } | null;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
              latestDeviceConfigMetadata?: {
                __typename?: 'DeviceConfigMetadata';
                version: number;
                acknowledgedAt?: string | null;
                createdAt: string;
                isCurrentAsOf?: string | null;
                state?: {
                  __typename?: 'DeviceConfigState';
                  state: DeviceConfigStateType;
                  timestamp: string;
                } | null;
              } | null;
            }
          | {
              __typename: 'ControllerHardwareDevice';
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              isDev?: boolean;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
              latestDeviceConfigMetadata?: {
                __typename?: 'DeviceConfigMetadata';
                version: number;
                acknowledgedAt?: string | null;
                createdAt: string;
                isCurrentAsOf?: string | null;
                state?: {
                  __typename?: 'DeviceConfigState';
                  state: DeviceConfigStateType;
                  timestamp: string;
                } | null;
              } | null;
            }
          | {
              __typename: 'PowerDistributionUnitHardwareDevice';
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              isDev?: boolean;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
              latestDeviceConfigMetadata?: {
                __typename?: 'DeviceConfigMetadata';
                version: number;
                acknowledgedAt?: string | null;
                createdAt: string;
                isCurrentAsOf?: string | null;
                state?: {
                  __typename?: 'DeviceConfigState';
                  state: DeviceConfigStateType;
                  timestamp: string;
                } | null;
              } | null;
            }
          | {
              __typename: 'SwitchHardwareDevice';
              ipAddress?: string | null;
              isInCurrentControllerMACTable: boolean;
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              isDev?: boolean;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
              latestDeviceConfigMetadata?: {
                __typename?: 'DeviceConfigMetadata';
                version: number;
                acknowledgedAt?: string | null;
                createdAt: string;
                isCurrentAsOf?: string | null;
                state?: {
                  __typename?: 'DeviceConfigState';
                  state: DeviceConfigStateType;
                  timestamp: string;
                } | null;
              } | null;
            }
          | null;
      }
    | {
        __typename: 'SwitchVirtualDevice';
        UUID: string;
        uptime?: string | null;
        label: string;
        description?: string | null;
        deviceType: VirtualDeviceType;
        phyInterfaces: Array<{
          __typename?: 'PhyInterface';
          UUID: string;
          portNumber: number;
          isEthernet: boolean;
          isSFP: boolean;
          isUplink: boolean;
          isUplinkActive?: boolean | null;
          isConnected: boolean;
          portSpeedMbps?: number | null;
          maxSpeedMbps?: number | null;
          isFLIPEnabled: boolean;
          isVoiceVLANEnabled: boolean;
          sfpModuleInfo?: { __typename?: 'SFPModuleInfo'; moduleSpeedKbps?: number | null } | null;
        }>;
        network: { __typename?: 'Network'; UUID: string; slug: string; label: string };
        nosVersion?: {
          __typename?: 'ConfiguredNOSVersion';
          id: number;
          version: string;
          buildName: string;
        } | null;
        pendingNosVersion?: {
          __typename?: 'PendingNosVersion';
          scheduledAt: string;
          nosVersion: { __typename?: 'NosVersion'; version: string };
        } | null;
        hardwareDevice?:
          | {
              __typename: 'AccessPointHardwareDevice';
              ipAddress?: string | null;
              isInCurrentControllerMACTable: boolean;
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              isDev?: boolean;
              phyInterfaceConnectedTo?: {
                __typename?: 'PhyInterface';
                UUID: string;
                portNumber: number;
                isEthernet: boolean;
                isSFP: boolean;
                isUplink: boolean;
                isUplinkActive?: boolean | null;
                isConnected: boolean;
                portSpeedMbps?: number | null;
                maxSpeedMbps?: number | null;
                isFLIPEnabled: boolean;
                isVoiceVLANEnabled: boolean;
                sfpModuleInfo?: {
                  __typename?: 'SFPModuleInfo';
                  moduleSpeedKbps?: number | null;
                } | null;
              } | null;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
              latestDeviceConfigMetadata?: {
                __typename?: 'DeviceConfigMetadata';
                version: number;
                acknowledgedAt?: string | null;
                createdAt: string;
                isCurrentAsOf?: string | null;
                state?: {
                  __typename?: 'DeviceConfigState';
                  state: DeviceConfigStateType;
                  timestamp: string;
                } | null;
              } | null;
            }
          | {
              __typename: 'ControllerHardwareDevice';
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              isDev?: boolean;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
              latestDeviceConfigMetadata?: {
                __typename?: 'DeviceConfigMetadata';
                version: number;
                acknowledgedAt?: string | null;
                createdAt: string;
                isCurrentAsOf?: string | null;
                state?: {
                  __typename?: 'DeviceConfigState';
                  state: DeviceConfigStateType;
                  timestamp: string;
                } | null;
              } | null;
            }
          | {
              __typename: 'PowerDistributionUnitHardwareDevice';
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              isDev?: boolean;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
              latestDeviceConfigMetadata?: {
                __typename?: 'DeviceConfigMetadata';
                version: number;
                acknowledgedAt?: string | null;
                createdAt: string;
                isCurrentAsOf?: string | null;
                state?: {
                  __typename?: 'DeviceConfigState';
                  state: DeviceConfigStateType;
                  timestamp: string;
                } | null;
              } | null;
            }
          | {
              __typename: 'SwitchHardwareDevice';
              ipAddress?: string | null;
              isInCurrentControllerMACTable: boolean;
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              isDev?: boolean;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
              latestDeviceConfigMetadata?: {
                __typename?: 'DeviceConfigMetadata';
                version: number;
                acknowledgedAt?: string | null;
                createdAt: string;
                isCurrentAsOf?: string | null;
                state?: {
                  __typename?: 'DeviceConfigState';
                  state: DeviceConfigStateType;
                  timestamp: string;
                } | null;
              } | null;
            }
          | null;
      }
  >;
};

export type PhyInterfaceFieldsFragment = {
  __typename?: 'PhyInterface';
  UUID: string;
  portNumber: number;
  isEthernet: boolean;
  isSFP: boolean;
  isUplink: boolean;
  isUplinkActive?: boolean | null;
  isConnected: boolean;
  portSpeedMbps?: number | null;
  maxSpeedMbps?: number | null;
  isFLIPEnabled: boolean;
  isVoiceVLANEnabled: boolean;
  sfpModuleInfo?: { __typename?: 'SFPModuleInfo'; moduleSpeedKbps?: number | null } | null;
};

type HardwareDeviceFields_AccessPointHardwareDevice_Fragment = {
  __typename: 'AccessPointHardwareDevice';
  ipAddress?: string | null;
  isInCurrentControllerMACTable: boolean;
  deviceType: DeviceType;
  serialNumber: string;
  macAddress?: string | null;
  isActive: boolean;
  isConnectedToBackend: boolean;
  disconnectedFromBackendAt?: string | null;
  isDev?: boolean;
  phyInterfaceConnectedTo?: {
    __typename?: 'PhyInterface';
    UUID: string;
    portNumber: number;
    isEthernet: boolean;
    isSFP: boolean;
    isUplink: boolean;
    isUplinkActive?: boolean | null;
    isConnected: boolean;
    portSpeedMbps?: number | null;
    maxSpeedMbps?: number | null;
    isFLIPEnabled: boolean;
    isVoiceVLANEnabled: boolean;
    sfpModuleInfo?: { __typename?: 'SFPModuleInfo'; moduleSpeedKbps?: number | null } | null;
  } | null;
  bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
  latestDeviceConfigMetadata?: {
    __typename?: 'DeviceConfigMetadata';
    version: number;
    acknowledgedAt?: string | null;
    createdAt: string;
    isCurrentAsOf?: string | null;
    state?: {
      __typename?: 'DeviceConfigState';
      state: DeviceConfigStateType;
      timestamp: string;
    } | null;
  } | null;
};

type HardwareDeviceFields_ControllerHardwareDevice_Fragment = {
  __typename: 'ControllerHardwareDevice';
  deviceType: DeviceType;
  serialNumber: string;
  macAddress?: string | null;
  isActive: boolean;
  isConnectedToBackend: boolean;
  disconnectedFromBackendAt?: string | null;
  isDev?: boolean;
  bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
  latestDeviceConfigMetadata?: {
    __typename?: 'DeviceConfigMetadata';
    version: number;
    acknowledgedAt?: string | null;
    createdAt: string;
    isCurrentAsOf?: string | null;
    state?: {
      __typename?: 'DeviceConfigState';
      state: DeviceConfigStateType;
      timestamp: string;
    } | null;
  } | null;
};

type HardwareDeviceFields_PowerDistributionUnitHardwareDevice_Fragment = {
  __typename: 'PowerDistributionUnitHardwareDevice';
  deviceType: DeviceType;
  serialNumber: string;
  macAddress?: string | null;
  isActive: boolean;
  isConnectedToBackend: boolean;
  disconnectedFromBackendAt?: string | null;
  isDev?: boolean;
  bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
  latestDeviceConfigMetadata?: {
    __typename?: 'DeviceConfigMetadata';
    version: number;
    acknowledgedAt?: string | null;
    createdAt: string;
    isCurrentAsOf?: string | null;
    state?: {
      __typename?: 'DeviceConfigState';
      state: DeviceConfigStateType;
      timestamp: string;
    } | null;
  } | null;
};

type HardwareDeviceFields_SwitchHardwareDevice_Fragment = {
  __typename: 'SwitchHardwareDevice';
  ipAddress?: string | null;
  isInCurrentControllerMACTable: boolean;
  deviceType: DeviceType;
  serialNumber: string;
  macAddress?: string | null;
  isActive: boolean;
  isConnectedToBackend: boolean;
  disconnectedFromBackendAt?: string | null;
  isDev?: boolean;
  bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
  latestDeviceConfigMetadata?: {
    __typename?: 'DeviceConfigMetadata';
    version: number;
    acknowledgedAt?: string | null;
    createdAt: string;
    isCurrentAsOf?: string | null;
    state?: {
      __typename?: 'DeviceConfigState';
      state: DeviceConfigStateType;
      timestamp: string;
    } | null;
  } | null;
};

export type HardwareDeviceFieldsFragment =
  | HardwareDeviceFields_AccessPointHardwareDevice_Fragment
  | HardwareDeviceFields_ControllerHardwareDevice_Fragment
  | HardwareDeviceFields_PowerDistributionUnitHardwareDevice_Fragment
  | HardwareDeviceFields_SwitchHardwareDevice_Fragment;

export type HubNetworksOverviewQueryVariables = Exact<{
  companySlug: Scalars['String']['input'];
}>;

export type HubNetworksOverviewQuery = {
  __typename?: 'Query';
  networksForCompany: Array<{
    __typename?: 'Network';
    slug: string;
    label: string;
    UUID: string;
    isActive: boolean;
    isTemplate: boolean;
    isCustomer: boolean;
    isTrial: boolean;
    deactivatedAt?: string | null;
    mailingAddress?: {
      __typename?: 'MailingAddress';
      line1?: string | null;
      line2?: string | null;
      city?: string | null;
      subdivisionCode?: string | null;
      postalCode?: string | null;
      countryISO2?: string | null;
      timezone: string;
      coordinates?: { __typename?: 'Coordinates'; latitude: number; longitude: number } | null;
    } | null;
    virtualDevices: Array<
      | {
          __typename: 'AccessPointVirtualDevice';
          UUID: string;
          deviceType: VirtualDeviceType;
          hardwareDevice?:
            | {
                __typename?: 'AccessPointHardwareDevice';
                isActive: boolean;
                isConnectedToBackend: boolean;
              }
            | {
                __typename?: 'ControllerHardwareDevice';
                isActive: boolean;
                isConnectedToBackend: boolean;
              }
            | {
                __typename?: 'PowerDistributionUnitHardwareDevice';
                isActive: boolean;
                isConnectedToBackend: boolean;
              }
            | {
                __typename?: 'SwitchHardwareDevice';
                isActive: boolean;
                isConnectedToBackend: boolean;
              }
            | null;
        }
      | {
          __typename: 'ControllerVirtualDevice';
          UUID: string;
          deviceType: VirtualDeviceType;
          phyInterfaces: Array<{
            __typename: 'PhyInterface';
            isUplink: boolean;
            UUID: string;
            portNumber: number;
            label?: string | null;
            hardwareLabel?: string | null;
            virtualDevice:
              | {
                  __typename?: 'AccessPointVirtualDevice';
                  UUID: string;
                  label: string;
                  deviceModel: DeviceModel;
                }
              | {
                  __typename?: 'ControllerVirtualDevice';
                  UUID: string;
                  label: string;
                  deviceModel: DeviceModel;
                }
              | {
                  __typename?: 'ObserverVirtualDevice';
                  UUID: string;
                  label: string;
                  deviceModel: DeviceModel;
                }
              | {
                  __typename?: 'PowerDistributionUnitVirtualDevice';
                  UUID: string;
                  label: string;
                  deviceModel: DeviceModel;
                }
              | {
                  __typename?: 'SwitchVirtualDevice';
                  UUID: string;
                  label: string;
                  deviceModel: DeviceModel;
                };
            internetServicePlan?: {
              __typename?: 'InternetServicePlan';
              UUID: string;
              provider?: { __typename?: 'InternetServicePlanProvider'; name: string } | null;
            } | null;
          }>;
          hardwareDevice?:
            | {
                __typename?: 'AccessPointHardwareDevice';
                isActive: boolean;
                isConnectedToBackend: boolean;
              }
            | {
                __typename?: 'ControllerHardwareDevice';
                isActive: boolean;
                isConnectedToBackend: boolean;
              }
            | {
                __typename?: 'PowerDistributionUnitHardwareDevice';
                isActive: boolean;
                isConnectedToBackend: boolean;
              }
            | {
                __typename?: 'SwitchHardwareDevice';
                isActive: boolean;
                isConnectedToBackend: boolean;
              }
            | null;
        }
      | {
          __typename: 'ObserverVirtualDevice';
          UUID: string;
          deviceType: VirtualDeviceType;
          hardwareDevice?:
            | {
                __typename?: 'AccessPointHardwareDevice';
                isActive: boolean;
                isConnectedToBackend: boolean;
              }
            | {
                __typename?: 'ControllerHardwareDevice';
                isActive: boolean;
                isConnectedToBackend: boolean;
              }
            | {
                __typename?: 'PowerDistributionUnitHardwareDevice';
                isActive: boolean;
                isConnectedToBackend: boolean;
              }
            | {
                __typename?: 'SwitchHardwareDevice';
                isActive: boolean;
                isConnectedToBackend: boolean;
              }
            | null;
        }
      | {
          __typename: 'PowerDistributionUnitVirtualDevice';
          UUID: string;
          deviceType: VirtualDeviceType;
          hardwareDevice?:
            | {
                __typename?: 'AccessPointHardwareDevice';
                isActive: boolean;
                isConnectedToBackend: boolean;
              }
            | {
                __typename?: 'ControllerHardwareDevice';
                isActive: boolean;
                isConnectedToBackend: boolean;
              }
            | {
                __typename?: 'PowerDistributionUnitHardwareDevice';
                isActive: boolean;
                isConnectedToBackend: boolean;
              }
            | {
                __typename?: 'SwitchHardwareDevice';
                isActive: boolean;
                isConnectedToBackend: boolean;
              }
            | null;
        }
      | {
          __typename: 'SwitchVirtualDevice';
          UUID: string;
          deviceType: VirtualDeviceType;
          hardwareDevice?:
            | {
                __typename?: 'AccessPointHardwareDevice';
                isActive: boolean;
                isConnectedToBackend: boolean;
              }
            | {
                __typename?: 'ControllerHardwareDevice';
                isActive: boolean;
                isConnectedToBackend: boolean;
              }
            | {
                __typename?: 'PowerDistributionUnitHardwareDevice';
                isActive: boolean;
                isConnectedToBackend: boolean;
              }
            | {
                __typename?: 'SwitchHardwareDevice';
                isActive: boolean;
                isConnectedToBackend: boolean;
              }
            | null;
        }
    >;
  }>;
};

export type UptimeStatsForNetworksQueryVariables = Exact<{
  networkUUIDs: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
  lookBack: Scalars['Int']['input'];
  stepSeconds: Scalars['Int']['input'];
}>;

export type UptimeStatsForNetworksQuery = {
  __typename?: 'Query';
  networksUplinkQualities: Array<{
    __typename?: 'NetworkUplinkQualityResponse';
    values: Array<{
      __typename?: 'NetworkUplinkQualityValue';
      phyInterfaceUUID: string;
      timestamp: string;
      value: number;
    }>;
  }>;
};

export type ApUptimeQueryVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
  filter: MetricsFilterInput;
}>;

export type ApUptimeQuery = {
  __typename?: 'Query';
  apUptime: {
    __typename?: 'APUptimeResponse';
    metadata?: { __typename?: 'MetricsMetadata'; minValue: number; maxValue: number } | null;
    values: Array<{
      __typename?: 'APUptimeMetricsValue';
      timestamp: string;
      value: number;
      apName: string;
    }>;
  };
};

export type ClientMetricsQueryVariables = Exact<{
  serialNumber: Scalars['String']['input'];
  filter: MetricsFilterInput;
}>;

export type ClientMetricsQuery = {
  __typename?: 'Query';
  clientMetrics: {
    __typename?: 'ClientMetricsResponse';
    metadata?: {
      __typename?: 'ClientMetricsMetadata';
      signal?: { __typename?: 'MetricsMetadata'; minValue: number; maxValue: number } | null;
      noise?: { __typename?: 'MetricsMetadata'; minValue: number; maxValue: number } | null;
      tx?: { __typename?: 'MetricsMetadata'; minValue: number; maxValue: number } | null;
      rx?: { __typename?: 'MetricsMetadata'; minValue: number; maxValue: number } | null;
    } | null;
    values: Array<{
      __typename?: 'ClientMetricsValue';
      timestamp: string;
      macAddress: string;
      signal: number;
      noise: number;
      txRate: number;
      rxRate: number;
    }>;
  };
};

export type RpcDisconnectClientMutationVariables = Exact<{
  mac: Scalars['String']['input'];
  serialNumber: Scalars['String']['input'];
  ssid: Scalars['String']['input'];
}>;

export type RpcDisconnectClientMutation = {
  __typename?: 'Mutation';
  rpcWosDisconnectClient: boolean;
};

export type GetCpEsQueryVariables = Exact<{
  filter: CpEsFilterInput;
}>;

export type GetCpEsQuery = {
  __typename?: 'Query';
  cpes: Array<{
    __typename?: 'CPE';
    UUID: string;
    part: string;
    vendor: string;
    product: string;
    version?: string | null;
    uri: string;
  }>;
};

export type CreateNetworkClientCpeBindingMutationVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
  inputs: Array<CreateNetworkClientCpeBindingInput> | CreateNetworkClientCpeBindingInput;
}>;

export type CreateNetworkClientCpeBindingMutation = {
  __typename?: 'Mutation';
  createNetworkClientCPEBindings: Array<{ __typename?: 'NetworkClientCPEBinding'; UUID: string }>;
};

export type GetNetworkClientCpeBindingsQueryVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
  macAddress: Scalars['MacAddress']['input'];
}>;

export type GetNetworkClientCpeBindingsQuery = {
  __typename?: 'Query';
  networkClientCPEBindingsForNetwork: Array<{
    __typename?: 'NetworkClientCPEBinding';
    UUID: string;
    macAddress: string;
    cpe: {
      __typename?: 'CPE';
      UUID: string;
      part: string;
      product: string;
      vendor: string;
      version?: string | null;
      uri: string;
    };
  } | null>;
};

export type DeleteNetworkClientCpeBindingsMutationVariables = Exact<{
  UUIDs: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
}>;

export type DeleteNetworkClientCpeBindingsMutation = {
  __typename?: 'Mutation';
  deleteNetworkClientCPEBindings: Array<{ __typename?: 'NetworkClientCPEBinding'; UUID: string }>;
};

export type GetCveQueryVariables = Exact<{
  cveID: Scalars['String']['input'];
}>;

export type GetCveQuery = {
  __typename?: 'Query';
  cve: {
    __typename?: 'CVE';
    ID: string;
    source?: string | null;
    title?: string | null;
    description?: string | null;
    baseSeverity?: CveSeverity | null;
    externalPublishedAt?: string | null;
  };
};

export type AllCvEsForNetworkQueryVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
}>;

export type AllCvEsForNetworkQuery = {
  __typename?: 'Query';
  allCVEsForNetwork: Array<{
    __typename?: 'CVE';
    ID: string;
    source?: string | null;
    title?: string | null;
    description?: string | null;
    baseSeverity?: CveSeverity | null;
    externalPublishedAt?: string | null;
  }>;
};

export type AffectedClientsByCveiDsQueryVariables = Exact<{
  cveIDs: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;

export type AffectedClientsByCveiDsQuery = {
  __typename?: 'Query';
  affectedClientsByCVEIDs: Array<{
    __typename?: 'AffectedClient';
    cveID: string;
    macAddress: string;
    networkUUID: string;
  }>;
};

export type GetClientsCpeBindingsQueryVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
}>;

export type GetClientsCpeBindingsQuery = {
  __typename?: 'Query';
  networkClientCPEBindingsForNetwork: Array<{
    __typename?: 'NetworkClientCPEBinding';
    UUID: string;
    macAddress: string;
    cpe: {
      __typename?: 'CPE';
      UUID: string;
      part: string;
      product: string;
      vendor: string;
      version?: string | null;
      uri: string;
    };
  } | null>;
};

export type BlockClientsInNetworkMutationVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
  macAddresses?: InputMaybe<Array<Scalars['MacAddress']['input']> | Scalars['MacAddress']['input']>;
  ouis?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;

export type BlockClientsInNetworkMutation = {
  __typename?: 'Mutation';
  blockClientsInNetwork: Array<{
    __typename?: 'NetworkClientBlocklistEntry';
    uuid?: string | null;
    networkUUID: string;
    macAddress?: string | null;
    oui?: string | null;
    createdAt?: string | null;
  }>;
};

export type UnblockClientsInNetworkMutationVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
  macAddresses?: InputMaybe<Array<Scalars['MacAddress']['input']> | Scalars['MacAddress']['input']>;
  ouis?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;

export type UnblockClientsInNetworkMutation = {
  __typename?: 'Mutation';
  unblockClientsInNetwork: Array<{
    __typename?: 'NetworkClientBlocklistEntry';
    uuid?: string | null;
    networkUUID: string;
    macAddress?: string | null;
    oui?: string | null;
    createdAt?: string | null;
  }>;
};

export type BlockedClientsForNetworkQueryVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
}>;

export type BlockedClientsForNetworkQuery = {
  __typename?: 'Query';
  blockedClientsForNetwork: Array<{
    __typename?: 'NetworkClientBlocklistEntry';
    uuid?: string | null;
    networkUUID: string;
    macAddress?: string | null;
    oui?: string | null;
    createdAt?: string | null;
  }>;
};

type BaseMetricsResponseFields_ApChannelUtilizationResponse_Fragment = {
  __typename?: 'APChannelUtilizationResponse';
  metadata?: { __typename?: 'MetricsMetadata'; minValue: number; maxValue: number } | null;
  values: Array<{
    __typename?: 'APChannelUtilizationMetricsValue';
    timestamp: string;
    value: number;
  }>;
};

type BaseMetricsResponseFields_ApUptimeResponse_Fragment = {
  __typename?: 'APUptimeResponse';
  metadata?: { __typename?: 'MetricsMetadata'; minValue: number; maxValue: number } | null;
  values: Array<{ __typename?: 'APUptimeMetricsValue'; timestamp: string; value: number }>;
};

type BaseMetricsResponseFields_ActiveClientsMetricsResponse_Fragment = {
  __typename?: 'ActiveClientsMetricsResponse';
  metadata?: { __typename?: 'MetricsMetadata'; minValue: number; maxValue: number } | null;
  values: Array<{ __typename?: 'ActiveClientsMetricsValue'; timestamp: string; value: number }>;
};

type BaseMetricsResponseFields_BaseMetricsResponse_Fragment = {
  __typename?: 'BaseMetricsResponse';
  metadata?: { __typename?: 'MetricsMetadata'; minValue: number; maxValue: number } | null;
  values: Array<{ __typename?: 'BaseMetricsValue'; timestamp: string; value: number }>;
};

type BaseMetricsResponseFields_ControllerDhcpUptimeResponse_Fragment = {
  __typename?: 'ControllerDHCPUptimeResponse';
  metadata?: { __typename?: 'MetricsMetadata'; minValue: number; maxValue: number } | null;
  values: Array<{
    __typename?: 'ControllerDHCPUptimeMetricsValue';
    timestamp: string;
    value: number;
  }>;
};

type BaseMetricsResponseFields_HostMonitoringResponse_Fragment = {
  __typename?: 'HostMonitoringResponse';
  metadata: { __typename?: 'MetricsMetadata'; minValue: number; maxValue: number };
  values: Array<{ __typename?: 'HostMonitoringValue'; timestamp: string; value: number }>;
};

type BaseMetricsResponseFields_NetworkUplinkQualityResponse_Fragment = {
  __typename?: 'NetworkUplinkQualityResponse';
  metadata?: { __typename?: 'MetricsMetadata'; minValue: number; maxValue: number } | null;
  values: Array<{ __typename?: 'NetworkUplinkQualityValue'; timestamp: string; value: number }>;
};

type BaseMetricsResponseFields_NetworkUplinkThroughputMetricsResponse_Fragment = {
  __typename?: 'NetworkUplinkThroughputMetricsResponse';
  metadata?: { __typename?: 'MetricsMetadata'; minValue: number; maxValue: number } | null;
  values: Array<{
    __typename?: 'NetworkUplinkThroughputMetricsValue';
    timestamp: string;
    value: number;
  }>;
};

type BaseMetricsResponseFields_SwitchMetricsResponse_Fragment = {
  __typename?: 'SwitchMetricsResponse';
  metadata?: { __typename?: 'MetricsMetadata'; minValue: number; maxValue: number } | null;
  values: Array<{ __typename?: 'SwitchPortMetricsValue'; timestamp: string; value: number }>;
};

export type BaseMetricsResponseFieldsFragment =
  | BaseMetricsResponseFields_ApChannelUtilizationResponse_Fragment
  | BaseMetricsResponseFields_ApUptimeResponse_Fragment
  | BaseMetricsResponseFields_ActiveClientsMetricsResponse_Fragment
  | BaseMetricsResponseFields_BaseMetricsResponse_Fragment
  | BaseMetricsResponseFields_ControllerDhcpUptimeResponse_Fragment
  | BaseMetricsResponseFields_HostMonitoringResponse_Fragment
  | BaseMetricsResponseFields_NetworkUplinkQualityResponse_Fragment
  | BaseMetricsResponseFields_NetworkUplinkThroughputMetricsResponse_Fragment
  | BaseMetricsResponseFields_SwitchMetricsResponse_Fragment;

export type ClientMetricsTimeseriesResponseQueryVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
  macAddress: Scalars['MacAddress']['input'];
  filter: AllClientMetricsTimeseriesFilterInput;
}>;

export type ClientMetricsTimeseriesResponseQuery = {
  __typename?: 'Query';
  allClientMetricsByClient: {
    __typename?: 'AllClientMetricsTimeseriesResponse';
    rxBytes: {
      __typename?: 'BaseMetricsResponse';
      metadata?: { __typename?: 'MetricsMetadata'; minValue: number; maxValue: number } | null;
      values: Array<{ __typename?: 'BaseMetricsValue'; timestamp: string; value: number }>;
    };
    txBytes: {
      __typename?: 'BaseMetricsResponse';
      metadata?: { __typename?: 'MetricsMetadata'; minValue: number; maxValue: number } | null;
      values: Array<{ __typename?: 'BaseMetricsValue'; timestamp: string; value: number }>;
    };
  };
};

export type WirelessClientMetricsByClientQueryQueryVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
  macAddress: Scalars['MacAddress']['input'];
  filter: ClientMetricsTimeseriesFilterInput;
}>;

export type WirelessClientMetricsByClientQueryQuery = {
  __typename?: 'Query';
  wirelessClientMetricsByClient: {
    __typename?: 'ClientMetricsTimeseriesResponse';
    metadata?: {
      __typename?: 'ClientMetricsMetadata';
      signal?: { __typename?: 'MetricsMetadata'; minValue: number; maxValue: number } | null;
      noise?: { __typename?: 'MetricsMetadata'; minValue: number; maxValue: number } | null;
      txBytes?: { __typename?: 'MetricsMetadata'; minValue: number; maxValue: number } | null;
      rxBytes?: { __typename?: 'MetricsMetadata'; minValue: number; maxValue: number } | null;
    } | null;
    values: Array<{
      __typename?: 'ClientMetricsTimeseriesValue';
      timestamp: string;
      signal: number;
      noise: number;
      txRate: number;
      rxRate: number;
      snr: number;
      txBytes: number;
      rxBytes: number;
      txMulticastBytes: number;
      rxMulticastBytes: number;
      txUnicastBytes: number;
      rxUnicastBytes: number;
      rxSuccessRatio?: number | null;
      txSuccessRatio?: number | null;
      rxRetryRatio?: number | null;
      txRetryRatio?: number | null;
      clientCount: number;
    }>;
  };
};

export type CountCvEsBySeverityForMacAddressesBulkQueryQueryVariables = Exact<{
  input: Array<CvEsByNetworkMacAddressesInput> | CvEsByNetworkMacAddressesInput;
}>;

export type CountCvEsBySeverityForMacAddressesBulkQueryQuery = {
  __typename?: 'Query';
  countCVEsBySeverityForMACAddressesBulk: Array<{
    __typename?: 'BulkCVESeverityCountResult';
    networkUUID: string;
    macAddress: string;
    counts: Array<{ __typename?: 'CVESeverityCount'; baseSeverity: CveSeverity; count: number }>;
  }>;
};

export type ClientChannelUtilizationQueryQueryVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
  macAddress: Scalars['MacAddress']['input'];
  filter: ChannelUtilizationTimeseriesFilterInput;
}>;

export type ClientChannelUtilizationQueryQuery = {
  __typename?: 'Query';
  channelUtilizationByClient: Array<{
    __typename?: 'ClientChannelUtilizationTimeseriesValue';
    timestamp: string;
    totalUtilization: number;
  }>;
};

export type UpsertMacAddressAliasMutationVariables = Exact<{
  companySlug: Scalars['String']['input'];
  macAddress: Scalars['MacAddress']['input'];
  alias: Scalars['String']['input'];
}>;

export type UpsertMacAddressAliasMutation = {
  __typename?: 'Mutation';
  upsertMACAddressAlias: { __typename?: 'MACAddressAlias'; alias: string };
};

export type HostMonitoringQueryVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
  virtualDeviceUUID?: InputMaybe<Scalars['UUID']['input']>;
  hostIPs?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  durationSeconds: Scalars['Int']['input'];
  stepSeconds: Scalars['Int']['input'];
}>;

export type HostMonitoringQuery = {
  __typename?: 'Query';
  hostMonitoringForNetwork: Array<{
    __typename?: 'HostMonitoringResponse';
    values: Array<{
      __typename?: 'HostMonitoringValue';
      hostIPAddr: string;
      timestamp: string;
      value: number;
      status: HostMonitoringStatus;
      statusValue: number;
      countOk: number;
      countFailed: number;
      countTimeout: number;
      virtualDevice:
        | { __typename?: 'AccessPointVirtualDevice'; UUID: string; label: string }
        | { __typename?: 'ControllerVirtualDevice'; UUID: string; label: string }
        | { __typename?: 'ObserverVirtualDevice'; UUID: string; label: string }
        | { __typename?: 'PowerDistributionUnitVirtualDevice'; UUID: string; label: string }
        | { __typename?: 'SwitchVirtualDevice'; UUID: string; label: string };
      srcPhyInterface: {
        __typename: 'PhyInterface';
        UUID: string;
        portNumber: number;
        label?: string | null;
        hardwareLabel?: string | null;
        virtualDevice:
          | {
              __typename?: 'AccessPointVirtualDevice';
              UUID: string;
              label: string;
              deviceModel: DeviceModel;
            }
          | {
              __typename?: 'ControllerVirtualDevice';
              UUID: string;
              label: string;
              deviceModel: DeviceModel;
            }
          | {
              __typename?: 'ObserverVirtualDevice';
              UUID: string;
              label: string;
              deviceModel: DeviceModel;
            }
          | {
              __typename?: 'PowerDistributionUnitVirtualDevice';
              UUID: string;
              label: string;
              deviceModel: DeviceModel;
            }
          | {
              __typename?: 'SwitchVirtualDevice';
              UUID: string;
              label: string;
              deviceModel: DeviceModel;
            };
        internetServicePlan?: {
          __typename?: 'InternetServicePlan';
          UUID: string;
          provider?: { __typename?: 'InternetServicePlanProvider'; name: string } | null;
        } | null;
      };
    }>;
  }>;
};

export type HostMonitoringTargetFieldsFragment = {
  __typename?: 'HostMonitoringTarget';
  UUID: string;
  description?: string | null;
  isEnabled: boolean;
  targetHost: string;
  type: HostMonitoringType;
  isUsedForWANFailover: boolean;
};

export type HostMonitoringTargetQueryVariables = Exact<{
  uuid: Scalars['UUID']['input'];
}>;

export type HostMonitoringTargetQuery = {
  __typename?: 'Query';
  hostMonitoringTarget: {
    __typename?: 'HostMonitoringTarget';
    UUID: string;
    description?: string | null;
    isEnabled: boolean;
    targetHost: string;
    type: HostMonitoringType;
    isUsedForWANFailover: boolean;
  };
};

export type HostMonitoringTargetsQueryVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
}>;

export type HostMonitoringTargetsQuery = {
  __typename?: 'Query';
  hostMonitoringTargetsForNetwork: Array<{
    __typename?: 'HostMonitoringTarget';
    UUID: string;
    description?: string | null;
    isEnabled: boolean;
    targetHost: string;
    type: HostMonitoringType;
    isUsedForWANFailover: boolean;
  }>;
};

export type CreateHostMonitoringTargetMutationVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
  input: CreateHostMonitoringTargetInput;
}>;

export type CreateHostMonitoringTargetMutation = {
  __typename?: 'Mutation';
  createHostMonitoringTarget: { __typename?: 'HostMonitoringTarget'; UUID: string };
};

export type UpdateHostMonitoringTargetMutationVariables = Exact<{
  uuid: Scalars['UUID']['input'];
  input: UpdateHostMonitoringTargetInput;
}>;

export type UpdateHostMonitoringTargetMutation = {
  __typename?: 'Mutation';
  updateHostMonitoringTarget: { __typename?: 'HostMonitoringTarget'; UUID: string };
};

export type DeleteHostMonitoringTargetMutationVariables = Exact<{
  uuid: Scalars['UUID']['input'];
}>;

export type DeleteHostMonitoringTargetMutation = {
  __typename?: 'Mutation';
  deleteHostMonitoringTarget: { __typename?: 'HostMonitoringTarget'; UUID: string };
};

export type ActiveClientsQueryVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
  filter: MetricsFilterInput;
  input?: InputMaybe<ActiveClientsInput>;
}>;

export type ActiveClientsQuery = {
  __typename?: 'Query';
  activeClients: {
    __typename?: 'ActiveClientsMetricsResponse';
    wired: Array<{ __typename?: 'ActiveClientsMetricsValue'; timestamp: string; value: number }>;
    wireless: Array<{ __typename?: 'ActiveClientsMetricsValue'; timestamp: string; value: number }>;
  };
};

export type NetworkUplinkQualityQueryVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
  filter: MetricsFilterInput;
}>;

export type NetworkUplinkQualityQuery = {
  __typename?: 'Query';
  networkUplinkQuality: {
    __typename?: 'NetworkUplinkQualityResponse';
    values: Array<{
      __typename?: 'NetworkUplinkQualityValue';
      timestamp: string;
      value: number;
      phyInterfaceUUID: string;
    }>;
  };
};

export type NetworkUplinkThroughputQueryVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
  filter: MetricsFilterInput;
}>;

export type NetworkUplinkThroughputQuery = {
  __typename?: 'Query';
  networkUplinkThroughput: {
    __typename?: 'NetworkUplinkThroughputMetricsResponse';
    values: Array<{
      __typename?: 'NetworkUplinkThroughputMetricsValue';
      timestamp: string;
      value: number;
      direction: TrafficDirection;
      phyInterfaceUUID: string;
    }>;
  };
};

export type ApChannelUtilizationQueryVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
  filter: MetricsFilterInput;
}>;

export type ApChannelUtilizationQuery = {
  __typename?: 'Query';
  band2G: {
    __typename?: 'APChannelUtilizationResponse';
    metadata?: { __typename?: 'MetricsMetadata'; minValue: number; maxValue: number } | null;
    values: Array<{
      __typename?: 'APChannelUtilizationMetricsValue';
      apName: string;
      timestamp: string;
      value: number;
    }>;
  };
  band5G: {
    __typename?: 'APChannelUtilizationResponse';
    metadata?: { __typename?: 'MetricsMetadata'; minValue: number; maxValue: number } | null;
    values: Array<{
      __typename?: 'APChannelUtilizationMetricsValue';
      apName: string;
      timestamp: string;
      value: number;
    }>;
  };
};

export type ConnectionEventFieldsFragment = {
  __typename?: 'WirelessClientConnectionEvent';
  timestamp: string;
  band: RadioBand;
  eventType: WirelessClientConnectionEventType;
  failedStep?: WirelessClientConnectionFailedStep | null;
  reasonCode?: number | null;
  sessionDuration?: string | null;
  timeToConnect?: string | null;
  is80211rRoam: boolean;
  isObserver: boolean;
  isSteeringRejection: boolean;
  instigator?: WirelessClientConnectionEventInstigator | null;
  macAddress: string;
  rssi: number;
  ssid?: { __typename?: 'SSID'; UUID: string; ssid: string } | null;
  virtualDevice?: { __typename?: 'AccessPointVirtualDevice'; UUID: string; label: string } | null;
  previousVirtualDeviceConnectedTo?: {
    __typename?: 'AccessPointVirtualDevice';
    UUID: string;
    label: string;
  } | null;
};

export type WirelessConnectionEventsByClientQueryQueryVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
  mac: Scalars['MacAddress']['input'];
  filter: ClientMetricsTimeseriesFilterInput;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;

export type WirelessConnectionEventsByClientQueryQuery = {
  __typename?: 'Query';
  wirelessClientConnectionEventsByClient: Array<{
    __typename?: 'WirelessClientConnectionEvent';
    timestamp: string;
    band: RadioBand;
    eventType: WirelessClientConnectionEventType;
    failedStep?: WirelessClientConnectionFailedStep | null;
    reasonCode?: number | null;
    sessionDuration?: string | null;
    timeToConnect?: string | null;
    is80211rRoam: boolean;
    isObserver: boolean;
    isSteeringRejection: boolean;
    instigator?: WirelessClientConnectionEventInstigator | null;
    macAddress: string;
    rssi: number;
    ssid?: { __typename?: 'SSID'; UUID: string; ssid: string } | null;
    virtualDevice?: { __typename?: 'AccessPointVirtualDevice'; UUID: string; label: string } | null;
    previousVirtualDeviceConnectedTo?: {
      __typename?: 'AccessPointVirtualDevice';
      UUID: string;
      label: string;
    } | null;
  }>;
};

export type WirelessConnectionEventsByAccessPointQueryQueryVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
  virtualDeviceUUID: Scalars['UUID']['input'];
  filter: ClientMetricsTimeseriesFilterInput;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;

export type WirelessConnectionEventsByAccessPointQueryQuery = {
  __typename?: 'Query';
  wirelessClientConnectionEventsByAP: Array<{
    __typename?: 'WirelessClientConnectionEvent';
    timestamp: string;
    band: RadioBand;
    eventType: WirelessClientConnectionEventType;
    failedStep?: WirelessClientConnectionFailedStep | null;
    reasonCode?: number | null;
    sessionDuration?: string | null;
    timeToConnect?: string | null;
    is80211rRoam: boolean;
    isObserver: boolean;
    isSteeringRejection: boolean;
    instigator?: WirelessClientConnectionEventInstigator | null;
    macAddress: string;
    rssi: number;
    ssid?: { __typename?: 'SSID'; UUID: string; ssid: string } | null;
    virtualDevice?: { __typename?: 'AccessPointVirtualDevice'; UUID: string; label: string } | null;
    previousVirtualDeviceConnectedTo?: {
      __typename?: 'AccessPointVirtualDevice';
      UUID: string;
      label: string;
    } | null;
  }>;
};

export type WirelessConnectionEventsQueryQueryVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
  filter: ClientMetricsTimeseriesFilterInput;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;

export type WirelessConnectionEventsQueryQuery = {
  __typename?: 'Query';
  wirelessClientConnectionEvents: Array<{
    __typename?: 'WirelessClientConnectionEvent';
    timestamp: string;
    band: RadioBand;
    eventType: WirelessClientConnectionEventType;
    failedStep?: WirelessClientConnectionFailedStep | null;
    reasonCode?: number | null;
    sessionDuration?: string | null;
    timeToConnect?: string | null;
    is80211rRoam: boolean;
    isObserver: boolean;
    isSteeringRejection: boolean;
    instigator?: WirelessClientConnectionEventInstigator | null;
    macAddress: string;
    rssi: number;
    ssid?: { __typename?: 'SSID'; UUID: string; ssid: string } | null;
    virtualDevice?: { __typename?: 'AccessPointVirtualDevice'; UUID: string; label: string } | null;
    previousVirtualDeviceConnectedTo?: {
      __typename?: 'AccessPointVirtualDevice';
      UUID: string;
      label: string;
    } | null;
  }>;
};

export type NetworkForNavigationQueryVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
}>;

export type NetworkForNavigationQuery = {
  __typename?: 'Query';
  network: {
    __typename?: 'Network';
    UUID: string;
    slug: string;
    label: string;
    companySlug?: string | null;
  };
};

export type HardwareDeviceForNavigationQueryVariables = Exact<{
  serialNumber: Scalars['String']['input'];
}>;

export type HardwareDeviceForNavigationQuery = {
  __typename?: 'Query';
  hardwareDevice:
    | {
        __typename?: 'AccessPointHardwareDevice';
        serialNumber: string;
        deviceType: DeviceType;
        deviceModel: DeviceModel;
        virtualDevice?:
          | {
              __typename?: 'AccessPointVirtualDevice';
              UUID: string;
              label: string;
              description?: string | null;
              network: {
                __typename?: 'Network';
                UUID: string;
                slug: string;
                companySlug?: string | null;
              };
            }
          | {
              __typename?: 'ControllerVirtualDevice';
              UUID: string;
              label: string;
              description?: string | null;
              network: {
                __typename?: 'Network';
                UUID: string;
                slug: string;
                companySlug?: string | null;
              };
            }
          | {
              __typename?: 'ObserverVirtualDevice';
              UUID: string;
              label: string;
              description?: string | null;
              network: {
                __typename?: 'Network';
                UUID: string;
                slug: string;
                companySlug?: string | null;
              };
            }
          | {
              __typename?: 'PowerDistributionUnitVirtualDevice';
              UUID: string;
              label: string;
              description?: string | null;
              network: {
                __typename?: 'Network';
                UUID: string;
                slug: string;
                companySlug?: string | null;
              };
            }
          | {
              __typename?: 'SwitchVirtualDevice';
              UUID: string;
              label: string;
              description?: string | null;
              network: {
                __typename?: 'Network';
                UUID: string;
                slug: string;
                companySlug?: string | null;
              };
            }
          | null;
        spareDeviceNetwork?: {
          __typename?: 'Network';
          UUID: string;
          slug: string;
          companySlug?: string | null;
        } | null;
      }
    | {
        __typename?: 'ControllerHardwareDevice';
        serialNumber: string;
        deviceType: DeviceType;
        deviceModel: DeviceModel;
        virtualDevice?:
          | {
              __typename?: 'AccessPointVirtualDevice';
              UUID: string;
              label: string;
              description?: string | null;
              network: {
                __typename?: 'Network';
                UUID: string;
                slug: string;
                companySlug?: string | null;
              };
            }
          | {
              __typename?: 'ControllerVirtualDevice';
              UUID: string;
              label: string;
              description?: string | null;
              network: {
                __typename?: 'Network';
                UUID: string;
                slug: string;
                companySlug?: string | null;
              };
            }
          | {
              __typename?: 'ObserverVirtualDevice';
              UUID: string;
              label: string;
              description?: string | null;
              network: {
                __typename?: 'Network';
                UUID: string;
                slug: string;
                companySlug?: string | null;
              };
            }
          | {
              __typename?: 'PowerDistributionUnitVirtualDevice';
              UUID: string;
              label: string;
              description?: string | null;
              network: {
                __typename?: 'Network';
                UUID: string;
                slug: string;
                companySlug?: string | null;
              };
            }
          | {
              __typename?: 'SwitchVirtualDevice';
              UUID: string;
              label: string;
              description?: string | null;
              network: {
                __typename?: 'Network';
                UUID: string;
                slug: string;
                companySlug?: string | null;
              };
            }
          | null;
        spareDeviceNetwork?: {
          __typename?: 'Network';
          UUID: string;
          slug: string;
          companySlug?: string | null;
        } | null;
      }
    | {
        __typename?: 'PowerDistributionUnitHardwareDevice';
        serialNumber: string;
        deviceType: DeviceType;
        deviceModel: DeviceModel;
        virtualDevice?:
          | {
              __typename?: 'AccessPointVirtualDevice';
              UUID: string;
              label: string;
              description?: string | null;
              network: {
                __typename?: 'Network';
                UUID: string;
                slug: string;
                companySlug?: string | null;
              };
            }
          | {
              __typename?: 'ControllerVirtualDevice';
              UUID: string;
              label: string;
              description?: string | null;
              network: {
                __typename?: 'Network';
                UUID: string;
                slug: string;
                companySlug?: string | null;
              };
            }
          | {
              __typename?: 'ObserverVirtualDevice';
              UUID: string;
              label: string;
              description?: string | null;
              network: {
                __typename?: 'Network';
                UUID: string;
                slug: string;
                companySlug?: string | null;
              };
            }
          | {
              __typename?: 'PowerDistributionUnitVirtualDevice';
              UUID: string;
              label: string;
              description?: string | null;
              network: {
                __typename?: 'Network';
                UUID: string;
                slug: string;
                companySlug?: string | null;
              };
            }
          | {
              __typename?: 'SwitchVirtualDevice';
              UUID: string;
              label: string;
              description?: string | null;
              network: {
                __typename?: 'Network';
                UUID: string;
                slug: string;
                companySlug?: string | null;
              };
            }
          | null;
        spareDeviceNetwork?: {
          __typename?: 'Network';
          UUID: string;
          slug: string;
          companySlug?: string | null;
        } | null;
      }
    | {
        __typename?: 'SwitchHardwareDevice';
        serialNumber: string;
        deviceType: DeviceType;
        deviceModel: DeviceModel;
        virtualDevice?:
          | {
              __typename?: 'AccessPointVirtualDevice';
              UUID: string;
              label: string;
              description?: string | null;
              network: {
                __typename?: 'Network';
                UUID: string;
                slug: string;
                companySlug?: string | null;
              };
            }
          | {
              __typename?: 'ControllerVirtualDevice';
              UUID: string;
              label: string;
              description?: string | null;
              network: {
                __typename?: 'Network';
                UUID: string;
                slug: string;
                companySlug?: string | null;
              };
            }
          | {
              __typename?: 'ObserverVirtualDevice';
              UUID: string;
              label: string;
              description?: string | null;
              network: {
                __typename?: 'Network';
                UUID: string;
                slug: string;
                companySlug?: string | null;
              };
            }
          | {
              __typename?: 'PowerDistributionUnitVirtualDevice';
              UUID: string;
              label: string;
              description?: string | null;
              network: {
                __typename?: 'Network';
                UUID: string;
                slug: string;
                companySlug?: string | null;
              };
            }
          | {
              __typename?: 'SwitchVirtualDevice';
              UUID: string;
              label: string;
              description?: string | null;
              network: {
                __typename?: 'Network';
                UUID: string;
                slug: string;
                companySlug?: string | null;
              };
            }
          | null;
        spareDeviceNetwork?: {
          __typename?: 'Network';
          UUID: string;
          slug: string;
          companySlug?: string | null;
        } | null;
      };
};

export type CaptivePortalBodyFragment = {
  __typename: 'CaptivePortal';
  UUID: string;
  callToAction?: string | null;
  logoImageS3Key?: string | null;
  name?: string | null;
  redirectURL?: string | null;
  allowedHosts: Array<string>;
  externalPortalURL?: string | null;
  authLifetimeSec?: number | null;
  termsAndConditions?: string | null;
  webhookKey: string;
  isEnabled: boolean;
  requiresApproval: boolean;
  requiresEmail: boolean;
  requiresName: boolean;
  isCompanyScoped: boolean;
  logoImageBase64?: { __typename?: 'Base64Image'; data: string; imageType: ImageType } | null;
  vlans?: Array<{ __typename?: 'VLAN'; UUID: string; name: string; vlanID: number }> | null;
  displaySettings?: {
    __typename?: 'CaptivePortalDisplaySettings';
    backgroundColor?: string | null;
    callToActionColor?: string | null;
    fontColor?: string | null;
    hidePoweredByMeter?: boolean | null;
  } | null;
};

export type CaptivePortalQueryVariables = Exact<{
  uuid: Scalars['UUID']['input'];
}>;

export type CaptivePortalQuery = {
  __typename?: 'Query';
  captivePortal: {
    __typename: 'CaptivePortal';
    UUID: string;
    callToAction?: string | null;
    logoImageS3Key?: string | null;
    name?: string | null;
    redirectURL?: string | null;
    allowedHosts: Array<string>;
    externalPortalURL?: string | null;
    authLifetimeSec?: number | null;
    termsAndConditions?: string | null;
    webhookKey: string;
    isEnabled: boolean;
    requiresApproval: boolean;
    requiresEmail: boolean;
    requiresName: boolean;
    isCompanyScoped: boolean;
    logoImageBase64?: { __typename?: 'Base64Image'; data: string; imageType: ImageType } | null;
    vlans?: Array<{ __typename?: 'VLAN'; UUID: string; name: string; vlanID: number }> | null;
    displaySettings?: {
      __typename?: 'CaptivePortalDisplaySettings';
      backgroundColor?: string | null;
      callToActionColor?: string | null;
      fontColor?: string | null;
      hidePoweredByMeter?: boolean | null;
    } | null;
  };
};

export type CaptivePortalForNetworkQueryQueryVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
}>;

export type CaptivePortalForNetworkQueryQuery = {
  __typename?: 'Query';
  captivePortalForNetwork?: {
    __typename: 'CaptivePortal';
    UUID: string;
    callToAction?: string | null;
    logoImageS3Key?: string | null;
    name?: string | null;
    redirectURL?: string | null;
    allowedHosts: Array<string>;
    externalPortalURL?: string | null;
    authLifetimeSec?: number | null;
    termsAndConditions?: string | null;
    webhookKey: string;
    isEnabled: boolean;
    requiresApproval: boolean;
    requiresEmail: boolean;
    requiresName: boolean;
    isCompanyScoped: boolean;
    logoImageBase64?: { __typename?: 'Base64Image'; data: string; imageType: ImageType } | null;
    vlans?: Array<{ __typename?: 'VLAN'; UUID: string; name: string; vlanID: number }> | null;
    displaySettings?: {
      __typename?: 'CaptivePortalDisplaySettings';
      backgroundColor?: string | null;
      callToActionColor?: string | null;
      fontColor?: string | null;
      hidePoweredByMeter?: boolean | null;
    } | null;
  } | null;
};

export type CaptivePortalsForNetworkQueryVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
}>;

export type CaptivePortalsForNetworkQuery = {
  __typename?: 'Query';
  captivePortalsForNetwork: Array<{
    __typename: 'CaptivePortal';
    UUID: string;
    callToAction?: string | null;
    logoImageS3Key?: string | null;
    name?: string | null;
    redirectURL?: string | null;
    allowedHosts: Array<string>;
    externalPortalURL?: string | null;
    authLifetimeSec?: number | null;
    termsAndConditions?: string | null;
    webhookKey: string;
    isEnabled: boolean;
    requiresApproval: boolean;
    requiresEmail: boolean;
    requiresName: boolean;
    isCompanyScoped: boolean;
    logoImageBase64?: { __typename?: 'Base64Image'; data: string; imageType: ImageType } | null;
    vlans?: Array<{ __typename?: 'VLAN'; UUID: string; name: string; vlanID: number }> | null;
    displaySettings?: {
      __typename?: 'CaptivePortalDisplaySettings';
      backgroundColor?: string | null;
      callToActionColor?: string | null;
      fontColor?: string | null;
      hidePoweredByMeter?: boolean | null;
    } | null;
  }>;
};

export type UpdateCaptivePortalMutationVariables = Exact<{
  uuid: Scalars['UUID']['input'];
  input: CaptivePortalSettingsInput;
}>;

export type UpdateCaptivePortalMutation = {
  __typename?: 'Mutation';
  updateCaptivePortal: {
    __typename: 'CaptivePortal';
    UUID: string;
    callToAction?: string | null;
    logoImageS3Key?: string | null;
    name?: string | null;
    redirectURL?: string | null;
    allowedHosts: Array<string>;
    externalPortalURL?: string | null;
    authLifetimeSec?: number | null;
    termsAndConditions?: string | null;
    webhookKey: string;
    isEnabled: boolean;
    requiresApproval: boolean;
    requiresEmail: boolean;
    requiresName: boolean;
    isCompanyScoped: boolean;
    logoImageBase64?: { __typename?: 'Base64Image'; data: string; imageType: ImageType } | null;
    vlans?: Array<{ __typename?: 'VLAN'; UUID: string; name: string; vlanID: number }> | null;
    displaySettings?: {
      __typename?: 'CaptivePortalDisplaySettings';
      backgroundColor?: string | null;
      callToActionColor?: string | null;
      fontColor?: string | null;
      hidePoweredByMeter?: boolean | null;
    } | null;
  };
};

export type DeleteCaptivePortalMutationVariables = Exact<{
  uuid: Scalars['UUID']['input'];
}>;

export type DeleteCaptivePortalMutation = {
  __typename?: 'Mutation';
  deleteCaptivePortal: { __typename?: 'CaptivePortal'; UUID: string };
};

export type CreateCaptivePortalMutationVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
  input: CaptivePortalSettingsInput;
}>;

export type CreateCaptivePortalMutation = {
  __typename?: 'Mutation';
  createCaptivePortal: {
    __typename: 'CaptivePortal';
    UUID: string;
    callToAction?: string | null;
    logoImageS3Key?: string | null;
    name?: string | null;
    redirectURL?: string | null;
    allowedHosts: Array<string>;
    externalPortalURL?: string | null;
    authLifetimeSec?: number | null;
    termsAndConditions?: string | null;
    webhookKey: string;
    isEnabled: boolean;
    requiresApproval: boolean;
    requiresEmail: boolean;
    requiresName: boolean;
    isCompanyScoped: boolean;
    logoImageBase64?: { __typename?: 'Base64Image'; data: string; imageType: ImageType } | null;
    vlans?: Array<{ __typename?: 'VLAN'; UUID: string; name: string; vlanID: number }> | null;
    displaySettings?: {
      __typename?: 'CaptivePortalDisplaySettings';
      backgroundColor?: string | null;
      callToActionColor?: string | null;
      fontColor?: string | null;
      hidePoweredByMeter?: boolean | null;
    } | null;
  };
};

export type CapoActivityQueryQueryVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
  numHoursLookback: Scalars['Int']['input'];
}>;

export type CapoActivityQueryQuery = {
  __typename?: 'Query';
  captivePortalAuthorizedClients: Array<{
    __typename?: 'CaptivePortalClient';
    timestamp: string;
    isAuthorized: boolean;
    ipAddress: string;
    macAddress: string;
    rawUserAgent: string;
  }>;
};

export type CaptivePortalEntryBodyFragment = {
  __typename?: 'CaptivePortalEntry';
  UUID: string;
  networkUUID: string;
  ip?: string | null;
  mac?: string | null;
  email?: string | null;
  name?: string | null;
  createdAt: string;
  approvedAt?: string | null;
  deniedAt?: string | null;
  deletedAt?: string | null;
  captivePortal: { __typename?: 'CaptivePortal'; UUID: string };
  actionedBy?: {
    __typename?: 'User';
    id: string;
    firstName?: string | null;
    lastName?: string | null;
    email: string;
  } | null;
};

export type CaptivePortalEntriesForNetworkQueryQueryVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
  filter?: InputMaybe<CaptivePortalEntryFilterInput>;
}>;

export type CaptivePortalEntriesForNetworkQueryQuery = {
  __typename?: 'Query';
  captivePortalEntriesForNetwork: {
    __typename?: 'CaptivePortalEntryPage';
    total: number;
    entries: Array<{
      __typename?: 'CaptivePortalEntry';
      UUID: string;
      networkUUID: string;
      ip?: string | null;
      mac?: string | null;
      email?: string | null;
      name?: string | null;
      createdAt: string;
      approvedAt?: string | null;
      deniedAt?: string | null;
      deletedAt?: string | null;
      captivePortal: { __typename?: 'CaptivePortal'; UUID: string };
      actionedBy?: {
        __typename?: 'User';
        id: string;
        firstName?: string | null;
        lastName?: string | null;
        email: string;
      } | null;
    }>;
  };
};

export type CaptivePortalEntriesForPortalQueryQueryVariables = Exact<{
  captivePortalUUID: Scalars['UUID']['input'];
  filter?: InputMaybe<CaptivePortalEntryFilterInput>;
}>;

export type CaptivePortalEntriesForPortalQueryQuery = {
  __typename?: 'Query';
  captivePortalEntriesForPortal: {
    __typename?: 'CaptivePortalEntryPage';
    total: number;
    entries: Array<{
      __typename?: 'CaptivePortalEntry';
      UUID: string;
      networkUUID: string;
      ip?: string | null;
      mac?: string | null;
      email?: string | null;
      name?: string | null;
      createdAt: string;
      approvedAt?: string | null;
      deniedAt?: string | null;
      deletedAt?: string | null;
      captivePortal: { __typename?: 'CaptivePortal'; UUID: string };
      actionedBy?: {
        __typename?: 'User';
        id: string;
        firstName?: string | null;
        lastName?: string | null;
        email: string;
      } | null;
    }>;
  };
};

export type ActionCaptivePortalEntryMutationMutationVariables = Exact<{
  entryUUID: Scalars['UUID']['input'];
  action: CaptivePortalEntryAction;
}>;

export type ActionCaptivePortalEntryMutationMutation = {
  __typename?: 'Mutation';
  actionCaptivePortalEntry: {
    __typename?: 'CaptivePortalEntry';
    UUID: string;
    networkUUID: string;
    ip?: string | null;
    mac?: string | null;
    email?: string | null;
    name?: string | null;
    createdAt: string;
    approvedAt?: string | null;
    deniedAt?: string | null;
    deletedAt?: string | null;
    captivePortal: { __typename?: 'CaptivePortal'; UUID: string };
    actionedBy?: {
      __typename?: 'User';
      id: string;
      firstName?: string | null;
      lastName?: string | null;
      email: string;
    } | null;
  };
};

export type DeleteInternetServicePlanMutationMutationVariables = Exact<{
  internetServicePlanUUID: Scalars['UUID']['input'];
}>;

export type DeleteInternetServicePlanMutationMutation = {
  __typename?: 'Mutation';
  deleteInternetServicePlan: boolean;
};

export type CreateInternetServicePlanMutationMutationVariables = Exact<{
  companySlug: Scalars['String']['input'];
  networkUUID: Scalars['UUID']['input'];
  input: CreateInternetServicePlanInput;
}>;

export type CreateInternetServicePlanMutationMutation = {
  __typename?: 'Mutation';
  createInternetServicePlan: { __typename?: 'InternetServicePlan'; UUID: string };
};

export type UpdateInternetServicePlanMutationMutationVariables = Exact<{
  internetServicePlanUUID: Scalars['UUID']['input'];
  input: UpdateInternetServicePlanInput;
}>;

export type UpdateInternetServicePlanMutationMutation = {
  __typename?: 'Mutation';
  updateInternetServicePlan: { __typename?: 'InternetServicePlan'; UUID: string };
};

export type ProvidersQueryQueryVariables = Exact<{
  companySlug?: InputMaybe<Scalars['String']['input']>;
}>;

export type ProvidersQueryQuery = {
  __typename?: 'Query';
  internetServicePlanProviders: Array<{
    __typename?: 'InternetServicePlanProvider';
    UUID: string;
    logoURL?: string | null;
    logoS3Key?: string | null;
    iconS3Key?: string | null;
    name: string;
  }>;
};

export type ListIsPsQueryQueryVariables = Exact<{
  companySlug: Scalars['String']['input'];
  networkUUID?: InputMaybe<Scalars['UUID']['input']>;
}>;

export type ListIsPsQueryQuery = {
  __typename?: 'Query';
  internetServicePlans: Array<{
    __typename?: 'InternetServicePlan';
    UUID: string;
    connectionProduct: IspProduct;
    connectionStatus: IspStatus;
    controllerIP?: string | null;
    controllerName?: string | null;
    firstUsableIP?: string | null;
    gatewayAddr?: string | null;
    hasStaticIP: boolean;
    lastUsableIP?: string | null;
    networkUUID?: string | null;
    staticIPRange?: string | null;
    address?: {
      __typename?: 'Address';
      address1: string;
      address2: string;
      city: string;
      state: string;
      postalCode: string;
      country: string;
    } | null;
    provider?: {
      __typename?: 'InternetServicePlanProvider';
      UUID: string;
      logoURL?: string | null;
      logoS3Key?: string | null;
      iconS3Key?: string | null;
      name: string;
    } | null;
  }>;
};

export type MoveInternetServicePlanMutationMutationVariables = Exact<{
  ispUUID: Scalars['UUID']['input'];
  networkUUID: Scalars['UUID']['input'];
}>;

export type MoveInternetServicePlanMutationMutation = {
  __typename?: 'Mutation';
  moveInternetServicePlanToNetwork: { __typename?: 'InternetServicePlan'; UUID: string };
};

export type RateLimitRuleFieldsFragment = {
  __typename?: 'RateLimitRule';
  UUID: string;
  name: string;
  description?: string | null;
  rateLimitKbpsDownload?: number | null;
  rateLimitKbpsUpload?: number | null;
  isEnabled: boolean;
  isPerSource: boolean;
  priority: number;
  protocol?: IpProtocol | null;
  srcMac?: string | null;
  srcPrefix?: string | null;
  dstMac?: string | null;
  dstPrefix?: string | null;
  srcPortRange?: { __typename?: 'PortRange'; lower: number; upper: number } | null;
  dstPortRange?: { __typename?: 'PortRange'; lower: number; upper: number } | null;
  vlanBindings?: Array<{ __typename: 'VLAN'; UUID: string; name: string; vlanID: number }> | null;
  phyInterfaceBindings?: Array<{
    __typename: 'PhyInterface';
    UUID: string;
    portNumber: number;
    label?: string | null;
    hardwareLabel?: string | null;
    virtualDevice:
      | {
          __typename?: 'AccessPointVirtualDevice';
          UUID: string;
          label: string;
          deviceModel: DeviceModel;
        }
      | {
          __typename?: 'ControllerVirtualDevice';
          UUID: string;
          label: string;
          deviceModel: DeviceModel;
        }
      | {
          __typename?: 'ObserverVirtualDevice';
          UUID: string;
          label: string;
          deviceModel: DeviceModel;
        }
      | {
          __typename?: 'PowerDistributionUnitVirtualDevice';
          UUID: string;
          label: string;
          deviceModel: DeviceModel;
        }
      | {
          __typename?: 'SwitchVirtualDevice';
          UUID: string;
          label: string;
          deviceModel: DeviceModel;
        };
    internetServicePlan?: {
      __typename?: 'InternetServicePlan';
      UUID: string;
      provider?: { __typename?: 'InternetServicePlanProvider'; name: string } | null;
    } | null;
  }> | null;
  ssidBindings?: Array<{ __typename: 'SSID'; UUID: string; ssid: string }> | null;
};

export type RateLimitRulesForNetworkQueryVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
}>;

export type RateLimitRulesForNetworkQuery = {
  __typename?: 'Query';
  rateLimitRulesForNetwork: Array<{
    __typename?: 'RateLimitRule';
    UUID: string;
    name: string;
    description?: string | null;
    rateLimitKbpsDownload?: number | null;
    rateLimitKbpsUpload?: number | null;
    isEnabled: boolean;
    isPerSource: boolean;
    priority: number;
    protocol?: IpProtocol | null;
    srcMac?: string | null;
    srcPrefix?: string | null;
    dstMac?: string | null;
    dstPrefix?: string | null;
    srcPortRange?: { __typename?: 'PortRange'; lower: number; upper: number } | null;
    dstPortRange?: { __typename?: 'PortRange'; lower: number; upper: number } | null;
    vlanBindings?: Array<{ __typename: 'VLAN'; UUID: string; name: string; vlanID: number }> | null;
    phyInterfaceBindings?: Array<{
      __typename: 'PhyInterface';
      UUID: string;
      portNumber: number;
      label?: string | null;
      hardwareLabel?: string | null;
      virtualDevice:
        | {
            __typename?: 'AccessPointVirtualDevice';
            UUID: string;
            label: string;
            deviceModel: DeviceModel;
          }
        | {
            __typename?: 'ControllerVirtualDevice';
            UUID: string;
            label: string;
            deviceModel: DeviceModel;
          }
        | {
            __typename?: 'ObserverVirtualDevice';
            UUID: string;
            label: string;
            deviceModel: DeviceModel;
          }
        | {
            __typename?: 'PowerDistributionUnitVirtualDevice';
            UUID: string;
            label: string;
            deviceModel: DeviceModel;
          }
        | {
            __typename?: 'SwitchVirtualDevice';
            UUID: string;
            label: string;
            deviceModel: DeviceModel;
          };
      internetServicePlan?: {
        __typename?: 'InternetServicePlan';
        UUID: string;
        provider?: { __typename?: 'InternetServicePlanProvider'; name: string } | null;
      } | null;
    }> | null;
    ssidBindings?: Array<{ __typename: 'SSID'; UUID: string; ssid: string }> | null;
  }>;
};

export type RateLimitRuleQueryVariables = Exact<{
  uuid: Scalars['UUID']['input'];
}>;

export type RateLimitRuleQuery = {
  __typename?: 'Query';
  rateLimitRule: {
    __typename?: 'RateLimitRule';
    UUID: string;
    name: string;
    description?: string | null;
    rateLimitKbpsDownload?: number | null;
    rateLimitKbpsUpload?: number | null;
    isEnabled: boolean;
    isPerSource: boolean;
    priority: number;
    protocol?: IpProtocol | null;
    srcMac?: string | null;
    srcPrefix?: string | null;
    dstMac?: string | null;
    dstPrefix?: string | null;
    srcPortRange?: { __typename?: 'PortRange'; lower: number; upper: number } | null;
    dstPortRange?: { __typename?: 'PortRange'; lower: number; upper: number } | null;
    vlanBindings?: Array<{ __typename: 'VLAN'; UUID: string; name: string; vlanID: number }> | null;
    phyInterfaceBindings?: Array<{
      __typename: 'PhyInterface';
      UUID: string;
      portNumber: number;
      label?: string | null;
      hardwareLabel?: string | null;
      virtualDevice:
        | {
            __typename?: 'AccessPointVirtualDevice';
            UUID: string;
            label: string;
            deviceModel: DeviceModel;
          }
        | {
            __typename?: 'ControllerVirtualDevice';
            UUID: string;
            label: string;
            deviceModel: DeviceModel;
          }
        | {
            __typename?: 'ObserverVirtualDevice';
            UUID: string;
            label: string;
            deviceModel: DeviceModel;
          }
        | {
            __typename?: 'PowerDistributionUnitVirtualDevice';
            UUID: string;
            label: string;
            deviceModel: DeviceModel;
          }
        | {
            __typename?: 'SwitchVirtualDevice';
            UUID: string;
            label: string;
            deviceModel: DeviceModel;
          };
      internetServicePlan?: {
        __typename?: 'InternetServicePlan';
        UUID: string;
        provider?: { __typename?: 'InternetServicePlanProvider'; name: string } | null;
      } | null;
    }> | null;
    ssidBindings?: Array<{ __typename: 'SSID'; UUID: string; ssid: string }> | null;
  };
};

export type CreateRateLimitRuleMutationVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
  input: CreateRateLimitRuleInput;
}>;

export type CreateRateLimitRuleMutation = {
  __typename?: 'Mutation';
  createRateLimitRule: { __typename?: 'RateLimitRule'; UUID: string };
};

export type UpdateRateLimitRuleMutationVariables = Exact<{
  uuid: Scalars['UUID']['input'];
  input: UpdateRateLimitRuleInput;
}>;

export type UpdateRateLimitRuleMutation = {
  __typename?: 'Mutation';
  updateRateLimitRule: { __typename?: 'RateLimitRule'; UUID: string };
};

export type DeleteRateLimitRuleMutationVariables = Exact<{
  uuid: Scalars['UUID']['input'];
}>;

export type DeleteRateLimitRuleMutation = {
  __typename?: 'Mutation';
  deleteRateLimitRule: { __typename?: 'RateLimitRule'; UUID: string };
};

export type UpdateRateLimitRulesIndependentlyMutationVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
  inputs: Array<UpdateRateLimitRulesInput> | UpdateRateLimitRulesInput;
}>;

export type UpdateRateLimitRulesIndependentlyMutation = {
  __typename?: 'Mutation';
  updateRateLimitRulesIndependently: Array<{ __typename?: 'RateLimitRule'; UUID: string }>;
};

export type VlanMetricsQueryVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
  virtualDeviceUUID: Scalars['UUID']['input'];
  filter: MetricsFilterInput;
  vlanUUID?: InputMaybe<Scalars['UUID']['input']>;
}>;

export type VlanMetricsQuery = {
  __typename?: 'Query';
  vlanMetrics: Array<{
    __typename?: 'VLANMetricsTimeseriesResponse';
    vlanID: number;
    txBytes: {
      __typename?: 'BaseMetricsResponse';
      metadata?: { __typename?: 'MetricsMetadata'; minValue: number; maxValue: number } | null;
      values: Array<{ __typename?: 'BaseMetricsValue'; timestamp: string; value: number }>;
    };
    rxBytes: {
      __typename?: 'BaseMetricsResponse';
      metadata?: { __typename?: 'MetricsMetadata'; minValue: number; maxValue: number } | null;
      values: Array<{ __typename?: 'BaseMetricsValue'; timestamp: string; value: number }>;
    };
    txPackets: {
      __typename?: 'BaseMetricsResponse';
      metadata?: { __typename?: 'MetricsMetadata'; minValue: number; maxValue: number } | null;
      values: Array<{ __typename?: 'BaseMetricsValue'; timestamp: string; value: number }>;
    };
    rxPackets: {
      __typename?: 'BaseMetricsResponse';
      metadata?: { __typename?: 'MetricsMetadata'; minValue: number; maxValue: number } | null;
      values: Array<{ __typename?: 'BaseMetricsValue'; timestamp: string; value: number }>;
    };
    txError: {
      __typename?: 'BaseMetricsResponse';
      metadata?: { __typename?: 'MetricsMetadata'; minValue: number; maxValue: number } | null;
      values: Array<{ __typename?: 'BaseMetricsValue'; timestamp: string; value: number }>;
    };
    rxError: {
      __typename?: 'BaseMetricsResponse';
      metadata?: { __typename?: 'MetricsMetadata'; minValue: number; maxValue: number } | null;
      values: Array<{ __typename?: 'BaseMetricsValue'; timestamp: string; value: number }>;
    };
    drops: {
      __typename?: 'BaseMetricsResponse';
      metadata?: { __typename?: 'MetricsMetadata'; minValue: number; maxValue: number } | null;
      values: Array<{ __typename?: 'BaseMetricsValue'; timestamp: string; value: number }>;
    };
  }>;
};

export type VlaNsQueryQueryVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
}>;

export type VlaNsQueryQuery = {
  __typename?: 'Query';
  vlans: Array<{
    __typename: 'VLAN';
    UUID: string;
    name: string;
    description?: string | null;
    isEnabled: boolean;
    isInternal?: boolean | null;
    isDefault: boolean;
    vlanID: number;
    ipV4ClientAssignmentProtocol?: ClientAssignmentProtocol | null;
    ipV4ClientGateway?: string | null;
    ipV4ClientPrefixLength?: number | null;
    isWANDenied: boolean;
    participatesInVPNs: boolean;
    isMulticastReflectionEnabled: boolean;
    permittedInterVLANCommunicationVLANs: Array<{
      __typename?: 'VLAN';
      UUID: string;
      name: string;
      vlanID: number;
    }>;
    dhcpRule?: {
      __typename?: 'DHCPRule';
      latestStats?: {
        __typename?: 'LatestDHCPRuleStats';
        observedAt: string;
        totalAddresses: number;
        assignedAddresses: number;
      } | null;
    } | null;
  }>;
};

export type VlanQueryQueryVariables = Exact<{
  uuid: Scalars['UUID']['input'];
}>;

export type VlanQueryQuery = {
  __typename?: 'Query';
  vlan: {
    __typename: 'VLAN';
    UUID: string;
    name: string;
    description?: string | null;
    isEnabled: boolean;
    isInternal?: boolean | null;
    isDefault: boolean;
    vlanID: number;
    ipV4ClientAssignmentProtocol?: ClientAssignmentProtocol | null;
    ipV4ClientGateway?: string | null;
    ipV4ClientPrefixLength?: number | null;
    isWANDenied: boolean;
    participatesInVPNs: boolean;
    isMulticastReflectionEnabled: boolean;
    permittedInterVLANCommunicationVLANs: Array<{
      __typename?: 'VLAN';
      UUID: string;
      name: string;
      vlanID: number;
    }>;
    dhcpRule?: {
      __typename?: 'DHCPRule';
      UUID: string;
      isIPv6: boolean;
      startIPAddress?: string | null;
      endIPAddress?: string | null;
      hasGatewayOverride: boolean;
      gatewayIPAddress: string;
      gatewayPrefixLength: number;
      leaseDurationSeconds?: number | null;
      dnsUseGatewayProxy: boolean;
      dnsUpstreamServers: Array<string>;
      dnsSearchDomains?: Array<string> | null;
      dnsCacheIsEnabled: boolean;
      dnsCacheSize: number;
      dnsCacheMaxTTL: number;
      latestStats?: {
        __typename?: 'LatestDHCPRuleStats';
        observedAt: string;
        totalAddresses: number;
        assignedAddresses: number;
      } | null;
      options: Array<{
        __typename?: 'DHCPOption';
        UUID: string;
        code: number;
        data: string;
        dataType?: DhcpOptionDataType | null;
        description?: string | null;
        createdAt: string;
      }>;
      reservedRanges: Array<{
        __typename?: 'DHCPReservedRange';
        UUID: string;
        description?: string | null;
        startIPAddress: string;
        endIPAddress: string;
        createdAt: string;
      }>;
      staticMappings: Array<{
        __typename?: 'DHCPStaticMapping';
        UUID: string;
        name?: string | null;
        macAddress: string;
        ipAddress?: string | null;
        hostname?: string | null;
        createdAt: string;
      }>;
      dnsHostMappings: Array<{
        __typename?: 'DNSHostMapping';
        UUID: string;
        isEnabled: boolean;
        overrideDomain: string;
        destinationIPAddress?: string | null;
        destinationDomain?: string | null;
        createdAt: string;
      }>;
      applicationDNSFirewallRules: Array<{
        __typename?: 'ApplicationDNSFirewallRule';
        UUID: string;
      }>;
      dhcpRuleFilters: Array<{
        __typename?: 'DHCPRuleFilter';
        UUID: string;
        allowedMACAddress?: string | null;
        allowedOUI?: string | null;
        createdAt: string;
      }>;
      dhcpProxies?: Array<{
        __typename?: 'DHCPProxy';
        UUID: string;
        phyInterfaceUUID?: string | null;
        ipAddress: string;
        phyInterface?: {
          __typename: 'PhyInterface';
          UUID: string;
          portNumber: number;
          label?: string | null;
          hardwareLabel?: string | null;
          virtualDevice:
            | {
                __typename?: 'AccessPointVirtualDevice';
                UUID: string;
                label: string;
                deviceModel: DeviceModel;
              }
            | {
                __typename?: 'ControllerVirtualDevice';
                UUID: string;
                label: string;
                deviceModel: DeviceModel;
              }
            | {
                __typename?: 'ObserverVirtualDevice';
                UUID: string;
                label: string;
                deviceModel: DeviceModel;
              }
            | {
                __typename?: 'PowerDistributionUnitVirtualDevice';
                UUID: string;
                label: string;
                deviceModel: DeviceModel;
              }
            | {
                __typename?: 'SwitchVirtualDevice';
                UUID: string;
                label: string;
                deviceModel: DeviceModel;
              };
          internetServicePlan?: {
            __typename?: 'InternetServicePlan';
            UUID: string;
            provider?: { __typename?: 'InternetServicePlanProvider'; name: string } | null;
          } | null;
        } | null;
      }> | null;
    } | null;
  };
};

export type VlaNsDetailedQueryQueryVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
}>;

export type VlaNsDetailedQueryQuery = {
  __typename?: 'Query';
  vlans: Array<{
    __typename: 'VLAN';
    UUID: string;
    name: string;
    description?: string | null;
    isEnabled: boolean;
    isInternal?: boolean | null;
    isDefault: boolean;
    vlanID: number;
    ipV4ClientAssignmentProtocol?: ClientAssignmentProtocol | null;
    ipV4ClientGateway?: string | null;
    ipV4ClientPrefixLength?: number | null;
    isWANDenied: boolean;
    participatesInVPNs: boolean;
    isMulticastReflectionEnabled: boolean;
    permittedInterVLANCommunicationVLANs: Array<{
      __typename?: 'VLAN';
      UUID: string;
      name: string;
      vlanID: number;
    }>;
    dhcpRule?: {
      __typename?: 'DHCPRule';
      UUID: string;
      isIPv6: boolean;
      startIPAddress?: string | null;
      endIPAddress?: string | null;
      hasGatewayOverride: boolean;
      gatewayIPAddress: string;
      gatewayPrefixLength: number;
      leaseDurationSeconds?: number | null;
      dnsUseGatewayProxy: boolean;
      dnsUpstreamServers: Array<string>;
      dnsSearchDomains?: Array<string> | null;
      dnsCacheIsEnabled: boolean;
      dnsCacheSize: number;
      dnsCacheMaxTTL: number;
      latestStats?: {
        __typename?: 'LatestDHCPRuleStats';
        observedAt: string;
        totalAddresses: number;
        assignedAddresses: number;
      } | null;
      options: Array<{
        __typename?: 'DHCPOption';
        UUID: string;
        code: number;
        data: string;
        dataType?: DhcpOptionDataType | null;
        description?: string | null;
        createdAt: string;
      }>;
      reservedRanges: Array<{
        __typename?: 'DHCPReservedRange';
        UUID: string;
        description?: string | null;
        startIPAddress: string;
        endIPAddress: string;
        createdAt: string;
      }>;
      staticMappings: Array<{
        __typename?: 'DHCPStaticMapping';
        UUID: string;
        name?: string | null;
        macAddress: string;
        ipAddress?: string | null;
        hostname?: string | null;
        createdAt: string;
      }>;
      dnsHostMappings: Array<{
        __typename?: 'DNSHostMapping';
        UUID: string;
        isEnabled: boolean;
        overrideDomain: string;
        destinationIPAddress?: string | null;
        destinationDomain?: string | null;
        createdAt: string;
      }>;
      applicationDNSFirewallRules: Array<{
        __typename?: 'ApplicationDNSFirewallRule';
        UUID: string;
      }>;
      dhcpRuleFilters: Array<{
        __typename?: 'DHCPRuleFilter';
        UUID: string;
        allowedMACAddress?: string | null;
        allowedOUI?: string | null;
        createdAt: string;
      }>;
      dhcpProxies?: Array<{
        __typename?: 'DHCPProxy';
        UUID: string;
        phyInterfaceUUID?: string | null;
        ipAddress: string;
        phyInterface?: {
          __typename: 'PhyInterface';
          UUID: string;
          portNumber: number;
          label?: string | null;
          hardwareLabel?: string | null;
          virtualDevice:
            | {
                __typename?: 'AccessPointVirtualDevice';
                UUID: string;
                label: string;
                deviceModel: DeviceModel;
              }
            | {
                __typename?: 'ControllerVirtualDevice';
                UUID: string;
                label: string;
                deviceModel: DeviceModel;
              }
            | {
                __typename?: 'ObserverVirtualDevice';
                UUID: string;
                label: string;
                deviceModel: DeviceModel;
              }
            | {
                __typename?: 'PowerDistributionUnitVirtualDevice';
                UUID: string;
                label: string;
                deviceModel: DeviceModel;
              }
            | {
                __typename?: 'SwitchVirtualDevice';
                UUID: string;
                label: string;
                deviceModel: DeviceModel;
              };
          internetServicePlan?: {
            __typename?: 'InternetServicePlan';
            UUID: string;
            provider?: { __typename?: 'InternetServicePlanProvider'; name: string } | null;
          } | null;
        } | null;
      }> | null;
    } | null;
  }>;
};

export type CreateVlanMutationMutationVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
  input: CreateVlanInput;
}>;

export type CreateVlanMutationMutation = {
  __typename?: 'Mutation';
  createVLAN: { __typename?: 'VLAN'; UUID: string };
};

export type UpdateVlanMutationMutationVariables = Exact<{
  uuid: Scalars['UUID']['input'];
  input: UpdateVlanInput;
}>;

export type UpdateVlanMutationMutation = {
  __typename?: 'Mutation';
  updateVLAN: { __typename?: 'VLAN'; UUID: string };
};

export type DeleteVlanMutationMutationVariables = Exact<{
  uuid: Scalars['UUID']['input'];
}>;

export type DeleteVlanMutationMutation = { __typename?: 'Mutation'; deleteVLAN: boolean };

export type CreateDhcpRuleMutationVariables = Exact<{
  vlanUUID: Scalars['UUID']['input'];
  input: CreateDhcpRuleInput;
}>;

export type CreateDhcpRuleMutation = {
  __typename?: 'Mutation';
  createDHCPRule: { __typename?: 'DHCPRule'; UUID: string };
};

export type UpdateDhcpRuleMutationVariables = Exact<{
  uuid: Scalars['UUID']['input'];
  input: UpdateDhcpRuleInput;
}>;

export type UpdateDhcpRuleMutation = {
  __typename?: 'Mutation';
  updateDHCPRule: { __typename?: 'DHCPRule'; UUID: string };
};

export type DeleteDhcpRuleMutationVariables = Exact<{
  uuid: Scalars['UUID']['input'];
}>;

export type DeleteDhcpRuleMutation = {
  __typename?: 'Mutation';
  deleteDHCPRule: { __typename?: 'DHCPRule'; UUID: string };
};

export type CreateDhcpOptionMutationVariables = Exact<{
  ruleUUID: Scalars['UUID']['input'];
  input: CreateDhcpOptionInput;
}>;

export type CreateDhcpOptionMutation = {
  __typename?: 'Mutation';
  createDHCPOption: { __typename?: 'DHCPOption'; UUID: string };
};

export type UpdateDhcpOptionMutationVariables = Exact<{
  uuid: Scalars['UUID']['input'];
  input: UpdateDhcpOptionInput;
}>;

export type UpdateDhcpOptionMutation = {
  __typename?: 'Mutation';
  updateDHCPOption: { __typename?: 'DHCPOption'; UUID: string };
};

export type DeleteDhcpOptionMutationVariables = Exact<{
  uuid: Scalars['UUID']['input'];
}>;

export type DeleteDhcpOptionMutation = {
  __typename?: 'Mutation';
  deleteDHCPOption: { __typename?: 'DHCPOption'; UUID: string };
};

export type CreateDhcpRuleFilterMutationVariables = Exact<{
  ruleUUID: Scalars['UUID']['input'];
  input: CreateDhcpRuleFilterInput;
}>;

export type CreateDhcpRuleFilterMutation = {
  __typename?: 'Mutation';
  createDHCPRuleFilter: { __typename?: 'DHCPRuleFilter'; UUID: string };
};

export type DeleteDhcpRuleFilterMutationVariables = Exact<{
  uuid: Scalars['UUID']['input'];
}>;

export type DeleteDhcpRuleFilterMutation = {
  __typename?: 'Mutation';
  deleteDHCPRuleFilter: { __typename?: 'DHCPRuleFilter'; UUID: string };
};

export type CreateDhcpReservedRangeMutationVariables = Exact<{
  ruleUUID: Scalars['UUID']['input'];
  input: CreateDhcpReservedRangeInput;
}>;

export type CreateDhcpReservedRangeMutation = {
  __typename?: 'Mutation';
  createDHCPReservedRange: { __typename?: 'DHCPReservedRange'; UUID: string };
};

export type UpdateDhcpReservedRangeMutationVariables = Exact<{
  uuid: Scalars['UUID']['input'];
  input: UpdateDhcpReservedRangeInput;
}>;

export type UpdateDhcpReservedRangeMutation = {
  __typename?: 'Mutation';
  updateDHCPReservedRange: { __typename?: 'DHCPReservedRange'; UUID: string };
};

export type DeleteDhcpReservedRangeMutationVariables = Exact<{
  uuid: Scalars['UUID']['input'];
}>;

export type DeleteDhcpReservedRangeMutation = {
  __typename?: 'Mutation';
  deleteDHCPReservedRange: { __typename?: 'DHCPReservedRange'; UUID: string };
};

export type CreateDhcpStaticMappingMutationVariables = Exact<{
  ruleUUID: Scalars['UUID']['input'];
  input: CreateDhcpStaticMappingInput;
}>;

export type CreateDhcpStaticMappingMutation = {
  __typename?: 'Mutation';
  createDHCPStaticMapping: { __typename?: 'DHCPStaticMapping'; UUID: string };
};

export type UpdateDhcpStaticMappingMutationVariables = Exact<{
  uuid: Scalars['UUID']['input'];
  input: UpdateDhcpStaticMappingInput;
}>;

export type UpdateDhcpStaticMappingMutation = {
  __typename?: 'Mutation';
  updateDHCPStaticMapping: { __typename?: 'DHCPStaticMapping'; UUID: string };
};

export type DeleteDhcpStaticMappingMutationVariables = Exact<{
  uuid: Scalars['UUID']['input'];
}>;

export type DeleteDhcpStaticMappingMutation = {
  __typename?: 'Mutation';
  deleteDHCPStaticMapping: { __typename?: 'DHCPStaticMapping'; UUID: string };
};

export type CreateDnsHostMappingMutationVariables = Exact<{
  ruleUUID: Scalars['UUID']['input'];
  input: CreateDnsHostMappingInput;
}>;

export type CreateDnsHostMappingMutation = {
  __typename?: 'Mutation';
  createDNSHostMapping: { __typename?: 'DNSHostMapping'; UUID: string };
};

export type UpdateDnsHostMappingMutationVariables = Exact<{
  uuid: Scalars['UUID']['input'];
  input: UpdateDnsHostMappingInput;
}>;

export type UpdateDnsHostMappingMutation = {
  __typename?: 'Mutation';
  updateDNSHostMapping: { __typename?: 'DNSHostMapping'; UUID: string };
};

export type DeleteDnsHostMappingMutationVariables = Exact<{
  uuid: Scalars['UUID']['input'];
}>;

export type DeleteDnsHostMappingMutation = {
  __typename?: 'Mutation';
  deleteDNSHostMapping: { __typename?: 'DNSHostMapping'; UUID: string };
};

export type OnboardingForNetworkQueryVariables = Exact<{
  uuid: Scalars['UUID']['input'];
}>;

export type OnboardingForNetworkQuery = {
  __typename?: 'Query';
  network: {
    __typename?: 'Network';
    UUID: string;
    onboarding?: {
      __typename?: 'NetworkOnboarding';
      networkUUID: string;
      jobData?: {
        __typename?: 'NetworkOnboardingJobData';
        fullAddress?: Array<string> | null;
        installationStartDate?: string | null;
        installationEndDate?: string | null;
        jobOwnerUser?: string | null;
        jobStage?: string | null;
        jobStatus?: string | null;
        onsiteContactInformation?: string | null;
        scheduleSiteSurveyLink?: Array<string> | null;
        siteSurveyDate?: Array<string> | null;
        siteSurveyStatus?: Array<string> | null;
        targetGoLiveDate?: string | null;
        totalSqFt?: Array<string> | null;
      } | null;
    } | null;
  };
};

export type NetworkForOnboardingDocumentQueryVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
}>;

export type NetworkForOnboardingDocumentQuery = {
  __typename?: 'Query';
  network: {
    __typename?: 'Network';
    UUID: string;
    onboardingDocument?: {
      __typename?: 'NetworkOnboardingDocument';
      document: Record<string, unknown>;
      delegations: Array<{
        __typename?: 'NetworkOnboardingFieldDelegation';
        UUID: string;
        fieldName: string;
        email: string;
        description?: string | null;
      }>;
    } | null;
  };
};

export type NetworksQueryVariables = Exact<{
  companySlug: Scalars['String']['input'];
}>;

export type NetworksQuery = {
  __typename?: 'Query';
  networksForCompany: Array<{
    __typename?: 'Network';
    UUID: string;
    onboardingDocument?: {
      __typename?: 'NetworkOnboardingDocument';
      document: Record<string, unknown>;
      delegations: Array<{
        __typename?: 'NetworkOnboardingFieldDelegation';
        UUID: string;
        fieldName: string;
        email: string;
        description?: string | null;
      }>;
    } | null;
  }>;
};

export type CompanyForOnboardingDocumentQueryVariables = Exact<{
  companyUUID: Scalars['UUID']['input'];
}>;

export type CompanyForOnboardingDocumentQuery = {
  __typename?: 'Query';
  getCompanyByUUID?: {
    __typename?: 'Company';
    uuid: string;
    onboardingDocument?: {
      __typename?: 'CompanyOnboardingDocument';
      document: Record<string, unknown>;
      delegations: Array<{
        __typename?: 'CompanyOnboardingFieldDelegation';
        UUID: string;
        fieldName: string;
        email: string;
        description?: string | null;
      }>;
    } | null;
  } | null;
};

export type UpsertNetworkOnboardingDocumentMutationVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
  document: Scalars['JSONObject']['input'];
}>;

export type UpsertNetworkOnboardingDocumentMutation = {
  __typename?: 'Mutation';
  upsertNetworkOnboardingDocument: { __typename?: 'NetworkOnboardingDocument'; UUID: string };
};

export type UpsertCompanyOnboardingDocumentMutationVariables = Exact<{
  companyUUID: Scalars['UUID']['input'];
  document: Scalars['JSONObject']['input'];
}>;

export type UpsertCompanyOnboardingDocumentMutation = {
  __typename?: 'Mutation';
  upsertCompanyOnboardingDocument: { __typename?: 'CompanyOnboardingDocument'; UUID: string };
};

export type UpsertNetworkOnboardingFieldDelegationMutationVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
  fieldName: Scalars['String']['input'];
  input: UpsertNetworkOnboardingFieldDelegationInput;
}>;

export type UpsertNetworkOnboardingFieldDelegationMutation = {
  __typename?: 'Mutation';
  upsertNetworkOnboardingFieldDelegation: {
    __typename?: 'NetworkOnboardingFieldDelegation';
    UUID: string;
  };
};

export type UpsertCompanyOnboardingFieldDelegationMutationVariables = Exact<{
  companyUUID: Scalars['UUID']['input'];
  fieldName: Scalars['String']['input'];
  input: UpsertCompanyOnboardingFieldDelegationInput;
}>;

export type UpsertCompanyOnboardingFieldDelegationMutation = {
  __typename?: 'Mutation';
  upsertCompanyOnboardingFieldDelegation: {
    __typename?: 'CompanyOnboardingFieldDelegation';
    UUID: string;
  };
};

export type DeleteNetworkOnboardingFieldDelegationMutationVariables = Exact<{
  uuid: Scalars['UUID']['input'];
}>;

export type DeleteNetworkOnboardingFieldDelegationMutation = {
  __typename?: 'Mutation';
  deleteNetworkOnboardingFieldDelegation: {
    __typename?: 'NetworkOnboardingFieldDelegation';
    UUID: string;
  };
};

export type DeleteCompanyOnboardingFieldDelegationMutationVariables = Exact<{
  uuid: Scalars['UUID']['input'];
}>;

export type DeleteCompanyOnboardingFieldDelegationMutation = {
  __typename?: 'Mutation';
  deleteCompanyOnboardingFieldDelegation: {
    __typename?: 'CompanyOnboardingFieldDelegation';
    UUID: string;
  };
};

export type NetworkFieldsFragment = {
  __typename?: 'Network';
  UUID: string;
  slug: string;
  label: string;
  companySlug?: string | null;
  isActive: boolean;
  isTrial: boolean;
  isTemplate: boolean;
  nosUpgradeChannel: NetworkNosUpgradeChannel;
  lastUpgradedAt?: string | null;
  highAvailabilityConfig?: {
    __typename?: 'HighAvailabilityControllersConfig';
    UUID: string;
  } | null;
  virtualDevices: Array<
    | { __typename?: 'AccessPointVirtualDevice'; deviceType: VirtualDeviceType }
    | { __typename?: 'ControllerVirtualDevice'; deviceType: VirtualDeviceType }
    | { __typename?: 'ObserverVirtualDevice'; deviceType: VirtualDeviceType }
    | { __typename?: 'PowerDistributionUnitVirtualDevice'; deviceType: VirtualDeviceType }
    | { __typename?: 'SwitchVirtualDevice'; deviceType: VirtualDeviceType }
  >;
  mailingAddress?: {
    __typename?: 'MailingAddress';
    line1?: string | null;
    line2?: string | null;
    city?: string | null;
    subdivisionCode?: string | null;
    postalCode?: string | null;
    countryISO2?: string | null;
  } | null;
};

export type CompaniesQueryQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;

export type CompaniesQueryQuery = {
  __typename?: 'Query';
  listCompanies: Array<{
    __typename?: 'Company';
    uuid: string;
    isCustomer: boolean;
    supportTier?: CompanySupportTier | null;
    slug: string;
    name: string;
    networks: Array<{
      __typename?: 'Network';
      UUID: string;
      slug: string;
      label: string;
      companySlug?: string | null;
      isActive: boolean;
      isTrial: boolean;
      isTemplate: boolean;
      nosUpgradeChannel: NetworkNosUpgradeChannel;
      lastUpgradedAt?: string | null;
      highAvailabilityConfig?: {
        __typename?: 'HighAvailabilityControllersConfig';
        UUID: string;
      } | null;
      virtualDevices: Array<
        | { __typename?: 'AccessPointVirtualDevice'; deviceType: VirtualDeviceType }
        | { __typename?: 'ControllerVirtualDevice'; deviceType: VirtualDeviceType }
        | { __typename?: 'ObserverVirtualDevice'; deviceType: VirtualDeviceType }
        | { __typename?: 'PowerDistributionUnitVirtualDevice'; deviceType: VirtualDeviceType }
        | { __typename?: 'SwitchVirtualDevice'; deviceType: VirtualDeviceType }
      >;
      mailingAddress?: {
        __typename?: 'MailingAddress';
        line1?: string | null;
        line2?: string | null;
        city?: string | null;
        subdivisionCode?: string | null;
        postalCode?: string | null;
        countryISO2?: string | null;
      } | null;
    }>;
  }>;
};

export type CompanyQueryQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;

export type CompanyQueryQuery = {
  __typename?: 'Query';
  getCompany?: {
    __typename?: 'Company';
    uuid: string;
    isCustomer: boolean;
    supportTier?: CompanySupportTier | null;
    slug: string;
    name: string;
    networks: Array<{
      __typename?: 'Network';
      UUID: string;
      slug: string;
      label: string;
      companySlug?: string | null;
      isActive: boolean;
      isTrial: boolean;
      isTemplate: boolean;
      nosUpgradeChannel: NetworkNosUpgradeChannel;
      lastUpgradedAt?: string | null;
      highAvailabilityConfig?: {
        __typename?: 'HighAvailabilityControllersConfig';
        UUID: string;
      } | null;
      virtualDevices: Array<
        | { __typename?: 'AccessPointVirtualDevice'; deviceType: VirtualDeviceType }
        | { __typename?: 'ControllerVirtualDevice'; deviceType: VirtualDeviceType }
        | { __typename?: 'ObserverVirtualDevice'; deviceType: VirtualDeviceType }
        | { __typename?: 'PowerDistributionUnitVirtualDevice'; deviceType: VirtualDeviceType }
        | { __typename?: 'SwitchVirtualDevice'; deviceType: VirtualDeviceType }
      >;
      mailingAddress?: {
        __typename?: 'MailingAddress';
        line1?: string | null;
        line2?: string | null;
        city?: string | null;
        subdivisionCode?: string | null;
        postalCode?: string | null;
        countryISO2?: string | null;
      } | null;
    }>;
  } | null;
};

export type CreateNosFirmwareUpgradeMutationMutationVariables = Exact<{
  input: CreateBulkNosUpgradeInput;
}>;

export type CreateNosFirmwareUpgradeMutationMutation = {
  __typename?: 'Mutation';
  createBulkNOSUpgrade: { __typename?: 'BulkNOSUpgrade'; UUID: string };
};

export type BulkNosUpgradeQueryQueryVariables = Exact<{
  uuid: Scalars['UUID']['input'];
}>;

export type BulkNosUpgradeQueryQuery = {
  __typename?: 'Query';
  bulkNOSUpgrade: {
    __typename?: 'BulkNOSUpgrade';
    UUID: string;
    createdAt: string;
    updatedAt: string;
    updatedBy: string;
    nosVersionID: number;
    scheduledAtEarliest: string;
    networks: Array<{
      __typename: 'Network';
      UUID: string;
      label: string;
      slug: string;
      companySlug?: string | null;
      company?: { __typename?: 'Company'; name: string } | null;
      upcomingScheduledNetworkNOSUpgrade?: {
        __typename?: 'ScheduledNetworkNOSUpgrade';
        scheduledAt: string;
      } | null;
    }>;
  };
};

export type BulkNosUpgradesQueryQueryVariables = Exact<{
  filter: BulkNosUpgradesFilterInput;
}>;

export type BulkNosUpgradesQueryQuery = {
  __typename?: 'Query';
  bulkNOSUpgrades: Array<{
    __typename?: 'BulkNOSUpgrade';
    UUID: string;
    createdAt: string;
    updatedAt: string;
    updatedBy: string;
    nosVersionID: number;
    scheduledAtEarliest: string;
    networks: Array<{ __typename?: 'Network'; UUID: string; label: string }>;
  }>;
};

export type NetworksByFilterQueryQueryVariables = Exact<{
  filter: NetworksFilter;
}>;

export type NetworksByFilterQueryQuery = {
  __typename?: 'Query';
  networks: Array<{
    __typename: 'Network';
    UUID: string;
    label: string;
    slug: string;
    companySlug?: string | null;
    pinnedNOSVersionID: number;
    pendingNOSVersionID?: number | null;
    lastUpgradedAt?: string | null;
    isActive: boolean;
    nosUpgradeChannel: NetworkNosUpgradeChannel;
    company?: {
      __typename?: 'Company';
      uuid: string;
      name: string;
      supportTier?: CompanySupportTier | null;
    } | null;
    mailingAddress?: { __typename?: 'MailingAddress'; squareFeet?: number | null } | null;
    virtualDevices: Array<
      | {
          __typename?: 'AccessPointVirtualDevice';
          hardwareDevice?:
            | {
                __typename?: 'AccessPointHardwareDevice';
                deviceType: DeviceType;
                deviceModel: DeviceModel;
              }
            | {
                __typename?: 'ControllerHardwareDevice';
                deviceType: DeviceType;
                deviceModel: DeviceModel;
              }
            | {
                __typename?: 'PowerDistributionUnitHardwareDevice';
                deviceType: DeviceType;
                deviceModel: DeviceModel;
              }
            | {
                __typename?: 'SwitchHardwareDevice';
                deviceType: DeviceType;
                deviceModel: DeviceModel;
              }
            | null;
        }
      | {
          __typename?: 'ControllerVirtualDevice';
          hardwareDevice?:
            | {
                __typename?: 'AccessPointHardwareDevice';
                deviceType: DeviceType;
                deviceModel: DeviceModel;
              }
            | {
                __typename?: 'ControllerHardwareDevice';
                deviceType: DeviceType;
                deviceModel: DeviceModel;
              }
            | {
                __typename?: 'PowerDistributionUnitHardwareDevice';
                deviceType: DeviceType;
                deviceModel: DeviceModel;
              }
            | {
                __typename?: 'SwitchHardwareDevice';
                deviceType: DeviceType;
                deviceModel: DeviceModel;
              }
            | null;
        }
      | {
          __typename?: 'ObserverVirtualDevice';
          hardwareDevice?:
            | {
                __typename?: 'AccessPointHardwareDevice';
                deviceType: DeviceType;
                deviceModel: DeviceModel;
              }
            | {
                __typename?: 'ControllerHardwareDevice';
                deviceType: DeviceType;
                deviceModel: DeviceModel;
              }
            | {
                __typename?: 'PowerDistributionUnitHardwareDevice';
                deviceType: DeviceType;
                deviceModel: DeviceModel;
              }
            | {
                __typename?: 'SwitchHardwareDevice';
                deviceType: DeviceType;
                deviceModel: DeviceModel;
              }
            | null;
        }
      | {
          __typename?: 'PowerDistributionUnitVirtualDevice';
          hardwareDevice?:
            | {
                __typename?: 'AccessPointHardwareDevice';
                deviceType: DeviceType;
                deviceModel: DeviceModel;
              }
            | {
                __typename?: 'ControllerHardwareDevice';
                deviceType: DeviceType;
                deviceModel: DeviceModel;
              }
            | {
                __typename?: 'PowerDistributionUnitHardwareDevice';
                deviceType: DeviceType;
                deviceModel: DeviceModel;
              }
            | {
                __typename?: 'SwitchHardwareDevice';
                deviceType: DeviceType;
                deviceModel: DeviceModel;
              }
            | null;
        }
      | {
          __typename?: 'SwitchVirtualDevice';
          hardwareDevice?:
            | {
                __typename?: 'AccessPointHardwareDevice';
                deviceType: DeviceType;
                deviceModel: DeviceModel;
              }
            | {
                __typename?: 'ControllerHardwareDevice';
                deviceType: DeviceType;
                deviceModel: DeviceModel;
              }
            | {
                __typename?: 'PowerDistributionUnitHardwareDevice';
                deviceType: DeviceType;
                deviceModel: DeviceModel;
              }
            | {
                __typename?: 'SwitchHardwareDevice';
                deviceType: DeviceType;
                deviceModel: DeviceModel;
              }
            | null;
        }
    >;
  }>;
};

export type FleetwideNotificationSettingFragmentFragment = {
  __typename?: 'FleetwideNotificationSetting';
  UUID: string;
  alertDefinitionName: string;
  countAppliedNetworks: number;
  createdAt: string;
  enabledForInactiveNetworks: boolean;
  enabledForInternalNetworks: boolean;
  enabledCustomerSupportTiers?: Array<CompanySupportTier> | null;
  enabledNOSUpgradeChannels?: Array<NetworkNosUpgradeChannel> | null;
  label: string;
  alertReceiver: { __typename?: 'AlertReceiver'; companyUUID: string; label: string; UUID: string };
  arguments: Array<{
    __typename?: 'NotificationSettingArgument';
    parameterName: string;
    value: unknown;
  }>;
  company?: { __typename?: 'Company'; uuid: string; slug: string } | null;
};

export type FleetwideNotificationSettingsQueryQueryVariables = Exact<{
  alertName?: InputMaybe<Scalars['String']['input']>;
}>;

export type FleetwideNotificationSettingsQueryQuery = {
  __typename?: 'Query';
  fleetwideNotificationSettings: Array<{
    __typename?: 'FleetwideNotificationSetting';
    UUID: string;
    alertDefinitionName: string;
    countAppliedNetworks: number;
    createdAt: string;
    enabledForInactiveNetworks: boolean;
    enabledForInternalNetworks: boolean;
    enabledCustomerSupportTiers?: Array<CompanySupportTier> | null;
    enabledNOSUpgradeChannels?: Array<NetworkNosUpgradeChannel> | null;
    label: string;
    alertReceiver: {
      __typename?: 'AlertReceiver';
      companyUUID: string;
      label: string;
      UUID: string;
    };
    arguments: Array<{
      __typename?: 'NotificationSettingArgument';
      parameterName: string;
      value: unknown;
    }>;
    company?: { __typename?: 'Company'; uuid: string; slug: string } | null;
  }>;
};

export type CreateFleetwideNotificationSettingMutationMutationVariables = Exact<{
  input: CreateFleetwideNotificationSettingInput;
}>;

export type CreateFleetwideNotificationSettingMutationMutation = {
  __typename?: 'Mutation';
  createFleetwideNotificationSetting: {
    __typename?: 'FleetwideNotificationSetting';
    UUID: string;
    alertDefinitionName: string;
    countAppliedNetworks: number;
    createdAt: string;
    enabledForInactiveNetworks: boolean;
    enabledForInternalNetworks: boolean;
    enabledCustomerSupportTiers?: Array<CompanySupportTier> | null;
    enabledNOSUpgradeChannels?: Array<NetworkNosUpgradeChannel> | null;
    label: string;
    alertReceiver: {
      __typename?: 'AlertReceiver';
      companyUUID: string;
      label: string;
      UUID: string;
    };
    arguments: Array<{
      __typename?: 'NotificationSettingArgument';
      parameterName: string;
      value: unknown;
    }>;
    company?: { __typename?: 'Company'; uuid: string; slug: string } | null;
  };
};

export type UpdateFleetwideNotificationSettingMutationMutationVariables = Exact<{
  uuid: Scalars['UUID']['input'];
  input: UpdateFleetwideNotificationSettingInput;
}>;

export type UpdateFleetwideNotificationSettingMutationMutation = {
  __typename?: 'Mutation';
  updateFleetwideNotificationSetting: {
    __typename?: 'FleetwideNotificationSetting';
    UUID: string;
    alertDefinitionName: string;
    countAppliedNetworks: number;
    createdAt: string;
    enabledForInactiveNetworks: boolean;
    enabledForInternalNetworks: boolean;
    enabledCustomerSupportTiers?: Array<CompanySupportTier> | null;
    enabledNOSUpgradeChannels?: Array<NetworkNosUpgradeChannel> | null;
    label: string;
    alertReceiver: {
      __typename?: 'AlertReceiver';
      companyUUID: string;
      label: string;
      UUID: string;
    };
    arguments: Array<{
      __typename?: 'NotificationSettingArgument';
      parameterName: string;
      value: unknown;
    }>;
    company?: { __typename?: 'Company'; uuid: string; slug: string } | null;
  };
};

export type DeleteFleetwideNotificationSettingMutationVariables = Exact<{
  UUID: Scalars['UUID']['input'];
}>;

export type DeleteFleetwideNotificationSettingMutation = {
  __typename?: 'Mutation';
  deleteFleetwideNotificationSetting: { __typename?: 'FleetwideNotificationSetting'; UUID: string };
};

export type AlertDefinitionsQueryQueryVariables = Exact<{ [key: string]: never }>;

export type AlertDefinitionsQueryQuery = {
  __typename?: 'Query';
  alertDefinitions: Array<{
    __typename?: 'AlertDefinition';
    name: string;
    displayName: string;
    description?: string | null;
    availability: AccessLevel;
    isBatch: boolean;
    isFleetwideSupported: boolean;
    parameters: Array<
      | {
          __typename: 'AlertParameterBoolean';
          name: string;
          uuid: string;
          description?: string | null;
          type: AlertParameterType;
          required: boolean;
          displayName?: string | null;
          isFleetwideSupported: boolean;
          booleanDefaultValue?: boolean | null;
        }
      | {
          __typename: 'AlertParameterDate';
          name: string;
          uuid: string;
          description?: string | null;
          type: AlertParameterType;
          required: boolean;
          displayName?: string | null;
          isFleetwideSupported: boolean;
          dateDefaultValue?: string | null;
        }
      | {
          __typename: 'AlertParameterDateTime';
          name: string;
          uuid: string;
          description?: string | null;
          type: AlertParameterType;
          required: boolean;
          displayName?: string | null;
          isFleetwideSupported: boolean;
          dateTimeDefaultValue?: string | null;
        }
      | {
          __typename: 'AlertParameterDuration';
          name: string;
          uuid: string;
          description?: string | null;
          type: AlertParameterType;
          required: boolean;
          displayName?: string | null;
          isFleetwideSupported: boolean;
          durationDefaultValue?: string | null;
        }
      | {
          __typename: 'AlertParameterNumber';
          name: string;
          uuid: string;
          description?: string | null;
          type: AlertParameterType;
          required: boolean;
          displayName?: string | null;
          isFleetwideSupported: boolean;
          numberDefaultValue?: number | null;
        }
      | {
          __typename: 'AlertParameterNumberArray';
          name: string;
          uuid: string;
          description?: string | null;
          type: AlertParameterType;
          required: boolean;
          displayName?: string | null;
          isFleetwideSupported: boolean;
        }
      | {
          __typename: 'AlertParameterString';
          name: string;
          uuid: string;
          description?: string | null;
          type: AlertParameterType;
          required: boolean;
          displayName?: string | null;
          isFleetwideSupported: boolean;
          stringDefaultValue?: string | null;
        }
      | {
          __typename: 'AlertParameterStringArray';
          name: string;
          uuid: string;
          description?: string | null;
          type: AlertParameterType;
          required: boolean;
          displayName?: string | null;
          isFleetwideSupported: boolean;
        }
      | {
          __typename: 'AlertParameterUUID';
          name: string;
          uuid: string;
          description?: string | null;
          type: AlertParameterType;
          required: boolean;
          displayName?: string | null;
          isFleetwideSupported: boolean;
        }
      | {
          __typename: 'AlertParameterUUIDArray';
          name: string;
          uuid: string;
          description?: string | null;
          type: AlertParameterType;
          required: boolean;
          displayName?: string | null;
          isFleetwideSupported: boolean;
        }
    >;
  }>;
};

export type FleetwideNotificationSettingQueryQueryVariables = Exact<{
  uuid: Scalars['UUID']['input'];
}>;

export type FleetwideNotificationSettingQueryQuery = {
  __typename?: 'Query';
  fleetwideNotificationSetting: {
    __typename?: 'FleetwideNotificationSetting';
    UUID: string;
    alertDefinitionName: string;
    countAppliedNetworks: number;
    createdAt: string;
    enabledForInactiveNetworks: boolean;
    enabledForInternalNetworks: boolean;
    enabledCustomerSupportTiers?: Array<CompanySupportTier> | null;
    enabledNOSUpgradeChannels?: Array<NetworkNosUpgradeChannel> | null;
    label: string;
    alertReceiver: {
      __typename?: 'AlertReceiver';
      companyUUID: string;
      label: string;
      UUID: string;
    };
    arguments: Array<{
      __typename?: 'NotificationSettingArgument';
      parameterName: string;
      value: unknown;
    }>;
    company?: { __typename?: 'Company'; uuid: string; slug: string } | null;
  };
};

export type AppliedFleetwideNotificationSettingQueryQueryVariables = Exact<{
  uuid: Scalars['UUID']['input'];
}>;

export type AppliedFleetwideNotificationSettingQueryQuery = {
  __typename?: 'Query';
  appliedFleetwideNotificationSetting: Array<{
    __typename?: 'AppliedFleetwideNotificationSetting';
    alertReceiver: {
      __typename?: 'AlertReceiver';
      UUID: string;
      label: string;
      targets: Array<
        | { __typename?: 'AlertTargetEmail'; UUID: string; type: AlertTargetType }
        | { __typename?: 'AlertTargetSlack'; UUID: string; type: AlertTargetType }
        | { __typename?: 'AlertTargetWebhook'; UUID: string; type: AlertTargetType }
      >;
    };
    fleetwideNotificationSetting: {
      __typename?: 'FleetwideNotificationSetting';
      UUID: string;
      alertDefinitionName: string;
      countAppliedNetworks: number;
      createdAt: string;
      enabledForInactiveNetworks: boolean;
      enabledForInternalNetworks: boolean;
      enabledCustomerSupportTiers?: Array<CompanySupportTier> | null;
      enabledNOSUpgradeChannels?: Array<NetworkNosUpgradeChannel> | null;
      label: string;
      alertReceiver: {
        __typename?: 'AlertReceiver';
        companyUUID: string;
        label: string;
        UUID: string;
      };
      arguments: Array<{
        __typename?: 'NotificationSettingArgument';
        parameterName: string;
        value: unknown;
      }>;
      company?: { __typename?: 'Company'; uuid: string; slug: string } | null;
    };
    network: { __typename?: 'Network'; UUID: string; label: string };
  }>;
};

export type FleetwideSnoozesQueryVariables = Exact<{ [key: string]: never }>;

export type FleetwideSnoozesQuery = {
  __typename?: 'Query';
  futureFleetwideNotificationSnoozes?: Array<{
    __typename?: 'FleetwideNotificationSnooze';
    UUID: string;
    createdAt: string;
    snoozeStart: string;
    snoozeEnd: string;
    snoozeReason?: string | null;
    company?: { __typename?: 'Company'; uuid: string; name: string } | null;
    network?: {
      __typename?: 'Network';
      UUID: string;
      label: string;
      company?: { __typename?: 'Company'; uuid: string; name: string; slug: string } | null;
    } | null;
    fleetwideNotificationSetting?: {
      __typename?: 'FleetwideNotificationSetting';
      UUID: string;
    } | null;
  }> | null;
};

export type CreateFleetwideSnoozeMutationVariables = Exact<{
  fleetwideNotificationSettingUUID?: InputMaybe<Scalars['UUID']['input']>;
  companyUUID?: InputMaybe<Scalars['UUID']['input']>;
  networkUUID?: InputMaybe<Scalars['UUID']['input']>;
  input: CreateNotificationSnoozeInput;
}>;

export type CreateFleetwideSnoozeMutation = {
  __typename?: 'Mutation';
  createFleetwideNotificationSnooze: { __typename?: 'FleetwideNotificationSnooze'; UUID: string };
};

export type UpdateFleetwideSnoozeMutationVariables = Exact<{
  uuid: Scalars['UUID']['input'];
  input: UpdateNotificationSnoozeInput;
}>;

export type UpdateFleetwideSnoozeMutation = {
  __typename?: 'Mutation';
  updateFleetwideNotificationSnooze: { __typename?: 'FleetwideNotificationSnooze'; UUID: string };
};

export type DeleteFleetwideSnoozeMutationVariables = Exact<{
  uuid: Scalars['UUID']['input'];
}>;

export type DeleteFleetwideSnoozeMutation = {
  __typename?: 'Mutation';
  deleteFleetwideNotificationSnooze: { __typename?: 'FleetwideNotificationSnooze'; UUID: string };
};

export type NosUpgradeGroupsForNetworkQueryVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
}>;

export type NosUpgradeGroupsForNetworkQuery = {
  __typename?: 'Query';
  nosUpgradeGroupsForNetwork: Array<{
    __typename?: 'NOSUpgradeGroup';
    UUID: string;
    name: string;
    priority: number;
    updatedAt: string;
    description?: string | null;
    defaultDeviceType?: VirtualDeviceType | null;
    defaultDeviceSubtype?: NosUpgradeGroupDeviceSubtype | null;
    networkUUID: string;
    timeoutDurationSeconds: number;
    virtualDevices: Array<
      | {
          __typename?: 'AccessPointVirtualDevice';
          label: string;
          UUID: string;
          deviceType: VirtualDeviceType;
          deviceModel: DeviceModel;
          network: { __typename?: 'Network'; slug: string; companySlug?: string | null };
          hardwareDevice?:
            | { __typename?: 'AccessPointHardwareDevice'; macAddress?: string | null }
            | { __typename?: 'ControllerHardwareDevice'; macAddress?: string | null }
            | { __typename?: 'PowerDistributionUnitHardwareDevice'; macAddress?: string | null }
            | { __typename?: 'SwitchHardwareDevice'; macAddress?: string | null }
            | null;
        }
      | {
          __typename?: 'ControllerVirtualDevice';
          label: string;
          UUID: string;
          deviceType: VirtualDeviceType;
          deviceModel: DeviceModel;
          network: { __typename?: 'Network'; slug: string; companySlug?: string | null };
          hardwareDevice?:
            | { __typename?: 'AccessPointHardwareDevice'; macAddress?: string | null }
            | { __typename?: 'ControllerHardwareDevice'; macAddress?: string | null }
            | { __typename?: 'PowerDistributionUnitHardwareDevice'; macAddress?: string | null }
            | { __typename?: 'SwitchHardwareDevice'; macAddress?: string | null }
            | null;
        }
      | {
          __typename?: 'ObserverVirtualDevice';
          label: string;
          UUID: string;
          deviceType: VirtualDeviceType;
          deviceModel: DeviceModel;
          network: { __typename?: 'Network'; slug: string; companySlug?: string | null };
          hardwareDevice?:
            | { __typename?: 'AccessPointHardwareDevice'; macAddress?: string | null }
            | { __typename?: 'ControllerHardwareDevice'; macAddress?: string | null }
            | { __typename?: 'PowerDistributionUnitHardwareDevice'; macAddress?: string | null }
            | { __typename?: 'SwitchHardwareDevice'; macAddress?: string | null }
            | null;
        }
      | {
          __typename?: 'PowerDistributionUnitVirtualDevice';
          label: string;
          UUID: string;
          deviceType: VirtualDeviceType;
          deviceModel: DeviceModel;
          network: { __typename?: 'Network'; slug: string; companySlug?: string | null };
          hardwareDevice?:
            | { __typename?: 'AccessPointHardwareDevice'; macAddress?: string | null }
            | { __typename?: 'ControllerHardwareDevice'; macAddress?: string | null }
            | { __typename?: 'PowerDistributionUnitHardwareDevice'; macAddress?: string | null }
            | { __typename?: 'SwitchHardwareDevice'; macAddress?: string | null }
            | null;
        }
      | {
          __typename?: 'SwitchVirtualDevice';
          label: string;
          UUID: string;
          deviceType: VirtualDeviceType;
          deviceModel: DeviceModel;
          network: { __typename?: 'Network'; slug: string; companySlug?: string | null };
          hardwareDevice?:
            | { __typename?: 'AccessPointHardwareDevice'; macAddress?: string | null }
            | { __typename?: 'ControllerHardwareDevice'; macAddress?: string | null }
            | { __typename?: 'PowerDistributionUnitHardwareDevice'; macAddress?: string | null }
            | { __typename?: 'SwitchHardwareDevice'; macAddress?: string | null }
            | null;
        }
    >;
  }>;
};

export type ScheduledNetworkNosUpgradesforNetworkQueryVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
}>;

export type ScheduledNetworkNosUpgradesforNetworkQuery = {
  __typename?: 'Query';
  scheduledNetworkNOSUpgradesForNetwork: Array<{
    __typename?: 'ScheduledNetworkNOSUpgrade';
    UUID: string;
    networkUUID: string;
    scheduledAt: string;
    completedAt?: string | null;
    status: ScheduledNosUpgradeStatus;
    nosVersion: {
      __typename?: 'NosVersion';
      id: number;
      isDefault: boolean;
      version: string;
      name?: string | null;
      major: number;
      minor: number;
      patch: number;
    };
    pendingNOSUpgradeGroups?: Array<{
      __typename?: 'NOSUpgradeGroup';
      UUID: string;
      name: string;
    }> | null;
    groupUpgrades: Array<{
      __typename?: 'ScheduledGroupNOSUpgrade';
      UUID: string;
      scheduledAt: string;
      completedAt?: string | null;
      status: ScheduledNosUpgradeStatus;
      nosUpgradeGroup: { __typename?: 'NOSUpgradeGroup'; UUID: string; name: string };
      deviceUpgrades: Array<{
        __typename?: 'ScheduledDeviceNOSUpgrade';
        status: ScheduledNosUpgradeStatus;
        scheduledAt: string;
        completedAt?: string | null;
        virtualDevice:
          | { __typename?: 'AccessPointVirtualDevice'; label: string }
          | { __typename?: 'ControllerVirtualDevice'; label: string }
          | { __typename?: 'ObserverVirtualDevice'; label: string }
          | { __typename?: 'PowerDistributionUnitVirtualDevice'; label: string }
          | { __typename?: 'SwitchVirtualDevice'; label: string };
      }>;
    }>;
  }>;
};

export type CreateNosUpgradeGroupMutationVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
  input: CreateNosUpgradeGroupInput;
}>;

export type CreateNosUpgradeGroupMutation = {
  __typename?: 'Mutation';
  createNOSUpgradeGroup: { __typename?: 'NOSUpgradeGroup'; UUID: string };
};

export type UpdateNosUpgradeGroupMutationVariables = Exact<{
  uuid: Scalars['UUID']['input'];
  input: UpdateNosUpgradeGroupInput;
}>;

export type UpdateNosUpgradeGroupMutation = {
  __typename?: 'Mutation';
  updateNOSUpgradeGroup: { __typename?: 'NOSUpgradeGroup'; UUID: string };
};

export type UpdateNosUpgradeGroupsMutationVariables = Exact<{
  inputs: Array<UpdateNosUpgradeGroupsInput> | UpdateNosUpgradeGroupsInput;
}>;

export type UpdateNosUpgradeGroupsMutation = {
  __typename?: 'Mutation';
  updateNOSUpgradeGroups: Array<{ __typename?: 'NOSUpgradeGroup'; UUID: string }>;
};

export type DeleteNosUpgradeGroupMutationVariables = Exact<{
  uuid: Scalars['UUID']['input'];
}>;

export type DeleteNosUpgradeGroupMutation = {
  __typename?: 'Mutation';
  deleteNOSUpgradeGroup: { __typename?: 'NOSUpgradeGroup'; UUID: string };
};

export type CancelNosUpgradeMutationVariables = Exact<{
  uuid: Scalars['UUID']['input'];
  force: Scalars['Boolean']['input'];
}>;

export type CancelNosUpgradeMutation = {
  __typename?: 'Mutation';
  cancelScheduledNetworkNOSUpgrade: { __typename?: 'ScheduledNetworkNOSUpgrade'; UUID: string };
};

export type SetNetworkNosVersionMutationVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
  input: SetNetworkNosVersionInput;
}>;

export type SetNetworkNosVersionMutation = {
  __typename?: 'Mutation';
  setNetworkNosVersion: boolean;
};

export type NetworkFieldsForNosVersionFragment = {
  __typename: 'Network';
  UUID: string;
  label: string;
  slug: string;
  isCustomer: boolean;
  companySlug?: string | null;
  pinnedNOSVersionID: number;
  pendingNOSVersionID?: number | null;
  lastUpgradedAt?: string | null;
  isActive: boolean;
  nosUpgradeChannel: NetworkNosUpgradeChannel;
  company?: {
    __typename?: 'Company';
    uuid: string;
    name: string;
    supportTier?: CompanySupportTier | null;
  } | null;
  mailingAddress?: { __typename?: 'MailingAddress'; squareFeet?: number | null } | null;
  virtualDevices: Array<
    | {
        __typename?: 'AccessPointVirtualDevice';
        hardwareDevice?:
          | {
              __typename?: 'AccessPointHardwareDevice';
              deviceType: DeviceType;
              deviceModel: DeviceModel;
            }
          | {
              __typename?: 'ControllerHardwareDevice';
              deviceType: DeviceType;
              deviceModel: DeviceModel;
            }
          | {
              __typename?: 'PowerDistributionUnitHardwareDevice';
              deviceType: DeviceType;
              deviceModel: DeviceModel;
            }
          | {
              __typename?: 'SwitchHardwareDevice';
              deviceType: DeviceType;
              deviceModel: DeviceModel;
            }
          | null;
      }
    | {
        __typename?: 'ControllerVirtualDevice';
        hardwareDevice?:
          | {
              __typename?: 'AccessPointHardwareDevice';
              deviceType: DeviceType;
              deviceModel: DeviceModel;
            }
          | {
              __typename?: 'ControllerHardwareDevice';
              deviceType: DeviceType;
              deviceModel: DeviceModel;
            }
          | {
              __typename?: 'PowerDistributionUnitHardwareDevice';
              deviceType: DeviceType;
              deviceModel: DeviceModel;
            }
          | {
              __typename?: 'SwitchHardwareDevice';
              deviceType: DeviceType;
              deviceModel: DeviceModel;
            }
          | null;
      }
    | {
        __typename?: 'ObserverVirtualDevice';
        hardwareDevice?:
          | {
              __typename?: 'AccessPointHardwareDevice';
              deviceType: DeviceType;
              deviceModel: DeviceModel;
            }
          | {
              __typename?: 'ControllerHardwareDevice';
              deviceType: DeviceType;
              deviceModel: DeviceModel;
            }
          | {
              __typename?: 'PowerDistributionUnitHardwareDevice';
              deviceType: DeviceType;
              deviceModel: DeviceModel;
            }
          | {
              __typename?: 'SwitchHardwareDevice';
              deviceType: DeviceType;
              deviceModel: DeviceModel;
            }
          | null;
      }
    | {
        __typename?: 'PowerDistributionUnitVirtualDevice';
        hardwareDevice?:
          | {
              __typename?: 'AccessPointHardwareDevice';
              deviceType: DeviceType;
              deviceModel: DeviceModel;
            }
          | {
              __typename?: 'ControllerHardwareDevice';
              deviceType: DeviceType;
              deviceModel: DeviceModel;
            }
          | {
              __typename?: 'PowerDistributionUnitHardwareDevice';
              deviceType: DeviceType;
              deviceModel: DeviceModel;
            }
          | {
              __typename?: 'SwitchHardwareDevice';
              deviceType: DeviceType;
              deviceModel: DeviceModel;
            }
          | null;
      }
    | {
        __typename?: 'SwitchVirtualDevice';
        hardwareDevice?:
          | {
              __typename?: 'AccessPointHardwareDevice';
              deviceType: DeviceType;
              deviceModel: DeviceModel;
            }
          | {
              __typename?: 'ControllerHardwareDevice';
              deviceType: DeviceType;
              deviceModel: DeviceModel;
            }
          | {
              __typename?: 'PowerDistributionUnitHardwareDevice';
              deviceType: DeviceType;
              deviceModel: DeviceModel;
            }
          | {
              __typename?: 'SwitchHardwareDevice';
              deviceType: DeviceType;
              deviceModel: DeviceModel;
            }
          | null;
      }
  >;
};

export type NosVersionFieldsFragment = {
  __typename?: 'NosVersion';
  version: string;
  id: number;
  mc01Build?: string | null;
  mw07Build?: string | null;
  ms10Build?: string | null;
  s1Build?: string | null;
  mp01Build?: string | null;
  observerBuild?: string | null;
  isDeprecated: boolean;
  isDefault: boolean;
  isPublic: boolean;
  updatedAt: string;
  major: number;
  minor: number;
  patch: number;
  networks: Array<{
    __typename: 'Network';
    UUID: string;
    label: string;
    slug: string;
    isCustomer: boolean;
    companySlug?: string | null;
    pinnedNOSVersionID: number;
    pendingNOSVersionID?: number | null;
    lastUpgradedAt?: string | null;
    isActive: boolean;
    nosUpgradeChannel: NetworkNosUpgradeChannel;
    company?: {
      __typename?: 'Company';
      uuid: string;
      name: string;
      supportTier?: CompanySupportTier | null;
    } | null;
    mailingAddress?: { __typename?: 'MailingAddress'; squareFeet?: number | null } | null;
    virtualDevices: Array<
      | {
          __typename?: 'AccessPointVirtualDevice';
          hardwareDevice?:
            | {
                __typename?: 'AccessPointHardwareDevice';
                deviceType: DeviceType;
                deviceModel: DeviceModel;
              }
            | {
                __typename?: 'ControllerHardwareDevice';
                deviceType: DeviceType;
                deviceModel: DeviceModel;
              }
            | {
                __typename?: 'PowerDistributionUnitHardwareDevice';
                deviceType: DeviceType;
                deviceModel: DeviceModel;
              }
            | {
                __typename?: 'SwitchHardwareDevice';
                deviceType: DeviceType;
                deviceModel: DeviceModel;
              }
            | null;
        }
      | {
          __typename?: 'ControllerVirtualDevice';
          hardwareDevice?:
            | {
                __typename?: 'AccessPointHardwareDevice';
                deviceType: DeviceType;
                deviceModel: DeviceModel;
              }
            | {
                __typename?: 'ControllerHardwareDevice';
                deviceType: DeviceType;
                deviceModel: DeviceModel;
              }
            | {
                __typename?: 'PowerDistributionUnitHardwareDevice';
                deviceType: DeviceType;
                deviceModel: DeviceModel;
              }
            | {
                __typename?: 'SwitchHardwareDevice';
                deviceType: DeviceType;
                deviceModel: DeviceModel;
              }
            | null;
        }
      | {
          __typename?: 'ObserverVirtualDevice';
          hardwareDevice?:
            | {
                __typename?: 'AccessPointHardwareDevice';
                deviceType: DeviceType;
                deviceModel: DeviceModel;
              }
            | {
                __typename?: 'ControllerHardwareDevice';
                deviceType: DeviceType;
                deviceModel: DeviceModel;
              }
            | {
                __typename?: 'PowerDistributionUnitHardwareDevice';
                deviceType: DeviceType;
                deviceModel: DeviceModel;
              }
            | {
                __typename?: 'SwitchHardwareDevice';
                deviceType: DeviceType;
                deviceModel: DeviceModel;
              }
            | null;
        }
      | {
          __typename?: 'PowerDistributionUnitVirtualDevice';
          hardwareDevice?:
            | {
                __typename?: 'AccessPointHardwareDevice';
                deviceType: DeviceType;
                deviceModel: DeviceModel;
              }
            | {
                __typename?: 'ControllerHardwareDevice';
                deviceType: DeviceType;
                deviceModel: DeviceModel;
              }
            | {
                __typename?: 'PowerDistributionUnitHardwareDevice';
                deviceType: DeviceType;
                deviceModel: DeviceModel;
              }
            | {
                __typename?: 'SwitchHardwareDevice';
                deviceType: DeviceType;
                deviceModel: DeviceModel;
              }
            | null;
        }
      | {
          __typename?: 'SwitchVirtualDevice';
          hardwareDevice?:
            | {
                __typename?: 'AccessPointHardwareDevice';
                deviceType: DeviceType;
                deviceModel: DeviceModel;
              }
            | {
                __typename?: 'ControllerHardwareDevice';
                deviceType: DeviceType;
                deviceModel: DeviceModel;
              }
            | {
                __typename?: 'PowerDistributionUnitHardwareDevice';
                deviceType: DeviceType;
                deviceModel: DeviceModel;
              }
            | {
                __typename?: 'SwitchHardwareDevice';
                deviceType: DeviceType;
                deviceModel: DeviceModel;
              }
            | null;
        }
    >;
  }>;
};

export type NosVersionsQueryQueryVariables = Exact<{ [key: string]: never }>;

export type NosVersionsQueryQuery = {
  __typename?: 'Query';
  nosVersions: Array<{
    __typename?: 'NosVersion';
    version: string;
    id: number;
    mc01Build?: string | null;
    mw07Build?: string | null;
    ms10Build?: string | null;
    s1Build?: string | null;
    mp01Build?: string | null;
    observerBuild?: string | null;
    isDeprecated: boolean;
    isDefault: boolean;
    isPublic: boolean;
    updatedAt: string;
    major: number;
    minor: number;
    patch: number;
    networks: Array<{
      __typename: 'Network';
      UUID: string;
      label: string;
      slug: string;
      isCustomer: boolean;
      companySlug?: string | null;
      pinnedNOSVersionID: number;
      pendingNOSVersionID?: number | null;
      lastUpgradedAt?: string | null;
      isActive: boolean;
      nosUpgradeChannel: NetworkNosUpgradeChannel;
      company?: {
        __typename?: 'Company';
        uuid: string;
        name: string;
        supportTier?: CompanySupportTier | null;
      } | null;
      mailingAddress?: { __typename?: 'MailingAddress'; squareFeet?: number | null } | null;
      virtualDevices: Array<
        | {
            __typename?: 'AccessPointVirtualDevice';
            hardwareDevice?:
              | {
                  __typename?: 'AccessPointHardwareDevice';
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                }
              | {
                  __typename?: 'ControllerHardwareDevice';
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                }
              | {
                  __typename?: 'PowerDistributionUnitHardwareDevice';
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                }
              | {
                  __typename?: 'SwitchHardwareDevice';
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                }
              | null;
          }
        | {
            __typename?: 'ControllerVirtualDevice';
            hardwareDevice?:
              | {
                  __typename?: 'AccessPointHardwareDevice';
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                }
              | {
                  __typename?: 'ControllerHardwareDevice';
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                }
              | {
                  __typename?: 'PowerDistributionUnitHardwareDevice';
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                }
              | {
                  __typename?: 'SwitchHardwareDevice';
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                }
              | null;
          }
        | {
            __typename?: 'ObserverVirtualDevice';
            hardwareDevice?:
              | {
                  __typename?: 'AccessPointHardwareDevice';
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                }
              | {
                  __typename?: 'ControllerHardwareDevice';
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                }
              | {
                  __typename?: 'PowerDistributionUnitHardwareDevice';
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                }
              | {
                  __typename?: 'SwitchHardwareDevice';
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                }
              | null;
          }
        | {
            __typename?: 'PowerDistributionUnitVirtualDevice';
            hardwareDevice?:
              | {
                  __typename?: 'AccessPointHardwareDevice';
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                }
              | {
                  __typename?: 'ControllerHardwareDevice';
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                }
              | {
                  __typename?: 'PowerDistributionUnitHardwareDevice';
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                }
              | {
                  __typename?: 'SwitchHardwareDevice';
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                }
              | null;
          }
        | {
            __typename?: 'SwitchVirtualDevice';
            hardwareDevice?:
              | {
                  __typename?: 'AccessPointHardwareDevice';
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                }
              | {
                  __typename?: 'ControllerHardwareDevice';
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                }
              | {
                  __typename?: 'PowerDistributionUnitHardwareDevice';
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                }
              | {
                  __typename?: 'SwitchHardwareDevice';
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                }
              | null;
          }
      >;
    }>;
  }>;
  networks: Array<{
    __typename: 'Network';
    UUID: string;
    label: string;
    slug: string;
    isCustomer: boolean;
    companySlug?: string | null;
    pinnedNOSVersionID: number;
    pendingNOSVersionID?: number | null;
    lastUpgradedAt?: string | null;
    isActive: boolean;
    nosUpgradeChannel: NetworkNosUpgradeChannel;
    company?: {
      __typename?: 'Company';
      uuid: string;
      name: string;
      supportTier?: CompanySupportTier | null;
    } | null;
    mailingAddress?: { __typename?: 'MailingAddress'; squareFeet?: number | null } | null;
    virtualDevices: Array<
      | {
          __typename?: 'AccessPointVirtualDevice';
          hardwareDevice?:
            | {
                __typename?: 'AccessPointHardwareDevice';
                deviceType: DeviceType;
                deviceModel: DeviceModel;
              }
            | {
                __typename?: 'ControllerHardwareDevice';
                deviceType: DeviceType;
                deviceModel: DeviceModel;
              }
            | {
                __typename?: 'PowerDistributionUnitHardwareDevice';
                deviceType: DeviceType;
                deviceModel: DeviceModel;
              }
            | {
                __typename?: 'SwitchHardwareDevice';
                deviceType: DeviceType;
                deviceModel: DeviceModel;
              }
            | null;
        }
      | {
          __typename?: 'ControllerVirtualDevice';
          hardwareDevice?:
            | {
                __typename?: 'AccessPointHardwareDevice';
                deviceType: DeviceType;
                deviceModel: DeviceModel;
              }
            | {
                __typename?: 'ControllerHardwareDevice';
                deviceType: DeviceType;
                deviceModel: DeviceModel;
              }
            | {
                __typename?: 'PowerDistributionUnitHardwareDevice';
                deviceType: DeviceType;
                deviceModel: DeviceModel;
              }
            | {
                __typename?: 'SwitchHardwareDevice';
                deviceType: DeviceType;
                deviceModel: DeviceModel;
              }
            | null;
        }
      | {
          __typename?: 'ObserverVirtualDevice';
          hardwareDevice?:
            | {
                __typename?: 'AccessPointHardwareDevice';
                deviceType: DeviceType;
                deviceModel: DeviceModel;
              }
            | {
                __typename?: 'ControllerHardwareDevice';
                deviceType: DeviceType;
                deviceModel: DeviceModel;
              }
            | {
                __typename?: 'PowerDistributionUnitHardwareDevice';
                deviceType: DeviceType;
                deviceModel: DeviceModel;
              }
            | {
                __typename?: 'SwitchHardwareDevice';
                deviceType: DeviceType;
                deviceModel: DeviceModel;
              }
            | null;
        }
      | {
          __typename?: 'PowerDistributionUnitVirtualDevice';
          hardwareDevice?:
            | {
                __typename?: 'AccessPointHardwareDevice';
                deviceType: DeviceType;
                deviceModel: DeviceModel;
              }
            | {
                __typename?: 'ControllerHardwareDevice';
                deviceType: DeviceType;
                deviceModel: DeviceModel;
              }
            | {
                __typename?: 'PowerDistributionUnitHardwareDevice';
                deviceType: DeviceType;
                deviceModel: DeviceModel;
              }
            | {
                __typename?: 'SwitchHardwareDevice';
                deviceType: DeviceType;
                deviceModel: DeviceModel;
              }
            | null;
        }
      | {
          __typename?: 'SwitchVirtualDevice';
          hardwareDevice?:
            | {
                __typename?: 'AccessPointHardwareDevice';
                deviceType: DeviceType;
                deviceModel: DeviceModel;
              }
            | {
                __typename?: 'ControllerHardwareDevice';
                deviceType: DeviceType;
                deviceModel: DeviceModel;
              }
            | {
                __typename?: 'PowerDistributionUnitHardwareDevice';
                deviceType: DeviceType;
                deviceModel: DeviceModel;
              }
            | {
                __typename?: 'SwitchHardwareDevice';
                deviceType: DeviceType;
                deviceModel: DeviceModel;
              }
            | null;
        }
    >;
  }>;
};

export type NosVersionByIdQueryQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;

export type NosVersionByIdQueryQuery = {
  __typename?: 'Query';
  nosVersions: Array<{
    __typename?: 'NosVersion';
    id: number;
    version: string;
    isDeprecated: boolean;
    isGA: boolean;
    isDefault: boolean;
    isLocked: boolean;
    isPublic: boolean;
    releaseNotes?: string | null;
    major: number;
    minor: number;
    patch: number;
    updatedAt: string;
    mc01Build?: string | null;
    mw07Build?: string | null;
    mw08Build?: string | null;
    mw09Build?: string | null;
    ms10Build?: string | null;
    ms11Build?: string | null;
    s1Build?: string | null;
    mp01Build?: string | null;
    observerBuild?: string | null;
  }>;
};

export type UpdateNosVersionMutationMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  input: NosVersionInput;
}>;

export type UpdateNosVersionMutationMutation = {
  __typename?: 'Mutation';
  updateNosVersion: { __typename?: 'NosVersion'; id: number };
};

export type CreateNosVersionMutationMutationVariables = Exact<{
  input: NosVersionInput;
}>;

export type CreateNosVersionMutationMutation = {
  __typename?: 'Mutation';
  createNosVersion: { __typename?: 'NosVersion'; id: number };
};

export type NosFeaturesQueryQueryVariables = Exact<{ [key: string]: never }>;

export type NosFeaturesQueryQuery = {
  __typename?: 'Query';
  nosFeatures: Array<{
    __typename?: 'NosFeature';
    key: string;
    uuid: string;
    name: string;
    description: string;
    minMajorVersion: number;
    minMinorVersion: number;
    minPatchVersion: number;
    maxMajorVersion?: number | null;
    maxMinorVersion?: number | null;
    maxPatchVersion?: number | null;
    featureFlag?: string | null;
    nosVersions: Array<{ __typename?: 'NosVersion'; id: number }>;
  }>;
  networks: Array<{
    __typename: 'Network';
    UUID: string;
    label: string;
    slug: string;
    isCustomer: boolean;
    companySlug?: string | null;
    pinnedNOSVersionID: number;
    pendingNOSVersionID?: number | null;
    lastUpgradedAt?: string | null;
    isActive: boolean;
    nosUpgradeChannel: NetworkNosUpgradeChannel;
    company?: {
      __typename?: 'Company';
      uuid: string;
      name: string;
      supportTier?: CompanySupportTier | null;
    } | null;
    mailingAddress?: { __typename?: 'MailingAddress'; squareFeet?: number | null } | null;
    virtualDevices: Array<
      | {
          __typename?: 'AccessPointVirtualDevice';
          hardwareDevice?:
            | {
                __typename?: 'AccessPointHardwareDevice';
                deviceType: DeviceType;
                deviceModel: DeviceModel;
              }
            | {
                __typename?: 'ControllerHardwareDevice';
                deviceType: DeviceType;
                deviceModel: DeviceModel;
              }
            | {
                __typename?: 'PowerDistributionUnitHardwareDevice';
                deviceType: DeviceType;
                deviceModel: DeviceModel;
              }
            | {
                __typename?: 'SwitchHardwareDevice';
                deviceType: DeviceType;
                deviceModel: DeviceModel;
              }
            | null;
        }
      | {
          __typename?: 'ControllerVirtualDevice';
          hardwareDevice?:
            | {
                __typename?: 'AccessPointHardwareDevice';
                deviceType: DeviceType;
                deviceModel: DeviceModel;
              }
            | {
                __typename?: 'ControllerHardwareDevice';
                deviceType: DeviceType;
                deviceModel: DeviceModel;
              }
            | {
                __typename?: 'PowerDistributionUnitHardwareDevice';
                deviceType: DeviceType;
                deviceModel: DeviceModel;
              }
            | {
                __typename?: 'SwitchHardwareDevice';
                deviceType: DeviceType;
                deviceModel: DeviceModel;
              }
            | null;
        }
      | {
          __typename?: 'ObserverVirtualDevice';
          hardwareDevice?:
            | {
                __typename?: 'AccessPointHardwareDevice';
                deviceType: DeviceType;
                deviceModel: DeviceModel;
              }
            | {
                __typename?: 'ControllerHardwareDevice';
                deviceType: DeviceType;
                deviceModel: DeviceModel;
              }
            | {
                __typename?: 'PowerDistributionUnitHardwareDevice';
                deviceType: DeviceType;
                deviceModel: DeviceModel;
              }
            | {
                __typename?: 'SwitchHardwareDevice';
                deviceType: DeviceType;
                deviceModel: DeviceModel;
              }
            | null;
        }
      | {
          __typename?: 'PowerDistributionUnitVirtualDevice';
          hardwareDevice?:
            | {
                __typename?: 'AccessPointHardwareDevice';
                deviceType: DeviceType;
                deviceModel: DeviceModel;
              }
            | {
                __typename?: 'ControllerHardwareDevice';
                deviceType: DeviceType;
                deviceModel: DeviceModel;
              }
            | {
                __typename?: 'PowerDistributionUnitHardwareDevice';
                deviceType: DeviceType;
                deviceModel: DeviceModel;
              }
            | {
                __typename?: 'SwitchHardwareDevice';
                deviceType: DeviceType;
                deviceModel: DeviceModel;
              }
            | null;
        }
      | {
          __typename?: 'SwitchVirtualDevice';
          hardwareDevice?:
            | {
                __typename?: 'AccessPointHardwareDevice';
                deviceType: DeviceType;
                deviceModel: DeviceModel;
              }
            | {
                __typename?: 'ControllerHardwareDevice';
                deviceType: DeviceType;
                deviceModel: DeviceModel;
              }
            | {
                __typename?: 'PowerDistributionUnitHardwareDevice';
                deviceType: DeviceType;
                deviceModel: DeviceModel;
              }
            | {
                __typename?: 'SwitchHardwareDevice';
                deviceType: DeviceType;
                deviceModel: DeviceModel;
              }
            | null;
        }
    >;
  }>;
};

export type NosFeatureQueryQueryVariables = Exact<{
  uuid: Scalars['UUID']['input'];
}>;

export type NosFeatureQueryQuery = {
  __typename?: 'Query';
  nosFeature: {
    __typename?: 'NosFeature';
    uuid: string;
    key: string;
    name: string;
    description: string;
    minMajorVersion: number;
    minMinorVersion: number;
    minPatchVersion: number;
    maxMajorVersion?: number | null;
    maxMinorVersion?: number | null;
    maxPatchVersion?: number | null;
    featureFlag?: string | null;
  };
};

export type UpdateNosFeatureMutationMutationVariables = Exact<{
  uuid: Scalars['UUID']['input'];
  input: UpdateNosFeatureInput;
}>;

export type UpdateNosFeatureMutationMutation = {
  __typename?: 'Mutation';
  updateNosFeature: { __typename?: 'NosFeature'; uuid: string };
};

export type CreateNosFeatureMutationMutationVariables = Exact<{
  input: CreateNosFeatureInput;
}>;

export type CreateNosFeatureMutationMutation = {
  __typename?: 'Mutation';
  createNosFeature: { __typename?: 'NosFeature'; uuid: string };
};

export type PromoFieldsFragment = {
  __typename?: 'MarketingChangelogEntry';
  UUID: string;
  heading: string;
  copy?: string | null;
  linkURL?: string | null;
  visibleStartAt: string;
  visibleEndAt: string;
  imageS3Keys?: { __typename?: 'ThemedImageS3Keys'; lightS3Key: string; darkS3Key: string } | null;
  badge?: { __typename?: 'DisplayBadge'; icon?: string | null; text?: string | null } | null;
};

export type AllPromosQueryVariables = Exact<{ [key: string]: never }>;

export type AllPromosQuery = {
  __typename?: 'Query';
  allMarketingChangelogEntries: Array<{
    __typename?: 'MarketingChangelogEntry';
    UUID: string;
    heading: string;
    copy?: string | null;
    linkURL?: string | null;
    visibleStartAt: string;
    visibleEndAt: string;
    imageS3Keys?: {
      __typename?: 'ThemedImageS3Keys';
      lightS3Key: string;
      darkS3Key: string;
    } | null;
    badge?: { __typename?: 'DisplayBadge'; icon?: string | null; text?: string | null } | null;
  }>;
};

export type PromoQueryVariables = Exact<{
  uuid: Scalars['UUID']['input'];
}>;

export type PromoQuery = {
  __typename?: 'Query';
  marketingChangelogEntry: {
    __typename?: 'MarketingChangelogEntry';
    UUID: string;
    heading: string;
    copy?: string | null;
    linkURL?: string | null;
    visibleStartAt: string;
    visibleEndAt: string;
    imageS3Keys?: {
      __typename?: 'ThemedImageS3Keys';
      lightS3Key: string;
      darkS3Key: string;
    } | null;
    badge?: { __typename?: 'DisplayBadge'; icon?: string | null; text?: string | null } | null;
  };
};

export type CreatePromoMutationVariables = Exact<{
  input: CreateMarketingChangelogEntryInput;
}>;

export type CreatePromoMutation = {
  __typename?: 'Mutation';
  createMarketingChangelogEntry: { __typename?: 'MarketingChangelogEntry'; UUID: string };
};

export type UpdatePromoMutationVariables = Exact<{
  uuid: Scalars['UUID']['input'];
  input: UpdateMarketingChangelogEntryInput;
}>;

export type UpdatePromoMutation = {
  __typename?: 'Mutation';
  updateMarketingChangelogEntry: { __typename?: 'MarketingChangelogEntry'; UUID: string };
};

export type ListProvidersQueryQueryVariables = Exact<{ [key: string]: never }>;

export type ListProvidersQueryQuery = {
  __typename?: 'Query';
  internetServicePlanProviders: Array<{
    __typename?: 'InternetServicePlanProvider';
    UUID: string;
    name: string;
    logoS3Key?: string | null;
    iconS3Key?: string | null;
    staticRates?: Array<{
      __typename?: 'InternetServicePlanProviderStaticRate';
      UUID: string;
    }> | null;
  }>;
};

export type ListProviderStaticRatesQueryQueryVariables = Exact<{
  providerUUID: Scalars['UUID']['input'];
}>;

export type ListProviderStaticRatesQueryQuery = {
  __typename?: 'Query';
  internetServicePlanProviderStaticRates: Array<{
    __typename?: 'InternetServicePlanProviderStaticRate';
    UUID: string;
    locationMode: InternetServicePlanProviderStaticRateLocationMode;
    downloadKbps: number;
    uploadKbps: number;
    monthlyCostCents: number;
    installCostCents: number;
    termMonths: number;
    enabled: boolean;
    createdAt: string;
    updatedAt: string;
    connectionType: {
      __typename?: 'InternetServicePlanConnectionType';
      UUID: string;
      name: string;
    };
  }>;
};

export type ListConnectionTypesQueryQueryVariables = Exact<{ [key: string]: never }>;

export type ListConnectionTypesQueryQuery = {
  __typename?: 'Query';
  internetServicePlanConnectionTypes: Array<{
    __typename?: 'InternetServicePlanConnectionType';
    UUID: string;
    name: string;
  }>;
};

export type GetProviderQueryQueryVariables = Exact<{
  uuid: Scalars['UUID']['input'];
}>;

export type GetProviderQueryQuery = {
  __typename?: 'Query';
  internetServicePlanProvider: {
    __typename?: 'InternetServicePlanProvider';
    UUID: string;
    name: string;
    logoS3Key?: string | null;
    iconS3Key?: string | null;
    aliases?: Array<{
      __typename?: 'InternetServicePlanProviderAlias';
      UUID: string;
      alias: string;
    }> | null;
    staticRates?: Array<{
      __typename?: 'InternetServicePlanProviderStaticRate';
      UUID: string;
    }> | null;
  };
};

export type GetProviderStaticRateQueryQueryVariables = Exact<{
  UUID: Scalars['UUID']['input'];
}>;

export type GetProviderStaticRateQueryQuery = {
  __typename?: 'Query';
  internetServicePlanProviderStaticRate: {
    __typename?: 'InternetServicePlanProviderStaticRate';
    UUID: string;
    locationMode: InternetServicePlanProviderStaticRateLocationMode;
    downloadKbps: number;
    uploadKbps: number;
    monthlyCostCents: number;
    installCostCents: number;
    termMonths: number;
    enabled: boolean;
    createdAt: string;
    updatedAt: string;
    connectionType: {
      __typename?: 'InternetServicePlanConnectionType';
      UUID: string;
      name: string;
    };
  };
};

export type CreateInternetServicePlanProviderMutationMutationVariables = Exact<{
  input: CreateInternetServicePlanProviderInput;
}>;

export type CreateInternetServicePlanProviderMutationMutation = {
  __typename?: 'Mutation';
  createInternetServicePlanProvider: {
    __typename?: 'InternetServicePlanProvider';
    UUID: string;
    name: string;
    logoS3Key?: string | null;
    iconS3Key?: string | null;
    aliases?: Array<{
      __typename?: 'InternetServicePlanProviderAlias';
      UUID: string;
      alias: string;
    }> | null;
  };
};

export type UpdateInternetServicePlanProviderMutationMutationVariables = Exact<{
  uuid: Scalars['UUID']['input'];
  input: UpdateInternetServicePlanProviderInput;
}>;

export type UpdateInternetServicePlanProviderMutationMutation = {
  __typename?: 'Mutation';
  updateInternetServicePlanProvider: {
    __typename?: 'InternetServicePlanProvider';
    UUID: string;
    name: string;
    logoS3Key?: string | null;
    iconS3Key?: string | null;
    aliases?: Array<{
      __typename?: 'InternetServicePlanProviderAlias';
      UUID: string;
      alias: string;
    }> | null;
  };
};

export type CreateInternetServicePlanProviderStaticRateMutationMutationVariables = Exact<{
  input: CreateInternetServicePlanProviderStaticRateInput;
}>;

export type CreateInternetServicePlanProviderStaticRateMutationMutation = {
  __typename?: 'Mutation';
  createInternetServicePlanProviderStaticRate: {
    __typename?: 'InternetServicePlanProviderStaticRate';
    UUID: string;
    locationMode: InternetServicePlanProviderStaticRateLocationMode;
    downloadKbps: number;
    uploadKbps: number;
    monthlyCostCents: number;
    installCostCents: number;
    termMonths: number;
    enabled: boolean;
    connectionType: {
      __typename?: 'InternetServicePlanConnectionType';
      UUID: string;
      name: string;
    };
  };
};

export type UpdateInternetServicePlanProviderStaticRateMutationMutationVariables = Exact<{
  UUID: Scalars['UUID']['input'];
  input: UpdateInternetServicePlanProviderStaticRateInput;
}>;

export type UpdateInternetServicePlanProviderStaticRateMutationMutation = {
  __typename?: 'Mutation';
  updateInternetServicePlanProviderStaticRate: {
    __typename?: 'InternetServicePlanProviderStaticRate';
    UUID: string;
    locationMode: InternetServicePlanProviderStaticRateLocationMode;
    downloadKbps: number;
    uploadKbps: number;
    monthlyCostCents: number;
    installCostCents: number;
    termMonths: number;
    enabled: boolean;
    connectionType: {
      __typename?: 'InternetServicePlanConnectionType';
      UUID: string;
      name: string;
    };
  };
};

export type UpdateInternetServicePlanProviderStaticRatesMutationMutationVariables = Exact<{
  UUIDs?: InputMaybe<Array<Scalars['UUID']['input']> | Scalars['UUID']['input']>;
  enabled: Scalars['Boolean']['input'];
}>;

export type UpdateInternetServicePlanProviderStaticRatesMutationMutation = {
  __typename?: 'Mutation';
  updateInternetServicePlanProviderStaticRates?: Array<{
    __typename?: 'InternetServicePlanProviderStaticRate';
    UUID: string;
    locationMode: InternetServicePlanProviderStaticRateLocationMode;
    downloadKbps: number;
    uploadKbps: number;
    monthlyCostCents: number;
    installCostCents: number;
    termMonths: number;
    enabled: boolean;
    connectionType: {
      __typename?: 'InternetServicePlanConnectionType';
      UUID: string;
      name: string;
    };
  }> | null;
};

export type DeleteInternetServicePlanProviderStaticRateMutationMutationVariables = Exact<{
  UUID: Scalars['UUID']['input'];
}>;

export type DeleteInternetServicePlanProviderStaticRateMutationMutation = {
  __typename?: 'Mutation';
  deleteInternetServicePlanProviderStaticRate: boolean;
};

export type DeviceConfigLatestAndCurrentQueryVariables = Exact<{
  serialNumber: Scalars['String']['input'];
}>;

export type DeviceConfigLatestAndCurrentQuery = {
  __typename?: 'Query';
  latestDeviceConfig: {
    __typename?: 'DeviceConfig';
    createdAt: string;
    version: number;
    isCurrentAsOf?: string | null;
    state?: {
      __typename?: 'DeviceConfigState';
      state: DeviceConfigStateType;
      timestamp: string;
    } | null;
  };
  currentDeviceConfig: {
    __typename?: 'DeviceConfigMetadata';
    createdAt: string;
    version: number;
    isCurrentAsOf?: string | null;
    state?: {
      __typename?: 'DeviceConfigState';
      state: DeviceConfigStateType;
      timestamp: string;
    } | null;
  };
};

export type WorkbenchNetworkInsightsQueryQueryVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
}>;

export type WorkbenchNetworkInsightsQueryQuery = {
  __typename?: 'Query';
  network: {
    __typename?: 'Network';
    nosUpgradeChannel: NetworkNosUpgradeChannel;
    company?: { __typename?: 'Company'; supportTier?: CompanySupportTier | null } | null;
  };
};

export type ReassignNetworkMutationVariables = Exact<{
  sourceNetworkUUID: Scalars['UUID']['input'];
  destinationNetworkUUID: Scalars['UUID']['input'];
}>;

export type ReassignNetworkMutation = {
  __typename?: 'Mutation';
  reassignNetwork: { __typename?: 'Network'; UUID: string; slug: string };
};

export type ListCompaniesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;

export type ListCompaniesQuery = {
  __typename?: 'Query';
  listCompanies: Array<{
    __typename?: 'Company';
    uuid: string;
    name: string;
    slug: string;
    networks: Array<{ __typename?: 'Network'; UUID: string; slug: string; label: string }>;
  }>;
};

export type ApplyNetworkTemplateMutationVariables = Exact<{
  sourceNetworkUUID: Scalars['UUID']['input'];
  destinationNetworkUUID: Scalars['UUID']['input'];
  shouldKeepSSIDNames: Scalars['Boolean']['input'];
}>;

export type ApplyNetworkTemplateMutation = {
  __typename?: 'Mutation';
  applyTemplateToNetwork: { __typename?: 'Network'; UUID: string; slug: string };
};

export type CompaniesHoldingGlobalNetworkTemplatesQueryVariables = Exact<{ [key: string]: never }>;

export type CompaniesHoldingGlobalNetworkTemplatesQuery = {
  __typename?: 'Query';
  companiesHoldingGlobalNetworkTemplates: Array<{
    __typename?: 'Company';
    uuid: string;
    name: string;
    slug: string;
    isCustomer: boolean;
    supportGroup?: number | null;
    websiteDomain?: string | null;
    holdsGlobalNetworkTemplates: boolean;
    networks: Array<{
      __typename?: 'Network';
      UUID: string;
      slug: string;
      label: string;
      isTemplate: boolean;
    }>;
  }>;
};

export type NetworkVirtualDevicesForCopierQueryVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
}>;

export type NetworkVirtualDevicesForCopierQuery = {
  __typename?: 'Query';
  virtualDevicesForNetwork: Array<
    | {
        __typename?: 'AccessPointVirtualDevice';
        UUID: string;
        hardwareDevice?:
          | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
          | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
          | { __typename?: 'PowerDistributionUnitHardwareDevice'; serialNumber: string }
          | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
          | null;
      }
    | {
        __typename?: 'ControllerVirtualDevice';
        UUID: string;
        hardwareDevice?:
          | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
          | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
          | { __typename?: 'PowerDistributionUnitHardwareDevice'; serialNumber: string }
          | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
          | null;
      }
    | {
        __typename?: 'ObserverVirtualDevice';
        UUID: string;
        hardwareDevice?:
          | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
          | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
          | { __typename?: 'PowerDistributionUnitHardwareDevice'; serialNumber: string }
          | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
          | null;
      }
    | {
        __typename?: 'PowerDistributionUnitVirtualDevice';
        UUID: string;
        hardwareDevice?:
          | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
          | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
          | { __typename?: 'PowerDistributionUnitHardwareDevice'; serialNumber: string }
          | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
          | null;
      }
    | {
        __typename?: 'SwitchVirtualDevice';
        UUID: string;
        hardwareDevice?:
          | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
          | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
          | { __typename?: 'PowerDistributionUnitHardwareDevice'; serialNumber: string }
          | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
          | null;
      }
  >;
};

export type InternalNoteFieldsFragment = {
  __typename?: 'InternalNote';
  UUID: string;
  createdAt: string;
  updatedAt?: string | null;
  isImportant: boolean;
  note: string;
  photoURLs?: Array<string> | null;
  photoS3Keys?: Array<string> | null;
  createdByUser: {
    __typename?: 'User';
    email: string;
    firstName?: string | null;
    lastName?: string | null;
  };
  updatedByUser?: {
    __typename?: 'User';
    email: string;
    firstName?: string | null;
    lastName?: string | null;
  } | null;
};

export type InternalNotesForNetworkQueryVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
}>;

export type InternalNotesForNetworkQuery = {
  __typename?: 'Query';
  internalNotesForNetwork: Array<{
    __typename?: 'InternalNote';
    UUID: string;
    createdAt: string;
    updatedAt?: string | null;
    isImportant: boolean;
    note: string;
    photoURLs?: Array<string> | null;
    photoS3Keys?: Array<string> | null;
    createdByUser: {
      __typename?: 'User';
      email: string;
      firstName?: string | null;
      lastName?: string | null;
    };
    updatedByUser?: {
      __typename?: 'User';
      email: string;
      firstName?: string | null;
      lastName?: string | null;
    } | null;
  }>;
};

export type InternalNoteQueryVariables = Exact<{
  UUID: Scalars['UUID']['input'];
}>;

export type InternalNoteQuery = {
  __typename?: 'Query';
  internalNote: {
    __typename?: 'InternalNote';
    UUID: string;
    createdAt: string;
    updatedAt?: string | null;
    isImportant: boolean;
    note: string;
    photoURLs?: Array<string> | null;
    photoS3Keys?: Array<string> | null;
    createdByUser: {
      __typename?: 'User';
      email: string;
      firstName?: string | null;
      lastName?: string | null;
    };
    updatedByUser?: {
      __typename?: 'User';
      email: string;
      firstName?: string | null;
      lastName?: string | null;
    } | null;
  };
};

export type CreateInternalNoteMutationVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
  input: CreateInternalNoteInput;
}>;

export type CreateInternalNoteMutation = {
  __typename?: 'Mutation';
  createInternalNote: { __typename?: 'InternalNote'; UUID: string };
};

export type UpdateInternalNoteMutationVariables = Exact<{
  UUID: Scalars['UUID']['input'];
  input: UpdateInternalNoteInput;
}>;

export type UpdateInternalNoteMutation = {
  __typename?: 'Mutation';
  updateInternalNote: { __typename?: 'InternalNote'; UUID: string };
};

export type DeleteInternalNoteMutationVariables = Exact<{
  UUID: Scalars['UUID']['input'];
}>;

export type DeleteInternalNoteMutation = {
  __typename?: 'Mutation';
  deleteInternalNote: { __typename?: 'InternalNote'; UUID: string };
};

export type DevicesForNetworkQueryVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
}>;

export type DevicesForNetworkQuery = {
  __typename?: 'Query';
  virtualDevicesForNetwork: Array<
    | {
        __typename?: 'AccessPointVirtualDevice';
        label: string;
        UUID: string;
        deviceType: VirtualDeviceType;
        hardwareDevice?:
          | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
          | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
          | { __typename?: 'PowerDistributionUnitHardwareDevice'; serialNumber: string }
          | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
          | null;
      }
    | {
        __typename?: 'ControllerVirtualDevice';
        label: string;
        UUID: string;
        deviceType: VirtualDeviceType;
        hardwareDevice?:
          | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
          | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
          | { __typename?: 'PowerDistributionUnitHardwareDevice'; serialNumber: string }
          | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
          | null;
      }
    | {
        __typename?: 'ObserverVirtualDevice';
        label: string;
        UUID: string;
        deviceType: VirtualDeviceType;
        hardwareDevice?:
          | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
          | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
          | { __typename?: 'PowerDistributionUnitHardwareDevice'; serialNumber: string }
          | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
          | null;
      }
    | {
        __typename?: 'PowerDistributionUnitVirtualDevice';
        label: string;
        UUID: string;
        deviceType: VirtualDeviceType;
        hardwareDevice?:
          | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
          | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
          | { __typename?: 'PowerDistributionUnitHardwareDevice'; serialNumber: string }
          | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
          | null;
      }
    | {
        __typename?: 'SwitchVirtualDevice';
        label: string;
        UUID: string;
        deviceType: VirtualDeviceType;
        hardwareDevice?:
          | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
          | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
          | { __typename?: 'PowerDistributionUnitHardwareDevice'; serialNumber: string }
          | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
          | null;
      }
  >;
};

export type TunnelIpAddressHardwareDeviceQueryVariables = Exact<{
  serialNumber: Scalars['String']['input'];
}>;

export type TunnelIpAddressHardwareDeviceQuery = {
  __typename?: 'Query';
  hardwareDevice:
    | { __typename?: 'AccessPointHardwareDevice'; tunnelIPAddress?: string | null }
    | { __typename?: 'ControllerHardwareDevice'; tunnelIPAddress?: string | null }
    | { __typename?: 'PowerDistributionUnitHardwareDevice'; tunnelIPAddress?: string | null }
    | { __typename?: 'SwitchHardwareDevice'; tunnelIPAddress?: string | null };
};

export type StartPacketCaptureMutationVariables = Exact<{
  serialNumber: Scalars['String']['input'];
  input: RpcWosPacketCaptureStartInput;
}>;

export type StartPacketCaptureMutation = {
  __typename?: 'Mutation';
  rpcWosPacketCaptureStart: {
    __typename?: 'RPCWosPacketCaptureResponse';
    jobId: string;
    status: RpcWosPacketCaptureResponseStatus;
  };
};

export type StopPacketCaptureMutationVariables = Exact<{
  serialNumber: Scalars['String']['input'];
  input: RpcWosPacketCaptureStopInput;
}>;

export type StopPacketCaptureMutation = {
  __typename?: 'Mutation';
  rpcWosPacketCaptureStop: {
    __typename?: 'RPCWosPacketCaptureResponse';
    jobId: string;
    status: RpcWosPacketCaptureResponseStatus;
  };
};

export type PacketCaptureJobQueryVariables = Exact<{
  jobId: Scalars['UUID']['input'];
}>;

export type PacketCaptureJobQuery = {
  __typename?: 'Query';
  packetCaptureJob: {
    __typename?: 'PacketCaptureJob';
    jobId: string;
    virtualDeviceUUID: string;
    networkUUID: string;
    listenOn: WosPacketCaptureCommandMonitor;
    createdAt: string;
    stopped: boolean;
    tcpDumpFilter: string;
    timeLimitSeconds: number;
    sizeLimitMb: number;
  };
};

export type RoutesForVirtualDeviceQueryVariables = Exact<{
  virtualDeviceUUID: Scalars['UUID']['input'];
}>;

export type RoutesForVirtualDeviceQuery = {
  __typename?: 'Query';
  networkRoutesForVirtualDevice: Array<{
    __typename?: 'NetworkRoute';
    destination: string;
    gateway?: string | null;
    attachment: {
      __typename?: 'NetworkRouteAttachment';
      vlan?: { __typename: 'VLAN'; UUID: string; name: string; vlanID: number } | null;
      phyInterface?: {
        __typename: 'PhyInterface';
        UUID: string;
        portNumber: number;
        label?: string | null;
        hardwareLabel?: string | null;
        virtualDevice:
          | {
              __typename?: 'AccessPointVirtualDevice';
              UUID: string;
              label: string;
              deviceType: VirtualDeviceType;
              deviceModel: DeviceModel;
            }
          | {
              __typename?: 'ControllerVirtualDevice';
              UUID: string;
              label: string;
              deviceType: VirtualDeviceType;
              deviceModel: DeviceModel;
            }
          | {
              __typename?: 'ObserverVirtualDevice';
              UUID: string;
              label: string;
              deviceType: VirtualDeviceType;
              deviceModel: DeviceModel;
            }
          | {
              __typename?: 'PowerDistributionUnitVirtualDevice';
              UUID: string;
              label: string;
              deviceType: VirtualDeviceType;
              deviceModel: DeviceModel;
            }
          | {
              __typename?: 'SwitchVirtualDevice';
              UUID: string;
              label: string;
              deviceType: VirtualDeviceType;
              deviceModel: DeviceModel;
            };
        internetServicePlan?: {
          __typename?: 'InternetServicePlan';
          UUID: string;
          provider?: { __typename?: 'InternetServicePlanProvider'; name: string } | null;
        } | null;
      } | null;
      autoVPNGroup?: { __typename: 'AutoVPNGroup'; UUID: string; name: string } | null;
      ipSecTunnel?: { __typename: 'IPSecTunnel'; UUID: string; name: string } | null;
      clientVPNServer?: { __typename: 'ClientVPNServer'; UUID: string; endpoint: string } | null;
    };
  }>;
};

export type PolicyRoutingRulesFieldsFragment = {
  __typename?: 'PolicyRoutingRule';
  UUID: string;
  name: string;
  isEnabled: boolean;
  srcPrefix?: string | null;
  dstPrefix: string;
  protocols: Array<IpProtocol>;
  srcVLAN?: {
    __typename: 'VLAN';
    UUID: string;
    name: string;
    vlanID: number;
    ipV4ClientAssignmentProtocol?: ClientAssignmentProtocol | null;
    ipV4ClientGateway?: string | null;
    ipV4ClientPrefixLength?: number | null;
  } | null;
  srcPortRanges: Array<{ __typename?: 'PortRange'; lower: number; upper: number }>;
  dstPortRanges: Array<{ __typename?: 'PortRange'; lower: number; upper: number }>;
  bindings?: Array<{
    __typename?: 'PolicyRoutingRuleBinding';
    UUID: string;
    metric: number;
    phyInterface: {
      __typename: 'PhyInterface';
      isUplinkActive?: boolean | null;
      hasWANActivity?: boolean | null;
      isEnabled: boolean;
      UUID: string;
      portNumber: number;
      label?: string | null;
      hardwareLabel?: string | null;
      virtualDevice:
        | {
            __typename?: 'AccessPointVirtualDevice';
            UUID: string;
            label: string;
            deviceModel: DeviceModel;
          }
        | {
            __typename?: 'ControllerVirtualDevice';
            UUID: string;
            label: string;
            deviceModel: DeviceModel;
          }
        | {
            __typename?: 'ObserverVirtualDevice';
            UUID: string;
            label: string;
            deviceModel: DeviceModel;
          }
        | {
            __typename?: 'PowerDistributionUnitVirtualDevice';
            UUID: string;
            label: string;
            deviceModel: DeviceModel;
          }
        | {
            __typename?: 'SwitchVirtualDevice';
            UUID: string;
            label: string;
            deviceModel: DeviceModel;
          };
      internetServicePlan?: {
        __typename?: 'InternetServicePlan';
        UUID: string;
        provider?: { __typename?: 'InternetServicePlanProvider'; name: string } | null;
      } | null;
    };
  }> | null;
};

export type PolicyRoutingRulesForNetworkQueryVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
}>;

export type PolicyRoutingRulesForNetworkQuery = {
  __typename?: 'Query';
  policyRoutingRulesForNetwork: Array<{
    __typename?: 'PolicyRoutingRule';
    UUID: string;
    name: string;
    isEnabled: boolean;
    srcPrefix?: string | null;
    dstPrefix: string;
    protocols: Array<IpProtocol>;
    srcVLAN?: {
      __typename: 'VLAN';
      UUID: string;
      name: string;
      vlanID: number;
      ipV4ClientAssignmentProtocol?: ClientAssignmentProtocol | null;
      ipV4ClientGateway?: string | null;
      ipV4ClientPrefixLength?: number | null;
    } | null;
    srcPortRanges: Array<{ __typename?: 'PortRange'; lower: number; upper: number }>;
    dstPortRanges: Array<{ __typename?: 'PortRange'; lower: number; upper: number }>;
    bindings?: Array<{
      __typename?: 'PolicyRoutingRuleBinding';
      UUID: string;
      metric: number;
      phyInterface: {
        __typename: 'PhyInterface';
        isUplinkActive?: boolean | null;
        hasWANActivity?: boolean | null;
        isEnabled: boolean;
        UUID: string;
        portNumber: number;
        label?: string | null;
        hardwareLabel?: string | null;
        virtualDevice:
          | {
              __typename?: 'AccessPointVirtualDevice';
              UUID: string;
              label: string;
              deviceModel: DeviceModel;
            }
          | {
              __typename?: 'ControllerVirtualDevice';
              UUID: string;
              label: string;
              deviceModel: DeviceModel;
            }
          | {
              __typename?: 'ObserverVirtualDevice';
              UUID: string;
              label: string;
              deviceModel: DeviceModel;
            }
          | {
              __typename?: 'PowerDistributionUnitVirtualDevice';
              UUID: string;
              label: string;
              deviceModel: DeviceModel;
            }
          | {
              __typename?: 'SwitchVirtualDevice';
              UUID: string;
              label: string;
              deviceModel: DeviceModel;
            };
        internetServicePlan?: {
          __typename?: 'InternetServicePlan';
          UUID: string;
          provider?: { __typename?: 'InternetServicePlanProvider'; name: string } | null;
        } | null;
      };
    }> | null;
  }>;
};

export type PolicyRoutingRuleQueryVariables = Exact<{
  uuid: Scalars['UUID']['input'];
}>;

export type PolicyRoutingRuleQuery = {
  __typename?: 'Query';
  policyRoutingRule: {
    __typename?: 'PolicyRoutingRule';
    UUID: string;
    name: string;
    isEnabled: boolean;
    srcPrefix?: string | null;
    dstPrefix: string;
    protocols: Array<IpProtocol>;
    srcVLAN?: {
      __typename: 'VLAN';
      UUID: string;
      name: string;
      vlanID: number;
      ipV4ClientAssignmentProtocol?: ClientAssignmentProtocol | null;
      ipV4ClientGateway?: string | null;
      ipV4ClientPrefixLength?: number | null;
    } | null;
    srcPortRanges: Array<{ __typename?: 'PortRange'; lower: number; upper: number }>;
    dstPortRanges: Array<{ __typename?: 'PortRange'; lower: number; upper: number }>;
    bindings?: Array<{
      __typename?: 'PolicyRoutingRuleBinding';
      UUID: string;
      metric: number;
      phyInterface: {
        __typename: 'PhyInterface';
        isUplinkActive?: boolean | null;
        hasWANActivity?: boolean | null;
        isEnabled: boolean;
        UUID: string;
        portNumber: number;
        label?: string | null;
        hardwareLabel?: string | null;
        virtualDevice:
          | {
              __typename?: 'AccessPointVirtualDevice';
              UUID: string;
              label: string;
              deviceModel: DeviceModel;
            }
          | {
              __typename?: 'ControllerVirtualDevice';
              UUID: string;
              label: string;
              deviceModel: DeviceModel;
            }
          | {
              __typename?: 'ObserverVirtualDevice';
              UUID: string;
              label: string;
              deviceModel: DeviceModel;
            }
          | {
              __typename?: 'PowerDistributionUnitVirtualDevice';
              UUID: string;
              label: string;
              deviceModel: DeviceModel;
            }
          | {
              __typename?: 'SwitchVirtualDevice';
              UUID: string;
              label: string;
              deviceModel: DeviceModel;
            };
        internetServicePlan?: {
          __typename?: 'InternetServicePlan';
          UUID: string;
          provider?: { __typename?: 'InternetServicePlanProvider'; name: string } | null;
        } | null;
      };
    }> | null;
  };
};

export type CreatePolicyRoutingRuleMutationVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
  input: CreatePolicyRoutingRuleInput;
}>;

export type CreatePolicyRoutingRuleMutation = {
  __typename?: 'Mutation';
  createPolicyRoutingRule: { __typename?: 'PolicyRoutingRule'; UUID: string };
};

export type UpdatePolicyRoutingRuleMutationVariables = Exact<{
  uuid: Scalars['UUID']['input'];
  input: UpdatePolicyRoutingRuleInput;
}>;

export type UpdatePolicyRoutingRuleMutation = {
  __typename?: 'Mutation';
  updatePolicyRoutingRule: { __typename?: 'PolicyRoutingRule'; UUID: string };
};

export type DeletePolicyRoutingRuleMutationVariables = Exact<{
  uuid: Scalars['UUID']['input'];
}>;

export type DeletePolicyRoutingRuleMutation = {
  __typename?: 'Mutation';
  deletePolicyRoutingRule: { __typename?: 'PolicyRoutingRule'; UUID: string };
};

export type UpdatePolicyRoutingRuleBindingsMutationVariables = Exact<{
  input: BindPolicyRoutingRulesInput;
  orderedRuleUUIDs: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
}>;

export type UpdatePolicyRoutingRuleBindingsMutation = {
  __typename?: 'Mutation';
  bindPolicyRoutingRules: Array<{
    __typename?: 'PolicyRoutingRuleBinding';
    UUID: string;
    metric: number;
  }>;
};

export type StaticRouteFieldsFragment = {
  __typename?: 'StaticRoute';
  UUID: string;
  name: string;
  isEnabled: boolean;
  dstPrefix: string;
  gatewayIP?: string | null;
  gatewayDHCPStaticMapping?: {
    __typename?: 'DHCPStaticMapping';
    UUID: string;
    name?: string | null;
    macAddress: string;
    ipAddress?: string | null;
    hostname?: string | null;
  } | null;
  gatewayVLAN?: {
    __typename?: 'VLAN';
    UUID: string;
    name: string;
    ipV4ClientAssignmentProtocol?: ClientAssignmentProtocol | null;
    ipV4ClientGateway?: string | null;
  } | null;
  explicitlyBoundVLANs?: Array<{ __typename?: 'VLAN'; UUID: string; name: string }> | null;
  excludedVLANs?: Array<{ __typename?: 'VLAN'; UUID: string; name: string }> | null;
};

export type StaticRoutesForNetworkQueryVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
}>;

export type StaticRoutesForNetworkQuery = {
  __typename?: 'Query';
  staticRoutesForNetwork: Array<{
    __typename?: 'StaticRoute';
    UUID: string;
    name: string;
    isEnabled: boolean;
    dstPrefix: string;
    gatewayIP?: string | null;
    gatewayDHCPStaticMapping?: {
      __typename?: 'DHCPStaticMapping';
      UUID: string;
      name?: string | null;
      macAddress: string;
      ipAddress?: string | null;
      hostname?: string | null;
    } | null;
    gatewayVLAN?: {
      __typename?: 'VLAN';
      UUID: string;
      name: string;
      ipV4ClientAssignmentProtocol?: ClientAssignmentProtocol | null;
      ipV4ClientGateway?: string | null;
    } | null;
    explicitlyBoundVLANs?: Array<{ __typename?: 'VLAN'; UUID: string; name: string }> | null;
    excludedVLANs?: Array<{ __typename?: 'VLAN'; UUID: string; name: string }> | null;
  }>;
};

export type StaticRouteQueryVariables = Exact<{
  uuid: Scalars['UUID']['input'];
}>;

export type StaticRouteQuery = {
  __typename?: 'Query';
  staticRoute: {
    __typename?: 'StaticRoute';
    UUID: string;
    name: string;
    isEnabled: boolean;
    dstPrefix: string;
    gatewayIP?: string | null;
    gatewayDHCPStaticMapping?: {
      __typename?: 'DHCPStaticMapping';
      UUID: string;
      name?: string | null;
      macAddress: string;
      ipAddress?: string | null;
      hostname?: string | null;
    } | null;
    gatewayVLAN?: {
      __typename?: 'VLAN';
      UUID: string;
      name: string;
      ipV4ClientAssignmentProtocol?: ClientAssignmentProtocol | null;
      ipV4ClientGateway?: string | null;
    } | null;
    explicitlyBoundVLANs?: Array<{ __typename?: 'VLAN'; UUID: string; name: string }> | null;
    excludedVLANs?: Array<{ __typename?: 'VLAN'; UUID: string; name: string }> | null;
  };
};

export type CreateStaticRouteMutationVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
  input: CreateStaticRouteInput;
}>;

export type CreateStaticRouteMutation = {
  __typename?: 'Mutation';
  createStaticRoute: { __typename?: 'StaticRoute'; UUID: string };
};

export type UpdateStaticRouteMutationVariables = Exact<{
  uuid: Scalars['UUID']['input'];
  input: UpdateStaticRouteInput;
}>;

export type UpdateStaticRouteMutation = {
  __typename?: 'Mutation';
  updateStaticRoute: { __typename?: 'StaticRoute'; UUID: string };
};

export type DeleteStaticRouteMutationVariables = Exact<{
  uuid: Scalars['UUID']['input'];
}>;

export type DeleteStaticRouteMutation = {
  __typename?: 'Mutation';
  deleteStaticRoute: { __typename?: 'StaticRoute'; UUID: string };
};

export type VlaNsStaticMappingsRulesQueryVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
}>;

export type VlaNsStaticMappingsRulesQuery = {
  __typename?: 'Query';
  vlans: Array<{
    __typename?: 'VLAN';
    UUID: string;
    name: string;
    vlanID: number;
    isInternal?: boolean | null;
    ipV4ClientAssignmentProtocol?: ClientAssignmentProtocol | null;
    ipV4ClientGateway?: string | null;
    ipV4ClientPrefixLength?: number | null;
    dhcpRule?: {
      __typename?: 'DHCPRule';
      UUID: string;
      staticMappings: Array<{
        __typename?: 'DHCPStaticMapping';
        UUID: string;
        name?: string | null;
        macAddress: string;
        ipAddress?: string | null;
        hostname?: string | null;
      }>;
    } | null;
  }>;
};

export type IpForwardingRulesQueryVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
}>;

export type IpForwardingRulesQuery = {
  __typename?: 'Query';
  ipForwardingRulesForNetwork: Array<{
    __typename?: 'IPForwardingRule';
    UUID: string;
    name: string;
    isEnabled: boolean;
    uplinkPhyInterface: {
      __typename: 'PhyInterface';
      UUID: string;
      portNumber: number;
      label?: string | null;
      hardwareLabel?: string | null;
      virtualDevice:
        | {
            __typename?: 'AccessPointVirtualDevice';
            UUID: string;
            label: string;
            deviceModel: DeviceModel;
          }
        | {
            __typename?: 'ControllerVirtualDevice';
            UUID: string;
            label: string;
            deviceModel: DeviceModel;
          }
        | {
            __typename?: 'ObserverVirtualDevice';
            UUID: string;
            label: string;
            deviceModel: DeviceModel;
          }
        | {
            __typename?: 'PowerDistributionUnitVirtualDevice';
            UUID: string;
            label: string;
            deviceModel: DeviceModel;
          }
        | {
            __typename?: 'SwitchVirtualDevice';
            UUID: string;
            label: string;
            deviceModel: DeviceModel;
          };
      internetServicePlan?: {
        __typename?: 'InternetServicePlan';
        UUID: string;
        provider?: { __typename?: 'InternetServicePlanProvider'; name: string } | null;
      } | null;
    };
    vlan: { __typename?: 'VLAN'; UUID: string; name: string; vlanID: number };
  }>;
};

export type IpForwardingRuleQueryVariables = Exact<{
  uuid: Scalars['UUID']['input'];
}>;

export type IpForwardingRuleQuery = {
  __typename?: 'Query';
  ipForwardingRule: {
    __typename?: 'IPForwardingRule';
    UUID: string;
    name: string;
    isEnabled: boolean;
    uplinkPhyInterface: {
      __typename: 'PhyInterface';
      UUID: string;
      portNumber: number;
      label?: string | null;
      hardwareLabel?: string | null;
      virtualDevice:
        | {
            __typename?: 'AccessPointVirtualDevice';
            UUID: string;
            label: string;
            deviceModel: DeviceModel;
          }
        | {
            __typename?: 'ControllerVirtualDevice';
            UUID: string;
            label: string;
            deviceModel: DeviceModel;
          }
        | {
            __typename?: 'ObserverVirtualDevice';
            UUID: string;
            label: string;
            deviceModel: DeviceModel;
          }
        | {
            __typename?: 'PowerDistributionUnitVirtualDevice';
            UUID: string;
            label: string;
            deviceModel: DeviceModel;
          }
        | {
            __typename?: 'SwitchVirtualDevice';
            UUID: string;
            label: string;
            deviceModel: DeviceModel;
          };
      internetServicePlan?: {
        __typename?: 'InternetServicePlan';
        UUID: string;
        provider?: { __typename?: 'InternetServicePlanProvider'; name: string } | null;
      } | null;
    };
    vlan: { __typename?: 'VLAN'; UUID: string; name: string; vlanID: number };
  };
};

export type CreateIpForwardingRuleMutationVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
  input: CreateIpForwardingRuleInput;
}>;

export type CreateIpForwardingRuleMutation = {
  __typename?: 'Mutation';
  createIPForwardingRule: { __typename?: 'IPForwardingRule'; UUID: string };
};

export type UpdateIpForwardingRuleMutationVariables = Exact<{
  uuid: Scalars['UUID']['input'];
  input: UpdateIpForwardingRuleInput;
}>;

export type UpdateIpForwardingRuleMutation = {
  __typename?: 'Mutation';
  updateIPForwardingRule: { __typename?: 'IPForwardingRule'; UUID: string };
};

export type DeleteIpForwardingRuleMutationVariables = Exact<{
  uuid: Scalars['UUID']['input'];
}>;

export type DeleteIpForwardingRuleMutation = {
  __typename?: 'Mutation';
  deleteIPForwardingRule: { __typename?: 'IPForwardingRule'; UUID: string };
};

export type IpSecTunnelFieldsFragment = {
  __typename: 'IPSecTunnel';
  UUID: string;
  name: string;
  isEnabled: boolean;
  isInitiator: boolean;
  authenticationAlgorithm?: IpSecAuthenticationAlgorithm | null;
  encryptionAlgorithm?: IpSecEncryptionAlgorithm | null;
  keyExchangeDHGroup?: IpSecDhGroup | null;
  right?: string | null;
  rightPrefixes: Array<string>;
  rightID: string;
  leftID: string;
  isClientVPNBound: boolean;
  peerType?: IpSecPeerType | null;
  dpdAction?: IpSecDpdAction | null;
  dpdTimeout?: string | null;
  dpdDelay?: string | null;
  ikeLifetime?: string | null;
  rekey: boolean;
  reauth: boolean;
  boundPhyInterface: {
    __typename?: 'PhyInterface';
    UUID: string;
    label?: string | null;
    portNumber: number;
    virtualDevice:
      | {
          __typename?: 'AccessPointVirtualDevice';
          label: string;
          hardwareDevice?:
            | {
                __typename?: 'AccessPointHardwareDevice';
                serialNumber: string;
                isSpare: boolean;
                isConnectedToBackend: boolean;
                deviceType: DeviceType;
              }
            | {
                __typename?: 'ControllerHardwareDevice';
                serialNumber: string;
                isSpare: boolean;
                isConnectedToBackend: boolean;
                deviceType: DeviceType;
              }
            | {
                __typename?: 'PowerDistributionUnitHardwareDevice';
                serialNumber: string;
                isSpare: boolean;
                isConnectedToBackend: boolean;
                deviceType: DeviceType;
              }
            | {
                __typename?: 'SwitchHardwareDevice';
                serialNumber: string;
                isSpare: boolean;
                isConnectedToBackend: boolean;
                deviceType: DeviceType;
              }
            | null;
        }
      | {
          __typename?: 'ControllerVirtualDevice';
          label: string;
          hardwareDevice?:
            | {
                __typename?: 'AccessPointHardwareDevice';
                serialNumber: string;
                isSpare: boolean;
                isConnectedToBackend: boolean;
                deviceType: DeviceType;
              }
            | {
                __typename?: 'ControllerHardwareDevice';
                serialNumber: string;
                isSpare: boolean;
                isConnectedToBackend: boolean;
                deviceType: DeviceType;
              }
            | {
                __typename?: 'PowerDistributionUnitHardwareDevice';
                serialNumber: string;
                isSpare: boolean;
                isConnectedToBackend: boolean;
                deviceType: DeviceType;
              }
            | {
                __typename?: 'SwitchHardwareDevice';
                serialNumber: string;
                isSpare: boolean;
                isConnectedToBackend: boolean;
                deviceType: DeviceType;
              }
            | null;
        }
      | {
          __typename?: 'ObserverVirtualDevice';
          label: string;
          hardwareDevice?:
            | {
                __typename?: 'AccessPointHardwareDevice';
                serialNumber: string;
                isSpare: boolean;
                isConnectedToBackend: boolean;
                deviceType: DeviceType;
              }
            | {
                __typename?: 'ControllerHardwareDevice';
                serialNumber: string;
                isSpare: boolean;
                isConnectedToBackend: boolean;
                deviceType: DeviceType;
              }
            | {
                __typename?: 'PowerDistributionUnitHardwareDevice';
                serialNumber: string;
                isSpare: boolean;
                isConnectedToBackend: boolean;
                deviceType: DeviceType;
              }
            | {
                __typename?: 'SwitchHardwareDevice';
                serialNumber: string;
                isSpare: boolean;
                isConnectedToBackend: boolean;
                deviceType: DeviceType;
              }
            | null;
        }
      | {
          __typename?: 'PowerDistributionUnitVirtualDevice';
          label: string;
          hardwareDevice?:
            | {
                __typename?: 'AccessPointHardwareDevice';
                serialNumber: string;
                isSpare: boolean;
                isConnectedToBackend: boolean;
                deviceType: DeviceType;
              }
            | {
                __typename?: 'ControllerHardwareDevice';
                serialNumber: string;
                isSpare: boolean;
                isConnectedToBackend: boolean;
                deviceType: DeviceType;
              }
            | {
                __typename?: 'PowerDistributionUnitHardwareDevice';
                serialNumber: string;
                isSpare: boolean;
                isConnectedToBackend: boolean;
                deviceType: DeviceType;
              }
            | {
                __typename?: 'SwitchHardwareDevice';
                serialNumber: string;
                isSpare: boolean;
                isConnectedToBackend: boolean;
                deviceType: DeviceType;
              }
            | null;
        }
      | {
          __typename?: 'SwitchVirtualDevice';
          label: string;
          hardwareDevice?:
            | {
                __typename?: 'AccessPointHardwareDevice';
                serialNumber: string;
                isSpare: boolean;
                isConnectedToBackend: boolean;
                deviceType: DeviceType;
              }
            | {
                __typename?: 'ControllerHardwareDevice';
                serialNumber: string;
                isSpare: boolean;
                isConnectedToBackend: boolean;
                deviceType: DeviceType;
              }
            | {
                __typename?: 'PowerDistributionUnitHardwareDevice';
                serialNumber: string;
                isSpare: boolean;
                isConnectedToBackend: boolean;
                deviceType: DeviceType;
              }
            | {
                __typename?: 'SwitchHardwareDevice';
                serialNumber: string;
                isSpare: boolean;
                isConnectedToBackend: boolean;
                deviceType: DeviceType;
              }
            | null;
        };
  };
  boundVLANs: Array<{ __typename?: 'VLAN'; UUID: string; vlanID: number; name: string }>;
  status?: {
    __typename?: 'IPSecTunnelStatus';
    observedAt: string;
    saStatus: IpSecSaStatus;
    uniqueID: string;
    remoteHostIP4Address: string;
    establishedAt: string;
    rekeyAt: string;
    reauthAt: string;
    childSAStatus: IpSecChildSaStatus;
    rxBytes: number;
    txBytes: number;
    rxPackets: number;
    rxLast: string;
    txLast: string;
    childRekeyAt: string;
    childLifetime: string;
    latencyMs: number;
  } | null;
};

export type IpSecTunnelsQueryQueryVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
}>;

export type IpSecTunnelsQueryQuery = {
  __typename?: 'Query';
  ipSecTunnelsForNetwork: Array<{
    __typename: 'IPSecTunnel';
    UUID: string;
    name: string;
    isEnabled: boolean;
    isInitiator: boolean;
    authenticationAlgorithm?: IpSecAuthenticationAlgorithm | null;
    encryptionAlgorithm?: IpSecEncryptionAlgorithm | null;
    keyExchangeDHGroup?: IpSecDhGroup | null;
    right?: string | null;
    rightPrefixes: Array<string>;
    rightID: string;
    leftID: string;
    isClientVPNBound: boolean;
    peerType?: IpSecPeerType | null;
    dpdAction?: IpSecDpdAction | null;
    dpdTimeout?: string | null;
    dpdDelay?: string | null;
    ikeLifetime?: string | null;
    rekey: boolean;
    reauth: boolean;
    boundPhyInterface: {
      __typename?: 'PhyInterface';
      UUID: string;
      label?: string | null;
      portNumber: number;
      virtualDevice:
        | {
            __typename?: 'AccessPointVirtualDevice';
            label: string;
            hardwareDevice?:
              | {
                  __typename?: 'AccessPointHardwareDevice';
                  serialNumber: string;
                  isSpare: boolean;
                  isConnectedToBackend: boolean;
                  deviceType: DeviceType;
                }
              | {
                  __typename?: 'ControllerHardwareDevice';
                  serialNumber: string;
                  isSpare: boolean;
                  isConnectedToBackend: boolean;
                  deviceType: DeviceType;
                }
              | {
                  __typename?: 'PowerDistributionUnitHardwareDevice';
                  serialNumber: string;
                  isSpare: boolean;
                  isConnectedToBackend: boolean;
                  deviceType: DeviceType;
                }
              | {
                  __typename?: 'SwitchHardwareDevice';
                  serialNumber: string;
                  isSpare: boolean;
                  isConnectedToBackend: boolean;
                  deviceType: DeviceType;
                }
              | null;
          }
        | {
            __typename?: 'ControllerVirtualDevice';
            label: string;
            hardwareDevice?:
              | {
                  __typename?: 'AccessPointHardwareDevice';
                  serialNumber: string;
                  isSpare: boolean;
                  isConnectedToBackend: boolean;
                  deviceType: DeviceType;
                }
              | {
                  __typename?: 'ControllerHardwareDevice';
                  serialNumber: string;
                  isSpare: boolean;
                  isConnectedToBackend: boolean;
                  deviceType: DeviceType;
                }
              | {
                  __typename?: 'PowerDistributionUnitHardwareDevice';
                  serialNumber: string;
                  isSpare: boolean;
                  isConnectedToBackend: boolean;
                  deviceType: DeviceType;
                }
              | {
                  __typename?: 'SwitchHardwareDevice';
                  serialNumber: string;
                  isSpare: boolean;
                  isConnectedToBackend: boolean;
                  deviceType: DeviceType;
                }
              | null;
          }
        | {
            __typename?: 'ObserverVirtualDevice';
            label: string;
            hardwareDevice?:
              | {
                  __typename?: 'AccessPointHardwareDevice';
                  serialNumber: string;
                  isSpare: boolean;
                  isConnectedToBackend: boolean;
                  deviceType: DeviceType;
                }
              | {
                  __typename?: 'ControllerHardwareDevice';
                  serialNumber: string;
                  isSpare: boolean;
                  isConnectedToBackend: boolean;
                  deviceType: DeviceType;
                }
              | {
                  __typename?: 'PowerDistributionUnitHardwareDevice';
                  serialNumber: string;
                  isSpare: boolean;
                  isConnectedToBackend: boolean;
                  deviceType: DeviceType;
                }
              | {
                  __typename?: 'SwitchHardwareDevice';
                  serialNumber: string;
                  isSpare: boolean;
                  isConnectedToBackend: boolean;
                  deviceType: DeviceType;
                }
              | null;
          }
        | {
            __typename?: 'PowerDistributionUnitVirtualDevice';
            label: string;
            hardwareDevice?:
              | {
                  __typename?: 'AccessPointHardwareDevice';
                  serialNumber: string;
                  isSpare: boolean;
                  isConnectedToBackend: boolean;
                  deviceType: DeviceType;
                }
              | {
                  __typename?: 'ControllerHardwareDevice';
                  serialNumber: string;
                  isSpare: boolean;
                  isConnectedToBackend: boolean;
                  deviceType: DeviceType;
                }
              | {
                  __typename?: 'PowerDistributionUnitHardwareDevice';
                  serialNumber: string;
                  isSpare: boolean;
                  isConnectedToBackend: boolean;
                  deviceType: DeviceType;
                }
              | {
                  __typename?: 'SwitchHardwareDevice';
                  serialNumber: string;
                  isSpare: boolean;
                  isConnectedToBackend: boolean;
                  deviceType: DeviceType;
                }
              | null;
          }
        | {
            __typename?: 'SwitchVirtualDevice';
            label: string;
            hardwareDevice?:
              | {
                  __typename?: 'AccessPointHardwareDevice';
                  serialNumber: string;
                  isSpare: boolean;
                  isConnectedToBackend: boolean;
                  deviceType: DeviceType;
                }
              | {
                  __typename?: 'ControllerHardwareDevice';
                  serialNumber: string;
                  isSpare: boolean;
                  isConnectedToBackend: boolean;
                  deviceType: DeviceType;
                }
              | {
                  __typename?: 'PowerDistributionUnitHardwareDevice';
                  serialNumber: string;
                  isSpare: boolean;
                  isConnectedToBackend: boolean;
                  deviceType: DeviceType;
                }
              | {
                  __typename?: 'SwitchHardwareDevice';
                  serialNumber: string;
                  isSpare: boolean;
                  isConnectedToBackend: boolean;
                  deviceType: DeviceType;
                }
              | null;
          };
    };
    boundVLANs: Array<{ __typename?: 'VLAN'; UUID: string; vlanID: number; name: string }>;
    status?: {
      __typename?: 'IPSecTunnelStatus';
      observedAt: string;
      saStatus: IpSecSaStatus;
      uniqueID: string;
      remoteHostIP4Address: string;
      establishedAt: string;
      rekeyAt: string;
      reauthAt: string;
      childSAStatus: IpSecChildSaStatus;
      rxBytes: number;
      txBytes: number;
      rxPackets: number;
      rxLast: string;
      txLast: string;
      childRekeyAt: string;
      childLifetime: string;
      latencyMs: number;
    } | null;
  }>;
};

export type IpSecTunnelQueryQueryVariables = Exact<{
  UUID: Scalars['UUID']['input'];
}>;

export type IpSecTunnelQueryQuery = {
  __typename?: 'Query';
  ipSecTunnel: {
    __typename: 'IPSecTunnel';
    UUID: string;
    name: string;
    isEnabled: boolean;
    isInitiator: boolean;
    authenticationAlgorithm?: IpSecAuthenticationAlgorithm | null;
    encryptionAlgorithm?: IpSecEncryptionAlgorithm | null;
    keyExchangeDHGroup?: IpSecDhGroup | null;
    right?: string | null;
    rightPrefixes: Array<string>;
    rightID: string;
    leftID: string;
    isClientVPNBound: boolean;
    peerType?: IpSecPeerType | null;
    dpdAction?: IpSecDpdAction | null;
    dpdTimeout?: string | null;
    dpdDelay?: string | null;
    ikeLifetime?: string | null;
    rekey: boolean;
    reauth: boolean;
    boundPhyInterface: {
      __typename?: 'PhyInterface';
      UUID: string;
      label?: string | null;
      portNumber: number;
      virtualDevice:
        | {
            __typename?: 'AccessPointVirtualDevice';
            label: string;
            hardwareDevice?:
              | {
                  __typename?: 'AccessPointHardwareDevice';
                  serialNumber: string;
                  isSpare: boolean;
                  isConnectedToBackend: boolean;
                  deviceType: DeviceType;
                }
              | {
                  __typename?: 'ControllerHardwareDevice';
                  serialNumber: string;
                  isSpare: boolean;
                  isConnectedToBackend: boolean;
                  deviceType: DeviceType;
                }
              | {
                  __typename?: 'PowerDistributionUnitHardwareDevice';
                  serialNumber: string;
                  isSpare: boolean;
                  isConnectedToBackend: boolean;
                  deviceType: DeviceType;
                }
              | {
                  __typename?: 'SwitchHardwareDevice';
                  serialNumber: string;
                  isSpare: boolean;
                  isConnectedToBackend: boolean;
                  deviceType: DeviceType;
                }
              | null;
          }
        | {
            __typename?: 'ControllerVirtualDevice';
            label: string;
            hardwareDevice?:
              | {
                  __typename?: 'AccessPointHardwareDevice';
                  serialNumber: string;
                  isSpare: boolean;
                  isConnectedToBackend: boolean;
                  deviceType: DeviceType;
                }
              | {
                  __typename?: 'ControllerHardwareDevice';
                  serialNumber: string;
                  isSpare: boolean;
                  isConnectedToBackend: boolean;
                  deviceType: DeviceType;
                }
              | {
                  __typename?: 'PowerDistributionUnitHardwareDevice';
                  serialNumber: string;
                  isSpare: boolean;
                  isConnectedToBackend: boolean;
                  deviceType: DeviceType;
                }
              | {
                  __typename?: 'SwitchHardwareDevice';
                  serialNumber: string;
                  isSpare: boolean;
                  isConnectedToBackend: boolean;
                  deviceType: DeviceType;
                }
              | null;
          }
        | {
            __typename?: 'ObserverVirtualDevice';
            label: string;
            hardwareDevice?:
              | {
                  __typename?: 'AccessPointHardwareDevice';
                  serialNumber: string;
                  isSpare: boolean;
                  isConnectedToBackend: boolean;
                  deviceType: DeviceType;
                }
              | {
                  __typename?: 'ControllerHardwareDevice';
                  serialNumber: string;
                  isSpare: boolean;
                  isConnectedToBackend: boolean;
                  deviceType: DeviceType;
                }
              | {
                  __typename?: 'PowerDistributionUnitHardwareDevice';
                  serialNumber: string;
                  isSpare: boolean;
                  isConnectedToBackend: boolean;
                  deviceType: DeviceType;
                }
              | {
                  __typename?: 'SwitchHardwareDevice';
                  serialNumber: string;
                  isSpare: boolean;
                  isConnectedToBackend: boolean;
                  deviceType: DeviceType;
                }
              | null;
          }
        | {
            __typename?: 'PowerDistributionUnitVirtualDevice';
            label: string;
            hardwareDevice?:
              | {
                  __typename?: 'AccessPointHardwareDevice';
                  serialNumber: string;
                  isSpare: boolean;
                  isConnectedToBackend: boolean;
                  deviceType: DeviceType;
                }
              | {
                  __typename?: 'ControllerHardwareDevice';
                  serialNumber: string;
                  isSpare: boolean;
                  isConnectedToBackend: boolean;
                  deviceType: DeviceType;
                }
              | {
                  __typename?: 'PowerDistributionUnitHardwareDevice';
                  serialNumber: string;
                  isSpare: boolean;
                  isConnectedToBackend: boolean;
                  deviceType: DeviceType;
                }
              | {
                  __typename?: 'SwitchHardwareDevice';
                  serialNumber: string;
                  isSpare: boolean;
                  isConnectedToBackend: boolean;
                  deviceType: DeviceType;
                }
              | null;
          }
        | {
            __typename?: 'SwitchVirtualDevice';
            label: string;
            hardwareDevice?:
              | {
                  __typename?: 'AccessPointHardwareDevice';
                  serialNumber: string;
                  isSpare: boolean;
                  isConnectedToBackend: boolean;
                  deviceType: DeviceType;
                }
              | {
                  __typename?: 'ControllerHardwareDevice';
                  serialNumber: string;
                  isSpare: boolean;
                  isConnectedToBackend: boolean;
                  deviceType: DeviceType;
                }
              | {
                  __typename?: 'PowerDistributionUnitHardwareDevice';
                  serialNumber: string;
                  isSpare: boolean;
                  isConnectedToBackend: boolean;
                  deviceType: DeviceType;
                }
              | {
                  __typename?: 'SwitchHardwareDevice';
                  serialNumber: string;
                  isSpare: boolean;
                  isConnectedToBackend: boolean;
                  deviceType: DeviceType;
                }
              | null;
          };
    };
    boundVLANs: Array<{ __typename?: 'VLAN'; UUID: string; vlanID: number; name: string }>;
    status?: {
      __typename?: 'IPSecTunnelStatus';
      observedAt: string;
      saStatus: IpSecSaStatus;
      uniqueID: string;
      remoteHostIP4Address: string;
      establishedAt: string;
      rekeyAt: string;
      reauthAt: string;
      childSAStatus: IpSecChildSaStatus;
      rxBytes: number;
      txBytes: number;
      rxPackets: number;
      rxLast: string;
      txLast: string;
      childRekeyAt: string;
      childLifetime: string;
      latencyMs: number;
    } | null;
  };
};

export type UpdateIpSecTunnelMutationVariables = Exact<{
  uuid: Scalars['UUID']['input'];
  input: UpdateIpSecTunnelInput;
}>;

export type UpdateIpSecTunnelMutation = {
  __typename?: 'Mutation';
  updateIPSecTunnel: { __typename?: 'IPSecTunnel'; UUID: string };
};

export type DeleteIpSecTunnelMutationVariables = Exact<{
  uuid: Scalars['UUID']['input'];
}>;

export type DeleteIpSecTunnelMutation = {
  __typename?: 'Mutation';
  deleteIPSecTunnel: { __typename?: 'IPSecTunnel'; UUID: string };
};

export type CreateIpSecTunnelMutationVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
  input: CreateIpSecTunnelInput;
}>;

export type CreateIpSecTunnelMutation = {
  __typename?: 'Mutation';
  createIPSecTunnel: { __typename?: 'IPSecTunnel'; UUID: string };
};

export type RpcRestartIpSecTunnelMutationVariables = Exact<{
  serialNumber: Scalars['String']['input'];
  ipSecTunnelUUID: Scalars['UUID']['input'];
}>;

export type RpcRestartIpSecTunnelMutation = {
  __typename?: 'Mutation';
  rpcRestartIPSecTunnel: boolean;
};

export type IpSecTunnelMetricsQueryQueryVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
  UUID: Scalars['UUID']['input'];
  filter: MetricsFilterInput;
}>;

export type IpSecTunnelMetricsQueryQuery = {
  __typename?: 'Query';
  ipSecTunnelMetrics: Array<{
    __typename?: 'IPSecTunnelMetricsTimeseriesResponse';
    ipSecTunnel: { __typename?: 'IPSecTunnel'; UUID: string };
    txBytes: {
      __typename?: 'BaseMetricsResponse';
      metadata?: { __typename?: 'MetricsMetadata'; minValue: number; maxValue: number } | null;
      values: Array<{ __typename?: 'BaseMetricsValue'; timestamp: string; value: number }>;
    };
    rxBytes: {
      __typename?: 'BaseMetricsResponse';
      metadata?: { __typename?: 'MetricsMetadata'; minValue: number; maxValue: number } | null;
      values: Array<{ __typename?: 'BaseMetricsValue'; timestamp: string; value: number }>;
    };
    txPackets: {
      __typename?: 'BaseMetricsResponse';
      metadata?: { __typename?: 'MetricsMetadata'; minValue: number; maxValue: number } | null;
      values: Array<{ __typename?: 'BaseMetricsValue'; timestamp: string; value: number }>;
    };
    rxPackets: {
      __typename?: 'BaseMetricsResponse';
      metadata?: { __typename?: 'MetricsMetadata'; minValue: number; maxValue: number } | null;
      values: Array<{ __typename?: 'BaseMetricsValue'; timestamp: string; value: number }>;
    };
    latencyMs: {
      __typename?: 'BaseMetricsResponse';
      metadata?: { __typename?: 'MetricsMetadata'; minValue: number; maxValue: number } | null;
      values: Array<{ __typename?: 'BaseMetricsValue'; timestamp: string; value: number }>;
    };
  }>;
};

export type VlaNsAndDhcpRulesQueryVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
}>;

export type VlaNsAndDhcpRulesQuery = {
  __typename?: 'Query';
  vlans: Array<{
    __typename: 'VLAN';
    UUID: string;
    name: string;
    description?: string | null;
    isEnabled: boolean;
    isInternal?: boolean | null;
    isDefault: boolean;
    vlanID: number;
    ipV4ClientAssignmentProtocol?: ClientAssignmentProtocol | null;
    ipV4ClientGateway?: string | null;
    ipV4ClientPrefixLength?: number | null;
    dhcpRule?: { __typename?: 'DHCPRule'; UUID: string; dnsUseGatewayProxy: boolean } | null;
  }>;
};

export type DnsFirewallRulesForNetworkQueryVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
}>;

export type DnsFirewallRulesForNetworkQuery = {
  __typename?: 'Query';
  applicationDNSFirewallRulesForNetwork: Array<{
    __typename?: 'ApplicationDNSFirewallRule';
    UUID: string;
    isEnabled: boolean;
    name: string;
    action: FirewallRuleAction;
    priority: number;
    domain?: string | null;
    category?: {
      __typename?: 'ApplicationDNSFirewallRuleCategory';
      id: number;
      name: string;
      description: string;
      group: { __typename?: 'ApplicationDNSFirewallRuleGroup'; id: number; name: string };
    } | null;
    group?: { __typename?: 'ApplicationDNSFirewallRuleGroup'; id: number; name: string } | null;
    application?: {
      __typename?: 'ApplicationDNSFirewallRuleApplication';
      id: number;
      name: string;
    } | null;
    boundDHCPRules?: Array<{
      __typename?: 'DHCPRule';
      UUID: string;
      vlan: { __typename?: 'VLAN'; UUID: string; name: string; vlanID: number };
    }> | null;
  }>;
};

export type DnsFirewallRuleQueryVariables = Exact<{
  uuid: Scalars['UUID']['input'];
}>;

export type DnsFirewallRuleQuery = {
  __typename?: 'Query';
  applicationDNSFirewallRule: {
    __typename?: 'ApplicationDNSFirewallRule';
    UUID: string;
    isEnabled: boolean;
    name: string;
    action: FirewallRuleAction;
    priority: number;
    domain?: string | null;
    category?: {
      __typename?: 'ApplicationDNSFirewallRuleCategory';
      id: number;
      name: string;
      description: string;
      group: { __typename?: 'ApplicationDNSFirewallRuleGroup'; id: number; name: string };
    } | null;
    group?: { __typename?: 'ApplicationDNSFirewallRuleGroup'; id: number; name: string } | null;
    application?: {
      __typename?: 'ApplicationDNSFirewallRuleApplication';
      id: number;
      name: string;
    } | null;
    boundDHCPRules?: Array<{
      __typename?: 'DHCPRule';
      UUID: string;
      vlan: { __typename?: 'VLAN'; UUID: string; name: string; vlanID: number };
    }> | null;
  };
};

export type CreateDnsFirewallRuleMutationVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
  input: CreateApplicationDnsFirewallRuleInput;
}>;

export type CreateDnsFirewallRuleMutation = {
  __typename?: 'Mutation';
  createApplicationDNSFirewallRule: { __typename?: 'ApplicationDNSFirewallRule'; UUID: string };
};

export type UpdateDnsFirewallRuleMutationVariables = Exact<{
  uuid: Scalars['UUID']['input'];
  input: UpdateApplicationDnsFirewallRuleInput;
}>;

export type UpdateDnsFirewallRuleMutation = {
  __typename?: 'Mutation';
  updateApplicationDNSFirewallRule: { __typename?: 'ApplicationDNSFirewallRule'; UUID: string };
};

export type DeleteDnsFirewallRuleMutationVariables = Exact<{
  uuid: Scalars['UUID']['input'];
}>;

export type DeleteDnsFirewallRuleMutation = {
  __typename?: 'Mutation';
  deleteApplicationDNSFirewallRule: { __typename?: 'ApplicationDNSFirewallRule'; UUID: string };
};

export type UpdateDnsFirewallRulesMutationVariables = Exact<{
  inputs: Array<UpdateApplicationDnsFirewallRulesInput> | UpdateApplicationDnsFirewallRulesInput;
}>;

export type UpdateDnsFirewallRulesMutation = {
  __typename?: 'Mutation';
  updateApplicationDNSFirewallRules: Array<{
    __typename?: 'ApplicationDNSFirewallRule';
    UUID: string;
    priority: number;
  }>;
};

export type DnsFirewallRuleCategoriesQueryVariables = Exact<{ [key: string]: never }>;

export type DnsFirewallRuleCategoriesQuery = {
  __typename?: 'Query';
  applicationDNSFirewallRuleCategories: Array<{
    __typename?: 'ApplicationDNSFirewallRuleCategory';
    id: number;
    name: string;
    description: string;
    group: { __typename?: 'ApplicationDNSFirewallRuleGroup'; id: number; name: string };
  }>;
};

export type DnsFirewallRuleGroupsQueryVariables = Exact<{ [key: string]: never }>;

export type DnsFirewallRuleGroupsQuery = {
  __typename?: 'Query';
  applicationDNSFirewallRuleGroups: Array<{
    __typename?: 'ApplicationDNSFirewallRuleGroup';
    id: number;
    name: string;
  }>;
};

export type DnsFirewallRuleApplicationsQueryVariables = Exact<{ [key: string]: never }>;

export type DnsFirewallRuleApplicationsQuery = {
  __typename?: 'Query';
  applicationDNSFirewallRuleApplications: Array<{
    __typename?: 'ApplicationDNSFirewallRuleApplication';
    id: number;
    name: string;
  }>;
};

export type DnsDomainApplicationQueryVariables = Exact<{
  hostname: Scalars['String']['input'];
}>;

export type DnsDomainApplicationQuery = {
  __typename?: 'Query';
  applicationDNSFirewallRuleApplicationForHostname: {
    __typename?: 'ApplicationDNSFirewallRuleApplication';
    id: number;
    isVisible: boolean;
    name: string;
  };
};

export type DnsDomainCategoryQueryVariables = Exact<{
  hostname: Scalars['String']['input'];
}>;

export type DnsDomainCategoryQuery = {
  __typename?: 'Query';
  applicationDNSFirewallRuleCategoryForHostname: {
    __typename?: 'ApplicationDNSFirewallRuleCategory';
    id: number;
    name: string;
    description: string;
    group: { __typename?: 'ApplicationDNSFirewallRuleGroup'; id: number; name: string };
  };
};

export type IdsipsCustomRuleQueryVariables = Exact<{
  uuid: Scalars['UUID']['input'];
}>;

export type IdsipsCustomRuleQuery = {
  __typename?: 'Query';
  idsIPSCustomRule: {
    __typename?: 'IDSIPSCustomRule';
    UUID: string;
    isEnabled: boolean;
    name: string;
    action: FirewallRuleAction;
    domain?: string | null;
    application?: {
      __typename?: 'ApplicationDNSFirewallRuleApplication';
      id: number;
      name: string;
    } | null;
    boundVLANs?: Array<{ __typename?: 'VLAN'; UUID: string; name: string; vlanID: number }> | null;
  };
};

export type CreateIdsipsCustomRuleMutationVariables = Exact<{
  configUUID: Scalars['UUID']['input'];
  input: CreateIdsipsCustomRuleInput;
}>;

export type CreateIdsipsCustomRuleMutation = {
  __typename?: 'Mutation';
  createIDSIPSCustomRule: { __typename?: 'IDSIPSCustomRule'; UUID: string };
};

export type UpdateIdsipsCustomRuleMutationVariables = Exact<{
  ruleUUID: Scalars['UUID']['input'];
  input: UpdateIdsipsCustomRuleInput;
}>;

export type UpdateIdsipsCustomRuleMutation = {
  __typename?: 'Mutation';
  updateIDSIPSCustomRule: { __typename?: 'IDSIPSCustomRule'; UUID: string };
};

export type DeleteIdsipsCustomRuleMutationVariables = Exact<{
  ruleUUID: Scalars['UUID']['input'];
}>;

export type DeleteIdsipsCustomRuleMutation = {
  __typename?: 'Mutation';
  deleteIDSIPSCustomRule: { __typename?: 'IDSIPSCustomRule'; UUID: string };
};

export type UpdateInterVlanCommunicationPermittedPairsMutationVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
  vlanPairs: Array<VlanPairInput> | VlanPairInput;
}>;

export type UpdateInterVlanCommunicationPermittedPairsMutation = {
  __typename?: 'Mutation';
  updateInterVLANCommunicationPermittedPairs: Array<{
    __typename?: 'InterVLANCommunicationPermittedPair';
    UUID: string;
  }>;
};

export type IdsipsCategoryFieldsFragment = {
  __typename?: 'IDSIPSCategory';
  UUID: string;
  shortname: string;
  shortDescription: string;
  priority: number;
  ruleCount: number;
};

export type IdsRuleFieldsFragment = {
  __typename?: 'IDSRule';
  SID: number;
  action: string;
  classType: string;
  groupID?: number | null;
  header: string;
  description?: string | null;
  revision: number;
  metadata: Array<string>;
  references: Array<{ __typename?: 'IDSRuleReference'; type: string; ref: string }>;
};

export type IdsipsCustomRuleFieldsFragment = {
  __typename?: 'IDSIPSCustomRule';
  UUID: string;
  isEnabled: boolean;
  name: string;
  action: FirewallRuleAction;
  domain?: string | null;
  application?: {
    __typename?: 'ApplicationDNSFirewallRuleApplication';
    id: number;
    name: string;
  } | null;
  boundVLANs?: Array<{ __typename?: 'VLAN'; UUID: string; name: string; vlanID: number }> | null;
};

export type IdsCategoryQueryVariables = Exact<{
  categoryUUID: Scalars['UUID']['input'];
}>;

export type IdsCategoryQuery = {
  __typename?: 'Query';
  idsIPSCategory: {
    __typename?: 'IDSIPSCategory';
    UUID: string;
    shortname: string;
    shortDescription: string;
    priority: number;
    ruleCount: number;
  };
};

export type IdsipsCategoriesQueryVariables = Exact<{ [key: string]: never }>;

export type IdsipsCategoriesQuery = {
  __typename?: 'Query';
  idsIPSCategories: Array<{
    __typename?: 'IDSIPSCategory';
    UUID: string;
    shortname: string;
    shortDescription: string;
    priority: number;
    ruleCount: number;
  }>;
};

export type IdsRuleQueryVariables = Exact<{
  ruleSID: Scalars['Int']['input'];
}>;

export type IdsRuleQuery = {
  __typename?: 'Query';
  idsRule: {
    __typename?: 'IDSRule';
    SID: number;
    action: string;
    classType: string;
    groupID?: number | null;
    header: string;
    description?: string | null;
    revision: number;
    metadata: Array<string>;
    references: Array<{ __typename?: 'IDSRuleReference'; type: string; ref: string }>;
  };
};

export type IdsipsConfigForNetworkQueryVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
}>;

export type IdsipsConfigForNetworkQuery = {
  __typename?: 'Query';
  network: {
    __typename?: 'Network';
    idsIPSConfig?: {
      __typename?: 'IDSIPSConfig';
      UUID: string;
      mode: IdsipsMode;
      minSeverity: number;
      minIPSSeverity?: number | null;
      isEastWestProtectionEnabled: boolean;
      ipsRuleDuration?: string | null;
      safelist?: Array<string> | null;
      sourceVersion: number;
      enabledVLANs: Array<{ __typename?: 'VLAN'; UUID: string; name: string; vlanID: number }>;
      boundCategories: Array<{
        __typename?: 'IDSIPSConfigCategoryBinding';
        categoryUUID: string;
        mode: IdsipsMode;
        category: {
          __typename?: 'IDSIPSCategory';
          UUID: string;
          shortname: string;
          shortDescription: string;
          priority: number;
          ruleCount: number;
        };
      }>;
      boundIDSRules: Array<{
        __typename?: 'IDSIPSConfigRuleBinding';
        ruleSID: number;
        mode: IdsipsMode;
        rule: {
          __typename?: 'IDSRule';
          SID: number;
          action: string;
          classType: string;
          groupID?: number | null;
          header: string;
          description?: string | null;
          revision: number;
          metadata: Array<string>;
          category?: {
            __typename?: 'IDSIPSCategory';
            UUID: string;
            shortname: string;
            shortDescription: string;
            priority: number;
            ruleCount: number;
          } | null;
          references: Array<{ __typename?: 'IDSRuleReference'; type: string; ref: string }>;
        };
      }>;
      suppressedRules: Array<{
        __typename?: 'IDSIPSConfigRuleSuppression';
        ruleSID: number;
        mode: IdsipsMode;
        ipPrefixes?: Array<string> | null;
        direction?: IdsipsSuppressedRuleDirection | null;
        description?: string | null;
        rule: {
          __typename?: 'IDSRule';
          SID: number;
          action: string;
          classType: string;
          groupID?: number | null;
          header: string;
          description?: string | null;
          revision: number;
          metadata: Array<string>;
          category?: {
            __typename?: 'IDSIPSCategory';
            UUID: string;
            shortname: string;
            shortDescription: string;
            priority: number;
            ruleCount: number;
          } | null;
          references: Array<{ __typename?: 'IDSRuleReference'; type: string; ref: string }>;
        };
      }>;
      suppressedCategories: Array<{
        __typename?: 'IDSIPSConfigCategorySuppression';
        UUID: string;
        categoryUUID: string;
        mode: IdsipsMode;
        ipPrefixes?: Array<string> | null;
        direction?: IdsipsSuppressedRuleDirection | null;
        description?: string | null;
        category: {
          __typename?: 'IDSIPSCategory';
          UUID: string;
          shortname: string;
          shortDescription: string;
          priority: number;
          ruleCount: number;
        };
      }>;
      customRules?: Array<{
        __typename?: 'IDSIPSCustomRule';
        UUID: string;
        isEnabled: boolean;
        name: string;
        action: FirewallRuleAction;
        domain?: string | null;
        application?: {
          __typename?: 'ApplicationDNSFirewallRuleApplication';
          id: number;
          name: string;
        } | null;
        boundVLANs?: Array<{
          __typename?: 'VLAN';
          UUID: string;
          name: string;
          vlanID: number;
        }> | null;
      }> | null;
    } | null;
  };
  idsIPSCategories: Array<{
    __typename?: 'IDSIPSCategory';
    UUID: string;
    shortname: string;
    shortDescription: string;
    priority: number;
    ruleCount: number;
  }>;
};

export type CreateIdsipsConfigMutationVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
  input: CreateIdsipsConfigInput;
}>;

export type CreateIdsipsConfigMutation = {
  __typename?: 'Mutation';
  createIDSIPSConfig: { __typename?: 'IDSIPSConfig'; UUID: string };
};

export type UpdateIdsipsConfigMutationVariables = Exact<{
  uuid: Scalars['UUID']['input'];
  input: UpdateIdsipsConfigInput;
}>;

export type UpdateIdsipsConfigMutation = {
  __typename?: 'Mutation';
  updateIDSIPSConfig: { __typename?: 'IDSIPSConfig'; UUID: string };
};

export type DeleteIdsipsConfigMutationVariables = Exact<{
  uuid: Scalars['UUID']['input'];
}>;

export type DeleteIdsipsConfigMutation = {
  __typename?: 'Mutation';
  deleteIDSIPSConfig: { __typename?: 'IDSIPSConfig'; UUID: string };
};

export type IdsEventFieldsFragment = {
  __typename?: 'IDSEvent';
  observedAt: string;
  timestamp: string;
  eventType: string;
  srcMAC?: string | null;
  srcIP?: string | null;
  srcPort: number;
  dstMAC?: string | null;
  dstIP?: string | null;
  dstPort: number;
  flowID: number;
  appProto?: string | null;
  protocol: IdsEventProtocol;
  direction: IdsEventDirection;
  virtualDevice:
    | {
        __typename?: 'AccessPointVirtualDevice';
        UUID: string;
        deviceType: VirtualDeviceType;
        label: string;
      }
    | {
        __typename?: 'ControllerVirtualDevice';
        UUID: string;
        deviceType: VirtualDeviceType;
        label: string;
      }
    | {
        __typename?: 'ObserverVirtualDevice';
        UUID: string;
        deviceType: VirtualDeviceType;
        label: string;
      }
    | {
        __typename?: 'PowerDistributionUnitVirtualDevice';
        UUID: string;
        deviceType: VirtualDeviceType;
        label: string;
      }
    | {
        __typename?: 'SwitchVirtualDevice';
        UUID: string;
        deviceType: VirtualDeviceType;
        label: string;
      };
  alert?: {
    __typename?: 'IDSEventAlert';
    action: IdsEventAlertAction;
    category: string;
    gid: number;
    sid: number;
    rev: number;
    rule?: string | null;
    severity: number;
    signature: string;
  } | null;
  httpInfo?: {
    __typename?: 'IDSEventHTTPInfo';
    hostname: string;
    url: string;
    userAgent: string;
    contentType: string;
    protocol: string;
    status: number;
    length: number;
  } | null;
  tlsInfo?: { __typename?: 'IDSEventTLSInfo'; sni: string } | null;
  flow?: {
    __typename?: 'IDSEventFlowInfo';
    packetsToServer: number;
    packetsToClient: number;
    bytesToServer: number;
    bytesToClient: number;
    start?: string | null;
    end?: string | null;
    reason?: string | null;
  } | null;
  firewallRule?: { __typename?: 'FirewallRule'; UUID: string; name: string } | null;
  ipsRule?: {
    __typename?: 'IDSEventIPSRule';
    protocol: IdsEventProtocol;
    srcPrefix: string;
    dstPrefix: string;
    durationSec: number;
    srcPortRange: { __typename?: 'PortRange'; lower: number; upper: number };
    dstPortRange: { __typename?: 'PortRange'; lower: number; upper: number };
    vlanBindings?: Array<{ __typename: 'VLAN'; UUID: string; name: string; vlanID: number }> | null;
    phyInterfaceBindings?: Array<{
      __typename: 'PhyInterface';
      UUID: string;
      portNumber: number;
      label?: string | null;
      hardwareLabel?: string | null;
      virtualDevice:
        | {
            __typename?: 'AccessPointVirtualDevice';
            UUID: string;
            label: string;
            deviceModel: DeviceModel;
          }
        | {
            __typename?: 'ControllerVirtualDevice';
            UUID: string;
            label: string;
            deviceModel: DeviceModel;
          }
        | {
            __typename?: 'ObserverVirtualDevice';
            UUID: string;
            label: string;
            deviceModel: DeviceModel;
          }
        | {
            __typename?: 'PowerDistributionUnitVirtualDevice';
            UUID: string;
            label: string;
            deviceModel: DeviceModel;
          }
        | {
            __typename?: 'SwitchVirtualDevice';
            UUID: string;
            label: string;
            deviceModel: DeviceModel;
          };
      internetServicePlan?: {
        __typename?: 'InternetServicePlan';
        UUID: string;
        provider?: { __typename?: 'InternetServicePlanProvider'; name: string } | null;
      } | null;
    }> | null;
  } | null;
};

export type IdsEventsForNetworkQueryVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  durationSeconds?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<IdsEventFilterInput>;
}>;

export type IdsEventsForNetworkQuery = {
  __typename?: 'Query';
  idsEvents: {
    __typename?: 'IDSEventsPage';
    total: number;
    events?: Array<{
      __typename?: 'IDSEvent';
      observedAt: string;
      timestamp: string;
      eventType: string;
      srcMAC?: string | null;
      srcIP?: string | null;
      srcPort: number;
      dstMAC?: string | null;
      dstIP?: string | null;
      dstPort: number;
      flowID: number;
      appProto?: string | null;
      protocol: IdsEventProtocol;
      direction: IdsEventDirection;
      virtualDevice:
        | {
            __typename?: 'AccessPointVirtualDevice';
            UUID: string;
            deviceType: VirtualDeviceType;
            label: string;
          }
        | {
            __typename?: 'ControllerVirtualDevice';
            UUID: string;
            deviceType: VirtualDeviceType;
            label: string;
          }
        | {
            __typename?: 'ObserverVirtualDevice';
            UUID: string;
            deviceType: VirtualDeviceType;
            label: string;
          }
        | {
            __typename?: 'PowerDistributionUnitVirtualDevice';
            UUID: string;
            deviceType: VirtualDeviceType;
            label: string;
          }
        | {
            __typename?: 'SwitchVirtualDevice';
            UUID: string;
            deviceType: VirtualDeviceType;
            label: string;
          };
      alert?: {
        __typename?: 'IDSEventAlert';
        action: IdsEventAlertAction;
        category: string;
        gid: number;
        sid: number;
        rev: number;
        rule?: string | null;
        severity: number;
        signature: string;
      } | null;
      httpInfo?: {
        __typename?: 'IDSEventHTTPInfo';
        hostname: string;
        url: string;
        userAgent: string;
        contentType: string;
        protocol: string;
        status: number;
        length: number;
      } | null;
      tlsInfo?: { __typename?: 'IDSEventTLSInfo'; sni: string } | null;
      flow?: {
        __typename?: 'IDSEventFlowInfo';
        packetsToServer: number;
        packetsToClient: number;
        bytesToServer: number;
        bytesToClient: number;
        start?: string | null;
        end?: string | null;
        reason?: string | null;
      } | null;
      firewallRule?: { __typename?: 'FirewallRule'; UUID: string; name: string } | null;
      ipsRule?: {
        __typename?: 'IDSEventIPSRule';
        protocol: IdsEventProtocol;
        srcPrefix: string;
        dstPrefix: string;
        durationSec: number;
        srcPortRange: { __typename?: 'PortRange'; lower: number; upper: number };
        dstPortRange: { __typename?: 'PortRange'; lower: number; upper: number };
        vlanBindings?: Array<{
          __typename: 'VLAN';
          UUID: string;
          name: string;
          vlanID: number;
        }> | null;
        phyInterfaceBindings?: Array<{
          __typename: 'PhyInterface';
          UUID: string;
          portNumber: number;
          label?: string | null;
          hardwareLabel?: string | null;
          virtualDevice:
            | {
                __typename?: 'AccessPointVirtualDevice';
                UUID: string;
                label: string;
                deviceModel: DeviceModel;
              }
            | {
                __typename?: 'ControllerVirtualDevice';
                UUID: string;
                label: string;
                deviceModel: DeviceModel;
              }
            | {
                __typename?: 'ObserverVirtualDevice';
                UUID: string;
                label: string;
                deviceModel: DeviceModel;
              }
            | {
                __typename?: 'PowerDistributionUnitVirtualDevice';
                UUID: string;
                label: string;
                deviceModel: DeviceModel;
              }
            | {
                __typename?: 'SwitchVirtualDevice';
                UUID: string;
                label: string;
                deviceModel: DeviceModel;
              };
          internetServicePlan?: {
            __typename?: 'InternetServicePlan';
            UUID: string;
            provider?: { __typename?: 'InternetServicePlanProvider'; name: string } | null;
          } | null;
        }> | null;
      } | null;
    }> | null;
  };
};

export type IdsEventQueryVariables = Exact<{
  virtualDeviceUUID: Scalars['UUID']['input'];
  observedAt: Scalars['DateTime']['input'];
}>;

export type IdsEventQuery = {
  __typename?: 'Query';
  idsEvent: {
    __typename?: 'IDSEvent';
    observedAt: string;
    timestamp: string;
    eventType: string;
    srcMAC?: string | null;
    srcIP?: string | null;
    srcPort: number;
    dstMAC?: string | null;
    dstIP?: string | null;
    dstPort: number;
    flowID: number;
    appProto?: string | null;
    protocol: IdsEventProtocol;
    direction: IdsEventDirection;
    virtualDevice:
      | {
          __typename?: 'AccessPointVirtualDevice';
          UUID: string;
          deviceType: VirtualDeviceType;
          label: string;
        }
      | {
          __typename?: 'ControllerVirtualDevice';
          UUID: string;
          deviceType: VirtualDeviceType;
          label: string;
        }
      | {
          __typename?: 'ObserverVirtualDevice';
          UUID: string;
          deviceType: VirtualDeviceType;
          label: string;
        }
      | {
          __typename?: 'PowerDistributionUnitVirtualDevice';
          UUID: string;
          deviceType: VirtualDeviceType;
          label: string;
        }
      | {
          __typename?: 'SwitchVirtualDevice';
          UUID: string;
          deviceType: VirtualDeviceType;
          label: string;
        };
    alert?: {
      __typename?: 'IDSEventAlert';
      action: IdsEventAlertAction;
      category: string;
      gid: number;
      sid: number;
      rev: number;
      rule?: string | null;
      severity: number;
      signature: string;
    } | null;
    httpInfo?: {
      __typename?: 'IDSEventHTTPInfo';
      hostname: string;
      url: string;
      userAgent: string;
      contentType: string;
      protocol: string;
      status: number;
      length: number;
    } | null;
    tlsInfo?: { __typename?: 'IDSEventTLSInfo'; sni: string } | null;
    flow?: {
      __typename?: 'IDSEventFlowInfo';
      packetsToServer: number;
      packetsToClient: number;
      bytesToServer: number;
      bytesToClient: number;
      start?: string | null;
      end?: string | null;
      reason?: string | null;
    } | null;
    firewallRule?: { __typename?: 'FirewallRule'; UUID: string; name: string } | null;
    ipsRule?: {
      __typename?: 'IDSEventIPSRule';
      protocol: IdsEventProtocol;
      srcPrefix: string;
      dstPrefix: string;
      durationSec: number;
      srcPortRange: { __typename?: 'PortRange'; lower: number; upper: number };
      dstPortRange: { __typename?: 'PortRange'; lower: number; upper: number };
      vlanBindings?: Array<{
        __typename: 'VLAN';
        UUID: string;
        name: string;
        vlanID: number;
      }> | null;
      phyInterfaceBindings?: Array<{
        __typename: 'PhyInterface';
        UUID: string;
        portNumber: number;
        label?: string | null;
        hardwareLabel?: string | null;
        virtualDevice:
          | {
              __typename?: 'AccessPointVirtualDevice';
              UUID: string;
              label: string;
              deviceModel: DeviceModel;
            }
          | {
              __typename?: 'ControllerVirtualDevice';
              UUID: string;
              label: string;
              deviceModel: DeviceModel;
            }
          | {
              __typename?: 'ObserverVirtualDevice';
              UUID: string;
              label: string;
              deviceModel: DeviceModel;
            }
          | {
              __typename?: 'PowerDistributionUnitVirtualDevice';
              UUID: string;
              label: string;
              deviceModel: DeviceModel;
            }
          | {
              __typename?: 'SwitchVirtualDevice';
              UUID: string;
              label: string;
              deviceModel: DeviceModel;
            };
        internetServicePlan?: {
          __typename?: 'InternetServicePlan';
          UUID: string;
          provider?: { __typename?: 'InternetServicePlanProvider'; name: string } | null;
        } | null;
      }> | null;
    } | null;
  };
};

export type IpsEventsForNetworkQueryVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  durationSeconds?: InputMaybe<Scalars['Int']['input']>;
  idsFilter?: InputMaybe<IdsEventFilterInput>;
}>;

export type IpsEventsForNetworkQuery = {
  __typename?: 'Query';
  ipsEvents: {
    __typename?: 'IDSEventsPage';
    total: number;
    events?: Array<{
      __typename?: 'IDSEvent';
      observedAt: string;
      timestamp: string;
      eventType: string;
      srcMAC?: string | null;
      srcIP?: string | null;
      srcPort: number;
      dstMAC?: string | null;
      dstIP?: string | null;
      dstPort: number;
      flowID: number;
      appProto?: string | null;
      protocol: IdsEventProtocol;
      direction: IdsEventDirection;
      virtualDevice:
        | {
            __typename?: 'AccessPointVirtualDevice';
            UUID: string;
            deviceType: VirtualDeviceType;
            label: string;
          }
        | {
            __typename?: 'ControllerVirtualDevice';
            UUID: string;
            deviceType: VirtualDeviceType;
            label: string;
          }
        | {
            __typename?: 'ObserverVirtualDevice';
            UUID: string;
            deviceType: VirtualDeviceType;
            label: string;
          }
        | {
            __typename?: 'PowerDistributionUnitVirtualDevice';
            UUID: string;
            deviceType: VirtualDeviceType;
            label: string;
          }
        | {
            __typename?: 'SwitchVirtualDevice';
            UUID: string;
            deviceType: VirtualDeviceType;
            label: string;
          };
      alert?: {
        __typename?: 'IDSEventAlert';
        action: IdsEventAlertAction;
        category: string;
        gid: number;
        sid: number;
        rev: number;
        rule?: string | null;
        severity: number;
        signature: string;
      } | null;
      httpInfo?: {
        __typename?: 'IDSEventHTTPInfo';
        hostname: string;
        url: string;
        userAgent: string;
        contentType: string;
        protocol: string;
        status: number;
        length: number;
      } | null;
      tlsInfo?: { __typename?: 'IDSEventTLSInfo'; sni: string } | null;
      flow?: {
        __typename?: 'IDSEventFlowInfo';
        packetsToServer: number;
        packetsToClient: number;
        bytesToServer: number;
        bytesToClient: number;
        start?: string | null;
        end?: string | null;
        reason?: string | null;
      } | null;
      firewallRule?: { __typename?: 'FirewallRule'; UUID: string; name: string } | null;
      ipsRule?: {
        __typename?: 'IDSEventIPSRule';
        protocol: IdsEventProtocol;
        srcPrefix: string;
        dstPrefix: string;
        durationSec: number;
        srcPortRange: { __typename?: 'PortRange'; lower: number; upper: number };
        dstPortRange: { __typename?: 'PortRange'; lower: number; upper: number };
        vlanBindings?: Array<{
          __typename: 'VLAN';
          UUID: string;
          name: string;
          vlanID: number;
        }> | null;
        phyInterfaceBindings?: Array<{
          __typename: 'PhyInterface';
          UUID: string;
          portNumber: number;
          label?: string | null;
          hardwareLabel?: string | null;
          virtualDevice:
            | {
                __typename?: 'AccessPointVirtualDevice';
                UUID: string;
                label: string;
                deviceModel: DeviceModel;
              }
            | {
                __typename?: 'ControllerVirtualDevice';
                UUID: string;
                label: string;
                deviceModel: DeviceModel;
              }
            | {
                __typename?: 'ObserverVirtualDevice';
                UUID: string;
                label: string;
                deviceModel: DeviceModel;
              }
            | {
                __typename?: 'PowerDistributionUnitVirtualDevice';
                UUID: string;
                label: string;
                deviceModel: DeviceModel;
              }
            | {
                __typename?: 'SwitchVirtualDevice';
                UUID: string;
                label: string;
                deviceModel: DeviceModel;
              };
          internetServicePlan?: {
            __typename?: 'InternetServicePlan';
            UUID: string;
            provider?: { __typename?: 'InternetServicePlanProvider'; name: string } | null;
          } | null;
        }> | null;
      } | null;
    }> | null;
  };
};

export type IdsRulesForSourceVersionQueryVariables = Exact<{
  sourceVersion: Scalars['Int']['input'];
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  filter?: InputMaybe<IdsRuleFilterInput>;
}>;

export type IdsRulesForSourceVersionQuery = {
  __typename?: 'Query';
  idsRulesForSourceVersion: {
    __typename?: 'IDSRulePage';
    total: number;
    items: Array<{
      __typename?: 'IDSRule';
      SID: number;
      action: string;
      classType: string;
      groupID?: number | null;
      header: string;
      description?: string | null;
      revision: number;
      metadata: Array<string>;
      references: Array<{ __typename?: 'IDSRuleReference'; type: string; ref: string }>;
    }>;
  };
};

export type VlaNsForMulticastQueryVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
}>;

export type VlaNsForMulticastQuery = {
  __typename?: 'Query';
  vlans: Array<{
    __typename?: 'VLAN';
    UUID: string;
    name: string;
    vlanID: number;
    isEnabled: boolean;
    isDefault: boolean;
    isInternal?: boolean | null;
    isMulticastReflectionEnabled: boolean;
    ipV4ClientAssignmentProtocol?: ClientAssignmentProtocol | null;
    ipV4ClientGateway?: string | null;
    ipV4ClientPrefixLength?: number | null;
  }>;
};

export type UpdateVlaNsForMulticastMutationVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
  inputs: Array<UpdateVlaNsIndependentlyInput> | UpdateVlaNsIndependentlyInput;
}>;

export type UpdateVlaNsForMulticastMutation = {
  __typename?: 'Mutation';
  updateVLANsIndependently: Array<{ __typename?: 'VLAN'; UUID: string }>;
};

export type DhcpRulesWithStaticMappingsForNetworkQueryQueryVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
}>;

export type DhcpRulesWithStaticMappingsForNetworkQueryQuery = {
  __typename?: 'Query';
  dhcpRulesForNetwork: Array<{
    __typename?: 'DHCPRule';
    UUID: string;
    vlan: { __typename?: 'VLAN'; UUID: string; name: string; vlanID: number };
    staticMappings: Array<{
      __typename?: 'DHCPStaticMapping';
      UUID: string;
      name?: string | null;
      macAddress: string;
      ipAddress?: string | null;
      hostname?: string | null;
      createdAt: string;
    }>;
  }>;
};

export type OneToOneNatRulesForNetworkQueryVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
}>;

export type OneToOneNatRulesForNetworkQuery = {
  __typename?: 'Query';
  oneToOneNATRulesForNetwork: Array<{
    __typename?: 'OneToOneNATRule';
    UUID: string;
    name: string;
    description?: string | null;
    isEnabled: boolean;
    networkUUID: string;
    internalIPAddr: string;
    externalIPAddr: string;
    externalPhyInterfaceUUID: string;
    externalPhyInterface: {
      __typename: 'PhyInterface';
      UUID: string;
      portNumber: number;
      label?: string | null;
      hardwareLabel?: string | null;
      virtualDevice:
        | {
            __typename?: 'AccessPointVirtualDevice';
            UUID: string;
            label: string;
            deviceModel: DeviceModel;
          }
        | {
            __typename?: 'ControllerVirtualDevice';
            UUID: string;
            label: string;
            deviceModel: DeviceModel;
          }
        | {
            __typename?: 'ObserverVirtualDevice';
            UUID: string;
            label: string;
            deviceModel: DeviceModel;
          }
        | {
            __typename?: 'PowerDistributionUnitVirtualDevice';
            UUID: string;
            label: string;
            deviceModel: DeviceModel;
          }
        | {
            __typename?: 'SwitchVirtualDevice';
            UUID: string;
            label: string;
            deviceModel: DeviceModel;
          };
      internetServicePlan?: {
        __typename?: 'InternetServicePlan';
        UUID: string;
        provider?: { __typename?: 'InternetServicePlanProvider'; name: string } | null;
      } | null;
    };
  }>;
};

export type OneToOneNatRuleQueryVariables = Exact<{
  uuid: Scalars['UUID']['input'];
}>;

export type OneToOneNatRuleQuery = {
  __typename?: 'Query';
  oneToOneNATRule: {
    __typename?: 'OneToOneNATRule';
    UUID: string;
    name: string;
    description?: string | null;
    isEnabled: boolean;
    networkUUID: string;
    internalIPAddr: string;
    externalIPAddr: string;
    externalPhyInterfaceUUID: string;
    externalPhyInterface: {
      __typename: 'PhyInterface';
      UUID: string;
      portNumber: number;
      label?: string | null;
      hardwareLabel?: string | null;
      virtualDevice:
        | {
            __typename?: 'AccessPointVirtualDevice';
            UUID: string;
            label: string;
            deviceModel: DeviceModel;
          }
        | {
            __typename?: 'ControllerVirtualDevice';
            UUID: string;
            label: string;
            deviceModel: DeviceModel;
          }
        | {
            __typename?: 'ObserverVirtualDevice';
            UUID: string;
            label: string;
            deviceModel: DeviceModel;
          }
        | {
            __typename?: 'PowerDistributionUnitVirtualDevice';
            UUID: string;
            label: string;
            deviceModel: DeviceModel;
          }
        | {
            __typename?: 'SwitchVirtualDevice';
            UUID: string;
            label: string;
            deviceModel: DeviceModel;
          };
      internetServicePlan?: {
        __typename?: 'InternetServicePlan';
        UUID: string;
        provider?: { __typename?: 'InternetServicePlanProvider'; name: string } | null;
      } | null;
    };
  };
};

export type CreateOneToOneNatRuleMutationVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
  input: CreateOneToOneNatRuleInput;
}>;

export type CreateOneToOneNatRuleMutation = {
  __typename?: 'Mutation';
  createOneToOneNATRule: { __typename?: 'OneToOneNATRule'; UUID: string };
};

export type UpdateOneToOneNatRuleMutationVariables = Exact<{
  uuid: Scalars['UUID']['input'];
  input: UpdateOneToOneNatRuleInput;
}>;

export type UpdateOneToOneNatRuleMutation = {
  __typename?: 'Mutation';
  updateOneToOneNATRule: { __typename?: 'OneToOneNATRule'; UUID: string };
};

export type DeleteOneToOneNatRuleMutationVariables = Exact<{
  uuid: Scalars['UUID']['input'];
}>;

export type DeleteOneToOneNatRuleMutation = {
  __typename?: 'Mutation';
  deleteOneToOneNATRule: { __typename?: 'OneToOneNATRule'; UUID: string };
};

export type PortForwardingRuleQueryVariables = Exact<{
  uuid: Scalars['UUID']['input'];
}>;

export type PortForwardingRuleQuery = {
  __typename?: 'Query';
  portForwardingRule: {
    __typename?: 'PortForwardingRule';
    UUID: string;
    name: string;
    description?: string | null;
    isEnabled: boolean;
    protocol: PortIpProtocol;
    localIPAddress: string;
    externalPhyInterfaceUUID?: string | null;
    externalIPAddress?: string | null;
    externalPort: number;
    localPort: number;
  };
};

export type PortForwardingRulesForNetworkQueryVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
}>;

export type PortForwardingRulesForNetworkQuery = {
  __typename?: 'Query';
  portForwardingRulesForNetwork: Array<{
    __typename?: 'PortForwardingRule';
    UUID: string;
    name: string;
    description?: string | null;
    isEnabled: boolean;
    protocol: PortIpProtocol;
    localIPAddress: string;
    externalPhyInterfaceUUID?: string | null;
    externalIPAddress?: string | null;
    externalPort: number;
    localPort: number;
    externalPhyInterface?: {
      __typename: 'PhyInterface';
      UUID: string;
      label?: string | null;
      hardwareLabel?: string | null;
      portNumber: number;
      virtualDevice:
        | {
            __typename?: 'AccessPointVirtualDevice';
            UUID: string;
            label: string;
            deviceModel: DeviceModel;
          }
        | {
            __typename?: 'ControllerVirtualDevice';
            UUID: string;
            label: string;
            deviceModel: DeviceModel;
          }
        | {
            __typename?: 'ObserverVirtualDevice';
            UUID: string;
            label: string;
            deviceModel: DeviceModel;
          }
        | {
            __typename?: 'PowerDistributionUnitVirtualDevice';
            UUID: string;
            label: string;
            deviceModel: DeviceModel;
          }
        | {
            __typename?: 'SwitchVirtualDevice';
            UUID: string;
            label: string;
            deviceModel: DeviceModel;
          };
      internetServicePlan?: {
        __typename?: 'InternetServicePlan';
        UUID: string;
        provider?: { __typename?: 'InternetServicePlanProvider'; name: string } | null;
      } | null;
    } | null;
  }>;
};

export type CreatePortForwardingRuleMutationVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
  input: CreatePortForwardingRuleInput;
}>;

export type CreatePortForwardingRuleMutation = {
  __typename?: 'Mutation';
  createPortForwardingRule: { __typename?: 'PortForwardingRule'; UUID: string };
};

export type UpdatePortForwardingRuleMutationVariables = Exact<{
  uuid: Scalars['UUID']['input'];
  input: UpdatePortForwardingRuleInput;
}>;

export type UpdatePortForwardingRuleMutation = {
  __typename?: 'Mutation';
  updatePortForwardingRule: { __typename?: 'PortForwardingRule'; UUID: string };
};

export type DeletePortForwardingRuleMutationVariables = Exact<{
  uuid: Scalars['UUID']['input'];
}>;

export type DeletePortForwardingRuleMutation = {
  __typename?: 'Mutation';
  deletePortForwardingRule: { __typename?: 'PortForwardingRule'; UUID: string };
};

export type VlaNsForFirewallQueryVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
}>;

export type VlaNsForFirewallQuery = {
  __typename?: 'Query';
  vlans: Array<{
    __typename: 'VLAN';
    UUID: string;
    name: string;
    description?: string | null;
    isEnabled: boolean;
    isInternal?: boolean | null;
    isDefault: boolean;
    isWANDenied: boolean;
    vlanID: number;
    ipV4ClientAssignmentProtocol?: ClientAssignmentProtocol | null;
    ipV4ClientGateway?: string | null;
    ipV4ClientPrefixLength?: number | null;
    permittedInterVLANCommunicationVLANs: Array<{
      __typename?: 'VLAN';
      UUID: string;
      name: string;
      vlanID: number;
    }>;
    dhcpRule?: {
      __typename?: 'DHCPRule';
      applicationDNSFirewallRules: Array<{
        __typename?: 'ApplicationDNSFirewallRule';
        UUID: string;
      }>;
    } | null;
  }>;
};

export type PhyInterfaceLabelFieldsFragment = {
  __typename: 'PhyInterface';
  UUID: string;
  portNumber: number;
  label?: string | null;
  hardwareLabel?: string | null;
  virtualDevice:
    | {
        __typename?: 'AccessPointVirtualDevice';
        UUID: string;
        label: string;
        deviceModel: DeviceModel;
      }
    | {
        __typename?: 'ControllerVirtualDevice';
        UUID: string;
        label: string;
        deviceModel: DeviceModel;
      }
    | {
        __typename?: 'ObserverVirtualDevice';
        UUID: string;
        label: string;
        deviceModel: DeviceModel;
      }
    | {
        __typename?: 'PowerDistributionUnitVirtualDevice';
        UUID: string;
        label: string;
        deviceModel: DeviceModel;
      }
    | { __typename?: 'SwitchVirtualDevice'; UUID: string; label: string; deviceModel: DeviceModel };
  internetServicePlan?: {
    __typename?: 'InternetServicePlan';
    UUID: string;
    provider?: { __typename?: 'InternetServicePlanProvider'; name: string } | null;
  } | null;
};

export type FirewallRulesForNetworkQueryVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
}>;

export type FirewallRulesForNetworkQuery = {
  __typename?: 'Query';
  firewallRulesForNetwork: Array<{
    __typename?: 'FirewallRule';
    UUID: string;
    name: string;
    description?: string | null;
    isMeterInternal: boolean;
    isEnabled: boolean;
    priority: number;
    isBidirectional?: boolean | null;
    action: FirewallRuleAction;
    srcPrefix?: string | null;
    dstPrefix?: string | null;
    protocols: Array<IpProtocol>;
    tags?: Array<string> | null;
    srcVLAN?: {
      __typename: 'VLAN';
      UUID: string;
      name: string;
      vlanID: number;
      ipV4ClientAssignmentProtocol?: ClientAssignmentProtocol | null;
      ipV4ClientGateway?: string | null;
      ipV4ClientPrefixLength?: number | null;
    } | null;
    srcClientVPNServer?: {
      __typename?: 'ClientVPNServer';
      UUID: string;
      name: string;
      address?: string | null;
      addressMask?: number | null;
    } | null;
    dstVLAN?: {
      __typename: 'VLAN';
      UUID: string;
      name: string;
      vlanID: number;
      ipV4ClientAssignmentProtocol?: ClientAssignmentProtocol | null;
      ipV4ClientGateway?: string | null;
      ipV4ClientPrefixLength?: number | null;
    } | null;
    dstClientVPNServer?: {
      __typename?: 'ClientVPNServer';
      UUID: string;
      name: string;
      address?: string | null;
      addressMask?: number | null;
    } | null;
    srcPortRanges: Array<{ __typename?: 'PortRange'; lower: number; upper: number }>;
    dstPortRanges: Array<{ __typename?: 'PortRange'; lower: number; upper: number }>;
    vlanBindings?: Array<{
      __typename?: 'FirewallVLANBinding';
      metric?: number | null;
      vlan: { __typename: 'VLAN'; UUID: string; name: string; vlanID: number };
    }> | null;
    phyInterfaceBindings?: Array<{
      __typename?: 'FirewallPhyInterfaceBinding';
      metric?: number | null;
      phyInterface: {
        __typename: 'PhyInterface';
        UUID: string;
        portNumber: number;
        label?: string | null;
        hardwareLabel?: string | null;
        virtualDevice:
          | {
              __typename?: 'AccessPointVirtualDevice';
              UUID: string;
              label: string;
              deviceModel: DeviceModel;
            }
          | {
              __typename?: 'ControllerVirtualDevice';
              UUID: string;
              label: string;
              deviceModel: DeviceModel;
            }
          | {
              __typename?: 'ObserverVirtualDevice';
              UUID: string;
              label: string;
              deviceModel: DeviceModel;
            }
          | {
              __typename?: 'PowerDistributionUnitVirtualDevice';
              UUID: string;
              label: string;
              deviceModel: DeviceModel;
            }
          | {
              __typename?: 'SwitchVirtualDevice';
              UUID: string;
              label: string;
              deviceModel: DeviceModel;
            };
        internetServicePlan?: {
          __typename?: 'InternetServicePlan';
          UUID: string;
          provider?: { __typename?: 'InternetServicePlanProvider'; name: string } | null;
        } | null;
      };
    }> | null;
    idsEvent?: {
      __typename?: 'IDSEvent';
      observedAt: string;
      virtualDevice:
        | { __typename?: 'AccessPointVirtualDevice'; UUID: string }
        | { __typename?: 'ControllerVirtualDevice'; UUID: string }
        | { __typename?: 'ObserverVirtualDevice'; UUID: string }
        | { __typename?: 'PowerDistributionUnitVirtualDevice'; UUID: string }
        | { __typename?: 'SwitchVirtualDevice'; UUID: string };
    } | null;
  }>;
};

export type FirewallRuleQueryVariables = Exact<{
  uuid: Scalars['UUID']['input'];
}>;

export type FirewallRuleQuery = {
  __typename?: 'Query';
  firewallRule: {
    __typename?: 'FirewallRule';
    UUID: string;
    name: string;
    description?: string | null;
    isMeterInternal: boolean;
    isEnabled: boolean;
    priority: number;
    isBidirectional?: boolean | null;
    action: FirewallRuleAction;
    srcPrefix?: string | null;
    dstPrefix?: string | null;
    protocols: Array<IpProtocol>;
    tags?: Array<string> | null;
    srcVLAN?: {
      __typename: 'VLAN';
      UUID: string;
      name: string;
      vlanID: number;
      ipV4ClientAssignmentProtocol?: ClientAssignmentProtocol | null;
      ipV4ClientGateway?: string | null;
      ipV4ClientPrefixLength?: number | null;
    } | null;
    srcClientVPNServer?: {
      __typename?: 'ClientVPNServer';
      UUID: string;
      name: string;
      address?: string | null;
      addressMask?: number | null;
    } | null;
    dstVLAN?: {
      __typename: 'VLAN';
      UUID: string;
      name: string;
      vlanID: number;
      ipV4ClientAssignmentProtocol?: ClientAssignmentProtocol | null;
      ipV4ClientGateway?: string | null;
      ipV4ClientPrefixLength?: number | null;
    } | null;
    dstClientVPNServer?: {
      __typename?: 'ClientVPNServer';
      UUID: string;
      name: string;
      address?: string | null;
      addressMask?: number | null;
    } | null;
    srcPortRanges: Array<{ __typename?: 'PortRange'; lower: number; upper: number }>;
    dstPortRanges: Array<{ __typename?: 'PortRange'; lower: number; upper: number }>;
    vlanBindings?: Array<{
      __typename?: 'FirewallVLANBinding';
      metric?: number | null;
      vlan: { __typename: 'VLAN'; UUID: string; name: string; vlanID: number };
    }> | null;
    phyInterfaceBindings?: Array<{
      __typename?: 'FirewallPhyInterfaceBinding';
      metric?: number | null;
      phyInterface: {
        __typename: 'PhyInterface';
        UUID: string;
        label?: string | null;
        portNumber: number;
        virtualDevice:
          | {
              __typename: 'AccessPointVirtualDevice';
              UUID: string;
              label: string;
              deviceModel: DeviceModel;
            }
          | {
              __typename: 'ControllerVirtualDevice';
              UUID: string;
              label: string;
              deviceModel: DeviceModel;
            }
          | {
              __typename: 'ObserverVirtualDevice';
              UUID: string;
              label: string;
              deviceModel: DeviceModel;
            }
          | {
              __typename: 'PowerDistributionUnitVirtualDevice';
              UUID: string;
              label: string;
              deviceModel: DeviceModel;
            }
          | {
              __typename: 'SwitchVirtualDevice';
              UUID: string;
              label: string;
              deviceModel: DeviceModel;
            };
      };
    }> | null;
    idsEvent?: {
      __typename?: 'IDSEvent';
      observedAt: string;
      virtualDevice:
        | { __typename?: 'AccessPointVirtualDevice'; UUID: string }
        | { __typename?: 'ControllerVirtualDevice'; UUID: string }
        | { __typename?: 'ObserverVirtualDevice'; UUID: string }
        | { __typename?: 'PowerDistributionUnitVirtualDevice'; UUID: string }
        | { __typename?: 'SwitchVirtualDevice'; UUID: string };
    } | null;
  };
};

export type UpdateFirewallRuleBindingsForVlanMutationVariables = Exact<{
  vlanUUID: Scalars['UUID']['input'];
  orderedRuleUUIDs: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
}>;

export type UpdateFirewallRuleBindingsForVlanMutation = {
  __typename?: 'Mutation';
  bindFirewallRulesToVLAN: Array<{ __typename?: 'FirewallVLANBinding'; metric?: number | null }>;
};

export type UpdateFirewallRuleBindingsForPhyInterfaceMutationVariables = Exact<{
  phyInterfaceUUID: Scalars['UUID']['input'];
  orderedRuleUUIDs: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
}>;

export type UpdateFirewallRuleBindingsForPhyInterfaceMutation = {
  __typename?: 'Mutation';
  bindFirewallRulesToPhyInterface: Array<{
    __typename?: 'FirewallPhyInterfaceBinding';
    metric?: number | null;
  }>;
};

export type UplinkPhyInterfacesForNetworkQueryVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
}>;

export type UplinkPhyInterfacesForNetworkQuery = {
  __typename?: 'Query';
  uplinkPhyInterfacesForNetwork: Array<{
    __typename: 'PhyInterface';
    UUID: string;
    label?: string | null;
    isEnabled: boolean;
    portNumber: number;
    hardwareLabel?: string | null;
    ipv4ClientAddresses?: Array<string> | null;
    isUplinkActive?: boolean | null;
    hasWANActivity?: boolean | null;
    uplinkExternalAddresses?: Array<string> | null;
    virtualDevice:
      | {
          __typename: 'AccessPointVirtualDevice';
          UUID: string;
          label: string;
          deviceModel: DeviceModel;
          hardwareDevice?:
            | {
                __typename?: 'AccessPointHardwareDevice';
                isActive: boolean;
                isConnectedToBackend: boolean;
                serialNumber: string;
              }
            | {
                __typename?: 'ControllerHardwareDevice';
                isActive: boolean;
                isConnectedToBackend: boolean;
                serialNumber: string;
              }
            | {
                __typename?: 'PowerDistributionUnitHardwareDevice';
                isActive: boolean;
                isConnectedToBackend: boolean;
                serialNumber: string;
              }
            | {
                __typename?: 'SwitchHardwareDevice';
                isActive: boolean;
                isConnectedToBackend: boolean;
                serialNumber: string;
              }
            | null;
        }
      | {
          __typename: 'ControllerVirtualDevice';
          UUID: string;
          label: string;
          deviceModel: DeviceModel;
          highAvailability?: {
            __typename?: 'HighAvailabilityControllerVirtualDeviceInfo';
            role: HighAvailabilityControllerRole;
            status: HighAvailabilityStatus;
          } | null;
          hardwareDevice?:
            | {
                __typename?: 'AccessPointHardwareDevice';
                isActive: boolean;
                isConnectedToBackend: boolean;
                serialNumber: string;
              }
            | {
                __typename?: 'ControllerHardwareDevice';
                isActive: boolean;
                isConnectedToBackend: boolean;
                serialNumber: string;
              }
            | {
                __typename?: 'PowerDistributionUnitHardwareDevice';
                isActive: boolean;
                isConnectedToBackend: boolean;
                serialNumber: string;
              }
            | {
                __typename?: 'SwitchHardwareDevice';
                isActive: boolean;
                isConnectedToBackend: boolean;
                serialNumber: string;
              }
            | null;
        }
      | {
          __typename: 'ObserverVirtualDevice';
          UUID: string;
          label: string;
          deviceModel: DeviceModel;
          hardwareDevice?:
            | {
                __typename?: 'AccessPointHardwareDevice';
                isActive: boolean;
                isConnectedToBackend: boolean;
                serialNumber: string;
              }
            | {
                __typename?: 'ControllerHardwareDevice';
                isActive: boolean;
                isConnectedToBackend: boolean;
                serialNumber: string;
              }
            | {
                __typename?: 'PowerDistributionUnitHardwareDevice';
                isActive: boolean;
                isConnectedToBackend: boolean;
                serialNumber: string;
              }
            | {
                __typename?: 'SwitchHardwareDevice';
                isActive: boolean;
                isConnectedToBackend: boolean;
                serialNumber: string;
              }
            | null;
        }
      | {
          __typename: 'PowerDistributionUnitVirtualDevice';
          UUID: string;
          label: string;
          deviceModel: DeviceModel;
          hardwareDevice?:
            | {
                __typename?: 'AccessPointHardwareDevice';
                isActive: boolean;
                isConnectedToBackend: boolean;
                serialNumber: string;
              }
            | {
                __typename?: 'ControllerHardwareDevice';
                isActive: boolean;
                isConnectedToBackend: boolean;
                serialNumber: string;
              }
            | {
                __typename?: 'PowerDistributionUnitHardwareDevice';
                isActive: boolean;
                isConnectedToBackend: boolean;
                serialNumber: string;
              }
            | {
                __typename?: 'SwitchHardwareDevice';
                isActive: boolean;
                isConnectedToBackend: boolean;
                serialNumber: string;
              }
            | null;
        }
      | {
          __typename: 'SwitchVirtualDevice';
          UUID: string;
          label: string;
          deviceModel: DeviceModel;
          hardwareDevice?:
            | {
                __typename?: 'AccessPointHardwareDevice';
                isActive: boolean;
                isConnectedToBackend: boolean;
                serialNumber: string;
              }
            | {
                __typename?: 'ControllerHardwareDevice';
                isActive: boolean;
                isConnectedToBackend: boolean;
                serialNumber: string;
              }
            | {
                __typename?: 'PowerDistributionUnitHardwareDevice';
                isActive: boolean;
                isConnectedToBackend: boolean;
                serialNumber: string;
              }
            | {
                __typename?: 'SwitchHardwareDevice';
                isActive: boolean;
                isConnectedToBackend: boolean;
                serialNumber: string;
              }
            | null;
        };
    internetServicePlan?: {
      __typename?: 'InternetServicePlan';
      UUID: string;
      provider?: { __typename?: 'InternetServicePlanProvider'; name: string } | null;
    } | null;
  }>;
};

export type CreateFirewallRuleMutationVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
  input: CreateFirewallRuleInput;
}>;

export type CreateFirewallRuleMutation = {
  __typename?: 'Mutation';
  createFirewallRule: { __typename?: 'FirewallRule'; UUID: string };
};

export type UpdateFirewallRuleMutationVariables = Exact<{
  uuid: Scalars['UUID']['input'];
  input: UpdateFirewallRuleInput;
}>;

export type UpdateFirewallRuleMutation = {
  __typename?: 'Mutation';
  updateFirewallRule: { __typename?: 'FirewallRule'; UUID: string };
};

export type UpdateFirewallRulesMutationVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
  inputs: Array<UpdateFirewallRulesInput> | UpdateFirewallRulesInput;
}>;

export type UpdateFirewallRulesMutation = {
  __typename?: 'Mutation';
  updateFirewallRules: Array<{ __typename?: 'FirewallRule'; UUID: string }>;
};

export type DeleteFirewallRuleMutationVariables = Exact<{
  uuid: Scalars['UUID']['input'];
}>;

export type DeleteFirewallRuleMutation = {
  __typename?: 'Mutation';
  deleteFirewallRule: { __typename?: 'FirewallRule'; UUID: string };
};

export type NotificationSettingsQueryQueryVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
}>;

export type NotificationSettingsQueryQuery = {
  __typename?: 'Query';
  notificationSettingsForNetwork: Array<{
    __typename?: 'NotificationSetting';
    UUID: string;
    alertReceiverUUID: string;
    isEnabled: boolean;
    arguments: Array<{
      __typename?: 'NotificationSettingArgument';
      value: unknown;
      parameterName: string;
    }>;
    notificationDefinition?: {
      __typename?: 'AlertDefinition';
      name: string;
      displayName: string;
      description?: string | null;
      parameters: Array<
        | { __typename?: 'AlertParameterBoolean'; name: string; displayName?: string | null }
        | { __typename?: 'AlertParameterDate'; name: string; displayName?: string | null }
        | { __typename?: 'AlertParameterDateTime'; name: string; displayName?: string | null }
        | { __typename?: 'AlertParameterDuration'; name: string; displayName?: string | null }
        | { __typename?: 'AlertParameterNumber'; name: string; displayName?: string | null }
        | { __typename?: 'AlertParameterNumberArray'; name: string; displayName?: string | null }
        | { __typename?: 'AlertParameterString'; name: string; displayName?: string | null }
        | { __typename?: 'AlertParameterStringArray'; name: string; displayName?: string | null }
        | { __typename?: 'AlertParameterUUID'; name: string; displayName?: string | null }
        | { __typename?: 'AlertParameterUUIDArray'; name: string; displayName?: string | null }
      >;
    } | null;
  }>;
};

export type CreateNotificationSettingMutationMutationVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
  input: CreateNotificationSettingInput;
}>;

export type CreateNotificationSettingMutationMutation = {
  __typename?: 'Mutation';
  createNotificationSetting: { __typename?: 'NotificationSetting'; UUID: string };
};

export type NotificationDefinitionsQueryQueryVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
}>;

export type NotificationDefinitionsQueryQuery = {
  __typename?: 'Query';
  alertDefinitionsForNetwork: Array<{
    __typename?: 'AlertDefinition';
    name: string;
    displayName: string;
    description?: string | null;
    availability: AccessLevel;
    parameters: Array<
      | {
          __typename: 'AlertParameterBoolean';
          uuid: string;
          name: string;
          description?: string | null;
          type: AlertParameterType;
          required: boolean;
          displayName?: string | null;
          isFleetwideSupported: boolean;
          booleanDefaultValue?: boolean | null;
        }
      | {
          __typename: 'AlertParameterDate';
          uuid: string;
          name: string;
          description?: string | null;
          type: AlertParameterType;
          required: boolean;
          displayName?: string | null;
          isFleetwideSupported: boolean;
          dateDefaultValue?: string | null;
        }
      | {
          __typename: 'AlertParameterDateTime';
          uuid: string;
          name: string;
          description?: string | null;
          type: AlertParameterType;
          required: boolean;
          displayName?: string | null;
          isFleetwideSupported: boolean;
          dateTimeDefaultValue?: string | null;
        }
      | {
          __typename: 'AlertParameterDuration';
          uuid: string;
          name: string;
          description?: string | null;
          type: AlertParameterType;
          required: boolean;
          displayName?: string | null;
          isFleetwideSupported: boolean;
          durationDefaultValue?: string | null;
        }
      | {
          __typename: 'AlertParameterNumber';
          uuid: string;
          name: string;
          description?: string | null;
          type: AlertParameterType;
          required: boolean;
          displayName?: string | null;
          isFleetwideSupported: boolean;
          numberDefaultValue?: number | null;
        }
      | {
          __typename: 'AlertParameterNumberArray';
          uuid: string;
          name: string;
          description?: string | null;
          type: AlertParameterType;
          required: boolean;
          displayName?: string | null;
          isFleetwideSupported: boolean;
          numberArrayDefaultValue?: Array<number> | null;
        }
      | {
          __typename: 'AlertParameterString';
          uuid: string;
          name: string;
          description?: string | null;
          type: AlertParameterType;
          required: boolean;
          displayName?: string | null;
          isFleetwideSupported: boolean;
          stringDefaultValue?: string | null;
        }
      | {
          __typename: 'AlertParameterStringArray';
          uuid: string;
          name: string;
          description?: string | null;
          type: AlertParameterType;
          required: boolean;
          displayName?: string | null;
          isFleetwideSupported: boolean;
          stringArrayDefaultValue?: Array<string> | null;
        }
      | {
          __typename: 'AlertParameterUUID';
          uuid: string;
          name: string;
          description?: string | null;
          type: AlertParameterType;
          required: boolean;
          displayName?: string | null;
          isFleetwideSupported: boolean;
        }
      | {
          __typename: 'AlertParameterUUIDArray';
          uuid: string;
          name: string;
          description?: string | null;
          type: AlertParameterType;
          required: boolean;
          displayName?: string | null;
          isFleetwideSupported: boolean;
          uuidArrayDefaultValue?: Array<string> | null;
        }
    >;
  }>;
};

export type DeleteNotificationSettingMutationMutationVariables = Exact<{
  UUID: Scalars['UUID']['input'];
}>;

export type DeleteNotificationSettingMutationMutation = {
  __typename?: 'Mutation';
  deleteNotificationSetting: { __typename?: 'NotificationSetting'; UUID: string };
};

export type UpdateNotificationSettingMutationMutationVariables = Exact<{
  UUID: Scalars['UUID']['input'];
  input: UpdateNotificationSettingInput;
}>;

export type UpdateNotificationSettingMutationMutation = {
  __typename?: 'Mutation';
  updateNotificationSetting: { __typename?: 'NotificationSetting'; UUID: string };
};

export type UpdateServiceDiscoveryForNetworkMutationVariables = Exact<{
  UUID: Scalars['UUID']['input'];
  input: UpdateNetworkInput;
}>;

export type UpdateServiceDiscoveryForNetworkMutation = {
  __typename?: 'Mutation';
  updateNetwork: { __typename?: 'Network'; UUID: string };
};

export type UpdateNetworkNetworkQueryVariables = Exact<{
  uuid: Scalars['UUID']['input'];
  includeNOSUpgradeChannel?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type UpdateNetworkNetworkQuery = {
  __typename?: 'Query';
  network: {
    __typename?: 'Network';
    UUID: string;
    slug: string;
    label: string;
    isActive: boolean;
    isCustomer: boolean;
    isTemplate: boolean;
    isConfig1WosUpgradesEnabled?: boolean | null;
    nosUpgradeChannel?: NetworkNosUpgradeChannel;
    pinnedNOSVersionID: number;
    onboarding?: {
      __typename?: 'NetworkOnboarding';
      UUID: string;
      jobData?: {
        __typename?: 'NetworkOnboardingJobData';
        id: string;
        jobID?: string | null;
      } | null;
    } | null;
    mailingAddress?: {
      __typename?: 'MailingAddress';
      UUID: string;
      line1?: string | null;
      line2?: string | null;
      city?: string | null;
      subdivisionCode?: string | null;
      postalCode?: string | null;
      countryISO2?: string | null;
      timezone: string;
      squareFeet?: number | null;
    } | null;
  };
};

export type CreateNetworkMutationVariables = Exact<{
  input: CreateNetworkInput;
}>;

export type CreateNetworkMutation = {
  __typename?: 'Mutation';
  createNetwork: { __typename?: 'Network'; UUID: string; slug: string };
};

export type UpdateNetworkMutationVariables = Exact<{
  uuid: Scalars['UUID']['input'];
  input: UpdateNetworkInput;
}>;

export type UpdateNetworkMutation = {
  __typename?: 'Mutation';
  updateNetwork: { __typename?: 'Network'; UUID: string; slug: string };
};

export type DeleteNetworkMutationVariables = Exact<{
  uuid: Scalars['UUID']['input'];
}>;

export type DeleteNetworkMutation = {
  __typename?: 'Mutation';
  deleteNetwork: { __typename?: 'Network'; UUID: string };
};

export type JobTrackersQueryVariables = Exact<{ [key: string]: never }>;

export type JobTrackersQuery = {
  __typename?: 'Query';
  jobTrackers: Array<{
    __typename?: 'NetworkOnboardingJobData';
    id: string;
    jobID?: string | null;
    totalSqFt?: Array<string> | null;
    fullAddress?: Array<string> | null;
    locationCode?: string | null;
  }>;
};

export type CreateNetworkOnboardingMutationVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
  jobTrackerID: Scalars['String']['input'];
}>;

export type CreateNetworkOnboardingMutation = {
  __typename?: 'Mutation';
  createNetworkOnboarding: { __typename?: 'NetworkOnboarding'; UUID: string };
};

export type MaintenanceWindowForNetworkQueryVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
}>;

export type MaintenanceWindowForNetworkQuery = {
  __typename?: 'Query';
  maintenanceWindowForNetwork: {
    __typename?: 'MaintenanceWindow';
    recurrence: MaintenanceWindowRecurrence;
    timezone?: string | null;
    isOptedOut: boolean;
    startHourOfDayLocal?: number | null;
    endHourOfDayLocal?: number | null;
    startDayOfWeekLocal?: number | null;
    endDayOfWeekLocal?: number | null;
    excludedDaysOfWeek?: Array<number> | null;
  };
};

export type UpdateMaintenanceWindowMutationVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
  input: UpdateMaintenanceWindowInput;
}>;

export type UpdateMaintenanceWindowMutation = {
  __typename?: 'Mutation';
  updateMaintenanceWindowForNetwork: { __typename?: 'MaintenanceWindow'; UUID: string };
};

export type PublicNosVersionsForNetworkQueryVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
}>;

export type PublicNosVersionsForNetworkQuery = {
  __typename?: 'Query';
  publicNOSVersionsForNetwork: Array<{
    __typename?: 'NosVersion';
    major: number;
    minor: number;
    patch: number;
    releaseNotes?: string | null;
  }>;
};

export type UpdateCompanyMutationVariables = Exact<{
  companyUUID: Scalars['UUID']['input'];
  input: UpdateCompanyInput;
}>;

export type UpdateCompanyMutation = {
  __typename?: 'Mutation';
  updateCompany: { __typename?: 'Company'; uuid: string; slug: string };
};

export type UpdateAlertReceiverWithTargetsMutationVariables = Exact<{
  alertReceiverUUID: Scalars['UUID']['input'];
  input: UpdateAlertReceiverWithTargetsInput;
}>;

export type UpdateAlertReceiverWithTargetsMutation = {
  __typename?: 'Mutation';
  updateAlertReceiverWithTargets: { __typename?: 'AlertReceiver'; UUID: string };
};

export type CreateAlertReceiverWithTargetsMutationMutationVariables = Exact<{
  companyUUID: Scalars['UUID']['input'];
  input: CreateAlertReceiverWithTargetsInput;
}>;

export type CreateAlertReceiverWithTargetsMutationMutation = {
  __typename?: 'Mutation';
  createAlertReceiverWithTargets: { __typename?: 'AlertReceiver'; UUID: string };
};

export type TestFireFailureMutationVariables = Exact<{
  alertReceiverUUID: Scalars['UUID']['input'];
  networkUUID: Scalars['UUID']['input'];
}>;

export type TestFireFailureMutation = {
  __typename?: 'Mutation';
  testFireAlert?: { __typename?: 'TestFireAlertResult'; ok: boolean } | null;
};

export type SendCompanySiemIntegrationTestEventMutationVariables = Exact<{
  UUID: Scalars['UUID']['input'];
}>;

export type SendCompanySiemIntegrationTestEventMutation = {
  __typename?: 'Mutation';
  sendCompanySIEMIntegrationTestEvent: boolean;
};

export type CreateSiemIntegrationMutationVariables = Exact<{
  companyUUID: Scalars['UUID']['input'];
  input: CreateCompanySiemIntegrationInput;
}>;

export type CreateSiemIntegrationMutation = {
  __typename?: 'Mutation';
  createCompanySIEMIntegration: { __typename?: 'CompanySIEMIntegration'; UUID: string };
};

export type DeleteSiemIntegrationMutationVariables = Exact<{
  UUID: Scalars['UUID']['input'];
}>;

export type DeleteSiemIntegrationMutation = {
  __typename?: 'Mutation';
  deleteCompanySIEMIntegration: { __typename?: 'CompanySIEMIntegration'; UUID: string };
};

export type SiemIntegrationsForCompanyQueryVariables = Exact<{
  companyUUID: Scalars['UUID']['input'];
}>;

export type SiemIntegrationsForCompanyQuery = {
  __typename?: 'Query';
  siemIntegrationsForCompany?: Array<{
    __typename?: 'CompanySIEMIntegration';
    UUID: string;
    createdAt: string;
    awsKinesisARN: string;
    externalID: string;
    roleARN: string;
    status?: CompanySiemIntegrationStatus | null;
    statusUpdatedAt?: string | null;
  }> | null;
};

export type UpdateWebhookMutationMutationVariables = Exact<{
  UUID: Scalars['UUID']['input'];
  input: UpdateAlertTargetWebhookInput;
}>;

export type UpdateWebhookMutationMutation = {
  __typename?: 'Mutation';
  updateAlertTargetWebhook: { __typename?: 'AlertTargetWebhook'; UUID: string };
};

export type WebhookTestTriggerMutationMutationVariables = Exact<{
  uuid: Scalars['UUID']['input'];
  input: TestTriggerAlertTargetWebhookInput;
}>;

export type WebhookTestTriggerMutationMutation = {
  __typename?: 'Mutation';
  testTriggerWebhookAlertTarget: {
    __typename?: 'TestTriggerAlertTargetWebhookResponse';
    UUID: string;
    ok: boolean;
  };
};

export type CreateAlertTargetWebhookMutationVariables = Exact<{
  companyUUID: Scalars['UUID']['input'];
  input: CreateAlertTargetWebhookInput;
}>;

export type CreateAlertTargetWebhookMutation = {
  __typename?: 'Mutation';
  createAlertTargetWebhook: {
    __typename?: 'AlertTargetWebhook';
    UUID: string;
    companyUUID: string;
    signingSecret?: string | null;
    type: AlertTargetType;
    url: string;
    label?: string | null;
  };
};

export type CreateSlackAccessTokenMutationVariables = Exact<{
  companyUUID: Scalars['UUID']['input'];
}>;

export type CreateSlackAccessTokenMutation = {
  __typename?: 'Mutation';
  createSlackAccessToken: { __typename?: 'SlackAccessToken'; uuid: string };
};

export type DeleteSlackAccessTokensForCompanyMutationVariables = Exact<{
  companyUUID: Scalars['UUID']['input'];
}>;

export type DeleteSlackAccessTokensForCompanyMutation = {
  __typename?: 'Mutation';
  deleteSlackAccessTokensForCompany: { __typename?: 'SlackAccessToken'; uuid: string };
};

export type DeleteAlertReceiverMutationMutationVariables = Exact<{
  alertReceiverUUID: Scalars['UUID']['input'];
}>;

export type DeleteAlertReceiverMutationMutation = {
  __typename?: 'Mutation';
  deleteAlertReceiverWithTargets: { __typename?: 'AlertReceiver'; UUID: string };
};

export type AlertTargetWebhookFieldsFragment = {
  __typename?: 'AlertTargetWebhook';
  UUID: string;
  url: string;
  authType?: WebhookAuthType | null;
  authValue?: string | null;
  label?: string | null;
  type: AlertTargetType;
  signingSecret?: string | null;
};

export type AlertTargetsQueryQueryVariables = Exact<{
  companyUUID: Scalars['UUID']['input'];
}>;

export type AlertTargetsQueryQuery = {
  __typename?: 'Query';
  alertTargets: {
    __typename?: 'AlertTargetsResponse';
    emails: Array<{
      __typename: 'AlertTargetEmail';
      UUID: string;
      emailAddress: string;
      type: AlertTargetType;
    }>;
    webhooks: Array<{
      __typename: 'AlertTargetWebhook';
      UUID: string;
      url: string;
      authType?: WebhookAuthType | null;
      authValue?: string | null;
      label?: string | null;
      type: AlertTargetType;
      signingSecret?: string | null;
    }>;
    slacks: Array<{
      __typename: 'AlertTargetSlack';
      type: AlertTargetType;
      UUID: string;
      label?: string | null;
      channelID: string;
    }>;
  };
};

export type AlertTargetsWebhookQueryQueryVariables = Exact<{
  companyUUID: Scalars['UUID']['input'];
}>;

export type AlertTargetsWebhookQueryQuery = {
  __typename?: 'Query';
  alertTargetsWebhook: Array<{
    __typename: 'AlertTargetWebhook';
    UUID: string;
    url: string;
    authType?: WebhookAuthType | null;
    authValue?: string | null;
    label?: string | null;
    type: AlertTargetType;
    signingSecret?: string | null;
  }>;
};

export type AlertReceiversQueryQueryVariables = Exact<{
  companyUUID: Scalars['UUID']['input'];
}>;

export type AlertReceiversQueryQuery = {
  __typename?: 'Query';
  alertReceiversForCompany: Array<{
    __typename: 'AlertReceiver';
    UUID: string;
    companyUUID: string;
    label: string;
    targets: Array<
      | {
          __typename: 'AlertTargetEmail';
          emailAddress: string;
          UUID: string;
          type: AlertTargetType;
        }
      | {
          __typename: 'AlertTargetSlack';
          label?: string | null;
          channelID: string;
          UUID: string;
          type: AlertTargetType;
        }
      | {
          __typename: 'AlertTargetWebhook';
          url: string;
          label?: string | null;
          UUID: string;
          type: AlertTargetType;
        }
    >;
  }>;
};

export type DeleteAlertTargetWebhookMutationMutationVariables = Exact<{
  UUID: Scalars['UUID']['input'];
}>;

export type DeleteAlertTargetWebhookMutationMutation = {
  __typename?: 'Mutation';
  deleteAlertTargetWebhook: { __typename?: 'AlertTargetWebhook'; UUID: string };
};

export type TestTriggerAlertTargetWebhookMutationMutationVariables = Exact<{
  UUID: Scalars['UUID']['input'];
  input: TestTriggerAlertTargetWebhookInput;
}>;

export type TestTriggerAlertTargetWebhookMutationMutation = {
  __typename?: 'Mutation';
  testTriggerWebhookAlertTarget: {
    __typename?: 'TestTriggerAlertTargetWebhookResponse';
    UUID: string;
    ok: boolean;
  };
};

export type WanSpeedTestMutationMutationVariables = Exact<{
  input: RpcwanSpeedtestInput;
}>;

export type WanSpeedTestMutationMutation = {
  __typename?: 'Mutation';
  rpcWANSpeedtest: {
    __typename?: 'RPCWANSpeedtestResponse';
    downloadSpeedMbps: number;
    uploadSpeedMbps: number;
    latencyNs?: number | null;
    jitterNs?: number | null;
    targetName?: string | null;
    targetHost?: string | null;
    distance?: number | null;
  };
};

export type VendorsForVendorQueryVariables = Exact<{
  vendorSubstring: Scalars['String']['input'];
}>;

export type VendorsForVendorQuery = {
  __typename?: 'Query';
  OUIsForVendor: Array<{
    __typename?: 'OUIsForVendorResult';
    vendor: { __typename?: 'IEEEDeviceVendor'; vendorAddress: string; vendor: string };
  }>;
};

export type VlansForPingQueryVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
}>;

export type VlansForPingQuery = {
  __typename?: 'Query';
  vlans: Array<{ __typename?: 'VLAN'; UUID: string; name: string }>;
};

export type RpcPing2MutationMutationVariables = Exact<{
  input: RpcPingInput;
}>;

export type RpcPing2MutationMutation = {
  __typename?: 'Mutation';
  rpcPing: { __typename?: 'RPCPingResponse'; successRate: number; roundTripTimeMs?: number | null };
};

export type StartSpeedtestJobMutationVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
  input: StartWanSpeedtestJobInput;
}>;

export type StartSpeedtestJobMutation = {
  __typename?: 'Mutation';
  startWANSpeedtestJob: { __typename?: 'WANSpeedtestJob'; UUID: string };
};

export type WanSpeedtestJobQueryVariables = Exact<{
  UUID: Scalars['UUID']['input'];
}>;

export type WanSpeedtestJobQuery = {
  __typename?: 'Query';
  wanSpeedtestJob: {
    __typename?: 'WANSpeedtestJob';
    UUID: string;
    completedAt?: string | null;
    status?: WanSpeedtestStatus | null;
    results?: Array<{
      __typename?: 'WANSpeedtestJobResult';
      direction: WanSpeedtestDirection;
      transferBytes?: number | null;
      durationNs?: number | null;
      mbps?: number | null;
      httpRTTsNs: Array<number>;
      failed: boolean;
    }> | null;
  };
};

export type CompanyUserBodyFragment = {
  __typename?: 'CompanyUser';
  createdAt: string;
  deletedAt?: string | null;
  UUID: string;
  companyMembershipRole: CompanyMembershipRole;
  roles: Array<{
    __typename?: 'RoleAssignment';
    companySlug?: string | null;
    name: RoleName;
    networkUUID?: string | null;
  }>;
  user: { __typename?: 'User'; email: string; firstName?: string | null; lastName?: string | null };
};

export type GetCompanyUsersQueryVariables = Exact<{
  companySlug: Scalars['String']['input'];
  input?: InputMaybe<GetCompanyUserInput>;
}>;

export type GetCompanyUsersQuery = {
  __typename?: 'Query';
  companyUsers: Array<{
    __typename?: 'CompanyUser';
    createdAt: string;
    deletedAt?: string | null;
    UUID: string;
    companyMembershipRole: CompanyMembershipRole;
    roles: Array<{
      __typename?: 'RoleAssignment';
      companySlug?: string | null;
      name: RoleName;
      networkUUID?: string | null;
    }>;
    user: {
      __typename?: 'User';
      email: string;
      firstName?: string | null;
      lastName?: string | null;
    };
  }>;
};

export type GetCompanyUserQueryVariables = Exact<{
  uuid: Scalars['UUID']['input'];
  input?: InputMaybe<GetCompanyUserInput>;
}>;

export type GetCompanyUserQuery = {
  __typename?: 'Query';
  companyUser: {
    __typename?: 'CompanyUser';
    createdAt: string;
    deletedAt?: string | null;
    UUID: string;
    companyMembershipRole: CompanyMembershipRole;
    roles: Array<{
      __typename?: 'RoleAssignment';
      companySlug?: string | null;
      name: RoleName;
      networkUUID?: string | null;
    }>;
    user: {
      __typename?: 'User';
      email: string;
      firstName?: string | null;
      lastName?: string | null;
    };
  };
};

export type DeleteCompanyUserMutationVariables = Exact<{
  uuid: Scalars['UUID']['input'];
}>;

export type DeleteCompanyUserMutation = {
  __typename?: 'Mutation';
  deleteCompanyUser: { __typename?: 'CompanyUser'; UUID: string };
};

export type ReactivateCompanyUserMutationVariables = Exact<{
  uuid: Scalars['UUID']['input'];
}>;

export type ReactivateCompanyUserMutation = {
  __typename?: 'Mutation';
  activateCompanyUser: { __typename?: 'CompanyUser'; UUID: string };
};

export type CreateCompanyUserMutationVariables = Exact<{
  companySlug: Scalars['String']['input'];
  input: CreateCompanyUserInput;
}>;

export type CreateCompanyUserMutation = {
  __typename?: 'Mutation';
  createCompanyUser: { __typename?: 'CompanyUser'; UUID: string };
};

export type UpdateCompanyUserMutationVariables = Exact<{
  uuid: Scalars['UUID']['input'];
  input: UpdateCompanyUserInput;
}>;

export type UpdateCompanyUserMutation = {
  __typename?: 'Mutation';
  updateCompanyUser: { __typename?: 'CompanyUser'; UUID: string };
};

export type UpdateUserRolesMutationVariables = Exact<{
  uuid: Scalars['UUID']['input'];
  input: Array<UserRoleInput> | UserRoleInput;
}>;

export type UpdateUserRolesMutation = {
  __typename?: 'Mutation';
  updateUserRoles: { __typename?: 'CompanyUser'; UUID: string };
};

export type AssignOperatorRoleMutationVariables = Exact<{
  uuid: Scalars['UUID']['input'];
}>;

export type AssignOperatorRoleMutation = {
  __typename?: 'Mutation';
  assignOperatorRole: { __typename?: 'CompanyUser'; UUID: string };
};

export type RemoveOperatorRoleMutationVariables = Exact<{
  uuid: Scalars['UUID']['input'];
}>;

export type RemoveOperatorRoleMutation = {
  __typename?: 'Mutation';
  removeOperatorRole: { __typename?: 'CompanyUser'; UUID: string };
};

export type RadioProfilesQueryQueryVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
}>;

export type RadioProfilesQueryQuery = {
  __typename?: 'Query';
  radioProfilesForNetwork: Array<{
    __typename?: 'RadioProfile';
    UUID: string;
    name: string;
    description?: string | null;
    isDefault: boolean;
    band2_4GIsEnabled: boolean;
    band2_4GAutoChannelIsEnabled: boolean;
    band2_4GAllowedChannels?: Array<number> | null;
    band2_4GAutoChannelWidthIsEnabled: boolean;
    band2_4GAutoTxPowerIsEnabled: boolean;
    band2_4GChannelWidthMHz?: number | null;
    band2_4GAutoTxPowerMaxdBm?: number | null;
    band2_4GAutoTxPowerMindBm?: number | null;
    band5GIsEnabled: boolean;
    band5GAutoChannelIsEnabled: boolean;
    band5GAllowedChannels?: Array<number> | null;
    band5GAutoChannelWidthIsEnabled: boolean;
    band5GAutoTxPowerIsEnabled: boolean;
    band5GChannelWidthMHz?: number | null;
    band5GAutoTxPowerMaxdBm?: number | null;
    band5GAutoTxPowerMindBm?: number | null;
    band6GIsEnabled: boolean;
    band6GAutoChannelIsEnabled: boolean;
    band6GAllowedChannels?: Array<number> | null;
    band6GAutoChannelWidthIsEnabled: boolean;
    band6GAutoTxPowerIsEnabled: boolean;
    band6GChannelWidthMHz?: number | null;
    band6GAutoTxPowerMaxdBm?: number | null;
    band6GAutoTxPowerMindBm?: number | null;
    virtualDevices: Array<
      | {
          __typename: 'AccessPointVirtualDevice';
          UUID: string;
          label: string;
          radioSettings: {
            __typename?: 'RadioSettings';
            band2_4GPrimaryChannel: number;
            band5GPrimaryChannel: number;
            band6GPrimaryChannel: number;
          };
        }
      | { __typename: 'ControllerVirtualDevice'; UUID: string; label: string }
      | { __typename: 'ObserverVirtualDevice'; UUID: string; label: string }
      | { __typename: 'PowerDistributionUnitVirtualDevice'; UUID: string; label: string }
      | { __typename: 'SwitchVirtualDevice'; UUID: string; label: string }
    >;
  }>;
};

export type CreateRadioProfileMutationMutationVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
  input: CreateRadioProfileInput;
}>;

export type CreateRadioProfileMutationMutation = {
  __typename?: 'Mutation';
  createRadioProfile: { __typename?: 'RadioProfile'; UUID: string };
};

export type UpdateRadioProfileMutationMutationVariables = Exact<{
  uuid: Scalars['UUID']['input'];
  input: UpdateRadioProfileInput;
}>;

export type UpdateRadioProfileMutationMutation = {
  __typename?: 'Mutation';
  updateRadioProfile: { __typename?: 'RadioProfile'; UUID: string };
};

export type DeleteRadioProfileMutationMutationVariables = Exact<{
  uuid: Scalars['UUID']['input'];
}>;

export type DeleteRadioProfileMutationMutation = {
  __typename?: 'Mutation';
  deleteRadioProfile: { __typename?: 'RadioProfile'; UUID: string };
};

export type WirelessInfoForNetworkQueryVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
}>;

export type WirelessInfoForNetworkQuery = {
  __typename?: 'Query';
  network: {
    __typename?: 'Network';
    UUID: string;
    wirelessMaxTxPowerdBm: number;
    wirelessValidChannels: Array<{
      __typename?: 'ValidChannelsResponse';
      band: RadioBand;
      channels: Array<number>;
    }>;
  };
};

export type PsKsQueryVariables = Exact<{
  ssidUUID: Scalars['UUID']['input'];
}>;

export type PsKsQuery = {
  __typename?: 'Query';
  wifiIPSKs: Array<{
    __typename?: 'WifiIPSK';
    UUID: string;
    clientMACs?: Array<string> | null;
    label?: string | null;
    password: string;
    vlanUUID?: string | null;
    ssidUUID: string;
  }>;
};

export type CreatePskMutationVariables = Exact<{
  input: CreateWifiIpskInput;
}>;

export type CreatePskMutation = {
  __typename?: 'Mutation';
  createWifiIPSK: { __typename?: 'WifiIPSK'; UUID: string };
};

export type UpdatePskMutationVariables = Exact<{
  uuid: Scalars['UUID']['input'];
  input: UpdateWifiIpskInput;
}>;

export type UpdatePskMutation = {
  __typename?: 'Mutation';
  updateWifiIPSK: { __typename?: 'WifiIPSK'; UUID: string };
};

export type DeletePskMutationVariables = Exact<{
  uuid: Scalars['UUID']['input'];
}>;

export type DeletePskMutation = {
  __typename?: 'Mutation';
  deleteWifiIPSK: { __typename?: 'WifiIPSK'; UUID: string };
};

export type RpceapolTestMutationMutationVariables = Exact<{
  input: RpcEapolTestForSerialsInput;
}>;

export type RpceapolTestMutationMutation = {
  __typename?: 'Mutation';
  rpcWosEapolTestForSerials: Array<{
    __typename?: 'RPCEapolTestForSerialResponse';
    status: RpcEapolTestForSerialStatus;
    error_reason?: string | null;
    serialNumber: string;
  }>;
};

export type SsidFieldsFragment = {
  __typename: 'SSID';
  UUID: string;
  ssid: string;
  clientSteeringAssociationSteeringIsEnabled: boolean;
  clientSteeringLoadBalancingClientMinThreshold?: number | null;
  clientSteeringPreassociationRSSIMinThreshold?: number | null;
  clientSteeringPostassociationSteeringIsEnabled?: boolean | null;
  description?: string | null;
  is80211axEnabled: boolean;
  isEnabled: boolean;
  isGuest: boolean;
  isHidden: boolean;
  isIsolateClientsEnabled: boolean;
  encryptionProtocol?: SsidEncryptionProtocol | null;
  password?: string | null;
  isBand2GAllowed: boolean;
  isBand5GAllowed: boolean;
  isBand6GAllowed: boolean;
  passwordRotationCadence?: SsidPasswordRotationCadence | null;
  passwordRotationDayOfMonthLocal?: number | null;
  passwordRotationDayOfWeekLocal?: number | null;
  passwordRotationHourOfDayLocal?: number | null;
  passwordLastRotatedAt?: string | null;
  passwordNextRotationAt?: string | null;
  band2GMinimumBasicRateKbps?: number | null;
  band5GMinimumBasicRateKbps?: number | null;
  band6GMinimumBasicRateKbps?: number | null;
  isEnabledForAllAccessPoints: boolean;
  roaming80211rIsEnabled: boolean;
  roaming80211kIsEnabled: boolean;
  roaming80211vIsEnabled: boolean;
  encryption80211wProtectedManagementFramesMode?: SsidEncryption80211wProtectedManagementFramesMode | null;
  hs20HasProfile: boolean;
  hs20Enabled: boolean;
  hs20OperatorNames?: Array<string> | null;
  hs20VenueNames?: Array<string> | null;
  hs20VenueGroup?: number | null;
  hs20VenueType?: number | null;
  hs20AccessNetworkType?: number | null;
  hs20RoamingConsortiumOIs?: Array<string> | null;
  hs20DomainNames?: Array<string> | null;
  hs20NaiRealms?: Array<string> | null;
  hs20MccMncPairs?: Array<string> | null;
  dynamicVLANMode?: SsidDynamicVlanMode | null;
  radiusCoaEnabled: boolean;
  radiusCoaPort?: number | null;
  nasIdentifier?: string | null;
  rtsCtsEnabledCode?: number | null;
  rtsThreshold?: number | null;
  network: { __typename?: 'Network'; UUID: string; slug: string; label: string };
  primaryEncryption8021X?: { __typename?: 'Encryption8021X'; UUID: string; label: string } | null;
  secondaryEncryption8021X?: { __typename?: 'Encryption8021X'; UUID: string; label: string } | null;
  enabledAccessPointVirtualDevices?: Array<{
    __typename?: 'AccessPointVirtualDevice';
    UUID: string;
    label: string;
  }> | null;
  disabledAccessPointVirtualDevices?: Array<{
    __typename?: 'AccessPointVirtualDevice';
    UUID: string;
    label: string;
  }> | null;
  vlan?: { __typename?: 'VLAN'; UUID: string; name: string; vlanID: number } | null;
  broadcastSchedule?: Array<{
    __typename?: 'SSIDBroadcastScheduleInterval';
    startDayOfWeek: number;
    startHour: number;
    startMinute: number;
    endDayOfWeek: number;
    endHour: number;
    endMinute: number;
  }> | null;
  rateLimitRules: Array<{
    __typename?: 'RateLimitRule';
    UUID: string;
    isPerSource: boolean;
    rateLimitKbpsUpload?: number | null;
    rateLimitKbpsDownload?: number | null;
  }>;
};

export type SsidQueryVariables = Exact<{
  uuid: Scalars['UUID']['input'];
}>;

export type SsidQuery = {
  __typename?: 'Query';
  ssid: {
    __typename: 'SSID';
    UUID: string;
    ssid: string;
    clientSteeringAssociationSteeringIsEnabled: boolean;
    clientSteeringLoadBalancingClientMinThreshold?: number | null;
    clientSteeringPreassociationRSSIMinThreshold?: number | null;
    clientSteeringPostassociationSteeringIsEnabled?: boolean | null;
    description?: string | null;
    is80211axEnabled: boolean;
    isEnabled: boolean;
    isGuest: boolean;
    isHidden: boolean;
    isIsolateClientsEnabled: boolean;
    encryptionProtocol?: SsidEncryptionProtocol | null;
    password?: string | null;
    isBand2GAllowed: boolean;
    isBand5GAllowed: boolean;
    isBand6GAllowed: boolean;
    passwordRotationCadence?: SsidPasswordRotationCadence | null;
    passwordRotationDayOfMonthLocal?: number | null;
    passwordRotationDayOfWeekLocal?: number | null;
    passwordRotationHourOfDayLocal?: number | null;
    passwordLastRotatedAt?: string | null;
    passwordNextRotationAt?: string | null;
    band2GMinimumBasicRateKbps?: number | null;
    band5GMinimumBasicRateKbps?: number | null;
    band6GMinimumBasicRateKbps?: number | null;
    isEnabledForAllAccessPoints: boolean;
    roaming80211rIsEnabled: boolean;
    roaming80211kIsEnabled: boolean;
    roaming80211vIsEnabled: boolean;
    encryption80211wProtectedManagementFramesMode?: SsidEncryption80211wProtectedManagementFramesMode | null;
    hs20HasProfile: boolean;
    hs20Enabled: boolean;
    hs20OperatorNames?: Array<string> | null;
    hs20VenueNames?: Array<string> | null;
    hs20VenueGroup?: number | null;
    hs20VenueType?: number | null;
    hs20AccessNetworkType?: number | null;
    hs20RoamingConsortiumOIs?: Array<string> | null;
    hs20DomainNames?: Array<string> | null;
    hs20NaiRealms?: Array<string> | null;
    hs20MccMncPairs?: Array<string> | null;
    dynamicVLANMode?: SsidDynamicVlanMode | null;
    radiusCoaEnabled: boolean;
    radiusCoaPort?: number | null;
    nasIdentifier?: string | null;
    rtsCtsEnabledCode?: number | null;
    rtsThreshold?: number | null;
    network: { __typename?: 'Network'; UUID: string; slug: string; label: string };
    primaryEncryption8021X?: { __typename?: 'Encryption8021X'; UUID: string; label: string } | null;
    secondaryEncryption8021X?: {
      __typename?: 'Encryption8021X';
      UUID: string;
      label: string;
    } | null;
    enabledAccessPointVirtualDevices?: Array<{
      __typename?: 'AccessPointVirtualDevice';
      UUID: string;
      label: string;
    }> | null;
    disabledAccessPointVirtualDevices?: Array<{
      __typename?: 'AccessPointVirtualDevice';
      UUID: string;
      label: string;
    }> | null;
    vlan?: { __typename?: 'VLAN'; UUID: string; name: string; vlanID: number } | null;
    broadcastSchedule?: Array<{
      __typename?: 'SSIDBroadcastScheduleInterval';
      startDayOfWeek: number;
      startHour: number;
      startMinute: number;
      endDayOfWeek: number;
      endHour: number;
      endMinute: number;
    }> | null;
    rateLimitRules: Array<{
      __typename?: 'RateLimitRule';
      UUID: string;
      isPerSource: boolean;
      rateLimitKbpsUpload?: number | null;
      rateLimitKbpsDownload?: number | null;
    }>;
  };
};

export type SsiDsForCompanyNetworksQueryVariables = Exact<{
  companySlug: Scalars['String']['input'];
  networkUUIDs?: InputMaybe<Array<Scalars['UUID']['input']> | Scalars['UUID']['input']>;
}>;

export type SsiDsForCompanyNetworksQuery = {
  __typename?: 'Query';
  companyBySlug: {
    __typename?: 'Company';
    networks: Array<{
      __typename?: 'Network';
      ssids: Array<{
        __typename: 'SSID';
        UUID: string;
        ssid: string;
        clientSteeringAssociationSteeringIsEnabled: boolean;
        clientSteeringLoadBalancingClientMinThreshold?: number | null;
        clientSteeringPreassociationRSSIMinThreshold?: number | null;
        clientSteeringPostassociationSteeringIsEnabled?: boolean | null;
        description?: string | null;
        is80211axEnabled: boolean;
        isEnabled: boolean;
        isGuest: boolean;
        isHidden: boolean;
        isIsolateClientsEnabled: boolean;
        encryptionProtocol?: SsidEncryptionProtocol | null;
        password?: string | null;
        isBand2GAllowed: boolean;
        isBand5GAllowed: boolean;
        isBand6GAllowed: boolean;
        passwordRotationCadence?: SsidPasswordRotationCadence | null;
        passwordRotationDayOfMonthLocal?: number | null;
        passwordRotationDayOfWeekLocal?: number | null;
        passwordRotationHourOfDayLocal?: number | null;
        passwordLastRotatedAt?: string | null;
        passwordNextRotationAt?: string | null;
        band2GMinimumBasicRateKbps?: number | null;
        band5GMinimumBasicRateKbps?: number | null;
        band6GMinimumBasicRateKbps?: number | null;
        isEnabledForAllAccessPoints: boolean;
        roaming80211rIsEnabled: boolean;
        roaming80211kIsEnabled: boolean;
        roaming80211vIsEnabled: boolean;
        encryption80211wProtectedManagementFramesMode?: SsidEncryption80211wProtectedManagementFramesMode | null;
        hs20HasProfile: boolean;
        hs20Enabled: boolean;
        hs20OperatorNames?: Array<string> | null;
        hs20VenueNames?: Array<string> | null;
        hs20VenueGroup?: number | null;
        hs20VenueType?: number | null;
        hs20AccessNetworkType?: number | null;
        hs20RoamingConsortiumOIs?: Array<string> | null;
        hs20DomainNames?: Array<string> | null;
        hs20NaiRealms?: Array<string> | null;
        hs20MccMncPairs?: Array<string> | null;
        dynamicVLANMode?: SsidDynamicVlanMode | null;
        radiusCoaEnabled: boolean;
        radiusCoaPort?: number | null;
        nasIdentifier?: string | null;
        rtsCtsEnabledCode?: number | null;
        rtsThreshold?: number | null;
        network: { __typename?: 'Network'; UUID: string; slug: string; label: string };
        primaryEncryption8021X?: {
          __typename?: 'Encryption8021X';
          UUID: string;
          label: string;
        } | null;
        secondaryEncryption8021X?: {
          __typename?: 'Encryption8021X';
          UUID: string;
          label: string;
        } | null;
        enabledAccessPointVirtualDevices?: Array<{
          __typename?: 'AccessPointVirtualDevice';
          UUID: string;
          label: string;
        }> | null;
        disabledAccessPointVirtualDevices?: Array<{
          __typename?: 'AccessPointVirtualDevice';
          UUID: string;
          label: string;
        }> | null;
        vlan?: { __typename?: 'VLAN'; UUID: string; name: string; vlanID: number } | null;
        broadcastSchedule?: Array<{
          __typename?: 'SSIDBroadcastScheduleInterval';
          startDayOfWeek: number;
          startHour: number;
          startMinute: number;
          endDayOfWeek: number;
          endHour: number;
          endMinute: number;
        }> | null;
        rateLimitRules: Array<{
          __typename?: 'RateLimitRule';
          UUID: string;
          isPerSource: boolean;
          rateLimitKbpsUpload?: number | null;
          rateLimitKbpsDownload?: number | null;
        }>;
      }>;
    }>;
  };
};

export type SsidsForNetworkQueryVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
}>;

export type SsidsForNetworkQuery = {
  __typename?: 'Query';
  ssidsForNetwork: Array<{
    __typename: 'SSID';
    UUID: string;
    ssid: string;
    clientSteeringAssociationSteeringIsEnabled: boolean;
    clientSteeringLoadBalancingClientMinThreshold?: number | null;
    clientSteeringPreassociationRSSIMinThreshold?: number | null;
    clientSteeringPostassociationSteeringIsEnabled?: boolean | null;
    description?: string | null;
    is80211axEnabled: boolean;
    isEnabled: boolean;
    isGuest: boolean;
    isHidden: boolean;
    isIsolateClientsEnabled: boolean;
    encryptionProtocol?: SsidEncryptionProtocol | null;
    password?: string | null;
    isBand2GAllowed: boolean;
    isBand5GAllowed: boolean;
    isBand6GAllowed: boolean;
    passwordRotationCadence?: SsidPasswordRotationCadence | null;
    passwordRotationDayOfMonthLocal?: number | null;
    passwordRotationDayOfWeekLocal?: number | null;
    passwordRotationHourOfDayLocal?: number | null;
    passwordLastRotatedAt?: string | null;
    passwordNextRotationAt?: string | null;
    band2GMinimumBasicRateKbps?: number | null;
    band5GMinimumBasicRateKbps?: number | null;
    band6GMinimumBasicRateKbps?: number | null;
    isEnabledForAllAccessPoints: boolean;
    roaming80211rIsEnabled: boolean;
    roaming80211kIsEnabled: boolean;
    roaming80211vIsEnabled: boolean;
    encryption80211wProtectedManagementFramesMode?: SsidEncryption80211wProtectedManagementFramesMode | null;
    hs20HasProfile: boolean;
    hs20Enabled: boolean;
    hs20OperatorNames?: Array<string> | null;
    hs20VenueNames?: Array<string> | null;
    hs20VenueGroup?: number | null;
    hs20VenueType?: number | null;
    hs20AccessNetworkType?: number | null;
    hs20RoamingConsortiumOIs?: Array<string> | null;
    hs20DomainNames?: Array<string> | null;
    hs20NaiRealms?: Array<string> | null;
    hs20MccMncPairs?: Array<string> | null;
    dynamicVLANMode?: SsidDynamicVlanMode | null;
    radiusCoaEnabled: boolean;
    radiusCoaPort?: number | null;
    nasIdentifier?: string | null;
    rtsCtsEnabledCode?: number | null;
    rtsThreshold?: number | null;
    network: { __typename?: 'Network'; UUID: string; slug: string; label: string };
    primaryEncryption8021X?: { __typename?: 'Encryption8021X'; UUID: string; label: string } | null;
    secondaryEncryption8021X?: {
      __typename?: 'Encryption8021X';
      UUID: string;
      label: string;
    } | null;
    enabledAccessPointVirtualDevices?: Array<{
      __typename?: 'AccessPointVirtualDevice';
      UUID: string;
      label: string;
    }> | null;
    disabledAccessPointVirtualDevices?: Array<{
      __typename?: 'AccessPointVirtualDevice';
      UUID: string;
      label: string;
    }> | null;
    vlan?: { __typename?: 'VLAN'; UUID: string; name: string; vlanID: number } | null;
    broadcastSchedule?: Array<{
      __typename?: 'SSIDBroadcastScheduleInterval';
      startDayOfWeek: number;
      startHour: number;
      startMinute: number;
      endDayOfWeek: number;
      endHour: number;
      endMinute: number;
    }> | null;
    rateLimitRules: Array<{
      __typename?: 'RateLimitRule';
      UUID: string;
      isPerSource: boolean;
      rateLimitKbpsUpload?: number | null;
      rateLimitKbpsDownload?: number | null;
    }>;
  }>;
};

export type Hs20AccessNetworkTypesQueryVariables = Exact<{ [key: string]: never }>;

export type Hs20AccessNetworkTypesQuery = {
  __typename?: 'Query';
  hs20ValidTypes: {
    __typename?: 'Hs20ValidTypesResponse';
    accessNetworkTypes: Array<{
      __typename?: 'Hs20AccessNetworkTypes';
      type: number;
      description: string;
    }>;
    venueTypes: Array<{
      __typename?: 'Hs20VenueTypes';
      group: number;
      type: number;
      description: string;
    }>;
    eapMethods: Array<{
      __typename?: 'Hs20EapMethod';
      method: number;
      description: string;
      mostUsed: boolean;
    }>;
    authParams: Array<{
      __typename?: 'Hs20AuthParam';
      param: number;
      description: string;
      validValues: Array<{ __typename?: 'Hs20AuthValue'; value: number; description: string }>;
    }>;
  };
};

export type CreateSsidMutationMutationVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
  input: CreateSsidInput;
}>;

export type CreateSsidMutationMutation = {
  __typename?: 'Mutation';
  createSSID: { __typename?: 'SSID'; UUID: string };
};

export type UpdateSsidMutationMutationVariables = Exact<{
  uuid: Scalars['UUID']['input'];
  input: UpdateSsidInput;
}>;

export type UpdateSsidMutationMutation = {
  __typename?: 'Mutation';
  updateSSID: { __typename?: 'SSID'; UUID: string };
};

export type DeleteSsidMutationMutationVariables = Exact<{
  uuid: Scalars['UUID']['input'];
}>;

export type DeleteSsidMutationMutation = {
  __typename?: 'Mutation';
  deleteSSID: { __typename?: 'SSID'; UUID: string };
};

export type RadiusProfilesQueryQueryVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
}>;

export type RadiusProfilesQueryQuery = {
  __typename?: 'Query';
  encryption8021XsForNetwork: Array<{
    __typename?: 'Encryption8021X';
    UUID: string;
    label: string;
    authServerIPAddress: string;
    authServerPort: number;
    authServerSecret: string;
    accountingServerIPAddress?: string | null;
    accountingServerPort?: number | null;
    accountingServerSecret?: string | null;
    ssids?: Array<{ __typename?: 'SSID'; UUID: string; ssid: string }> | null;
  }>;
};

export type CreateRadiusProfileMutationMutationVariables = Exact<{
  input: CreateEncryption8021XInput;
}>;

export type CreateRadiusProfileMutationMutation = {
  __typename?: 'Mutation';
  createEncryption8021X: { __typename?: 'Encryption8021X'; UUID: string };
};

export type UpdateRadiusProfileMutationMutationVariables = Exact<{
  uuid: Scalars['UUID']['input'];
  input: UpdateEncryption8021XInput;
}>;

export type UpdateRadiusProfileMutationMutation = {
  __typename?: 'Mutation';
  updateEncryption8021X: { __typename?: 'Encryption8021X'; UUID: string };
};

export type DeleteRadiusProfileMutationMutationVariables = Exact<{
  uuid: Scalars['UUID']['input'];
}>;

export type DeleteRadiusProfileMutationMutation = {
  __typename?: 'Mutation';
  deleteEncryption8021X: { __typename?: 'Encryption8021X'; UUID: string };
};

export type NetworkThreatObserverFieldsFragment = {
  __typename?: 'NetworkThreatObserver';
  ssid: string;
  observedAt: string;
  rssi: number;
  noiseFloor: number;
  virtualDevice?:
    | { __typename: 'AccessPointVirtualDevice'; UUID: string; label: string }
    | { __typename: 'ControllerVirtualDevice'; UUID: string; label: string }
    | { __typename: 'ObserverVirtualDevice'; UUID: string; label: string }
    | { __typename: 'PowerDistributionUnitVirtualDevice'; UUID: string; label: string }
    | { __typename: 'SwitchVirtualDevice'; UUID: string; label: string }
    | null;
};

export type RogueAccessPointsQueryVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
}>;

export type RogueAccessPointsQuery = {
  __typename?: 'Query';
  rogueAccessPointsObservedOnNetwork?: Array<{
    __typename?: 'RogueAccessPoint';
    vendor?: string | null;
    networkUUID: string;
    macAddress: string;
    phyInterface: {
      __typename?: 'PhyInterface';
      UUID: string;
      isEnabled: boolean;
      portNumber: number;
      description?: string | null;
      virtualDevice:
        | { __typename?: 'AccessPointVirtualDevice'; UUID: string; label: string }
        | { __typename?: 'ControllerVirtualDevice'; UUID: string; label: string }
        | { __typename?: 'ObserverVirtualDevice'; UUID: string; label: string }
        | { __typename?: 'PowerDistributionUnitVirtualDevice'; UUID: string; label: string }
        | { __typename?: 'SwitchVirtualDevice'; UUID: string; label: string };
    };
    observers: Array<{
      __typename?: 'NetworkThreatObserver';
      ssid: string;
      observedAt: string;
      rssi: number;
      noiseFloor: number;
      virtualDevice?:
        | { __typename: 'AccessPointVirtualDevice'; UUID: string; label: string }
        | { __typename: 'ControllerVirtualDevice'; UUID: string; label: string }
        | { __typename: 'ObserverVirtualDevice'; UUID: string; label: string }
        | { __typename: 'PowerDistributionUnitVirtualDevice'; UUID: string; label: string }
        | { __typename: 'SwitchVirtualDevice'; UUID: string; label: string }
        | null;
    }>;
  }> | null;
};

export type HoneypotSsiDsQueryVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
}>;

export type HoneypotSsiDsQuery = {
  __typename?: 'Query';
  honeypotSSIDsObservedOnNetwork?: Array<{
    __typename?: 'HoneypotSSID';
    networkUUID: string;
    ssid: string;
    broadcasters: Array<{
      __typename?: 'HoneypotBroadcaster';
      bssid: string;
      observers: Array<{
        __typename?: 'NetworkThreatObserver';
        ssid: string;
        observedAt: string;
        rssi: number;
        noiseFloor: number;
        virtualDevice?:
          | { __typename: 'AccessPointVirtualDevice'; UUID: string; label: string }
          | { __typename: 'ControllerVirtualDevice'; UUID: string; label: string }
          | { __typename: 'ObserverVirtualDevice'; UUID: string; label: string }
          | { __typename: 'PowerDistributionUnitVirtualDevice'; UUID: string; label: string }
          | { __typename: 'SwitchVirtualDevice'; UUID: string; label: string }
          | null;
      }>;
    }>;
  }> | null;
};

export type NetworkThreatAllowlistForNetworkQueryVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
}>;

export type NetworkThreatAllowlistForNetworkQuery = {
  __typename?: 'Query';
  networkThreatAllowlistForNetwork?: Array<{
    __typename?: 'NetworkThreatAllowlistEntry';
    UUID: string;
    reason?: string | null;
    wiredMAC?: string | null;
    ssidUUID?: string | null;
    updatedAt: string;
  }> | null;
};

export type CreateNetworkThreatAllowlistEntryMutationVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
  input: CreateNetworkThreatAllowlistEntryInput;
}>;

export type CreateNetworkThreatAllowlistEntryMutation = {
  __typename?: 'Mutation';
  createNetworkThreatAllowlistEntry: { __typename?: 'NetworkThreatAllowlistEntry'; UUID: string };
};

export type UpdateNetworkThreatAllowlistEntryMutationVariables = Exact<{
  uuid: Scalars['UUID']['input'];
  input: UpdateNetworkThreatAllowlistEntryInput;
}>;

export type UpdateNetworkThreatAllowlistEntryMutation = {
  __typename?: 'Mutation';
  updateNetworkThreatAllowlistEntry: { __typename?: 'NetworkThreatAllowlistEntry'; UUID: string };
};

export type DeleteNetworkThreatAllowlistEntryMutationVariables = Exact<{
  uuid: Scalars['UUID']['input'];
}>;

export type DeleteNetworkThreatAllowlistEntryMutation = {
  __typename?: 'Mutation';
  deleteNetworkThreatAllowlistEntry: { __typename?: 'NetworkThreatAllowlistEntry'; UUID: string };
};

export type WirelessClientMetricsByAccessPointQueryQueryVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
  virtualDeviceUUID: Scalars['UUID']['input'];
  filter: ClientMetricsTimeseriesFilterInput;
}>;

export type WirelessClientMetricsByAccessPointQueryQuery = {
  __typename?: 'Query';
  wirelessClientMetricsByAP: {
    __typename?: 'ClientMetricsTimeseriesResponse';
    metadata?: {
      __typename?: 'ClientMetricsMetadata';
      signal?: { __typename?: 'MetricsMetadata'; minValue: number; maxValue: number } | null;
      noise?: { __typename?: 'MetricsMetadata'; minValue: number; maxValue: number } | null;
      tx?: { __typename?: 'MetricsMetadata'; minValue: number; maxValue: number } | null;
      rx?: { __typename?: 'MetricsMetadata'; minValue: number; maxValue: number } | null;
    } | null;
    values: Array<{
      __typename?: 'ClientMetricsTimeseriesValue';
      timestamp: string;
      signal: number;
      noise: number;
      txRate: number;
      rxRate: number;
      snr: number;
      txBytes: number;
      rxBytes: number;
      txMulticastBytes: number;
      rxMulticastBytes: number;
      txUnicastBytes: number;
      rxUnicastBytes: number;
      clientCount: number;
    }>;
  };
};

export type ApChannelUtilizationByNetworkQueryQueryVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
  filter: ChannelUtilizationTimeseriesFilterInput;
}>;

export type ApChannelUtilizationByNetworkQueryQuery = {
  __typename?: 'Query';
  channelUtilizationByNetwork: Array<{
    __typename?: 'ChannelUtilizationResponseV2';
    band: RadioBand;
    virtualDeviceUUID: string;
    values: Array<{
      __typename?: 'APChannelUtilizationTimeseriesValue';
      totalUtilization: number;
      timestamp: string;
    }>;
  }>;
};

export type ApHealthScoresByAccessPointQueryQueryVariables = Exact<{
  serialNumber: Scalars['String']['input'];
  filter: MetricsFilterInput;
}>;

export type ApHealthScoresByAccessPointQueryQuery = {
  __typename?: 'Query';
  apHealthScores: Array<{
    __typename?: 'AccessPointHealthScores';
    timestamp: string;
    overallScore: number;
    performanceScore: number;
    connectionScore: number;
    rfScore: number;
    systemScore: number;
  }>;
};

export type ApChannelUtilizationByAccessPointQueryQueryVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
  virtualDeviceUUID: Scalars['UUID']['input'];
  filter: ChannelUtilizationTimeseriesFilterInput;
}>;

export type ApChannelUtilizationByAccessPointQueryQuery = {
  __typename?: 'Query';
  channelUtilizationByAP: Array<{
    __typename?: 'ChannelUtilizationResponseV2';
    band: RadioBand;
    values: Array<{
      __typename?: 'APChannelUtilizationTimeseriesValue';
      totalUtilization: number;
      timestamp: string;
    }>;
  }>;
};

export type ObserversQueryQueryVariables = Exact<{
  companySlug: Scalars['String']['input'];
  networkUUIDs?: InputMaybe<Array<Scalars['UUID']['input']> | Scalars['UUID']['input']>;
  includeUptime?: InputMaybe<Scalars['Boolean']['input']>;
  includeConfigMetadata?: InputMaybe<Scalars['Boolean']['input']>;
  includeNOS?: InputMaybe<Scalars['Boolean']['input']>;
  includeIsDev?: InputMaybe<Scalars['Boolean']['input']>;
  resultsFilter?: InputMaybe<ObserverResultsFilterInput>;
}>;

export type ObserversQueryQuery = {
  __typename?: 'Query';
  companyBySlug: {
    __typename?: 'Company';
    networks: Array<{
      __typename?: 'Network';
      virtualDevices: Array<
        | {
            __typename: 'AccessPointVirtualDevice';
            UUID: string;
            label: string;
            description?: string | null;
            deviceType: VirtualDeviceType;
            uptime?: string | null;
            network: { __typename?: 'Network'; UUID: string; slug: string; label: string };
            nosVersion?: {
              __typename?: 'ConfiguredNOSVersion';
              id: number;
              version: string;
              buildName: string;
            } | null;
            pendingNosVersion?: {
              __typename?: 'PendingNosVersion';
              scheduledAt: string;
              nosVersion: { __typename?: 'NosVersion'; version: string };
            } | null;
            hardwareDevice?:
              | {
                  __typename: 'AccessPointHardwareDevice';
                  ipAddress?: string | null;
                  isInCurrentControllerMACTable: boolean;
                  deviceType: DeviceType;
                  serialNumber: string;
                  macAddress?: string | null;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  isDev?: boolean;
                  phyInterfaceConnectedTo?: {
                    __typename?: 'PhyInterface';
                    UUID: string;
                    portSpeedMbps?: number | null;
                    maxSpeedMbps?: number | null;
                    isEthernet: boolean;
                    isSFP: boolean;
                    sfpModuleInfo?: {
                      __typename?: 'SFPModuleInfo';
                      moduleSpeedKbps?: number | null;
                    } | null;
                  } | null;
                  bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
                  latestDeviceConfigMetadata?: {
                    __typename?: 'DeviceConfigMetadata';
                    version: number;
                    acknowledgedAt?: string | null;
                    createdAt: string;
                    isCurrentAsOf?: string | null;
                    state?: {
                      __typename?: 'DeviceConfigState';
                      state: DeviceConfigStateType;
                      timestamp: string;
                    } | null;
                  } | null;
                }
              | {
                  __typename: 'ControllerHardwareDevice';
                  deviceType: DeviceType;
                  serialNumber: string;
                  macAddress?: string | null;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  isDev?: boolean;
                  bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
                  latestDeviceConfigMetadata?: {
                    __typename?: 'DeviceConfigMetadata';
                    version: number;
                    acknowledgedAt?: string | null;
                    createdAt: string;
                    isCurrentAsOf?: string | null;
                    state?: {
                      __typename?: 'DeviceConfigState';
                      state: DeviceConfigStateType;
                      timestamp: string;
                    } | null;
                  } | null;
                }
              | {
                  __typename: 'PowerDistributionUnitHardwareDevice';
                  deviceType: DeviceType;
                  serialNumber: string;
                  macAddress?: string | null;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  isDev?: boolean;
                  bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
                  latestDeviceConfigMetadata?: {
                    __typename?: 'DeviceConfigMetadata';
                    version: number;
                    acknowledgedAt?: string | null;
                    createdAt: string;
                    isCurrentAsOf?: string | null;
                    state?: {
                      __typename?: 'DeviceConfigState';
                      state: DeviceConfigStateType;
                      timestamp: string;
                    } | null;
                  } | null;
                }
              | {
                  __typename: 'SwitchHardwareDevice';
                  deviceType: DeviceType;
                  serialNumber: string;
                  macAddress?: string | null;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  isDev?: boolean;
                  bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
                  latestDeviceConfigMetadata?: {
                    __typename?: 'DeviceConfigMetadata';
                    version: number;
                    acknowledgedAt?: string | null;
                    createdAt: string;
                    isCurrentAsOf?: string | null;
                    state?: {
                      __typename?: 'DeviceConfigState';
                      state: DeviceConfigStateType;
                      timestamp: string;
                    } | null;
                  } | null;
                }
              | null;
          }
        | {
            __typename: 'ControllerVirtualDevice';
            UUID: string;
            label: string;
            description?: string | null;
            deviceType: VirtualDeviceType;
            uptime?: string | null;
            network: { __typename?: 'Network'; UUID: string; slug: string; label: string };
            nosVersion?: {
              __typename?: 'ConfiguredNOSVersion';
              id: number;
              version: string;
              buildName: string;
            } | null;
            pendingNosVersion?: {
              __typename?: 'PendingNosVersion';
              scheduledAt: string;
              nosVersion: { __typename?: 'NosVersion'; version: string };
            } | null;
            hardwareDevice?:
              | {
                  __typename: 'AccessPointHardwareDevice';
                  ipAddress?: string | null;
                  isInCurrentControllerMACTable: boolean;
                  deviceType: DeviceType;
                  serialNumber: string;
                  macAddress?: string | null;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  isDev?: boolean;
                  phyInterfaceConnectedTo?: {
                    __typename?: 'PhyInterface';
                    UUID: string;
                    portSpeedMbps?: number | null;
                    maxSpeedMbps?: number | null;
                    isEthernet: boolean;
                    isSFP: boolean;
                    sfpModuleInfo?: {
                      __typename?: 'SFPModuleInfo';
                      moduleSpeedKbps?: number | null;
                    } | null;
                  } | null;
                  bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
                  latestDeviceConfigMetadata?: {
                    __typename?: 'DeviceConfigMetadata';
                    version: number;
                    acknowledgedAt?: string | null;
                    createdAt: string;
                    isCurrentAsOf?: string | null;
                    state?: {
                      __typename?: 'DeviceConfigState';
                      state: DeviceConfigStateType;
                      timestamp: string;
                    } | null;
                  } | null;
                }
              | {
                  __typename: 'ControllerHardwareDevice';
                  deviceType: DeviceType;
                  serialNumber: string;
                  macAddress?: string | null;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  isDev?: boolean;
                  bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
                  latestDeviceConfigMetadata?: {
                    __typename?: 'DeviceConfigMetadata';
                    version: number;
                    acknowledgedAt?: string | null;
                    createdAt: string;
                    isCurrentAsOf?: string | null;
                    state?: {
                      __typename?: 'DeviceConfigState';
                      state: DeviceConfigStateType;
                      timestamp: string;
                    } | null;
                  } | null;
                }
              | {
                  __typename: 'PowerDistributionUnitHardwareDevice';
                  deviceType: DeviceType;
                  serialNumber: string;
                  macAddress?: string | null;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  isDev?: boolean;
                  bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
                  latestDeviceConfigMetadata?: {
                    __typename?: 'DeviceConfigMetadata';
                    version: number;
                    acknowledgedAt?: string | null;
                    createdAt: string;
                    isCurrentAsOf?: string | null;
                    state?: {
                      __typename?: 'DeviceConfigState';
                      state: DeviceConfigStateType;
                      timestamp: string;
                    } | null;
                  } | null;
                }
              | {
                  __typename: 'SwitchHardwareDevice';
                  deviceType: DeviceType;
                  serialNumber: string;
                  macAddress?: string | null;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  isDev?: boolean;
                  bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
                  latestDeviceConfigMetadata?: {
                    __typename?: 'DeviceConfigMetadata';
                    version: number;
                    acknowledgedAt?: string | null;
                    createdAt: string;
                    isCurrentAsOf?: string | null;
                    state?: {
                      __typename?: 'DeviceConfigState';
                      state: DeviceConfigStateType;
                      timestamp: string;
                    } | null;
                  } | null;
                }
              | null;
          }
        | {
            __typename: 'ObserverVirtualDevice';
            UUID: string;
            label: string;
            description?: string | null;
            deviceType: VirtualDeviceType;
            uptime?: string | null;
            observerSettings?: Array<{
              __typename?: 'WifiObserverSetting';
              SSIDUUID: string;
              targetVirtualDeviceUUID?: string | null;
              band: RadioBand;
              results?: Array<{
                __typename?: 'WifiObserverResults';
                numConnectionAttempts: number;
                numAssocSuccess: number;
                numDhcpSuccess: number;
                testResults?: Array<{
                  __typename?: 'WifiObserverTestResults';
                  commandType: WosObserverCommandType;
                  target: string;
                  numAttempts: number;
                  numSuccess: number;
                  totalLatencyMs: number;
                }> | null;
              }> | null;
            }> | null;
            network: { __typename?: 'Network'; UUID: string; slug: string; label: string };
            nosVersion?: {
              __typename?: 'ConfiguredNOSVersion';
              id: number;
              version: string;
              buildName: string;
            } | null;
            pendingNosVersion?: {
              __typename?: 'PendingNosVersion';
              scheduledAt: string;
              nosVersion: { __typename?: 'NosVersion'; version: string };
            } | null;
            hardwareDevice?:
              | {
                  __typename: 'AccessPointHardwareDevice';
                  ipAddress?: string | null;
                  isInCurrentControllerMACTable: boolean;
                  deviceType: DeviceType;
                  serialNumber: string;
                  macAddress?: string | null;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  isDev?: boolean;
                  phyInterfaceConnectedTo?: {
                    __typename?: 'PhyInterface';
                    UUID: string;
                    portSpeedMbps?: number | null;
                    maxSpeedMbps?: number | null;
                    isEthernet: boolean;
                    isSFP: boolean;
                    sfpModuleInfo?: {
                      __typename?: 'SFPModuleInfo';
                      moduleSpeedKbps?: number | null;
                    } | null;
                  } | null;
                  bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
                  latestDeviceConfigMetadata?: {
                    __typename?: 'DeviceConfigMetadata';
                    version: number;
                    acknowledgedAt?: string | null;
                    createdAt: string;
                    isCurrentAsOf?: string | null;
                    state?: {
                      __typename?: 'DeviceConfigState';
                      state: DeviceConfigStateType;
                      timestamp: string;
                    } | null;
                  } | null;
                }
              | {
                  __typename: 'ControllerHardwareDevice';
                  deviceType: DeviceType;
                  serialNumber: string;
                  macAddress?: string | null;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  isDev?: boolean;
                  bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
                  latestDeviceConfigMetadata?: {
                    __typename?: 'DeviceConfigMetadata';
                    version: number;
                    acknowledgedAt?: string | null;
                    createdAt: string;
                    isCurrentAsOf?: string | null;
                    state?: {
                      __typename?: 'DeviceConfigState';
                      state: DeviceConfigStateType;
                      timestamp: string;
                    } | null;
                  } | null;
                }
              | {
                  __typename: 'PowerDistributionUnitHardwareDevice';
                  deviceType: DeviceType;
                  serialNumber: string;
                  macAddress?: string | null;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  isDev?: boolean;
                  bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
                  latestDeviceConfigMetadata?: {
                    __typename?: 'DeviceConfigMetadata';
                    version: number;
                    acknowledgedAt?: string | null;
                    createdAt: string;
                    isCurrentAsOf?: string | null;
                    state?: {
                      __typename?: 'DeviceConfigState';
                      state: DeviceConfigStateType;
                      timestamp: string;
                    } | null;
                  } | null;
                }
              | {
                  __typename: 'SwitchHardwareDevice';
                  deviceType: DeviceType;
                  serialNumber: string;
                  macAddress?: string | null;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  isDev?: boolean;
                  bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
                  latestDeviceConfigMetadata?: {
                    __typename?: 'DeviceConfigMetadata';
                    version: number;
                    acknowledgedAt?: string | null;
                    createdAt: string;
                    isCurrentAsOf?: string | null;
                    state?: {
                      __typename?: 'DeviceConfigState';
                      state: DeviceConfigStateType;
                      timestamp: string;
                    } | null;
                  } | null;
                }
              | null;
          }
        | {
            __typename: 'PowerDistributionUnitVirtualDevice';
            UUID: string;
            label: string;
            description?: string | null;
            deviceType: VirtualDeviceType;
            uptime?: string | null;
            network: { __typename?: 'Network'; UUID: string; slug: string; label: string };
            nosVersion?: {
              __typename?: 'ConfiguredNOSVersion';
              id: number;
              version: string;
              buildName: string;
            } | null;
            pendingNosVersion?: {
              __typename?: 'PendingNosVersion';
              scheduledAt: string;
              nosVersion: { __typename?: 'NosVersion'; version: string };
            } | null;
            hardwareDevice?:
              | {
                  __typename: 'AccessPointHardwareDevice';
                  ipAddress?: string | null;
                  isInCurrentControllerMACTable: boolean;
                  deviceType: DeviceType;
                  serialNumber: string;
                  macAddress?: string | null;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  isDev?: boolean;
                  phyInterfaceConnectedTo?: {
                    __typename?: 'PhyInterface';
                    UUID: string;
                    portSpeedMbps?: number | null;
                    maxSpeedMbps?: number | null;
                    isEthernet: boolean;
                    isSFP: boolean;
                    sfpModuleInfo?: {
                      __typename?: 'SFPModuleInfo';
                      moduleSpeedKbps?: number | null;
                    } | null;
                  } | null;
                  bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
                  latestDeviceConfigMetadata?: {
                    __typename?: 'DeviceConfigMetadata';
                    version: number;
                    acknowledgedAt?: string | null;
                    createdAt: string;
                    isCurrentAsOf?: string | null;
                    state?: {
                      __typename?: 'DeviceConfigState';
                      state: DeviceConfigStateType;
                      timestamp: string;
                    } | null;
                  } | null;
                }
              | {
                  __typename: 'ControllerHardwareDevice';
                  deviceType: DeviceType;
                  serialNumber: string;
                  macAddress?: string | null;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  isDev?: boolean;
                  bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
                  latestDeviceConfigMetadata?: {
                    __typename?: 'DeviceConfigMetadata';
                    version: number;
                    acknowledgedAt?: string | null;
                    createdAt: string;
                    isCurrentAsOf?: string | null;
                    state?: {
                      __typename?: 'DeviceConfigState';
                      state: DeviceConfigStateType;
                      timestamp: string;
                    } | null;
                  } | null;
                }
              | {
                  __typename: 'PowerDistributionUnitHardwareDevice';
                  deviceType: DeviceType;
                  serialNumber: string;
                  macAddress?: string | null;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  isDev?: boolean;
                  bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
                  latestDeviceConfigMetadata?: {
                    __typename?: 'DeviceConfigMetadata';
                    version: number;
                    acknowledgedAt?: string | null;
                    createdAt: string;
                    isCurrentAsOf?: string | null;
                    state?: {
                      __typename?: 'DeviceConfigState';
                      state: DeviceConfigStateType;
                      timestamp: string;
                    } | null;
                  } | null;
                }
              | {
                  __typename: 'SwitchHardwareDevice';
                  deviceType: DeviceType;
                  serialNumber: string;
                  macAddress?: string | null;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  isDev?: boolean;
                  bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
                  latestDeviceConfigMetadata?: {
                    __typename?: 'DeviceConfigMetadata';
                    version: number;
                    acknowledgedAt?: string | null;
                    createdAt: string;
                    isCurrentAsOf?: string | null;
                    state?: {
                      __typename?: 'DeviceConfigState';
                      state: DeviceConfigStateType;
                      timestamp: string;
                    } | null;
                  } | null;
                }
              | null;
          }
        | {
            __typename: 'SwitchVirtualDevice';
            UUID: string;
            label: string;
            description?: string | null;
            deviceType: VirtualDeviceType;
            uptime?: string | null;
            network: { __typename?: 'Network'; UUID: string; slug: string; label: string };
            nosVersion?: {
              __typename?: 'ConfiguredNOSVersion';
              id: number;
              version: string;
              buildName: string;
            } | null;
            pendingNosVersion?: {
              __typename?: 'PendingNosVersion';
              scheduledAt: string;
              nosVersion: { __typename?: 'NosVersion'; version: string };
            } | null;
            hardwareDevice?:
              | {
                  __typename: 'AccessPointHardwareDevice';
                  ipAddress?: string | null;
                  isInCurrentControllerMACTable: boolean;
                  deviceType: DeviceType;
                  serialNumber: string;
                  macAddress?: string | null;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  isDev?: boolean;
                  phyInterfaceConnectedTo?: {
                    __typename?: 'PhyInterface';
                    UUID: string;
                    portSpeedMbps?: number | null;
                    maxSpeedMbps?: number | null;
                    isEthernet: boolean;
                    isSFP: boolean;
                    sfpModuleInfo?: {
                      __typename?: 'SFPModuleInfo';
                      moduleSpeedKbps?: number | null;
                    } | null;
                  } | null;
                  bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
                  latestDeviceConfigMetadata?: {
                    __typename?: 'DeviceConfigMetadata';
                    version: number;
                    acknowledgedAt?: string | null;
                    createdAt: string;
                    isCurrentAsOf?: string | null;
                    state?: {
                      __typename?: 'DeviceConfigState';
                      state: DeviceConfigStateType;
                      timestamp: string;
                    } | null;
                  } | null;
                }
              | {
                  __typename: 'ControllerHardwareDevice';
                  deviceType: DeviceType;
                  serialNumber: string;
                  macAddress?: string | null;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  isDev?: boolean;
                  bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
                  latestDeviceConfigMetadata?: {
                    __typename?: 'DeviceConfigMetadata';
                    version: number;
                    acknowledgedAt?: string | null;
                    createdAt: string;
                    isCurrentAsOf?: string | null;
                    state?: {
                      __typename?: 'DeviceConfigState';
                      state: DeviceConfigStateType;
                      timestamp: string;
                    } | null;
                  } | null;
                }
              | {
                  __typename: 'PowerDistributionUnitHardwareDevice';
                  deviceType: DeviceType;
                  serialNumber: string;
                  macAddress?: string | null;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  isDev?: boolean;
                  bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
                  latestDeviceConfigMetadata?: {
                    __typename?: 'DeviceConfigMetadata';
                    version: number;
                    acknowledgedAt?: string | null;
                    createdAt: string;
                    isCurrentAsOf?: string | null;
                    state?: {
                      __typename?: 'DeviceConfigState';
                      state: DeviceConfigStateType;
                      timestamp: string;
                    } | null;
                  } | null;
                }
              | {
                  __typename: 'SwitchHardwareDevice';
                  deviceType: DeviceType;
                  serialNumber: string;
                  macAddress?: string | null;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  isDev?: boolean;
                  bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
                  latestDeviceConfigMetadata?: {
                    __typename?: 'DeviceConfigMetadata';
                    version: number;
                    acknowledgedAt?: string | null;
                    createdAt: string;
                    isCurrentAsOf?: string | null;
                    state?: {
                      __typename?: 'DeviceConfigState';
                      state: DeviceConfigStateType;
                      timestamp: string;
                    } | null;
                  } | null;
                }
              | null;
          }
      >;
    }>;
  };
};

export type ObserverQueryQueryVariables = Exact<{
  uuid: Scalars['UUID']['input'];
  includeUptime?: InputMaybe<Scalars['Boolean']['input']>;
  includeNOS?: InputMaybe<Scalars['Boolean']['input']>;
  includeIsDev?: InputMaybe<Scalars['Boolean']['input']>;
  resultsFilter?: InputMaybe<ObserverResultsFilterInput>;
}>;

export type ObserverQueryQuery = {
  __typename?: 'Query';
  virtualDevice:
    | {
        __typename: 'AccessPointVirtualDevice';
        UUID: string;
        label: string;
        description?: string | null;
        deviceType: VirtualDeviceType;
        deviceModel: DeviceModel;
        isConsoleEnabled: boolean;
        networkUUID: string;
        uptime?: string | null;
        nosUpgradeGroup?: { __typename?: 'NOSUpgradeGroup'; UUID: string };
        network: { __typename?: 'Network'; UUID: string; slug: string; label: string };
        nosVersion?: {
          __typename?: 'ConfiguredNOSVersion';
          id: number;
          version: string;
          buildName: string;
        } | null;
        pendingNosVersion?: {
          __typename?: 'PendingNosVersion';
          scheduledAt: string;
          nosVersion: { __typename?: 'NosVersion'; version: string };
        } | null;
        hardwareDevice?:
          | {
              __typename: 'AccessPointHardwareDevice';
              ipAddress?: string | null;
              isInCurrentControllerMACTable: boolean;
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              deviceModel: DeviceModel;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              isDev?: boolean;
              phyInterfaceConnectedTo?: {
                __typename?: 'PhyInterface';
                UUID: string;
                portNumber: number;
                portSpeedMbps?: number | null;
                maxSpeedMbps?: number | null;
                isEthernet: boolean;
                isSFP: boolean;
                virtualDevice:
                  | { __typename?: 'AccessPointVirtualDevice'; UUID: string; label: string }
                  | { __typename?: 'ControllerVirtualDevice'; UUID: string; label: string }
                  | { __typename?: 'ObserverVirtualDevice'; UUID: string; label: string }
                  | {
                      __typename?: 'PowerDistributionUnitVirtualDevice';
                      UUID: string;
                      label: string;
                    }
                  | { __typename?: 'SwitchVirtualDevice'; UUID: string; label: string };
              } | null;
              phyInterfaceLastConnectedTo?: {
                __typename?: 'PhyInterfaceConnectedAt';
                connectedAt: string;
                phyInterface: {
                  __typename?: 'PhyInterface';
                  UUID: string;
                  portNumber: number;
                  virtualDevice:
                    | { __typename?: 'AccessPointVirtualDevice'; UUID: string; label: string }
                    | { __typename?: 'ControllerVirtualDevice'; UUID: string; label: string }
                    | { __typename?: 'ObserverVirtualDevice'; UUID: string; label: string }
                    | {
                        __typename?: 'PowerDistributionUnitVirtualDevice';
                        UUID: string;
                        label: string;
                      }
                    | { __typename?: 'SwitchVirtualDevice'; UUID: string; label: string };
                };
              } | null;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
            }
          | {
              __typename: 'ControllerHardwareDevice';
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              deviceModel: DeviceModel;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              isDev?: boolean;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
            }
          | {
              __typename: 'PowerDistributionUnitHardwareDevice';
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              deviceModel: DeviceModel;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              isDev?: boolean;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
            }
          | {
              __typename: 'SwitchHardwareDevice';
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              deviceModel: DeviceModel;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              isDev?: boolean;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
            }
          | null;
      }
    | {
        __typename: 'ControllerVirtualDevice';
        UUID: string;
        label: string;
        description?: string | null;
        deviceType: VirtualDeviceType;
        deviceModel: DeviceModel;
        isConsoleEnabled: boolean;
        networkUUID: string;
        uptime?: string | null;
        nosUpgradeGroup?: { __typename?: 'NOSUpgradeGroup'; UUID: string };
        network: { __typename?: 'Network'; UUID: string; slug: string; label: string };
        nosVersion?: {
          __typename?: 'ConfiguredNOSVersion';
          id: number;
          version: string;
          buildName: string;
        } | null;
        pendingNosVersion?: {
          __typename?: 'PendingNosVersion';
          scheduledAt: string;
          nosVersion: { __typename?: 'NosVersion'; version: string };
        } | null;
        hardwareDevice?:
          | {
              __typename: 'AccessPointHardwareDevice';
              ipAddress?: string | null;
              isInCurrentControllerMACTable: boolean;
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              deviceModel: DeviceModel;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              isDev?: boolean;
              phyInterfaceConnectedTo?: {
                __typename?: 'PhyInterface';
                UUID: string;
                portNumber: number;
                portSpeedMbps?: number | null;
                maxSpeedMbps?: number | null;
                isEthernet: boolean;
                isSFP: boolean;
                virtualDevice:
                  | { __typename?: 'AccessPointVirtualDevice'; UUID: string; label: string }
                  | { __typename?: 'ControllerVirtualDevice'; UUID: string; label: string }
                  | { __typename?: 'ObserverVirtualDevice'; UUID: string; label: string }
                  | {
                      __typename?: 'PowerDistributionUnitVirtualDevice';
                      UUID: string;
                      label: string;
                    }
                  | { __typename?: 'SwitchVirtualDevice'; UUID: string; label: string };
              } | null;
              phyInterfaceLastConnectedTo?: {
                __typename?: 'PhyInterfaceConnectedAt';
                connectedAt: string;
                phyInterface: {
                  __typename?: 'PhyInterface';
                  UUID: string;
                  portNumber: number;
                  virtualDevice:
                    | { __typename?: 'AccessPointVirtualDevice'; UUID: string; label: string }
                    | { __typename?: 'ControllerVirtualDevice'; UUID: string; label: string }
                    | { __typename?: 'ObserverVirtualDevice'; UUID: string; label: string }
                    | {
                        __typename?: 'PowerDistributionUnitVirtualDevice';
                        UUID: string;
                        label: string;
                      }
                    | { __typename?: 'SwitchVirtualDevice'; UUID: string; label: string };
                };
              } | null;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
            }
          | {
              __typename: 'ControllerHardwareDevice';
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              deviceModel: DeviceModel;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              isDev?: boolean;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
            }
          | {
              __typename: 'PowerDistributionUnitHardwareDevice';
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              deviceModel: DeviceModel;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              isDev?: boolean;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
            }
          | {
              __typename: 'SwitchHardwareDevice';
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              deviceModel: DeviceModel;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              isDev?: boolean;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
            }
          | null;
      }
    | {
        __typename: 'ObserverVirtualDevice';
        UUID: string;
        label: string;
        description?: string | null;
        deviceType: VirtualDeviceType;
        deviceModel: DeviceModel;
        isConsoleEnabled: boolean;
        networkUUID: string;
        uptime?: string | null;
        observerSettings?: Array<{
          __typename?: 'WifiObserverSetting';
          band: RadioBand;
          durationMsec: number;
          networkUUID: string;
          SSID: { __typename?: 'SSID'; UUID: string; ssid: string };
          targetVirtualDevice?: {
            __typename?: 'AccessPointVirtualDevice';
            UUID: string;
            label: string;
          } | null;
          virtualDevice: { __typename?: 'ObserverVirtualDevice'; UUID: string; label: string };
          results?: Array<{
            __typename?: 'WifiObserverResults';
            numConnectionAttempts: number;
            numAssocSuccess: number;
            numDhcpSuccess: number;
            testResults?: Array<{
              __typename?: 'WifiObserverTestResults';
              commandType: WosObserverCommandType;
              target: string;
              numAttempts: number;
              numSuccess: number;
              totalLatencyMs: number;
            }> | null;
          }> | null;
        }> | null;
        nosUpgradeGroup?: { __typename?: 'NOSUpgradeGroup'; UUID: string };
        network: { __typename?: 'Network'; UUID: string; slug: string; label: string };
        nosVersion?: {
          __typename?: 'ConfiguredNOSVersion';
          id: number;
          version: string;
          buildName: string;
        } | null;
        pendingNosVersion?: {
          __typename?: 'PendingNosVersion';
          scheduledAt: string;
          nosVersion: { __typename?: 'NosVersion'; version: string };
        } | null;
        hardwareDevice?:
          | {
              __typename: 'AccessPointHardwareDevice';
              ipAddress?: string | null;
              isInCurrentControllerMACTable: boolean;
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              deviceModel: DeviceModel;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              isDev?: boolean;
              phyInterfaceConnectedTo?: {
                __typename?: 'PhyInterface';
                UUID: string;
                portNumber: number;
                portSpeedMbps?: number | null;
                maxSpeedMbps?: number | null;
                isEthernet: boolean;
                isSFP: boolean;
                virtualDevice:
                  | { __typename?: 'AccessPointVirtualDevice'; UUID: string; label: string }
                  | { __typename?: 'ControllerVirtualDevice'; UUID: string; label: string }
                  | { __typename?: 'ObserverVirtualDevice'; UUID: string; label: string }
                  | {
                      __typename?: 'PowerDistributionUnitVirtualDevice';
                      UUID: string;
                      label: string;
                    }
                  | { __typename?: 'SwitchVirtualDevice'; UUID: string; label: string };
              } | null;
              phyInterfaceLastConnectedTo?: {
                __typename?: 'PhyInterfaceConnectedAt';
                connectedAt: string;
                phyInterface: {
                  __typename?: 'PhyInterface';
                  UUID: string;
                  portNumber: number;
                  virtualDevice:
                    | { __typename?: 'AccessPointVirtualDevice'; UUID: string; label: string }
                    | { __typename?: 'ControllerVirtualDevice'; UUID: string; label: string }
                    | { __typename?: 'ObserverVirtualDevice'; UUID: string; label: string }
                    | {
                        __typename?: 'PowerDistributionUnitVirtualDevice';
                        UUID: string;
                        label: string;
                      }
                    | { __typename?: 'SwitchVirtualDevice'; UUID: string; label: string };
                };
              } | null;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
            }
          | {
              __typename: 'ControllerHardwareDevice';
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              deviceModel: DeviceModel;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              isDev?: boolean;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
            }
          | {
              __typename: 'PowerDistributionUnitHardwareDevice';
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              deviceModel: DeviceModel;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              isDev?: boolean;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
            }
          | {
              __typename: 'SwitchHardwareDevice';
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              deviceModel: DeviceModel;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              isDev?: boolean;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
            }
          | null;
      }
    | {
        __typename: 'PowerDistributionUnitVirtualDevice';
        UUID: string;
        label: string;
        description?: string | null;
        deviceType: VirtualDeviceType;
        deviceModel: DeviceModel;
        isConsoleEnabled: boolean;
        networkUUID: string;
        uptime?: string | null;
        nosUpgradeGroup?: { __typename?: 'NOSUpgradeGroup'; UUID: string };
        network: { __typename?: 'Network'; UUID: string; slug: string; label: string };
        nosVersion?: {
          __typename?: 'ConfiguredNOSVersion';
          id: number;
          version: string;
          buildName: string;
        } | null;
        pendingNosVersion?: {
          __typename?: 'PendingNosVersion';
          scheduledAt: string;
          nosVersion: { __typename?: 'NosVersion'; version: string };
        } | null;
        hardwareDevice?:
          | {
              __typename: 'AccessPointHardwareDevice';
              ipAddress?: string | null;
              isInCurrentControllerMACTable: boolean;
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              deviceModel: DeviceModel;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              isDev?: boolean;
              phyInterfaceConnectedTo?: {
                __typename?: 'PhyInterface';
                UUID: string;
                portNumber: number;
                portSpeedMbps?: number | null;
                maxSpeedMbps?: number | null;
                isEthernet: boolean;
                isSFP: boolean;
                virtualDevice:
                  | { __typename?: 'AccessPointVirtualDevice'; UUID: string; label: string }
                  | { __typename?: 'ControllerVirtualDevice'; UUID: string; label: string }
                  | { __typename?: 'ObserverVirtualDevice'; UUID: string; label: string }
                  | {
                      __typename?: 'PowerDistributionUnitVirtualDevice';
                      UUID: string;
                      label: string;
                    }
                  | { __typename?: 'SwitchVirtualDevice'; UUID: string; label: string };
              } | null;
              phyInterfaceLastConnectedTo?: {
                __typename?: 'PhyInterfaceConnectedAt';
                connectedAt: string;
                phyInterface: {
                  __typename?: 'PhyInterface';
                  UUID: string;
                  portNumber: number;
                  virtualDevice:
                    | { __typename?: 'AccessPointVirtualDevice'; UUID: string; label: string }
                    | { __typename?: 'ControllerVirtualDevice'; UUID: string; label: string }
                    | { __typename?: 'ObserverVirtualDevice'; UUID: string; label: string }
                    | {
                        __typename?: 'PowerDistributionUnitVirtualDevice';
                        UUID: string;
                        label: string;
                      }
                    | { __typename?: 'SwitchVirtualDevice'; UUID: string; label: string };
                };
              } | null;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
            }
          | {
              __typename: 'ControllerHardwareDevice';
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              deviceModel: DeviceModel;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              isDev?: boolean;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
            }
          | {
              __typename: 'PowerDistributionUnitHardwareDevice';
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              deviceModel: DeviceModel;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              isDev?: boolean;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
            }
          | {
              __typename: 'SwitchHardwareDevice';
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              deviceModel: DeviceModel;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              isDev?: boolean;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
            }
          | null;
      }
    | {
        __typename: 'SwitchVirtualDevice';
        UUID: string;
        label: string;
        description?: string | null;
        deviceType: VirtualDeviceType;
        deviceModel: DeviceModel;
        isConsoleEnabled: boolean;
        networkUUID: string;
        uptime?: string | null;
        nosUpgradeGroup?: { __typename?: 'NOSUpgradeGroup'; UUID: string };
        network: { __typename?: 'Network'; UUID: string; slug: string; label: string };
        nosVersion?: {
          __typename?: 'ConfiguredNOSVersion';
          id: number;
          version: string;
          buildName: string;
        } | null;
        pendingNosVersion?: {
          __typename?: 'PendingNosVersion';
          scheduledAt: string;
          nosVersion: { __typename?: 'NosVersion'; version: string };
        } | null;
        hardwareDevice?:
          | {
              __typename: 'AccessPointHardwareDevice';
              ipAddress?: string | null;
              isInCurrentControllerMACTable: boolean;
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              deviceModel: DeviceModel;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              isDev?: boolean;
              phyInterfaceConnectedTo?: {
                __typename?: 'PhyInterface';
                UUID: string;
                portNumber: number;
                portSpeedMbps?: number | null;
                maxSpeedMbps?: number | null;
                isEthernet: boolean;
                isSFP: boolean;
                virtualDevice:
                  | { __typename?: 'AccessPointVirtualDevice'; UUID: string; label: string }
                  | { __typename?: 'ControllerVirtualDevice'; UUID: string; label: string }
                  | { __typename?: 'ObserverVirtualDevice'; UUID: string; label: string }
                  | {
                      __typename?: 'PowerDistributionUnitVirtualDevice';
                      UUID: string;
                      label: string;
                    }
                  | { __typename?: 'SwitchVirtualDevice'; UUID: string; label: string };
              } | null;
              phyInterfaceLastConnectedTo?: {
                __typename?: 'PhyInterfaceConnectedAt';
                connectedAt: string;
                phyInterface: {
                  __typename?: 'PhyInterface';
                  UUID: string;
                  portNumber: number;
                  virtualDevice:
                    | { __typename?: 'AccessPointVirtualDevice'; UUID: string; label: string }
                    | { __typename?: 'ControllerVirtualDevice'; UUID: string; label: string }
                    | { __typename?: 'ObserverVirtualDevice'; UUID: string; label: string }
                    | {
                        __typename?: 'PowerDistributionUnitVirtualDevice';
                        UUID: string;
                        label: string;
                      }
                    | { __typename?: 'SwitchVirtualDevice'; UUID: string; label: string };
                };
              } | null;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
            }
          | {
              __typename: 'ControllerHardwareDevice';
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              deviceModel: DeviceModel;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              isDev?: boolean;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
            }
          | {
              __typename: 'PowerDistributionUnitHardwareDevice';
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              deviceModel: DeviceModel;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              isDev?: boolean;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
            }
          | {
              __typename: 'SwitchHardwareDevice';
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              deviceModel: DeviceModel;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              isDev?: boolean;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
            }
          | null;
      };
};

export type ObserversTargetsQueryQueryVariables = Exact<{
  companySlug: Scalars['String']['input'];
  networkUUIDs?: InputMaybe<Array<Scalars['UUID']['input']> | Scalars['UUID']['input']>;
  includeUptime?: InputMaybe<Scalars['Boolean']['input']>;
  resultsFilter?: InputMaybe<ObserverResultsFilterInput>;
  includeNOS?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type ObserversTargetsQueryQuery = {
  __typename?: 'Query';
  companyBySlug: {
    __typename?: 'Company';
    networks: Array<{
      __typename?: 'Network';
      virtualDevices: Array<
        | {
            __typename: 'AccessPointVirtualDevice';
            uptime?: string | null;
            UUID: string;
            label: string;
            description?: string | null;
            deviceType: VirtualDeviceType;
            observerSettings?: Array<{
              __typename?: 'WifiObserverSetting';
              virtualDeviceUUID: string;
              SSIDUUID: string;
              band: RadioBand;
              results?: Array<{
                __typename?: 'WifiObserverResults';
                numConnectionAttempts: number;
                numAssocSuccess: number;
                numDhcpSuccess: number;
                testResults?: Array<{
                  __typename?: 'WifiObserverTestResults';
                  commandType: WosObserverCommandType;
                  target: string;
                  numAttempts: number;
                  numSuccess: number;
                  totalLatencyMs: number;
                }> | null;
              }> | null;
            }> | null;
            network: { __typename?: 'Network'; UUID: string; slug: string; label: string };
            nosVersion?: {
              __typename?: 'ConfiguredNOSVersion';
              id: number;
              version: string;
              buildName: string;
            } | null;
            pendingNosVersion?: {
              __typename?: 'PendingNosVersion';
              scheduledAt: string;
              nosVersion: { __typename?: 'NosVersion'; version: string };
            } | null;
            hardwareDevice?:
              | {
                  __typename: 'AccessPointHardwareDevice';
                  ipAddress?: string | null;
                  isInCurrentControllerMACTable: boolean;
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                  serialNumber: string;
                  macAddress?: string | null;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  phyInterfaceConnectedTo?: {
                    __typename?: 'PhyInterface';
                    UUID: string;
                    portSpeedMbps?: number | null;
                    maxSpeedMbps?: number | null;
                    isEthernet: boolean;
                    isSFP: boolean;
                  } | null;
                  bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
                }
              | {
                  __typename: 'ControllerHardwareDevice';
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                  serialNumber: string;
                  macAddress?: string | null;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
                }
              | {
                  __typename: 'PowerDistributionUnitHardwareDevice';
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                  serialNumber: string;
                  macAddress?: string | null;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
                }
              | {
                  __typename: 'SwitchHardwareDevice';
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                  serialNumber: string;
                  macAddress?: string | null;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
                }
              | null;
          }
        | {
            __typename: 'ControllerVirtualDevice';
            UUID: string;
            label: string;
            description?: string | null;
            deviceType: VirtualDeviceType;
            network: { __typename?: 'Network'; UUID: string; slug: string; label: string };
            nosVersion?: {
              __typename?: 'ConfiguredNOSVersion';
              id: number;
              version: string;
              buildName: string;
            } | null;
            pendingNosVersion?: {
              __typename?: 'PendingNosVersion';
              scheduledAt: string;
              nosVersion: { __typename?: 'NosVersion'; version: string };
            } | null;
            hardwareDevice?:
              | {
                  __typename: 'AccessPointHardwareDevice';
                  ipAddress?: string | null;
                  isInCurrentControllerMACTable: boolean;
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                  serialNumber: string;
                  macAddress?: string | null;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  phyInterfaceConnectedTo?: {
                    __typename?: 'PhyInterface';
                    UUID: string;
                    portSpeedMbps?: number | null;
                    maxSpeedMbps?: number | null;
                    isEthernet: boolean;
                    isSFP: boolean;
                  } | null;
                  bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
                }
              | {
                  __typename: 'ControllerHardwareDevice';
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                  serialNumber: string;
                  macAddress?: string | null;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
                }
              | {
                  __typename: 'PowerDistributionUnitHardwareDevice';
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                  serialNumber: string;
                  macAddress?: string | null;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
                }
              | {
                  __typename: 'SwitchHardwareDevice';
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                  serialNumber: string;
                  macAddress?: string | null;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
                }
              | null;
          }
        | {
            __typename: 'ObserverVirtualDevice';
            UUID: string;
            label: string;
            description?: string | null;
            deviceType: VirtualDeviceType;
            network: { __typename?: 'Network'; UUID: string; slug: string; label: string };
            nosVersion?: {
              __typename?: 'ConfiguredNOSVersion';
              id: number;
              version: string;
              buildName: string;
            } | null;
            pendingNosVersion?: {
              __typename?: 'PendingNosVersion';
              scheduledAt: string;
              nosVersion: { __typename?: 'NosVersion'; version: string };
            } | null;
            hardwareDevice?:
              | {
                  __typename: 'AccessPointHardwareDevice';
                  ipAddress?: string | null;
                  isInCurrentControllerMACTable: boolean;
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                  serialNumber: string;
                  macAddress?: string | null;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  phyInterfaceConnectedTo?: {
                    __typename?: 'PhyInterface';
                    UUID: string;
                    portSpeedMbps?: number | null;
                    maxSpeedMbps?: number | null;
                    isEthernet: boolean;
                    isSFP: boolean;
                  } | null;
                  bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
                }
              | {
                  __typename: 'ControllerHardwareDevice';
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                  serialNumber: string;
                  macAddress?: string | null;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
                }
              | {
                  __typename: 'PowerDistributionUnitHardwareDevice';
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                  serialNumber: string;
                  macAddress?: string | null;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
                }
              | {
                  __typename: 'SwitchHardwareDevice';
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                  serialNumber: string;
                  macAddress?: string | null;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
                }
              | null;
          }
        | {
            __typename: 'PowerDistributionUnitVirtualDevice';
            UUID: string;
            label: string;
            description?: string | null;
            deviceType: VirtualDeviceType;
            network: { __typename?: 'Network'; UUID: string; slug: string; label: string };
            nosVersion?: {
              __typename?: 'ConfiguredNOSVersion';
              id: number;
              version: string;
              buildName: string;
            } | null;
            pendingNosVersion?: {
              __typename?: 'PendingNosVersion';
              scheduledAt: string;
              nosVersion: { __typename?: 'NosVersion'; version: string };
            } | null;
            hardwareDevice?:
              | {
                  __typename: 'AccessPointHardwareDevice';
                  ipAddress?: string | null;
                  isInCurrentControllerMACTable: boolean;
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                  serialNumber: string;
                  macAddress?: string | null;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  phyInterfaceConnectedTo?: {
                    __typename?: 'PhyInterface';
                    UUID: string;
                    portSpeedMbps?: number | null;
                    maxSpeedMbps?: number | null;
                    isEthernet: boolean;
                    isSFP: boolean;
                  } | null;
                  bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
                }
              | {
                  __typename: 'ControllerHardwareDevice';
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                  serialNumber: string;
                  macAddress?: string | null;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
                }
              | {
                  __typename: 'PowerDistributionUnitHardwareDevice';
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                  serialNumber: string;
                  macAddress?: string | null;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
                }
              | {
                  __typename: 'SwitchHardwareDevice';
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                  serialNumber: string;
                  macAddress?: string | null;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
                }
              | null;
          }
        | {
            __typename: 'SwitchVirtualDevice';
            UUID: string;
            label: string;
            description?: string | null;
            deviceType: VirtualDeviceType;
            network: { __typename?: 'Network'; UUID: string; slug: string; label: string };
            nosVersion?: {
              __typename?: 'ConfiguredNOSVersion';
              id: number;
              version: string;
              buildName: string;
            } | null;
            pendingNosVersion?: {
              __typename?: 'PendingNosVersion';
              scheduledAt: string;
              nosVersion: { __typename?: 'NosVersion'; version: string };
            } | null;
            hardwareDevice?:
              | {
                  __typename: 'AccessPointHardwareDevice';
                  ipAddress?: string | null;
                  isInCurrentControllerMACTable: boolean;
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                  serialNumber: string;
                  macAddress?: string | null;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  phyInterfaceConnectedTo?: {
                    __typename?: 'PhyInterface';
                    UUID: string;
                    portSpeedMbps?: number | null;
                    maxSpeedMbps?: number | null;
                    isEthernet: boolean;
                    isSFP: boolean;
                  } | null;
                  bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
                }
              | {
                  __typename: 'ControllerHardwareDevice';
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                  serialNumber: string;
                  macAddress?: string | null;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
                }
              | {
                  __typename: 'PowerDistributionUnitHardwareDevice';
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                  serialNumber: string;
                  macAddress?: string | null;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
                }
              | {
                  __typename: 'SwitchHardwareDevice';
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                  serialNumber: string;
                  macAddress?: string | null;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
                }
              | null;
          }
      >;
    }>;
  };
};

export type ObserversTestsQueryQueryVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
  resultsFilter?: InputMaybe<ObserverResultsFilterInput>;
}>;

export type ObserversTestsQueryQuery = {
  __typename?: 'Query';
  wifiObserverSettingsForNetwork: Array<{
    __typename: 'WifiObserverSetting';
    band: RadioBand;
    virtualDevice: { __typename?: 'ObserverVirtualDevice'; UUID: string; label: string };
    targetVirtualDevice?: {
      __typename?: 'AccessPointVirtualDevice';
      UUID: string;
      label: string;
    } | null;
    SSID: { __typename?: 'SSID'; UUID: string; ssid: string };
    results?: Array<{
      __typename?: 'WifiObserverResults';
      numConnectionAttempts: number;
      numAssocSuccess: number;
      numDhcpSuccess: number;
      testResults?: Array<{
        __typename?: 'WifiObserverTestResults';
        commandType: WosObserverCommandType;
        target: string;
        numAttempts: number;
        numSuccess: number;
        totalLatencyMs: number;
      }> | null;
    }> | null;
  }>;
};

export type ObserversAddAutoTestsMutationVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
  durationMsec: Scalars['Int']['input'];
  snrThreshold: Scalars['Int']['input'];
  filters: AutoWifiObserverFiltersInput;
  commands?: InputMaybe<Array<WosObserverCommandInput> | WosObserverCommandInput>;
  commit: Scalars['Boolean']['input'];
}>;

export type ObserversAddAutoTestsMutation = {
  __typename?: 'Mutation';
  createAutoWifiObserverSettings: Array<{
    __typename?: 'WifiObserverSetting';
    band: RadioBand;
    virtualDevice: { __typename?: 'ObserverVirtualDevice'; UUID: string; label: string };
    targetVirtualDevice?: {
      __typename?: 'AccessPointVirtualDevice';
      UUID: string;
      label: string;
    } | null;
    SSID: { __typename?: 'SSID'; UUID: string; ssid: string };
  } | null>;
};

export type ObserversDeleteTestsForSsidMutationVariables = Exact<{
  ssidUUID: Scalars['UUID']['input'];
}>;

export type ObserversDeleteTestsForSsidMutation = {
  __typename?: 'Mutation';
  deleteWifiObserverSettingsForSSID: Array<{
    __typename?: 'WifiObserverSetting';
    band: RadioBand;
    virtualDevice: { __typename?: 'ObserverVirtualDevice'; UUID: string; label: string };
    targetVirtualDevice?: {
      __typename?: 'AccessPointVirtualDevice';
      UUID: string;
      label: string;
    } | null;
    SSID: { __typename?: 'SSID'; UUID: string; ssid: string };
  } | null>;
};

export type AccessPointsQueryQueryVariables = Exact<{
  companySlug: Scalars['String']['input'];
  networkUUIDs?: InputMaybe<Array<Scalars['UUID']['input']> | Scalars['UUID']['input']>;
  includeUptime?: InputMaybe<Scalars['Boolean']['input']>;
  includeIsDev?: InputMaybe<Scalars['Boolean']['input']>;
  includeNOS?: InputMaybe<Scalars['Boolean']['input']>;
  includeConfigMetadata?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type AccessPointsQueryQuery = {
  __typename?: 'Query';
  companyBySlug: {
    __typename?: 'Company';
    networks: Array<{
      __typename?: 'Network';
      virtualDevices: Array<
        | {
            __typename: 'AccessPointVirtualDevice';
            UUID: string;
            label: string;
            description?: string | null;
            deviceType: VirtualDeviceType;
            uptime?: string | null;
            latestHealthScores?: {
              __typename?: 'AccessPointHealthScores';
              overallScore: number;
              performanceScore: number;
              connectionScore: number;
              rfScore: number;
              systemScore: number;
            } | null;
            radioProfile?: {
              __typename?: 'RadioProfile';
              name: string;
              UUID: string;
              band2_4GIsEnabled: boolean;
              band2_4GChannelWidthMHz?: number | null;
              band2_4GAutoChannelIsEnabled: boolean;
              band5GIsEnabled: boolean;
              band5GChannelWidthMHz?: number | null;
              band5GAutoChannelIsEnabled: boolean;
              band6GIsEnabled: boolean;
              band6GChannelWidthMHz?: number | null;
              band6GAutoChannelIsEnabled: boolean;
            } | null;
            radioSettings: {
              __typename?: 'RadioSettings';
              band2_4GActiveChannel?: number | null;
              band2_4GPrimaryChannel: number;
              band2_4GTransmitPowerdBm: number;
              band5GActiveChannel?: number | null;
              band5GPrimaryChannel: number;
              band5GSecondaryChannel?: number | null;
              band5GTransmitPowerdBm: number;
              band6GActiveChannel?: number | null;
              band6GPrimaryChannel: number;
              band6GTransmitPowerdBm: number;
            };
            connectedClients: Array<{
              __typename?: 'WirelessClient';
              macAddress: string;
              band: RadioBand;
              channel: number;
              ssidName: string;
              observerVirtualDevice?: { __typename?: 'ObserverVirtualDevice'; UUID: string } | null;
            }>;
            network: { __typename?: 'Network'; UUID: string; slug: string; label: string };
            nosUpgradeGroup?: { __typename?: 'NOSUpgradeGroup'; UUID: string };
            nosVersion?: {
              __typename?: 'ConfiguredNOSVersion';
              id: number;
              version: string;
              buildName: string;
            } | null;
            pendingNosVersion?: {
              __typename?: 'PendingNosVersion';
              scheduledAt: string;
              nosVersion: { __typename?: 'NosVersion'; version: string };
            } | null;
            hardwareDevice?:
              | {
                  __typename: 'AccessPointHardwareDevice';
                  ipAddress?: string | null;
                  isInCurrentControllerMACTable: boolean;
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                  serialNumber: string;
                  macAddress?: string | null;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  isDev?: boolean;
                  phyInterfaceConnectedTo?: {
                    __typename?: 'PhyInterface';
                    UUID: string;
                    portSpeedMbps?: number | null;
                    maxSpeedMbps?: number | null;
                    isEthernet: boolean;
                    isSFP: boolean;
                    isPOEEnabled: boolean;
                    portNumber: number;
                    poeType?: PoEType | null;
                    sfpModuleInfo?: {
                      __typename?: 'SFPModuleInfo';
                      moduleSpeedKbps?: number | null;
                    } | null;
                    virtualDevice:
                      | {
                          __typename?: 'AccessPointVirtualDevice';
                          hardwareDevice?:
                            | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
                            | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
                            | {
                                __typename?: 'PowerDistributionUnitHardwareDevice';
                                serialNumber: string;
                              }
                            | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
                            | null;
                        }
                      | {
                          __typename?: 'ControllerVirtualDevice';
                          hardwareDevice?:
                            | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
                            | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
                            | {
                                __typename?: 'PowerDistributionUnitHardwareDevice';
                                serialNumber: string;
                              }
                            | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
                            | null;
                        }
                      | {
                          __typename?: 'ObserverVirtualDevice';
                          hardwareDevice?:
                            | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
                            | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
                            | {
                                __typename?: 'PowerDistributionUnitHardwareDevice';
                                serialNumber: string;
                              }
                            | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
                            | null;
                        }
                      | {
                          __typename?: 'PowerDistributionUnitVirtualDevice';
                          hardwareDevice?:
                            | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
                            | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
                            | {
                                __typename?: 'PowerDistributionUnitHardwareDevice';
                                serialNumber: string;
                              }
                            | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
                            | null;
                        }
                      | {
                          __typename?: 'SwitchVirtualDevice';
                          hardwareDevice?:
                            | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
                            | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
                            | {
                                __typename?: 'PowerDistributionUnitHardwareDevice';
                                serialNumber: string;
                              }
                            | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
                            | null;
                        };
                  } | null;
                  BSSIDs: Array<{ __typename?: 'BSSID'; BSSID: string }>;
                  bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
                  latestDeviceConfigMetadata?: {
                    __typename?: 'DeviceConfigMetadata';
                    version: number;
                    acknowledgedAt?: string | null;
                    createdAt: string;
                    isCurrentAsOf?: string | null;
                    state?: {
                      __typename?: 'DeviceConfigState';
                      state: DeviceConfigStateType;
                      timestamp: string;
                    } | null;
                  } | null;
                }
              | {
                  __typename: 'ControllerHardwareDevice';
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                  serialNumber: string;
                  macAddress?: string | null;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  isDev?: boolean;
                  bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
                  latestDeviceConfigMetadata?: {
                    __typename?: 'DeviceConfigMetadata';
                    version: number;
                    acknowledgedAt?: string | null;
                    createdAt: string;
                    isCurrentAsOf?: string | null;
                    state?: {
                      __typename?: 'DeviceConfigState';
                      state: DeviceConfigStateType;
                      timestamp: string;
                    } | null;
                  } | null;
                }
              | {
                  __typename: 'PowerDistributionUnitHardwareDevice';
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                  serialNumber: string;
                  macAddress?: string | null;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  isDev?: boolean;
                  bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
                  latestDeviceConfigMetadata?: {
                    __typename?: 'DeviceConfigMetadata';
                    version: number;
                    acknowledgedAt?: string | null;
                    createdAt: string;
                    isCurrentAsOf?: string | null;
                    state?: {
                      __typename?: 'DeviceConfigState';
                      state: DeviceConfigStateType;
                      timestamp: string;
                    } | null;
                  } | null;
                }
              | {
                  __typename: 'SwitchHardwareDevice';
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                  serialNumber: string;
                  macAddress?: string | null;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  isDev?: boolean;
                  bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
                  latestDeviceConfigMetadata?: {
                    __typename?: 'DeviceConfigMetadata';
                    version: number;
                    acknowledgedAt?: string | null;
                    createdAt: string;
                    isCurrentAsOf?: string | null;
                    state?: {
                      __typename?: 'DeviceConfigState';
                      state: DeviceConfigStateType;
                      timestamp: string;
                    } | null;
                  } | null;
                }
              | null;
          }
        | {
            __typename: 'ControllerVirtualDevice';
            UUID: string;
            label: string;
            description?: string | null;
            deviceType: VirtualDeviceType;
            uptime?: string | null;
            network: { __typename?: 'Network'; UUID: string; slug: string; label: string };
            nosUpgradeGroup?: { __typename?: 'NOSUpgradeGroup'; UUID: string };
            nosVersion?: {
              __typename?: 'ConfiguredNOSVersion';
              id: number;
              version: string;
              buildName: string;
            } | null;
            pendingNosVersion?: {
              __typename?: 'PendingNosVersion';
              scheduledAt: string;
              nosVersion: { __typename?: 'NosVersion'; version: string };
            } | null;
            hardwareDevice?:
              | {
                  __typename: 'AccessPointHardwareDevice';
                  ipAddress?: string | null;
                  isInCurrentControllerMACTable: boolean;
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                  serialNumber: string;
                  macAddress?: string | null;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  isDev?: boolean;
                  phyInterfaceConnectedTo?: {
                    __typename?: 'PhyInterface';
                    UUID: string;
                    portSpeedMbps?: number | null;
                    maxSpeedMbps?: number | null;
                    isEthernet: boolean;
                    isSFP: boolean;
                    isPOEEnabled: boolean;
                    portNumber: number;
                    poeType?: PoEType | null;
                    sfpModuleInfo?: {
                      __typename?: 'SFPModuleInfo';
                      moduleSpeedKbps?: number | null;
                    } | null;
                    virtualDevice:
                      | {
                          __typename?: 'AccessPointVirtualDevice';
                          hardwareDevice?:
                            | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
                            | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
                            | {
                                __typename?: 'PowerDistributionUnitHardwareDevice';
                                serialNumber: string;
                              }
                            | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
                            | null;
                        }
                      | {
                          __typename?: 'ControllerVirtualDevice';
                          hardwareDevice?:
                            | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
                            | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
                            | {
                                __typename?: 'PowerDistributionUnitHardwareDevice';
                                serialNumber: string;
                              }
                            | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
                            | null;
                        }
                      | {
                          __typename?: 'ObserverVirtualDevice';
                          hardwareDevice?:
                            | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
                            | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
                            | {
                                __typename?: 'PowerDistributionUnitHardwareDevice';
                                serialNumber: string;
                              }
                            | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
                            | null;
                        }
                      | {
                          __typename?: 'PowerDistributionUnitVirtualDevice';
                          hardwareDevice?:
                            | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
                            | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
                            | {
                                __typename?: 'PowerDistributionUnitHardwareDevice';
                                serialNumber: string;
                              }
                            | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
                            | null;
                        }
                      | {
                          __typename?: 'SwitchVirtualDevice';
                          hardwareDevice?:
                            | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
                            | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
                            | {
                                __typename?: 'PowerDistributionUnitHardwareDevice';
                                serialNumber: string;
                              }
                            | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
                            | null;
                        };
                  } | null;
                  BSSIDs: Array<{ __typename?: 'BSSID'; BSSID: string }>;
                  bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
                  latestDeviceConfigMetadata?: {
                    __typename?: 'DeviceConfigMetadata';
                    version: number;
                    acknowledgedAt?: string | null;
                    createdAt: string;
                    isCurrentAsOf?: string | null;
                    state?: {
                      __typename?: 'DeviceConfigState';
                      state: DeviceConfigStateType;
                      timestamp: string;
                    } | null;
                  } | null;
                }
              | {
                  __typename: 'ControllerHardwareDevice';
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                  serialNumber: string;
                  macAddress?: string | null;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  isDev?: boolean;
                  bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
                  latestDeviceConfigMetadata?: {
                    __typename?: 'DeviceConfigMetadata';
                    version: number;
                    acknowledgedAt?: string | null;
                    createdAt: string;
                    isCurrentAsOf?: string | null;
                    state?: {
                      __typename?: 'DeviceConfigState';
                      state: DeviceConfigStateType;
                      timestamp: string;
                    } | null;
                  } | null;
                }
              | {
                  __typename: 'PowerDistributionUnitHardwareDevice';
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                  serialNumber: string;
                  macAddress?: string | null;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  isDev?: boolean;
                  bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
                  latestDeviceConfigMetadata?: {
                    __typename?: 'DeviceConfigMetadata';
                    version: number;
                    acknowledgedAt?: string | null;
                    createdAt: string;
                    isCurrentAsOf?: string | null;
                    state?: {
                      __typename?: 'DeviceConfigState';
                      state: DeviceConfigStateType;
                      timestamp: string;
                    } | null;
                  } | null;
                }
              | {
                  __typename: 'SwitchHardwareDevice';
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                  serialNumber: string;
                  macAddress?: string | null;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  isDev?: boolean;
                  bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
                  latestDeviceConfigMetadata?: {
                    __typename?: 'DeviceConfigMetadata';
                    version: number;
                    acknowledgedAt?: string | null;
                    createdAt: string;
                    isCurrentAsOf?: string | null;
                    state?: {
                      __typename?: 'DeviceConfigState';
                      state: DeviceConfigStateType;
                      timestamp: string;
                    } | null;
                  } | null;
                }
              | null;
          }
        | {
            __typename: 'ObserverVirtualDevice';
            UUID: string;
            label: string;
            description?: string | null;
            deviceType: VirtualDeviceType;
            uptime?: string | null;
            network: { __typename?: 'Network'; UUID: string; slug: string; label: string };
            nosUpgradeGroup?: { __typename?: 'NOSUpgradeGroup'; UUID: string };
            nosVersion?: {
              __typename?: 'ConfiguredNOSVersion';
              id: number;
              version: string;
              buildName: string;
            } | null;
            pendingNosVersion?: {
              __typename?: 'PendingNosVersion';
              scheduledAt: string;
              nosVersion: { __typename?: 'NosVersion'; version: string };
            } | null;
            hardwareDevice?:
              | {
                  __typename: 'AccessPointHardwareDevice';
                  ipAddress?: string | null;
                  isInCurrentControllerMACTable: boolean;
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                  serialNumber: string;
                  macAddress?: string | null;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  isDev?: boolean;
                  phyInterfaceConnectedTo?: {
                    __typename?: 'PhyInterface';
                    UUID: string;
                    portSpeedMbps?: number | null;
                    maxSpeedMbps?: number | null;
                    isEthernet: boolean;
                    isSFP: boolean;
                    isPOEEnabled: boolean;
                    portNumber: number;
                    poeType?: PoEType | null;
                    sfpModuleInfo?: {
                      __typename?: 'SFPModuleInfo';
                      moduleSpeedKbps?: number | null;
                    } | null;
                    virtualDevice:
                      | {
                          __typename?: 'AccessPointVirtualDevice';
                          hardwareDevice?:
                            | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
                            | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
                            | {
                                __typename?: 'PowerDistributionUnitHardwareDevice';
                                serialNumber: string;
                              }
                            | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
                            | null;
                        }
                      | {
                          __typename?: 'ControllerVirtualDevice';
                          hardwareDevice?:
                            | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
                            | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
                            | {
                                __typename?: 'PowerDistributionUnitHardwareDevice';
                                serialNumber: string;
                              }
                            | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
                            | null;
                        }
                      | {
                          __typename?: 'ObserverVirtualDevice';
                          hardwareDevice?:
                            | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
                            | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
                            | {
                                __typename?: 'PowerDistributionUnitHardwareDevice';
                                serialNumber: string;
                              }
                            | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
                            | null;
                        }
                      | {
                          __typename?: 'PowerDistributionUnitVirtualDevice';
                          hardwareDevice?:
                            | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
                            | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
                            | {
                                __typename?: 'PowerDistributionUnitHardwareDevice';
                                serialNumber: string;
                              }
                            | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
                            | null;
                        }
                      | {
                          __typename?: 'SwitchVirtualDevice';
                          hardwareDevice?:
                            | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
                            | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
                            | {
                                __typename?: 'PowerDistributionUnitHardwareDevice';
                                serialNumber: string;
                              }
                            | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
                            | null;
                        };
                  } | null;
                  BSSIDs: Array<{ __typename?: 'BSSID'; BSSID: string }>;
                  bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
                  latestDeviceConfigMetadata?: {
                    __typename?: 'DeviceConfigMetadata';
                    version: number;
                    acknowledgedAt?: string | null;
                    createdAt: string;
                    isCurrentAsOf?: string | null;
                    state?: {
                      __typename?: 'DeviceConfigState';
                      state: DeviceConfigStateType;
                      timestamp: string;
                    } | null;
                  } | null;
                }
              | {
                  __typename: 'ControllerHardwareDevice';
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                  serialNumber: string;
                  macAddress?: string | null;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  isDev?: boolean;
                  bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
                  latestDeviceConfigMetadata?: {
                    __typename?: 'DeviceConfigMetadata';
                    version: number;
                    acknowledgedAt?: string | null;
                    createdAt: string;
                    isCurrentAsOf?: string | null;
                    state?: {
                      __typename?: 'DeviceConfigState';
                      state: DeviceConfigStateType;
                      timestamp: string;
                    } | null;
                  } | null;
                }
              | {
                  __typename: 'PowerDistributionUnitHardwareDevice';
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                  serialNumber: string;
                  macAddress?: string | null;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  isDev?: boolean;
                  bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
                  latestDeviceConfigMetadata?: {
                    __typename?: 'DeviceConfigMetadata';
                    version: number;
                    acknowledgedAt?: string | null;
                    createdAt: string;
                    isCurrentAsOf?: string | null;
                    state?: {
                      __typename?: 'DeviceConfigState';
                      state: DeviceConfigStateType;
                      timestamp: string;
                    } | null;
                  } | null;
                }
              | {
                  __typename: 'SwitchHardwareDevice';
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                  serialNumber: string;
                  macAddress?: string | null;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  isDev?: boolean;
                  bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
                  latestDeviceConfigMetadata?: {
                    __typename?: 'DeviceConfigMetadata';
                    version: number;
                    acknowledgedAt?: string | null;
                    createdAt: string;
                    isCurrentAsOf?: string | null;
                    state?: {
                      __typename?: 'DeviceConfigState';
                      state: DeviceConfigStateType;
                      timestamp: string;
                    } | null;
                  } | null;
                }
              | null;
          }
        | {
            __typename: 'PowerDistributionUnitVirtualDevice';
            UUID: string;
            label: string;
            description?: string | null;
            deviceType: VirtualDeviceType;
            uptime?: string | null;
            network: { __typename?: 'Network'; UUID: string; slug: string; label: string };
            nosUpgradeGroup?: { __typename?: 'NOSUpgradeGroup'; UUID: string };
            nosVersion?: {
              __typename?: 'ConfiguredNOSVersion';
              id: number;
              version: string;
              buildName: string;
            } | null;
            pendingNosVersion?: {
              __typename?: 'PendingNosVersion';
              scheduledAt: string;
              nosVersion: { __typename?: 'NosVersion'; version: string };
            } | null;
            hardwareDevice?:
              | {
                  __typename: 'AccessPointHardwareDevice';
                  ipAddress?: string | null;
                  isInCurrentControllerMACTable: boolean;
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                  serialNumber: string;
                  macAddress?: string | null;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  isDev?: boolean;
                  phyInterfaceConnectedTo?: {
                    __typename?: 'PhyInterface';
                    UUID: string;
                    portSpeedMbps?: number | null;
                    maxSpeedMbps?: number | null;
                    isEthernet: boolean;
                    isSFP: boolean;
                    isPOEEnabled: boolean;
                    portNumber: number;
                    poeType?: PoEType | null;
                    sfpModuleInfo?: {
                      __typename?: 'SFPModuleInfo';
                      moduleSpeedKbps?: number | null;
                    } | null;
                    virtualDevice:
                      | {
                          __typename?: 'AccessPointVirtualDevice';
                          hardwareDevice?:
                            | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
                            | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
                            | {
                                __typename?: 'PowerDistributionUnitHardwareDevice';
                                serialNumber: string;
                              }
                            | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
                            | null;
                        }
                      | {
                          __typename?: 'ControllerVirtualDevice';
                          hardwareDevice?:
                            | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
                            | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
                            | {
                                __typename?: 'PowerDistributionUnitHardwareDevice';
                                serialNumber: string;
                              }
                            | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
                            | null;
                        }
                      | {
                          __typename?: 'ObserverVirtualDevice';
                          hardwareDevice?:
                            | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
                            | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
                            | {
                                __typename?: 'PowerDistributionUnitHardwareDevice';
                                serialNumber: string;
                              }
                            | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
                            | null;
                        }
                      | {
                          __typename?: 'PowerDistributionUnitVirtualDevice';
                          hardwareDevice?:
                            | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
                            | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
                            | {
                                __typename?: 'PowerDistributionUnitHardwareDevice';
                                serialNumber: string;
                              }
                            | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
                            | null;
                        }
                      | {
                          __typename?: 'SwitchVirtualDevice';
                          hardwareDevice?:
                            | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
                            | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
                            | {
                                __typename?: 'PowerDistributionUnitHardwareDevice';
                                serialNumber: string;
                              }
                            | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
                            | null;
                        };
                  } | null;
                  BSSIDs: Array<{ __typename?: 'BSSID'; BSSID: string }>;
                  bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
                  latestDeviceConfigMetadata?: {
                    __typename?: 'DeviceConfigMetadata';
                    version: number;
                    acknowledgedAt?: string | null;
                    createdAt: string;
                    isCurrentAsOf?: string | null;
                    state?: {
                      __typename?: 'DeviceConfigState';
                      state: DeviceConfigStateType;
                      timestamp: string;
                    } | null;
                  } | null;
                }
              | {
                  __typename: 'ControllerHardwareDevice';
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                  serialNumber: string;
                  macAddress?: string | null;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  isDev?: boolean;
                  bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
                  latestDeviceConfigMetadata?: {
                    __typename?: 'DeviceConfigMetadata';
                    version: number;
                    acknowledgedAt?: string | null;
                    createdAt: string;
                    isCurrentAsOf?: string | null;
                    state?: {
                      __typename?: 'DeviceConfigState';
                      state: DeviceConfigStateType;
                      timestamp: string;
                    } | null;
                  } | null;
                }
              | {
                  __typename: 'PowerDistributionUnitHardwareDevice';
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                  serialNumber: string;
                  macAddress?: string | null;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  isDev?: boolean;
                  bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
                  latestDeviceConfigMetadata?: {
                    __typename?: 'DeviceConfigMetadata';
                    version: number;
                    acknowledgedAt?: string | null;
                    createdAt: string;
                    isCurrentAsOf?: string | null;
                    state?: {
                      __typename?: 'DeviceConfigState';
                      state: DeviceConfigStateType;
                      timestamp: string;
                    } | null;
                  } | null;
                }
              | {
                  __typename: 'SwitchHardwareDevice';
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                  serialNumber: string;
                  macAddress?: string | null;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  isDev?: boolean;
                  bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
                  latestDeviceConfigMetadata?: {
                    __typename?: 'DeviceConfigMetadata';
                    version: number;
                    acknowledgedAt?: string | null;
                    createdAt: string;
                    isCurrentAsOf?: string | null;
                    state?: {
                      __typename?: 'DeviceConfigState';
                      state: DeviceConfigStateType;
                      timestamp: string;
                    } | null;
                  } | null;
                }
              | null;
          }
        | {
            __typename: 'SwitchVirtualDevice';
            UUID: string;
            label: string;
            description?: string | null;
            deviceType: VirtualDeviceType;
            uptime?: string | null;
            network: { __typename?: 'Network'; UUID: string; slug: string; label: string };
            nosUpgradeGroup?: { __typename?: 'NOSUpgradeGroup'; UUID: string };
            nosVersion?: {
              __typename?: 'ConfiguredNOSVersion';
              id: number;
              version: string;
              buildName: string;
            } | null;
            pendingNosVersion?: {
              __typename?: 'PendingNosVersion';
              scheduledAt: string;
              nosVersion: { __typename?: 'NosVersion'; version: string };
            } | null;
            hardwareDevice?:
              | {
                  __typename: 'AccessPointHardwareDevice';
                  ipAddress?: string | null;
                  isInCurrentControllerMACTable: boolean;
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                  serialNumber: string;
                  macAddress?: string | null;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  isDev?: boolean;
                  phyInterfaceConnectedTo?: {
                    __typename?: 'PhyInterface';
                    UUID: string;
                    portSpeedMbps?: number | null;
                    maxSpeedMbps?: number | null;
                    isEthernet: boolean;
                    isSFP: boolean;
                    isPOEEnabled: boolean;
                    portNumber: number;
                    poeType?: PoEType | null;
                    sfpModuleInfo?: {
                      __typename?: 'SFPModuleInfo';
                      moduleSpeedKbps?: number | null;
                    } | null;
                    virtualDevice:
                      | {
                          __typename?: 'AccessPointVirtualDevice';
                          hardwareDevice?:
                            | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
                            | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
                            | {
                                __typename?: 'PowerDistributionUnitHardwareDevice';
                                serialNumber: string;
                              }
                            | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
                            | null;
                        }
                      | {
                          __typename?: 'ControllerVirtualDevice';
                          hardwareDevice?:
                            | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
                            | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
                            | {
                                __typename?: 'PowerDistributionUnitHardwareDevice';
                                serialNumber: string;
                              }
                            | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
                            | null;
                        }
                      | {
                          __typename?: 'ObserverVirtualDevice';
                          hardwareDevice?:
                            | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
                            | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
                            | {
                                __typename?: 'PowerDistributionUnitHardwareDevice';
                                serialNumber: string;
                              }
                            | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
                            | null;
                        }
                      | {
                          __typename?: 'PowerDistributionUnitVirtualDevice';
                          hardwareDevice?:
                            | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
                            | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
                            | {
                                __typename?: 'PowerDistributionUnitHardwareDevice';
                                serialNumber: string;
                              }
                            | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
                            | null;
                        }
                      | {
                          __typename?: 'SwitchVirtualDevice';
                          hardwareDevice?:
                            | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
                            | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
                            | {
                                __typename?: 'PowerDistributionUnitHardwareDevice';
                                serialNumber: string;
                              }
                            | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
                            | null;
                        };
                  } | null;
                  BSSIDs: Array<{ __typename?: 'BSSID'; BSSID: string }>;
                  bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
                  latestDeviceConfigMetadata?: {
                    __typename?: 'DeviceConfigMetadata';
                    version: number;
                    acknowledgedAt?: string | null;
                    createdAt: string;
                    isCurrentAsOf?: string | null;
                    state?: {
                      __typename?: 'DeviceConfigState';
                      state: DeviceConfigStateType;
                      timestamp: string;
                    } | null;
                  } | null;
                }
              | {
                  __typename: 'ControllerHardwareDevice';
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                  serialNumber: string;
                  macAddress?: string | null;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  isDev?: boolean;
                  bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
                  latestDeviceConfigMetadata?: {
                    __typename?: 'DeviceConfigMetadata';
                    version: number;
                    acknowledgedAt?: string | null;
                    createdAt: string;
                    isCurrentAsOf?: string | null;
                    state?: {
                      __typename?: 'DeviceConfigState';
                      state: DeviceConfigStateType;
                      timestamp: string;
                    } | null;
                  } | null;
                }
              | {
                  __typename: 'PowerDistributionUnitHardwareDevice';
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                  serialNumber: string;
                  macAddress?: string | null;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  isDev?: boolean;
                  bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
                  latestDeviceConfigMetadata?: {
                    __typename?: 'DeviceConfigMetadata';
                    version: number;
                    acknowledgedAt?: string | null;
                    createdAt: string;
                    isCurrentAsOf?: string | null;
                    state?: {
                      __typename?: 'DeviceConfigState';
                      state: DeviceConfigStateType;
                      timestamp: string;
                    } | null;
                  } | null;
                }
              | {
                  __typename: 'SwitchHardwareDevice';
                  deviceType: DeviceType;
                  deviceModel: DeviceModel;
                  serialNumber: string;
                  macAddress?: string | null;
                  isActive: boolean;
                  isConnectedToBackend: boolean;
                  disconnectedFromBackendAt?: string | null;
                  isDev?: boolean;
                  bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
                  latestDeviceConfigMetadata?: {
                    __typename?: 'DeviceConfigMetadata';
                    version: number;
                    acknowledgedAt?: string | null;
                    createdAt: string;
                    isCurrentAsOf?: string | null;
                    state?: {
                      __typename?: 'DeviceConfigState';
                      state: DeviceConfigStateType;
                      timestamp: string;
                    } | null;
                  } | null;
                }
              | null;
          }
      >;
    }>;
  };
};

export type AccessPointQueryQueryVariables = Exact<{
  uuid: Scalars['UUID']['input'];
  includeUptime?: InputMaybe<Scalars['Boolean']['input']>;
  includeNOS?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type AccessPointQueryQuery = {
  __typename?: 'Query';
  virtualDevice:
    | {
        __typename: 'AccessPointVirtualDevice';
        isLEDDarkModeEnabled: boolean;
        UUID: string;
        label: string;
        description?: string | null;
        deviceType: VirtualDeviceType;
        deviceModel: DeviceModel;
        isConsoleEnabled: boolean;
        networkUUID: string;
        uptime?: string | null;
        latestHealthScores?: {
          __typename?: 'AccessPointHealthScores';
          overallScore: number;
          performanceScore: number;
          connectionScore: number;
          rfScore: number;
          systemScore: number;
        } | null;
        radioProfile?: {
          __typename?: 'RadioProfile';
          UUID: string;
          name: string;
          band2_4GIsEnabled: boolean;
          band2_4GChannelWidthMHz?: number | null;
          band2_4GAutoChannelIsEnabled: boolean;
          band5GIsEnabled: boolean;
          band5GChannelWidthMHz?: number | null;
          band5GAutoChannelIsEnabled: boolean;
          band6GIsEnabled: boolean;
          band6GChannelWidthMHz?: number | null;
          band6GAutoChannelIsEnabled: boolean;
        } | null;
        radioSettings: {
          __typename?: 'RadioSettings';
          band2_4GActiveChannel?: number | null;
          band2_4GPrimaryChannel: number;
          band2_4GTransmitPowerdBm: number;
          band5GActiveChannel?: number | null;
          band5GPrimaryChannel: number;
          band5GSecondaryChannel?: number | null;
          band5GTransmitPowerdBm: number;
          band6GActiveChannel?: number | null;
          band6GPrimaryChannel: number;
          band6GTransmitPowerdBm: number;
        };
        connectedClients: Array<{
          __typename?: 'WirelessClient';
          macAddress: string;
          band: RadioBand;
          channel: number;
          ssidName: string;
          observerVirtualDevice?: { __typename?: 'ObserverVirtualDevice'; UUID: string } | null;
        }>;
        network: { __typename?: 'Network'; UUID: string; slug: string; label: string };
        nosUpgradeGroup?: { __typename?: 'NOSUpgradeGroup'; UUID: string };
        nosVersion?: {
          __typename?: 'ConfiguredNOSVersion';
          id: number;
          version: string;
          buildName: string;
        } | null;
        pendingNosVersion?: {
          __typename?: 'PendingNosVersion';
          scheduledAt: string;
          nosVersion: { __typename?: 'NosVersion'; version: string };
        } | null;
        hardwareDevice?:
          | {
              __typename: 'AccessPointHardwareDevice';
              ipAddress?: string | null;
              isInCurrentControllerMACTable: boolean;
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              deviceModel: DeviceModel;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              phyInterfaceConnectedTo?: {
                __typename?: 'PhyInterface';
                UUID: string;
                portNumber: number;
                portSpeedMbps?: number | null;
                maxSpeedMbps?: number | null;
                isEthernet: boolean;
                isSFP: boolean;
                poeType?: PoEType | null;
                isPOEEnabled: boolean;
                virtualDevice:
                  | {
                      __typename?: 'AccessPointVirtualDevice';
                      UUID: string;
                      label: string;
                      hardwareDevice?:
                        | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
                        | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
                        | {
                            __typename?: 'PowerDistributionUnitHardwareDevice';
                            serialNumber: string;
                          }
                        | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
                        | null;
                    }
                  | {
                      __typename?: 'ControllerVirtualDevice';
                      UUID: string;
                      label: string;
                      hardwareDevice?:
                        | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
                        | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
                        | {
                            __typename?: 'PowerDistributionUnitHardwareDevice';
                            serialNumber: string;
                          }
                        | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
                        | null;
                    }
                  | {
                      __typename?: 'ObserverVirtualDevice';
                      UUID: string;
                      label: string;
                      hardwareDevice?:
                        | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
                        | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
                        | {
                            __typename?: 'PowerDistributionUnitHardwareDevice';
                            serialNumber: string;
                          }
                        | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
                        | null;
                    }
                  | {
                      __typename?: 'PowerDistributionUnitVirtualDevice';
                      UUID: string;
                      label: string;
                      hardwareDevice?:
                        | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
                        | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
                        | {
                            __typename?: 'PowerDistributionUnitHardwareDevice';
                            serialNumber: string;
                          }
                        | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
                        | null;
                    }
                  | {
                      __typename?: 'SwitchVirtualDevice';
                      UUID: string;
                      label: string;
                      hardwareDevice?:
                        | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
                        | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
                        | {
                            __typename?: 'PowerDistributionUnitHardwareDevice';
                            serialNumber: string;
                          }
                        | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
                        | null;
                    };
              } | null;
              phyInterfaceLastConnectedTo?: {
                __typename?: 'PhyInterfaceConnectedAt';
                connectedAt: string;
                phyInterface: {
                  __typename?: 'PhyInterface';
                  UUID: string;
                  portNumber: number;
                  virtualDevice:
                    | { __typename?: 'AccessPointVirtualDevice'; UUID: string; label: string }
                    | { __typename?: 'ControllerVirtualDevice'; UUID: string; label: string }
                    | { __typename?: 'ObserverVirtualDevice'; UUID: string; label: string }
                    | {
                        __typename?: 'PowerDistributionUnitVirtualDevice';
                        UUID: string;
                        label: string;
                      }
                    | { __typename?: 'SwitchVirtualDevice'; UUID: string; label: string };
                };
              } | null;
              BSSIDs: Array<{ __typename?: 'BSSID'; BSSID: string }>;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
            }
          | {
              __typename: 'ControllerHardwareDevice';
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              deviceModel: DeviceModel;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
            }
          | {
              __typename: 'PowerDistributionUnitHardwareDevice';
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              deviceModel: DeviceModel;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
            }
          | {
              __typename: 'SwitchHardwareDevice';
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              deviceModel: DeviceModel;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
            }
          | null;
      }
    | {
        __typename: 'ControllerVirtualDevice';
        UUID: string;
        label: string;
        description?: string | null;
        deviceType: VirtualDeviceType;
        deviceModel: DeviceModel;
        isConsoleEnabled: boolean;
        networkUUID: string;
        uptime?: string | null;
        network: { __typename?: 'Network'; UUID: string; slug: string; label: string };
        nosUpgradeGroup?: { __typename?: 'NOSUpgradeGroup'; UUID: string };
        nosVersion?: {
          __typename?: 'ConfiguredNOSVersion';
          id: number;
          version: string;
          buildName: string;
        } | null;
        pendingNosVersion?: {
          __typename?: 'PendingNosVersion';
          scheduledAt: string;
          nosVersion: { __typename?: 'NosVersion'; version: string };
        } | null;
        hardwareDevice?:
          | {
              __typename: 'AccessPointHardwareDevice';
              ipAddress?: string | null;
              isInCurrentControllerMACTable: boolean;
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              deviceModel: DeviceModel;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              phyInterfaceConnectedTo?: {
                __typename?: 'PhyInterface';
                UUID: string;
                portNumber: number;
                portSpeedMbps?: number | null;
                maxSpeedMbps?: number | null;
                isEthernet: boolean;
                isSFP: boolean;
                poeType?: PoEType | null;
                isPOEEnabled: boolean;
                virtualDevice:
                  | {
                      __typename?: 'AccessPointVirtualDevice';
                      UUID: string;
                      label: string;
                      hardwareDevice?:
                        | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
                        | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
                        | {
                            __typename?: 'PowerDistributionUnitHardwareDevice';
                            serialNumber: string;
                          }
                        | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
                        | null;
                    }
                  | {
                      __typename?: 'ControllerVirtualDevice';
                      UUID: string;
                      label: string;
                      hardwareDevice?:
                        | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
                        | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
                        | {
                            __typename?: 'PowerDistributionUnitHardwareDevice';
                            serialNumber: string;
                          }
                        | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
                        | null;
                    }
                  | {
                      __typename?: 'ObserverVirtualDevice';
                      UUID: string;
                      label: string;
                      hardwareDevice?:
                        | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
                        | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
                        | {
                            __typename?: 'PowerDistributionUnitHardwareDevice';
                            serialNumber: string;
                          }
                        | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
                        | null;
                    }
                  | {
                      __typename?: 'PowerDistributionUnitVirtualDevice';
                      UUID: string;
                      label: string;
                      hardwareDevice?:
                        | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
                        | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
                        | {
                            __typename?: 'PowerDistributionUnitHardwareDevice';
                            serialNumber: string;
                          }
                        | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
                        | null;
                    }
                  | {
                      __typename?: 'SwitchVirtualDevice';
                      UUID: string;
                      label: string;
                      hardwareDevice?:
                        | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
                        | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
                        | {
                            __typename?: 'PowerDistributionUnitHardwareDevice';
                            serialNumber: string;
                          }
                        | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
                        | null;
                    };
              } | null;
              phyInterfaceLastConnectedTo?: {
                __typename?: 'PhyInterfaceConnectedAt';
                connectedAt: string;
                phyInterface: {
                  __typename?: 'PhyInterface';
                  UUID: string;
                  portNumber: number;
                  virtualDevice:
                    | { __typename?: 'AccessPointVirtualDevice'; UUID: string; label: string }
                    | { __typename?: 'ControllerVirtualDevice'; UUID: string; label: string }
                    | { __typename?: 'ObserverVirtualDevice'; UUID: string; label: string }
                    | {
                        __typename?: 'PowerDistributionUnitVirtualDevice';
                        UUID: string;
                        label: string;
                      }
                    | { __typename?: 'SwitchVirtualDevice'; UUID: string; label: string };
                };
              } | null;
              BSSIDs: Array<{ __typename?: 'BSSID'; BSSID: string }>;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
            }
          | {
              __typename: 'ControllerHardwareDevice';
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              deviceModel: DeviceModel;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
            }
          | {
              __typename: 'PowerDistributionUnitHardwareDevice';
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              deviceModel: DeviceModel;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
            }
          | {
              __typename: 'SwitchHardwareDevice';
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              deviceModel: DeviceModel;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
            }
          | null;
      }
    | {
        __typename: 'ObserverVirtualDevice';
        UUID: string;
        label: string;
        description?: string | null;
        deviceType: VirtualDeviceType;
        deviceModel: DeviceModel;
        isConsoleEnabled: boolean;
        networkUUID: string;
        uptime?: string | null;
        network: { __typename?: 'Network'; UUID: string; slug: string; label: string };
        nosUpgradeGroup?: { __typename?: 'NOSUpgradeGroup'; UUID: string };
        nosVersion?: {
          __typename?: 'ConfiguredNOSVersion';
          id: number;
          version: string;
          buildName: string;
        } | null;
        pendingNosVersion?: {
          __typename?: 'PendingNosVersion';
          scheduledAt: string;
          nosVersion: { __typename?: 'NosVersion'; version: string };
        } | null;
        hardwareDevice?:
          | {
              __typename: 'AccessPointHardwareDevice';
              ipAddress?: string | null;
              isInCurrentControllerMACTable: boolean;
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              deviceModel: DeviceModel;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              phyInterfaceConnectedTo?: {
                __typename?: 'PhyInterface';
                UUID: string;
                portNumber: number;
                portSpeedMbps?: number | null;
                maxSpeedMbps?: number | null;
                isEthernet: boolean;
                isSFP: boolean;
                poeType?: PoEType | null;
                isPOEEnabled: boolean;
                virtualDevice:
                  | {
                      __typename?: 'AccessPointVirtualDevice';
                      UUID: string;
                      label: string;
                      hardwareDevice?:
                        | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
                        | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
                        | {
                            __typename?: 'PowerDistributionUnitHardwareDevice';
                            serialNumber: string;
                          }
                        | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
                        | null;
                    }
                  | {
                      __typename?: 'ControllerVirtualDevice';
                      UUID: string;
                      label: string;
                      hardwareDevice?:
                        | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
                        | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
                        | {
                            __typename?: 'PowerDistributionUnitHardwareDevice';
                            serialNumber: string;
                          }
                        | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
                        | null;
                    }
                  | {
                      __typename?: 'ObserverVirtualDevice';
                      UUID: string;
                      label: string;
                      hardwareDevice?:
                        | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
                        | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
                        | {
                            __typename?: 'PowerDistributionUnitHardwareDevice';
                            serialNumber: string;
                          }
                        | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
                        | null;
                    }
                  | {
                      __typename?: 'PowerDistributionUnitVirtualDevice';
                      UUID: string;
                      label: string;
                      hardwareDevice?:
                        | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
                        | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
                        | {
                            __typename?: 'PowerDistributionUnitHardwareDevice';
                            serialNumber: string;
                          }
                        | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
                        | null;
                    }
                  | {
                      __typename?: 'SwitchVirtualDevice';
                      UUID: string;
                      label: string;
                      hardwareDevice?:
                        | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
                        | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
                        | {
                            __typename?: 'PowerDistributionUnitHardwareDevice';
                            serialNumber: string;
                          }
                        | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
                        | null;
                    };
              } | null;
              phyInterfaceLastConnectedTo?: {
                __typename?: 'PhyInterfaceConnectedAt';
                connectedAt: string;
                phyInterface: {
                  __typename?: 'PhyInterface';
                  UUID: string;
                  portNumber: number;
                  virtualDevice:
                    | { __typename?: 'AccessPointVirtualDevice'; UUID: string; label: string }
                    | { __typename?: 'ControllerVirtualDevice'; UUID: string; label: string }
                    | { __typename?: 'ObserverVirtualDevice'; UUID: string; label: string }
                    | {
                        __typename?: 'PowerDistributionUnitVirtualDevice';
                        UUID: string;
                        label: string;
                      }
                    | { __typename?: 'SwitchVirtualDevice'; UUID: string; label: string };
                };
              } | null;
              BSSIDs: Array<{ __typename?: 'BSSID'; BSSID: string }>;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
            }
          | {
              __typename: 'ControllerHardwareDevice';
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              deviceModel: DeviceModel;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
            }
          | {
              __typename: 'PowerDistributionUnitHardwareDevice';
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              deviceModel: DeviceModel;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
            }
          | {
              __typename: 'SwitchHardwareDevice';
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              deviceModel: DeviceModel;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
            }
          | null;
      }
    | {
        __typename: 'PowerDistributionUnitVirtualDevice';
        UUID: string;
        label: string;
        description?: string | null;
        deviceType: VirtualDeviceType;
        deviceModel: DeviceModel;
        isConsoleEnabled: boolean;
        networkUUID: string;
        uptime?: string | null;
        network: { __typename?: 'Network'; UUID: string; slug: string; label: string };
        nosUpgradeGroup?: { __typename?: 'NOSUpgradeGroup'; UUID: string };
        nosVersion?: {
          __typename?: 'ConfiguredNOSVersion';
          id: number;
          version: string;
          buildName: string;
        } | null;
        pendingNosVersion?: {
          __typename?: 'PendingNosVersion';
          scheduledAt: string;
          nosVersion: { __typename?: 'NosVersion'; version: string };
        } | null;
        hardwareDevice?:
          | {
              __typename: 'AccessPointHardwareDevice';
              ipAddress?: string | null;
              isInCurrentControllerMACTable: boolean;
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              deviceModel: DeviceModel;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              phyInterfaceConnectedTo?: {
                __typename?: 'PhyInterface';
                UUID: string;
                portNumber: number;
                portSpeedMbps?: number | null;
                maxSpeedMbps?: number | null;
                isEthernet: boolean;
                isSFP: boolean;
                poeType?: PoEType | null;
                isPOEEnabled: boolean;
                virtualDevice:
                  | {
                      __typename?: 'AccessPointVirtualDevice';
                      UUID: string;
                      label: string;
                      hardwareDevice?:
                        | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
                        | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
                        | {
                            __typename?: 'PowerDistributionUnitHardwareDevice';
                            serialNumber: string;
                          }
                        | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
                        | null;
                    }
                  | {
                      __typename?: 'ControllerVirtualDevice';
                      UUID: string;
                      label: string;
                      hardwareDevice?:
                        | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
                        | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
                        | {
                            __typename?: 'PowerDistributionUnitHardwareDevice';
                            serialNumber: string;
                          }
                        | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
                        | null;
                    }
                  | {
                      __typename?: 'ObserverVirtualDevice';
                      UUID: string;
                      label: string;
                      hardwareDevice?:
                        | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
                        | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
                        | {
                            __typename?: 'PowerDistributionUnitHardwareDevice';
                            serialNumber: string;
                          }
                        | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
                        | null;
                    }
                  | {
                      __typename?: 'PowerDistributionUnitVirtualDevice';
                      UUID: string;
                      label: string;
                      hardwareDevice?:
                        | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
                        | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
                        | {
                            __typename?: 'PowerDistributionUnitHardwareDevice';
                            serialNumber: string;
                          }
                        | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
                        | null;
                    }
                  | {
                      __typename?: 'SwitchVirtualDevice';
                      UUID: string;
                      label: string;
                      hardwareDevice?:
                        | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
                        | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
                        | {
                            __typename?: 'PowerDistributionUnitHardwareDevice';
                            serialNumber: string;
                          }
                        | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
                        | null;
                    };
              } | null;
              phyInterfaceLastConnectedTo?: {
                __typename?: 'PhyInterfaceConnectedAt';
                connectedAt: string;
                phyInterface: {
                  __typename?: 'PhyInterface';
                  UUID: string;
                  portNumber: number;
                  virtualDevice:
                    | { __typename?: 'AccessPointVirtualDevice'; UUID: string; label: string }
                    | { __typename?: 'ControllerVirtualDevice'; UUID: string; label: string }
                    | { __typename?: 'ObserverVirtualDevice'; UUID: string; label: string }
                    | {
                        __typename?: 'PowerDistributionUnitVirtualDevice';
                        UUID: string;
                        label: string;
                      }
                    | { __typename?: 'SwitchVirtualDevice'; UUID: string; label: string };
                };
              } | null;
              BSSIDs: Array<{ __typename?: 'BSSID'; BSSID: string }>;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
            }
          | {
              __typename: 'ControllerHardwareDevice';
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              deviceModel: DeviceModel;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
            }
          | {
              __typename: 'PowerDistributionUnitHardwareDevice';
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              deviceModel: DeviceModel;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
            }
          | {
              __typename: 'SwitchHardwareDevice';
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              deviceModel: DeviceModel;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
            }
          | null;
      }
    | {
        __typename: 'SwitchVirtualDevice';
        UUID: string;
        label: string;
        description?: string | null;
        deviceType: VirtualDeviceType;
        deviceModel: DeviceModel;
        isConsoleEnabled: boolean;
        networkUUID: string;
        uptime?: string | null;
        network: { __typename?: 'Network'; UUID: string; slug: string; label: string };
        nosUpgradeGroup?: { __typename?: 'NOSUpgradeGroup'; UUID: string };
        nosVersion?: {
          __typename?: 'ConfiguredNOSVersion';
          id: number;
          version: string;
          buildName: string;
        } | null;
        pendingNosVersion?: {
          __typename?: 'PendingNosVersion';
          scheduledAt: string;
          nosVersion: { __typename?: 'NosVersion'; version: string };
        } | null;
        hardwareDevice?:
          | {
              __typename: 'AccessPointHardwareDevice';
              ipAddress?: string | null;
              isInCurrentControllerMACTable: boolean;
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              deviceModel: DeviceModel;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              phyInterfaceConnectedTo?: {
                __typename?: 'PhyInterface';
                UUID: string;
                portNumber: number;
                portSpeedMbps?: number | null;
                maxSpeedMbps?: number | null;
                isEthernet: boolean;
                isSFP: boolean;
                poeType?: PoEType | null;
                isPOEEnabled: boolean;
                virtualDevice:
                  | {
                      __typename?: 'AccessPointVirtualDevice';
                      UUID: string;
                      label: string;
                      hardwareDevice?:
                        | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
                        | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
                        | {
                            __typename?: 'PowerDistributionUnitHardwareDevice';
                            serialNumber: string;
                          }
                        | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
                        | null;
                    }
                  | {
                      __typename?: 'ControllerVirtualDevice';
                      UUID: string;
                      label: string;
                      hardwareDevice?:
                        | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
                        | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
                        | {
                            __typename?: 'PowerDistributionUnitHardwareDevice';
                            serialNumber: string;
                          }
                        | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
                        | null;
                    }
                  | {
                      __typename?: 'ObserverVirtualDevice';
                      UUID: string;
                      label: string;
                      hardwareDevice?:
                        | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
                        | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
                        | {
                            __typename?: 'PowerDistributionUnitHardwareDevice';
                            serialNumber: string;
                          }
                        | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
                        | null;
                    }
                  | {
                      __typename?: 'PowerDistributionUnitVirtualDevice';
                      UUID: string;
                      label: string;
                      hardwareDevice?:
                        | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
                        | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
                        | {
                            __typename?: 'PowerDistributionUnitHardwareDevice';
                            serialNumber: string;
                          }
                        | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
                        | null;
                    }
                  | {
                      __typename?: 'SwitchVirtualDevice';
                      UUID: string;
                      label: string;
                      hardwareDevice?:
                        | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
                        | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
                        | {
                            __typename?: 'PowerDistributionUnitHardwareDevice';
                            serialNumber: string;
                          }
                        | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
                        | null;
                    };
              } | null;
              phyInterfaceLastConnectedTo?: {
                __typename?: 'PhyInterfaceConnectedAt';
                connectedAt: string;
                phyInterface: {
                  __typename?: 'PhyInterface';
                  UUID: string;
                  portNumber: number;
                  virtualDevice:
                    | { __typename?: 'AccessPointVirtualDevice'; UUID: string; label: string }
                    | { __typename?: 'ControllerVirtualDevice'; UUID: string; label: string }
                    | { __typename?: 'ObserverVirtualDevice'; UUID: string; label: string }
                    | {
                        __typename?: 'PowerDistributionUnitVirtualDevice';
                        UUID: string;
                        label: string;
                      }
                    | { __typename?: 'SwitchVirtualDevice'; UUID: string; label: string };
                };
              } | null;
              BSSIDs: Array<{ __typename?: 'BSSID'; BSSID: string }>;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
            }
          | {
              __typename: 'ControllerHardwareDevice';
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              deviceModel: DeviceModel;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
            }
          | {
              __typename: 'PowerDistributionUnitHardwareDevice';
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              deviceModel: DeviceModel;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
            }
          | {
              __typename: 'SwitchHardwareDevice';
              deviceType: DeviceType;
              serialNumber: string;
              macAddress?: string | null;
              deviceModel: DeviceModel;
              isActive: boolean;
              isConnectedToBackend: boolean;
              disconnectedFromBackendAt?: string | null;
              bootHistory: Array<{ __typename?: 'BootInfo'; buildName: string }>;
            }
          | null;
      };
};

export type PacketCaptureDeviceQueryQueryVariables = Exact<{
  uuid: Scalars['UUID']['input'];
}>;

export type PacketCaptureDeviceQueryQuery = {
  __typename?: 'Query';
  virtualDevice:
    | {
        __typename: 'AccessPointVirtualDevice';
        UUID: string;
        label: string;
        deviceType: VirtualDeviceType;
        hardwareDevice?:
          | {
              __typename: 'AccessPointHardwareDevice';
              deviceType: DeviceType;
              serialNumber: string;
            }
          | { __typename: 'ControllerHardwareDevice'; deviceType: DeviceType; serialNumber: string }
          | {
              __typename: 'PowerDistributionUnitHardwareDevice';
              deviceType: DeviceType;
              serialNumber: string;
            }
          | { __typename: 'SwitchHardwareDevice'; deviceType: DeviceType; serialNumber: string }
          | null;
      }
    | {
        __typename: 'ControllerVirtualDevice';
        UUID: string;
        label: string;
        deviceType: VirtualDeviceType;
        hardwareDevice?:
          | {
              __typename: 'AccessPointHardwareDevice';
              deviceType: DeviceType;
              serialNumber: string;
            }
          | { __typename: 'ControllerHardwareDevice'; deviceType: DeviceType; serialNumber: string }
          | {
              __typename: 'PowerDistributionUnitHardwareDevice';
              deviceType: DeviceType;
              serialNumber: string;
            }
          | { __typename: 'SwitchHardwareDevice'; deviceType: DeviceType; serialNumber: string }
          | null;
      }
    | {
        __typename: 'ObserverVirtualDevice';
        UUID: string;
        label: string;
        deviceType: VirtualDeviceType;
        hardwareDevice?:
          | {
              __typename: 'AccessPointHardwareDevice';
              deviceType: DeviceType;
              serialNumber: string;
            }
          | { __typename: 'ControllerHardwareDevice'; deviceType: DeviceType; serialNumber: string }
          | {
              __typename: 'PowerDistributionUnitHardwareDevice';
              deviceType: DeviceType;
              serialNumber: string;
            }
          | { __typename: 'SwitchHardwareDevice'; deviceType: DeviceType; serialNumber: string }
          | null;
      }
    | {
        __typename: 'PowerDistributionUnitVirtualDevice';
        UUID: string;
        label: string;
        deviceType: VirtualDeviceType;
        hardwareDevice?:
          | {
              __typename: 'AccessPointHardwareDevice';
              deviceType: DeviceType;
              serialNumber: string;
            }
          | { __typename: 'ControllerHardwareDevice'; deviceType: DeviceType; serialNumber: string }
          | {
              __typename: 'PowerDistributionUnitHardwareDevice';
              deviceType: DeviceType;
              serialNumber: string;
            }
          | { __typename: 'SwitchHardwareDevice'; deviceType: DeviceType; serialNumber: string }
          | null;
      }
    | {
        __typename: 'SwitchVirtualDevice';
        UUID: string;
        label: string;
        deviceType: VirtualDeviceType;
        hardwareDevice?:
          | {
              __typename: 'AccessPointHardwareDevice';
              deviceType: DeviceType;
              serialNumber: string;
            }
          | { __typename: 'ControllerHardwareDevice'; deviceType: DeviceType; serialNumber: string }
          | {
              __typename: 'PowerDistributionUnitHardwareDevice';
              deviceType: DeviceType;
              serialNumber: string;
            }
          | { __typename: 'SwitchHardwareDevice'; deviceType: DeviceType; serialNumber: string }
          | null;
      };
};

export type UpdateVirtualDevicesMutationMutationVariables = Exact<{
  virtualDeviceUUIDs: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
  networkUUID: Scalars['UUID']['input'];
  input: UpdateVirtualDeviceInput;
}>;

export type UpdateVirtualDevicesMutationMutation = {
  __typename?: 'Mutation';
  updateVirtualDevices: Array<
    | { __typename?: 'AccessPointVirtualDevice'; UUID: string }
    | { __typename?: 'ControllerVirtualDevice'; UUID: string }
    | { __typename?: 'ObserverVirtualDevice'; UUID: string }
    | { __typename?: 'PowerDistributionUnitVirtualDevice'; UUID: string }
    | { __typename?: 'SwitchVirtualDevice'; UUID: string }
  >;
};

export type FallbackAccessPointHardwareQueryQueryVariables = Exact<{
  serialNumber: Scalars['String']['input'];
}>;

export type FallbackAccessPointHardwareQueryQuery = {
  __typename?: 'Query';
  hardwareDevice:
    | {
        __typename?: 'AccessPointHardwareDevice';
        serialNumber: string;
        virtualDeviceUUID?: string | null;
        virtualDevice?:
          | { __typename?: 'AccessPointVirtualDevice'; label: string }
          | { __typename?: 'ControllerVirtualDevice'; label: string }
          | { __typename?: 'ObserverVirtualDevice'; label: string }
          | { __typename?: 'PowerDistributionUnitVirtualDevice'; label: string }
          | { __typename?: 'SwitchVirtualDevice'; label: string }
          | null;
      }
    | {
        __typename?: 'ControllerHardwareDevice';
        serialNumber: string;
        virtualDeviceUUID?: string | null;
        virtualDevice?:
          | { __typename?: 'AccessPointVirtualDevice'; label: string }
          | { __typename?: 'ControllerVirtualDevice'; label: string }
          | { __typename?: 'ObserverVirtualDevice'; label: string }
          | { __typename?: 'PowerDistributionUnitVirtualDevice'; label: string }
          | { __typename?: 'SwitchVirtualDevice'; label: string }
          | null;
      }
    | {
        __typename?: 'PowerDistributionUnitHardwareDevice';
        serialNumber: string;
        virtualDeviceUUID?: string | null;
        virtualDevice?:
          | { __typename?: 'AccessPointVirtualDevice'; label: string }
          | { __typename?: 'ControllerVirtualDevice'; label: string }
          | { __typename?: 'ObserverVirtualDevice'; label: string }
          | { __typename?: 'PowerDistributionUnitVirtualDevice'; label: string }
          | { __typename?: 'SwitchVirtualDevice'; label: string }
          | null;
      }
    | {
        __typename?: 'SwitchHardwareDevice';
        serialNumber: string;
        virtualDeviceUUID?: string | null;
        virtualDevice?:
          | { __typename?: 'AccessPointVirtualDevice'; label: string }
          | { __typename?: 'ControllerVirtualDevice'; label: string }
          | { __typename?: 'ObserverVirtualDevice'; label: string }
          | { __typename?: 'PowerDistributionUnitVirtualDevice'; label: string }
          | { __typename?: 'SwitchVirtualDevice'; label: string }
          | null;
      };
};

export type BssiDsForNetworkQueryQueryVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
}>;

export type BssiDsForNetworkQueryQuery = {
  __typename?: 'Query';
  bssidsForNetwork: Array<{
    __typename?: 'BSSID';
    BSSID: string;
    isActive: boolean;
    radioBand: RadioBand;
    SSID: { __typename?: 'SSID'; ssid: string; isHidden: boolean };
    accessPointHardwareDevice: {
      __typename?: 'AccessPointHardwareDevice';
      virtualDevice?:
        | { __typename?: 'AccessPointVirtualDevice'; UUID: string; label: string }
        | { __typename?: 'ControllerVirtualDevice'; UUID: string; label: string }
        | { __typename?: 'ObserverVirtualDevice'; UUID: string; label: string }
        | { __typename?: 'PowerDistributionUnitVirtualDevice'; UUID: string; label: string }
        | { __typename?: 'SwitchVirtualDevice'; UUID: string; label: string }
        | null;
    };
  }>;
};

export type AutoVpnMemberFieldsFragment = {
  __typename: 'AutoVPNMember';
  UUID: string;
  networkUUID: string;
  isFailoverEnabled: boolean;
  network: { __typename?: 'Network'; UUID: string; slug: string; label: string };
  permittedVLANs: Array<{
    __typename: 'VLAN';
    UUID: string;
    name: string;
    vlanID: number;
    ipV4ClientGateway?: string | null;
    ipV4ClientPrefixLength?: number | null;
  }>;
  uplink: {
    __typename?: 'AutoVPNMemberUplink';
    UUID: string;
    address: string;
    addressPrefixLength: number;
    hubUplinkUUID: string;
    publicKey: string;
    listenPort: number;
    phyInterfaceUUID: string;
    phyInterface: {
      __typename: 'PhyInterface';
      UUID: string;
      portNumber: number;
      label?: string | null;
      hardwareLabel?: string | null;
      virtualDevice:
        | {
            __typename?: 'AccessPointVirtualDevice';
            UUID: string;
            label: string;
            deviceModel: DeviceModel;
          }
        | {
            __typename?: 'ControllerVirtualDevice';
            UUID: string;
            label: string;
            deviceModel: DeviceModel;
          }
        | {
            __typename?: 'ObserverVirtualDevice';
            UUID: string;
            label: string;
            deviceModel: DeviceModel;
          }
        | {
            __typename?: 'PowerDistributionUnitVirtualDevice';
            UUID: string;
            label: string;
            deviceModel: DeviceModel;
          }
        | {
            __typename?: 'SwitchVirtualDevice';
            UUID: string;
            label: string;
            deviceModel: DeviceModel;
          };
      internetServicePlan?: {
        __typename?: 'InternetServicePlan';
        UUID: string;
        provider?: { __typename?: 'InternetServicePlanProvider'; name: string } | null;
      } | null;
    };
    connectionInfo?: {
      __typename?: 'AutoVPNMemberUplinkConnectionInfo';
      observedAt?: string | null;
      lastHandshakeRx?: string | null;
      lastHandshakeTx?: string | null;
      lastPacketTx?: string | null;
      lastPacketRx?: string | null;
    } | null;
  };
};

export type AutoVpnGroupFieldsFragment = {
  __typename: 'AutoVPNGroup';
  UUID: string;
  name: string;
  isEnabled: boolean;
  hubNetworkUUID: string;
  isHubFailoverEnabled: boolean;
  hubNetwork: { __typename?: 'Network'; UUID: string; slug: string; label: string };
  hubUplink: {
    __typename?: 'AutoVPNHubUplink';
    address: string;
    addressPrefixLength: number;
    listenPort: number;
    phyInterface: {
      __typename: 'PhyInterface';
      UUID: string;
      portNumber: number;
      label?: string | null;
      hardwareLabel?: string | null;
      virtualDevice:
        | {
            __typename?: 'AccessPointVirtualDevice';
            UUID: string;
            label: string;
            deviceModel: DeviceModel;
          }
        | {
            __typename?: 'ControllerVirtualDevice';
            UUID: string;
            label: string;
            deviceModel: DeviceModel;
          }
        | {
            __typename?: 'ObserverVirtualDevice';
            UUID: string;
            label: string;
            deviceModel: DeviceModel;
          }
        | {
            __typename?: 'PowerDistributionUnitVirtualDevice';
            UUID: string;
            label: string;
            deviceModel: DeviceModel;
          }
        | {
            __typename?: 'SwitchVirtualDevice';
            UUID: string;
            label: string;
            deviceModel: DeviceModel;
          };
      internetServicePlan?: {
        __typename?: 'InternetServicePlan';
        UUID: string;
        provider?: { __typename?: 'InternetServicePlanProvider'; name: string } | null;
      } | null;
    };
  };
  members?: Array<{
    __typename: 'AutoVPNMember';
    UUID: string;
    networkUUID: string;
    isFailoverEnabled: boolean;
    network: { __typename?: 'Network'; UUID: string; slug: string; label: string };
    permittedVLANs: Array<{
      __typename: 'VLAN';
      UUID: string;
      name: string;
      vlanID: number;
      ipV4ClientGateway?: string | null;
      ipV4ClientPrefixLength?: number | null;
    }>;
    uplink: {
      __typename?: 'AutoVPNMemberUplink';
      UUID: string;
      address: string;
      addressPrefixLength: number;
      hubUplinkUUID: string;
      publicKey: string;
      listenPort: number;
      phyInterfaceUUID: string;
      phyInterface: {
        __typename: 'PhyInterface';
        UUID: string;
        portNumber: number;
        label?: string | null;
        hardwareLabel?: string | null;
        virtualDevice:
          | {
              __typename?: 'AccessPointVirtualDevice';
              UUID: string;
              label: string;
              deviceModel: DeviceModel;
            }
          | {
              __typename?: 'ControllerVirtualDevice';
              UUID: string;
              label: string;
              deviceModel: DeviceModel;
            }
          | {
              __typename?: 'ObserverVirtualDevice';
              UUID: string;
              label: string;
              deviceModel: DeviceModel;
            }
          | {
              __typename?: 'PowerDistributionUnitVirtualDevice';
              UUID: string;
              label: string;
              deviceModel: DeviceModel;
            }
          | {
              __typename?: 'SwitchVirtualDevice';
              UUID: string;
              label: string;
              deviceModel: DeviceModel;
            };
        internetServicePlan?: {
          __typename?: 'InternetServicePlan';
          UUID: string;
          provider?: { __typename?: 'InternetServicePlanProvider'; name: string } | null;
        } | null;
      };
      connectionInfo?: {
        __typename?: 'AutoVPNMemberUplinkConnectionInfo';
        observedAt?: string | null;
        lastHandshakeRx?: string | null;
        lastHandshakeTx?: string | null;
        lastPacketTx?: string | null;
        lastPacketRx?: string | null;
      } | null;
    };
  }> | null;
  routes?: Array<{
    __typename: 'AutoVPNRoute';
    UUID: string;
    name: string;
    isEnabled: boolean;
    dstPrefixLength: number;
    dstGateway: string;
  }> | null;
};

export type AutoVpnGroupsForCompanyQueryVariables = Exact<{
  companySlug: Scalars['String']['input'];
}>;

export type AutoVpnGroupsForCompanyQuery = {
  __typename?: 'Query';
  autoVPNGroupsForCompany: Array<{
    __typename: 'AutoVPNGroup';
    UUID: string;
    name: string;
    isEnabled: boolean;
    hubNetworkUUID: string;
    isHubFailoverEnabled: boolean;
    hubNetwork: { __typename?: 'Network'; UUID: string; slug: string; label: string };
    hubUplink: {
      __typename?: 'AutoVPNHubUplink';
      address: string;
      addressPrefixLength: number;
      listenPort: number;
      phyInterface: {
        __typename: 'PhyInterface';
        UUID: string;
        portNumber: number;
        label?: string | null;
        hardwareLabel?: string | null;
        virtualDevice:
          | {
              __typename?: 'AccessPointVirtualDevice';
              UUID: string;
              label: string;
              deviceModel: DeviceModel;
            }
          | {
              __typename?: 'ControllerVirtualDevice';
              UUID: string;
              label: string;
              deviceModel: DeviceModel;
            }
          | {
              __typename?: 'ObserverVirtualDevice';
              UUID: string;
              label: string;
              deviceModel: DeviceModel;
            }
          | {
              __typename?: 'PowerDistributionUnitVirtualDevice';
              UUID: string;
              label: string;
              deviceModel: DeviceModel;
            }
          | {
              __typename?: 'SwitchVirtualDevice';
              UUID: string;
              label: string;
              deviceModel: DeviceModel;
            };
        internetServicePlan?: {
          __typename?: 'InternetServicePlan';
          UUID: string;
          provider?: { __typename?: 'InternetServicePlanProvider'; name: string } | null;
        } | null;
      };
    };
    members?: Array<{
      __typename: 'AutoVPNMember';
      UUID: string;
      networkUUID: string;
      isFailoverEnabled: boolean;
      network: { __typename?: 'Network'; UUID: string; slug: string; label: string };
      permittedVLANs: Array<{
        __typename: 'VLAN';
        UUID: string;
        name: string;
        vlanID: number;
        ipV4ClientGateway?: string | null;
        ipV4ClientPrefixLength?: number | null;
      }>;
      uplink: {
        __typename?: 'AutoVPNMemberUplink';
        UUID: string;
        address: string;
        addressPrefixLength: number;
        hubUplinkUUID: string;
        publicKey: string;
        listenPort: number;
        phyInterfaceUUID: string;
        phyInterface: {
          __typename: 'PhyInterface';
          UUID: string;
          portNumber: number;
          label?: string | null;
          hardwareLabel?: string | null;
          virtualDevice:
            | {
                __typename?: 'AccessPointVirtualDevice';
                UUID: string;
                label: string;
                deviceModel: DeviceModel;
              }
            | {
                __typename?: 'ControllerVirtualDevice';
                UUID: string;
                label: string;
                deviceModel: DeviceModel;
              }
            | {
                __typename?: 'ObserverVirtualDevice';
                UUID: string;
                label: string;
                deviceModel: DeviceModel;
              }
            | {
                __typename?: 'PowerDistributionUnitVirtualDevice';
                UUID: string;
                label: string;
                deviceModel: DeviceModel;
              }
            | {
                __typename?: 'SwitchVirtualDevice';
                UUID: string;
                label: string;
                deviceModel: DeviceModel;
              };
          internetServicePlan?: {
            __typename?: 'InternetServicePlan';
            UUID: string;
            provider?: { __typename?: 'InternetServicePlanProvider'; name: string } | null;
          } | null;
        };
        connectionInfo?: {
          __typename?: 'AutoVPNMemberUplinkConnectionInfo';
          observedAt?: string | null;
          lastHandshakeRx?: string | null;
          lastHandshakeTx?: string | null;
          lastPacketTx?: string | null;
          lastPacketRx?: string | null;
        } | null;
      };
    }> | null;
    routes?: Array<{
      __typename: 'AutoVPNRoute';
      UUID: string;
      name: string;
      isEnabled: boolean;
      dstPrefixLength: number;
      dstGateway: string;
    }> | null;
  }>;
};

export type AutoVpnGroupQueryVariables = Exact<{
  uuid: Scalars['UUID']['input'];
}>;

export type AutoVpnGroupQuery = {
  __typename?: 'Query';
  autoVPNGroup: {
    __typename: 'AutoVPNGroup';
    UUID: string;
    name: string;
    isEnabled: boolean;
    hubNetworkUUID: string;
    isHubFailoverEnabled: boolean;
    hubNetwork: { __typename?: 'Network'; UUID: string; slug: string; label: string };
    hubUplink: {
      __typename?: 'AutoVPNHubUplink';
      address: string;
      addressPrefixLength: number;
      listenPort: number;
      phyInterface: {
        __typename: 'PhyInterface';
        UUID: string;
        portNumber: number;
        label?: string | null;
        hardwareLabel?: string | null;
        virtualDevice:
          | {
              __typename?: 'AccessPointVirtualDevice';
              UUID: string;
              label: string;
              deviceModel: DeviceModel;
            }
          | {
              __typename?: 'ControllerVirtualDevice';
              UUID: string;
              label: string;
              deviceModel: DeviceModel;
            }
          | {
              __typename?: 'ObserverVirtualDevice';
              UUID: string;
              label: string;
              deviceModel: DeviceModel;
            }
          | {
              __typename?: 'PowerDistributionUnitVirtualDevice';
              UUID: string;
              label: string;
              deviceModel: DeviceModel;
            }
          | {
              __typename?: 'SwitchVirtualDevice';
              UUID: string;
              label: string;
              deviceModel: DeviceModel;
            };
        internetServicePlan?: {
          __typename?: 'InternetServicePlan';
          UUID: string;
          provider?: { __typename?: 'InternetServicePlanProvider'; name: string } | null;
        } | null;
      };
    };
    members?: Array<{
      __typename: 'AutoVPNMember';
      UUID: string;
      networkUUID: string;
      isFailoverEnabled: boolean;
      network: { __typename?: 'Network'; UUID: string; slug: string; label: string };
      permittedVLANs: Array<{
        __typename: 'VLAN';
        UUID: string;
        name: string;
        vlanID: number;
        ipV4ClientGateway?: string | null;
        ipV4ClientPrefixLength?: number | null;
      }>;
      uplink: {
        __typename?: 'AutoVPNMemberUplink';
        UUID: string;
        address: string;
        addressPrefixLength: number;
        hubUplinkUUID: string;
        publicKey: string;
        listenPort: number;
        phyInterfaceUUID: string;
        phyInterface: {
          __typename: 'PhyInterface';
          UUID: string;
          portNumber: number;
          label?: string | null;
          hardwareLabel?: string | null;
          virtualDevice:
            | {
                __typename?: 'AccessPointVirtualDevice';
                UUID: string;
                label: string;
                deviceModel: DeviceModel;
              }
            | {
                __typename?: 'ControllerVirtualDevice';
                UUID: string;
                label: string;
                deviceModel: DeviceModel;
              }
            | {
                __typename?: 'ObserverVirtualDevice';
                UUID: string;
                label: string;
                deviceModel: DeviceModel;
              }
            | {
                __typename?: 'PowerDistributionUnitVirtualDevice';
                UUID: string;
                label: string;
                deviceModel: DeviceModel;
              }
            | {
                __typename?: 'SwitchVirtualDevice';
                UUID: string;
                label: string;
                deviceModel: DeviceModel;
              };
          internetServicePlan?: {
            __typename?: 'InternetServicePlan';
            UUID: string;
            provider?: { __typename?: 'InternetServicePlanProvider'; name: string } | null;
          } | null;
        };
        connectionInfo?: {
          __typename?: 'AutoVPNMemberUplinkConnectionInfo';
          observedAt?: string | null;
          lastHandshakeRx?: string | null;
          lastHandshakeTx?: string | null;
          lastPacketTx?: string | null;
          lastPacketRx?: string | null;
        } | null;
      };
    }> | null;
    routes?: Array<{
      __typename: 'AutoVPNRoute';
      UUID: string;
      name: string;
      isEnabled: boolean;
      dstPrefixLength: number;
      dstGateway: string;
    }> | null;
  };
};

export type AutoVpnMemberQueryQueryVariables = Exact<{
  uuid: Scalars['UUID']['input'];
}>;

export type AutoVpnMemberQueryQuery = {
  __typename?: 'Query';
  autoVPNMember: {
    __typename: 'AutoVPNMember';
    UUID: string;
    networkUUID: string;
    isFailoverEnabled: boolean;
    network: { __typename?: 'Network'; UUID: string; slug: string; label: string };
    permittedVLANs: Array<{
      __typename: 'VLAN';
      UUID: string;
      name: string;
      vlanID: number;
      ipV4ClientGateway?: string | null;
      ipV4ClientPrefixLength?: number | null;
    }>;
    uplink: {
      __typename?: 'AutoVPNMemberUplink';
      UUID: string;
      address: string;
      addressPrefixLength: number;
      hubUplinkUUID: string;
      publicKey: string;
      listenPort: number;
      phyInterfaceUUID: string;
      phyInterface: {
        __typename: 'PhyInterface';
        UUID: string;
        portNumber: number;
        label?: string | null;
        hardwareLabel?: string | null;
        virtualDevice:
          | {
              __typename?: 'AccessPointVirtualDevice';
              UUID: string;
              label: string;
              deviceModel: DeviceModel;
            }
          | {
              __typename?: 'ControllerVirtualDevice';
              UUID: string;
              label: string;
              deviceModel: DeviceModel;
            }
          | {
              __typename?: 'ObserverVirtualDevice';
              UUID: string;
              label: string;
              deviceModel: DeviceModel;
            }
          | {
              __typename?: 'PowerDistributionUnitVirtualDevice';
              UUID: string;
              label: string;
              deviceModel: DeviceModel;
            }
          | {
              __typename?: 'SwitchVirtualDevice';
              UUID: string;
              label: string;
              deviceModel: DeviceModel;
            };
        internetServicePlan?: {
          __typename?: 'InternetServicePlan';
          UUID: string;
          provider?: { __typename?: 'InternetServicePlanProvider'; name: string } | null;
        } | null;
      };
      connectionInfo?: {
        __typename?: 'AutoVPNMemberUplinkConnectionInfo';
        observedAt?: string | null;
        lastHandshakeRx?: string | null;
        lastHandshakeTx?: string | null;
        lastPacketTx?: string | null;
        lastPacketRx?: string | null;
      } | null;
    };
  };
};

export type CreateAutoVpnGroupMutationVariables = Exact<{
  companySlug: Scalars['String']['input'];
  input: CreateAutoVpnGroupInput;
}>;

export type CreateAutoVpnGroupMutation = {
  __typename?: 'Mutation';
  createAutoVPNGroup: {
    __typename?: 'AutoVPNGroup';
    UUID: string;
    companySlug: string;
    isEnabled: boolean;
    name: string;
    hubNetworkUUID: string;
  };
};

export type UpdateAutoVpnGroupMutationVariables = Exact<{
  UUID: Scalars['UUID']['input'];
  input: UpdateAutoVpnGroupInput;
}>;

export type UpdateAutoVpnGroupMutation = {
  __typename?: 'Mutation';
  updateAutoVPNGroup: { __typename?: 'AutoVPNGroup'; UUID: string };
};

export type DeleteAutoVpnGroupMutationVariables = Exact<{
  uuid: Scalars['UUID']['input'];
}>;

export type DeleteAutoVpnGroupMutation = {
  __typename?: 'Mutation';
  deleteAutoVPNGroup: {
    __typename?: 'AutoVPNGroup';
    UUID: string;
    companySlug: string;
    isEnabled: boolean;
    name: string;
    hubNetworkUUID: string;
  };
};

export type AddNetworkToAutoVpnGroupMutationVariables = Exact<{
  groupUUID: Scalars['UUID']['input'];
  input: AddNetworkToAutoVpnGroupInput;
}>;

export type AddNetworkToAutoVpnGroupMutation = {
  __typename?: 'Mutation';
  addNetworkToAutoVPNGroup: { __typename?: 'AutoVPNMember'; UUID: string };
};

export type UpdateAutoVpnMemberMutationVariables = Exact<{
  uuid: Scalars['UUID']['input'];
  input: UpdateAutoVpnMemberInput;
}>;

export type UpdateAutoVpnMemberMutation = {
  __typename?: 'Mutation';
  updateAutoVPNMember: { __typename?: 'AutoVPNMember'; UUID: string };
};

export type RemoveNetworkFromAutoVpnGroupMutationVariables = Exact<{
  groupUUID: Scalars['UUID']['input'];
  networkUUID: Scalars['UUID']['input'];
}>;

export type RemoveNetworkFromAutoVpnGroupMutation = {
  __typename?: 'Mutation';
  removeNetworkFromAutoVPNGroup: boolean;
};

export type CreateAutoVpnRouteMutationVariables = Exact<{
  groupUUID: Scalars['UUID']['input'];
  input: CreateAutoVpnRouteInput;
}>;

export type CreateAutoVpnRouteMutation = {
  __typename?: 'Mutation';
  createAutoVPNRoute: {
    __typename?: 'AutoVPNRoute';
    UUID: string;
    createdAt: string;
    updatedAt: string;
    dstGateway: string;
    dstPrefixLength: number;
  };
};

export type DeleteAutoVpnRouteMutationVariables = Exact<{
  uuid: Scalars['UUID']['input'];
}>;

export type DeleteAutoVpnRouteMutation = {
  __typename?: 'Mutation';
  deleteAutoVPNRoute: { __typename?: 'AutoVPNRoute'; UUID: string };
};

export type NetworksWithControllerPortsQueryVariables = Exact<{
  companySlug: Scalars['String']['input'];
}>;

export type NetworksWithControllerPortsQuery = {
  __typename?: 'Query';
  networksForCompany: Array<{
    __typename?: 'Network';
    UUID: string;
    label: string;
    isActive: boolean;
    isTemplate: boolean;
    virtualDevices: Array<
      | { __typename: 'AccessPointVirtualDevice'; label: string }
      | {
          __typename: 'ControllerVirtualDevice';
          label: string;
          phyInterfaces: Array<{
            __typename: 'PhyInterface';
            UUID: string;
            isUplink: boolean;
            portNumber: number;
            label?: string | null;
            hardwareLabel?: string | null;
            virtualDevice:
              | {
                  __typename?: 'AccessPointVirtualDevice';
                  UUID: string;
                  label: string;
                  deviceModel: DeviceModel;
                }
              | {
                  __typename?: 'ControllerVirtualDevice';
                  UUID: string;
                  label: string;
                  deviceModel: DeviceModel;
                }
              | {
                  __typename?: 'ObserverVirtualDevice';
                  UUID: string;
                  label: string;
                  deviceModel: DeviceModel;
                }
              | {
                  __typename?: 'PowerDistributionUnitVirtualDevice';
                  UUID: string;
                  label: string;
                  deviceModel: DeviceModel;
                }
              | {
                  __typename?: 'SwitchVirtualDevice';
                  UUID: string;
                  label: string;
                  deviceModel: DeviceModel;
                };
            internetServicePlan?: {
              __typename?: 'InternetServicePlan';
              UUID: string;
              provider?: { __typename?: 'InternetServicePlanProvider'; name: string } | null;
            } | null;
          }>;
        }
      | { __typename: 'ObserverVirtualDevice'; label: string }
      | { __typename: 'PowerDistributionUnitVirtualDevice'; label: string }
      | { __typename: 'SwitchVirtualDevice'; label: string }
    >;
  }>;
};

export type GetEventLogsQueryVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  typeFilter?: InputMaybe<Array<EventType> | EventType>;
  virtualDeviceUUIDFilter?: InputMaybe<Array<Scalars['UUID']['input']> | Scalars['UUID']['input']>;
}>;

export type GetEventLogsQuery = {
  __typename?: 'Query';
  recentEventLogEventsPage: {
    __typename?: 'EventLogEventsPage';
    total: number;
    events: Array<{
      __typename: 'EventLogEvent';
      eventType: EventType;
      generatedAt: string;
      networkUUID: string;
      properties:
        | { __typename?: 'AccessPointConnectionProperties' }
        | {
            __typename: 'AccessPointDfsChannelResetProperties';
            opChan: number;
            newOpChan: number;
            fbChan: number;
            virtualDevice?:
              | {
                  __typename: 'AccessPointVirtualDevice';
                  UUID: string;
                  label: string;
                  deviceType: VirtualDeviceType;
                  hardwareDevice?:
                    | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
                    | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
                    | { __typename?: 'PowerDistributionUnitHardwareDevice'; serialNumber: string }
                    | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
                    | null;
                }
              | {
                  __typename: 'ControllerVirtualDevice';
                  UUID: string;
                  label: string;
                  deviceType: VirtualDeviceType;
                  hardwareDevice?:
                    | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
                    | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
                    | { __typename?: 'PowerDistributionUnitHardwareDevice'; serialNumber: string }
                    | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
                    | null;
                }
              | {
                  __typename: 'ObserverVirtualDevice';
                  UUID: string;
                  label: string;
                  deviceType: VirtualDeviceType;
                  hardwareDevice?:
                    | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
                    | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
                    | { __typename?: 'PowerDistributionUnitHardwareDevice'; serialNumber: string }
                    | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
                    | null;
                }
              | {
                  __typename: 'PowerDistributionUnitVirtualDevice';
                  UUID: string;
                  label: string;
                  deviceType: VirtualDeviceType;
                  hardwareDevice?:
                    | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
                    | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
                    | { __typename?: 'PowerDistributionUnitHardwareDevice'; serialNumber: string }
                    | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
                    | null;
                }
              | {
                  __typename: 'SwitchVirtualDevice';
                  UUID: string;
                  label: string;
                  deviceType: VirtualDeviceType;
                  hardwareDevice?:
                    | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
                    | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
                    | { __typename?: 'PowerDistributionUnitHardwareDevice'; serialNumber: string }
                    | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
                    | null;
                }
              | null;
          }
        | {
            __typename: 'AccessPointRadarHitDetectedProperties';
            dfsChannel: number;
            fallbackChannel: number;
            clientsMovedOff: Array<string>;
            virtualDevice?:
              | {
                  __typename: 'AccessPointVirtualDevice';
                  UUID: string;
                  label: string;
                  deviceType: VirtualDeviceType;
                  hardwareDevice?:
                    | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
                    | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
                    | { __typename?: 'PowerDistributionUnitHardwareDevice'; serialNumber: string }
                    | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
                    | null;
                }
              | {
                  __typename: 'ControllerVirtualDevice';
                  UUID: string;
                  label: string;
                  deviceType: VirtualDeviceType;
                  hardwareDevice?:
                    | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
                    | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
                    | { __typename?: 'PowerDistributionUnitHardwareDevice'; serialNumber: string }
                    | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
                    | null;
                }
              | {
                  __typename: 'ObserverVirtualDevice';
                  UUID: string;
                  label: string;
                  deviceType: VirtualDeviceType;
                  hardwareDevice?:
                    | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
                    | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
                    | { __typename?: 'PowerDistributionUnitHardwareDevice'; serialNumber: string }
                    | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
                    | null;
                }
              | {
                  __typename: 'PowerDistributionUnitVirtualDevice';
                  UUID: string;
                  label: string;
                  deviceType: VirtualDeviceType;
                  hardwareDevice?:
                    | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
                    | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
                    | { __typename?: 'PowerDistributionUnitHardwareDevice'; serialNumber: string }
                    | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
                    | null;
                }
              | {
                  __typename: 'SwitchVirtualDevice';
                  UUID: string;
                  label: string;
                  deviceType: VirtualDeviceType;
                  hardwareDevice?:
                    | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
                    | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
                    | { __typename?: 'PowerDistributionUnitHardwareDevice'; serialNumber: string }
                    | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
                    | null;
                }
              | null;
          }
        | {
            __typename: 'DeviceBootProperties';
            bootCount: number;
            buildName: string;
            rebootReason: string;
            virtualDevice?:
              | {
                  __typename: 'AccessPointVirtualDevice';
                  deviceType: VirtualDeviceType;
                  UUID: string;
                  label: string;
                  hardwareDevice?:
                    | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
                    | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
                    | { __typename?: 'PowerDistributionUnitHardwareDevice'; serialNumber: string }
                    | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
                    | null;
                }
              | {
                  __typename: 'ControllerVirtualDevice';
                  deviceType: VirtualDeviceType;
                  UUID: string;
                  label: string;
                  hardwareDevice?:
                    | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
                    | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
                    | { __typename?: 'PowerDistributionUnitHardwareDevice'; serialNumber: string }
                    | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
                    | null;
                }
              | {
                  __typename: 'ObserverVirtualDevice';
                  deviceType: VirtualDeviceType;
                  UUID: string;
                  label: string;
                  hardwareDevice?:
                    | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
                    | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
                    | { __typename?: 'PowerDistributionUnitHardwareDevice'; serialNumber: string }
                    | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
                    | null;
                }
              | {
                  __typename: 'PowerDistributionUnitVirtualDevice';
                  deviceType: VirtualDeviceType;
                  UUID: string;
                  label: string;
                  hardwareDevice?:
                    | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
                    | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
                    | { __typename?: 'PowerDistributionUnitHardwareDevice'; serialNumber: string }
                    | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
                    | null;
                }
              | {
                  __typename: 'SwitchVirtualDevice';
                  deviceType: VirtualDeviceType;
                  UUID: string;
                  label: string;
                  hardwareDevice?:
                    | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
                    | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
                    | { __typename?: 'PowerDistributionUnitHardwareDevice'; serialNumber: string }
                    | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
                    | null;
                }
              | null;
          }
        | {
            __typename: 'DeviceOfflineProperties';
            lastSeen: string;
            virtualDevice?:
              | {
                  __typename: 'AccessPointVirtualDevice';
                  deviceType: VirtualDeviceType;
                  UUID: string;
                  label: string;
                  hardwareDevice?:
                    | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
                    | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
                    | { __typename?: 'PowerDistributionUnitHardwareDevice'; serialNumber: string }
                    | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
                    | null;
                }
              | {
                  __typename: 'ControllerVirtualDevice';
                  deviceType: VirtualDeviceType;
                  UUID: string;
                  label: string;
                  hardwareDevice?:
                    | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
                    | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
                    | { __typename?: 'PowerDistributionUnitHardwareDevice'; serialNumber: string }
                    | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
                    | null;
                }
              | {
                  __typename: 'ObserverVirtualDevice';
                  deviceType: VirtualDeviceType;
                  UUID: string;
                  label: string;
                  hardwareDevice?:
                    | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
                    | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
                    | { __typename?: 'PowerDistributionUnitHardwareDevice'; serialNumber: string }
                    | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
                    | null;
                }
              | {
                  __typename: 'PowerDistributionUnitVirtualDevice';
                  deviceType: VirtualDeviceType;
                  UUID: string;
                  label: string;
                  hardwareDevice?:
                    | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
                    | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
                    | { __typename?: 'PowerDistributionUnitHardwareDevice'; serialNumber: string }
                    | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
                    | null;
                }
              | {
                  __typename: 'SwitchVirtualDevice';
                  deviceType: VirtualDeviceType;
                  UUID: string;
                  label: string;
                  hardwareDevice?:
                    | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
                    | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
                    | { __typename?: 'PowerDistributionUnitHardwareDevice'; serialNumber: string }
                    | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
                    | null;
                }
              | null;
          }
        | {
            __typename: 'DeviceOnlineProperties';
            firstSeen: string;
            virtualDevice?:
              | {
                  __typename: 'AccessPointVirtualDevice';
                  deviceType: VirtualDeviceType;
                  UUID: string;
                  label: string;
                  hardwareDevice?:
                    | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
                    | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
                    | { __typename?: 'PowerDistributionUnitHardwareDevice'; serialNumber: string }
                    | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
                    | null;
                }
              | {
                  __typename: 'ControllerVirtualDevice';
                  deviceType: VirtualDeviceType;
                  UUID: string;
                  label: string;
                  hardwareDevice?:
                    | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
                    | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
                    | { __typename?: 'PowerDistributionUnitHardwareDevice'; serialNumber: string }
                    | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
                    | null;
                }
              | {
                  __typename: 'ObserverVirtualDevice';
                  deviceType: VirtualDeviceType;
                  UUID: string;
                  label: string;
                  hardwareDevice?:
                    | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
                    | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
                    | { __typename?: 'PowerDistributionUnitHardwareDevice'; serialNumber: string }
                    | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
                    | null;
                }
              | {
                  __typename: 'PowerDistributionUnitVirtualDevice';
                  deviceType: VirtualDeviceType;
                  UUID: string;
                  label: string;
                  hardwareDevice?:
                    | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
                    | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
                    | { __typename?: 'PowerDistributionUnitHardwareDevice'; serialNumber: string }
                    | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
                    | null;
                }
              | {
                  __typename: 'SwitchVirtualDevice';
                  deviceType: VirtualDeviceType;
                  UUID: string;
                  label: string;
                  hardwareDevice?:
                    | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
                    | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
                    | { __typename?: 'PowerDistributionUnitHardwareDevice'; serialNumber: string }
                    | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
                    | null;
                }
              | null;
          }
        | {
            __typename: 'FirmwareUpgradeCompletedProperties';
            status: FirmwareUpgradeCompletedStatus;
            completedAt: string;
            successfulVirtualDevices?: Array<
              | {
                  __typename?: 'AccessPointVirtualDevice';
                  UUID: string;
                  label: string;
                  deviceType: VirtualDeviceType;
                  deviceModel: DeviceModel;
                }
              | {
                  __typename?: 'ControllerVirtualDevice';
                  UUID: string;
                  label: string;
                  deviceType: VirtualDeviceType;
                  deviceModel: DeviceModel;
                }
              | {
                  __typename?: 'ObserverVirtualDevice';
                  UUID: string;
                  label: string;
                  deviceType: VirtualDeviceType;
                  deviceModel: DeviceModel;
                }
              | {
                  __typename?: 'PowerDistributionUnitVirtualDevice';
                  UUID: string;
                  label: string;
                  deviceType: VirtualDeviceType;
                  deviceModel: DeviceModel;
                }
              | {
                  __typename?: 'SwitchVirtualDevice';
                  UUID: string;
                  label: string;
                  deviceType: VirtualDeviceType;
                  deviceModel: DeviceModel;
                }
              | null
            > | null;
            failedVirtualDevices?: Array<
              | {
                  __typename?: 'AccessPointVirtualDevice';
                  UUID: string;
                  label: string;
                  deviceType: VirtualDeviceType;
                  deviceModel: DeviceModel;
                }
              | {
                  __typename?: 'ControllerVirtualDevice';
                  UUID: string;
                  label: string;
                  deviceType: VirtualDeviceType;
                  deviceModel: DeviceModel;
                }
              | {
                  __typename?: 'ObserverVirtualDevice';
                  UUID: string;
                  label: string;
                  deviceType: VirtualDeviceType;
                  deviceModel: DeviceModel;
                }
              | {
                  __typename?: 'PowerDistributionUnitVirtualDevice';
                  UUID: string;
                  label: string;
                  deviceType: VirtualDeviceType;
                  deviceModel: DeviceModel;
                }
              | {
                  __typename?: 'SwitchVirtualDevice';
                  UUID: string;
                  label: string;
                  deviceType: VirtualDeviceType;
                  deviceModel: DeviceModel;
                }
              | null
            > | null;
            nosVersion: { __typename?: 'NosVersion'; major: number; minor: number; patch: number };
          }
        | {
            __typename: 'FirmwareUpgradePendingProperties';
            virtualDevices?: Array<
              | {
                  __typename?: 'AccessPointVirtualDevice';
                  UUID: string;
                  label: string;
                  deviceType: VirtualDeviceType;
                  deviceModel: DeviceModel;
                }
              | {
                  __typename?: 'ControllerVirtualDevice';
                  UUID: string;
                  label: string;
                  deviceType: VirtualDeviceType;
                  deviceModel: DeviceModel;
                }
              | {
                  __typename?: 'ObserverVirtualDevice';
                  UUID: string;
                  label: string;
                  deviceType: VirtualDeviceType;
                  deviceModel: DeviceModel;
                }
              | {
                  __typename?: 'PowerDistributionUnitVirtualDevice';
                  UUID: string;
                  label: string;
                  deviceType: VirtualDeviceType;
                  deviceModel: DeviceModel;
                }
              | {
                  __typename?: 'SwitchVirtualDevice';
                  UUID: string;
                  label: string;
                  deviceType: VirtualDeviceType;
                  deviceModel: DeviceModel;
                }
              | null
            > | null;
            nosVersion: { __typename?: 'NosVersion'; major: number; minor: number; patch: number };
          }
        | {
            __typename: 'FirmwareUpgradeScheduledProperties';
            scheduledAt: string;
            virtualDevices?: Array<
              | {
                  __typename?: 'AccessPointVirtualDevice';
                  UUID: string;
                  label: string;
                  deviceType: VirtualDeviceType;
                  deviceModel: DeviceModel;
                }
              | {
                  __typename?: 'ControllerVirtualDevice';
                  UUID: string;
                  label: string;
                  deviceType: VirtualDeviceType;
                  deviceModel: DeviceModel;
                }
              | {
                  __typename?: 'ObserverVirtualDevice';
                  UUID: string;
                  label: string;
                  deviceType: VirtualDeviceType;
                  deviceModel: DeviceModel;
                }
              | {
                  __typename?: 'PowerDistributionUnitVirtualDevice';
                  UUID: string;
                  label: string;
                  deviceType: VirtualDeviceType;
                  deviceModel: DeviceModel;
                }
              | {
                  __typename?: 'SwitchVirtualDevice';
                  UUID: string;
                  label: string;
                  deviceType: VirtualDeviceType;
                  deviceModel: DeviceModel;
                }
              | null
            > | null;
            nosVersion: { __typename?: 'NosVersion'; major: number; minor: number; patch: number };
          }
        | {
            __typename: 'HighAvailabilityFailoverProperties';
            primaryVirtualDevice?:
              | {
                  __typename: 'AccessPointVirtualDevice';
                  UUID: string;
                  label: string;
                  deviceType: VirtualDeviceType;
                  hardwareDevice?:
                    | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
                    | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
                    | { __typename?: 'PowerDistributionUnitHardwareDevice'; serialNumber: string }
                    | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
                    | null;
                }
              | {
                  __typename: 'ControllerVirtualDevice';
                  UUID: string;
                  label: string;
                  deviceType: VirtualDeviceType;
                  hardwareDevice?:
                    | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
                    | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
                    | { __typename?: 'PowerDistributionUnitHardwareDevice'; serialNumber: string }
                    | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
                    | null;
                }
              | {
                  __typename: 'ObserverVirtualDevice';
                  UUID: string;
                  label: string;
                  deviceType: VirtualDeviceType;
                  hardwareDevice?:
                    | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
                    | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
                    | { __typename?: 'PowerDistributionUnitHardwareDevice'; serialNumber: string }
                    | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
                    | null;
                }
              | {
                  __typename: 'PowerDistributionUnitVirtualDevice';
                  UUID: string;
                  label: string;
                  deviceType: VirtualDeviceType;
                  hardwareDevice?:
                    | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
                    | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
                    | { __typename?: 'PowerDistributionUnitHardwareDevice'; serialNumber: string }
                    | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
                    | null;
                }
              | {
                  __typename: 'SwitchVirtualDevice';
                  UUID: string;
                  label: string;
                  deviceType: VirtualDeviceType;
                  hardwareDevice?:
                    | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
                    | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
                    | { __typename?: 'PowerDistributionUnitHardwareDevice'; serialNumber: string }
                    | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
                    | null;
                }
              | null;
            backupVirtualDevice?:
              | {
                  __typename: 'AccessPointVirtualDevice';
                  UUID: string;
                  label: string;
                  deviceType: VirtualDeviceType;
                  hardwareDevice?:
                    | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
                    | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
                    | { __typename?: 'PowerDistributionUnitHardwareDevice'; serialNumber: string }
                    | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
                    | null;
                }
              | {
                  __typename: 'ControllerVirtualDevice';
                  UUID: string;
                  label: string;
                  deviceType: VirtualDeviceType;
                  hardwareDevice?:
                    | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
                    | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
                    | { __typename?: 'PowerDistributionUnitHardwareDevice'; serialNumber: string }
                    | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
                    | null;
                }
              | {
                  __typename: 'ObserverVirtualDevice';
                  UUID: string;
                  label: string;
                  deviceType: VirtualDeviceType;
                  hardwareDevice?:
                    | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
                    | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
                    | { __typename?: 'PowerDistributionUnitHardwareDevice'; serialNumber: string }
                    | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
                    | null;
                }
              | {
                  __typename: 'PowerDistributionUnitVirtualDevice';
                  UUID: string;
                  label: string;
                  deviceType: VirtualDeviceType;
                  hardwareDevice?:
                    | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
                    | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
                    | { __typename?: 'PowerDistributionUnitHardwareDevice'; serialNumber: string }
                    | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
                    | null;
                }
              | {
                  __typename: 'SwitchVirtualDevice';
                  UUID: string;
                  label: string;
                  deviceType: VirtualDeviceType;
                  hardwareDevice?:
                    | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
                    | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
                    | { __typename?: 'PowerDistributionUnitHardwareDevice'; serialNumber: string }
                    | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
                    | null;
                }
              | null;
          }
        | { __typename?: 'HighAvailabilityMultipleActiveProperties' }
        | {
            __typename: 'HighAvailabilityRecoveryProperties';
            primaryVirtualDevice?:
              | {
                  __typename: 'AccessPointVirtualDevice';
                  UUID: string;
                  label: string;
                  deviceType: VirtualDeviceType;
                  hardwareDevice?:
                    | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
                    | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
                    | { __typename?: 'PowerDistributionUnitHardwareDevice'; serialNumber: string }
                    | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
                    | null;
                }
              | {
                  __typename: 'ControllerVirtualDevice';
                  UUID: string;
                  label: string;
                  deviceType: VirtualDeviceType;
                  hardwareDevice?:
                    | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
                    | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
                    | { __typename?: 'PowerDistributionUnitHardwareDevice'; serialNumber: string }
                    | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
                    | null;
                }
              | {
                  __typename: 'ObserverVirtualDevice';
                  UUID: string;
                  label: string;
                  deviceType: VirtualDeviceType;
                  hardwareDevice?:
                    | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
                    | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
                    | { __typename?: 'PowerDistributionUnitHardwareDevice'; serialNumber: string }
                    | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
                    | null;
                }
              | {
                  __typename: 'PowerDistributionUnitVirtualDevice';
                  UUID: string;
                  label: string;
                  deviceType: VirtualDeviceType;
                  hardwareDevice?:
                    | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
                    | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
                    | { __typename?: 'PowerDistributionUnitHardwareDevice'; serialNumber: string }
                    | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
                    | null;
                }
              | {
                  __typename: 'SwitchVirtualDevice';
                  UUID: string;
                  label: string;
                  deviceType: VirtualDeviceType;
                  hardwareDevice?:
                    | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
                    | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
                    | { __typename?: 'PowerDistributionUnitHardwareDevice'; serialNumber: string }
                    | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
                    | null;
                }
              | null;
            backupVirtualDevice?:
              | {
                  __typename: 'AccessPointVirtualDevice';
                  UUID: string;
                  label: string;
                  deviceType: VirtualDeviceType;
                  hardwareDevice?:
                    | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
                    | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
                    | { __typename?: 'PowerDistributionUnitHardwareDevice'; serialNumber: string }
                    | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
                    | null;
                }
              | {
                  __typename: 'ControllerVirtualDevice';
                  UUID: string;
                  label: string;
                  deviceType: VirtualDeviceType;
                  hardwareDevice?:
                    | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
                    | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
                    | { __typename?: 'PowerDistributionUnitHardwareDevice'; serialNumber: string }
                    | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
                    | null;
                }
              | {
                  __typename: 'ObserverVirtualDevice';
                  UUID: string;
                  label: string;
                  deviceType: VirtualDeviceType;
                  hardwareDevice?:
                    | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
                    | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
                    | { __typename?: 'PowerDistributionUnitHardwareDevice'; serialNumber: string }
                    | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
                    | null;
                }
              | {
                  __typename: 'PowerDistributionUnitVirtualDevice';
                  UUID: string;
                  label: string;
                  deviceType: VirtualDeviceType;
                  hardwareDevice?:
                    | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
                    | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
                    | { __typename?: 'PowerDistributionUnitHardwareDevice'; serialNumber: string }
                    | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
                    | null;
                }
              | {
                  __typename: 'SwitchVirtualDevice';
                  UUID: string;
                  label: string;
                  deviceType: VirtualDeviceType;
                  hardwareDevice?:
                    | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
                    | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
                    | { __typename?: 'PowerDistributionUnitHardwareDevice'; serialNumber: string }
                    | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
                    | null;
                }
              | null;
          }
        | {
            __typename: 'IPSecTunnelStatusChangeProperties';
            saStatus?: IpSecSaStatus | null;
            childSAStatus?: IpSecChildSaStatus | null;
            ipSecTunnel: { __typename?: 'IPSecTunnel'; UUID: string; name: string };
          }
        | {
            __typename: 'PDUOutletProperties';
            outletNum: number;
            outletEnabled: boolean;
            virtualDevice?:
              | {
                  __typename: 'AccessPointVirtualDevice';
                  UUID: string;
                  label: string;
                  deviceType: VirtualDeviceType;
                  hardwareDevice?:
                    | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
                    | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
                    | { __typename?: 'PowerDistributionUnitHardwareDevice'; serialNumber: string }
                    | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
                    | null;
                }
              | {
                  __typename: 'ControllerVirtualDevice';
                  UUID: string;
                  label: string;
                  deviceType: VirtualDeviceType;
                  hardwareDevice?:
                    | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
                    | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
                    | { __typename?: 'PowerDistributionUnitHardwareDevice'; serialNumber: string }
                    | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
                    | null;
                }
              | {
                  __typename: 'ObserverVirtualDevice';
                  UUID: string;
                  label: string;
                  deviceType: VirtualDeviceType;
                  hardwareDevice?:
                    | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
                    | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
                    | { __typename?: 'PowerDistributionUnitHardwareDevice'; serialNumber: string }
                    | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
                    | null;
                }
              | {
                  __typename: 'PowerDistributionUnitVirtualDevice';
                  UUID: string;
                  label: string;
                  deviceType: VirtualDeviceType;
                  hardwareDevice?:
                    | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
                    | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
                    | { __typename?: 'PowerDistributionUnitHardwareDevice'; serialNumber: string }
                    | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
                    | null;
                }
              | {
                  __typename: 'SwitchVirtualDevice';
                  UUID: string;
                  label: string;
                  deviceType: VirtualDeviceType;
                  hardwareDevice?:
                    | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
                    | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
                    | { __typename?: 'PowerDistributionUnitHardwareDevice'; serialNumber: string }
                    | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
                    | null;
                }
              | null;
          }
        | {
            __typename: 'WANDownProperties';
            virtualDevice?:
              | {
                  __typename: 'AccessPointVirtualDevice';
                  deviceType: VirtualDeviceType;
                  UUID: string;
                  label: string;
                  hardwareDevice?:
                    | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
                    | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
                    | { __typename?: 'PowerDistributionUnitHardwareDevice'; serialNumber: string }
                    | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
                    | null;
                }
              | {
                  __typename: 'ControllerVirtualDevice';
                  deviceType: VirtualDeviceType;
                  UUID: string;
                  label: string;
                  phyInterfaces: Array<{
                    __typename?: 'PhyInterface';
                    UUID: string;
                    portNumber: number;
                    uplinkPriority?: number | null;
                    isUplink: boolean;
                  }>;
                  hardwareDevice?:
                    | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
                    | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
                    | { __typename?: 'PowerDistributionUnitHardwareDevice'; serialNumber: string }
                    | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
                    | null;
                }
              | {
                  __typename: 'ObserverVirtualDevice';
                  deviceType: VirtualDeviceType;
                  UUID: string;
                  label: string;
                  hardwareDevice?:
                    | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
                    | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
                    | { __typename?: 'PowerDistributionUnitHardwareDevice'; serialNumber: string }
                    | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
                    | null;
                }
              | {
                  __typename: 'PowerDistributionUnitVirtualDevice';
                  deviceType: VirtualDeviceType;
                  UUID: string;
                  label: string;
                  hardwareDevice?:
                    | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
                    | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
                    | { __typename?: 'PowerDistributionUnitHardwareDevice'; serialNumber: string }
                    | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
                    | null;
                }
              | {
                  __typename: 'SwitchVirtualDevice';
                  deviceType: VirtualDeviceType;
                  UUID: string;
                  label: string;
                  hardwareDevice?:
                    | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
                    | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
                    | { __typename?: 'PowerDistributionUnitHardwareDevice'; serialNumber: string }
                    | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
                    | null;
                }
              | null;
          }
        | {
            __typename: 'WANStatusChangeProperties';
            virtualDevice?:
              | {
                  __typename: 'AccessPointVirtualDevice';
                  deviceType: VirtualDeviceType;
                  UUID: string;
                  label: string;
                }
              | {
                  __typename: 'ControllerVirtualDevice';
                  deviceType: VirtualDeviceType;
                  UUID: string;
                  label: string;
                  phyInterfaces: Array<{
                    __typename?: 'PhyInterface';
                    UUID: string;
                    label?: string | null;
                    isUplink: boolean;
                    portNumber: number;
                    uplinkPriority?: number | null;
                  }>;
                }
              | {
                  __typename: 'ObserverVirtualDevice';
                  deviceType: VirtualDeviceType;
                  UUID: string;
                  label: string;
                }
              | {
                  __typename: 'PowerDistributionUnitVirtualDevice';
                  deviceType: VirtualDeviceType;
                  UUID: string;
                  label: string;
                }
              | {
                  __typename: 'SwitchVirtualDevice';
                  deviceType: VirtualDeviceType;
                  UUID: string;
                  label: string;
                }
              | null;
            activeWANConnections: Array<{
              __typename?: 'WANConnection';
              externalAddresses: Array<string>;
              port: number;
              internetServicePlanProvider?: {
                __typename?: 'InternetServicePlanProvider';
                name: string;
              } | null;
            } | null>;
          }
        | {
            __typename: 'WANUpProperties';
            virtualDevice?:
              | {
                  __typename: 'AccessPointVirtualDevice';
                  deviceType: VirtualDeviceType;
                  UUID: string;
                  label: string;
                  hardwareDevice?:
                    | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
                    | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
                    | { __typename?: 'PowerDistributionUnitHardwareDevice'; serialNumber: string }
                    | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
                    | null;
                }
              | {
                  __typename: 'ControllerVirtualDevice';
                  deviceType: VirtualDeviceType;
                  UUID: string;
                  label: string;
                  phyInterfaces: Array<{
                    __typename?: 'PhyInterface';
                    UUID: string;
                    portNumber: number;
                    uplinkPriority?: number | null;
                    isUplink: boolean;
                  }>;
                  hardwareDevice?:
                    | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
                    | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
                    | { __typename?: 'PowerDistributionUnitHardwareDevice'; serialNumber: string }
                    | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
                    | null;
                }
              | {
                  __typename: 'ObserverVirtualDevice';
                  deviceType: VirtualDeviceType;
                  UUID: string;
                  label: string;
                  hardwareDevice?:
                    | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
                    | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
                    | { __typename?: 'PowerDistributionUnitHardwareDevice'; serialNumber: string }
                    | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
                    | null;
                }
              | {
                  __typename: 'PowerDistributionUnitVirtualDevice';
                  deviceType: VirtualDeviceType;
                  UUID: string;
                  label: string;
                  hardwareDevice?:
                    | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
                    | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
                    | { __typename?: 'PowerDistributionUnitHardwareDevice'; serialNumber: string }
                    | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
                    | null;
                }
              | {
                  __typename: 'SwitchVirtualDevice';
                  deviceType: VirtualDeviceType;
                  UUID: string;
                  label: string;
                  hardwareDevice?:
                    | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
                    | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
                    | { __typename?: 'PowerDistributionUnitHardwareDevice'; serialNumber: string }
                    | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
                    | null;
                }
              | null;
          };
    }>;
  };
};

export type NetworkClientsQueryVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
  filter?: InputMaybe<NetworkClientsFilter>;
}>;

export type NetworkClientsQuery = {
  __typename?: 'Query';
  networkClients: Array<{
    __typename?: 'NetworkClient';
    alias?: string | null;
    apLocation?: string | null;
    apSerialNumber?: string | null;
    channel?: number | null;
    clientName?: string | null;
    ip: string;
    isWireless: boolean;
    isBlocked: boolean;
    lastSeen: string;
    dhcpLeaseExpiresAt?: string | null;
    macAddress: string;
    noise?: number | null;
    radioBand?: RadioBand | null;
    totalRxBytes?: number | null;
    rxRate?: number | null;
    signal?: number | null;
    ssid?: string | null;
    txRate?: number | null;
    totalTxBytes?: number | null;
    vlan?: string | null;
    vlanUUID?: string | null;
    hwMode?: NetworkClientHwMode | null;
    numSpatialStreams?: number | null;
    associatedAt?: string | null;
    serviceTypes?: Array<ServiceType> | null;
    wirelessScore?: number | null;
    apVirtualDevice?: {
      __typename: 'AccessPointVirtualDevice';
      UUID: string;
      label: string;
      deviceModel: DeviceModel;
    } | null;
    observerVirtualDevice?: {
      __typename?: 'ObserverVirtualDevice';
      UUID: string;
      label: string;
    } | null;
    connectedVLAN?: {
      __typename?: 'VLAN';
      UUID: string;
      name: string;
      vlanID: number;
      dhcpRule?: { __typename?: 'DHCPRule'; UUID: string } | null;
    } | null;
    connectedSSID?: { __typename?: 'SSID'; UUID: string; ssid: string } | null;
    phyInterfaceConnectedTo?: {
      __typename: 'PhyInterface';
      UUID: string;
      portNumber: number;
      label?: string | null;
      hardwareLabel?: string | null;
      virtualDevice:
        | {
            __typename?: 'AccessPointVirtualDevice';
            UUID: string;
            label: string;
            deviceModel: DeviceModel;
          }
        | {
            __typename?: 'ControllerVirtualDevice';
            UUID: string;
            label: string;
            deviceModel: DeviceModel;
          }
        | {
            __typename?: 'ObserverVirtualDevice';
            UUID: string;
            label: string;
            deviceModel: DeviceModel;
          }
        | {
            __typename?: 'PowerDistributionUnitVirtualDevice';
            UUID: string;
            label: string;
            deviceModel: DeviceModel;
          }
        | {
            __typename?: 'SwitchVirtualDevice';
            UUID: string;
            label: string;
            deviceModel: DeviceModel;
          };
      internetServicePlan?: {
        __typename?: 'InternetServicePlan';
        UUID: string;
        provider?: { __typename?: 'InternetServicePlanProvider'; name: string } | null;
      } | null;
    } | null;
    throughput?: {
      __typename?: 'NetworkClientThroughput';
      txRate?: number | null;
      rxRate?: number | null;
    } | null;
    staticMapping?: {
      __typename?: 'DHCPStaticMapping';
      UUID: string;
      name?: string | null;
      macAddress: string;
      ipAddress?: string | null;
      hostname?: string | null;
    } | null;
  }>;
};

export type GetCaptivePortalQueryVariables = Exact<{
  vlanUUID: Scalars['UUID']['input'];
}>;

export type GetCaptivePortalQuery = {
  __typename?: 'Query';
  captivePortalForVLAN?: {
    __typename?: 'CaptivePortal';
    logoImageURL?: string | null;
    redirectURL?: string | null;
    termsAndConditions?: string | null;
    displaySettings?: {
      __typename?: 'CaptivePortalDisplaySettings';
      fontColor?: string | null;
    } | null;
    vlans?: Array<{ __typename?: 'VLAN'; UUID: string }> | null;
  } | null;
};

export type GetNetworkClientsTxRxPerDayQueryVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
  numDaysLookback: Scalars['Int']['input'];
}>;

export type GetNetworkClientsTxRxPerDayQuery = {
  __typename?: 'Query';
  networkClientsTxRxPerDay: Array<{
    __typename?: 'NetworkClientTxRxPerDay';
    ip: string;
    macAddress: string;
    dateString: string;
    txBytes: number;
    rxBytes: number;
  }>;
};

export type CompanyQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;

export type CompanyQuery = {
  __typename?: 'Query';
  getCompany?: {
    __typename?: 'Company';
    uuid: string;
    name: string;
    slug: string;
    isCustomer: boolean;
    supportGroup?: number | null;
    websiteDomain?: string | null;
  } | null;
};

export type GetKeyValueQueryVariables = Exact<{
  key: Scalars['String']['input'];
}>;

export type GetKeyValueQuery = { __typename?: 'Query'; getKeyValue?: string | null };

export type SetKeyValueMutationVariables = Exact<{
  key: Scalars['String']['input'];
  value?: InputMaybe<Scalars['JSON']['input']>;
}>;

export type SetKeyValueMutation = { __typename?: 'Mutation'; setKeyValue?: string | null };

export type NetworkStatusQueryQueryVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
}>;

export type NetworkStatusQueryQuery = {
  __typename?: 'Query';
  virtualDevicesForNetwork: Array<
    | {
        __typename?: 'AccessPointVirtualDevice';
        UUID: string;
        label: string;
        description?: string | null;
        deviceModel: DeviceModel;
        hardwareDevice?:
          | {
              __typename?: 'AccessPointHardwareDevice';
              serialNumber: string;
              macAddress?: string | null;
              isConnectedToBackend: boolean;
            }
          | {
              __typename?: 'ControllerHardwareDevice';
              serialNumber: string;
              macAddress?: string | null;
              isConnectedToBackend: boolean;
            }
          | {
              __typename?: 'PowerDistributionUnitHardwareDevice';
              serialNumber: string;
              macAddress?: string | null;
              isConnectedToBackend: boolean;
            }
          | {
              __typename?: 'SwitchHardwareDevice';
              serialNumber: string;
              macAddress?: string | null;
              isConnectedToBackend: boolean;
            }
          | null;
      }
    | {
        __typename?: 'ControllerVirtualDevice';
        UUID: string;
        label: string;
        description?: string | null;
        deviceModel: DeviceModel;
        hardwareDevice?:
          | {
              __typename?: 'AccessPointHardwareDevice';
              serialNumber: string;
              macAddress?: string | null;
              isConnectedToBackend: boolean;
            }
          | {
              __typename?: 'ControllerHardwareDevice';
              serialNumber: string;
              macAddress?: string | null;
              isConnectedToBackend: boolean;
            }
          | {
              __typename?: 'PowerDistributionUnitHardwareDevice';
              serialNumber: string;
              macAddress?: string | null;
              isConnectedToBackend: boolean;
            }
          | {
              __typename?: 'SwitchHardwareDevice';
              serialNumber: string;
              macAddress?: string | null;
              isConnectedToBackend: boolean;
            }
          | null;
      }
    | {
        __typename?: 'ObserverVirtualDevice';
        UUID: string;
        label: string;
        description?: string | null;
        deviceModel: DeviceModel;
        hardwareDevice?:
          | {
              __typename?: 'AccessPointHardwareDevice';
              serialNumber: string;
              macAddress?: string | null;
              isConnectedToBackend: boolean;
            }
          | {
              __typename?: 'ControllerHardwareDevice';
              serialNumber: string;
              macAddress?: string | null;
              isConnectedToBackend: boolean;
            }
          | {
              __typename?: 'PowerDistributionUnitHardwareDevice';
              serialNumber: string;
              macAddress?: string | null;
              isConnectedToBackend: boolean;
            }
          | {
              __typename?: 'SwitchHardwareDevice';
              serialNumber: string;
              macAddress?: string | null;
              isConnectedToBackend: boolean;
            }
          | null;
      }
    | {
        __typename?: 'PowerDistributionUnitVirtualDevice';
        UUID: string;
        label: string;
        description?: string | null;
        deviceModel: DeviceModel;
        hardwareDevice?:
          | {
              __typename?: 'AccessPointHardwareDevice';
              serialNumber: string;
              macAddress?: string | null;
              isConnectedToBackend: boolean;
            }
          | {
              __typename?: 'ControllerHardwareDevice';
              serialNumber: string;
              macAddress?: string | null;
              isConnectedToBackend: boolean;
            }
          | {
              __typename?: 'PowerDistributionUnitHardwareDevice';
              serialNumber: string;
              macAddress?: string | null;
              isConnectedToBackend: boolean;
            }
          | {
              __typename?: 'SwitchHardwareDevice';
              serialNumber: string;
              macAddress?: string | null;
              isConnectedToBackend: boolean;
            }
          | null;
      }
    | {
        __typename?: 'SwitchVirtualDevice';
        UUID: string;
        label: string;
        description?: string | null;
        deviceModel: DeviceModel;
        hardwareDevice?:
          | {
              __typename?: 'AccessPointHardwareDevice';
              serialNumber: string;
              macAddress?: string | null;
              isConnectedToBackend: boolean;
            }
          | {
              __typename?: 'ControllerHardwareDevice';
              serialNumber: string;
              macAddress?: string | null;
              isConnectedToBackend: boolean;
            }
          | {
              __typename?: 'PowerDistributionUnitHardwareDevice';
              serialNumber: string;
              macAddress?: string | null;
              isConnectedToBackend: boolean;
            }
          | {
              __typename?: 'SwitchHardwareDevice';
              serialNumber: string;
              macAddress?: string | null;
              isConnectedToBackend: boolean;
            }
          | null;
      }
  >;
};

export type NetworkForCompanyFieldsFragment = {
  __typename?: 'Network';
  UUID: string;
  label: string;
  slug: string;
  isActive: boolean;
  isCustomer: boolean;
  isTemplate: boolean;
  isTrial: boolean;
  trialExpiresAt?: string | null;
  deactivatedAt?: string | null;
  goLiveAt?: string | null;
  enabledServiceDiscoveryTypes: Array<ServiceType>;
  pinnedNOSVersionID: number;
  company?: {
    __typename?: 'Company';
    slug: string;
    name: string;
    uuid: string;
    supportGroup?: number | null;
  } | null;
  virtualDevices: Array<
    | {
        __typename: 'AccessPointVirtualDevice';
        UUID: string;
        label: string;
        deviceModel: DeviceModel;
        deviceType: VirtualDeviceType;
        hardwareDevice?:
          | {
              __typename?: 'AccessPointHardwareDevice';
              serialNumber: string;
              isActive: boolean;
              isSpare: boolean;
              isConnectedToBackend: boolean;
            }
          | {
              __typename?: 'ControllerHardwareDevice';
              serialNumber: string;
              isActive: boolean;
              isSpare: boolean;
              isConnectedToBackend: boolean;
            }
          | {
              __typename?: 'PowerDistributionUnitHardwareDevice';
              serialNumber: string;
              isActive: boolean;
              isSpare: boolean;
              isConnectedToBackend: boolean;
            }
          | {
              __typename?: 'SwitchHardwareDevice';
              serialNumber: string;
              isActive: boolean;
              isSpare: boolean;
              isConnectedToBackend: boolean;
            }
          | null;
      }
    | {
        __typename: 'ControllerVirtualDevice';
        UUID: string;
        label: string;
        deviceModel: DeviceModel;
        deviceType: VirtualDeviceType;
        highAvailability?: {
          __typename?: 'HighAvailabilityControllerVirtualDeviceInfo';
          role: HighAvailabilityControllerRole;
          status: HighAvailabilityStatus;
        } | null;
        hardwareDevice?:
          | {
              __typename?: 'AccessPointHardwareDevice';
              serialNumber: string;
              isActive: boolean;
              isSpare: boolean;
              isConnectedToBackend: boolean;
            }
          | {
              __typename?: 'ControllerHardwareDevice';
              serialNumber: string;
              isActive: boolean;
              isSpare: boolean;
              isConnectedToBackend: boolean;
            }
          | {
              __typename?: 'PowerDistributionUnitHardwareDevice';
              serialNumber: string;
              isActive: boolean;
              isSpare: boolean;
              isConnectedToBackend: boolean;
            }
          | {
              __typename?: 'SwitchHardwareDevice';
              serialNumber: string;
              isActive: boolean;
              isSpare: boolean;
              isConnectedToBackend: boolean;
            }
          | null;
      }
    | {
        __typename: 'ObserverVirtualDevice';
        UUID: string;
        label: string;
        deviceModel: DeviceModel;
        deviceType: VirtualDeviceType;
        hardwareDevice?:
          | {
              __typename?: 'AccessPointHardwareDevice';
              serialNumber: string;
              isActive: boolean;
              isSpare: boolean;
              isConnectedToBackend: boolean;
            }
          | {
              __typename?: 'ControllerHardwareDevice';
              serialNumber: string;
              isActive: boolean;
              isSpare: boolean;
              isConnectedToBackend: boolean;
            }
          | {
              __typename?: 'PowerDistributionUnitHardwareDevice';
              serialNumber: string;
              isActive: boolean;
              isSpare: boolean;
              isConnectedToBackend: boolean;
            }
          | {
              __typename?: 'SwitchHardwareDevice';
              serialNumber: string;
              isActive: boolean;
              isSpare: boolean;
              isConnectedToBackend: boolean;
            }
          | null;
      }
    | {
        __typename: 'PowerDistributionUnitVirtualDevice';
        UUID: string;
        label: string;
        deviceModel: DeviceModel;
        deviceType: VirtualDeviceType;
        hardwareDevice?:
          | {
              __typename?: 'AccessPointHardwareDevice';
              serialNumber: string;
              isActive: boolean;
              isSpare: boolean;
              isConnectedToBackend: boolean;
            }
          | {
              __typename?: 'ControllerHardwareDevice';
              serialNumber: string;
              isActive: boolean;
              isSpare: boolean;
              isConnectedToBackend: boolean;
            }
          | {
              __typename?: 'PowerDistributionUnitHardwareDevice';
              serialNumber: string;
              isActive: boolean;
              isSpare: boolean;
              isConnectedToBackend: boolean;
            }
          | {
              __typename?: 'SwitchHardwareDevice';
              serialNumber: string;
              isActive: boolean;
              isSpare: boolean;
              isConnectedToBackend: boolean;
            }
          | null;
      }
    | {
        __typename: 'SwitchVirtualDevice';
        UUID: string;
        label: string;
        deviceModel: DeviceModel;
        deviceType: VirtualDeviceType;
        hardwareDevice?:
          | {
              __typename?: 'AccessPointHardwareDevice';
              serialNumber: string;
              isActive: boolean;
              isSpare: boolean;
              isConnectedToBackend: boolean;
            }
          | {
              __typename?: 'ControllerHardwareDevice';
              serialNumber: string;
              isActive: boolean;
              isSpare: boolean;
              isConnectedToBackend: boolean;
            }
          | {
              __typename?: 'PowerDistributionUnitHardwareDevice';
              serialNumber: string;
              isActive: boolean;
              isSpare: boolean;
              isConnectedToBackend: boolean;
            }
          | {
              __typename?: 'SwitchHardwareDevice';
              serialNumber: string;
              isActive: boolean;
              isSpare: boolean;
              isConnectedToBackend: boolean;
            }
          | null;
      }
  >;
  mailingAddress?: {
    __typename?: 'MailingAddress';
    line1?: string | null;
    line2?: string | null;
    city?: string | null;
    subdivisionCode?: string | null;
    postalCode?: string | null;
    timezone: string;
    countryISO2?: string | null;
  } | null;
  pinnedNOSVersion: {
    __typename?: 'NosVersion';
    major: number;
    minor: number;
    patch: number;
    version?: string;
    isDefault?: boolean;
  };
};

export type NetworksForCompanyQueryVariables = Exact<{
  companySlug: Scalars['String']['input'];
  includePinnedNOSVersionInfo?: Scalars['Boolean']['input'];
}>;

export type NetworksForCompanyQuery = {
  __typename?: 'Query';
  networksForCompany: Array<{
    __typename?: 'Network';
    UUID: string;
    label: string;
    slug: string;
    isActive: boolean;
    isCustomer: boolean;
    isTemplate: boolean;
    isTrial: boolean;
    trialExpiresAt?: string | null;
    deactivatedAt?: string | null;
    goLiveAt?: string | null;
    enabledServiceDiscoveryTypes: Array<ServiceType>;
    pinnedNOSVersionID: number;
    company?: {
      __typename?: 'Company';
      slug: string;
      name: string;
      uuid: string;
      supportGroup?: number | null;
    } | null;
    virtualDevices: Array<
      | {
          __typename: 'AccessPointVirtualDevice';
          UUID: string;
          label: string;
          deviceModel: DeviceModel;
          deviceType: VirtualDeviceType;
          hardwareDevice?:
            | {
                __typename?: 'AccessPointHardwareDevice';
                serialNumber: string;
                isActive: boolean;
                isSpare: boolean;
                isConnectedToBackend: boolean;
              }
            | {
                __typename?: 'ControllerHardwareDevice';
                serialNumber: string;
                isActive: boolean;
                isSpare: boolean;
                isConnectedToBackend: boolean;
              }
            | {
                __typename?: 'PowerDistributionUnitHardwareDevice';
                serialNumber: string;
                isActive: boolean;
                isSpare: boolean;
                isConnectedToBackend: boolean;
              }
            | {
                __typename?: 'SwitchHardwareDevice';
                serialNumber: string;
                isActive: boolean;
                isSpare: boolean;
                isConnectedToBackend: boolean;
              }
            | null;
        }
      | {
          __typename: 'ControllerVirtualDevice';
          UUID: string;
          label: string;
          deviceModel: DeviceModel;
          deviceType: VirtualDeviceType;
          highAvailability?: {
            __typename?: 'HighAvailabilityControllerVirtualDeviceInfo';
            role: HighAvailabilityControllerRole;
            status: HighAvailabilityStatus;
          } | null;
          hardwareDevice?:
            | {
                __typename?: 'AccessPointHardwareDevice';
                serialNumber: string;
                isActive: boolean;
                isSpare: boolean;
                isConnectedToBackend: boolean;
              }
            | {
                __typename?: 'ControllerHardwareDevice';
                serialNumber: string;
                isActive: boolean;
                isSpare: boolean;
                isConnectedToBackend: boolean;
              }
            | {
                __typename?: 'PowerDistributionUnitHardwareDevice';
                serialNumber: string;
                isActive: boolean;
                isSpare: boolean;
                isConnectedToBackend: boolean;
              }
            | {
                __typename?: 'SwitchHardwareDevice';
                serialNumber: string;
                isActive: boolean;
                isSpare: boolean;
                isConnectedToBackend: boolean;
              }
            | null;
        }
      | {
          __typename: 'ObserverVirtualDevice';
          UUID: string;
          label: string;
          deviceModel: DeviceModel;
          deviceType: VirtualDeviceType;
          hardwareDevice?:
            | {
                __typename?: 'AccessPointHardwareDevice';
                serialNumber: string;
                isActive: boolean;
                isSpare: boolean;
                isConnectedToBackend: boolean;
              }
            | {
                __typename?: 'ControllerHardwareDevice';
                serialNumber: string;
                isActive: boolean;
                isSpare: boolean;
                isConnectedToBackend: boolean;
              }
            | {
                __typename?: 'PowerDistributionUnitHardwareDevice';
                serialNumber: string;
                isActive: boolean;
                isSpare: boolean;
                isConnectedToBackend: boolean;
              }
            | {
                __typename?: 'SwitchHardwareDevice';
                serialNumber: string;
                isActive: boolean;
                isSpare: boolean;
                isConnectedToBackend: boolean;
              }
            | null;
        }
      | {
          __typename: 'PowerDistributionUnitVirtualDevice';
          UUID: string;
          label: string;
          deviceModel: DeviceModel;
          deviceType: VirtualDeviceType;
          hardwareDevice?:
            | {
                __typename?: 'AccessPointHardwareDevice';
                serialNumber: string;
                isActive: boolean;
                isSpare: boolean;
                isConnectedToBackend: boolean;
              }
            | {
                __typename?: 'ControllerHardwareDevice';
                serialNumber: string;
                isActive: boolean;
                isSpare: boolean;
                isConnectedToBackend: boolean;
              }
            | {
                __typename?: 'PowerDistributionUnitHardwareDevice';
                serialNumber: string;
                isActive: boolean;
                isSpare: boolean;
                isConnectedToBackend: boolean;
              }
            | {
                __typename?: 'SwitchHardwareDevice';
                serialNumber: string;
                isActive: boolean;
                isSpare: boolean;
                isConnectedToBackend: boolean;
              }
            | null;
        }
      | {
          __typename: 'SwitchVirtualDevice';
          UUID: string;
          label: string;
          deviceModel: DeviceModel;
          deviceType: VirtualDeviceType;
          hardwareDevice?:
            | {
                __typename?: 'AccessPointHardwareDevice';
                serialNumber: string;
                isActive: boolean;
                isSpare: boolean;
                isConnectedToBackend: boolean;
              }
            | {
                __typename?: 'ControllerHardwareDevice';
                serialNumber: string;
                isActive: boolean;
                isSpare: boolean;
                isConnectedToBackend: boolean;
              }
            | {
                __typename?: 'PowerDistributionUnitHardwareDevice';
                serialNumber: string;
                isActive: boolean;
                isSpare: boolean;
                isConnectedToBackend: boolean;
              }
            | {
                __typename?: 'SwitchHardwareDevice';
                serialNumber: string;
                isActive: boolean;
                isSpare: boolean;
                isConnectedToBackend: boolean;
              }
            | null;
        }
    >;
    mailingAddress?: {
      __typename?: 'MailingAddress';
      line1?: string | null;
      line2?: string | null;
      city?: string | null;
      subdivisionCode?: string | null;
      postalCode?: string | null;
      timezone: string;
      countryISO2?: string | null;
    } | null;
    pinnedNOSVersion: {
      __typename?: 'NosVersion';
      major: number;
      minor: number;
      patch: number;
      version?: string;
      isDefault?: boolean;
    };
  }>;
};

export type NetworkByUuidQueryQueryVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
  includePinnedNOSVersionInfo?: Scalars['Boolean']['input'];
}>;

export type NetworkByUuidQueryQuery = {
  __typename?: 'Query';
  network: {
    __typename?: 'Network';
    UUID: string;
    label: string;
    slug: string;
    isActive: boolean;
    isCustomer: boolean;
    isTemplate: boolean;
    isTrial: boolean;
    trialExpiresAt?: string | null;
    deactivatedAt?: string | null;
    goLiveAt?: string | null;
    enabledServiceDiscoveryTypes: Array<ServiceType>;
    pinnedNOSVersionID: number;
    company?: {
      __typename?: 'Company';
      slug: string;
      name: string;
      uuid: string;
      supportGroup?: number | null;
    } | null;
    virtualDevices: Array<
      | {
          __typename: 'AccessPointVirtualDevice';
          UUID: string;
          label: string;
          deviceModel: DeviceModel;
          deviceType: VirtualDeviceType;
          hardwareDevice?:
            | {
                __typename?: 'AccessPointHardwareDevice';
                serialNumber: string;
                isActive: boolean;
                isSpare: boolean;
                isConnectedToBackend: boolean;
              }
            | {
                __typename?: 'ControllerHardwareDevice';
                serialNumber: string;
                isActive: boolean;
                isSpare: boolean;
                isConnectedToBackend: boolean;
              }
            | {
                __typename?: 'PowerDistributionUnitHardwareDevice';
                serialNumber: string;
                isActive: boolean;
                isSpare: boolean;
                isConnectedToBackend: boolean;
              }
            | {
                __typename?: 'SwitchHardwareDevice';
                serialNumber: string;
                isActive: boolean;
                isSpare: boolean;
                isConnectedToBackend: boolean;
              }
            | null;
        }
      | {
          __typename: 'ControllerVirtualDevice';
          UUID: string;
          label: string;
          deviceModel: DeviceModel;
          deviceType: VirtualDeviceType;
          highAvailability?: {
            __typename?: 'HighAvailabilityControllerVirtualDeviceInfo';
            role: HighAvailabilityControllerRole;
            status: HighAvailabilityStatus;
          } | null;
          hardwareDevice?:
            | {
                __typename?: 'AccessPointHardwareDevice';
                serialNumber: string;
                isActive: boolean;
                isSpare: boolean;
                isConnectedToBackend: boolean;
              }
            | {
                __typename?: 'ControllerHardwareDevice';
                serialNumber: string;
                isActive: boolean;
                isSpare: boolean;
                isConnectedToBackend: boolean;
              }
            | {
                __typename?: 'PowerDistributionUnitHardwareDevice';
                serialNumber: string;
                isActive: boolean;
                isSpare: boolean;
                isConnectedToBackend: boolean;
              }
            | {
                __typename?: 'SwitchHardwareDevice';
                serialNumber: string;
                isActive: boolean;
                isSpare: boolean;
                isConnectedToBackend: boolean;
              }
            | null;
        }
      | {
          __typename: 'ObserverVirtualDevice';
          UUID: string;
          label: string;
          deviceModel: DeviceModel;
          deviceType: VirtualDeviceType;
          hardwareDevice?:
            | {
                __typename?: 'AccessPointHardwareDevice';
                serialNumber: string;
                isActive: boolean;
                isSpare: boolean;
                isConnectedToBackend: boolean;
              }
            | {
                __typename?: 'ControllerHardwareDevice';
                serialNumber: string;
                isActive: boolean;
                isSpare: boolean;
                isConnectedToBackend: boolean;
              }
            | {
                __typename?: 'PowerDistributionUnitHardwareDevice';
                serialNumber: string;
                isActive: boolean;
                isSpare: boolean;
                isConnectedToBackend: boolean;
              }
            | {
                __typename?: 'SwitchHardwareDevice';
                serialNumber: string;
                isActive: boolean;
                isSpare: boolean;
                isConnectedToBackend: boolean;
              }
            | null;
        }
      | {
          __typename: 'PowerDistributionUnitVirtualDevice';
          UUID: string;
          label: string;
          deviceModel: DeviceModel;
          deviceType: VirtualDeviceType;
          hardwareDevice?:
            | {
                __typename?: 'AccessPointHardwareDevice';
                serialNumber: string;
                isActive: boolean;
                isSpare: boolean;
                isConnectedToBackend: boolean;
              }
            | {
                __typename?: 'ControllerHardwareDevice';
                serialNumber: string;
                isActive: boolean;
                isSpare: boolean;
                isConnectedToBackend: boolean;
              }
            | {
                __typename?: 'PowerDistributionUnitHardwareDevice';
                serialNumber: string;
                isActive: boolean;
                isSpare: boolean;
                isConnectedToBackend: boolean;
              }
            | {
                __typename?: 'SwitchHardwareDevice';
                serialNumber: string;
                isActive: boolean;
                isSpare: boolean;
                isConnectedToBackend: boolean;
              }
            | null;
        }
      | {
          __typename: 'SwitchVirtualDevice';
          UUID: string;
          label: string;
          deviceModel: DeviceModel;
          deviceType: VirtualDeviceType;
          hardwareDevice?:
            | {
                __typename?: 'AccessPointHardwareDevice';
                serialNumber: string;
                isActive: boolean;
                isSpare: boolean;
                isConnectedToBackend: boolean;
              }
            | {
                __typename?: 'ControllerHardwareDevice';
                serialNumber: string;
                isActive: boolean;
                isSpare: boolean;
                isConnectedToBackend: boolean;
              }
            | {
                __typename?: 'PowerDistributionUnitHardwareDevice';
                serialNumber: string;
                isActive: boolean;
                isSpare: boolean;
                isConnectedToBackend: boolean;
              }
            | {
                __typename?: 'SwitchHardwareDevice';
                serialNumber: string;
                isActive: boolean;
                isSpare: boolean;
                isConnectedToBackend: boolean;
              }
            | null;
        }
    >;
    mailingAddress?: {
      __typename?: 'MailingAddress';
      line1?: string | null;
      line2?: string | null;
      city?: string | null;
      subdivisionCode?: string | null;
      postalCode?: string | null;
      timezone: string;
      countryISO2?: string | null;
    } | null;
    pinnedNOSVersion: {
      __typename?: 'NosVersion';
      major: number;
      minor: number;
      patch: number;
      version?: string;
      isDefault?: boolean;
    };
  };
};

export type IsNosFeatureEnabledForNetworkQueryVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
  nosFeatureKey: Scalars['String']['input'];
}>;

export type IsNosFeatureEnabledForNetworkQuery = {
  __typename?: 'Query';
  isNosFeatureEnabledForNetwork: boolean;
};

export type AreNosFeatureEnabledForNetworkQueryVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
  nosFeatureKeys: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;

export type AreNosFeatureEnabledForNetworkQuery = {
  __typename?: 'Query';
  areNosFeaturesEnabledForNetwork: Array<{
    __typename?: 'NosFeatureEnabled';
    key: string;
    enabled: boolean;
  }>;
};

export type IsNosFeatureEnabledForCompanyQueryVariables = Exact<{
  companySlug: Scalars['String']['input'];
  nosFeatureKey: Scalars['String']['input'];
}>;

export type IsNosFeatureEnabledForCompanyQuery = {
  __typename?: 'Query';
  isNosFeatureEnabledForCompany: boolean;
};

export type AreNosFeatureEnabledForCompanyQueryVariables = Exact<{
  companySlug: Scalars['String']['input'];
  nosFeatureKeys: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;

export type AreNosFeatureEnabledForCompanyQuery = {
  __typename?: 'Query';
  areNosFeaturesEnabledForCompany: Array<{
    __typename?: 'NosFeatureEnabled';
    key: string;
    enabled: boolean;
  }>;
};

export type CompanyUuidQueryQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;

export type CompanyUuidQueryQuery = {
  __typename?: 'Query';
  getCompany?: {
    __typename: 'Company';
    uuid: string;
    name: string;
    slug: string;
    isCustomer: boolean;
    supportGroup?: number | null;
    websiteDomain?: string | null;
  } | null;
};

export type CreateKnockTokenMutationVariables = Exact<{
  companyUUID: Scalars['UUID']['input'];
}>;

export type CreateKnockTokenMutation = { __typename?: 'Mutation'; createKnockToken: string };

export type PermissionsQueryVariables = Exact<{
  input: PermissionsInput;
}>;

export type PermissionsQuery = {
  __typename?: 'Query';
  permissions: Array<{
    __typename?: 'PermissionAssignment';
    networkUUID?: string | null;
    permissions: Array<PermissionType>;
  }>;
};

export type DeleteNosFirmwareUpgradeMutationMutationVariables = Exact<{
  uuid: Scalars['UUID']['input'];
}>;

export type DeleteNosFirmwareUpgradeMutationMutation = {
  __typename?: 'Mutation';
  deleteBulkNOSUpgrade: { __typename?: 'BulkNOSUpgrade'; UUID: string };
};

export type VirtualDeviceForNavigationQueryVariables = Exact<{
  uuid: Scalars['UUID']['input'];
}>;

export type VirtualDeviceForNavigationQuery = {
  __typename?: 'Query';
  virtualDevice:
    | {
        __typename?: 'AccessPointVirtualDevice';
        UUID: string;
        deviceType: VirtualDeviceType;
        network: {
          __typename?: 'Network';
          UUID: string;
          slug: string;
          companySlug?: string | null;
        };
      }
    | {
        __typename?: 'ControllerVirtualDevice';
        UUID: string;
        deviceType: VirtualDeviceType;
        network: {
          __typename?: 'Network';
          UUID: string;
          slug: string;
          companySlug?: string | null;
        };
      }
    | {
        __typename?: 'ObserverVirtualDevice';
        UUID: string;
        deviceType: VirtualDeviceType;
        network: {
          __typename?: 'Network';
          UUID: string;
          slug: string;
          companySlug?: string | null;
        };
      }
    | {
        __typename?: 'PowerDistributionUnitVirtualDevice';
        UUID: string;
        deviceType: VirtualDeviceType;
        network: {
          __typename?: 'Network';
          UUID: string;
          slug: string;
          companySlug?: string | null;
        };
      }
    | {
        __typename?: 'SwitchVirtualDevice';
        UUID: string;
        deviceType: VirtualDeviceType;
        network: {
          __typename?: 'Network';
          UUID: string;
          slug: string;
          companySlug?: string | null;
        };
      };
};

export type MutationDiffAuditLogQueryVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
  filter?: InputMaybe<MutationDiffAuditLogFilterInput>;
}>;

export type MutationDiffAuditLogQuery = {
  __typename?: 'Query';
  mutationDiffAuditLogPageForNetwork: {
    __typename?: 'MutationDiffAuditLogPage';
    total: number;
    entries: Array<{
      __typename?: 'MutationDiffAuditLogEntry';
      UUID: string;
      createdAt: string;
      username: string;
      action: string;
      beforeJSON: string;
      afterJSON: string;
      reason?: string | null;
    }>;
  };
};

export type MutationDiffAuditLogFilteredQueryVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
  filter?: InputMaybe<MutationDiffAuditLogFilterInput>;
}>;

export type MutationDiffAuditLogFilteredQuery = {
  __typename?: 'Query';
  mutationDiffAuditLogPageForNetworkFiltered: {
    __typename?: 'MutationDiffAuditLogPage';
    total: number;
    entries: Array<{
      __typename?: 'MutationDiffAuditLogEntry';
      UUID: string;
      createdAt: string;
      username: string;
      action: string;
      beforeJSON: string;
      afterJSON: string;
      reason?: string | null;
    }>;
  };
};

export type MutationAuditLogEntriesForNetworkQueryVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
  filter?: InputMaybe<MutationAuditLogFilter>;
}>;

export type MutationAuditLogEntriesForNetworkQuery = {
  __typename?: 'Query';
  mutationAuditLogEntriesForNetwork: Array<{
    __typename?: 'MutationAuditLogEntry';
    UUID: string;
    networkUUID: string;
    createdAt: string;
    username: string;
    action: string;
    args: Record<string, unknown>;
    reason?: string | null;
  }>;
};

export type StatsForVirtualDevicesQueryVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
  filter: NetworkStatsFilter;
}>;

export type StatsForVirtualDevicesQuery = {
  __typename?: 'Query';
  statsForVirtualDevices: Array<{
    __typename?: 'Stat';
    observedAt: string;
    insertedAt?: string | null;
    networkUUID: string;
    virtualDeviceUUID: string;
    type: StatType;
    rawData: Record<string, unknown>;
  }>;
};

export type AnomaliesForVirtualDevicesQueryVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
  filter: AnomalyStatsFilterInput;
}>;

export type AnomaliesForVirtualDevicesQuery = {
  __typename?: 'Query';
  anomalyStatsGroupsForVirtualDevices: Array<{
    __typename?: 'AnomalyStatsGroup';
    message: string;
    sourceFunction: string;
    sourceLine: string;
    stackTrace: string;
    count: number;
    mostRecentObservedAt: string;
    rawStats: Array<{
      __typename?: 'Stat';
      observedAt: string;
      insertedAt?: string | null;
      networkUUID: string;
      virtualDeviceUUID: string;
      type: StatType;
      rawData: Record<string, unknown>;
    }>;
  }>;
};

export type VirtualDevicesForTopologyQueryVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
}>;

export type VirtualDevicesForTopologyQuery = {
  __typename?: 'Query';
  virtualDevicesForNetwork: Array<
    | {
        __typename: 'AccessPointVirtualDevice';
        UUID: string;
        label: string;
        deviceType: VirtualDeviceType;
        hardwareDevice?:
          | {
              __typename: 'AccessPointHardwareDevice';
              serialNumber: string;
              deviceType: DeviceType;
              isActive: boolean;
              isConnectedToBackend: boolean;
            }
          | {
              __typename: 'ControllerHardwareDevice';
              serialNumber: string;
              deviceType: DeviceType;
              isActive: boolean;
              isConnectedToBackend: boolean;
            }
          | {
              __typename: 'PowerDistributionUnitHardwareDevice';
              serialNumber: string;
              deviceType: DeviceType;
              isActive: boolean;
              isConnectedToBackend: boolean;
            }
          | {
              __typename: 'SwitchHardwareDevice';
              serialNumber: string;
              deviceType: DeviceType;
              isActive: boolean;
              isConnectedToBackend: boolean;
            }
          | null;
      }
    | {
        __typename: 'ControllerVirtualDevice';
        UUID: string;
        label: string;
        deviceType: VirtualDeviceType;
        phyInterfaces: Array<{
          __typename?: 'PhyInterface';
          virtualDeviceUUID: string;
          isEnabled: boolean;
          isUplink: boolean;
          isConnected: boolean;
          isLoopbackDetected?: boolean | null;
          isBlockedDueToFlaps: boolean;
          isSTPForwarding?: boolean | null;
          isUplinkActive?: boolean | null;
          connectedDevices?: Array<{
            __typename?: 'PhyInterfaceConnectedDevice';
            hardwareDevice?:
              | {
                  __typename?: 'AccessPointHardwareDevice';
                  serialNumber: string;
                  deviceType: DeviceType;
                  isActive: boolean;
                  virtualDeviceUUID?: string | null;
                  isConnectedToBackend: boolean;
                }
              | {
                  __typename?: 'ControllerHardwareDevice';
                  serialNumber: string;
                  deviceType: DeviceType;
                  isActive: boolean;
                  virtualDeviceUUID?: string | null;
                  isConnectedToBackend: boolean;
                }
              | {
                  __typename?: 'PowerDistributionUnitHardwareDevice';
                  serialNumber: string;
                  deviceType: DeviceType;
                  isActive: boolean;
                  virtualDeviceUUID?: string | null;
                  isConnectedToBackend: boolean;
                }
              | {
                  __typename?: 'SwitchHardwareDevice';
                  serialNumber: string;
                  deviceType: DeviceType;
                  isActive: boolean;
                  virtualDeviceUUID?: string | null;
                  isConnectedToBackend: boolean;
                }
              | null;
          }> | null;
          internetServicePlan?: {
            __typename?: 'InternetServicePlan';
            provider?: {
              __typename?: 'InternetServicePlanProvider';
              UUID: string;
              name: string;
            } | null;
          } | null;
        }>;
        hardwareDevice?:
          | {
              __typename: 'AccessPointHardwareDevice';
              serialNumber: string;
              deviceType: DeviceType;
              isActive: boolean;
              isConnectedToBackend: boolean;
            }
          | {
              __typename: 'ControllerHardwareDevice';
              serialNumber: string;
              deviceType: DeviceType;
              isActive: boolean;
              isConnectedToBackend: boolean;
            }
          | {
              __typename: 'PowerDistributionUnitHardwareDevice';
              serialNumber: string;
              deviceType: DeviceType;
              isActive: boolean;
              isConnectedToBackend: boolean;
            }
          | {
              __typename: 'SwitchHardwareDevice';
              serialNumber: string;
              deviceType: DeviceType;
              isActive: boolean;
              isConnectedToBackend: boolean;
            }
          | null;
      }
    | {
        __typename: 'ObserverVirtualDevice';
        UUID: string;
        label: string;
        deviceType: VirtualDeviceType;
        hardwareDevice?:
          | {
              __typename: 'AccessPointHardwareDevice';
              serialNumber: string;
              deviceType: DeviceType;
              isActive: boolean;
              isConnectedToBackend: boolean;
            }
          | {
              __typename: 'ControllerHardwareDevice';
              serialNumber: string;
              deviceType: DeviceType;
              isActive: boolean;
              isConnectedToBackend: boolean;
            }
          | {
              __typename: 'PowerDistributionUnitHardwareDevice';
              serialNumber: string;
              deviceType: DeviceType;
              isActive: boolean;
              isConnectedToBackend: boolean;
            }
          | {
              __typename: 'SwitchHardwareDevice';
              serialNumber: string;
              deviceType: DeviceType;
              isActive: boolean;
              isConnectedToBackend: boolean;
            }
          | null;
      }
    | {
        __typename: 'PowerDistributionUnitVirtualDevice';
        UUID: string;
        label: string;
        deviceType: VirtualDeviceType;
        hardwareDevice?:
          | {
              __typename: 'AccessPointHardwareDevice';
              serialNumber: string;
              deviceType: DeviceType;
              isActive: boolean;
              isConnectedToBackend: boolean;
            }
          | {
              __typename: 'ControllerHardwareDevice';
              serialNumber: string;
              deviceType: DeviceType;
              isActive: boolean;
              isConnectedToBackend: boolean;
            }
          | {
              __typename: 'PowerDistributionUnitHardwareDevice';
              serialNumber: string;
              deviceType: DeviceType;
              isActive: boolean;
              isConnectedToBackend: boolean;
            }
          | {
              __typename: 'SwitchHardwareDevice';
              serialNumber: string;
              deviceType: DeviceType;
              isActive: boolean;
              isConnectedToBackend: boolean;
            }
          | null;
      }
    | {
        __typename: 'SwitchVirtualDevice';
        UUID: string;
        label: string;
        deviceType: VirtualDeviceType;
        phyInterfaces: Array<{
          __typename?: 'PhyInterface';
          isEnabled: boolean;
          isUplink: boolean;
          isConnected: boolean;
          isLoopbackDetected?: boolean | null;
          isBlockedDueToFlaps: boolean;
          isSTPForwarding?: boolean | null;
          connectedDevices?: Array<{
            __typename?: 'PhyInterfaceConnectedDevice';
            hardwareDevice?:
              | {
                  __typename?: 'AccessPointHardwareDevice';
                  serialNumber: string;
                  deviceType: DeviceType;
                  isActive: boolean;
                  virtualDeviceUUID?: string | null;
                  isConnectedToBackend: boolean;
                }
              | {
                  __typename?: 'ControllerHardwareDevice';
                  serialNumber: string;
                  deviceType: DeviceType;
                  isActive: boolean;
                  virtualDeviceUUID?: string | null;
                  isConnectedToBackend: boolean;
                }
              | {
                  __typename?: 'PowerDistributionUnitHardwareDevice';
                  serialNumber: string;
                  deviceType: DeviceType;
                  isActive: boolean;
                  virtualDeviceUUID?: string | null;
                  isConnectedToBackend: boolean;
                }
              | {
                  __typename?: 'SwitchHardwareDevice';
                  serialNumber: string;
                  deviceType: DeviceType;
                  isActive: boolean;
                  virtualDeviceUUID?: string | null;
                  isConnectedToBackend: boolean;
                }
              | null;
          }> | null;
        }>;
        switchProfile: { __typename?: 'SwitchProfile'; switchingTier: SwitchProfileSwitchingTier };
        hardwareDevice?:
          | {
              __typename: 'AccessPointHardwareDevice';
              serialNumber: string;
              deviceType: DeviceType;
              isActive: boolean;
              isConnectedToBackend: boolean;
            }
          | {
              __typename: 'ControllerHardwareDevice';
              serialNumber: string;
              deviceType: DeviceType;
              isActive: boolean;
              isConnectedToBackend: boolean;
            }
          | {
              __typename: 'PowerDistributionUnitHardwareDevice';
              serialNumber: string;
              deviceType: DeviceType;
              isActive: boolean;
              isConnectedToBackend: boolean;
            }
          | {
              __typename: 'SwitchHardwareDevice';
              serialNumber: string;
              deviceType: DeviceType;
              isActive: boolean;
              isConnectedToBackend: boolean;
            }
          | null;
      }
  >;
};

export type LatestDeviceConfigQueryVariables = Exact<{
  serialNumber: Scalars['String']['input'];
}>;

export type LatestDeviceConfigQuery = {
  __typename?: 'Query';
  latestDeviceConfig: { __typename?: 'DeviceConfig'; configJSON: Record<string, unknown> };
};

export type DeviceConfigOverrideQueryVariables = Exact<{
  serialNumber: Scalars['String']['input'];
}>;

export type DeviceConfigOverrideQuery = {
  __typename?: 'Query';
  deviceConfigOverride: {
    __typename?: 'DeviceConfigOverride';
    configJSON: Record<string, unknown>;
  };
};

export type UpdateDeviceConfigOverrideMutationVariables = Exact<{
  serialNumber: Scalars['String']['input'];
  configJSON: Scalars['String']['input'];
}>;

export type UpdateDeviceConfigOverrideMutation = {
  __typename?: 'Mutation';
  upsertDeviceConfigOverride: boolean;
};

export type DeviceForNetworkQueryVariables = Exact<{
  networkUUID: Scalars['UUID']['input'];
}>;

export type DeviceForNetworkQuery = {
  __typename?: 'Query';
  virtualDevicesForNetwork: Array<
    | {
        __typename?: 'AccessPointVirtualDevice';
        label: string;
        hardwareDevice?:
          | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
          | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
          | { __typename?: 'PowerDistributionUnitHardwareDevice'; serialNumber: string }
          | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
          | null;
      }
    | {
        __typename?: 'ControllerVirtualDevice';
        label: string;
        hardwareDevice?:
          | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
          | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
          | { __typename?: 'PowerDistributionUnitHardwareDevice'; serialNumber: string }
          | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
          | null;
      }
    | {
        __typename?: 'ObserverVirtualDevice';
        label: string;
        hardwareDevice?:
          | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
          | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
          | { __typename?: 'PowerDistributionUnitHardwareDevice'; serialNumber: string }
          | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
          | null;
      }
    | {
        __typename?: 'PowerDistributionUnitVirtualDevice';
        label: string;
        hardwareDevice?:
          | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
          | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
          | { __typename?: 'PowerDistributionUnitHardwareDevice'; serialNumber: string }
          | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
          | null;
      }
    | {
        __typename?: 'SwitchVirtualDevice';
        label: string;
        hardwareDevice?:
          | { __typename?: 'AccessPointHardwareDevice'; serialNumber: string }
          | { __typename?: 'ControllerHardwareDevice'; serialNumber: string }
          | { __typename?: 'PowerDistributionUnitHardwareDevice'; serialNumber: string }
          | { __typename?: 'SwitchHardwareDevice'; serialNumber: string }
          | null;
      }
  >;
};

export type ValidateBearerSessionMutationVariables = Exact<{
  UUID: Scalars['UUID']['input'];
}>;

export type ValidateBearerSessionMutation = {
  __typename?: 'Mutation';
  validateBearerSession: { __typename?: 'BearerSession'; UUID: string };
};

export type AllSecurityAppliancesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;

export type AllSecurityAppliancesQuery = {
  __typename?: 'Query';
  hardwareDevices: Array<
    | {
        __typename?: 'AccessPointHardwareDevice';
        serialNumber: string;
        isActive: boolean;
        deviceType: DeviceType;
        deviceModel: DeviceModel;
        virtualDevice?:
          | {
              __typename?: 'AccessPointVirtualDevice';
              UUID: string;
              label: string;
              network: {
                __typename?: 'Network';
                UUID: string;
                label: string;
                slug: string;
                company?: { __typename?: 'Company'; slug: string; name: string } | null;
                mailingAddress?: {
                  __typename?: 'MailingAddress';
                  line1?: string | null;
                  line2?: string | null;
                  city?: string | null;
                  subdivisionCode?: string | null;
                  postalCode?: string | null;
                  timezone: string;
                } | null;
              };
            }
          | {
              __typename?: 'ControllerVirtualDevice';
              UUID: string;
              label: string;
              network: {
                __typename?: 'Network';
                UUID: string;
                label: string;
                slug: string;
                company?: { __typename?: 'Company'; slug: string; name: string } | null;
                mailingAddress?: {
                  __typename?: 'MailingAddress';
                  line1?: string | null;
                  line2?: string | null;
                  city?: string | null;
                  subdivisionCode?: string | null;
                  postalCode?: string | null;
                  timezone: string;
                } | null;
              };
            }
          | {
              __typename?: 'ObserverVirtualDevice';
              UUID: string;
              label: string;
              network: {
                __typename?: 'Network';
                UUID: string;
                label: string;
                slug: string;
                company?: { __typename?: 'Company'; slug: string; name: string } | null;
                mailingAddress?: {
                  __typename?: 'MailingAddress';
                  line1?: string | null;
                  line2?: string | null;
                  city?: string | null;
                  subdivisionCode?: string | null;
                  postalCode?: string | null;
                  timezone: string;
                } | null;
              };
            }
          | {
              __typename?: 'PowerDistributionUnitVirtualDevice';
              UUID: string;
              label: string;
              network: {
                __typename?: 'Network';
                UUID: string;
                label: string;
                slug: string;
                company?: { __typename?: 'Company'; slug: string; name: string } | null;
                mailingAddress?: {
                  __typename?: 'MailingAddress';
                  line1?: string | null;
                  line2?: string | null;
                  city?: string | null;
                  subdivisionCode?: string | null;
                  postalCode?: string | null;
                  timezone: string;
                } | null;
              };
            }
          | {
              __typename?: 'SwitchVirtualDevice';
              UUID: string;
              label: string;
              network: {
                __typename?: 'Network';
                UUID: string;
                label: string;
                slug: string;
                company?: { __typename?: 'Company'; slug: string; name: string } | null;
                mailingAddress?: {
                  __typename?: 'MailingAddress';
                  line1?: string | null;
                  line2?: string | null;
                  city?: string | null;
                  subdivisionCode?: string | null;
                  postalCode?: string | null;
                  timezone: string;
                } | null;
              };
            }
          | null;
      }
    | {
        __typename?: 'ControllerHardwareDevice';
        serialNumber: string;
        isActive: boolean;
        deviceType: DeviceType;
        deviceModel: DeviceModel;
        virtualDevice?:
          | {
              __typename?: 'AccessPointVirtualDevice';
              UUID: string;
              label: string;
              network: {
                __typename?: 'Network';
                UUID: string;
                label: string;
                slug: string;
                company?: { __typename?: 'Company'; slug: string; name: string } | null;
                mailingAddress?: {
                  __typename?: 'MailingAddress';
                  line1?: string | null;
                  line2?: string | null;
                  city?: string | null;
                  subdivisionCode?: string | null;
                  postalCode?: string | null;
                  timezone: string;
                } | null;
              };
            }
          | {
              __typename?: 'ControllerVirtualDevice';
              UUID: string;
              label: string;
              network: {
                __typename?: 'Network';
                UUID: string;
                label: string;
                slug: string;
                company?: { __typename?: 'Company'; slug: string; name: string } | null;
                mailingAddress?: {
                  __typename?: 'MailingAddress';
                  line1?: string | null;
                  line2?: string | null;
                  city?: string | null;
                  subdivisionCode?: string | null;
                  postalCode?: string | null;
                  timezone: string;
                } | null;
              };
            }
          | {
              __typename?: 'ObserverVirtualDevice';
              UUID: string;
              label: string;
              network: {
                __typename?: 'Network';
                UUID: string;
                label: string;
                slug: string;
                company?: { __typename?: 'Company'; slug: string; name: string } | null;
                mailingAddress?: {
                  __typename?: 'MailingAddress';
                  line1?: string | null;
                  line2?: string | null;
                  city?: string | null;
                  subdivisionCode?: string | null;
                  postalCode?: string | null;
                  timezone: string;
                } | null;
              };
            }
          | {
              __typename?: 'PowerDistributionUnitVirtualDevice';
              UUID: string;
              label: string;
              network: {
                __typename?: 'Network';
                UUID: string;
                label: string;
                slug: string;
                company?: { __typename?: 'Company'; slug: string; name: string } | null;
                mailingAddress?: {
                  __typename?: 'MailingAddress';
                  line1?: string | null;
                  line2?: string | null;
                  city?: string | null;
                  subdivisionCode?: string | null;
                  postalCode?: string | null;
                  timezone: string;
                } | null;
              };
            }
          | {
              __typename?: 'SwitchVirtualDevice';
              UUID: string;
              label: string;
              network: {
                __typename?: 'Network';
                UUID: string;
                label: string;
                slug: string;
                company?: { __typename?: 'Company'; slug: string; name: string } | null;
                mailingAddress?: {
                  __typename?: 'MailingAddress';
                  line1?: string | null;
                  line2?: string | null;
                  city?: string | null;
                  subdivisionCode?: string | null;
                  postalCode?: string | null;
                  timezone: string;
                } | null;
              };
            }
          | null;
      }
    | {
        __typename?: 'PowerDistributionUnitHardwareDevice';
        serialNumber: string;
        isActive: boolean;
        deviceType: DeviceType;
        deviceModel: DeviceModel;
        virtualDevice?:
          | {
              __typename?: 'AccessPointVirtualDevice';
              UUID: string;
              label: string;
              network: {
                __typename?: 'Network';
                UUID: string;
                label: string;
                slug: string;
                company?: { __typename?: 'Company'; slug: string; name: string } | null;
                mailingAddress?: {
                  __typename?: 'MailingAddress';
                  line1?: string | null;
                  line2?: string | null;
                  city?: string | null;
                  subdivisionCode?: string | null;
                  postalCode?: string | null;
                  timezone: string;
                } | null;
              };
            }
          | {
              __typename?: 'ControllerVirtualDevice';
              UUID: string;
              label: string;
              network: {
                __typename?: 'Network';
                UUID: string;
                label: string;
                slug: string;
                company?: { __typename?: 'Company'; slug: string; name: string } | null;
                mailingAddress?: {
                  __typename?: 'MailingAddress';
                  line1?: string | null;
                  line2?: string | null;
                  city?: string | null;
                  subdivisionCode?: string | null;
                  postalCode?: string | null;
                  timezone: string;
                } | null;
              };
            }
          | {
              __typename?: 'ObserverVirtualDevice';
              UUID: string;
              label: string;
              network: {
                __typename?: 'Network';
                UUID: string;
                label: string;
                slug: string;
                company?: { __typename?: 'Company'; slug: string; name: string } | null;
                mailingAddress?: {
                  __typename?: 'MailingAddress';
                  line1?: string | null;
                  line2?: string | null;
                  city?: string | null;
                  subdivisionCode?: string | null;
                  postalCode?: string | null;
                  timezone: string;
                } | null;
              };
            }
          | {
              __typename?: 'PowerDistributionUnitVirtualDevice';
              UUID: string;
              label: string;
              network: {
                __typename?: 'Network';
                UUID: string;
                label: string;
                slug: string;
                company?: { __typename?: 'Company'; slug: string; name: string } | null;
                mailingAddress?: {
                  __typename?: 'MailingAddress';
                  line1?: string | null;
                  line2?: string | null;
                  city?: string | null;
                  subdivisionCode?: string | null;
                  postalCode?: string | null;
                  timezone: string;
                } | null;
              };
            }
          | {
              __typename?: 'SwitchVirtualDevice';
              UUID: string;
              label: string;
              network: {
                __typename?: 'Network';
                UUID: string;
                label: string;
                slug: string;
                company?: { __typename?: 'Company'; slug: string; name: string } | null;
                mailingAddress?: {
                  __typename?: 'MailingAddress';
                  line1?: string | null;
                  line2?: string | null;
                  city?: string | null;
                  subdivisionCode?: string | null;
                  postalCode?: string | null;
                  timezone: string;
                } | null;
              };
            }
          | null;
      }
    | {
        __typename?: 'SwitchHardwareDevice';
        serialNumber: string;
        isActive: boolean;
        deviceType: DeviceType;
        deviceModel: DeviceModel;
        virtualDevice?:
          | {
              __typename?: 'AccessPointVirtualDevice';
              UUID: string;
              label: string;
              network: {
                __typename?: 'Network';
                UUID: string;
                label: string;
                slug: string;
                company?: { __typename?: 'Company'; slug: string; name: string } | null;
                mailingAddress?: {
                  __typename?: 'MailingAddress';
                  line1?: string | null;
                  line2?: string | null;
                  city?: string | null;
                  subdivisionCode?: string | null;
                  postalCode?: string | null;
                  timezone: string;
                } | null;
              };
            }
          | {
              __typename?: 'ControllerVirtualDevice';
              UUID: string;
              label: string;
              network: {
                __typename?: 'Network';
                UUID: string;
                label: string;
                slug: string;
                company?: { __typename?: 'Company'; slug: string; name: string } | null;
                mailingAddress?: {
                  __typename?: 'MailingAddress';
                  line1?: string | null;
                  line2?: string | null;
                  city?: string | null;
                  subdivisionCode?: string | null;
                  postalCode?: string | null;
                  timezone: string;
                } | null;
              };
            }
          | {
              __typename?: 'ObserverVirtualDevice';
              UUID: string;
              label: string;
              network: {
                __typename?: 'Network';
                UUID: string;
                label: string;
                slug: string;
                company?: { __typename?: 'Company'; slug: string; name: string } | null;
                mailingAddress?: {
                  __typename?: 'MailingAddress';
                  line1?: string | null;
                  line2?: string | null;
                  city?: string | null;
                  subdivisionCode?: string | null;
                  postalCode?: string | null;
                  timezone: string;
                } | null;
              };
            }
          | {
              __typename?: 'PowerDistributionUnitVirtualDevice';
              UUID: string;
              label: string;
              network: {
                __typename?: 'Network';
                UUID: string;
                label: string;
                slug: string;
                company?: { __typename?: 'Company'; slug: string; name: string } | null;
                mailingAddress?: {
                  __typename?: 'MailingAddress';
                  line1?: string | null;
                  line2?: string | null;
                  city?: string | null;
                  subdivisionCode?: string | null;
                  postalCode?: string | null;
                  timezone: string;
                } | null;
              };
            }
          | {
              __typename?: 'SwitchVirtualDevice';
              UUID: string;
              label: string;
              network: {
                __typename?: 'Network';
                UUID: string;
                label: string;
                slug: string;
                company?: { __typename?: 'Company'; slug: string; name: string } | null;
                mailingAddress?: {
                  __typename?: 'MailingAddress';
                  line1?: string | null;
                  line2?: string | null;
                  city?: string | null;
                  subdivisionCode?: string | null;
                  postalCode?: string | null;
                  timezone: string;
                } | null;
              };
            }
          | null;
      }
  >;
};

export type SsoOptionsQueryQueryVariables = Exact<{
  companySlug: Scalars['String']['input'];
}>;

export type SsoOptionsQueryQuery = {
  __typename?: 'Query';
  ssoOptions: {
    __typename?: 'SSOOptions';
    connectedDirectory?: {
      __typename?: 'SSOConnectedDirectory';
      createdAt: string;
      state: SsoState;
      type: SsoDirectoryTypes;
    } | null;
    connections: Array<{
      __typename?: 'SSOConnection';
      connectedAt: string;
      state: SsoConnectionState;
      type: SsoConnectionType;
    }>;
  };
};

export type GetCompanyQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;

export type GetCompanyQuery = {
  __typename?: 'Query';
  getCompany?: {
    __typename?: 'Company';
    uuid: string;
    slug: string;
    defaultRoleForUsers: RoleName;
  } | null;
};

export type UpsertDefaultRoleForUsersMutationVariables = Exact<{
  companySlug: Scalars['String']['input'];
  input: UpdateDefaultRoleForUsersInput;
}>;

export type UpsertDefaultRoleForUsersMutation = {
  __typename?: 'Mutation';
  updateDefaultRoleForUsers: {
    __typename?: 'DefaultRoleForUsersResponse';
    companySlug: string;
    defaultRoleForUsers: RoleName;
  };
};

export type CreatePermittedEmailDomainMutationVariables = Exact<{
  input: CreatePermittedEmailDomainInput;
}>;

export type CreatePermittedEmailDomainMutation = {
  __typename?: 'Mutation';
  createPermittedEmailDomain: { __typename?: 'PermittedEmailDomain'; domain: string };
};

export type ConfigureSsoMutationMutationVariables = Exact<{
  input: ConfigureSsoInput;
}>;

export type ConfigureSsoMutationMutation = {
  __typename?: 'Mutation';
  configureSSO: { __typename?: 'ConfigureSSOResult'; portalURL: string };
};

export const PhyInterfaceLabelFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhyInterfaceLabelFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PhyInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'portNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hardwareLabel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'virtualDevice' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deviceModel' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'internetServicePlan' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'provider' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PhyInterfaceLabelFieldsFragment, unknown>;
export const ClientVpnClientFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ClientVPNClientFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ClientVPNClient' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdBy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ipAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publicKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'userEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'userSID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'vpnServerUUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isConnected' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'connectionInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'observedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastHandshakeTx' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastHandshakeRx' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastPacketTx' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastPacketRx' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ClientVpnClientFieldsFragment, unknown>;
export const ClientVpnServerFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ClientVPNServerFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ClientVPNServer' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endpoint' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publicKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'port' } },
          { kind: 'Field', name: { kind: 'Name', value: 'defaultClientAllowedIPs' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address' } },
          { kind: 'Field', name: { kind: 'Name', value: 'addressMask' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'phyInterface' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PhyInterfaceLabelFields' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'dnsListenAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'defaultClientAllowedIPs' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isFailoverEnabled' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'clients' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ClientVPNClientFields' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'boundVLANs' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'vlanID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ipV4ClientAssignmentProtocol' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ipV4ClientGateway' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ipV4ClientPrefixLength' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ClientVPNClientFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ClientVPNClient' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdBy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ipAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publicKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'userEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'userSID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'vpnServerUUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isConnected' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'connectionInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'observedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastHandshakeTx' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastHandshakeRx' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastPacketTx' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastPacketRx' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhyInterfaceLabelFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PhyInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'portNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hardwareLabel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'virtualDevice' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deviceModel' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'internetServicePlan' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'provider' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ClientVpnServerFieldsFragment, unknown>;
export const RackElevationFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RackElevationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'RackElevation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rackMountUnitCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'networkUUID' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'devices' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rackMountUnitIndexes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'virtualDeviceUUID' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'virtualDevice' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'deviceType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'deviceModel' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hardwareDevice' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'serialNumber' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'deviceType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'deviceModel' } },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'SwitchVirtualDevice' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'phyInterfaces' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'isConnected' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'portNumber' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isEthernet' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isSFP' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'notes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rackMountUnitIndexStart' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rackMountUnitIndexEnd' } },
                { kind: 'Field', name: { kind: 'Name', value: 'note' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RackElevationFieldsFragment, unknown>;
export const DeviceConfigMetadataFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DeviceConfigMetadataFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DeviceConfigMetadata' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hardwareDevice' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'serialNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deviceType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'virtualDevice' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'acknowledgedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'state' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isCurrentAsOf' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeviceConfigMetadataFieldsFragment, unknown>;
export const PhyInterfaceFieldsForInstallStatusFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhyInterfaceFieldsForInstallStatus' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PhyInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isEthernet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isSFP' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isUplink' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isUplinkActive' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isConnected' } },
          { kind: 'Field', name: { kind: 'Name', value: 'portSpeedMbps' } },
          { kind: 'Field', name: { kind: 'Name', value: 'maxSpeedMbps' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isFLIPEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isVoiceVLANEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'powerDraw' } },
          { kind: 'Field', name: { kind: 'Name', value: 'poeType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasWANActivity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'portNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isTrunkPort' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isBoundToAllVLANs' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sfpModuleInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'moduleSpeedKbps' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'virtualDevice' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deviceType' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'connectedDevices' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'macAddress' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hardwareDevice' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'virtualDevice' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'deviceType' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PhyInterfaceFieldsForInstallStatusFragment, unknown>;
export const DeviceConfigMetadataFieldsForDeviceListBadgeFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DeviceConfigMetadataFieldsForDeviceListBadge' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DeviceConfigMetadata' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'acknowledgedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'state' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isCurrentAsOf' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeviceConfigMetadataFieldsForDeviceListBadgeFragment, unknown>;
export const HardwareDeviceFieldsForInstallStatusFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'hardwareDeviceFieldsForInstallStatus' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'HardwareDevice' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deviceType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'serialNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'macAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isConnectedToBackend' } },
          { kind: 'Field', name: { kind: 'Name', value: 'disconnectedFromBackendAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'bootHistory' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'count' },
                value: { kind: 'IntValue', value: '5' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'buildName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'isDev' },
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'if' },
                    value: { kind: 'Variable', name: { kind: 'Name', value: 'includeIsDev' } },
                  },
                ],
              },
            ],
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AccessPointHardwareDevice' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'ipAddress' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isInCurrentControllerMACTable' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'phyInterfaceConnectedTo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'PhyInterfaceFieldsForInstallStatus' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SwitchHardwareDevice' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'ipAddress' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isInCurrentControllerMACTable' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'latestDeviceConfigMetadata' },
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'if' },
                    value: {
                      kind: 'Variable',
                      name: { kind: 'Name', value: 'includeConfigMetadata' },
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'DeviceConfigMetadataFieldsForDeviceListBadge' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DeviceConfigMetadataFieldsForDeviceListBadge' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DeviceConfigMetadata' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'acknowledgedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'state' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isCurrentAsOf' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhyInterfaceFieldsForInstallStatus' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PhyInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isEthernet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isSFP' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isUplink' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isUplinkActive' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isConnected' } },
          { kind: 'Field', name: { kind: 'Name', value: 'portSpeedMbps' } },
          { kind: 'Field', name: { kind: 'Name', value: 'maxSpeedMbps' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isFLIPEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isVoiceVLANEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'powerDraw' } },
          { kind: 'Field', name: { kind: 'Name', value: 'poeType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasWANActivity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'portNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isTrunkPort' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isBoundToAllVLANs' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sfpModuleInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'moduleSpeedKbps' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'virtualDevice' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deviceType' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'connectedDevices' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'macAddress' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hardwareDevice' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'virtualDevice' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'deviceType' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<HardwareDeviceFieldsForInstallStatusFragment, unknown>;
export const OutletInterfaceFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OutletInterfaceFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'OutletInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'outletNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'virtualDeviceUUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'powerCycleDelaySec' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentAmps' } },
          { kind: 'Field', name: { kind: 'Name', value: 'powerWatts' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'connectedVirtualDevice' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deviceType' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OutletInterfaceFieldsFragment, unknown>;
export const ControllerFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ControllerFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'VirtualDevice' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deviceType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deviceModel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isConsoleEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'networkUUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'uptime' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'nosUpgradeGroup' },
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'if' },
                    value: { kind: 'Variable', name: { kind: 'Name', value: 'includeNOS' } },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'nosVersion' },
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'if' },
                    value: { kind: 'Variable', name: { kind: 'Name', value: 'includeNOS' } },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'buildName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pendingNosVersion' },
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'if' },
                    value: { kind: 'Variable', name: { kind: 'Name', value: 'includeNOS' } },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nosVersion' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'version' } }],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'scheduledAt' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hardwareDevice' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deviceType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'serialNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'macAddress' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deviceModel' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isConnectedToBackend' } },
                { kind: 'Field', name: { kind: 'Name', value: 'disconnectedFromBackendAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'bootHistory' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'count' },
                      value: { kind: 'IntValue', value: '20' },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'bootCount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'buildName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'rebootReason' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'isDev' },
                  directives: [
                    {
                      kind: 'Directive',
                      name: { kind: 'Name', value: 'include' },
                      arguments: [
                        {
                          kind: 'Argument',
                          name: { kind: 'Name', value: 'if' },
                          value: {
                            kind: 'Variable',
                            name: { kind: 'Name', value: 'includeIsDev' },
                          },
                        },
                      ],
                    },
                  ],
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'latestDeviceConfigMetadata' },
                  directives: [
                    {
                      kind: 'Directive',
                      name: { kind: 'Name', value: 'include' },
                      arguments: [
                        {
                          kind: 'Argument',
                          name: { kind: 'Name', value: 'if' },
                          value: {
                            kind: 'Variable',
                            name: { kind: 'Name', value: 'includeConfigMetadata' },
                          },
                        },
                      ],
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'DeviceConfigMetadataFieldsForDeviceListBadge',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ControllerVirtualDevice' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'highAvailability' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'securityApplianceProfile' },
                  directives: [
                    {
                      kind: 'Directive',
                      name: { kind: 'Name', value: 'include' },
                      arguments: [
                        {
                          kind: 'Argument',
                          name: { kind: 'Name', value: 'if' },
                          value: {
                            kind: 'Variable',
                            name: { kind: 'Name', value: 'includeSecurityApplianceProfile' },
                          },
                        },
                      ],
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'multiWANAlgorithm' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'multiWANUpdateLookback' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'multiWANUpdateThreshold' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'multiWANUpdateCooldownSec' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hostMonitoringTimeoutSec' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hostMonitoringIntervalSec' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'managementConnection' },
                  directives: [
                    {
                      kind: 'Directive',
                      name: { kind: 'Name', value: 'include' },
                      arguments: [
                        {
                          kind: 'Argument',
                          name: { kind: 'Name', value: 'if' },
                          value: {
                            kind: 'Variable',
                            name: { kind: 'Name', value: 'includeManagementConnection' },
                          },
                        },
                      ],
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'connectionType' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DeviceConfigMetadataFieldsForDeviceListBadge' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DeviceConfigMetadata' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'acknowledgedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'state' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isCurrentAsOf' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ControllerFragmentFragment, unknown>;
export const ControllerVirtualDeviceFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ControllerVirtualDeviceFragment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ControllerVirtualDevice' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'highAvailability' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'outletInterfaceConnectedTo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'outletNumber' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'virtualDevice' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'phyInterfaces' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isConnected' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isSFP' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isTrunkPort' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isUplink' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'portNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'portSpeedMbps' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'connectedDevices' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hardwareDevice' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'deviceModel' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'deviceType' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'virtualDevice' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'deviceType' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'phyInterface' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'portNumber' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'hasWANActivity' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'internetServicePlan' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'controllerIP' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'provider' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'logoURL' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ControllerVirtualDeviceFragmentFragment, unknown>;
export const ControllerPhyInterfaceFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ControllerPhyInterfaceFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PhyInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'virtualDeviceUUID' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'virtualDevice' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deviceModel' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'portNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hardwareLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'forcedSpeedAllowed' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isTrunkPort' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isUplink' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isEthernet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isSFP' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isConnected' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasWANActivity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'forcedPortSpeedMbps' } },
          { kind: 'Field', name: { kind: 'Name', value: 'portSpeedMbps' } },
          { kind: 'Field', name: { kind: 'Name', value: 'maxSpeedMbps' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ipv4ClientAssignmentProtocol' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ipv4ClientGateway' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ipv4ClientPrefixLength' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ipv4ClientAddresses' } },
          { kind: 'Field', name: { kind: 'Name', value: 'uplinkPriority' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'nativeVLAN' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'vlanID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'connectedDevices' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'macAddress' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hardwareDevice' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'serialNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isConnectedToBackend' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'deviceType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'deviceModel' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'virtualDevice' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'deviceType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'phyInterface' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'portNumber' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'uplinkExternalAddresses' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasWANActivity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isUplinkActive' } },
          { kind: 'Field', name: { kind: 'Name', value: 'uplinkVLANID' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'internetServicePlan' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'controllerIP' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'provider' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'logoURL' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'uplinkGatewayMACAddress' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sfpModuleInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'moduleSpeedKbps' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ControllerPhyInterfaceFieldsFragment, unknown>;
export const PhyInterfaceFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhyInterfaceFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PhyInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'portNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isEthernet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isSFP' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isUplink' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isUplinkActive' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isConnected' } },
          { kind: 'Field', name: { kind: 'Name', value: 'portSpeedMbps' } },
          { kind: 'Field', name: { kind: 'Name', value: 'maxSpeedMbps' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isFLIPEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isVoiceVLANEnabled' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sfpModuleInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'moduleSpeedKbps' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PhyInterfaceFieldsFragment, unknown>;
export const HardwareDeviceFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'hardwareDeviceFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'HardwareDevice' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deviceType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'serialNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'macAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isConnectedToBackend' } },
          { kind: 'Field', name: { kind: 'Name', value: 'disconnectedFromBackendAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'bootHistory' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'count' },
                value: { kind: 'IntValue', value: '1' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'buildName' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'isDev' },
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'if' },
                    value: { kind: 'Variable', name: { kind: 'Name', value: 'includeIsDev' } },
                  },
                ],
              },
            ],
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AccessPointHardwareDevice' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'ipAddress' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isInCurrentControllerMACTable' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'phyInterfaceConnectedTo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'PhyInterfaceFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SwitchHardwareDevice' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'ipAddress' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isInCurrentControllerMACTable' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'latestDeviceConfigMetadata' },
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'if' },
                    value: {
                      kind: 'Variable',
                      name: { kind: 'Name', value: 'includeConfigMetadata' },
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'DeviceConfigMetadataFieldsForDeviceListBadge' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DeviceConfigMetadataFieldsForDeviceListBadge' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DeviceConfigMetadata' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'acknowledgedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'state' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isCurrentAsOf' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhyInterfaceFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PhyInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'portNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isEthernet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isSFP' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isUplink' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isUplinkActive' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isConnected' } },
          { kind: 'Field', name: { kind: 'Name', value: 'portSpeedMbps' } },
          { kind: 'Field', name: { kind: 'Name', value: 'maxSpeedMbps' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isFLIPEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isVoiceVLANEnabled' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sfpModuleInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'moduleSpeedKbps' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<HardwareDeviceFieldsFragment, unknown>;
export const BaseMetricsResponseFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BaseMetricsResponseFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'MetricsResponse' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'metadata' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'minValue' } },
                { kind: 'Field', name: { kind: 'Name', value: 'maxValue' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'values' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BaseMetricsResponseFieldsFragment, unknown>;
export const HostMonitoringTargetFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'HostMonitoringTargetFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'HostMonitoringTarget' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'targetHost' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isUsedForWANFailover' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<HostMonitoringTargetFieldsFragment, unknown>;
export const ConnectionEventFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ConnectionEventFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'WirelessClientConnectionEvent' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
          { kind: 'Field', name: { kind: 'Name', value: 'band' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eventType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failedStep' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reasonCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sessionDuration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timeToConnect' } },
          { kind: 'Field', name: { kind: 'Name', value: 'is80211rRoam' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isObserver' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isSteeringRejection' } },
          { kind: 'Field', name: { kind: 'Name', value: 'instigator' } },
          { kind: 'Field', name: { kind: 'Name', value: 'macAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rssi' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ssid' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ssid' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'virtualDevice' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'previousVirtualDeviceConnectedTo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ConnectionEventFieldsFragment, unknown>;
export const CaptivePortalBodyFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CaptivePortalBody' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CaptivePortal' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callToAction' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'logoImageBase64' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'data' } },
                { kind: 'Field', name: { kind: 'Name', value: 'imageType' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'logoImageS3Key' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'redirectURL' } },
          { kind: 'Field', name: { kind: 'Name', value: 'allowedHosts' } },
          { kind: 'Field', name: { kind: 'Name', value: 'externalPortalURL' } },
          { kind: 'Field', name: { kind: 'Name', value: 'authLifetimeSec' } },
          { kind: 'Field', name: { kind: 'Name', value: 'termsAndConditions' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'vlans' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'vlanID' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'displaySettings' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'backgroundColor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'callToActionColor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fontColor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hidePoweredByMeter' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'webhookKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requiresApproval' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requiresEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requiresName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCompanyScoped' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CaptivePortalBodyFragment, unknown>;
export const CaptivePortalEntryBodyFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CaptivePortalEntryBody' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CaptivePortalEntry' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'networkUUID' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'captivePortal' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'ip' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mac' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'actionedBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'approvedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deniedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deletedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CaptivePortalEntryBodyFragment, unknown>;
export const RateLimitRuleFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RateLimitRuleFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'RateLimitRule' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rateLimitKbpsDownload' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rateLimitKbpsUpload' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPerSource' } },
          { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
          { kind: 'Field', name: { kind: 'Name', value: 'protocol' } },
          { kind: 'Field', name: { kind: 'Name', value: 'srcMac' } },
          { kind: 'Field', name: { kind: 'Name', value: 'srcPrefix' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'srcPortRange' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'lower' } },
                { kind: 'Field', name: { kind: 'Name', value: 'upper' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'dstMac' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dstPrefix' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dstPortRange' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'lower' } },
                { kind: 'Field', name: { kind: 'Name', value: 'upper' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'vlanBindings' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'vlanID' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'phyInterfaceBindings' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PhyInterfaceLabelFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ssidBindings' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ssid' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhyInterfaceLabelFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PhyInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'portNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hardwareLabel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'virtualDevice' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deviceModel' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'internetServicePlan' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'provider' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RateLimitRuleFieldsFragment, unknown>;
export const NetworkFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'NetworkFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Network' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companySlug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isTrial' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isTemplate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nosUpgradeChannel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpgradedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'highAvailabilityConfig' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'virtualDevices' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'deviceType' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mailingAddress' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'line1' } },
                { kind: 'Field', name: { kind: 'Name', value: 'line2' } },
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subdivisionCode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'postalCode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'countryISO2' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<NetworkFieldsFragment, unknown>;
export const FleetwideNotificationSettingFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'FleetwideNotificationSettingFragment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FleetwideNotificationSetting' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'alertDefinitionName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'alertReceiver' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'companyUUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'arguments' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'parameterName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'countAppliedNetworks' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'enabledForInactiveNetworks' } },
          { kind: 'Field', name: { kind: 'Name', value: 'enabledForInternalNetworks' } },
          { kind: 'Field', name: { kind: 'Name', value: 'enabledCustomerSupportTiers' } },
          { kind: 'Field', name: { kind: 'Name', value: 'enabledNOSUpgradeChannels' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FleetwideNotificationSettingFragmentFragment, unknown>;
export const NetworkFieldsForNosVersionFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'NetworkFieldsForNOSVersion' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Network' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCustomer' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companySlug' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'supportTier' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mailingAddress' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'squareFeet' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'virtualDevices' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hardwareDevice' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'deviceType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'deviceModel' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'pinnedNOSVersionID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pendingNOSVersionID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpgradedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nosUpgradeChannel' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<NetworkFieldsForNosVersionFragment, unknown>;
export const NosVersionFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'NosVersionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'NosVersion' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mc01Build' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mw07Build' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ms10Build' } },
          { kind: 'Field', name: { kind: 'Name', value: 's1Build' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mp01Build' } },
          { kind: 'Field', name: { kind: 'Name', value: 'observerBuild' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isDeprecated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPublic' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'major' } },
          { kind: 'Field', name: { kind: 'Name', value: 'minor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'patch' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'networks' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'NetworkFieldsForNOSVersion' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'NetworkFieldsForNOSVersion' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Network' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCustomer' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companySlug' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'supportTier' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mailingAddress' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'squareFeet' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'virtualDevices' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hardwareDevice' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'deviceType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'deviceModel' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'pinnedNOSVersionID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pendingNOSVersionID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpgradedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nosUpgradeChannel' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<NosVersionFieldsFragment, unknown>;
export const PromoFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PromoFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MarketingChangelogEntry' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heading' } },
          { kind: 'Field', name: { kind: 'Name', value: 'copy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkURL' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'imageS3Keys' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'lightS3Key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'darkS3Key' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'badge' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'icon' } },
                { kind: 'Field', name: { kind: 'Name', value: 'text' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'visibleStartAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'visibleEndAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PromoFieldsFragment, unknown>;
export const InternalNoteFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'InternalNoteFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'InternalNote' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createdByUser' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updatedByUser' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isImportant' } },
          { kind: 'Field', name: { kind: 'Name', value: 'note' } },
          { kind: 'Field', name: { kind: 'Name', value: 'photoURLs' } },
          { kind: 'Field', name: { kind: 'Name', value: 'photoS3Keys' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<InternalNoteFieldsFragment, unknown>;
export const PolicyRoutingRulesFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PolicyRoutingRulesFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PolicyRoutingRule' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'srcPrefix' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'srcVLAN' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'vlanID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ipV4ClientAssignmentProtocol' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ipV4ClientGateway' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ipV4ClientPrefixLength' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'dstPrefix' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'srcPortRanges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'lower' } },
                { kind: 'Field', name: { kind: 'Name', value: 'upper' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dstPortRanges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'lower' } },
                { kind: 'Field', name: { kind: 'Name', value: 'upper' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'protocols' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'bindings' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'phyInterface' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'PhyInterfaceLabelFields' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'isUplinkActive' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasWANActivity' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isEnabled' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'metric' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhyInterfaceLabelFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PhyInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'portNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hardwareLabel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'virtualDevice' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deviceModel' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'internetServicePlan' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'provider' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PolicyRoutingRulesFieldsFragment, unknown>;
export const StaticRouteFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaticRouteFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaticRoute' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dstPrefix' } },
          { kind: 'Field', name: { kind: 'Name', value: 'gatewayIP' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'gatewayDHCPStaticMapping' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'macAddress' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ipAddress' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hostname' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'gatewayVLAN' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ipV4ClientAssignmentProtocol' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ipV4ClientGateway' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'explicitlyBoundVLANs' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'excludedVLANs' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<StaticRouteFieldsFragment, unknown>;
export const IpSecTunnelFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'IPSecTunnelFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IPSecTunnel' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isInitiator' } },
          { kind: 'Field', name: { kind: 'Name', value: 'authenticationAlgorithm' } },
          { kind: 'Field', name: { kind: 'Name', value: 'encryptionAlgorithm' } },
          { kind: 'Field', name: { kind: 'Name', value: 'keyExchangeDHGroup' } },
          { kind: 'Field', name: { kind: 'Name', value: 'right' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rightPrefixes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rightID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'leftID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isClientVPNBound' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'boundPhyInterface' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'portNumber' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'virtualDevice' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hardwareDevice' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'serialNumber' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isSpare' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'isConnectedToBackend' },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'deviceType' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'boundVLANs' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'vlanID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'observedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'saStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uniqueID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'remoteHostIP4Address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'establishedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rekeyAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reauthAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'childSAStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rxBytes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'txBytes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rxPackets' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rxLast' } },
                { kind: 'Field', name: { kind: 'Name', value: 'txLast' } },
                { kind: 'Field', name: { kind: 'Name', value: 'childRekeyAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'childLifetime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'latencyMs' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'peerType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dpdAction' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dpdTimeout' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dpdDelay' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ikeLifetime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rekey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reauth' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<IpSecTunnelFieldsFragment, unknown>;
export const IdsipsCategoryFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'IDSIPSCategoryFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IDSIPSCategory' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shortname' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shortDescription' } },
          { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ruleCount' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<IdsipsCategoryFieldsFragment, unknown>;
export const IdsRuleFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'IDSRuleFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IDSRule' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'SID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'action' } },
          { kind: 'Field', name: { kind: 'Name', value: 'classType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'groupID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'revision' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'references' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ref' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<IdsRuleFieldsFragment, unknown>;
export const IdsipsCustomRuleFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'IDSIPSCustomRuleFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IDSIPSCustomRule' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'action' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'application' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'domain' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'boundVLANs' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'vlanID' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<IdsipsCustomRuleFieldsFragment, unknown>;
export const IdsEventFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'IDSEventFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IDSEvent' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'virtualDevice' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deviceType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'observedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eventType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'srcMAC' } },
          { kind: 'Field', name: { kind: 'Name', value: 'srcIP' } },
          { kind: 'Field', name: { kind: 'Name', value: 'srcPort' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dstMAC' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dstIP' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dstPort' } },
          { kind: 'Field', name: { kind: 'Name', value: 'flowID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'appProto' } },
          { kind: 'Field', name: { kind: 'Name', value: 'protocol' } },
          { kind: 'Field', name: { kind: 'Name', value: 'direction' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'alert' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'action' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'gid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rev' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rule' } },
                { kind: 'Field', name: { kind: 'Name', value: 'severity' } },
                { kind: 'Field', name: { kind: 'Name', value: 'signature' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'httpInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'hostname' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'userAgent' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'protocol' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'length' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tlsInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'sni' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'flow' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'packetsToServer' } },
                { kind: 'Field', name: { kind: 'Name', value: 'packetsToClient' } },
                { kind: 'Field', name: { kind: 'Name', value: 'bytesToServer' } },
                { kind: 'Field', name: { kind: 'Name', value: 'bytesToClient' } },
                { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                { kind: 'Field', name: { kind: 'Name', value: 'end' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'firewallRule' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ipsRule' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'protocol' } },
                { kind: 'Field', name: { kind: 'Name', value: 'srcPrefix' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'srcPortRange' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'lower' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'upper' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'dstPrefix' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'dstPortRange' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'lower' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'upper' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'vlanBindings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'vlanID' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'phyInterfaceBindings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'PhyInterfaceLabelFields' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'durationSec' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhyInterfaceLabelFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PhyInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'portNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hardwareLabel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'virtualDevice' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deviceModel' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'internetServicePlan' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'provider' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<IdsEventFieldsFragment, unknown>;
export const AlertTargetWebhookFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AlertTargetWebhookFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AlertTargetWebhook' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'authType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'authValue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'signingSecret' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AlertTargetWebhookFieldsFragment, unknown>;
export const CompanyUserBodyFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CompanyUserBody' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CompanyUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'roles' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'companySlug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'networkUUID' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deletedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyMembershipRole' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CompanyUserBodyFragment, unknown>;
export const SsidFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SSIDFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SSID' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ssid' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'network' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'clientSteeringAssociationSteeringIsEnabled' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'clientSteeringLoadBalancingClientMinThreshold' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'clientSteeringPreassociationRSSIMinThreshold' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'clientSteeringPostassociationSteeringIsEnabled' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'is80211axEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isGuest' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isHidden' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isIsolateClientsEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'encryptionProtocol' } },
          { kind: 'Field', name: { kind: 'Name', value: 'password' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isBand2GAllowed' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isBand5GAllowed' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isBand6GAllowed' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passwordRotationCadence' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passwordRotationDayOfMonthLocal' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passwordRotationDayOfWeekLocal' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passwordRotationHourOfDayLocal' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passwordLastRotatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passwordNextRotationAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'band2GMinimumBasicRateKbps' } },
          { kind: 'Field', name: { kind: 'Name', value: 'band5GMinimumBasicRateKbps' } },
          { kind: 'Field', name: { kind: 'Name', value: 'band6GMinimumBasicRateKbps' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isEnabledForAllAccessPoints' } },
          { kind: 'Field', name: { kind: 'Name', value: 'roaming80211rIsEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'roaming80211kIsEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'roaming80211vIsEnabled' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'encryption80211wProtectedManagementFramesMode' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hs20HasProfile' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hs20Enabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hs20OperatorNames' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hs20VenueNames' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hs20VenueGroup' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hs20VenueType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hs20AccessNetworkType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hs20RoamingConsortiumOIs' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hs20DomainNames' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hs20NaiRealms' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hs20MccMncPairs' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dynamicVLANMode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'radiusCoaEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'radiusCoaPort' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nasIdentifier' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rtsCtsEnabledCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rtsThreshold' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primaryEncryption8021X' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'secondaryEncryption8021X' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'enabledAccessPointVirtualDevices' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'disabledAccessPointVirtualDevices' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'vlan' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'vlanID' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'broadcastSchedule' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'startDayOfWeek' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startHour' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startMinute' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endDayOfWeek' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endHour' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endMinute' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rateLimitRules' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isPerSource' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rateLimitKbpsUpload' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rateLimitKbpsDownload' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SsidFieldsFragment, unknown>;
export const NetworkThreatObserverFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'NetworkThreatObserverFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'NetworkThreatObserver' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'ssid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'observedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rssi' } },
          { kind: 'Field', name: { kind: 'Name', value: 'noiseFloor' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'virtualDevice' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<NetworkThreatObserverFieldsFragment, unknown>;
export const AutoVpnMemberFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AutoVPNMemberFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AutoVPNMember' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'networkUUID' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'network' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isFailoverEnabled' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'permittedVLANs' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'vlanID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ipV4ClientGateway' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ipV4ClientPrefixLength' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'uplink' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'addressPrefixLength' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hubUplinkUUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'publicKey' } },
                { kind: 'Field', name: { kind: 'Name', value: 'listenPort' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phyInterfaceUUID' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'phyInterface' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'PhyInterfaceLabelFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'connectionInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'observedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastHandshakeRx' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastHandshakeTx' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastPacketTx' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastPacketRx' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhyInterfaceLabelFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PhyInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'portNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hardwareLabel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'virtualDevice' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deviceModel' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'internetServicePlan' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'provider' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AutoVpnMemberFieldsFragment, unknown>;
export const AutoVpnGroupFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AutoVPNGroupFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AutoVPNGroup' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hubNetworkUUID' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hubNetwork' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hubUplink' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'addressPrefixLength' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'phyInterface' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'PhyInterfaceLabelFields' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'listenPort' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isHubFailoverEnabled' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'members' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'AutoVPNMemberFields' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'routes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'dstPrefixLength' } },
                { kind: 'Field', name: { kind: 'Name', value: 'dstGateway' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhyInterfaceLabelFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PhyInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'portNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hardwareLabel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'virtualDevice' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deviceModel' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'internetServicePlan' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'provider' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AutoVPNMemberFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AutoVPNMember' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'networkUUID' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'network' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isFailoverEnabled' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'permittedVLANs' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'vlanID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ipV4ClientGateway' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ipV4ClientPrefixLength' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'uplink' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'addressPrefixLength' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hubUplinkUUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'publicKey' } },
                { kind: 'Field', name: { kind: 'Name', value: 'listenPort' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phyInterfaceUUID' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'phyInterface' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'PhyInterfaceLabelFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'connectionInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'observedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastHandshakeRx' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastHandshakeTx' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastPacketTx' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastPacketRx' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AutoVpnGroupFieldsFragment, unknown>;
export const NetworkForCompanyFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'NetworkForCompanyFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Network' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCustomer' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isTemplate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isTrial' } },
          { kind: 'Field', name: { kind: 'Name', value: 'trialExpiresAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deactivatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'goLiveAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'supportGroup' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'virtualDevices' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deviceModel' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deviceType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hardwareDevice' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'serialNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isSpare' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isConnectedToBackend' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ControllerVirtualDevice' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'highAvailability' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mailingAddress' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'line1' } },
                { kind: 'Field', name: { kind: 'Name', value: 'line2' } },
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subdivisionCode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'postalCode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'countryISO2' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'enabledServiceDiscoveryTypes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pinnedNOSVersionID' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pinnedNOSVersion' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'major' } },
                { kind: 'Field', name: { kind: 'Name', value: 'minor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'patch' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'version' },
                  directives: [
                    {
                      kind: 'Directive',
                      name: { kind: 'Name', value: 'include' },
                      arguments: [
                        {
                          kind: 'Argument',
                          name: { kind: 'Name', value: 'if' },
                          value: {
                            kind: 'Variable',
                            name: { kind: 'Name', value: 'includePinnedNOSVersionInfo' },
                          },
                        },
                      ],
                    },
                  ],
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'isDefault' },
                  directives: [
                    {
                      kind: 'Directive',
                      name: { kind: 'Name', value: 'include' },
                      arguments: [
                        {
                          kind: 'Argument',
                          name: { kind: 'Name', value: 'if' },
                          value: {
                            kind: 'Variable',
                            name: { kind: 'Name', value: 'includePinnedNOSVersionInfo' },
                          },
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<NetworkForCompanyFieldsFragment, unknown>;
export const AlertAuditLogQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AlertAuditLogQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'companyUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'AlertAuditLogFilter' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'alertAuditLogEntriesForCompany' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'companyUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'companyUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'triggeredAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'networkUUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyUUID' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'alertDefinition' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AlertAuditLogQueryQuery, AlertAuditLogQueryQueryVariables>;
export const AutoSwitchConfigurationJobsForNetworkDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AutoSwitchConfigurationJobsForNetwork' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'autoSwitchConfigurationJobsForNetwork' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'networkUUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'virtualDeviceUUIDs' } },
                { kind: 'Field', name: { kind: 'Name', value: 'scheduledAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isDryRun' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AutoSwitchConfigurationJobsForNetworkQuery,
  AutoSwitchConfigurationJobsForNetworkQueryVariables
>;
export const AutoSwitchConfigurationJobDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AutoSwitchConfigurationJob' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'jobUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'autoSwitchConfigurationJob' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'jobUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'jobUUID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'scheduledAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isDryRun' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'results' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'virtualDevice' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'phyInterface' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'portNumber' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'previousNativeVLAN' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'vlanID' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'newNativeVLAN' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'vlanID' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'toggleDirection' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'warnings' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AutoSwitchConfigurationJobQuery,
  AutoSwitchConfigurationJobQueryVariables
>;
export const WanSpeedtestJobsForNetworkDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'wanSpeedtestJobsForNetwork' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'wanSpeedtestJobsForNetwork' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'results' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'direction' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'transferBytes' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'durationNs' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mbps' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'httpRTTsNs' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'failed' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  WanSpeedtestJobsForNetworkQuery,
  WanSpeedtestJobsForNetworkQueryVariables
>;
export const JobsForNetworkDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'JobsForNetwork' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'includeWANSpeedtestJobs' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'includeAutoSwitchConfigurationJobs' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'includePacketCaptureJobs' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'wanSpeedtestJobsForNetwork' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
            ],
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'if' },
                    value: {
                      kind: 'Variable',
                      name: { kind: 'Name', value: 'includeWANSpeedtestJobs' },
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'scheduledAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'results' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'direction' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'autoSwitchConfigurationJobsForNetwork' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
            ],
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'if' },
                    value: {
                      kind: 'Variable',
                      name: { kind: 'Name', value: 'includeAutoSwitchConfigurationJobs' },
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'networkUUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'virtualDeviceUUIDs' } },
                { kind: 'Field', name: { kind: 'Name', value: 'scheduledAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isDryRun' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'packetCaptureJobsForNetwork' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'IntValue', value: '20' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'offset' },
                value: { kind: 'IntValue', value: '0' },
              },
            ],
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'if' },
                    value: {
                      kind: 'Variable',
                      name: { kind: 'Name', value: 'includePacketCaptureJobs' },
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'jobId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stopped' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timeLimitSeconds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'listenOn' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tcpDumpFilter' } },
                { kind: 'Field', name: { kind: 'Name', value: 'virtualDeviceUUID' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<JobsForNetworkQuery, JobsForNetworkQueryVariables>;
export const CompanyMembershipsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CompanyMemberships' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'companyMemberships' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isCustomer' } },
                { kind: 'Field', name: { kind: 'Name', value: 'supportGroup' } },
                { kind: 'Field', name: { kind: 'Name', value: 'websiteDomain' } },
                { kind: 'Field', name: { kind: 'Name', value: 'logoS3Key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'logoDownloadURL' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CompanyMembershipsQuery, CompanyMembershipsQueryVariables>;
export const VisibleMarketingChangelogsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'VisibleMarketingChangelogs' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'visibleMarketingChangelogEntries' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'heading' } },
                { kind: 'Field', name: { kind: 'Name', value: 'copy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'linkURL' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'imageS3Keys' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'lightS3Key' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'darkS3Key' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'badge' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'icon' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  VisibleMarketingChangelogsQuery,
  VisibleMarketingChangelogsQueryVariables
>;
export const ClientVpnServerDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ClientVPNServer' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'UUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'clientVPNServer' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'UUID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ClientVPNServerFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ClientVPNServerFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ClientVPNServer' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endpoint' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publicKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'port' } },
          { kind: 'Field', name: { kind: 'Name', value: 'defaultClientAllowedIPs' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address' } },
          { kind: 'Field', name: { kind: 'Name', value: 'addressMask' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'phyInterface' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PhyInterfaceLabelFields' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'dnsListenAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'defaultClientAllowedIPs' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isFailoverEnabled' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'clients' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ClientVPNClientFields' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'boundVLANs' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'vlanID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ipV4ClientAssignmentProtocol' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ipV4ClientGateway' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ipV4ClientPrefixLength' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ClientVPNClientFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ClientVPNClient' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdBy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ipAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publicKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'userEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'userSID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'vpnServerUUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isConnected' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'connectionInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'observedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastHandshakeTx' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastHandshakeRx' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastPacketTx' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastPacketRx' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhyInterfaceLabelFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PhyInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'portNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hardwareLabel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'virtualDevice' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deviceModel' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'internetServicePlan' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'provider' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ClientVpnServerQuery, ClientVpnServerQueryVariables>;
export const ClientVpnServersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ClientVPNServers' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'clientVPNServers' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ClientVPNServerFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ClientVPNServerFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ClientVPNServer' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endpoint' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publicKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'port' } },
          { kind: 'Field', name: { kind: 'Name', value: 'defaultClientAllowedIPs' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address' } },
          { kind: 'Field', name: { kind: 'Name', value: 'addressMask' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'phyInterface' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PhyInterfaceLabelFields' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'dnsListenAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'defaultClientAllowedIPs' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isFailoverEnabled' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'clients' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ClientVPNClientFields' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'boundVLANs' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'vlanID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ipV4ClientAssignmentProtocol' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ipV4ClientGateway' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ipV4ClientPrefixLength' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ClientVPNClientFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ClientVPNClient' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdBy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ipAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publicKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'userEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'userSID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'vpnServerUUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isConnected' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'connectionInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'observedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastHandshakeTx' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastHandshakeRx' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastPacketTx' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastPacketRx' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhyInterfaceLabelFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PhyInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'portNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hardwareLabel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'virtualDevice' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deviceModel' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'internetServicePlan' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'provider' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ClientVpnServersQuery, ClientVpnServersQueryVariables>;
export const CreateClientVpnServerDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateClientVPNServer' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreateClientVPNServerInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createClientVPNServer' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateClientVpnServerMutation, CreateClientVpnServerMutationVariables>;
export const UpdateClientVpnServerDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateClientVPNServer' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateClientVPNServerInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateClientVPNServer' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateClientVpnServerMutation, UpdateClientVpnServerMutationVariables>;
export const DeleteClientVpnServerDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteClientVPNServer' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteClientVPNServer' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteClientVpnServerMutation, DeleteClientVpnServerMutationVariables>;
export const ClientVpnClientsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ClientVPNClients' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'serverUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'clientVPNClients' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'serverUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'serverUUID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ClientVPNClientFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ClientVPNClientFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ClientVPNClient' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdBy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ipAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publicKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'userEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'userSID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'vpnServerUUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isConnected' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'connectionInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'observedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastHandshakeTx' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastHandshakeRx' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastPacketTx' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastPacketRx' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ClientVpnClientsQuery, ClientVpnClientsQueryVariables>;
export const ClientVpnClientDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ClientVPNClient' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'UUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'clientVPNClient' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'UUID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ClientVPNClientFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ClientVPNClientFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ClientVPNClient' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdBy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ipAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publicKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'userEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'userSID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'vpnServerUUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isConnected' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'connectionInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'observedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastHandshakeTx' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastHandshakeRx' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastPacketTx' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastPacketRx' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ClientVpnClientQuery, ClientVpnClientQueryVariables>;
export const CreateClientVpnClientDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateClientVPNClient' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'serverUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreateClientVPNClientInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createClientVPNClient' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'serverUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'serverUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ipAddress' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'publicKey' } },
                { kind: 'Field', name: { kind: 'Name', value: 'userEmail' } },
                { kind: 'Field', name: { kind: 'Name', value: 'userSID' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateClientVpnClientMutation, CreateClientVpnClientMutationVariables>;
export const UpdateClientVpnClientDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateClientVPNClient' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateClientVPNClientInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateClientVPNClient' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateClientVpnClientMutation, UpdateClientVpnClientMutationVariables>;
export const DeleteClientVpnClientDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteClientVPNClient' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteClientVPNClient' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteClientVpnClientMutation, DeleteClientVpnClientMutationVariables>;
export const CreateRackElevationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateRackElevation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'label' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'rackMountUnitCount' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createRackElevation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'label' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'label' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'rackMountUnitCount' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'rackMountUnitCount' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'networkUUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rackMountUnitCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateRackElevationMutation, CreateRackElevationMutationVariables>;
export const AttachDeviceToRackElevationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AttachDeviceToRackElevation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'rackElevationUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'rackMountUnitIndexes' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'virtualDeviceUUID' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'label' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'type' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'RackElevationDeviceType' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attachDeviceToRackElevation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'rackElevationUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'rackElevationUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'rackMountUnitIndexes' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'rackMountUnitIndexes' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'virtualDeviceUUID' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'virtualDeviceUUID' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'label' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'label' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'type' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'type' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rackMountUnitCount' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'devices' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'rackMountUnitIndexes' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'virtualDeviceUUID' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AttachDeviceToRackElevationMutation,
  AttachDeviceToRackElevationMutationVariables
>;
export const DetachRackElevationDeviceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DetachRackElevationDevice' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'UUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'detachDeviceFromRackElevation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'UUID' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DetachRackElevationDeviceMutation,
  DetachRackElevationDeviceMutationVariables
>;
export const RackElevationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'RackElevation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'UUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rackElevation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'UUID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'RackElevationFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RackElevationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'RackElevation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rackMountUnitCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'networkUUID' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'devices' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rackMountUnitIndexes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'virtualDeviceUUID' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'virtualDevice' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'deviceType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'deviceModel' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hardwareDevice' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'serialNumber' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'deviceType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'deviceModel' } },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'SwitchVirtualDevice' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'phyInterfaces' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'isConnected' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'portNumber' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isEthernet' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isSFP' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'notes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rackMountUnitIndexStart' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rackMountUnitIndexEnd' } },
                { kind: 'Field', name: { kind: 'Name', value: 'note' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RackElevationQuery, RackElevationQueryVariables>;
export const RackElevationsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'RackElevations' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rackElevations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'RackElevationFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RackElevationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'RackElevation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rackMountUnitCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'networkUUID' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'devices' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rackMountUnitIndexes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'virtualDeviceUUID' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'virtualDevice' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'deviceType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'deviceModel' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hardwareDevice' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'serialNumber' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'deviceType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'deviceModel' } },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'SwitchVirtualDevice' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'phyInterfaces' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'isConnected' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'portNumber' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isEthernet' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isSFP' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'notes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rackMountUnitIndexStart' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rackMountUnitIndexEnd' } },
                { kind: 'Field', name: { kind: 'Name', value: 'note' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RackElevationsQuery, RackElevationsQueryVariables>;
export const UpdateRackNotesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateRackNotes' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'rackElevationUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'notes' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'RackElevationNoteInput' } },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateRackElevation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'rackElevationUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'notes' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'notes' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rackMountUnitCount' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'devices' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'rackMountUnitIndexes' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'virtualDeviceUUID' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateRackNotesMutation, UpdateRackNotesMutationVariables>;
export const VirtualDevicesForNetworkDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'VirtualDevicesForNetwork' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'DevicesForNetworkFilter' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'virtualDevicesForNetwork' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'networkUUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deviceType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deviceModel' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hardwareDevice' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'serialNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'deviceType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'deviceModel' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<VirtualDevicesForNetworkQuery, VirtualDevicesForNetworkQueryVariables>;
export const UpdateRackElevationDeviceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateRackElevationDevice' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'UUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateRackElevationDeviceInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateRackElevationDevice' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'UUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rackMountUnitCount' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'devices' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'rackMountUnitIndexes' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'virtualDeviceUUID' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateRackElevationDeviceMutation,
  UpdateRackElevationDeviceMutationVariables
>;
export const UpdateRackElevationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateRackElevation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'UUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateRackElevationInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateRackElevation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'UUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rackMountUnitCount' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateRackElevationMutation, UpdateRackElevationMutationVariables>;
export const DeleteRackElevationMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteRackElevationMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'UUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteRackElevation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'UUID' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteRackElevationMutationMutation,
  DeleteRackElevationMutationMutationVariables
>;
export const DevicesConfigsQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'DevicesConfigsQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'serialNumbers' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deviceConfigs' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'serialNumbers' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'serialNumbers' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'DeviceConfigMetadataFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DeviceConfigMetadataFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DeviceConfigMetadata' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hardwareDevice' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'serialNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deviceType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'virtualDevice' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'acknowledgedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'state' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isCurrentAsOf' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DevicesConfigsQueryQuery, DevicesConfigsQueryQueryVariables>;
export const DeviceConfigsQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'DeviceConfigsQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'serialNumber' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deviceConfigs' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'serialNumber' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'serialNumber' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'DeviceConfigMetadataFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DeviceConfigMetadataFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DeviceConfigMetadata' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hardwareDevice' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'serialNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deviceType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'virtualDevice' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'acknowledgedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'state' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isCurrentAsOf' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeviceConfigsQueryQuery, DeviceConfigsQueryQueryVariables>;
export const DeviceConfigByVersionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'DeviceConfigByVersion' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'serialNumber' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'version' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deviceConfigByVersion' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'serialNumber' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'serialNumber' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'version' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'version' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'acknowledgedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'configJSON' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeviceConfigByVersionQuery, DeviceConfigByVersionQueryVariables>;
export const LatestAcknowledgedDeviceConfigDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'LatestAcknowledgedDeviceConfig' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'serialNumber' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'latestAcknowledgedDeviceConfig' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'serialNumber' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'serialNumber' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'acknowledgedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  LatestAcknowledgedDeviceConfigQuery,
  LatestAcknowledgedDeviceConfigQueryVariables
>;
export const RenderDeviceConfigDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RenderDeviceConfig' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'serialNumber' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'renderDeviceConfig' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'serialNumber' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'serialNumber' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'acknowledgedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'configJSON' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RenderDeviceConfigMutation, RenderDeviceConfigMutationVariables>;
export const SignConsoleChallengeMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SignConsoleChallengeMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'serial' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'challenge' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'signConsoleLoginChallenge' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'serialNumber' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'serial' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'challenge' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'challenge' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'response' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SignConsoleChallengeMutationMutation,
  SignConsoleChallengeMutationMutationVariables
>;
export const CreateVirtualDeviceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createVirtualDevice' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateVirtualDeviceInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createVirtualDevice' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateVirtualDeviceMutation, CreateVirtualDeviceMutationVariables>;
export const UpdateVirtualDeviceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateVirtualDevice' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateVirtualDeviceInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateVirtualDevice' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'virtualDeviceUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateVirtualDeviceMutation, UpdateVirtualDeviceMutationVariables>;
export const DeleteVirtualDeviceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteVirtualDevice' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteVirtualDevice' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'virtualDeviceUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteVirtualDeviceMutation, DeleteVirtualDeviceMutationVariables>;
export const CreateVirtualDevicesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createVirtualDevices' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateVirtualDevicesInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createVirtualDevices' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateVirtualDevicesMutation, CreateVirtualDevicesMutationVariables>;
export const CreateVirtualDevicesIndependentlyDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createVirtualDevicesIndependently' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'inputs' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: { kind: 'Name', value: 'CreateVirtualDeviceInput' },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createVirtualDevicesIndependently' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'inputs' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateVirtualDevicesIndependentlyMutation,
  CreateVirtualDevicesIndependentlyMutationVariables
>;
export const UpdateVirtualDevicesIndependentlyDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateVirtualDevicesIndependently' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'inputs' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: { kind: 'Name', value: 'UpdateVirtualDeviceIndependentlyInput' },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateVirtualDevicesIndependently' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'inputs' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'inputs' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateVirtualDevicesIndependentlyMutation,
  UpdateVirtualDevicesIndependentlyMutationVariables
>;
export const AssignHardwareDeviceToVirtualDeviceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AssignHardwareDeviceToVirtualDevice' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'serialNumber' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'virtualDeviceUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assignHardwareDeviceToVirtualDevice' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'serialNumber' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'serialNumber' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'virtualDeviceUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'virtualDeviceUUID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'virtualDevice' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AssignHardwareDeviceToVirtualDeviceMutation,
  AssignHardwareDeviceToVirtualDeviceMutationVariables
>;
export const CreateDevHardwareDeviceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateDevHardwareDevice' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreateDevHardwareDeviceInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createDevHardwareDevice' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'serialNumber' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateDevHardwareDeviceMutation,
  CreateDevHardwareDeviceMutationVariables
>;
export const AssignHardwareDeviceToNetworkDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AssignHardwareDeviceToNetwork' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'serialNumber' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assignHardwareDeviceToNetwork' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'serialNumber' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'serialNumber' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'virtualDevice' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AssignHardwareDeviceToNetworkMutation,
  AssignHardwareDeviceToNetworkMutationVariables
>;
export const UnassignHardwareDeviceFromVirtualDeviceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UnassignHardwareDeviceFromVirtualDevice' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'serialNumber' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'assignAsSpare' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
          defaultValue: { kind: 'BooleanValue', value: false },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'unassignHardwareDeviceFromVirtualDevice' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'serialNumber' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'serialNumber' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'assignAsSpare' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'assignAsSpare' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'serialNumber' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UnassignHardwareDeviceFromVirtualDeviceMutation,
  UnassignHardwareDeviceFromVirtualDeviceMutationVariables
>;
export const AssignHardwareToVirtualDevicesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AssignHardwareToVirtualDevices' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'inputs' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: { kind: 'Name', value: 'AssignHardwareDeviceToVirtualDeviceInput' },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assignHardwareDevicesToVirtualDevices' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'inputs' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'inputs' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'serialNumber' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'virtualDevice' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AssignHardwareToVirtualDevicesMutation,
  AssignHardwareToVirtualDevicesMutationVariables
>;
export const HardwareDeviceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'HardwareDevice' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'serialNumber' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hardwareDevice' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'serialNumber' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'serialNumber' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'serialNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deviceType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deviceModel' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'virtualDevice' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<HardwareDeviceQuery, HardwareDeviceQueryVariables>;
export const UpdateHardwareDeviceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateHardwareDevice' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'serialNumber' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateHardwareDeviceInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateHardwareDevice' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'serialNumber' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'serialNumber' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'serialNumber' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateHardwareDeviceMutation, UpdateHardwareDeviceMutationVariables>;
export const BlinkLeDsMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'BlinkLEDsMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'serialNumber' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rpcBlinkLEDs' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'serialNumber' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'serialNumber' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'durationSec' },
                value: { kind: 'IntValue', value: '10' },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BlinkLeDsMutationMutation, BlinkLeDsMutationMutationVariables>;
export const RefreshConfigMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RefreshConfigMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'serialNumber' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rpcRefreshConfig' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'serialNumber' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'serialNumber' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RefreshConfigMutationMutation, RefreshConfigMutationMutationVariables>;
export const ClearBlockedConfigsMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ClearBlockedConfigsMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'serialNumber' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rpcClearBlockedConfigs' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'serialNumber' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'serialNumber' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ClearBlockedConfigsMutationMutation,
  ClearBlockedConfigsMutationMutationVariables
>;
export const RpcPduOutletCycleMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RpcPDUOutletCycleMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'serialNumber' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'RPCPDUOutletCycleInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rpcPDUOutletCycle' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'serialNumber' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'serialNumber' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RpcPduOutletCycleMutationMutation,
  RpcPduOutletCycleMutationMutationVariables
>;
export const LatestDeviceMemoryUsageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'LatestDeviceMemoryUsage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'serialNumber' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'latestDeviceMemoryUsage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'serialNumber' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'serialNumber' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'bytesUsed' } },
                { kind: 'Field', name: { kind: 'Name', value: 'bytesAvailable' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LatestDeviceMemoryUsageQuery, LatestDeviceMemoryUsageQueryVariables>;
export const DeviceUptimeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'DeviceUptime' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'serialNumber' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deviceUptime' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'serialNumber' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'serialNumber' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeviceUptimeQuery, DeviceUptimeQueryVariables>;
export const LatestDeviceCpuLoadDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'LatestDeviceCPULoad' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'serialNumber' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'latestDeviceCPULoad' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'serialNumber' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'serialNumber' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'usedPercentage' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LatestDeviceCpuLoadQuery, LatestDeviceCpuLoadQueryVariables>;
export const SwitchPoEInfoDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SwitchPoEInfo' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'serialNumber' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hardwareDevice' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'serialNumber' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'serialNumber' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SwitchHardwareDevice' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'poeInfo' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'max' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'used' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SwitchPoEInfoQuery, SwitchPoEInfoQueryVariables>;
export const SwitchVirtualDevicePoEInfoDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SwitchVirtualDevicePoEInfo' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'virtualDevice' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SwitchVirtualDevice' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'poeInfo' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'max' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'used' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SwitchVirtualDevicePoEInfoQuery,
  SwitchVirtualDevicePoEInfoQueryVariables
>;
export const SystemInfoStatQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SystemInfoStatQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'systemInfoStatForVirtualDevice' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'virtualDeviceUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'durationSeconds' },
                      value: { kind: 'IntValue', value: '300' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'limit' },
                      value: { kind: 'IntValue', value: '1' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uptime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'memoryBytesAvailable' } },
                { kind: 'Field', name: { kind: 'Name', value: 'memoryBytesTotal' } },
                { kind: 'Field', name: { kind: 'Name', value: 'cpuUsedPercentage' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SystemInfoStatQueryQuery, SystemInfoStatQueryQueryVariables>;
export const UpdatePhyInterfaceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdatePhyInterface' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdatePhyInterfaceInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updatePhyInterface' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdatePhyInterfaceMutation, UpdatePhyInterfaceMutationVariables>;
export const UpdatePhyInterfacesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdatePhyInterfaces' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'phyInterfaceUUIDs' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'virtualDeviceUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdatePhyInterfaceInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updatePhyInterfaces' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'phyInterfaceUUIDs' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'phyInterfaceUUIDs' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'virtualDeviceUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'virtualDeviceUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdatePhyInterfacesMutation, UpdatePhyInterfacesMutationVariables>;
export const UpdatePhyInterfacesIndependentlyDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdatePhyInterfacesIndependently' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'inputs' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: { kind: 'Name', value: 'UpdatePhyInterfacesIndependentlyInput' },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updatePhyInterfacesIndependently' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'inputs' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'inputs' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdatePhyInterfacesIndependentlyMutation,
  UpdatePhyInterfacesIndependentlyMutationVariables
>;
export const SpareHardwareDevicesForNetworkDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SpareHardwareDevicesForNetwork' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'HardwareDevicesFilter' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'spareHardwareDevicesForNetwork' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'serialNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deviceModel' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deviceType' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SpareHardwareDevicesForNetworkQuery,
  SpareHardwareDevicesForNetworkQueryVariables
>;
export const AssignHardwareDeviceAsSpareDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AssignHardwareDeviceAsSpare' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'serialNumber' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assignHardwareDeviceToNetworkAsSpare' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'serialNumber' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'serialNumber' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'serialNumber' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AssignHardwareDeviceAsSpareMutation,
  AssignHardwareDeviceAsSpareMutationVariables
>;
export const UnassignSpareHardwareDeviceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UnassignSpareHardwareDevice' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'serialNumber' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'unassignSpareHardwareDeviceFromNetwork' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'serialNumber' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'serialNumber' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'serialNumber' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UnassignSpareHardwareDeviceMutation,
  UnassignSpareHardwareDeviceMutationVariables
>;
export const FloorPlansForNetworkDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'FloorPlansForNetwork' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'floorPlansForNetwork' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'imageS3Key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'imageDownloadURL' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FloorPlansForNetworkQuery, FloorPlansForNetworkQueryVariables>;
export const FloorPlanDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'FloorPlan' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'UUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'floorPlan' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'UUID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'imageS3Key' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FloorPlanQuery, FloorPlanQueryVariables>;
export const CreateFloorPlanDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateFloorPlan' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateFloorPlanInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createFloorPlan' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateFloorPlanMutation, CreateFloorPlanMutationVariables>;
export const UpdateFloorPlanDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateFloorPlan' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'UUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateFloorPlanInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateFloorPlan' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'UUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateFloorPlanMutation, UpdateFloorPlanMutationVariables>;
export const DeleteFloorPlanDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteFloorPlan' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'UUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteFloorPlan' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'UUID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteFloorPlanMutation, DeleteFloorPlanMutationVariables>;
export const ApbssiDsQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'APBSSIDsQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'virtualDeviceUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'virtualDevice' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'virtualDeviceUUID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hardwareDevice' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'AccessPointHardwareDevice' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'BSSIDs' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'SSID' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'ssid' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'isHidden' },
                                        },
                                      ],
                                    },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'BSSID' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'radioBand' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ApbssiDsQueryQuery, ApbssiDsQueryQueryVariables>;
export const ApBootHistoryQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'APBootHistoryQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'serialNumber' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'count' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hardwareDevice' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'serialNumber' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'serialNumber' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'bootHistory' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'count' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'count' } },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'bootCount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'buildName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'rebootReason' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ApBootHistoryQueryQuery, ApBootHistoryQueryQueryVariables>;
export const RebootAccessPointDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RebootAccessPoint' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'serialNumber' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rpcRebootDevice' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'serialNumber' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'serialNumber' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RebootAccessPointMutation, RebootAccessPointMutationVariables>;
export const RebootAccessPointsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RebootAccessPoints' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'serialNumbers' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rpcRebootDevices' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'serialNumbers' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'serialNumbers' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'error' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'serialNumber' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RebootAccessPointsMutation, RebootAccessPointsMutationVariables>;
export const RunAcsForAccessPointsMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RunACSForAccessPointsMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'virtualDeviceUUIDs' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AutoChannelSelectionJobInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'initializeAutoChannelSelectionForAccessPoints' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'virtualDeviceUUIDs' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'virtualDeviceUUIDs' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'scheduledAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timeoutAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RunAcsForAccessPointsMutationMutation,
  RunAcsForAccessPointsMutationMutationVariables
>;
export const RunAcsForNetworkMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RunACSForNetworkMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AutoChannelSelectionJobInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'initializeAutoChannelSelectionForNetwork' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'scheduledAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timeoutAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RunAcsForNetworkMutationMutation,
  RunAcsForNetworkMutationMutationVariables
>;
export const AcsJobsForNetworkQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ACSJobsForNetworkQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'autoChannelSelectionJobsForNetwork' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'networkUUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'scheduledAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timeoutAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'virtualDeviceUUIDs' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'results' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'virtualDeviceUUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'resultType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'previous5GHzChannel' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'new5GHzChannel' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AcsJobsForNetworkQueryQuery, AcsJobsForNetworkQueryQueryVariables>;
export const CancelAcsJobMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CancelACSJobMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'jobUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cancelAutoChannelSelectionJob' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'jobUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'jobUUID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CancelAcsJobMutationMutation, CancelAcsJobMutationMutationVariables>;
export const ScanDataForNetworkDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ScanDataForNetwork' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'durationSeconds' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'virtualDeviceUUID' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scanDataForNetwork' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'virtualDeviceUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'virtualDeviceUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'durationSeconds' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'durationSeconds' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'observedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'BSSID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'SSID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'band' } },
                { kind: 'Field', name: { kind: 'Name', value: 'radio' } },
                { kind: 'Field', name: { kind: 'Name', value: 'channel' } },
                { kind: 'Field', name: { kind: 'Name', value: 'channelWidth' } },
                { kind: 'Field', name: { kind: 'Name', value: 'RSSI' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'virtualDevice' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'deviceModel' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ScanDataForNetworkQuery, ScanDataForNetworkQueryVariables>;
export const InstallStatusQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'InstallStatusQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'includeIsDev' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          defaultValue: { kind: 'BooleanValue', value: false },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'includeConfigMetadata' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          defaultValue: { kind: 'BooleanValue', value: false },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'virtualDevicesForNetwork' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'network' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'uptime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deviceType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nosVersion' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'buildName' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pendingNosVersion' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nosVersion' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'version' } }],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'scheduledAt' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SwitchVirtualDevice' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'phyInterfaces' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'PhyInterfaceFieldsForInstallStatus' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'switchProfile' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'stpBridgePriority' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'switchingTier' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ControllerVirtualDevice' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'phyInterfaces' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'PhyInterfaceFieldsForInstallStatus' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'highAvailability' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'PowerDistributionUnitVirtualDevice' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'ipAddress' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hardwareDevice' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'hardwareDeviceFieldsForInstallStatus' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DeviceConfigMetadataFieldsForDeviceListBadge' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DeviceConfigMetadata' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'acknowledgedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'state' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isCurrentAsOf' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhyInterfaceFieldsForInstallStatus' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PhyInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isEthernet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isSFP' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isUplink' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isUplinkActive' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isConnected' } },
          { kind: 'Field', name: { kind: 'Name', value: 'portSpeedMbps' } },
          { kind: 'Field', name: { kind: 'Name', value: 'maxSpeedMbps' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isFLIPEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isVoiceVLANEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'powerDraw' } },
          { kind: 'Field', name: { kind: 'Name', value: 'poeType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasWANActivity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'portNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isTrunkPort' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isBoundToAllVLANs' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sfpModuleInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'moduleSpeedKbps' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'virtualDevice' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deviceType' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'connectedDevices' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'macAddress' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hardwareDevice' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'virtualDevice' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'deviceType' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'hardwareDeviceFieldsForInstallStatus' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'HardwareDevice' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deviceType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'serialNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'macAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isConnectedToBackend' } },
          { kind: 'Field', name: { kind: 'Name', value: 'disconnectedFromBackendAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'bootHistory' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'count' },
                value: { kind: 'IntValue', value: '5' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'buildName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'isDev' },
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'if' },
                    value: { kind: 'Variable', name: { kind: 'Name', value: 'includeIsDev' } },
                  },
                ],
              },
            ],
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AccessPointHardwareDevice' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'ipAddress' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isInCurrentControllerMACTable' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'phyInterfaceConnectedTo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'PhyInterfaceFieldsForInstallStatus' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SwitchHardwareDevice' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'ipAddress' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isInCurrentControllerMACTable' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'latestDeviceConfigMetadata' },
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'if' },
                    value: {
                      kind: 'Variable',
                      name: { kind: 'Name', value: 'includeConfigMetadata' },
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'DeviceConfigMetadataFieldsForDeviceListBadge' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<InstallStatusQueryQuery, InstallStatusQueryQueryVariables>;
export const StatusPageVlaNsQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'StatusPageVLANsQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'vlans' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ipV4ClientGateway' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ipV4ClientPrefixLength' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<StatusPageVlaNsQueryQuery, StatusPageVlaNsQueryQueryVariables>;
export const RebootObserverDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RebootObserver' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'serialNumber' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rpcRebootDevice' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'serialNumber' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'serialNumber' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RebootObserverMutation, RebootObserverMutationVariables>;
export const OutletTopologyLayoutPowerDistributionUnitsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'OutletTopologyLayoutPowerDistributionUnits' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'network' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'company' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'virtualDevices' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'filter' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'deviceType' },
                            value: { kind: 'EnumValue', value: 'POWER_DISTRIBUTION_UNIT' },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'PowerDistributionUnitVirtualDevice' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'outletInterfaces' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'outletNumber' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'connectedVirtualDevice' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  OutletTopologyLayoutPowerDistributionUnitsQuery,
  OutletTopologyLayoutPowerDistributionUnitsQueryVariables
>;
export const PduMetricsQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PduMetricsQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'virtualDeviceUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'MetricsFilterInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pduMetrics' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'virtualDeviceUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'virtualDeviceUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'temperatureCelsius' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'metadata' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'minValue' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'maxValue' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'values' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'outlets' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'outlet' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'outletNumber' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'powerWatts' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'metadata' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'minValue' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'maxValue' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'values' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'voltageVolts' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'metadata' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'minValue' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'maxValue' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'values' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'currentAmps' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'metadata' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'minValue' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'maxValue' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'values' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'frequencyHz' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'metadata' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'minValue' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'maxValue' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'values' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PduMetricsQueryQuery, PduMetricsQueryQueryVariables>;
export const RebootPowerDistributionUnitDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RebootPowerDistributionUnit' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'serialNumber' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rpcRebootDevice' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'serialNumber' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'serialNumber' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RebootPowerDistributionUnitMutation,
  RebootPowerDistributionUnitMutationVariables
>;
export const FallbackPowerDistributionUnitHardwareQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'FallbackPowerDistributionUnitHardwareQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'serialNumber' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hardwareDevice' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'serialNumber' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'serialNumber' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'serialNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'virtualDeviceUUID' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FallbackPowerDistributionUnitHardwareQueryQuery,
  FallbackPowerDistributionUnitHardwareQueryQueryVariables
>;
export const PowerDistributionUnitQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PowerDistributionUnitQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'includeNOS' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          defaultValue: { kind: 'BooleanValue', value: false },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'virtualDevice' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'network' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'networkUUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isConsoleEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deviceType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deviceModel' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nosUpgradeGroup' },
                  directives: [
                    {
                      kind: 'Directive',
                      name: { kind: 'Name', value: 'include' },
                      arguments: [
                        {
                          kind: 'Argument',
                          name: { kind: 'Name', value: 'if' },
                          value: { kind: 'Variable', name: { kind: 'Name', value: 'includeNOS' } },
                        },
                      ],
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nosVersion' },
                  directives: [
                    {
                      kind: 'Directive',
                      name: { kind: 'Name', value: 'include' },
                      arguments: [
                        {
                          kind: 'Argument',
                          name: { kind: 'Name', value: 'if' },
                          value: { kind: 'Variable', name: { kind: 'Name', value: 'includeNOS' } },
                        },
                      ],
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'buildName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pendingNosVersion' },
                  directives: [
                    {
                      kind: 'Directive',
                      name: { kind: 'Name', value: 'include' },
                      arguments: [
                        {
                          kind: 'Argument',
                          name: { kind: 'Name', value: 'if' },
                          value: { kind: 'Variable', name: { kind: 'Name', value: 'includeNOS' } },
                        },
                      ],
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nosVersion' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'version' } }],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'scheduledAt' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'uptime' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'PowerDistributionUnitVirtualDevice' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'ipAddress' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'ethernetSpeedMbps' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isCircuitBreakerGood' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isGrounded' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isReadonly' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isSurgeProtectionGood' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'outletInterfaces' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'OutletInterfaceFields' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hardwareDevice' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isConnectedToBackend' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'disconnectedFromBackendAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'macAddress' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'deviceModel' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'serialNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'deviceType' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'bootHistory' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'count' },
                            value: { kind: 'IntValue', value: '20' },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'bootCount' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'buildName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'rebootReason' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'PowerDistributionUnitHardwareDevice' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'phyInterfaceConnectedTo' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'portNumber' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'virtualDevice' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OutletInterfaceFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'OutletInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'outletNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'virtualDeviceUUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'powerCycleDelaySec' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentAmps' } },
          { kind: 'Field', name: { kind: 'Name', value: 'powerWatts' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'connectedVirtualDevice' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deviceType' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PowerDistributionUnitQueryQuery,
  PowerDistributionUnitQueryQueryVariables
>;
export const PowerDistributionUnitsQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PowerDistributionUnitsQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'companySlug' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUIDs' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'includeIsDev' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          defaultValue: { kind: 'BooleanValue', value: false },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'includeNOS' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          defaultValue: { kind: 'BooleanValue', value: false },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'includeConfigMetadata' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          defaultValue: { kind: 'BooleanValue', value: false },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'companyBySlug' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'slug' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'companySlug' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'networks' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'filter' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'networkUUIDs' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'networkUUIDs' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'virtualDevices' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'filter' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'deviceType' },
                                  value: { kind: 'EnumValue', value: 'POWER_DISTRIBUTION_UNIT' },
                                },
                              ],
                            },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'network' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'deviceType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'deviceModel' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'nosUpgradeGroup' },
                              directives: [
                                {
                                  kind: 'Directive',
                                  name: { kind: 'Name', value: 'include' },
                                  arguments: [
                                    {
                                      kind: 'Argument',
                                      name: { kind: 'Name', value: 'if' },
                                      value: {
                                        kind: 'Variable',
                                        name: { kind: 'Name', value: 'includeNOS' },
                                      },
                                    },
                                  ],
                                },
                              ],
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'nosVersion' },
                              directives: [
                                {
                                  kind: 'Directive',
                                  name: { kind: 'Name', value: 'include' },
                                  arguments: [
                                    {
                                      kind: 'Argument',
                                      name: { kind: 'Name', value: 'if' },
                                      value: {
                                        kind: 'Variable',
                                        name: { kind: 'Name', value: 'includeNOS' },
                                      },
                                    },
                                  ],
                                },
                              ],
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'buildName' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'pendingNosVersion' },
                              directives: [
                                {
                                  kind: 'Directive',
                                  name: { kind: 'Name', value: 'include' },
                                  arguments: [
                                    {
                                      kind: 'Argument',
                                      name: { kind: 'Name', value: 'if' },
                                      value: {
                                        kind: 'Variable',
                                        name: { kind: 'Name', value: 'includeNOS' },
                                      },
                                    },
                                  ],
                                },
                              ],
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'nosVersion' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                                      ],
                                    },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'scheduledAt' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'uptime' } },
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: { kind: 'Name', value: 'PowerDistributionUnitVirtualDevice' },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'ipAddress' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'ethernetSpeedMbps' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'isCircuitBreakerGood' },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isGrounded' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isReadonly' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'isSurgeProtectionGood' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'outletInterfaces' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'FragmentSpread',
                                          name: { kind: 'Name', value: 'OutletInterfaceFields' },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'hardwareDevice' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'deviceType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'deviceModel' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'serialNumber' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'macAddress' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'isConnectedToBackend' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'disconnectedFromBackendAt' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'bootHistory' },
                                    arguments: [
                                      {
                                        kind: 'Argument',
                                        name: { kind: 'Name', value: 'count' },
                                        value: { kind: 'IntValue', value: '1' },
                                      },
                                    ],
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'buildName' },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'isDev' },
                                    directives: [
                                      {
                                        kind: 'Directive',
                                        name: { kind: 'Name', value: 'include' },
                                        arguments: [
                                          {
                                            kind: 'Argument',
                                            name: { kind: 'Name', value: 'if' },
                                            value: {
                                              kind: 'Variable',
                                              name: { kind: 'Name', value: 'includeIsDev' },
                                            },
                                          },
                                        ],
                                      },
                                    ],
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'latestDeviceConfigMetadata' },
                                    directives: [
                                      {
                                        kind: 'Directive',
                                        name: { kind: 'Name', value: 'include' },
                                        arguments: [
                                          {
                                            kind: 'Argument',
                                            name: { kind: 'Name', value: 'if' },
                                            value: {
                                              kind: 'Variable',
                                              name: {
                                                kind: 'Name',
                                                value: 'includeConfigMetadata',
                                              },
                                            },
                                          },
                                        ],
                                      },
                                    ],
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'FragmentSpread',
                                          name: {
                                            kind: 'Name',
                                            value: 'DeviceConfigMetadataFieldsForDeviceListBadge',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DeviceConfigMetadataFieldsForDeviceListBadge' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DeviceConfigMetadata' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'acknowledgedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'state' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isCurrentAsOf' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OutletInterfaceFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'OutletInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'outletNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'virtualDeviceUUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'powerCycleDelaySec' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentAmps' } },
          { kind: 'Field', name: { kind: 'Name', value: 'powerWatts' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'connectedVirtualDevice' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deviceType' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PowerDistributionUnitsQueryQuery,
  PowerDistributionUnitsQueryQueryVariables
>;
export const DeviceHeartbeatForDeviceQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'deviceHeartbeatForDeviceQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'serialNumber' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deviceHeartbeatForDevice' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'serialNumber' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'serialNumber' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'token' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeviceHeartbeatForDeviceQueryQuery,
  DeviceHeartbeatForDeviceQueryQueryVariables
>;
export const UpdateOutletInterfaceMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateOutletInterfaceMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateOutletInterfaceInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateOutletInterface' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateOutletInterfaceMutationMutation,
  UpdateOutletInterfaceMutationMutationVariables
>;
export const UpdateOutletInterfacesIndependentlyDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateOutletInterfacesIndependently' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'inputs' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: { kind: 'Name', value: 'UpdateOutletInterfacesIndependentlyInput' },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateOutletInterfacesIndependently' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'inputs' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'inputs' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateOutletInterfacesIndependentlyMutation,
  UpdateOutletInterfacesIndependentlyMutationVariables
>;
export const UpdateSecurityApplianceProfilesMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateSecurityApplianceProfilesMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateSecurityApplianceProfileInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateSecurityApplianceProfilesForNetwork' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateSecurityApplianceProfilesMutationMutation,
  UpdateSecurityApplianceProfilesMutationMutationVariables
>;
export const UpdateSecurityApplianceProfileMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateSecurityApplianceProfileMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'UUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateSecurityApplianceProfileInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateSecurityApplianceProfile' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'UUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateSecurityApplianceProfileMutationMutation,
  UpdateSecurityApplianceProfileMutationMutationVariables
>;
export const RebootSecurityApplianceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RebootSecurityAppliance' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'serialNumber' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rpcRebootDevice' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'serialNumber' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'serialNumber' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RebootSecurityApplianceMutation,
  RebootSecurityApplianceMutationVariables
>;
export const ControllersQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ControllersQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'includeNOS' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'virtualDevicesForNetwork' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'deviceType' },
                      value: { kind: 'EnumValue', value: 'CONTROLLER' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deviceType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deviceModel' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uptime' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nosVersion' },
                  directives: [
                    {
                      kind: 'Directive',
                      name: { kind: 'Name', value: 'include' },
                      arguments: [
                        {
                          kind: 'Argument',
                          name: { kind: 'Name', value: 'if' },
                          value: { kind: 'Variable', name: { kind: 'Name', value: 'includeNOS' } },
                        },
                      ],
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'buildName' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hardwareDevice' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'deviceType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'serialNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'macAddress' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isConnectedToBackend' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'disconnectedFromBackendAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'bootHistory' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'count' },
                            value: { kind: 'IntValue', value: '1' },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'buildName' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ControllersQueryQuery, ControllersQueryQueryVariables>;
export const HaConfigForNetworkQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'HAConfigForNetworkQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'network' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'highAvailabilityConfig' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'primaryPhyInterface' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'portNumber' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'virtualDevice' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'deviceType' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'hardwareDevice' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'isConnectedToBackend' },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'backupPhyInterface' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'portNumber' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'virtualDevice' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'deviceType' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'hardwareDevice' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'isConnectedToBackend' },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'advertisementVLAN' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'vlanID' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'preemption' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'advertisementIntervalMs' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<HaConfigForNetworkQueryQuery, HaConfigForNetworkQueryQueryVariables>;
export const ControllerForSecurityApplianceQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ControllerForSecurityApplianceQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'includeIsDev' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          defaultValue: { kind: 'BooleanValue', value: false },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'includeSecurityApplianceProfile' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          defaultValue: { kind: 'BooleanValue', value: false },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'includeManagementConnection' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          defaultValue: { kind: 'BooleanValue', value: false },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'includeNOS' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          defaultValue: { kind: 'BooleanValue', value: false },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'includeConfigMetadata' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          defaultValue: { kind: 'BooleanValue', value: false },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'virtualDevice' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'network' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ControllerFragment' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ControllerVirtualDevice' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'ControllerVirtualDeviceFragment' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'phyInterfaces' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'ControllerPhyInterfaceFields' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DeviceConfigMetadataFieldsForDeviceListBadge' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DeviceConfigMetadata' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'acknowledgedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'state' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isCurrentAsOf' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ControllerFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'VirtualDevice' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deviceType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deviceModel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isConsoleEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'networkUUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'uptime' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'nosUpgradeGroup' },
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'if' },
                    value: { kind: 'Variable', name: { kind: 'Name', value: 'includeNOS' } },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'nosVersion' },
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'if' },
                    value: { kind: 'Variable', name: { kind: 'Name', value: 'includeNOS' } },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'buildName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pendingNosVersion' },
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'if' },
                    value: { kind: 'Variable', name: { kind: 'Name', value: 'includeNOS' } },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nosVersion' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'version' } }],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'scheduledAt' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hardwareDevice' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deviceType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'serialNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'macAddress' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deviceModel' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isConnectedToBackend' } },
                { kind: 'Field', name: { kind: 'Name', value: 'disconnectedFromBackendAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'bootHistory' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'count' },
                      value: { kind: 'IntValue', value: '20' },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'bootCount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'buildName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'rebootReason' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'isDev' },
                  directives: [
                    {
                      kind: 'Directive',
                      name: { kind: 'Name', value: 'include' },
                      arguments: [
                        {
                          kind: 'Argument',
                          name: { kind: 'Name', value: 'if' },
                          value: {
                            kind: 'Variable',
                            name: { kind: 'Name', value: 'includeIsDev' },
                          },
                        },
                      ],
                    },
                  ],
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'latestDeviceConfigMetadata' },
                  directives: [
                    {
                      kind: 'Directive',
                      name: { kind: 'Name', value: 'include' },
                      arguments: [
                        {
                          kind: 'Argument',
                          name: { kind: 'Name', value: 'if' },
                          value: {
                            kind: 'Variable',
                            name: { kind: 'Name', value: 'includeConfigMetadata' },
                          },
                        },
                      ],
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'DeviceConfigMetadataFieldsForDeviceListBadge',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ControllerVirtualDevice' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'highAvailability' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'securityApplianceProfile' },
                  directives: [
                    {
                      kind: 'Directive',
                      name: { kind: 'Name', value: 'include' },
                      arguments: [
                        {
                          kind: 'Argument',
                          name: { kind: 'Name', value: 'if' },
                          value: {
                            kind: 'Variable',
                            name: { kind: 'Name', value: 'includeSecurityApplianceProfile' },
                          },
                        },
                      ],
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'multiWANAlgorithm' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'multiWANUpdateLookback' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'multiWANUpdateThreshold' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'multiWANUpdateCooldownSec' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hostMonitoringTimeoutSec' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hostMonitoringIntervalSec' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'managementConnection' },
                  directives: [
                    {
                      kind: 'Directive',
                      name: { kind: 'Name', value: 'include' },
                      arguments: [
                        {
                          kind: 'Argument',
                          name: { kind: 'Name', value: 'if' },
                          value: {
                            kind: 'Variable',
                            name: { kind: 'Name', value: 'includeManagementConnection' },
                          },
                        },
                      ],
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'connectionType' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ControllerVirtualDeviceFragment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ControllerVirtualDevice' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'highAvailability' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'outletInterfaceConnectedTo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'outletNumber' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'virtualDevice' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'phyInterfaces' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isConnected' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isSFP' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isTrunkPort' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isUplink' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'portNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'portSpeedMbps' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'connectedDevices' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hardwareDevice' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'deviceModel' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'deviceType' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'virtualDevice' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'deviceType' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'phyInterface' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'portNumber' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'hasWANActivity' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'internetServicePlan' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'controllerIP' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'provider' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'logoURL' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ControllerPhyInterfaceFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PhyInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'virtualDeviceUUID' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'virtualDevice' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deviceModel' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'portNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hardwareLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'forcedSpeedAllowed' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isTrunkPort' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isUplink' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isEthernet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isSFP' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isConnected' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasWANActivity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'forcedPortSpeedMbps' } },
          { kind: 'Field', name: { kind: 'Name', value: 'portSpeedMbps' } },
          { kind: 'Field', name: { kind: 'Name', value: 'maxSpeedMbps' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ipv4ClientAssignmentProtocol' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ipv4ClientGateway' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ipv4ClientPrefixLength' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ipv4ClientAddresses' } },
          { kind: 'Field', name: { kind: 'Name', value: 'uplinkPriority' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'nativeVLAN' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'vlanID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'connectedDevices' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'macAddress' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hardwareDevice' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'serialNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isConnectedToBackend' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'deviceType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'deviceModel' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'virtualDevice' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'deviceType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'phyInterface' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'portNumber' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'uplinkExternalAddresses' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasWANActivity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isUplinkActive' } },
          { kind: 'Field', name: { kind: 'Name', value: 'uplinkVLANID' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'internetServicePlan' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'controllerIP' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'provider' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'logoURL' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'uplinkGatewayMACAddress' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sfpModuleInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'moduleSpeedKbps' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ControllerForSecurityApplianceQueryQuery,
  ControllerForSecurityApplianceQueryQueryVariables
>;
export const ControllersForSecurityApplianceQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ControllersForSecurityApplianceQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'companySlug' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUIDs' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'includeIsDev' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          defaultValue: { kind: 'BooleanValue', value: false },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'includeSecurityApplianceProfile' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          defaultValue: { kind: 'BooleanValue', value: false },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'includeManagementConnection' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          defaultValue: { kind: 'BooleanValue', value: false },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'includeNOS' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          defaultValue: { kind: 'BooleanValue', value: false },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'includeConfigMetadata' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          defaultValue: { kind: 'BooleanValue', value: false },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'companyBySlug' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'slug' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'companySlug' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'networks' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'filter' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'networkUUIDs' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'networkUUIDs' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'virtualDevices' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'filter' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'deviceType' },
                                  value: { kind: 'EnumValue', value: 'CONTROLLER' },
                                },
                              ],
                            },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'network' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                ],
                              },
                            },
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'ControllerFragment' },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: { kind: 'Name', value: 'ControllerVirtualDevice' },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'FragmentSpread',
                                    name: {
                                      kind: 'Name',
                                      value: 'ControllerVirtualDeviceFragment',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'phyInterfaces' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'FragmentSpread',
                                          name: {
                                            kind: 'Name',
                                            value: 'ControllerPhyInterfaceFields',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DeviceConfigMetadataFieldsForDeviceListBadge' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DeviceConfigMetadata' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'acknowledgedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'state' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isCurrentAsOf' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ControllerFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'VirtualDevice' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deviceType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deviceModel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isConsoleEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'networkUUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'uptime' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'nosUpgradeGroup' },
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'if' },
                    value: { kind: 'Variable', name: { kind: 'Name', value: 'includeNOS' } },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'nosVersion' },
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'if' },
                    value: { kind: 'Variable', name: { kind: 'Name', value: 'includeNOS' } },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'buildName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pendingNosVersion' },
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'if' },
                    value: { kind: 'Variable', name: { kind: 'Name', value: 'includeNOS' } },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nosVersion' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'version' } }],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'scheduledAt' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hardwareDevice' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deviceType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'serialNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'macAddress' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deviceModel' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isConnectedToBackend' } },
                { kind: 'Field', name: { kind: 'Name', value: 'disconnectedFromBackendAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'bootHistory' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'count' },
                      value: { kind: 'IntValue', value: '20' },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'bootCount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'buildName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'rebootReason' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'isDev' },
                  directives: [
                    {
                      kind: 'Directive',
                      name: { kind: 'Name', value: 'include' },
                      arguments: [
                        {
                          kind: 'Argument',
                          name: { kind: 'Name', value: 'if' },
                          value: {
                            kind: 'Variable',
                            name: { kind: 'Name', value: 'includeIsDev' },
                          },
                        },
                      ],
                    },
                  ],
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'latestDeviceConfigMetadata' },
                  directives: [
                    {
                      kind: 'Directive',
                      name: { kind: 'Name', value: 'include' },
                      arguments: [
                        {
                          kind: 'Argument',
                          name: { kind: 'Name', value: 'if' },
                          value: {
                            kind: 'Variable',
                            name: { kind: 'Name', value: 'includeConfigMetadata' },
                          },
                        },
                      ],
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'DeviceConfigMetadataFieldsForDeviceListBadge',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ControllerVirtualDevice' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'highAvailability' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'securityApplianceProfile' },
                  directives: [
                    {
                      kind: 'Directive',
                      name: { kind: 'Name', value: 'include' },
                      arguments: [
                        {
                          kind: 'Argument',
                          name: { kind: 'Name', value: 'if' },
                          value: {
                            kind: 'Variable',
                            name: { kind: 'Name', value: 'includeSecurityApplianceProfile' },
                          },
                        },
                      ],
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'multiWANAlgorithm' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'multiWANUpdateLookback' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'multiWANUpdateThreshold' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'multiWANUpdateCooldownSec' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hostMonitoringTimeoutSec' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hostMonitoringIntervalSec' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'managementConnection' },
                  directives: [
                    {
                      kind: 'Directive',
                      name: { kind: 'Name', value: 'include' },
                      arguments: [
                        {
                          kind: 'Argument',
                          name: { kind: 'Name', value: 'if' },
                          value: {
                            kind: 'Variable',
                            name: { kind: 'Name', value: 'includeManagementConnection' },
                          },
                        },
                      ],
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'connectionType' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ControllerVirtualDeviceFragment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ControllerVirtualDevice' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'highAvailability' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'outletInterfaceConnectedTo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'outletNumber' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'virtualDevice' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'phyInterfaces' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isConnected' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isSFP' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isTrunkPort' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isUplink' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'portNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'portSpeedMbps' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'connectedDevices' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hardwareDevice' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'deviceModel' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'deviceType' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'virtualDevice' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'deviceType' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'phyInterface' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'portNumber' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'hasWANActivity' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'internetServicePlan' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'controllerIP' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'provider' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'logoURL' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ControllerPhyInterfaceFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PhyInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'virtualDeviceUUID' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'virtualDevice' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deviceModel' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'portNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hardwareLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'forcedSpeedAllowed' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isTrunkPort' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isUplink' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isEthernet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isSFP' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isConnected' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasWANActivity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'forcedPortSpeedMbps' } },
          { kind: 'Field', name: { kind: 'Name', value: 'portSpeedMbps' } },
          { kind: 'Field', name: { kind: 'Name', value: 'maxSpeedMbps' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ipv4ClientAssignmentProtocol' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ipv4ClientGateway' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ipv4ClientPrefixLength' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ipv4ClientAddresses' } },
          { kind: 'Field', name: { kind: 'Name', value: 'uplinkPriority' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'nativeVLAN' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'vlanID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'connectedDevices' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'macAddress' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hardwareDevice' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'serialNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isConnectedToBackend' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'deviceType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'deviceModel' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'virtualDevice' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'deviceType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'phyInterface' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'portNumber' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'uplinkExternalAddresses' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasWANActivity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isUplinkActive' } },
          { kind: 'Field', name: { kind: 'Name', value: 'uplinkVLANID' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'internetServicePlan' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'controllerIP' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'provider' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'logoURL' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'uplinkGatewayMACAddress' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sfpModuleInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'moduleSpeedKbps' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ControllersForSecurityApplianceQueryQuery,
  ControllersForSecurityApplianceQueryQueryVariables
>;
export const DeviceConfigVersionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'DeviceConfigVersion' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'serialNumber' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'latestDeviceConfig' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'serialNumber' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'serialNumber' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'version' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'latestAcknowledgedDeviceConfig' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'serialNumber' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'serialNumber' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'acknowledgedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeviceConfigVersionQuery, DeviceConfigVersionQueryVariables>;
export const FallbackSwitchHardwareQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'FallbackSwitchHardwareQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'serialNumber' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hardwareDevice' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'serialNumber' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'serialNumber' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'serialNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'virtualDeviceUUID' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FallbackSwitchHardwareQueryQuery,
  FallbackSwitchHardwareQueryQueryVariables
>;
export const CreateHighAvailabilityConfigDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateHighAvailabilityConfig' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'primaryPhyInterfaceUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'backupPhyInterfaceUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreateHighAvailabilityPairInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createHighAvailabilityControllersConfiguration' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'primaryPhyInterfaceUUID' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'primaryPhyInterfaceUUID' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'backupPhyInterfaceUUID' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'backupPhyInterfaceUUID' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'advertisementVLAN' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'networkUUID' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateHighAvailabilityConfigMutation,
  CreateHighAvailabilityConfigMutationVariables
>;
export const UpdateHighAvailabilityConfigDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateHighAvailabilityConfig' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateHighAvailabilityPairInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateHighAvailabilityControllersConfiguration' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateHighAvailabilityConfigMutation,
  UpdateHighAvailabilityConfigMutationVariables
>;
export const DeleteHighAvailabilityConfigDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteHighAvailabilityConfig' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteHighAvailabilityControllersConfiguration' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteHighAvailabilityConfigMutation,
  DeleteHighAvailabilityConfigMutationVariables
>;
export const DeviceLastDayCellularUsageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'DeviceLastDayCellularUsage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'serialNumber' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deviceLastDayCellularUsage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'serialNumber' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'serialNumber' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uploadBytes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'downloadBytes' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeviceLastDayCellularUsageQuery,
  DeviceLastDayCellularUsageQueryVariables
>;
export const DeviceCellularStatusDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'DeviceCellularStatus' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'serialNumber' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deviceCellularStatus' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'serialNumber' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'serialNumber' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'managerModemState' } },
                { kind: 'Field', name: { kind: 'Name', value: 'observedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeviceCellularStatusQuery, DeviceCellularStatusQueryVariables>;
export const DhcpRulesForNetworkQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'DHCPRulesForNetworkQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dhcpRulesForNetwork' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'vlan' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'vlanID' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DhcpRulesForNetworkQueryQuery, DhcpRulesForNetworkQueryQueryVariables>;
export const ControllerMetricsQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ControllerMetricsQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'virtualDeviceUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'MetricsFilterInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'controllerPortMetricsRate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'virtualDeviceUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'virtualDeviceUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'values' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'portNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dropsPerSecond' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'txErrPerSecond' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'rxErrPerSecond' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalRxBytesPerSecond' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalTxBytesPerSecond' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'multicastRxPacketsPerSecond' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'multicastTxPacketsPerSecond' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'broadcastRxPacketsPerSecond' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'broadcastTxPacketsPerSecond' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'controllerDNSRequestRates' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'virtualDeviceUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'virtualDeviceUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'values' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ControllerMetricsQueryQuery, ControllerMetricsQueryQueryVariables>;
export const SecurityAppliancePortStatsQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SecurityAppliancePortStatsQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'virtualDeviceUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'controllerPortStats' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'virtualDeviceUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'virtualDeviceUUID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'portNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'drops' } },
                { kind: 'Field', name: { kind: 'Name', value: 'txErr' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rxErr' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ipv4' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ipv6' } },
                { kind: 'Field', name: { kind: 'Name', value: 'punts' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalRxBytes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalTxBytes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalRxPackets' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalTxPackets' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hwUp' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SecurityAppliancePortStatsQueryQuery,
  SecurityAppliancePortStatsQueryQueryVariables
>;
export const UptimeStatsForNetworkDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'UptimeStatsForNetwork' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'MetricsFilterInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'networkUplinkQuality' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'values' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'phyInterfaceUUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UptimeStatsForNetworkQuery, UptimeStatsForNetworkQueryVariables>;
export const PortCableTestMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'PortCableTestMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'serialNumber' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'portNumber' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rpcPortCableTest' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'serialNumber' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'serialNumber' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'portNumber' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'portNumber' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pairA' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'status' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pairB' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'status' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pairC' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'status' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pairD' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'status' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PortCableTestMutationMutation, PortCableTestMutationMutationVariables>;
export const PatchPanelLayoutSwitchesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PatchPanelLayoutSwitches' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'network' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'company' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'virtualDevices' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'filter' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'deviceType' },
                            value: { kind: 'EnumValue', value: 'SWITCH' },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'SwitchVirtualDevice' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'phyInterfaces' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'portNumber' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isTrunkPort' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'allowedVLANs' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'vlanID' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'nativeVLAN' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'vlanID' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PatchPanelLayoutSwitchesQuery, PatchPanelLayoutSwitchesQueryVariables>;
export const OuIsForVendorDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'OUIsForVendor' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'vendorSubstring' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'OUIsForVendor' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'vendorSubstring' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'vendorSubstring' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'vendor' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'vendorAddress' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'vendor' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'OUIs' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OuIsForVendorQuery, OuIsForVendorQueryVariables>;
export const CancelAutoSwitchConfigurationJobDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CancelAutoSwitchConfigurationJob' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'jobUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cancelAutoSwitchConfigurationJob' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'jobUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'jobUUID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CancelAutoSwitchConfigurationJobMutation,
  CancelAutoSwitchConfigurationJobMutationVariables
>;
export const CreateSwitchAutoConfigMacAddressVlanBindingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateSwitchAutoConfigMACAddressVLANBindings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: { kind: 'Name', value: 'CreateSwitchAutoConfigMACAddressVLANBindingInput' },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createSwitchAutoConfigMACAddressVLANBindings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateSwitchAutoConfigMacAddressVlanBindingsMutation,
  CreateSwitchAutoConfigMacAddressVlanBindingsMutationVariables
>;
export const UpsertSwitchAutoConfigMacAddressVlanBindingsMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpsertSwitchAutoConfigMACAddressVLANBindingsMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: { kind: 'Name', value: 'CreateSwitchAutoConfigMACAddressVLANBindingInput' },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'upsertSwitchAutoConfigMACAddressVLANBindingsForNetwork' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpsertSwitchAutoConfigMacAddressVlanBindingsMutationMutation,
  UpsertSwitchAutoConfigMacAddressVlanBindingsMutationMutationVariables
>;
export const SwitchAutoConfigMacAddressVlanBindingsForNetworkDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SwitchAutoConfigMACAddressVLANBindingsForNetwork' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'switchAutoConfigMACAddressVLANBindingsForNetwork' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'networkUUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'macAddress' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'vendor' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'vendor' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'vendor' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'vendorAddress' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'OUI' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'VLAN' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SwitchAutoConfigMacAddressVlanBindingsForNetworkQuery,
  SwitchAutoConfigMacAddressVlanBindingsForNetworkQueryVariables
>;
export const InitializeAutoSwitchConfigurationForNetworkDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'InitializeAutoSwitchConfigurationForNetwork' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SwitchAutoConfigurationJobInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'initializeAutoSwitchConfigurationForNetwork' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  InitializeAutoSwitchConfigurationForNetworkMutation,
  InitializeAutoSwitchConfigurationForNetworkMutationVariables
>;
export const SwitchBootHistoryQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SwitchBootHistoryQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'serialNumber' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'count' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hardwareDevice' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'serialNumber' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'serialNumber' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'bootHistory' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'count' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'count' } },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'bootCount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'buildName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'rebootReason' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SwitchBootHistoryQueryQuery, SwitchBootHistoryQueryQueryVariables>;
export const InsightsQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'InsightsQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'serialNumber' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'count' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hardwareDevice' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'serialNumber' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'serialNumber' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'serialNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'macAddress' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deviceType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deviceModel' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isConnectedToBackend' } },
                { kind: 'Field', name: { kind: 'Name', value: 'disconnectedFromBackendAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'bootHistory' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'count' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'count' } },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'bootCount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'buildName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'rebootReason' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SwitchHardwareDevice' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'stpInfo' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'isRootBridge' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'rootBridgeMACAddress' },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'ipAddress' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'virtualDevice' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'deviceType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'deviceModel' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'networkUUID' } },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'SwitchVirtualDevice' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'switchProfile' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'stpBridgePriority' },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'mtu' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isFLIPEnabled' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'isVoiceVLANEnabled' },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'voiceVLANUUID' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'outletInterfaceConnectedTo' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'outletNumber' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'virtualDevice' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<InsightsQueryQuery, InsightsQueryQueryVariables>;
export const SwitchesRootQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SwitchesRootQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'virtualDevicesForNetwork' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'deviceType' },
                      value: { kind: 'EnumValue', value: 'SWITCH' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hardwareDevice' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'serialNumber' } },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'SwitchHardwareDevice' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'stpInfo' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'isRootBridge' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SwitchesRootQueryQuery, SwitchesRootQueryQueryVariables>;
export const SwitchMetricsQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SwitchMetricsQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'MetricsSerialNumberDirectionInput' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'MetricsFilterInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'switchThroughputPerPort' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'metadata' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'minValue' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'maxValue' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'values' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'SwitchPortMetricsValue' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'port' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'direction' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'switchDiscardRatesPerPort' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'metadata' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'minValue' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'maxValue' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'values' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'SwitchPortMetricsValue' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'port' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'direction' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'switchErrorRatesPerPort' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'metadata' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'minValue' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'maxValue' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'values' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'SwitchPortMetricsValue' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'port' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'direction' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SwitchMetricsQueryQuery, SwitchMetricsQueryQueryVariables>;
export const RebootSwitchDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RebootSwitch' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'serialNumber' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rpcRebootDevice' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'serialNumber' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'serialNumber' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RebootSwitchMutation, RebootSwitchMutationVariables>;
export const UnassignedHardwareForNetworkDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'UnassignedHardwareForNetwork' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'unassignedHardwareDevicesForNetwork' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'virtualDevice' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'unassignedHardwareConnections' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'phyInterface' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'portNumber' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'unassignedHardwareDevice' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'serialNumber' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'deviceType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'deviceModel' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'macAddress' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UnassignedHardwareForNetworkQuery,
  UnassignedHardwareForNetworkQueryVariables
>;
export const SwitchQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SwitchQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'includeNOS' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          defaultValue: { kind: 'BooleanValue', value: false },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'includeMACTable' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          defaultValue: { kind: 'BooleanValue', value: false },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'virtualDevice' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'network' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'networkUUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isConsoleEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deviceType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deviceModel' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nosUpgradeGroup' },
                  directives: [
                    {
                      kind: 'Directive',
                      name: { kind: 'Name', value: 'include' },
                      arguments: [
                        {
                          kind: 'Argument',
                          name: { kind: 'Name', value: 'if' },
                          value: { kind: 'Variable', name: { kind: 'Name', value: 'includeNOS' } },
                        },
                      ],
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nosVersion' },
                  directives: [
                    {
                      kind: 'Directive',
                      name: { kind: 'Name', value: 'include' },
                      arguments: [
                        {
                          kind: 'Argument',
                          name: { kind: 'Name', value: 'if' },
                          value: { kind: 'Variable', name: { kind: 'Name', value: 'includeNOS' } },
                        },
                      ],
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'buildName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pendingNosVersion' },
                  directives: [
                    {
                      kind: 'Directive',
                      name: { kind: 'Name', value: 'include' },
                      arguments: [
                        {
                          kind: 'Argument',
                          name: { kind: 'Name', value: 'if' },
                          value: { kind: 'Variable', name: { kind: 'Name', value: 'includeNOS' } },
                        },
                      ],
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nosVersion' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'version' } }],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'scheduledAt' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SwitchVirtualDevice' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'switchProfile' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'stpBridgePriority' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'mtu' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isFLIPEnabled' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isVoiceVLANEnabled' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'voiceVLANUUID' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'encryption8021Xs' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'encryption8021XGuestVLAN' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'switchingTier' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'outletInterfaceConnectedTo' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'outletNumber' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'virtualDevice' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'phyInterfaces' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'portNumber' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isFLIPEnabled' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isVoiceVLANEnabled' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isEthernet' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isSFP' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isUplink' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isConnected' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'portSpeedMbps' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'maxSpeedMbps' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'poeType' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'sfpModuleInfo' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'moduleSpeedKbps' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'macTable' },
                        directives: [
                          {
                            kind: 'Directive',
                            name: { kind: 'Name', value: 'include' },
                            arguments: [
                              {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'if' },
                                value: {
                                  kind: 'Variable',
                                  name: { kind: 'Name', value: 'includeMACTable' },
                                },
                              },
                            ],
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'macAddress' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'macAddressAlias' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'alias' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'phyInterface' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'isUplink' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'portNumber' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'vlan' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'vlanID' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'poeInfo' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'used' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'max' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hardwareDevice' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isConnectedToBackend' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'disconnectedFromBackendAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'macAddress' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'deviceModel' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'serialNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'deviceType' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'bootHistory' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'count' },
                            value: { kind: 'IntValue', value: '1' },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'buildName' } },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'SwitchHardwareDevice' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'ipAddress' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'stpInfo' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'isRootBridge' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'rootBridgePortNumber' },
                                  },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'ipAddress' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'isInCurrentControllerMACTable' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SwitchQueryQuery, SwitchQueryQueryVariables>;
export const SwitchesQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SwitchesQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'companySlug' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUIDs' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'includeIsDev' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          defaultValue: { kind: 'BooleanValue', value: false },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'includeConfigMetadata' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          defaultValue: { kind: 'BooleanValue', value: false },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'includeNOS' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          defaultValue: { kind: 'BooleanValue', value: false },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'includeMACTable' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          defaultValue: { kind: 'BooleanValue', value: false },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'companyBySlug' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'slug' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'companySlug' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'networks' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'filter' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'networkUUIDs' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'networkUUIDs' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'virtualDevices' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'filter' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'deviceType' },
                                  value: { kind: 'EnumValue', value: 'SWITCH' },
                                },
                              ],
                            },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'network' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'uptime' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'deviceType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'deviceModel' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'nosVersion' },
                              directives: [
                                {
                                  kind: 'Directive',
                                  name: { kind: 'Name', value: 'include' },
                                  arguments: [
                                    {
                                      kind: 'Argument',
                                      name: { kind: 'Name', value: 'if' },
                                      value: {
                                        kind: 'Variable',
                                        name: { kind: 'Name', value: 'includeNOS' },
                                      },
                                    },
                                  ],
                                },
                              ],
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'buildName' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'pendingNosVersion' },
                              directives: [
                                {
                                  kind: 'Directive',
                                  name: { kind: 'Name', value: 'include' },
                                  arguments: [
                                    {
                                      kind: 'Argument',
                                      name: { kind: 'Name', value: 'if' },
                                      value: {
                                        kind: 'Variable',
                                        name: { kind: 'Name', value: 'includeNOS' },
                                      },
                                    },
                                  ],
                                },
                              ],
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'nosVersion' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                                      ],
                                    },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'scheduledAt' } },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: { kind: 'Name', value: 'SwitchVirtualDevice' },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'switchProfile' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'stpBridgePriority' },
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'mtu' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'isVoiceVLANEnabled' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'isFLIPEnabled' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'voiceVLANUUID' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'switchingTier' },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'phyInterfaces' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'portNumber' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'isEthernet' },
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'isSFP' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'isUplink' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'isConnected' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'portSpeedMbps' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'maxSpeedMbps' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'isFLIPEnabled' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'isVoiceVLANEnabled' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'sfpModuleInfo' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'moduleSpeedKbps' },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'macTable' },
                                    directives: [
                                      {
                                        kind: 'Directive',
                                        name: { kind: 'Name', value: 'include' },
                                        arguments: [
                                          {
                                            kind: 'Argument',
                                            name: { kind: 'Name', value: 'if' },
                                            value: {
                                              kind: 'Variable',
                                              name: { kind: 'Name', value: 'includeMACTable' },
                                            },
                                          },
                                        ],
                                      },
                                    ],
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'macAddress' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'macAddressAlias' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'alias' },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'phyInterface' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'isUplink' },
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'portNumber' },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'vlan' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'UUID' },
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'name' },
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'vlanID' },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'updatedAt' },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'poeInfo' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'used' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'max' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'hardwareDevice' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'deviceType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'serialNumber' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'macAddress' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'isConnectedToBackend' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'disconnectedFromBackendAt' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'bootHistory' },
                                    arguments: [
                                      {
                                        kind: 'Argument',
                                        name: { kind: 'Name', value: 'count' },
                                        value: { kind: 'IntValue', value: '1' },
                                      },
                                    ],
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'buildName' },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'isDev' },
                                    directives: [
                                      {
                                        kind: 'Directive',
                                        name: { kind: 'Name', value: 'include' },
                                        arguments: [
                                          {
                                            kind: 'Argument',
                                            name: { kind: 'Name', value: 'if' },
                                            value: {
                                              kind: 'Variable',
                                              name: { kind: 'Name', value: 'includeIsDev' },
                                            },
                                          },
                                        ],
                                      },
                                    ],
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'SwitchHardwareDevice' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'stpInfo' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'isRootBridge' },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'rootBridgePortNumber',
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'ipAddress' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'isInCurrentControllerMACTable',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'latestDeviceConfigMetadata' },
                                    directives: [
                                      {
                                        kind: 'Directive',
                                        name: { kind: 'Name', value: 'include' },
                                        arguments: [
                                          {
                                            kind: 'Argument',
                                            name: { kind: 'Name', value: 'if' },
                                            value: {
                                              kind: 'Variable',
                                              name: {
                                                kind: 'Name',
                                                value: 'includeConfigMetadata',
                                              },
                                            },
                                          },
                                        ],
                                      },
                                    ],
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'FragmentSpread',
                                          name: {
                                            kind: 'Name',
                                            value: 'DeviceConfigMetadataFieldsForDeviceListBadge',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DeviceConfigMetadataFieldsForDeviceListBadge' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DeviceConfigMetadata' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'acknowledgedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'state' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isCurrentAsOf' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SwitchesQueryQuery, SwitchesQueryQueryVariables>;
export const PortsQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PortsQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'virtualDeviceUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'phyInterfacesForVirtualDevice' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'virtualDeviceUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'virtualDeviceUUID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'virtualDeviceUUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'forcedPortSpeedMbps' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isBoundToAllVLANs' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isBlockedByFLIP' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isPOEEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isSTPEdgePortEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isSTPEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isTrunkPort' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isUplink' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isConnected' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isLoopbackDetected' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isBlockedDueToFlaps' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isSTPForwarding' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isIngressFilteringEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'frameAcceptTypeFilter' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'portNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isEthernet' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isSFP' } },
                { kind: 'Field', name: { kind: 'Name', value: 'powerDraw' } },
                { kind: 'Field', name: { kind: 'Name', value: 'portSpeedMbps' } },
                { kind: 'Field', name: { kind: 'Name', value: 'maxSpeedMbps' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stpPortRole' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stpPathCost' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stpPriority' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isStormControlEnabled' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stormControlBroadcastTrafficPercent' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stormControlUnknownMulticastTrafficPercent' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stormControlUnknownUnicastTrafficPercent' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'txRateLimitKbps' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rxRateLimitKbps' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isIsolationEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'maxMACAddressesAllowed' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isSTPRootGuardEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isFLIPEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isVoiceVLANEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'poeType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'encryption8021XSettings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isAssignVLANsFromRADIUSEnabled' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'isGuestVLANEnabled' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'macAuthenticationBypassMode' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'portMode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'quietPeriodSeconds' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'supplicantPeriodSeconds' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'allowedVLANs' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'vlanID' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nativeVLAN' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'vlanID' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nativeVLANOrDefaultVLAN' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'vlanID' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'throughputLastDay' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'direction' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'connectedDevices' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'macAddress' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hardwareDevice' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'serialNumber' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'isConnectedToBackend' },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'deviceType' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'virtualDevice' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'deviceType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'phyInterface' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'portNumber' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'sfpModuleInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'vendor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'serialNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'partName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'moduleSpeed' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'moduleType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'moduleSpeedKbps' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PortsQueryQuery, PortsQueryQueryVariables>;
export const MacTableQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'MACTableQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'virtualDeviceUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'switchMACTable' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'virtualDeviceUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'virtualDeviceUUID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'macAddress' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'macAddressAlias' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'alias' } }],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'port' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'vlan' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'vlanID' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MacTableQueryQuery, MacTableQueryQueryVariables>;
export const UpdateSwitchProfileDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateSwitchProfile' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateSwitchProfileInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateSwitchProfile' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateSwitchProfileMutation, UpdateSwitchProfileMutationVariables>;
export const FindMacOnSwitchQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'FindMACOnSwitchQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'mac' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'MacAddress' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'findSwitchesForClientMAC' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'macAddress' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'mac' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'virtualDevice' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hardwareDevice' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'isConnectedToBackend' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'phyInterface' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'portNumber' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FindMacOnSwitchQueryQuery, FindMacOnSwitchQueryQueryVariables>;
export const FindLldpEntryOnSwitchQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'FindLLDPEntryOnSwitchQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'mac' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'MacAddress' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'findSwitchLLDPEntryForMAC' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'macAddress' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'mac' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'virtualDevice' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hardwareDevice' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'isConnectedToBackend' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'phyInterface' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'portNumber' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FindLldpEntryOnSwitchQueryQuery,
  FindLldpEntryOnSwitchQueryQueryVariables
>;
export const PortCycleMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'PortCycleMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'portNumber' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'serialNumber' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'poeCycle' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'portCycle' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rpcSwitchPortCycle' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'portNumber' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'portNumber' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'serialNumber' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'serialNumber' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'poeCycle' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'poeCycle' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'portCycle' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'portCycle' } },
                    },
                  ],
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PortCycleMutationMutation, PortCycleMutationMutationVariables>;
export const SwitchPortMetricsQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SwitchPortMetricsQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'virtualDeviceUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'MetricsFilterInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'switchPortMetricsRate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'virtualDeviceUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'virtualDeviceUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'values' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'portNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dropsPerSecond' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'txErrPerSecond' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'rxErrPerSecond' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalRxBytesPerSecond' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalTxBytesPerSecond' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'multicastRxPacketsPerSecond' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'multicastTxPacketsPerSecond' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'broadcastRxPacketsPerSecond' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'broadcastTxPacketsPerSecond' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SwitchPortMetricsQueryQuery, SwitchPortMetricsQueryQueryVariables>;
export const SwitchPortStatsQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'switchPortStatsQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'virtualDeviceUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'switchPortStats' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'virtualDeviceUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'virtualDeviceUUID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'portNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalRxBytes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalTxBytes' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SwitchPortStatsQueryQuery, SwitchPortStatsQueryQueryVariables>;
export const SwitchPortNumbersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SwitchPortNumbers' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'virtualDeviceUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'phyInterfacesForVirtualDevice' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'virtualDeviceUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'virtualDeviceUUID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'portNumber' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SwitchPortNumbersQuery, SwitchPortNumbersQueryVariables>;
export const HardwareListQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'HardwareListQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'includeIsDev' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          defaultValue: { kind: 'BooleanValue', value: false },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'includeConfigMetadata' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          defaultValue: { kind: 'BooleanValue', value: false },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'virtualDevicesForNetwork' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uptime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deviceType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'network' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nosVersion' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'buildName' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pendingNosVersion' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nosVersion' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'version' } }],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'scheduledAt' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SwitchVirtualDevice' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'phyInterfaces' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'PhyInterfaceFields' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ControllerVirtualDevice' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'phyInterfaces' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'PhyInterfaceFields' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'PowerDistributionUnitVirtualDevice' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'ipAddress' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hardwareDevice' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'hardwareDeviceFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DeviceConfigMetadataFieldsForDeviceListBadge' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DeviceConfigMetadata' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'acknowledgedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'state' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isCurrentAsOf' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhyInterfaceFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PhyInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'portNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isEthernet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isSFP' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isUplink' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isUplinkActive' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isConnected' } },
          { kind: 'Field', name: { kind: 'Name', value: 'portSpeedMbps' } },
          { kind: 'Field', name: { kind: 'Name', value: 'maxSpeedMbps' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isFLIPEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isVoiceVLANEnabled' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sfpModuleInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'moduleSpeedKbps' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'hardwareDeviceFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'HardwareDevice' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deviceType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'serialNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'macAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isConnectedToBackend' } },
          { kind: 'Field', name: { kind: 'Name', value: 'disconnectedFromBackendAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'bootHistory' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'count' },
                value: { kind: 'IntValue', value: '1' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'buildName' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'isDev' },
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'if' },
                    value: { kind: 'Variable', name: { kind: 'Name', value: 'includeIsDev' } },
                  },
                ],
              },
            ],
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AccessPointHardwareDevice' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'ipAddress' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isInCurrentControllerMACTable' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'phyInterfaceConnectedTo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'PhyInterfaceFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SwitchHardwareDevice' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'ipAddress' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isInCurrentControllerMACTable' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'latestDeviceConfigMetadata' },
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'if' },
                    value: {
                      kind: 'Variable',
                      name: { kind: 'Name', value: 'includeConfigMetadata' },
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'DeviceConfigMetadataFieldsForDeviceListBadge' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<HardwareListQueryQuery, HardwareListQueryQueryVariables>;
export const HubNetworksOverviewDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'HubNetworksOverview' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'companySlug' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'networksForCompany' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'companySlug' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'companySlug' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isTemplate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isCustomer' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isTrial' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deactivatedAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'mailingAddress' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'line1' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'line2' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subdivisionCode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'postalCode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'countryISO2' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'coordinates' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'longitude' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'virtualDevices' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'deviceType' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hardwareDevice' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'isConnectedToBackend' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'ControllerVirtualDevice' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'phyInterfaces' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'isUplink' } },
                                  {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'PhyInterfaceLabelFields' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhyInterfaceLabelFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PhyInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'portNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hardwareLabel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'virtualDevice' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deviceModel' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'internetServicePlan' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'provider' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<HubNetworksOverviewQuery, HubNetworksOverviewQueryVariables>;
export const UptimeStatsForNetworksDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'UptimeStatsForNetworks' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUIDs' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'lookBack' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'stepSeconds' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'networksUplinkQualities' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUIDs' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUIDs' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'durationSeconds' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'lookBack' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'stepSeconds' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'stepSeconds' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'values' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'phyInterfaceUUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UptimeStatsForNetworksQuery, UptimeStatsForNetworksQueryVariables>;
export const ApUptimeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'APUptime' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'MetricsFilterInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'apUptime' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'metadata' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'minValue' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'maxValue' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'values' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'apName' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ApUptimeQuery, ApUptimeQueryVariables>;
export const ClientMetricsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ClientMetrics' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'serialNumber' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'MetricsFilterInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'clientMetrics' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'serialNumber' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'serialNumber' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'metadata' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'signal' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'minValue' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'maxValue' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'noise' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'minValue' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'maxValue' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tx' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'minValue' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'maxValue' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'rx' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'minValue' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'maxValue' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'values' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'macAddress' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'signal' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'noise' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'txRate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'rxRate' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ClientMetricsQuery, ClientMetricsQueryVariables>;
export const RpcDisconnectClientDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'rpcDisconnectClient' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'mac' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'serialNumber' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'ssid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rpcWosDisconnectClient' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'mac' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'mac' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'serialNumber' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'serialNumber' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'ssid' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'ssid' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RpcDisconnectClientMutation, RpcDisconnectClientMutationVariables>;
export const GetCpEsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetCPEs' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CPEsFilterInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cpes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'part' } },
                { kind: 'Field', name: { kind: 'Name', value: 'vendor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'product' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uri' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCpEsQuery, GetCpEsQueryVariables>;
export const CreateNetworkClientCpeBindingDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateNetworkClientCPEBinding' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'inputs' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: { kind: 'Name', value: 'CreateNetworkClientCPEBindingInput' },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createNetworkClientCPEBindings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'inputs' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'inputs' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateNetworkClientCpeBindingMutation,
  CreateNetworkClientCpeBindingMutationVariables
>;
export const GetNetworkClientCpeBindingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetNetworkClientCPEBindings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'macAddress' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'MacAddress' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'networkClientCPEBindingsForNetwork' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'macAddress' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'macAddress' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'macAddress' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cpe' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'part' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'product' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'vendor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'uri' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetNetworkClientCpeBindingsQuery,
  GetNetworkClientCpeBindingsQueryVariables
>;
export const DeleteNetworkClientCpeBindingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteNetworkClientCPEBindings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'UUIDs' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteNetworkClientCPEBindings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUIDs' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'UUIDs' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteNetworkClientCpeBindingsMutation,
  DeleteNetworkClientCpeBindingsMutationVariables
>;
export const GetCveDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetCVE' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'cveID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cve' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'cveID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'cveID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'ID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'baseSeverity' } },
                { kind: 'Field', name: { kind: 'Name', value: 'externalPublishedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCveQuery, GetCveQueryVariables>;
export const AllCvEsForNetworkDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AllCVEsForNetwork' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allCVEsForNetwork' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'ID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'baseSeverity' } },
                { kind: 'Field', name: { kind: 'Name', value: 'externalPublishedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AllCvEsForNetworkQuery, AllCvEsForNetworkQueryVariables>;
export const AffectedClientsByCveiDsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AffectedClientsByCVEIDs' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'cveIDs' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'affectedClientsByCVEIDs' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'cveIDs' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'cveIDs' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'cveID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'macAddress' } },
                { kind: 'Field', name: { kind: 'Name', value: 'networkUUID' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AffectedClientsByCveiDsQuery, AffectedClientsByCveiDsQueryVariables>;
export const GetClientsCpeBindingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetClientsCPEBindings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'networkClientCPEBindingsForNetwork' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'macAddress' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cpe' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'part' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'product' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'vendor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'uri' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetClientsCpeBindingsQuery, GetClientsCpeBindingsQueryVariables>;
export const BlockClientsInNetworkDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'blockClientsInNetwork' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'macAddresses' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'MacAddress' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'ouis' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'blockClientsInNetwork' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'macAddresses' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'macAddresses' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'ouis' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'ouis' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'networkUUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'macAddress' } },
                { kind: 'Field', name: { kind: 'Name', value: 'oui' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BlockClientsInNetworkMutation, BlockClientsInNetworkMutationVariables>;
export const UnblockClientsInNetworkDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'unblockClientsInNetwork' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'macAddresses' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'MacAddress' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'ouis' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'unblockClientsInNetwork' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'macAddresses' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'macAddresses' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'ouis' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'ouis' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'networkUUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'macAddress' } },
                { kind: 'Field', name: { kind: 'Name', value: 'oui' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UnblockClientsInNetworkMutation,
  UnblockClientsInNetworkMutationVariables
>;
export const BlockedClientsForNetworkDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'blockedClientsForNetwork' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'blockedClientsForNetwork' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'networkUUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'macAddress' } },
                { kind: 'Field', name: { kind: 'Name', value: 'oui' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BlockedClientsForNetworkQuery, BlockedClientsForNetworkQueryVariables>;
export const ClientMetricsTimeseriesResponseDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ClientMetricsTimeseriesResponse' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'macAddress' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'MacAddress' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AllClientMetricsTimeseriesFilterInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allClientMetricsByClient' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'macAddress' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'macAddress' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'rxBytes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'BaseMetricsResponseFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'txBytes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'BaseMetricsResponseFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BaseMetricsResponseFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'MetricsResponse' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'metadata' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'minValue' } },
                { kind: 'Field', name: { kind: 'Name', value: 'maxValue' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'values' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ClientMetricsTimeseriesResponseQuery,
  ClientMetricsTimeseriesResponseQueryVariables
>;
export const WirelessClientMetricsByClientQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'WirelessClientMetricsByClientQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'macAddress' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'MacAddress' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ClientMetricsTimeseriesFilterInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'wirelessClientMetricsByClient' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'macAddress' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'macAddress' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'metadata' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'signal' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'minValue' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'maxValue' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'noise' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'minValue' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'maxValue' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'txBytes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'minValue' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'maxValue' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'rxBytes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'minValue' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'maxValue' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'values' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'signal' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'noise' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'txRate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'rxRate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'snr' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'txBytes' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'rxBytes' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'txMulticastBytes' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'rxMulticastBytes' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'txUnicastBytes' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'rxUnicastBytes' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'rxSuccessRatio' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'txSuccessRatio' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'rxRetryRatio' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'txRetryRatio' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'clientCount' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  WirelessClientMetricsByClientQueryQuery,
  WirelessClientMetricsByClientQueryQueryVariables
>;
export const CountCvEsBySeverityForMacAddressesBulkQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'countCVEsBySeverityForMACAddressesBulkQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: { kind: 'Name', value: 'CVEsByNetworkMacAddressesInput' },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'countCVEsBySeverityForMACAddressesBulk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'networkUUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'macAddress' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'counts' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'baseSeverity' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CountCvEsBySeverityForMacAddressesBulkQueryQuery,
  CountCvEsBySeverityForMacAddressesBulkQueryQueryVariables
>;
export const ClientChannelUtilizationQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ClientChannelUtilizationQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'macAddress' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'MacAddress' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ChannelUtilizationTimeseriesFilterInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'channelUtilizationByClient' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'macAddress' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'macAddress' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalUtilization' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ClientChannelUtilizationQueryQuery,
  ClientChannelUtilizationQueryQueryVariables
>;
export const UpsertMacAddressAliasDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'upsertMACAddressAlias' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'companySlug' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'macAddress' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'MacAddress' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'alias' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'upsertMACAddressAlias' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'companySlug' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'companySlug' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'macAddress' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'macAddress' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'alias' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'alias' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'alias' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpsertMacAddressAliasMutation, UpsertMacAddressAliasMutationVariables>;
export const HostMonitoringDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'HostMonitoring' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'virtualDeviceUUID' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'hostIPs' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'durationSeconds' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'stepSeconds' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hostMonitoringForNetwork' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'virtualDeviceUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'virtualDeviceUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'durationSeconds' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'durationSeconds' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'stepSeconds' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'stepSeconds' } },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'hostIPs' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'hostIPs' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'values' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'hostIPAddr' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'virtualDevice' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'statusValue' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'countOk' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'countFailed' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'countTimeout' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'srcPhyInterface' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'PhyInterfaceLabelFields' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhyInterfaceLabelFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PhyInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'portNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hardwareLabel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'virtualDevice' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deviceModel' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'internetServicePlan' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'provider' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<HostMonitoringQuery, HostMonitoringQueryVariables>;
export const HostMonitoringTargetDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'HostMonitoringTarget' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hostMonitoringTarget' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'HostMonitoringTargetFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'HostMonitoringTargetFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'HostMonitoringTarget' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'targetHost' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isUsedForWANFailover' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<HostMonitoringTargetQuery, HostMonitoringTargetQueryVariables>;
export const HostMonitoringTargetsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'HostMonitoringTargets' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hostMonitoringTargetsForNetwork' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'HostMonitoringTargetFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'HostMonitoringTargetFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'HostMonitoringTarget' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'targetHost' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isUsedForWANFailover' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<HostMonitoringTargetsQuery, HostMonitoringTargetsQueryVariables>;
export const CreateHostMonitoringTargetDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateHostMonitoringTarget' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreateHostMonitoringTargetInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createHostMonitoringTarget' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateHostMonitoringTargetMutation,
  CreateHostMonitoringTargetMutationVariables
>;
export const UpdateHostMonitoringTargetDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateHostMonitoringTarget' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateHostMonitoringTargetInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateHostMonitoringTarget' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateHostMonitoringTargetMutation,
  UpdateHostMonitoringTargetMutationVariables
>;
export const DeleteHostMonitoringTargetDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteHostMonitoringTarget' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteHostMonitoringTarget' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteHostMonitoringTargetMutation,
  DeleteHostMonitoringTargetMutationVariables
>;
export const ActiveClientsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'activeClients' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'MetricsFilterInput' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ActiveClientsInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activeClients' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'wired' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'wireless' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ActiveClientsQuery, ActiveClientsQueryVariables>;
export const NetworkUplinkQualityDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'networkUplinkQuality' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'MetricsFilterInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'networkUplinkQuality' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'values' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phyInterfaceUUID' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<NetworkUplinkQualityQuery, NetworkUplinkQualityQueryVariables>;
export const NetworkUplinkThroughputDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'networkUplinkThroughput' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'MetricsFilterInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'networkUplinkThroughput' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'values' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'direction' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phyInterfaceUUID' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<NetworkUplinkThroughputQuery, NetworkUplinkThroughputQueryVariables>;
export const ApChannelUtilizationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'APChannelUtilization' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'MetricsFilterInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'band2G' },
            name: { kind: 'Name', value: 'apChannelUtilization' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'band' },
                value: { kind: 'EnumValue', value: 'BAND_2_4G' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'metadata' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'minValue' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'maxValue' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'values' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'APChannelUtilizationMetricsValue' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'apName' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'band5G' },
            name: { kind: 'Name', value: 'apChannelUtilization' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'band' },
                value: { kind: 'EnumValue', value: 'BAND_5G' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'metadata' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'minValue' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'maxValue' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'values' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'APChannelUtilizationMetricsValue' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'apName' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ApChannelUtilizationQuery, ApChannelUtilizationQueryVariables>;
export const WirelessConnectionEventsByClientQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'WirelessConnectionEventsByClientQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'mac' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'MacAddress' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ClientMetricsTimeseriesFilterInput' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'wirelessClientConnectionEventsByClient' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'macAddress' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'mac' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'offset' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ConnectionEventFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ConnectionEventFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'WirelessClientConnectionEvent' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
          { kind: 'Field', name: { kind: 'Name', value: 'band' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eventType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failedStep' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reasonCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sessionDuration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timeToConnect' } },
          { kind: 'Field', name: { kind: 'Name', value: 'is80211rRoam' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isObserver' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isSteeringRejection' } },
          { kind: 'Field', name: { kind: 'Name', value: 'instigator' } },
          { kind: 'Field', name: { kind: 'Name', value: 'macAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rssi' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ssid' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ssid' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'virtualDevice' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'previousVirtualDeviceConnectedTo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  WirelessConnectionEventsByClientQueryQuery,
  WirelessConnectionEventsByClientQueryQueryVariables
>;
export const WirelessConnectionEventsByAccessPointQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'WirelessConnectionEventsByAccessPointQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'virtualDeviceUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ClientMetricsTimeseriesFilterInput' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'wirelessClientConnectionEventsByAP' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'apVirtualDeviceUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'virtualDeviceUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'offset' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ConnectionEventFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ConnectionEventFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'WirelessClientConnectionEvent' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
          { kind: 'Field', name: { kind: 'Name', value: 'band' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eventType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failedStep' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reasonCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sessionDuration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timeToConnect' } },
          { kind: 'Field', name: { kind: 'Name', value: 'is80211rRoam' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isObserver' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isSteeringRejection' } },
          { kind: 'Field', name: { kind: 'Name', value: 'instigator' } },
          { kind: 'Field', name: { kind: 'Name', value: 'macAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rssi' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ssid' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ssid' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'virtualDevice' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'previousVirtualDeviceConnectedTo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  WirelessConnectionEventsByAccessPointQueryQuery,
  WirelessConnectionEventsByAccessPointQueryQueryVariables
>;
export const WirelessConnectionEventsQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'WirelessConnectionEventsQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ClientMetricsTimeseriesFilterInput' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'wirelessClientConnectionEvents' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'offset' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ConnectionEventFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ConnectionEventFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'WirelessClientConnectionEvent' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
          { kind: 'Field', name: { kind: 'Name', value: 'band' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eventType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failedStep' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reasonCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sessionDuration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timeToConnect' } },
          { kind: 'Field', name: { kind: 'Name', value: 'is80211rRoam' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isObserver' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isSteeringRejection' } },
          { kind: 'Field', name: { kind: 'Name', value: 'instigator' } },
          { kind: 'Field', name: { kind: 'Name', value: 'macAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rssi' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ssid' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ssid' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'virtualDevice' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'previousVirtualDeviceConnectedTo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  WirelessConnectionEventsQueryQuery,
  WirelessConnectionEventsQueryQueryVariables
>;
export const NetworkForNavigationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'NetworkForNavigation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'network' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companySlug' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<NetworkForNavigationQuery, NetworkForNavigationQueryVariables>;
export const HardwareDeviceForNavigationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'HardwareDeviceForNavigation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'serialNumber' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hardwareDevice' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'serialNumber' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'serialNumber' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'serialNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deviceType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deviceModel' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'virtualDevice' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'network' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'companySlug' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'spareDeviceNetwork' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'companySlug' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  HardwareDeviceForNavigationQuery,
  HardwareDeviceForNavigationQueryVariables
>;
export const CaptivePortalDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CaptivePortal' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'captivePortal' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'uuid' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CaptivePortalBody' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CaptivePortalBody' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CaptivePortal' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callToAction' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'logoImageBase64' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'data' } },
                { kind: 'Field', name: { kind: 'Name', value: 'imageType' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'logoImageS3Key' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'redirectURL' } },
          { kind: 'Field', name: { kind: 'Name', value: 'allowedHosts' } },
          { kind: 'Field', name: { kind: 'Name', value: 'externalPortalURL' } },
          { kind: 'Field', name: { kind: 'Name', value: 'authLifetimeSec' } },
          { kind: 'Field', name: { kind: 'Name', value: 'termsAndConditions' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'vlans' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'vlanID' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'displaySettings' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'backgroundColor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'callToActionColor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fontColor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hidePoweredByMeter' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'webhookKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requiresApproval' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requiresEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requiresName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCompanyScoped' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CaptivePortalQuery, CaptivePortalQueryVariables>;
export const CaptivePortalForNetworkQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CaptivePortalForNetworkQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'captivePortalForNetwork' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CaptivePortalBody' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CaptivePortalBody' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CaptivePortal' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callToAction' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'logoImageBase64' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'data' } },
                { kind: 'Field', name: { kind: 'Name', value: 'imageType' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'logoImageS3Key' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'redirectURL' } },
          { kind: 'Field', name: { kind: 'Name', value: 'allowedHosts' } },
          { kind: 'Field', name: { kind: 'Name', value: 'externalPortalURL' } },
          { kind: 'Field', name: { kind: 'Name', value: 'authLifetimeSec' } },
          { kind: 'Field', name: { kind: 'Name', value: 'termsAndConditions' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'vlans' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'vlanID' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'displaySettings' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'backgroundColor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'callToActionColor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fontColor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hidePoweredByMeter' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'webhookKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requiresApproval' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requiresEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requiresName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCompanyScoped' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CaptivePortalForNetworkQueryQuery,
  CaptivePortalForNetworkQueryQueryVariables
>;
export const CaptivePortalsForNetworkDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CaptivePortalsForNetwork' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'captivePortalsForNetwork' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CaptivePortalBody' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CaptivePortalBody' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CaptivePortal' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callToAction' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'logoImageBase64' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'data' } },
                { kind: 'Field', name: { kind: 'Name', value: 'imageType' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'logoImageS3Key' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'redirectURL' } },
          { kind: 'Field', name: { kind: 'Name', value: 'allowedHosts' } },
          { kind: 'Field', name: { kind: 'Name', value: 'externalPortalURL' } },
          { kind: 'Field', name: { kind: 'Name', value: 'authLifetimeSec' } },
          { kind: 'Field', name: { kind: 'Name', value: 'termsAndConditions' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'vlans' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'vlanID' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'displaySettings' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'backgroundColor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'callToActionColor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fontColor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hidePoweredByMeter' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'webhookKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requiresApproval' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requiresEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requiresName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCompanyScoped' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CaptivePortalsForNetworkQuery, CaptivePortalsForNetworkQueryVariables>;
export const UpdateCaptivePortalDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateCaptivePortal' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CaptivePortalSettingsInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateCaptivePortal' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'uuid' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CaptivePortalBody' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CaptivePortalBody' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CaptivePortal' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callToAction' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'logoImageBase64' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'data' } },
                { kind: 'Field', name: { kind: 'Name', value: 'imageType' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'logoImageS3Key' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'redirectURL' } },
          { kind: 'Field', name: { kind: 'Name', value: 'allowedHosts' } },
          { kind: 'Field', name: { kind: 'Name', value: 'externalPortalURL' } },
          { kind: 'Field', name: { kind: 'Name', value: 'authLifetimeSec' } },
          { kind: 'Field', name: { kind: 'Name', value: 'termsAndConditions' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'vlans' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'vlanID' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'displaySettings' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'backgroundColor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'callToActionColor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fontColor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hidePoweredByMeter' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'webhookKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requiresApproval' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requiresEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requiresName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCompanyScoped' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateCaptivePortalMutation, UpdateCaptivePortalMutationVariables>;
export const DeleteCaptivePortalDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteCaptivePortal' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteCaptivePortal' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'uuid' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteCaptivePortalMutation, DeleteCaptivePortalMutationVariables>;
export const CreateCaptivePortalDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateCaptivePortal' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CaptivePortalSettingsInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createCaptivePortal' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CaptivePortalBody' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CaptivePortalBody' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CaptivePortal' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callToAction' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'logoImageBase64' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'data' } },
                { kind: 'Field', name: { kind: 'Name', value: 'imageType' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'logoImageS3Key' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'redirectURL' } },
          { kind: 'Field', name: { kind: 'Name', value: 'allowedHosts' } },
          { kind: 'Field', name: { kind: 'Name', value: 'externalPortalURL' } },
          { kind: 'Field', name: { kind: 'Name', value: 'authLifetimeSec' } },
          { kind: 'Field', name: { kind: 'Name', value: 'termsAndConditions' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'vlans' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'vlanID' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'displaySettings' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'backgroundColor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'callToActionColor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fontColor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hidePoweredByMeter' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'webhookKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requiresApproval' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requiresEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requiresName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCompanyScoped' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateCaptivePortalMutation, CreateCaptivePortalMutationVariables>;
export const CapoActivityQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'capoActivityQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'numHoursLookback' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'captivePortalAuthorizedClients' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'numHoursLookback' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'numHoursLookback' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isAuthorized' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ipAddress' } },
                { kind: 'Field', name: { kind: 'Name', value: 'macAddress' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rawUserAgent' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CapoActivityQueryQuery, CapoActivityQueryQueryVariables>;
export const CaptivePortalEntriesForNetworkQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CaptivePortalEntriesForNetworkQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'CaptivePortalEntryFilterInput' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'captivePortalEntriesForNetwork' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'entries' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'CaptivePortalEntryBody' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CaptivePortalEntryBody' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CaptivePortalEntry' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'networkUUID' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'captivePortal' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'ip' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mac' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'actionedBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'approvedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deniedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deletedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CaptivePortalEntriesForNetworkQueryQuery,
  CaptivePortalEntriesForNetworkQueryQueryVariables
>;
export const CaptivePortalEntriesForPortalQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CaptivePortalEntriesForPortalQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'captivePortalUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'CaptivePortalEntryFilterInput' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'captivePortalEntriesForPortal' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'captivePortalUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'captivePortalUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'entries' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'CaptivePortalEntryBody' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CaptivePortalEntryBody' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CaptivePortalEntry' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'networkUUID' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'captivePortal' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'ip' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mac' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'actionedBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'approvedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deniedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deletedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CaptivePortalEntriesForPortalQueryQuery,
  CaptivePortalEntriesForPortalQueryQueryVariables
>;
export const ActionCaptivePortalEntryMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ActionCaptivePortalEntryMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'entryUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'action' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CaptivePortalEntryAction' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'actionCaptivePortalEntry' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'entryUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'entryUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'action' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'action' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CaptivePortalEntryBody' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CaptivePortalEntryBody' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CaptivePortalEntry' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'networkUUID' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'captivePortal' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'ip' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mac' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'actionedBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'approvedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deniedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deletedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ActionCaptivePortalEntryMutationMutation,
  ActionCaptivePortalEntryMutationMutationVariables
>;
export const DeleteInternetServicePlanMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteInternetServicePlanMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'internetServicePlanUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteInternetServicePlan' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'internetServicePlanUUID' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'internetServicePlanUUID' },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteInternetServicePlanMutationMutation,
  DeleteInternetServicePlanMutationMutationVariables
>;
export const CreateInternetServicePlanMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateInternetServicePlanMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'companySlug' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreateInternetServicePlanInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createInternetServicePlan' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'companySlug' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'companySlug' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateInternetServicePlanMutationMutation,
  CreateInternetServicePlanMutationMutationVariables
>;
export const UpdateInternetServicePlanMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateInternetServicePlanMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'internetServicePlanUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateInternetServicePlanInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateInternetServicePlan' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'internetServicePlanUUID' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'internetServicePlanUUID' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateInternetServicePlanMutationMutation,
  UpdateInternetServicePlanMutationMutationVariables
>;
export const ProvidersQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ProvidersQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'companySlug' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'internetServicePlanProviders' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'companySlug' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'companySlug' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'logoURL' } },
                { kind: 'Field', name: { kind: 'Name', value: 'logoS3Key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'iconS3Key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ProvidersQueryQuery, ProvidersQueryQueryVariables>;
export const ListIsPsQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ListISPsQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'companySlug' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'internetServicePlans' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'companySlug' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'companySlug' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'address' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'address1' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'address2' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'postalCode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'connectionProduct' } },
                { kind: 'Field', name: { kind: 'Name', value: 'connectionStatus' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'provider' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'logoURL' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'logoS3Key' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'iconS3Key' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'controllerIP' } },
                { kind: 'Field', name: { kind: 'Name', value: 'controllerName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstUsableIP' } },
                { kind: 'Field', name: { kind: 'Name', value: 'gatewayAddr' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasStaticIP' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastUsableIP' } },
                { kind: 'Field', name: { kind: 'Name', value: 'networkUUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'staticIPRange' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ListIsPsQueryQuery, ListIsPsQueryQueryVariables>;
export const MoveInternetServicePlanMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'MoveInternetServicePlanMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'ispUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'moveInternetServicePlanToNetwork' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'internetServicePlanUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'ispUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MoveInternetServicePlanMutationMutation,
  MoveInternetServicePlanMutationMutationVariables
>;
export const RateLimitRulesForNetworkDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'RateLimitRulesForNetwork' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rateLimitRulesForNetwork' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'RateLimitRuleFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RateLimitRuleFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'RateLimitRule' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rateLimitKbpsDownload' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rateLimitKbpsUpload' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPerSource' } },
          { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
          { kind: 'Field', name: { kind: 'Name', value: 'protocol' } },
          { kind: 'Field', name: { kind: 'Name', value: 'srcMac' } },
          { kind: 'Field', name: { kind: 'Name', value: 'srcPrefix' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'srcPortRange' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'lower' } },
                { kind: 'Field', name: { kind: 'Name', value: 'upper' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'dstMac' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dstPrefix' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dstPortRange' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'lower' } },
                { kind: 'Field', name: { kind: 'Name', value: 'upper' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'vlanBindings' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'vlanID' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'phyInterfaceBindings' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PhyInterfaceLabelFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ssidBindings' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ssid' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhyInterfaceLabelFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PhyInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'portNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hardwareLabel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'virtualDevice' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deviceModel' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'internetServicePlan' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'provider' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RateLimitRulesForNetworkQuery, RateLimitRulesForNetworkQueryVariables>;
export const RateLimitRuleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'RateLimitRule' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rateLimitRule' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'RateLimitRuleFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RateLimitRuleFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'RateLimitRule' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rateLimitKbpsDownload' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rateLimitKbpsUpload' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPerSource' } },
          { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
          { kind: 'Field', name: { kind: 'Name', value: 'protocol' } },
          { kind: 'Field', name: { kind: 'Name', value: 'srcMac' } },
          { kind: 'Field', name: { kind: 'Name', value: 'srcPrefix' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'srcPortRange' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'lower' } },
                { kind: 'Field', name: { kind: 'Name', value: 'upper' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'dstMac' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dstPrefix' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dstPortRange' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'lower' } },
                { kind: 'Field', name: { kind: 'Name', value: 'upper' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'vlanBindings' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'vlanID' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'phyInterfaceBindings' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PhyInterfaceLabelFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ssidBindings' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ssid' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhyInterfaceLabelFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PhyInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'portNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hardwareLabel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'virtualDevice' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deviceModel' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'internetServicePlan' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'provider' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RateLimitRuleQuery, RateLimitRuleQueryVariables>;
export const CreateRateLimitRuleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateRateLimitRule' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateRateLimitRuleInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createRateLimitRule' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateRateLimitRuleMutation, CreateRateLimitRuleMutationVariables>;
export const UpdateRateLimitRuleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateRateLimitRule' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateRateLimitRuleInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateRateLimitRule' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateRateLimitRuleMutation, UpdateRateLimitRuleMutationVariables>;
export const DeleteRateLimitRuleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteRateLimitRule' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteRateLimitRule' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteRateLimitRuleMutation, DeleteRateLimitRuleMutationVariables>;
export const UpdateRateLimitRulesIndependentlyDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateRateLimitRulesIndependently' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'inputs' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: { kind: 'Name', value: 'UpdateRateLimitRulesInput' },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateRateLimitRulesIndependently' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'inputs' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'inputs' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateRateLimitRulesIndependentlyMutation,
  UpdateRateLimitRulesIndependentlyMutationVariables
>;
export const VlanMetricsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'VLANMetrics' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'virtualDeviceUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'MetricsFilterInput' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'vlanUUID' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'vlanMetrics' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'virtualDeviceUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'virtualDeviceUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'vlanUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'vlanUUID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'vlanID' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'txBytes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'BaseMetricsResponseFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'rxBytes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'BaseMetricsResponseFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'txPackets' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'BaseMetricsResponseFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'rxPackets' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'BaseMetricsResponseFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'txError' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'BaseMetricsResponseFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'rxError' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'BaseMetricsResponseFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'drops' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'BaseMetricsResponseFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BaseMetricsResponseFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'MetricsResponse' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'metadata' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'minValue' } },
                { kind: 'Field', name: { kind: 'Name', value: 'maxValue' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'values' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<VlanMetricsQuery, VlanMetricsQueryVariables>;
export const VlaNsQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'VLANsQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'vlans' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isInternal' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
                { kind: 'Field', name: { kind: 'Name', value: 'vlanID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ipV4ClientAssignmentProtocol' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ipV4ClientGateway' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ipV4ClientPrefixLength' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isWANDenied' } },
                { kind: 'Field', name: { kind: 'Name', value: 'participatesInVPNs' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isMulticastReflectionEnabled' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'permittedInterVLANCommunicationVLANs' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'vlanID' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'dhcpRule' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'latestStats' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'observedAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'totalAddresses' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'assignedAddresses' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<VlaNsQueryQuery, VlaNsQueryQueryVariables>;
export const VlanQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'VLANQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'vlan' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isInternal' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
                { kind: 'Field', name: { kind: 'Name', value: 'vlanID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ipV4ClientAssignmentProtocol' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ipV4ClientGateway' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ipV4ClientPrefixLength' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isWANDenied' } },
                { kind: 'Field', name: { kind: 'Name', value: 'participatesInVPNs' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isMulticastReflectionEnabled' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'permittedInterVLANCommunicationVLANs' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'vlanID' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'dhcpRule' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isIPv6' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startIPAddress' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endIPAddress' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasGatewayOverride' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'gatewayIPAddress' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'gatewayPrefixLength' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'leaseDurationSeconds' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dnsUseGatewayProxy' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dnsUpstreamServers' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dnsSearchDomains' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dnsCacheIsEnabled' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dnsCacheSize' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dnsCacheMaxTTL' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'latestStats' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'observedAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'totalAddresses' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'assignedAddresses' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'options' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'data' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'dataType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reservedRanges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'startIPAddress' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'endIPAddress' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'staticMappings' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'macAddress' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'ipAddress' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'hostname' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dnsHostMappings' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isEnabled' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'overrideDomain' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'destinationIPAddress' },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'destinationDomain' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'applicationDNSFirewallRules' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dhcpRuleFilters' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'allowedMACAddress' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'allowedOUI' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dhcpProxies' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'phyInterfaceUUID' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'phyInterface' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'PhyInterfaceLabelFields' },
                                  },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'ipAddress' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhyInterfaceLabelFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PhyInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'portNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hardwareLabel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'virtualDevice' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deviceModel' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'internetServicePlan' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'provider' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<VlanQueryQuery, VlanQueryQueryVariables>;
export const VlaNsDetailedQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'VLANsDetailedQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'vlans' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isInternal' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
                { kind: 'Field', name: { kind: 'Name', value: 'vlanID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ipV4ClientAssignmentProtocol' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ipV4ClientGateway' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ipV4ClientPrefixLength' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isWANDenied' } },
                { kind: 'Field', name: { kind: 'Name', value: 'participatesInVPNs' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isMulticastReflectionEnabled' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'permittedInterVLANCommunicationVLANs' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'vlanID' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'dhcpRule' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isIPv6' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startIPAddress' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endIPAddress' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasGatewayOverride' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'gatewayIPAddress' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'gatewayPrefixLength' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'leaseDurationSeconds' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dnsUseGatewayProxy' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dnsUpstreamServers' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dnsSearchDomains' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dnsCacheIsEnabled' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dnsCacheSize' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dnsCacheMaxTTL' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'latestStats' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'observedAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'totalAddresses' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'assignedAddresses' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'options' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'data' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'dataType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reservedRanges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'startIPAddress' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'endIPAddress' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'staticMappings' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'macAddress' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'ipAddress' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'hostname' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dnsHostMappings' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isEnabled' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'overrideDomain' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'destinationIPAddress' },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'destinationDomain' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'applicationDNSFirewallRules' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dhcpRuleFilters' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'allowedMACAddress' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'allowedOUI' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dhcpProxies' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'phyInterfaceUUID' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'phyInterface' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                                  {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'PhyInterfaceLabelFields' },
                                  },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'ipAddress' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhyInterfaceLabelFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PhyInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'portNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hardwareLabel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'virtualDevice' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deviceModel' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'internetServicePlan' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'provider' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<VlaNsDetailedQueryQuery, VlaNsDetailedQueryQueryVariables>;
export const CreateVlanMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateVLANMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateVLANInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createVLAN' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateVlanMutationMutation, CreateVlanMutationMutationVariables>;
export const UpdateVlanMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateVLANMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateVLANInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateVLAN' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateVlanMutationMutation, UpdateVlanMutationMutationVariables>;
export const DeleteVlanMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteVLANMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteVLAN' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteVlanMutationMutation, DeleteVlanMutationMutationVariables>;
export const CreateDhcpRuleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateDHCPRule' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'vlanUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateDHCPRuleInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createDHCPRule' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'vlanUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'vlanUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateDhcpRuleMutation, CreateDhcpRuleMutationVariables>;
export const UpdateDhcpRuleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateDHCPRule' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateDHCPRuleInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateDHCPRule' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateDhcpRuleMutation, UpdateDhcpRuleMutationVariables>;
export const DeleteDhcpRuleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteDHCPRule' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteDHCPRule' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteDhcpRuleMutation, DeleteDhcpRuleMutationVariables>;
export const CreateDhcpOptionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateDHCPOption' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'ruleUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateDHCPOptionInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createDHCPOption' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'dhcpRuleUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'ruleUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateDhcpOptionMutation, CreateDhcpOptionMutationVariables>;
export const UpdateDhcpOptionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateDHCPOption' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateDHCPOptionInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateDHCPOption' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateDhcpOptionMutation, UpdateDhcpOptionMutationVariables>;
export const DeleteDhcpOptionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteDHCPOption' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteDHCPOption' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteDhcpOptionMutation, DeleteDhcpOptionMutationVariables>;
export const CreateDhcpRuleFilterDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateDHCPRuleFilter' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'ruleUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateDHCPRuleFilterInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createDHCPRuleFilter' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'dhcpRuleUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'ruleUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateDhcpRuleFilterMutation, CreateDhcpRuleFilterMutationVariables>;
export const DeleteDhcpRuleFilterDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteDHCPRuleFilter' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteDHCPRuleFilter' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteDhcpRuleFilterMutation, DeleteDhcpRuleFilterMutationVariables>;
export const CreateDhcpReservedRangeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateDHCPReservedRange' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'ruleUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreateDHCPReservedRangeInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createDHCPReservedRange' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'dhcpRuleUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'ruleUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateDhcpReservedRangeMutation,
  CreateDhcpReservedRangeMutationVariables
>;
export const UpdateDhcpReservedRangeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateDHCPReservedRange' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateDHCPReservedRangeInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateDHCPReservedRange' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateDhcpReservedRangeMutation,
  UpdateDhcpReservedRangeMutationVariables
>;
export const DeleteDhcpReservedRangeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteDHCPReservedRange' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteDHCPReservedRange' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteDhcpReservedRangeMutation,
  DeleteDhcpReservedRangeMutationVariables
>;
export const CreateDhcpStaticMappingDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateDHCPStaticMapping' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'ruleUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreateDHCPStaticMappingInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createDHCPStaticMapping' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'dhcpRuleUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'ruleUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateDhcpStaticMappingMutation,
  CreateDhcpStaticMappingMutationVariables
>;
export const UpdateDhcpStaticMappingDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateDHCPStaticMapping' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateDHCPStaticMappingInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateDHCPStaticMapping' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateDhcpStaticMappingMutation,
  UpdateDhcpStaticMappingMutationVariables
>;
export const DeleteDhcpStaticMappingDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteDHCPStaticMapping' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteDHCPStaticMapping' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteDhcpStaticMappingMutation,
  DeleteDhcpStaticMappingMutationVariables
>;
export const CreateDnsHostMappingDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateDNSHostMapping' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'ruleUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateDNSHostMappingInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createDNSHostMapping' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'dhcpRuleUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'ruleUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateDnsHostMappingMutation, CreateDnsHostMappingMutationVariables>;
export const UpdateDnsHostMappingDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateDNSHostMapping' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateDNSHostMappingInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateDNSHostMapping' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateDnsHostMappingMutation, UpdateDnsHostMappingMutationVariables>;
export const DeleteDnsHostMappingDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteDNSHostMapping' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteDNSHostMapping' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteDnsHostMappingMutation, DeleteDnsHostMappingMutationVariables>;
export const OnboardingForNetworkDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'onboardingForNetwork' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'network' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onboarding' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'networkUUID' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'jobData' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'fullAddress' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'installationStartDate' },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'installationEndDate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'jobOwnerUser' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'jobStage' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'jobStatus' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'onsiteContactInformation' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'scheduleSiteSurveyLink' },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'siteSurveyDate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'siteSurveyStatus' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'targetGoLiveDate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'totalSqFt' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OnboardingForNetworkQuery, OnboardingForNetworkQueryVariables>;
export const NetworkForOnboardingDocumentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'NetworkForOnboardingDocument' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'network' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onboardingDocument' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'document' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'delegations' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'fieldName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  NetworkForOnboardingDocumentQuery,
  NetworkForOnboardingDocumentQueryVariables
>;
export const NetworksDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Networks' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'companySlug' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'networksForCompany' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'companySlug' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'companySlug' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onboardingDocument' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'document' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'delegations' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'fieldName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<NetworksQuery, NetworksQueryVariables>;
export const CompanyForOnboardingDocumentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CompanyForOnboardingDocument' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'companyUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getCompanyByUUID' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'uuid' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'companyUUID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onboardingDocument' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'document' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'delegations' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'fieldName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CompanyForOnboardingDocumentQuery,
  CompanyForOnboardingDocumentQueryVariables
>;
export const UpsertNetworkOnboardingDocumentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpsertNetworkOnboardingDocument' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'document' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'JSONObject' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'upsertNetworkOnboardingDocument' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'document' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'document' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpsertNetworkOnboardingDocumentMutation,
  UpsertNetworkOnboardingDocumentMutationVariables
>;
export const UpsertCompanyOnboardingDocumentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpsertCompanyOnboardingDocument' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'companyUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'document' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'JSONObject' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'upsertCompanyOnboardingDocument' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'companyUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'companyUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'document' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'document' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpsertCompanyOnboardingDocumentMutation,
  UpsertCompanyOnboardingDocumentMutationVariables
>;
export const UpsertNetworkOnboardingFieldDelegationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpsertNetworkOnboardingFieldDelegation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'fieldName' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpsertNetworkOnboardingFieldDelegationInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'upsertNetworkOnboardingFieldDelegation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'fieldName' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'fieldName' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpsertNetworkOnboardingFieldDelegationMutation,
  UpsertNetworkOnboardingFieldDelegationMutationVariables
>;
export const UpsertCompanyOnboardingFieldDelegationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpsertCompanyOnboardingFieldDelegation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'companyUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'fieldName' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpsertCompanyOnboardingFieldDelegationInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'upsertCompanyOnboardingFieldDelegation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'companyUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'companyUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'fieldName' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'fieldName' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpsertCompanyOnboardingFieldDelegationMutation,
  UpsertCompanyOnboardingFieldDelegationMutationVariables
>;
export const DeleteNetworkOnboardingFieldDelegationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteNetworkOnboardingFieldDelegation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteNetworkOnboardingFieldDelegation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteNetworkOnboardingFieldDelegationMutation,
  DeleteNetworkOnboardingFieldDelegationMutationVariables
>;
export const DeleteCompanyOnboardingFieldDelegationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteCompanyOnboardingFieldDelegation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteCompanyOnboardingFieldDelegation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteCompanyOnboardingFieldDelegationMutation,
  DeleteCompanyOnboardingFieldDelegationMutationVariables
>;
export const CompaniesQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CompaniesQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'listCompanies' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'offset' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isCustomer' } },
                { kind: 'Field', name: { kind: 'Name', value: 'supportTier' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'networks' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'NetworkFields' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'NetworkFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Network' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companySlug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isTrial' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isTemplate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nosUpgradeChannel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpgradedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'highAvailabilityConfig' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'virtualDevices' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'deviceType' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mailingAddress' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'line1' } },
                { kind: 'Field', name: { kind: 'Name', value: 'line2' } },
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subdivisionCode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'postalCode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'countryISO2' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CompaniesQueryQuery, CompaniesQueryQueryVariables>;
export const CompanyQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CompanyQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getCompany' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'slug' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isCustomer' } },
                { kind: 'Field', name: { kind: 'Name', value: 'supportTier' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'networks' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'NetworkFields' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'NetworkFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Network' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companySlug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isTrial' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isTemplate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nosUpgradeChannel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpgradedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'highAvailabilityConfig' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'virtualDevices' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'deviceType' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mailingAddress' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'line1' } },
                { kind: 'Field', name: { kind: 'Name', value: 'line2' } },
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subdivisionCode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'postalCode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'countryISO2' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CompanyQueryQuery, CompanyQueryQueryVariables>;
export const CreateNosFirmwareUpgradeMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateNOSFirmwareUpgradeMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateBulkNOSUpgradeInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createBulkNOSUpgrade' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateNosFirmwareUpgradeMutationMutation,
  CreateNosFirmwareUpgradeMutationMutationVariables
>;
export const BulkNosUpgradeQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'BulkNOSUpgradeQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'bulkNOSUpgrade' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nosVersionID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'scheduledAtEarliest' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'networks' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'companySlug' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'company' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'upcomingScheduledNetworkNOSUpgrade' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'scheduledAt' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BulkNosUpgradeQueryQuery, BulkNosUpgradeQueryQueryVariables>;
export const BulkNosUpgradesQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'BulkNOSUpgradesQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'BulkNOSUpgradesFilterInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'bulkNOSUpgrades' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nosVersionID' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'networks' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'scheduledAtEarliest' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BulkNosUpgradesQueryQuery, BulkNosUpgradesQueryQueryVariables>;
export const NetworksByFilterQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'NetworksByFilterQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'NetworksFilter' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'networks' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companySlug' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'company' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'supportTier' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'mailingAddress' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'squareFeet' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'virtualDevices' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hardwareDevice' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'deviceType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'deviceModel' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'pinnedNOSVersionID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pendingNOSVersionID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastUpgradedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nosUpgradeChannel' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<NetworksByFilterQueryQuery, NetworksByFilterQueryQueryVariables>;
export const FleetwideNotificationSettingsQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'FleetwideNotificationSettingsQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'alertName' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fleetwideNotificationSettings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filters' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'alertName' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'alertName' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'FleetwideNotificationSettingFragment' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'FleetwideNotificationSettingFragment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FleetwideNotificationSetting' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'alertDefinitionName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'alertReceiver' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'companyUUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'arguments' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'parameterName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'countAppliedNetworks' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'enabledForInactiveNetworks' } },
          { kind: 'Field', name: { kind: 'Name', value: 'enabledForInternalNetworks' } },
          { kind: 'Field', name: { kind: 'Name', value: 'enabledCustomerSupportTiers' } },
          { kind: 'Field', name: { kind: 'Name', value: 'enabledNOSUpgradeChannels' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FleetwideNotificationSettingsQueryQuery,
  FleetwideNotificationSettingsQueryQueryVariables
>;
export const CreateFleetwideNotificationSettingMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateFleetwideNotificationSettingMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreateFleetwideNotificationSettingInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createFleetwideNotificationSetting' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'FleetwideNotificationSettingFragment' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'FleetwideNotificationSettingFragment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FleetwideNotificationSetting' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'alertDefinitionName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'alertReceiver' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'companyUUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'arguments' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'parameterName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'countAppliedNetworks' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'enabledForInactiveNetworks' } },
          { kind: 'Field', name: { kind: 'Name', value: 'enabledForInternalNetworks' } },
          { kind: 'Field', name: { kind: 'Name', value: 'enabledCustomerSupportTiers' } },
          { kind: 'Field', name: { kind: 'Name', value: 'enabledNOSUpgradeChannels' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateFleetwideNotificationSettingMutationMutation,
  CreateFleetwideNotificationSettingMutationMutationVariables
>;
export const UpdateFleetwideNotificationSettingMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateFleetwideNotificationSettingMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateFleetwideNotificationSettingInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateFleetwideNotificationSetting' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'FleetwideNotificationSettingFragment' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'FleetwideNotificationSettingFragment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FleetwideNotificationSetting' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'alertDefinitionName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'alertReceiver' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'companyUUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'arguments' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'parameterName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'countAppliedNetworks' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'enabledForInactiveNetworks' } },
          { kind: 'Field', name: { kind: 'Name', value: 'enabledForInternalNetworks' } },
          { kind: 'Field', name: { kind: 'Name', value: 'enabledCustomerSupportTiers' } },
          { kind: 'Field', name: { kind: 'Name', value: 'enabledNOSUpgradeChannels' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateFleetwideNotificationSettingMutationMutation,
  UpdateFleetwideNotificationSettingMutationMutationVariables
>;
export const DeleteFleetwideNotificationSettingDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteFleetwideNotificationSetting' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'UUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteFleetwideNotificationSetting' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'UUID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteFleetwideNotificationSettingMutation,
  DeleteFleetwideNotificationSettingMutationVariables
>;
export const AlertDefinitionsQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AlertDefinitionsQuery' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'alertDefinitions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'availability' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isBatch' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isFleetwideSupported' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'parameters' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'required' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isFleetwideSupported' } },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'AlertParameterNumber' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              alias: { kind: 'Name', value: 'numberDefaultValue' },
                              name: { kind: 'Name', value: 'defaultValue' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'AlertParameterBoolean' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              alias: { kind: 'Name', value: 'booleanDefaultValue' },
                              name: { kind: 'Name', value: 'defaultValue' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'AlertParameterDate' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              alias: { kind: 'Name', value: 'dateDefaultValue' },
                              name: { kind: 'Name', value: 'defaultValue' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'AlertParameterDateTime' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              alias: { kind: 'Name', value: 'dateTimeDefaultValue' },
                              name: { kind: 'Name', value: 'defaultValue' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'AlertParameterDuration' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              alias: { kind: 'Name', value: 'durationDefaultValue' },
                              name: { kind: 'Name', value: 'defaultValue' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'AlertParameterString' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              alias: { kind: 'Name', value: 'stringDefaultValue' },
                              name: { kind: 'Name', value: 'defaultValue' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AlertDefinitionsQueryQuery, AlertDefinitionsQueryQueryVariables>;
export const FleetwideNotificationSettingQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'FleetwideNotificationSettingQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fleetwideNotificationSetting' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'uuid' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'FleetwideNotificationSettingFragment' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'FleetwideNotificationSettingFragment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FleetwideNotificationSetting' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'alertDefinitionName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'alertReceiver' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'companyUUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'arguments' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'parameterName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'countAppliedNetworks' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'enabledForInactiveNetworks' } },
          { kind: 'Field', name: { kind: 'Name', value: 'enabledForInternalNetworks' } },
          { kind: 'Field', name: { kind: 'Name', value: 'enabledCustomerSupportTiers' } },
          { kind: 'Field', name: { kind: 'Name', value: 'enabledNOSUpgradeChannels' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FleetwideNotificationSettingQueryQuery,
  FleetwideNotificationSettingQueryQueryVariables
>;
export const AppliedFleetwideNotificationSettingQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AppliedFleetwideNotificationSettingQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'appliedFleetwideNotificationSetting' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'uuid' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'alertReceiver' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'targets' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'fleetwideNotificationSetting' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'FleetwideNotificationSettingFragment' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'network' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'FleetwideNotificationSettingFragment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FleetwideNotificationSetting' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'alertDefinitionName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'alertReceiver' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'companyUUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'arguments' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'parameterName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'countAppliedNetworks' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'enabledForInactiveNetworks' } },
          { kind: 'Field', name: { kind: 'Name', value: 'enabledForInternalNetworks' } },
          { kind: 'Field', name: { kind: 'Name', value: 'enabledCustomerSupportTiers' } },
          { kind: 'Field', name: { kind: 'Name', value: 'enabledNOSUpgradeChannels' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AppliedFleetwideNotificationSettingQueryQuery,
  AppliedFleetwideNotificationSettingQueryQueryVariables
>;
export const FleetwideSnoozesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'fleetwideSnoozes' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'futureFleetwideNotificationSnoozes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'snoozeStart' } },
                { kind: 'Field', name: { kind: 'Name', value: 'snoozeEnd' } },
                { kind: 'Field', name: { kind: 'Name', value: 'snoozeReason' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'company' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'network' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'company' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'fleetwideNotificationSetting' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FleetwideSnoozesQuery, FleetwideSnoozesQueryVariables>;
export const CreateFleetwideSnoozeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createFleetwideSnooze' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'fleetwideNotificationSettingUUID' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'companyUUID' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreateNotificationSnoozeInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createFleetwideNotificationSnooze' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'fleetwideNotificationSettingUUID' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'fleetwideNotificationSettingUUID' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'companyUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'companyUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateFleetwideSnoozeMutation, CreateFleetwideSnoozeMutationVariables>;
export const UpdateFleetwideSnoozeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateFleetwideSnooze' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateNotificationSnoozeInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateFleetwideNotificationSnooze' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateFleetwideSnoozeMutation, UpdateFleetwideSnoozeMutationVariables>;
export const DeleteFleetwideSnoozeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'deleteFleetwideSnooze' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteFleetwideNotificationSnooze' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteFleetwideSnoozeMutation, DeleteFleetwideSnoozeMutationVariables>;
export const NosUpgradeGroupsForNetworkDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'NOSUpgradeGroupsForNetwork' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'nosUpgradeGroupsForNetwork' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'defaultDeviceType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'defaultDeviceSubtype' } },
                { kind: 'Field', name: { kind: 'Name', value: 'networkUUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timeoutDurationSeconds' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'virtualDevices' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'deviceType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'deviceModel' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'network' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'companySlug' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hardwareDevice' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'macAddress' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  NosUpgradeGroupsForNetworkQuery,
  NosUpgradeGroupsForNetworkQueryVariables
>;
export const ScheduledNetworkNosUpgradesforNetworkDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ScheduledNetworkNOSUpgradesforNetwork' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scheduledNetworkNOSUpgradesForNetwork' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'networkUUID' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nosVersion' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'major' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'minor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'patch' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'scheduledAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pendingNOSUpgradeGroups' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'groupUpgrades' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nosUpgradeGroup' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'scheduledAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'deviceUpgrades' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'virtualDevice' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'scheduledAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ScheduledNetworkNosUpgradesforNetworkQuery,
  ScheduledNetworkNosUpgradesforNetworkQueryVariables
>;
export const CreateNosUpgradeGroupDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateNOSUpgradeGroup' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreateNOSUpgradeGroupInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createNOSUpgradeGroup' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateNosUpgradeGroupMutation, CreateNosUpgradeGroupMutationVariables>;
export const UpdateNosUpgradeGroupDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateNOSUpgradeGroup' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateNOSUpgradeGroupInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateNOSUpgradeGroup' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'nosUpgradeGroupUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateNosUpgradeGroupMutation, UpdateNosUpgradeGroupMutationVariables>;
export const UpdateNosUpgradeGroupsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateNOSUpgradeGroups' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'inputs' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: { kind: 'Name', value: 'UpdateNOSUpgradeGroupsInput' },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateNOSUpgradeGroups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'inputs' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'inputs' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateNosUpgradeGroupsMutation,
  UpdateNosUpgradeGroupsMutationVariables
>;
export const DeleteNosUpgradeGroupDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteNOSUpgradeGroup' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteNOSUpgradeGroup' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'nosUpgradeGroupUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteNosUpgradeGroupMutation, DeleteNosUpgradeGroupMutationVariables>;
export const CancelNosUpgradeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CancelNOSUpgrade' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'force' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cancelScheduledNetworkNOSUpgrade' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'scheduledNetworkNOSUpgradeUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'forceInProgressCancel' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'force' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CancelNosUpgradeMutation, CancelNosUpgradeMutationVariables>;
export const SetNetworkNosVersionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SetNetworkNOSVersion' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'SetNetworkNosVersionInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setNetworkNosVersion' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SetNetworkNosVersionMutation, SetNetworkNosVersionMutationVariables>;
export const NosVersionsQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'NosVersionsQuery' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'nosVersions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'NosVersionFields' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'networks' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'active' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'eq' },
                            value: { kind: 'BooleanValue', value: true },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'NetworkFieldsForNOSVersion' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'NetworkFieldsForNOSVersion' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Network' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCustomer' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companySlug' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'supportTier' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mailingAddress' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'squareFeet' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'virtualDevices' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hardwareDevice' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'deviceType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'deviceModel' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'pinnedNOSVersionID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pendingNOSVersionID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpgradedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nosUpgradeChannel' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'NosVersionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'NosVersion' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mc01Build' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mw07Build' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ms10Build' } },
          { kind: 'Field', name: { kind: 'Name', value: 's1Build' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mp01Build' } },
          { kind: 'Field', name: { kind: 'Name', value: 'observerBuild' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isDeprecated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPublic' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'major' } },
          { kind: 'Field', name: { kind: 'Name', value: 'minor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'patch' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'networks' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'NetworkFieldsForNOSVersion' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<NosVersionsQueryQuery, NosVersionsQueryQueryVariables>;
export const NosVersionByIdQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'NosVersionByIDQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'nosVersions' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isDeprecated' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isGA' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isLocked' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isPublic' } },
                { kind: 'Field', name: { kind: 'Name', value: 'releaseNotes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'major' } },
                { kind: 'Field', name: { kind: 'Name', value: 'minor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'patch' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mc01Build' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mw07Build' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mw08Build' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mw09Build' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ms10Build' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ms11Build' } },
                { kind: 'Field', name: { kind: 'Name', value: 's1Build' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mp01Build' } },
                { kind: 'Field', name: { kind: 'Name', value: 'observerBuild' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<NosVersionByIdQueryQuery, NosVersionByIdQueryQueryVariables>;
export const UpdateNosVersionMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateNOSVersionMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'NosVersionInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateNosVersion' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateNosVersionMutationMutation,
  UpdateNosVersionMutationMutationVariables
>;
export const CreateNosVersionMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateNOSVersionMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'NosVersionInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createNosVersion' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateNosVersionMutationMutation,
  CreateNosVersionMutationMutationVariables
>;
export const NosFeaturesQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'NosFeaturesQuery' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'nosFeatures' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'minMajorVersion' } },
                { kind: 'Field', name: { kind: 'Name', value: 'minMinorVersion' } },
                { kind: 'Field', name: { kind: 'Name', value: 'minPatchVersion' } },
                { kind: 'Field', name: { kind: 'Name', value: 'maxMajorVersion' } },
                { kind: 'Field', name: { kind: 'Name', value: 'maxMinorVersion' } },
                { kind: 'Field', name: { kind: 'Name', value: 'maxPatchVersion' } },
                { kind: 'Field', name: { kind: 'Name', value: 'featureFlag' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nosVersions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'networks' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'active' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'eq' },
                            value: { kind: 'BooleanValue', value: true },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'NetworkFieldsForNOSVersion' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'NetworkFieldsForNOSVersion' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Network' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCustomer' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companySlug' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'supportTier' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mailingAddress' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'squareFeet' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'virtualDevices' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hardwareDevice' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'deviceType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'deviceModel' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'pinnedNOSVersionID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pendingNOSVersionID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpgradedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nosUpgradeChannel' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<NosFeaturesQueryQuery, NosFeaturesQueryQueryVariables>;
export const NosFeatureQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'NosFeatureQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'nosFeature' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'minMajorVersion' } },
                { kind: 'Field', name: { kind: 'Name', value: 'minMinorVersion' } },
                { kind: 'Field', name: { kind: 'Name', value: 'minPatchVersion' } },
                { kind: 'Field', name: { kind: 'Name', value: 'maxMajorVersion' } },
                { kind: 'Field', name: { kind: 'Name', value: 'maxMinorVersion' } },
                { kind: 'Field', name: { kind: 'Name', value: 'maxPatchVersion' } },
                { kind: 'Field', name: { kind: 'Name', value: 'featureFlag' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<NosFeatureQueryQuery, NosFeatureQueryQueryVariables>;
export const UpdateNosFeatureMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateNosFeatureMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateNosFeatureInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateNosFeature' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateNosFeatureMutationMutation,
  UpdateNosFeatureMutationMutationVariables
>;
export const CreateNosFeatureMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateNosFeatureMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateNosFeatureInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createNosFeature' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateNosFeatureMutationMutation,
  CreateNosFeatureMutationMutationVariables
>;
export const AllPromosDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AllPromos' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allMarketingChangelogEntries' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PromoFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PromoFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MarketingChangelogEntry' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heading' } },
          { kind: 'Field', name: { kind: 'Name', value: 'copy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkURL' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'imageS3Keys' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'lightS3Key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'darkS3Key' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'badge' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'icon' } },
                { kind: 'Field', name: { kind: 'Name', value: 'text' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'visibleStartAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'visibleEndAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AllPromosQuery, AllPromosQueryVariables>;
export const PromoDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Promo' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'marketingChangelogEntry' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PromoFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PromoFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MarketingChangelogEntry' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heading' } },
          { kind: 'Field', name: { kind: 'Name', value: 'copy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkURL' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'imageS3Keys' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'lightS3Key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'darkS3Key' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'badge' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'icon' } },
                { kind: 'Field', name: { kind: 'Name', value: 'text' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'visibleStartAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'visibleEndAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PromoQuery, PromoQueryVariables>;
export const CreatePromoDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreatePromo' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreateMarketingChangelogEntryInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createMarketingChangelogEntry' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreatePromoMutation, CreatePromoMutationVariables>;
export const UpdatePromoDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdatePromo' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateMarketingChangelogEntryInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateMarketingChangelogEntry' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdatePromoMutation, UpdatePromoMutationVariables>;
export const ListProvidersQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ListProvidersQuery' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'internetServicePlanProviders' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'logoS3Key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'iconS3Key' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'staticRates' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ListProvidersQueryQuery, ListProvidersQueryQueryVariables>;
export const ListProviderStaticRatesQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ListProviderStaticRatesQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'providerUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'internetServicePlanProviderStaticRates' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'providerUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'providerUUID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'connectionType' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'locationMode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'downloadKbps' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uploadKbps' } },
                { kind: 'Field', name: { kind: 'Name', value: 'monthlyCostCents' } },
                { kind: 'Field', name: { kind: 'Name', value: 'installCostCents' } },
                { kind: 'Field', name: { kind: 'Name', value: 'termMonths' } },
                { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ListProviderStaticRatesQueryQuery,
  ListProviderStaticRatesQueryQueryVariables
>;
export const ListConnectionTypesQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ListConnectionTypesQuery' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'internetServicePlanConnectionTypes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ListConnectionTypesQueryQuery, ListConnectionTypesQueryQueryVariables>;
export const GetProviderQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetProviderQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'internetServicePlanProvider' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'uuid' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'logoS3Key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'iconS3Key' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'aliases' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'alias' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'staticRates' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetProviderQueryQuery, GetProviderQueryQueryVariables>;
export const GetProviderStaticRateQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetProviderStaticRateQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'UUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'internetServicePlanProviderStaticRate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'UUID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'connectionType' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'locationMode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'downloadKbps' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uploadKbps' } },
                { kind: 'Field', name: { kind: 'Name', value: 'monthlyCostCents' } },
                { kind: 'Field', name: { kind: 'Name', value: 'installCostCents' } },
                { kind: 'Field', name: { kind: 'Name', value: 'termMonths' } },
                { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetProviderStaticRateQueryQuery,
  GetProviderStaticRateQueryQueryVariables
>;
export const CreateInternetServicePlanProviderMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateInternetServicePlanProviderMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreateInternetServicePlanProviderInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createInternetServicePlanProvider' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'logoS3Key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'iconS3Key' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'aliases' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'alias' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateInternetServicePlanProviderMutationMutation,
  CreateInternetServicePlanProviderMutationMutationVariables
>;
export const UpdateInternetServicePlanProviderMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateInternetServicePlanProviderMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateInternetServicePlanProviderInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateInternetServicePlanProvider' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'uuid' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'logoS3Key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'iconS3Key' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'aliases' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'alias' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateInternetServicePlanProviderMutationMutation,
  UpdateInternetServicePlanProviderMutationMutationVariables
>;
export const CreateInternetServicePlanProviderStaticRateMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateInternetServicePlanProviderStaticRateMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreateInternetServicePlanProviderStaticRateInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createInternetServicePlanProviderStaticRate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'connectionType' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'locationMode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'downloadKbps' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uploadKbps' } },
                { kind: 'Field', name: { kind: 'Name', value: 'monthlyCostCents' } },
                { kind: 'Field', name: { kind: 'Name', value: 'installCostCents' } },
                { kind: 'Field', name: { kind: 'Name', value: 'termMonths' } },
                { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateInternetServicePlanProviderStaticRateMutationMutation,
  CreateInternetServicePlanProviderStaticRateMutationMutationVariables
>;
export const UpdateInternetServicePlanProviderStaticRateMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateInternetServicePlanProviderStaticRateMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'UUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateInternetServicePlanProviderStaticRateInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateInternetServicePlanProviderStaticRate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'UUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'connectionType' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'locationMode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'downloadKbps' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uploadKbps' } },
                { kind: 'Field', name: { kind: 'Name', value: 'monthlyCostCents' } },
                { kind: 'Field', name: { kind: 'Name', value: 'installCostCents' } },
                { kind: 'Field', name: { kind: 'Name', value: 'termMonths' } },
                { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateInternetServicePlanProviderStaticRateMutationMutation,
  UpdateInternetServicePlanProviderStaticRateMutationMutationVariables
>;
export const UpdateInternetServicePlanProviderStaticRatesMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateInternetServicePlanProviderStaticRatesMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'UUIDs' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'enabled' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateInternetServicePlanProviderStaticRates' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUIDs' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'UUIDs' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'enabled' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'enabled' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'connectionType' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'locationMode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'downloadKbps' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uploadKbps' } },
                { kind: 'Field', name: { kind: 'Name', value: 'monthlyCostCents' } },
                { kind: 'Field', name: { kind: 'Name', value: 'installCostCents' } },
                { kind: 'Field', name: { kind: 'Name', value: 'termMonths' } },
                { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateInternetServicePlanProviderStaticRatesMutationMutation,
  UpdateInternetServicePlanProviderStaticRatesMutationMutationVariables
>;
export const DeleteInternetServicePlanProviderStaticRateMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteInternetServicePlanProviderStaticRateMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'UUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteInternetServicePlanProviderStaticRate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'UUID' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteInternetServicePlanProviderStaticRateMutationMutation,
  DeleteInternetServicePlanProviderStaticRateMutationMutationVariables
>;
export const DeviceConfigLatestAndCurrentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'DeviceConfigLatestAndCurrent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'serialNumber' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'latestDeviceConfig' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'serialNumber' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'serialNumber' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'state' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'isCurrentAsOf' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'currentDeviceConfig' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'serialNumber' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'serialNumber' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'state' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'isCurrentAsOf' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeviceConfigLatestAndCurrentQuery,
  DeviceConfigLatestAndCurrentQueryVariables
>;
export const WorkbenchNetworkInsightsQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'WorkbenchNetworkInsightsQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'network' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'nosUpgradeChannel' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'company' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'supportTier' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  WorkbenchNetworkInsightsQueryQuery,
  WorkbenchNetworkInsightsQueryQueryVariables
>;
export const ReassignNetworkDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ReassignNetwork' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sourceNetworkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'destinationNetworkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reassignNetwork' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sourceNetworkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sourceNetworkUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'destinationNetworkUUID' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'destinationNetworkUUID' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ReassignNetworkMutation, ReassignNetworkMutationVariables>;
export const ListCompaniesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'listCompanies' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'listCompanies' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'networks' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ListCompaniesQuery, ListCompaniesQueryVariables>;
export const ApplyNetworkTemplateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ApplyNetworkTemplate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sourceNetworkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'destinationNetworkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'shouldKeepSSIDNames' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applyTemplateToNetwork' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sourceNetworkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sourceNetworkUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'destinationNetworkUUID' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'destinationNetworkUUID' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'shouldKeepSSIDNames' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'shouldKeepSSIDNames' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ApplyNetworkTemplateMutation, ApplyNetworkTemplateMutationVariables>;
export const CompaniesHoldingGlobalNetworkTemplatesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CompaniesHoldingGlobalNetworkTemplates' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'companiesHoldingGlobalNetworkTemplates' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isCustomer' } },
                { kind: 'Field', name: { kind: 'Name', value: 'supportGroup' } },
                { kind: 'Field', name: { kind: 'Name', value: 'websiteDomain' } },
                { kind: 'Field', name: { kind: 'Name', value: 'holdsGlobalNetworkTemplates' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'networks' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isTemplate' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CompaniesHoldingGlobalNetworkTemplatesQuery,
  CompaniesHoldingGlobalNetworkTemplatesQueryVariables
>;
export const NetworkVirtualDevicesForCopierDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'NetworkVirtualDevicesForCopier' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'virtualDevicesForNetwork' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hardwareDevice' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'serialNumber' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  NetworkVirtualDevicesForCopierQuery,
  NetworkVirtualDevicesForCopierQueryVariables
>;
export const InternalNotesForNetworkDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'InternalNotesForNetwork' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'internalNotesForNetwork' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'InternalNoteFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'InternalNoteFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'InternalNote' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createdByUser' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updatedByUser' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isImportant' } },
          { kind: 'Field', name: { kind: 'Name', value: 'note' } },
          { kind: 'Field', name: { kind: 'Name', value: 'photoURLs' } },
          { kind: 'Field', name: { kind: 'Name', value: 'photoS3Keys' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<InternalNotesForNetworkQuery, InternalNotesForNetworkQueryVariables>;
export const InternalNoteDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'InternalNote' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'UUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'internalNote' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'UUID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'InternalNoteFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'InternalNoteFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'InternalNote' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createdByUser' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updatedByUser' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isImportant' } },
          { kind: 'Field', name: { kind: 'Name', value: 'note' } },
          { kind: 'Field', name: { kind: 'Name', value: 'photoURLs' } },
          { kind: 'Field', name: { kind: 'Name', value: 'photoS3Keys' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<InternalNoteQuery, InternalNoteQueryVariables>;
export const CreateInternalNoteDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateInternalNote' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateInternalNoteInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createInternalNote' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateInternalNoteMutation, CreateInternalNoteMutationVariables>;
export const UpdateInternalNoteDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateInternalNote' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'UUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateInternalNoteInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateInternalNote' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'UUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateInternalNoteMutation, UpdateInternalNoteMutationVariables>;
export const DeleteInternalNoteDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteInternalNote' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'UUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteInternalNote' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'UUID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteInternalNoteMutation, DeleteInternalNoteMutationVariables>;
export const DevicesForNetworkDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'DevicesForNetwork' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'virtualDevicesForNetwork' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deviceType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hardwareDevice' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'serialNumber' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DevicesForNetworkQuery, DevicesForNetworkQueryVariables>;
export const TunnelIpAddressHardwareDeviceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'TunnelIPAddressHardwareDevice' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'serialNumber' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hardwareDevice' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'serialNumber' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'serialNumber' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'tunnelIPAddress' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TunnelIpAddressHardwareDeviceQuery,
  TunnelIpAddressHardwareDeviceQueryVariables
>;
export const StartPacketCaptureDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'startPacketCapture' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'serialNumber' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RPCWosPacketCaptureStartInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rpcWosPacketCaptureStart' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'serialNumber' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'serialNumber' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'jobId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<StartPacketCaptureMutation, StartPacketCaptureMutationVariables>;
export const StopPacketCaptureDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'stopPacketCapture' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'serialNumber' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RPCWosPacketCaptureStopInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rpcWosPacketCaptureStop' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'serialNumber' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'serialNumber' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'jobId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<StopPacketCaptureMutation, StopPacketCaptureMutationVariables>;
export const PacketCaptureJobDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'packetCaptureJob' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'jobId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'packetCaptureJob' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'jobId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'jobId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'jobId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'virtualDeviceUUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'networkUUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'listenOn' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stopped' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tcpDumpFilter' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timeLimitSeconds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sizeLimitMb' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PacketCaptureJobQuery, PacketCaptureJobQueryVariables>;
export const RoutesForVirtualDeviceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'RoutesForVirtualDevice' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'virtualDeviceUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'networkRoutesForVirtualDevice' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'virtualDeviceUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'virtualDeviceUUID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'destination' } },
                { kind: 'Field', name: { kind: 'Name', value: 'gateway' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'attachment' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'vlan' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'vlanID' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'phyInterface' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'portNumber' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'hardwareLabel' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'virtualDevice' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'deviceType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'deviceModel' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'internetServicePlan' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'provider' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'autoVPNGroup' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ipSecTunnel' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'clientVPNServer' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'endpoint' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RoutesForVirtualDeviceQuery, RoutesForVirtualDeviceQueryVariables>;
export const PolicyRoutingRulesForNetworkDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PolicyRoutingRulesForNetwork' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'policyRoutingRulesForNetwork' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PolicyRoutingRulesFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PolicyRoutingRulesFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PolicyRoutingRule' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'srcPrefix' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'srcVLAN' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'vlanID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ipV4ClientAssignmentProtocol' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ipV4ClientGateway' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ipV4ClientPrefixLength' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'dstPrefix' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'srcPortRanges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'lower' } },
                { kind: 'Field', name: { kind: 'Name', value: 'upper' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dstPortRanges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'lower' } },
                { kind: 'Field', name: { kind: 'Name', value: 'upper' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'protocols' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'bindings' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'phyInterface' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'PhyInterfaceLabelFields' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'isUplinkActive' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasWANActivity' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isEnabled' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'metric' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhyInterfaceLabelFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PhyInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'portNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hardwareLabel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'virtualDevice' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deviceModel' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'internetServicePlan' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'provider' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PolicyRoutingRulesForNetworkQuery,
  PolicyRoutingRulesForNetworkQueryVariables
>;
export const PolicyRoutingRuleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PolicyRoutingRule' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'policyRoutingRule' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PolicyRoutingRulesFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PolicyRoutingRulesFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PolicyRoutingRule' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'srcPrefix' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'srcVLAN' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'vlanID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ipV4ClientAssignmentProtocol' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ipV4ClientGateway' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ipV4ClientPrefixLength' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'dstPrefix' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'srcPortRanges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'lower' } },
                { kind: 'Field', name: { kind: 'Name', value: 'upper' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dstPortRanges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'lower' } },
                { kind: 'Field', name: { kind: 'Name', value: 'upper' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'protocols' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'bindings' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'phyInterface' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'PhyInterfaceLabelFields' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'isUplinkActive' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasWANActivity' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isEnabled' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'metric' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhyInterfaceLabelFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PhyInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'portNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hardwareLabel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'virtualDevice' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deviceModel' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'internetServicePlan' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'provider' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PolicyRoutingRuleQuery, PolicyRoutingRuleQueryVariables>;
export const CreatePolicyRoutingRuleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreatePolicyRoutingRule' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreatePolicyRoutingRuleInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createPolicyRoutingRule' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreatePolicyRoutingRuleMutation,
  CreatePolicyRoutingRuleMutationVariables
>;
export const UpdatePolicyRoutingRuleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdatePolicyRoutingRule' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdatePolicyRoutingRuleInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updatePolicyRoutingRule' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdatePolicyRoutingRuleMutation,
  UpdatePolicyRoutingRuleMutationVariables
>;
export const DeletePolicyRoutingRuleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeletePolicyRoutingRule' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deletePolicyRoutingRule' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeletePolicyRoutingRuleMutation,
  DeletePolicyRoutingRuleMutationVariables
>;
export const UpdatePolicyRoutingRuleBindingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdatePolicyRoutingRuleBindings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'BindPolicyRoutingRulesInput' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderedRuleUUIDs' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'bindPolicyRoutingRules' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'orderedRuleUUIDs' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'orderedRuleUUIDs' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'metric' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdatePolicyRoutingRuleBindingsMutation,
  UpdatePolicyRoutingRuleBindingsMutationVariables
>;
export const StaticRoutesForNetworkDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'StaticRoutesForNetwork' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'staticRoutesForNetwork' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaticRouteFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaticRouteFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaticRoute' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dstPrefix' } },
          { kind: 'Field', name: { kind: 'Name', value: 'gatewayIP' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'gatewayDHCPStaticMapping' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'macAddress' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ipAddress' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hostname' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'gatewayVLAN' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ipV4ClientAssignmentProtocol' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ipV4ClientGateway' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'explicitlyBoundVLANs' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'excludedVLANs' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<StaticRoutesForNetworkQuery, StaticRoutesForNetworkQueryVariables>;
export const StaticRouteDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'StaticRoute' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'staticRoute' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaticRouteFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaticRouteFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaticRoute' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dstPrefix' } },
          { kind: 'Field', name: { kind: 'Name', value: 'gatewayIP' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'gatewayDHCPStaticMapping' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'macAddress' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ipAddress' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hostname' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'gatewayVLAN' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ipV4ClientAssignmentProtocol' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ipV4ClientGateway' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'explicitlyBoundVLANs' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'excludedVLANs' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<StaticRouteQuery, StaticRouteQueryVariables>;
export const CreateStaticRouteDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateStaticRoute' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateStaticRouteInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createStaticRoute' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateStaticRouteMutation, CreateStaticRouteMutationVariables>;
export const UpdateStaticRouteDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateStaticRoute' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateStaticRouteInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateStaticRoute' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateStaticRouteMutation, UpdateStaticRouteMutationVariables>;
export const DeleteStaticRouteDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteStaticRoute' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteStaticRoute' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteStaticRouteMutation, DeleteStaticRouteMutationVariables>;
export const VlaNsStaticMappingsRulesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'VLANsStaticMappingsRules' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'vlans' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'vlanID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isInternal' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ipV4ClientAssignmentProtocol' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ipV4ClientGateway' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ipV4ClientPrefixLength' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'dhcpRule' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'staticMappings' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'macAddress' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'ipAddress' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'hostname' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<VlaNsStaticMappingsRulesQuery, VlaNsStaticMappingsRulesQueryVariables>;
export const IpForwardingRulesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'IPForwardingRules' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ipForwardingRulesForNetwork' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isEnabled' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'uplinkPhyInterface' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'PhyInterfaceLabelFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'vlan' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'vlanID' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhyInterfaceLabelFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PhyInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'portNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hardwareLabel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'virtualDevice' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deviceModel' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'internetServicePlan' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'provider' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<IpForwardingRulesQuery, IpForwardingRulesQueryVariables>;
export const IpForwardingRuleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'IPForwardingRule' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ipForwardingRule' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isEnabled' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'uplinkPhyInterface' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'PhyInterfaceLabelFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'vlan' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'vlanID' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhyInterfaceLabelFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PhyInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'portNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hardwareLabel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'virtualDevice' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deviceModel' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'internetServicePlan' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'provider' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<IpForwardingRuleQuery, IpForwardingRuleQueryVariables>;
export const CreateIpForwardingRuleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateIPForwardingRule' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreateIPForwardingRuleInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createIPForwardingRule' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateIpForwardingRuleMutation,
  CreateIpForwardingRuleMutationVariables
>;
export const UpdateIpForwardingRuleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateIPForwardingRule' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateIPForwardingRuleInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateIPForwardingRule' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateIpForwardingRuleMutation,
  UpdateIpForwardingRuleMutationVariables
>;
export const DeleteIpForwardingRuleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteIPForwardingRule' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteIPForwardingRule' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteIpForwardingRuleMutation,
  DeleteIpForwardingRuleMutationVariables
>;
export const IpSecTunnelsQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'IPSecTunnelsQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ipSecTunnelsForNetwork' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'IPSecTunnelFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'IPSecTunnelFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IPSecTunnel' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isInitiator' } },
          { kind: 'Field', name: { kind: 'Name', value: 'authenticationAlgorithm' } },
          { kind: 'Field', name: { kind: 'Name', value: 'encryptionAlgorithm' } },
          { kind: 'Field', name: { kind: 'Name', value: 'keyExchangeDHGroup' } },
          { kind: 'Field', name: { kind: 'Name', value: 'right' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rightPrefixes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rightID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'leftID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isClientVPNBound' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'boundPhyInterface' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'portNumber' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'virtualDevice' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hardwareDevice' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'serialNumber' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isSpare' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'isConnectedToBackend' },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'deviceType' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'boundVLANs' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'vlanID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'observedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'saStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uniqueID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'remoteHostIP4Address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'establishedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rekeyAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reauthAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'childSAStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rxBytes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'txBytes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rxPackets' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rxLast' } },
                { kind: 'Field', name: { kind: 'Name', value: 'txLast' } },
                { kind: 'Field', name: { kind: 'Name', value: 'childRekeyAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'childLifetime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'latencyMs' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'peerType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dpdAction' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dpdTimeout' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dpdDelay' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ikeLifetime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rekey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reauth' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<IpSecTunnelsQueryQuery, IpSecTunnelsQueryQueryVariables>;
export const IpSecTunnelQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'IPSecTunnelQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'UUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ipSecTunnel' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'UUID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'IPSecTunnelFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'IPSecTunnelFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IPSecTunnel' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isInitiator' } },
          { kind: 'Field', name: { kind: 'Name', value: 'authenticationAlgorithm' } },
          { kind: 'Field', name: { kind: 'Name', value: 'encryptionAlgorithm' } },
          { kind: 'Field', name: { kind: 'Name', value: 'keyExchangeDHGroup' } },
          { kind: 'Field', name: { kind: 'Name', value: 'right' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rightPrefixes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rightID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'leftID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isClientVPNBound' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'boundPhyInterface' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'portNumber' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'virtualDevice' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hardwareDevice' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'serialNumber' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isSpare' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'isConnectedToBackend' },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'deviceType' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'boundVLANs' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'vlanID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'observedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'saStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uniqueID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'remoteHostIP4Address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'establishedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rekeyAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reauthAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'childSAStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rxBytes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'txBytes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rxPackets' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rxLast' } },
                { kind: 'Field', name: { kind: 'Name', value: 'txLast' } },
                { kind: 'Field', name: { kind: 'Name', value: 'childRekeyAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'childLifetime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'latencyMs' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'peerType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dpdAction' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dpdTimeout' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dpdDelay' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ikeLifetime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rekey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reauth' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<IpSecTunnelQueryQuery, IpSecTunnelQueryQueryVariables>;
export const UpdateIpSecTunnelDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateIPSecTunnel' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateIPSecTunnelInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateIPSecTunnel' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateIpSecTunnelMutation, UpdateIpSecTunnelMutationVariables>;
export const DeleteIpSecTunnelDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteIPSecTunnel' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteIPSecTunnel' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteIpSecTunnelMutation, DeleteIpSecTunnelMutationVariables>;
export const CreateIpSecTunnelDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateIPSecTunnel' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateIPSecTunnelInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createIPSecTunnel' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateIpSecTunnelMutation, CreateIpSecTunnelMutationVariables>;
export const RpcRestartIpSecTunnelDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RpcRestartIPSecTunnel' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'serialNumber' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'ipSecTunnelUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rpcRestartIPSecTunnel' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'serialNumber' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'serialNumber' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'ipSecTunnelUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'ipSecTunnelUUID' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RpcRestartIpSecTunnelMutation, RpcRestartIpSecTunnelMutationVariables>;
export const IpSecTunnelMetricsQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'IPSecTunnelMetricsQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'UUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'MetricsFilterInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ipSecTunnelMetrics' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'ipSecTunnelUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'UUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'ipSecTunnel' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'txBytes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'metadata' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'minValue' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'maxValue' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'values' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'rxBytes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'metadata' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'minValue' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'maxValue' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'values' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'txPackets' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'metadata' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'minValue' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'maxValue' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'values' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'rxPackets' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'metadata' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'minValue' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'maxValue' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'values' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'latencyMs' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'metadata' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'minValue' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'maxValue' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'values' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<IpSecTunnelMetricsQueryQuery, IpSecTunnelMetricsQueryQueryVariables>;
export const VlaNsAndDhcpRulesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'VLANsAndDHCPRules' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'vlans' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isInternal' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
                { kind: 'Field', name: { kind: 'Name', value: 'vlanID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ipV4ClientAssignmentProtocol' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ipV4ClientGateway' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ipV4ClientPrefixLength' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'dhcpRule' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dnsUseGatewayProxy' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<VlaNsAndDhcpRulesQuery, VlaNsAndDhcpRulesQueryVariables>;
export const DnsFirewallRulesForNetworkDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'DNSFirewallRulesForNetwork' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicationDNSFirewallRulesForNetwork' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'action' } },
                { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
                { kind: 'Field', name: { kind: 'Name', value: 'domain' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'category' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'group' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'group' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'application' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'boundDHCPRules' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'vlan' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'vlanID' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DnsFirewallRulesForNetworkQuery,
  DnsFirewallRulesForNetworkQueryVariables
>;
export const DnsFirewallRuleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'DNSFirewallRule' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicationDNSFirewallRule' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'action' } },
                { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
                { kind: 'Field', name: { kind: 'Name', value: 'domain' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'category' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'group' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'group' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'application' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'boundDHCPRules' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'vlan' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'vlanID' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DnsFirewallRuleQuery, DnsFirewallRuleQueryVariables>;
export const CreateDnsFirewallRuleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateDNSFirewallRule' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreateApplicationDNSFirewallRuleInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createApplicationDNSFirewallRule' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateDnsFirewallRuleMutation, CreateDnsFirewallRuleMutationVariables>;
export const UpdateDnsFirewallRuleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateDNSFirewallRule' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateApplicationDNSFirewallRuleInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateApplicationDNSFirewallRule' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateDnsFirewallRuleMutation, UpdateDnsFirewallRuleMutationVariables>;
export const DeleteDnsFirewallRuleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteDNSFirewallRule' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteApplicationDNSFirewallRule' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteDnsFirewallRuleMutation, DeleteDnsFirewallRuleMutationVariables>;
export const UpdateDnsFirewallRulesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateDNSFirewallRules' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'inputs' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: { kind: 'Name', value: 'UpdateApplicationDNSFirewallRulesInput' },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateApplicationDNSFirewallRules' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'inputs' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'inputs' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateDnsFirewallRulesMutation,
  UpdateDnsFirewallRulesMutationVariables
>;
export const DnsFirewallRuleCategoriesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'DNSFirewallRuleCategories' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicationDNSFirewallRuleCategories' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'group' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DnsFirewallRuleCategoriesQuery,
  DnsFirewallRuleCategoriesQueryVariables
>;
export const DnsFirewallRuleGroupsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'DNSFirewallRuleGroups' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicationDNSFirewallRuleGroups' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DnsFirewallRuleGroupsQuery, DnsFirewallRuleGroupsQueryVariables>;
export const DnsFirewallRuleApplicationsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'DNSFirewallRuleApplications' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicationDNSFirewallRuleApplications' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DnsFirewallRuleApplicationsQuery,
  DnsFirewallRuleApplicationsQueryVariables
>;
export const DnsDomainApplicationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'DNSDomainApplication' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'hostname' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicationDNSFirewallRuleApplicationForHostname' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'hostname' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'hostname' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isVisible' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DnsDomainApplicationQuery, DnsDomainApplicationQueryVariables>;
export const DnsDomainCategoryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'DNSDomainCategory' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'hostname' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicationDNSFirewallRuleCategoryForHostname' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'hostname' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'hostname' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'group' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DnsDomainCategoryQuery, DnsDomainCategoryQueryVariables>;
export const IdsipsCustomRuleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'IDSIPSCustomRule' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'idsIPSCustomRule' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'IDSIPSCustomRuleFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'IDSIPSCustomRuleFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IDSIPSCustomRule' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'action' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'application' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'domain' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'boundVLANs' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'vlanID' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<IdsipsCustomRuleQuery, IdsipsCustomRuleQueryVariables>;
export const CreateIdsipsCustomRuleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateIDSIPSCustomRule' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'configUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreateIDSIPSCustomRuleInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createIDSIPSCustomRule' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'idsIPSConfigUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'configUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateIdsipsCustomRuleMutation,
  CreateIdsipsCustomRuleMutationVariables
>;
export const UpdateIdsipsCustomRuleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateIDSIPSCustomRule' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'ruleUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateIDSIPSCustomRuleInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateIDSIPSCustomRule' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'ruleUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'ruleUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateIdsipsCustomRuleMutation,
  UpdateIdsipsCustomRuleMutationVariables
>;
export const DeleteIdsipsCustomRuleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteIDSIPSCustomRule' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'ruleUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteIDSIPSCustomRule' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'ruleUUID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteIdsipsCustomRuleMutation,
  DeleteIdsipsCustomRuleMutationVariables
>;
export const UpdateInterVlanCommunicationPermittedPairsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateInterVLANCommunicationPermittedPairs' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'vlanPairs' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'VLANPairInput' } },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateInterVLANCommunicationPermittedPairs' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'vlanPairs' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'vlanPairs' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateInterVlanCommunicationPermittedPairsMutation,
  UpdateInterVlanCommunicationPermittedPairsMutationVariables
>;
export const IdsCategoryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'IDSCategory' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'categoryUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'idsIPSCategory' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'categoryUUID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'IDSIPSCategoryFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'IDSIPSCategoryFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IDSIPSCategory' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shortname' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shortDescription' } },
          { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ruleCount' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<IdsCategoryQuery, IdsCategoryQueryVariables>;
export const IdsipsCategoriesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'IDSIPSCategories' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'idsIPSCategories' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'IDSIPSCategoryFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'IDSIPSCategoryFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IDSIPSCategory' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shortname' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shortDescription' } },
          { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ruleCount' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<IdsipsCategoriesQuery, IdsipsCategoriesQueryVariables>;
export const IdsRuleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'IDSRule' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'ruleSID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'idsRule' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'ruleSID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'ruleSID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'IDSRuleFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'IDSRuleFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IDSRule' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'SID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'action' } },
          { kind: 'Field', name: { kind: 'Name', value: 'classType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'groupID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'revision' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'references' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ref' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<IdsRuleQuery, IdsRuleQueryVariables>;
export const IdsipsConfigForNetworkDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'IDSIPSConfigForNetwork' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'network' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'idsIPSConfig' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'minSeverity' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'minIPSSeverity' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isEastWestProtectionEnabled' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'ipsRuleDuration' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'safelist' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sourceVersion' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'enabledVLANs' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'vlanID' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'boundCategories' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'categoryUUID' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'category' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'IDSIPSCategoryFields' },
                                  },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'mode' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'boundIDSRules' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'ruleSID' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'rule' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'IDSRuleFields' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'category' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'FragmentSpread',
                                          name: { kind: 'Name', value: 'IDSIPSCategoryFields' },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'mode' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'suppressedRules' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'ruleSID' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'rule' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'IDSRuleFields' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'category' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'FragmentSpread',
                                          name: { kind: 'Name', value: 'IDSIPSCategoryFields' },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'mode' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'ipPrefixes' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'direction' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'suppressedCategories' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'categoryUUID' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'category' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'IDSIPSCategoryFields' },
                                  },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'mode' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'ipPrefixes' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'direction' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'customRules' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'IDSIPSCustomRuleFields' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'idsIPSCategories' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'IDSIPSCategoryFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'IDSIPSCategoryFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IDSIPSCategory' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shortname' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shortDescription' } },
          { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ruleCount' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'IDSRuleFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IDSRule' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'SID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'action' } },
          { kind: 'Field', name: { kind: 'Name', value: 'classType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'groupID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'revision' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'references' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ref' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'IDSIPSCustomRuleFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IDSIPSCustomRule' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'action' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'application' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'domain' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'boundVLANs' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'vlanID' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<IdsipsConfigForNetworkQuery, IdsipsConfigForNetworkQueryVariables>;
export const CreateIdsipsConfigDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateIDSIPSConfig' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateIDSIPSConfigInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createIDSIPSConfig' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateIdsipsConfigMutation, CreateIdsipsConfigMutationVariables>;
export const UpdateIdsipsConfigDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateIDSIPSConfig' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateIDSIPSConfigInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateIDSIPSConfig' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateIdsipsConfigMutation, UpdateIdsipsConfigMutationVariables>;
export const DeleteIdsipsConfigDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteIDSIPSConfig' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteIDSIPSConfig' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteIdsipsConfigMutation, DeleteIdsipsConfigMutationVariables>;
export const IdsEventsForNetworkDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'IDSEventsForNetwork' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'startTime' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateTime' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'endTime' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateTime' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'durationSeconds' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'IDSEventFilterInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'idsEvents' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'offset' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'startTime' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'startTime' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'endTime' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'endTime' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'durationSeconds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'durationSeconds' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'events' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'IDSEventFields' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'IDSEventFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IDSEvent' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'virtualDevice' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deviceType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'observedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eventType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'srcMAC' } },
          { kind: 'Field', name: { kind: 'Name', value: 'srcIP' } },
          { kind: 'Field', name: { kind: 'Name', value: 'srcPort' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dstMAC' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dstIP' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dstPort' } },
          { kind: 'Field', name: { kind: 'Name', value: 'flowID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'appProto' } },
          { kind: 'Field', name: { kind: 'Name', value: 'protocol' } },
          { kind: 'Field', name: { kind: 'Name', value: 'direction' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'alert' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'action' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'gid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rev' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rule' } },
                { kind: 'Field', name: { kind: 'Name', value: 'severity' } },
                { kind: 'Field', name: { kind: 'Name', value: 'signature' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'httpInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'hostname' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'userAgent' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'protocol' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'length' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tlsInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'sni' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'flow' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'packetsToServer' } },
                { kind: 'Field', name: { kind: 'Name', value: 'packetsToClient' } },
                { kind: 'Field', name: { kind: 'Name', value: 'bytesToServer' } },
                { kind: 'Field', name: { kind: 'Name', value: 'bytesToClient' } },
                { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                { kind: 'Field', name: { kind: 'Name', value: 'end' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'firewallRule' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ipsRule' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'protocol' } },
                { kind: 'Field', name: { kind: 'Name', value: 'srcPrefix' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'srcPortRange' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'lower' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'upper' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'dstPrefix' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'dstPortRange' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'lower' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'upper' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'vlanBindings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'vlanID' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'phyInterfaceBindings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'PhyInterfaceLabelFields' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'durationSec' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhyInterfaceLabelFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PhyInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'portNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hardwareLabel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'virtualDevice' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deviceModel' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'internetServicePlan' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'provider' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<IdsEventsForNetworkQuery, IdsEventsForNetworkQueryVariables>;
export const IdsEventDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'IDSEvent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'virtualDeviceUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'observedAt' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateTime' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'idsEvent' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'virtualDeviceUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'virtualDeviceUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'observedAt' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'observedAt' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'IDSEventFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'IDSEventFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IDSEvent' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'virtualDevice' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deviceType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'observedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eventType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'srcMAC' } },
          { kind: 'Field', name: { kind: 'Name', value: 'srcIP' } },
          { kind: 'Field', name: { kind: 'Name', value: 'srcPort' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dstMAC' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dstIP' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dstPort' } },
          { kind: 'Field', name: { kind: 'Name', value: 'flowID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'appProto' } },
          { kind: 'Field', name: { kind: 'Name', value: 'protocol' } },
          { kind: 'Field', name: { kind: 'Name', value: 'direction' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'alert' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'action' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'gid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rev' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rule' } },
                { kind: 'Field', name: { kind: 'Name', value: 'severity' } },
                { kind: 'Field', name: { kind: 'Name', value: 'signature' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'httpInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'hostname' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'userAgent' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'protocol' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'length' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tlsInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'sni' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'flow' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'packetsToServer' } },
                { kind: 'Field', name: { kind: 'Name', value: 'packetsToClient' } },
                { kind: 'Field', name: { kind: 'Name', value: 'bytesToServer' } },
                { kind: 'Field', name: { kind: 'Name', value: 'bytesToClient' } },
                { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                { kind: 'Field', name: { kind: 'Name', value: 'end' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'firewallRule' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ipsRule' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'protocol' } },
                { kind: 'Field', name: { kind: 'Name', value: 'srcPrefix' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'srcPortRange' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'lower' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'upper' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'dstPrefix' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'dstPortRange' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'lower' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'upper' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'vlanBindings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'vlanID' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'phyInterfaceBindings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'PhyInterfaceLabelFields' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'durationSec' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhyInterfaceLabelFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PhyInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'portNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hardwareLabel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'virtualDevice' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deviceModel' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'internetServicePlan' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'provider' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<IdsEventQuery, IdsEventQueryVariables>;
export const IpsEventsForNetworkDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'IPSEventsForNetwork' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'startTime' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateTime' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'endTime' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateTime' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'durationSeconds' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'idsFilter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'IDSEventFilterInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ipsEvents' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'offset' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'startTime' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'startTime' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'endTime' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'endTime' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'durationSeconds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'durationSeconds' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'idsFilter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'idsFilter' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'events' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'IDSEventFields' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'IDSEventFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IDSEvent' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'virtualDevice' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deviceType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'observedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eventType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'srcMAC' } },
          { kind: 'Field', name: { kind: 'Name', value: 'srcIP' } },
          { kind: 'Field', name: { kind: 'Name', value: 'srcPort' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dstMAC' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dstIP' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dstPort' } },
          { kind: 'Field', name: { kind: 'Name', value: 'flowID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'appProto' } },
          { kind: 'Field', name: { kind: 'Name', value: 'protocol' } },
          { kind: 'Field', name: { kind: 'Name', value: 'direction' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'alert' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'action' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'gid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rev' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rule' } },
                { kind: 'Field', name: { kind: 'Name', value: 'severity' } },
                { kind: 'Field', name: { kind: 'Name', value: 'signature' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'httpInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'hostname' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'userAgent' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'protocol' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'length' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tlsInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'sni' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'flow' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'packetsToServer' } },
                { kind: 'Field', name: { kind: 'Name', value: 'packetsToClient' } },
                { kind: 'Field', name: { kind: 'Name', value: 'bytesToServer' } },
                { kind: 'Field', name: { kind: 'Name', value: 'bytesToClient' } },
                { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                { kind: 'Field', name: { kind: 'Name', value: 'end' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'firewallRule' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ipsRule' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'protocol' } },
                { kind: 'Field', name: { kind: 'Name', value: 'srcPrefix' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'srcPortRange' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'lower' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'upper' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'dstPrefix' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'dstPortRange' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'lower' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'upper' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'vlanBindings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'vlanID' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'phyInterfaceBindings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'PhyInterfaceLabelFields' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'durationSec' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhyInterfaceLabelFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PhyInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'portNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hardwareLabel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'virtualDevice' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deviceModel' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'internetServicePlan' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'provider' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<IpsEventsForNetworkQuery, IpsEventsForNetworkQueryVariables>;
export const IdsRulesForSourceVersionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'IDSRulesForSourceVersion' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sourceVersion' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
          defaultValue: { kind: 'IntValue', value: '100' },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
          defaultValue: { kind: 'IntValue', value: '0' },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'IDSRuleFilterInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'idsRulesForSourceVersion' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sourceVersion' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sourceVersion' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'offset' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'IDSRuleFields' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'IDSRuleFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IDSRule' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'SID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'action' } },
          { kind: 'Field', name: { kind: 'Name', value: 'classType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'groupID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'revision' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'references' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ref' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<IdsRulesForSourceVersionQuery, IdsRulesForSourceVersionQueryVariables>;
export const VlaNsForMulticastDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'VLANsForMulticast' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'vlans' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'vlanID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isInternal' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isMulticastReflectionEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ipV4ClientAssignmentProtocol' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ipV4ClientGateway' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ipV4ClientPrefixLength' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<VlaNsForMulticastQuery, VlaNsForMulticastQueryVariables>;
export const UpdateVlaNsForMulticastDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateVLANsForMulticast' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'inputs' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: { kind: 'Name', value: 'UpdateVLANsIndependentlyInput' },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateVLANsIndependently' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'inputs' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'inputs' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateVlaNsForMulticastMutation,
  UpdateVlaNsForMulticastMutationVariables
>;
export const DhcpRulesWithStaticMappingsForNetworkQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'DHCPRulesWithStaticMappingsForNetworkQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dhcpRulesForNetwork' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'vlan' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'vlanID' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'staticMappings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'macAddress' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'ipAddress' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hostname' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DhcpRulesWithStaticMappingsForNetworkQueryQuery,
  DhcpRulesWithStaticMappingsForNetworkQueryQueryVariables
>;
export const OneToOneNatRulesForNetworkDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'OneToOneNATRulesForNetwork' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'oneToOneNATRulesForNetwork' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'networkUUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'internalIPAddr' } },
                { kind: 'Field', name: { kind: 'Name', value: 'externalIPAddr' } },
                { kind: 'Field', name: { kind: 'Name', value: 'externalPhyInterfaceUUID' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'externalPhyInterface' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'PhyInterfaceLabelFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhyInterfaceLabelFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PhyInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'portNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hardwareLabel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'virtualDevice' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deviceModel' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'internetServicePlan' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'provider' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  OneToOneNatRulesForNetworkQuery,
  OneToOneNatRulesForNetworkQueryVariables
>;
export const OneToOneNatRuleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'OneToOneNATRule' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'oneToOneNATRule' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'networkUUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'internalIPAddr' } },
                { kind: 'Field', name: { kind: 'Name', value: 'externalIPAddr' } },
                { kind: 'Field', name: { kind: 'Name', value: 'externalPhyInterfaceUUID' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'externalPhyInterface' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'PhyInterfaceLabelFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhyInterfaceLabelFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PhyInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'portNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hardwareLabel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'virtualDevice' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deviceModel' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'internetServicePlan' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'provider' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OneToOneNatRuleQuery, OneToOneNatRuleQueryVariables>;
export const CreateOneToOneNatRuleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateOneToOneNATRule' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreateOneToOneNATRuleInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createOneToOneNATRule' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateOneToOneNatRuleMutation, CreateOneToOneNatRuleMutationVariables>;
export const UpdateOneToOneNatRuleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateOneToOneNATRule' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateOneToOneNATRuleInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateOneToOneNATRule' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateOneToOneNatRuleMutation, UpdateOneToOneNatRuleMutationVariables>;
export const DeleteOneToOneNatRuleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteOneToOneNATRule' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteOneToOneNATRule' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteOneToOneNatRuleMutation, DeleteOneToOneNatRuleMutationVariables>;
export const PortForwardingRuleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PortForwardingRule' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'portForwardingRule' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'protocol' } },
                { kind: 'Field', name: { kind: 'Name', value: 'localIPAddress' } },
                { kind: 'Field', name: { kind: 'Name', value: 'externalPhyInterfaceUUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'externalIPAddress' } },
                { kind: 'Field', name: { kind: 'Name', value: 'externalPort' } },
                { kind: 'Field', name: { kind: 'Name', value: 'localPort' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PortForwardingRuleQuery, PortForwardingRuleQueryVariables>;
export const PortForwardingRulesForNetworkDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PortForwardingRulesForNetwork' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'portForwardingRulesForNetwork' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'protocol' } },
                { kind: 'Field', name: { kind: 'Name', value: 'localIPAddress' } },
                { kind: 'Field', name: { kind: 'Name', value: 'externalPhyInterfaceUUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'externalIPAddress' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'externalPhyInterface' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hardwareLabel' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'portNumber' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'virtualDevice' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'deviceModel' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'internetServicePlan' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'provider' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'externalPort' } },
                { kind: 'Field', name: { kind: 'Name', value: 'localPort' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PortForwardingRulesForNetworkQuery,
  PortForwardingRulesForNetworkQueryVariables
>;
export const CreatePortForwardingRuleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreatePortForwardingRule' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreatePortForwardingRuleInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createPortForwardingRule' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreatePortForwardingRuleMutation,
  CreatePortForwardingRuleMutationVariables
>;
export const UpdatePortForwardingRuleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdatePortForwardingRule' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdatePortForwardingRuleInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updatePortForwardingRule' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdatePortForwardingRuleMutation,
  UpdatePortForwardingRuleMutationVariables
>;
export const DeletePortForwardingRuleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeletePortForwardingRule' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deletePortForwardingRule' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeletePortForwardingRuleMutation,
  DeletePortForwardingRuleMutationVariables
>;
export const VlaNsForFirewallDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'VLANsForFirewall' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'vlans' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isInternal' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isWANDenied' } },
                { kind: 'Field', name: { kind: 'Name', value: 'vlanID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ipV4ClientAssignmentProtocol' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ipV4ClientGateway' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ipV4ClientPrefixLength' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'permittedInterVLANCommunicationVLANs' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'vlanID' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'dhcpRule' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'applicationDNSFirewallRules' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<VlaNsForFirewallQuery, VlaNsForFirewallQueryVariables>;
export const FirewallRulesForNetworkDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'FirewallRulesForNetwork' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'firewallRulesForNetwork' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isMeterInternal' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isBidirectional' } },
                { kind: 'Field', name: { kind: 'Name', value: 'action' } },
                { kind: 'Field', name: { kind: 'Name', value: 'srcPrefix' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'srcVLAN' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'vlanID' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ipV4ClientAssignmentProtocol' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'ipV4ClientGateway' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'ipV4ClientPrefixLength' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'srcClientVPNServer' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'addressMask' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'dstPrefix' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'dstVLAN' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'vlanID' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ipV4ClientAssignmentProtocol' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'ipV4ClientGateway' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'ipV4ClientPrefixLength' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'dstClientVPNServer' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'addressMask' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'srcPortRanges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'lower' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'upper' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'dstPortRanges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'lower' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'upper' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'protocols' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'vlanBindings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'vlan' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'vlanID' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'metric' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'phyInterfaceBindings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'phyInterface' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'PhyInterfaceLabelFields' },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'metric' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'idsEvent' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'virtualDevice' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'observedAt' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhyInterfaceLabelFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PhyInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'portNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hardwareLabel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'virtualDevice' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deviceModel' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'internetServicePlan' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'provider' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FirewallRulesForNetworkQuery, FirewallRulesForNetworkQueryVariables>;
export const FirewallRuleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'FirewallRule' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'firewallRule' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isMeterInternal' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isBidirectional' } },
                { kind: 'Field', name: { kind: 'Name', value: 'action' } },
                { kind: 'Field', name: { kind: 'Name', value: 'srcPrefix' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'srcVLAN' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'vlanID' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ipV4ClientAssignmentProtocol' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'ipV4ClientGateway' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'ipV4ClientPrefixLength' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'srcClientVPNServer' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'addressMask' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'dstPrefix' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'dstVLAN' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'vlanID' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ipV4ClientAssignmentProtocol' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'ipV4ClientGateway' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'ipV4ClientPrefixLength' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'dstClientVPNServer' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'addressMask' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'srcPortRanges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'lower' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'upper' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'dstPortRanges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'lower' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'upper' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'protocols' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'vlanBindings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'vlan' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'vlanID' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'metric' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'phyInterfaceBindings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'phyInterface' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'portNumber' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'virtualDevice' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'deviceModel' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'metric' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'idsEvent' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'virtualDevice' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'observedAt' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FirewallRuleQuery, FirewallRuleQueryVariables>;
export const UpdateFirewallRuleBindingsForVlanDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateFirewallRuleBindingsForVLAN' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'vlanUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderedRuleUUIDs' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'bindFirewallRulesToVLAN' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'vlanUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'vlanUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'orderedRuleUUIDs' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'orderedRuleUUIDs' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'metric' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateFirewallRuleBindingsForVlanMutation,
  UpdateFirewallRuleBindingsForVlanMutationVariables
>;
export const UpdateFirewallRuleBindingsForPhyInterfaceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateFirewallRuleBindingsForPhyInterface' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'phyInterfaceUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderedRuleUUIDs' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'bindFirewallRulesToPhyInterface' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'phyInterfaceUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'phyInterfaceUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'orderedRuleUUIDs' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'orderedRuleUUIDs' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'metric' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateFirewallRuleBindingsForPhyInterfaceMutation,
  UpdateFirewallRuleBindingsForPhyInterfaceMutationVariables
>;
export const UplinkPhyInterfacesForNetworkDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'UplinkPhyInterfacesForNetwork' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'uplinkPhyInterfacesForNetwork' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PhyInterfaceLabelFields' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'portNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hardwareLabel' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'virtualDevice' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'deviceModel' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hardwareDevice' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'isConnectedToBackend' },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'serialNumber' } },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'ControllerVirtualDevice' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'highAvailability' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'internetServicePlan' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'provider' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'ipv4ClientAddresses' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isUplinkActive' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasWANActivity' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uplinkExternalAddresses' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhyInterfaceLabelFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PhyInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'portNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hardwareLabel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'virtualDevice' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deviceModel' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'internetServicePlan' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'provider' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UplinkPhyInterfacesForNetworkQuery,
  UplinkPhyInterfacesForNetworkQueryVariables
>;
export const CreateFirewallRuleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateFirewallRule' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateFirewallRuleInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createFirewallRule' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateFirewallRuleMutation, CreateFirewallRuleMutationVariables>;
export const UpdateFirewallRuleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateFirewallRule' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateFirewallRuleInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateFirewallRule' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateFirewallRuleMutation, UpdateFirewallRuleMutationVariables>;
export const UpdateFirewallRulesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateFirewallRules' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'inputs' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: { kind: 'Name', value: 'UpdateFirewallRulesInput' },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateFirewallRules' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'inputs' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'inputs' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateFirewallRulesMutation, UpdateFirewallRulesMutationVariables>;
export const DeleteFirewallRuleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteFirewallRule' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteFirewallRule' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteFirewallRuleMutation, DeleteFirewallRuleMutationVariables>;
export const NotificationSettingsQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'NotificationSettingsQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'notificationSettingsForNetwork' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'alertReceiverUUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isEnabled' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'arguments' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'parameterName' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'notificationDefinition' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'parameters' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  NotificationSettingsQueryQuery,
  NotificationSettingsQueryQueryVariables
>;
export const CreateNotificationSettingMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateNotificationSettingMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreateNotificationSettingInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createNotificationSetting' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateNotificationSettingMutationMutation,
  CreateNotificationSettingMutationMutationVariables
>;
export const NotificationDefinitionsQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'NotificationDefinitionsQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'alertDefinitionsForNetwork' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'availability' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'parameters' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'required' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isFleetwideSupported' } },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'AlertParameterNumber' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              alias: { kind: 'Name', value: 'numberDefaultValue' },
                              name: { kind: 'Name', value: 'defaultValue' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'AlertParameterBoolean' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              alias: { kind: 'Name', value: 'booleanDefaultValue' },
                              name: { kind: 'Name', value: 'defaultValue' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'AlertParameterDate' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              alias: { kind: 'Name', value: 'dateDefaultValue' },
                              name: { kind: 'Name', value: 'defaultValue' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'AlertParameterDateTime' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              alias: { kind: 'Name', value: 'dateTimeDefaultValue' },
                              name: { kind: 'Name', value: 'defaultValue' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'AlertParameterDuration' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              alias: { kind: 'Name', value: 'durationDefaultValue' },
                              name: { kind: 'Name', value: 'defaultValue' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'AlertParameterString' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              alias: { kind: 'Name', value: 'stringDefaultValue' },
                              name: { kind: 'Name', value: 'defaultValue' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'AlertParameterUUIDArray' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              alias: { kind: 'Name', value: 'uuidArrayDefaultValue' },
                              name: { kind: 'Name', value: 'defaultValue' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'AlertParameterNumberArray' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              alias: { kind: 'Name', value: 'numberArrayDefaultValue' },
                              name: { kind: 'Name', value: 'defaultValue' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'AlertParameterStringArray' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              alias: { kind: 'Name', value: 'stringArrayDefaultValue' },
                              name: { kind: 'Name', value: 'defaultValue' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  NotificationDefinitionsQueryQuery,
  NotificationDefinitionsQueryQueryVariables
>;
export const DeleteNotificationSettingMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'deleteNotificationSettingMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'UUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteNotificationSetting' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'UUID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteNotificationSettingMutationMutation,
  DeleteNotificationSettingMutationMutationVariables
>;
export const UpdateNotificationSettingMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateNotificationSettingMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'UUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateNotificationSettingInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateNotificationSetting' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'UUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateNotificationSettingMutationMutation,
  UpdateNotificationSettingMutationMutationVariables
>;
export const UpdateServiceDiscoveryForNetworkDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateServiceDiscoveryForNetwork' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'UUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateNetworkInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateNetwork' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'UUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateServiceDiscoveryForNetworkMutation,
  UpdateServiceDiscoveryForNetworkMutationVariables
>;
export const UpdateNetworkNetworkDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'UpdateNetworkNetwork' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'includeNOSUpgradeChannel' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          defaultValue: { kind: 'BooleanValue', value: false },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'network' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isCustomer' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isTemplate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isConfig1WosUpgradesEnabled' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nosUpgradeChannel' },
                  directives: [
                    {
                      kind: 'Directive',
                      name: { kind: 'Name', value: 'include' },
                      arguments: [
                        {
                          kind: 'Argument',
                          name: { kind: 'Name', value: 'if' },
                          value: {
                            kind: 'Variable',
                            name: { kind: 'Name', value: 'includeNOSUpgradeChannel' },
                          },
                        },
                      ],
                    },
                  ],
                },
                { kind: 'Field', name: { kind: 'Name', value: 'pinnedNOSVersionID' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onboarding' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'jobData' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'jobID' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'mailingAddress' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'line1' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'line2' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subdivisionCode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'postalCode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'countryISO2' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'squareFeet' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateNetworkNetworkQuery, UpdateNetworkNetworkQueryVariables>;
export const CreateNetworkDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateNetwork' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateNetworkInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createNetwork' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateNetworkMutation, CreateNetworkMutationVariables>;
export const UpdateNetworkDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateNetwork' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateNetworkInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateNetwork' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateNetworkMutation, UpdateNetworkMutationVariables>;
export const DeleteNetworkDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteNetwork' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteNetwork' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteNetworkMutation, DeleteNetworkMutationVariables>;
export const JobTrackersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'JobTrackers' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'jobTrackers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'jobID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalSqFt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fullAddress' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationCode' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<JobTrackersQuery, JobTrackersQueryVariables>;
export const CreateNetworkOnboardingDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateNetworkOnboarding' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'jobTrackerID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createNetworkOnboarding' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'jobTrackerID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'jobTrackerID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateNetworkOnboardingMutation,
  CreateNetworkOnboardingMutationVariables
>;
export const MaintenanceWindowForNetworkDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'MaintenanceWindowForNetwork' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'maintenanceWindowForNetwork' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'recurrence' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isOptedOut' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startHourOfDayLocal' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endHourOfDayLocal' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startDayOfWeekLocal' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endDayOfWeekLocal' } },
                { kind: 'Field', name: { kind: 'Name', value: 'excludedDaysOfWeek' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MaintenanceWindowForNetworkQuery,
  MaintenanceWindowForNetworkQueryVariables
>;
export const UpdateMaintenanceWindowDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateMaintenanceWindow' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateMaintenanceWindowInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateMaintenanceWindowForNetwork' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateMaintenanceWindowMutation,
  UpdateMaintenanceWindowMutationVariables
>;
export const PublicNosVersionsForNetworkDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PublicNOSVersionsForNetwork' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'publicNOSVersionsForNetwork' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'major' } },
                { kind: 'Field', name: { kind: 'Name', value: 'minor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'patch' } },
                { kind: 'Field', name: { kind: 'Name', value: 'releaseNotes' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PublicNosVersionsForNetworkQuery,
  PublicNosVersionsForNetworkQueryVariables
>;
export const UpdateCompanyDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateCompany' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'companyUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateCompanyInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateCompany' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'companyUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateCompanyMutation, UpdateCompanyMutationVariables>;
export const UpdateAlertReceiverWithTargetsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateAlertReceiverWithTargets' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'alertReceiverUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateAlertReceiverWithTargetsInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateAlertReceiverWithTargets' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'alertReceiverUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'alertReceiverUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateAlertReceiverWithTargetsMutation,
  UpdateAlertReceiverWithTargetsMutationVariables
>;
export const CreateAlertReceiverWithTargetsMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateAlertReceiverWithTargetsMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'companyUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreateAlertReceiverWithTargetsInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createAlertReceiverWithTargets' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'companyUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'companyUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateAlertReceiverWithTargetsMutationMutation,
  CreateAlertReceiverWithTargetsMutationMutationVariables
>;
export const TestFireFailureDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'TestFireFailure' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'alertReceiverUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'testFireAlert' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'alertReceiverUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'alertReceiverUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'ok' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TestFireFailureMutation, TestFireFailureMutationVariables>;
export const SendCompanySiemIntegrationTestEventDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'sendCompanySIEMIntegrationTestEvent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'UUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendCompanySIEMIntegrationTestEvent' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'UUID' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SendCompanySiemIntegrationTestEventMutation,
  SendCompanySiemIntegrationTestEventMutationVariables
>;
export const CreateSiemIntegrationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createSiemIntegration' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'companyUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreateCompanySIEMIntegrationInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createCompanySIEMIntegration' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'companyUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'companyUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateSiemIntegrationMutation, CreateSiemIntegrationMutationVariables>;
export const DeleteSiemIntegrationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'deleteSiemIntegration' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'UUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteCompanySIEMIntegration' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'UUID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteSiemIntegrationMutation, DeleteSiemIntegrationMutationVariables>;
export const SiemIntegrationsForCompanyDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'siemIntegrationsForCompany' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'companyUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'siemIntegrationsForCompany' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'companyUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'companyUUID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'awsKinesisARN' } },
                { kind: 'Field', name: { kind: 'Name', value: 'externalID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'roleARN' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'statusUpdatedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SiemIntegrationsForCompanyQuery,
  SiemIntegrationsForCompanyQueryVariables
>;
export const UpdateWebhookMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateWebhookMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'UUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateAlertTargetWebhookInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateAlertTargetWebhook' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'UUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateWebhookMutationMutation, UpdateWebhookMutationMutationVariables>;
export const WebhookTestTriggerMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'WebhookTestTriggerMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'TestTriggerAlertTargetWebhookInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'testTriggerWebhookAlertTarget' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ok' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  WebhookTestTriggerMutationMutation,
  WebhookTestTriggerMutationMutationVariables
>;
export const CreateAlertTargetWebhookDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createAlertTargetWebhook' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'companyUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreateAlertTargetWebhookInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createAlertTargetWebhook' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'companyUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'companyUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyUUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'signingSecret' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateAlertTargetWebhookMutation,
  CreateAlertTargetWebhookMutationVariables
>;
export const CreateSlackAccessTokenDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateSlackAccessToken' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'companyUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createSlackAccessToken' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'companyUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'companyUUID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateSlackAccessTokenMutation,
  CreateSlackAccessTokenMutationVariables
>;
export const DeleteSlackAccessTokensForCompanyDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteSlackAccessTokensForCompany' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'companyUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteSlackAccessTokensForCompany' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'companyUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'companyUUID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteSlackAccessTokensForCompanyMutation,
  DeleteSlackAccessTokensForCompanyMutationVariables
>;
export const DeleteAlertReceiverMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteAlertReceiverMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'alertReceiverUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteAlertReceiverWithTargets' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'alertReceiverUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'alertReceiverUUID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteAlertReceiverMutationMutation,
  DeleteAlertReceiverMutationMutationVariables
>;
export const AlertTargetsQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AlertTargetsQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'companyUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'alertTargets' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'companyUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'companyUUID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'emails' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'webhooks' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'AlertTargetWebhookFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'slacks' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'channelID' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AlertTargetWebhookFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AlertTargetWebhook' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'authType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'authValue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'signingSecret' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AlertTargetsQueryQuery, AlertTargetsQueryQueryVariables>;
export const AlertTargetsWebhookQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'alertTargetsWebhookQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'companyUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'alertTargetsWebhook' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'companyUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'companyUUID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AlertTargetWebhookFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AlertTargetWebhookFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AlertTargetWebhook' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'authType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'authValue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'signingSecret' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AlertTargetsWebhookQueryQuery, AlertTargetsWebhookQueryQueryVariables>;
export const AlertReceiversQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AlertReceiversQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'companyUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'alertReceiversForCompany' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'companyUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'companyUUID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyUUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'targets' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'AlertTargetEmail' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'AlertTargetWebhook' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'AlertTargetSlack' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'channelID' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AlertReceiversQueryQuery, AlertReceiversQueryQueryVariables>;
export const DeleteAlertTargetWebhookMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteAlertTargetWebhookMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'UUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteAlertTargetWebhook' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'UUID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteAlertTargetWebhookMutationMutation,
  DeleteAlertTargetWebhookMutationMutationVariables
>;
export const TestTriggerAlertTargetWebhookMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'TestTriggerAlertTargetWebhookMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'UUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'TestTriggerAlertTargetWebhookInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'testTriggerWebhookAlertTarget' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'UUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ok' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TestTriggerAlertTargetWebhookMutationMutation,
  TestTriggerAlertTargetWebhookMutationMutationVariables
>;
export const WanSpeedTestMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'WANSpeedTestMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'RPCWANSpeedtestInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rpcWANSpeedtest' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'downloadSpeedMbps' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uploadSpeedMbps' } },
                { kind: 'Field', name: { kind: 'Name', value: 'latencyNs' } },
                { kind: 'Field', name: { kind: 'Name', value: 'jitterNs' } },
                { kind: 'Field', name: { kind: 'Name', value: 'targetName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'targetHost' } },
                { kind: 'Field', name: { kind: 'Name', value: 'distance' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<WanSpeedTestMutationMutation, WanSpeedTestMutationMutationVariables>;
export const VendorsForVendorDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'VendorsForVendor' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'vendorSubstring' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'OUIsForVendor' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'vendorSubstring' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'vendorSubstring' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'vendor' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'vendorAddress' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'vendor' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<VendorsForVendorQuery, VendorsForVendorQueryVariables>;
export const VlansForPingDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'VlansForPing' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'vlans' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<VlansForPingQuery, VlansForPingQueryVariables>;
export const RpcPing2MutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RPCPing2Mutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'RPCPingInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rpcPing' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'successRate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'roundTripTimeMs' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RpcPing2MutationMutation, RpcPing2MutationMutationVariables>;
export const StartSpeedtestJobDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'StartSpeedtestJob' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'StartWANSpeedtestJobInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'startWANSpeedtestJob' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<StartSpeedtestJobMutation, StartSpeedtestJobMutationVariables>;
export const WanSpeedtestJobDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'wanSpeedtestJob' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'UUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'wanSpeedtestJob' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'UUID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'results' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'direction' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'transferBytes' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'durationNs' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mbps' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'httpRTTsNs' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'failed' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<WanSpeedtestJobQuery, WanSpeedtestJobQueryVariables>;
export const GetCompanyUsersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetCompanyUsers' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'companySlug' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'GetCompanyUserInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'companyUsers' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'companySlug' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'companySlug' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CompanyUserBody' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CompanyUserBody' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CompanyUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'roles' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'companySlug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'networkUUID' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deletedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyMembershipRole' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCompanyUsersQuery, GetCompanyUsersQueryVariables>;
export const GetCompanyUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetCompanyUser' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'GetCompanyUserInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'companyUser' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'companyUserUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CompanyUserBody' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CompanyUserBody' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CompanyUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'roles' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'companySlug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'networkUUID' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deletedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyMembershipRole' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCompanyUserQuery, GetCompanyUserQueryVariables>;
export const DeleteCompanyUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteCompanyUser' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteCompanyUser' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'companyUserUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteCompanyUserMutation, DeleteCompanyUserMutationVariables>;
export const ReactivateCompanyUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ReactivateCompanyUser' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activateCompanyUser' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'companyUserUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ReactivateCompanyUserMutation, ReactivateCompanyUserMutationVariables>;
export const CreateCompanyUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateCompanyUser' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'companySlug' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateCompanyUserInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createCompanyUser' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'companySlug' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'companySlug' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateCompanyUserMutation, CreateCompanyUserMutationVariables>;
export const UpdateCompanyUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateCompanyUser' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateCompanyUserInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateCompanyUser' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'companyUserUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateCompanyUserMutation, UpdateCompanyUserMutationVariables>;
export const UpdateUserRolesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateUserRoles' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'UserRoleInput' } },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateUserRoles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'companyUserUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateUserRolesMutation, UpdateUserRolesMutationVariables>;
export const AssignOperatorRoleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AssignOperatorRole' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assignOperatorRole' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'companyUserUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AssignOperatorRoleMutation, AssignOperatorRoleMutationVariables>;
export const RemoveOperatorRoleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RemoveOperatorRole' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'removeOperatorRole' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'companyUserUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RemoveOperatorRoleMutation, RemoveOperatorRoleMutationVariables>;
export const RadioProfilesQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'RadioProfilesQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'radioProfilesForNetwork' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
                { kind: 'Field', name: { kind: 'Name', value: 'band2_4GIsEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'band2_4GAutoChannelIsEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'band2_4GAllowedChannels' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'band2_4GAutoChannelWidthIsEnabled' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'band2_4GAutoTxPowerIsEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'band2_4GChannelWidthMHz' } },
                { kind: 'Field', name: { kind: 'Name', value: 'band2_4GAutoTxPowerMaxdBm' } },
                { kind: 'Field', name: { kind: 'Name', value: 'band2_4GAutoTxPowerMindBm' } },
                { kind: 'Field', name: { kind: 'Name', value: 'band5GIsEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'band5GAutoChannelIsEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'band5GAllowedChannels' } },
                { kind: 'Field', name: { kind: 'Name', value: 'band5GAutoChannelWidthIsEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'band5GAutoTxPowerIsEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'band5GChannelWidthMHz' } },
                { kind: 'Field', name: { kind: 'Name', value: 'band5GAutoTxPowerMaxdBm' } },
                { kind: 'Field', name: { kind: 'Name', value: 'band5GAutoTxPowerMindBm' } },
                { kind: 'Field', name: { kind: 'Name', value: 'band6GIsEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'band6GAutoChannelIsEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'band6GAllowedChannels' } },
                { kind: 'Field', name: { kind: 'Name', value: 'band6GAutoChannelWidthIsEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'band6GAutoTxPowerIsEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'band6GChannelWidthMHz' } },
                { kind: 'Field', name: { kind: 'Name', value: 'band6GAutoTxPowerMaxdBm' } },
                { kind: 'Field', name: { kind: 'Name', value: 'band6GAutoTxPowerMindBm' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'virtualDevices' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'AccessPointVirtualDevice' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'radioSettings' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'band2_4GPrimaryChannel' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'band5GPrimaryChannel' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'band6GPrimaryChannel' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RadioProfilesQueryQuery, RadioProfilesQueryQueryVariables>;
export const CreateRadioProfileMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateRadioProfileMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateRadioProfileInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createRadioProfile' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateRadioProfileMutationMutation,
  CreateRadioProfileMutationMutationVariables
>;
export const UpdateRadioProfileMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateRadioProfileMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateRadioProfileInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateRadioProfile' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateRadioProfileMutationMutation,
  UpdateRadioProfileMutationMutationVariables
>;
export const DeleteRadioProfileMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteRadioProfileMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteRadioProfile' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteRadioProfileMutationMutation,
  DeleteRadioProfileMutationMutationVariables
>;
export const WirelessInfoForNetworkDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'WirelessInfoForNetwork' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'network' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'wirelessValidChannels' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'band' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'channels' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'wirelessMaxTxPowerdBm' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<WirelessInfoForNetworkQuery, WirelessInfoForNetworkQueryVariables>;
export const PsKsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PSKs' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'ssidUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'wifiIPSKs' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'ssidUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'ssidUUID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'clientMACs' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'password' } },
                { kind: 'Field', name: { kind: 'Name', value: 'vlanUUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ssidUUID' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PsKsQuery, PsKsQueryVariables>;
export const CreatePskDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreatePSK' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateWifiIPSKInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createWifiIPSK' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreatePskMutation, CreatePskMutationVariables>;
export const UpdatePskDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdatePSK' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateWifiIPSKInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateWifiIPSK' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'uuid' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdatePskMutation, UpdatePskMutationVariables>;
export const DeletePskDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeletePSK' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteWifiIPSK' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'uuid' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeletePskMutation, DeletePskMutationVariables>;
export const RpceapolTestMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RPCEAPOLTestMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RPCEapolTestForSerialsInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rpcWosEapolTestForSerials' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'error_reason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'serialNumber' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RpceapolTestMutationMutation, RpceapolTestMutationMutationVariables>;
export const SsidDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SSID' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ssid' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'SSIDFields' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SSIDFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SSID' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ssid' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'network' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'clientSteeringAssociationSteeringIsEnabled' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'clientSteeringLoadBalancingClientMinThreshold' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'clientSteeringPreassociationRSSIMinThreshold' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'clientSteeringPostassociationSteeringIsEnabled' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'is80211axEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isGuest' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isHidden' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isIsolateClientsEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'encryptionProtocol' } },
          { kind: 'Field', name: { kind: 'Name', value: 'password' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isBand2GAllowed' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isBand5GAllowed' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isBand6GAllowed' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passwordRotationCadence' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passwordRotationDayOfMonthLocal' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passwordRotationDayOfWeekLocal' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passwordRotationHourOfDayLocal' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passwordLastRotatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passwordNextRotationAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'band2GMinimumBasicRateKbps' } },
          { kind: 'Field', name: { kind: 'Name', value: 'band5GMinimumBasicRateKbps' } },
          { kind: 'Field', name: { kind: 'Name', value: 'band6GMinimumBasicRateKbps' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isEnabledForAllAccessPoints' } },
          { kind: 'Field', name: { kind: 'Name', value: 'roaming80211rIsEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'roaming80211kIsEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'roaming80211vIsEnabled' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'encryption80211wProtectedManagementFramesMode' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hs20HasProfile' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hs20Enabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hs20OperatorNames' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hs20VenueNames' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hs20VenueGroup' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hs20VenueType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hs20AccessNetworkType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hs20RoamingConsortiumOIs' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hs20DomainNames' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hs20NaiRealms' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hs20MccMncPairs' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dynamicVLANMode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'radiusCoaEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'radiusCoaPort' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nasIdentifier' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rtsCtsEnabledCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rtsThreshold' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primaryEncryption8021X' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'secondaryEncryption8021X' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'enabledAccessPointVirtualDevices' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'disabledAccessPointVirtualDevices' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'vlan' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'vlanID' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'broadcastSchedule' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'startDayOfWeek' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startHour' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startMinute' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endDayOfWeek' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endHour' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endMinute' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rateLimitRules' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isPerSource' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rateLimitKbpsUpload' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rateLimitKbpsDownload' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SsidQuery, SsidQueryVariables>;
export const SsiDsForCompanyNetworksDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SSIDsForCompanyNetworks' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'companySlug' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUIDs' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'companyBySlug' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'slug' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'companySlug' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'networks' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'filter' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'networkUUIDs' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'networkUUIDs' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ssids' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'SSIDFields' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SSIDFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SSID' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ssid' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'network' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'clientSteeringAssociationSteeringIsEnabled' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'clientSteeringLoadBalancingClientMinThreshold' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'clientSteeringPreassociationRSSIMinThreshold' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'clientSteeringPostassociationSteeringIsEnabled' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'is80211axEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isGuest' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isHidden' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isIsolateClientsEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'encryptionProtocol' } },
          { kind: 'Field', name: { kind: 'Name', value: 'password' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isBand2GAllowed' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isBand5GAllowed' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isBand6GAllowed' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passwordRotationCadence' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passwordRotationDayOfMonthLocal' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passwordRotationDayOfWeekLocal' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passwordRotationHourOfDayLocal' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passwordLastRotatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passwordNextRotationAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'band2GMinimumBasicRateKbps' } },
          { kind: 'Field', name: { kind: 'Name', value: 'band5GMinimumBasicRateKbps' } },
          { kind: 'Field', name: { kind: 'Name', value: 'band6GMinimumBasicRateKbps' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isEnabledForAllAccessPoints' } },
          { kind: 'Field', name: { kind: 'Name', value: 'roaming80211rIsEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'roaming80211kIsEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'roaming80211vIsEnabled' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'encryption80211wProtectedManagementFramesMode' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hs20HasProfile' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hs20Enabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hs20OperatorNames' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hs20VenueNames' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hs20VenueGroup' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hs20VenueType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hs20AccessNetworkType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hs20RoamingConsortiumOIs' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hs20DomainNames' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hs20NaiRealms' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hs20MccMncPairs' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dynamicVLANMode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'radiusCoaEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'radiusCoaPort' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nasIdentifier' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rtsCtsEnabledCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rtsThreshold' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primaryEncryption8021X' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'secondaryEncryption8021X' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'enabledAccessPointVirtualDevices' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'disabledAccessPointVirtualDevices' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'vlan' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'vlanID' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'broadcastSchedule' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'startDayOfWeek' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startHour' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startMinute' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endDayOfWeek' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endHour' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endMinute' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rateLimitRules' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isPerSource' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rateLimitKbpsUpload' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rateLimitKbpsDownload' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SsiDsForCompanyNetworksQuery, SsiDsForCompanyNetworksQueryVariables>;
export const SsidsForNetworkDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SSIDSForNetwork' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ssidsForNetwork' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'SSIDFields' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SSIDFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SSID' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ssid' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'network' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'clientSteeringAssociationSteeringIsEnabled' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'clientSteeringLoadBalancingClientMinThreshold' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'clientSteeringPreassociationRSSIMinThreshold' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'clientSteeringPostassociationSteeringIsEnabled' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'is80211axEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isGuest' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isHidden' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isIsolateClientsEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'encryptionProtocol' } },
          { kind: 'Field', name: { kind: 'Name', value: 'password' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isBand2GAllowed' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isBand5GAllowed' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isBand6GAllowed' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passwordRotationCadence' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passwordRotationDayOfMonthLocal' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passwordRotationDayOfWeekLocal' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passwordRotationHourOfDayLocal' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passwordLastRotatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passwordNextRotationAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'band2GMinimumBasicRateKbps' } },
          { kind: 'Field', name: { kind: 'Name', value: 'band5GMinimumBasicRateKbps' } },
          { kind: 'Field', name: { kind: 'Name', value: 'band6GMinimumBasicRateKbps' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isEnabledForAllAccessPoints' } },
          { kind: 'Field', name: { kind: 'Name', value: 'roaming80211rIsEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'roaming80211kIsEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'roaming80211vIsEnabled' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'encryption80211wProtectedManagementFramesMode' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hs20HasProfile' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hs20Enabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hs20OperatorNames' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hs20VenueNames' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hs20VenueGroup' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hs20VenueType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hs20AccessNetworkType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hs20RoamingConsortiumOIs' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hs20DomainNames' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hs20NaiRealms' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hs20MccMncPairs' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dynamicVLANMode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'radiusCoaEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'radiusCoaPort' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nasIdentifier' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rtsCtsEnabledCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rtsThreshold' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primaryEncryption8021X' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'secondaryEncryption8021X' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'enabledAccessPointVirtualDevices' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'disabledAccessPointVirtualDevices' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'vlan' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'vlanID' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'broadcastSchedule' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'startDayOfWeek' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startHour' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startMinute' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endDayOfWeek' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endHour' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endMinute' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rateLimitRules' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isPerSource' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rateLimitKbpsUpload' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rateLimitKbpsDownload' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SsidsForNetworkQuery, SsidsForNetworkQueryVariables>;
export const Hs20AccessNetworkTypesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Hs20AccessNetworkTypes' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hs20ValidTypes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'accessNetworkTypes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'venueTypes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'group' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'eapMethods' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'method' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mostUsed' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'authParams' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'param' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'validValues' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<Hs20AccessNetworkTypesQuery, Hs20AccessNetworkTypesQueryVariables>;
export const CreateSsidMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateSSIDMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateSSIDInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createSSID' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateSsidMutationMutation, CreateSsidMutationMutationVariables>;
export const UpdateSsidMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateSSIDMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateSSIDInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateSSID' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'uuid' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateSsidMutationMutation, UpdateSsidMutationMutationVariables>;
export const DeleteSsidMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteSSIDMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteSSID' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'uuid' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteSsidMutationMutation, DeleteSsidMutationMutationVariables>;
export const RadiusProfilesQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'RadiusProfilesQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'encryption8021XsForNetwork' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'authServerIPAddress' } },
                { kind: 'Field', name: { kind: 'Name', value: 'authServerPort' } },
                { kind: 'Field', name: { kind: 'Name', value: 'authServerSecret' } },
                { kind: 'Field', name: { kind: 'Name', value: 'accountingServerIPAddress' } },
                { kind: 'Field', name: { kind: 'Name', value: 'accountingServerPort' } },
                { kind: 'Field', name: { kind: 'Name', value: 'accountingServerSecret' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'ssids' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'ssid' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RadiusProfilesQueryQuery, RadiusProfilesQueryQueryVariables>;
export const CreateRadiusProfileMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateRadiusProfileMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreateEncryption8021XInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createEncryption8021X' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateRadiusProfileMutationMutation,
  CreateRadiusProfileMutationMutationVariables
>;
export const UpdateRadiusProfileMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateRadiusProfileMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateEncryption8021XInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateEncryption8021X' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateRadiusProfileMutationMutation,
  UpdateRadiusProfileMutationMutationVariables
>;
export const DeleteRadiusProfileMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteRadiusProfileMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteEncryption8021X' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteRadiusProfileMutationMutation,
  DeleteRadiusProfileMutationMutationVariables
>;
export const RogueAccessPointsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'RogueAccessPoints' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rogueAccessPointsObservedOnNetwork' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'timeFilter' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'durationSeconds' },
                            value: { kind: 'IntValue', value: '600' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'stepSeconds' },
                            value: { kind: 'IntValue', value: '30' },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'vendor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'networkUUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'macAddress' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'phyInterface' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isEnabled' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'portNumber' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'virtualDevice' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'observers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'NetworkThreatObserverFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'NetworkThreatObserverFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'NetworkThreatObserver' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'ssid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'observedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rssi' } },
          { kind: 'Field', name: { kind: 'Name', value: 'noiseFloor' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'virtualDevice' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RogueAccessPointsQuery, RogueAccessPointsQueryVariables>;
export const HoneypotSsiDsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'HoneypotSSIDs' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'honeypotSSIDsObservedOnNetwork' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'timeFilter' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'durationSeconds' },
                            value: { kind: 'IntValue', value: '600' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'stepSeconds' },
                            value: { kind: 'IntValue', value: '30' },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'networkUUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ssid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'broadcasters' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'bssid' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'observers' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'NetworkThreatObserverFields' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'NetworkThreatObserverFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'NetworkThreatObserver' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'ssid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'observedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rssi' } },
          { kind: 'Field', name: { kind: 'Name', value: 'noiseFloor' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'virtualDevice' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<HoneypotSsiDsQuery, HoneypotSsiDsQueryVariables>;
export const NetworkThreatAllowlistForNetworkDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'NetworkThreatAllowlistForNetwork' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'networkThreatAllowlistForNetwork' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'wiredMAC' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ssidUUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  NetworkThreatAllowlistForNetworkQuery,
  NetworkThreatAllowlistForNetworkQueryVariables
>;
export const CreateNetworkThreatAllowlistEntryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateNetworkThreatAllowlistEntry' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreateNetworkThreatAllowlistEntryInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createNetworkThreatAllowlistEntry' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateNetworkThreatAllowlistEntryMutation,
  CreateNetworkThreatAllowlistEntryMutationVariables
>;
export const UpdateNetworkThreatAllowlistEntryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateNetworkThreatAllowlistEntry' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateNetworkThreatAllowlistEntryInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateNetworkThreatAllowlistEntry' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateNetworkThreatAllowlistEntryMutation,
  UpdateNetworkThreatAllowlistEntryMutationVariables
>;
export const DeleteNetworkThreatAllowlistEntryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteNetworkThreatAllowlistEntry' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteNetworkThreatAllowlistEntry' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteNetworkThreatAllowlistEntryMutation,
  DeleteNetworkThreatAllowlistEntryMutationVariables
>;
export const WirelessClientMetricsByAccessPointQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'WirelessClientMetricsByAccessPointQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'virtualDeviceUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ClientMetricsTimeseriesFilterInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'wirelessClientMetricsByAP' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'apVirtualDeviceUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'virtualDeviceUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'metadata' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'signal' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'minValue' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'maxValue' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'noise' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'minValue' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'maxValue' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tx' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'minValue' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'maxValue' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'rx' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'minValue' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'maxValue' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'values' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'signal' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'noise' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'txRate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'rxRate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'snr' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'txBytes' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'rxBytes' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'txMulticastBytes' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'rxMulticastBytes' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'txUnicastBytes' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'rxUnicastBytes' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'clientCount' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  WirelessClientMetricsByAccessPointQueryQuery,
  WirelessClientMetricsByAccessPointQueryQueryVariables
>;
export const ApChannelUtilizationByNetworkQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'APChannelUtilizationByNetworkQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ChannelUtilizationTimeseriesFilterInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'channelUtilizationByNetwork' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'band' } },
                { kind: 'Field', name: { kind: 'Name', value: 'virtualDeviceUUID' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'values' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'totalUtilization' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ApChannelUtilizationByNetworkQueryQuery,
  ApChannelUtilizationByNetworkQueryQueryVariables
>;
export const ApHealthScoresByAccessPointQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'APHealthScoresByAccessPointQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'serialNumber' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'MetricsFilterInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'apHealthScores' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'serialNumber' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'serialNumber' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'overallScore' } },
                { kind: 'Field', name: { kind: 'Name', value: 'performanceScore' } },
                { kind: 'Field', name: { kind: 'Name', value: 'connectionScore' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rfScore' } },
                { kind: 'Field', name: { kind: 'Name', value: 'systemScore' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ApHealthScoresByAccessPointQueryQuery,
  ApHealthScoresByAccessPointQueryQueryVariables
>;
export const ApChannelUtilizationByAccessPointQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'APChannelUtilizationByAccessPointQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'virtualDeviceUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ChannelUtilizationTimeseriesFilterInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'channelUtilizationByAP' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'apVirtualDeviceUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'virtualDeviceUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'band' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'values' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'totalUtilization' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ApChannelUtilizationByAccessPointQueryQuery,
  ApChannelUtilizationByAccessPointQueryQueryVariables
>;
export const ObserversQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ObserversQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'companySlug' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUIDs' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'includeUptime' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          defaultValue: { kind: 'BooleanValue', value: false },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'includeConfigMetadata' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          defaultValue: { kind: 'BooleanValue', value: false },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'includeNOS' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          defaultValue: { kind: 'BooleanValue', value: false },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'includeIsDev' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          defaultValue: { kind: 'BooleanValue', value: false },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'resultsFilter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObserverResultsFilterInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'companyBySlug' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'slug' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'companySlug' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'networks' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'filter' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'networkUUIDs' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'networkUUIDs' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'virtualDevices' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'filter' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'deviceType' },
                                  value: { kind: 'EnumValue', value: 'OBSERVER' },
                                },
                              ],
                            },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'network' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'deviceType' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'nosVersion' },
                              directives: [
                                {
                                  kind: 'Directive',
                                  name: { kind: 'Name', value: 'include' },
                                  arguments: [
                                    {
                                      kind: 'Argument',
                                      name: { kind: 'Name', value: 'if' },
                                      value: {
                                        kind: 'Variable',
                                        name: { kind: 'Name', value: 'includeNOS' },
                                      },
                                    },
                                  ],
                                },
                              ],
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'buildName' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'pendingNosVersion' },
                              directives: [
                                {
                                  kind: 'Directive',
                                  name: { kind: 'Name', value: 'include' },
                                  arguments: [
                                    {
                                      kind: 'Argument',
                                      name: { kind: 'Name', value: 'if' },
                                      value: {
                                        kind: 'Variable',
                                        name: { kind: 'Name', value: 'includeNOS' },
                                      },
                                    },
                                  ],
                                },
                              ],
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'nosVersion' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                                      ],
                                    },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'scheduledAt' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'uptime' },
                              directives: [
                                {
                                  kind: 'Directive',
                                  name: { kind: 'Name', value: 'include' },
                                  arguments: [
                                    {
                                      kind: 'Argument',
                                      name: { kind: 'Name', value: 'if' },
                                      value: {
                                        kind: 'Variable',
                                        name: { kind: 'Name', value: 'includeUptime' },
                                      },
                                    },
                                  ],
                                },
                              ],
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: { kind: 'Name', value: 'ObserverVirtualDevice' },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'observerSettings' },
                                    arguments: [
                                      {
                                        kind: 'Argument',
                                        name: { kind: 'Name', value: 'resultsFilter' },
                                        value: {
                                          kind: 'Variable',
                                          name: { kind: 'Name', value: 'resultsFilter' },
                                        },
                                      },
                                    ],
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'SSIDUUID' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'targetVirtualDeviceUUID' },
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'band' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'results' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'numConnectionAttempts',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'numAssocSuccess' },
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'numDhcpSuccess' },
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'testResults' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'commandType' },
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'target' },
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'numAttempts' },
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'numSuccess' },
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'totalLatencyMs',
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'hardwareDevice' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'deviceType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'serialNumber' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'macAddress' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'isConnectedToBackend' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'disconnectedFromBackendAt' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'bootHistory' },
                                    arguments: [
                                      {
                                        kind: 'Argument',
                                        name: { kind: 'Name', value: 'count' },
                                        value: { kind: 'IntValue', value: '1' },
                                      },
                                    ],
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'buildName' },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'isDev' },
                                    directives: [
                                      {
                                        kind: 'Directive',
                                        name: { kind: 'Name', value: 'include' },
                                        arguments: [
                                          {
                                            kind: 'Argument',
                                            name: { kind: 'Name', value: 'if' },
                                            value: {
                                              kind: 'Variable',
                                              name: { kind: 'Name', value: 'includeIsDev' },
                                            },
                                          },
                                        ],
                                      },
                                    ],
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'latestDeviceConfigMetadata' },
                                    directives: [
                                      {
                                        kind: 'Directive',
                                        name: { kind: 'Name', value: 'include' },
                                        arguments: [
                                          {
                                            kind: 'Argument',
                                            name: { kind: 'Name', value: 'if' },
                                            value: {
                                              kind: 'Variable',
                                              name: {
                                                kind: 'Name',
                                                value: 'includeConfigMetadata',
                                              },
                                            },
                                          },
                                        ],
                                      },
                                    ],
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'FragmentSpread',
                                          name: {
                                            kind: 'Name',
                                            value: 'DeviceConfigMetadataFieldsForDeviceListBadge',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'AccessPointHardwareDevice' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'ipAddress' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'isInCurrentControllerMACTable',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'phyInterfaceConnectedTo' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'UUID' },
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'portSpeedMbps' },
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'maxSpeedMbps' },
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'isEthernet' },
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'isSFP' },
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sfpModuleInfo' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'moduleSpeedKbps',
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DeviceConfigMetadataFieldsForDeviceListBadge' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DeviceConfigMetadata' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'acknowledgedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'state' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isCurrentAsOf' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ObserversQueryQuery, ObserversQueryQueryVariables>;
export const ObserverQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ObserverQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'includeUptime' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          defaultValue: { kind: 'BooleanValue', value: false },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'includeNOS' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          defaultValue: { kind: 'BooleanValue', value: false },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'includeIsDev' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          defaultValue: { kind: 'BooleanValue', value: false },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'resultsFilter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObserverResultsFilterInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'virtualDevice' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deviceType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deviceModel' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isConsoleEnabled' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nosUpgradeGroup' },
                  directives: [
                    {
                      kind: 'Directive',
                      name: { kind: 'Name', value: 'include' },
                      arguments: [
                        {
                          kind: 'Argument',
                          name: { kind: 'Name', value: 'if' },
                          value: { kind: 'Variable', name: { kind: 'Name', value: 'includeNOS' } },
                        },
                      ],
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'networkUUID' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'network' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nosVersion' },
                  directives: [
                    {
                      kind: 'Directive',
                      name: { kind: 'Name', value: 'include' },
                      arguments: [
                        {
                          kind: 'Argument',
                          name: { kind: 'Name', value: 'if' },
                          value: { kind: 'Variable', name: { kind: 'Name', value: 'includeNOS' } },
                        },
                      ],
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'buildName' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pendingNosVersion' },
                  directives: [
                    {
                      kind: 'Directive',
                      name: { kind: 'Name', value: 'include' },
                      arguments: [
                        {
                          kind: 'Argument',
                          name: { kind: 'Name', value: 'if' },
                          value: { kind: 'Variable', name: { kind: 'Name', value: 'includeNOS' } },
                        },
                      ],
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nosVersion' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'version' } }],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'scheduledAt' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'uptime' },
                  directives: [
                    {
                      kind: 'Directive',
                      name: { kind: 'Name', value: 'include' },
                      arguments: [
                        {
                          kind: 'Argument',
                          name: { kind: 'Name', value: 'if' },
                          value: {
                            kind: 'Variable',
                            name: { kind: 'Name', value: 'includeUptime' },
                          },
                        },
                      ],
                    },
                  ],
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ObserverVirtualDevice' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'observerSettings' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'resultsFilter' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'resultsFilter' },
                            },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'SSID' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'ssid' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'targetVirtualDevice' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'band' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'durationMsec' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'networkUUID' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'virtualDevice' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'results' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'numConnectionAttempts' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'numAssocSuccess' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'numDhcpSuccess' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'testResults' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'commandType' },
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'target' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'numAttempts' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'numSuccess' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'totalLatencyMs' },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hardwareDevice' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'deviceType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'serialNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'macAddress' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'deviceModel' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isConnectedToBackend' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'disconnectedFromBackendAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'bootHistory' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'count' },
                            value: { kind: 'IntValue', value: '1' },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'buildName' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isDev' },
                        directives: [
                          {
                            kind: 'Directive',
                            name: { kind: 'Name', value: 'include' },
                            arguments: [
                              {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'if' },
                                value: {
                                  kind: 'Variable',
                                  name: { kind: 'Name', value: 'includeIsDev' },
                                },
                              },
                            ],
                          },
                        ],
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'AccessPointHardwareDevice' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'ipAddress' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'isInCurrentControllerMACTable' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'phyInterfaceConnectedTo' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'portNumber' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'portSpeedMbps' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'maxSpeedMbps' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isEthernet' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isSFP' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'virtualDevice' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'phyInterfaceLastConnectedTo' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'phyInterface' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'portNumber' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'virtualDevice' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'UUID' },
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'label' },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'connectedAt' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ObserverQueryQuery, ObserverQueryQueryVariables>;
export const ObserversTargetsQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ObserversTargetsQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'companySlug' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUIDs' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'includeUptime' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          defaultValue: { kind: 'BooleanValue', value: false },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'resultsFilter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObserverResultsFilterInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'includeNOS' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          defaultValue: { kind: 'BooleanValue', value: false },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'companyBySlug' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'slug' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'companySlug' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'networks' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'filter' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'networkUUIDs' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'networkUUIDs' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'virtualDevices' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'filter' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'deviceType' },
                                  value: { kind: 'EnumValue', value: 'ACCESS_POINT' },
                                },
                              ],
                            },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'network' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'deviceType' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'nosVersion' },
                              directives: [
                                {
                                  kind: 'Directive',
                                  name: { kind: 'Name', value: 'include' },
                                  arguments: [
                                    {
                                      kind: 'Argument',
                                      name: { kind: 'Name', value: 'if' },
                                      value: {
                                        kind: 'Variable',
                                        name: { kind: 'Name', value: 'includeNOS' },
                                      },
                                    },
                                  ],
                                },
                              ],
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'buildName' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'pendingNosVersion' },
                              directives: [
                                {
                                  kind: 'Directive',
                                  name: { kind: 'Name', value: 'include' },
                                  arguments: [
                                    {
                                      kind: 'Argument',
                                      name: { kind: 'Name', value: 'if' },
                                      value: {
                                        kind: 'Variable',
                                        name: { kind: 'Name', value: 'includeNOS' },
                                      },
                                    },
                                  ],
                                },
                              ],
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'nosVersion' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                                      ],
                                    },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'scheduledAt' } },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: { kind: 'Name', value: 'AccessPointVirtualDevice' },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'uptime' },
                                    directives: [
                                      {
                                        kind: 'Directive',
                                        name: { kind: 'Name', value: 'include' },
                                        arguments: [
                                          {
                                            kind: 'Argument',
                                            name: { kind: 'Name', value: 'if' },
                                            value: {
                                              kind: 'Variable',
                                              name: { kind: 'Name', value: 'includeUptime' },
                                            },
                                          },
                                        ],
                                      },
                                    ],
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'observerSettings' },
                                    arguments: [
                                      {
                                        kind: 'Argument',
                                        name: { kind: 'Name', value: 'resultsFilter' },
                                        value: {
                                          kind: 'Variable',
                                          name: { kind: 'Name', value: 'resultsFilter' },
                                        },
                                      },
                                    ],
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'virtualDeviceUUID' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'SSIDUUID' },
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'band' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'results' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'numConnectionAttempts',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'numAssocSuccess' },
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'numDhcpSuccess' },
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'testResults' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'commandType' },
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'target' },
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'numAttempts' },
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'numSuccess' },
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'totalLatencyMs',
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'hardwareDevice' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'deviceType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'deviceModel' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'serialNumber' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'macAddress' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'isConnectedToBackend' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'disconnectedFromBackendAt' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'bootHistory' },
                                    arguments: [
                                      {
                                        kind: 'Argument',
                                        name: { kind: 'Name', value: 'count' },
                                        value: { kind: 'IntValue', value: '1' },
                                      },
                                    ],
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'buildName' },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'AccessPointHardwareDevice' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'ipAddress' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'isInCurrentControllerMACTable',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'phyInterfaceConnectedTo' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'UUID' },
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'portSpeedMbps' },
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'maxSpeedMbps' },
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'isEthernet' },
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'isSFP' },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ObserversTargetsQueryQuery, ObserversTargetsQueryQueryVariables>;
export const ObserversTestsQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ObserversTestsQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'resultsFilter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObserverResultsFilterInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'wifiObserverSettingsForNetwork' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'resultsFilter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'resultsFilter' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'virtualDevice' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'targetVirtualDevice' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'SSID' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'ssid' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'band' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'results' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'numConnectionAttempts' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'numAssocSuccess' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'numDhcpSuccess' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'testResults' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'commandType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'target' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'numAttempts' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'numSuccess' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'totalLatencyMs' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ObserversTestsQueryQuery, ObserversTestsQueryQueryVariables>;
export const ObserversAddAutoTestsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ObserversAddAutoTests' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'durationMsec' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'snrThreshold' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filters' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AutoWifiObserverFiltersInput' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'commands' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'WosObserverCommandInput' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'commit' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createAutoWifiObserverSettings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'networkUUID' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'durationMsec' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'durationMsec' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'snrThreshold' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'snrThreshold' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'filters' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'filters' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'commands' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'commands' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'commit' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'commit' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'numSpatialStreams' },
                      value: { kind: 'IntValue', value: '2' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'virtualDevice' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'targetVirtualDevice' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'SSID' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'ssid' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'band' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ObserversAddAutoTestsMutation, ObserversAddAutoTestsMutationVariables>;
export const ObserversDeleteTestsForSsidDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ObserversDeleteTestsForSSID' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'ssidUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteWifiObserverSettingsForSSID' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'ssidUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'ssidUUID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'virtualDevice' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'targetVirtualDevice' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'SSID' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'ssid' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'band' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ObserversDeleteTestsForSsidMutation,
  ObserversDeleteTestsForSsidMutationVariables
>;
export const AccessPointsQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AccessPointsQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'companySlug' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUIDs' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'includeUptime' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          defaultValue: { kind: 'BooleanValue', value: false },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'includeIsDev' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          defaultValue: { kind: 'BooleanValue', value: false },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'includeNOS' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          defaultValue: { kind: 'BooleanValue', value: false },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'includeConfigMetadata' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          defaultValue: { kind: 'BooleanValue', value: false },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'companyBySlug' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'slug' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'companySlug' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'networks' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'filter' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'networkUUIDs' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'networkUUIDs' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'virtualDevices' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'filter' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'deviceType' },
                                  value: { kind: 'EnumValue', value: 'ACCESS_POINT' },
                                },
                              ],
                            },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'network' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'deviceType' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'nosUpgradeGroup' },
                              directives: [
                                {
                                  kind: 'Directive',
                                  name: { kind: 'Name', value: 'include' },
                                  arguments: [
                                    {
                                      kind: 'Argument',
                                      name: { kind: 'Name', value: 'if' },
                                      value: {
                                        kind: 'Variable',
                                        name: { kind: 'Name', value: 'includeNOS' },
                                      },
                                    },
                                  ],
                                },
                              ],
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'nosVersion' },
                              directives: [
                                {
                                  kind: 'Directive',
                                  name: { kind: 'Name', value: 'include' },
                                  arguments: [
                                    {
                                      kind: 'Argument',
                                      name: { kind: 'Name', value: 'if' },
                                      value: {
                                        kind: 'Variable',
                                        name: { kind: 'Name', value: 'includeNOS' },
                                      },
                                    },
                                  ],
                                },
                              ],
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'buildName' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'pendingNosVersion' },
                              directives: [
                                {
                                  kind: 'Directive',
                                  name: { kind: 'Name', value: 'include' },
                                  arguments: [
                                    {
                                      kind: 'Argument',
                                      name: { kind: 'Name', value: 'if' },
                                      value: {
                                        kind: 'Variable',
                                        name: { kind: 'Name', value: 'includeNOS' },
                                      },
                                    },
                                  ],
                                },
                              ],
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'nosVersion' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                                      ],
                                    },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'scheduledAt' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'uptime' },
                              directives: [
                                {
                                  kind: 'Directive',
                                  name: { kind: 'Name', value: 'include' },
                                  arguments: [
                                    {
                                      kind: 'Argument',
                                      name: { kind: 'Name', value: 'if' },
                                      value: {
                                        kind: 'Variable',
                                        name: { kind: 'Name', value: 'includeUptime' },
                                      },
                                    },
                                  ],
                                },
                              ],
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: { kind: 'Name', value: 'AccessPointVirtualDevice' },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'latestHealthScores' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'overallScore' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'performanceScore' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'connectionScore' },
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'rfScore' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'systemScore' },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'radioProfile' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'band2_4GIsEnabled' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'band2_4GChannelWidthMHz' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'band2_4GAutoChannelIsEnabled',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'band5GIsEnabled' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'band5GChannelWidthMHz' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'band5GAutoChannelIsEnabled',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'band6GIsEnabled' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'band6GChannelWidthMHz' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'band6GAutoChannelIsEnabled',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'radioSettings' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'band2_4GActiveChannel' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'band2_4GPrimaryChannel' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'band2_4GTransmitPowerdBm' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'band5GActiveChannel' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'band5GPrimaryChannel' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'band5GSecondaryChannel' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'band5GTransmitPowerdBm' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'band6GActiveChannel' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'band6GPrimaryChannel' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'band6GTransmitPowerdBm' },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'connectedClients' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'macAddress' },
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'band' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'channel' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'ssidName' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'observerVirtualDevice' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'UUID' },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'hardwareDevice' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'deviceType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'deviceModel' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'serialNumber' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'macAddress' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'isConnectedToBackend' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'disconnectedFromBackendAt' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'bootHistory' },
                                    arguments: [
                                      {
                                        kind: 'Argument',
                                        name: { kind: 'Name', value: 'count' },
                                        value: { kind: 'IntValue', value: '1' },
                                      },
                                    ],
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'buildName' },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'isDev' },
                                    directives: [
                                      {
                                        kind: 'Directive',
                                        name: { kind: 'Name', value: 'include' },
                                        arguments: [
                                          {
                                            kind: 'Argument',
                                            name: { kind: 'Name', value: 'if' },
                                            value: {
                                              kind: 'Variable',
                                              name: { kind: 'Name', value: 'includeIsDev' },
                                            },
                                          },
                                        ],
                                      },
                                    ],
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'latestDeviceConfigMetadata' },
                                    directives: [
                                      {
                                        kind: 'Directive',
                                        name: { kind: 'Name', value: 'include' },
                                        arguments: [
                                          {
                                            kind: 'Argument',
                                            name: { kind: 'Name', value: 'if' },
                                            value: {
                                              kind: 'Variable',
                                              name: {
                                                kind: 'Name',
                                                value: 'includeConfigMetadata',
                                              },
                                            },
                                          },
                                        ],
                                      },
                                    ],
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'FragmentSpread',
                                          name: {
                                            kind: 'Name',
                                            value: 'DeviceConfigMetadataFieldsForDeviceListBadge',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'AccessPointHardwareDevice' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'ipAddress' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'isInCurrentControllerMACTable',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'phyInterfaceConnectedTo' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'UUID' },
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'portSpeedMbps' },
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'maxSpeedMbps' },
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'isEthernet' },
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'isSFP' },
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'isPOEEnabled' },
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'portNumber' },
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'poeType' },
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sfpModuleInfo' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'moduleSpeedKbps',
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'virtualDevice' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'hardwareDevice',
                                                      },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          {
                                                            kind: 'Field',
                                                            name: {
                                                              kind: 'Name',
                                                              value: 'serialNumber',
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'BSSIDs' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'BSSID' },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DeviceConfigMetadataFieldsForDeviceListBadge' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DeviceConfigMetadata' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'acknowledgedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'state' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isCurrentAsOf' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AccessPointsQueryQuery, AccessPointsQueryQueryVariables>;
export const AccessPointQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AccessPointQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'includeUptime' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          defaultValue: { kind: 'BooleanValue', value: false },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'includeNOS' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          defaultValue: { kind: 'BooleanValue', value: false },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'virtualDevice' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'network' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deviceType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deviceModel' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isConsoleEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'networkUUID' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nosUpgradeGroup' },
                  directives: [
                    {
                      kind: 'Directive',
                      name: { kind: 'Name', value: 'include' },
                      arguments: [
                        {
                          kind: 'Argument',
                          name: { kind: 'Name', value: 'if' },
                          value: { kind: 'Variable', name: { kind: 'Name', value: 'includeNOS' } },
                        },
                      ],
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nosVersion' },
                  directives: [
                    {
                      kind: 'Directive',
                      name: { kind: 'Name', value: 'include' },
                      arguments: [
                        {
                          kind: 'Argument',
                          name: { kind: 'Name', value: 'if' },
                          value: { kind: 'Variable', name: { kind: 'Name', value: 'includeNOS' } },
                        },
                      ],
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'buildName' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pendingNosVersion' },
                  directives: [
                    {
                      kind: 'Directive',
                      name: { kind: 'Name', value: 'include' },
                      arguments: [
                        {
                          kind: 'Argument',
                          name: { kind: 'Name', value: 'if' },
                          value: { kind: 'Variable', name: { kind: 'Name', value: 'includeNOS' } },
                        },
                      ],
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nosVersion' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'version' } }],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'scheduledAt' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'uptime' },
                  directives: [
                    {
                      kind: 'Directive',
                      name: { kind: 'Name', value: 'include' },
                      arguments: [
                        {
                          kind: 'Argument',
                          name: { kind: 'Name', value: 'if' },
                          value: {
                            kind: 'Variable',
                            name: { kind: 'Name', value: 'includeUptime' },
                          },
                        },
                      ],
                    },
                  ],
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'AccessPointVirtualDevice' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'isLEDDarkModeEnabled' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'latestHealthScores' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'overallScore' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'performanceScore' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'connectionScore' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'rfScore' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'systemScore' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'radioProfile' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'band2_4GIsEnabled' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'band2_4GChannelWidthMHz' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'band2_4GAutoChannelIsEnabled' },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'band5GIsEnabled' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'band5GChannelWidthMHz' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'band5GAutoChannelIsEnabled' },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'band6GIsEnabled' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'band6GChannelWidthMHz' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'band6GAutoChannelIsEnabled' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'radioSettings' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'band2_4GActiveChannel' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'band2_4GPrimaryChannel' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'band2_4GTransmitPowerdBm' },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'band5GActiveChannel' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'band5GPrimaryChannel' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'band5GSecondaryChannel' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'band5GTransmitPowerdBm' },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'band6GActiveChannel' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'band6GPrimaryChannel' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'band6GTransmitPowerdBm' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'connectedClients' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'macAddress' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'band' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'channel' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'ssidName' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'observerVirtualDevice' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hardwareDevice' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'deviceType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'serialNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'macAddress' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'deviceModel' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isConnectedToBackend' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'disconnectedFromBackendAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'bootHistory' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'count' },
                            value: { kind: 'IntValue', value: '1' },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'buildName' } },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'AccessPointHardwareDevice' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'ipAddress' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'isInCurrentControllerMACTable' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'phyInterfaceConnectedTo' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'portNumber' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'portSpeedMbps' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'maxSpeedMbps' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isEthernet' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isSFP' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'poeType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isPOEEnabled' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'portNumber' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'virtualDevice' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'hardwareDevice' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'serialNumber' },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'phyInterfaceLastConnectedTo' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'phyInterface' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'portNumber' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'virtualDevice' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'UUID' },
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'label' },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'connectedAt' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'BSSIDs' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'BSSID' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AccessPointQueryQuery, AccessPointQueryQueryVariables>;
export const PacketCaptureDeviceQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PacketCaptureDeviceQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'virtualDevice' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deviceType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hardwareDevice' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'deviceType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'serialNumber' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PacketCaptureDeviceQueryQuery, PacketCaptureDeviceQueryQueryVariables>;
export const UpdateVirtualDevicesMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateVirtualDevicesMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'virtualDeviceUUIDs' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateVirtualDeviceInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateVirtualDevices' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'virtualDeviceUUIDs' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'virtualDeviceUUIDs' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateVirtualDevicesMutationMutation,
  UpdateVirtualDevicesMutationMutationVariables
>;
export const FallbackAccessPointHardwareQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'FallbackAccessPointHardwareQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'serialNumber' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hardwareDevice' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'serialNumber' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'serialNumber' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'serialNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'virtualDeviceUUID' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'virtualDevice' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'label' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FallbackAccessPointHardwareQueryQuery,
  FallbackAccessPointHardwareQueryQueryVariables
>;
export const BssiDsForNetworkQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'BSSIDsForNetworkQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'bssidsForNetwork' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'BSSID' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'SSID' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'ssid' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isHidden' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
                { kind: 'Field', name: { kind: 'Name', value: 'radioBand' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'accessPointHardwareDevice' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'virtualDevice' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BssiDsForNetworkQueryQuery, BssiDsForNetworkQueryQueryVariables>;
export const AutoVpnGroupsForCompanyDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AutoVPNGroupsForCompany' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'companySlug' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'autoVPNGroupsForCompany' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'companySlug' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'companySlug' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'AutoVPNGroupFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhyInterfaceLabelFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PhyInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'portNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hardwareLabel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'virtualDevice' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deviceModel' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'internetServicePlan' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'provider' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AutoVPNMemberFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AutoVPNMember' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'networkUUID' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'network' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isFailoverEnabled' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'permittedVLANs' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'vlanID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ipV4ClientGateway' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ipV4ClientPrefixLength' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'uplink' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'addressPrefixLength' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hubUplinkUUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'publicKey' } },
                { kind: 'Field', name: { kind: 'Name', value: 'listenPort' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phyInterfaceUUID' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'phyInterface' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'PhyInterfaceLabelFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'connectionInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'observedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastHandshakeRx' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastHandshakeTx' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastPacketTx' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastPacketRx' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AutoVPNGroupFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AutoVPNGroup' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hubNetworkUUID' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hubNetwork' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hubUplink' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'addressPrefixLength' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'phyInterface' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'PhyInterfaceLabelFields' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'listenPort' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isHubFailoverEnabled' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'members' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'AutoVPNMemberFields' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'routes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'dstPrefixLength' } },
                { kind: 'Field', name: { kind: 'Name', value: 'dstGateway' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AutoVpnGroupsForCompanyQuery, AutoVpnGroupsForCompanyQueryVariables>;
export const AutoVpnGroupDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AutoVPNGroup' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'autoVPNGroup' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'AutoVPNGroupFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhyInterfaceLabelFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PhyInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'portNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hardwareLabel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'virtualDevice' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deviceModel' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'internetServicePlan' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'provider' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AutoVPNMemberFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AutoVPNMember' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'networkUUID' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'network' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isFailoverEnabled' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'permittedVLANs' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'vlanID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ipV4ClientGateway' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ipV4ClientPrefixLength' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'uplink' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'addressPrefixLength' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hubUplinkUUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'publicKey' } },
                { kind: 'Field', name: { kind: 'Name', value: 'listenPort' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phyInterfaceUUID' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'phyInterface' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'PhyInterfaceLabelFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'connectionInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'observedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastHandshakeRx' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastHandshakeTx' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastPacketTx' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastPacketRx' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AutoVPNGroupFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AutoVPNGroup' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hubNetworkUUID' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hubNetwork' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hubUplink' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'addressPrefixLength' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'phyInterface' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'PhyInterfaceLabelFields' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'listenPort' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isHubFailoverEnabled' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'members' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'AutoVPNMemberFields' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'routes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'dstPrefixLength' } },
                { kind: 'Field', name: { kind: 'Name', value: 'dstGateway' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AutoVpnGroupQuery, AutoVpnGroupQueryVariables>;
export const AutoVpnMemberQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AutoVPNMemberQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'autoVPNMember' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'AutoVPNMemberFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhyInterfaceLabelFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PhyInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'portNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hardwareLabel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'virtualDevice' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deviceModel' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'internetServicePlan' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'provider' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AutoVPNMemberFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AutoVPNMember' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'networkUUID' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'network' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isFailoverEnabled' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'permittedVLANs' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'vlanID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ipV4ClientGateway' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ipV4ClientPrefixLength' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'uplink' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'addressPrefixLength' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hubUplinkUUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'publicKey' } },
                { kind: 'Field', name: { kind: 'Name', value: 'listenPort' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phyInterfaceUUID' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'phyInterface' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'PhyInterfaceLabelFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'connectionInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'observedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastHandshakeRx' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastHandshakeTx' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastPacketTx' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastPacketRx' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AutoVpnMemberQueryQuery, AutoVpnMemberQueryQueryVariables>;
export const CreateAutoVpnGroupDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateAutoVPNGroup' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'companySlug' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateAutoVPNGroupInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createAutoVPNGroup' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'companySlug' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'companySlug' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companySlug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hubNetworkUUID' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateAutoVpnGroupMutation, CreateAutoVpnGroupMutationVariables>;
export const UpdateAutoVpnGroupDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateAutoVPNGroup' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'UUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateAutoVPNGroupInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateAutoVPNGroup' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'UUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateAutoVpnGroupMutation, UpdateAutoVpnGroupMutationVariables>;
export const DeleteAutoVpnGroupDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteAutoVPNGroup' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteAutoVPNGroup' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companySlug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hubNetworkUUID' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteAutoVpnGroupMutation, DeleteAutoVpnGroupMutationVariables>;
export const AddNetworkToAutoVpnGroupDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AddNetworkToAutoVPNGroup' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'groupUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AddNetworkToAutoVPNGroupInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'addNetworkToAutoVPNGroup' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'groupUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'groupUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AddNetworkToAutoVpnGroupMutation,
  AddNetworkToAutoVpnGroupMutationVariables
>;
export const UpdateAutoVpnMemberDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateAutoVPNMember' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateAutoVPNMemberInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateAutoVPNMember' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateAutoVpnMemberMutation, UpdateAutoVpnMemberMutationVariables>;
export const RemoveNetworkFromAutoVpnGroupDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RemoveNetworkFromAutoVPNGroup' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'groupUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'removeNetworkFromAutoVPNGroup' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'groupUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'groupUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RemoveNetworkFromAutoVpnGroupMutation,
  RemoveNetworkFromAutoVpnGroupMutationVariables
>;
export const CreateAutoVpnRouteDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateAutoVPNRoute' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'groupUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateAutoVPNRouteInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createAutoVPNRoute' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'groupUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'groupUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'dstGateway' } },
                { kind: 'Field', name: { kind: 'Name', value: 'dstPrefixLength' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateAutoVpnRouteMutation, CreateAutoVpnRouteMutationVariables>;
export const DeleteAutoVpnRouteDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteAutoVPNRoute' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteAutoVPNRoute' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteAutoVpnRouteMutation, DeleteAutoVpnRouteMutationVariables>;
export const NetworksWithControllerPortsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'NetworksWithControllerPorts' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'companySlug' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'networksForCompany' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'companySlug' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'companySlug' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isTemplate' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'virtualDevices' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'filter' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'deviceType' },
                            value: { kind: 'EnumValue', value: 'CONTROLLER' },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'ControllerVirtualDevice' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'phyInterfaces' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isUplink' } },
                                  {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'PhyInterfaceLabelFields' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhyInterfaceLabelFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PhyInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'portNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hardwareLabel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'virtualDevice' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deviceModel' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'internetServicePlan' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'provider' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  NetworksWithControllerPortsQuery,
  NetworksWithControllerPortsQueryVariables
>;
export const GetEventLogsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetEventLogs' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'startTime' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateTime' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'endTime' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateTime' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          defaultValue: { kind: 'IntValue', value: '0' },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          defaultValue: { kind: 'IntValue', value: '100' },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'typeFilter' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'EventType' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'virtualDeviceUUIDFilter' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'recentEventLogEventsPage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'offset' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'startTime' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'startTime' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'endTime' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'endTime' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'typeFilter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'typeFilter' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'virtualDeviceUUIDFilter' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'virtualDeviceUUIDFilter' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'events' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'eventType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'generatedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'networkUUID' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'properties' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: { kind: 'Name', value: 'WANUpProperties' },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'virtualDevice' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: '__typename' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'deviceType' },
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'hardwareDevice' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'serialNumber' },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'InlineFragment',
                                          typeCondition: {
                                            kind: 'NamedType',
                                            name: {
                                              kind: 'Name',
                                              value: 'ControllerVirtualDevice',
                                            },
                                          },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'phyInterfaces' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'UUID' },
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'portNumber' },
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'uplinkPriority',
                                                      },
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'isUplink' },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: { kind: 'Name', value: 'WANDownProperties' },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'virtualDevice' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: '__typename' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'deviceType' },
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'hardwareDevice' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'serialNumber' },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'InlineFragment',
                                          typeCondition: {
                                            kind: 'NamedType',
                                            name: {
                                              kind: 'Name',
                                              value: 'ControllerVirtualDevice',
                                            },
                                          },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'phyInterfaces' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'UUID' },
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'portNumber' },
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'uplinkPriority',
                                                      },
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'isUplink' },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: { kind: 'Name', value: 'DeviceOfflineProperties' },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'lastSeen' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'virtualDevice' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: '__typename' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'deviceType' },
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'deviceType' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'hardwareDevice' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'serialNumber' },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: { kind: 'Name', value: 'DeviceOnlineProperties' },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'firstSeen' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'virtualDevice' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: '__typename' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'deviceType' },
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'deviceType' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'hardwareDevice' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'serialNumber' },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: { kind: 'Name', value: 'WANStatusChangeProperties' },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'virtualDevice' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: '__typename' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'deviceType' },
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                        {
                                          kind: 'InlineFragment',
                                          typeCondition: {
                                            kind: 'NamedType',
                                            name: {
                                              kind: 'Name',
                                              value: 'ControllerVirtualDevice',
                                            },
                                          },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'phyInterfaces' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'UUID' },
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'label' },
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'isUplink' },
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'portNumber' },
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'uplinkPriority',
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'activeWANConnections' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'externalAddresses' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'internetServicePlanProvider',
                                          },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'name' },
                                              },
                                            ],
                                          },
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'port' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: { kind: 'Name', value: 'FirmwareUpgradeScheduledProperties' },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'virtualDevices' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'deviceType' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'deviceModel' },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'nosVersion' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'major' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'minor' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'patch' } },
                                      ],
                                    },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'scheduledAt' } },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: { kind: 'Name', value: 'FirmwareUpgradePendingProperties' },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'virtualDevices' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'deviceType' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'deviceModel' },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'nosVersion' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'major' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'minor' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'patch' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: { kind: 'Name', value: 'FirmwareUpgradeCompletedProperties' },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'successfulVirtualDevices' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'deviceType' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'deviceModel' },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'failedVirtualDevices' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'deviceType' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'deviceModel' },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'nosVersion' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'major' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'minor' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'patch' } },
                                      ],
                                    },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: { kind: 'Name', value: 'DeviceBootProperties' },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'virtualDevice' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: '__typename' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'deviceType' },
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'deviceType' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'hardwareDevice' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'serialNumber' },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'bootCount' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'buildName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'rebootReason' } },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: { kind: 'Name', value: 'HighAvailabilityFailoverProperties' },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'primaryVirtualDevice' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: '__typename' },
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'deviceType' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'hardwareDevice' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'serialNumber' },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'backupVirtualDevice' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: '__typename' },
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'deviceType' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'hardwareDevice' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'serialNumber' },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: { kind: 'Name', value: 'PDUOutletProperties' },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'virtualDevice' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: '__typename' },
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'deviceType' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'hardwareDevice' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'serialNumber' },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'outletNum' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'outletEnabled' } },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: {
                                  kind: 'Name',
                                  value: 'AccessPointRadarHitDetectedProperties',
                                },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'virtualDevice' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: '__typename' },
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'deviceType' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'hardwareDevice' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'serialNumber' },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'dfsChannel' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'fallbackChannel' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'clientsMovedOff' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: {
                                  kind: 'Name',
                                  value: 'AccessPointDfsChannelResetProperties',
                                },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'virtualDevice' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: '__typename' },
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'deviceType' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'hardwareDevice' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'serialNumber' },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'opChan' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'newOpChan' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'fbChan' } },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: { kind: 'Name', value: 'HighAvailabilityRecoveryProperties' },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'primaryVirtualDevice' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: '__typename' },
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'deviceType' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'hardwareDevice' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'serialNumber' },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'backupVirtualDevice' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: '__typename' },
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'deviceType' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'hardwareDevice' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'serialNumber' },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: { kind: 'Name', value: 'IPSecTunnelStatusChangeProperties' },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'ipSecTunnel' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                      ],
                                    },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'saStatus' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'childSAStatus' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetEventLogsQuery, GetEventLogsQueryVariables>;
export const NetworkClientsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'networkClients' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'NetworkClientsFilter' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'networkClients' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'alias' } },
                { kind: 'Field', name: { kind: 'Name', value: 'apLocation' } },
                { kind: 'Field', name: { kind: 'Name', value: 'apSerialNumber' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'apVirtualDevice' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'deviceModel' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'channel' } },
                { kind: 'Field', name: { kind: 'Name', value: 'clientName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ip' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isWireless' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isBlocked' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'observerVirtualDevice' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'lastSeen' } },
                { kind: 'Field', name: { kind: 'Name', value: 'dhcpLeaseExpiresAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'macAddress' } },
                { kind: 'Field', name: { kind: 'Name', value: 'noise' } },
                { kind: 'Field', name: { kind: 'Name', value: 'radioBand' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalRxBytes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rxRate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'signal' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ssid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'txRate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalTxBytes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'vlan' } },
                { kind: 'Field', name: { kind: 'Name', value: 'vlanUUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hwMode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'numSpatialStreams' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'connectedVLAN' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'vlanID' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dhcpRule' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'connectedSSID' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'ssid' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'phyInterfaceConnectedTo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'PhyInterfaceLabelFields' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'associatedAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'throughput' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'txRate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'rxRate' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'serviceTypes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'wirelessScore' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'staticMapping' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'macAddress' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'ipAddress' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hostname' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhyInterfaceLabelFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PhyInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'portNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hardwareLabel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'virtualDevice' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deviceModel' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'internetServicePlan' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'provider' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<NetworkClientsQuery, NetworkClientsQueryVariables>;
export const GetCaptivePortalDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetCaptivePortal' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'vlanUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'captivePortalForVLAN' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'vlanUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'vlanUUID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'displaySettings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'fontColor' } }],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'logoImageURL' } },
                { kind: 'Field', name: { kind: 'Name', value: 'redirectURL' } },
                { kind: 'Field', name: { kind: 'Name', value: 'termsAndConditions' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'vlans' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCaptivePortalQuery, GetCaptivePortalQueryVariables>;
export const GetNetworkClientsTxRxPerDayDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getNetworkClientsTxRxPerDay' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'numDaysLookback' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'networkClientsTxRxPerDay' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'numDaysLookback' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'numDaysLookback' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'ip' } },
                { kind: 'Field', name: { kind: 'Name', value: 'macAddress' } },
                { kind: 'Field', name: { kind: 'Name', value: 'dateString' } },
                { kind: 'Field', name: { kind: 'Name', value: 'txBytes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rxBytes' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetNetworkClientsTxRxPerDayQuery,
  GetNetworkClientsTxRxPerDayQueryVariables
>;
export const CompanyDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Company' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getCompany' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'slug' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isCustomer' } },
                { kind: 'Field', name: { kind: 'Name', value: 'supportGroup' } },
                { kind: 'Field', name: { kind: 'Name', value: 'websiteDomain' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CompanyQuery, CompanyQueryVariables>;
export const GetKeyValueDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetKeyValue' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'key' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getKeyValue' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'key' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'key' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetKeyValueQuery, GetKeyValueQueryVariables>;
export const SetKeyValueDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SetKeyValue' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'key' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'value' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'JSON' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setKeyValue' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'key' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'key' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'value' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'value' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SetKeyValueMutation, SetKeyValueMutationVariables>;
export const NetworkStatusQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'NetworkStatusQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'virtualDevicesForNetwork' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deviceModel' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hardwareDevice' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'serialNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'macAddress' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isConnectedToBackend' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<NetworkStatusQueryQuery, NetworkStatusQueryQueryVariables>;
export const NetworksForCompanyDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'NetworksForCompany' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'companySlug' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'includePinnedNOSVersionInfo' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
          defaultValue: { kind: 'BooleanValue', value: false },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'networksForCompany' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'companySlug' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'companySlug' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'NetworkForCompanyFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'NetworkForCompanyFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Network' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCustomer' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isTemplate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isTrial' } },
          { kind: 'Field', name: { kind: 'Name', value: 'trialExpiresAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deactivatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'goLiveAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'supportGroup' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'virtualDevices' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deviceModel' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deviceType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hardwareDevice' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'serialNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isSpare' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isConnectedToBackend' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ControllerVirtualDevice' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'highAvailability' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mailingAddress' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'line1' } },
                { kind: 'Field', name: { kind: 'Name', value: 'line2' } },
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subdivisionCode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'postalCode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'countryISO2' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'enabledServiceDiscoveryTypes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pinnedNOSVersionID' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pinnedNOSVersion' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'major' } },
                { kind: 'Field', name: { kind: 'Name', value: 'minor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'patch' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'version' },
                  directives: [
                    {
                      kind: 'Directive',
                      name: { kind: 'Name', value: 'include' },
                      arguments: [
                        {
                          kind: 'Argument',
                          name: { kind: 'Name', value: 'if' },
                          value: {
                            kind: 'Variable',
                            name: { kind: 'Name', value: 'includePinnedNOSVersionInfo' },
                          },
                        },
                      ],
                    },
                  ],
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'isDefault' },
                  directives: [
                    {
                      kind: 'Directive',
                      name: { kind: 'Name', value: 'include' },
                      arguments: [
                        {
                          kind: 'Argument',
                          name: { kind: 'Name', value: 'if' },
                          value: {
                            kind: 'Variable',
                            name: { kind: 'Name', value: 'includePinnedNOSVersionInfo' },
                          },
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<NetworksForCompanyQuery, NetworksForCompanyQueryVariables>;
export const NetworkByUuidQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'NetworkByUUIDQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'includePinnedNOSVersionInfo' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
          defaultValue: { kind: 'BooleanValue', value: false },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'network' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'NetworkForCompanyFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'NetworkForCompanyFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Network' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCustomer' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isTemplate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isTrial' } },
          { kind: 'Field', name: { kind: 'Name', value: 'trialExpiresAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deactivatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'goLiveAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'supportGroup' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'virtualDevices' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deviceModel' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deviceType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hardwareDevice' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'serialNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isSpare' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isConnectedToBackend' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ControllerVirtualDevice' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'highAvailability' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mailingAddress' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'line1' } },
                { kind: 'Field', name: { kind: 'Name', value: 'line2' } },
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subdivisionCode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'postalCode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'countryISO2' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'enabledServiceDiscoveryTypes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pinnedNOSVersionID' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pinnedNOSVersion' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'major' } },
                { kind: 'Field', name: { kind: 'Name', value: 'minor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'patch' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'version' },
                  directives: [
                    {
                      kind: 'Directive',
                      name: { kind: 'Name', value: 'include' },
                      arguments: [
                        {
                          kind: 'Argument',
                          name: { kind: 'Name', value: 'if' },
                          value: {
                            kind: 'Variable',
                            name: { kind: 'Name', value: 'includePinnedNOSVersionInfo' },
                          },
                        },
                      ],
                    },
                  ],
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'isDefault' },
                  directives: [
                    {
                      kind: 'Directive',
                      name: { kind: 'Name', value: 'include' },
                      arguments: [
                        {
                          kind: 'Argument',
                          name: { kind: 'Name', value: 'if' },
                          value: {
                            kind: 'Variable',
                            name: { kind: 'Name', value: 'includePinnedNOSVersionInfo' },
                          },
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<NetworkByUuidQueryQuery, NetworkByUuidQueryQueryVariables>;
export const IsNosFeatureEnabledForNetworkDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'IsNosFeatureEnabledForNetwork' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'nosFeatureKey' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'isNosFeatureEnabledForNetwork' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'nosFeatureKey' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'nosFeatureKey' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  IsNosFeatureEnabledForNetworkQuery,
  IsNosFeatureEnabledForNetworkQueryVariables
>;
export const AreNosFeatureEnabledForNetworkDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AreNosFeatureEnabledForNetwork' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'nosFeatureKeys' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'areNosFeaturesEnabledForNetwork' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'nosFeatureKeys' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'nosFeatureKeys' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AreNosFeatureEnabledForNetworkQuery,
  AreNosFeatureEnabledForNetworkQueryVariables
>;
export const IsNosFeatureEnabledForCompanyDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'IsNosFeatureEnabledForCompany' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'companySlug' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'nosFeatureKey' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'isNosFeatureEnabledForCompany' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'companySlug' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'companySlug' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'nosFeatureKey' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'nosFeatureKey' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  IsNosFeatureEnabledForCompanyQuery,
  IsNosFeatureEnabledForCompanyQueryVariables
>;
export const AreNosFeatureEnabledForCompanyDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AreNosFeatureEnabledForCompany' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'companySlug' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'nosFeatureKeys' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'areNosFeaturesEnabledForCompany' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'companySlug' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'companySlug' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'nosFeatureKeys' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'nosFeatureKeys' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AreNosFeatureEnabledForCompanyQuery,
  AreNosFeatureEnabledForCompanyQueryVariables
>;
export const CompanyUuidQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CompanyUUIDQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getCompany' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'slug' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isCustomer' } },
                { kind: 'Field', name: { kind: 'Name', value: 'supportGroup' } },
                { kind: 'Field', name: { kind: 'Name', value: 'websiteDomain' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CompanyUuidQueryQuery, CompanyUuidQueryQueryVariables>;
export const CreateKnockTokenDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateKnockToken' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'companyUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createKnockToken' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'companyUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'companyUUID' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateKnockTokenMutation, CreateKnockTokenMutationVariables>;
export const PermissionsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Permissions' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'PermissionsInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'permissions' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'networkUUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'permissions' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PermissionsQuery, PermissionsQueryVariables>;
export const DeleteNosFirmwareUpgradeMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteNOSFirmwareUpgradeMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteBulkNOSUpgrade' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteNosFirmwareUpgradeMutationMutation,
  DeleteNosFirmwareUpgradeMutationMutationVariables
>;
export const VirtualDeviceForNavigationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'VirtualDeviceForNavigation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'virtualDevice' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deviceType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'network' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'companySlug' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  VirtualDeviceForNavigationQuery,
  VirtualDeviceForNavigationQueryVariables
>;
export const MutationDiffAuditLogDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'MutationDiffAuditLog' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'MutationDiffAuditLogFilterInput' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mutationDiffAuditLogPageForNetwork' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'entries' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'username' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'action' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'beforeJSON' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'afterJSON' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MutationDiffAuditLogQuery, MutationDiffAuditLogQueryVariables>;
export const MutationDiffAuditLogFilteredDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'MutationDiffAuditLogFiltered' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'MutationDiffAuditLogFilterInput' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mutationDiffAuditLogPageForNetworkFiltered' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'entries' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'username' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'action' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'beforeJSON' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'afterJSON' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MutationDiffAuditLogFilteredQuery,
  MutationDiffAuditLogFilteredQueryVariables
>;
export const MutationAuditLogEntriesForNetworkDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'MutationAuditLogEntriesForNetwork' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'MutationAuditLogFilter' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mutationAuditLogEntriesForNetwork' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'networkUUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'username' } },
                { kind: 'Field', name: { kind: 'Name', value: 'action' } },
                { kind: 'Field', name: { kind: 'Name', value: 'args' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MutationAuditLogEntriesForNetworkQuery,
  MutationAuditLogEntriesForNetworkQueryVariables
>;
export const StatsForVirtualDevicesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'statsForVirtualDevices' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'NetworkStatsFilter' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'statsForVirtualDevices' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'observedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'insertedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'networkUUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'virtualDeviceUUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rawData' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<StatsForVirtualDevicesQuery, StatsForVirtualDevicesQueryVariables>;
export const AnomaliesForVirtualDevicesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'anomaliesForVirtualDevices' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'AnomalyStatsFilterInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'anomalyStatsGroupsForVirtualDevices' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sourceFunction' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sourceLine' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stackTrace' } },
                { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mostRecentObservedAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'rawStats' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'observedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'insertedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'networkUUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'virtualDeviceUUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'rawData' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AnomaliesForVirtualDevicesQuery,
  AnomaliesForVirtualDevicesQueryVariables
>;
export const VirtualDevicesForTopologyDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'VirtualDevicesForTopology' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'virtualDevicesForNetwork' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deviceType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hardwareDevice' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'serialNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'deviceType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isConnectedToBackend' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ControllerVirtualDevice' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'phyInterfaces' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'virtualDeviceUUID' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isEnabled' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isUplink' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isConnected' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isLoopbackDetected' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isBlockedDueToFlaps' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isSTPForwarding' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'connectedDevices' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'hardwareDevice' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'serialNumber' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'deviceType' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'isActive' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'virtualDeviceUUID' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'isConnectedToBackend' },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'internetServicePlan' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'provider' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'isUplinkActive' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SwitchVirtualDevice' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'phyInterfaces' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'isEnabled' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isUplink' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isConnected' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isLoopbackDetected' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isBlockedDueToFlaps' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isSTPForwarding' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'connectedDevices' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'hardwareDevice' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'serialNumber' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'deviceType' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'isActive' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'virtualDeviceUUID' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'isConnectedToBackend' },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'switchProfile' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'switchingTier' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  VirtualDevicesForTopologyQuery,
  VirtualDevicesForTopologyQueryVariables
>;
export const LatestDeviceConfigDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'LatestDeviceConfig' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'serialNumber' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'latestDeviceConfig' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'serialNumber' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'serialNumber' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'configJSON' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LatestDeviceConfigQuery, LatestDeviceConfigQueryVariables>;
export const DeviceConfigOverrideDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'DeviceConfigOverride' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'serialNumber' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deviceConfigOverride' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'serialNumber' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'serialNumber' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'configJSON' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeviceConfigOverrideQuery, DeviceConfigOverrideQueryVariables>;
export const UpdateDeviceConfigOverrideDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateDeviceConfigOverride' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'serialNumber' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'configJSON' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'upsertDeviceConfigOverride' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'serialNumber' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'serialNumber' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'configJSON' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'configJSON' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateDeviceConfigOverrideMutation,
  UpdateDeviceConfigOverrideMutationVariables
>;
export const DeviceForNetworkDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'DeviceForNetwork' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'virtualDevicesForNetwork' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'networkUUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'networkUUID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hardwareDevice' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'serialNumber' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeviceForNetworkQuery, DeviceForNetworkQueryVariables>;
export const ValidateBearerSessionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'validateBearerSession' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'UUID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'validateBearerSession' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'UUID' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'UUID' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'UUID' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ValidateBearerSessionMutation, ValidateBearerSessionMutationVariables>;
export const AllSecurityAppliancesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AllSecurityAppliances' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hardwareDevices' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'deviceType' },
                      value: { kind: 'EnumValue', value: 'CONTROLLER' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'limit' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'offset' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'serialNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deviceType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deviceModel' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'virtualDevice' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'network' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'UUID' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'company' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'mailingAddress' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'line1' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'line2' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'subdivisionCode' },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'postalCode' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AllSecurityAppliancesQuery, AllSecurityAppliancesQueryVariables>;
export const SsoOptionsQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SSOOptionsQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'companySlug' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ssoOptions' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'companySlug' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'companySlug' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'connectedDirectory' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'connections' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'connectedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SsoOptionsQueryQuery, SsoOptionsQueryQueryVariables>;
export const GetCompanyDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetCompany' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getCompany' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'slug' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'defaultRoleForUsers' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCompanyQuery, GetCompanyQueryVariables>;
export const UpsertDefaultRoleForUsersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpsertDefaultRoleForUsers' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'companySlug' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateDefaultRoleForUsersInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateDefaultRoleForUsers' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'companySlug' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'companySlug' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'companySlug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'defaultRoleForUsers' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpsertDefaultRoleForUsersMutation,
  UpsertDefaultRoleForUsersMutationVariables
>;
export const CreatePermittedEmailDomainDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreatePermittedEmailDomain' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreatePermittedEmailDomainInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createPermittedEmailDomain' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'domain' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreatePermittedEmailDomainMutation,
  CreatePermittedEmailDomainMutationVariables
>;
export const ConfigureSsoMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ConfigureSSOMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ConfigureSSOInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'configureSSO' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'portalURL' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ConfigureSsoMutationMutation, ConfigureSsoMutationMutationVariables>;

export const rootObjectDefinitions = {
  Query: [
    'OUIsForVendor',
    'activeClients',
    'affectedClientsByCVE',
    'affectedClientsByCVEIDs',
    'alertAuditLogEntriesForCompany',
    'alertDefinitions',
    'alertDefinitionsForNetwork',
    'alertReceiver',
    'alertReceiversForCompany',
    'alertTargetSlack',
    'alertTargetWebhook',
    'alertTargets',
    'alertTargetsSlack',
    'alertTargetsWebhook',
    'allCVEsForNetwork',
    'allClientMetricsByClient',
    'allClientMetricsByVLAN',
    'allMarketingChangelogEntries',
    'anomalyStatsGroupsForVirtualDevices',
    'apChannelUtilization',
    'apHealthScores',
    'apUptime',
    'applicationDNSFirewallRule',
    'applicationDNSFirewallRuleApplicationForHostname',
    'applicationDNSFirewallRuleApplications',
    'applicationDNSFirewallRuleCategories',
    'applicationDNSFirewallRuleCategoryForHostname',
    'applicationDNSFirewallRuleGroups',
    'applicationDNSFirewallRulesForNetwork',
    'appliedFleetwideNotificationSetting',
    'areNosFeaturesEnabledForCompany',
    'areNosFeaturesEnabledForNetwork',
    'authenticationToken',
    'autoChannelSelectionJob',
    'autoChannelSelectionJobsForNetwork',
    'autoSwitchConfigurationJob',
    'autoSwitchConfigurationJobsForNetwork',
    'autoVPNGroup',
    'autoVPNGroupsForCompany',
    'autoVPNGroupsForNetwork',
    'autoVPNMember',
    'autoVPNMemberMetricsForCompany',
    'bearerSession',
    'blockedClientsForNetwork',
    'bssidsForNetwork',
    'bulkNOSUpgrade',
    'bulkNOSUpgrades',
    'captivePortal',
    'captivePortalAllClients',
    'captivePortalAuthorizedClients',
    'captivePortalEntriesForNetwork',
    'captivePortalEntriesForPortal',
    'captivePortalEntry',
    'captivePortalForNetwork',
    'captivePortalForVLAN',
    'captivePortalForWebhook',
    'captivePortalsForNetwork',
    'channelUtilizationByAP',
    'channelUtilizationByClient',
    'channelUtilizationByNetwork',
    'clientMetrics',
    'clientVPNClient',
    'clientVPNClientMetrics',
    'clientVPNClients',
    'clientVPNServer',
    'clientVPNServers',
    'companiesHoldingGlobalNetworkTemplates',
    'company',
    'companyBySlug',
    'companyMemberships',
    'companyUser',
    'companyUsers',
    'consoleLogins',
    'controllerDHCPUptime',
    'controllerDNSRequestRates',
    'controllerPortMetrics',
    'controllerPortMetricsRate',
    'controllerPortStats',
    'countCVEsBySeverityForMACAddressesBulk',
    'cpe',
    'cpes',
    'currentDeviceConfig',
    'cve',
    'cvesForMACAddress',
    'device',
    'deviceCellularStatus',
    'deviceConfigByVersion',
    'deviceConfigOverride',
    'deviceConfigs',
    'deviceHeartbeatForDevice',
    'deviceLastDayCellularUsage',
    'deviceSIM',
    'deviceUptime',
    'devicesForNetwork',
    'dfsChannels',
    'dhcpOption',
    'dhcpProxy',
    'dhcpReservedRange',
    'dhcpRule',
    'dhcpRuleFilter',
    'dhcpRulesForNetwork',
    'dhcpStaticMapping',
    'discoveredServicesForNetwork',
    'dnsHostMapping',
    'downloadUrl',
    'encryption8021XsForNetwork',
    'findSwitchLLDPEntryForMAC',
    'findSwitchesForClientMAC',
    'firewallRule',
    'firewallRuleMetrics',
    'firewallRulesForNetwork',
    'fleetwideNotificationSetting',
    'fleetwideNotificationSettings',
    'fleetwideNotificationSnooze',
    'floorPlan',
    'floorPlansForNetwork',
    'futureFleetwideNotificationSnoozes',
    'futureFleetwideNotificationSnoozesForNetwork',
    'futureNotificationSnoozesForNetwork',
    'getCompany',
    'getCompanyByUUID',
    'getKeyValue',
    'hardwareDevice',
    'hardwareDeviceByMACAddress',
    'hardwareDevices',
    'highAvailabilityControllersConfig',
    'honeypotSSIDsObservedOnNetwork',
    'hostMonitoringForNetwork',
    'hostMonitoringTarget',
    'hostMonitoringTargetsForNetwork',
    'hs20ValidTypes',
    'idsEvent',
    'idsEvents',
    'idsIPSCategories',
    'idsIPSCategory',
    'idsIPSConfig',
    'idsIPSConfigCategoryBindings',
    'idsIPSCustomRule',
    'idsRule',
    'idsRulesForConfig',
    'idsRulesForSourceVersion',
    'incident',
    'interVLANCommunicationPermittedPairs',
    'internalNote',
    'internalNotesForNetwork',
    'internetServicePlan',
    'internetServicePlanConnectionTypes',
    'internetServicePlanProvider',
    'internetServicePlanProviderStaticRate',
    'internetServicePlanProviderStaticRates',
    'internetServicePlanProviders',
    'internetServicePlans',
    'ipForwardingRule',
    'ipForwardingRulesForNetwork',
    'ipSecTunnel',
    'ipSecTunnelMetrics',
    'ipSecTunnelsForNetwork',
    'ipsEvents',
    'isNosFeatureEnabledForCompany',
    'isNosFeatureEnabledForNetwork',
    'jobTrackers',
    'latestAcknowledgedDeviceConfig',
    'latestDeviceCPULoad',
    'latestDeviceConfig',
    'latestDeviceMemoryUsage',
    'listCompanies',
    'maintenanceWindowForNetwork',
    'marketingChangelogEntry',
    'mutationAuditLogEntriesForNetwork',
    'mutationDiffAuditLogEntriesForCompany',
    'mutationDiffAuditLogEntriesForNetwork',
    'mutationDiffAuditLogPageForNetwork',
    'mutationDiffAuditLogPageForNetworkFiltered',
    'network',
    'networkBySlug',
    'networkClientCPEBinding',
    'networkClientCPEBindingsForNetwork',
    'networkClients',
    'networkClientsTxRxPerDay',
    'networkJobsForCompany',
    'networkRoutesForVirtualDevice',
    'networkThreatAllowlistForNetwork',
    'networkUplinkQuality',
    'networkUplinkThroughput',
    'networks',
    'networksForCompany',
    'networksUplinkQualities',
    'noop',
    'nosFeature',
    'nosFeatures',
    'nosHistoryForVirtualDevice',
    'nosUpgradeGroupsForNetwork',
    'nosVersions',
    'notificationPreference',
    'notificationPreferences',
    'notificationSetting',
    'notificationSettingsForNetwork',
    'notificationSnooze',
    'oneToOneNATRule',
    'oneToOneNATRulesForNetwork',
    'outletInterfacesForVirtualDevice',
    'packetCaptureJob',
    'packetCaptureJobsForNetwork',
    'pduMetrics',
    'permissions',
    'phyInterfacesForVirtualDevice',
    'policyRoutingRule',
    'policyRoutingRulesForNetwork',
    'portForwardingRule',
    'portForwardingRulesForNetwork',
    'publicNOSVersionsForNetwork',
    'rackElevation',
    'rackElevations',
    'radioProfilesForNetwork',
    'rateLimitRule',
    'rateLimitRulesForNetwork',
    'recentEventLogEvents',
    'recentEventLogEventsPage',
    'rogueAccessPointsObservedOnNetwork',
    'roles',
    'scanDataForNetwork',
    'scheduledNetworkNOSUpgradesForNetwork',
    'siemIntegrationsForCompany',
    'spareHardwareDevicesForNetwork',
    'speedtestServersForNetwork',
    'ssid',
    'ssidsForNetwork',
    'ssoOptions',
    'staticRoute',
    'staticRoutesForNetwork',
    'statsForVirtualDevice',
    'statsForVirtualDevices',
    'suggestedNOSUpgradeGroupForDevice',
    'switchAutoConfigMACAddressVLANBindingsForNetwork',
    'switchDiscardRatesPerPort',
    'switchErrorRatesPerPort',
    'switchMACTable',
    'switchPortMetrics',
    'switchPortMetricsRate',
    'switchPortStats',
    'switchThroughputPerPort',
    'systemInfoStatForVirtualDevice',
    'unassignedHardwareDevicesForNetwork',
    'uplinkPhyInterfacesForNetwork',
    'userNetworkAccessExpiry',
    'vendorForOUI',
    'virtualDevice',
    'virtualDeviceTagsByNetwork',
    'virtualDevicesByTag',
    'virtualDevicesForNetwork',
    'visibleMarketingChangelogEntries',
    'vlan',
    'vlanMetrics',
    'vlans',
    'wanSpeedtestJob',
    'wanSpeedtestJobsForNetwork',
    'wifiIPSKs',
    'wifiObserverSettingsForNetwork',
    'wirelessCalibrationJob',
    'wirelessCalibrationJobsForNetwork',
    'wirelessClientConnectionEvents',
    'wirelessClientConnectionEventsByAP',
    'wirelessClientConnectionEventsByClient',
    'wirelessClientMetrics',
    'wirelessClientMetricsByAP',
    'wirelessClientMetricsByClient',
  ],
  Mutation: [
    'actionCaptivePortalEntry',
    'activateCompanyUser',
    'addNetworkToAutoVPNGroup',
    'addNetworksToAutoVPNGroup',
    'applyTemplateToNetwork',
    'assignHardwareDeviceToNetwork',
    'assignHardwareDeviceToNetworkAsSpare',
    'assignHardwareDeviceToVirtualDevice',
    'assignHardwareDevicesToVirtualDevices',
    'assignOperatorRole',
    'assignSwitchProfleToVirtualDevice',
    'attachDeviceToRackElevation',
    'attachVirtualDeviceToRadioProfile',
    'bindFirewallRuleToPhyInterface',
    'bindFirewallRuleToVLAN',
    'bindFirewallRulesToPhyInterface',
    'bindFirewallRulesToVLAN',
    'bindPhyInterfaceToFirewallRules',
    'bindPolicyRoutingRule',
    'bindPolicyRoutingRules',
    'bindRateLimitRuleToPhyInterface',
    'bindRateLimitRuleToSSID',
    'bindRateLimitRuleToVLAN',
    'bindTagToVirtualDevices',
    'bindVLANToFirewallRules',
    'bindVLANtoPhyInterface',
    'blockClientsInNetwork',
    'cancelAutoChannelSelectionJob',
    'cancelAutoSwitchConfigurationJob',
    'configureSSO',
    'createAlertReceiverWithTargets',
    'createAlertTargetSlack',
    'createAlertTargetWebhook',
    'createApplicationDNSFirewallRule',
    'createAutoVPNGroup',
    'createAutoVPNRoute',
    'createBulkNOSUpgrade',
    'createCaptivePortal',
    'createCaptivePortalEntry',
    'createClientVPNClient',
    'createClientVPNServer',
    'createCompanyOnboarding',
    'createCompanySIEMIntegration',
    'createCompanyUser',
    'createDHCPOption',
    'createDHCPProxy',
    'createDHCPReservedRange',
    'createDHCPRule',
    'createDHCPRuleFilter',
    'createDHCPStaticMapping',
    'createDNSHostMapping',
    'createEncryption8021X',
    'createFirewallRule',
    'createFleetwideNotificationSetting',
    'createFleetwideNotificationSnooze',
    'createFloorPlan',
    'createHighAvailabilityControllersConfiguration',
    'createHostMonitoringTarget',
    'createIDSIPSConfig',
    'createIDSIPSCustomRule',
    'createIPForwardingRule',
    'createIPSecTunnel',
    'createInternetServicePlan',
    'createInternetServicePlanProvider',
    'createInternetServicePlanProviderStaticRate',
    'createMailingAddress',
    'createNetworkClientCPEBindings',
    'createNetworkOnboarding',
    'createNetworkThreatAllowlistEntry',
    'createNotificationSetting',
    'createNotificationSnooze',
    'createOneToOneNATRule',
    'createPermittedEmailDomain',
    'createPolicyRoutingRule',
    'createPortForwardingRule',
    'createRackElevation',
    'createRadioProfile',
    'createRateLimitRule',
    'createSSID',
    'createSSOAdminPortalLink',
    'createSSODashboardForCompany',
    'createSSORedirectURI',
    'createSSOVerify',
    'createSlackAccessToken',
    'createSsoOAuthURI',
    'createStaticRoute',
    'createSwitchAutoConfigMACAddressVLANBindings',
    'createSwitchProfile',
    'createTemplateFromNetwork',
    'createVLAN',
    'createVLANs',
    'createVirtualDevice',
    'createVirtualDeviceTag',
    'createVirtualDevices',
    'createVirtualDevicesIndependently',
    'createWifiIPSK',
    'deleteAlertReceiverWithTargets',
    'deleteAlertTargetSlack',
    'deleteAlertTargetWebhook',
    'deleteAllWifiIPSKsForSSID',
    'deleteApplicationDNSFirewallRule',
    'deleteAutoVPNGroup',
    'deleteAutoVPNRoute',
    'deleteBulkNOSUpgrade',
    'deleteCaptivePortal',
    'deleteClientVPNClient',
    'deleteClientVPNServer',
    'deleteCompanyOnboardingDocument',
    'deleteCompanyOnboardingFieldDelegation',
    'deleteCompanySIEMIntegration',
    'deleteCompanyUser',
    'deleteDHCPOption',
    'deleteDHCPProxy',
    'deleteDHCPReservedRange',
    'deleteDHCPRule',
    'deleteDHCPRuleFilter',
    'deleteDHCPStaticMapping',
    'deleteDNSHostMapping',
    'deleteEncryption8021X',
    'deleteFirewallRule',
    'deleteFleetwideNotificationSetting',
    'deleteFleetwideNotificationSnooze',
    'deleteFloorPlan',
    'deleteHighAvailabilityControllersConfiguration',
    'deleteHostMonitoringTarget',
    'deleteIDSIPSConfig',
    'deleteIDSIPSConfigCategoryBinding',
    'deleteIDSIPSConfigRuleBinding',
    'deleteIDSIPSCustomRule',
    'deleteIPForwardingRule',
    'deleteIPSecTunnel',
    'deleteInternetServicePlan',
    'deleteInternetServicePlanProviderStaticRate',
    'deleteNetworkClientCPEBindings',
    'deleteNetworkOnboardingDocument',
    'deleteNetworkOnboardingFieldDelegation',
    'deleteNetworkThreatAllowlistEntry',
    'deleteNotificationPreference',
    'deleteNotificationSetting',
    'deleteNotificationSnooze',
    'deleteOneToOneNATRule',
    'deletePermittedEmailDomain',
    'deletePolicyRoutingRule',
    'deletePortForwardingRule',
    'deletePortForwardingRules',
    'deleteRackElevation',
    'deleteRadioProfile',
    'deleteRateLimitRule',
    'deleteSSID',
    'deleteSlackAccessToken',
    'deleteSlackAccessTokensForCompany',
    'deleteStaticRoute',
    'deleteSwitchAutoConfigMACAddressVLANBinding',
    'deleteVLAN',
    'deleteVirtualDevice',
    'deleteVirtualDeviceTag',
    'deleteVirtualDevices',
    'deleteWifiIPSK',
    'detachDeviceFromRackElevation',
    'detachVirtualDeviceFromRadioProfile',
    'editMutationAuditLogEntryReason',
    'editMutationDiffAuditLogEntryReason',
    'enableSSOForCompany',
    'generatePowerPlanForNetwork',
    'initializeAutoChannelSelectionForAccessPoint',
    'initializeAutoChannelSelectionForAccessPoints',
    'initializeAutoChannelSelectionForNetwork',
    'initializeAutoSwitchConfigurationForNetwork',
    'mintAuthenticationToken',
    'moveInternetServicePlanToNetwork',
    'noop',
    'removeNetworkFromAutoVPNGroup',
    'removeNetworksFromAutoVPNGroup',
    'removeNetworksFromBulkNOSUpgrade',
    'removeOperatorRole',
    'revokeAuthenticationToken',
    'rotateCaptivePortalSecret',
    'rpcBlinkLEDs',
    'rpcPDUOutletCycle',
    'rpcPing',
    'rpcPortCableTest',
    'rpcRebootDevice',
    'rpcRebootDevices',
    'rpcRestartIPSecTunnel',
    'rpcSwitchPortCycle',
    'rpcWirelessCalibrationStart',
    'rpcWosDisconnectClient',
    'rpcWosEapolTestForSerial',
    'rpcWosEapolTestForSerials',
    'rpcWosObserver',
    'rpcWosPacketCaptureStart',
    'rpcWosPacketCaptureStop',
    'rpcWosRadioReset',
    'rpcWosResetDfs',
    'sendCompanySIEMIntegrationTestEvent',
    'setKeyValue',
    'setNetworkNosVersion',
    'setPolicyRoutingRuleBindings',
    'suppressIPSRules',
    'unassignHardwareDeviceFromVirtualDevice',
    'unassignHardwareFromVirtualDevices',
    'unassignInternetServicePlanFromNetwork',
    'unassignSpareHardwareDeviceFromNetwork',
    'unbindFirewallRuleFromPhyInterface',
    'unbindFirewallRuleFromVLAN',
    'unbindPolicyRoutingRule',
    'unbindRateLimitRuleFromPhyInterface',
    'unbindRateLimitRuleFromSSID',
    'unbindRateLimitRuleFromVLAN',
    'unbindTagFromVirtualDevices',
    'unblockClientsInNetwork',
    'updateAlertReceiverWithTargets',
    'updateAlertTargetSlack',
    'updateAlertTargetWebhook',
    'updateApplicationDNSFirewallRule',
    'updateApplicationDNSFirewallRuleApplicationVisibilities',
    'updateApplicationDNSFirewallRules',
    'updateApplicationDNSFirewallRulesPriorities',
    'updateAutoVPNGroup',
    'updateAutoVPNMember',
    'updateAutoVPNRoute',
    'updateCaptivePortal',
    'updateClientVPNClient',
    'updateClientVPNServer',
    'updateCompany',
    'updateCompanySIEMIntegration',
    'updateCompanyUser',
    'updateDHCPOption',
    'updateDHCPProxy',
    'updateDHCPReservedRange',
    'updateDHCPRule',
    'updateDHCPStaticMapping',
    'updateDNSHostMapping',
    'updateDefaultRoleForUsers',
    'updateEncryption8021X',
    'updateFirewallRule',
    'updateFirewallRules',
    'updateFleetwideNotificationSetting',
    'updateFleetwideNotificationSnooze',
    'updateFloorPlan',
    'updateHardwareDevice',
    'updateHighAvailabilityControllersConfiguration',
    'updateHostMonitoringTarget',
    'updateIDSIPSConfig',
    'updateIDSIPSCustomRule',
    'updateIPForwardingRule',
    'updateIPSecTunnel',
    'updateInterVLANCommunicationPermittedPairs',
    'updateInternetServicePlan',
    'updateInternetServicePlanProvider',
    'updateInternetServicePlanProviderStaticRate',
    'updateInternetServicePlanProviderStaticRates',
    'updateMailingAddress',
    'updateNetwork',
    'updateNetworkThreatAllowlistEntry',
    'updateNotificationPreference',
    'updateNotificationSetting',
    'updateNotificationSnooze',
    'updateOneToOneNATRule',
    'updateOutletInterface',
    'updateOutletInterfaces',
    'updateOutletInterfacesIndependently',
    'updatePhyInterface',
    'updatePhyInterfaces',
    'updatePhyInterfacesIndependently',
    'updatePolicyRoutingRule',
    'updatePortForwardingRule',
    'updateRackElevation',
    'updateRackElevationDevice',
    'updateRadioProfile',
    'updateRateLimitRule',
    'updateRateLimitRulesIndependently',
    'updateSSID',
    'updateSecurityApplianceProfile',
    'updateSecurityApplianceProfilesForNetwork',
    'updateSlackAccessToken',
    'updateStaticRoute',
    'updateSwitchProfile',
    'updateUserRoles',
    'updateVLAN',
    'updateVLANInterVLANCommunicationPermittedVLANs',
    'updateVLANsIndependently',
    'updateVirtualDevice',
    'updateVirtualDeviceTag',
    'updateVirtualDevices',
    'updateVirtualDevicesIndependently',
    'updateWifiIPSK',
    'upsertCompanyNotificationPreference',
    'upsertCompanyOnboardingDocument',
    'upsertCompanyOnboardingFieldDelegation',
    'upsertIDSIPSConfigCategoryBinding',
    'upsertIDSIPSConfigRuleBinding',
    'upsertMACAddressAlias',
    'upsertNetworkNotificationPreference',
    'upsertNetworkOnboardingDocument',
    'upsertNetworkOnboardingFieldDelegation',
    'upsertSwitchAutoConfigMACAddressVLANBindingsForNetwork',
    'validateBearerSession',
  ],
} as const;
